var cee = Object.defineProperty;
var AR = (e) => {
  throw TypeError(e);
};
var dee = (e, t, r) => t in e ? cee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Dr = (e, t, r) => dee(e, typeof t != "symbol" ? t + "" : t, r), TA = (e, t, r) => t.has(e) || AR("Cannot " + r);
var S = (e, t, r) => (TA(e, t, "read from private field"), r ? r.call(e) : t.get(e)), E = (e, t, r) => t.has(e) ? AR("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), G = (e, t, r, n) => (TA(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), O = (e, t, r) => (TA(e, t, "access private method"), r);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Dk = "lit-localize-status";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const uee = (e) => typeof e != "string" && "strTag" in e, R3 = (e, t, r) => {
  let n = e[0];
  for (let a = 1; a < e.length; a++)
    n += t[r ? r[a - 1] : a - 1], n += e[a];
  return n;
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const D3 = (e) => uee(e) ? R3(e.strings, e.values) : e;
let y = D3, UR = !1;
function hee(e) {
  if (UR)
    throw new Error("lit-localize can only be configured once");
  y = e, UR = !0;
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class pee {
  constructor(t) {
    this.__litLocalizeEventHandler = (r) => {
      r.detail.status === "ready" && this.host.requestUpdate();
    }, this.host = t;
  }
  hostConnected() {
    window.addEventListener(Dk, this.__litLocalizeEventHandler);
  }
  hostDisconnected() {
    window.removeEventListener(Dk, this.__litLocalizeEventHandler);
  }
}
const gee = (e) => e.addController(new pee(e)), fee = gee;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const be = () => (e, t) => (e.addInitializer(fee), e);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class J3 {
  constructor() {
    this.settled = !1, this.promise = new Promise((t, r) => {
      this._resolve = t, this._reject = r;
    });
  }
  resolve(t) {
    this.settled = !0, this._resolve(t);
  }
  reject(t) {
    this.settled = !0, this._reject(t);
  }
}
/**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */
const Ws = [];
for (let e = 0; e < 256; e++)
  Ws[e] = (e >> 4 & 15).toString(16) + (e & 15).toString(16);
function mee(e) {
  let t = 0, r = 8997, n = 0, a = 33826, i = 0, o = 40164, s = 0, c = 52210;
  for (let l = 0; l < e.length; l++)
    r ^= e.charCodeAt(l), t = r * 435, n = a * 435, i = o * 435, s = c * 435, i += r << 8, s += a << 8, n += t >>> 16, r = t & 65535, i += n >>> 16, a = n & 65535, c = s + (i >>> 16) & 65535, o = i & 65535;
  return Ws[c >> 8] + Ws[c & 255] + Ws[o >> 8] + Ws[o & 255] + Ws[a >> 8] + Ws[a & 255] + Ws[r >> 8] + Ws[r & 255];
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const vee = "", See = "h", Iee = "s";
function Cee(e, t) {
  return (t ? See : Iee) + mee(typeof e == "string" ? e : e.join(vee));
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const kR = /* @__PURE__ */ new WeakMap(), _R = /* @__PURE__ */ new Map();
function bee(e, t, r) {
  if (e) {
    const n = (r == null ? void 0 : r.id) ?? yee(t), a = e[n];
    if (a) {
      if (typeof a == "string")
        return a;
      if ("strTag" in a)
        return R3(
          a.strings,
          // Cast `template` because its type wasn't automatically narrowed (but
          // we know it must be the same type as `localized`).
          t.values,
          a.values
        );
      {
        let i = kR.get(a);
        return i === void 0 && (i = a.values, kR.set(a, i)), {
          ...a,
          values: i.map((o) => t.values[o])
        };
      }
    }
  }
  return D3(t);
}
function yee(e) {
  const t = typeof e == "string" ? e : e.strings;
  let r = _R.get(t);
  return r === void 0 && (r = Cee(t, typeof e != "string" && !("strTag" in e)), _R.set(t, r)), r;
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function RA(e) {
  window.dispatchEvent(new CustomEvent(Dk, { detail: e }));
}
let c1 = "", DA, V3, d1, Jk, M3, Ad = new J3();
Ad.resolve();
let NI = 0;
const wee = (e) => (hee((t, r) => bee(M3, t, r)), c1 = V3 = e.sourceLocale, d1 = new Set(e.targetLocales), d1.add(e.sourceLocale), Jk = e.loadLocale, { getLocale: Aee, setLocale: Uee }), Aee = () => c1, Uee = (e) => {
  if (e === (DA ?? c1))
    return Ad.promise;
  if (!d1 || !Jk)
    throw new Error("Internal error");
  if (!d1.has(e))
    throw new Error("Invalid locale code");
  NI++;
  const t = NI;
  return DA = e, Ad.settled && (Ad = new J3()), RA({ status: "loading", loadingLocale: e }), (e === V3 ? (
    // We could switch to the source locale synchronously, but we prefer to
    // queue it on a microtask so that switching locales is consistently
    // asynchronous.
    Promise.resolve({ templates: void 0 })
  ) : Jk(e)).then((n) => {
    NI === t && (c1 = e, DA = void 0, M3 = n.templates, RA({ status: "ready", readyLocale: e }), Ad.resolve());
  }, (n) => {
    NI === t && (RA({
      status: "error",
      errorLocale: e,
      errorMessage: n.toString()
    }), Ad.reject(n));
  }), Ad.promise;
};
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const gC = globalThis, mW = gC.ShadowRoot && (gC.ShadyCSS === void 0 || gC.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, vW = Symbol(), NR = /* @__PURE__ */ new WeakMap();
let G3 = class {
  constructor(t, r, n) {
    if (this._$cssResult$ = !0, n !== vW) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = r;
  }
  get styleSheet() {
    let t = this.o;
    const r = this.t;
    if (mW && t === void 0) {
      const n = r !== void 0 && r.length === 1;
      n && (t = NR.get(r)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && NR.set(r, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Gt = (e) => new G3(typeof e == "string" ? e : e + "", void 0, vW), ee = (e, ...t) => {
  const r = e.length === 1 ? e[0] : t.reduce((n, a, i) => n + ((o) => {
    if (o._$cssResult$ === !0) return o.cssText;
    if (typeof o == "number") return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(a) + e[i + 1], e[0]);
  return new G3(r, e, vW);
}, kee = (e, t) => {
  if (mW) e.adoptedStyleSheets = t.map((r) => r instanceof CSSStyleSheet ? r : r.styleSheet);
  else for (const r of t) {
    const n = document.createElement("style"), a = gC.litNonce;
    a !== void 0 && n.setAttribute("nonce", a), n.textContent = r.cssText, e.appendChild(n);
  }
}, ZR = mW ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((t) => {
  let r = "";
  for (const n of t.cssRules) r += n.cssText;
  return Gt(r);
})(e) : e;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: _ee, defineProperty: Nee, getOwnPropertyDescriptor: Zee, getOwnPropertyNames: Bee, getOwnPropertySymbols: Wee, getPrototypeOf: Eee } = Object, _c = globalThis, BR = _c.trustedTypes, Qee = BR ? BR.emptyScript : "", JA = _c.reactiveElementPolyfillSupport, Qf = (e, t) => e, u1 = { toAttribute(e, t) {
  switch (t) {
    case Boolean:
      e = e ? Qee : null;
      break;
    case Object:
    case Array:
      e = e == null ? e : JSON.stringify(e);
  }
  return e;
}, fromAttribute(e, t) {
  let r = e;
  switch (t) {
    case Boolean:
      r = e !== null;
      break;
    case Number:
      r = e === null ? null : Number(e);
      break;
    case Object:
    case Array:
      try {
        r = JSON.parse(e);
      } catch {
        r = null;
      }
  }
  return r;
} }, SW = (e, t) => !_ee(e, t), WR = { attribute: !0, type: String, converter: u1, reflect: !1, hasChanged: SW };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), _c.litPropertyMetadata ?? (_c.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class Nh extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, r = WR) {
    if (r.state && (r.attribute = !1), this._$Ei(), this.elementProperties.set(t, r), !r.noAccessor) {
      const n = Symbol(), a = this.getPropertyDescriptor(t, n, r);
      a !== void 0 && Nee(this.prototype, t, a);
    }
  }
  static getPropertyDescriptor(t, r, n) {
    const { get: a, set: i } = Zee(this.prototype, t) ?? { get() {
      return this[r];
    }, set(o) {
      this[r] = o;
    } };
    return { get() {
      return a == null ? void 0 : a.call(this);
    }, set(o) {
      const s = a == null ? void 0 : a.call(this);
      i.call(this, o), this.requestUpdate(t, s, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? WR;
  }
  static _$Ei() {
    if (this.hasOwnProperty(Qf("elementProperties"))) return;
    const t = Eee(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(Qf("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(Qf("properties"))) {
      const r = this.properties, n = [...Bee(r), ...Wee(r)];
      for (const a of n) this.createProperty(a, r[a]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const r = litPropertyMetadata.get(t);
      if (r !== void 0) for (const [n, a] of r) this.elementProperties.set(n, a);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [r, n] of this.elementProperties) {
      const a = this._$Eu(r, n);
      a !== void 0 && this._$Eh.set(a, r);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const r = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const a of n) r.unshift(ZR(a));
    } else t !== void 0 && r.push(ZR(t));
    return r;
  }
  static _$Eu(t, r) {
    const n = r.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((r) => this.enableUpdating = r), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((r) => r(this));
  }
  addController(t) {
    var r;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((r = t.hostConnected) == null || r.call(t));
  }
  removeController(t) {
    var r;
    (r = this._$EO) == null || r.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), r = this.constructor.elementProperties;
    for (const n of r.keys()) this.hasOwnProperty(n) && (t.set(n, this[n]), delete this[n]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return kee(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((r) => {
      var n;
      return (n = r.hostConnected) == null ? void 0 : n.call(r);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((r) => {
      var n;
      return (n = r.hostDisconnected) == null ? void 0 : n.call(r);
    });
  }
  attributeChangedCallback(t, r, n) {
    this._$AK(t, n);
  }
  _$EC(t, r) {
    var i;
    const n = this.constructor.elementProperties.get(t), a = this.constructor._$Eu(t, n);
    if (a !== void 0 && n.reflect === !0) {
      const o = (((i = n.converter) == null ? void 0 : i.toAttribute) !== void 0 ? n.converter : u1).toAttribute(r, n.type);
      this._$Em = t, o == null ? this.removeAttribute(a) : this.setAttribute(a, o), this._$Em = null;
    }
  }
  _$AK(t, r) {
    var i;
    const n = this.constructor, a = n._$Eh.get(t);
    if (a !== void 0 && this._$Em !== a) {
      const o = n.getPropertyOptions(a), s = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((i = o.converter) == null ? void 0 : i.fromAttribute) !== void 0 ? o.converter : u1;
      this._$Em = a, this[a] = s.fromAttribute(r, o.type), this._$Em = null;
    }
  }
  requestUpdate(t, r, n) {
    if (t !== void 0) {
      if (n ?? (n = this.constructor.getPropertyOptions(t)), !(n.hasChanged ?? SW)(this[t], r)) return;
      this.P(t, r, n);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, r, n) {
    this._$AL.has(t) || this._$AL.set(t, r), n.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (r) {
      Promise.reject(r);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var n;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [i, o] of this._$Ep) this[i] = o;
        this._$Ep = void 0;
      }
      const a = this.constructor.elementProperties;
      if (a.size > 0) for (const [i, o] of a) o.wrapped !== !0 || this._$AL.has(i) || this[i] === void 0 || this.P(i, this[i], o);
    }
    let t = !1;
    const r = this._$AL;
    try {
      t = this.shouldUpdate(r), t ? (this.willUpdate(r), (n = this._$EO) == null || n.forEach((a) => {
        var i;
        return (i = a.hostUpdate) == null ? void 0 : i.call(a);
      }), this.update(r)) : this._$EU();
    } catch (a) {
      throw t = !1, this._$EU(), a;
    }
    t && this._$AE(r);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var r;
    (r = this._$EO) == null || r.forEach((n) => {
      var a;
      return (a = n.hostUpdated) == null ? void 0 : a.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((r) => this._$EC(r, this[r]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
Nh.elementStyles = [], Nh.shadowRootOptions = { mode: "open" }, Nh[Qf("elementProperties")] = /* @__PURE__ */ new Map(), Nh[Qf("finalized")] = /* @__PURE__ */ new Map(), JA == null || JA({ ReactiveElement: Nh }), (_c.reactiveElementVersions ?? (_c.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ff = globalThis, h1 = Ff.trustedTypes, ER = h1 ? h1.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, IW = "$lit$", tl = `lit$${Math.random().toFixed(9).slice(2)}$`, CW = "?" + tl, Fee = `<${CW}>`, _u = document, rm = () => _u.createComment(""), nm = (e) => e === null || typeof e != "object" && typeof e != "function", bW = Array.isArray, x3 = (e) => bW(e) || typeof (e == null ? void 0 : e[Symbol.iterator]) == "function", VA = `[ 	
\f\r]`, U0 = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, QR = /-->/g, FR = />/g, md = RegExp(`>|${VA}(?:([^\\s"'>=/]+)(${VA}*=${VA}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), TR = /'/g, RR = /"/g, H3 = /^(?:script|style|textarea|title)$/i, L3 = (e) => (t, ...r) => ({ _$litType$: e, strings: t, values: r }), w = L3(1), CS = L3(2), no = Symbol.for("lit-noChange"), q = Symbol.for("lit-nothing"), DR = /* @__PURE__ */ new WeakMap(), Yd = _u.createTreeWalker(_u, 129);
function Y3(e, t) {
  if (!bW(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return ER !== void 0 ? ER.createHTML(t) : t;
}
const O3 = (e, t) => {
  const r = e.length - 1, n = [];
  let a, i = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = U0;
  for (let s = 0; s < r; s++) {
    const c = e[s];
    let l, u, g = -1, p = 0;
    for (; p < c.length && (o.lastIndex = p, u = o.exec(c), u !== null); ) p = o.lastIndex, o === U0 ? u[1] === "!--" ? o = QR : u[1] !== void 0 ? o = FR : u[2] !== void 0 ? (H3.test(u[2]) && (a = RegExp("</" + u[2], "g")), o = md) : u[3] !== void 0 && (o = md) : o === md ? u[0] === ">" ? (o = a ?? U0, g = -1) : u[1] === void 0 ? g = -2 : (g = o.lastIndex - u[2].length, l = u[1], o = u[3] === void 0 ? md : u[3] === '"' ? RR : TR) : o === RR || o === TR ? o = md : o === QR || o === FR ? o = U0 : (o = md, a = void 0);
    const m = o === md && e[s + 1].startsWith("/>") ? " " : "";
    i += o === U0 ? c + Fee : g >= 0 ? (n.push(l), c.slice(0, g) + IW + c.slice(g) + tl + m) : c + tl + (g === -2 ? s : m);
  }
  return [Y3(e, i + (e[r] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), n];
};
class am {
  constructor({ strings: t, _$litType$: r }, n) {
    let a;
    this.parts = [];
    let i = 0, o = 0;
    const s = t.length - 1, c = this.parts, [l, u] = O3(t, r);
    if (this.el = am.createElement(l, n), Yd.currentNode = this.el.content, r === 2 || r === 3) {
      const g = this.el.content.firstChild;
      g.replaceWith(...g.childNodes);
    }
    for (; (a = Yd.nextNode()) !== null && c.length < s; ) {
      if (a.nodeType === 1) {
        if (a.hasAttributes()) for (const g of a.getAttributeNames()) if (g.endsWith(IW)) {
          const p = u[o++], m = a.getAttribute(g).split(tl), I = /([.?@])?(.*)/.exec(p);
          c.push({ type: 1, index: i, name: I[2], strings: m, ctor: I[1] === "." ? $3 : I[1] === "?" ? K3 : I[1] === "@" ? X3 : bS }), a.removeAttribute(g);
        } else g.startsWith(tl) && (c.push({ type: 6, index: i }), a.removeAttribute(g));
        if (H3.test(a.tagName)) {
          const g = a.textContent.split(tl), p = g.length - 1;
          if (p > 0) {
            a.textContent = h1 ? h1.emptyScript : "";
            for (let m = 0; m < p; m++) a.append(g[m], rm()), Yd.nextNode(), c.push({ type: 2, index: ++i });
            a.append(g[p], rm());
          }
        }
      } else if (a.nodeType === 8) if (a.data === CW) c.push({ type: 2, index: i });
      else {
        let g = -1;
        for (; (g = a.data.indexOf(tl, g + 1)) !== -1; ) c.push({ type: 7, index: i }), g += tl.length - 1;
      }
      i++;
    }
  }
  static createElement(t, r) {
    const n = _u.createElement("template");
    return n.innerHTML = t, n;
  }
}
function Nu(e, t, r = e, n) {
  var o, s;
  if (t === no) return t;
  let a = n !== void 0 ? (o = r.o) == null ? void 0 : o[n] : r.l;
  const i = nm(t) ? void 0 : t._$litDirective$;
  return (a == null ? void 0 : a.constructor) !== i && ((s = a == null ? void 0 : a._$AO) == null || s.call(a, !1), i === void 0 ? a = void 0 : (a = new i(e), a._$AT(e, r, n)), n !== void 0 ? (r.o ?? (r.o = []))[n] = a : r.l = a), a !== void 0 && (t = Nu(e, a._$AS(e, t.values), a, n)), t;
}
class j3 {
  constructor(t, r) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = r;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: r }, parts: n } = this._$AD, a = ((t == null ? void 0 : t.creationScope) ?? _u).importNode(r, !0);
    Yd.currentNode = a;
    let i = Yd.nextNode(), o = 0, s = 0, c = n[0];
    for (; c !== void 0; ) {
      if (o === c.index) {
        let l;
        c.type === 2 ? l = new W2(i, i.nextSibling, this, t) : c.type === 1 ? l = new c.ctor(i, c.name, c.strings, this, t) : c.type === 6 && (l = new z3(i, this, t)), this._$AV.push(l), c = n[++s];
      }
      o !== (c == null ? void 0 : c.index) && (i = Yd.nextNode(), o++);
    }
    return Yd.currentNode = _u, a;
  }
  p(t) {
    let r = 0;
    for (const n of this._$AV) n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, r), r += n.strings.length - 2) : n._$AI(t[r])), r++;
  }
}
let W2 = class P3 {
  get _$AU() {
    var t;
    return ((t = this._$AM) == null ? void 0 : t._$AU) ?? this.v;
  }
  constructor(t, r, n, a) {
    this.type = 2, this._$AH = q, this._$AN = void 0, this._$AA = t, this._$AB = r, this._$AM = n, this.options = a, this.v = (a == null ? void 0 : a.isConnected) ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const r = this._$AM;
    return r !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = r.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, r = this) {
    t = Nu(this, t, r), nm(t) ? t === q || t == null || t === "" ? (this._$AH !== q && this._$AR(), this._$AH = q) : t !== this._$AH && t !== no && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : x3(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== q && nm(this._$AH) ? this._$AA.nextSibling.data = t : this.T(_u.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var i;
    const { values: r, _$litType$: n } = t, a = typeof n == "number" ? this._$AC(t) : (n.el === void 0 && (n.el = am.createElement(Y3(n.h, n.h[0]), this.options)), n);
    if (((i = this._$AH) == null ? void 0 : i._$AD) === a) this._$AH.p(r);
    else {
      const o = new j3(a, this), s = o.u(this.options);
      o.p(r), this.T(s), this._$AH = o;
    }
  }
  _$AC(t) {
    let r = DR.get(t.strings);
    return r === void 0 && DR.set(t.strings, r = new am(t)), r;
  }
  k(t) {
    bW(this._$AH) || (this._$AH = [], this._$AR());
    const r = this._$AH;
    let n, a = 0;
    for (const i of t) a === r.length ? r.push(n = new P3(this.O(rm()), this.O(rm()), this, this.options)) : n = r[a], n._$AI(i), a++;
    a < r.length && (this._$AR(n && n._$AB.nextSibling, a), r.length = a);
  }
  _$AR(t = this._$AA.nextSibling, r) {
    var n;
    for ((n = this._$AP) == null ? void 0 : n.call(this, !1, !0, r); t && t !== this._$AB; ) {
      const a = t.nextSibling;
      t.remove(), t = a;
    }
  }
  setConnected(t) {
    var r;
    this._$AM === void 0 && (this.v = t, (r = this._$AP) == null || r.call(this, t));
  }
};
class bS {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, r, n, a, i) {
    this.type = 1, this._$AH = q, this._$AN = void 0, this.element = t, this.name = r, this._$AM = a, this.options = i, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = q;
  }
  _$AI(t, r = this, n, a) {
    const i = this.strings;
    let o = !1;
    if (i === void 0) t = Nu(this, t, r, 0), o = !nm(t) || t !== this._$AH && t !== no, o && (this._$AH = t);
    else {
      const s = t;
      let c, l;
      for (t = i[0], c = 0; c < i.length - 1; c++) l = Nu(this, s[n + c], r, c), l === no && (l = this._$AH[c]), o || (o = !nm(l) || l !== this._$AH[c]), l === q ? t = q : t !== q && (t += (l ?? "") + i[c + 1]), this._$AH[c] = l;
    }
    o && !a && this.j(t);
  }
  j(t) {
    t === q ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class $3 extends bS {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === q ? void 0 : t;
  }
}
class K3 extends bS {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== q);
  }
}
class X3 extends bS {
  constructor(t, r, n, a, i) {
    super(t, r, n, a, i), this.type = 5;
  }
  _$AI(t, r = this) {
    if ((t = Nu(this, t, r, 0) ?? q) === no) return;
    const n = this._$AH, a = t === q && n !== q || t.capture !== n.capture || t.once !== n.once || t.passive !== n.passive, i = t !== q && (n === q || a);
    a && this.element.removeEventListener(this.name, this, n), i && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var r;
    typeof this._$AH == "function" ? this._$AH.call(((r = this.options) == null ? void 0 : r.host) ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class z3 {
  constructor(t, r, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = r, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    Nu(this, t);
  }
}
const Tee = { M: IW, P: tl, A: CW, C: 1, L: O3, R: j3, D: x3, V: Nu, I: W2, H: bS, N: K3, U: X3, B: $3, F: z3 }, MA = Ff.litHtmlPolyfillSupport;
MA == null || MA(am, W2), (Ff.litHtmlVersions ?? (Ff.litHtmlVersions = [])).push("3.2.0");
const Ree = (e, t, r) => {
  const n = (r == null ? void 0 : r.renderBefore) ?? t;
  let a = n._$litPart$;
  if (a === void 0) {
    const i = (r == null ? void 0 : r.renderBefore) ?? null;
    n._$litPart$ = a = new W2(t.insertBefore(rm(), i), i, void 0, r ?? {});
  }
  return a._$AI(e), a;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class ro extends Nh {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var r;
    const t = super.createRenderRoot();
    return (r = this.renderOptions).renderBefore ?? (r.renderBefore = t.firstChild), t;
  }
  update(t) {
    const r = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = Ree(r, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this.o) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this.o) == null || t.setConnected(!1);
  }
  render() {
    return no;
  }
}
var T3;
ro._$litElement$ = !0, ro.finalized = !0, (T3 = globalThis.litElementHydrateSupport) == null || T3.call(globalThis, { LitElement: ro });
const GA = globalThis.litElementPolyfillSupport;
GA == null || GA({ LitElement: ro });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const P = (e) => (t, r) => {
  r !== void 0 ? r.addInitializer(() => {
    customElements.define(e, t);
  }) : customElements.define(e, t);
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Dee = { attribute: !0, type: String, converter: u1, reflect: !1, hasChanged: SW }, Jee = (e = Dee, t, r) => {
  const { kind: n, metadata: a } = r;
  let i = globalThis.litPropertyMetadata.get(a);
  if (i === void 0 && globalThis.litPropertyMetadata.set(a, i = /* @__PURE__ */ new Map()), i.set(r.name, e), n === "accessor") {
    const { name: o } = r;
    return { set(s) {
      const c = t.get.call(this);
      t.set.call(this, s), this.requestUpdate(o, c, e);
    }, init(s) {
      return s !== void 0 && this.P(o, void 0, e), s;
    } };
  }
  if (n === "setter") {
    const { name: o } = r;
    return function(s) {
      const c = this[o];
      t.call(this, s), this.requestUpdate(o, c, e);
    };
  }
  throw Error("Unsupported decorator location: " + n);
};
function M(e) {
  return (t, r) => typeof r == "object" ? Jee(e, t, r) : ((n, a, i) => {
    const o = a.hasOwnProperty(i);
    return a.constructor.createProperty(i, o ? { ...n, wrapped: !0 } : n), o ? Object.getOwnPropertyDescriptor(a, i) : void 0;
  })(e, t, r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Xn(e) {
  return M({ ...e, state: !0, attribute: !1 });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const q3 = (e, t, r) => (r.configurable = !0, r.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, r), r);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function yW(e, t) {
  return (r, n, a) => {
    const i = (o) => {
      var s;
      return ((s = o.renderRoot) == null ? void 0 : s.querySelector(e)) ?? null;
    };
    return q3(r, n, { get() {
      return i(this);
    } });
  };
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function dr(e) {
  return (t, r) => {
    const { slot: n, selector: a } = e ?? {}, i = "slot" + (n ? `[name=${n}]` : ":not([name])");
    return q3(t, r, { get() {
      var c;
      const o = (c = this.renderRoot) == null ? void 0 : c.querySelector(i), s = (o == null ? void 0 : o.assignedElements(e)) ?? [];
      return a === void 0 ? s : s.filter((l) => l.matches(a));
    } });
  };
}
var Vk = function(e, t) {
  return Vk = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, Vk(e, t);
};
function Ti(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Vk(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
function Vee(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (g) {
        o(g);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (g) {
        o(g);
      }
    }
    function l(u) {
      u.done ? i(u.value) : a(u.value).then(s, c);
    }
    l((n = n.apply(e, t || [])).next());
  });
}
function eM(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (r = 0)), r; ) try {
      if (n = 1, a && (i = l[0] & 2 ? a.return : l[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, l[1])).done) return i;
      switch (a = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (u) {
      l = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function $o(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ca(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; ) i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}
function za(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function lp(e) {
  return this instanceof lp ? (this.v = e, this) : new lp(e);
}
function Mee(e, t, r) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var n = r.apply(e, t || []), a, i = [];
  return a = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", o), a[Symbol.asyncIterator] = function() {
    return this;
  }, a;
  function o(m) {
    return function(I) {
      return Promise.resolve(I).then(m, g);
    };
  }
  function s(m, I) {
    n[m] && (a[m] = function(C) {
      return new Promise(function(A, U) {
        i.push([m, C, A, U]) > 1 || c(m, C);
      });
    }, I && (a[m] = I(a[m])));
  }
  function c(m, I) {
    try {
      l(n[m](I));
    } catch (C) {
      p(i[0][3], C);
    }
  }
  function l(m) {
    m.value instanceof lp ? Promise.resolve(m.value.v).then(u, g) : p(i[0][2], m);
  }
  function u(m) {
    c("next", m);
  }
  function g(m) {
    c("throw", m);
  }
  function p(m, I) {
    m(I), i.shift(), i.length && c(i[0][0], i[0][1]);
  }
}
function Gee(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], r;
  return t ? t.call(e) : (e = typeof $o == "function" ? $o(e) : e[Symbol.iterator](), r = {}, n("next"), n("throw"), n("return"), r[Symbol.asyncIterator] = function() {
    return this;
  }, r);
  function n(i) {
    r[i] = e[i] && function(o) {
      return new Promise(function(s, c) {
        o = e[i](o), a(s, c, o.done, o.value);
      });
    };
  }
  function a(i, o, s, c) {
    Promise.resolve(c).then(function(l) {
      i({ value: l, done: s });
    }, o);
  }
}
function Bt(e) {
  return typeof e == "function";
}
function wW(e) {
  var t = function(n) {
    Error.call(n), n.stack = new Error().stack;
  }, r = e(t);
  return r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r;
}
var xA = wW(function(e) {
  return function(r) {
    e(this), this.message = r ? r.length + ` errors occurred during unsubscription:
` + r.map(function(n, a) {
      return a + 1 + ") " + n.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = r;
  };
});
function Lp(e, t) {
  if (e) {
    var r = e.indexOf(t);
    0 <= r && e.splice(r, 1);
  }
}
var zu = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, r, n, a, i;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var s = $o(o), c = s.next(); !c.done; c = s.next()) {
              var l = c.value;
              l.remove(this);
            }
          } catch (C) {
            t = { error: C };
          } finally {
            try {
              c && !c.done && (r = s.return) && r.call(s);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          o.remove(this);
      var u = this.initialTeardown;
      if (Bt(u))
        try {
          u();
        } catch (C) {
          i = C instanceof xA ? C.errors : [C];
        }
      var g = this._finalizers;
      if (g) {
        this._finalizers = null;
        try {
          for (var p = $o(g), m = p.next(); !m.done; m = p.next()) {
            var I = m.value;
            try {
              JR(I);
            } catch (C) {
              i = i ?? [], C instanceof xA ? i = za(za([], Ca(i)), Ca(C.errors)) : i.push(C);
            }
          }
        } catch (C) {
          n = { error: C };
        } finally {
          try {
            m && !m.done && (a = p.return) && a.call(p);
          } finally {
            if (n) throw n.error;
          }
        }
      }
      if (i)
        throw new xA(i);
    }
  }, e.prototype.add = function(t) {
    var r;
    if (t && t !== this)
      if (this.closed)
        JR(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (r = this._finalizers) !== null && r !== void 0 ? r : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var r = this._parentage;
    return r === t || Array.isArray(r) && r.includes(t);
  }, e.prototype._addParent = function(t) {
    var r = this._parentage;
    this._parentage = Array.isArray(r) ? (r.push(t), r) : r ? [r, t] : t;
  }, e.prototype._removeParent = function(t) {
    var r = this._parentage;
    r === t ? this._parentage = null : Array.isArray(r) && Lp(r, t);
  }, e.prototype.remove = function(t) {
    var r = this._finalizers;
    r && Lp(r, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), tM = zu.EMPTY;
function rM(e) {
  return e instanceof zu || e && "closed" in e && Bt(e.remove) && Bt(e.add) && Bt(e.unsubscribe);
}
function JR(e) {
  Bt(e) ? e() : e.unsubscribe();
}
var nM = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, aM = {
  setTimeout: function(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    return setTimeout.apply(void 0, za([e, t], Ca(r)));
  },
  clearTimeout: function(e) {
    var t = aM.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function iM(e) {
  aM.setTimeout(function() {
    throw e;
  });
}
function im() {
}
function fC(e) {
  e();
}
var AW = function(e) {
  Ti(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n.isStopped = !1, r ? (n.destination = r, rM(r) && r.add(n)) : n.destination = Yee, n;
  }
  return t.create = function(r, n, a) {
    return new Yp(r, n, a);
  }, t.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, t.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(r) {
    this.destination.next(r);
  }, t.prototype._error = function(r) {
    try {
      this.destination.error(r);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(zu), xee = Function.prototype.bind;
function HA(e, t) {
  return xee.call(e, t);
}
var Hee = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var r = this.partialObserver;
    if (r.next)
      try {
        r.next(t);
      } catch (n) {
        ZI(n);
      }
  }, e.prototype.error = function(t) {
    var r = this.partialObserver;
    if (r.error)
      try {
        r.error(t);
      } catch (n) {
        ZI(n);
      }
    else
      ZI(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (r) {
        ZI(r);
      }
  }, e;
}(), Yp = function(e) {
  Ti(t, e);
  function t(r, n, a) {
    var i = e.call(this) || this, o;
    if (Bt(r) || !r)
      o = {
        next: r ?? void 0,
        error: n ?? void 0,
        complete: a ?? void 0
      };
    else {
      var s;
      i && nM.useDeprecatedNextContext ? (s = Object.create(r), s.unsubscribe = function() {
        return i.unsubscribe();
      }, o = {
        next: r.next && HA(r.next, s),
        error: r.error && HA(r.error, s),
        complete: r.complete && HA(r.complete, s)
      }) : o = r;
    }
    return i.destination = new Hee(o), i;
  }
  return t;
}(AW);
function ZI(e) {
  iM(e);
}
function Lee(e) {
  throw e;
}
var Yee = {
  closed: !0,
  next: im,
  error: Lee,
  complete: im
}, UW = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Al(e) {
  return e;
}
function ho() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return oM(e);
}
function oM(e) {
  return e.length === 0 ? Al : e.length === 1 ? e[0] : function(r) {
    return e.reduce(function(n, a) {
      return a(n);
    }, r);
  };
}
var Ht = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var r = new e();
    return r.source = this, r.operator = t, r;
  }, e.prototype.subscribe = function(t, r, n) {
    var a = this, i = jee(t) ? t : new Yp(t, r, n);
    return fC(function() {
      var o = a, s = o.operator, c = o.source;
      i.add(s ? s.call(i, c) : c ? a._subscribe(i) : a._trySubscribe(i));
    }), i;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (r) {
      t.error(r);
    }
  }, e.prototype.forEach = function(t, r) {
    var n = this;
    return r = VR(r), new r(function(a, i) {
      var o = new Yp({
        next: function(s) {
          try {
            t(s);
          } catch (c) {
            i(c), o.unsubscribe();
          }
        },
        error: i,
        complete: a
      });
      n.subscribe(o);
    });
  }, e.prototype._subscribe = function(t) {
    var r;
    return (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t);
  }, e.prototype[UW] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return oM(t)(this);
  }, e.prototype.toPromise = function(t) {
    var r = this;
    return t = VR(t), new t(function(n, a) {
      var i;
      r.subscribe(function(o) {
        return i = o;
      }, function(o) {
        return a(o);
      }, function() {
        return n(i);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function VR(e) {
  var t;
  return (t = e ?? nM.Promise) !== null && t !== void 0 ? t : Promise;
}
function Oee(e) {
  return e && Bt(e.next) && Bt(e.error) && Bt(e.complete);
}
function jee(e) {
  return e && e instanceof AW || Oee(e) && rM(e);
}
function Pee(e) {
  return Bt(e == null ? void 0 : e.lift);
}
function Lt(e) {
  return function(t) {
    if (Pee(t))
      return t.lift(function(r) {
        try {
          return e(r, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Jt(e, t, r, n, a) {
  return new $ee(e, t, r, n, a);
}
var $ee = function(e) {
  Ti(t, e);
  function t(r, n, a, i, o, s) {
    var c = e.call(this, r) || this;
    return c.onFinalize = o, c.shouldUnsubscribe = s, c._next = n ? function(l) {
      try {
        n(l);
      } catch (u) {
        r.error(u);
      }
    } : e.prototype._next, c._error = i ? function(l) {
      try {
        i(l);
      } catch (u) {
        r.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = a ? function() {
      try {
        a();
      } catch (l) {
        r.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var r;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      e.prototype.unsubscribe.call(this), !n && ((r = this.onFinalize) === null || r === void 0 || r.call(this));
    }
  }, t;
}(AW), Mk = {
  schedule: function(e) {
    var t = requestAnimationFrame, r = cancelAnimationFrame, n = Mk.delegate;
    n && (t = n.requestAnimationFrame, r = n.cancelAnimationFrame);
    var a = t(function(i) {
      r = void 0, e(i);
    });
    return new zu(function() {
      return r == null ? void 0 : r(a);
    });
  },
  requestAnimationFrame: function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return requestAnimationFrame.apply(void 0, za([], Ca(e)));
  },
  cancelAnimationFrame: function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return cancelAnimationFrame.apply(void 0, za([], Ca(e)));
  },
  delegate: void 0
}, Kee = wW(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), _e = function(e) {
  Ti(t, e);
  function t() {
    var r = e.call(this) || this;
    return r.closed = !1, r.currentObservers = null, r.observers = [], r.isStopped = !1, r.hasError = !1, r.thrownError = null, r;
  }
  return t.prototype.lift = function(r) {
    var n = new MR(this, this);
    return n.operator = r, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Kee();
  }, t.prototype.next = function(r) {
    var n = this;
    fC(function() {
      var a, i;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var o = $o(n.currentObservers), s = o.next(); !s.done; s = o.next()) {
            var c = s.value;
            c.next(r);
          }
        } catch (l) {
          a = { error: l };
        } finally {
          try {
            s && !s.done && (i = o.return) && i.call(o);
          } finally {
            if (a) throw a.error;
          }
        }
      }
    });
  }, t.prototype.error = function(r) {
    var n = this;
    fC(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = r;
        for (var a = n.observers; a.length; )
          a.shift().error(r);
      }
    });
  }, t.prototype.complete = function() {
    var r = this;
    fC(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.isStopped = !0;
        for (var n = r.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var r;
      return ((r = this.observers) === null || r === void 0 ? void 0 : r.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(r) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, r);
  }, t.prototype._subscribe = function(r) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(r), this._innerSubscribe(r);
  }, t.prototype._innerSubscribe = function(r) {
    var n = this, a = this, i = a.hasError, o = a.isStopped, s = a.observers;
    return i || o ? tM : (this.currentObservers = null, s.push(r), new zu(function() {
      n.currentObservers = null, Lp(s, r);
    }));
  }, t.prototype._checkFinalizedStatuses = function(r) {
    var n = this, a = n.hasError, i = n.thrownError, o = n.isStopped;
    a ? r.error(i) : o && r.complete();
  }, t.prototype.asObservable = function() {
    var r = new Ht();
    return r.source = this, r;
  }, t.create = function(r, n) {
    return new MR(r, n);
  }, t;
}(Ht), MR = function(e) {
  Ti(t, e);
  function t(r, n) {
    var a = e.call(this) || this;
    return a.destination = r, a.source = n, a;
  }
  return t.prototype.next = function(r) {
    var n, a;
    (a = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || a === void 0 || a.call(n, r);
  }, t.prototype.error = function(r) {
    var n, a;
    (a = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || a === void 0 || a.call(n, r);
  }, t.prototype.complete = function() {
    var r, n;
    (n = (r = this.destination) === null || r === void 0 ? void 0 : r.complete) === null || n === void 0 || n.call(r);
  }, t.prototype._subscribe = function(r) {
    var n, a;
    return (a = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(r)) !== null && a !== void 0 ? a : tM;
  }, t;
}(_e), Kt = function(e) {
  Ti(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._value = r, n;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(r) {
    var n = e.prototype._subscribe.call(this, r);
    return !n.closed && r.next(this._value), n;
  }, t.prototype.getValue = function() {
    var r = this, n = r.hasError, a = r.thrownError, i = r._value;
    if (n)
      throw a;
    return this._throwIfClosed(), i;
  }, t.prototype.next = function(r) {
    e.prototype.next.call(this, this._value = r);
  }, t;
}(_e), kW = {
  now: function() {
    return (kW.delegate || Date).now();
  },
  delegate: void 0
}, sM = function(e) {
  Ti(t, e);
  function t(r, n, a) {
    r === void 0 && (r = 1 / 0), n === void 0 && (n = 1 / 0), a === void 0 && (a = kW);
    var i = e.call(this) || this;
    return i._bufferSize = r, i._windowTime = n, i._timestampProvider = a, i._buffer = [], i._infiniteTimeWindow = !0, i._infiniteTimeWindow = n === 1 / 0, i._bufferSize = Math.max(1, r), i._windowTime = Math.max(1, n), i;
  }
  return t.prototype.next = function(r) {
    var n = this, a = n.isStopped, i = n._buffer, o = n._infiniteTimeWindow, s = n._timestampProvider, c = n._windowTime;
    a || (i.push(r), !o && i.push(s.now() + c)), this._trimBuffer(), e.prototype.next.call(this, r);
  }, t.prototype._subscribe = function(r) {
    this._throwIfClosed(), this._trimBuffer();
    for (var n = this._innerSubscribe(r), a = this, i = a._infiniteTimeWindow, o = a._buffer, s = o.slice(), c = 0; c < s.length && !r.closed; c += i ? 1 : 2)
      r.next(s[c]);
    return this._checkFinalizedStatuses(r), n;
  }, t.prototype._trimBuffer = function() {
    var r = this, n = r._bufferSize, a = r._timestampProvider, i = r._buffer, o = r._infiniteTimeWindow, s = (o ? 1 : 2) * n;
    if (n < 1 / 0 && s < i.length && i.splice(0, i.length - s), !o) {
      for (var c = a.now(), l = 0, u = 1; u < i.length && i[u] <= c; u += 2)
        l = u;
      l && i.splice(0, l + 1);
    }
  }, t;
}(_e), Xee = function(e) {
  Ti(t, e);
  function t(r, n) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(r, n) {
    return this;
  }, t;
}(zu), GR = {
  setInterval: function(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    return setInterval.apply(void 0, za([e, t], Ca(r)));
  },
  clearInterval: function(e) {
    return clearInterval(e);
  },
  delegate: void 0
}, lM = function(e) {
  Ti(t, e);
  function t(r, n) {
    var a = e.call(this, r, n) || this;
    return a.scheduler = r, a.work = n, a.pending = !1, a;
  }
  return t.prototype.schedule = function(r, n) {
    var a;
    if (n === void 0 && (n = 0), this.closed)
      return this;
    this.state = r;
    var i = this.id, o = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(o, i, n)), this.pending = !0, this.delay = n, this.id = (a = this.id) !== null && a !== void 0 ? a : this.requestAsyncId(o, this.id, n), this;
  }, t.prototype.requestAsyncId = function(r, n, a) {
    return a === void 0 && (a = 0), GR.setInterval(r.flush.bind(r, this), a);
  }, t.prototype.recycleAsyncId = function(r, n, a) {
    if (a === void 0 && (a = 0), a != null && this.delay === a && this.pending === !1)
      return n;
    n != null && GR.clearInterval(n);
  }, t.prototype.execute = function(r, n) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var a = this._execute(r, n);
    if (a)
      return a;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(r, n) {
    var a = !1, i;
    try {
      this.work(r);
    } catch (o) {
      a = !0, i = o || new Error("Scheduled action threw falsy error");
    }
    if (a)
      return this.unsubscribe(), i;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var r = this, n = r.id, a = r.scheduler, i = a.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Lp(i, this), n != null && (this.id = this.recycleAsyncId(a, n, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(Xee), xR = function() {
  function e(t, r) {
    r === void 0 && (r = e.now), this.schedulerActionCtor = t, this.now = r;
  }
  return e.prototype.schedule = function(t, r, n) {
    return r === void 0 && (r = 0), new this.schedulerActionCtor(this, t).schedule(n, r);
  }, e.now = kW.now, e;
}(), cM = function(e) {
  Ti(t, e);
  function t(r, n) {
    n === void 0 && (n = xR.now);
    var a = e.call(this, r, n) || this;
    return a.actions = [], a._active = !1, a;
  }
  return t.prototype.flush = function(r) {
    var n = this.actions;
    if (this._active) {
      n.push(r);
      return;
    }
    var a;
    this._active = !0;
    do
      if (a = r.execute(r.state, r.delay))
        break;
    while (r = n.shift());
    if (this._active = !1, a) {
      for (; r = n.shift(); )
        r.unsubscribe();
      throw a;
    }
  }, t;
}(xR), qu = new cM(lM), zee = qu, qee = function(e) {
  Ti(t, e);
  function t(r, n) {
    var a = e.call(this, r, n) || this;
    return a.scheduler = r, a.work = n, a;
  }
  return t.prototype.requestAsyncId = function(r, n, a) {
    return a === void 0 && (a = 0), a !== null && a > 0 ? e.prototype.requestAsyncId.call(this, r, n, a) : (r.actions.push(this), r._scheduled || (r._scheduled = Mk.requestAnimationFrame(function() {
      return r.flush(void 0);
    })));
  }, t.prototype.recycleAsyncId = function(r, n, a) {
    var i;
    if (a === void 0 && (a = 0), a != null ? a > 0 : this.delay > 0)
      return e.prototype.recycleAsyncId.call(this, r, n, a);
    var o = r.actions;
    n != null && ((i = o[o.length - 1]) === null || i === void 0 ? void 0 : i.id) !== n && (Mk.cancelAnimationFrame(n), r._scheduled = void 0);
  }, t;
}(lM), ete = function(e) {
  Ti(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.flush = function(r) {
    this._active = !0;
    var n = this._scheduled;
    this._scheduled = void 0;
    var a = this.actions, i;
    r = r || a.shift();
    do
      if (i = r.execute(r.state, r.delay))
        break;
    while ((r = a[0]) && r.id === n && a.shift());
    if (this._active = !1, i) {
      for (; (r = a[0]) && r.id === n && a.shift(); )
        r.unsubscribe();
      throw i;
    }
  }, t;
}(cM), yS = new ete(qee), ba = new Ht(function(e) {
  return e.complete();
});
function dM(e) {
  return e && Bt(e.schedule);
}
function _W(e) {
  return e[e.length - 1];
}
function NW(e) {
  return Bt(_W(e)) ? e.pop() : void 0;
}
function Gg(e) {
  return dM(_W(e)) ? e.pop() : void 0;
}
function tte(e, t) {
  return typeof _W(e) == "number" ? e.pop() : t;
}
var ZW = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function uM(e) {
  return Bt(e == null ? void 0 : e.then);
}
function hM(e) {
  return Bt(e[UW]);
}
function pM(e) {
  return Symbol.asyncIterator && Bt(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function gM(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function rte() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var fM = rte();
function mM(e) {
  return Bt(e == null ? void 0 : e[fM]);
}
function vM(e) {
  return Mee(this, arguments, function() {
    var r, n, a, i;
    return eM(this, function(o) {
      switch (o.label) {
        case 0:
          r = e.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, lp(r.read())];
        case 3:
          return n = o.sent(), a = n.value, i = n.done, i ? [4, lp(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, lp(a)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return r.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function SM(e) {
  return Bt(e == null ? void 0 : e.getReader);
}
function Tr(e) {
  if (e instanceof Ht)
    return e;
  if (e != null) {
    if (hM(e))
      return nte(e);
    if (ZW(e))
      return ate(e);
    if (uM(e))
      return ite(e);
    if (pM(e))
      return IM(e);
    if (mM(e))
      return ote(e);
    if (SM(e))
      return ste(e);
  }
  throw gM(e);
}
function nte(e) {
  return new Ht(function(t) {
    var r = e[UW]();
    if (Bt(r.subscribe))
      return r.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function ate(e) {
  return new Ht(function(t) {
    for (var r = 0; r < e.length && !t.closed; r++)
      t.next(e[r]);
    t.complete();
  });
}
function ite(e) {
  return new Ht(function(t) {
    e.then(function(r) {
      t.closed || (t.next(r), t.complete());
    }, function(r) {
      return t.error(r);
    }).then(null, iM);
  });
}
function ote(e) {
  return new Ht(function(t) {
    var r, n;
    try {
      for (var a = $o(e), i = a.next(); !i.done; i = a.next()) {
        var o = i.value;
        if (t.next(o), t.closed)
          return;
      }
    } catch (s) {
      r = { error: s };
    } finally {
      try {
        i && !i.done && (n = a.return) && n.call(a);
      } finally {
        if (r) throw r.error;
      }
    }
    t.complete();
  });
}
function IM(e) {
  return new Ht(function(t) {
    lte(e, t).catch(function(r) {
      return t.error(r);
    });
  });
}
function ste(e) {
  return IM(vM(e));
}
function lte(e, t) {
  var r, n, a, i;
  return Vee(this, void 0, void 0, function() {
    var o, s;
    return eM(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), r = Gee(e), c.label = 1;
        case 1:
          return [4, r.next()];
        case 2:
          if (n = c.sent(), !!n.done) return [3, 4];
          if (o = n.value, t.next(o), t.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return s = c.sent(), a = { error: s }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), n && !n.done && (i = r.return) ? [4, i.call(r)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (a) throw a.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function Ko(e, t, r, n, a) {
  n === void 0 && (n = 0), a === void 0 && (a = !1);
  var i = t.schedule(function() {
    r(), a ? e.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (e.add(i), !a)
    return i;
}
function Xc(e, t) {
  return t === void 0 && (t = 0), Lt(function(r, n) {
    r.subscribe(Jt(n, function(a) {
      return Ko(n, e, function() {
        return n.next(a);
      }, t);
    }, function() {
      return Ko(n, e, function() {
        return n.complete();
      }, t);
    }, function(a) {
      return Ko(n, e, function() {
        return n.error(a);
      }, t);
    }));
  });
}
function CM(e, t) {
  return t === void 0 && (t = 0), Lt(function(r, n) {
    n.add(e.schedule(function() {
      return r.subscribe(n);
    }, t));
  });
}
function cte(e, t) {
  return Tr(e).pipe(CM(t), Xc(t));
}
function dte(e, t) {
  return Tr(e).pipe(CM(t), Xc(t));
}
function ute(e, t) {
  return new Ht(function(r) {
    var n = 0;
    return t.schedule(function() {
      n === e.length ? r.complete() : (r.next(e[n++]), r.closed || this.schedule());
    });
  });
}
function hte(e, t) {
  return new Ht(function(r) {
    var n;
    return Ko(r, t, function() {
      n = e[fM](), Ko(r, t, function() {
        var a, i, o;
        try {
          a = n.next(), i = a.value, o = a.done;
        } catch (s) {
          r.error(s);
          return;
        }
        o ? r.complete() : r.next(i);
      }, 0, !0);
    }), function() {
      return Bt(n == null ? void 0 : n.return) && n.return();
    };
  });
}
function bM(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new Ht(function(r) {
    Ko(r, t, function() {
      var n = e[Symbol.asyncIterator]();
      Ko(r, t, function() {
        n.next().then(function(a) {
          a.done ? r.complete() : r.next(a.value);
        });
      }, 0, !0);
    });
  });
}
function pte(e, t) {
  return bM(vM(e), t);
}
function gte(e, t) {
  if (e != null) {
    if (hM(e))
      return cte(e, t);
    if (ZW(e))
      return ute(e, t);
    if (uM(e))
      return dte(e, t);
    if (pM(e))
      return bM(e, t);
    if (mM(e))
      return hte(e, t);
    if (SM(e))
      return pte(e, t);
  }
  throw gM(e);
}
function po(e, t) {
  return t ? gte(e, t) : Tr(e);
}
function Sa() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Gg(e);
  return po(e, r);
}
function zc(e, t) {
  var r = Bt(e) ? e : function() {
    return e;
  }, n = function(a) {
    return a.error(r());
  };
  return new Ht(n);
}
var BW = wW(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function Be(e, t) {
  var r = typeof t == "object";
  return new Promise(function(n, a) {
    var i = new Yp({
      next: function(o) {
        n(o), i.unsubscribe();
      },
      error: a,
      complete: function() {
        r ? n(t.defaultValue) : a(new BW());
      }
    });
    e.subscribe(i);
  });
}
function fte(e) {
  return e instanceof Date && !isNaN(e);
}
function te(e, t) {
  return Lt(function(r, n) {
    var a = 0;
    r.subscribe(Jt(n, function(i) {
      n.next(e.call(t, i, a++));
    }));
  });
}
var mte = Array.isArray;
function vte(e, t) {
  return mte(t) ? e.apply(void 0, za([], Ca(t))) : e(t);
}
function WW(e) {
  return te(function(t) {
    return vte(e, t);
  });
}
var Ste = Array.isArray, Ite = Object.getPrototypeOf, Cte = Object.prototype, bte = Object.keys;
function yte(e) {
  if (e.length === 1) {
    var t = e[0];
    if (Ste(t))
      return { args: t, keys: null };
    if (wte(t)) {
      var r = bte(t);
      return {
        args: r.map(function(n) {
          return t[n];
        }),
        keys: r
      };
    }
  }
  return { args: e, keys: null };
}
function wte(e) {
  return e && typeof e == "object" && Ite(e) === Cte;
}
function Ate(e, t) {
  return e.reduce(function(r, n, a) {
    return r[n] = t[a], r;
  }, {});
}
function Ute() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Gg(e), n = NW(e), a = yte(e), i = a.args, o = a.keys;
  if (i.length === 0)
    return po([], r);
  var s = new Ht(yM(i, r, o ? function(c) {
    return Ate(o, c);
  } : Al));
  return n ? s.pipe(WW(n)) : s;
}
function yM(e, t, r) {
  return r === void 0 && (r = Al), function(n) {
    HR(t, function() {
      for (var a = e.length, i = new Array(a), o = a, s = a, c = function(u) {
        HR(t, function() {
          var g = po(e[u], t), p = !1;
          g.subscribe(Jt(n, function(m) {
            i[u] = m, p || (p = !0, s--), s || n.next(r(i.slice()));
          }, function() {
            --o || n.complete();
          }));
        }, n);
      }, l = 0; l < a; l++)
        c(l);
    }, n);
  };
}
function HR(e, t, r) {
  e ? Ko(r, e, t) : t();
}
function kte(e, t, r, n, a, i, o, s) {
  var c = [], l = 0, u = 0, g = !1, p = function() {
    g && !c.length && !l && t.complete();
  }, m = function(C) {
    return l < n ? I(C) : c.push(C);
  }, I = function(C) {
    l++;
    var A = !1;
    Tr(r(C, u++)).subscribe(Jt(t, function(U) {
      t.next(U);
    }, function() {
      A = !0;
    }, void 0, function() {
      if (A)
        try {
          l--;
          for (var U = function() {
            var B = c.shift();
            o || I(B);
          }; c.length && l < n; )
            U();
          p();
        } catch (B) {
          t.error(B);
        }
    }));
  };
  return e.subscribe(Jt(t, m, function() {
    g = !0, p();
  })), function() {
  };
}
function ao(e, t, r) {
  return r === void 0 && (r = 1 / 0), Bt(t) ? ao(function(n, a) {
    return te(function(i, o) {
      return t(n, i, a, o);
    })(Tr(e(n, a)));
  }, r) : (typeof t == "number" && (r = t), Lt(function(n, a) {
    return kte(n, a, e, r);
  }));
}
function wM(e) {
  return e === void 0 && (e = 1 / 0), ao(Al, e);
}
function _te() {
  return wM(1);
}
function p1() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return _te()(po(e, Gg(e)));
}
function vn(e) {
  return new Ht(function(t) {
    Tr(e()).subscribe(t);
  });
}
var Nte = ["addListener", "removeListener"], Zte = ["addEventListener", "removeEventListener"], Bte = ["on", "off"];
function Ke(e, t, r, n) {
  if (Bt(r) && (n = r, r = void 0), n)
    return Ke(e, t, r).pipe(WW(n));
  var a = Ca(Qte(e) ? Zte.map(function(s) {
    return function(c) {
      return e[s](t, c, r);
    };
  }) : Wte(e) ? Nte.map(LR(e, t)) : Ete(e) ? Bte.map(LR(e, t)) : [], 2), i = a[0], o = a[1];
  if (!i && ZW(e))
    return ao(function(s) {
      return Ke(s, t, r);
    })(Tr(e));
  if (!i)
    throw new TypeError("Invalid event target");
  return new Ht(function(s) {
    var c = function() {
      for (var l = [], u = 0; u < arguments.length; u++)
        l[u] = arguments[u];
      return s.next(1 < l.length ? l : l[0]);
    };
    return i(c), function() {
      return o(c);
    };
  });
}
function LR(e, t) {
  return function(r) {
    return function(n) {
      return e[r](t, n);
    };
  };
}
function Wte(e) {
  return Bt(e.addListener) && Bt(e.removeListener);
}
function Ete(e) {
  return Bt(e.on) && Bt(e.off);
}
function Qte(e) {
  return Bt(e.addEventListener) && Bt(e.removeEventListener);
}
function hs(e, t, r) {
  e === void 0 && (e = 0), r === void 0 && (r = zee);
  var n = -1;
  return t != null && (dM(t) ? r = t : n = t), new Ht(function(a) {
    var i = fte(e) ? +e - r.now() : e;
    i < 0 && (i = 0);
    var o = 0;
    return r.schedule(function() {
      a.closed || (a.next(o++), 0 <= n ? this.schedule(void 0, n) : a.complete());
    }, i);
  });
}
function E2(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = qu), e < 0 && (e = 0), hs(e, e, t);
}
function ps() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Gg(e), n = tte(e, 1 / 0), a = e;
  return a.length ? a.length === 1 ? Tr(a[0]) : wM(n)(po(a, r)) : ba;
}
var om = new Ht(im), Fte = Array.isArray;
function AM(e) {
  return e.length === 1 && Fte(e[0]) ? e[0] : e;
}
function at(e, t) {
  return Lt(function(r, n) {
    var a = 0;
    r.subscribe(Jt(n, function(i) {
      return e.call(t, i, a++) && n.next(i);
    }));
  });
}
function UM() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e = AM(e), e.length === 1 ? Tr(e[0]) : new Ht(Tte(e));
}
function Tte(e) {
  return function(t) {
    for (var r = [], n = function(i) {
      r.push(Tr(e[i]).subscribe(Jt(t, function(o) {
        if (r) {
          for (var s = 0; s < r.length; s++)
            s !== i && r[s].unsubscribe();
          r = null;
        }
        t.next(o);
      })));
    }, a = 0; r && !t.closed && a < e.length; a++)
      n(a);
  };
}
function kM(e, t) {
  return t === void 0 && (t = null), t = t ?? e, Lt(function(r, n) {
    var a = [], i = 0;
    r.subscribe(Jt(n, function(o) {
      var s, c, l, u, g = null;
      i++ % t === 0 && a.push([]);
      try {
        for (var p = $o(a), m = p.next(); !m.done; m = p.next()) {
          var I = m.value;
          I.push(o), e <= I.length && (g = g ?? [], g.push(I));
        }
      } catch (U) {
        s = { error: U };
      } finally {
        try {
          m && !m.done && (c = p.return) && c.call(p);
        } finally {
          if (s) throw s.error;
        }
      }
      if (g)
        try {
          for (var C = $o(g), A = C.next(); !A.done; A = C.next()) {
            var I = A.value;
            Lp(a, I), n.next(I);
          }
        } catch (U) {
          l = { error: U };
        } finally {
          try {
            A && !A.done && (u = C.return) && u.call(C);
          } finally {
            if (l) throw l.error;
          }
        }
    }, function() {
      var o, s;
      try {
        for (var c = $o(a), l = c.next(); !l.done; l = c.next()) {
          var u = l.value;
          n.next(u);
        }
      } catch (g) {
        o = { error: g };
      } finally {
        try {
          l && !l.done && (s = c.return) && s.call(c);
        } finally {
          if (o) throw o.error;
        }
      }
      n.complete();
    }, void 0, function() {
      a = null;
    }));
  });
}
function Rte(e) {
  for (var t, r, n = [], a = 1; a < arguments.length; a++)
    n[a - 1] = arguments[a];
  var i = (t = Gg(n)) !== null && t !== void 0 ? t : qu, o = (r = n[0]) !== null && r !== void 0 ? r : null, s = n[1] || 1 / 0;
  return Lt(function(c, l) {
    var u = [], g = !1, p = function(C) {
      var A = C.buffer, U = C.subs;
      U.unsubscribe(), Lp(u, C), l.next(A), g && m();
    }, m = function() {
      if (u) {
        var C = new zu();
        l.add(C);
        var A = [], U = {
          buffer: A,
          subs: C
        };
        u.push(U), Ko(C, i, function() {
          return p(U);
        }, e);
      }
    };
    o !== null && o >= 0 ? Ko(l, i, m, o, !0) : g = !0, m();
    var I = Jt(l, function(C) {
      var A, U, B = u.slice();
      try {
        for (var J = $o(B), W = J.next(); !W.done; W = J.next()) {
          var L = W.value, H = L.buffer;
          H.push(C), s <= H.length && p(L);
        }
      } catch (R) {
        A = { error: R };
      } finally {
        try {
          W && !W.done && (U = J.return) && U.call(J);
        } finally {
          if (A) throw A.error;
        }
      }
    }, function() {
      for (; u != null && u.length; )
        l.next(u.shift().buffer);
      I == null || I.unsubscribe(), l.complete(), l.unsubscribe();
    }, void 0, function() {
      return u = null;
    });
    c.subscribe(I);
  });
}
function ti(e) {
  return Lt(function(t, r) {
    var n = null, a = !1, i;
    n = t.subscribe(Jt(r, void 0, void 0, function(o) {
      i = Tr(e(o, ti(e)(t))), n ? (n.unsubscribe(), n = null, i.subscribe(r)) : a = !0;
    })), a && (n.unsubscribe(), n = null, i.subscribe(r));
  });
}
function _M(e, t, r, n, a) {
  return function(i, o) {
    var s = r, c = t, l = 0;
    i.subscribe(Jt(o, function(u) {
      var g = l++;
      c = s ? e(c, u, g) : (s = !0, u), n && o.next(c);
    }, a && function() {
      s && o.next(c), o.complete();
    }));
  };
}
function Dte(e, t) {
  return Lt(_M(e, t, arguments.length >= 2, !1, !0));
}
var Jte = function(e, t) {
  return e.push(t), e;
};
function wS() {
  return Lt(function(e, t) {
    Dte(Jte, [])(e).subscribe(t);
  });
}
function NM() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = NW(e);
  return r ? ho(NM.apply(void 0, za([], Ca(e))), WW(r)) : Lt(function(n, a) {
    yM(za([n], Ca(AM(e))))(a);
  });
}
function $a() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return NM.apply(void 0, za([], Ca(e)));
}
function Wi(e, t) {
  return Bt(t) ? ao(e, t, 1) : ao(e, 1);
}
function ZM(e, t) {
  return t === void 0 && (t = qu), Lt(function(r, n) {
    var a = null, i = null, o = null, s = function() {
      if (a) {
        a.unsubscribe(), a = null;
        var l = i;
        i = null, n.next(l);
      }
    };
    function c() {
      var l = o + e, u = t.now();
      if (u < l) {
        a = this.schedule(void 0, l - u), n.add(a);
        return;
      }
      s();
    }
    r.subscribe(Jt(n, function(l) {
      i = l, o = t.now(), a || (a = t.schedule(c, e), n.add(a));
    }, function() {
      s(), n.complete();
    }, void 0, function() {
      i = a = null;
    }));
  });
}
function Vte(e) {
  return Lt(function(t, r) {
    var n = !1;
    t.subscribe(Jt(r, function(a) {
      n = !0, r.next(a);
    }, function() {
      n || r.next(e), r.complete();
    }));
  });
}
function qc(e) {
  return e <= 0 ? function() {
    return ba;
  } : Lt(function(t, r) {
    var n = 0;
    t.subscribe(Jt(r, function(a) {
      ++n <= e && (r.next(a), e <= n && r.complete());
    }));
  });
}
function Mte(e) {
  return te(function() {
    return e;
  });
}
function Gte(e, t) {
  return ao(function(r, n) {
    return Tr(e(r, n)).pipe(qc(1), Mte(r));
  });
}
function BM(e, t) {
  t === void 0 && (t = qu);
  var r = hs(e, t);
  return Gte(function() {
    return r;
  });
}
function vt(e, t) {
  return t === void 0 && (t = Al), e = e ?? xte, Lt(function(r, n) {
    var a, i = !0;
    r.subscribe(Jt(n, function(o) {
      var s = t(o);
      (i || !e(a, s)) && (i = !1, a = s, n.next(o));
    }));
  });
}
function xte(e, t) {
  return e === t;
}
function Hte(e) {
  return e === void 0 && (e = Lte), Lt(function(t, r) {
    var n = !1;
    t.subscribe(Jt(r, function(a) {
      n = !0, r.next(a);
    }, function() {
      return n ? r.complete() : r.error(e());
    }));
  });
}
function Lte() {
  return new BW();
}
function WM(e) {
  return Lt(function(t, r) {
    try {
      t.subscribe(r);
    } finally {
      r.add(e);
    }
  });
}
function Yte(e, t) {
  var r = arguments.length >= 2;
  return function(n) {
    return n.pipe(e ? at(function(a, i) {
      return e(a, i, n);
    }) : Al, qc(1), r ? Vte(t) : Hte(function() {
      return new BW();
    }));
  };
}
function EW() {
  return Lt(function(e, t) {
    var r, n = !1;
    e.subscribe(Jt(t, function(a) {
      var i = r;
      r = a, n && t.next([i, a]), n = !0;
    }));
  });
}
function Ote(e) {
  var t, r = 1 / 0, n;
  return e != null && (typeof e == "object" ? (t = e.count, r = t === void 0 ? 1 / 0 : t, n = e.delay) : r = e), r <= 0 ? function() {
    return ba;
  } : Lt(function(a, i) {
    var o = 0, s, c = function() {
      if (s == null || s.unsubscribe(), s = null, n != null) {
        var u = typeof n == "number" ? hs(n) : Tr(n(o)), g = Jt(i, function() {
          g.unsubscribe(), l();
        });
        u.subscribe(g);
      } else
        l();
    }, l = function() {
      var u = !1;
      s = a.subscribe(Jt(i, void 0, function() {
        ++o < r ? s ? c() : u = !0 : i.complete();
      })), u && c();
    };
    l();
  });
}
function EM(e) {
  e === void 0 && (e = 1 / 0);
  var t;
  e && typeof e == "object" ? t = e : t = {
    count: e
  };
  var r = t.count, n = r === void 0 ? 1 / 0 : r, a = t.delay, i = t.resetOnSuccess, o = i === void 0 ? !1 : i;
  return n <= 0 ? Al : Lt(function(s, c) {
    var l = 0, u, g = function() {
      var p = !1;
      u = s.subscribe(Jt(c, function(m) {
        o && (l = 0), c.next(m);
      }, void 0, function(m) {
        if (l++ < n) {
          var I = function() {
            u ? (u.unsubscribe(), u = null, g()) : p = !0;
          };
          if (a != null) {
            var C = typeof a == "number" ? hs(a) : Tr(a(m, l)), A = Jt(c, function() {
              A.unsubscribe(), I();
            }, function() {
              c.complete();
            });
            C.subscribe(A);
          } else
            I();
        } else
          c.error(m);
      })), p && (u.unsubscribe(), u = null, g());
    };
    g();
  });
}
function jte(e, t) {
  return Lt(_M(e, t, arguments.length >= 2, !0));
}
function Gk(e) {
  e === void 0 && (e = {});
  var t = e.connector, r = t === void 0 ? function() {
    return new _e();
  } : t, n = e.resetOnError, a = n === void 0 ? !0 : n, i = e.resetOnComplete, o = i === void 0 ? !0 : i, s = e.resetOnRefCountZero, c = s === void 0 ? !0 : s;
  return function(l) {
    var u, g, p, m = 0, I = !1, C = !1, A = function() {
      g == null || g.unsubscribe(), g = void 0;
    }, U = function() {
      A(), u = p = void 0, I = C = !1;
    }, B = function() {
      var J = u;
      U(), J == null || J.unsubscribe();
    };
    return Lt(function(J, W) {
      m++, !C && !I && A();
      var L = p = p ?? r();
      W.add(function() {
        m--, m === 0 && !C && !I && (g = LA(B, c));
      }), L.subscribe(W), !u && m > 0 && (u = new Yp({
        next: function(H) {
          return L.next(H);
        },
        error: function(H) {
          C = !0, A(), g = LA(U, a, H), L.error(H);
        },
        complete: function() {
          I = !0, A(), g = LA(U, o), L.complete();
        }
      }), Tr(J).subscribe(u));
    })(l);
  };
}
function LA(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  if (t === !0) {
    e();
    return;
  }
  if (t !== !1) {
    var a = new Yp({
      next: function() {
        a.unsubscribe(), e();
      }
    });
    return Tr(t.apply(void 0, za([], Ca(r)))).subscribe(a);
  }
}
function QW(e, t, r) {
  var n, a, i, o, s = !1;
  return e && typeof e == "object" ? (n = e.bufferSize, o = n === void 0 ? 1 / 0 : n, a = e.windowTime, t = a === void 0 ? 1 / 0 : a, i = e.refCount, s = i === void 0 ? !1 : i, r = e.scheduler) : o = e ?? 1 / 0, Gk({
    connector: function() {
      return new sM(o, t, r);
    },
    resetOnError: !0,
    resetOnComplete: !1,
    resetOnRefCountZero: s
  });
}
function QM(e) {
  return at(function(t, r) {
    return e <= r;
  });
}
function FW() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Gg(e);
  return Lt(function(n, a) {
    (r ? p1(e, n, r) : p1(e, n)).subscribe(a);
  });
}
function Wt(e, t) {
  return Lt(function(r, n) {
    var a = null, i = 0, o = !1, s = function() {
      return o && !a && n.complete();
    };
    r.subscribe(Jt(n, function(c) {
      a == null || a.unsubscribe();
      var l = 0, u = i++;
      Tr(e(c, u)).subscribe(a = Jt(n, function(g) {
        return n.next(t ? t(c, g, u, l++) : g);
      }, function() {
        a = null, s();
      }));
    }, function() {
      o = !0, s();
    }));
  });
}
function le(e) {
  return Lt(function(t, r) {
    Tr(e).subscribe(Jt(r, function() {
      return r.complete();
    }, im)), !r.closed && t.subscribe(r);
  });
}
function ae(e, t, r) {
  var n = Bt(e) || t || r ? { next: e, error: t, complete: r } : e;
  return n ? Lt(function(a, i) {
    var o;
    (o = n.subscribe) === null || o === void 0 || o.call(n);
    var s = !0;
    a.subscribe(Jt(i, function(c) {
      var l;
      (l = n.next) === null || l === void 0 || l.call(n, c), i.next(c);
    }, function() {
      var c;
      s = !1, (c = n.complete) === null || c === void 0 || c.call(n), i.complete();
    }, function(c) {
      var l;
      s = !1, (l = n.error) === null || l === void 0 || l.call(n, c), i.error(c);
    }, function() {
      var c, l;
      s && ((c = n.unsubscribe) === null || c === void 0 || c.call(n)), (l = n.finalize) === null || l === void 0 || l.call(n);
    }));
  }) : Al;
}
function Pte(e, t) {
  return Lt(function(r, n) {
    var a = t ?? {}, i = a.leading, o = i === void 0 ? !0 : i, s = a.trailing, c = s === void 0 ? !1 : s, l = !1, u = null, g = null, p = !1, m = function() {
      g == null || g.unsubscribe(), g = null, c && (A(), p && n.complete());
    }, I = function() {
      g = null, p && n.complete();
    }, C = function(U) {
      return g = Tr(e(U)).subscribe(Jt(n, m, I));
    }, A = function() {
      if (l) {
        l = !1;
        var U = u;
        u = null, n.next(U), !p && C(U);
      }
    };
    r.subscribe(Jt(n, function(U) {
      l = !0, u = U, !(g && !g.closed) && (o ? A() : C(U));
    }, function() {
      p = !0, !(c && l && g && !g.closed) && n.complete();
    }));
  });
}
function $te(e, t, r) {
  t === void 0 && (t = qu);
  var n = hs(e, t);
  return Pte(function() {
    return n;
  }, r);
}
function go() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = NW(e);
  return Lt(function(n, a) {
    for (var i = e.length, o = new Array(i), s = e.map(function() {
      return !1;
    }), c = !1, l = function(g) {
      Tr(e[g]).subscribe(Jt(a, function(p) {
        o[g] = p, !c && !s[g] && (s[g] = !0, (c = s.every(Al)) && (s = null));
      }, im));
    }, u = 0; u < i; u++)
      l(u);
    n.subscribe(Jt(a, function(g) {
      if (c) {
        var p = za([g], Ca(o));
        a.next(r ? r.apply(void 0, za([], Ca(p))) : p);
      }
    }));
  });
}
var bv, Cp, yv, bp;
class ue {
  constructor(t, r, n) {
    E(this, bv);
    E(this, Cp);
    E(this, yv);
    E(this, bp);
    G(this, bp, n), G(this, yv, r), G(this, Cp, t), S(this, Cp).addController(this);
  }
  hostConnected() {
    G(this, bv, S(this, yv).subscribe((t) => {
      G(this, bp, t), S(this, Cp).requestUpdate();
    }));
  }
  hostDisconnected() {
    var t;
    (t = S(this, bv)) == null || t.unsubscribe();
  }
  get value() {
    return S(this, bp);
  }
}
bv = new WeakMap(), Cp = new WeakMap(), yv = new WeakMap(), bp = new WeakMap();
const Dd = async (e, t = 0) => new Promise((r) => {
  setTimeout(() => {
    e(), r();
  }, t);
}), Q2 = async (e = 0, t) => new Promise((r, n) => {
  setTimeout(() => {
    n(t);
  }, e);
});
var FM = typeof global == "object" && global && global.Object === Object && global, Kte = typeof self == "object" && self && self.Object === Object && self, fo = FM || Kte || Function("return this")(), Ei = fo.Symbol, TM = Object.prototype, Xte = TM.hasOwnProperty, zte = TM.toString, k0 = Ei ? Ei.toStringTag : void 0;
function qte(e) {
  var t = Xte.call(e, k0), r = e[k0];
  try {
    e[k0] = void 0;
    var n = !0;
  } catch {
  }
  var a = zte.call(e);
  return n && (t ? e[k0] = r : delete e[k0]), a;
}
var ere = Object.prototype, tre = ere.toString;
function rre(e) {
  return tre.call(e);
}
var nre = "[object Null]", are = "[object Undefined]", YR = Ei ? Ei.toStringTag : void 0;
function ed(e) {
  return e == null ? e === void 0 ? are : nre : YR && YR in Object(e) ? qte(e) : rre(e);
}
function is(e) {
  return e != null && typeof e == "object";
}
var ire = "[object Symbol]";
function Op(e) {
  return typeof e == "symbol" || is(e) && ed(e) == ire;
}
function cp(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Pn = Array.isArray, ore = 1 / 0, OR = Ei ? Ei.prototype : void 0, jR = OR ? OR.toString : void 0;
function RM(e) {
  if (typeof e == "string")
    return e;
  if (Pn(e))
    return cp(e, RM) + "";
  if (Op(e))
    return jR ? jR.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -ore ? "-0" : t;
}
var sre = /\s/;
function lre(e) {
  for (var t = e.length; t-- && sre.test(e.charAt(t)); )
    ;
  return t;
}
var cre = /^\s+/;
function dre(e) {
  return e && e.slice(0, lre(e) + 1).replace(cre, "");
}
function io(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var PR = NaN, ure = /^[-+]0x[0-9a-f]+$/i, hre = /^0b[01]+$/i, pre = /^0o[0-7]+$/i, gre = parseInt;
function $R(e) {
  if (typeof e == "number")
    return e;
  if (Op(e))
    return PR;
  if (io(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = io(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = dre(e);
  var r = hre.test(e);
  return r || pre.test(e) ? gre(e.slice(2), r ? 2 : 8) : ure.test(e) ? PR : +e;
}
function F2(e) {
  return e;
}
var fre = "[object AsyncFunction]", mre = "[object Function]", vre = "[object GeneratorFunction]", Sre = "[object Proxy]";
function DM(e) {
  if (!io(e))
    return !1;
  var t = ed(e);
  return t == mre || t == vre || t == fre || t == Sre;
}
var YA = fo["__core-js_shared__"], KR = function() {
  var e = /[^.]+$/.exec(YA && YA.keys && YA.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Ire(e) {
  return !!KR && KR in e;
}
var Cre = Function.prototype, bre = Cre.toString;
function eh(e) {
  if (e != null) {
    try {
      return bre.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var yre = /[\\^$.*+?()[\]{}|]/g, wre = /^\[object .+?Constructor\]$/, Are = Function.prototype, Ure = Object.prototype, kre = Are.toString, _re = Ure.hasOwnProperty, Nre = RegExp(
  "^" + kre.call(_re).replace(yre, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Zre(e) {
  if (!io(e) || Ire(e))
    return !1;
  var t = DM(e) ? Nre : wre;
  return t.test(eh(e));
}
function Bre(e, t) {
  return e == null ? void 0 : e[t];
}
function th(e, t) {
  var r = Bre(e, t);
  return Zre(r) ? r : void 0;
}
var xk = th(fo, "WeakMap"), XR = Object.create, Wre = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!io(t))
      return {};
    if (XR)
      return XR(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
function JM(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function Ere() {
}
function Qre(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var Fre = 800, Tre = 16, Rre = Date.now;
function Dre(e) {
  var t = 0, r = 0;
  return function() {
    var n = Rre(), a = Tre - (n - r);
    if (r = n, a > 0) {
      if (++t >= Fre)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Jre(e) {
  return function() {
    return e;
  };
}
var g1 = function() {
  try {
    var e = th(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Vre = g1 ? function(e, t) {
  return g1(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Jre(t),
    writable: !0
  });
} : F2, VM = Dre(Vre);
function Mre(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
function Gre(e, t, r, n) {
  for (var a = e.length, i = r + -1; ++i < a; )
    if (t(e[i], i, e))
      return i;
  return -1;
}
function xre(e) {
  return e !== e;
}
function Hre(e, t, r) {
  for (var n = r - 1, a = e.length; ++n < a; )
    if (e[n] === t)
      return n;
  return -1;
}
function Lre(e, t, r) {
  return t === t ? Hre(e, t, r) : Gre(e, xre, r);
}
function Yre(e, t) {
  var r = e == null ? 0 : e.length;
  return !!r && Lre(e, t, 0) > -1;
}
var Ore = 9007199254740991, jre = /^(?:0|[1-9]\d*)$/;
function TW(e, t) {
  var r = typeof e;
  return t = t ?? Ore, !!t && (r == "number" || r != "symbol" && jre.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function RW(e, t, r) {
  t == "__proto__" && g1 ? g1(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function AS(e, t) {
  return e === t || e !== e && t !== t;
}
var Pre = Object.prototype, $re = Pre.hasOwnProperty;
function MM(e, t, r) {
  var n = e[t];
  (!($re.call(e, t) && AS(n, r)) || r === void 0 && !(t in e)) && RW(e, t, r);
}
function xg(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], c = n ? n(r[s], e[s], s, r, e) : void 0;
    c === void 0 && (c = e[s]), a ? RW(r, s, c) : MM(r, s, c);
  }
  return r;
}
var zR = Math.max;
function GM(e, t, r) {
  return t = zR(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = zR(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), JM(e, this, s);
  };
}
function xM(e, t) {
  return VM(GM(e, t, F2), e + "");
}
var Kre = 9007199254740991;
function DW(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Kre;
}
function US(e) {
  return e != null && DW(e.length) && !DM(e);
}
function Xre(e, t, r) {
  if (!io(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? US(r) && TW(t, r.length) : n == "string" && t in r) ? AS(r[t], e) : !1;
}
function zre(e) {
  return xM(function(t, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && Xre(r[0], r[1], o) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++n < a; ) {
      var s = r[n];
      s && e(t, s, n, i);
    }
    return t;
  });
}
var qre = Object.prototype;
function JW(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || qre;
  return e === r;
}
function ene(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var tne = "[object Arguments]";
function qR(e) {
  return is(e) && ed(e) == tne;
}
var HM = Object.prototype, rne = HM.hasOwnProperty, nne = HM.propertyIsEnumerable, VW = qR(/* @__PURE__ */ function() {
  return arguments;
}()) ? qR : function(e) {
  return is(e) && rne.call(e, "callee") && !nne.call(e, "callee");
};
function ane() {
  return !1;
}
var LM = typeof exports == "object" && exports && !exports.nodeType && exports, e5 = LM && typeof module == "object" && module && !module.nodeType && module, ine = e5 && e5.exports === LM, t5 = ine ? fo.Buffer : void 0, one = t5 ? t5.isBuffer : void 0, f1 = one || ane, sne = "[object Arguments]", lne = "[object Array]", cne = "[object Boolean]", dne = "[object Date]", une = "[object Error]", hne = "[object Function]", pne = "[object Map]", gne = "[object Number]", fne = "[object Object]", mne = "[object RegExp]", vne = "[object Set]", Sne = "[object String]", Ine = "[object WeakMap]", Cne = "[object ArrayBuffer]", bne = "[object DataView]", yne = "[object Float32Array]", wne = "[object Float64Array]", Ane = "[object Int8Array]", Une = "[object Int16Array]", kne = "[object Int32Array]", _ne = "[object Uint8Array]", Nne = "[object Uint8ClampedArray]", Zne = "[object Uint16Array]", Bne = "[object Uint32Array]", zt = {};
zt[yne] = zt[wne] = zt[Ane] = zt[Une] = zt[kne] = zt[_ne] = zt[Nne] = zt[Zne] = zt[Bne] = !0;
zt[sne] = zt[lne] = zt[Cne] = zt[cne] = zt[bne] = zt[dne] = zt[une] = zt[hne] = zt[pne] = zt[gne] = zt[fne] = zt[mne] = zt[vne] = zt[Sne] = zt[Ine] = !1;
function Wne(e) {
  return is(e) && DW(e.length) && !!zt[ed(e)];
}
function T2(e) {
  return function(t) {
    return e(t);
  };
}
var YM = typeof exports == "object" && exports && !exports.nodeType && exports, Tf = YM && typeof module == "object" && module && !module.nodeType && module, Ene = Tf && Tf.exports === YM, OA = Ene && FM.process, jp = function() {
  try {
    var e = Tf && Tf.require && Tf.require("util").types;
    return e || OA && OA.binding && OA.binding("util");
  } catch {
  }
}(), r5 = jp && jp.isTypedArray, OM = r5 ? T2(r5) : Wne, Qne = Object.prototype, Fne = Qne.hasOwnProperty;
function jM(e, t) {
  var r = Pn(e), n = !r && VW(e), a = !r && !n && f1(e), i = !r && !n && !a && OM(e), o = r || n || a || i, s = o ? ene(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || Fne.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    TW(l, c))) && s.push(l);
  return s;
}
function PM(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Tne = PM(Object.keys, Object), Rne = Object.prototype, Dne = Rne.hasOwnProperty;
function Jne(e) {
  if (!JW(e))
    return Tne(e);
  var t = [];
  for (var r in Object(e))
    Dne.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Hg(e) {
  return US(e) ? jM(e) : Jne(e);
}
function Vne(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Mne = Object.prototype, Gne = Mne.hasOwnProperty;
function xne(e) {
  if (!io(e))
    return Vne(e);
  var t = JW(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !Gne.call(e, n)) || r.push(n);
  return r;
}
function R2(e) {
  return US(e) ? jM(e, !0) : xne(e);
}
var n5 = zre(function(e, t, r, n) {
  xg(t, R2(t), e, n);
}), Hne = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Lne = /^\w*$/;
function MW(e, t) {
  if (Pn(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || Op(e) ? !0 : Lne.test(e) || !Hne.test(e) || t != null && e in Object(t);
}
var sm = th(Object, "create");
function Yne() {
  this.__data__ = sm ? sm(null) : {}, this.size = 0;
}
function One(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var jne = "__lodash_hash_undefined__", Pne = Object.prototype, $ne = Pne.hasOwnProperty;
function Kne(e) {
  var t = this.__data__;
  if (sm) {
    var r = t[e];
    return r === jne ? void 0 : r;
  }
  return $ne.call(t, e) ? t[e] : void 0;
}
var Xne = Object.prototype, zne = Xne.hasOwnProperty;
function qne(e) {
  var t = this.__data__;
  return sm ? t[e] !== void 0 : zne.call(t, e);
}
var eae = "__lodash_hash_undefined__";
function tae(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = sm && t === void 0 ? eae : t, this;
}
function Zu(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Zu.prototype.clear = Yne;
Zu.prototype.delete = One;
Zu.prototype.get = Kne;
Zu.prototype.has = qne;
Zu.prototype.set = tae;
function rae() {
  this.__data__ = [], this.size = 0;
}
function D2(e, t) {
  for (var r = e.length; r--; )
    if (AS(e[r][0], t))
      return r;
  return -1;
}
var nae = Array.prototype, aae = nae.splice;
function iae(e) {
  var t = this.__data__, r = D2(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : aae.call(t, r, 1), --this.size, !0;
}
function oae(e) {
  var t = this.__data__, r = D2(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function sae(e) {
  return D2(this.__data__, e) > -1;
}
function lae(e, t) {
  var r = this.__data__, n = D2(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function Ul(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ul.prototype.clear = rae;
Ul.prototype.delete = iae;
Ul.prototype.get = oae;
Ul.prototype.has = sae;
Ul.prototype.set = lae;
var lm = th(fo, "Map");
function cae() {
  this.size = 0, this.__data__ = {
    hash: new Zu(),
    map: new (lm || Ul)(),
    string: new Zu()
  };
}
function dae(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function J2(e, t) {
  var r = e.__data__;
  return dae(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function uae(e) {
  var t = J2(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function hae(e) {
  return J2(this, e).get(e);
}
function pae(e) {
  return J2(this, e).has(e);
}
function gae(e, t) {
  var r = J2(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function kl(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
kl.prototype.clear = cae;
kl.prototype.delete = uae;
kl.prototype.get = hae;
kl.prototype.has = pae;
kl.prototype.set = gae;
var fae = "Expected a function";
function GW(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(fae);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (GW.Cache || kl)(), r;
}
GW.Cache = kl;
var mae = 500;
function vae(e) {
  var t = GW(e, function(n) {
    return r.size === mae && r.clear(), n;
  }), r = t.cache;
  return t;
}
var Sae = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Iae = /\\(\\)?/g, Cae = vae(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Sae, function(r, n, a, i) {
    t.push(a ? i.replace(Iae, "$1") : n || r);
  }), t;
});
function xW(e) {
  return e == null ? "" : RM(e);
}
function V2(e, t) {
  return Pn(e) ? e : MW(e, t) ? [e] : Cae(xW(e));
}
var bae = 1 / 0;
function kS(e) {
  if (typeof e == "string" || Op(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -bae ? "-0" : t;
}
function M2(e, t) {
  t = V2(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[kS(t[r++])];
  return r && r == n ? e : void 0;
}
function yae(e, t, r) {
  var n = e == null ? void 0 : M2(e, t);
  return n === void 0 ? r : n;
}
function HW(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var a5 = Ei ? Ei.isConcatSpreadable : void 0;
function wae(e) {
  return Pn(e) || VW(e) || !!(a5 && e && e[a5]);
}
function Aae(e, t, r, n, a) {
  var i = -1, o = e.length;
  for (r || (r = wae), a || (a = []); ++i < o; ) {
    var s = e[i];
    r(s) ? HW(a, s) : a[a.length] = s;
  }
  return a;
}
function Uae(e) {
  var t = e == null ? 0 : e.length;
  return t ? Aae(e) : [];
}
function kae(e) {
  return VM(GM(e, void 0, Uae), e + "");
}
var LW = PM(Object.getPrototypeOf, Object), _ae = "[object Object]", Nae = Function.prototype, Zae = Object.prototype, $M = Nae.toString, Bae = Zae.hasOwnProperty, Wae = $M.call(Object);
function KM(e) {
  if (!is(e) || ed(e) != _ae)
    return !1;
  var t = LW(e);
  if (t === null)
    return !0;
  var r = Bae.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && $M.call(r) == Wae;
}
var Eae = "[object DOMException]", Qae = "[object Error]";
function XM(e) {
  if (!is(e))
    return !1;
  var t = ed(e);
  return t == Qae || t == Eae || typeof e.message == "string" && typeof e.name == "string" && !KM(e);
}
var Fae = xM(function(e, t) {
  try {
    return JM(e, void 0, t);
  } catch (r) {
    return XM(r) ? r : new Error(r);
  }
});
function Tae(e, t, r) {
  var n = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), r = r > a ? a : r, r < 0 && (r += a), a = t > r ? 0 : r - t >>> 0, t >>>= 0;
  for (var i = Array(a); ++n < a; )
    i[n] = e[n + t];
  return i;
}
function Rae(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
function Dae() {
  this.__data__ = new Ul(), this.size = 0;
}
function Jae(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Vae(e) {
  return this.__data__.get(e);
}
function Mae(e) {
  return this.__data__.has(e);
}
var Gae = 200;
function xae(e, t) {
  var r = this.__data__;
  if (r instanceof Ul) {
    var n = r.__data__;
    if (!lm || n.length < Gae - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new kl(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function Xo(e) {
  var t = this.__data__ = new Ul(e);
  this.size = t.size;
}
Xo.prototype.clear = Dae;
Xo.prototype.delete = Jae;
Xo.prototype.get = Vae;
Xo.prototype.has = Mae;
Xo.prototype.set = xae;
function Hae(e, t) {
  return e && xg(t, Hg(t), e);
}
function Lae(e, t) {
  return e && xg(t, R2(t), e);
}
var zM = typeof exports == "object" && exports && !exports.nodeType && exports, i5 = zM && typeof module == "object" && module && !module.nodeType && module, Yae = i5 && i5.exports === zM, o5 = Yae ? fo.Buffer : void 0, s5 = o5 ? o5.allocUnsafe : void 0;
function Oae(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = s5 ? s5(r) : new e.constructor(r);
  return e.copy(n), n;
}
function jae(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
function qM() {
  return [];
}
var Pae = Object.prototype, $ae = Pae.propertyIsEnumerable, l5 = Object.getOwnPropertySymbols, YW = l5 ? function(e) {
  return e == null ? [] : (e = Object(e), jae(l5(e), function(t) {
    return $ae.call(e, t);
  }));
} : qM;
function Kae(e, t) {
  return xg(e, YW(e), t);
}
var Xae = Object.getOwnPropertySymbols, eG = Xae ? function(e) {
  for (var t = []; e; )
    HW(t, YW(e)), e = LW(e);
  return t;
} : qM;
function zae(e, t) {
  return xg(e, eG(e), t);
}
function tG(e, t, r) {
  var n = t(e);
  return Pn(e) ? n : HW(n, r(e));
}
function Hk(e) {
  return tG(e, Hg, YW);
}
function rG(e) {
  return tG(e, R2, eG);
}
var Lk = th(fo, "DataView"), Yk = th(fo, "Promise"), dp = th(fo, "Set"), c5 = "[object Map]", qae = "[object Object]", d5 = "[object Promise]", u5 = "[object Set]", h5 = "[object WeakMap]", p5 = "[object DataView]", eie = eh(Lk), tie = eh(lm), rie = eh(Yk), nie = eh(dp), aie = eh(xk), zi = ed;
(Lk && zi(new Lk(new ArrayBuffer(1))) != p5 || lm && zi(new lm()) != c5 || Yk && zi(Yk.resolve()) != d5 || dp && zi(new dp()) != u5 || xk && zi(new xk()) != h5) && (zi = function(e) {
  var t = ed(e), r = t == qae ? e.constructor : void 0, n = r ? eh(r) : "";
  if (n)
    switch (n) {
      case eie:
        return p5;
      case tie:
        return c5;
      case rie:
        return d5;
      case nie:
        return u5;
      case aie:
        return h5;
    }
  return t;
});
var iie = Object.prototype, oie = iie.hasOwnProperty;
function sie(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && oie.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var m1 = fo.Uint8Array;
function OW(e) {
  var t = new e.constructor(e.byteLength);
  return new m1(t).set(new m1(e)), t;
}
function lie(e, t) {
  var r = t ? OW(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var cie = /\w*$/;
function die(e) {
  var t = new e.constructor(e.source, cie.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var g5 = Ei ? Ei.prototype : void 0, f5 = g5 ? g5.valueOf : void 0;
function uie(e) {
  return f5 ? Object(f5.call(e)) : {};
}
function hie(e, t) {
  var r = t ? OW(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var pie = "[object Boolean]", gie = "[object Date]", fie = "[object Map]", mie = "[object Number]", vie = "[object RegExp]", Sie = "[object Set]", Iie = "[object String]", Cie = "[object Symbol]", bie = "[object ArrayBuffer]", yie = "[object DataView]", wie = "[object Float32Array]", Aie = "[object Float64Array]", Uie = "[object Int8Array]", kie = "[object Int16Array]", _ie = "[object Int32Array]", Nie = "[object Uint8Array]", Zie = "[object Uint8ClampedArray]", Bie = "[object Uint16Array]", Wie = "[object Uint32Array]";
function Eie(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case bie:
      return OW(e);
    case pie:
    case gie:
      return new n(+e);
    case yie:
      return lie(e, r);
    case wie:
    case Aie:
    case Uie:
    case kie:
    case _ie:
    case Nie:
    case Zie:
    case Bie:
    case Wie:
      return hie(e, r);
    case fie:
      return new n();
    case mie:
    case Iie:
      return new n(e);
    case vie:
      return die(e);
    case Sie:
      return new n();
    case Cie:
      return uie(e);
  }
}
function Qie(e) {
  return typeof e.constructor == "function" && !JW(e) ? Wre(LW(e)) : {};
}
var Fie = "[object Map]";
function Tie(e) {
  return is(e) && zi(e) == Fie;
}
var m5 = jp && jp.isMap, Rie = m5 ? T2(m5) : Tie, Die = "[object Set]";
function Jie(e) {
  return is(e) && zi(e) == Die;
}
var v5 = jp && jp.isSet, Vie = v5 ? T2(v5) : Jie, Mie = 1, Gie = 2, xie = 4, nG = "[object Arguments]", Hie = "[object Array]", Lie = "[object Boolean]", Yie = "[object Date]", Oie = "[object Error]", aG = "[object Function]", jie = "[object GeneratorFunction]", Pie = "[object Map]", $ie = "[object Number]", iG = "[object Object]", Kie = "[object RegExp]", Xie = "[object Set]", zie = "[object String]", qie = "[object Symbol]", eoe = "[object WeakMap]", toe = "[object ArrayBuffer]", roe = "[object DataView]", noe = "[object Float32Array]", aoe = "[object Float64Array]", ioe = "[object Int8Array]", ooe = "[object Int16Array]", soe = "[object Int32Array]", loe = "[object Uint8Array]", coe = "[object Uint8ClampedArray]", doe = "[object Uint16Array]", uoe = "[object Uint32Array]", Pt = {};
Pt[nG] = Pt[Hie] = Pt[toe] = Pt[roe] = Pt[Lie] = Pt[Yie] = Pt[noe] = Pt[aoe] = Pt[ioe] = Pt[ooe] = Pt[soe] = Pt[Pie] = Pt[$ie] = Pt[iG] = Pt[Kie] = Pt[Xie] = Pt[zie] = Pt[qie] = Pt[loe] = Pt[coe] = Pt[doe] = Pt[uoe] = !0;
Pt[Oie] = Pt[aG] = Pt[eoe] = !1;
function Rf(e, t, r, n, a, i) {
  var o, s = t & Mie, c = t & Gie, l = t & xie;
  if (r && (o = a ? r(e, n, a, i) : r(e)), o !== void 0)
    return o;
  if (!io(e))
    return e;
  var u = Pn(e);
  if (u) {
    if (o = sie(e), !s)
      return Qre(e, o);
  } else {
    var g = zi(e), p = g == aG || g == jie;
    if (f1(e))
      return Oae(e, s);
    if (g == iG || g == nG || p && !a) {
      if (o = c || p ? {} : Qie(e), !s)
        return c ? zae(e, Lae(o, e)) : Kae(e, Hae(o, e));
    } else {
      if (!Pt[g])
        return a ? e : {};
      o = Eie(e, g, s);
    }
  }
  i || (i = new Xo());
  var m = i.get(e);
  if (m)
    return m;
  i.set(e, o), Vie(e) ? e.forEach(function(A) {
    o.add(Rf(A, t, r, A, e, i));
  }) : Rie(e) && e.forEach(function(A, U) {
    o.set(U, Rf(A, t, r, U, e, i));
  });
  var I = l ? c ? rG : Hk : c ? R2 : Hg, C = u ? void 0 : I(e);
  return Mre(C || e, function(A, U) {
    C && (U = A, A = e[U]), MM(o, U, Rf(A, t, r, U, e, i));
  }), o;
}
var hoe = 1, poe = 4;
function goe(e) {
  return Rf(e, hoe | poe);
}
var foe = "__lodash_hash_undefined__";
function moe(e) {
  return this.__data__.set(e, foe), this;
}
function voe(e) {
  return this.__data__.has(e);
}
function cm(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new kl(); ++t < r; )
    this.add(e[t]);
}
cm.prototype.add = cm.prototype.push = moe;
cm.prototype.has = voe;
function Soe(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function oG(e, t) {
  return e.has(t);
}
var Ioe = 1, Coe = 2;
function sG(e, t, r, n, a, i) {
  var o = r & Ioe, s = e.length, c = t.length;
  if (s != c && !(o && c > s))
    return !1;
  var l = i.get(e), u = i.get(t);
  if (l && u)
    return l == t && u == e;
  var g = -1, p = !0, m = r & Coe ? new cm() : void 0;
  for (i.set(e, t), i.set(t, e); ++g < s; ) {
    var I = e[g], C = t[g];
    if (n)
      var A = o ? n(C, I, g, t, e, i) : n(I, C, g, e, t, i);
    if (A !== void 0) {
      if (A)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!Soe(t, function(U, B) {
        if (!oG(m, B) && (I === U || a(I, U, r, n, i)))
          return m.push(B);
      })) {
        p = !1;
        break;
      }
    } else if (!(I === C || a(I, C, r, n, i))) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
function boe(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function jW(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var yoe = 1, woe = 2, Aoe = "[object Boolean]", Uoe = "[object Date]", koe = "[object Error]", _oe = "[object Map]", Noe = "[object Number]", Zoe = "[object RegExp]", Boe = "[object Set]", Woe = "[object String]", Eoe = "[object Symbol]", Qoe = "[object ArrayBuffer]", Foe = "[object DataView]", S5 = Ei ? Ei.prototype : void 0, jA = S5 ? S5.valueOf : void 0;
function Toe(e, t, r, n, a, i, o) {
  switch (r) {
    case Foe:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Qoe:
      return !(e.byteLength != t.byteLength || !i(new m1(e), new m1(t)));
    case Aoe:
    case Uoe:
    case Noe:
      return AS(+e, +t);
    case koe:
      return e.name == t.name && e.message == t.message;
    case Zoe:
    case Woe:
      return e == t + "";
    case _oe:
      var s = boe;
    case Boe:
      var c = n & yoe;
      if (s || (s = jW), e.size != t.size && !c)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= woe, o.set(e, t);
      var u = sG(s(e), s(t), n, a, i, o);
      return o.delete(e), u;
    case Eoe:
      if (jA)
        return jA.call(e) == jA.call(t);
  }
  return !1;
}
var Roe = 1, Doe = Object.prototype, Joe = Doe.hasOwnProperty;
function Voe(e, t, r, n, a, i) {
  var o = r & Roe, s = Hk(e), c = s.length, l = Hk(t), u = l.length;
  if (c != u && !o)
    return !1;
  for (var g = c; g--; ) {
    var p = s[g];
    if (!(o ? p in t : Joe.call(t, p)))
      return !1;
  }
  var m = i.get(e), I = i.get(t);
  if (m && I)
    return m == t && I == e;
  var C = !0;
  i.set(e, t), i.set(t, e);
  for (var A = o; ++g < c; ) {
    p = s[g];
    var U = e[p], B = t[p];
    if (n)
      var J = o ? n(B, U, p, t, e, i) : n(U, B, p, e, t, i);
    if (!(J === void 0 ? U === B || a(U, B, r, n, i) : J)) {
      C = !1;
      break;
    }
    A || (A = p == "constructor");
  }
  if (C && !A) {
    var W = e.constructor, L = t.constructor;
    W != L && "constructor" in e && "constructor" in t && !(typeof W == "function" && W instanceof W && typeof L == "function" && L instanceof L) && (C = !1);
  }
  return i.delete(e), i.delete(t), C;
}
var Moe = 1, I5 = "[object Arguments]", C5 = "[object Array]", BI = "[object Object]", Goe = Object.prototype, b5 = Goe.hasOwnProperty;
function xoe(e, t, r, n, a, i) {
  var o = Pn(e), s = Pn(t), c = o ? C5 : zi(e), l = s ? C5 : zi(t);
  c = c == I5 ? BI : c, l = l == I5 ? BI : l;
  var u = c == BI, g = l == BI, p = c == l;
  if (p && f1(e)) {
    if (!f1(t))
      return !1;
    o = !0, u = !1;
  }
  if (p && !u)
    return i || (i = new Xo()), o || OM(e) ? sG(e, t, r, n, a, i) : Toe(e, t, c, r, n, a, i);
  if (!(r & Moe)) {
    var m = u && b5.call(e, "__wrapped__"), I = g && b5.call(t, "__wrapped__");
    if (m || I) {
      var C = m ? e.value() : e, A = I ? t.value() : t;
      return i || (i = new Xo()), a(C, A, r, n, i);
    }
  }
  return p ? (i || (i = new Xo()), Voe(e, t, r, n, a, i)) : !1;
}
function G2(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !is(e) && !is(t) ? e !== e && t !== t : xoe(e, t, r, n, G2, a);
}
var Hoe = 1, Loe = 2;
function Yoe(e, t, r, n) {
  var a = r.length, i = a;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var o = r[a];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    o = r[a];
    var s = o[0], c = e[s], l = o[1];
    if (o[2]) {
      if (c === void 0 && !(s in e))
        return !1;
    } else {
      var u = new Xo(), g;
      if (!(g === void 0 ? G2(l, c, Hoe | Loe, n, u) : g))
        return !1;
    }
  }
  return !0;
}
function lG(e) {
  return e === e && !io(e);
}
function Ooe(e) {
  for (var t = Hg(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, lG(a)];
  }
  return t;
}
function cG(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function joe(e) {
  var t = Ooe(e);
  return t.length == 1 && t[0][2] ? cG(t[0][0], t[0][1]) : function(r) {
    return r === e || Yoe(r, e, t);
  };
}
function Poe(e, t) {
  return e != null && t in Object(e);
}
function $oe(e, t, r) {
  t = V2(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = kS(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && DW(a) && TW(o, a) && (Pn(e) || VW(e)));
}
function Koe(e, t) {
  return e != null && $oe(e, t, Poe);
}
var Xoe = 1, zoe = 2;
function qoe(e, t) {
  return MW(e) && lG(t) ? cG(kS(e), t) : function(r) {
    var n = yae(r, e);
    return n === void 0 && n === t ? Koe(r, e) : G2(t, n, Xoe | zoe);
  };
}
function ese(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function tse(e) {
  return function(t) {
    return M2(t, e);
  };
}
function rse(e) {
  return MW(e) ? ese(kS(e)) : tse(e);
}
function PW(e) {
  return typeof e == "function" ? e : e == null ? F2 : typeof e == "object" ? Pn(e) ? qoe(e[0], e[1]) : joe(e) : rse(e);
}
function nse(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var c = o[++a];
      if (r(i[c], c, i) === !1)
        break;
    }
    return t;
  };
}
var ase = nse();
function dG(e, t) {
  return e && ase(e, t, Hg);
}
function ise(e, t) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!US(r))
      return e(r, n);
    for (var a = r.length, i = -1, o = Object(r); ++i < a && n(o[i], i, o) !== !1; )
      ;
    return r;
  };
}
var ose = ise(dG), PA = function() {
  return fo.Date.now();
}, sse = "Expected a function", lse = Math.max, cse = Math.min;
function dse(e, t, r) {
  var n, a, i, o, s, c, l = 0, u = !1, g = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(sse);
  t = $R(t) || 0, io(r) && (u = !!r.leading, g = "maxWait" in r, i = g ? lse($R(r.maxWait) || 0, t) : i, p = "trailing" in r ? !!r.trailing : p);
  function m(H) {
    var R = n, ge = a;
    return n = a = void 0, l = H, o = e.apply(ge, R), o;
  }
  function I(H) {
    return l = H, s = setTimeout(U, t), u ? m(H) : o;
  }
  function C(H) {
    var R = H - c, ge = H - l, z = t - R;
    return g ? cse(z, i - ge) : z;
  }
  function A(H) {
    var R = H - c, ge = H - l;
    return c === void 0 || R >= t || R < 0 || g && ge >= i;
  }
  function U() {
    var H = PA();
    if (A(H))
      return B(H);
    s = setTimeout(U, C(H));
  }
  function B(H) {
    return s = void 0, p && n ? m(H) : (n = a = void 0, o);
  }
  function J() {
    s !== void 0 && clearTimeout(s), l = 0, n = c = a = s = void 0;
  }
  function W() {
    return s === void 0 ? o : B(PA());
  }
  function L() {
    var H = PA(), R = A(H);
    if (n = arguments, a = this, c = H, R) {
      if (s === void 0)
        return I(c);
      if (g)
        return clearTimeout(s), s = setTimeout(U, t), m(c);
    }
    return s === void 0 && (s = setTimeout(U, t)), o;
  }
  return L.cancel = J, L.flush = W, L;
}
function use(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var hse = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, pse = Rae(hse), uG = /[&<>"']/g, gse = RegExp(uG.source);
function fse(e) {
  return e = xW(e), e && gse.test(e) ? e.replace(uG, pse) : e;
}
function mse(e, t) {
  var r = -1, n = US(e) ? Array(e.length) : [];
  return ose(e, function(a, i, o) {
    n[++r] = t(a, i, o);
  }), n;
}
function vse(e, t) {
  return cp(t, function(r) {
    return e[r];
  });
}
function Sse(e, t) {
  return t.length < 2 ? e : M2(e, Tae(t, 0, -1));
}
function hG(e, t) {
  return G2(e, t);
}
function Ise(e, t) {
  var r = {};
  return t = PW(t), dG(e, function(n, a, i) {
    RW(r, a, t(n, a, i));
  }), r;
}
function Cse(e, t) {
  return t = V2(t, e), e = Sse(e, t), e == null || delete e[kS(use(t))];
}
function bse(e) {
  return KM(e) ? void 0 : e;
}
var yse = 1, wse = 2, Ase = 4, pG = kae(function(e, t) {
  var r = {};
  if (e == null)
    return r;
  var n = !1;
  t = cp(t, function(i) {
    return i = V2(i, e), n || (n = i.length > 1), i;
  }), xg(e, rG(e), r), n && (r = Rf(r, yse | wse | Ase, bse));
  for (var a = t.length; a--; )
    Cse(r, t[a]);
  return r;
});
function Use(e, t) {
  var r = e.length;
  for (e.sort(t); r--; )
    e[r] = e[r].value;
  return e;
}
function kse(e, t) {
  if (e !== t) {
    var r = e !== void 0, n = e === null, a = e === e, i = Op(e), o = t !== void 0, s = t === null, c = t === t, l = Op(t);
    if (!s && !l && !i && e > t || i && o && c && !s && !l || n && o && c || !r && c || !a)
      return 1;
    if (!n && !i && !l && e < t || l && r && a && !n && !i || s && r && a || !o && a || !c)
      return -1;
  }
  return 0;
}
function _se(e, t, r) {
  for (var n = -1, a = e.criteria, i = t.criteria, o = a.length, s = r.length; ++n < o; ) {
    var c = kse(a[n], i[n]);
    if (c) {
      if (n >= s)
        return c;
      var l = r[n];
      return c * (l == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
function Nse(e, t, r) {
  t.length ? t = cp(t, function(i) {
    return Pn(i) ? function(o) {
      return M2(o, i.length === 1 ? i[0] : i);
    } : i;
  }) : t = [F2];
  var n = -1;
  t = cp(t, T2(PW));
  var a = mse(e, function(i, o, s) {
    var c = cp(t, function(l) {
      return l(i);
    });
    return { criteria: c, index: ++n, value: i };
  });
  return Use(a, function(i, o) {
    return _se(i, o, r);
  });
}
function Od(e, t, r, n) {
  return e == null ? [] : (Pn(t) || (t = t == null ? [] : [t]), r = r, Pn(r) || (r = r == null ? [] : [r]), Nse(e, t, r));
}
var gG = Object.prototype, Zse = gG.hasOwnProperty;
function y5(e, t, r, n) {
  return e === void 0 || AS(e, gG[r]) && !Zse.call(n, r) ? t : e;
}
var Bse = {
  "\\": "\\",
  "'": "'",
  "\n": "n",
  "\r": "r",
  "\u2028": "u2028",
  "\u2029": "u2029"
};
function Wse(e) {
  return "\\" + Bse[e];
}
var fG = /<%=([\s\S]+?)%>/g, Ese = /<%-([\s\S]+?)%>/g, Qse = /<%([\s\S]+?)%>/g, Ok = {
  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  escape: Ese,
  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  evaluate: Qse,
  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  interpolate: fG,
  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  variable: "",
  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  imports: {
    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    _: { escape: fse }
  }
}, Fse = "Invalid `variable` option passed into `_.template`", Tse = /\b__p \+= '';/g, Rse = /\b(__p \+=) '' \+/g, Dse = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Jse = /[()=,{}\[\]\/\s]/, Vse = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, WI = /($^)/, Mse = /['\n\r\u2028\u2029\\]/g, Gse = Object.prototype, w5 = Gse.hasOwnProperty;
function Rc(e, t, r) {
  var n = Ok.imports._.templateSettings || Ok;
  e = xW(e), t = n5({}, t, n, y5);
  var a = n5({}, t.imports, n.imports, y5), i = Hg(a), o = vse(a, i), s, c, l = 0, u = t.interpolate || WI, g = "__p += '", p = RegExp(
    (t.escape || WI).source + "|" + u.source + "|" + (u === fG ? Vse : WI).source + "|" + (t.evaluate || WI).source + "|$",
    "g"
  ), m = w5.call(t, "sourceURL") ? "//# sourceURL=" + (t.sourceURL + "").replace(/\s/g, " ") + `
` : "";
  e.replace(p, function(A, U, B, J, W, L) {
    return B || (B = J), g += e.slice(l, L).replace(Mse, Wse), U && (s = !0, g += `' +
__e(` + U + `) +
'`), W && (c = !0, g += `';
` + W + `;
__p += '`), B && (g += `' +
((__t = (` + B + `)) == null ? '' : __t) +
'`), l = L + A.length, A;
  }), g += `';
`;
  var I = w5.call(t, "variable") && t.variable;
  if (!I)
    g = `with (obj) {
` + g + `
}
`;
  else if (Jse.test(I))
    throw new Error(Fse);
  g = (c ? g.replace(Tse, "") : g).replace(Rse, "$1").replace(Dse, "$1;"), g = "function(" + (I || "obj") + `) {
` + (I ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (s ? ", __e = _.escape" : "") + (c ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + g + `return __p
}`;
  var C = Fae(function() {
    return Function(i, m + "return " + g).apply(void 0, o);
  });
  if (C.source = g, XM(C))
    throw C;
  return C;
}
var xse = 1 / 0, Hse = dp && 1 / jW(new dp([, -0]))[1] == xse ? function(e) {
  return new dp(e);
} : Ere, Lse = 200;
function Yse(e, t, r) {
  var n = -1, a = Yre, i = e.length, o = !0, s = [], c = s;
  if (i >= Lse) {
    var l = t ? null : Hse(e);
    if (l)
      return jW(l);
    o = !1, a = oG, c = new cm();
  } else
    c = t ? [] : s;
  e:
    for (; ++n < i; ) {
      var u = e[n], g = t ? t(u) : u;
      if (u = u !== 0 ? u : 0, o && g === g) {
        for (var p = c.length; p--; )
          if (c[p] === g)
            continue e;
        t && c.push(g), s.push(u);
      } else a(c, g, r) || (c !== s && c.push(g), s.push(u));
    }
  return s;
}
function Ose(e, t) {
  return e && e.length ? Yse(e, PW(t)) : [];
}
function zo(e, t) {
  function r(n) {
    if (Pn(n))
      return n.map(r);
    if (io(n)) {
      const a = pG(n, t);
      return Ise(a, r);
    }
    return n;
  }
  return r(e);
}
const _S = ({
  interval: e = 2e3,
  shouldRepeat: t
}) => (r) => new Ht((n) => {
  let a = 0, i;
  const o = () => {
    i = r.subscribe((s) => {
      n.next(s), t(s) ? a = window.setTimeout(o, e) : n.complete();
    });
  };
  return o(), () => {
    window.clearTimeout(a), i == null || i.unsubscribe();
  };
}), jse = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, Pse = (e = "") => jse.test(e);
function Lg(e) {
  return (t) => new Ht((r) => (e(), t.subscribe(r)));
}
const mG = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
};
var A5 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $W(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var x2 = { exports: {} };
x2.exports = KW;
x2.exports.isMobile = KW;
x2.exports.default = KW;
const $se = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, Kse = /CrOS/, Xse = /android|ipad|playbook|silk/i;
function KW(e) {
  e || (e = {});
  let t = e.ua;
  if (!t && typeof navigator < "u" && (t = navigator.userAgent), t && t.headers && typeof t.headers["user-agent"] == "string" && (t = t.headers["user-agent"]), typeof t != "string") return !1;
  let r = $se.test(t) && !Kse.test(t) || !!e.tablet && Xse.test(t);
  return !r && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && t.indexOf("Macintosh") !== -1 && t.indexOf("Safari") !== -1 && (r = !0), r;
}
var zse = x2.exports;
const dm = /* @__PURE__ */ $W(zse), _l = () => dm({ tablet: !0 }), Ut = (e, t, r = () => !0) => t.every((n) => typeof e == "object" && e !== null && n in e) && r(e), vd = (e) => typeof e == "object" && e !== null && !Array.isArray(e), qse = (e) => typeof e == "number" && !Number.isNaN(e), XW = (e) => e / 1024 / 1024, H2 = (e) => e.type.toLowerCase() === "application/pdf", vG = (e) => e.replace(/&quot;/g, '"'), Pp = () => {
};
function um() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
var An = /* @__PURE__ */ ((e) => (e.Generic = "generic", e.CaptureScreen = "capture-screen", e))(An || {}), Bu = /* @__PURE__ */ ((e) => (e.Small = "small", e.Large = "large", e))(Bu || {});
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let SG = class extends Event {
  constructor(t, r, n) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.callback = r, this.subscribe = n ?? !1;
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let U5 = class {
  constructor(t, r, n, a) {
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (i, o) => {
      this.unsubscribe && (this.unsubscribe !== o && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = i, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(i, o)), this.unsubscribe = o;
    }, this.host = t, r.context !== void 0) {
      const i = r;
      this.context = i.context, this.callback = i.callback, this.subscribe = i.subscribe ?? !1;
    } else this.context = r, this.callback = n, this.subscribe = a ?? !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new SG(this.context, this.t, this.subscribe));
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class ele {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, r = !1) {
    const n = r || !Object.is(t, this.o);
    this.o = t, n && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [r, { disposer: n }] of this.subscriptions) r(this.o, n);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, r, n) {
    if (!n) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: r });
    const { disposer: a } = this.subscriptions.get(t);
    t(this.value, a);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let tle = class extends Event {
  constructor(t) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t;
  }
}, k5 = class extends ele {
  constructor(t, r, n) {
    var a, i;
    super(r.context !== void 0 ? r.initialValue : n), this.onContextRequest = (o) => {
      const s = o.composedPath()[0];
      o.context === this.context && s !== this.host && (o.stopPropagation(), this.addCallback(o.callback, s, o.subscribe));
    }, this.onProviderRequest = (o) => {
      const s = o.composedPath()[0];
      if (o.context !== this.context || s === this.host) return;
      const c = /* @__PURE__ */ new Set();
      for (const [l, { consumerHost: u }] of this.subscriptions) c.has(l) || (c.add(l), u.dispatchEvent(new SG(this.context, l, !0)));
      o.stopPropagation();
    }, this.host = t, r.context !== void 0 ? this.context = r.context : this.context = r, this.attachListeners(), (i = (a = this.host).addController) == null || i.call(a, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new tle(this.context));
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function ka({ context: e }) {
  return (t, r) => {
    const n = /* @__PURE__ */ new WeakMap();
    if (typeof r == "object") return r.addInitializer(function() {
      n.set(this, new k5(this, { context: e }));
    }), { get() {
      return t.get.call(this);
    }, set(a) {
      var i;
      return (i = n.get(this)) == null || i.setValue(a), t.set.call(this, a);
    }, init(a) {
      var i;
      return (i = n.get(this)) == null || i.setValue(a), a;
    } };
    {
      t.constructor.addInitializer((o) => {
        n.set(o, new k5(o, { context: e }));
      });
      const a = Object.getOwnPropertyDescriptor(t, r);
      let i;
      if (a === void 0) {
        const o = /* @__PURE__ */ new WeakMap();
        i = { get() {
          return o.get(this);
        }, set(s) {
          n.get(this).setValue(s), o.set(this, s);
        }, configurable: !0, enumerable: !0 };
      } else {
        const o = a.set;
        i = { ...a, set(s) {
          n.get(this).setValue(s), o == null || o.call(this, s);
        } };
      }
      return void Object.defineProperty(t, r, i);
    }
  };
}
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function td({ context: e, subscribe: t }) {
  return (r, n) => {
    typeof n == "object" ? n.addInitializer(function() {
      new U5(this, { context: e, callback: (a) => {
        r.set.call(this, a);
      }, subscribe: t });
    }) : r.constructor.addInitializer((a) => {
      new U5(a, { context: e, callback: (i) => {
        a[n] = i;
      }, subscribe: t });
    });
  };
}
var Un = /* @__PURE__ */ ((e) => (e.Light = "light", e.Dark = "dark", e.Auto = "auto", e))(Un || {});
const IG = Symbol("color-scheme-service-context"), zW = Symbol("color-scheme-context");
var au, iu, Ku, jk, CG;
class rle {
  constructor() {
    E(this, Ku);
    E(this, au);
    E(this, iu);
    G(this, au, new Kt(Un.Light)), G(this, iu, new Kt(Un.Auto)), this.colorScheme$ = O(this, Ku, CG).call(this, S(this, au), S(this, iu));
  }
  setUserColorScheme(t) {
    S(this, iu).next(t);
  }
  setBrowserColorScheme(t) {
    S(this, au).next(t);
  }
  getColorScheme() {
    return O(this, Ku, jk).call(this);
  }
}
au = new WeakMap(), iu = new WeakMap(), Ku = new WeakSet(), jk = function(t = S(this, au).getValue(), r = S(this, iu).getValue()) {
  return r === Un.Auto ? t : r;
}, CG = function(t, r) {
  return t.pipe($a(r)).pipe(te(([n, a]) => O(this, Ku, jk).call(this, n, a)));
};
const v1 = (e) => Object.values(Un).includes(e);
var nle = Object.defineProperty, ale = Object.getOwnPropertyDescriptor, bG = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ale(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && nle(t, r, a), a;
};
let Pk = class extends ro {
  constructor() {
    super(...arguments), this.colorScheme = Un.Auto;
  }
};
bG([
  M({
    attribute: "data-color",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => v1(e) ? e : Un.Auto,
      toAttribute: (e) => v1(e) ? e.toString() : null
    }
  })
], Pk.prototype, "colorScheme", 2);
Pk = bG([
  P("x-ds-color-scheme-config")
], Pk);
var ile = Object.defineProperty, ole = Object.getOwnPropertyDescriptor, yG = (e) => {
  throw TypeError(e);
}, L2 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ole(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ile(t, r, a), a;
}, wG = (e, t, r) => t.has(e) || yG("Cannot " + r), Sd = (e, t, r) => (wG(e, t, "read from private field"), r ? r.call(e) : t.get(e)), $A = (e, t, r) => t.has(e) ? yG("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), sle = (e, t, r, n) => (wG(e, t, "write to private field"), t.set(e, r), r), mC, Zh, vC;
let $p = class extends ro {
  constructor() {
    super(), this.colorSchemeService = new rle(), this.colorScheme = Un.Light, $A(this, mC, new _e()), $A(this, Zh), $A(this, vC, () => {
      const e = this.getBrowserColorScheme();
      this.colorSchemeService.setBrowserColorScheme(e);
    }), sle(this, Zh, window.matchMedia("(prefers-color-scheme: dark)")), this.colorSchemeService.colorScheme$.pipe(
      ae((e) => {
        this.colorScheme = e, this.requestUpdate();
      }),
      le(Sd(this, mC))
    ).subscribe(), this.colorSchemeService.setBrowserColorScheme(this.getBrowserColorScheme());
  }
  connectedCallback() {
    super.connectedCallback(), Sd(this, Zh).addEventListener("change", Sd(this, vC));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Sd(this, Zh).removeEventListener("change", Sd(this, vC)), Sd(this, mC).next();
  }
  getBrowserColorScheme() {
    return Sd(this, Zh).matches ? Un.Dark : Un.Light;
  }
  render() {
    return w`
      <slot
        name="theme"
        @slotchange="${() => {
      this.applyColorScheme();
    }}"
      >
        <x-ds-color-scheme-config data-color="${Un.Auto}"></x-ds-color-scheme-config>
      </slot>
      <slot></slot>
    `;
  }
  applyColorScheme() {
    this.colorSchemeConfigs.forEach((e) => {
      this.colorSchemeService.setUserColorScheme(e.colorScheme);
    }), this.requestUpdate();
  }
};
mC = /* @__PURE__ */ new WeakMap();
Zh = /* @__PURE__ */ new WeakMap();
vC = /* @__PURE__ */ new WeakMap();
$p.styles = [
  ee`
      :host {
        display: contents;
      }
    `
];
L2([
  ka({ context: IG }),
  Xn()
], $p.prototype, "colorSchemeService", 2);
L2([
  ka({ context: zW }),
  M({ attribute: "data-color-scheme", reflect: !0 })
], $p.prototype, "colorScheme", 2);
L2([
  dr({ slot: "theme", flatten: !0 })
], $p.prototype, "colorSchemeConfigs", 2);
$p = L2([
  P("x-ds-color-scheme")
], $p);
const lle = ee`
  [class^='icon-'],
  [class*=' icon-'] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'jumio-sdk-icomoon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-bra-id:before {
    content: '\\e970';
  }
  .icon-pdf:before {
    content: '\\e969';
  }
  .icon-id-document:before {
    content: '\\e967';
  }
  .icon-upload-method:before {
    content: '\\e968';
  }
  .icon-add:before {
    content: '\\e901';
  }
  .icon-add-time:before {
    content: '\\e902';
  }
  .icon-analytics:before {
    content: '\\e903';
  }
  .icon-arrow-direction-down:before {
    content: '\\e904';
  }
  .icon-arrow-direction-left:before {
    content: '\\e905';
  }
  .icon-arrow-direction-right:before {
    content: '\\e906';
  }
  .icon-arrow-direction-up:before {
    content: '\\e907';
  }
  .icon-attachment:before {
    content: '\\e908';
  }
  .icon-business .path1:before {
    content: '\\e909';
    color: rgb(92, 101, 112);
    opacity: 0.5;
  }
  .icon-business .path2:before {
    content: '\\e90a';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-business .path3:before {
    content: '\\e90b';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-business .path4:before {
    content: '\\e96a';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-calendar .path1:before {
    content: '\\e90c';
    color: rgb(92, 101, 112);
  }
  .icon-calendar .path2:before {
    content: '\\e90d';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-calendar .path3:before {
    content: '\\e90e';
    margin-left: -1em;
    color: rgb(92, 101, 112);
    opacity: 0.5;
  }
  .icon-camera-video:before {
    content: '\\e90f';
  }
  .icon-check:before {
    content: '\\e910';
  }
  .icon-check-circle:before {
    content: '\\e911';
  }
  .icon-check-circle-filled:before {
    content: '\\e912';
  }
  .icon-chevron-direction-down:before {
    content: '\\e913';
  }
  .icon-chevron-direction-left:before {
    content: '\\e914';
  }
  .icon-chevron-direction-right:before {
    content: '\\e915';
  }
  .icon-chevron-direction-up:before {
    content: '\\e916';
  }
  .icon-close:before {
    content: '\\e917';
  }
  .icon-collapse:before {
    content: '\\e918';
  }
  .icon-columns:before {
    content: '\\e919';
  }
  .icon-compare:before {
    content: '\\e91a';
  }
  .icon-copy:before {
    content: '\\e91b';
  }
  .icon-create-new:before {
    content: '\\e91c';
  }
  .icon-delete:before {
    content: '\\e91d';
  }
  .icon-device:before {
    content: '\\e91e';
  }
  .icon-download:before {
    content: '\\e91f';
  }
  .icon-edit:before {
    content: '\\e920';
  }
  .icon-email:before {
    content: '\\e921';
  }
  .icon-exit:before {
    content: '\\e922';
  }
  .icon-exclamation-mark:before {
    content: '\\e923';
  }
  .icon-expand:before {
    content: '\\e924';
  }
  .icon-external:before {
    content: '\\e925';
  }
  .icon-filter:before {
    content: '\\e926';
  }
  .icon-globe:before {
    content: '\\e927';
  }
  .icon-help:before {
    content: '\\e928';
  }
  .icon-id-back:before {
    content: '\\e929';
  }
  .icon-id-digital:before {
    content: '\\e92a';
  }
  .icon-id-drivers-license:before {
    content: '\\e92b';
  }
  .icon-id-front:before {
    content: '\\e92c';
  }
  .icon-id-passport:before {
    content: '\\e92d';
  }
  .icon-id-work-visa:before {
    content: '\\e92e';
  }
  .icon-info:before {
    content: '\\e92f';
  }
  .icon-initiate:before {
    content: '\\e930';
  }
  .icon-jump-back:before {
    content: '\\e931';
  }
  .icon-jump-forward:before {
    content: '\\e932';
  }
  .icon-link:before {
    content: '\\e933';
  }
  .icon-list-view:before {
    content: '\\e934';
  }
  .icon-lock:before {
    content: '\\e935';
  }
  .icon-menu:before {
    content: '\\e936';
  }
  .icon-minus-circle:before {
    content: '\\e937';
  }
  .icon-more-actions:before {
    content: '\\e938';
  }
  .icon-notification-filled .path1:before {
    content: '\\e939';
    color: rgb(92, 101, 112);
    opacity: 0.25;
  }
  .icon-notification-filled .path2:before {
    content: '\\e93a';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-notification-filled .path3:before {
    content: '\\e93b';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-party:before {
    content: '\\e93c';
  }
  .icon-payment-method .path1:before {
    content: '\\e93d';
    color: rgb(92, 101, 112);
    opacity: 0.3;
  }
  .icon-payment-method .path2:before {
    content: '\\e93e';
    margin-left: -1em;
    color: rgb(92, 101, 112);
    opacity: 0.3;
  }
  .icon-payment-method .path3:before {
    content: '\\e93f';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-plus-circle:before {
    content: '\\e940';
  }
  .icon-reset:before {
    content: '\\e941';
  }
  .icon-risk:before {
    content: '\\e942';
  }
  .icon-rotate-left:before {
    content: '\\e943';
  }
  .icon-rotate-right:before {
    content: '\\e944';
  }
  .icon-schedule:before {
    content: '\\e945';
  }
  .icon-search:before {
    content: '\\e946';
  }
  .icon-share:before {
    content: '\\e947';
  }
  .icon-shield:before {
    content: '\\e948';
  }
  .icon-sort:before {
    content: '\\e949';
  }
  .icon-sort-ascending:before {
    content: '\\e94a';
  }
  .icon-sort-descending:before {
    content: '\\e94b';
  }
  .icon-table-view:before {
    content: '\\e94c';
  }
  .icon-timeline:before {
    content: '\\e94d';
  }
  .icon-transaction .path1:before {
    content: '\\e94e';
    color: rgb(92, 101, 112);
    opacity: 0.3;
  }
  .icon-transaction .path2:before {
    content: '\\e94f';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-transaction .path3:before {
    content: '\\e950';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-verification:before {
    content: '\\e951';
  }
  .icon-unlink:before {
    content: '\\e952';
  }
  .icon-unlock:before {
    content: '\\e953';
  }
  .icon-unschedule:before {
    content: '\\e954';
  }
  .icon-upload:before {
    content: '\\e955';
  }
  .icon-user:before {
    content: '\\e956';
  }
  .icon-version-history:before {
    content: '\\e957';
  }
  .icon-visibility:before {
    content: '\\e958';
  }
  .icon-visibility-off:before {
    content: '\\e959';
  }
  .icon-zoom-in:before {
    content: '\\e95a';
  }
  .icon-zoom-out:before {
    content: '\\e95b';
  }
  .icon-info-filled .path1:before {
    content: '\\e95c';
    color: rgb(92, 101, 112);
    opacity: 0.3;
  }
  .icon-info-filled .path2:before {
    content: '\\e95d';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-info-filled .path3:before {
    content: '\\e95e';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-info-filled .path4:before {
    content: '\\e95f';
    margin-left: -1em;
    color: rgb(92, 101, 112);
  }
  .icon-jumio:before {
    content: '\\e960';
  }
  .icon-ic-capture-camera:before {
    content: '\\e961';
  }
  .icon-ic-capture-camera-flash:before {
    content: '\\e962';
  }
  .icon-ic-capture-flip:before {
    content: '\\e963';
  }
  .icon-ic-capture-switch:before {
    content: '\\e964';
  }
  .icon-ic-method-camera:before {
    content: '\\e965';
  }
  .icon-camera-number-placeholder:before {
    content: '\\e966';
  }
`, cle = ee`:host{--font-family: var(--jumio-sdk-font-family, var(--portal-font-family, IBM Plex Sans));--white: var(--jumio-sdk-white, var(--portal-white, #fff));--black: var(--jumio-sdk-black, var(--portal-black, #000));--green1: var(--jumio-sdk-green1, var(--portal-green1, #d2f0c3));--green2: var(--jumio-sdk-green2, var(--portal-green2, #92dc72));--green3: var(--jumio-sdk-green3, var(--portal-green3, #5acc29));--green4: var(--jumio-sdk-green4, var(--portal-green4, #49bc21));--green5: var(--jumio-sdk-green5, var(--portal-green5, #2fa715));--green6: var(--jumio-sdk-green6, var(--portal-green6, #007100));--green7: var(--jumio-sdk-green7, var(--portal-green7, #54852c));--gray1: var(--jumio-sdk-gray1, var(--portal-gray1, #f5f7fa));--gray2: var(--jumio-sdk-gray2, var(--portal-gray2, #edf1f5));--gray3: var(--jumio-sdk-gray3, var(--portal-gray3, #dfe5ec));--gray4: var(--jumio-sdk-gray4, var(--portal-gray4, #c6cdd5));--gray5: var(--jumio-sdk-gray5, var(--portal-gray5, #9aa4af));--gray6: var(--jumio-sdk-gray6, var(--portal-gray6, #757f8a));--gray7: var(--jumio-sdk-gray7, var(--portal-gray7, #5c6570));--gray8: var(--jumio-sdk-gray8, var(--portal-gray8, #3e4753));--gray9: var(--jumio-sdk-gray9, var(--portal-gray9, #333d47));--gray10: var(--jumio-sdk-gray10, var(--portal-gray10, #2b333d));--gray11: var(--jumio-sdk-gray11, var(--portal-gray11, #222931));--gray12: var(--jumio-sdk-gray12, var(--portal-gray12, #1c2229));--gray200-250: var(--jumio-sdk-gray200-250, var(--portal-gray200-250, rgba(237, 241, 245, .2)));--gray1000-250: var(--jumio-sdk-gray1000-250, var(--portal-gray1000-250, rgba(43, 51, 61, .2)));--gray200: var(--jumio-sdk-gray200, var(--portal-gray200, rgba(0, 0, 0, .2)));--gray400: var(--jumio-sdk-gray400, var(--portal-gray400, rgba(0, 0, 0, .4)));--gray800: var(--jumio-sdk-gray800, var(--portal-gray800, rgba(0, 0, 0, .8)));--red: var(--jumio-sdk-red, var(--portal-red, #e44e4e));--semantic-red-05: var(--jumio-sdk-semantic-red-05, var(--portal-semantic-red-05, #ffebeb));--semantic-red-10: var(--jumio-sdk-semantic-red-10, var(--portal-semantic-red-10, #fcc));--semantic-red-30: var(--jumio-sdk-semantic-red-30, var(--portal-semantic-red-30, #eb5757));--semantic-red-40: var(--jumio-sdk-semantic-red-40, var(--portal-semantic-red-40, #d64141));--color-primary1: var(--jumio-sdk-color-primary1, var(--portal-color-primary1, var(--green1)));--color-primary2: var(--jumio-sdk-color-primary2, var(--portal-color-primary2, var(--green2)));--color-primary3: var(--jumio-sdk-color-primary3, var(--portal-color-primary3, var(--green3)));--color-primary4: var(--jumio-sdk-color-primary4, var(--portal-color-primary4, var(--green4)));--color-primary5: var(--jumio-sdk-color-primary5, var(--portal-color-primary5, var(--green5)));--color-primary6: var(--jumio-sdk-color-primary6, var(--portal-color-primary6, var(--green6)));--color-primary7: var(--jumio-sdk-color-primary7, var(--portal-color-primary7, var(--green7)));--color-secondary1: var(--jumio-sdk-color-secondary1, var(--portal-color-secondary1, var(--gray1)));--color-secondary2: var(--jumio-sdk-color-secondary2, var(--portal-color-secondary2, var(--gray2)));--color-secondary3: var(--jumio-sdk-color-secondary3, var(--portal-color-secondary3, var(--gray3)));--color-secondary4: var(--jumio-sdk-color-secondary4, var(--portal-color-secondary4, var(--gray4)));--color-secondary5: var(--jumio-sdk-color-secondary5, var(--portal-color-secondary5, var(--gray5)));--color-secondary6: var(--jumio-sdk-color-secondary6, var(--portal-color-secondary6, var(--gray6)));--color-secondary7: var(--jumio-sdk-color-secondary7, var(--portal-color-secondary7, var(--gray7)));--color-secondary8: var(--jumio-sdk-color-secondary8, var(--portal-color-secondary8, var(--gray8)));--color-secondary9: var(--jumio-sdk-color-secondary9, var(--portal-color-secondary9, var(--gray9)));--color-secondary10: var(--jumio-sdk-color-secondary10, var(--portal-color-secondary10, var(--gray10)));--color-secondary11: var(--jumio-sdk-color-secondary11, var(--portal-color-secondary11, var(--gray11)));--color-secondary12: var(--jumio-sdk-color-secondary12, var(--portal-color-secondary12, var(--gray12)));--color-tertiary1: var(--jumio-sdk-color-tertiary1, var(--portal-color-tertiary1, var(--gray200)));--color-tertiary2: var(--jumio-sdk-color-tertiary2, var(--portal-color-tertiary2, var(--gray400)));--color-tertiary3: var(--jumio-sdk-color-tertiary3, var(--portal-color-tertiary3, var(--gray800)));--text-font-h1: var(--jumio-sdk-text-font-h1, var(--portal-text-font-h1, 500 2em/1.125 var(--font-family)));--text-font-h2: var(--jumio-sdk-text-font-h2, var(--portal-text-font-h2, 500 1.625em/1.1538461538 var(--font-family)));--text-font-h3: var(--jumio-sdk-text-font-h3, var(--portal-text-font-h3, 500 1.375em/1.1818181818 var(--font-family)));--text-font-h4: var(--jumio-sdk-text-font-h4, var(--portal-text-font-h4, 400 1.25em/1.2 var(--font-family)));--text-font-h5: var(--jumio-sdk-text-font-h5, var(--portal-text-font-h5, 400 1.125em/1.4 var(--font-family)));--text-font-h6: var(--jumio-sdk-text-font-h6, var(--portal-text-font-h6, 400 1em/1.5 var(--font-family)));--text-font-body-small: var(--jumio-sdk-text-font-body-small, var(--portal-text-font-body-small, 400 .875em/1.125 var(--font-family)));--text-font-body-regular: var(--jumio-sdk-text-font-body-regular, var(--portal-text-font-body-regular, 400 1em/1.5 var(--font-family)));--text-font-body-medium: var(--jumio-sdk-text-font-body-medium, var(--portal-text-font-body-medium, 500 1em/1.5 var(--font-family)));--text-font-caption-small: var(--jumio-sdk-text-font-caption-small, var(--portal-text-font-caption-small, 400 .625em/.765 var(--font-family)));--text-font-caption-medium: var(--jumio-sdk-text-font-caption-medium, var(--portal-text-font-caption-medium, 400 .75em/1 var(--font-family)));--text-font-subtitle-medium: var(--jumio-sdk-text-font-subtitle-medium, var(--portal-text-font-subtitle-medium, 500 1.125em/1.3333333333 var(--font-family)));--theme-light-text-color: var(--jumio-sdk-theme-light-text-color, var(--portal-theme-light-text-color, var(--color-secondary12)));--theme-dark-text-color: var(--jumio-sdk-theme-dark-text-color, var(--portal-theme-dark-text-color, var(--white)));--theme-light-app-container-bg-color: var(--jumio-sdk-theme-light-app-container-bg-color, var(--portal-theme-light-app-container-bg-color, var(--white)));--theme-dark-app-container-bg-color: var(--jumio-sdk-theme-dark-app-container-bg-color, var(--portal-theme-dark-app-container-bg-color, var(--color-secondary12)));--theme-light-page-bg-color: var(--jumio-sdk-theme-light-page-bg-color, var(--portal-theme-light-page-bg-color, var(--color-secondary1)));--theme-dark-page-bg-color: var(--jumio-sdk-theme-dark-page-bg-color, var(--portal-theme-dark-page-bg-color, var(--color-secondary10)));--theme-light-primary-default-color: var(--jumio-sdk-theme-light-primary-default-color, var(--portal-theme-light-primary-default-color, var(--color-secondary12)));--theme-light-primary-focus-color: var(--jumio-sdk-theme-light-primary-focus-color, var(--portal-theme-light-primary-focus-color, var(--color-secondary12)));--theme-light-primary-active-color: var(--jumio-sdk-theme-light-primary-active-color, var(--portal-theme-light-primary-active-color, var(--color-secondary12)));--theme-light-primary-disabled-color: var(--jumio-sdk-theme-light-primary-disabled-color, var(--portal-theme-light-primary-disabled-color, var(--color-secondary6)));--theme-dark-primary-default-color: var(--jumio-sdk-theme-dark-primary-default-color, var(--portal-theme-dark-primary-default-color, var(--color-secondary12)));--theme-dark-primary-focus-color: var(--jumio-sdk-theme-dark-primary-focus-color, var(--portal-theme-dark-primary-focus-color, var(--color-secondary12)));--theme-dark-primary-active-color: var(--jumio-sdk-theme-dark-primary-active-color, var(--portal-theme-dark-primary-active-color, var(--color-secondary12)));--theme-dark-primary-disabled-color: var(--jumio-sdk-theme-dark-primary-disabled-color, var(--portal-theme-dark-primary-disabled-color, var(--color-secondary6)));--theme-light-clickable-primary-default-color: var(--jumio-sdk-theme-light-clickable-primary-default-color, var(--portal-theme-light-clickable-primary-default-color, var(--theme-light-primary-default-color)));--theme-dark-clickable-primary-default-color: var(--jumio-sdk-theme-dark-clickable-primary-default-color, var(--portal-theme-dark-clickable-primary-default-color, var(--theme-dark-primary-default-color)));--theme-light-clickable-primary-default-bg-color: var(--jumio-sdk-theme-light-clickable-primary-default-bg-color, var(--portal-theme-light-clickable-primary-default-bg-color, var(--color-primary4)));--theme-dark-clickable-primary-default-bg-color: var(--jumio-sdk-theme-dark-clickable-primary-default-bg-color, var(--portal-theme-dark-clickable-primary-default-bg-color, var(--color-primary4)));--theme-light-clickable-primary-focus-color: var(--jumio-sdk-theme-light-clickable-primary-focus-color, var(--portal-theme-light-clickable-primary-focus-color, var(--theme-light-primary-focus-color)));--theme-dark-clickable-primary-focus-color: var(--jumio-sdk-theme-dark-clickable-primary-focus-color, var(--portal-theme-dark-clickable-primary-focus-color, var(--theme-dark-primary-focus-color)));--theme-light-clickable-primary-focus-bg-color: var(--jumio-sdk-theme-light-clickable-primary-focus-bg-color, var(--portal-theme-light-clickable-primary-focus-bg-color, var(--color-primary5)));--theme-dark-clickable-primary-focus-bg-color: var(--jumio-sdk-theme-dark-clickable-primary-focus-bg-color, var(--portal-theme-dark-clickable-primary-focus-bg-color, var(--color-primary2)));--theme-light-clickable-primary-active-color: var(--jumio-sdk-theme-light-clickable-primary-active-color, var(--portal-theme-light-clickable-primary-active-color, var(--theme-light-primary-active-color)));--theme-dark-clickable-primary-active-color: var(--jumio-sdk-theme-dark-clickable-primary-active-color, var(--portal-theme-dark-clickable-primary-active-color, var(--theme-dark-primary-active-color)));--theme-light-clickable-primary-active-bg-color: var(--jumio-sdk-theme-light-clickable-primary-active-bg-color, var(--portal-theme-light-clickable-primary-active-bg-color, var(--color-primary2)));--theme-dark-clickable-primary-active-bg-color: var(--jumio-sdk-theme-dark-clickable-primary-active-bg-color, var(--portal-theme-dark-clickable-primary-active-bg-color, var(--color-primary3)));--theme-light-clickable-primary-disabled-color: var(--jumio-sdk-theme-light-clickable-primary-disabled-color, var(--portal-theme-light-clickable-primary-disabled-color, var(--theme-light-primary-disabled-color)));--theme-dark-clickable-primary-disabled-color: var(--jumio-sdk-theme-dark-clickable-primary-disabled-color, var(--portal-theme-dark-clickable-primary-disabled-color, var(--theme-dark-primary-disabled-color)));--theme-light-clickable-primary-disabled-bg-color: var(--jumio-sdk-theme-light-clickable-primary-disabled-bg-color, var(--portal-theme-light-clickable-primary-disabled-bg-color, var(--color-primary1)));--theme-dark-clickable-primary-disabled-bg-color: var(--jumio-sdk-theme-dark-clickable-primary-disabled-bg-color, var(--portal-theme-dark-clickable-primary-disabled-bg-color, var(--color-primary7)));--theme-light-clickable-secondary-default-bg-color: var(--jumio-sdk-theme-light-clickable-secondary-default-bg-color, var(--portal-theme-light-clickable-secondary-default-bg-color, var(--color-secondary1)));--theme-light-clickable-secondary-default-color: var(--jumio-sdk-theme-light-clickable-secondary-default-color, var(--portal-theme-light-clickable-secondary-default-color, var(--color-secondary12)));--theme-light-clickable-secondary-default-border-color: var(--jumio-sdk-theme-light-clickable-secondary-default-border-color, var(--portal-theme-light-clickable-secondary-default-border-color, var(--color-secondary5)));--theme-light-clickable-secondary-focus-bg-color: var(--jumio-sdk-theme-light-clickable-secondary-focus-bg-color, var(--portal-theme-light-clickable-secondary-focus-bg-color, var(--color-secondary3)));--theme-light-clickable-secondary-focus-color: var(--jumio-sdk-theme-light-clickable-secondary-focus-color, var(--portal-theme-light-clickable-secondary-focus-color, var(--color-secondary12)));--theme-light-clickable-secondary-focus-border-color: var(--jumio-sdk-theme-light-clickable-secondary-focus-border-color, var(--portal-theme-light-clickable-secondary-focus-border-color, var(--color-secondary7)));--theme-light-clickable-secondary-active-bg-color: var(--jumio-sdk-theme-light-clickable-secondary-active-bg-color, var(--portal-theme-light-clickable-secondary-active-bg-color, var(--color-secondary4)));--theme-light-clickable-secondary-active-color: var(--jumio-sdk-theme-light-clickable-secondary-active-color, var(--portal-theme-light-clickable-secondary-active-color, var(--color-secondary12)));--theme-light-clickable-secondary-active-border-color: var(--jumio-sdk-theme-light-clickable-secondary-active-border-color, var(--portal-theme-light-clickable-secondary-active-border-color, var(--color-secondary7)));--theme-light-clickable-secondary-disabled-bg-color: var(--jumio-sdk-theme-light-clickable-secondary-disabled-bg-color, var(--portal-theme-light-clickable-secondary-disabled-bg-color, var(--color-secondary2)));--theme-light-clickable-secondary-disabled-color: var(--jumio-sdk-theme-light-clickable-secondary-disabled-color, var(--portal-theme-light-clickable-secondary-disabled-color, var(--color-secondary5)));--theme-light-clickable-secondary-disabled-border-color: var(--jumio-sdk-theme-light-clickable-secondary-disabled-border-color, var(--portal-theme-light-clickable-secondary-disabled-border-color, var(--color-secondary3)));--theme-dark-clickable-secondary-default-bg-color: var(--jumio-sdk-theme-dark-clickable-secondary-default-bg-color, var(--portal-theme-dark-clickable-secondary-default-bg-color, var(--color-secondary10)));--theme-dark-clickable-secondary-default-color: var(--jumio-sdk-theme-dark-clickable-secondary-default-color, var(--portal-theme-dark-clickable-secondary-default-color, var(--white)));--theme-dark-clickable-secondary-default-border-color: var(--jumio-sdk-theme-dark-clickable-secondary-default-border-color, var(--portal-theme-dark-clickable-secondary-default-border-color, var(--color-secondary7)));--theme-dark-clickable-secondary-focus-bg-color: var(--jumio-sdk-theme-dark-clickable-secondary-focus-bg-color, var(--portal-theme-dark-clickable-secondary-focus-bg-color, var(--color-secondary9)));--theme-dark-clickable-secondary-focus-color: var(--jumio-sdk-theme-dark-clickable-secondary-focus-color, var(--portal-theme-dark-clickable-secondary-focus-color, var(--white)));--theme-dark-clickable-secondary-focus-border-color: var(--jumio-sdk-theme-dark-clickable-secondary-focus-border-color, var(--portal-theme-dark-clickable-secondary-focus-border-color, var(--color-secondary5)));--theme-dark-clickable-secondary-active-bg-color: var(--jumio-sdk-theme-dark-clickable-secondary-active-bg-color, var(--portal-theme-dark-clickable-secondary-active-bg-color, var(--color-secondary8)));--theme-dark-clickable-secondary-active-color: var(--jumio-sdk-theme-dark-clickable-secondary-active-color, var(--portal-theme-dark-clickable-secondary-active-color, var(--white)));--theme-dark-clickable-secondary-active-border-color: var(--jumio-sdk-theme-dark-clickable-secondary-active-border-color, var(--portal-theme-dark-clickable-secondary-active-border-color, var(--color-secondary5)));--theme-dark-clickable-secondary-disabled-bg-color: var(--jumio-sdk-theme-dark-clickable-secondary-disabled-bg-color, var(--portal-theme-dark-clickable-secondary-disabled-bg-color, var(--color-secondary10)));--theme-dark-clickable-secondary-disabled-color: var(--jumio-sdk-theme-dark-clickable-secondary-disabled-color, var(--portal-theme-dark-clickable-secondary-disabled-color, var(--color-secondary7)));--theme-dark-clickable-secondary-disabled-border-color: var(--jumio-sdk-theme-dark-clickable-secondary-disabled-border-color, var(--portal-theme-dark-clickable-secondary-disabled-border-color, var(--color-secondary9)));--theme-light-clickable-tertiary-default-bg-color: var(--jumio-sdk-theme-light-clickable-tertiary-default-bg-color, var(--portal-theme-light-clickable-tertiary-default-bg-color, var(--color-tertiary2)));--theme-light-clickable-tertiary-default-color: var(--jumio-sdk-theme-light-clickable-tertiary-default-color, var(--portal-theme-light-clickable-tertiary-default-color, var(--white)));--theme-light-clickable-tertiary-focus-bg-color: var(--jumio-sdk-theme-light-clickable-tertiary-focus-bg-color, var(--portal-theme-light-clickable-tertiary-focus-bg-color, var(--color-tertiary3)));--theme-light-clickable-tertiary-focus-color: var(--jumio-sdk-theme-light-clickable-tertiary-focus-color, var(--portal-theme-light-clickable-tertiary-focus-color, var(--white)));--theme-light-clickable-tertiary-active-bg-color: var(--jumio-sdk-theme-light-clickable-tertiary-active-bg-color, var(--portal-theme-light-clickable-tertiary-active-bg-color, var(--color-tertiary3)));--theme-light-clickable-tertiary-active-color: var(--jumio-sdk-theme-light-clickable-tertiary-active-color, var(--portal-theme-light-clickable-tertiary-active-color, var(--white)));--theme-light-clickable-tertiary-disabled-bg-color: var(--jumio-sdk-theme-light-clickable-tertiary-disabled-bg-color, var(--portal-theme-light-clickable-tertiary-disabled-bg-color, var(--color-tertiary1)));--theme-light-clickable-tertiary-disabled-color: var(--jumio-sdk-theme-light-clickable-tertiary-disabled-color, var(--portal-theme-light-clickable-tertiary-disabled-color, var(--white)));--theme-dark-clickable-tertiary-default-bg-color: var(--jumio-sdk-theme-dark-clickable-tertiary-default-bg-color, var(--portal-theme-dark-clickable-tertiary-default-bg-color, var(--color-tertiary2)));--theme-dark-clickable-tertiary-default-color: var(--jumio-sdk-theme-dark-clickable-tertiary-default-color, var(--portal-theme-dark-clickable-tertiary-default-color, var(--white)));--theme-dark-clickable-tertiary-focus-bg-color: var(--jumio-sdk-theme-dark-clickable-tertiary-focus-bg-color, var(--portal-theme-dark-clickable-tertiary-focus-bg-color, var(--color-tertiary3)));--theme-dark-clickable-tertiary-focus-color: var(--jumio-sdk-theme-dark-clickable-tertiary-focus-color, var(--portal-theme-dark-clickable-tertiary-focus-color, var(--white)));--theme-dark-clickable-tertiary-active-bg-color: var(--jumio-sdk-theme-dark-clickable-tertiary-active-bg-color, var(--portal-theme-dark-clickable-tertiary-active-bg-color, var(--color-tertiary3)));--theme-dark-clickable-tertiary-active-color: var(--jumio-sdk-theme-dark-clickable-tertiary-active-color, var(--portal-theme-dark-clickable-tertiary-active-color, var(--white)));--theme-dark-clickable-tertiary-disabled-bg-color: var(--jumio-sdk-theme-dark-clickable-tertiary-disabled-bg-color, var(--portal-theme-dark-clickable-tertiary-disabled-bg-color, var(--color-tertiary1)));--theme-dark-clickable-tertiary-disabled-color: var(--jumio-sdk-theme-dark-clickable-tertiary-disabled-color, var(--portal-theme-dark-clickable-tertiary-disabled-color, var(--color-secondary8)));--theme-light-clickable-quiet-default-bg-color: var(--jumio-sdk-theme-light-clickable-quiet-default-bg-color, var(--portal-theme-light-clickable-quiet-default-bg-color, transparent));--theme-light-clickable-quiet-default-color: var(--jumio-sdk-theme-light-clickable-quiet-default-color, var(--portal-theme-light-clickable-quiet-default-color, var(--color-primary6)));--theme-light-clickable-quiet-focus-bg-color: var(--jumio-sdk-theme-light-clickable-quiet-focus-bg-color, var(--portal-theme-light-clickable-quiet-focus-bg-color, var(--color-secondary3)));--theme-light-clickable-quiet-focus-color: var(--jumio-sdk-theme-light-clickable-quiet-focus-color, var(--portal-theme-light-clickable-quiet-focus-color, var(--color-primary6)));--theme-light-clickable-quiet-active-bg-color: var(--jumio-sdk-theme-light-clickable-quiet-active-bg-color, var(--portal-theme-light-clickable-quiet-active-bg-color, var(--color-secondary4)));--theme-light-clickable-quiet-active-color: var(--jumio-sdk-theme-light-clickable-quiet-active-color, var(--portal-theme-light-clickable-quiet-active-color, var(--color-primary6)));--theme-light-clickable-quiet-disabled-bg-color: var(--jumio-sdk-theme-light-clickable-quiet-disabled-bg-color, var(--portal-theme-light-clickable-quiet-disabled-bg-color, transparent));--theme-light-clickable-quiet-disabled-color: var(--jumio-sdk-theme-light-clickable-quiet-disabled-color, var(--portal-theme-light-clickable-quiet-disabled-color, var(--color-secondary4)));--theme-dark-clickable-quiet-default-bg-color: var(--jumio-sdk-theme-dark-clickable-quiet-default-bg-color, var(--portal-theme-dark-clickable-quiet-default-bg-color, transparent));--theme-dark-clickable-quiet-default-color: var(--jumio-sdk-theme-dark-clickable-quiet-default-color, var(--portal-theme-dark-clickable-quiet-default-color, var(--color-primary1)));--theme-dark-clickable-quiet-focus-bg-color: var(--jumio-sdk-theme-dark-clickable-quiet-focus-bg-color, var(--portal-theme-dark-clickable-quiet-focus-bg-color, var(--color-secondary9)));--theme-dark-clickable-quiet-focus-color: var(--jumio-sdk-theme-dark-clickable-quiet-focus-color, var(--portal-theme-dark-clickable-quiet-focus-color, var(--color-primary1)));--theme-dark-clickable-quiet-active-bg-color: var(--jumio-sdk-theme-dark-clickable-quiet-active-bg-color, var(--portal-theme-dark-clickable-quiet-active-bg-color, var(--color-secondary10)));--theme-dark-clickable-quiet-active-color: var(--jumio-sdk-theme-dark-clickable-quiet-active-color, var(--portal-theme-dark-clickable-quiet-active-color, var(--color-primary1)));--theme-dark-clickable-quiet-disabled-bg-color: var(--jumio-sdk-theme-dark-clickable-quiet-disabled-bg-color, var(--portal-theme-dark-clickable-quiet-disabled-bg-color, transparent));--theme-dark-clickable-quiet-disabled-color: var(--jumio-sdk-theme-dark-clickable-quiet-disabled-color, var(--portal-theme-dark-clickable-quiet-disabled-color, var(--color-secondary7)));--theme-light-clickable-destructive-default-bg-color: var(--jumio-sdk-theme-light-clickable-destructive-default-bg-color, var(--portal-theme-light-clickable-destructive-default-bg-color, var(--semantic-red-10)));--theme-light-clickable-destructive-default-color: var(--jumio-sdk-theme-light-clickable-destructive-default-color, var(--portal-theme-light-clickable-destructive-default-color, var(--color-secondary12)));--theme-light-clickable-destructive-default-border-color: var(--jumio-sdk-theme-light-clickable-destructive-default-border-color, var(--portal-theme-light-clickable-destructive-default-border-color, var(--semantic-red-40)));--theme-light-clickable-destructive-focus-bg-color: var(--jumio-sdk-theme-light-clickable-destructive-focus-bg-color, var(--portal-theme-light-clickable-destructive-focus-bg-color, var(--semantic-red-30)));--theme-light-clickable-destructive-focus-color: var(--jumio-sdk-theme-light-clickable-destructive-focus-color, var(--portal-theme-light-clickable-destructive-focus-color, var(--color-secondary12)));--theme-light-clickable-destructive-focus-border-color: var(--jumio-sdk-theme-light-clickable-destructive-focus-border-color, var(--portal-theme-light-clickable-destructive-focus-border-color, var(--semantic-red-30)));--theme-light-clickable-destructive-active-bg-color: var(--jumio-sdk-theme-light-clickable-destructive-active-bg-color, var(--portal-theme-light-clickable-destructive-active-bg-color, var(--semantic-red-30)));--theme-light-clickable-destructive-active-color: var(--jumio-sdk-theme-light-clickable-destructive-active-color, var(--portal-theme-light-clickable-destructive-active-color, var(--color-secondary12)));--theme-light-clickable-destructive-active-border-color: var(--jumio-sdk-theme-light-clickable-destructive-active-border-color, var(--portal-theme-light-clickable-destructive-active-border-color, var(--semantic-red-30)));--theme-light-clickable-destructive-disabled-bg-color: var(--jumio-sdk-theme-light-clickable-destructive-disabled-bg-color, var(--portal-theme-light-clickable-destructive-disabled-bg-color, var(--semantic-red-05)));--theme-light-clickable-destructive-disabled-color: var(--jumio-sdk-theme-light-clickable-destructive-disabled-color, var(--portal-theme-light-clickable-destructive-disabled-color, var(--color-secondary4)));--theme-light-clickable-destructive-disabled-border-color: var(--jumio-sdk-theme-light-clickable-destructive-disabled-border-color, var(--portal-theme-light-clickable-destructive-disabled-border-color, var(--semantic-red-10)));--theme-dark-clickable-destructive-default-bg-color: var(--jumio-sdk-theme-dark-clickable-destructive-default-bg-color, var(--portal-theme-dark-clickable-destructive-default-bg-color, var(--semantic-red-10)));--theme-dark-clickable-destructive-default-color: var(--jumio-sdk-theme-dark-clickable-destructive-default-color, var(--portal-theme-dark-clickable-destructive-default-color, var(--color-secondary12)));--theme-dark-clickable-destructive-default-border-color: var(--jumio-sdk-theme-dark-clickable-destructive-default-border-color, var(--portal-theme-dark-clickable-destructive-default-border-color, var(--semantic-red-40)));--theme-dark-clickable-destructive-focus-bg-color: var(--jumio-sdk-theme-dark-clickable-destructive-focus-bg-color, var(--portal-theme-dark-clickable-destructive-focus-bg-color, var(--semantic-red-30)));--theme-dark-clickable-destructive-focus-color: var(--jumio-sdk-theme-dark-clickable-destructive-focus-color, var(--portal-theme-dark-clickable-destructive-focus-color, var(--color-secondary12)));--theme-dark-clickable-destructive-focus-border-color: var(--jumio-sdk-theme-dark-clickable-destructive-focus-border-color, var(--portal-theme-dark-clickable-destructive-focus-border-color, var(--semantic-red-30)));--theme-dark-clickable-destructive-active-bg-color: var(--jumio-sdk-theme-dark-clickable-destructive-active-bg-color, var(--portal-theme-dark-clickable-destructive-active-bg-color, var(--semantic-red-30)));--theme-dark-clickable-destructive-active-color: var(--jumio-sdk-theme-dark-clickable-destructive-active-color, var(--portal-theme-dark-clickable-destructive-active-color, var(--color-secondary12)));--theme-dark-clickable-destructive-active-border-color: var(--jumio-sdk-theme-dark-clickable-destructive-active-border-color, var(--portal-theme-dark-clickable-destructive-active-border-color, var(--semantic-red-30)));--theme-dark-clickable-destructive-disabled-bg-color: var(--jumio-sdk-theme-dark-clickable-destructive-disabled-bg-color, var(--portal-theme-dark-clickable-destructive-disabled-bg-color, var(--semantic-red-05)));--theme-dark-clickable-destructive-disabled-color: var(--jumio-sdk-theme-dark-clickable-destructive-disabled-color, var(--portal-theme-dark-clickable-destructive-disabled-color, var(--color-secondary5)));--theme-dark-clickable-destructive-disabled-border-color: var(--jumio-sdk-theme-dark-clickable-destructive-disabled-border-color, var(--portal-theme-dark-clickable-destructive-disabled-border-color, var(--semantic-red-10)));--theme-light-button-primary-default-bg-color: var(--jumio-sdk-theme-light-button-primary-default-bg-color, var(--portal-theme-light-button-primary-default-bg-color, var(--theme-light-clickable-primary-default-bg-color)));--theme-light-button-primary-default-color: var(--jumio-sdk-theme-light-button-primary-default-color, var(--portal-theme-light-button-primary-default-color, var(--theme-light-clickable-primary-default-color)));--theme-light-button-primary-focus-bg-color: var(--jumio-sdk-theme-light-button-primary-focus-bg-color, var(--portal-theme-light-button-primary-focus-bg-color, var(--theme-light-clickable-primary-focus-bg-color)));--theme-light-button-primary-focus-color: var(--jumio-sdk-theme-light-button-primary-focus-color, var(--portal-theme-light-button-primary-focus-color, var(--theme-light-clickable-primary-focus-color)));--theme-light-button-primary-active-bg-color: var(--jumio-sdk-theme-light-button-primary-active-bg-color, var(--portal-theme-light-button-primary-active-bg-color, var(--theme-light-clickable-primary-active-bg-color)));--theme-light-button-primary-active-color: var(--jumio-sdk-theme-light-button-primary-active-color, var(--portal-theme-light-button-primary-active-color, var(--theme-light-clickable-primary-active-color)));--theme-light-button-primary-disabled-bg-color: var(--jumio-sdk-theme-light-button-primary-disabled-bg-color, var(--portal-theme-light-button-primary-disabled-bg-color, var(--theme-light-clickable-primary-disabled-bg-color)));--theme-light-button-primary-disabled-color: var(--jumio-sdk-theme-light-button-primary-disabled-color, var(--portal-theme-light-button-primary-disabled-color, var(--theme-light-clickable-primary-disabled-color)));--theme-dark-button-primary-default-bg-color: var(--jumio-sdk-theme-dark-button-primary-default-bg-color, var(--portal-theme-dark-button-primary-default-bg-color, var(--theme-dark-clickable-primary-default-bg-color)));--theme-dark-button-primary-default-color: var(--jumio-sdk-theme-dark-button-primary-default-color, var(--portal-theme-dark-button-primary-default-color, var(--theme-dark-clickable-primary-default-color)));--theme-dark-button-primary-focus-bg-color: var(--jumio-sdk-theme-dark-button-primary-focus-bg-color, var(--portal-theme-dark-button-primary-focus-bg-color, var(--theme-dark-clickable-primary-focus-bg-color)));--theme-dark-button-primary-focus-color: var(--jumio-sdk-theme-dark-button-primary-focus-color, var(--portal-theme-dark-button-primary-focus-color, var(--theme-dark-clickable-primary-focus-color)));--theme-dark-button-primary-active-bg-color: var(--jumio-sdk-theme-dark-button-primary-active-bg-color, var(--portal-theme-dark-button-primary-active-bg-color, var(--theme-dark-clickable-primary-active-bg-color)));--theme-dark-button-primary-active-color: var(--jumio-sdk-theme-dark-button-primary-active-color, var(--portal-theme-dark-button-primary-active-color, var(--theme-dark-clickable-primary-active-color)));--theme-dark-button-primary-disabled-bg-color: var(--jumio-sdk-theme-dark-button-primary-disabled-bg-color, var(--portal-theme-dark-button-primary-disabled-bg-color, var(--theme-dark-clickable-primary-disabled-bg-color)));--theme-dark-button-primary-disabled-color: var(--jumio-sdk-theme-dark-button-primary-disabled-color, var(--portal-theme-dark-button-primary-disabled-color, var(--theme-dark-clickable-primary-disabled-color)));--theme-light-button-secondary-default-bg-color: var(--jumio-sdk-theme-light-button-secondary-default-bg-color, var(--portal-theme-light-button-secondary-default-bg-color, var(--theme-light-clickable-secondary-default-bg-color)));--theme-light-button-secondary-default-color: var(--jumio-sdk-theme-light-button-secondary-default-color, var(--portal-theme-light-button-secondary-default-color, var(--theme-light-clickable-secondary-default-color)));--theme-light-button-secondary-default-border-color: var(--jumio-sdk-theme-light-button-secondary-default-border-color, var(--portal-theme-light-button-secondary-default-border-color, var(--theme-light-clickable-secondary-default-border-color)));--theme-light-button-secondary-focus-bg-color: var(--jumio-sdk-theme-light-button-secondary-focus-bg-color, var(--portal-theme-light-button-secondary-focus-bg-color, var(--theme-light-clickable-secondary-focus-bg-color)));--theme-light-button-secondary-focus-color: var(--jumio-sdk-theme-light-button-secondary-focus-color, var(--portal-theme-light-button-secondary-focus-color, var(--theme-light-clickable-secondary-focus-color)));--theme-light-button-secondary-focus-border-color: var(--jumio-sdk-theme-light-button-secondary-focus-border-color, var(--portal-theme-light-button-secondary-focus-border-color, var(--theme-light-clickable-secondary-focus-border-color)));--theme-light-button-secondary-active-bg-color: var(--jumio-sdk-theme-light-button-secondary-active-bg-color, var(--portal-theme-light-button-secondary-active-bg-color, var(--theme-light-clickable-secondary-active-bg-color)));--theme-light-button-secondary-active-color: var(--jumio-sdk-theme-light-button-secondary-active-color, var(--portal-theme-light-button-secondary-active-color, var(--theme-light-clickable-secondary-active-color)));--theme-light-button-secondary-active-border-color: var(--jumio-sdk-theme-light-button-secondary-active-border-color, var(--portal-theme-light-button-secondary-active-border-color, var(--theme-light-clickable-secondary-active-border-color)));--theme-light-button-secondary-disabled-bg-color: var(--jumio-sdk-theme-light-button-secondary-disabled-bg-color, var(--portal-theme-light-button-secondary-disabled-bg-color, var(--theme-light-clickable-secondary-disabled-bg-color)));--theme-light-button-secondary-disabled-color: var(--jumio-sdk-theme-light-button-secondary-disabled-color, var(--portal-theme-light-button-secondary-disabled-color, var(--theme-light-clickable-secondary-disabled-color)));--theme-light-button-secondary-disabled-border-color: var(--jumio-sdk-theme-light-button-secondary-disabled-border-color, var(--portal-theme-light-button-secondary-disabled-border-color, var(--theme-light-clickable-secondary-disabled-border-color)));--theme-dark-button-secondary-default-bg-color: var(--jumio-sdk-theme-dark-button-secondary-default-bg-color, var(--portal-theme-dark-button-secondary-default-bg-color, var(--theme-dark-clickable-secondary-default-bg-color)));--theme-dark-button-secondary-default-color: var(--jumio-sdk-theme-dark-button-secondary-default-color, var(--portal-theme-dark-button-secondary-default-color, var(--theme-dark-clickable-secondary-default-color)));--theme-dark-button-secondary-default-border-color: var(--jumio-sdk-theme-dark-button-secondary-default-border-color, var(--portal-theme-dark-button-secondary-default-border-color, var(--theme-dark-clickable-secondary-default-border-color)));--theme-dark-button-secondary-focus-bg-color: var(--jumio-sdk-theme-dark-button-secondary-focus-bg-color, var(--portal-theme-dark-button-secondary-focus-bg-color, var(--theme-dark-clickable-secondary-focus-bg-color)));--theme-dark-button-secondary-focus-color: var(--jumio-sdk-theme-dark-button-secondary-focus-color, var(--portal-theme-dark-button-secondary-focus-color, var(--theme-dark-clickable-secondary-focus-color)));--theme-dark-button-secondary-focus-border-color: var(--jumio-sdk-theme-dark-button-secondary-focus-border-color, var(--portal-theme-dark-button-secondary-focus-border-color, var(--theme-dark-clickable-secondary-focus-border-color)));--theme-dark-button-secondary-active-bg-color: var(--jumio-sdk-theme-dark-button-secondary-active-bg-color, var(--portal-theme-dark-button-secondary-active-bg-color, var(--theme-dark-clickable-secondary-active-bg-color)));--theme-dark-button-secondary-active-color: var(--jumio-sdk-theme-dark-button-secondary-active-color, var(--portal-theme-dark-button-secondary-active-color, var(--theme-dark-clickable-secondary-active-color)));--theme-dark-button-secondary-active-border-color: var(--jumio-sdk-theme-dark-button-secondary-active-border-color, var(--portal-theme-dark-button-secondary-active-border-color, var(--theme-dark-clickable-secondary-active-border-color)));--theme-dark-button-secondary-disabled-bg-color: var(--jumio-sdk-theme-dark-button-secondary-disabled-bg-color, var(--portal-theme-dark-button-secondary-disabled-bg-color, var(--theme-dark-clickable-secondary-disabled-bg-color)));--theme-dark-button-secondary-disabled-color: var(--jumio-sdk-theme-dark-button-secondary-disabled-color, var(--portal-theme-dark-button-secondary-disabled-color, var(--theme-dark-clickable-secondary-disabled-color)));--theme-dark-button-secondary-disabled-border-color: var(--jumio-sdk-theme-dark-button-secondary-disabled-border-color, var(--portal-theme-dark-button-secondary-disabled-border-color, var(--theme-dark-clickable-secondary-disabled-border-color)));--theme-light-button-tertiary-default-bg-color: var(--jumio-sdk-theme-light-button-tertiary-default-bg-color, var(--portal-theme-light-button-tertiary-default-bg-color, var(--theme-light-clickable-tertiary-default-bg-color)));--theme-light-button-tertiary-default-color: var(--jumio-sdk-theme-light-button-tertiary-default-color, var(--portal-theme-light-button-tertiary-default-color, var(--theme-light-clickable-tertiary-default-color)));--theme-light-button-tertiary-focus-bg-color: var(--jumio-sdk-theme-light-button-tertiary-focus-bg-color, var(--portal-theme-light-button-tertiary-focus-bg-color, var(--theme-light-clickable-tertiary-focus-bg-color)));--theme-light-button-tertiary-focus-color: var(--jumio-sdk-theme-light-button-tertiary-focus-color, var(--portal-theme-light-button-tertiary-focus-color, var(--theme-light-clickable-tertiary-focus-color)));--theme-light-button-tertiary-active-bg-color: var(--jumio-sdk-theme-light-button-tertiary-active-bg-color, var(--portal-theme-light-button-tertiary-active-bg-color, var(--theme-light-clickable-tertiary-active-bg-color)));--theme-light-button-tertiary-active-color: var(--jumio-sdk-theme-light-button-tertiary-active-color, var(--portal-theme-light-button-tertiary-active-color, var(--theme-light-clickable-tertiary-active-color)));--theme-light-button-tertiary-disabled-bg-color: var(--jumio-sdk-theme-light-button-tertiary-disabled-bg-color, var(--portal-theme-light-button-tertiary-disabled-bg-color, var(--theme-light-clickable-tertiary-disabled-bg-color)));--theme-light-button-tertiary-disabled-color: var(--jumio-sdk-theme-light-button-tertiary-disabled-color, var(--portal-theme-light-button-tertiary-disabled-color, var(--theme-light-clickable-tertiary-disabled-color)));--theme-dark-button-tertiary-default-bg-color: var(--jumio-sdk-theme-dark-button-tertiary-default-bg-color, var(--portal-theme-dark-button-tertiary-default-bg-color, var(--theme-dark-clickable-tertiary-default-bg-color)));--theme-dark-button-tertiary-default-color: var(--jumio-sdk-theme-dark-button-tertiary-default-color, var(--portal-theme-dark-button-tertiary-default-color, var(--theme-dark-clickable-tertiary-default-color)));--theme-dark-button-tertiary-focus-bg-color: var(--jumio-sdk-theme-dark-button-tertiary-focus-bg-color, var(--portal-theme-dark-button-tertiary-focus-bg-color, var(--theme-dark-clickable-tertiary-focus-bg-color)));--theme-dark-button-tertiary-focus-color: var(--jumio-sdk-theme-dark-button-tertiary-focus-color, var(--portal-theme-dark-button-tertiary-focus-color, var(--theme-dark-clickable-tertiary-focus-color)));--theme-dark-button-tertiary-active-bg-color: var(--jumio-sdk-theme-dark-button-tertiary-active-bg-color, var(--portal-theme-dark-button-tertiary-active-bg-color, var(--theme-dark-clickable-tertiary-active-bg-color)));--theme-dark-button-tertiary-active-color: var(--jumio-sdk-theme-dark-button-tertiary-active-color, var(--portal-theme-dark-button-tertiary-active-color, var(--theme-dark-clickable-tertiary-active-color)));--theme-dark-button-tertiary-disabled-bg-color: var(--jumio-sdk-theme-dark-button-tertiary-disabled-bg-color, var(--portal-theme-dark-button-tertiary-disabled-bg-color, var(--theme-dark-clickable-tertiary-disabled-bg-color)));--theme-dark-button-tertiary-disabled-color: var(--jumio-sdk-theme-dark-button-tertiary-disabled-color, var(--portal-theme-dark-button-tertiary-disabled-color, var(--theme-dark-clickable-tertiary-disabled-color)));--theme-light-button-quiet-default-bg-color: var(--jumio-sdk-theme-light-button-quiet-default-bg-color, var(--portal-theme-light-button-quiet-default-bg-color, transparent));--theme-light-button-quiet-default-color: var(--jumio-sdk-theme-light-button-quiet-default-color, var(--portal-theme-light-button-quiet-default-color, var(--theme-light-clickable-quiet-default-color)));--theme-light-button-quiet-focus-bg-color: var(--jumio-sdk-theme-light-button-quiet-focus-bg-color, var(--portal-theme-light-button-quiet-focus-bg-color, var(--theme-light-clickable-quiet-focus-bg-color)));--theme-light-button-quiet-focus-color: var(--jumio-sdk-theme-light-button-quiet-focus-color, var(--portal-theme-light-button-quiet-focus-color, var(--theme-light-clickable-quiet-focus-color)));--theme-light-button-quiet-active-bg-color: var(--jumio-sdk-theme-light-button-quiet-active-bg-color, var(--portal-theme-light-button-quiet-active-bg-color, var(--theme-light-clickable-quiet-active-bg-color)));--theme-light-button-quiet-active-color: var(--jumio-sdk-theme-light-button-quiet-active-color, var(--portal-theme-light-button-quiet-active-color, var(--theme-light-clickable-quiet-active-color)));--theme-light-button-quiet-disabled-bg-color: var(--jumio-sdk-theme-light-button-quiet-disabled-bg-color, var(--portal-theme-light-button-quiet-disabled-bg-color, transparent));--theme-light-button-quiet-disabled-color: var(--jumio-sdk-theme-light-button-quiet-disabled-color, var(--portal-theme-light-button-quiet-disabled-color, var(--theme-light-clickable-quiet-disabled-color)));--theme-dark-button-quiet-default-bg-color: var(--jumio-sdk-theme-dark-button-quiet-default-bg-color, var(--portal-theme-dark-button-quiet-default-bg-color, transparent));--theme-dark-button-quiet-default-color: var(--jumio-sdk-theme-dark-button-quiet-default-color, var(--portal-theme-dark-button-quiet-default-color, var(--theme-dark-clickable-quiet-default-color)));--theme-dark-button-quiet-focus-bg-color: var(--jumio-sdk-theme-dark-button-quiet-focus-bg-color, var(--portal-theme-dark-button-quiet-focus-bg-color, var(--theme-dark-clickable-quiet-focus-bg-color)));--theme-dark-button-quiet-focus-color: var(--jumio-sdk-theme-dark-button-quiet-focus-color, var(--portal-theme-dark-button-quiet-focus-color, var(--theme-dark-clickable-quiet-focus-color)));--theme-dark-button-quiet-active-bg-color: var(--jumio-sdk-theme-dark-button-quiet-active-bg-color, var(--portal-theme-dark-button-quiet-active-bg-color, var(--theme-dark-clickable-quiet-active-bg-color)));--theme-dark-button-quiet-active-color: var(--jumio-sdk-theme-dark-button-quiet-active-color, var(--portal-theme-dark-button-quiet-active-color, var(--theme-dark-clickable-quiet-active-color)));--theme-dark-button-quiet-disabled-bg-color: var(--jumio-sdk-theme-dark-button-quiet-disabled-bg-color, var(--portal-theme-dark-button-quiet-disabled-bg-color, transparent));--theme-dark-button-quiet-disabled-color: var(--jumio-sdk-theme-dark-button-quiet-disabled-color, var(--portal-theme-dark-button-quiet-disabled-color, var(--theme-dark-clickable-quiet-disabled-color)));--theme-light-button-destructive-default-bg-color: var(--jumio-sdk-theme-light-button-destructive-default-bg-color, var(--portal-theme-light-button-destructive-default-bg-color, var(--theme-light-clickable-destructive-default-bg-color)));--theme-light-button-destructive-default-color: var(--jumio-sdk-theme-light-button-destructive-default-color, var(--portal-theme-light-button-destructive-default-color, var(--theme-light-clickable-destructive-default-color)));--theme-light-button-destructive-default-border-color: var(--jumio-sdk-theme-light-button-destructive-default-border-color, var(--portal-theme-light-button-destructive-default-border-color, var(--theme-light-clickable-destructive-default-border-color)));--theme-light-button-destructive-focus-bg-color: var(--jumio-sdk-theme-light-button-destructive-focus-bg-color, var(--portal-theme-light-button-destructive-focus-bg-color, var(--theme-light-clickable-destructive-focus-bg-color)));--theme-light-button-destructive-focus-color: var(--jumio-sdk-theme-light-button-destructive-focus-color, var(--portal-theme-light-button-destructive-focus-color, var(--theme-light-clickable-destructive-focus-color)));--theme-light-button-destructive-focus-border-color: var(--jumio-sdk-theme-light-button-destructive-focus-border-color, var(--portal-theme-light-button-destructive-focus-border-color, var(--theme-light-clickable-destructive-focus-border-color)));--theme-light-button-destructive-active-bg-color: var(--jumio-sdk-theme-light-button-destructive-active-bg-color, var(--portal-theme-light-button-destructive-active-bg-color, var(--theme-light-clickable-destructive-active-bg-color)));--theme-light-button-destructive-active-color: var(--jumio-sdk-theme-light-button-destructive-active-color, var(--portal-theme-light-button-destructive-active-color, var(--theme-light-clickable-destructive-active-color)));--theme-light-button-destructive-active-border-color: var(--jumio-sdk-theme-light-button-destructive-active-border-color, var(--portal-theme-light-button-destructive-active-border-color, var(--theme-light-clickable-destructive-active-border-color)));--theme-light-button-destructive-disabled-bg-color: var(--jumio-sdk-theme-light-button-destructive-disabled-bg-color, var(--portal-theme-light-button-destructive-disabled-bg-color, var(--theme-light-clickable-destructive-disabled-bg-color)));--theme-light-button-destructive-disabled-color: var(--jumio-sdk-theme-light-button-destructive-disabled-color, var(--portal-theme-light-button-destructive-disabled-color, var(--theme-light-clickable-destructive-disabled-color)));--theme-light-button-destructive-disabled-border-color: var(--jumio-sdk-theme-light-button-destructive-disabled-border-color, var(--portal-theme-light-button-destructive-disabled-border-color, var(--theme-light-clickable-destructive-disabled-border-color)));--theme-dark-button-destructive-default-bg-color: var(--jumio-sdk-theme-dark-button-destructive-default-bg-color, var(--portal-theme-dark-button-destructive-default-bg-color, var(--theme-dark-clickable-destructive-default-bg-color)));--theme-dark-button-destructive-default-color: var(--jumio-sdk-theme-dark-button-destructive-default-color, var(--portal-theme-dark-button-destructive-default-color, var(--theme-dark-clickable-destructive-default-color)));--theme-dark-button-destructive-default-border-color: var(--jumio-sdk-theme-dark-button-destructive-default-border-color, var(--portal-theme-dark-button-destructive-default-border-color, var(--theme-dark-clickable-destructive-default-border-color)));--theme-dark-button-destructive-focus-bg-color: var(--jumio-sdk-theme-dark-button-destructive-focus-bg-color, var(--portal-theme-dark-button-destructive-focus-bg-color, var(--theme-dark-clickable-destructive-focus-bg-color)));--theme-dark-button-destructive-focus-color: var(--jumio-sdk-theme-dark-button-destructive-focus-color, var(--portal-theme-dark-button-destructive-focus-color, var(--theme-dark-clickable-destructive-focus-color)));--theme-dark-button-destructive-focus-border-color: var(--jumio-sdk-theme-dark-button-destructive-focus-border-color, var(--portal-theme-dark-button-destructive-focus-border-color, var(--theme-dark-clickable-destructive-focus-border-color)));--theme-dark-button-destructive-active-bg-color: var(--jumio-sdk-theme-dark-button-destructive-active-bg-color, var(--portal-theme-dark-button-destructive-active-bg-color, var(--theme-dark-clickable-destructive-active-bg-color)));--theme-dark-button-destructive-active-color: var(--jumio-sdk-theme-dark-button-destructive-active-color, var(--portal-theme-dark-button-destructive-active-color, var(--theme-dark-clickable-destructive-active-color)));--theme-dark-button-destructive-active-border-color: var(--jumio-sdk-theme-dark-button-destructive-active-border-color, var(--portal-theme-dark-button-destructive-active-border-color, var(--theme-dark-clickable-destructive-active-border-color)));--theme-dark-button-destructive-disabled-bg-color: var(--jumio-sdk-theme-dark-button-destructive-disabled-bg-color, var(--portal-theme-dark-button-destructive-disabled-bg-color, var(--theme-dark-clickable-destructive-disabled-bg-color)));--theme-dark-button-destructive-disabled-color: var(--jumio-sdk-theme-dark-button-destructive-disabled-color, var(--portal-theme-dark-button-destructive-disabled-color, var(--theme-dark-clickable-destructive-disabled-color)));--theme-dark-button-destructive-disabled-border-color: var(--jumio-sdk-theme-dark-button-destructive-disabled-border-color, var(--portal-theme-dark-button-destructive-disabled-border-color, var(--theme-dark-clickable-destructive-disabled-border-color)));--theme-light-card-primary-default-bg-color: var(--jumio-sdk-theme-light-card-primary-default-bg-color, var(--portal-theme-light-card-primary-default-bg-color, var(--theme-light-clickable-primary-default-bg-color)));--theme-light-card-primary-default-color: var(--jumio-sdk-theme-light-card-primary-default-color, var(--portal-theme-light-card-primary-default-color, var(--theme-light-clickable-primary-default-color)));--theme-light-card-primary-focus-bg-color: var(--jumio-sdk-theme-light-card-primary-focus-bg-color, var(--portal-theme-light-card-primary-focus-bg-color, var(--theme-light-clickable-primary-focus-bg-color)));--theme-light-card-primary-focus-color: var(--jumio-sdk-theme-light-card-primary-focus-color, var(--portal-theme-light-card-primary-focus-color, var(--theme-light-clickable-primary-focus-color)));--theme-light-card-primary-active-bg-color: var(--jumio-sdk-theme-light-card-primary-active-bg-color, var(--portal-theme-light-card-primary-active-bg-color, var(--theme-light-clickable-primary-active-bg-color)));--theme-light-card-primary-active-color: var(--jumio-sdk-theme-light-card-primary-active-color, var(--portal-theme-light-card-primary-active-color, var(--theme-light-clickable-primary-active-color)));--theme-light-card-primary-disabled-bg-color: var(--jumio-sdk-theme-light-card-primary-disabled-bg-color, var(--portal-theme-light-card-primary-disabled-bg-color, var(--theme-light-clickable-primary-disabled-bg-color)));--theme-light-card-primary-disabled-color: var(--jumio-sdk-theme-light-card-primary-disabled-color, var(--portal-theme-light-card-primary-disabled-color, var(--theme-light-clickable-primary-disabled-color)));--theme-dark-card-primary-default-bg-color: var(--jumio-sdk-theme-dark-card-primary-default-bg-color, var(--portal-theme-dark-card-primary-default-bg-color, var(--theme-dark-clickable-primary-default-bg-color)));--theme-dark-card-primary-default-color: var(--jumio-sdk-theme-dark-card-primary-default-color, var(--portal-theme-dark-card-primary-default-color, var(--theme-dark-clickable-primary-default-color)));--theme-dark-card-primary-focus-bg-color: var(--jumio-sdk-theme-dark-card-primary-focus-bg-color, var(--portal-theme-dark-card-primary-focus-bg-color, var(--theme-dark-clickable-primary-focus-bg-color)));--theme-dark-card-primary-focus-color: var(--jumio-sdk-theme-dark-card-primary-focus-color, var(--portal-theme-dark-card-primary-focus-color, var(--theme-dark-clickable-primary-focus-color)));--theme-dark-card-primary-active-bg-color: var(--jumio-sdk-theme-dark-card-primary-active-bg-color, var(--portal-theme-dark-card-primary-active-bg-color, var(--theme-dark-clickable-primary-active-bg-color)));--theme-dark-card-primary-active-color: var(--jumio-sdk-theme-dark-card-primary-active-color, var(--portal-theme-dark-card-primary-active-color, var(--theme-dark-clickable-primary-active-color)));--theme-dark-card-primary-disabled-bg-color: var(--jumio-sdk-theme-dark-card-primary-disabled-bg-color, var(--portal-theme-dark-card-primary-disabled-bg-color, var(--theme-dark-clickable-primary-disabled-bg-color)));--theme-dark-card-primary-disabled-color: var(--jumio-sdk-theme-dark-card-primary-disabled-color, var(--portal-theme-dark-card-primary-disabled-color, var(--theme-dark-clickable-primary-disabled-color)));--theme-light-card-secondary-default-bg-color: var(--jumio-sdk-theme-light-card-secondary-default-bg-color, var(--portal-theme-light-card-secondary-default-bg-color, var(--theme-light-clickable-secondary-default-bg-color)));--theme-light-card-secondary-default-color: var(--jumio-sdk-theme-light-card-secondary-default-color, var(--portal-theme-light-card-secondary-default-color, var(--theme-light-clickable-secondary-default-color)));--theme-light-card-secondary-default-border-color: var(--jumio-sdk-theme-light-card-secondary-default-border-color, var(--portal-theme-light-card-secondary-default-border-color, var(--theme-light-clickable-secondary-default-border-color)));--theme-light-card-secondary-focus-bg-color: var(--jumio-sdk-theme-light-card-secondary-focus-bg-color, var(--portal-theme-light-card-secondary-focus-bg-color, var(--theme-light-clickable-secondary-focus-bg-color)));--theme-light-card-secondary-focus-color: var(--jumio-sdk-theme-light-card-secondary-focus-color, var(--portal-theme-light-card-secondary-focus-color, var(--theme-light-clickable-secondary-focus-color)));--theme-light-card-secondary-focus-border-color: var(--jumio-sdk-theme-light-card-secondary-focus-border-color, var(--portal-theme-light-card-secondary-focus-border-color, var(--theme-light-clickable-secondary-focus-border-color)));--theme-light-card-secondary-active-bg-color: var(--jumio-sdk-theme-light-card-secondary-active-bg-color, var(--portal-theme-light-card-secondary-active-bg-color, var(--theme-light-clickable-secondary-active-bg-color)));--theme-light-card-secondary-active-color: var(--jumio-sdk-theme-light-card-secondary-active-color, var(--portal-theme-light-card-secondary-active-color, var(--theme-light-clickable-secondary-active-color)));--theme-light-card-secondary-active-border-color: var(--jumio-sdk-theme-light-card-secondary-active-border-color, var(--portal-theme-light-card-secondary-active-border-color, var(--theme-light-clickable-secondary-active-border-color)));--theme-light-card-secondary-disabled-bg-color: var(--jumio-sdk-theme-light-card-secondary-disabled-bg-color, var(--portal-theme-light-card-secondary-disabled-bg-color, var(--theme-light-clickable-secondary-disabled-bg-color)));--theme-light-card-secondary-disabled-color: var(--jumio-sdk-theme-light-card-secondary-disabled-color, var(--portal-theme-light-card-secondary-disabled-color, var(--theme-light-clickable-secondary-disabled-color)));--theme-light-card-secondary-disabled-border-color: var(--jumio-sdk-theme-light-card-secondary-disabled-border-color, var(--portal-theme-light-card-secondary-disabled-border-color, var(--theme-light-clickable-secondary-disabled-border-color)));--theme-dark-card-secondary-default-bg-color: var(--jumio-sdk-theme-dark-card-secondary-default-bg-color, var(--portal-theme-dark-card-secondary-default-bg-color, var(--theme-dark-clickable-secondary-default-bg-color)));--theme-dark-card-secondary-default-color: var(--jumio-sdk-theme-dark-card-secondary-default-color, var(--portal-theme-dark-card-secondary-default-color, var(--theme-dark-clickable-secondary-default-color)));--theme-dark-card-secondary-default-border-color: var(--jumio-sdk-theme-dark-card-secondary-default-border-color, var(--portal-theme-dark-card-secondary-default-border-color, var(--theme-dark-clickable-secondary-default-border-color)));--theme-dark-card-secondary-focus-bg-color: var(--jumio-sdk-theme-dark-card-secondary-focus-bg-color, var(--portal-theme-dark-card-secondary-focus-bg-color, var(--theme-dark-clickable-secondary-focus-bg-color)));--theme-dark-card-secondary-focus-color: var(--jumio-sdk-theme-dark-card-secondary-focus-color, var(--portal-theme-dark-card-secondary-focus-color, var(--theme-dark-clickable-secondary-focus-color)));--theme-dark-card-secondary-focus-border-color: var(--jumio-sdk-theme-dark-card-secondary-focus-border-color, var(--portal-theme-dark-card-secondary-focus-border-color, var(--theme-dark-clickable-secondary-focus-border-color)));--theme-dark-card-secondary-active-bg-color: var(--jumio-sdk-theme-dark-card-secondary-active-bg-color, var(--portal-theme-dark-card-secondary-active-bg-color, var(--theme-dark-clickable-secondary-active-bg-color)));--theme-dark-card-secondary-active-color: var(--jumio-sdk-theme-dark-card-secondary-active-color, var(--portal-theme-dark-card-secondary-active-color, var(--theme-dark-clickable-secondary-active-color)));--theme-dark-card-secondary-active-border-color: var(--jumio-sdk-theme-dark-card-secondary-active-border-color, var(--portal-theme-dark-card-secondary-active-border-color, var(--theme-dark-clickable-secondary-active-border-color)));--theme-dark-card-secondary-disabled-bg-color: var(--jumio-sdk-theme-dark-card-secondary-disabled-bg-color, var(--portal-theme-dark-card-secondary-disabled-bg-color, var(--theme-dark-clickable-secondary-disabled-bg-color)));--theme-dark-card-secondary-disabled-color: var(--jumio-sdk-theme-dark-card-secondary-disabled-color, var(--portal-theme-dark-card-secondary-disabled-color, var(--theme-dark-clickable-secondary-disabled-color)));--theme-dark-card-secondary-disabled-border-color: var(--jumio-sdk-theme-dark-card-secondary-disabled-border-color, var(--portal-theme-dark-card-secondary-disabled-border-color, var(--theme-dark-clickable-secondary-disabled-border-color)));--theme-light-card-tertiary-default-bg-color: var(--jumio-sdk-theme-light-card-tertiary-default-bg-color, var(--portal-theme-light-card-tertiary-default-bg-color, var(--theme-light-clickable-tertiary-default-bg-color)));--theme-light-card-tertiary-default-color: var(--jumio-sdk-theme-light-card-tertiary-default-color, var(--portal-theme-light-card-tertiary-default-color, var(--theme-light-clickable-tertiary-default-color)));--theme-light-card-tertiary-focus-bg-color: var(--jumio-sdk-theme-light-card-tertiary-focus-bg-color, var(--portal-theme-light-card-tertiary-focus-bg-color, var(--theme-light-clickable-tertiary-focus-bg-color)));--theme-light-card-tertiary-focus-color: var(--jumio-sdk-theme-light-card-tertiary-focus-color, var(--portal-theme-light-card-tertiary-focus-color, var(--theme-light-clickable-tertiary-focus-color)));--theme-light-card-tertiary-active-bg-color: var(--jumio-sdk-theme-light-card-tertiary-active-bg-color, var(--portal-theme-light-card-tertiary-active-bg-color, var(--theme-light-clickable-tertiary-active-bg-color)));--theme-light-card-tertiary-active-color: var(--jumio-sdk-theme-light-card-tertiary-active-color, var(--portal-theme-light-card-tertiary-active-color, var(--theme-light-clickable-tertiary-active-color)));--theme-light-card-tertiary-disabled-bg-color: var(--jumio-sdk-theme-light-card-tertiary-disabled-bg-color, var(--portal-theme-light-card-tertiary-disabled-bg-color, var(--theme-light-clickable-tertiary-disabled-bg-color)));--theme-light-card-tertiary-disabled-color: var(--jumio-sdk-theme-light-card-tertiary-disabled-color, var(--portal-theme-light-card-tertiary-disabled-color, var(--theme-light-clickable-tertiary-disabled-color)));--theme-dark-card-tertiary-default-bg-color: var(--jumio-sdk-theme-dark-card-tertiary-default-bg-color, var(--portal-theme-dark-card-tertiary-default-bg-color, var(--theme-dark-clickable-tertiary-default-bg-color)));--theme-dark-card-tertiary-default-color: var(--jumio-sdk-theme-dark-card-tertiary-default-color, var(--portal-theme-dark-card-tertiary-default-color, var(--theme-dark-clickable-tertiary-default-color)));--theme-dark-card-tertiary-focus-bg-color: var(--jumio-sdk-theme-dark-card-tertiary-focus-bg-color, var(--portal-theme-dark-card-tertiary-focus-bg-color, var(--theme-dark-clickable-tertiary-focus-bg-color)));--theme-dark-card-tertiary-focus-color: var(--jumio-sdk-theme-dark-card-tertiary-focus-color, var(--portal-theme-dark-card-tertiary-focus-color, var(--theme-dark-clickable-tertiary-focus-color)));--theme-dark-card-tertiary-active-bg-color: var(--jumio-sdk-theme-dark-card-tertiary-active-bg-color, var(--portal-theme-dark-card-tertiary-active-bg-color, var(--theme-dark-clickable-tertiary-active-bg-color)));--theme-dark-card-tertiary-active-color: var(--jumio-sdk-theme-dark-card-tertiary-active-color, var(--portal-theme-dark-card-tertiary-active-color, var(--theme-dark-clickable-tertiary-active-color)));--theme-dark-card-tertiary-disabled-bg-color: var(--jumio-sdk-theme-dark-card-tertiary-disabled-bg-color, var(--portal-theme-dark-card-tertiary-disabled-bg-color, var(--theme-dark-clickable-tertiary-disabled-bg-color)));--theme-dark-card-tertiary-disabled-color: var(--jumio-sdk-theme-dark-card-tertiary-disabled-color, var(--portal-theme-dark-card-tertiary-disabled-color, var(--theme-dark-clickable-tertiary-disabled-color)))}`, dle = cle, ule = ee`
  :host {
    font-family: var(--font-family);
  }

  :host([data-color-scheme='light']) {
    color: var(--theme-light-text-color);
  }

  :host([data-color-scheme='dark']) {
    color: var(--theme-dark-text-color);
  }

  h1 {
    font: var(--text-font-h1);
    margin: 0;
  }

  h2 {
    font: var(--text-font-h2);
    margin: 0;
  }

  h3 {
    font: var(--text-font-h3);
    margin: 0;
  }

  h4 {
    font: var(--text-font-h4);
    margin: 0;
  }

  h5 {
    font: var(--text-font-h5);
    margin: 0;
  }

  h6 {
    font: var(--text-font-h6);
    margin: 0;
  }

  .text-subtitle-medium {
    font: var(--text-font-subtitle-medium);
  }

  .text-body-medium {
    font: var(--text-font-body-medium);
  }

  .text-body-small {
    font: var(--text-font-body-small);
  }

  .text-caption-regular,
  .text-caption-medium {
    font: var(--text-font-caption-medium);
  }

  .text-caption-small {
    font: var(--text-font-caption-small);
  }

  .text-center {
    text-align: center;
  }

  p {
    font-family: var(--font-family);
    line-height: 1.5em;
  }

  .text-regular {
    font-weight: 400;
  }

  .text-medium {
    font-weight: 500;
  }

  .text-bold {
    font-weight: 600;
  }

  a {
    transition-property: background-color, color;
    transition-duration: 250ms;
    text-decoration: underline;
  }

  [data-color-scheme='light'] a {
    color: var(--color-primary7);
  }

  [data-color-scheme='dark'] a {
    color: var(--color-primary4);
  }
`, hle = ee`
  .no-margin {
    margin: 0;
  }

  .hidden {
    display: none !important;
  }
`;
var ple = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
};
const hm = ple, AG = {};
for (const e of Object.keys(hm))
  AG[hm[e]] = e;
const Ze = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var UG = Ze;
for (const e of Object.keys(Ze)) {
  if (!("channels" in Ze[e]))
    throw new Error("missing channels property: " + e);
  if (!("labels" in Ze[e]))
    throw new Error("missing channel labels property: " + e);
  if (Ze[e].labels.length !== Ze[e].channels)
    throw new Error("channel and label counts mismatch: " + e);
  const { channels: t, labels: r } = Ze[e];
  delete Ze[e].channels, delete Ze[e].labels, Object.defineProperty(Ze[e], "channels", { value: t }), Object.defineProperty(Ze[e], "labels", { value: r });
}
Ze.rgb.hsl = function(e) {
  const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, a = Math.min(t, r, n), i = Math.max(t, r, n), o = i - a;
  let s, c;
  i === a ? s = 0 : t === i ? s = (r - n) / o : r === i ? s = 2 + (n - t) / o : n === i && (s = 4 + (t - r) / o), s = Math.min(s * 60, 360), s < 0 && (s += 360);
  const l = (a + i) / 2;
  return i === a ? c = 0 : l <= 0.5 ? c = o / (i + a) : c = o / (2 - i - a), [s, c * 100, l * 100];
};
Ze.rgb.hsv = function(e) {
  let t, r, n, a, i;
  const o = e[0] / 255, s = e[1] / 255, c = e[2] / 255, l = Math.max(o, s, c), u = l - Math.min(o, s, c), g = function(p) {
    return (l - p) / 6 / u + 1 / 2;
  };
  return u === 0 ? (a = 0, i = 0) : (i = u / l, t = g(o), r = g(s), n = g(c), o === l ? a = n - r : s === l ? a = 1 / 3 + t - n : c === l && (a = 2 / 3 + r - t), a < 0 ? a += 1 : a > 1 && (a -= 1)), [
    a * 360,
    i * 100,
    l * 100
  ];
};
Ze.rgb.hwb = function(e) {
  const t = e[0], r = e[1];
  let n = e[2];
  const a = Ze.rgb.hsl(e)[0], i = 1 / 255 * Math.min(t, Math.min(r, n));
  return n = 1 - 1 / 255 * Math.max(t, Math.max(r, n)), [a, i * 100, n * 100];
};
Ze.rgb.cmyk = function(e) {
  const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, a = Math.min(1 - t, 1 - r, 1 - n), i = (1 - t - a) / (1 - a) || 0, o = (1 - r - a) / (1 - a) || 0, s = (1 - n - a) / (1 - a) || 0;
  return [i * 100, o * 100, s * 100, a * 100];
};
function gle(e, t) {
  return (e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2 + (e[2] - t[2]) ** 2;
}
Ze.rgb.keyword = function(e) {
  const t = AG[e];
  if (t)
    return t;
  let r = 1 / 0, n;
  for (const a of Object.keys(hm)) {
    const i = hm[a], o = gle(e, i);
    o < r && (r = o, n = a);
  }
  return n;
};
Ze.keyword.rgb = function(e) {
  return hm[e];
};
Ze.rgb.xyz = function(e) {
  let t = e[0] / 255, r = e[1] / 255, n = e[2] / 255;
  t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92, n = n > 0.04045 ? ((n + 0.055) / 1.055) ** 2.4 : n / 12.92;
  const a = t * 0.4124 + r * 0.3576 + n * 0.1805, i = t * 0.2126 + r * 0.7152 + n * 0.0722, o = t * 0.0193 + r * 0.1192 + n * 0.9505;
  return [a * 100, i * 100, o * 100];
};
Ze.rgb.lab = function(e) {
  const t = Ze.rgb.xyz(e);
  let r = t[0], n = t[1], a = t[2];
  r /= 95.047, n /= 100, a /= 108.883, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116, a = a > 8856e-6 ? a ** (1 / 3) : 7.787 * a + 16 / 116;
  const i = 116 * n - 16, o = 500 * (r - n), s = 200 * (n - a);
  return [i, o, s];
};
Ze.hsl.rgb = function(e) {
  const t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
  let a, i, o;
  if (r === 0)
    return o = n * 255, [o, o, o];
  n < 0.5 ? a = n * (1 + r) : a = n + r - n * r;
  const s = 2 * n - a, c = [0, 0, 0];
  for (let l = 0; l < 3; l++)
    i = t + 1 / 3 * -(l - 1), i < 0 && i++, i > 1 && i--, 6 * i < 1 ? o = s + (a - s) * 6 * i : 2 * i < 1 ? o = a : 3 * i < 2 ? o = s + (a - s) * (2 / 3 - i) * 6 : o = s, c[l] = o * 255;
  return c;
};
Ze.hsl.hsv = function(e) {
  const t = e[0];
  let r = e[1] / 100, n = e[2] / 100, a = r;
  const i = Math.max(n, 0.01);
  n *= 2, r *= n <= 1 ? n : 2 - n, a *= i <= 1 ? i : 2 - i;
  const o = (n + r) / 2, s = n === 0 ? 2 * a / (i + a) : 2 * r / (n + r);
  return [t, s * 100, o * 100];
};
Ze.hsv.rgb = function(e) {
  const t = e[0] / 60, r = e[1] / 100;
  let n = e[2] / 100;
  const a = Math.floor(t) % 6, i = t - Math.floor(t), o = 255 * n * (1 - r), s = 255 * n * (1 - r * i), c = 255 * n * (1 - r * (1 - i));
  switch (n *= 255, a) {
    case 0:
      return [n, c, o];
    case 1:
      return [s, n, o];
    case 2:
      return [o, n, c];
    case 3:
      return [o, s, n];
    case 4:
      return [c, o, n];
    case 5:
      return [n, o, s];
  }
};
Ze.hsv.hsl = function(e) {
  const t = e[0], r = e[1] / 100, n = e[2] / 100, a = Math.max(n, 0.01);
  let i, o;
  o = (2 - r) * n;
  const s = (2 - r) * a;
  return i = r * a, i /= s <= 1 ? s : 2 - s, i = i || 0, o /= 2, [t, i * 100, o * 100];
};
Ze.hwb.rgb = function(e) {
  const t = e[0] / 360;
  let r = e[1] / 100, n = e[2] / 100;
  const a = r + n;
  let i;
  a > 1 && (r /= a, n /= a);
  const o = Math.floor(6 * t), s = 1 - n;
  i = 6 * t - o, o & 1 && (i = 1 - i);
  const c = r + i * (s - r);
  let l, u, g;
  switch (o) {
    default:
    case 6:
    case 0:
      l = s, u = c, g = r;
      break;
    case 1:
      l = c, u = s, g = r;
      break;
    case 2:
      l = r, u = s, g = c;
      break;
    case 3:
      l = r, u = c, g = s;
      break;
    case 4:
      l = c, u = r, g = s;
      break;
    case 5:
      l = s, u = r, g = c;
      break;
  }
  return [l * 255, u * 255, g * 255];
};
Ze.cmyk.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, n = e[2] / 100, a = e[3] / 100, i = 1 - Math.min(1, t * (1 - a) + a), o = 1 - Math.min(1, r * (1 - a) + a), s = 1 - Math.min(1, n * (1 - a) + a);
  return [i * 255, o * 255, s * 255];
};
Ze.xyz.rgb = function(e) {
  const t = e[0] / 100, r = e[1] / 100, n = e[2] / 100;
  let a, i, o;
  return a = t * 3.2406 + r * -1.5372 + n * -0.4986, i = t * -0.9689 + r * 1.8758 + n * 0.0415, o = t * 0.0557 + r * -0.204 + n * 1.057, a = a > 31308e-7 ? 1.055 * a ** (1 / 2.4) - 0.055 : a * 12.92, i = i > 31308e-7 ? 1.055 * i ** (1 / 2.4) - 0.055 : i * 12.92, o = o > 31308e-7 ? 1.055 * o ** (1 / 2.4) - 0.055 : o * 12.92, a = Math.min(Math.max(0, a), 1), i = Math.min(Math.max(0, i), 1), o = Math.min(Math.max(0, o), 1), [a * 255, i * 255, o * 255];
};
Ze.xyz.lab = function(e) {
  let t = e[0], r = e[1], n = e[2];
  t /= 95.047, r /= 100, n /= 108.883, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, r = r > 8856e-6 ? r ** (1 / 3) : 7.787 * r + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116;
  const a = 116 * r - 16, i = 500 * (t - r), o = 200 * (r - n);
  return [a, i, o];
};
Ze.lab.xyz = function(e) {
  const t = e[0], r = e[1], n = e[2];
  let a, i, o;
  i = (t + 16) / 116, a = r / 500 + i, o = i - n / 200;
  const s = i ** 3, c = a ** 3, l = o ** 3;
  return i = s > 8856e-6 ? s : (i - 16 / 116) / 7.787, a = c > 8856e-6 ? c : (a - 16 / 116) / 7.787, o = l > 8856e-6 ? l : (o - 16 / 116) / 7.787, a *= 95.047, i *= 100, o *= 108.883, [a, i, o];
};
Ze.lab.lch = function(e) {
  const t = e[0], r = e[1], n = e[2];
  let a;
  a = Math.atan2(n, r) * 360 / 2 / Math.PI, a < 0 && (a += 360);
  const o = Math.sqrt(r * r + n * n);
  return [t, o, a];
};
Ze.lch.lab = function(e) {
  const t = e[0], r = e[1], a = e[2] / 360 * 2 * Math.PI, i = r * Math.cos(a), o = r * Math.sin(a);
  return [t, i, o];
};
Ze.rgb.ansi16 = function(e, t = null) {
  const [r, n, a] = e;
  let i = t === null ? Ze.rgb.hsv(e)[2] : t;
  if (i = Math.round(i / 50), i === 0)
    return 30;
  let o = 30 + (Math.round(a / 255) << 2 | Math.round(n / 255) << 1 | Math.round(r / 255));
  return i === 2 && (o += 60), o;
};
Ze.hsv.ansi16 = function(e) {
  return Ze.rgb.ansi16(Ze.hsv.rgb(e), e[2]);
};
Ze.rgb.ansi256 = function(e) {
  const t = e[0], r = e[1], n = e[2];
  return t === r && r === n ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(r / 255 * 5) + Math.round(n / 255 * 5);
};
Ze.ansi16.rgb = function(e) {
  let t = e % 10;
  if (t === 0 || t === 7)
    return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
  const r = (~~(e > 50) + 1) * 0.5, n = (t & 1) * r * 255, a = (t >> 1 & 1) * r * 255, i = (t >> 2 & 1) * r * 255;
  return [n, a, i];
};
Ze.ansi256.rgb = function(e) {
  if (e >= 232) {
    const i = (e - 232) * 10 + 8;
    return [i, i, i];
  }
  e -= 16;
  let t;
  const r = Math.floor(e / 36) / 5 * 255, n = Math.floor((t = e % 36) / 6) / 5 * 255, a = t % 6 / 5 * 255;
  return [r, n, a];
};
Ze.rgb.hex = function(e) {
  const r = (((Math.round(e[0]) & 255) << 16) + ((Math.round(e[1]) & 255) << 8) + (Math.round(e[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(r.length) + r;
};
Ze.hex.rgb = function(e) {
  const t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!t)
    return [0, 0, 0];
  let r = t[0];
  t[0].length === 3 && (r = r.split("").map((s) => s + s).join(""));
  const n = parseInt(r, 16), a = n >> 16 & 255, i = n >> 8 & 255, o = n & 255;
  return [a, i, o];
};
Ze.rgb.hcg = function(e) {
  const t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, a = Math.max(Math.max(t, r), n), i = Math.min(Math.min(t, r), n), o = a - i;
  let s, c;
  return o < 1 ? s = i / (1 - o) : s = 0, o <= 0 ? c = 0 : a === t ? c = (r - n) / o % 6 : a === r ? c = 2 + (n - t) / o : c = 4 + (t - r) / o, c /= 6, c %= 1, [c * 360, o * 100, s * 100];
};
Ze.hsl.hcg = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = r < 0.5 ? 2 * t * r : 2 * t * (1 - r);
  let a = 0;
  return n < 1 && (a = (r - 0.5 * n) / (1 - n)), [e[0], n * 100, a * 100];
};
Ze.hsv.hcg = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = t * r;
  let a = 0;
  return n < 1 && (a = (r - n) / (1 - n)), [e[0], n * 100, a * 100];
};
Ze.hcg.rgb = function(e) {
  const t = e[0] / 360, r = e[1] / 100, n = e[2] / 100;
  if (r === 0)
    return [n * 255, n * 255, n * 255];
  const a = [0, 0, 0], i = t % 1 * 6, o = i % 1, s = 1 - o;
  let c = 0;
  switch (Math.floor(i)) {
    case 0:
      a[0] = 1, a[1] = o, a[2] = 0;
      break;
    case 1:
      a[0] = s, a[1] = 1, a[2] = 0;
      break;
    case 2:
      a[0] = 0, a[1] = 1, a[2] = o;
      break;
    case 3:
      a[0] = 0, a[1] = s, a[2] = 1;
      break;
    case 4:
      a[0] = o, a[1] = 0, a[2] = 1;
      break;
    default:
      a[0] = 1, a[1] = 0, a[2] = s;
  }
  return c = (1 - r) * n, [
    (r * a[0] + c) * 255,
    (r * a[1] + c) * 255,
    (r * a[2] + c) * 255
  ];
};
Ze.hcg.hsv = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = t + r * (1 - t);
  let a = 0;
  return n > 0 && (a = t / n), [e[0], a * 100, n * 100];
};
Ze.hcg.hsl = function(e) {
  const t = e[1] / 100, n = e[2] / 100 * (1 - t) + 0.5 * t;
  let a = 0;
  return n > 0 && n < 0.5 ? a = t / (2 * n) : n >= 0.5 && n < 1 && (a = t / (2 * (1 - n))), [e[0], a * 100, n * 100];
};
Ze.hcg.hwb = function(e) {
  const t = e[1] / 100, r = e[2] / 100, n = t + r * (1 - t);
  return [e[0], (n - t) * 100, (1 - n) * 100];
};
Ze.hwb.hcg = function(e) {
  const t = e[1] / 100, n = 1 - e[2] / 100, a = n - t;
  let i = 0;
  return a < 1 && (i = (n - a) / (1 - a)), [e[0], a * 100, i * 100];
};
Ze.apple.rgb = function(e) {
  return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
};
Ze.rgb.apple = function(e) {
  return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
};
Ze.gray.rgb = function(e) {
  return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
};
Ze.gray.hsl = function(e) {
  return [0, 0, e[0]];
};
Ze.gray.hsv = Ze.gray.hsl;
Ze.gray.hwb = function(e) {
  return [0, 100, e[0]];
};
Ze.gray.cmyk = function(e) {
  return [0, 0, 0, e[0]];
};
Ze.gray.lab = function(e) {
  return [e[0], 0, 0];
};
Ze.gray.hex = function(e) {
  const t = Math.round(e[0] / 100 * 255) & 255, n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
  return "000000".substring(n.length) + n;
};
Ze.rgb.gray = function(e) {
  return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
};
const S1 = UG;
function fle() {
  const e = {}, t = Object.keys(S1);
  for (let r = t.length, n = 0; n < r; n++)
    e[t[n]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  return e;
}
function mle(e) {
  const t = fle(), r = [e];
  for (t[e].distance = 0; r.length; ) {
    const n = r.pop(), a = Object.keys(S1[n]);
    for (let i = a.length, o = 0; o < i; o++) {
      const s = a[o], c = t[s];
      c.distance === -1 && (c.distance = t[n].distance + 1, c.parent = n, r.unshift(s));
    }
  }
  return t;
}
function vle(e, t) {
  return function(r) {
    return t(e(r));
  };
}
function Sle(e, t) {
  const r = [t[e].parent, e];
  let n = S1[t[e].parent][e], a = t[e].parent;
  for (; t[a].parent; )
    r.unshift(t[a].parent), n = vle(S1[t[a].parent][a], n), a = t[a].parent;
  return n.conversion = r, n;
}
var Ile = function(e) {
  const t = mle(e), r = {}, n = Object.keys(t);
  for (let a = n.length, i = 0; i < a; i++) {
    const o = n[i];
    t[o].parent !== null && (r[o] = Sle(o, t));
  }
  return r;
};
const $k = UG, Cle = Ile, Bh = {}, ble = Object.keys($k);
function yle(e) {
  const t = function(...r) {
    const n = r[0];
    return n == null ? n : (n.length > 1 && (r = n), e(r));
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
function wle(e) {
  const t = function(...r) {
    const n = r[0];
    if (n == null)
      return n;
    n.length > 1 && (r = n);
    const a = e(r);
    if (typeof a == "object")
      for (let i = a.length, o = 0; o < i; o++)
        a[o] = Math.round(a[o]);
    return a;
  };
  return "conversion" in e && (t.conversion = e.conversion), t;
}
ble.forEach((e) => {
  Bh[e] = {}, Object.defineProperty(Bh[e], "channels", { value: $k[e].channels }), Object.defineProperty(Bh[e], "labels", { value: $k[e].labels });
  const t = Cle(e);
  Object.keys(t).forEach((n) => {
    const a = t[n];
    Bh[e][n] = wle(a), Bh[e][n].raw = yle(a);
  });
});
var Dc = Bh;
const kG = (e) => {
  const [t, r, n, a] = e;
  return a ? `hsla(${Math.round(t)},${Math.round(r)}%,${Math.round(n)}%,${a})` : `hsl(${Math.round(t)},${Math.round(r)}%,${Math.round(n)}%)`;
}, KA = (e, t) => {
  const [r, n, a] = Dc.hex.hsl(e), i = n * t;
  return Dc.hsl.hex([r, Math.max(n - i, 0), a]);
}, XJe = (e, t) => {
  const [r, n, a] = Dc.hex.hsl(e), i = (100 - n) * t;
  return Dc.hsl.hex([r, Math.max(n + i, 0), a]);
}, _0 = (e, t) => {
  const [r, n, a] = Dc.hex.hsl(e), i = (100 - a) * t;
  return kG([r, n, Math.max(a + i, 0)]);
}, XA = (e, t) => {
  const [r, n, a] = Dc.hex.hsl(e), i = a * t;
  return kG([r, n, Math.max(a - i, 0)]);
}, zA = (e) => e <= 0.3928 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4, _5 = ([e, t, r]) => 0.2126 * zA(e) + 0.7152 * zA(t) + 0.0722 * zA(r), Ale = (e, t) => {
  const r = _5(Dc.hex.rgb(e)), n = _5(Dc.hex.rgb(t));
  return r > n ? (r + 0.05) / (n + 0.05) : (n + 0.05) / (r + 0.05);
}, Ule = (e, t = !1) => {
  const r = Ale(e.primary, e.font);
  return {
    AA: t ? r >= 3 : r >= 4.5,
    AAA: t ? r >= 4.5 : r >= 7
  };
};
var kle = Object.defineProperty, _le = (e, t, r, n) => {
  for (var a = void 0, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = o(t, r, a) || a);
  return a && kle(t, r, a), a;
};
const BT = class BT extends ro {
  constructor() {
    super(...arguments), this.colorScheme = Un.Light;
  }
};
BT.styles = [dle, ule, hle, lle];
let N = BT;
_le([
  td({ context: zW, subscribe: !0 }),
  M({ attribute: "data-color-scheme", reflect: !0 })
], N.prototype, "colorScheme");
const Y2 = Symbol("language-direction-context"), I1 = ee`
  /* iPad with a single tab, with multiple tabs, with bookmarks bar */
  /* iPhone 14 - with multiple tabs opened and with single tab opened: 307, 340 */
  /* iPhone 14 plus - with multiple tabs opened and with single tab opened: 345, 378 */
  /* iPhone 14 pro - with multiple tabs opened and with single tab opened: 310, 343 */
  /* iPhone 14 pro max - with multiple tabs opened and with single tab opened: 347, 380 */
  @media screen and (height: 690px),
    screen and (height: 713px),
    screen and (height: 723px),
    screen and (height: 746px),
    screen and (height: 1050px),
    screen and (height: 1073px),
    screen and (height: 1083px),
    screen and (height: 1106px),
    screen and (height: 307px),
    screen and (height: 340px),
    screen and (height: 345px),
    screen and (height: 378px),
    screen and (height: 310px),
    screen and (height: 343px),
    screen and (height: 347px),
    screen and (height: 380px) {
    .footer {
      padding-bottom: 1.3125em; /* 21 / 16 */
    }
  }
`;
var Nle = Object.defineProperty, Zle = Object.getOwnPropertyDescriptor, _G = (e) => {
  throw TypeError(e);
}, qW = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Zle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Nle(t, r, a), a;
}, Ble = (e, t, r) => t.has(e) || _G("Cannot " + r), Wle = (e, t, r) => t.has(e) ? _G("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Ele = (e, t, r) => (Ble(e, t, "access private method"), r), Kk, NG;
let pm = class extends N {
  constructor() {
    super(...arguments), Wle(this, Kk), this.languageDirection = "ltr", this.footerVisible = !0;
  }
  render() {
    return w`
      <div class="container" data-qa-id="container">
        <div class="background" data-qa-id="background">
          <slot name="background"></slot>
        </div>
        <div class="header">
          <div class="header__left" data-qa-id="top-left">
            <slot name="top-left"></slot>
          </div>
          <div class="header__middle" data-qa-id="top-middle">
            <slot name="top-middle"></slot>
          </div>
          <div class="header__right" data-qa-id="top-right">
            <slot name="top-right"></slot>
          </div>
        </div>
        <div class="main" data-qa-id="main">
          <slot name="main"></slot>
        </div>
        ${Ele(this, Kk, NG).call(this)}
        <slot name="overlay" data-qa-id="overlay"></slot>
      </div>
    `;
  }
};
Kk = /* @__PURE__ */ new WeakSet();
NG = function() {
  return this.footerVisible ? w`
          <div class="footer">
            <div class="footer__left" data-qa-id="bottom-left">
              <slot name="bottom-left"></slot>
            </div>
            <div class="footer__middle" data-qa-id="bottom-middle">
              <slot name="bottom-middle"></slot>
            </div>
            <div class="footer__right" data-qa-id="bottom-right">
              <slot name="bottom-right"></slot>
            </div>
          </div>
        ` : q;
};
pm.styles = [
  ...N.styles,
  I1,
  ee`
      :host {
        display: contents;
      }

      .container {
        display: flex;
        position: relative;
        box-sizing: border-box;
        padding: 0 1em;
        flex-grow: 1;
        flex-direction: column;
        height: 100%;
        max-height: 100dvh;
      }

      .background {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .header,
      .footer {
        display: flex;
        position: relative;
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 3.5em; /* 56 / 16 */
      }

      .header {
        height: unset;
        min-height: 3.5em;
        max-height: 5em;
      }

      ${Gt(I1)}

      .main {
        display: flex;
        position: relative;
        flex-grow: 1;
        flex-direction: column;
        height: calc(100% - 7em);
        overflow-y: auto;
        margin: 0 -1em;
        padding: 0 1em;
      }

      .overlay {
        position: relative;
        flex-grow: 1;
      }

      .header__left,
      .header__right,
      .header__middle,
      .footer__middle,
      .footer__left,
      .footer__right {
        position: relative;
        flex: 1 1 33.33%;
      }

      .header__middle,
      .footer__middle {
        flex-shrink: 0;
        flex-basis: auto;
      }

      .header > .header__right,
      .footer > .footer__right {
        text-align: right;
      }

      .header__left,
      .header__middle,
      .header__right,
      .footer__left,
      .footer__middle,
      .footer__right {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      :host([data-language-direction='rtl']) {
        direction: rtl;
      }

      :host([data-language-direction='rtl']) .header,
      :host([data-language-direction='rtl']) .footer {
        direction: ltr;
      }

      slot[name='overlay']::slotted(.overlay) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
    `
];
qW([
  td({ context: Y2, subscribe: !0 }),
  M({ attribute: "data-language-direction", reflect: !0 })
], pm.prototype, "languageDirection", 2);
qW([
  M({
    attribute: "data-footer-visible",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => e.toString()
    }
  })
], pm.prototype, "footerVisible", 2);
pm = qW([
  be(),
  P("x-ds-generic-app-container")
], pm);
var Qle = Object.defineProperty, Fle = Object.getOwnPropertyDescriptor, ZG = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Fle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Qle(t, r, a), a;
};
let C1 = class extends N {
  constructor() {
    super(...arguments), this.languageDirection = "ltr";
  }
  render() {
    return w`
      <div class="container" data-qa-id="container">
        <div class="background" data-qa-id="background">
          <slot name="background"></slot>
        </div>
        <div class="header">
          <div class="header__left" data-qa-id="top-left">
            <slot name="top-left"></slot>
          </div>
          <div class="header__middle" data-qa-id="top-middle">
            <slot name="top-middle"></slot>
          </div>
          <div class="header__right" data-qa-id="top-right">
            <slot name="top-right"></slot>
          </div>
        </div>
        <div class="main" data-qa-id="main">
          <slot name="main"></slot>
        </div>
        <div class="footer">
          <div class="footer__left" data-qa-id="bottom-left">
            <slot name="bottom-left"></slot>
          </div>
          <div class="footer__right" data-qa-id="camera-selector-container">
            <slot name="camera-selector"></slot>
          </div>
        </div>
        <div class="capture-button-container" data-qa-id="capture-button-container">
          <slot name="capture-button"></slot>
        </div>
        <slot name="overlay" data-qa-id="overlay"></slot>
      </div>
    `;
  }
};
C1.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .container {
        display: flex;
        position: relative;
        box-sizing: border-box;
        padding: 0 1em;
        flex-grow: 1;
        flex-direction: column;
        height: 100%;
        max-height: 100dvh;
      }

      .background {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .header,
      .footer {
        display: flex;
        position: relative;
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 3.5em; /* 56 / 16 */
      }

      .header {
        height: unset;
        min-height: 3.5em;
        max-height: 5em;
      }

      .footer {
        padding-bottom: 0.5em; /* 8 / 16 */
      }

      ${Gt(I1)}

      .main {
        display: flex;
        position: relative;
        flex-grow: 1;
        flex-direction: column;
        height: calc(100% - 7em);
        overflow-y: auto;
        margin: 0 -1em;
        padding: 0 1em;
      }

      .capture-button-container {
        position: absolute;
        width: 4.5em;
        height: 4.5em;
        margin-top: -2.25em;
        right: 1em;
        top: 50%;
      }

      .overlay {
        position: relative;
        flex-grow: 1;
      }

      .header__left,
      .header__right,
      .header__middle,
      .footer__middle,
      .footer__left,
      .footer__right {
        position: relative;
        flex: 1 1 33.33%;
      }

      .header__middle,
      .footer__middle {
        flex-shrink: 0;
        flex-basis: auto;
      }

      .header__left,
      .footer__left {
        display: flex;
        flex-direction: row;
        align-self: stretch;
        justify-content: flex-start;
        align-items: center;
      }

      .header__right,
      .footer__right {
        display: flex;
        flex-direction: row;
        align-self: stretch;
        justify-content: flex-end;
        align-items: center;
      }

      .header__left,
      .footer__left,
      .header__right,
      .footer__right {
        column-gap: 0.25em;
      }

      .header__middle {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      :host([data-language-direction='rtl']) {
        direction: rtl;
      }

      :host([data-language-direction='rtl']) .header,
      :host([data-language-direction='rtl']) .footer {
        direction: ltr;
      }

      slot[name='overlay']::slotted(.overlay) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
    `
];
ZG([
  td({ context: Y2, subscribe: !0 }),
  M({ attribute: "data-language-direction", reflect: !0 })
], C1.prototype, "languageDirection", 2);
C1 = ZG([
  be(),
  P("x-ds-capture-screen-app-container-small")
], C1);
var Tle = Object.defineProperty, Rle = Object.getOwnPropertyDescriptor, BG = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Rle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Tle(t, r, a), a;
};
let b1 = class extends N {
  constructor() {
    super(...arguments), this.languageDirection = "ltr";
  }
  render() {
    return w`
      <div class="container" data-qa-id="container">
        <div class="background" data-qa-id="background">
          <slot name="background"></slot>
        </div>
        <div class="header">
          <div class="header__left" data-qa-id="top-left">
            <slot name="top-left"></slot>
          </div>
          <div class="header__middle" data-qa-id="top-middle">
            <slot name="top-middle"></slot>
          </div>
          <div class="header__right" data-qa-id="top-right">
            <slot name="top-right"></slot>
          </div>
        </div>
        <div class="main" data-qa-id="main">
          <slot name="main"></slot>
        </div>
        <div class="footer">
          <div class="footer__left" data-qa-id="bottom-left">
            <slot name="bottom-left"></slot>
          </div>
          <div class="footer__middle" data-qa-id="capture-button-container">
            <slot name="capture-button"></slot>
          </div>
          <div class="footer__right" data-qa-id="camera-selector-container">
            <slot name="camera-selector"></slot>
          </div>
        </div>
        <slot name="overlay" data-qa-id="overlay"></slot>
      </div>
    `;
  }
};
b1.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .container {
        display: flex;
        position: relative;
        box-sizing: border-box;
        padding: 0 1em;
        flex-grow: 1;
        flex-direction: column;
        height: 100%;
        max-height: 100dvh;
      }

      .background {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .header,
      .footer {
        display: flex;
        position: relative;
        width: 100%;
        flex-flow: row wrap;
        align-items: center;
        justify-content: space-between;
      }

      .header {
        min-height: 3.5em; /* 56 / 16 */
        max-height: 5em;
      }

      .footer {
        height: 4.5em; /* 72 / 16 */
        padding-bottom: 0.5em; /* 8 / 16 */
      }

      ${Gt(I1)}

      .main {
        display: flex;
        position: relative;
        flex-grow: 1;
        flex-direction: column;
        height: calc(100% - 7em);
        overflow-y: auto;
        margin: 0 -1em;
        padding: 0 1em;
      }

      .overlay {
        position: relative;
        flex-grow: 1;
      }

      .header__left,
      .header__right,
      .header__middle,
      .footer__middle,
      .footer__left,
      .footer__right {
        position: relative;
        flex: 1 1 33.33%;
      }

      .header__middle,
      .footer__middle {
        flex-shrink: 0;
        flex-basis: auto;
      }

      .header__left,
      .footer__left {
        display: flex;
        flex-direction: row;
        align-self: stretch;
        justify-content: flex-start;
        align-items: center;
      }

      .header__right,
      .footer__right {
        display: flex;
        flex-direction: row;
        align-self: stretch;
        justify-content: flex-end;
        align-items: center;
      }

      .header__middle,
      .footer__middle {
        display: flex;
        flex-direction: row;
        align-self: stretch;
        justify-content: center;
        align-items: center;
      }

      .header__left,
      .footer__left,
      .header__right,
      .footer__right {
        column-gap: 0.25em;
      }

      :host([data-language-direction='rtl']) {
        direction: rtl;
      }

      :host([data-language-direction='rtl']) .header,
      :host([data-language-direction='rtl']) .footer {
        direction: ltr;
      }

      slot[name='overlay']::slotted(.overlay) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
    `
];
BG([
  td({ context: Y2, subscribe: !0 }),
  M({ attribute: "data-language-direction", reflect: !0 })
], b1.prototype, "languageDirection", 2);
b1 = BG([
  be(),
  P("x-ds-capture-screen-app-container-large")
], b1);
var Dle = Object.defineProperty, Jle = Object.getOwnPropertyDescriptor, WG = (e) => {
  throw TypeError(e);
}, eE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Jle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Dle(t, r, a), a;
}, EG = (e, t, r) => t.has(e) || WG("Cannot " + r), qA = (e, t, r) => (EG(e, t, "read from private field"), r ? r.call(e) : t.get(e)), eU = (e, t, r) => t.has(e) ? WG("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), jh = (e, t, r) => (EG(e, t, "access private method"), r), SC, Xk, Kl, QG, FG, TG, RG, DG, JG;
const Vle = (e) => Object.values(An).includes(e);
let gm = class extends N {
  constructor() {
    super(), eU(this, Kl), this.type = An.Generic, this.footerVisible = !0, eU(this, SC, new Kt(this.type)), eU(this, Xk, jh(this, Kl, DG).call(this)), this.layout$ = jh(this, Kl, JG).call(this, qA(this, SC), qA(this, Xk)), this.layoutController = new ue(this, this.layout$);
  }
  update(e) {
    super.update(e), e.has("type") && qA(this, SC).next(this.type || void 0);
  }
  render() {
    const e = this.layoutController.value;
    switch (e == null ? void 0 : e.type) {
      case An.CaptureScreen:
        return jh(this, Kl, QG).call(this, e);
      case An.Generic:
      default:
        return jh(this, Kl, RG).call(this);
    }
  }
};
SC = /* @__PURE__ */ new WeakMap();
Xk = /* @__PURE__ */ new WeakMap();
Kl = /* @__PURE__ */ new WeakSet();
QG = function(e) {
  return e.variant === Bu.Small ? jh(this, Kl, FG).call(this) : jh(this, Kl, TG).call(this);
};
FG = function() {
  return w`
      <x-ds-capture-screen-app-container-small>
        <slot name="background" slot="background"></slot>
        <slot name="top-left" slot="top-left"></slot>
        <slot name="top-middle" slot="top-middle">
          <x-ds-watermark data-version="0.2.14-b10b1242.2"></x-ds-watermark>
        </slot>
        <slot name="top-right" slot="top-right"></slot>
        <slot name="main" slot="main"></slot>
        <slot name="bottom-left" slot="bottom-left"></slot>
        <slot name="capture-button" slot="capture-button"></slot>
        <slot name="camera-selector" slot="camera-selector"></slot>
        <slot name="overlay" slot="overlay"></slot>
      </x-ds-capture-screen-app-container-small>
    `;
};
TG = function() {
  return w`
      <x-ds-capture-screen-app-container-large>
        <slot name="background" slot="background"></slot>
        <slot name="top-left" slot="top-left"></slot>
        <slot name="top-middle" slot="top-middle">
          <x-ds-watermark data-version="0.2.14-b10b1242.2"></x-ds-watermark>
        </slot>
        <slot name="top-right" slot="top-right"></slot>
        <slot name="main" slot="main"></slot>
        <slot name="bottom-left" slot="bottom-left"></slot>
        <slot name="capture-button" slot="capture-button"></slot>
        <slot name="camera-selector" slot="camera-selector"></slot>
        <slot name="overlay" slot="overlay"></slot>
      </x-ds-capture-screen-app-container-large>
    `;
};
RG = function() {
  return w`
      <x-ds-generic-app-container data-footer-visible="${this.footerVisible}">
        <slot name="background" slot="background"></slot>
        <slot name="top-left" slot="top-left"></slot>
        <slot name="top-middle" slot="top-middle"></slot>
        <slot name="top-right" slot="top-right"></slot>
        <slot name="main" slot="main"></slot>
        <slot name="bottom-left" slot="bottom-left"></slot>
        <slot name="bottom-middle" slot="bottom-middle">
          <x-ds-watermark data-version="0.2.14-b10b1242.2"></x-ds-watermark>
        </slot>
        <slot name="bottom-right" slot="bottom-right"></slot>
        <slot name="overlay" slot="overlay"></slot>
      </x-ds-generic-app-container>
    `;
};
DG = function() {
  return new Ht((e) => {
    const t = window.matchMedia("(max-height: 380px)"), r = (n) => {
      e.next(n.matches);
    };
    return t.addEventListener("change", r), e.next(t.matches), () => {
      t.removeEventListener("change", r);
    };
  });
};
JG = function(e, t) {
  return e.pipe(
    $a(t),
    te(([r, n]) => {
      let a;
      switch (r) {
        case An.CaptureScreen:
          a = {
            type: An.CaptureScreen,
            variant: n ? Bu.Small : Bu.Large
          };
          break;
        case An.Generic:
        default:
          a = {
            type: An.Generic
          };
          break;
      }
      return a;
    })
  );
};
gm.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
eE([
  M({
    attribute: "data-type",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => Vle(e) ? e : An.Generic,
      toAttribute: (e) => e.toString()
    }
  })
], gm.prototype, "type", 2);
eE([
  M({
    attribute: "data-footer-visible",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => e.toString()
    }
  })
], gm.prototype, "footerVisible", 2);
gm = eE([
  be(),
  P("x-ds-app-container")
], gm);
var Mle = Object.defineProperty, Gle = Object.getOwnPropertyDescriptor, VG = (e) => {
  throw TypeError(e);
}, tE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Gle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Mle(t, r, a), a;
}, xle = (e, t, r) => t.has(e) || VG("Cannot " + r), Hle = (e, t, r) => t.has(e) ? VG("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Lle = (e, t, r) => (xle(e, t, "access private method"), r), zk, MG;
let fm = class extends N {
  constructor() {
    super(...arguments), Hle(this, zk), this.clickToClose = !1, this.hidden = !1;
  }
  render() {
    return w`
      <div
        data-qa-id="backdrop"
        class="backdrop"
        @click="${() => {
      Lle(this, zk, MG).call(this);
    }}"
      >
        <slot></slot>
      </div>
    `;
  }
};
zk = /* @__PURE__ */ new WeakSet();
MG = function() {
  this.clickToClose && (this.hidden = !0, this.requestUpdate());
};
fm.styles = [
  ...N.styles,
  ee`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
      :host([hidden]:not([hidden='false'])) {
        display: none;
      }

      .backdrop {
        background-color: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 100%;
        animation: 0.2s opacity-show ease-in-out;
      }

      @keyframes opacity-show {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `
];
tE([
  M({
    attribute: "data-click-to-close",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], fm.prototype, "clickToClose", 2);
tE([
  M({
    attribute: "hidden",
    type: Boolean,
    reflect: !0,
    converter: {
      fromAttribute: (e) => `${e}` == "true",
      toAttribute: (e) => `${e}`
    }
  })
], fm.prototype, "hidden", 2);
fm = tE([
  P("x-ds-backdrop")
], fm);
class Yle extends CustomEvent {
  constructor(t) {
    super("jclick", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var _a = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e.ExtraLarge = "extra-large", e))(_a || {}), ya = /* @__PURE__ */ ((e) => (e.Default = "default", e.Round = "round", e))(ya || {}), De = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e.Quiet = "quiet", e.QuietIcon = "quiet-icon", e.Destructive = "destructive", e))(De || {});
const O2 = (e) => Object.values(De).includes(e), rE = (e) => Object.values(_a).includes(e), GG = (e) => Object.values(ya).includes(e);
var Ole = Object.defineProperty, jle = Object.getOwnPropertyDescriptor, rh = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? jle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ole(t, r, a), a;
};
let pl = class extends N {
  constructor() {
    super(...arguments), this.fluid = !1, this.type = De.Primary, this.size = _a.Medium, this.shape = ya.Default, this.padding = !0, this.disabled = !1;
  }
  render() {
    return w`
      <div
        class="button"
        @click="${(e) => {
      this.handleClickEvent(e);
    }}"
        data-qa-id="button"
      >
        <slot></slot>
      </div>
    `;
  }
  handleClickEvent(e) {
    this.disabled || this.dispatchEvent(new Yle(e));
  }
};
pl.styles = [
  ...N.styles,
  ee`
      :host {
        display: inline-block;
        width: fit-content;
      }

      :host([data-fluid='true']) {
        width: 100%;
      }

      :host([data-disabled='true']) {
        pointer-events: none;
        cursor: default;
      }

      :host(:focus) .button,
      :host(:hover) .button,
      :host(:active) .button {
        box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, 0.1);
      }

      :host([data-disabled='true']:focus) .button,
      :host([data-disabled='true']:hover) .button,
      :host([data-disabled='true']:active) .button {
        box-shadow: none;
      }

      .button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        box-sizing: border-box;
        border: 0.0625em solid transparent;
        border-radius: 1.75em; /* 28 / 16 */
        line-height: 1.25em; /* 20 / 16 */
        cursor: pointer;
        font-style: normal;
        letter-spacing: 0.01em;
        text-align: center;
        transition-property: background-color, color, box-shadow;
        transition-duration: 250ms;
      }

      :host([data-shape='round']) .button {
        aspect-ratio: 1 / 1;
        border-radius: 50%;
      }

      :host([data-shape='round'][data-size='small']) .button {
        min-width: 2.625em;
      }

      :host([data-shape='round'][data-size='medium']) .button {
        min-width: 3.125em;
      }

      :host([data-shape='round'][data-size='large']) .button {
        min-width: 3.625em;
      }

      :host([data-shape='round'][data-size='extra-large']) .button {
        min-width: 4.625em;
      }

      :host([data-size='small'][data-padding='true']) .button {
        padding: 0.625em 1em; /* 10 / 16 */
      }

      :host([data-size='medium'][data-padding='true']) .button {
        padding: 0.875em 1em; /* 14 / 16 */
      }

      :host([data-size='large'][data-padding='true']) .button {
        padding: 1.125em 1em; /* 18 / 16 */
      }

      :host([data-size='extra-large'][data-padding='true']) .button {
        padding: 1.625em 1em; /* 26 / 16 */
      }

      :host([data-size='small'][data-type='quiet-icon'][data-padding='true']) .button {
        padding: 0.625em; /* 10 / 16 */
      }

      :host([data-size='medium'][data-type='quiet-icon'][data-padding='true']) .button {
        padding: 0.875em; /* 14 / 16 */
      }

      :host([data-size='large'][data-type='quiet-icon'][data-padding='true']) .button {
        padding: 1.125em; /* 18 / 16 */
      }

      :host([data-size='extra-large'][data-type='quiet-icon'][data-padding='true']) .button {
        padding: 1.625em; /* 26 / 16 */
      }

      /* Primary */
      :host([data-color-scheme='light'][data-type='primary']) .button {
        color: var(--theme-light-button-primary-default-color);
        background-color: var(--theme-light-button-primary-default-bg-color);
      }

      :host([data-color-scheme='light'][data-type='primary']:focus) .button,
      :host([data-color-scheme='light'][data-type='primary']:hover) .button {
        color: var(--theme-light-button-primary-focus-color);
        background-color: var(--theme-light-button-primary-focus-bg-color);
      }

      :host([data-color-scheme='light'][data-type='primary']:active) .button {
        color: var(--theme-light-button-primary-active-color);
        background-color: var(--theme-light-button-primary-active-bg-color);
      }

      :host([data-color-scheme='light'][data-type='primary'][data-disabled='true']) .button {
        color: var(--theme-light-button-primary-disabled-color);
        background-color: var(--theme-light-button-primary-disabled-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='primary']) .button {
        color: var(--theme-dark-button-primary-default-color);
        background-color: var(--theme-dark-button-primary-default-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='primary']:focus) .button,
      :host([data-color-scheme='dark'][data-type='primary']:hover) .button {
        color: var(--theme-dark-button-primary-focus-color);
        background-color: var(--theme-dark-button-primary-focus-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='primary']:active) .button {
        color: var(--theme-dark-button-primary-active-color);
        background-color: var(--theme-dark-button-primary-active-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='primary'][data-disabled='true']) .button {
        color: var(--theme-dark-button-primary-disabled-color);
        background-color: var(--theme-dark-button-primary-disabled-bg-color);
      }

      /* Secondary */
      :host([data-color-scheme='light'][data-type='secondary']) .button {
        color: var(--theme-light-button-secondary-default-color);
        background-color: var(--theme-light-button-secondary-default-bg-color);
        border-color: var(--theme-light-button-secondary-default-border-color);
      }

      :host([data-color-scheme='light'][data-type='secondary']:focus) .button,
      :host([data-color-scheme='light'][data-type='secondary']:hover) .button {
        color: var(--theme-light-button-secondary-focus-color);
        background-color: var(--theme-light-button-secondary-focus-bg-color);
        border-color: var(--theme-light-button-secondary-focus-border-color);
      }

      :host([data-color-scheme='light'][data-type='secondary']:active) .button {
        color: var(--theme-light-button-secondary-active-color);
        background-color: var(--theme-light-button-secondary-active-bg-color);
        border-color: var(--theme-light-button-secondary-active-border-color);
      }

      :host([data-color-scheme='light'][data-type='secondary'][data-disabled='true']) .button {
        color: var(--theme-light-button-secondary-disabled-color);
        background-color: var(--theme-light-button-secondary-disabled-bg-color);
        border-color: var(--theme-light-button-secondary-disabled-border-color);
      }

      :host([data-color-scheme='dark'][data-type='secondary']) .button {
        color: var(--theme-dark-button-secondary-default-color);
        background-color: var(--theme-dark-button-secondary-default-bg-color);
        border-color: var(--theme-dark-button-secondary-default-border-color);
      }

      :host([data-color-scheme='dark'][data-type='secondary']:focus) .button,
      :host([data-color-scheme='dark'][data-type='secondary']:hover) .button {
        color: var(--theme-dark-button-secondary-focus-color);
        background-color: var(--theme-dark-button-secondary-focus-bg-color);
        border-color: var(--theme-dark-button-secondary-focus-border-color);
      }

      :host([data-color-scheme='dark'][data-type='secondary']:active) .button {
        color: var(--theme-dark-button-secondary-active-color);
        background-color: var(--theme-dark-button-secondary-active-bg-color);
        border-color: var(--theme-dark-button-secondary-active-border-color);
      }

      :host([data-color-scheme='dark'][data-type='secondary'][data-disabled='true']) .button {
        color: var(--theme-dark-button-secondary-disabled-color);
        background-color: var(--theme-dark-button-secondary-disabled-bg-color);
        border-color: var(--theme-dark-button-secondary-disabled-border-color);
      }

      /* Tertiary */
      :host([data-color-scheme='light'][data-type='tertiary']) .button {
        color: var(--theme-light-button-tertiary-default-color);
        background-color: var(--theme-light-button-tertiary-default-bg-color);
      }

      :host([data-color-scheme='light'][data-type='tertiary']:focus) .button,
      :host([data-color-scheme='light'][data-type='tertiary']:hover) .button {
        color: var(--theme-light-button-tertiary-focus-color);
        background-color: var(--theme-light-button-tertiary-focus-bg-color);
      }

      :host([data-color-scheme='light'][data-type='tertiary']:active) .button {
        color: var(--theme-light-button-tertiary-active-color);
        background-color: var(--theme-light-button-tertiary-active-bg-color);
      }

      :host([data-color-scheme='light'][data-type='tertiary'][data-disabled='true']) .button {
        color: var(--theme-light-button-tertiary-disabled-color);
        background-color: var(--theme-light-button-tertiary-disabled-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='tertiary']) .button {
        color: var(--theme-dark-button-tertiary-default-color);
        background-color: var(--theme-dark-button-tertiary-default-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='tertiary']:focus) .button,
      :host([data-color-scheme='dark'][data-type='tertiary']:hover) .button {
        color: var(--theme-dark-button-tertiary-focus-color);
        background-color: var(--theme-dark-button-tertiary-focus-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='tertiary']:active) .button {
        color: var(--theme-dark-button-tertiary-active-color);
        background-color: var(--theme-dark-button-tertiary-active-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='tertiary'][data-disabled='true']) .button {
        color: var(--theme-dark-button-tertiary-disabled-color);
        background-color: var(--theme-dark-button-tertiary-disabled-bg-color);
      }

      /* Quiet */
      :host([data-color-scheme='light'][data-type='quiet']) .button {
        color: var(--theme-light-button-quiet-default-color);
        background-color: var(--theme-light-button-quiet-default-bg-color);
      }

      :host([data-color-scheme='light'][data-type='quiet']:focus) .button,
      :host([data-color-scheme='light'][data-type='quiet']:hover) .button {
        color: var(--theme-light-button-quiet-focus-color);
        background-color: var(--theme-light-button-quiet-focus-bg-color);
      }

      :host([data-color-scheme='light'][data-type='quiet']:active) .button {
        color: var(--theme-light-button-quiet-active-color);
        background-color: var(--theme-light-button-quiet-active-bg-color);
      }

      :host([data-color-scheme='light'][data-type='quiet'][data-disabled='true']) .button {
        color: var(--theme-light-button-quiet-disabled-color);
        background-color: var(--theme-light-button-quiet-disabled-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet']) .button {
        color: var(--theme-dark-button-quiet-default-color);
        background-color: var(--theme-dark-button-quiet-default-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet']:focus) .button,
      :host([data-color-scheme='dark'][data-type='quiet']:hover) .button {
        color: var(--theme-dark-button-quiet-focus-color);
        background-color: var(--theme-dark-button-quiet-focus-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet']:active) .button {
        color: var(--theme-dark-button-quiet-active-color);
        background-color: var(--theme-dark-button-quiet-active-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet'][data-disabled='true']) .button {
        color: var(--theme-dark-button-quiet-disabled-color);
        background-color: var(--theme-dark-button-quiet-disabled-bg-color);
      }

      /* Quiet - Icon */
      :host([data-color-scheme='light'][data-type='quiet-icon']) .button {
        color: var(--theme-light-button-quiet-default-color);
        background-color: var(--theme-light-button-quiet-default-bg-color);
      }

      :host([data-color-scheme='light'][data-type='quiet-icon']:focus) .button,
      :host([data-color-scheme='light'][data-type='quiet-icon']:hover) .button {
        color: var(--theme-light-button-quiet-focus-color);
        background-color: var(--theme-light-button-quiet-focus-bg-color);
      }

      :host([data-color-scheme='light'][data-type='quiet-icon']:active) .button {
        color: var(--theme-light-button-quiet-active-color);
        background-color: var(--theme-light-button-quiet-active-bg-color);
      }

      :host([data-color-scheme='light'][data-type='quiet-icon'][data-disabled='true']) .button {
        color: var(--theme-light-button-quiet-disabled-color);
        background-color: var(--theme-light-button-quiet-disabled-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet-icon']) .button {
        color: var(--theme-dark-button-quiet-default-color);
        background-color: var(--theme-dark-button-quiet-default-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet-icon']:focus) .button,
      :host([data-color-scheme='dark'][data-type='quiet-icon']:hover) .button {
        color: var(--theme-dark-button-quiet-focus-color);
        background-color: var(--theme-dark-button-quiet-focus-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet-icon']:active) .button {
        color: var(--theme-dark-button-quiet-active-color);
        background-color: var(--theme-dark-button-quiet-active-bg-color);
      }

      :host([data-color-scheme='dark'][data-type='quiet-icon'][data-disabled='true']) .button {
        color: var(--theme-dark-button-quiet-disabled-color);
        background-color: var(--theme-dark-button-quiet-disabled-bg-color);
      }

      /* Destructive */
      :host([data-color-scheme='light'][data-type='destructive']) .button {
        color: var(--theme-light-button-destructive-default-color);
        background-color: var(--theme-light-button-destructive-default-bg-color);
        border-color: var(--theme-light-button-destructive-default-border-color);
      }

      :host([data-color-scheme='light'][data-type='destructive']:focus) .button,
      :host([data-color-scheme='light'][data-type='destructive']:hover) .button {
        color: var(--theme-light-button-destructive-focus-color);
        background-color: var(--theme-light-button-destructive-focus-bg-color);
        border-color: var(--theme-light-button-destructive-focus-border-color);
      }

      :host([data-color-scheme='light'][data-type='destructive']:active) .button {
        color: var(--theme-light-button-destructive-active-color);
        background-color: var(--theme-light-button-destructive-active-bg-color);
        border-color: var(--theme-light-button-destructive-active-border-color);
      }

      :host([data-color-scheme='light'][data-type='destructive'][data-disabled='true']) .button {
        color: var(--theme-light-button-destructive-disabled-color);
        background-color: var(--theme-light-button-destructive-disabled-bg-color);
        border-color: var(--theme-light-button-destructive-disabled-border-color);
      }

      :host([data-color-scheme='dark'][data-type='destructive']) .button {
        color: var(--theme-dark-button-destructive-default-color);
        background-color: var(--theme-dark-button-destructive-default-bg-color);
        border-color: var(--theme-dark-button-destructive-default-border-color);
      }

      :host([data-color-scheme='dark'][data-type='destructive']:focus) .button,
      :host([data-color-scheme='dark'][data-type='destructive']:hover) .button {
        color: var(--theme-dark-button-destructive-focus-color);
        background-color: var(--theme-dark-button-destructive-focus-bg-color);
        border-color: var(--theme-dark-button-destructive-focus-border-color);
      }

      :host([data-color-scheme='dark'][data-type='destructive']:active) .button {
        color: var(--theme-dark-button-destructive-active-color);
        background-color: var(--theme-dark-button-destructive-active-bg-color);
        border-color: var(--theme-dark-button-destructive-active-border-color);
      }

      :host([data-color-scheme='dark'][data-type='destructive'][data-disabled='true']) .button {
        color: var(--theme-dark-button-destructive-disabled-color);
        background-color: var(--theme-dark-button-destructive-disabled-bg-color);
        border-color: var(--theme-dark-button-destructive-disabled-border-color);
      }
    `
];
rh([
  M({
    attribute: "data-fluid",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], pl.prototype, "fluid", 2);
rh([
  M({
    attribute: "data-type",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => O2(e) ? e : De.Primary,
      toAttribute: (e) => e.toString()
    }
  })
], pl.prototype, "type", 2);
rh([
  M({
    attribute: "data-size",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => rE(e) ? e : _a.Medium,
      toAttribute: (e) => e.toString()
    }
  })
], pl.prototype, "size", 2);
rh([
  M({
    attribute: "data-shape",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => GG(e) ? e : ya.Default,
      toAttribute: (e) => e.toString()
    }
  })
], pl.prototype, "shape", 2);
rh([
  M({
    attribute: "data-padding",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => e.toString()
    }
  })
], pl.prototype, "padding", 2);
rh([
  M({
    attribute: "data-disabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], pl.prototype, "disabled", 2);
pl = rh([
  P("x-ds-button")
], pl);
var Ple = Object.defineProperty, $le = Object.getOwnPropertyDescriptor, nE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? $le(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ple(t, r, a), a;
};
let mm = class extends N {
  constructor() {
    super(...arguments), this.selected = !1, this.enabled = !0;
  }
  render() {
    return w`
      <div class="camera" data-selected="${this.selected}" data-enabled="${this.enabled}" data-qa-id="camera">
        <slot></slot>
      </div>
    `;
  }
};
mm.styles = [
  ...N.styles,
  ee`
      .camera {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        user-select: none;
        background: rgba(0, 0, 0, 0.6);
        font-size: 0.875em; /* 14 / 16 */
        font-weight: 500;
        cursor: pointer;
      }

      .camera[data-selected='true'] {
        width: 3.4285714286em; /* 48 / 14 */
        height: 3.4285714286em; /* 48 / 14 */
        color: var(--color-primary4);
      }

      .camera[data-selected='true']:before {
        position: absolute;
        display: flex;
        font-family: 'jumio-sdk-icomoon';
        font-size: 2.3em;
        content: '\\e966';
      }

      .camera[data-selected='false'] {
        width: 2.2857142857em; /* 32 / 14 */
        height: 2.2857142857em;
        color: white;
      }

      .camera[data-enabled='false'] {
        opacity: 0.5;
      }
    `
];
nE([
  M({
    attribute: "data-selected",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], mm.prototype, "selected", 2);
nE([
  M({
    attribute: "data-enabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], mm.prototype, "enabled", 2);
mm = nE([
  P("x-ds-camera-icon")
], mm);
var qa = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(qa || {}), Kle = Object.defineProperty, Xle = Object.getOwnPropertyDescriptor, aE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Xle(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Kle(t, r, a), a;
};
let vm = class extends N {
  constructor() {
    super(...arguments), this.orientation = qa.Vertical;
  }
  render() {
    return w`
      <div
        class="camera-selector-container"
        data-orientation="${this.orientation}"
        data-qa-id="camera-selector-container"
      >
        <slot name="icon"></slot>
      </div>
    `;
  }
};
vm.styles = [
  ...N.styles,
  ee`
      .camera-selector-container {
        align-items: center;
        justify-content: center;
        border-radius: 1.75em; /* 28 / 16 */
        user-select: none;
        background: rgba(0, 0, 0, 0.2);
      }

      .camera-selector-container[data-orientation='vertical'] {
        display: inline-flex;
        flex-flow: column-reverse;
        row-gap: 0.25em;
        padding: 0.25em;
      }

      .camera-selector-container[data-orientation='horizontal'] {
        display: inline-flex;
        flex-flow: row;
        padding: 0.25em;
        column-gap: 0.25em;
      }

      .camera-icon {
        cursor: pointer;
      }
    `
];
aE([
  M({
    attribute: "data-orientation",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => Object.values(qa).includes(e) ? e : qa.Vertical,
      toAttribute: (e) => e.toString()
    }
  })
], vm.prototype, "orientation", 2);
aE([
  dr({ slot: "camera", selector: "x-ds-camera-icon", flatten: !0 })
], vm.prototype, "items", 2);
vm = aE([
  P("x-ds-camera-selector")
], vm);
const zle = (e) => Object.values(qa).includes(e), qle = `:host{position:relative;margin:0 auto;display:block;width:4.5em;height:4.5em;transition-property:opacity,background-size;transition-duration:.25s;cursor:pointer;border-radius:50%}:host(:active){background-size:95% 95%}:host([data-disabled="true"]){opacity:0;pointer-events:none}:host([data-inactive="true"]){pointer-events:none;background:url("data:image/svg+xml,%3csvg%20width='72'%20height='72'%20viewBox='0%200%2072%2072'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20y='0.000244141'%20width='72'%20height='72'%20rx='36'%20fill='black'%20fill-opacity='0.6'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M36%2064.0002C51.464%2064.0002%2064%2051.4642%2064%2036.0002C64%2020.5363%2051.464%208.00024%2036%208.00024C20.536%208.00024%208%2020.5363%208%2036.0002C8%2051.4642%2020.536%2064.0002%2036%2064.0002ZM60%2036.0002C60%2049.2551%2049.2548%2060.0002%2036%2060.0002C22.7452%2060.0002%2012%2049.2551%2012%2036.0002C12%2022.7454%2022.7452%2012.0002%2036%2012.0002C49.2548%2012.0002%2060%2022.7454%2060%2036.0002ZM62%2036.0002C62%2050.3596%2050.3594%2062.0002%2036%2062.0002C21.6406%2062.0002%2010%2050.3596%2010%2036.0002C10%2021.6408%2021.6406%2010.0002%2036%2010.0002C50.3594%2010.0002%2062%2021.6408%2062%2036.0002Z'%20fill='white'%20fill-opacity='0.4'/%3e%3c/svg%3e") center center no-repeat;background-size:contain}:host:before{content:"";position:absolute;top:50%;left:50%;width:100%;height:100%;background-color:var(--color-primary4);border-radius:50%;transform:translate(-50%,-50%) scale(1);opacity:0;animation:pulse 1.5s infinite}:host:after{position:absolute;top:0;right:0;bottom:0;left:0;background:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='72'%20height='72'%20fill='none'%3e%3crect%20width='72'%20height='72'%20rx='36'%20fill='%23000'%20fill-opacity='.6'/%3e%3cpath%20fill-rule='evenodd'%20d='M36%2064c15.464%200%2028-12.536%2028-28S51.464%208%2036%208%208%2020.536%208%2036s12.536%2028%2028%2028zm24-28c0%2013.255-10.745%2024-24%2024S12%2049.255%2012%2036s10.745-24%2024-24%2024%2010.745%2024%2024zm2%200c0%2014.359-11.641%2026-26%2026S10%2050.36%2010%2036s11.641-26%2026-26%2026%2011.641%2026%2026z'%20fill='%23fff'/%3e%3c/svg%3e") center center no-repeat;background-size:contain;content:""}@keyframes pulse{0%{transform:translate(-50%,-50%) scale(1);opacity:1}to{transform:translate(-50%,-50%) scale(1.5);opacity:0}}`;
var ece = Object.defineProperty, tce = Object.getOwnPropertyDescriptor, iE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? tce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ece(t, r, a), a;
};
let Sm = class extends N {
  constructor() {
    super(...arguments), this.disabled = !1, this.inactive = !1;
  }
  render() {
    return w``;
  }
};
Sm.styles = [...N.styles, Gt(qle)];
iE([
  M({
    attribute: "data-disabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Sm.prototype, "disabled", 2);
iE([
  M({
    attribute: "data-inactive",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Sm.prototype, "inactive", 2);
Sm = iE([
  be(),
  P("x-ds-capture-button")
], Sm);
var Wu = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Large = "large", e))(Wu || {});
const rce = (e) => Object.values(Wu).includes(e);
var nce = Object.defineProperty, ace = Object.getOwnPropertyDescriptor, xG = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ace(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && nce(t, r, a), a;
};
let y1 = class extends N {
  constructor() {
    super(...arguments), this.size = Wu.Medium;
  }
  render() {
    return w`
      <div class="container">
        <div class="container__label" data-size="${this.size}"><slot></slot></div>
      </div>
    `;
  }
};
y1.styles = [
  ...N.styles,
  ee`
      .container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0.75em 1.5em; /* 12 / 16 = 0.75em, 24 / 16 = 1.5em */
        background: rgba(0, 0, 0, 0.6);
        border-radius: 1.75em; /* 28 / 16 = 1.75em */
      }

      .container__label {
        text-align: center;
        color: #fff;
      }

      .container__label[data-size='${Gt(Wu.Medium)}'] {
        font: var(--text-font-h5);
      }

      .container__label[data-size='${Gt(Wu.Large)}'] {
        font: var(--text-font-h3);
      }
    `
];
xG([
  M({
    attribute: "data-size",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => rce(e) ? e : Wu.Medium,
      toAttribute: (e) => e.toString()
    }
  })
], y1.prototype, "size", 2);
y1 = xG([
  P("x-ds-capture-label")
], y1);
var ice = Object.defineProperty, oce = Object.getOwnPropertyDescriptor, sce = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? oce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ice(t, r, a), a;
};
let qk = class extends N {
  render() {
    return w`
      <slot name="top"></slot>
      <div class="label">
        <slot name="bottom"></slot>
      </div>
    `;
  }
};
qk.styles = [
  ...N.styles,
  ee`
      :host {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 1em;
        right: 1em;
        transform: translateY(-50%);
        pointer-events: none;
      }

      .label {
        position: absolute;
        top: calc(100% + 1.5em);
      }
    `
];
qk = sce([
  P("x-ds-capture-message-container")
], qk);
class lce extends CustomEvent {
  constructor(t) {
    super("jcardclick", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var Zn = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e))(Zn || {}), j2 = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(j2 || {});
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Yg = { ATTRIBUTE: 1, CHILD: 2, PROPERTY: 3, BOOLEAN_ATTRIBUTE: 4, EVENT: 5, ELEMENT: 6 }, Og = (e) => (...t) => ({ _$litDirective$: e, values: t });
class jg {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, r, n) {
    this.t = t, this._$AM = r, this.i = n;
  }
  _$AS(t, r) {
    return this.update(t, r);
  }
  update(t, r) {
    return this.render(...r);
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const tn = Og(class extends jg {
  constructor(e) {
    var t;
    if (super(e), e.type !== Yg.ATTRIBUTE || e.name !== "class" || ((t = e.strings) == null ? void 0 : t.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
  }
  update(e, [t]) {
    var n, a;
    if (this.st === void 0) {
      this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((i) => i !== "")));
      for (const i in t) t[i] && !((n = this.nt) != null && n.has(i)) && this.st.add(i);
      return this.render(t);
    }
    const r = e.element.classList;
    for (const i of this.st) i in t || (r.remove(i), this.st.delete(i));
    for (const i in t) {
      const o = !!t[i];
      o === this.st.has(i) || (a = this.nt) != null && a.has(i) || (o ? (r.add(i), this.st.add(i)) : (r.remove(i), this.st.delete(i)));
    }
    return no;
  }
}), cce = (e) => Object.values(Zn).includes(e), dce = (e) => Object.values(j2).includes(e);
var uce = Object.defineProperty, hce = Object.getOwnPropertyDescriptor, HG = (e) => {
  throw TypeError(e);
}, rd = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? hce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && uce(t, r, a), a;
}, pce = (e, t, r) => t.has(e) || HG("Cannot " + r), gce = (e, t, r) => t.has(e) ? HG("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), tU = (e, t, r) => (pce(e, t, "access private method"), r), z0, LG, YG, OG;
let os = class extends N {
  constructor() {
    super(...arguments), gce(this, z0), this.type = Zn.Primary, this.header = "", this.subheader = "", this.tag = "", this.size = j2.Medium, this.disabled = !1;
  }
  render() {
    return w`
      <div
        class="card"
        data-qa-id="card"
        data-disabled="${this.disabled}"
        data-size="${this.size}"
        data-type="${this.type}"
        data-color-scheme="${this.colorScheme}"
        @click="${(e) => {
      tU(this, z0, OG).call(this, e);
    }}"
      >
        ${this.tag ? w`<div class="card__tag">${this.tag}</div>` : q}
        <div class="card__icon ${tn({ hidden: this.iconElements.length === 0 })}">
          <slot
            name="icon"
            data-qa-id="card-icon"
            @slotchange="${() => {
      this.requestUpdate();
    }}"
          ></slot>
        </div>
        <div class="card__headers">${tU(this, z0, LG).call(this)} ${tU(this, z0, YG).call(this)}</div>
      </div>
    `;
  }
};
z0 = /* @__PURE__ */ new WeakSet();
LG = function() {
  return this.header ? w`<div class="card__header" data-qa-id="card-header">${this.header}</div>` : q;
};
YG = function() {
  return this.subheader ? w`<div class="card__subheader" data-qa-id="card-subheader">${this.subheader}</div>` : q;
};
OG = function(e) {
  this.disabled || this.dispatchEvent(new lce(e));
};
os.styles = [
  ...N.styles,
  ee`
      :host([data-disabled='true']) {
        pointer-events: none;
        cursor: default;
      }

      :host(:focus) .card,
      :host(:hover) .card,
      :host(:active) .card {
        box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, 0.1);
      }

      :host([data-disabled='true']:focus) .card,
      :host([data-disabled='true']:hover) .card,
      :host([data-disabled='true']:active) .card {
        box-shadow: none;
      }

      .card {
        display: flex;
        flex-direction: row;
        column-gap: 1.25em; /* 20 / 16 */
        position: relative;
        box-sizing: border-box;
        border-radius: 0.75em; /* 12 / 16 */
        border: 0.0625em solid transparent; /* 1 / 16 */
        align-items: center;
      }

      .card__icon {
        display: contents;
        place-self: center;
      }

      .hidden {
        display: none;
      }

      .card__headers {
        display: flex;
        flex-direction: column;
        row-gap: 0.125em; /* 2 / 16 */
      }

      .card__header:empty {
        display: none;
      }

      .card__subheader:empty {
        display: none;
      }

      .card__tag {
        position: absolute;
        top: -0.75rem;
        left: 0.75rem;
        border-radius: 0.5rem;
        text-transform: uppercase;
        font-size: 0.625rem;
        padding: 0.25rem 0.75rem;
      }

      .card[data-disabled='false'] {
        cursor: pointer;
      }

      .card[data-disabled='true'] {
        pointer-events: none;
        cursor: default;
      }

      .card[data-size='small'] {
        padding: 0.4375em 1em; /* 7 / 16; 16 / 16 */
      }

      .card[data-size='medium'] {
        padding: 0.9375em 1em; /* 15 / 16; 16 / 16 */
      }

      .card[data-size='large'] {
        padding: 1.4375em 1em; /* 23 / 16; 16 / 16 */
      }

      .card__header {
        font-weight: 500;
        font-size: 1.125em; /* 18 / 16 */
        line-height: 1.333em; /* 24 / 18 */
      }

      .card__subheader {
        font-style: normal;
        font-weight: 400;
        font-size: 0.875em; /* 14 / 16 */
        line-height: 1.2857142857em; /*  18 / 14 */
      }

      /* Primary */
      :host([data-color-scheme='light']) .card[data-type='primary'],
      :host([data-color-scheme='light']) .card__tag {
        background-color: var(--theme-light-card-primary-default-bg-color);
        color: var(--theme-light-card-primary-default-color);
      }

      :host([data-color-scheme='light']) .card[data-type='primary']:focus,
      :host([data-color-scheme='light']) .card[data-type='primary']:hover {
        background-color: var(--theme-light-card-primary-focus-bg-color);
        color: var(--theme-light-card-primary-focus-color);
      }

      :host([data-color-scheme='light']) .card[data-type='primary']:active {
        background-color: var(--theme-light-card-primary-active-bg-color);
        color: var(--theme-light-card-primary-active-color);
      }

      :host([data-color-scheme='light']) .card[data-type='primary'][data-disabled='true'] {
        background-color: var(--theme-light-card-primary-disabled-bg-color);
        color: var(--theme-light-card-primary-disabled-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='primary'],
      :host([data-color-scheme='dark']) .card__tag {
        background-color: var(--theme-dark-card-primary-default-bg-color);
        color: var(--theme-dark-card-primary-default-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='primary']:focus,
      :host([data-color-scheme='dark']) .card[data-type='primary']:hover {
        background-color: var(--theme-dark-card-primary-focus-bg-color);
        color: var(--theme-dark-card-primary-focus-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='primary']:active {
        background-color: var(--theme-dark-card-primary-active-bg-color);
        color: var(--theme-dark-card-primary-active-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='primary'][data-disabled='true'] {
        background-color: var(--theme-dark-card-primary-disabled-bg-color);
        color: var(--theme-dark-card-primary-disabled-color);
      }

      /* Secondary */
      :host([data-color-scheme='light']) .card[data-type='secondary'] {
        background-color: var(--theme-light-card-secondary-default-bg-color);
        color: var(--theme-light-card-secondary-default-color);
        border-color: var(--theme-light-card-secondary-default-border-color);
      }

      :host([data-color-scheme='light']) .card[data-type='secondary']:focus,
      :host([data-color-scheme='light']) .card[data-type='secondary']:hover {
        background-color: var(--theme-light-card-secondary-focus-bg-color);
        color: var(--theme-light-card-secondary-focus-color);
        border-color: var(--theme-light-card-secondary-focus-border-color);
      }

      :host([data-color-scheme='light']) .card[data-type='secondary']:active {
        background-color: var(--theme-light-card-secondary-active-bg-color);
        color: var(--theme-light-card-secondary-active-color);
        border-color: var(--theme-light-card-secondary-active-border-color);
      }

      :host([data-color-scheme='light']) .card[data-type='secondary'][data-disabled='true'] {
        background-color: var(--theme-light-card-secondary-disabled-bg-color);
        color: var(--theme-light-card-secondary-disabled-color);
        border-color: var(--theme-light-card-secondary-disabled-border-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='secondary'] {
        background-color: var(--theme-dark-card-secondary-default-bg-color);
        color: var(--theme-dark-card-secondary-default-color);
        border-color: var(--theme-dark-card-secondary-default-border-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='secondary']:focus,
      :host([data-color-scheme='dark']) .card[data-type='secondary']:hover {
        background-color: var(--theme-dark-card-secondary-focus-bg-color);
        color: var(--theme-dark-card-secondary-focus-color);
        border-color: var(--theme-dark-card-secondary-focus-border-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='secondary']:active {
        background-color: var(--theme-dark-card-secondary-active-bg-color);
        color: var(--theme-dark-card-secondary-active-color);
        border-color: var(--theme-dark-card-secondary-active-border-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='secondary'][data-disabled='true'] {
        background-color: var(--theme-dark-card-secondary-disabled-bg-color);
        color: var(--theme-dark-card-secondary-disabled-color);
        border-color: var(--theme-dark-card-secondary-disabled-border-color);
      }

      /* Tertiary */
      :host([data-color-scheme='light']) .card[data-type='tertiary'] {
        background-color: var(--theme-light-card-tertiary-default-bg-color);
        color: var(--theme-light-card-tertiary-default-color);
      }

      :host([data-color-scheme='light']) .card[data-type='tertiary']:focus,
      :host([data-color-scheme='light']) .card[data-type='tertiary']:hover {
        background-color: var(--theme-light-card-tertiary-focus-bg-color);
        color: var(--theme-light-card-tertiary-focus-color);
        border-color: var(--theme-light-card-tertiary-focus-bg-color);
      }

      :host([data-color-scheme='light']) .card[data-type='tertiary']:active {
        background-color: var(--theme-light-card-tertiary-active-bg-color);
        color: var(--theme-light-card-tertiary-active-color);
        border-color: var(--theme-light-card-tertiary-active-bg-color);
      }

      :host([data-color-scheme='light']) .card[data-type='tertiary'][data-disabled='true'] {
        background-color: var(--theme-light-card-tertiary-disabled-bg-color);
        color: var(--theme-light-card-tertiary-disabled-color);
        border-color: var(--theme-light-card-tertiary-disabled-bg-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='tertiary'] {
        background-color: var(--theme-dark-card-tertiary-default-bg-color);
        color: var(--theme-dark-card-tertiary-default-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='tertiary']:focus,
      :host([data-color-scheme='dark']) .card[data-type='tertiary']:hover {
        background-color: var(--theme-dark-card-tertiary-focus-bg-color);
        color: var(--theme-dark-card-tertiary-focus-color);
        border-color: var(--theme-dark-card-tertiary-focus-bg-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='tertiary']:active {
        background-color: var(--theme-dark-card-tertiary-active-bg-color);
        color: var(--theme-dark-card-tertiary-active-color);
        border-color: var(--theme-dark-card-tertiary-active-bg-color);
      }

      :host([data-color-scheme='dark']) .card[data-type='tertiary'][data-disabled='true'] {
        background-color: var(--theme-dark-card-tertiary-disabled-bg-color);
        color: var(--theme-dark-card-tertiary-disabled-color);
      }
    `
];
rd([
  M({
    attribute: "data-type",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => cce(e) ? e : Zn.Primary,
      toAttribute: (e) => e.toString()
    }
  })
], os.prototype, "type", 2);
rd([
  M({
    attribute: "data-header",
    type: String,
    reflect: !0
  })
], os.prototype, "header", 2);
rd([
  M({
    attribute: "data-subheader",
    type: String,
    reflect: !0
  })
], os.prototype, "subheader", 2);
rd([
  M({
    attribute: "data-tag",
    type: String,
    reflect: !0
  })
], os.prototype, "tag", 2);
rd([
  M({
    attribute: "data-size",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => dce(e) ? e : j2.Medium,
      toAttribute: (e) => e.toString()
    }
  })
], os.prototype, "size", 2);
rd([
  M({
    attribute: "data-disabled",
    type: String,
    reflect: !0
  })
], os.prototype, "disabled", 2);
rd([
  dr({ slot: "icon", flatten: !0 })
], os.prototype, "iconElements", 2);
os = rd([
  P("x-ds-card")
], os);
var fce = Object.defineProperty, mce = Object.getOwnPropertyDescriptor, vce = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? mce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && fce(t, r, a), a;
};
let e_ = class extends N {
  render() {
    return w`
      <div class="container" data-color-scheme="${this.colorScheme}">
        <slot></slot>
      </div>
    `;
  }
};
e_.styles = [
  ...N.styles,
  ee`
      .container {
        display: block;
        padding: 1em;
        border-radius: 1.75em;
        transition-property: background-color, color;
        transition-duration: 250ms;
      }

      :host([data-color-scheme='light']) .container {
        background-color: var(--color-secondary2);
      }

      :host([data-color-scheme='dark']) .container {
        background-color: var(--color-secondary11);
      }
    `
];
e_ = vce([
  be(),
  P("x-ds-card-light")
], e_);
var Sce = Object.defineProperty, Ice = Object.getOwnPropertyDescriptor, oE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Ice(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Sce(t, r, a), a;
};
let Im = class extends N {
  render() {
    return w`
      <x-ds-card-light
        data-header-visible="${this.headerElements.length > 0}"
        data-footer-visible="${this.footerElements.length > 0}"
      >
        <slot
          name="header"
          @slotchange="${() => {
      this.requestUpdate();
    }}"
        ></slot>
        <ul class="list">
          <slot name="item"></slot>
        </ul>
        <slot
          name="footer"
          @slotchange="${() => {
      this.requestUpdate();
    }}"
        ></slot>
      </x-ds-card-light>
    `;
  }
};
Im.styles = [
  ...N.styles,
  ee`
      .list {
        margin: 0;
        padding: 0 0.25em;
        font: var(--text-font-body-regular);
        list-style-position: inside;
      }

      [data-header-visible='false'] slot[name='header'],
      [data-footer-visible='false'] slot[name='footer'] {
        display: none;
      }

      slot[name='header'] + .list,
      .list + slot[name='header'] {
        margin-top: 0.5em;
      }
    `
];
oE([
  dr({ slot: "header", flatten: !0 })
], Im.prototype, "headerElements", 2);
oE([
  dr({ slot: "footer", flatten: !0 })
], Im.prototype, "footerElements", 2);
Im = oE([
  be(),
  P("x-ds-card-list")
], Im);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const jG = "important", Cce = " !" + jG, bce = Og(class extends jg {
  constructor(e) {
    var t;
    if (super(e), e.type !== Yg.ATTRIBUTE || e.name !== "style" || ((t = e.strings) == null ? void 0 : t.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(e) {
    return Object.keys(e).reduce((t, r) => {
      const n = e[r];
      return n == null ? t : t + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${n};`;
    }, "");
  }
  update(e, [t]) {
    const { style: r } = e.element;
    if (this.ft === void 0) return this.ft = new Set(Object.keys(t)), this.render(t);
    for (const n of this.ft) t[n] == null && (this.ft.delete(n), n.includes("-") ? r.removeProperty(n) : r[n] = null);
    for (const n in t) {
      const a = t[n];
      if (a != null) {
        this.ft.add(n);
        const i = typeof a == "string" && a.endsWith(Cce);
        n.includes("-") || i ? r.setProperty(n, i ? a.slice(0, -11) : a, i ? jG : "") : r[n] = a;
      }
    }
    return no;
  }
});
class PG extends CustomEvent {
  constructor(t) {
    super("carrouselnavigation", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var yce = Object.defineProperty, wce = Object.getOwnPropertyDescriptor, $G = (e) => {
  throw TypeError(e);
}, nh = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? wce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && yce(t, r, a), a;
}, KG = (e, t, r) => t.has(e) || $G("Cannot " + r), N5 = (e, t, r) => (KG(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Z5 = (e, t, r) => t.has(e) ? $G("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), N0 = (e, t, r) => (KG(e, t, "access private method"), r), Ud, XG, IC, t_, r_;
let gl = class extends N {
  constructor() {
    super(...arguments), Z5(this, Ud), this.offset = 0, this.tileWidth = 368, this.tileHeight = 208, Z5(this, IC, (e) => {
      e.key === "ArrowLeft" ? N0(this, Ud, r_).call(this) : e.key === "ArrowRight" && N0(this, Ud, t_).call(this);
    });
  }
  getOffsetTranslateX() {
    var o, s, c;
    const e = this.images ?? [], t = e[0], r = e[this.offset], n = ((((o = this.outerWrapperEl) == null ? void 0 : o.offsetWidth) ?? 0) - ((r == null ? void 0 : r.offsetWidth) ?? 0)) / 2, a = Math.max(0, ((r == null ? void 0 : r.offsetLeft) ?? 0) - ((t == null ? void 0 : t.offsetLeft) ?? 0) - n), i = Math.min(
      (((s = this.innerWrapperEl) == null ? void 0 : s.offsetWidth) ?? 0) - (((c = this.outerWrapperEl) == null ? void 0 : c.offsetWidth) ?? 0),
      a
    );
    return this.isScrollingAvailable() ? `${-i}px` : "";
  }
  isNavigationForwardEnabled() {
    return this.isScrollingAvailable() && this.offset < this.images.length - 1;
  }
  isNavigationBackwardEnabled() {
    return this.isScrollingAvailable() && this.offset > 0;
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("keydown", N5(this, IC));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("keydown", N5(this, IC));
  }
  isScrollingAvailable() {
    var r, n;
    const e = ((r = this.innerWrapperEl) == null ? void 0 : r.offsetWidth) ?? 0, t = ((n = this.outerWrapperEl) == null ? void 0 : n.offsetWidth) ?? 0;
    return e > t;
  }
  navigateTo(e) {
    const t = Math.max(0, e), r = Math.min(t, this.images.length - 1);
    this.offset !== r && (this.offset = r, this.dispatchEvent(new PG(r)));
  }
  render() {
    var e, t;
    return w`
      <div class="carrousel">
        ${((e = this.images) == null ? void 0 : e.length) > 1 ? w` <div class="carrousel__wing">
              <x-ds-button
                data-type="${De.QuietIcon}"
                @jclick="${() => {
      N0(this, Ud, r_).call(this);
    }}"
                .disabled="${!this.isNavigationBackwardEnabled()}"
              >
                <i class="carrousel__wing-icon icon icon-chevron-direction-left"></i>
              </x-ds-button>
            </div>` : q}
        <div class="carrousel__body" data-id="outer-wrapper">
          <div
            data-id="inner-wrapper"
            class="carrousel__inner-wrapper"
            style=${bce({
      "--carrousel-offset": this.getOffsetTranslateX(),
      "--carrousel-tile-width-px": `${this.tileWidth}px`,
      "--carrousel-tile-height-px": `${this.tileHeight}px`
    })}
          >
            <slot
              name="image"
              @slotchange="${() => {
      this.requestUpdate();
    }}"
            ></slot>
          </div>
        </div>
        ${((t = this.images) == null ? void 0 : t.length) > 2 ? w`<div class="carrousel__wing">
              <x-ds-button
                data-type="${De.QuietIcon}"
                @jclick="${() => {
      N0(this, Ud, t_).call(this);
    }}"
                .disabled="${!this.isNavigationForwardEnabled()}"
              >
                <i class="carrousel__wing-icon icon icon-chevron-direction-right"></i>
              </x-ds-button>
            </div>` : q}
      </div>
      ${N0(this, Ud, XG).call(this)}
    `;
  }
};
Ud = /* @__PURE__ */ new WeakSet();
XG = function() {
  var e;
  return ((e = this.images) == null ? void 0 : e.length) > 2 ? w`
          <ul class="pagination">
            ${(this.images || []).map((t, r) => w`
                <li
                  @click=${() => {
    this.navigateTo(r);
  }}
                  class="${this.offset === r ? "pagination__mark pagination__mark--active" : "pagination__mark"}"
                ></li>
              `)}
          </ul>
        ` : q;
};
IC = /* @__PURE__ */ new WeakMap();
t_ = function() {
  const e = Math.min(this.offset + 1, this.images.length - 1);
  this.navigateTo(e);
};
r_ = function() {
  const e = Math.max(this.offset - 1, 0);
  this.navigateTo(e);
};
gl.styles = [
  ...N.styles,
  ee`
      :host {
        direction: ltr;
      }

      .carrousel {
        display: flex;
        flex-flow: row nowrap;
        align-items: stretch;
        column-gap: 0.5em;
        --carrousel-offset: 0px;
      }

      .carrousel__wing-icon {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 1em;
        height: 1em;
      }

      .carrousel__wing {
        display: flex;
        place-content: center;
        place-items: center;
      }

      .carrousel__body {
        position: relative;
        display: block;
        overflow: hidden;
        flex-grow: 1;
        border-radius: 1.75em;
      }

      .carrousel__inner-wrapper {
        position: relative;
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: stretch;
        justify-content: center;
        column-gap: 0.5em;
        transform: translateX(var(--carrousel-offset));
        transition: transform 200ms ease-in-out;
        min-width: 100%;
      }

      ::slotted(img) {
        width: var(--carrousel-tile-width-px);
        height: var(--carrousel-tile-height-px);
        border-radius: 1.75em;
        object-fit: contain;
        object-position: center;
        overflow: hidden;
      }

      :host([data-color-scheme='light']) ::slotted(img) {
        background-color: var(--color-secondary1);
      }

      :host([data-color-scheme='dark']) ::slotted(img) {
        background-color: var(--color-secondary9);
      }

      .pagination {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        list-style: none;
        padding: 1em;
        margin: 0;
        gap: 0.5em;
      }

      .pagination__mark {
        cursor: pointer;
        min-width: 0.5em;
        max-width: 0.5em;
        min-height: 0.5em;
        max-height: 0.5em;
        border-radius: 50%;
      }

      :host([data-color-scheme='light']) .pagination__mark {
        background-color: var(--color-secondary3);
      }

      :host([data-color-scheme='light']) .pagination__mark--active {
        background-color: var(--color-secondary7);
      }

      :host([data-color-scheme='dark']) .pagination__mark {
        background-color: var(--color-secondary8);
      }

      :host([data-color-scheme='dark']) .pagination__mark--active {
        background-color: var(--color-secondary3);
      }
    `
];
nh([
  yW('[data-id="inner-wrapper"]')
], gl.prototype, "innerWrapperEl", 2);
nh([
  yW('[data-id="outer-wrapper"]')
], gl.prototype, "outerWrapperEl", 2);
nh([
  dr({
    slot: "image",
    flatten: !0
  })
], gl.prototype, "images", 2);
nh([
  M()
], gl.prototype, "offset", 2);
nh([
  M({
    attribute: "data-width",
    type: Number,
    reflect: !0
  })
], gl.prototype, "tileWidth", 2);
nh([
  M({
    attribute: "data-height",
    type: Number,
    reflect: !0
  })
], gl.prototype, "tileHeight", 2);
gl = nh([
  P("x-ds-carrousel")
], gl);
class zG extends CustomEvent {
  constructor(t) {
    super("optionselected", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
const Ace = ee`:host{--theme-light-select-secondary-default-bg-color: var(--jumio-sdk-theme-light-select-secondary-default-bg-color, var(--portal-theme-light-select-secondary-default-bg-color, var(--theme-light-clickable-secondary-default-bg-color)));--theme-light-select-secondary-default-color: var(--jumio-sdk-theme-light-select-secondary-default-color, var(--portal-theme-light-select-secondary-default-color, var(--theme-light-clickable-secondary-default-color)));--theme-light-select-secondary-default-border-color: var(--jumio-sdk-theme-light-select-secondary-default-border-color, var(--portal-theme-light-select-secondary-default-border-color, var(--theme-light-clickable-secondary-default-border-color)));--theme-light-select-secondary-focus-bg-color: var(--jumio-sdk-theme-light-select-secondary-focus-bg-color, var(--portal-theme-light-select-secondary-focus-bg-color, var(--theme-light-clickable-secondary-focus-bg-color)));--theme-light-select-secondary-focus-color: var(--jumio-sdk-theme-light-select-secondary-focus-color, var(--portal-theme-light-select-secondary-focus-color, var(--theme-light-clickable-secondary-focus-color)));--theme-light-select-secondary-focus-border-color: var(--jumio-sdk-theme-light-select-secondary-focus-border-color, var(--portal-theme-light-select-secondary-focus-border-color, var(--theme-light-clickable-secondary-focus-border-color)));--theme-light-select-secondary-active-bg-color: var(--jumio-sdk-theme-light-select-secondary-active-bg-color, var(--portal-theme-light-select-secondary-active-bg-color, var(--theme-light-clickable-secondary-active-bg-color)));--theme-light-select-secondary-active-color: var(--jumio-sdk-theme-light-select-secondary-active-color, var(--portal-theme-light-select-secondary-active-color, var(--theme-light-clickable-secondary-active-color)));--theme-light-select-secondary-active-border-color: var(--jumio-sdk-theme-light-select-secondary-active-border-color, var(--portal-theme-light-select-secondary-active-border-color, var(--theme-light-clickable-secondary-active-border-color)));--theme-light-select-secondary-disabled-bg-color: var(--jumio-sdk-theme-light-select-secondary-disabled-bg-color, var(--portal-theme-light-select-secondary-disabled-bg-color, var(--theme-light-clickable-secondary-disabled-bg-color)));--theme-light-select-secondary-disabled-color: var(--jumio-sdk-theme-light-select-secondary-disabled-color, var(--portal-theme-light-select-secondary-disabled-color, var(--theme-light-clickable-secondary-disabled-color)));--theme-light-select-secondary-disabled-border-color: var(--jumio-sdk-theme-light-select-secondary-disabled-border-color, var(--portal-theme-light-select-secondary-disabled-border-color, var(--theme-light-clickable-secondary-disabled-border-color)));--theme-dark-select-secondary-default-bg-color: var(--jumio-sdk-theme-dark-select-secondary-default-bg-color, var(--portal-theme-dark-select-secondary-default-bg-color, var(--theme-dark-clickable-secondary-default-bg-color)));--theme-dark-select-secondary-default-color: var(--jumio-sdk-theme-dark-select-secondary-default-color, var(--portal-theme-dark-select-secondary-default-color, var(--theme-dark-clickable-secondary-default-color)));--theme-dark-select-secondary-default-border-color: var(--jumio-sdk-theme-dark-select-secondary-default-border-color, var(--portal-theme-dark-select-secondary-default-border-color, var(--theme-dark-clickable-secondary-default-border-color)));--theme-dark-select-secondary-focus-bg-color: var(--jumio-sdk-theme-dark-select-secondary-focus-bg-color, var(--portal-theme-dark-select-secondary-focus-bg-color, var(--theme-dark-clickable-secondary-focus-bg-color)));--theme-dark-select-secondary-focus-color: var(--jumio-sdk-theme-dark-select-secondary-focus-color, var(--portal-theme-dark-select-secondary-focus-color, var(--theme-dark-clickable-secondary-focus-color)));--theme-dark-select-secondary-focus-border-color: var(--jumio-sdk-theme-dark-select-secondary-focus-border-color, var(--portal-theme-dark-select-secondary-focus-border-color, var(--theme-dark-clickable-secondary-focus-border-color)));--theme-dark-select-secondary-active-bg-color: var(--jumio-sdk-theme-dark-select-secondary-active-bg-color, var(--portal-theme-dark-select-secondary-active-bg-color, var(--theme-dark-clickable-secondary-active-bg-color)));--theme-dark-select-secondary-active-color: var(--jumio-sdk-theme-dark-select-secondary-active-color, var(--portal-theme-dark-select-secondary-active-color, var(--theme-dark-clickable-secondary-active-color)));--theme-dark-select-secondary-active-border-color: var(--jumio-sdk-theme-dark-select-secondary-active-border-color, var(--portal-theme-dark-select-secondary-active-border-color, var(--theme-dark-clickable-secondary-active-border-color)));--theme-dark-select-secondary-disabled-bg-color: var(--jumio-sdk-theme-dark-select-secondary-disabled-bg-color, var(--portal-theme-dark-select-secondary-disabled-bg-color, var(--theme-dark-clickable-secondary-disabled-bg-color)));--theme-dark-select-secondary-disabled-color: var(--jumio-sdk-theme-dark-select-secondary-disabled-color, var(--portal-theme-dark-select-secondary-disabled-color, var(--theme-dark-clickable-secondary-disabled-color)));--theme-dark-select-secondary-disabled-border-color: var(--jumio-sdk-theme-dark-select-secondary-disabled-border-color, var(--portal-theme-dark-select-secondary-disabled-border-color, var(--theme-dark-clickable-secondary-disabled-border-color)))}.container{position:relative}.select{font:var(--text-font-body-medium);-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:1em .75em;border-width:.0625em;border-style:solid;border-radius:.5em;width:100%;cursor:pointer}:host([data-color-scheme=light]) .select{color:var(--theme-light-text-color)}:host([data-color-scheme=dark]) .select{color:var(--theme-dark-text-color)}:host([data-color-scheme=light]) .select{background:var(--theme-light-app-container-bg-color)}:host([data-color-scheme=dark]) .select{background:var(--theme-dark-app-container-bg-color)}.marker{position:absolute;top:50%;right:.75em;pointer-events:none;width:1.125em;height:1.125em;margin-top:-.5625em;content:\"\\\\e913\"}:host([data-color-scheme=light]) .marker{color:var(--theme-light-text-color)}:host([data-color-scheme=dark]) .marker{color:var(--theme-dark-text-color)}:host([data-color-scheme=light]) .select{background-color:var(--theme-light-select-secondary-default-bg-color);color:var(--theme-light-select-secondary-default-color);border-color:var(--theme-light-select-secondary-default-border-color)}:host([data-color-scheme=light]) .select:focus,:host([data-color-scheme=light]) .select:hover{background-color:var(--theme-light-select-secondary-focus-bg-color);color:var(--theme-light-select-secondary-focus-color);border-color:var(--theme-light-select-secondary-focus-border-color)}:host([data-color-scheme=light]:active) .select{background-color:var(--theme-light-select-secondary-active-bg-color);color:var(--theme-light-select-secondary-active-color);border-color:var(--theme-light-select-secondary-active-border-color)}:host([data-color-scheme=light][data-disabled=true]) .select{background-color:var(--theme-light-select-secondary-disabled-bg-color);color:var(--theme-light-select-secondary-disabled-color);border-color:var(--theme-light-select-secondary-disabled-border-color)}:host([data-color-scheme=dark]) .select{background-color:var(--theme-dark-select-secondary-default-bg-color);color:var(--theme-dark-select-secondary-default-color);border-color:var(--theme-dark-select-secondary-default-border-color)}:host([data-color-scheme=dark]:focus) .select,:host([data-color-scheme=dark]:hover) .select{background-color:var(--theme-dark-select-secondary-focus-bg-color);color:var(--theme-dark-select-secondary-focus-color);border-color:var(--theme-dark-select-secondary-focus-border-color)}:host([data-color-scheme=dark]:active) .select{background-color:var(--theme-dark-select-secondary-active-bg-color);color:var(--theme-dark-select-secondary-active-color);border-color:var(--theme-dark-select-secondary-active-border-color)}:host([data-color-scheme=dark][data-disabled=true]) .select{background-color:var(--theme-dark-select-secondary-disabled-bg-color);color:var(--theme-dark-secondary-disabled-color-select);border-color:var(--theme-dark-select-secondary-disabled-border-color)}:host([data-color-scheme=light]){--marker: var(--theme-light-select-secondary-default-color)}:host([data-color-scheme=light]:focus),:host([data-color-scheme=light]:hover){--marker: var(--theme-light-select-secondary-focus-color)}:host([data-color-scheme=light]:active){--marker: var(--theme-light-select-secondary-active-color)}:host([data-color-scheme=light][data-disabled=true]){--marker: var(--theme-light-select-secondary-disabled-color)}:host([data-color-scheme=dark]){--marker: var(--theme-dark-select-secondary-default-color)}:host([data-color-scheme=dark]:focus),:host([data-color-scheme=dark]:hover){--marker: var(--theme-dark-select-secondary-focus-color)}:host([data-color-scheme=dark]:active){--marker: var(--theme-dark-select-secondary-active-color)}:host([data-color-scheme=dark][data-disabled=true]){--marker: var(--theme-dark-select-secondary-disabled-color)}`;
var Uce = Object.defineProperty, kce = Object.getOwnPropertyDescriptor, qG = (e) => {
  throw TypeError(e);
}, P2 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? kce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Uce(t, r, a), a;
}, _ce = (e, t, r) => t.has(e) || qG("Cannot " + r), Nce = (e, t, r) => t.has(e) ? qG("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), B5 = (e, t, r) => (_ce(e, t, "access private method"), r), CC, e9, t9;
let Kp = class extends N {
  constructor() {
    super(...arguments), Nce(this, CC), this.options = [], this.selection = "", this.disabled = !1;
  }
  render() {
    return w`
      <div class="container">
        <select
          class="select"
          data-qa-id="x-ds-dropdown-select"
          @change="${B5(this, CC, t9).bind(this)}"
          ?disabled="${this.disabled}"
        >
          ${this.options.map(
      (e) => w`
              <option value="${e.value}" ?selected="${B5(this, CC, e9).call(this, e, this.selection)}">
                ${e.label}
              </option>
            `
    )}
        </select>
        <div class="marker">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.7797 6.21937C12.4872 5.92688 12.0147 5.92688 11.7222 6.21937L8.81218 9.12937L5.90218 6.21937C5.60968 5.92688 5.13718 5.92688 4.84468 6.21937C4.55218 6.51187 4.55218 6.98437 4.84468 7.27687L8.28718 10.7194C8.57968 11.0119 9.05218 11.0119 9.34468 10.7194L12.7872 7.27687C13.0722 6.99187 13.0722 6.51187 12.7797 6.21937Z"
              fill="var(--marker)"
            />
          </svg>
        </div>
      </div>
    `;
  }
};
CC = /* @__PURE__ */ new WeakSet();
e9 = function(e, t) {
  return e.value === t;
};
t9 = function(e) {
  if (e.target instanceof HTMLSelectElement) {
    const { value: t } = e.target, r = this.options.find((n) => n.value === t);
    r && this.dispatchEvent(new zG(r));
  }
};
Kp.styles = [
  ...N.styles,
  Ace
];
P2([
  M({
    attribute: "data-options",
    type: Object,
    reflect: !1
  })
], Kp.prototype, "options", 2);
P2([
  M({
    attribute: "data-selection",
    type: String,
    reflect: !0
  })
], Kp.prototype, "selection", 2);
P2([
  M({
    attribute: "data-disabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Kp.prototype, "disabled", 2);
Kp = P2([
  P("x-ds-dropdown")
], Kp);
const Zce = `:host([data-overlay="true"]){position:absolute;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:center}:host([data-overlay="true"][data-color-scheme="dark"]){background-color:var(--color-secondary12)}:host([data-overlay="true"][data-color-scheme="light"]){background-color:var(--white)}.error{display:flex;flex-direction:column;row-gap:2em;align-items:center}.error__button-container{display:flex;flex-direction:column;row-gap:1em;align-items:center}.error-icon{width:7em;height:7em;background:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='-125.789%2082.733%20112%20112'%3e%3ccircle%20cx='-69.789'%20cy='138.733'%20r='56'%20fill='%23f2c94c'/%3e%3cpath%20fill-rule='evenodd'%20d='M-65.789%20113.688c0-1.632-1.791-2.955-4-2.955s-4%201.323-4%202.955l1.143%2032.089c0%201.633.648%202.956%202.857%202.956s2.857-1.323%202.857-2.956l1.143-32.089zm-4%2052.045a5%205%200%201%200%200-10%205%205%200%201%200%200%2010z'%20fill='%23fff'/%3e%3c/svg%3e") center center no-repeat;background-size:contain}`;
var Bce = Object.defineProperty, Wce = Object.getOwnPropertyDescriptor, ah = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Wce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Bce(t, r, a), a;
};
let fl = class extends N {
  constructor() {
    super(...arguments), this.title = "", this.message = "", this.errorCode = "", this.date = null, this.transactionId = "", this.showDate = !0;
  }
  render() {
    return w`
      <div class="container">
        <slot name="title"><div class="title" data-qa-id="title">${this.title}</div></slot>
        <slot name="message"><p class="message" data-qa-id="message">${this.message}</p></slot>
        <div class="details" data-qa-id="details">${this.getErrorDetails()}</div>
      </div>
    `;
  }
  getErrorDetails() {
    const { errorCode: e, date: t } = this, r = this.showDate ? (t ?? /* @__PURE__ */ new Date()).toISOString() : "", n = [e, this.transactionId, r].filter((a) => a.length > 0);
    return n.length > 0 ? n.join(" | ") : "";
  }
};
fl.styles = [
  ...N.styles,
  ee`
      :host([data-color-scheme='dark']) .details {
        color: var(--color-secondary9);
      }

      :host([data-color-scheme='light']) .details {
        color: var(--color-secondary3);
      }

      .container {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
      }

      .title {
        font: var(--text-font-h1);
      }

      .message {
        font: var(--text-font-subtitle-medium);
        margin: 0;
      }

      .details {
        font: var(--text-font-h6);
      }

      .title,
      .message,
      .details {
        text-align: center;
      }

      .title:empty,
      .message:empty,
      .details:empty {
        display: none;
      }
    `
];
ah([
  M({
    type: String,
    attribute: "data-title",
    reflect: !0
  })
], fl.prototype, "title", 2);
ah([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], fl.prototype, "message", 2);
ah([
  M({
    type: String,
    attribute: "data-error-code",
    reflect: !0
  })
], fl.prototype, "errorCode", 2);
ah([
  M({
    type: String,
    attribute: "data-date",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e ? new Date(e) : null,
      toAttribute: (e) => e instanceof Date ? e.toISOString() : null
    }
  })
], fl.prototype, "date", 2);
ah([
  M({
    type: String,
    attribute: "data-transaction-id",
    reflect: !0
  })
], fl.prototype, "transactionId", 2);
ah([
  M({
    type: String,
    attribute: "data-show-date",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], fl.prototype, "showDate", 2);
fl = ah([
  be(),
  P("x-ds-error-message-details")
], fl);
var Ece = Object.defineProperty, Qce = Object.getOwnPropertyDescriptor, Nl = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Qce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ece(t, r, a), a;
};
let wa = class extends N {
  constructor() {
    super(...arguments), this.title = "", this.message = "", this.overlay = !1, this.errorCode = "", this.date = null, this.transactionId = "", this.showDate = !0;
  }
  render() {
    return w`
      <div class="error">
        <div class="error-icon" data-qa-id="error-icon"></div>
        <x-ds-error-message-details
          data-qa-id="error-details"
          data-title="${this.title}"
          data-message="${this.message}"
          data-error-code="${this.errorCode}"
          data-transaction-id="${this.transactionId}"
          data-show-date="${this.showDate}"
          .date="${this.date}"
        ></x-ds-error-message-details>
        <div
          class="${tn({
      "error__button-container": !0,
      hidden: this.buttonElements.length === 0
    })}"
        >
          <slot
            name="button"
            @slotchange="${() => {
      this.requestUpdate();
    }}"
          ></slot>
        </div>
      </div>
    `;
  }
};
wa.styles = [...N.styles, Gt(Zce)];
Nl([
  M({
    type: String,
    attribute: "data-title",
    reflect: !0
  })
], wa.prototype, "title", 2);
Nl([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], wa.prototype, "message", 2);
Nl([
  M({
    type: String,
    attribute: "data-overlay",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], wa.prototype, "overlay", 2);
Nl([
  M({
    type: String,
    attribute: "data-error-code",
    reflect: !0
  })
], wa.prototype, "errorCode", 2);
Nl([
  M({
    type: String,
    attribute: "data-date",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e ? new Date(e) : null,
      toAttribute: (e) => e instanceof Date ? e.toISOString() : null
    }
  })
], wa.prototype, "date", 2);
Nl([
  M({
    type: String,
    attribute: "data-transaction-id",
    reflect: !0
  })
], wa.prototype, "transactionId", 2);
Nl([
  M({
    type: String,
    attribute: "data-show-date",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], wa.prototype, "showDate", 2);
Nl([
  dr({
    slot: "button",
    flatten: !0
  })
], wa.prototype, "buttonElements", 2);
wa = Nl([
  be(),
  P("x-ds-error-message")
], wa);
const Fce = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='-125.789%2082.733%20112%20112'%3e%3ccircle%20cx='-69.789'%20cy='138.733'%20r='56'%20fill='%23f2c94c'/%3e%3cpath%20fill-rule='evenodd'%20d='M-65.789%20113.688c0-1.632-1.791-2.955-4-2.955s-4%201.323-4%202.955l1.143%2032.089c0%201.633.648%202.956%202.857%202.956s2.857-1.323%202.857-2.956l1.143-32.089zm-4%2052.045a5%205%200%201%200%200-10%205%205%200%201%200%200%2010z'%20fill='%23fff'/%3e%3c/svg%3e";
var Tce = Object.defineProperty, Rce = Object.getOwnPropertyDescriptor, r9 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Rce(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Tce(t, r, a), a;
};
let w1 = class extends N {
  constructor() {
    super(...arguments), this.message = "";
  }
  render() {
    return w`<div class="container">
      <div class="error-icon" data-qa-id="error-icon"></div>
      <p class="message" data-qa-id="error-message">${this.message}</p>
    </div>`;
  }
};
w1.styles = [
  ...N.styles,
  ee`
      .container {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
        align-items: center;
      }

      .message {
        font: var(--text-font-subtitle-medium);
        margin: 0;
        text-align: center;
      }

      .error-icon {
        width: 4em;
        height: 4em;
        /* prettier-ignore */
        background: url("${Gt(Fce)}") center center no-repeat;

        @media screen and (min-width: 48em) {
          width: 7em;
          height: 7em;
        }
      }
    `
];
r9([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], w1.prototype, "message", 2);
w1 = r9([
  be(),
  P("x-ds-upload-error-message")
], w1);
var Nc = Object.freeze({
  Linear: Object.freeze({
    None: function(e) {
      return e;
    },
    In: function(e) {
      return e;
    },
    Out: function(e) {
      return e;
    },
    InOut: function(e) {
      return e;
    }
  }),
  Quadratic: Object.freeze({
    In: function(e) {
      return e * e;
    },
    Out: function(e) {
      return e * (2 - e);
    },
    InOut: function(e) {
      return (e *= 2) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1);
    }
  }),
  Cubic: Object.freeze({
    In: function(e) {
      return e * e * e;
    },
    Out: function(e) {
      return --e * e * e + 1;
    },
    InOut: function(e) {
      return (e *= 2) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2);
    }
  }),
  Quartic: Object.freeze({
    In: function(e) {
      return e * e * e * e;
    },
    Out: function(e) {
      return 1 - --e * e * e * e;
    },
    InOut: function(e) {
      return (e *= 2) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2);
    }
  }),
  Quintic: Object.freeze({
    In: function(e) {
      return e * e * e * e * e;
    },
    Out: function(e) {
      return --e * e * e * e * e + 1;
    },
    InOut: function(e) {
      return (e *= 2) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2);
    }
  }),
  Sinusoidal: Object.freeze({
    In: function(e) {
      return 1 - Math.sin((1 - e) * Math.PI / 2);
    },
    Out: function(e) {
      return Math.sin(e * Math.PI / 2);
    },
    InOut: function(e) {
      return 0.5 * (1 - Math.sin(Math.PI * (0.5 - e)));
    }
  }),
  Exponential: Object.freeze({
    In: function(e) {
      return e === 0 ? 0 : Math.pow(1024, e - 1);
    },
    Out: function(e) {
      return e === 1 ? 1 : 1 - Math.pow(2, -10 * e);
    },
    InOut: function(e) {
      return e === 0 ? 0 : e === 1 ? 1 : (e *= 2) < 1 ? 0.5 * Math.pow(1024, e - 1) : 0.5 * (-Math.pow(2, -10 * (e - 1)) + 2);
    }
  }),
  Circular: Object.freeze({
    In: function(e) {
      return 1 - Math.sqrt(1 - e * e);
    },
    Out: function(e) {
      return Math.sqrt(1 - --e * e);
    },
    InOut: function(e) {
      return (e *= 2) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
    }
  }),
  Elastic: Object.freeze({
    In: function(e) {
      return e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * (e - 1)) * Math.sin((e - 1.1) * 5 * Math.PI);
    },
    Out: function(e) {
      return e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e - 0.1) * 5 * Math.PI) + 1;
    },
    InOut: function(e) {
      return e === 0 ? 0 : e === 1 ? 1 : (e *= 2, e < 1 ? -0.5 * Math.pow(2, 10 * (e - 1)) * Math.sin((e - 1.1) * 5 * Math.PI) : 0.5 * Math.pow(2, -10 * (e - 1)) * Math.sin((e - 1.1) * 5 * Math.PI) + 1);
    }
  }),
  Back: Object.freeze({
    In: function(e) {
      var t = 1.70158;
      return e === 1 ? 1 : e * e * ((t + 1) * e - t);
    },
    Out: function(e) {
      var t = 1.70158;
      return e === 0 ? 0 : --e * e * ((t + 1) * e + t) + 1;
    },
    InOut: function(e) {
      var t = 2.5949095;
      return (e *= 2) < 1 ? 0.5 * (e * e * ((t + 1) * e - t)) : 0.5 * ((e -= 2) * e * ((t + 1) * e + t) + 2);
    }
  }),
  Bounce: Object.freeze({
    In: function(e) {
      return 1 - Nc.Bounce.Out(1 - e);
    },
    Out: function(e) {
      return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    },
    InOut: function(e) {
      return e < 0.5 ? Nc.Bounce.In(e * 2) * 0.5 : Nc.Bounce.Out(e * 2 - 1) * 0.5 + 0.5;
    }
  }),
  generatePow: function(e) {
    return e === void 0 && (e = 4), e = e < Number.EPSILON ? Number.EPSILON : e, e = e > 1e4 ? 1e4 : e, {
      In: function(t) {
        return Math.pow(t, e);
      },
      Out: function(t) {
        return 1 - Math.pow(1 - t, e);
      },
      InOut: function(t) {
        return t < 0.5 ? Math.pow(t * 2, e) / 2 : (1 - Math.pow(2 - t * 2, e)) / 2 + 0.5;
      }
    };
  }
}), q0 = function() {
  return performance.now();
}, Dce = (
  /** @class */
  function() {
    function e() {
      this._tweens = {}, this._tweensAddedDuringUpdate = {};
    }
    return e.prototype.getAll = function() {
      var t = this;
      return Object.keys(this._tweens).map(function(r) {
        return t._tweens[r];
      });
    }, e.prototype.removeAll = function() {
      this._tweens = {};
    }, e.prototype.add = function(t) {
      this._tweens[t.getId()] = t, this._tweensAddedDuringUpdate[t.getId()] = t;
    }, e.prototype.remove = function(t) {
      delete this._tweens[t.getId()], delete this._tweensAddedDuringUpdate[t.getId()];
    }, e.prototype.update = function(t, r) {
      t === void 0 && (t = q0()), r === void 0 && (r = !1);
      var n = Object.keys(this._tweens);
      if (n.length === 0)
        return !1;
      for (; n.length > 0; ) {
        this._tweensAddedDuringUpdate = {};
        for (var a = 0; a < n.length; a++) {
          var i = this._tweens[n[a]], o = !r;
          i && i.update(t, o) === !1 && !r && delete this._tweens[n[a]];
        }
        n = Object.keys(this._tweensAddedDuringUpdate);
      }
      return !0;
    }, e;
  }()
), Ph = {
  Linear: function(e, t) {
    var r = e.length - 1, n = r * t, a = Math.floor(n), i = Ph.Utils.Linear;
    return t < 0 ? i(e[0], e[1], n) : t > 1 ? i(e[r], e[r - 1], r - n) : i(e[a], e[a + 1 > r ? r : a + 1], n - a);
  },
  Bezier: function(e, t) {
    for (var r = 0, n = e.length - 1, a = Math.pow, i = Ph.Utils.Bernstein, o = 0; o <= n; o++)
      r += a(1 - t, n - o) * a(t, o) * e[o] * i(n, o);
    return r;
  },
  CatmullRom: function(e, t) {
    var r = e.length - 1, n = r * t, a = Math.floor(n), i = Ph.Utils.CatmullRom;
    return e[0] === e[r] ? (t < 0 && (a = Math.floor(n = r * (1 + t))), i(e[(a - 1 + r) % r], e[a], e[(a + 1) % r], e[(a + 2) % r], n - a)) : t < 0 ? e[0] - (i(e[0], e[0], e[1], e[1], -n) - e[0]) : t > 1 ? e[r] - (i(e[r], e[r], e[r - 1], e[r - 1], n - r) - e[r]) : i(e[a ? a - 1 : 0], e[a], e[r < a + 1 ? r : a + 1], e[r < a + 2 ? r : a + 2], n - a);
  },
  Utils: {
    Linear: function(e, t, r) {
      return (t - e) * r + e;
    },
    Bernstein: function(e, t) {
      var r = Ph.Utils.Factorial;
      return r(e) / r(t) / r(e - t);
    },
    Factorial: /* @__PURE__ */ function() {
      var e = [1];
      return function(t) {
        var r = 1;
        if (e[t])
          return e[t];
        for (var n = t; n > 1; n--)
          r *= n;
        return e[t] = r, r;
      };
    }(),
    CatmullRom: function(e, t, r, n, a) {
      var i = (r - e) * 0.5, o = (n - t) * 0.5, s = a * a, c = a * s;
      return (2 * t - 2 * r + i + o) * c + (-3 * t + 3 * r - 2 * i - o) * s + i * a + t;
    }
  }
}, Jce = (
  /** @class */
  function() {
    function e() {
    }
    return e.nextId = function() {
      return e._nextId++;
    }, e._nextId = 0, e;
  }()
), n_ = new Dce(), a_ = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = n_), this._object = t, this._group = r, this._isPaused = !1, this._pauseStart = 0, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._isDynamic = !1, this._initialRepeat = 0, this._repeat = 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = 0, this._easingFunction = Nc.Linear.None, this._interpolationFunction = Ph.Linear, this._chainedTweens = [], this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._id = Jce.nextId(), this._isChainStopped = !1, this._propertiesAreSetUp = !1, this._goToEnd = !1;
    }
    return e.prototype.getId = function() {
      return this._id;
    }, e.prototype.isPlaying = function() {
      return this._isPlaying;
    }, e.prototype.isPaused = function() {
      return this._isPaused;
    }, e.prototype.getDuration = function() {
      return this._duration;
    }, e.prototype.to = function(t, r) {
      if (r === void 0 && (r = 1e3), this._isPlaying)
        throw new Error("Can not call Tween.to() while Tween is already started or paused. Stop the Tween first.");
      return this._valuesEnd = t, this._propertiesAreSetUp = !1, this._duration = r < 0 ? 0 : r, this;
    }, e.prototype.duration = function(t) {
      return t === void 0 && (t = 1e3), this._duration = t < 0 ? 0 : t, this;
    }, e.prototype.dynamic = function(t) {
      return t === void 0 && (t = !1), this._isDynamic = t, this;
    }, e.prototype.start = function(t, r) {
      if (t === void 0 && (t = q0()), r === void 0 && (r = !1), this._isPlaying)
        return this;
      if (this._group && this._group.add(this), this._repeat = this._initialRepeat, this._reversed) {
        this._reversed = !1;
        for (var n in this._valuesStartRepeat)
          this._swapEndStartRepeatValues(n), this._valuesStart[n] = this._valuesStartRepeat[n];
      }
      if (this._isPlaying = !0, this._isPaused = !1, this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._isChainStopped = !1, this._startTime = t, this._startTime += this._delayTime, !this._propertiesAreSetUp || r) {
        if (this._propertiesAreSetUp = !0, !this._isDynamic) {
          var a = {};
          for (var i in this._valuesEnd)
            a[i] = this._valuesEnd[i];
          this._valuesEnd = a;
        }
        this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat, r);
      }
      return this;
    }, e.prototype.startFromCurrentValues = function(t) {
      return this.start(t, !0);
    }, e.prototype._setupProperties = function(t, r, n, a, i) {
      for (var o in n) {
        var s = t[o], c = Array.isArray(s), l = c ? "array" : typeof s, u = !c && Array.isArray(n[o]);
        if (!(l === "undefined" || l === "function")) {
          if (u) {
            var g = n[o];
            if (g.length === 0)
              continue;
            for (var p = [s], m = 0, I = g.length; m < I; m += 1) {
              var C = this._handleRelativeValue(s, g[m]);
              if (isNaN(C)) {
                u = !1, console.warn("Found invalid interpolation list. Skipping.");
                break;
              }
              p.push(C);
            }
            u && (n[o] = p);
          }
          if ((l === "object" || c) && s && !u) {
            r[o] = c ? [] : {};
            var A = s;
            for (var U in A)
              r[o][U] = A[U];
            a[o] = c ? [] : {};
            var g = n[o];
            if (!this._isDynamic) {
              var B = {};
              for (var U in g)
                B[U] = g[U];
              n[o] = g = B;
            }
            this._setupProperties(A, r[o], g, a[o], i);
          } else
            (typeof r[o] > "u" || i) && (r[o] = s), c || (r[o] *= 1), u ? a[o] = n[o].slice().reverse() : a[o] = r[o] || 0;
        }
      }
    }, e.prototype.stop = function() {
      return this._isChainStopped || (this._isChainStopped = !0, this.stopChainedTweens()), this._isPlaying ? (this._group && this._group.remove(this), this._isPlaying = !1, this._isPaused = !1, this._onStopCallback && this._onStopCallback(this._object), this) : this;
    }, e.prototype.end = function() {
      return this._goToEnd = !0, this.update(1 / 0), this;
    }, e.prototype.pause = function(t) {
      return t === void 0 && (t = q0()), this._isPaused || !this._isPlaying ? this : (this._isPaused = !0, this._pauseStart = t, this._group && this._group.remove(this), this);
    }, e.prototype.resume = function(t) {
      return t === void 0 && (t = q0()), !this._isPaused || !this._isPlaying ? this : (this._isPaused = !1, this._startTime += t - this._pauseStart, this._pauseStart = 0, this._group && this._group.add(this), this);
    }, e.prototype.stopChainedTweens = function() {
      for (var t = 0, r = this._chainedTweens.length; t < r; t++)
        this._chainedTweens[t].stop();
      return this;
    }, e.prototype.group = function(t) {
      return t === void 0 && (t = n_), this._group = t, this;
    }, e.prototype.delay = function(t) {
      return t === void 0 && (t = 0), this._delayTime = t, this;
    }, e.prototype.repeat = function(t) {
      return t === void 0 && (t = 0), this._initialRepeat = t, this._repeat = t, this;
    }, e.prototype.repeatDelay = function(t) {
      return this._repeatDelayTime = t, this;
    }, e.prototype.yoyo = function(t) {
      return t === void 0 && (t = !1), this._yoyo = t, this;
    }, e.prototype.easing = function(t) {
      return t === void 0 && (t = Nc.Linear.None), this._easingFunction = t, this;
    }, e.prototype.interpolation = function(t) {
      return t === void 0 && (t = Ph.Linear), this._interpolationFunction = t, this;
    }, e.prototype.chain = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return this._chainedTweens = t, this;
    }, e.prototype.onStart = function(t) {
      return this._onStartCallback = t, this;
    }, e.prototype.onEveryStart = function(t) {
      return this._onEveryStartCallback = t, this;
    }, e.prototype.onUpdate = function(t) {
      return this._onUpdateCallback = t, this;
    }, e.prototype.onRepeat = function(t) {
      return this._onRepeatCallback = t, this;
    }, e.prototype.onComplete = function(t) {
      return this._onCompleteCallback = t, this;
    }, e.prototype.onStop = function(t) {
      return this._onStopCallback = t, this;
    }, e.prototype.update = function(t, r) {
      var n = this, a;
      if (t === void 0 && (t = q0()), r === void 0 && (r = !0), this._isPaused)
        return !0;
      var i, o = this._startTime + this._duration;
      if (!this._goToEnd && !this._isPlaying) {
        if (t > o)
          return !1;
        r && this.start(t, !0);
      }
      if (this._goToEnd = !1, t < this._startTime)
        return !0;
      this._onStartCallbackFired === !1 && (this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), this._onEveryStartCallbackFired === !1 && (this._onEveryStartCallback && this._onEveryStartCallback(this._object), this._onEveryStartCallbackFired = !0);
      var s = t - this._startTime, c = this._duration + ((a = this._repeatDelayTime) !== null && a !== void 0 ? a : this._delayTime), l = this._duration + this._repeat * c, u = function() {
        if (n._duration === 0 || s > l)
          return 1;
        var A = Math.trunc(s / c), U = s - A * c, B = Math.min(U / n._duration, 1);
        return B === 0 && s === n._duration ? 1 : B;
      }, g = u(), p = this._easingFunction(g);
      if (this._updateProperties(this._object, this._valuesStart, this._valuesEnd, p), this._onUpdateCallback && this._onUpdateCallback(this._object, g), this._duration === 0 || s >= this._duration)
        if (this._repeat > 0) {
          var m = Math.min(Math.trunc((s - this._duration) / c) + 1, this._repeat);
          isFinite(this._repeat) && (this._repeat -= m);
          for (i in this._valuesStartRepeat)
            !this._yoyo && typeof this._valuesEnd[i] == "string" && (this._valuesStartRepeat[i] = // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._valuesStartRepeat[i] + parseFloat(this._valuesEnd[i])), this._yoyo && this._swapEndStartRepeatValues(i), this._valuesStart[i] = this._valuesStartRepeat[i];
          return this._yoyo && (this._reversed = !this._reversed), this._startTime += c * m, this._onRepeatCallback && this._onRepeatCallback(this._object), this._onEveryStartCallbackFired = !1, !0;
        } else {
          this._onCompleteCallback && this._onCompleteCallback(this._object);
          for (var I = 0, C = this._chainedTweens.length; I < C; I++)
            this._chainedTweens[I].start(this._startTime + this._duration, !1);
          return this._isPlaying = !1, !1;
        }
      return !0;
    }, e.prototype._updateProperties = function(t, r, n, a) {
      for (var i in n)
        if (r[i] !== void 0) {
          var o = r[i] || 0, s = n[i], c = Array.isArray(t[i]), l = Array.isArray(s), u = !c && l;
          u ? t[i] = this._interpolationFunction(s, a) : typeof s == "object" && s ? this._updateProperties(t[i], o, s, a) : (s = this._handleRelativeValue(o, s), typeof s == "number" && (t[i] = o + (s - o) * a));
        }
    }, e.prototype._handleRelativeValue = function(t, r) {
      return typeof r != "string" ? r : r.charAt(0) === "+" || r.charAt(0) === "-" ? t + parseFloat(r) : parseFloat(r);
    }, e.prototype._swapEndStartRepeatValues = function(t) {
      var r = this._valuesStartRepeat[t], n = this._valuesEnd[t];
      typeof n == "string" ? this._valuesStartRepeat[t] = this._valuesStartRepeat[t] + parseFloat(n) : this._valuesStartRepeat[t] = this._valuesEnd[t], this._valuesEnd[t] = r;
    }, e;
  }()
), ss = n_;
ss.getAll.bind(ss);
ss.removeAll.bind(ss);
ss.add.bind(ss);
ss.remove.bind(ss);
var Vce = ss.update.bind(ss);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: Mce } = Tee, Gce = (e) => e.strings === void 0, W5 = () => document.createComment(""), Z0 = (e, t, r) => {
  var i;
  const n = e._$AA.parentNode, a = t === void 0 ? e._$AB : t._$AA;
  if (r === void 0) {
    const o = n.insertBefore(W5(), a), s = n.insertBefore(W5(), a);
    r = new Mce(o, s, e, e.options);
  } else {
    const o = r._$AB.nextSibling, s = r._$AM, c = s !== e;
    if (c) {
      let l;
      (i = r._$AQ) == null || i.call(r, e), r._$AM = e, r._$AP !== void 0 && (l = e._$AU) !== s._$AU && r._$AP(l);
    }
    if (o !== a || c) {
      let l = r._$AA;
      for (; l !== o; ) {
        const u = l.nextSibling;
        n.insertBefore(l, a), l = u;
      }
    }
  }
  return r;
}, Id = (e, t, r = e) => (e._$AI(t, r), e), xce = {}, Hce = (e, t = xce) => e._$AH = t, Lce = (e) => e._$AH, rU = (e) => {
  var n;
  (n = e._$AP) == null || n.call(e, !1, !0);
  let t = e._$AA;
  const r = e._$AB.nextSibling;
  for (; t !== r; ) {
    const a = t.nextSibling;
    t.remove(), t = a;
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Df = (e, t) => {
  var n;
  const r = e._$AN;
  if (r === void 0) return !1;
  for (const a of r) (n = a._$AO) == null || n.call(a, t, !1), Df(a, t);
  return !0;
}, A1 = (e) => {
  let t, r;
  do {
    if ((t = e._$AM) === void 0) break;
    r = t._$AN, r.delete(e), e = t;
  } while ((r == null ? void 0 : r.size) === 0);
}, n9 = (e) => {
  for (let t; t = e._$AM; e = t) {
    let r = t._$AN;
    if (r === void 0) t._$AN = r = /* @__PURE__ */ new Set();
    else if (r.has(e)) break;
    r.add(e), jce(t);
  }
};
function Yce(e) {
  this._$AN !== void 0 ? (A1(this), this._$AM = e, n9(this)) : this._$AM = e;
}
function Oce(e, t = !1, r = 0) {
  const n = this._$AH, a = this._$AN;
  if (a !== void 0 && a.size !== 0) if (t) if (Array.isArray(n)) for (let i = r; i < n.length; i++) Df(n[i], !1), A1(n[i]);
  else n != null && (Df(n, !1), A1(n));
  else Df(this, e);
}
const jce = (e) => {
  e.type == Yg.CHILD && (e._$AP ?? (e._$AP = Oce), e._$AQ ?? (e._$AQ = Yce));
};
class Pce extends jg {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, r, n) {
    super._$AT(t, r, n), n9(this), this.isConnected = t._$AU;
  }
  _$AO(t, r = !0) {
    var n, a;
    t !== this.isConnected && (this.isConnected = t, t ? (n = this.reconnected) == null || n.call(this) : (a = this.disconnected) == null || a.call(this)), r && (Df(this, t), A1(this));
  }
  setValue(t) {
    if (Gce(this.t)) this.t._$AI(t, this);
    else {
      const r = [...this.t._$AH];
      r[this.i] = t, this.t._$AI(r, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Rt = () => new $ce();
class $ce {
}
const nU = /* @__PURE__ */ new WeakMap(), Mt = Og(class extends Pce {
  render(e) {
    return q;
  }
  update(e, [t]) {
    var n;
    const r = t !== this.Y;
    return r && this.Y !== void 0 && this.rt(void 0), (r || this.lt !== this.ct) && (this.Y = t, this.ht = (n = e.options) == null ? void 0 : n.host, this.rt(this.ct = e.element)), q;
  }
  rt(e) {
    if (this.isConnected || (e = void 0), typeof this.Y == "function") {
      const t = this.ht ?? globalThis;
      let r = nU.get(t);
      r === void 0 && (r = /* @__PURE__ */ new WeakMap(), nU.set(t, r)), r.get(this.Y) !== void 0 && this.Y.call(this.ht, void 0), r.set(this.Y, e), e !== void 0 && this.Y.call(this.ht, e);
    } else this.Y.value = e;
  }
  get lt() {
    var e, t;
    return typeof this.Y == "function" ? (e = nU.get(this.ht ?? globalThis)) == null ? void 0 : e.get(this.Y) : (t = this.Y) == null ? void 0 : t.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
}), Kce = ":host{position:absolute;top:0;right:0;bottom:0;left:0}.canvas{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;object-fit:contain;object-position:center center}", aU = 264 / 360, Xce = {
  near: {
    cxRatio: 0.5,
    cyRatio: 0.5,
    frameAspectRatio: aU,
    fillRatio: 0.8
  },
  far: {
    cxRatio: 0.5,
    cyRatio: 0.5,
    frameAspectRatio: aU,
    fillRatio: 0.625
  },
  initial: {
    cxRatio: 0.5,
    cyRatio: 0.5,
    frameAspectRatio: aU,
    fillRatio: (0.8 + 0.625) / 2
  }
}, zce = (e) => {
  var o;
  const { scanningBorderOpacity1: t, scanningBorderOpacity2: r, ...n } = e.to, a = new a_(e.from).to(n, e.durationMs).easing(Nc.Cubic.InOut).onUpdate(e == null ? void 0 : e.onUpdate), i = new a_({
    scanningBorderOpacity1: 1,
    scanningBorderOpacity2: 1
  }).to({ scanningBorderOpacity1: 0, scanningBorderOpacity2: 1 }, e.borderFlashDurationMs).repeat(1 / 0).yoyo(!0).easing(Nc.Linear.None).onUpdate(e == null ? void 0 : e.onUpdate);
  return (o = e == null ? void 0 : e.onStart) == null || o.call(e, e.from), a.startFromCurrentValues(), i.startFromCurrentValues(), e.durationMs === 0 && (i.end(), a.end()), () => {
    var s;
    i.end(), i.stop(), a.end(), a.stop(), (s = e.onFinish) == null || s.call(e, e.to);
  };
}, qce = (e) => {
  var r;
  const t = new a_(e.from).to(e.to, e.durationMs).easing(Nc.Cubic.InOut).onUpdate(e == null ? void 0 : e.onUpdate).onComplete(e == null ? void 0 : e.onFinish);
  return (r = e == null ? void 0 : e.onStart) == null || r.call(e, e.from), t.startFromCurrentValues(), e.durationMs === 0 && t.end(), () => {
    var n;
    t.end(), t.stop(), (n = e.onFinish) == null || n.call(e, e.to);
  };
}, ede = (e, t) => {
  if (e && t) {
    const r = e.height * t.fillRatio, n = r * t.frameAspectRatio, a = t.cxRatio * e.width, i = t.cyRatio * e.height, o = n / 2, s = r / 2;
    return { ...t, cx: a, cy: i, rx: o, ry: s };
  }
}, tde = (e, t) => {
  const r = (e == null ? void 0 : e.width) ?? 0, n = (e == null ? void 0 : e.height) ?? 0, a = n !== 0 ? r / n : 0, i = (t == null ? void 0 : t.width) ?? 0, o = (t == null ? void 0 : t.height) ?? 0, s = o !== 0 ? i / o : 0;
  return Math.min(1, s !== 0 ? a / s : 1);
}, a9 = new Kt(void 0), i9 = new Kt(void 0), o9 = new Kt(void 0), s9 = new Kt(!1), l9 = new Kt("initial"), c9 = () => a9.pipe(vt()), rde = () => o9.pipe(vt()), nde = () => s9.pipe(vt()), ade = () => i9.pipe(vt()), ide = () => l9.pipe(te((e) => Xce[e])), ode = (e) => {
  a9.next(e);
}, sde = (e) => {
  i9.next(e);
}, d9 = (e) => {
  l9.next(e);
}, lde = (e) => {
  s9.next(e);
}, cde = (e) => {
  o9.next(e);
}, dde = (e = ide(), t = c9()) => e.pipe(
  $a(t),
  te(([r, n]) => ede(n, r)),
  at((r) => !!r)
), ude = () => nde().pipe(
  $a(rde(), dde(), ade()),
  te(([e, t, r, n]) => ({
    scanning: e,
    backgroundColor: t,
    faceFinderEllipse: r,
    videoSize: n
  }))
);
var Xp = /* @__PURE__ */ ((e) => (e.Idle = "idle", e.Scanning = "scanning", e))(Xp || {}), hde = Object.defineProperty, pde = Object.getOwnPropertyDescriptor, u9 = (e) => {
  throw TypeError(e);
}, gde = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? pde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && hde(t, r, a), a;
}, sE = (e, t, r) => t.has(e) || u9("Cannot " + r), qe = (e, t, r) => (sE(e, t, "read from private field"), t.get(e)), si = (e, t, r) => t.has(e) ? u9("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), yi = (e, t, r, n) => (sE(e, t, "write to private field"), t.set(e, r), r), en = (e, t, r) => (sE(e, t, "access private method"), r), U1, k1, _1, qo, Cm, bm, Oo, N1, bC, Hr, yC, Qr, $2, h9, p9, g9, f9, lE, m9, K2, v9, X2, S9;
let i_ = class extends N {
  constructor() {
    super(), si(this, Qr), this.canvasRef = Rt(), si(this, U1, "#5acc29"), si(this, k1, "#54852c"), si(this, _1, "#3e4753"), si(this, qo), si(this, Cm, -1), si(this, bm), si(this, Oo, new ue(this, c9())), si(this, N1, new _e()), si(this, bC, new _e()), si(this, Hr), si(this, yC, !1), yi(this, qo, {
      scanningBorderOpacity1: 1,
      scanningBorderOpacity2: 1,
      borderLineDashOffset: 0,
      borderLineDashPart1: 0,
      borderLineDashPart2: 0,
      borderWidth: en(this, Qr, K2).call(this, Xp.Idle),
      faceFinderCx: 0,
      faceFinderCy: 0,
      faceFinderRx: 0,
      faceFinderRy: 0,
      circumference: 0
    }), en(this, Qr, v9).call(this).pipe(le(qe(this, bC))).subscribe();
  }
  firstUpdated(e) {
    super.firstUpdated(e), yi(this, _1, getComputedStyle(this).getPropertyValue("--gray8") ?? "#3e4753"), yi(this, U1, getComputedStyle(this).getPropertyValue("--color-primary4") ?? "#5acc29"), yi(this, k1, getComputedStyle(this).getPropertyValue("--color-primary7") ?? "#54852c"), qe(this, N1).next();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), qe(this, bC).next();
  }
  handleScanningChange(e, t = !0) {
    var r;
    (r = qe(this, bm)) == null || r.call(this), e ? en(this, Qr, f9).call(this, t) : en(this, Qr, g9).call(this, t);
  }
  render() {
    var e, t;
    return w`
      <canvas
        ${Mt(this.canvasRef)}
        class="canvas"
        width="${((e = qe(this, Oo).value) == null ? void 0 : e.width) ?? 0}"
        height="${((t = qe(this, Oo).value) == null ? void 0 : t.height) ?? 0}"
      ></canvas>
    `;
  }
  restartAnimationLoop() {
    this.stopAnimationLoop(), en(this, Qr, m9).call(this);
  }
  stopAnimationLoop() {
    window.cancelAnimationFrame(qe(this, Cm));
  }
  drawCanvas(e = qe(this, yC)) {
    qe(this, Oo).value && qe(this, Hr) && qe(this, Hr).videoSize && (this.handleScanningChange(!!qe(this, Hr).scanning, e), yi(this, yC, !0));
  }
};
U1 = /* @__PURE__ */ new WeakMap();
k1 = /* @__PURE__ */ new WeakMap();
_1 = /* @__PURE__ */ new WeakMap();
qo = /* @__PURE__ */ new WeakMap();
Cm = /* @__PURE__ */ new WeakMap();
bm = /* @__PURE__ */ new WeakMap();
Oo = /* @__PURE__ */ new WeakMap();
N1 = /* @__PURE__ */ new WeakMap();
bC = /* @__PURE__ */ new WeakMap();
Hr = /* @__PURE__ */ new WeakMap();
yC = /* @__PURE__ */ new WeakMap();
Qr = /* @__PURE__ */ new WeakSet();
$2 = function() {
  var t, r;
  const e = (t = this.canvasRef.value) == null ? void 0 : t.getContext("2d");
  if (qe(this, Oo).value && qe(this, Hr) && this.canvasRef.value && e) {
    const n = qe(this, Oo).value.width ?? 0, a = qe(this, Oo).value.height ?? 0, i = ((r = qe(this, Hr)) == null ? void 0 : r.backgroundColor) ?? "rgba(255, 255, 255, 0.6)", o = qe(this, Hr).scanning, {
      scanningBorderOpacity1: s,
      scanningBorderOpacity2: c,
      borderLineDashOffset: l,
      borderLineDashPart1: u,
      borderLineDashPart2: g,
      borderWidth: p,
      faceFinderCx: m,
      faceFinderCy: I,
      faceFinderRx: C,
      faceFinderRy: A
    } = qe(this, qo);
    e.save(), e.save(), e.clearRect(0, 0, n, a), e.fillStyle = i, e.fillRect(0, 0, n, a), e.restore(), e.save(), e.globalCompositeOperation = "destination-out", e.lineWidth = p, e.fillStyle = en(this, Qr, S9).call(this) ? "rgba(255, 255, 255, 0.3)" : "#fff", e.strokeStyle = "#fff", e.beginPath(), e.ellipse(m, I, C, A, 0, 0, 2 * Math.PI), e.closePath(), e.fill(), e.stroke(), e.restore(), e.save(), e.lineWidth = p, e.strokeStyle = "rgba(255, 255, 255, 0.2)", e.beginPath(), e.ellipse(m, I, C, A, 0, 0, 2 * Math.PI), e.closePath(), e.stroke(), e.restore(), o ? (e.save(), e.lineDashOffset = l, e.lineCap = "round", e.lineWidth = p, e.strokeStyle = qe(this, k1), e.globalAlpha = c, e.beginPath(), e.setLineDash([u, g]), e.ellipse(m, I, C, A, 0, 0, 2 * Math.PI), e.closePath(), e.stroke(), e.restore(), e.save(), e.lineDashOffset = l, e.lineCap = "round", e.lineWidth = p, e.strokeStyle = qe(this, U1), e.globalAlpha = s, e.beginPath(), e.setLineDash([u, g]), e.ellipse(m, I, C, A, 0, 0, 2 * Math.PI), e.closePath(), e.stroke(), e.restore()) : (e.save(), e.lineDashOffset = l, e.lineCap = "round", e.lineWidth = p, e.strokeStyle = qe(this, _1), e.beginPath(), e.setLineDash([u, g]), e.ellipse(m, I, C, A, 0, 0, 2 * Math.PI), e.closePath(), e.stroke(), e.restore()), e.restore();
  }
};
h9 = function(e, t) {
  return en(this, Qr, p9).call(this, e, t).pipe(
    ae(({ width: r, height: n }) => {
      ode({
        width: window.devicePixelRatio * r,
        height: window.devicePixelRatio * n
      });
    })
  );
};
p9 = function(e, t) {
  return Bl(e, t).pipe(Wt((r) => aw({ el: r })));
};
g9 = function(e = !0) {
  var s, c, l, u;
  const t = en(this, Qr, X2).call(this), r = (((s = qe(this, Hr)) == null ? void 0 : s.faceFinderEllipse.rx) ?? 0) * t, n = (((c = qe(this, Hr)) == null ? void 0 : c.faceFinderEllipse.ry) ?? 0) * t, a = ((l = qe(this, Hr)) == null ? void 0 : l.faceFinderEllipse.cx) ?? 0, i = ((u = qe(this, Hr)) == null ? void 0 : u.faceFinderEllipse.cy) ?? 0, o = en(this, Qr, lE).call(this, r, n);
  yi(this, bm, qce({
    from: qe(this, qo),
    to: {
      borderLineDashOffset: -o / 16,
      borderLineDashPart1: o / 8,
      borderLineDashPart2: o / 8,
      borderWidth: en(this, Qr, K2).call(this, Xp.Idle),
      faceFinderCx: a ?? 0,
      faceFinderCy: i ?? 0,
      faceFinderRx: r ?? 0,
      faceFinderRy: n ?? 0,
      circumference: o
    },
    durationMs: e ? 150 : 0,
    onStart: () => {
      this.restartAnimationLoop();
    },
    onUpdate: (g) => {
      yi(this, qo, {
        ...qe(this, qo),
        ...g
      });
    },
    onFinish: () => {
      this.stopAnimationLoop(), en(this, Qr, $2).call(this);
    }
  }));
};
f9 = function(e = !0) {
  var c, l, u, g;
  const t = en(this, Qr, X2).call(this), r = en(this, Qr, K2).call(this, Xp.Scanning) ?? 0, n = ((((c = qe(this, Hr)) == null ? void 0 : c.faceFinderEllipse.rx) ?? 0) - r / 2) * t, a = ((((l = qe(this, Hr)) == null ? void 0 : l.faceFinderEllipse.ry) ?? 0) - r / 2) * t, i = ((u = qe(this, Hr)) == null ? void 0 : u.faceFinderEllipse.cx) ?? 0, o = ((g = qe(this, Hr)) == null ? void 0 : g.faceFinderEllipse.cy) ?? 0, s = en(this, Qr, lE).call(this, n, a);
  yi(this, bm, zce({
    from: qe(this, qo),
    to: {
      borderLineDashPart1: s / 4,
      borderLineDashPart2: 0,
      borderWidth: r,
      faceFinderCx: i,
      faceFinderCy: o,
      faceFinderRx: n,
      faceFinderRy: a,
      circumference: s
    },
    durationMs: e ? 150 : 0,
    borderFlashDurationMs: 1e3,
    onStart: () => {
      this.restartAnimationLoop();
    },
    onUpdate: (p) => {
      yi(this, qo, {
        ...qe(this, qo),
        ...p
      });
    },
    onFinish: () => {
      this.stopAnimationLoop(), en(this, Qr, $2).call(this);
    }
  }));
};
lE = function(e, t) {
  return Math.PI * (3 * (e + t) - Math.sqrt((3 * e + t) * (e + 3 * t)));
};
m9 = function() {
  const e = (t) => {
    Vce(t), en(this, Qr, $2).call(this), yi(this, Cm, requestAnimationFrame(e));
  };
  yi(this, Cm, requestAnimationFrame(e));
};
K2 = function(e) {
  var r;
  const t = en(this, Qr, X2).call(this) * (((r = qe(this, Oo).value) == null ? void 0 : r.height) ?? 0);
  switch (e) {
    case Xp.Scanning:
      return Math.ceil(16 * t / 768);
    case Xp.Idle:
    default:
      return Math.ceil(8 * t / 768);
  }
};
v9 = function() {
  const e = en(this, Qr, h9).call(this, this.canvasRef, qe(this, N1)), t = ude().pipe(
    ae((r) => {
      yi(this, Hr, r);
    })
  );
  return ps(e, t).pipe(
    Xc(qu),
    ae(() => {
      this.drawCanvas();
    })
  );
};
X2 = function() {
  var e;
  return tde(qe(this, Oo).value, (e = qe(this, Hr)) == null ? void 0 : e.videoSize);
};
S9 = function() {
  var e;
  return (e = qe(this, Hr)) == null ? void 0 : e.backgroundColor;
};
i_.styles = [...N.styles, Gt(Kce)];
i_ = gde([
  P("x-ds-face-finder"),
  be()
], i_);
var yp, t2, I9, wv, Av;
class fde {
  constructor(t) {
    E(this, t2);
    E(this, yp);
    E(this, wv, () => {
      S(this, yp).fullscreenChange$.next(this.isFullscreen());
    });
    E(this, Av, () => {
      S(this, yp).fullscreenError$.next();
    });
    G(this, yp, t), O(this, t2, I9).call(this);
  }
  cleanUp() {
    document.removeEventListener("mozfullscreenchange", S(this, wv)), document.removeEventListener("mozfullscreenerror", S(this, Av));
  }
  async requestFullscreen(t) {
    var r;
    await ((r = t.mozRequestFullScreen) == null ? void 0 : r.call(t));
  }
  async exitFullscreen() {
    await document.mozCancelFullScreen();
  }
  isFullscreen() {
    return !!document.mozFullScreenElement;
  }
  isFullscreenEnabled() {
    return document.mozFullScreenEnabled;
  }
}
yp = new WeakMap(), t2 = new WeakSet(), I9 = function() {
  document.addEventListener("mozfullscreenchange", S(this, wv)), document.addEventListener("mozfullscreenerror", S(this, Av));
}, wv = new WeakMap(), Av = new WeakMap();
var wp, r2, C9, Uv, kv;
class mde {
  constructor(t) {
    E(this, r2);
    E(this, wp);
    E(this, Uv, () => {
      S(this, wp).fullscreenChange$.next(this.isFullscreen());
    });
    E(this, kv, () => {
      S(this, wp).fullscreenError$.next();
    });
    G(this, wp, t), O(this, r2, C9).call(this);
  }
  cleanUp() {
    document.removeEventListener("fullscreenchange", S(this, Uv)), document.removeEventListener("fullscreenerror", S(this, kv));
  }
  async requestFullscreen(t) {
    await t.requestFullscreen();
  }
  async exitFullscreen() {
    await document.exitFullscreen();
  }
  isFullscreen() {
    return !!document.fullscreenElement;
  }
  isFullscreenEnabled() {
    return !!document.fullscreenEnabled;
  }
}
wp = new WeakMap(), r2 = new WeakSet(), C9 = function() {
  document.addEventListener("fullscreenchange", S(this, Uv)), document.addEventListener("fullscreenerror", S(this, kv));
}, Uv = new WeakMap(), kv = new WeakMap();
var Ap, n2, b9, _v, Nv;
class vde {
  constructor(t) {
    E(this, n2);
    E(this, Ap);
    E(this, _v, () => {
      S(this, Ap).fullscreenChange$.next(this.isFullscreen());
    });
    E(this, Nv, () => {
      S(this, Ap).fullscreenError$.next();
    });
    G(this, Ap, t), O(this, n2, b9).call(this);
  }
  cleanUp() {
    document.removeEventListener("webkitfullscreenchange", S(this, _v)), document.removeEventListener("webkitfullscreenerror", S(this, Nv));
  }
  async requestFullscreen(t) {
    var r;
    await ((r = t.webkitRequestFullscreen) == null ? void 0 : r.call(t));
  }
  async exitFullscreen() {
    await document.webkitExitFullscreen();
  }
  isFullscreen() {
    return !!document.webkitFullscreenElement;
  }
  isFullscreenEnabled() {
    return document.webkitFullscreenEnabled;
  }
}
Ap = new WeakMap(), n2 = new WeakSet(), b9 = function() {
  document.addEventListener("webkitfullscreenchange", S(this, _v)), document.addEventListener("webkitfullscreenerror", S(this, Nv));
}, _v = new WeakMap(), Nv = new WeakMap();
var Si, Zv, Bv, a2, y9;
const $l = class $l {
  constructor() {
    E(this, a2);
    E(this, Si);
    E(this, Zv, new Kt(!1));
    E(this, Bv, new _e());
    this.fullscreenChange$ = S(this, Zv).asObservable(), this.fullscreenError$ = S(this, Bv).asObservable();
    try {
      G(this, Si, O(this, a2, y9).call(this, {
        fullscreenChange$: S(this, Zv),
        fullscreenError$: S(this, Bv)
      }));
    } catch {
    }
  }
  static getInstance() {
    return $l.instance || ($l.instance = new $l()), $l.instance;
  }
  static resetInstance() {
    var t, r;
    (r = (t = $l.instance) == null ? void 0 : t.getStrategy()) == null || r.cleanUp(), $l.instance = void 0;
  }
  async enterFullscreen(t = document.documentElement) {
    var r;
    return (r = S(this, Si)) == null ? void 0 : r.requestFullscreen(t);
  }
  async exitFullscreen() {
    var t;
    return (t = S(this, Si)) == null ? void 0 : t.exitFullscreen();
  }
  isFullscreen() {
    var t;
    return !!((t = S(this, Si)) != null && t.isFullscreen());
  }
  isFullscreenEnabled() {
    var t;
    return !!((t = S(this, Si)) != null && t.isFullscreenEnabled());
  }
  getStrategy() {
    return S(this, Si);
  }
  async toggleFullscreenMode(t = document.documentElement) {
    var n, a, i;
    ((n = S(this, Si)) == null ? void 0 : n.isFullscreen()) ? await ((a = S(this, Si)) == null ? void 0 : a.exitFullscreen()) : await ((i = S(this, Si)) == null ? void 0 : i.requestFullscreen(t));
  }
};
Si = new WeakMap(), Zv = new WeakMap(), Bv = new WeakMap(), a2 = new WeakSet(), y9 = function(t) {
  if (typeof document.fullscreenEnabled < "u")
    return new mde(t);
  if (typeof document.webkitFullscreenEnabled < "u")
    return new vde(t);
  if (typeof document.mozFullScreenEnabled < "u")
    return new fde(t);
  throw new Error("Fullscreen API is not supported");
};
let ml = $l;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function Sde(e, t, r) {
  return e ? t(e) : r == null ? void 0 : r(e);
}
var Ide = Object.defineProperty, Cde = Object.getOwnPropertyDescriptor, w9 = (e) => {
  throw TypeError(e);
}, bde = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Cde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ide(t, r, a), a;
}, A9 = (e, t, r) => t.has(e) || w9("Cannot " + r), iU = (e, t, r) => (A9(e, t, "read from private field"), r ? r.call(e) : t.get(e)), oU = (e, t, r) => t.has(e) ? w9("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), yde = (e, t, r) => (A9(e, t, "access private method"), r), o_, wC, s_, U9;
let l_ = class extends N {
  constructor() {
    super(...arguments), oU(this, s_), oU(this, o_, yde(this, s_, U9).call(this)), oU(this, wC, new ue(this, iU(this, o_)));
  }
  render() {
    return w`
      ${Sde(
      !iU(this, wC).value,
      () => w`<div class="pulsing-underlay"></div>`,
      () => q
    )}
      <x-ds-button
        class="button"
        data-type="${De.Tertiary}"
        data-shape="${ya.Round}"
        data-padding="false"
        @jclick="${() => {
      var e;
      (e = this.elRef) != null && e.value && ml.getInstance().toggleFullscreenMode(this.elRef.value);
    }}"
      >
        <span class="${iU(this, wC).value ? "icon-collapse" : "icon-expand"}"></span>
      </x-ds-button>
    `;
  }
};
o_ = /* @__PURE__ */ new WeakMap();
wC = /* @__PURE__ */ new WeakMap();
s_ = /* @__PURE__ */ new WeakSet();
U9 = function() {
  const e = ml.getInstance();
  return ps(e.fullscreenChange$, e.fullscreenError$).pipe(te(() => e.isFullscreen()));
};
l_.styles = [
  ...N.styles,
  ee`
      :host {
        position: relative;
      }

      .pulsing-underlay {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        background-color: var(--color-primary4);
        border-radius: 50%;
        transform: translate(-50%, -50%) scale(1);
        opacity: 0;
        animation: pulse 1.5s infinite;
        pointer-events: none;
      }

      .button {
        position: relative;
      }

      @keyframes pulse {
        0% {
          transform: translate(-50%, -50%) scale(1);
          opacity: 1;
        }
        100% {
          transform: translate(-50%, -50%) scale(1.5);
          opacity: 0;
        }
      }
    `
];
l_ = bde([
  be(),
  P("x-ds-fullscreen-mode-button")
], l_);
const wde = ":host{display:inline-flex}svg{width:100%;height:100%}.group--oval{opacity:1;will-change:opacity;animation:oval-light-out 5s;animation-iteration-count:infinite}.group--oval-success{transform:translate(-2.25pt,-3pt) scale(1.05);opacity:0;will-change:opacity,transform;animation:oval-light-in 5s;animation-iteration-count:infinite;color:var(--color-primary4)}.jumio-premium{animation:jumioPremium 5s step-end;animation-iteration-count:infinite}.group--face{bottom:0;left:0;transform:translate(-24pt,49pt) scale(.815);animation:shift-inside 5s;animation-iteration-count:infinite}@keyframes oval-light-out{0%{opacity:1}45%{opacity:1}50%,to{opacity:0}}@keyframes oval-light-in{0%{transform:translate(-2.25pt,-3pt) scale(1.05);opacity:0}45%{transform:translate(-2.25pt,-3pt) scale(1.05);opacity:0}60%,to{transform:translate(.25pt) scale(1);opacity:1}}@keyframes shift-inside{0%{opacity:0;transform:translate(-24pt,49pt) scale(.815)}25%{opacity:.4;transform:translate(7pt,20pt) scale(.815)}40%,to{opacity:1;transform:translate(-1pt,4pt) scale(1)}}@keyframes jumioPremium{60%{fill:#b3e69c}63%{fill:#3e4753}66%{fill:#b3e69c}69%{fill:transparent}}";
var Ade = Object.defineProperty, Ude = Object.getOwnPropertyDescriptor, k9 = (e) => {
  throw TypeError(e);
}, _9 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Ude(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ade(t, r, a), a;
}, kde = (e, t, r) => t.has(e) || k9("Cannot " + r), _de = (e, t, r) => t.has(e) ? k9("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), E5 = (e, t, r) => (kde(e, t, "access private method"), r), AC, N9, Z9;
let Z1 = class extends N {
  constructor() {
    super(...arguments), _de(this, AC), this.isPremium = !1;
  }
  render() {
    return CS`
    <svg width="128" height="160" viewBox="0 0 128 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="oval">
          <rect x="0" y="0" width="128" height="160" fill="#000" />
          <ellipse cx="63.8" cy="79.75" rx="64" ry="80" fill="#fff" />
        </mask>
        <g mask="url(#oval)">
            ${E5(this, AC, Z9).call(this)}
            <g class="group group--face">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M51.6078 118.38L51.3203 122.684C51.0632 126.533 50.3798 130.471 48.101 133.584C47.2207 134.787 46.2482 135.727 45.3598 135.727C44.2735 135.727 45.6404 138.839 45.6404 138.839C45.6404 138.839 52.1073 142.525 65.1466 142.525C78.1859 142.525 84.8799 139.122 84.8799 139.122C84.8799 139.122 85.9223 137.255 83.4023 135.727C80.8822 134.2 80.36 131.391 80.36 131.391L80.0186 129.791C79.6865 128.235 79.4673 126.658 79.3628 125.07L78.9223 118.38H51.6078Z" fill="#DFE5EC"/>
                <path opacity="0.402232" fill-rule="evenodd" clip-rule="evenodd" d="M51.5253 122.684L51.8128 118.38H58.7496H79.1274L79.5678 125.07C79.6723 126.658 79.8915 128.235 80.2236 129.791L80.565 131.391C80.565 131.391 81.0477 133.987 83.3243 135.545C82.5015 135.752 81.2386 135.737 80.576 135.73C80.4727 135.728 80.384 135.727 80.3138 135.727C63.104 135.727 57.8242 129.969 54.7005 126.562C53.4671 125.217 52.5698 124.239 51.407 124.126C51.4546 123.645 51.4933 123.164 51.5253 122.684Z" fill="#9AA4AF"/>
                <path d="M99.2624 74.9213C99.2624 80.9203 97.9646 90.7968 102.873 90.7968C107.781 90.7968 117.036 80.9203 117.036 74.9213C117.036 68.9222 113.057 64.0591 108.149 64.0591C103.241 64.0591 99.2624 68.9222 99.2624 74.9213Z" fill="#DFE5EC"/>
                <path d="M31.9012 74.9213C31.9012 80.9203 33.199 90.7968 28.2909 90.7968C23.3829 90.7968 14.1277 80.9203 14.1277 74.9213C14.1277 68.9222 18.1064 64.0591 23.0144 64.0591C27.9225 64.0591 31.9012 68.9222 31.9012 74.9213Z" fill="#DFE5EC"/>
                <path d="M101.034 75.4261C101.034 79.5504 100.15 86.3405 103.495 86.3405C106.84 86.3405 113.148 79.5504 113.148 75.4261C113.148 71.3017 110.436 67.9583 107.091 67.9583C103.746 67.9583 101.034 71.3017 101.034 75.4261Z" fill="#C6CDD5"/>
                <path d="M30.1291 75.4261C30.1291 79.5504 31.0136 86.3405 27.6685 86.3405C24.3235 86.3405 18.0156 79.5504 18.0156 75.4261C18.0156 71.3017 20.7273 67.9583 24.0724 67.9583C27.4174 67.9583 30.1291 71.3017 30.1291 75.4261Z" fill="#C6CDD5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M65.5041 16.154C88.0503 16.154 106.328 32.1748 106.328 51.9374V62.945H106.231V68.8201C106.231 69.0369 106.241 69.3995 106.255 69.8901C106.439 76.4714 107.267 106.073 92.8734 115.383C83.7193 121.303 80.8988 122.501 79.3926 123.141C78.354 123.582 77.9402 123.758 76.5056 125.034C73.5982 127.619 71.7103 127.597 67.5485 127.549C66.9359 127.542 66.2741 127.535 65.5525 127.535C64.8295 127.535 64.1681 127.542 63.5573 127.549C59.4169 127.597 57.6028 127.619 54.6962 125.034C53.276 123.771 52.8246 123.586 51.7709 123.154C50.2167 122.518 47.352 121.344 38.1347 115.383C23.7411 106.073 24.5694 76.4714 24.7535 69.8901C24.7672 69.3995 24.7774 69.0369 24.7774 68.8201V62.945H24.6805V51.9374C24.6805 32.1748 42.9579 16.154 65.5041 16.154Z" fill="#DFE5EC"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M125.796 166C117.829 166 9.69055 166 1.72375 166C1.83814 140.385 25.7959 138.536 47.0416 134.828C49.4139 138.112 59.8135 140.385 65.7473 140.385C71.7853 140.385 79.531 138.032 81.8461 134.654C103.564 138.153 125.759 140.385 125.796 166Z" fill="#757F8A"/>
            </g>
            <g class="group ${tn({ "group--oval": !this.isPremium })}" >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.91482 53.2149C4.28001 53.2149 3.82132 52.607 4.00199 51.9985C9.85957 32.2684 21.7281 16.2293 36.8029 7.41155C37.4445 7.03624 38.2396 7.50601 38.2396 8.24936C38.2396 8.60028 38.0519 8.92342 37.7491 9.10078C23.1631 17.6439 11.57 33.2096 5.83794 52.5221C5.71654 52.9311 5.34148 53.2149 4.91482 53.2149ZM5.02079 107.14C4.38442 107.14 3.9255 107.75 4.10906 108.36C10.0034 127.926 21.8194 143.824 36.8029 152.588C37.4445 152.964 38.2396 152.494 38.2396 151.751C38.2396 151.4 38.0519 151.077 37.7491 150.899C23.2515 142.408 11.7106 126.979 5.94281 107.829C5.82018 107.421 5.44602 107.14 5.02079 107.14ZM122.09 107.14C121.665 107.14 121.291 107.421 121.168 107.829C115.401 126.979 103.86 142.408 89.3621 150.899C89.0593 151.077 88.8716 151.4 88.8716 151.751C88.8716 152.494 89.6666 152.964 90.3083 152.588C105.292 143.824 117.108 127.926 123.002 108.36C123.186 107.75 122.727 107.14 122.09 107.14ZM122.196 53.2149C122.831 53.2149 123.29 52.607 123.109 51.9985C117.252 32.2684 105.383 16.2293 90.3083 7.41156C89.6666 7.03624 88.8716 7.50601 88.8716 8.24936C88.8716 8.60028 89.0593 8.92342 89.3621 9.10078C103.948 17.6439 115.541 33.2096 121.273 52.5221C121.395 52.9311 121.77 53.2149 122.196 53.2149Z" fill="#3E4753"/>
            </g>
            ${E5(this, AC, N9).call(this)}
        </g>
    </svg>
    `;
  }
};
AC = /* @__PURE__ */ new WeakSet();
N9 = function() {
  return this.isPremium ? q : CS`
        <g class="group group--oval-success">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.3294 53.2149C6.97746 53.2149 4.5528 50.0076 5.69405 46.8559C11.0126 32.1684 19.7569 19.8603 30.6415 11.5499C33.8904 9.06937 38.2396 11.589 38.2396 15.6765C38.2396 17.4259 37.3784 19.0516 36.0032 20.1327C27.2046 27.0495 19.8469 37.2155 15.2289 49.7158C14.4657 51.7817 12.5318 53.2149 10.3294 53.2149ZM10.4596 107.14C7.09837 107.14 4.67211 110.363 5.83038 113.518C11.1613 128.041 19.8494 140.21 30.6416 148.45C33.8904 150.931 38.2396 148.411 38.2396 144.323C38.2396 142.574 37.3785 140.948 36.0032 139.867C27.283 133.012 19.9779 122.965 15.3528 110.617C14.5831 108.562 12.6541 107.14 10.4596 107.14ZM116.652 107.14C114.457 107.14 112.528 108.562 111.758 110.617C107.133 122.965 99.8282 133.012 91.108 139.867C89.7328 140.948 88.8716 142.574 88.8716 144.323C88.8716 148.411 93.2208 150.931 96.4697 148.45C107.262 140.21 115.95 128.04 121.281 113.518C122.439 110.363 120.013 107.14 116.652 107.14ZM116.782 53.2149C120.134 53.2149 122.558 50.0076 121.417 46.8559C116.099 32.1684 107.354 19.8604 96.4697 11.55C93.2209 9.06946 88.8716 11.5891 88.8716 15.6766C88.8716 17.426 89.7328 19.0517 91.108 20.1328C99.9065 27.0496 107.264 37.2155 111.882 49.7158C112.645 51.7818 114.579 53.2149 116.782 53.2149Z"
            fill="currentColor"
          />
        </g>
      `;
};
Z9 = function() {
  return this.isPremium ? CS`<rect class="jumio-premium" x="0" y="0" width="128" height="160" />` : q;
};
Z1.styles = [...N.styles, Gt(wde)];
_9([
  M({
    attribute: "data-jumio-premium",
    type: Boolean,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Z1.prototype, "isPremium", 2);
Z1 = _9([
  P("x-ds-guidance-face-animation")
], Z1);
class Nde extends CustomEvent {
  constructor(t) {
    super("imageviewerremove", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var Zde = /* @__PURE__ */ ((e) => (e.ImageViewerToggle = "imageviewertoggle", e))(Zde || {});
class B9 extends CustomEvent {
  constructor() {
    super("imageviewertoggle", {
      bubbles: !0,
      composed: !0
    });
  }
}
var Bde = Object.defineProperty, Wde = Object.getOwnPropertyDescriptor, W9 = (e) => {
  throw TypeError(e);
}, cE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Wde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Bde(t, r, a), a;
}, E9 = (e, t, r) => t.has(e) || W9("Cannot " + r), Q5 = (e, t, r) => (E9(e, t, "read from private field"), r ? r.call(e) : t.get(e)), F5 = (e, t, r) => t.has(e) ? W9("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), mi = (e, t, r) => (E9(e, t, "access private method"), r), da, Q9, F9, T9, R9, dE, uE, D9, B1, UC;
let ym = class extends N {
  constructor() {
    super(...arguments), F5(this, da), this.index = 0, F5(this, UC, (e) => {
      e.code === "Escape" ? mi(this, da, B1).call(this) : e.code === "ArrowLeft" ? mi(this, da, uE).call(this) : e.code === "ArrowRight" && mi(this, da, dE).call(this);
    });
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("keydown", Q5(this, UC));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.removeEventListener("keydown", Q5(this, UC));
  }
  render() {
    return w`
      <div class="image-viewer">
        <div class="image-viewer-header">
          <span class="image-viewer-title">${mi(this, da, T9).call(this)}</span>
          <span
            class="icon icon-close"
            @click="${() => {
      mi(this, da, B1).call(this);
    }}"
          ></span>
        </div>
        <slot
          class="image-viewer-buffer"
          style="${mi(this, da, F9).call(this)}"
          name="image"
          @slotchange="${() => {
      mi(this, da, Q9).call(this);
    }}"
        ></slot>
        <div class="image-viewer-footer">
          <span></span>
          ${mi(this, da, R9).call(this)}
          <span
            class="icon icon-delete delete-icon"
            @click="${() => {
      mi(this, da, D9).call(this);
    }}"
          ></span>
        </div>
      </div>
    `;
  }
};
da = /* @__PURE__ */ new WeakSet();
Q9 = function() {
  this.index = Math.min(this.index, this.images.length - 1), this.images.length === 0 && mi(this, da, B1).call(this), this.requestUpdate();
};
F9 = function() {
  return `transform: translateX(${this.index * -100}%)`;
};
T9 = function() {
  const e = this.images[this.index];
  return e ? w`${e.alt}` : q;
};
R9 = function() {
  return w`<div class="image-viewer-pager">
      <span
        class="icon icon-chevron-direction-left"
        @click="${() => {
    mi(this, da, uE).call(this);
  }}"
      ></span>
      ${this.index + 1} / ${this.images.length}
      <span
        class="icon icon-chevron-direction-right"
        @click="${() => {
    mi(this, da, dE).call(this);
  }}"
      ></span>
    </div>`;
};
dE = function() {
  this.index = Math.min(this.index + 1, this.images.length - 1);
};
uE = function() {
  this.index = Math.max(this.index - 1, 0);
};
D9 = function() {
  const e = this.images[this.index];
  if (e) {
    const t = e.getAttribute("data-id") ?? "default-id", r = new Nde({ name: t });
    this.dispatchEvent(r);
  }
};
B1 = function() {
  this.dispatchEvent(new B9());
};
UC = /* @__PURE__ */ new WeakMap();
ym.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .image-viewer {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        color: var(--white);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        top: 0;
        left: 0;
        pointer-events: auto;
      }

      .image-viewer-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25em 2em;
      }

      .image-viewer-buffer {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 80%;
        flex-flow: column wrap;
      }

      ::slotted(img) {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        overflow: hidden;
      }

      .image-viewer-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1em;
      }

      .image-viewer-pager {
        display: flex;
        align-items: center;
        gap: 0.75em;
        font-size: 1.125em;
      }

      .image-viewer-pager .icon {
        color: var(--gray6);
        font-size: 0.75em;
      }

      .icon {
        cursor: pointer;
      }
      .delete-icon {
        cursor: pointer;
        font-size: 2.5em;
      }
    `
];
cE([
  M({
    attribute: "data-index",
    type: Number,
    reflect: !0
  })
], ym.prototype, "index", 2);
cE([
  dr({
    slot: "image",
    flatten: !0
  })
], ym.prototype, "images", 2);
ym = cE([
  P("x-ds-image-viewer")
], ym);
var W1 = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(W1 || {}), Ede = Object.defineProperty, Qde = Object.getOwnPropertyDescriptor, J9 = (e) => {
  throw TypeError(e);
}, Zl = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Qde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ede(t, r, a), a;
}, hE = (e, t, r) => t.has(e) || J9("Cannot " + r), Fde = (e, t, r) => (hE(e, t, "read from private field"), r ? r.call(e) : t.get(e)), T5 = (e, t, r) => t.has(e) ? J9("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), R5 = (e, t, r, n) => (hE(e, t, "write to private field"), t.set(e, r), r), D5 = (e, t, r) => (hE(e, t, "access private method"), r), ef, kC, V9, M9;
let oo = class extends N {
  constructor() {
    super(...arguments), T5(this, kC), this.size = W1.Medium, this.placeholder = "", this.disabled = !1, this.error = !1, this.errorMessage = "", this.infoMessage = "", this.inputRef = Rt(), T5(this, ef, !1);
  }
  render() {
    return w`
      ${D5(this, kC, V9).call(this)}
      <div
        data-qa-id="input-container"
        data-size="${this.size}"
        data-error="${this.error || this.errorMessage.length > 0}"
        data-disabled="${this.disabled}"
        data-focused="${Fde(this, ef)}"
        class="input-container"
        @click="${() => {
      D5(this, kC, M9).call(this);
    }}"
      >
        <div
          class="icon-container ${tn({
      hidden: this.preIconElements.length === 0
    })}"
          data-qa-id="pre-icon"
        >
          <slot
            name="pre-icon"
            @slotchange="${() => {
      this.requestUpdate();
    }}"
          ></slot>
        </div>
        <input
          ${Mt(this.inputRef)}
          @blur="${() => {
      R5(this, ef, !1), this.requestUpdate();
    }}"
          @focus="${() => {
      R5(this, ef, !0), this.requestUpdate();
    }}"
          placeholder="${this.placeholder}"
          data-qa-id="input"
          class="input"
          ?disabled=${this.disabled}
        />
        <div
          class="icon-container ${tn({
      hidden: this.postIconElements.length === 0
    })}"
          data-qa-id="post-icon"
        >
          <slot
            name="post-icon"
            @slotchange="${() => {
      this.requestUpdate();
    }}"
          ></slot>
        </div>
      </div>
    `;
  }
};
ef = /* @__PURE__ */ new WeakMap();
kC = /* @__PURE__ */ new WeakSet();
V9 = function() {
  return this.errorMessage ? w`<div data-qa-id="error-message" class="message message--error">${this.errorMessage}</div>` : this.infoMessage ? w`<div data-qa-id="info-message" class="message message--info">${this.infoMessage}</div>` : q;
};
M9 = function() {
  var e;
  (e = this.inputRef.value) == null || e.focus();
};
oo.styles = [
  ...N.styles,
  ee`
      .hidden {
        display: none;
      }

      .input-container {
        position: relative;
        display: flex;
        flex-direction: row;
        background-color: var(--white);
        align-items: center;
        border-radius: 0.5em;
        box-shadow: 0 0 0 0.0625em var(--color-secondary6);
        column-gap: 0.625em; /* 10 / 16 */
        padding-left: 0.75em;
        padding-right: 0.75em;
        margin-top: 0.125em;
      }

      .input-container:hover {
        background: var(--color-secondary1);
        box-shadow: 0 0 0 0.125em var(--color-secondary7);
      }

      .input-container:active {
        background: var(--color-secondary4);
      }

      .input-container[data-focused='true'] {
        box-shadow: 0 0 0 0.125em var(--color-secondary7);
      }

      .input-container[data-disabled='true'] {
        pointer-events: none;
        box-shadow: 0 0 0 0.0625em var(--color-secondary3);
      }

      .input-container[data-error='true'] {
        box-shadow: 0 0 0 0.125em var(--color-secondary6);
      }

      .input-container[data-size='small'] {
        height: 2.375em; /* 38 / 16 */
        max-height: 2.375em; /* 38 / 16 */
      }

      .input-container[data-size='medium'] {
        height: 2.875em; /* 46 / 16 */
        max-height: 2.875em; /* 46 / 16 */
      }

      .input {
        background: transparent;
        padding: 0.75em 0; /* 12 / 16 */
        color: var(--color-secondary12);
        outline: none;
        font-size: 1em;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border: none;
        font-weight: 400;
      }

      .input:disabled {
        color: var(--color-secondary4);
      }

      .input::placeholder {
        color: var(--color-secondary5);
        opacity: 1;
      }

      .input:disabled::placeholder {
        color: var(--color-secondary4);
        opacity: 1;
      }

      .message {
        font-style: normal;
        font-weight: 400;
        font-size: 0.75em;
        line-height: 1em;
        padding: 0.3125em 0.25em;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }

      .message--error {
        color: var(--semantic-red-40);
      }

      .message--info {
        color: var(--color-secondary6);
      }

      .icon-container {
        display: contents;
        color: var(--color-secondary6);
      }

      [data-disabled='true'] .icon-container {
        color: var(--color-secondary4);
      }

      [data-error='true'] .icon-container {
        color: var(--semantic-red-40);
      }
    `
];
Zl([
  M({
    attribute: "data-size",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => Object.values(W1).includes(e) ? e : W1.Medium,
      toAttribute: (e) => e.toString()
    }
  })
], oo.prototype, "size", 2);
Zl([
  M({
    attribute: "data-placeholder",
    type: String,
    reflect: !0
  })
], oo.prototype, "placeholder", 2);
Zl([
  M({
    attribute: "data-disabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], oo.prototype, "disabled", 2);
Zl([
  M({
    attribute: "data-error",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], oo.prototype, "error", 2);
Zl([
  M({
    attribute: "data-error-message",
    type: String,
    reflect: !0
  })
], oo.prototype, "errorMessage", 2);
Zl([
  M({
    attribute: "data-info-message",
    type: String,
    reflect: !0
  })
], oo.prototype, "infoMessage", 2);
Zl([
  dr({ slot: "pre-icon", flatten: !0 })
], oo.prototype, "preIconElements", 2);
Zl([
  dr({ slot: "post-icon", flatten: !0 })
], oo.prototype, "postIconElements", 2);
oo = Zl([
  P("x-ds-input")
], oo);
var Tde = Object.defineProperty, Rde = Object.getOwnPropertyDescriptor, z2 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Rde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Tde(t, r, a), a;
};
let zp = class extends N {
  constructor() {
    super(...arguments), this.itemRenderer = (e) => w`<div>${e.item.value}</div>`, this.data = [];
  }
  render() {
    const t = (this.dataFlattenerCallback ? this.dataFlattenerCallback(this.data) : []).map((r, n, a) => this.itemRenderer ? this.itemRenderer({ item: r, isFirst: n === 0, isLast: n === a.length - 1 }) : q);
    return w`
      <div class="list-container">
        <slot name="before"></slot>
        <div class="list-wrapper">
          <div class="list-wrapper-scrollable">${t}</div>
        </div>
        <slot name="after"></slot>
      </div>
    `;
  }
};
zp.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .list-container {
        display: flex;
        flex: 1;
        height: 100%;
        width: 100%;
        flex-direction: column;
        justify-content: space-between;
        row-gap: 1em;
      }

      .list-wrapper {
        position: relative;
        flex: var(--list-wrapper-flex, 1);
        max-width: var(--list-wrapper-max-width, 100%);
        min-height: var(--list-wrapper-max-width, 6.625em);
        border: var(--list-wrapper-border, none);
        border-radius: var(--list-wrapper-border-radius, 0);
        overflow: var(--list-wrapper-overflow, auto);
      }

      .list-wrapper-scrollable {
        position: absolute;
        top: var(--list-wrapper-padding);
        right: 0;
        bottom: var(--list-wrapper-padding);
        left: 0;
        padding-inline: var(--list-wrapper-padding);
        overflow: var(--list-wrapper-scrollable-overflow, auto);
      }
    `
];
z2([
  M({
    attribute: !1
  })
], zp.prototype, "dataFlattenerCallback", 2);
z2([
  M({
    attribute: !1
  })
], zp.prototype, "itemRenderer", 2);
z2([
  M({
    attribute: !1
  })
], zp.prototype, "data", 2);
zp = z2([
  be(),
  P("x-ds-list")
], zp);
const Dde = ":host{display:block;aspect-ratio:128 / 160}.image{pointer-events:none}@keyframes strokeColor{0%,12.5%{stroke:var(--gray8, #3e4753);stroke-width:2;stroke-dasharray:54.3747475,54.3747475}25%,37.5%{stroke:var(--color-primary3, #5acc29);stroke-width:6;stroke-dasharray:108.749495,0}50%,to{stroke:var(--gray8, #3e4753);stroke-width:2;stroke-dasharray:54.3747475,54.3747475}}@keyframes movementAnimation{0%{opacity:0;transform:translate(-100%,100%)}12.5%{opacity:1;transform:translate(0)}37.5%{opacity:1;transform:translate(0)}50%,to{opacity:0}}.outer-ellipse{fill:none;stroke-dasharray:54.3747475,54.3747475;stroke-width:2;stroke-linecap:round;stroke:var(--gray8, #3e4753);stroke-dashoffset:-27.18737375;animation:strokeColor 5s infinite}.person{animation:movementAnimation 5s infinite}";
var Jde = Object.defineProperty, Vde = Object.getOwnPropertyDescriptor, Mde = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Vde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Jde(t, r, a), a;
};
let c_ = class extends N {
  render() {
    return CS`
      <svg xmlns="http://www.w3.org/2000/svg" width="128" height="160" viewBox="0 0 128 160" class="image">
        <mask id="faceFinderMask">
          <rect x="0" y="0" width="128" height="160" fill="#000" />
          <ellipse cx="64" cy="80" rx="62" ry="78" fill="#fff" />
        </mask>
        <g mask="url(#faceFinderMask)">
          <g class="person">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M50.5949 118.35L50.3076 122.651C50.0504 126.5 49.3672 130.439 47.0881 133.551C46.2082 134.753 45.2363 135.693 44.3485 135.693C43.2624 135.693 44.629 138.804 44.629 138.804C44.629 138.804 51.0942 142.489 64.1303 142.489C77.1664 142.489 83.8587 139.087 83.8587 139.087C83.8587 139.087 84.9009 137.22 82.3814 135.693C79.862 134.165 79.3399 131.357 79.3399 131.357L78.9987 129.759C78.6666 128.203 78.4474 126.625 78.3429 125.038L77.9026 118.35H50.5949Z" fill="#DFE5EC"/>
            <path opacity="0.402232" fill-rule="evenodd" clip-rule="evenodd" d="M50.5125 122.651L50.7998 118.35H57.735H78.1076L78.5479 125.038C78.6524 126.625 78.8716 128.203 79.2037 129.759L79.5449 131.357C79.5449 131.357 80.0275 133.953 82.3036 135.511C81.4809 135.718 80.2183 135.703 79.5559 135.695C79.4526 135.694 79.3639 135.693 79.2937 135.693C62.0882 135.693 56.8097 129.936 53.6868 126.53C52.4537 125.185 51.5566 124.207 50.3941 124.094C50.4417 123.613 50.4805 123.131 50.5125 122.651Z" fill="#9AA4AF"/>
            <path d="M98.2376 74.9022C98.2376 80.8997 96.9402 90.7738 101.847 90.7738C106.754 90.7738 116.007 80.8997 116.007 74.9022C116.007 68.9047 112.029 64.0427 107.122 64.0427C102.215 64.0427 98.2376 68.9047 98.2376 74.9022Z" fill="#DFE5EC"/>
            <path d="M30.8932 74.9022C30.8932 80.8997 32.1907 90.7738 27.2839 90.7738C22.3771 90.7738 13.1241 80.8997 13.1241 74.9022C13.1241 68.9047 17.1019 64.0427 22.0087 64.0427C26.9155 64.0427 30.8932 68.9047 30.8932 74.9022Z" fill="#DFE5EC"/>
            <path d="M100.009 75.4068C100.009 79.5301 99.125 86.3185 102.469 86.3185C105.813 86.3185 112.12 79.5301 112.12 75.4068C112.12 71.2835 109.409 67.9409 106.064 67.9409C102.72 67.9409 100.009 71.2835 100.009 75.4068Z" fill="#C6CDD5"/>
            <path d="M29.1215 75.4068C29.1215 79.5301 30.0058 86.3185 26.6616 86.3185C23.3174 86.3185 17.0111 79.5301 17.0111 75.4068C17.0111 71.2835 19.7221 67.9409 23.0663 67.9409C26.4105 67.9409 29.1215 71.2835 29.1215 75.4068Z" fill="#C6CDD5"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M64.4877 16.1494C87.0283 16.1494 105.301 32.1662 105.301 51.9239V62.9287H105.204V68.8023C105.204 69.0191 105.214 69.3817 105.228 69.8721C105.412 76.4517 106.24 106.046 91.8502 115.353C82.6984 121.273 79.8786 122.47 78.3728 123.11C77.3344 123.551 76.9208 123.726 75.4865 125.002C72.5799 127.587 70.6924 127.565 66.5317 127.517C65.9192 127.51 65.2576 127.502 64.5361 127.502C63.8133 127.502 63.1521 127.51 62.5414 127.517C58.4021 127.565 56.5884 127.586 53.6826 125.002C52.2627 123.739 51.8115 123.554 50.758 123.123C49.2042 122.486 46.3402 121.313 37.1252 115.353C22.7352 106.046 23.5632 76.4517 23.7473 69.8721C23.7611 69.3817 23.7712 69.0191 23.7712 68.8023V62.9287H23.6744V51.9239C23.6744 32.1662 41.9471 16.1494 64.4877 16.1494Z" fill="#DFE5EC"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M124.764 165.958C116.8 165.958 8.68808 165.958 0.723267 165.958C0.83762 140.349 24.7895 138.501 46.0298 134.794C48.4015 138.077 58.7985 140.349 64.7308 140.349C70.7673 140.349 78.5111 137.997 80.8256 134.62C102.538 138.118 124.727 140.349 124.764 165.958Z" fill="#757F8A"/>
          </g>
        </g>
        <ellipse class="outer-ellipse" cx="64" cy="80" rx="61" ry="77" stroke-width="2" />
      </svg>
    `;
  }
};
c_.styles = [...N.styles, Gt(Dde)];
c_ = Mde([
  P("x-ds-liveness-face-animation")
], c_);
var Gde = Object.defineProperty, xde = Object.getOwnPropertyDescriptor, Hde = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? xde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Gde(t, r, a), a;
};
let d_ = class extends N {
  render() {
    return w`
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
  }
};
d_.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .lds-ellipsis {
        display: block;
        position: relative;
        width: 80px;
        height: 13px;
        margin: 0 auto;
      }

      .lds-ellipsis div {
        position: absolute;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: var(--color-primary4);
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
      }

      .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
      }

      .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
      }

      .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
      }

      .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
      }

      @keyframes lds-ellipsis1 {
        0% {
          transform: scale(0);
        }
        100% {
          transform: scale(1);
        }
      }

      @keyframes lds-ellipsis3 {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(0);
        }
      }

      @keyframes lds-ellipsis2 {
        0% {
          transform: translate(0, 0);
        }
        100% {
          transform: translate(24px, 0);
        }
      }
    `
];
d_ = Hde([
  P("x-ds-loading-indicator")
], d_);
var Lde = Object.defineProperty, Yde = Object.getOwnPropertyDescriptor, pE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Yde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Lde(t, r, a), a;
};
let wm = class extends N {
  constructor() {
    super(...arguments), this.title = "", this.message = "";
  }
  render() {
    return w`
      <div class="container">
        <div class="title" data-qa-id="title">${this.title}</div>
        <p class="message" data-qa-id="message">${this.message}</p>
      </div>
    `;
  }
};
wm.styles = [
  ...N.styles,
  ee`
      :host([data-color-scheme='dark']) .details {
        color: var(--color-secondary9);
      }

      :host([data-color-scheme='light']) .details {
        color: var(--color-secondary3);
      }

      .container {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
      }

      .title {
        font: var(--text-font-h1);
      }

      .message {
        font: var(--text-font-subtitle-medium);
        margin: 0;
      }

      .title,
      .message {
        text-align: center;
      }

      .title:empty,
      .message:empty {
        display: none;
      }
    `
];
pE([
  M({
    type: String,
    attribute: "data-title",
    reflect: !0
  })
], wm.prototype, "title", 2);
pE([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], wm.prototype, "message", 2);
wm = pE([
  be(),
  P("x-ds-message-details")
], wm);
var Ode = Object.defineProperty, jde = Object.getOwnPropertyDescriptor, Pde = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? jde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ode(t, r, a), a;
};
let u_ = class extends N {
  render() {
    return w`
      <div class="overlay-modal">
        <slot></slot>
      </div>
    `;
  }
};
u_.styles = [
  ...N.styles,
  ee`
      :host {
        background-color: var(--white);
        pointer-events: unset;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;

        @media (min-width: 32em) {
          background-color: rgba(0, 0, 0, 0.6);
        }
      }

      .overlay-modal {
        background-color: var(--white);
        padding: 3em;
        border-radius: 1.75em;
      }

      :host([data-color-scheme='light']) {
        background-color: var(--theme-light-app-container-bg-color);

        @media (min-width: 32em) {
          background-color: rgba(0, 0, 0, 0.6);
        }
      }

      :host([data-color-scheme='light']) .overlay-modal {
        background-color: var(--theme-light-app-container-bg-color);
      }

      :host([data-color-scheme='dark']),
      :host([data-color-scheme='dark']) .overlay-modal {
        background-color: var(--theme-dark-app-container-bg-color);
      }
    `
];
u_ = Pde([
  be(),
  P("x-ds-modal")
], u_);
const h_ = new Kt(!0);
var $de = Object.defineProperty, Kde = Object.getOwnPropertyDescriptor, Xde = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Kde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && $de(t, r, a), a;
};
let p_ = class extends N {
  constructor() {
    super(...arguments), this.fullscreenModeController = new ue(this, h_);
  }
  render() {
    return this.fullscreenModeController.value ?? !0 ? w`
          <div class="outer">
            <div class="inner">
              <slot><x-ds-app-container></x-ds-app-container></slot>
            </div>
          </div>
        ` : w`<slot></slot>`;
  }
};
p_.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .outer {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        transition-property: background-color, color;
        transition-duration: 500ms;
      }

      @media (display-mode: fullscreen) and (orientation: portrait) {
        .outer {
          padding-top: env(safe-area-inset-top);
          padding-right: env(safe-area-inset-right);
          padding-bottom: env(safe-area-inset-bottom);
          padding-left: env(safe-area-inset-left);
        }
      }

      @media (display-mode: fullscreen) and (orientation: landscape) {
        .outer {
          padding-right: env(safe-area-inset-right);
          padding-left: env(safe-area-inset-left);
        }
      }

      .inner {
        position: relative;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        margin: 0 auto;
        width: 100%;
        min-width: 13.75em; /* 220 / 16 */
        max-width: 96em; /* 1536 / 16 */
        max-height: 48em; /* 768 / 16 */
        box-shadow:
          0 0.9963359832763672px 3.668327808380127px 0 rgba(0, 0, 0, 0.02),
          0 2.7547414302825928px 10.142457008361816px 0 rgba(0, 0, 0, 0.04),
          0 6.6323561668396px 24.41912841796875px 0 rgba(0, 0, 0, 0.05),
          0 22px 81px 0 rgba(0, 0, 0, 0.05);
      }

      :host([data-color-scheme='light']) .inner {
        background: var(--theme-light-app-container-bg-color);
      }

      :host([data-color-scheme='dark']) .inner {
        background: var(--theme-dark-app-container-bg-color);
      }

      :host([data-color-scheme='light']) .outer {
        background-color: var(--theme-light-page-bg-color);
      }

      :host([data-color-scheme='dark']) .outer {
        background-color: var(--theme-dark-page-bg-color);
      }
    `
];
p_ = Xde([
  P("x-ds-page-container")
], p_);
var zde = Object.defineProperty, qde = Object.getOwnPropertyDescriptor, q2 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? qde(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && zde(t, r, a), a;
};
let qp = class extends N {
  constructor() {
    super(...arguments), this.title = "", this.message = "", this.overlay = !1;
  }
  render() {
    return w`
      <div class="message">
        <x-ds-loading-indicator data-qa-id="loading-icon"></x-ds-loading-indicator>
        <x-ds-message-details
          class="${tn({
      hidden: !(this.title || this.message)
    })}"
          data-qa-id="progress-details"
          data-title="${this.title}"
          data-message="${this.message}"
        ></x-ds-message-details>
      </div>
    `;
  }
};
qp.styles = [
  ...N.styles,
  ee`
      :host([data-overlay='true']) {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      :host([data-overlay='true'][data-color-scheme='dark']) {
        background-color: var(--color-secondary12);
      }

      :host([data-overlay='true'][data-color-scheme='light']) {
        background-color: var(--white);
      }

      .message {
        display: flex;
        flex-direction: column;
        row-gap: 2em;
        align-items: center;
      }
    `
];
q2([
  M({
    type: String,
    attribute: "data-title",
    reflect: !0
  })
], qp.prototype, "title", 2);
q2([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], qp.prototype, "message", 2);
q2([
  M({
    type: String,
    attribute: "data-overlay",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], qp.prototype, "overlay", 2);
qp = q2([
  be(),
  P("x-ds-progress-message")
], qp);
var Ia = /* @__PURE__ */ ((e) => (e.Initial = "initial", e.Progress = "progress", e.Pulsing = "pulsing", e))(Ia || {});
const eue = (e) => e !== Ia.Pulsing ? w` <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path
          opacity="0.4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 40C10 56.5685 23.4315 70 40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40ZM40 6C21.2223 6 6 21.2223 6 40C6 58.7777 21.2223 74 40 74C58.7777 74 74 58.7777 74 40C74 21.2223 58.7777 6 40 6Z"
          fill="white"
        />
      </svg>` : q, tue = (e) => w`${eue(e.state)}
    <svg
      class="stroke-progress ${e.state === Ia.Pulsing ? "circle-pulsing" : ""}"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      xml:space="preserve"
    >
      <circle
        class="circle ${e.disableTransition ? "" : "dash-array-transition"}"
        data-qa-id="progress-circle"
        cx="40"
        cy="40"
        r="32"
        fill="transparent"
        stroke-dashoffset="${e.dashOffset}"
        style="transition-duration: ${e.transitionDuration}ms"
        stroke="white"
        stroke-width="4"
      />
    </svg>`, rue = (e) => e ? q : w`
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          class="plus-svg"
          data-qa-id="plus-svg"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_b_5_807)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5 32C41.5 31.1716 40.8284 30.5 40 30.5C39.1716 30.5 38.5 31.1716 38.5 32V38.5H32C31.1716 38.5 30.5 39.1716 30.5 40C30.5 40.8284 31.1716 41.5 32 41.5H38.5V48C38.5 48.8284 39.1716 49.5 40 49.5C40.8284 49.5 41.5 48.8284 41.5 48V41.5H48C48.8284 41.5 49.5 40.8284 49.5 40C49.5 39.1716 48.8284 38.5 48 38.5H41.5V32Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_b_5_807"
              x="-4"
              y="-4"
              width="88"
              height="88"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5_807" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_5_807" result="shape" />
            </filter>
          </defs>
        </svg>
      `, nue = (e) => w`
    ${rue(e)}
    <svg
      class="rotate-animated-target"
      data-qa-id="rotate-animated-target"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_5_807)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.9999 8.94503C33.9999 7.6847 32.859 6.72716 31.6372 7.03618C28.4198 7.84991 25.385 9.12231 22.6066 10.7797C21.5242 11.4254 21.3944 12.9092 22.2856 13.8004C22.9664 14.4812 24.0288 14.5818 24.8596 14.0952C27.1871 12.732 29.7147 11.6734 32.3877 10.9743C33.3194 10.7306 33.9999 9.90806 33.9999 8.94503ZM57.7143 13.8004C57.0336 14.4812 55.9711 14.5818 55.1404 14.0952C52.8128 12.7319 50.2852 11.6733 47.6121 10.9742C46.6804 10.7306 45.9999 9.908 45.9999 8.94497C45.9999 7.68465 47.1408 6.72711 48.3626 7.03612C51.5801 7.84984 54.6149 9.12224 57.3933 10.7797C58.4757 11.4254 58.6055 12.9092 57.7143 13.8004ZM71.0551 34C70.092 34 69.2695 33.3196 69.0258 32.3879C68.3267 29.7148 67.2681 27.1872 65.9048 24.8596C65.4182 24.0289 65.5189 22.9665 66.1996 22.2857C67.0908 21.3945 68.5747 21.5243 69.2203 22.6067C70.8778 25.3851 72.1502 28.4199 72.9639 31.6373C73.2729 32.8592 72.3154 34 71.0551 34ZM66.1996 57.7144C65.5188 57.0336 65.4182 55.9712 65.9048 55.1405C67.2681 52.8129 68.3267 50.2853 69.0258 47.6122C69.2695 46.6805 70.092 46 71.055 46C72.3154 46 73.2729 47.1409 72.9639 48.3628C72.1502 51.5802 70.8778 54.615 69.2203 57.3934C68.5746 58.4758 67.0908 58.6056 66.1996 57.7144ZM45.9999 71.0551C45.9999 70.0921 46.6804 69.2695 47.6121 69.0258C50.2851 68.3267 52.8128 67.2682 55.1404 65.9049C55.9711 65.4183 57.0335 65.5189 57.7143 66.1997C58.6055 67.0909 58.4757 68.5747 57.3933 69.2204C54.6148 70.8778 51.5801 72.1502 48.3626 72.9639C47.1408 73.2729 45.9999 72.3154 45.9999 71.0551ZM22.2857 66.1996C22.9665 65.5189 24.0289 65.4182 24.8596 65.9048C27.1871 67.2681 29.7147 68.3267 32.3878 69.0258C33.3194 69.2694 33.9999 70.092 33.9999 71.055C33.9999 72.3153 32.859 73.2729 31.6372 72.9639C28.4198 72.1501 25.3851 70.8778 22.6067 69.2204C21.5243 68.5747 21.3945 67.0908 22.2857 66.1996ZM8.945 46.0001C9.90803 46.0001 10.7306 46.6805 10.9743 47.6122C11.6734 50.2852 12.7319 52.8129 14.0952 55.1404C14.5818 55.9711 14.4812 57.0336 13.8004 57.7143C12.9092 58.6056 11.4254 58.4758 10.7797 57.3933C9.12226 54.6149 7.84987 51.5802 7.03615 48.3628C6.72713 47.1409 7.68468 46.0001 8.945 46.0001ZM13.8004 22.2858C14.4811 22.9665 14.5818 24.0289 14.0952 24.8597C12.7319 27.1872 11.6733 29.7149 10.9742 32.3879C10.7306 33.3196 9.90802 34.0001 8.94499 34.0001C7.68467 34.0001 6.72712 32.8592 7.03614 31.6373C7.84985 28.4199 9.12224 25.3852 10.7797 22.6067C11.4253 21.5243 12.9092 21.3945 13.8004 22.2858Z"
          fill="white"
        />
      </g>
    </svg>
  `;
var aue = Object.defineProperty, iue = Object.getOwnPropertyDescriptor, G9 = (e) => {
  throw TypeError(e);
}, Pg = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? iue(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && aue(t, r, a), a;
}, oue = (e, t, r) => t.has(e) || G9("Cannot " + r), sue = (e, t, r) => t.has(e) ? G9("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), g_ = (e, t, r) => (oue(e, t, "access private method"), r), Am, x9, H9, L9;
const sU = 201;
let Jc = class extends N {
  constructor() {
    super(...arguments), sue(this, Am), this.state = Ia.Initial, this.progress = 0, this.hidePlusOnInitialState = !1, this.progressTransitionDuration = 400, this.progressDisableTransition = !1;
  }
  render() {
    return w`
      <div class="prompt-loader-container" data-qa-id="prompt-loader-container">${g_(this, Am, L9).call(this)}</div>
    `;
  }
};
Am = /* @__PURE__ */ new WeakSet();
x9 = function(e) {
  return e > 0 && e < 100 ? sU - e * (sU / 100) : e >= 100 ? 0 : sU;
};
H9 = function() {
  this.state === Ia.Pulsing && (this.progress = 100);
};
L9 = function() {
  if (this.state === Ia.Initial)
    return nue(this.hidePlusOnInitialState);
  g_(this, Am, H9).call(this);
  const e = {
    state: this.state,
    dashOffset: g_(this, Am, x9).call(this, this.progress),
    transitionDuration: this.progressTransitionDuration,
    disableTransition: this.progressDisableTransition
  };
  return tue(e);
};
Jc.styles = [
  ...N.styles,
  ee`
      :host {
        transform: translateZ(0);
      }

      @keyframes rotate-key {
        0% {
          transform: rotate(0deg);
        }
        10.25% {
          transform: rotate(0deg);
        }
        16.66% {
          transform: rotate(60deg);
        }
        26.91% {
          transform: rotate(60deg);
        }
        33.32% {
          transform: rotate(120deg);
        }
        43.57% {
          transform: rotate(120deg);
        }
        49.98% {
          transform: rotate(180deg);
        }
        60.23% {
          transform: rotate(180deg);
        }
        66.64% {
          transform: rotate(240deg);
        }
        76.89% {
          transform: rotate(240deg);
        }
        83.3% {
          transform: rotate(300deg);
        }
        93.55% {
          transform: rotate(300deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes pulsing {
        0% {
          r: 32;
        }

        50% {
          r: 7.35;
        }

        100% {
          r: 32;
        }
      }

      .prompt-loader-container {
        font-size: 300%;
        width: 1.6667em;
        height: 1.6667em;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.4);
        position: relative;
      }

      svg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }

      .rotate-animated-target {
        animation: rotate-key 7.8s ease-in-out infinite;
      }

      .stroke-progress {
        transform: rotate(-105deg);
      }

      .stroke-progress .circle {
        stroke-dasharray: 201;
        stroke-linecap: round;
      }

      .dash-array-transition {
        transition: stroke-dashoffset ease-in-out 400ms;
        will-change: stroke-dashoffset;
      }

      .circle-pulsing .circle {
        animation: pulsing 1s infinite;
        will-change: r;
      }
    `
];
Pg([
  M({
    attribute: "data-state",
    type: String,
    reflect: !0
  })
], Jc.prototype, "state", 2);
Pg([
  M({
    attribute: "data-progress",
    type: Number,
    reflect: !0
  })
], Jc.prototype, "progress", 2);
Pg([
  M({
    attribute: "data-hide-plus-on-initial-state",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Jc.prototype, "hidePlusOnInitialState", 2);
Pg([
  M({
    attribute: "data-progress-transition-duration",
    type: Number,
    reflect: !0
  })
], Jc.prototype, "progressTransitionDuration", 2);
Pg([
  M({
    attribute: "data-progress-disable-transition",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Jc.prototype, "progressDisableTransition", 2);
Jc = Pg([
  P("x-ds-prompt-loader")
], Jc);
var lue = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, Y9 = {}, ri = {};
let gE;
const cue = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
ri.getSymbolSize = function(t) {
  if (!t) throw new Error('"version" cannot be null or undefined');
  if (t < 1 || t > 40) throw new Error('"version" should be in range from 1 to 40');
  return t * 4 + 17;
};
ri.getSymbolTotalCodewords = function(t) {
  return cue[t];
};
ri.getBCHDigit = function(e) {
  let t = 0;
  for (; e !== 0; )
    t++, e >>>= 1;
  return t;
};
ri.setToSJISFunction = function(t) {
  if (typeof t != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  gE = t;
};
ri.isKanjiModeEnabled = function() {
  return typeof gE < "u";
};
ri.toSJIS = function(t) {
  return gE(t);
};
var ew = {};
(function(e) {
  e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
  function t(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "l":
      case "low":
        return e.L;
      case "m":
      case "medium":
        return e.M;
      case "q":
      case "quartile":
        return e.Q;
      case "h":
      case "high":
        return e.H;
      default:
        throw new Error("Unknown EC Level: " + r);
    }
  }
  e.isValid = function(n) {
    return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
  }, e.from = function(n, a) {
    if (e.isValid(n))
      return n;
    try {
      return t(n);
    } catch {
      return a;
    }
  };
})(ew);
function O9() {
  this.buffer = [], this.length = 0;
}
O9.prototype = {
  get: function(e) {
    const t = Math.floor(e / 8);
    return (this.buffer[t] >>> 7 - e % 8 & 1) === 1;
  },
  put: function(e, t) {
    for (let r = 0; r < t; r++)
      this.putBit((e >>> t - r - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(e) {
    const t = Math.floor(this.length / 8);
    this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
  }
};
var due = O9;
function NS(e) {
  if (!e || e < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
}
NS.prototype.set = function(e, t, r, n) {
  const a = e * this.size + t;
  this.data[a] = r, n && (this.reservedBit[a] = !0);
};
NS.prototype.get = function(e, t) {
  return this.data[e * this.size + t];
};
NS.prototype.xor = function(e, t, r) {
  this.data[e * this.size + t] ^= r;
};
NS.prototype.isReserved = function(e, t) {
  return this.reservedBit[e * this.size + t];
};
var uue = NS, j9 = {};
(function(e) {
  const t = ri.getSymbolSize;
  e.getRowColCoords = function(n) {
    if (n === 1) return [];
    const a = Math.floor(n / 7) + 2, i = t(n), o = i === 145 ? 26 : Math.ceil((i - 13) / (2 * a - 2)) * 2, s = [i - 7];
    for (let c = 1; c < a - 1; c++)
      s[c] = s[c - 1] - o;
    return s.push(6), s.reverse();
  }, e.getPositions = function(n) {
    const a = [], i = e.getRowColCoords(n), o = i.length;
    for (let s = 0; s < o; s++)
      for (let c = 0; c < o; c++)
        s === 0 && c === 0 || // top-left
        s === 0 && c === o - 1 || // bottom-left
        s === o - 1 && c === 0 || a.push([i[s], i[c]]);
    return a;
  };
})(j9);
var P9 = {};
const hue = ri.getSymbolSize, J5 = 7;
P9.getPositions = function(t) {
  const r = hue(t);
  return [
    // top-left
    [0, 0],
    // top-right
    [r - J5, 0],
    // bottom-left
    [0, r - J5]
  ];
};
var $9 = {};
(function(e) {
  e.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const t = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  e.isValid = function(a) {
    return a != null && a !== "" && !isNaN(a) && a >= 0 && a <= 7;
  }, e.from = function(a) {
    return e.isValid(a) ? parseInt(a, 10) : void 0;
  }, e.getPenaltyN1 = function(a) {
    const i = a.size;
    let o = 0, s = 0, c = 0, l = null, u = null;
    for (let g = 0; g < i; g++) {
      s = c = 0, l = u = null;
      for (let p = 0; p < i; p++) {
        let m = a.get(g, p);
        m === l ? s++ : (s >= 5 && (o += t.N1 + (s - 5)), l = m, s = 1), m = a.get(p, g), m === u ? c++ : (c >= 5 && (o += t.N1 + (c - 5)), u = m, c = 1);
      }
      s >= 5 && (o += t.N1 + (s - 5)), c >= 5 && (o += t.N1 + (c - 5));
    }
    return o;
  }, e.getPenaltyN2 = function(a) {
    const i = a.size;
    let o = 0;
    for (let s = 0; s < i - 1; s++)
      for (let c = 0; c < i - 1; c++) {
        const l = a.get(s, c) + a.get(s, c + 1) + a.get(s + 1, c) + a.get(s + 1, c + 1);
        (l === 4 || l === 0) && o++;
      }
    return o * t.N2;
  }, e.getPenaltyN3 = function(a) {
    const i = a.size;
    let o = 0, s = 0, c = 0;
    for (let l = 0; l < i; l++) {
      s = c = 0;
      for (let u = 0; u < i; u++)
        s = s << 1 & 2047 | a.get(l, u), u >= 10 && (s === 1488 || s === 93) && o++, c = c << 1 & 2047 | a.get(u, l), u >= 10 && (c === 1488 || c === 93) && o++;
    }
    return o * t.N3;
  }, e.getPenaltyN4 = function(a) {
    let i = 0;
    const o = a.data.length;
    for (let c = 0; c < o; c++) i += a.data[c];
    return Math.abs(Math.ceil(i * 100 / o / 5) - 10) * t.N4;
  };
  function r(n, a, i) {
    switch (n) {
      case e.Patterns.PATTERN000:
        return (a + i) % 2 === 0;
      case e.Patterns.PATTERN001:
        return a % 2 === 0;
      case e.Patterns.PATTERN010:
        return i % 3 === 0;
      case e.Patterns.PATTERN011:
        return (a + i) % 3 === 0;
      case e.Patterns.PATTERN100:
        return (Math.floor(a / 2) + Math.floor(i / 3)) % 2 === 0;
      case e.Patterns.PATTERN101:
        return a * i % 2 + a * i % 3 === 0;
      case e.Patterns.PATTERN110:
        return (a * i % 2 + a * i % 3) % 2 === 0;
      case e.Patterns.PATTERN111:
        return (a * i % 3 + (a + i) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + n);
    }
  }
  e.applyMask = function(a, i) {
    const o = i.size;
    for (let s = 0; s < o; s++)
      for (let c = 0; c < o; c++)
        i.isReserved(c, s) || i.xor(c, s, r(a, c, s));
  }, e.getBestMask = function(a, i) {
    const o = Object.keys(e.Patterns).length;
    let s = 0, c = 1 / 0;
    for (let l = 0; l < o; l++) {
      i(l), e.applyMask(l, a);
      const u = e.getPenaltyN1(a) + e.getPenaltyN2(a) + e.getPenaltyN3(a) + e.getPenaltyN4(a);
      e.applyMask(l, a), u < c && (c = u, s = l);
    }
    return s;
  };
})($9);
var tw = {};
const gc = ew, EI = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], QI = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
tw.getBlocksCount = function(t, r) {
  switch (r) {
    case gc.L:
      return EI[(t - 1) * 4 + 0];
    case gc.M:
      return EI[(t - 1) * 4 + 1];
    case gc.Q:
      return EI[(t - 1) * 4 + 2];
    case gc.H:
      return EI[(t - 1) * 4 + 3];
    default:
      return;
  }
};
tw.getTotalCodewordsCount = function(t, r) {
  switch (r) {
    case gc.L:
      return QI[(t - 1) * 4 + 0];
    case gc.M:
      return QI[(t - 1) * 4 + 1];
    case gc.Q:
      return QI[(t - 1) * 4 + 2];
    case gc.H:
      return QI[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var K9 = {}, rw = {};
const Jf = new Uint8Array(512), E1 = new Uint8Array(256);
(function() {
  let t = 1;
  for (let r = 0; r < 255; r++)
    Jf[r] = t, E1[t] = r, t <<= 1, t & 256 && (t ^= 285);
  for (let r = 255; r < 512; r++)
    Jf[r] = Jf[r - 255];
})();
rw.log = function(t) {
  if (t < 1) throw new Error("log(" + t + ")");
  return E1[t];
};
rw.exp = function(t) {
  return Jf[t];
};
rw.mul = function(t, r) {
  return t === 0 || r === 0 ? 0 : Jf[E1[t] + E1[r]];
};
(function(e) {
  const t = rw;
  e.mul = function(n, a) {
    const i = new Uint8Array(n.length + a.length - 1);
    for (let o = 0; o < n.length; o++)
      for (let s = 0; s < a.length; s++)
        i[o + s] ^= t.mul(n[o], a[s]);
    return i;
  }, e.mod = function(n, a) {
    let i = new Uint8Array(n);
    for (; i.length - a.length >= 0; ) {
      const o = i[0];
      for (let c = 0; c < a.length; c++)
        i[c] ^= t.mul(a[c], o);
      let s = 0;
      for (; s < i.length && i[s] === 0; ) s++;
      i = i.slice(s);
    }
    return i;
  }, e.generateECPolynomial = function(n) {
    let a = new Uint8Array([1]);
    for (let i = 0; i < n; i++)
      a = e.mul(a, new Uint8Array([1, t.exp(i)]));
    return a;
  };
})(K9);
const X9 = K9;
function fE(e) {
  this.genPoly = void 0, this.degree = e, this.degree && this.initialize(this.degree);
}
fE.prototype.initialize = function(t) {
  this.degree = t, this.genPoly = X9.generateECPolynomial(this.degree);
};
fE.prototype.encode = function(t) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const r = new Uint8Array(t.length + this.degree);
  r.set(t);
  const n = X9.mod(r, this.genPoly), a = this.degree - n.length;
  if (a > 0) {
    const i = new Uint8Array(this.degree);
    return i.set(n, a), i;
  }
  return n;
};
var pue = fE, z9 = {}, nd = {}, mE = {};
mE.isValid = function(t) {
  return !isNaN(t) && t >= 1 && t <= 40;
};
var gs = {};
const q9 = "[0-9]+", gue = "[A-Z $%*+\\-./:]+";
let Um = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
Um = Um.replace(/u/g, "\\u");
const fue = "(?:(?![A-Z0-9 $%*+\\-./:]|" + Um + `)(?:.|[\r
]))+`;
gs.KANJI = new RegExp(Um, "g");
gs.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
gs.BYTE = new RegExp(fue, "g");
gs.NUMERIC = new RegExp(q9, "g");
gs.ALPHANUMERIC = new RegExp(gue, "g");
const mue = new RegExp("^" + Um + "$"), vue = new RegExp("^" + q9 + "$"), Sue = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
gs.testKanji = function(t) {
  return mue.test(t);
};
gs.testNumeric = function(t) {
  return vue.test(t);
};
gs.testAlphanumeric = function(t) {
  return Sue.test(t);
};
(function(e) {
  const t = mE, r = gs;
  e.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, e.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, e.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, e.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, e.MIXED = {
    bit: -1
  }, e.getCharCountIndicator = function(i, o) {
    if (!i.ccBits) throw new Error("Invalid mode: " + i);
    if (!t.isValid(o))
      throw new Error("Invalid version: " + o);
    return o >= 1 && o < 10 ? i.ccBits[0] : o < 27 ? i.ccBits[1] : i.ccBits[2];
  }, e.getBestModeForData = function(i) {
    return r.testNumeric(i) ? e.NUMERIC : r.testAlphanumeric(i) ? e.ALPHANUMERIC : r.testKanji(i) ? e.KANJI : e.BYTE;
  }, e.toString = function(i) {
    if (i && i.id) return i.id;
    throw new Error("Invalid mode");
  }, e.isValid = function(i) {
    return i && i.bit && i.ccBits;
  };
  function n(a) {
    if (typeof a != "string")
      throw new Error("Param is not a string");
    switch (a.toLowerCase()) {
      case "numeric":
        return e.NUMERIC;
      case "alphanumeric":
        return e.ALPHANUMERIC;
      case "kanji":
        return e.KANJI;
      case "byte":
        return e.BYTE;
      default:
        throw new Error("Unknown mode: " + a);
    }
  }
  e.from = function(i, o) {
    if (e.isValid(i))
      return i;
    try {
      return n(i);
    } catch {
      return o;
    }
  };
})(nd);
(function(e) {
  const t = ri, r = tw, n = ew, a = nd, i = mE, o = 7973, s = t.getBCHDigit(o);
  function c(p, m, I) {
    for (let C = 1; C <= 40; C++)
      if (m <= e.getCapacity(C, I, p))
        return C;
  }
  function l(p, m) {
    return a.getCharCountIndicator(p, m) + 4;
  }
  function u(p, m) {
    let I = 0;
    return p.forEach(function(C) {
      const A = l(C.mode, m);
      I += A + C.getBitsLength();
    }), I;
  }
  function g(p, m) {
    for (let I = 1; I <= 40; I++)
      if (u(p, I) <= e.getCapacity(I, m, a.MIXED))
        return I;
  }
  e.from = function(m, I) {
    return i.isValid(m) ? parseInt(m, 10) : I;
  }, e.getCapacity = function(m, I, C) {
    if (!i.isValid(m))
      throw new Error("Invalid QR Code version");
    typeof C > "u" && (C = a.BYTE);
    const A = t.getSymbolTotalCodewords(m), U = r.getTotalCodewordsCount(m, I), B = (A - U) * 8;
    if (C === a.MIXED) return B;
    const J = B - l(C, m);
    switch (C) {
      case a.NUMERIC:
        return Math.floor(J / 10 * 3);
      case a.ALPHANUMERIC:
        return Math.floor(J / 11 * 2);
      case a.KANJI:
        return Math.floor(J / 13);
      case a.BYTE:
      default:
        return Math.floor(J / 8);
    }
  }, e.getBestVersionForData = function(m, I) {
    let C;
    const A = n.from(I, n.M);
    if (Array.isArray(m)) {
      if (m.length > 1)
        return g(m, A);
      if (m.length === 0)
        return 1;
      C = m[0];
    } else
      C = m;
    return c(C.mode, C.getLength(), A);
  }, e.getEncodedBits = function(m) {
    if (!i.isValid(m) || m < 7)
      throw new Error("Invalid QR Code version");
    let I = m << 12;
    for (; t.getBCHDigit(I) - s >= 0; )
      I ^= o << t.getBCHDigit(I) - s;
    return m << 12 | I;
  };
})(z9);
var ex = {};
const f_ = ri, tx = 1335, Iue = 21522, V5 = f_.getBCHDigit(tx);
ex.getEncodedBits = function(t, r) {
  const n = t.bit << 3 | r;
  let a = n << 10;
  for (; f_.getBCHDigit(a) - V5 >= 0; )
    a ^= tx << f_.getBCHDigit(a) - V5;
  return (n << 10 | a) ^ Iue;
};
var rx = {};
const Cue = nd;
function eg(e) {
  this.mode = Cue.NUMERIC, this.data = e.toString();
}
eg.getBitsLength = function(t) {
  return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
eg.prototype.getLength = function() {
  return this.data.length;
};
eg.prototype.getBitsLength = function() {
  return eg.getBitsLength(this.data.length);
};
eg.prototype.write = function(t) {
  let r, n, a;
  for (r = 0; r + 3 <= this.data.length; r += 3)
    n = this.data.substr(r, 3), a = parseInt(n, 10), t.put(a, 10);
  const i = this.data.length - r;
  i > 0 && (n = this.data.substr(r), a = parseInt(n, 10), t.put(a, i * 3 + 1));
};
var bue = eg;
const yue = nd, lU = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function tg(e) {
  this.mode = yue.ALPHANUMERIC, this.data = e;
}
tg.getBitsLength = function(t) {
  return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
tg.prototype.getLength = function() {
  return this.data.length;
};
tg.prototype.getBitsLength = function() {
  return tg.getBitsLength(this.data.length);
};
tg.prototype.write = function(t) {
  let r;
  for (r = 0; r + 2 <= this.data.length; r += 2) {
    let n = lU.indexOf(this.data[r]) * 45;
    n += lU.indexOf(this.data[r + 1]), t.put(n, 11);
  }
  this.data.length % 2 && t.put(lU.indexOf(this.data[r]), 6);
};
var wue = tg;
const Aue = nd;
function rg(e) {
  this.mode = Aue.BYTE, typeof e == "string" ? this.data = new TextEncoder().encode(e) : this.data = new Uint8Array(e);
}
rg.getBitsLength = function(t) {
  return t * 8;
};
rg.prototype.getLength = function() {
  return this.data.length;
};
rg.prototype.getBitsLength = function() {
  return rg.getBitsLength(this.data.length);
};
rg.prototype.write = function(e) {
  for (let t = 0, r = this.data.length; t < r; t++)
    e.put(this.data[t], 8);
};
var Uue = rg;
const kue = nd, _ue = ri;
function ng(e) {
  this.mode = kue.KANJI, this.data = e;
}
ng.getBitsLength = function(t) {
  return t * 13;
};
ng.prototype.getLength = function() {
  return this.data.length;
};
ng.prototype.getBitsLength = function() {
  return ng.getBitsLength(this.data.length);
};
ng.prototype.write = function(e) {
  let t;
  for (t = 0; t < this.data.length; t++) {
    let r = _ue.toSJIS(this.data[t]);
    if (r >= 33088 && r <= 40956)
      r -= 33088;
    else if (r >= 57408 && r <= 60351)
      r -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[t] + `
Make sure your charset is UTF-8`
      );
    r = (r >>> 8 & 255) * 192 + (r & 255), e.put(r, 13);
  }
};
var Nue = ng, nx = { exports: {} };
(function(e) {
  var t = {
    single_source_shortest_paths: function(r, n, a) {
      var i = {}, o = {};
      o[n] = 0;
      var s = t.PriorityQueue.make();
      s.push(n, 0);
      for (var c, l, u, g, p, m, I, C, A; !s.empty(); ) {
        c = s.pop(), l = c.value, g = c.cost, p = r[l] || {};
        for (u in p)
          p.hasOwnProperty(u) && (m = p[u], I = g + m, C = o[u], A = typeof o[u] > "u", (A || C > I) && (o[u] = I, s.push(u, I), i[u] = l));
      }
      if (typeof a < "u" && typeof o[a] > "u") {
        var U = ["Could not find a path from ", n, " to ", a, "."].join("");
        throw new Error(U);
      }
      return i;
    },
    extract_shortest_path_from_predecessor_list: function(r, n) {
      for (var a = [], i = n; i; )
        a.push(i), r[i], i = r[i];
      return a.reverse(), a;
    },
    find_path: function(r, n, a) {
      var i = t.single_source_shortest_paths(r, n, a);
      return t.extract_shortest_path_from_predecessor_list(
        i,
        a
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(r) {
        var n = t.PriorityQueue, a = {}, i;
        r = r || {};
        for (i in n)
          n.hasOwnProperty(i) && (a[i] = n[i]);
        return a.queue = [], a.sorter = r.sorter || n.default_sorter, a;
      },
      default_sorter: function(r, n) {
        return r.cost - n.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(r, n) {
        var a = { value: r, cost: n };
        this.queue.push(a), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  e.exports = t;
})(nx);
var Zue = nx.exports;
(function(e) {
  const t = nd, r = bue, n = wue, a = Uue, i = Nue, o = gs, s = ri, c = Zue;
  function l(U) {
    return unescape(encodeURIComponent(U)).length;
  }
  function u(U, B, J) {
    const W = [];
    let L;
    for (; (L = U.exec(J)) !== null; )
      W.push({
        data: L[0],
        index: L.index,
        mode: B,
        length: L[0].length
      });
    return W;
  }
  function g(U) {
    const B = u(o.NUMERIC, t.NUMERIC, U), J = u(o.ALPHANUMERIC, t.ALPHANUMERIC, U);
    let W, L;
    return s.isKanjiModeEnabled() ? (W = u(o.BYTE, t.BYTE, U), L = u(o.KANJI, t.KANJI, U)) : (W = u(o.BYTE_KANJI, t.BYTE, U), L = []), B.concat(J, W, L).sort(function(R, ge) {
      return R.index - ge.index;
    }).map(function(R) {
      return {
        data: R.data,
        mode: R.mode,
        length: R.length
      };
    });
  }
  function p(U, B) {
    switch (B) {
      case t.NUMERIC:
        return r.getBitsLength(U);
      case t.ALPHANUMERIC:
        return n.getBitsLength(U);
      case t.KANJI:
        return i.getBitsLength(U);
      case t.BYTE:
        return a.getBitsLength(U);
    }
  }
  function m(U) {
    return U.reduce(function(B, J) {
      const W = B.length - 1 >= 0 ? B[B.length - 1] : null;
      return W && W.mode === J.mode ? (B[B.length - 1].data += J.data, B) : (B.push(J), B);
    }, []);
  }
  function I(U) {
    const B = [];
    for (let J = 0; J < U.length; J++) {
      const W = U[J];
      switch (W.mode) {
        case t.NUMERIC:
          B.push([
            W,
            { data: W.data, mode: t.ALPHANUMERIC, length: W.length },
            { data: W.data, mode: t.BYTE, length: W.length }
          ]);
          break;
        case t.ALPHANUMERIC:
          B.push([
            W,
            { data: W.data, mode: t.BYTE, length: W.length }
          ]);
          break;
        case t.KANJI:
          B.push([
            W,
            { data: W.data, mode: t.BYTE, length: l(W.data) }
          ]);
          break;
        case t.BYTE:
          B.push([
            { data: W.data, mode: t.BYTE, length: l(W.data) }
          ]);
      }
    }
    return B;
  }
  function C(U, B) {
    const J = {}, W = { start: {} };
    let L = ["start"];
    for (let H = 0; H < U.length; H++) {
      const R = U[H], ge = [];
      for (let z = 0; z < R.length; z++) {
        const K = R[z], Fe = "" + H + z;
        ge.push(Fe), J[Fe] = { node: K, lastCount: 0 }, W[Fe] = {};
        for (let yr = 0; yr < L.length; yr++) {
          const hr = L[yr];
          J[hr] && J[hr].node.mode === K.mode ? (W[hr][Fe] = p(J[hr].lastCount + K.length, K.mode) - p(J[hr].lastCount, K.mode), J[hr].lastCount += K.length) : (J[hr] && (J[hr].lastCount = K.length), W[hr][Fe] = p(K.length, K.mode) + 4 + t.getCharCountIndicator(K.mode, B));
        }
      }
      L = ge;
    }
    for (let H = 0; H < L.length; H++)
      W[L[H]].end = 0;
    return { map: W, table: J };
  }
  function A(U, B) {
    let J;
    const W = t.getBestModeForData(U);
    if (J = t.from(B, W), J !== t.BYTE && J.bit < W.bit)
      throw new Error('"' + U + '" cannot be encoded with mode ' + t.toString(J) + `.
 Suggested mode is: ` + t.toString(W));
    switch (J === t.KANJI && !s.isKanjiModeEnabled() && (J = t.BYTE), J) {
      case t.NUMERIC:
        return new r(U);
      case t.ALPHANUMERIC:
        return new n(U);
      case t.KANJI:
        return new i(U);
      case t.BYTE:
        return new a(U);
    }
  }
  e.fromArray = function(B) {
    return B.reduce(function(J, W) {
      return typeof W == "string" ? J.push(A(W, null)) : W.data && J.push(A(W.data, W.mode)), J;
    }, []);
  }, e.fromString = function(B, J) {
    const W = g(B, s.isKanjiModeEnabled()), L = I(W), H = C(L, J), R = c.find_path(H.map, "start", "end"), ge = [];
    for (let z = 1; z < R.length - 1; z++)
      ge.push(H.table[R[z]].node);
    return e.fromArray(m(ge));
  }, e.rawSplit = function(B) {
    return e.fromArray(
      g(B, s.isKanjiModeEnabled())
    );
  };
})(rx);
const nw = ri, cU = ew, Bue = due, Wue = uue, Eue = j9, Que = P9, m_ = $9, v_ = tw, Fue = pue, Q1 = z9, Tue = ex, Rue = nd, dU = rx;
function Due(e, t) {
  const r = e.size, n = Que.getPositions(t);
  for (let a = 0; a < n.length; a++) {
    const i = n[a][0], o = n[a][1];
    for (let s = -1; s <= 7; s++)
      if (!(i + s <= -1 || r <= i + s))
        for (let c = -1; c <= 7; c++)
          o + c <= -1 || r <= o + c || (s >= 0 && s <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (s === 0 || s === 6) || s >= 2 && s <= 4 && c >= 2 && c <= 4 ? e.set(i + s, o + c, !0, !0) : e.set(i + s, o + c, !1, !0));
  }
}
function Jue(e) {
  const t = e.size;
  for (let r = 8; r < t - 8; r++) {
    const n = r % 2 === 0;
    e.set(r, 6, n, !0), e.set(6, r, n, !0);
  }
}
function Vue(e, t) {
  const r = Eue.getPositions(t);
  for (let n = 0; n < r.length; n++) {
    const a = r[n][0], i = r[n][1];
    for (let o = -2; o <= 2; o++)
      for (let s = -2; s <= 2; s++)
        o === -2 || o === 2 || s === -2 || s === 2 || o === 0 && s === 0 ? e.set(a + o, i + s, !0, !0) : e.set(a + o, i + s, !1, !0);
  }
}
function Mue(e, t) {
  const r = e.size, n = Q1.getEncodedBits(t);
  let a, i, o;
  for (let s = 0; s < 18; s++)
    a = Math.floor(s / 3), i = s % 3 + r - 8 - 3, o = (n >> s & 1) === 1, e.set(a, i, o, !0), e.set(i, a, o, !0);
}
function uU(e, t, r) {
  const n = e.size, a = Tue.getEncodedBits(t, r);
  let i, o;
  for (i = 0; i < 15; i++)
    o = (a >> i & 1) === 1, i < 6 ? e.set(i, 8, o, !0) : i < 8 ? e.set(i + 1, 8, o, !0) : e.set(n - 15 + i, 8, o, !0), i < 8 ? e.set(8, n - i - 1, o, !0) : i < 9 ? e.set(8, 15 - i - 1 + 1, o, !0) : e.set(8, 15 - i - 1, o, !0);
  e.set(n - 8, 8, 1, !0);
}
function Gue(e, t) {
  const r = e.size;
  let n = -1, a = r - 1, i = 7, o = 0;
  for (let s = r - 1; s > 0; s -= 2)
    for (s === 6 && s--; ; ) {
      for (let c = 0; c < 2; c++)
        if (!e.isReserved(a, s - c)) {
          let l = !1;
          o < t.length && (l = (t[o] >>> i & 1) === 1), e.set(a, s - c, l), i--, i === -1 && (o++, i = 7);
        }
      if (a += n, a < 0 || r <= a) {
        a -= n, n = -n;
        break;
      }
    }
}
function xue(e, t, r) {
  const n = new Bue();
  r.forEach(function(c) {
    n.put(c.mode.bit, 4), n.put(c.getLength(), Rue.getCharCountIndicator(c.mode, e)), c.write(n);
  });
  const a = nw.getSymbolTotalCodewords(e), i = v_.getTotalCodewordsCount(e, t), o = (a - i) * 8;
  for (n.getLengthInBits() + 4 <= o && n.put(0, 4); n.getLengthInBits() % 8 !== 0; )
    n.putBit(0);
  const s = (o - n.getLengthInBits()) / 8;
  for (let c = 0; c < s; c++)
    n.put(c % 2 ? 17 : 236, 8);
  return Hue(n, e, t);
}
function Hue(e, t, r) {
  const n = nw.getSymbolTotalCodewords(t), a = v_.getTotalCodewordsCount(t, r), i = n - a, o = v_.getBlocksCount(t, r), s = n % o, c = o - s, l = Math.floor(n / o), u = Math.floor(i / o), g = u + 1, p = l - u, m = new Fue(p);
  let I = 0;
  const C = new Array(o), A = new Array(o);
  let U = 0;
  const B = new Uint8Array(e.buffer);
  for (let R = 0; R < o; R++) {
    const ge = R < c ? u : g;
    C[R] = B.slice(I, I + ge), A[R] = m.encode(C[R]), I += ge, U = Math.max(U, ge);
  }
  const J = new Uint8Array(n);
  let W = 0, L, H;
  for (L = 0; L < U; L++)
    for (H = 0; H < o; H++)
      L < C[H].length && (J[W++] = C[H][L]);
  for (L = 0; L < p; L++)
    for (H = 0; H < o; H++)
      J[W++] = A[H][L];
  return J;
}
function Lue(e, t, r, n) {
  let a;
  if (Array.isArray(e))
    a = dU.fromArray(e);
  else if (typeof e == "string") {
    let l = t;
    if (!l) {
      const u = dU.rawSplit(e);
      l = Q1.getBestVersionForData(u, r);
    }
    a = dU.fromString(e, l || 40);
  } else
    throw new Error("Invalid data");
  const i = Q1.getBestVersionForData(a, r);
  if (!i)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!t)
    t = i;
  else if (t < i)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + i + `.
`
    );
  const o = xue(t, r, a), s = nw.getSymbolSize(t), c = new Wue(s);
  return Due(c, t), Jue(c), Vue(c, t), uU(c, r, 0), t >= 7 && Mue(c, t), Gue(c, o), isNaN(n) && (n = m_.getBestMask(
    c,
    uU.bind(null, c, r)
  )), m_.applyMask(n, c), uU(c, r, n), {
    modules: c,
    version: t,
    errorCorrectionLevel: r,
    maskPattern: n,
    segments: a
  };
}
Y9.create = function(t, r) {
  if (typeof t > "u" || t === "")
    throw new Error("No input text");
  let n = cU.M, a, i;
  return typeof r < "u" && (n = cU.from(r.errorCorrectionLevel, cU.M), a = Q1.from(r.version), i = m_.from(r.maskPattern), r.toSJISFunc && nw.setToSJISFunction(r.toSJISFunc)), Lue(t, a, n, i);
};
var ax = {}, vE = {};
(function(e) {
  function t(r) {
    if (typeof r == "number" && (r = r.toString()), typeof r != "string")
      throw new Error("Color should be defined as hex string");
    let n = r.slice().replace("#", "").split("");
    if (n.length < 3 || n.length === 5 || n.length > 8)
      throw new Error("Invalid hex color: " + r);
    (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(i) {
      return [i, i];
    }))), n.length === 6 && n.push("F", "F");
    const a = parseInt(n.join(""), 16);
    return {
      r: a >> 24 & 255,
      g: a >> 16 & 255,
      b: a >> 8 & 255,
      a: a & 255,
      hex: "#" + n.slice(0, 6).join("")
    };
  }
  e.getOptions = function(n) {
    n || (n = {}), n.color || (n.color = {});
    const a = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, i = n.width && n.width >= 21 ? n.width : void 0, o = n.scale || 4;
    return {
      width: i,
      scale: i ? 4 : o,
      margin: a,
      color: {
        dark: t(n.color.dark || "#000000ff"),
        light: t(n.color.light || "#ffffffff")
      },
      type: n.type,
      rendererOpts: n.rendererOpts || {}
    };
  }, e.getScale = function(n, a) {
    return a.width && a.width >= n + a.margin * 2 ? a.width / (n + a.margin * 2) : a.scale;
  }, e.getImageWidth = function(n, a) {
    const i = e.getScale(n, a);
    return Math.floor((n + a.margin * 2) * i);
  }, e.qrToImageData = function(n, a, i) {
    const o = a.modules.size, s = a.modules.data, c = e.getScale(o, i), l = Math.floor((o + i.margin * 2) * c), u = i.margin * c, g = [i.color.light, i.color.dark];
    for (let p = 0; p < l; p++)
      for (let m = 0; m < l; m++) {
        let I = (p * l + m) * 4, C = i.color.light;
        if (p >= u && m >= u && p < l - u && m < l - u) {
          const A = Math.floor((p - u) / c), U = Math.floor((m - u) / c);
          C = g[s[A * o + U] ? 1 : 0];
        }
        n[I++] = C.r, n[I++] = C.g, n[I++] = C.b, n[I] = C.a;
      }
  };
})(vE);
(function(e) {
  const t = vE;
  function r(a, i, o) {
    a.clearRect(0, 0, i.width, i.height), i.style || (i.style = {}), i.height = o, i.width = o, i.style.height = o + "px", i.style.width = o + "px";
  }
  function n() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  e.render = function(i, o, s) {
    let c = s, l = o;
    typeof c > "u" && (!o || !o.getContext) && (c = o, o = void 0), o || (l = n()), c = t.getOptions(c);
    const u = t.getImageWidth(i.modules.size, c), g = l.getContext("2d"), p = g.createImageData(u, u);
    return t.qrToImageData(p.data, i, c), r(g, l, u), g.putImageData(p, 0, 0), l;
  }, e.renderToDataURL = function(i, o, s) {
    let c = s;
    typeof c > "u" && (!o || !o.getContext) && (c = o, o = void 0), c || (c = {});
    const l = e.render(i, o, c), u = c.type || "image/png", g = c.rendererOpts || {};
    return l.toDataURL(u, g.quality);
  };
})(ax);
var ix = {};
const Yue = vE;
function M5(e, t) {
  const r = e.a / 255, n = t + '="' + e.hex + '"';
  return r < 1 ? n + " " + t + '-opacity="' + r.toFixed(2).slice(1) + '"' : n;
}
function hU(e, t, r) {
  let n = e + t;
  return typeof r < "u" && (n += " " + r), n;
}
function Oue(e, t, r) {
  let n = "", a = 0, i = !1, o = 0;
  for (let s = 0; s < e.length; s++) {
    const c = Math.floor(s % t), l = Math.floor(s / t);
    !c && !i && (i = !0), e[s] ? (o++, s > 0 && c > 0 && e[s - 1] || (n += i ? hU("M", c + r, 0.5 + l + r) : hU("m", a, 0), a = 0, i = !1), c + 1 < t && e[s + 1] || (n += hU("h", o), o = 0)) : a++;
  }
  return n;
}
ix.render = function(t, r, n) {
  const a = Yue.getOptions(r), i = t.modules.size, o = t.modules.data, s = i + a.margin * 2, c = a.color.light.a ? "<path " + M5(a.color.light, "fill") + ' d="M0 0h' + s + "v" + s + 'H0z"/>' : "", l = "<path " + M5(a.color.dark, "stroke") + ' d="' + Oue(o, i, a.margin) + '"/>', u = 'viewBox="0 0 ' + s + " " + s + '"', p = '<svg xmlns="http://www.w3.org/2000/svg" ' + (a.width ? 'width="' + a.width + '" height="' + a.width + '" ' : "") + u + ' shape-rendering="crispEdges">' + c + l + `</svg>
`;
  return typeof n == "function" && n(null, p), p;
};
const jue = lue, S_ = Y9, ox = ax, Pue = ix;
function SE(e, t, r, n, a) {
  const i = [].slice.call(arguments, 1), o = i.length, s = typeof i[o - 1] == "function";
  if (!s && !jue())
    throw new Error("Callback required as last argument");
  if (s) {
    if (o < 2)
      throw new Error("Too few arguments provided");
    o === 2 ? (a = r, r = t, t = n = void 0) : o === 3 && (t.getContext && typeof a > "u" ? (a = n, n = void 0) : (a = n, n = r, r = t, t = void 0));
  } else {
    if (o < 1)
      throw new Error("Too few arguments provided");
    return o === 1 ? (r = t, t = n = void 0) : o === 2 && !t.getContext && (n = r, r = t, t = void 0), new Promise(function(c, l) {
      try {
        const u = S_.create(r, n);
        c(e(u, t, n));
      } catch (u) {
        l(u);
      }
    });
  }
  try {
    const c = S_.create(r, n);
    a(null, e(c, t, n));
  } catch (c) {
    a(c);
  }
}
S_.create;
var $ue = SE.bind(null, ox.render);
SE.bind(null, ox.renderToDataURL);
SE.bind(null, function(e, t, r) {
  return Pue.render(e, r);
});
const Kue = async (e) => new Promise((t) => {
  window.requestAnimationFrame(() => {
    e(), t();
  });
}), Bl = (e, t) => new Ht((r) => {
  e.value && r.next(e.value);
  const n = t.subscribe(() => {
    e.value && r.next(e.value);
  });
  return () => {
    n.unsubscribe();
  };
}), aw = ({
  el: e,
  ResizeObserverClass: t = ResizeObserver,
  requestAnimationFrameFn: r = window.requestAnimationFrame.bind(window),
  cancelAnimationFrameFn: n = window.cancelAnimationFrame.bind(window)
}) => new Ht((a) => {
  let i;
  const o = new t((s) => {
    i && n(i), i = r(() => {
      for (const c of s)
        a.next({
          width: c.contentRect.width,
          height: c.contentRect.height
        });
    });
  });
  return o.observe(e), () => {
    i && n(i), o.unobserve(e), o.disconnect();
  };
}), zJe = ({
  root: e,
  slotName: t,
  fallbackContentTagName: r
}) => {
  if (e) {
    const n = e.querySelector(`slot[name='${t}']`);
    if (n && n.assignedElements({ flatten: !0 }).length === 0) {
      const a = document.createElement(r);
      return n.appendChild(a);
    }
  }
};
var Xue = Object.defineProperty, zue = Object.getOwnPropertyDescriptor, sx = (e) => {
  throw TypeError(e);
}, iw = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? zue(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Xue(t, r, a), a;
}, IE = (e, t, r) => t.has(e) || sx("Cannot " + r), I_ = (e, t, r) => (IE(e, t, "read from private field"), r ? r.call(e) : t.get(e)), pU = (e, t, r) => t.has(e) ? sx("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), que = (e, t, r, n) => (IE(e, t, "write to private field"), t.set(e, r), r), ehe = (e, t, r) => (IE(e, t, "access private method"), r), F1, T1, C_, lx;
let ag = class extends N {
  constructor() {
    super(), pU(this, C_), this.uri = "", this.darkColor = "#000000", this.lightColor = "#ffffff", pU(this, F1), pU(this, T1, Rt()), que(this, F1, new ue(this, aw({ el: this })));
  }
  updated() {
    ehe(this, C_, lx).call(this);
  }
  render() {
    return w`<canvas ${Mt(I_(this, T1))} class="qr-code"></canvas>`;
  }
  toCanvas(e, t, r, n) {
    $ue(e, t, r, n);
  }
};
F1 = /* @__PURE__ */ new WeakMap();
T1 = /* @__PURE__ */ new WeakMap();
C_ = /* @__PURE__ */ new WeakSet();
lx = function() {
  const e = I_(this, T1).value, t = window.devicePixelRatio ?? 1;
  I_(this, F1) && e && this.toCanvas(
    e,
    this.uri,
    {
      color: {
        dark: this.darkColor,
        light: this.lightColor
      },
      width: t * this.offsetWidth,
      margin: 0
    },
    () => {
      e.removeAttribute("style");
    }
  );
};
ag.styles = [
  ...N.styles,
  ee`
      :host {
        display: inline-block;
        position: relative;
        min-width: 4em;
        aspect-ratio: 1;
      }

      .qr-code {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        object-fit: contain;
        object-position: center;
      }

      :host([data-color-scheme='dark']) .qr-code {
        border: 0.0625em solid var(--white);
      }
    `
];
iw([
  M({
    attribute: "data-uri",
    type: String,
    reflect: !0
  })
], ag.prototype, "uri", 2);
iw([
  M({
    attribute: "data-dark-color",
    type: String,
    reflect: !0
  })
], ag.prototype, "darkColor", 2);
iw([
  M({
    attribute: "data-light-color",
    type: String,
    reflect: !0
  })
], ag.prototype, "lightColor", 2);
ag = iw([
  P("x-ds-qr-code")
], ag);
class the extends CustomEvent {
  constructor(t) {
    super("radiolistselection", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var rhe = Object.defineProperty, nhe = Object.getOwnPropertyDescriptor, cx = (e) => {
  throw TypeError(e);
}, dx = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? nhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && rhe(t, r, a), a;
}, ahe = (e, t, r) => t.has(e) || cx("Cannot " + r), ihe = (e, t, r) => t.has(e) ? cx("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), ohe = (e, t, r) => (ahe(e, t, "access private method"), r), b_, ux;
let R1 = class extends N {
  constructor() {
    super(...arguments), ihe(this, b_), this.items = [];
  }
  render() {
    return w`
      <div class="radio-list">
        ${this.items.map(
      (e) => w`
            <div>
              <label>
                <input
                  type="radio"
                  name="radio-list"
                  value="${e.value}"
                  @change="${(t) => {
        ohe(this, b_, ux).call(this, t);
      }}"
                />
                ${e.label}
              </label>
            </div>
          `
    )}
      </div>
    `;
  }
};
b_ = /* @__PURE__ */ new WeakSet();
ux = function(e) {
  if (e.target instanceof HTMLInputElement) {
    const { value: t } = e.target;
    this.items.forEach((r) => {
      r.selected = r.value === t;
    }), this.dispatchEvent(new the({ name: t }));
  }
};
R1.styles = [
  ...N.styles,
  ee`
      :host {
      }

      .radio-list {
        display: flex;
        flex-direction: column;
      }

      label {
        display: grid;
        grid-template-columns: 1em auto;
        gap: 1em;
        padding: 0.75em;
        cursor: pointer;
      }

      label:hover {
        background-color: var(--color-secondary4);
      }

      input[type='radio'] {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;

        color: currentColor;
        width: 1.5em;
        height: 1.5em;
        border: 0.2em solid currentColor;
        border-radius: 50%;
        transform: translateY(-0.075em);

        display: grid;
        place-content: center;
      }

      input[type='radio']::before {
        content: '';
        width: 0.75em;
        height: 0.75em;
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        background-color: currentColor;
      }

      input[type='radio']:checked::before {
        transform: scale(1);
      }
    `
];
dx([
  M({
    attribute: "data-items",
    type: Array,
    reflect: !0
  })
], R1.prototype, "items", 2);
R1 = dx([
  be(),
  P("x-ds-radio-list")
], R1);
var she = Object.defineProperty, lhe = Object.getOwnPropertyDescriptor, hx = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? lhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && she(t, r, a), a;
};
let D1 = class extends N {
  constructor() {
    super(...arguments), this.uri = "", this.qrCodeRef = Rt();
  }
  render() {
    return w`
      <div class="container">
        <h4>${y("Scan QR code", { id: "xdevice.qrcode.title.noemail" })}</h4>
        <p class="no-margin">
          ${y("Scan this QR code using your mobile camera or QR code app.", { id: "xdevice.description.qrcode" })}
        </p>
        <div class="qr-code-container">
          <x-ds-qr-code ${Mt(this.qrCodeRef)} class="qr-code" data-uri="${this.uri}"></x-ds-qr-code>
        </div>
      </div>
    `;
  }
};
D1.styles = [
  ...N.styles,
  ee`
      .container {
        display: flex;
        flex-flow: column;
        row-gap: 1em;
        align-items: center;
        text-align: center;
      }

      .qr-code-container {
        display: block;
        width: 100%;
        max-width: 14em;
        margin: 0 auto;
        padding: 0.5em;
        border: 0.0625em solid var(--color-secondary4);
        border-radius: 0.5em;
        aspect-ratio: 1;
        background-color: var(--white);
      }

      .qr-code {
        width: 100%;
      }
    `
];
hx([
  M({
    type: String,
    attribute: "data-uri",
    reflect: !0
  })
], D1.prototype, "uri", 2);
D1 = hx([
  be(),
  P("x-ds-scan-qr-code")
], D1);
var che = Object.defineProperty, dhe = Object.getOwnPropertyDescriptor, px = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? dhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && che(t, r, a), a;
};
let J1 = class extends N {
  constructor() {
    super(...arguments), this.url = "";
  }
  render() {
    return w`
      <h6 class="header" data-qa-id="header">
        ${y("Copy the link to this session and try again in a different browser.", {
      id: "copy-session-link"
    })}
      </h6>
      <div class="input" @click="${() => this.copyToClipboard()}" data-qa-id="url">${this.url}</div>
    `;
  }
  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.url);
    } catch {
    }
  }
};
J1.styles = [
  ...N.styles,
  ee`
      :host {
        display: block;
        width: 100%;
      }

      .input {
        position: relative;
        border-radius: 0.5em;
        font: var(--text-font-h6);
        padding: 0.4375em 0.75em; /* 12 / 16 */
        background: transparent;
        outline: none;
        width: 100%;
        box-sizing: border-box;
        border: none;
        font-weight: 400;
        -webkit-user-select: all;
        -moz-user-select: all;
        user-select: all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      :host([data-color-scheme='light']) .input {
        background-color: var(--white);
        color: var(--color-secondary12);
        box-shadow: 0 0 0.0625em 0 var(--color-secondary7);
      }

      :host([data-color-scheme='light']) .input:hover {
        background-color: var(--color-secondary1);
        color: var(--color-secondary12);
        box-shadow: 0 0 0.125em 0 var(--color-secondary7);
      }

      :host([data-color-scheme='light']) .input:focus,
      :host([data-color-scheme='light']) .input:active {
        background-color: var(--color-secondary1);
        color: var(--color-secondary12);
        box-shadow: 0 0 0.125em 0 var(--color-secondary7);
      }

      :host([data-color-scheme='dark']) .input {
        background-color: var(--color-secondary11);
        color: var(--white);
        box-shadow: 0 0 0.0625em 0 rgba(0, 0, 0, 0.4);
      }

      :host([data-color-scheme='dark']) .input:hover {
        background-color: var(--color-secondary9);
        color: var(--white);
        box-shadow: 0 0 0.125em 0 rgba(0, 0, 0, 0.4);
      }

      :host([data-color-scheme='dark']) .input:focus,
      :host([data-color-scheme='dark']) .input:active {
        background-color: var(--color-secondary8);
        color: var(--white);
        box-shadow: 0 0 0.125em 0 rgba(0, 0, 0, 0.4);
      }

      .header {
        text-align: center;
      }

      .header + .input {
        margin-top: 0.5em;
      }
    `
];
px([
  M({
    type: String,
    attribute: "data-url",
    reflect: !0
  })
], J1.prototype, "url", 2);
J1 = px([
  be(),
  P("x-ds-session-url-box")
], J1);
var uhe = Object.defineProperty, hhe = Object.getOwnPropertyDescriptor, phe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? hhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && uhe(t, r, a), a;
};
let y_ = class extends N {
  render() {
    return w`
      <div class="sheet-container">
        <div class="sheet-card">
          <div class="sheet-instructions">
            <slot name="instructions"></slot>
          </div>
          <div class="sheet-actions">
            <slot name="actions"></slot>
          </div>
        </div>
      </div>
    `;
  }
};
y_.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
        overflow: hidden;
      }

      .sheet-container {
        width: 100%;
        height: 100%;
        overflow-y: hidden;
        position: relative;
      }

      .sheet-card {
        position: absolute;
        bottom: 0;
        background-color: var(--white);
        border-top-left-radius: 1.75em;
        border-top-right-radius: 1.75em;
        display: flex;
        padding: 1.5em;
        flex-direction: column;
        justify-content: flex-end;
        gap: 1.5em;
        width: 100%;
        box-sizing: border-box;
        box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, 0.05);
        animation: 1s slide-up;
      }

      :host([data-color-scheme='light']) .sheet-card {
        background-color: var(--white);
      }

      :host([data-color-scheme='dark']) .sheet-card {
        background-color: var(--color-secondary9);
      }

      @media (max-width: 32em) {
        .sheet-card {
          left: 0;
        }
      }

      @media (min-width: 32em) {
        /* CSS rules here will apply to screens with a width of 32em and above */
        .sheet-card {
          right: 1em;
          position: absolute;
          width: 24em;
        }
      }

      @keyframes slide-up {
        from {
          transform: translateY(100%);
        }
        to {
          transform: translateY(0);
        }
      }

      .sheet-instructions {
        border-bottom: 0.0625em solid var(--color-secondary3);
      }
    `
];
y_ = phe([
  P("x-ds-sheet")
], y_);
var ghe = Object.defineProperty, fhe = Object.getOwnPropertyDescriptor, gx = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? fhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ghe(t, r, a), a;
};
let V1 = class extends N {
  render() {
    return w`
      <x-ds-card-light class="card">
        <div class="list" data-qa-id="shield-list">
          <slot name="item"></slot>
        </div>
        <slot></slot>
      </x-ds-card-light>
    `;
  }
};
V1.styles = [
  ...N.styles,
  ee`
      .card {
        width: 100%;
      }

      .list {
        display: flex;
        flex-direction: column;
        list-style: none;
        margin: 0;
        row-gap: 1.5em; /* 24 / 16 */
        padding: 0 0.5em;
      }
    `
];
gx([
  dr({
    slot: "item",
    selector: "x-ds-shield-list-item",
    flatten: !0
  })
], V1.prototype, "items", 2);
V1 = gx([
  be(),
  P("x-ds-shield-list")
], V1);
var mhe = Object.defineProperty, vhe = Object.getOwnPropertyDescriptor, She = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? vhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && mhe(t, r, a), a;
};
let w_ = class extends N {
  render() {
    return w`
      <div class="item" data-qa-id="item">
        <div class="item__icon" data-qa-id="icon"></div>
        <div class="item__text" data-qa-id="text"><slot></slot></div>
      </div>
    `;
  }
};
w_.styles = [
  ...N.styles,
  ee`
      .item {
        display: flex;
        flex-direction: row;
        column-gap: 1em;
        line-height: 1.625em; /* 26 / 16 */
      }

      :host([data-color-scheme='light']) .item__icon::before {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='dark']) .item__icon::before {
        color: var(--color-secondary5);
      }

      .item__icon::before {
        font-family: 'jumio-sdk-icomoon', serif;
        height: 1.625em; /* 26 / 16 */
        min-width: 1.625em; /* 26 / 16 */
        box-sizing: border-box;
        border-radius: 50%;
        text-align: center;
        content: '\\e948';
      }

      :host([data-color-scheme='light']) .item__icon::before {
        background-color: var(--color-secondary3);
      }

      :host([data-color-scheme='dark']) .item__icon::before {
        background-color: var(--color-secondary9);
      }
    `
];
w_ = She([
  be(),
  P("x-ds-shield-list-item")
], w_);
var Ihe = Object.defineProperty, Che = Object.getOwnPropertyDescriptor, bhe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Che(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Ihe(t, r, a), a;
};
let A_ = class extends N {
  render() {
    return w` <div class="shimmer-loader"></div> `;
  }
};
A_.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .shimmer-loader {
        width: 100%;
        height: 100%;
        background: #f6f7f8 linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%) no-repeat;
        background-size: 100% 100%;
        display: inline-block;
        position: relative;

        animation-duration: 1s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeholderShimmer;
        animation-timing-function: linear;
      }

      @keyframes placeholderShimmer {
        0% {
          background-position: -468px 0;
        }

        100% {
          background-position: 468px 0;
        }
      }
    `
];
A_ = bhe([
  P("x-ds-shimmer-loader")
], A_);
var yhe = Object.defineProperty, whe = Object.getOwnPropertyDescriptor, Ahe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? whe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && yhe(t, r, a), a;
};
let G5 = class extends N {
  render() {
    return CS`
      <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <style>
            .color-overlay {
              fill: var(--color-primary4, #5acc29);
            }
          </style>
        </defs>
        <circle cx="56" cy="56" r="56" class="color-overlay" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M 89.952 35.028 C 91.34 36.409 91.351 38.658 89.977 40.053 L 52.642 77.947 C 51.978 78.621 51.073 79.001 50.129 79.001 C 49.186 79.001 48.281 78.621 47.617 77.947 L 26.023 56.03 C 24.649 54.635 24.661 52.386 26.048 51.006 C 27.436 49.625 29.675 49.637 31.048 51.031 L 50.129 70.398 L 84.952 35.054 C 86.325 33.659 88.564 33.648 89.952 35.028 Z" fill="white" />
      </svg>
    `;
  }
};
G5 = Ahe([
  be(),
  P("x-ds-success-mark")
], G5);
const Uhe = ':host([data-overlay="true"]){position:absolute;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:center}:host([data-overlay="true"][data-color-scheme="dark"]){background-color:var(--color-secondary12)}:host([data-overlay="true"][data-color-scheme="light"]){background-color:var(--white)}.success{display:flex;flex-direction:column;row-gap:2em;align-items:center}.success__button-container{display:flex;flex-direction:column;row-gap:1em;align-items:center}';
var khe = Object.defineProperty, _he = Object.getOwnPropertyDescriptor, ZS = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? _he(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && khe(t, r, a), a;
};
let Eu = class extends N {
  constructor() {
    super(...arguments), this.title = "", this.message = "", this.overlay = !1;
  }
  render() {
    return w`
      <div class="success">
        <x-ds-success-mark data-qa-id="success-icon"></x-ds-success-mark>
        <x-ds-message-details
          class="${tn({
      hidden: !(this.title || this.message)
    })}"
          data-qa-id="success-details"
          data-title="${this.title}"
          data-message="${this.message}"
        ></x-ds-message-details>
        <div
          class="${tn({
      "success__button-container": !0,
      hidden: this.buttonElements.length === 0
    })}"
        >
          <slot
            name="button"
            @slotchange="${() => {
      this.requestUpdate();
    }}"
          ></slot>
        </div>
      </div>
    `;
  }
};
Eu.styles = [...N.styles, Gt(Uhe)];
ZS([
  M({
    type: String,
    attribute: "data-title",
    reflect: !0
  })
], Eu.prototype, "title", 2);
ZS([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], Eu.prototype, "message", 2);
ZS([
  M({
    type: String,
    attribute: "data-overlay",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Eu.prototype, "overlay", 2);
ZS([
  dr({
    slot: "button",
    flatten: !0
  })
], Eu.prototype, "buttonElements", 2);
Eu = ZS([
  be(),
  P("x-ds-success-message")
], Eu);
var Nhe = Object.defineProperty, Zhe = Object.getOwnPropertyDescriptor, Bhe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Zhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Nhe(t, r, a), a;
};
let U_ = class extends N {
  render() {
    return w`
      <div class="container">
        <slot></slot>
      </div>
    `;
  }
};
U_.styles = [
  ...N.styles,
  ee`
      :host {
        display: block;
        position: absolute;
        top: 3.5em;
        left: 1em;
        right: 1em;
        pointer-events: none;
      }

      .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
      }
    `
];
U_ = Bhe([
  be(),
  P("x-ds-top-message-container")
], U_);
var Whe = Object.defineProperty, Ehe = Object.getOwnPropertyDescriptor, CE = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Ehe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Whe(t, r, a), a;
};
let km = class extends N {
  render() {
    return w`
      <div class="page-items">
        <slot
          @slotchange="${() => {
      this.requestUpdate();
    }}"
          name="item"
          class="${tn({
      hidden: this.itemElements.length === 0
    })}"
        ></slot>
        <div
          class="${tn({
      "button-container": !0,
      hidden: this.buttonElements.length === 0
    })}"
        >
          <slot
            name="button"
            @slotchange="${() => {
      this.requestUpdate();
    }}"
          ></slot>
        </div>
      </div>
    `;
  }
};
km.styles = [
  ...N.styles,
  ee`
      .page-items {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
        align-items: center;
        max-width: 32em;
        margin: 0 auto;
      }

      .button-container {
        position: sticky;
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 0.25em;
        bottom: 0;
        width: 100%;
        padding-block: 1em;
        margin-block: -1em;
      }

      :host([data-color-scheme='light']) .button-container {
        background: var(--theme-light-app-container-bg-color);
      }

      :host([data-color-scheme='dark']) .button-container {
        background: var(--theme-dark-app-container-bg-color);
      }
    `
];
CE([
  dr({ slot: "item", flatten: !0 })
], km.prototype, "itemElements", 2);
CE([
  dr({ slot: "button", flatten: !0 })
], km.prototype, "buttonElements", 2);
km = CE([
  be(),
  P("x-ds-usability-check")
], km);
const fx = Symbol("powered-by-visible-context");
var Qhe = Object.defineProperty, Fhe = Object.getOwnPropertyDescriptor, mx = (e) => {
  throw TypeError(e);
}, ow = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Fhe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Qhe(t, r, a), a;
}, The = (e, t, r) => t.has(e) || mx("Cannot " + r), Rhe = (e, t, r) => t.has(e) ? mx("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Dhe = (e, t, r) => (The(e, t, "access private method"), r), k_, vx;
let ig = class extends N {
  constructor() {
    super(...arguments), Rhe(this, k_), this.poweredBy = "Powered by", this.version = "", this.poweredByVisible = !0;
  }
  render() {
    return w`
      <div class="watermark">
        ${this.poweredByVisible ? Dhe(this, k_, vx).call(this) : q}
        ${this.version ? w`<div class="watermark__version" data-qa-id="version">${this.version}</div>` : q}
      </div>
    `;
  }
};
k_ = /* @__PURE__ */ new WeakSet();
vx = function() {
  return w`
      <div class="watermark__text" data-qa-id="powered-by">${this.poweredBy}</div>
      <div class="watermark__logo"><span class="watermark__icon icon-jumio"></span></div>
    `;
};
ig.styles = [
  ...N.styles,
  ee`
      :host {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
      }

      .watermark {
        display: inline-grid;
        grid-template-columns: auto auto;
        grid-template-rows: auto auto;
        grid-template-areas:
          'text logo'
          'version version';
        direction: ltr;
      }

      .watermark__text {
        grid-area: text;
        font-size: 0.625em; /* 10 / 16 */
        line-height: 1.8em; /* 18 / 10 */
      }

      .watermark__logo {
        grid-area: logo;
      }

      .watermark__text + .watermark__logo {
        margin-left: 0.125em; /* 2 / 16 */
      }

      .watermark__version {
        grid-area: version;
        font-size: 0.5em;
        justify-self: center;
      }

      .watermark__version:empty {
        display: none;
      }
    `
];
ow([
  M({
    attribute: "data-powered-by",
    type: String,
    reflect: !0
  })
], ig.prototype, "poweredBy", 2);
ow([
  M({
    attribute: "data-version",
    type: String,
    reflect: !0
  })
], ig.prototype, "version", 2);
ow([
  td({ context: fx, subscribe: !0 }),
  M({
    attribute: "data-powered-by-visible",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => e.toString()
    }
  })
], ig.prototype, "poweredByVisible", 2);
ig = ow([
  P("x-ds-watermark")
], ig);
var Sx = /* @__PURE__ */ ((e) => (e.DocFinder = "doc-finder", e))(Sx || {}), __ = /* @__PURE__ */ ((e) => (e.Defined = "DEFINED", e.Recommended = "RECOMMENDED", e.Optional = "OPTIONAL", e))(__ || {}), M1 = /* @__PURE__ */ ((e) => (e.Passive = "PASSIVE", e.Active = "ACTIVE", e))(M1 || {}), bE = /* @__PURE__ */ ((e) => (e.Iovation = "IOVATION", e))(bE || {}), Me = /* @__PURE__ */ ((e) => (e.Setup = "setup", e.Start = "start", e.Finish = "finish", e))(Me || {}), Ot = /* @__PURE__ */ ((e) => (e.Workflow = "workflow", e.CrossDevice = "cross-device", e))(Ot || {}), T = /* @__PURE__ */ ((e) => (e.Id = "ID", e.Facemap = "FACEMAP", e.Document = "DOCUMENT", e.Data = "DATA", e))(T || {}), zn = /* @__PURE__ */ ((e) => (e.PASS = "PASS", e.REJECT = "REJECT", e.NOT_AVAILABLE = "NOT_AVAILABLE", e))(zn || {}), $t = /* @__PURE__ */ ((e) => (e.GENERIC = "0", e.DIGITAL_COPY = "104", e.BLACK_WHITE_COPY = "102", e.COLOR_PHOTOCOPY = "103", e.NOT_READABLE = "200", e.NO_DOCUMENT = "201", e.SAMPLE_DOCUMENT = "202", e.MISSING_BACK = "206", e.MISSING_FRONT = "214", e.UNSUPPORTED_ID = "401", e.INVALID_CERTIFICATE = "501", e.BLURRY = "2001", e.BAD_QUALITY = "2002", e.MISSING_PART_DOCUMENT = "2003", e.HIDDEN_PART_DOCUMENT = "2004", e.DAMAGED_DOCUMENT = "2005", e.GLARE = "2006", e.LIVENESS_GENERIC = "3001", e.LIVENESS_TOO_MUCH_MOVEMENT = "3002", e.LIVENESS_TOO_BRIGHT = "3003", e.LIVENESS_TOO_DARK = "3004", e.LIVENESS_EYES_CLOSED = "3005", e.LIVENESS_FACE_OBSCURED = "3006", e.LIVENESS_MULTIPLE_FACES = "3007", e.LIVENESS_SUNGLASSES = "3008", e))($t || {}), Ja = /* @__PURE__ */ ((e) => (e.Mrz = "MRZ", e.Nfc = "NFC", e.Barcode = "BARCODE", e.LineFinder = "LINEFINDER", e.DocFinder = "DOCFINDER", e.Manual = "MANUAL", e.FaceManual = "FACE_MANUAL", e.FaceIproov = "FACE_IPROOV", e.DataDog = "DATADOG", e.Sardine = "SARDINE", e.Iovation = "IOVATION", e.JumioLiveness = "JUMIO_LIVENESS", e.DigitalIdentity = "DIGITAL_IDENTITY", e))(Ja || {}), Jhe = /* @__PURE__ */ ((e) => (e.Id1 = "ID1", e.Id2 = "ID2", e.Id3 = "ID3", e.None = "NONE", e))(Jhe || {}), cr = /* @__PURE__ */ ((e) => (e.Front = "FRONT", e.Back = "BACK", e.None = "NONE", e))(cr || {}), xr = /* @__PURE__ */ ((e) => (e.WebP = "WEBP", e.Png = "PNG", e.Jpg = "JPG", e.Jpeg = "JPEG", e.Jpeg2000 = "JPEG_2000", e.Pdf = "PDF", e.Dat = "DAT", e))(xr || {}), or = /* @__PURE__ */ ((e) => (e.Document = "DOCUMENT", e.FrontSide = "FRONTSIDE", e.BackSide = "BACKSIDE", e.Face = "FACE", e.Iproov = "IPROOV", e.Video = "VIDEO", e.Screenshot = "SCREENSHOT", e.MrzImage = "MRZ_IMAGE", e))(or || {}), ft = /* @__PURE__ */ ((e) => (e.Passport = "PASSPORT", e.IdCard = "ID_CARD", e.ResidencePermit = "RESIDENCE_PERMIT", e.Visa = "VISA", e.DrivingLicense = "DRIVING_LICENSE", e.DigitalIdentity = "DIGITAL_IDENTITY", e))(ft || {}), fc = /* @__PURE__ */ ((e) => (e.Landscape = "landscape", e.Portrait = "portrait", e))(fc || {}), Vhe = /* @__PURE__ */ ((e) => (e.Smartphone = "SMARTPHONE", e.Tablet = "TABLET", e.Desktop = "DESKTOP", e.Other = "OTHER", e))(Vhe || {}), Mhe = /* @__PURE__ */ ((e) => (e.Mrp = "MRP", e.Td1 = "TD1", e.Td2 = "TD2", e.Cnis = "CNIS", e.MrvA = "MRV_A", e.MrvB = "MRV_B", e))(Mhe || {}), Ghe = /* @__PURE__ */ ((e) => (e.Cssn = "CSSN", e.Wintone = "WINTONE", e))(Ghe || {}), xhe = /* @__PURE__ */ ((e) => (e.Pdf417 = "PDF417", e))(xhe || {}), Hhe = /* @__PURE__ */ ((e) => (e.Front = "FRONT", e.Back = "BACK", e))(Hhe || {}), Lhe = /* @__PURE__ */ ((e) => (e.True = "TRUE", e.False = "FALSE", e.Bo = "BO", e))(Lhe || {}), Qu = /* @__PURE__ */ ((e) => (e.Paper = "PAPER", e.Plastic = "PLASTIC", e))(Qu || {}), qi = /* @__PURE__ */ ((e) => (e.Eu = "eu", e.Us = "us", e.Sgp = "sgp", e))(qi || {}), Wr = /* @__PURE__ */ ((e) => (e.Failed = "FAILED", e.NotStarted = "NOT_STARTED", e.Pending = "PENDING", e.Retry = "RETRY", e.Success = "SUCCESS", e))(Wr || {}), N_ = /* @__PURE__ */ ((e) => (e[e.NOT_TURNED_ON = 890] = "NOT_TURNED_ON", e[e.OUT_OF_ATTEMPTS = 891] = "OUT_OF_ATTEMPTS", e[e.INVALID_ADDRESS = 892] = "INVALID_ADDRESS", e[e.UNKNOWN = 893] = "UNKNOWN", e))(N_ || {}), Fu = /* @__PURE__ */ ((e) => (e.Camera = "camera", e.Upload = "upload", e))(Fu || {}), Kr = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.SettingsCall = 1] = "SettingsCall", e[e.ExtractDataCall = 3] = "ExtractDataCall", e[e.UploadCall = 4] = "UploadCall", e[e.ReportingCall = 5] = "ReportingCall", e[e.FinalizeCall = 6] = "FinalizeCall", e[e.UsabilityCall = 7] = "UsabilityCall", e[e.IproovTokenCall = 8] = "IproovTokenCall", e[e.IproovValidateCall = 9] = "IproovValidateCall", e[e.DigitalIdentityWebViewCall = 10] = "DigitalIdentityWebViewCall", e[e.DigitalIdentityOutcomeCall = 11] = "DigitalIdentityOutcomeCall", e[e.StatusCall = 20] = "StatusCall", e[e.CrossDeviceEmailCall = 21] = "CrossDeviceEmailCall", e[e.GetFilePartCall = 22] = "GetFilePartCall", e[e.UpdateMetadata = 23] = "UpdateMetadata", e))(Kr || {}), rt = /* @__PURE__ */ ((e) => (e[e.SystemError = 9100] = "SystemError", e[e.AuthTokenError = 9200] = "AuthTokenError", e[e.AuthSessionError = 9210] = "AuthSessionError", e[e.FileUploadError = 9300] = "FileUploadError", e[e.UsabilityError = 9400] = "UsabilityError", e[e.UserOffline = 9800] = "UserOffline", e[e.UnhandledError = 9801] = "UnhandledError", e[e.BrowserDoesNotSupportCamera = 9822] = "BrowserDoesNotSupportCamera", e[e.AuthFailed = 9836] = "AuthFailed", e[e.CredentialError = 9900] = "CredentialError", e))(rt || {}), Na = /* @__PURE__ */ ((e) => (e.NetworkProblems = "A", e.SecureConnectionFailed = "B", e.AuthenticationFailed = "C", e.DeviceIsOffline = "E", e.ResourceFailedToLoad = "F", e.CancelledByEndUser = "G", e.NoCameraConnection = "H", e.ALEKeyInvalid = "I", e.TransactionAlreadyFinished = "J", e.UnsupportedDocumentCode = "K", e.TransactionReferenceInvalid = "L", e.TransactionCannotBeCompleted = "M", e.SDKTokenError = "N", e))(Na || {}), Ft = /* @__PURE__ */ ((e) => (e.BC = "BC", e.BS = "BS", e.CAAP = "CAAP", e.CB = "CB", e.CC = "CC", e.CCS = "CCS", e.CRC = "CRC", e.HCC = "HCC", e.IC = "IC", e.LAG = "LAG", e.LOAP = "LOAP", e.MEDC = "MEDC", e.MOAP = "MOAP", e.PB = "PB", e.SEL = "SEL", e.SENC = "SENC", e.SS = "SS", e.SSC = "SSC", e.STUC = "STUC", e.TAC = "TAC", e.TR = "TR", e.UB = "UB", e.USSS = "USSS", e.VC = "VC", e.VT = "VT", e.WWCC = "WWCC", e.WP = "WP", e.CUSTOM = "CUSTOM", e))(Ft || {}), Z_ = /* @__PURE__ */ ((e) => (e.Alive = "alive", e.Stalled = "stalled", e))(Z_ || {}), nt = /* @__PURE__ */ ((e) => (e.ModuleLoadingError = "module-loading-error", e.ModuleInitializationError = "module-initialization-error", e.WorkerCrashed = "worker-crashed", e.WorkerError = "worker-error", e.PostMessageError = "post-message-error", e.Struggle = "struggle", e.Timeout = "timeout", e.UserSelection = "user-selection", e.ExcludedDevice = "excluded-device", e))(nt || {}), _ = /* @__PURE__ */ ((e) => (e.ABW = "ABW", e.AFG = "AFG", e.AGO = "AGO", e.AIA = "AIA", e.ALA = "ALA", e.ALB = "ALB", e.AND = "AND", e.ARE = "ARE", e.ARG = "ARG", e.ARM = "ARM", e.ASM = "ASM", e.ATA = "ATA", e.ATF = "ATF", e.ATG = "ATG", e.AUS = "AUS", e.AUT = "AUT", e.AZE = "AZE", e.BDI = "BDI", e.BEL = "BEL", e.BEN = "BEN", e.BES = "BES", e.BFA = "BFA", e.BGD = "BGD", e.BGR = "BGR", e.BHR = "BHR", e.BHS = "BHS", e.BIH = "BIH", e.BLM = "BLM", e.BLR = "BLR", e.BLZ = "BLZ", e.BMU = "BMU", e.BOL = "BOL", e.BRA = "BRA", e.BRB = "BRB", e.BRN = "BRN", e.BTN = "BTN", e.BVT = "BVT", e.BWA = "BWA", e.CAF = "CAF", e.CAN = "CAN", e.CCK = "CCK", e.CHE = "CHE", e.CHL = "CHL", e.CHN = "CHN", e.CIV = "CIV", e.CMR = "CMR", e.COD = "COD", e.COG = "COG", e.COK = "COK", e.COL = "COL", e.COM = "COM", e.CPV = "CPV", e.CRI = "CRI", e.CUB = "CUB", e.CUW = "CUW", e.CXR = "CXR", e.CYM = "CYM", e.CYP = "CYP", e.CZE = "CZE", e.DEU = "DEU", e.DJI = "DJI", e.DMA = "DMA", e.DNK = "DNK", e.DOM = "DOM", e.DZA = "DZA", e.ECU = "ECU", e.EGY = "EGY", e.ERI = "ERI", e.ESH = "ESH", e.ESP = "ESP", e.EST = "EST", e.ETH = "ETH", e.FIN = "FIN", e.FJI = "FJI", e.FLK = "FLK", e.FRA = "FRA", e.FRO = "FRO", e.FSM = "FSM", e.GAB = "GAB", e.GBR = "GBR", e.GEO = "GEO", e.GGY = "GGY", e.GHA = "GHA", e.GIB = "GIB", e.GIN = "GIN", e.GLP = "GLP", e.GMB = "GMB", e.GNB = "GNB", e.GNQ = "GNQ", e.GRC = "GRC", e.GRD = "GRD", e.GRL = "GRL", e.GTM = "GTM", e.GUF = "GUF", e.GUM = "GUM", e.GUY = "GUY", e.HKG = "HKG", e.HMD = "HMD", e.HND = "HND", e.HRV = "HRV", e.HTI = "HTI", e.HUN = "HUN", e.IDN = "IDN", e.IMN = "IMN", e.IND = "IND", e.IOT = "IOT", e.IRL = "IRL", e.IRN = "IRN", e.IRQ = "IRQ", e.ISL = "ISL", e.ISR = "ISR", e.ITA = "ITA", e.JAM = "JAM", e.JEY = "JEY", e.JOR = "JOR", e.JPN = "JPN", e.KAZ = "KAZ", e.KEN = "KEN", e.KGZ = "KGZ", e.KHM = "KHM", e.KIR = "KIR", e.KNA = "KNA", e.KOR = "KOR", e.KWT = "KWT", e.LAO = "LAO", e.LBN = "LBN", e.LBR = "LBR", e.LBY = "LBY", e.LCA = "LCA", e.LIE = "LIE", e.LKA = "LKA", e.LSO = "LSO", e.LTU = "LTU", e.LUX = "LUX", e.LVA = "LVA", e.MAC = "MAC", e.MAF = "MAF", e.MAR = "MAR", e.MCO = "MCO", e.MDA = "MDA", e.MDG = "MDG", e.MDV = "MDV", e.MEX = "MEX", e.MHL = "MHL", e.MKD = "MKD", e.MLI = "MLI", e.MLT = "MLT", e.MMR = "MMR", e.MNE = "MNE", e.MNG = "MNG", e.MNP = "MNP", e.MOZ = "MOZ", e.MRT = "MRT", e.MSR = "MSR", e.MTQ = "MTQ", e.MUS = "MUS", e.MWI = "MWI", e.MYS = "MYS", e.MYT = "MYT", e.NAM = "NAM", e.NCL = "NCL", e.NER = "NER", e.NFK = "NFK", e.NGA = "NGA", e.NIC = "NIC", e.NIU = "NIU", e.NLD = "NLD", e.NOR = "NOR", e.NPL = "NPL", e.NRU = "NRU", e.NZL = "NZL", e.OMN = "OMN", e.PAK = "PAK", e.PAN = "PAN", e.PCN = "PCN", e.PER = "PER", e.PHL = "PHL", e.PLW = "PLW", e.PNG = "PNG", e.POL = "POL", e.PRI = "PRI", e.PRK = "PRK", e.PRT = "PRT", e.PRY = "PRY", e.PSE = "PSE", e.PYF = "PYF", e.QAT = "QAT", e.REU = "REU", e.ROU = "ROU", e.RUS = "RUS", e.RWA = "RWA", e.SAU = "SAU", e.SDN = "SDN", e.SEN = "SEN", e.SGP = "SGP", e.SGS = "SGS", e.SHN = "SHN", e.SJM = "SJM", e.SLB = "SLB", e.SLE = "SLE", e.SLV = "SLV", e.SMR = "SMR", e.SOM = "SOM", e.SPM = "SPM", e.SRB = "SRB", e.SSD = "SSD", e.STP = "STP", e.SUR = "SUR", e.SVK = "SVK", e.SVN = "SVN", e.SWE = "SWE", e.SWZ = "SWZ", e.SXM = "SXM", e.SYC = "SYC", e.SYR = "SYR", e.TCA = "TCA", e.TCD = "TCD", e.TGO = "TGO", e.THA = "THA", e.TJK = "TJK", e.TKL = "TKL", e.TKM = "TKM", e.TLS = "TLS", e.TON = "TON", e.TTO = "TTO", e.TUN = "TUN", e.TUR = "TUR", e.TUV = "TUV", e.TWN = "TWN", e.TZA = "TZA", e.UGA = "UGA", e.UKR = "UKR", e.UMI = "UMI", e.URY = "URY", e.USA = "USA", e.UZB = "UZB", e.VAT = "VAT", e.VCT = "VCT", e.VEN = "VEN", e.VGB = "VGB", e.VIR = "VIR", e.VNM = "VNM", e.VUT = "VUT", e.WLF = "WLF", e.WSM = "WSM", e.XKX = "XKX", e.YEM = "YEM", e.ZAF = "ZAF", e.ZMB = "ZMB", e.ZWE = "ZWE", e))(_ || {});
const B_ = {
  domain: Na.NetworkProblems,
  message: "public-error.network_problems",
  retry: !0,
  legacyCode: rt.SystemError
}, Yhe = {
  domain: Na.NetworkProblems,
  message: "public-error.network_problems",
  retry: !1,
  legacyCode: rt.SystemError
}, qJe = {
  domain: Na.SecureConnectionFailed,
  message: "public-error.auth_failed",
  retry: !1,
  legacyCode: rt.AuthFailed
}, Ohe = {
  domain: Na.AuthenticationFailed,
  message: "public-error.auth_failed",
  retry: !1,
  legacyCode: rt.AuthTokenError
}, jhe = {
  domain: Na.TransactionCannotBeCompleted,
  message: "public-error.credential_error",
  retry: !1,
  legacyCode: rt.CredentialError
}, eVe = {
  domain: Na.DeviceIsOffline,
  message: "public-error.device_offline",
  retry: !0,
  legacyCode: rt.UserOffline
}, tVe = {
  domain: Na.ResourceFailedToLoad,
  message: "public-error.ocr_failed",
  retry: !1,
  legacyCode: rt.UnhandledError
}, rVe = {
  domain: Na.CancelledByEndUser,
  message: "public-error.user_cancelled",
  retry: !1,
  legacyCode: rt.UnhandledError
}, nVe = {
  domain: Na.NoCameraConnection,
  message: "public-error.no_camera",
  retry: !1,
  legacyCode: rt.BrowserDoesNotSupportCamera
}, Phe = {
  domain: Na.ALEKeyInvalid,
  message: "public-error.invalid_cert",
  retry: !1,
  legacyCode: rt.AuthFailed
}, yE = {
  domain: Na.TransactionAlreadyFinished,
  message: "public-error.session_expired",
  retry: !1,
  legacyCode: rt.AuthSessionError
}, $he = {
  domain: Na.SDKTokenError,
  message: "public-error.ocr_failed",
  retry: !1,
  legacyCode: rt.UnhandledError
}, Khe = {
  legacyCode: rt.UnhandledError,
  domain: Na.TransactionCannotBeCompleted,
  message: "451 - Unavailable for legal reasons",
  retry: !1
};
var ei = /* @__PURE__ */ ((e) => (e.IproovStandard = "IPROOV_STANDARD", e.IproovPremium = "IPROOV_PREMIUM", e.JumioStandard = "JUMIO_STANDARD", e.JumioLiveness = "JUMIO_LIVENESS", e.JumioPremium = "JUMIO_PREMIUM", e))(ei || {});
class es extends DOMException {
  constructor(t) {
    var r;
    super(
      (() => {
        const { publicError: n, ...a } = t;
        return JSON.stringify(a);
      })(),
      ((r = t.publicError) == null ? void 0 : r.code()) ?? `HTTP Error ${t.httpStatus}`
    ), this.details = t;
  }
}
var Xhe = /* @__PURE__ */ ((e) => (e.TestEu = "test-eu", e.TestUs = "test-us", e.StagingEu = "staging-eu", e.StagingUs = "staging-us", e.ProdEu = "prod-eu", e.ProdUs = "prod-us", e.ProdSgp = "prod-sgp", e.Simulator = "simulator", e))(Xhe || {}), ol = /* @__PURE__ */ ((e) => (e.Disabled = "disabled", e.Soft = "soft", e.Strict = "strict", e))(ol || {}), zhe = Object.defineProperty, Ix = (e) => {
  throw TypeError(e);
}, qhe = (e, t, r) => t in e ? zhe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Qo = (e, t, r) => qhe(e, typeof t != "symbol" ? t + "" : t, r), wE = (e, t, r) => t.has(e) || Ix("Cannot " + r), $h = (e, t, r) => (wE(e, t, "read from private field"), r ? r.call(e) : t.get(e)), gU = (e, t, r) => t.has(e) ? Ix("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), W_ = (e, t, r, n) => (wE(e, t, "write to private field"), t.set(e, r), r), Ki = (e, t, r) => (wE(e, t, "access private method"), r);
const Cx = "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", epe = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), x5 = typeof self < "u" && self.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", epe(Cx)], { type: "text/javascript;charset=utf-8" });
function H5(e) {
  let t;
  try {
    if (t = x5 && (self.URL || self.webkitURL).createObjectURL(x5), !t) throw "";
    const r = new Worker(t, {
      type: "module",
      name: e == null ? void 0 : e.name
    });
    return r.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), r;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + Cx,
      {
        type: "module",
        name: e == null ? void 0 : e.name
      }
    );
  }
}
var _m = /* @__PURE__ */ ((e) => (e.FaceFinder = "face_finder", e.FaceFinderLiveness = "face_finder_liveness", e.FaceIdFinder = "face_id_finder", e.FaceIdFinderLiveness = "face_id_finder_liveness", e.IdFinder = "id_finder", e.IdFinderLiveness = "id_finder_liveness", e.IdLiveness = "id_liveness", e.Premium = "premium", e.PremiumWeb = "premium_web", e.Standard = "standard", e.StandardWeb = "standard_web", e))(_m || {}), He = /* @__PURE__ */ ((e) => (e.CameraLivenessEnd = "camera_liveness_end", e.CameraLivenessReqStatus = "camera_liveness_req_status", e.CameraLivenessStart = "camera_liveness_start", e.CameraLivenessStatus = "camera_liveness_status", e.CreateWasmInstance = "_create_wasm_instance", e.CreateWasmInstanceSuccess = "_create_wasm_instance_success", e.DocIdEnd = "doc_id_end", e.DocIdInfo = "doc_id_info", e.DocIdStart = "doc_id_start", e.Enroll = "enroll", e.FarPhotinusEnd = "far_photinus_end", e.FarPhotinusStart = "far_photinus_start", e.GetConfig = "get_config", e.GetConfigResult = "get_config_result", e.Image = "image", e.Initialize = "initialize", e.InitializeError = "initialize_error", e.InitializeSuccess = "initialize_success", e.InitializeWasm = "initialize_wasm", e.MotionEnd = "motion_end", e.MotionStart = "motion_start", e.NearPhotinusEnd = "near_photinus_end", e.NearPhotinusStart = "near_photinus_start", e.PhotinusPattern = "photinus_pattern", e.Pose = "pose", e.PoseReady = "pose_ready", e.PoseStart = "pose_start", e.Ready = "ready", e.RefDistance = "ref_distance", e.ServerDataBlob = "server_data_blob", e.SetMode = "set_mode", e.StartSession = "start_session", e.Terminate = "terminate", e.TerminateError = "terminate_error", e.TerminateSuccess = "terminate_success", e.Verify = "verify", e.VisorInfo = "visor_info", e.UXCommand = "ux_command", e))(He || {}), Zr = /* @__PURE__ */ ((e) => (e.FaceHoldStill = "face_hold_still", e.FaceHoldStillInitial = "face_hold_still_initial", e.FaceKeepCenterSevere = "face_keep_center_severe", e.FaceMoveAway = "face_move_away", e.FaceMoveCloser = "face_move_closer", e.FaceNoneDetected = "face_none_detected", e.FaceNotUpright = "face_not_upright", e.FaceStopMovement = "face_stop_movement", e.FaceTiltDown = "face_tilt_down", e.FaceTiltLeft = "face_tilt_left", e.FaceTiltRight = "face_tilt_right", e.FaceTiltUp = "face_tilt_up", e.Finish = "finish", e.KeepFaceCenter = "face_keep_center", e.MoreCapturesNeeded = "more_captures_needed", e.Start = "start", e))(Zr || {}), E_ = /* @__PURE__ */ ((e) => (e.HintMoveAway = "hint_move_away", e.HintMoveCloser = "hint_move_closer", e))(E_ || {});
const BS = (e, t, r = () => !0) => {
  if (typeof e == "object" && e !== null) {
    for (const n of t)
      if (!(n in e))
        return !1;
    return r(e);
  }
  return !1;
}, tpe = async (e, t) => new Promise((r) => {
  const n = (a) => {
    BS(
      a.data,
      ["event", "timestamp", "names"],
      (i) => i.event === He.GetConfigResult
    ) && (r(a.data), e.removeEventListener("message", n));
  };
  e.addEventListener("message", n), e.postMessage(t);
}), L5 = async (e, t) => new Promise((r) => {
  const n = (a) => {
    BS(
      a.data,
      ["event", "timestamp"],
      (i) => i.event === He.CreateWasmInstanceSuccess
    ) && (r(a.data), e.removeEventListener("message", n));
  };
  e.addEventListener("message", n), e.postMessage(t);
}), rpe = async (e, t) => new Promise((r, n) => {
  const a = (i) => {
    BS(
      i.data,
      ["event", "timestamp"],
      (o) => [He.InitializeSuccess, He.InitializeError].includes(o.event)
    ) && (i.data.event === He.InitializeSuccess ? r(i.data) : n(new Error(`${i.data.objectName}: ${i.data.event}`)), e.removeEventListener("message", a));
  };
  e.addEventListener("message", a), e.postMessage(t);
}), npe = async (e, t) => new Promise((r) => {
  const n = (a) => {
    BS(
      a.data,
      ["event", "timestamp"],
      (i) => i.event === He.Ready && i.timestamp === t.timestamp
    ) && (r(a.data), e.removeEventListener("message", n));
  };
  e.addEventListener("message", n), t.fn();
});
class ape {
  constructor() {
    Qo(this, "numExtraEvents", 4), Qo(this, "events", []), Qo(this, "throttledEvents", []), Qo(this, "useNewestThrottleEvent", !0), Qo(this, "maxOldestThrottleEvents", -1), Qo(this, "triggerEvent"), Qo(this, "acceptNextFrame", !0);
  }
  setMaxOldestEvents(t, r) {
    if (this.useNewestThrottleEvent = !1, this.maxOldestThrottleEvents = t, this.triggerEvent = r, this.triggerEvent) {
      this.acceptNextFrame = !1;
      const n = [];
      let a = this.events.shift();
      for (; a; )
        this.isThrottledEvent(a) ? this.acceptNextFrame && (n.push(a), this.acceptNextFrame = !1) : this.triggerEvent === a.event ? this.acceptNextFrame = !0 : n.push(a), a = this.events.shift();
      this.events = n;
    }
  }
  setThrottledEvents(t) {
    this.throttledEvents = t;
  }
  addEvent(t) {
    if (this.triggerEvent && this.triggerEvent === t.event) {
      this.acceptNextFrame = !0;
      return;
    }
    if (this.isThrottledEvent(t)) {
      if (this.triggerEvent)
        if (this.acceptNextFrame)
          this.acceptNextFrame = !1;
        else
          return;
      const r = this.getNumThrottledEventsInt();
      if (this.maxOldestThrottleEvents >= 0) {
        const n = this.maxOldestThrottleEvents + this.numExtraEvents;
        if (r >= n) {
          if (this.maxOldestThrottleEvents)
            return;
          this.removeFirstThrottledEvent();
        }
      } else if (this.useNewestThrottleEvent) {
        const n = this.numExtraEvents + 1;
        r >= n && this.removeFirstThrottledEvent();
      }
    }
    this.events.push(t);
  }
  getEvent() {
    const t = this.events.shift();
    if (t) {
      if (this.useNewestThrottleEvent || !this.isThrottledEvent(t))
        return t;
      if (this.maxOldestThrottleEvents)
        return this.maxOldestThrottleEvents > 0 && (this.maxOldestThrottleEvents--, this.maxOldestThrottleEvents || (this.triggerEvent = void 0)), t;
    }
  }
  get length() {
    return this.events.length;
  }
  get isEmpty() {
    return this.events.length === 0;
  }
  isThrottledEvent(t) {
    return this.throttledEvents.some((r) => r === t.event);
  }
  getNumThrottledEventsInt() {
    let t = 0;
    for (const r of this.events)
      this.isThrottledEvent(r) && t++;
    return t;
  }
  removeFirstThrottledEvent() {
    if (this.length === 0)
      return;
    let t = -1;
    for (const [r, n] of this.events.entries())
      if (this.isThrottledEvent(n)) {
        t = r;
        break;
      }
    t < 0 || this.events.splice(t, 1);
  }
}
function ipe(e) {
  if (e instanceof ImageData)
    return e.data.buffer;
  if (typeof e == "object" && e && "buffer" in e && e.buffer && e.buffer instanceof ArrayBuffer)
    return e.buffer;
}
function ope(e) {
  return typeof e == "object" && e ? Object.values(e).map(ipe).filter((t) => !!t) : [];
}
var rl, G1, Oa, bx, Y5, yx, fU, mU, O5, j5, Q_;
const kd = class {
  constructor() {
    gU(this, Oa), Qo(this, "onmessage"), Qo(this, "onerror"), gU(this, rl, []), gU(this, G1, []);
  }
  terminate() {
    for (const t of $h(this, rl))
      t.isReady = !1, t.worker.terminate();
    W_(this, rl, []);
  }
  isWorkerReady(t) {
    return !!$h(this, rl).find((r) => r.objectName === t && r.isReady);
  }
  async postMessage(t) {
    if (t.event === He.InitializeWasm) {
      const r = await Ki(this, Oa, yx).call(this, t);
      W_(this, G1, r.output_events.split(","));
      const n = r.names.split(",");
      await Ki(this, Oa, bx).call(this, n, t);
      return;
    }
    Ki(this, Oa, Q_).call(this, t);
  }
};
rl = /* @__PURE__ */ new WeakMap(), G1 = /* @__PURE__ */ new WeakMap(), Oa = /* @__PURE__ */ new WeakSet(), bx = async function(e, t) {
  try {
    W_(this, rl, await Promise.all(
      e.map((r) => Ki(this, Oa, Y5).call(this, r, t))
    )), Ki(this, Oa, fU).call(this, {
      event: He.InitializeSuccess,
      timestamp: t.timestamp,
      objectName: kd.ID
    });
  } catch (r) {
    Ki(this, Oa, mU).call(this, {
      event: He.InitializeError,
      timestamp: t.timestamp,
      objectName: kd.ID,
      reason: r instanceof Error ? r.message : `${kd.ID}: Failed to initialize one of the workers`
    });
  }
}, Y5 = async function(e, t) {
  var r;
  const n = new H5(), a = new ape(), i = {
    worker: n,
    objectName: e,
    isReady: void 0,
    acceptableEvents: [],
    throttledEvents: [],
    maxEvents: Number.MAX_VALUE,
    queue: a
  };
  n.onmessage = (s) => {
    if (BS(s.data, ["event", "timestamp"]))
      switch (s.data.event) {
        case He.CreateWasmInstanceSuccess:
          break;
        case He.Ready:
        case He.InitializeSuccess:
          i.isReady = !0;
          break;
        case He.InitializeError:
          i.isReady = !1;
          break;
        default:
          Ki(this, Oa, fU).call(this, s.data);
      }
  }, n.onerror = (s) => {
    i.isReady = !1, Ki(this, Oa, mU).call(this, s);
  }, await L5(n, {
    event: He.CreateWasmInstance,
    objectName: i.objectName,
    timestamp: Date.now().toString(),
    wasm_module: t.wasm_module
  });
  const o = await rpe(n, {
    assets: t.assets,
    config_name: t.config_name,
    event: He.Initialize,
    object_name: e,
    timestamp: Date.now().toString()
  });
  return i.acceptableEvents = ((r = o.event_names) == null ? void 0 : r.split(",")) ?? [], o.throttled_events && (i.throttledEvents = o.throttled_events.split(","), a.setThrottledEvents(i.throttledEvents)), o.max_events && (i.maxEvents = Number.parseInt(o.max_events), a.setMaxOldestEvents(i.maxEvents)), i;
}, yx = async function(e) {
  const t = new H5({ name: kd.ID });
  await L5(t, {
    event: He.CreateWasmInstance,
    objectName: kd.ID,
    timestamp: Date.now().toString(),
    wasm_module: e.wasm_module
  });
  const r = await tpe(t, {
    assets: e.assets,
    config_name: e.config_name,
    event: He.GetConfig,
    timestamp: Date.now().toString()
  });
  return t.terminate(), r;
}, fU = function(e) {
  var t;
  Ki(this, Oa, O5).call(this, e) && ((t = this.onmessage) == null || t.call(this, { data: e }));
  const r = $h(this, rl).filter((n) => n.objectName !== e.objectName);
  Ki(this, Oa, Q_).call(this, e, r);
}, mU = function(e) {
  var t;
  (t = this.onerror) == null || t.call(this, e);
}, O5 = function(e) {
  return $h(this, G1).includes(e.event) || e.event === He.InitializeSuccess || e.event === He.InitializeError;
}, j5 = async function() {
  for (const e of $h(this, rl)) {
    if (!e.isReady || e.queue.isEmpty)
      continue;
    let t;
    do {
      if (e.isReady = !1, t = e.queue.getEvent(), t) {
        const r = await npe(e.worker, t);
        r.max_events && e.queue.setMaxOldestEvents(Number.parseInt(r.max_events), r.trigger_event);
      }
      e.isReady = !0;
    } while (t && e.isReady);
  }
}, Q_ = function(e, t = $h(this, rl)) {
  const r = t.filter((i) => i.acceptableEvents.includes(e.event)), n = r.length === 1, a = ope(e);
  r.forEach((i) => {
    const o = () => {
      n && a.length > 0 ? i.worker.postMessage(e, a) : i.worker.postMessage(e);
    };
    i.queue.addEvent({
      event: e.event,
      timestamp: e.timestamp,
      fn: o
    });
  }), queueMicrotask(Ki(this, Oa, j5).bind(this));
}, Qo(kd, "ID", "da-system");
let wx = kd;
const spe = async () => WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));
var lpe = (() => {
  var e, t = typeof document < "u" ? (e = document.currentScript) == null ? void 0 : e.src : void 0;
  return function(r = {}) {
    var n, a = r, i, o, s = new Promise((d, h) => {
      i = d, o = h;
    }), c = typeof window == "object", l = typeof importScripts == "function", u = Object.assign({}, a), g = "./this.program", p = "", m, I;
    (c || l) && (l ? p = self.location.href : typeof document < "u" && document.currentScript && (p = document.currentScript.src), t && (p = t), p.startsWith("blob:") ? p = "" : p = p.substr(0, p.replace(/[?#].*/, "").lastIndexOf("/") + 1), l && (I = (d) => {
      var h = new XMLHttpRequest();
      return h.open("GET", d, !1), h.responseType = "arraybuffer", h.send(null), new Uint8Array(h.response);
    }), m = (d) => fetch(d, { credentials: "same-origin" }).then((h) => h.ok ? h.arrayBuffer() : Promise.reject(Error(h.status + " : " + h.url))));
    var C = a.print || console.log.bind(console), A = a.printErr || console.error.bind(console);
    Object.assign(a, u), u = null, a.thisProgram && (g = a.thisProgram);
    var U = a.wasmBinary, B, J = !1, W, L, H, R, ge, z, K, Fe, yr;
    function hr() {
      var d = B.buffer;
      a.HEAP8 = L = new Int8Array(d), a.HEAP16 = R = new Int16Array(d), a.HEAPU8 = H = new Uint8Array(d), a.HEAPU16 = ge = new Uint16Array(d), a.HEAP32 = z = new Int32Array(d), a.HEAPU32 = K = new Uint32Array(d), a.HEAPF32 = Fe = new Float32Array(d), a.HEAPF64 = yr = new Float64Array(d);
    }
    var ea = [], Rn = [], vs = [], Ss = [];
    function Tl() {
      var d = a.preRun.shift();
      ea.unshift(d);
    }
    var ta = 0, Rr = null;
    function wr(d) {
      var h;
      throw (h = a.onAbort) == null || h.call(a, d), d = "Aborted(" + d + ")", A(d), J = !0, W = 1, d = new WebAssembly.RuntimeError(d + ". Build with -sASSERTIONS for more info."), o(d), d;
    }
    var ye = (d) => d.startsWith("data:application/octet-stream;base64,"), fr;
    function Rl(d) {
      if (d == fr && U) return new Uint8Array(U);
      if (I) return I(d);
      throw "both async and sync fetching of the wasm failed";
    }
    function mr(d) {
      return U ? Promise.resolve().then(() => Rl(d)) : m(d).then((h) => new Uint8Array(h), () => Rl(d));
    }
    function aI(d, h, f) {
      return mr(d).then((v) => WebAssembly.instantiate(v, h)).then(f, (v) => {
        A(`failed to asynchronously prepare wasm: ${v}`), wr(v);
      });
    }
    function iA(d, h) {
      var f = fr;
      return U || typeof WebAssembly.instantiateStreaming != "function" || ye(f) || typeof fetch != "function" ? aI(f, d, h) : fetch(f, { credentials: "same-origin" }).then((v) => WebAssembly.instantiateStreaming(v, d).then(h, function(b) {
        return A(`wasm streaming compile failed: ${b}`), A("falling back to ArrayBuffer instantiation"), aI(f, d, h);
      }));
    }
    var Xe, Ar;
    function Qa(d) {
      this.name = "ExitStatus", this.message = `Program terminated with exit(${d})`, this.status = d;
    }
    var hd = (d) => {
      for (; 0 < d.length; ) d.shift()(a);
    }, Dl = a.noExitRuntime || !0, Ji = [], uh = 0, Fa = 0;
    class pd {
      constructor(h) {
        this.aa = h, this.h = h - 24;
      }
    }
    var hh = (d) => {
      var h = Fa;
      if (!h) return w0(0), 0;
      var f = new pd(h);
      K[f.h + 16 >> 2] = h;
      var v = K[f.h + 4 >> 2];
      if (!v) return w0(0), h;
      for (var b of d) {
        if (b === 0 || b === v) break;
        if (pR(b, v, f.h + 16)) return w0(b), h;
      }
      return w0(v), h;
    }, ph = () => {
      var d = Ji.pop();
      d || wr("no exception to throw");
      var h = d.aa;
      throw L[d.h + 13] == 0 && (Ji.push(d), L[d.h + 13] = 1, L[d.h + 12] = 0, uh++), Fa = h, Fa;
    };
    function ii() {
      var d = z[+v0 >> 2];
      return v0 += 4, d;
    }
    var p0 = (d, h) => {
      for (var f = 0, v = d.length - 1; 0 <= v; v--) {
        var b = d[v];
        b === "." ? d.splice(v, 1) : b === ".." ? (d.splice(v, 1), f++) : f && (d.splice(v, 1), f--);
      }
      if (h) for (; f; f--) d.unshift("..");
      return d;
    }, Is = (d) => {
      var h = d.charAt(0) === "/", f = d.substr(-1) === "/";
      return (d = p0(d.split("/").filter((v) => !!v), !h).join("/")) || h || (d = "."), d && f && (d += "/"), (h ? "/" : "") + d;
    }, oA = (d) => {
      var h = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(d).slice(1);
      return d = h[0], h = h[1], !d && !h ? "." : (h && (h = h.substr(0, h.length - 1)), d + h);
    }, iI = (d) => {
      if (d === "/") return "/";
      d = Is(d), d = d.replace(/\/$/, "");
      var h = d.lastIndexOf("/");
      return h === -1 ? d : d.substr(h + 1);
    }, sA = () => {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (d) => crypto.getRandomValues(d);
      wr("initRandomDevice");
    }, oI = (d) => (oI = sA())(d), So = (...d) => {
      for (var h = "", f = !1, v = d.length - 1; -1 <= v && !f; v--) {
        if (f = 0 <= v ? d[v] : "/", typeof f != "string") throw new TypeError("Arguments to path.resolve must be strings");
        if (!f) return "";
        h = f + "/" + h, f = f.charAt(0) === "/";
      }
      return h = p0(h.split("/").filter((b) => !!b), !f).join("/"), (f ? "/" : "") + h || ".";
    }, sI = typeof TextDecoder < "u" ? new TextDecoder() : void 0, Vi = (d, h, f) => {
      var v = h + f;
      for (f = h; d[f] && !(f >= v); ) ++f;
      if (16 < f - h && d.buffer && sI) return sI.decode(d.subarray(h, f));
      for (v = ""; h < f; ) {
        var b = d[h++];
        if (b & 128) {
          var k = d[h++] & 63;
          if ((b & 224) == 192) v += String.fromCharCode((b & 31) << 6 | k);
          else {
            var Q = d[h++] & 63;
            b = (b & 240) == 224 ? (b & 15) << 12 | k << 6 | Q : (b & 7) << 18 | k << 12 | Q << 6 | d[h++] & 63, 65536 > b ? v += String.fromCharCode(b) : (b -= 65536, v += String.fromCharCode(55296 | b >> 10, 56320 | b & 1023));
          }
        } else v += String.fromCharCode(b);
      }
      return v;
    }, g0 = [], gh = (d) => {
      for (var h = 0, f = 0; f < d.length; ++f) {
        var v = d.charCodeAt(f);
        127 >= v ? h++ : 2047 >= v ? h += 2 : 55296 <= v && 57343 >= v ? (h += 4, ++f) : h += 3;
      }
      return h;
    }, F = (d, h, f, v) => {
      if (!(0 < v)) return 0;
      var b = f;
      v = f + v - 1;
      for (var k = 0; k < d.length; ++k) {
        var Q = d.charCodeAt(k);
        if (55296 <= Q && 57343 >= Q) {
          var D = d.charCodeAt(++k);
          Q = 65536 + ((Q & 1023) << 10) | D & 1023;
        }
        if (127 >= Q) {
          if (f >= v) break;
          h[f++] = Q;
        } else {
          if (2047 >= Q) {
            if (f + 1 >= v) break;
            h[f++] = 192 | Q >> 6;
          } else {
            if (65535 >= Q) {
              if (f + 2 >= v) break;
              h[f++] = 224 | Q >> 12;
            } else {
              if (f + 3 >= v) break;
              h[f++] = 240 | Q >> 18, h[f++] = 128 | Q >> 12 & 63;
            }
            h[f++] = 128 | Q >> 6 & 63;
          }
          h[f++] = 128 | Q & 63;
        }
      }
      return h[f] = 0, f - b;
    }, V = [];
    function $(d, h) {
      V[d] = { input: [], C: [], N: h }, cA(d, ce);
    }
    var ce = { open(d) {
      var h = V[d.node.X];
      if (!h) throw new we(43);
      d.o = h, d.seekable = !1;
    }, close(d) {
      d.o.N.ba(d.o);
    }, ba(d) {
      d.o.N.ba(d.o);
    }, read(d, h, f, v) {
      if (!d.o || !d.o.N.sa) throw new we(60);
      for (var b = 0, k = 0; k < v; k++) {
        try {
          var Q = d.o.N.sa(d.o);
        } catch {
          throw new we(29);
        }
        if (Q === void 0 && b === 0) throw new we(6);
        if (Q == null) break;
        b++, h[f + k] = Q;
      }
      return b && (d.node.timestamp = Date.now()), b;
    }, write(d, h, f, v) {
      if (!d.o || !d.o.N.ka) throw new we(60);
      try {
        for (var b = 0; b < v; b++) d.o.N.ka(d.o, h[f + b]);
      } catch {
        throw new we(29);
      }
      return v && (d.node.timestamp = Date.now()), b;
    } }, Qe = { sa() {
      e: {
        if (!g0.length) {
          var d = null;
          if (typeof window < "u" && typeof window.prompt == "function" && (d = window.prompt("Input: "), d !== null && (d += `
`)), !d) {
            var h = null;
            break e;
          }
          h = Array(gh(d) + 1), d = F(d, h, 0, h.length), h.length = d, g0 = h;
        }
        h = g0.shift();
      }
      return h;
    }, ka(d, h) {
      h === null || h === 10 ? (C(Vi(d.C, 0)), d.C = []) : h != 0 && d.C.push(h);
    }, ba(d) {
      d.C && 0 < d.C.length && (C(Vi(d.C, 0)), d.C = []);
    }, Ta() {
      return { lb: 25856, nb: 5, kb: 191, mb: 35387, jb: [
        3,
        28,
        127,
        21,
        4,
        0,
        1,
        0,
        17,
        19,
        26,
        0,
        18,
        15,
        23,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ] };
    }, Ua() {
      return 0;
    }, Va() {
      return [24, 80];
    } }, Ur = { ka(d, h) {
      h === null || h === 10 ? (A(Vi(d.C, 0)), d.C = []) : h != 0 && d.C.push(h);
    }, ba(d) {
      d.C && 0 < d.C.length && (A(Vi(d.C, 0)), d.C = []);
    } };
    function pr(d, h) {
      var f = d.j ? d.j.length : 0;
      f >= h || (h = Math.max(h, f * (1048576 > f ? 2 : 1.125) >>> 0), f != 0 && (h = Math.max(h, 256)), f = d.j, d.j = new Uint8Array(h), 0 < d.u && d.j.set(f.subarray(0, d.u), 0));
    }
    var pe = { J: null, M() {
      return pe.createNode(null, "/", 16895, 0);
    }, createNode(d, h, f, v) {
      if ((f & 61440) === 24576 || (f & 61440) === 4096) throw new we(63);
      return pe.J || (pe.J = { dir: { node: { I: pe.i.I, L: pe.i.L, W: pe.i.W, ea: pe.i.ea, Aa: pe.i.Aa, Ca: pe.i.Ca, Ba: pe.i.Ba, za: pe.i.za, ga: pe.i.ga }, stream: { S: pe.l.S } }, file: { node: { I: pe.i.I, L: pe.i.L }, stream: { S: pe.l.S, read: pe.l.read, write: pe.l.write, na: pe.l.na, ua: pe.l.ua, wa: pe.l.wa } }, link: { node: { I: pe.i.I, L: pe.i.L, Y: pe.i.Y }, stream: {} }, oa: { node: { I: pe.i.I, L: pe.i.L }, stream: aq } }), f = TT(d, h, f, v), (f.mode & 61440) === 16384 ? (f.i = pe.J.dir.node, f.l = pe.J.dir.stream, f.j = {}) : (f.mode & 61440) === 32768 ? (f.i = pe.J.file.node, f.l = pe.J.file.stream, f.u = 0, f.j = null) : (f.mode & 61440) === 40960 ? (f.i = pe.J.link.node, f.l = pe.J.link.stream) : (f.mode & 61440) === 8192 && (f.i = pe.J.oa.node, f.l = pe.J.oa.stream), f.timestamp = Date.now(), d && (d.j[h] = f, d.timestamp = f.timestamp), f;
    }, pb(d) {
      return d.j ? d.j.subarray ? d.j.subarray(0, d.u) : new Uint8Array(d.j) : new Uint8Array(0);
    }, i: { I(d) {
      var h = {};
      return h.Ia = (d.mode & 61440) === 8192 ? d.id : 1, h.ta = d.id, h.mode = d.mode, h.$a = 1, h.uid = 0, h.Qa = 0, h.X = d.X, (d.mode & 61440) === 16384 ? h.size = 4096 : (d.mode & 61440) === 32768 ? h.size = d.u : (d.mode & 61440) === 40960 ? h.size = d.link.length : h.size = 0, h.Da = new Date(d.timestamp), h.Ya = new Date(d.timestamp), h.Ha = new Date(d.timestamp), h.Ea = 4096, h.Fa = Math.ceil(h.size / h.Ea), h;
    }, L(d, h) {
      if (h.mode !== void 0 && (d.mode = h.mode), h.timestamp !== void 0 && (d.timestamp = h.timestamp), h.size !== void 0 && (h = h.size, d.u != h)) if (h == 0) d.j = null, d.u = 0;
      else {
        var f = d.j;
        d.j = new Uint8Array(h), f && d.j.set(f.subarray(0, Math.min(h, d.u))), d.u = h;
      }
    }, W() {
      throw f0[44];
    }, ea(d, h, f, v) {
      return pe.createNode(
        d,
        h,
        f,
        v
      );
    }, Aa(d, h, f) {
      if ((d.mode & 61440) === 16384) {
        try {
          var v = lI(h, f);
        } catch {
        }
        if (v) for (var b in v.j) throw new we(55);
      }
      delete d.parent.j[d.name], d.parent.timestamp = Date.now(), d.name = f, h.j[f] = d, h.timestamp = d.parent.timestamp;
    }, Ca(d, h) {
      delete d.j[h], d.timestamp = Date.now();
    }, Ba(d, h) {
      var f = lI(d, h), v;
      for (v in f.j) throw new we(55);
      delete d.j[h], d.timestamp = Date.now();
    }, za(d) {
      var h = [".", ".."], f;
      for (f of Object.keys(d.j)) h.push(f);
      return h;
    }, ga(d, h, f) {
      return d = pe.createNode(d, h, 41471, 0), d.link = f, d;
    }, Y(d) {
      if ((d.mode & 61440) !== 40960) throw new we(28);
      return d.link;
    } }, l: { read(d, h, f, v, b) {
      var k = d.node.j;
      if (b >= d.node.u) return 0;
      if (d = Math.min(d.node.u - b, v), 8 < d && k.subarray) h.set(k.subarray(b, b + d), f);
      else for (v = 0; v < d; v++) h[f + v] = k[b + v];
      return d;
    }, write(d, h, f, v, b, k) {
      if (h.buffer === L.buffer && (k = !1), !v) return 0;
      if (d = d.node, d.timestamp = Date.now(), h.subarray && (!d.j || d.j.subarray)) {
        if (k) return d.j = h.subarray(f, f + v), d.u = v;
        if (d.u === 0 && b === 0) return d.j = h.slice(f, f + v), d.u = v;
        if (b + v <= d.u) return d.j.set(h.subarray(f, f + v), b), v;
      }
      if (pr(d, b + v), d.j.subarray && h.subarray) d.j.set(h.subarray(f, f + v), b);
      else for (k = 0; k < v; k++) d.j[b + k] = h[f + k];
      return d.u = Math.max(d.u, b + v), v;
    }, S(d, h, f) {
      if (f === 1 ? h += d.position : f === 2 && (d.node.mode & 61440) === 32768 && (h += d.node.u), 0 > h) throw new we(28);
      return h;
    }, na(d, h, f) {
      pr(d.node, h + f), d.node.u = Math.max(d.node.u, h + f);
    }, ua(d, h, f, v, b) {
      if ((d.node.mode & 61440) !== 32768) throw new we(43);
      if (d = d.node.j, b & 2 || !d || d.buffer !== L.buffer) {
        b = !0, v = 65536 * Math.ceil(h / 65536);
        var k = dR(65536, v);
        if (k ? (H.fill(0, k, k + v), v = k) : v = 0, !v) throw new we(48);
        d && ((0 < f || f + h < d.length) && (d.subarray ? d = d.subarray(f, f + h) : d = Array.prototype.slice.call(d, f, f + h)), L.set(d, v));
      } else b = !1, v = d.byteOffset;
      return { h: v, ib: b };
    }, wa(d, h, f, v) {
      return pe.l.write(d, h, 0, v, f, !1), 0;
    } } }, fe = (d, h) => {
      var f = 0;
      return d && (f |= 365), h && (f |= 146), f;
    }, Se = null, Ae = {}, Ue = [], et = 1, yt = null, rr = !1, ra = !0, we = class {
      constructor(d) {
        this.name = "ErrnoError", this.G = d;
      }
    }, f0 = {}, lA = class {
      constructor() {
        this.R = {}, this.node = null;
      }
      get flags() {
        return this.R.flags;
      }
      set flags(d) {
        this.R.flags = d;
      }
      get position() {
        return this.R.position;
      }
      set position(d) {
        this.R.position = d;
      }
    }, rq = class {
      constructor(d, h, f, v) {
        d || (d = this), this.parent = d, this.M = d.M, this.fa = null, this.id = et++, this.name = h, this.mode = f, this.i = {}, this.l = {}, this.X = v;
      }
      get read() {
        return (this.mode & 365) === 365;
      }
      set read(d) {
        d ? this.mode |= 365 : this.mode &= -366;
      }
      get write() {
        return (this.mode & 146) === 146;
      }
      set write(d) {
        d ? this.mode |= 146 : this.mode &= -147;
      }
    };
    function Jl(d, h = {}) {
      if (d = So(d), !d) return { path: "", node: null };
      if (h = Object.assign({ ra: !0, ma: 0 }, h), 8 < h.ma) throw new we(32);
      d = d.split("/").filter((Q) => !!Q);
      for (var f = Se, v = "/", b = 0; b < d.length; b++) {
        var k = b === d.length - 1;
        if (k && h.parent) break;
        if (f = lI(f, d[b]), v = Is(v + "/" + d[b]), f.fa && (!k || k && h.ra) && (f = f.fa.root), !k || h.ha) {
          for (k = 0; (f.mode & 61440) === 40960; ) if (f = iq(v), v = So(oA(v), f), f = Jl(v, { ma: h.ma + 1 }).node, 40 < k++) throw new we(32);
        }
      }
      return { path: v, node: f };
    }
    function QT(d) {
      for (var h; ; ) {
        if (d === d.parent) return d = d.M.va, h ? d[d.length - 1] !== "/" ? `${d}/${h}` : d + h : d;
        h = h ? `${d.name}/${h}` : d.name, d = d.parent;
      }
    }
    function FT(d, h) {
      for (var f = 0, v = 0; v < h.length; v++) f = (f << 5) - f + h.charCodeAt(v) | 0;
      return (d + f >>> 0) % yt.length;
    }
    function lI(d, h) {
      var f = (d.mode & 61440) === 16384 ? (f = cI(d, "x")) ? f : d.i.W ? 0 : 2 : 54;
      if (f) throw new we(f);
      for (f = yt[FT(d.id, h)]; f; f = f.Za) {
        var v = f.name;
        if (f.parent.id === d.id && v === h) return f;
      }
      return d.i.W(d, h);
    }
    function TT(d, h, f, v) {
      return d = new rq(d, h, f, v), h = FT(d.parent.id, d.name), d.Za = yt[h], yt[h] = d;
    }
    function RT(d) {
      var h = ["r", "w", "rw"][d & 3];
      return d & 512 && (h += "w"), h;
    }
    function cI(d, h) {
      if (ra) return 0;
      if (!h.includes("r") || d.mode & 292) {
        if (h.includes("w") && !(d.mode & 146) || h.includes("x") && !(d.mode & 73)) return 2;
      } else return 2;
      return 0;
    }
    function DT(d, h) {
      try {
        return lI(d, h), 20;
      } catch {
      }
      return cI(d, "wx");
    }
    function Cs(d) {
      if (d = Ue[d], !d) throw new we(8);
      return d;
    }
    function JT(d, h = -1) {
      if (d = Object.assign(new lA(), d), h == -1) e: {
        for (h = 0; 4096 >= h; h++) if (!Ue[h]) break e;
        throw new we(33);
      }
      return d.O = h, Ue[h] = d;
    }
    function nq(d, h = -1) {
      var f, v;
      return d = JT(d, h), (v = (f = d.l) == null ? void 0 : f.ob) == null || v.call(f, d), d;
    }
    var aq = { open(d) {
      var h, f;
      d.l = Ae[d.node.X].l, (f = (h = d.l).open) == null || f.call(h, d);
    }, S() {
      throw new we(70);
    } };
    function cA(d, h) {
      Ae[d] = { l: h };
    }
    function VT(d, h) {
      var f = h === "/";
      if (f && Se) throw new we(10);
      if (!f && h) {
        var v = Jl(h, { ra: !1 });
        if (h = v.path, v = v.node, v.fa) throw new we(10);
        if ((v.mode & 61440) !== 16384) throw new we(54);
      }
      h = { type: d, rb: {}, va: h, Xa: [] }, d = d.M(h), d.M = h, h.root = d, f ? Se = d : v && (v.fa = h, v.M && v.M.Xa.push(h));
    }
    function dA(d, h, f) {
      var v = Jl(d, { parent: !0 }).node;
      if (d = iI(d), !d || d === "." || d === "..") throw new we(28);
      var b = DT(v, d);
      if (b) throw new we(b);
      if (!v.i.ea) throw new we(63);
      return v.i.ea(v, d, h, f);
    }
    function bs(d) {
      return dA(d, 16895, 0);
    }
    function dI(d, h, f) {
      typeof f > "u" && (f = h, h = 438), dA(d, h | 8192, f);
    }
    function uA(d, h) {
      if (!So(d)) throw new we(44);
      var f = Jl(h, { parent: !0 }).node;
      if (!f) throw new we(44);
      h = iI(h);
      var v = DT(f, h);
      if (v) throw new we(v);
      if (!f.i.ga) throw new we(63);
      f.i.ga(f, h, d);
    }
    function iq(d) {
      if (d = Jl(d).node, !d) throw new we(44);
      if (!d.i.Y) throw new we(28);
      return So(QT(d.parent), d.i.Y(d));
    }
    function uI(d, h) {
      if (d = Jl(d, { ha: !h }).node, !d) throw new we(44);
      if (!d.i.I) throw new we(63);
      return d.i.I(d);
    }
    function MT(d) {
      return uI(d, !0);
    }
    function hI(d, h, f) {
      if (d === "") throw new we(44);
      if (typeof h == "string") {
        var v = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }[h];
        if (typeof v > "u") throw Error(`Unknown file open mode: ${h}`);
        h = v;
      }
      if (f = h & 64 ? (typeof f > "u" ? 438 : f) & 4095 | 32768 : 0, typeof d == "object") var b = d;
      else {
        d = Is(d);
        try {
          b = Jl(d, { ha: !(h & 131072) }).node;
        } catch {
        }
      }
      if (v = !1, h & 64) if (b) {
        if (h & 128) throw new we(20);
      } else b = dA(d, f, 0), v = !0;
      if (!b) throw new we(44);
      if ((b.mode & 61440) === 8192 && (h &= -513), h & 65536 && (b.mode & 61440) !== 16384) throw new we(54);
      if (!v && (f = b ? (b.mode & 61440) === 40960 ? 32 : (b.mode & 61440) === 16384 && (RT(h) !== "r" || h & 512) ? 31 : cI(b, RT(h)) : 44)) throw new we(f);
      if (h & 512 && !v) {
        if (f = b, f = typeof f == "string" ? Jl(f, { ha: !0 }).node : f, !f.i.L) throw new we(63);
        if ((f.mode & 61440) === 16384) throw new we(31);
        if ((f.mode & 61440) !== 32768) throw new we(28);
        if (v = cI(f, "w")) throw new we(v);
        f.i.L(f, { size: 0, timestamp: Date.now() });
      }
      return h &= -131713, b = JT({ node: b, path: QT(b), flags: h, seekable: !0, position: 0, l: b.l, hb: [], error: !1 }), b.l.open && b.l.open(b), !a.logReadFiles || h & 1 || (pI || (pI = {}), d in pI || (pI[d] = 1)), b;
    }
    function GT(d, h, f) {
      if (d.O === null) throw new we(8);
      if (!d.seekable || !d.l.S) throw new we(70);
      if (f != 0 && f != 1 && f != 2) throw new we(28);
      d.position = d.l.S(d, h, f), d.hb = [];
    }
    function m0(d, h, f) {
      d = Is("/dev/" + d);
      var v = fe(!!h, !!f);
      hA || (hA = 64);
      var b = hA++ << 8 | 0;
      cA(b, { open(k) {
        k.seekable = !1;
      }, close() {
        var k;
        (k = f == null ? void 0 : f.buffer) != null && k.length && f(10);
      }, read(k, Q, D, X) {
        for (var j = 0, he = 0; he < X; he++) {
          try {
            var Ye = h();
          } catch {
            throw new we(29);
          }
          if (Ye === void 0 && j === 0) throw new we(6);
          if (Ye == null) break;
          j++, Q[D + he] = Ye;
        }
        return j && (k.node.timestamp = Date.now()), j;
      }, write(k, Q, D, X) {
        for (var j = 0; j < X; j++) try {
          f(Q[D + j]);
        } catch {
          throw new we(29);
        }
        return X && (k.node.timestamp = Date.now()), j;
      } }), dI(d, v, b);
    }
    var hA, Mi = {}, pI;
    function xT(d, h, f) {
      if (h.charAt(0) === "/") return h;
      if (d = d === -100 ? "/" : Cs(d).path, h.length == 0) {
        if (!f) throw new we(44);
        return d;
      }
      return Is(d + "/" + h);
    }
    function gI(d, h, f) {
      d = d(h), z[f >> 2] = d.Ia, z[f + 4 >> 2] = d.mode, K[f + 8 >> 2] = d.$a, z[f + 12 >> 2] = d.uid, z[f + 16 >> 2] = d.Qa, z[f + 20 >> 2] = d.X, Ar = [d.size >>> 0, (Xe = d.size, 1 <= +Math.abs(Xe) ? 0 < Xe ? +Math.floor(Xe / 4294967296) >>> 0 : ~~+Math.ceil((Xe - +(~~Xe >>> 0)) / 4294967296) >>> 0 : 0)], z[f + 24 >> 2] = Ar[0], z[f + 28 >> 2] = Ar[1], z[f + 32 >> 2] = 4096, z[f + 36 >> 2] = d.Fa, h = d.Da.getTime();
      var v = d.Ya.getTime(), b = d.Ha.getTime();
      return Ar = [Math.floor(h / 1e3) >>> 0, (Xe = Math.floor(h / 1e3), 1 <= +Math.abs(Xe) ? 0 < Xe ? +Math.floor(Xe / 4294967296) >>> 0 : ~~+Math.ceil((Xe - +(~~Xe >>> 0)) / 4294967296) >>> 0 : 0)], z[f + 40 >> 2] = Ar[0], z[f + 44 >> 2] = Ar[1], K[f + 48 >> 2] = h % 1e3 * 1e3, Ar = [Math.floor(v / 1e3) >>> 0, (Xe = Math.floor(v / 1e3), 1 <= +Math.abs(Xe) ? 0 < Xe ? +Math.floor(Xe / 4294967296) >>> 0 : ~~+Math.ceil((Xe - +(~~Xe >>> 0)) / 4294967296) >>> 0 : 0)], z[f + 56 >> 2] = Ar[0], z[f + 60 >> 2] = Ar[1], K[f + 64 >> 2] = v % 1e3 * 1e3, Ar = [Math.floor(b / 1e3) >>> 0, (Xe = Math.floor(b / 1e3), 1 <= +Math.abs(Xe) ? 0 < Xe ? +Math.floor(Xe / 4294967296) >>> 0 : ~~+Math.ceil((Xe - +(~~Xe >>> 0)) / 4294967296) >>> 0 : 0)], z[f + 72 >> 2] = Ar[0], z[f + 76 >> 2] = Ar[1], K[f + 80 >> 2] = b % 1e3 * 1e3, Ar = [d.ta >>> 0, (Xe = d.ta, 1 <= +Math.abs(Xe) ? 0 < Xe ? +Math.floor(Xe / 4294967296) >>> 0 : ~~+Math.ceil((Xe - +(~~Xe >>> 0)) / 4294967296) >>> 0 : 0)], z[f + 88 >> 2] = Ar[0], z[f + 92 >> 2] = Ar[1], 0;
    }
    var v0 = void 0, fh = (d, h) => Object.defineProperty(h, "name", { value: d }), pA = [], ys = [], je, oq = (d) => {
      throw new je(d);
    }, na = (d) => {
      if (!d) throw new je("Cannot use deleted val. handle = " + d);
      return ys[d];
    }, Dn = (d) => {
      switch (d) {
        case void 0:
          return 2;
        case null:
          return 4;
        case !0:
          return 6;
        case !1:
          return 8;
        default:
          const h = pA.pop() || ys.length;
          return ys[h] = d, ys[h + 1] = 1, h;
      }
    }, HT = (d) => {
      var h = Error, f = fh(d, function(v) {
        this.name = d, this.message = v, v = Error(v).stack, v !== void 0 && (this.stack = this.toString() + `
` + v.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return f.prototype = Object.create(h.prototype), f.prototype.constructor = f, f.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, f;
    }, LT, YT, an = (d) => {
      for (var h = ""; H[d]; ) h += YT[H[d++]];
      return h;
    }, S0 = [], gA = () => {
      for (; S0.length; ) {
        var d = S0.pop();
        d.g.U = !1, d.delete();
      }
    }, I0, ws = {}, fA = (d, h) => {
      if (h === void 0) throw new je("ptr should not be undefined");
      for (; d.A; ) h = d.Z(h), d = d.A;
      return h;
    }, gd = {}, OT = (d) => {
      d = lR(d);
      var h = an(d);
      return Us(d), h;
    }, fI = (d, h) => {
      var f = gd[d];
      if (f === void 0) throw d = `${h} has unknown type ${OT(d)}`, new je(d);
      return f;
    }, mI = () => {
    }, mA = !1, jT = (d, h, f) => h === f ? d : f.A === void 0 ? null : (d = jT(d, h, f.A), d === null ? null : f.Ja(d)), PT = {}, sq = (d, h) => (h = fA(d, h), ws[h]), C0, vI = (d, h) => {
      if (!h.s || !h.h) throw new C0("makeClassHandle requires ptr and ptrType");
      if (!!h.D != !!h.B) throw new C0("Both smartPtrType and smartPtr must be specified");
      return h.count = { value: 1 }, mh(Object.create(d, { g: { value: h, writable: !0 } }));
    }, mh = (d) => typeof FinalizationRegistry > "u" ? (mh = (h) => h, d) : (mA = new FinalizationRegistry((h) => {
      h = h.g, --h.count.value, h.count.value === 0 && (h.B ? h.D.K(h.B) : h.s.m.K(h.h));
    }), mh = (h) => {
      var f = h.g;
      return f.B && mA.register(h, { g: f }, h), h;
    }, mI = (h) => {
      mA.unregister(h);
    }, mh(d)), SI = {}, vA = (d) => {
      for (; d.length; ) {
        var h = d.pop();
        d.pop()(h);
      }
    };
    function b0(d) {
      return this.fromWireType(K[d >> 2]);
    }
    var vh = {}, II = {}, fd = (d, h, f) => {
      function v(D) {
        if (D = f(D), D.length !== d.length) throw new C0("Mismatched type converter count");
        for (var X = 0; X < d.length; ++X) As(d[X], D[X]);
      }
      d.forEach(function(D) {
        II[D] = h;
      });
      var b = Array(h.length), k = [], Q = 0;
      h.forEach((D, X) => {
        gd.hasOwnProperty(D) ? b[X] = gd[D] : (k.push(D), vh.hasOwnProperty(D) || (vh[D] = []), vh[D].push(() => {
          b[X] = gd[D], ++Q, Q === k.length && v(b);
        }));
      }), k.length === 0 && v(b);
    };
    function lq(d, h, f = {}) {
      var v = h.name;
      if (!d) throw new je(`type "${v}" must have a positive integer typeid pointer`);
      if (gd.hasOwnProperty(d)) {
        if (f.Ra) return;
        throw new je(`Cannot register type '${v}' twice`);
      }
      gd[d] = h, delete II[d], vh.hasOwnProperty(d) && (h = vh[d], delete vh[d], h.forEach((b) => b()));
    }
    function As(d, h, f = {}) {
      return lq(d, h, f);
    }
    var SA = (d) => {
      throw new je(d.g.s.m.name + " instance already deleted");
    };
    function CI() {
    }
    var IA = (d, h, f) => {
      if (d[h].v === void 0) {
        var v = d[h];
        d[h] = function(...b) {
          if (!d[h].v.hasOwnProperty(b.length)) throw new je(`Function '${f}' called with an invalid number of arguments (${b.length}) - expects one of (${d[h].v})!`);
          return d[h].v[b.length].apply(this, b);
        }, d[h].v = [], d[h].v[v.T] = v;
      }
    }, $T = (d, h, f) => {
      if (a.hasOwnProperty(d)) {
        if (f === void 0 || a[d].v !== void 0 && a[d].v[f] !== void 0) throw new je(`Cannot register public name '${d}' twice`);
        if (IA(a, d, d), a.hasOwnProperty(f)) throw new je(`Cannot register multiple overloads of a function with the same number of arguments (${f})!`);
        a[d].v[f] = h;
      } else a[d] = h, f !== void 0 && (a[d].qb = f);
    }, cq = (d) => {
      if (d === void 0) return "_unknown";
      d = d.replace(/[^a-zA-Z0-9_]/g, "$");
      var h = d.charCodeAt(0);
      return 48 <= h && 57 >= h ? `_${d}` : d;
    };
    function dq(d, h, f, v, b, k, Q, D) {
      this.name = d, this.constructor = h, this.P = f, this.K = v, this.A = b, this.La = k, this.Z = Q, this.Ja = D, this.xa = [];
    }
    var CA = (d, h, f) => {
      for (; h !== f; ) {
        if (!h.Z) throw new je(`Expected null or instance of ${f.name}, got an instance of ${h.name}`);
        d = h.Z(d), h = h.A;
      }
      return d;
    };
    function uq(d, h) {
      if (h === null) {
        if (this.ja) throw new je(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!h.g) throw new je(`Cannot pass "${UA(h)}" as a ${this.name}`);
      if (!h.g.h) throw new je(`Cannot pass deleted object as a pointer of type ${this.name}`);
      return CA(h.g.h, h.g.s.m, this.m);
    }
    function hq(d, h) {
      if (h === null) {
        if (this.ja) throw new je(`null is not a valid ${this.name}`);
        if (this.da) {
          var f = this.la();
          return d !== null && d.push(this.K, f), f;
        }
        return 0;
      }
      if (!h || !h.g) throw new je(`Cannot pass "${UA(h)}" as a ${this.name}`);
      if (!h.g.h) throw new je(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (!this.ca && h.g.s.ca) throw new je(`Cannot convert argument of type ${h.g.D ? h.g.D.name : h.g.s.name} to parameter type ${this.name}`);
      if (f = CA(h.g.h, h.g.s.m, this.m), this.da) {
        if (h.g.B === void 0) throw new je("Passing raw pointer to smart pointer is illegal");
        switch (this.gb) {
          case 0:
            if (h.g.D === this) f = h.g.B;
            else throw new je(`Cannot convert argument of type ${h.g.D ? h.g.D.name : h.g.s.name} to parameter type ${this.name}`);
            break;
          case 1:
            f = h.g.B;
            break;
          case 2:
            if (h.g.D === this) f = h.g.B;
            else {
              var v = h.clone();
              f = this.bb(f, Dn(() => v.delete())), d !== null && d.push(this.K, f);
            }
            break;
          default:
            throw new je("Unsupporting sharing policy");
        }
      }
      return f;
    }
    function pq(d, h) {
      if (h === null) {
        if (this.ja) throw new je(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!h.g) throw new je(`Cannot pass "${UA(h)}" as a ${this.name}`);
      if (!h.g.h) throw new je(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (h.g.s.ca) throw new je(`Cannot convert argument of type ${h.g.s.name} to parameter type ${this.name}`);
      return CA(h.g.h, h.g.s.m, this.m);
    }
    function bI(d, h, f, v, b, k, Q, D, X, j, he) {
      this.name = d, this.m = h, this.ja = f, this.ca = v, this.da = b, this.ab = k, this.gb = Q, this.ya = D, this.la = X, this.bb = j, this.K = he, b || h.A !== void 0 ? this.toWireType = hq : (this.toWireType = v ? uq : pq, this.F = null);
    }
    var KT = (d, h, f) => {
      if (!a.hasOwnProperty(d)) throw new C0("Replacing nonexistent public symbol");
      a[d].v !== void 0 && f !== void 0 ? a[d].v[f] = h : (a[d] = h, a[d].T = f);
    }, yI = [], XT, _t = (d) => {
      var h = yI[d];
      return h || (d >= yI.length && (yI.length = d + 1), yI[d] = h = XT.get(d)), h;
    }, gq = (d, h, f = []) => (d.includes("j") ? (d = d.replace(/p/g, "i"), h = (0, a["dynCall_" + d])(h, ...f)) : h = _t(h)(...f), h), fq = (d, h) => (...f) => gq(d, h, f), Gi = (d, h) => {
      d = an(d);
      var f = d.includes("j") ? fq(d, h) : _t(h);
      if (typeof f != "function") throw new je(`unknown function pointer with signature ${d}: ${h}`);
      return f;
    }, zT, wI = (d, h) => {
      function f(k) {
        b[k] || gd[k] || (II[k] ? II[k].forEach(f) : (v.push(k), b[k] = !0));
      }
      var v = [], b = {};
      throw h.forEach(f), new zT(`${d}: ` + v.map(OT).join([", "]));
    };
    function qT(d) {
      for (var h = 1; h < d.length; ++h) if (d[h] !== null && d[h].F === void 0) return !0;
      return !1;
    }
    function eR(d) {
      var h = Function;
      if (!(h instanceof Function)) throw new TypeError(`new_ called with constructor type ${typeof h} which is not a function`);
      var f = fh(h.name || "unknownFunctionName", function() {
      });
      return f.prototype = h.prototype, f = new f(), d = h.apply(f, d), d instanceof Object ? d : f;
    }
    function bA(d, h, f, v, b, k) {
      var Q = h.length;
      if (2 > Q) throw new je("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var D = h[1] !== null && f !== null, X = qT(h);
      for (f = h[0].name !== "void", v = [d, oq, v, b, vA, h[0], h[1]], b = 0; b < Q - 2; ++b) v.push(h[b + 2]);
      if (!X) for (b = D ? 1 : 2; b < h.length; ++b) h[b].F !== null && v.push(h[b].F);
      X = qT(h), b = h.length - 2;
      var j = [], he = ["fn"];
      for (D && he.push("thisWired"), Q = 0; Q < b; ++Q) j.push(`arg${Q}`), he.push(`arg${Q}Wired`);
      j = j.join(","), he = he.join(","), j = `
        return function (${j}) {
        if (arguments.length !== ${b}) {
          throwBindingError('function ' + humanName + ' called with ' + arguments.length + ' arguments, expected ${b}');
        }`, X && (j += `var destructors = [];
`);
      var Ye = X ? "destructors" : "null", Oe = "humanName throwBindingError invoker fn runDestructors retType classParam".split(" ");
      for (D && (j += `var thisWired = classParam['toWireType'](${Ye}, this);
`), Q = 0; Q < b; ++Q) j += `var arg${Q}Wired = argType${Q}['toWireType'](${Ye}, arg${Q});
`, Oe.push(`argType${Q}`);
      if (j += (f || k ? "var rv = " : "") + `invoker(${he});
`, X) j += `runDestructors(destructors);
`;
      else for (Q = D ? 1 : 2; Q < h.length; ++Q) k = Q === 1 ? "thisWired" : "arg" + (Q - 2) + "Wired", h[Q].F !== null && (j += `${k}_dtor(${k});
`, Oe.push(`${k}_dtor`));
      f && (j += `var ret = retType['fromWireType'](rv);
return ret;
`);
      let [ht, Nt] = [Oe, j + `}
`];
      return ht.push(Nt), h = eR(ht)(...v), fh(d, h);
    }
    var yA = (d, h) => {
      for (var f = [], v = 0; v < d; v++) f.push(K[h + 4 * v >> 2]);
      return f;
    }, wA = (d) => {
      d = d.trim();
      const h = d.indexOf("(");
      return h !== -1 ? d.substr(0, h) : d;
    }, AA = (d) => {
      9 < d && --ys[d + 1] === 0 && (ys[d] = void 0, pA.push(d));
    }, mq = { name: "emscripten::val", fromWireType: (d) => {
      var h = na(d);
      return AA(d), h;
    }, toWireType: (d, h) => Dn(h), H: 8, readValueFromPointer: b0, F: null }, UA = (d) => {
      if (d === null) return "null";
      var h = typeof d;
      return h === "object" || h === "array" || h === "function" ? d.toString() : "" + d;
    }, vq = (d, h) => {
      switch (h) {
        case 4:
          return function(f) {
            return this.fromWireType(Fe[f >> 2]);
          };
        case 8:
          return function(f) {
            return this.fromWireType(yr[f >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${h}): ${d}`);
      }
    }, Sq = (d, h, f) => {
      switch (h) {
        case 1:
          return f ? (v) => L[v] : (v) => H[v];
        case 2:
          return f ? (v) => R[v >> 1] : (v) => ge[v >> 1];
        case 4:
          return f ? (v) => z[v >> 2] : (v) => K[v >> 2];
        default:
          throw new TypeError(`invalid integer width (${h}): ${d}`);
      }
    }, tR = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0, Iq = (d, h) => {
      for (var f = d >> 1, v = f + h / 2; !(f >= v) && ge[f]; ) ++f;
      if (f <<= 1, 32 < f - d && tR) return tR.decode(H.subarray(
        d,
        f
      ));
      for (f = "", v = 0; !(v >= h / 2); ++v) {
        var b = R[d + 2 * v >> 1];
        if (b == 0) break;
        f += String.fromCharCode(b);
      }
      return f;
    }, Cq = (d, h, f) => {
      if (f ?? (f = 2147483647), 2 > f) return 0;
      f -= 2;
      var v = h;
      f = f < 2 * d.length ? f / 2 : d.length;
      for (var b = 0; b < f; ++b) R[h >> 1] = d.charCodeAt(b), h += 2;
      return R[h >> 1] = 0, h - v;
    }, bq = (d) => 2 * d.length, yq = (d, h) => {
      for (var f = 0, v = ""; !(f >= h / 4); ) {
        var b = z[d + 4 * f >> 2];
        if (b == 0) break;
        ++f, 65536 <= b ? (b -= 65536, v += String.fromCharCode(55296 | b >> 10, 56320 | b & 1023)) : v += String.fromCharCode(b);
      }
      return v;
    }, wq = (d, h, f) => {
      if (f ?? (f = 2147483647), 4 > f) return 0;
      var v = h;
      f = v + f - 4;
      for (var b = 0; b < d.length; ++b) {
        var k = d.charCodeAt(b);
        if (55296 <= k && 57343 >= k) {
          var Q = d.charCodeAt(++b);
          k = 65536 + ((k & 1023) << 10) | Q & 1023;
        }
        if (z[h >> 2] = k, h += 4, h + 4 > f) break;
      }
      return z[h >> 2] = 0, h - v;
    }, Aq = (d) => {
      for (var h = 0, f = 0; f < d.length; ++f) {
        var v = d.charCodeAt(f);
        55296 <= v && 57343 >= v && ++f, h += 4;
      }
      return h;
    }, rR = (d, h, f) => {
      var v = [];
      return d = d.toWireType(v, f), v.length && (K[h >> 2] = Dn(v)), d;
    }, AI = [], Uq = {}, kA = (d) => {
      var h = Uq[d];
      return h === void 0 ? an(d) : h;
    }, nR = () => typeof globalThis == "object" ? globalThis : Function("return this")(), kq = (d) => {
      var h = AI.length;
      return AI.push(d), h;
    }, _q = (d, h) => {
      for (var f = Array(d), v = 0; v < d; ++v) f[v] = fI(K[h + 4 * v >> 2], "parameter " + v);
      return f;
    }, y0 = {}, _A = (d) => {
      if (!(d instanceof Qa || d == "unwind")) throw d;
    }, NA = 0, UI = (d) => {
      var h;
      throw W = d, Dl || 0 < NA || ((h = a.onExit) == null || h.call(a, d), J = !0), new Qa(d);
    }, aR = (d) => {
      if (!J) try {
        if (d(), !(Dl || 0 < NA)) try {
          W = d = W, UI(d);
        } catch (h) {
          _A(h);
        }
      } catch (h) {
        _A(h);
      }
    }, ZA;
    ZA = () => performance.now();
    var Nq = clearTimeout, Zq = (d, h) => setTimeout(() => {
      aR(d);
    }, h), BA = {}, iR = () => {
      if (!WA) {
        var d = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: g || "./this.program" }, h;
        for (h in BA) BA[h] === void 0 ? delete d[h] : d[h] = BA[h];
        var f = [];
        for (h in d) f.push(`${h}=${d[h]}`);
        WA = f;
      }
      return WA;
    }, WA;
    [44].forEach((d) => {
      f0[d] = new we(d), f0[d].stack = "<generic error, no stack>";
    }), yt = Array(4096), VT(pe, "/"), bs("/tmp"), bs("/home"), bs("/home/web_user"), function() {
      bs("/dev"), cA(259, { read: () => 0, write: (v, b, k, Q) => Q }), dI("/dev/null", 259), $(1280, Qe), $(1536, Ur), dI("/dev/tty", 1280), dI("/dev/tty1", 1536);
      var d = new Uint8Array(1024), h = 0, f = () => (h === 0 && (h = oI(d).byteLength), d[--h]);
      m0("random", f), m0("urandom", f), bs("/dev/shm"), bs("/dev/shm/tmp");
    }(), function() {
      bs("/proc");
      var d = bs("/proc/self");
      bs("/proc/self/fd"), VT({ M() {
        var h = TT(d, "fd", 16895, 73);
        return h.i = { W(f, v) {
          var b = Cs(+v);
          return f = { parent: null, M: { va: "fake" }, i: { Y: () => b.path } }, f.parent = f;
        } }, h;
      } }, "/proc/self/fd");
    }(), je = a.BindingError = class extends Error {
      constructor(d) {
        super(d), this.name = "BindingError";
      }
    }, ys.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), a.count_emval_handles = () => ys.length / 2 - 5 - pA.length, LT = a.PureVirtualError = HT("PureVirtualError");
    for (var oR = Array(256), kI = 0; 256 > kI; ++kI) oR[kI] = String.fromCharCode(kI);
    YT = oR, a.getInheritedInstanceCount = () => Object.keys(ws).length, a.getLiveInheritedInstances = () => {
      var d = [], h;
      for (h in ws) ws.hasOwnProperty(h) && d.push(ws[h]);
      return d;
    }, a.flushPendingDeletes = gA, a.setDelayFunction = (d) => {
      I0 = d, S0.length && I0 && I0(gA);
    }, C0 = a.InternalError = class extends Error {
      constructor(d) {
        super(d), this.name = "InternalError";
      }
    }, Object.assign(CI.prototype, { isAliasOf: function(d) {
      if (!(this instanceof CI && d instanceof CI)) return !1;
      var h = this.g.s.m, f = this.g.h;
      d.g = d.g;
      var v = d.g.s.m;
      for (d = d.g.h; h.A; ) f = h.Z(f), h = h.A;
      for (; v.A; ) d = v.Z(d), v = v.A;
      return h === v && f === d;
    }, clone: function() {
      if (this.g.h || SA(this), this.g.V) return this.g.count.value += 1, this;
      var d = mh, h = Object, f = h.create, v = Object.getPrototypeOf(this), b = this.g;
      return d = d(f.call(h, v, { g: { value: { count: b.count, U: b.U, V: b.V, h: b.h, s: b.s, B: b.B, D: b.D } } })), d.g.count.value += 1, d.g.U = !1, d;
    }, delete() {
      if (this.g.h || SA(this), this.g.U && !this.g.V) throw new je("Object already scheduled for deletion");
      mI(this);
      var d = this.g;
      --d.count.value, d.count.value === 0 && (d.B ? d.D.K(d.B) : d.s.m.K(d.h)), this.g.V || (this.g.B = void 0, this.g.h = void 0);
    }, isDeleted: function() {
      return !this.g.h;
    }, deleteLater: function() {
      if (this.g.h || SA(this), this.g.U && !this.g.V) throw new je("Object already scheduled for deletion");
      return S0.push(this), S0.length === 1 && I0 && I0(gA), this.g.U = !0, this;
    } }), Object.assign(bI.prototype, { Ma(d) {
      return this.ya && (d = this.ya(d)), d;
    }, pa(d) {
      var h;
      (h = this.K) == null || h.call(this, d);
    }, H: 8, readValueFromPointer: b0, fromWireType: function(d) {
      function h() {
        return this.da ? vI(this.m.P, { s: this.ab, h: f, D: this, B: d }) : vI(this.m.P, { s: this, h: d });
      }
      var f = this.Ma(d);
      if (!f) return this.pa(d), null;
      var v = sq(this.m, f);
      if (v !== void 0)
        return v.g.count.value === 0 ? (v.g.h = f, v.g.B = d, v.clone()) : (v = v.clone(), this.pa(d), v);
      if (v = this.m.La(f), v = PT[v], !v) return h.call(this);
      v = this.ca ? v.Ga : v.pointerType;
      var b = jT(f, this.m, v.m);
      return b === null ? h.call(this) : this.da ? vI(v.m.P, { s: v, h: b, D: this, B: d }) : vI(v.m.P, { s: v, h: b });
    } }), zT = a.UnboundTypeError = HT("UnboundTypeError");
    var sR = {
      __cxa_begin_catch: (d) => {
        var h = new pd(d);
        return L[h.h + 12] == 0 && (L[h.h + 12] = 1, uh--), L[h.h + 13] = 0, Ji.push(h), QA(d), gR(d);
      },
      __cxa_current_primary_exception: () => {
        if (!Ji.length) return 0;
        var d = Ji[Ji.length - 1];
        return QA(d.aa), d.aa;
      },
      __cxa_end_catch: () => {
        it(0, 0);
        var d = Ji.pop();
        hR(d.aa), Fa = 0;
      },
      __cxa_find_matching_catch_2: () => hh([]),
      __cxa_find_matching_catch_3: (d) => hh([d]),
      __cxa_find_matching_catch_6: (d, h, f, v) => hh([d, h, f, v]),
      __cxa_rethrow: ph,
      __cxa_rethrow_primary_exception: (d) => {
        d && (d = new pd(d), Ji.push(d), L[d.h + 13] = 1, ph());
      },
      __cxa_throw: (d, h, f) => {
        var v = new pd(d);
        throw K[v.h + 16 >> 2] = 0, K[v.h + 4 >> 2] = h, K[v.h + 8 >> 2] = f, Fa = d, uh++, Fa;
      },
      __cxa_uncaught_exceptions: () => uh,
      __resumeException: (d) => {
        throw Fa || (Fa = d), Fa;
      },
      __syscall_fcntl64: function(d, h, f) {
        v0 = f;
        try {
          var v = Cs(d);
          switch (h) {
            case 0:
              var b = ii();
              if (0 > b) break;
              for (; Ue[b]; ) b++;
              return nq(v, b).O;
            case 1:
            case 2:
              return 0;
            case 3:
              return v.flags;
            case 4:
              return b = ii(), v.flags |= b, 0;
            case 12:
              return b = ii(), R[b + 0 >> 1] = 2, 0;
            case 13:
            case 14:
              return 0;
          }
          return -28;
        } catch (k) {
          if (typeof Mi > "u" || k.name !== "ErrnoError") throw k;
          return -k.G;
        }
      },
      __syscall_fstat64: function(d, h) {
        try {
          var f = Cs(d);
          return gI(uI, f.path, h);
        } catch (v) {
          if (typeof Mi > "u" || v.name !== "ErrnoError") throw v;
          return -v.G;
        }
      },
      __syscall_ioctl: function(d, h, f) {
        v0 = f;
        try {
          var v = Cs(d);
          switch (h) {
            case 21509:
              return v.o ? 0 : -59;
            case 21505:
              if (!v.o) return -59;
              if (v.o.N.Ta) {
                d = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                var b = ii();
                z[b >> 2] = 25856, z[b + 4 >> 2] = 5, z[b + 8 >> 2] = 191, z[b + 12 >> 2] = 35387;
                for (var k = 0; 32 > k; k++) L[b + k + 17] = d[k] || 0;
              }
              return 0;
            case 21510:
            case 21511:
            case 21512:
              return v.o ? 0 : -59;
            case 21506:
            case 21507:
            case 21508:
              if (!v.o) return -59;
              if (v.o.N.Ua) for (b = ii(), d = [], k = 0; 32 > k; k++) d.push(L[b + k + 17]);
              return 0;
            case 21519:
              return v.o ? (b = ii(), z[b >> 2] = 0) : -59;
            case 21520:
              return v.o ? -28 : -59;
            case 21531:
              if (b = ii(), !v.l.Sa) throw new we(59);
              return v.l.Sa(v, h, b);
            case 21523:
              return v.o ? (v.o.N.Va && (k = [24, 80], b = ii(), R[b >> 1] = k[0], R[b + 2 >> 1] = k[1]), 0) : -59;
            case 21524:
              return v.o ? 0 : -59;
            case 21515:
              return v.o ? 0 : -59;
            default:
              return -28;
          }
        } catch (Q) {
          if (typeof Mi > "u" || Q.name !== "ErrnoError") throw Q;
          return -Q.G;
        }
      },
      __syscall_lstat64: function(d, h) {
        try {
          return d = d ? Vi(H, d) : "", gI(MT, d, h);
        } catch (f) {
          if (typeof Mi > "u" || f.name !== "ErrnoError") throw f;
          return -f.G;
        }
      },
      __syscall_newfstatat: function(d, h, f, v) {
        try {
          h = h ? Vi(H, h) : "";
          var b = v & 256;
          return h = xT(d, h, v & 4096), gI(b ? MT : uI, h, f);
        } catch (k) {
          if (typeof Mi > "u" || k.name !== "ErrnoError") throw k;
          return -k.G;
        }
      },
      __syscall_openat: function(d, h, f, v) {
        v0 = v;
        try {
          h = h ? Vi(H, h) : "", h = xT(d, h);
          var b = v ? ii() : 0;
          return hI(h, f, b).O;
        } catch (k) {
          if (typeof Mi > "u" || k.name !== "ErrnoError") throw k;
          return -k.G;
        }
      },
      __syscall_stat64: function(d, h) {
        try {
          return d = d ? Vi(H, d) : "", gI(uI, d, h);
        } catch (f) {
          if (typeof Mi > "u" || f.name !== "ErrnoError") throw f;
          return -f.G;
        }
      },
      _abort_js: () => {
        wr("");
      },
      _embind_create_inheriting_constructor: (d, h, f) => {
        d = an(d), h = fI(h, "wrapper"), f = na(f);
        var v = h.m, b = v.P, k = v.A.P, Q = v.A.constructor;
        return d = fh(d, function(...D) {
          v.A.xa.forEach((function(X) {
            if (this[X] === k[X]) throw new LT(`Pure virtual function ${X} must be implemented in JavaScript`);
          }).bind(this)), Object.defineProperty(this, "__parent", { value: b }), this.__construct(...D);
        }), b.__construct = function(...D) {
          if (this === b) throw new je("Pass correct 'this' to __construct");
          D = Q.implement(this, ...D), mI(D);
          var X = D.g;
          if (D.notifyOnDestruction(), X.V = !0, Object.defineProperties(this, { g: { value: X } }), mh(this), D = X.h, D = fA(v, D), ws.hasOwnProperty(D)) throw new je(`Tried to register registered instance: ${D}`);
          ws[D] = this;
        }, b.__destruct = function() {
          if (this === b) throw new je("Pass correct 'this' to __destruct");
          mI(this);
          var D = this.g.h;
          if (D = fA(v, D), ws.hasOwnProperty(D)) delete ws[D];
          else throw new je(`Tried to unregister unregistered instance: ${D}`);
        }, d.prototype = Object.create(b), Object.assign(d.prototype, f), Dn(d);
      },
      _embind_finalize_value_object: (d) => {
        var h = SI[d];
        delete SI[d];
        var f = h.la, v = h.K, b = h.qa, k = b.map((Q) => Q.Pa).concat(b.map((Q) => Q.eb));
        fd([d], k, (Q) => {
          var D = {};
          return b.forEach((X, j) => {
            var he = Q[j], Ye = X.Na, Oe = X.Oa, ht = Q[j + b.length], Nt = X.cb, kr = X.fb;
            D[X.Ka] = { read: (_r) => he.fromWireType(Ye(Oe, _r)), write: (_r, oi) => {
              var on = [];
              Nt(kr, _r, ht.toWireType(on, oi)), vA(on);
            } };
          }), [{ name: h.name, fromWireType: (X) => {
            var j = {}, he;
            for (he in D) j[he] = D[he].read(X);
            return v(X), j;
          }, toWireType: (X, j) => {
            for (var he in D) if (!(he in j)) throw new TypeError(`Missing field: "${he}"`);
            var Ye = f();
            for (he in D) D[he].write(Ye, j[he]);
            return X !== null && X.push(v, Ye), Ye;
          }, H: 8, readValueFromPointer: b0, F: v }];
        });
      },
      _embind_register_bigint: () => {
      },
      _embind_register_bool: (d, h, f, v) => {
        h = an(h), As(d, {
          name: h,
          fromWireType: function(b) {
            return !!b;
          },
          toWireType: function(b, k) {
            return k ? f : v;
          },
          H: 8,
          readValueFromPointer: function(b) {
            return this.fromWireType(H[b]);
          },
          F: null
        });
      },
      _embind_register_class: (d, h, f, v, b, k, Q, D, X, j, he, Ye, Oe) => {
        he = an(he), k = Gi(b, k), D && (D = Gi(Q, D)), j && (j = Gi(X, j)), Oe = Gi(Ye, Oe);
        var ht = cq(he);
        $T(ht, function() {
          wI(`Cannot construct ${he} due to unbound types`, [v]);
        }), fd([d, h, f], v ? [v] : [], (Nt) => {
          if (Nt = Nt[0], v)
            var kr = Nt.m, _r = kr.P;
          else _r = CI.prototype;
          Nt = fh(he, function(...FA) {
            if (Object.getPrototypeOf(this) !== oi) throw new je("Use 'new' to construct " + he);
            if (on.R === void 0) throw new je(he + " has no accessible constructor");
            var wR = on.R[FA.length];
            if (wR === void 0) throw new je(`Tried to invoke ctor of ${he} with invalid number of parameters (${FA.length}) - expected (${Object.keys(on.R).toString()}) parameters instead!`);
            return wR.apply(this, FA);
          });
          var oi = Object.create(_r, { constructor: { value: Nt } });
          Nt.prototype = oi;
          var on = new dq(he, Nt, oi, Oe, kr, k, D, j);
          if (on.A) {
            var A0;
            (A0 = on.A).$ ?? (A0.$ = []), on.A.$.push(on);
          }
          return kr = new bI(he, on, !0, !1, !1), A0 = new bI(he + "*", on, !1, !1, !1), _r = new bI(he + " const*", on, !1, !0, !1), PT[d] = { pointerType: A0, Ga: _r }, KT(ht, Nt), [kr, A0, _r];
        });
      },
      _embind_register_class_class_function: (d, h, f, v, b, k, Q, D) => {
        var X = yA(f, v);
        h = an(h), h = wA(h), k = Gi(b, k), fd([], [d], (j) => {
          function he() {
            wI(`Cannot call ${Ye} due to unbound types`, X);
          }
          j = j[0];
          var Ye = `${j.name}.${h}`;
          h.startsWith("@@") && (h = Symbol[h.substring(2)]);
          var Oe = j.m.constructor;
          return Oe[h] === void 0 ? (he.T = f - 1, Oe[h] = he) : (IA(Oe, h, Ye), Oe[h].v[f - 1] = he), fd([], X, (ht) => {
            if (ht = bA(Ye, [ht[0], null].concat(ht.slice(1)), null, k, Q, D), Oe[h].v === void 0 ? (ht.T = f - 1, Oe[h] = ht) : Oe[h].v[f - 1] = ht, j.m.$) for (const Nt of j.m.$) Nt.constructor.hasOwnProperty(h) || (Nt.constructor[h] = ht);
            return [];
          }), [];
        });
      },
      _embind_register_class_function: (d, h, f, v, b, k, Q, D, X) => {
        var j = yA(f, v);
        h = an(h), h = wA(h), k = Gi(b, k), fd([], [d], (he) => {
          function Ye() {
            wI(
              `Cannot call ${Oe} due to unbound types`,
              j
            );
          }
          he = he[0];
          var Oe = `${he.name}.${h}`;
          h.startsWith("@@") && (h = Symbol[h.substring(2)]), D && he.m.xa.push(h);
          var ht = he.m.P, Nt = ht[h];
          return Nt === void 0 || Nt.v === void 0 && Nt.className !== he.name && Nt.T === f - 2 ? (Ye.T = f - 2, Ye.className = he.name, ht[h] = Ye) : (IA(ht, h, Oe), ht[h].v[f - 2] = Ye), fd([], j, (kr) => (kr = bA(Oe, kr, he, k, Q, X), ht[h].v === void 0 ? (kr.T = f - 2, ht[h] = kr) : ht[h].v[f - 2] = kr, [])), [];
        });
      },
      _embind_register_emval: (d) => As(d, mq),
      _embind_register_float: (d, h, f) => {
        h = an(h), As(d, { name: h, fromWireType: (v) => v, toWireType: (v, b) => b, H: 8, readValueFromPointer: vq(h, f), F: null });
      },
      _embind_register_function: (d, h, f, v, b, k, Q) => {
        var D = yA(h, f);
        d = an(d), d = wA(d), b = Gi(v, b), $T(d, function() {
          wI(`Cannot call ${d} due to unbound types`, D);
        }, h - 1), fd([], D, (X) => (KT(d, bA(d, [X[0], null].concat(X.slice(1)), null, b, k, Q), h - 1), []));
      },
      _embind_register_integer: (d, h, f, v, b) => {
        if (h = an(h), b === -1 && (b = 4294967295), b = (D) => D, v === 0) {
          var k = 32 - 8 * f;
          b = (D) => D << k >>> k;
        }
        var Q = h.includes("unsigned") ? function(D, X) {
          return X >>> 0;
        } : function(D, X) {
          return X;
        };
        As(d, { name: h, fromWireType: b, toWireType: Q, H: 8, readValueFromPointer: Sq(h, f, v !== 0), F: null });
      },
      _embind_register_memory_view: (d, h, f) => {
        function v(k) {
          return new b(L.buffer, K[k + 4 >> 2], K[k >> 2]);
        }
        var b = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][h];
        f = an(f), As(d, { name: f, fromWireType: v, H: 8, readValueFromPointer: v }, { Ra: !0 });
      },
      _embind_register_std_string: (d, h) => {
        h = an(h);
        var f = h === "std::string";
        As(d, { name: h, fromWireType: function(v) {
          var b = K[v >> 2], k = v + 4;
          if (f) for (var Q = k, D = 0; D <= b; ++D) {
            var X = k + D;
            if (D == b || H[X] == 0) {
              if (Q = Q ? Vi(H, Q, X - Q) : "", j === void 0) var j = Q;
              else j += "\0", j += Q;
              Q = X + 1;
            }
          }
          else {
            for (j = Array(b), D = 0; D < b; ++D) j[D] = String.fromCharCode(H[k + D]);
            j = j.join("");
          }
          return Us(v), j;
        }, toWireType: function(v, b) {
          b instanceof ArrayBuffer && (b = new Uint8Array(b));
          var k = typeof b == "string";
          if (!(k || b instanceof Uint8Array || b instanceof Uint8ClampedArray || b instanceof Int8Array)) throw new je("Cannot pass non-string to std::string");
          var Q = f && k ? gh(b) : b.length, D = EA(4 + Q + 1), X = D + 4;
          if (K[D >> 2] = Q, f && k) F(b, H, X, Q + 1);
          else if (k) for (k = 0; k < Q; ++k) {
            var j = b.charCodeAt(k);
            if (255 < j) throw Us(X), new je("String has UTF-16 code units that do not fit in 8 bits");
            H[X + k] = j;
          }
          else for (k = 0; k < Q; ++k) H[X + k] = b[k];
          return v !== null && v.push(Us, D), D;
        }, H: 8, readValueFromPointer: b0, F(v) {
          Us(v);
        } });
      },
      _embind_register_std_wstring: (d, h, f) => {
        if (f = an(f), h === 2)
          var v = Iq, b = Cq, k = bq, Q = (D) => ge[D >> 1];
        else h === 4 && (v = yq, b = wq, k = Aq, Q = (D) => K[D >> 2]);
        As(d, { name: f, fromWireType: (D) => {
          for (var X = K[D >> 2], j, he = D + 4, Ye = 0; Ye <= X; ++Ye) {
            var Oe = D + 4 + Ye * h;
            (Ye == X || Q(Oe) == 0) && (he = v(he, Oe - he), j === void 0 ? j = he : (j += "\0", j += he), he = Oe + h);
          }
          return Us(D), j;
        }, toWireType: (D, X) => {
          if (typeof X != "string") throw new je(`Cannot pass non-string to C++ string type ${f}`);
          var j = k(X), he = EA(4 + j + h);
          return K[he >> 2] = j / h, b(X, he + 4, j + h), D !== null && D.push(Us, he), he;
        }, H: 8, readValueFromPointer: b0, F(D) {
          Us(D);
        } });
      },
      _embind_register_value_object: (d, h, f, v, b, k) => {
        SI[d] = { name: an(h), la: Gi(f, v), K: Gi(b, k), qa: [] };
      },
      _embind_register_value_object_field: (d, h, f, v, b, k, Q, D, X, j) => {
        SI[d].qa.push({ Ka: an(h), Pa: f, Na: Gi(v, b), Oa: k, eb: Q, cb: Gi(D, X), fb: j });
      },
      _embind_register_void: (d, h) => {
        h = an(h), As(
          d,
          { Wa: !0, name: h, H: 0, fromWireType: () => {
          }, toWireType: () => {
          } }
        );
      },
      _emscripten_get_now_is_monotonic: () => 1,
      _emscripten_memcpy_js: (d, h, f) => H.copyWithin(d, h, h + f),
      _emscripten_runtime_keepalive_clear: () => {
        Dl = !1, NA = 0;
      },
      _emscripten_throw_longjmp: () => {
        throw 1 / 0;
      },
      _emval_as: (d, h, f) => (d = na(d), h = fI(h, "emval::as"), rR(h, f, d)),
      _emval_call: (d, h, f, v) => (d = AI[d], h = na(h), d(null, h, f, v)),
      _emval_call_method: (d, h, f, v, b) => (d = AI[d], h = na(h), f = kA(f), d(h, h[f], v, b)),
      _emval_coro_make_promise: (d, h) => Dn(new Promise((f, v) => {
        K[d >> 2] = Dn(f), K[h >> 2] = Dn(() => {
          try {
            ph();
          } catch (b) {
            v(b);
          }
        });
      })),
      _emval_decref: AA,
      _emval_get_global: (d) => d === 0 ? Dn(nR()) : (d = kA(d), Dn(nR()[d])),
      _emval_get_method_caller: (d, h, f) => {
        h = _q(d, h);
        var v = h.shift();
        d--;
        var b = `return function (obj, func, destructorsRef, args) {
`, k = 0, Q = [];
        f === 0 && Q.push("obj");
        for (var D = ["retType"], X = [v], j = 0; j < d; ++j) Q.push("arg" + j), D.push("argType" + j), X.push(h[j]), b += `  var arg${j} = argType${j}.readValueFromPointer(args${k ? "+" + k : ""});
`, k += h[j].H;
        return b += `  var rv = ${f === 1 ? "new func" : "func.call"}(${Q.join(", ")});
`, v.Wa || (D.push("emval_returnValue"), X.push(rR), b += `  return emval_returnValue(retType, destructorsRef, rv);
`), D.push(b + `};
`), d = eR(D)(...X), f = `methodCaller<(${h.map((he) => he.name).join(", ")}) => ${v.name}>`, kq(fh(f, d));
      },
      _emval_get_property: (d, h) => (d = na(d), h = na(h), Dn(d[h])),
      _emval_incref: (d) => {
        9 < d && (ys[d + 1] += 1);
      },
      _emval_is_string: (d) => (d = na(d), typeof d == "string"),
      _emval_iter_begin: (d) => (d = na(d), Dn(d[Symbol.iterator]())),
      _emval_iter_next: (d) => (d = na(d), d = d.next(), d.done ? 0 : Dn(d.value)),
      _emval_new_cstring: (d) => Dn(kA(d)),
      _emval_new_object: () => Dn({}),
      _emval_run_destructors: (d) => {
        var h = na(d);
        vA(h), AA(d);
      },
      _emval_set_property: (d, h, f) => {
        d = na(d), h = na(h), f = na(f), d[h] = f;
      },
      _emval_take_value: (d, h) => (d = fI(d, "_emval_take_value"), d = d.readValueFromPointer(h), Dn(d)),
      _setitimer_js: (d, h) => {
        if (y0[d] && (clearTimeout(y0[d].id), delete y0[d]), !h) return 0;
        var f = setTimeout(() => {
          delete y0[d], aR(() => uR(d, ZA()));
        }, h);
        return y0[d] = { id: f, sb: h }, 0;
      },
      _tzset_js: (d, h, f, v) => {
        var b = (/* @__PURE__ */ new Date()).getFullYear(), k = new Date(b, 0, 1).getTimezoneOffset();
        b = new Date(b, 6, 1).getTimezoneOffset(), K[d >> 2] = 60 * Math.max(k, b), z[h >> 2] = +(k != b), h = (Q) => {
          var D = Math.abs(Q);
          return `UTC${0 <= Q ? "-" : "+"}${String(Math.floor(D / 60)).padStart(2, "0")}${String(D % 60).padStart(2, "0")}`;
        }, d = h(k), h = h(b), b < k ? (F(d, H, f, 17), F(h, H, v, 17)) : (F(d, H, v, 17), F(h, H, f, 17));
      },
      emscripten_clear_timeout: Nq,
      emscripten_date_now: () => Date.now(),
      emscripten_get_heap_max: () => 2147483648,
      emscripten_get_now: ZA,
      emscripten_resize_heap: (d) => {
        var h = H.length;
        if (d >>>= 0, 2147483648 < d) return !1;
        for (var f = 1; 4 >= f; f *= 2) {
          e: {
            var v = (Math.min(2147483648, 65536 * Math.ceil(Math.max(d, h + 4194304 / f) / 65536)) - B.buffer.byteLength + 65535) / 65536;
            try {
              B.grow(v), hr();
              var b = 1;
              break e;
            } catch {
            }
            b = void 0;
          }
          if (b) return !0;
        }
        return !1;
      },
      emscripten_set_timeout: (d, h, f) => Zq(() => _t(d)(f), h),
      environ_get: (d, h) => {
        var f = 0;
        return iR().forEach((v, b) => {
          var k = h + f;
          for (b = K[d + 4 * b >> 2] = k, k = 0; k < v.length; ++k) L[b++] = v.charCodeAt(k);
          L[b] = 0, f += v.length + 1;
        }), 0;
      },
      environ_sizes_get: (d, h) => {
        var f = iR();
        K[d >> 2] = f.length;
        var v = 0;
        return f.forEach((b) => v += b.length + 1), K[h >> 2] = v, 0;
      },
      exit: (d) => {
        W = d, UI(d);
      },
      fd_close: function(d) {
        try {
          var h = Cs(d);
          if (h.O === null) throw new we(8);
          h.ia && (h.ia = null);
          try {
            h.l.close && h.l.close(h);
          } catch (f) {
            throw f;
          } finally {
            Ue[h.O] = null;
          }
          return h.O = null, 0;
        } catch (f) {
          if (typeof Mi > "u" || f.name !== "ErrnoError") throw f;
          return f.G;
        }
      },
      fd_read: function(d, h, f, v) {
        try {
          e: {
            var b = Cs(d);
            d = h;
            for (var k, Q = h = 0; Q < f; Q++) {
              var D = K[d >> 2], X = K[d + 4 >> 2];
              d += 8;
              var j = b, he = k, Ye = L;
              if (0 > X || 0 > he) throw new we(28);
              if (j.O === null) throw new we(8);
              if ((j.flags & 2097155) === 1) throw new we(8);
              if ((j.node.mode & 61440) === 16384) throw new we(31);
              if (!j.l.read) throw new we(28);
              var Oe = typeof he < "u";
              if (!Oe) he = j.position;
              else if (!j.seekable) throw new we(70);
              var ht = j.l.read(j, Ye, D, X, he);
              Oe || (j.position += ht);
              var Nt = ht;
              if (0 > Nt) {
                var kr = -1;
                break e;
              }
              if (h += Nt, Nt < X) break;
              typeof k < "u" && (k += Nt);
            }
            kr = h;
          }
          return K[v >> 2] = kr, 0;
        } catch (_r) {
          if (typeof Mi > "u" || _r.name !== "ErrnoError") throw _r;
          return _r.G;
        }
      },
      fd_seek: function(d, h, f, v, b) {
        h = f + 2097152 >>> 0 < 4194305 - !!h ? (h >>> 0) + 4294967296 * f : NaN;
        try {
          if (isNaN(h)) return 61;
          var k = Cs(d);
          return GT(k, h, v), Ar = [k.position >>> 0, (Xe = k.position, 1 <= +Math.abs(Xe) ? 0 < Xe ? +Math.floor(Xe / 4294967296) >>> 0 : ~~+Math.ceil((Xe - +(~~Xe >>> 0)) / 4294967296) >>> 0 : 0)], z[b >> 2] = Ar[0], z[b + 4 >> 2] = Ar[1], k.ia && h === 0 && v === 0 && (k.ia = null), 0;
        } catch (Q) {
          if (typeof Mi > "u" || Q.name !== "ErrnoError") throw Q;
          return Q.G;
        }
      },
      fd_write: function(d, h, f, v) {
        try {
          e: {
            var b = Cs(d);
            d = h;
            for (var k, Q = h = 0; Q < f; Q++) {
              var D = K[d >> 2], X = K[d + 4 >> 2];
              d += 8;
              var j = b, he = D, Ye = X, Oe = k, ht = L;
              if (0 > Ye || 0 > Oe) throw new we(28);
              if (j.O === null) throw new we(8);
              if (!(j.flags & 2097155)) throw new we(8);
              if ((j.node.mode & 61440) === 16384) throw new we(31);
              if (!j.l.write) throw new we(28);
              j.seekable && j.flags & 1024 && GT(j, 0, 2);
              var Nt = typeof Oe < "u";
              if (!Nt) Oe = j.position;
              else if (!j.seekable) throw new we(70);
              var kr = j.l.write(j, ht, he, Ye, Oe, void 0);
              Nt || (j.position += kr);
              var _r = kr;
              if (0 > _r) {
                var oi = -1;
                break e;
              }
              if (h += _r, _r < X) break;
              typeof k < "u" && (k += _r);
            }
            oi = h;
          }
          return K[v >> 2] = oi, 0;
        } catch (on) {
          if (typeof Mi > "u" || on.name !== "ErrnoError") throw on;
          return on.G;
        }
      },
      invoke_diiii: Mq,
      invoke_diiiii: Gq,
      invoke_fi: Yq,
      invoke_ii: Wq,
      invoke_iid: Hq,
      invoke_iidi: Pq,
      invoke_iif: xq,
      invoke_iii: Eq,
      invoke_iiii: Bq,
      invoke_iiiii: jq,
      invoke_iiiiid: Kq,
      invoke_iiiiii: $q,
      invoke_iiiiiii: Dq,
      invoke_iiiiiiii: Xq,
      invoke_iiiiiiiiiiii: qq,
      invoke_iiiiij: oee,
      invoke_iij: see,
      invoke_j: iee,
      invoke_jii: lee,
      invoke_v: Qq,
      invoke_vi: Jq,
      invoke_vidii: Lq,
      invoke_vii: Rq,
      invoke_viid: ree,
      invoke_viif: tee,
      invoke_viifi: Oq,
      invoke_viii: Fq,
      invoke_viiii: Tq,
      invoke_viiiiiii: zq,
      invoke_viiiiiiiiii: Vq,
      invoke_viiiiiiiiiiiiiii: eee,
      invoke_vij: aee,
      invoke_viji: nee,
      llvm_eh_typeid_for: (d) => d,
      proc_exit: UI
    }, Pe = function() {
      var d;
      function h(v) {
        var b;
        return Pe = v.exports, B = Pe.memory, hr(), XT = Pe.__indirect_function_table, Rn.unshift(Pe.__wasm_call_ctors), ta--, (b = a.monitorRunDependencies) == null || b.call(a, ta), ta == 0 && Rr && (v = Rr, Rr = null, v()), Pe;
      }
      var f = { env: sR, wasi_snapshot_preview1: sR };
      if (ta++, (d = a.monitorRunDependencies) == null || d.call(a, ta), a.instantiateWasm) try {
        return a.instantiateWasm(f, h);
      } catch (v) {
        A(`Module.instantiateWasm callback failed with error: ${v}`), o(v);
      }
      return fr || (fr = ye("dac_simd.wasm") ? "dac_simd.wasm" : a.locateFile ? a.locateFile("dac_simd.wasm", p) : p + "dac_simd.wasm"), iA(f, function(v) {
        h(v.instance);
      }).catch(o), {};
    }(), lR = (d) => (lR = Pe.__getTypeName)(d);
    a._new_memory = (d) => (a._new_memory = Pe.new_memory)(d), a._free_memory = (d) => (a._free_memory = Pe.free_memory)(d), a._get_return_n_packets = (d) => (a._get_return_n_packets = Pe.get_return_n_packets)(d), a._get_return_packet_len = (d, h) => (a._get_return_packet_len = Pe.get_return_packet_len)(d, h), a._get_return_packet = (d, h) => (a._get_return_packet = Pe.get_return_packet)(d, h), a._clear_return_packets = () => (a._clear_return_packets = Pe.clear_return_packets)(), a._process_event_data = (d, h, f, v) => (a._process_event_data = Pe.process_event_data)(d, h, f, v);
    var cR = a._main = (d, h) => (cR = a._main = Pe.main)(d, h), EA = (d) => (EA = Pe.malloc)(d), Us = (d) => (Us = Pe.free)(d), dR = (d, h) => (dR = Pe.emscripten_builtin_memalign)(d, h), uR = (d, h) => (uR = Pe._emscripten_timeout)(d, h), it = (d, h) => (it = Pe.setThrew)(d, h), w0 = (d) => (w0 = Pe._emscripten_tempret_set)(d), dt = (d) => (dt = Pe._emscripten_stack_restore)(d), ut = () => (ut = Pe.emscripten_stack_get_current)(), hR = (d) => (hR = Pe.__cxa_decrement_exception_refcount)(d), QA = (d) => (QA = Pe.__cxa_increment_exception_refcount)(d), pR = (d, h, f) => (pR = Pe.__cxa_can_catch)(d, h, f), gR = (d) => (gR = Pe.__cxa_get_exception_ptr)(d), fR = a.dynCall_viji = (d, h, f, v, b) => (fR = a.dynCall_viji = Pe.dynCall_viji)(d, h, f, v, b);
    a.dynCall_ji = (d, h) => (a.dynCall_ji = Pe.dynCall_ji)(d, h);
    var mR = a.dynCall_j = (d) => (mR = a.dynCall_j = Pe.dynCall_j)(d), vR = a.dynCall_vij = (d, h, f, v) => (vR = a.dynCall_vij = Pe.dynCall_vij)(d, h, f, v), SR = a.dynCall_iiiiij = (d, h, f, v, b, k, Q) => (SR = a.dynCall_iiiiij = Pe.dynCall_iiiiij)(d, h, f, v, b, k, Q), IR = a.dynCall_jii = (d, h, f) => (IR = a.dynCall_jii = Pe.dynCall_jii)(d, h, f);
    a.dynCall_jiji = (d, h, f, v, b) => (a.dynCall_jiji = Pe.dynCall_jiji)(d, h, f, v, b);
    var CR = a.dynCall_iij = (d, h, f, v) => (CR = a.dynCall_iij = Pe.dynCall_iij)(d, h, f, v);
    a.dynCall_iiiijj = (d, h, f, v, b, k, Q, D) => (a.dynCall_iiiijj = Pe.dynCall_iiiijj)(d, h, f, v, b, k, Q, D), a.dynCall_viijj = (d, h, f, v, b, k, Q) => (a.dynCall_viijj = Pe.dynCall_viijj)(d, h, f, v, b, k, Q), a.dynCall_viiijjjj = (d, h, f, v, b, k, Q, D, X, j, he, Ye) => (a.dynCall_viiijjjj = Pe.dynCall_viiijjjj)(d, h, f, v, b, k, Q, D, X, j, he, Ye), a.dynCall_viijii = (d, h, f, v, b, k, Q) => (a.dynCall_viijii = Pe.dynCall_viijii)(d, h, f, v, b, k, Q), a.dynCall_iiiiijj = (d, h, f, v, b, k, Q, D, X) => (a.dynCall_iiiiijj = Pe.dynCall_iiiiijj)(d, h, f, v, b, k, Q, D, X), a.dynCall_iiiiiijj = (d, h, f, v, b, k, Q, D, X, j) => (a.dynCall_iiiiiijj = Pe.dynCall_iiiiiijj)(d, h, f, v, b, k, Q, D, X, j);
    function Bq(d, h, f, v) {
      var b = ut();
      try {
        return _t(d)(h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function Wq(d, h) {
      var f = ut();
      try {
        return _t(d)(h);
      } catch (v) {
        if (dt(f), v !== v + 0) throw v;
        it(1, 0);
      }
    }
    function Eq(d, h, f) {
      var v = ut();
      try {
        return _t(d)(h, f);
      } catch (b) {
        if (dt(v), b !== b + 0) throw b;
        it(1, 0);
      }
    }
    function Qq(d) {
      var h = ut();
      try {
        _t(d)();
      } catch (f) {
        if (dt(h), f !== f + 0) throw f;
        it(1, 0);
      }
    }
    function Fq(d, h, f, v) {
      var b = ut();
      try {
        _t(d)(h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function Tq(d, h, f, v, b) {
      var k = ut();
      try {
        _t(d)(h, f, v, b);
      } catch (Q) {
        if (dt(k), Q !== Q + 0) throw Q;
        it(1, 0);
      }
    }
    function Rq(d, h, f) {
      var v = ut();
      try {
        _t(d)(h, f);
      } catch (b) {
        if (dt(v), b !== b + 0) throw b;
        it(1, 0);
      }
    }
    function Dq(d, h, f, v, b, k, Q) {
      var D = ut();
      try {
        return _t(d)(h, f, v, b, k, Q);
      } catch (X) {
        if (dt(D), X !== X + 0) throw X;
        it(1, 0);
      }
    }
    function Jq(d, h) {
      var f = ut();
      try {
        _t(d)(h);
      } catch (v) {
        if (dt(f), v !== v + 0) throw v;
        it(1, 0);
      }
    }
    function Vq(d, h, f, v, b, k, Q, D, X, j, he) {
      var Ye = ut();
      try {
        _t(d)(h, f, v, b, k, Q, D, X, j, he);
      } catch (Oe) {
        if (dt(Ye), Oe !== Oe + 0) throw Oe;
        it(1, 0);
      }
    }
    function Mq(d, h, f, v, b) {
      var k = ut();
      try {
        return _t(d)(h, f, v, b);
      } catch (Q) {
        if (dt(k), Q !== Q + 0) throw Q;
        it(1, 0);
      }
    }
    function Gq(d, h, f, v, b, k) {
      var Q = ut();
      try {
        return _t(d)(h, f, v, b, k);
      } catch (D) {
        if (dt(Q), D !== D + 0) throw D;
        it(1, 0);
      }
    }
    function xq(d, h, f) {
      var v = ut();
      try {
        return _t(d)(h, f);
      } catch (b) {
        if (dt(v), b !== b + 0) throw b;
        it(1, 0);
      }
    }
    function Hq(d, h, f) {
      var v = ut();
      try {
        return _t(d)(h, f);
      } catch (b) {
        if (dt(v), b !== b + 0) throw b;
        it(1, 0);
      }
    }
    function Lq(d, h, f, v, b) {
      var k = ut();
      try {
        _t(d)(h, f, v, b);
      } catch (Q) {
        if (dt(k), Q !== Q + 0) throw Q;
        it(1, 0);
      }
    }
    function Yq(d, h) {
      var f = ut();
      try {
        return _t(d)(h);
      } catch (v) {
        if (dt(f), v !== v + 0) throw v;
        it(1, 0);
      }
    }
    function Oq(d, h, f, v, b) {
      var k = ut();
      try {
        _t(d)(h, f, v, b);
      } catch (Q) {
        if (dt(k), Q !== Q + 0) throw Q;
        it(1, 0);
      }
    }
    function jq(d, h, f, v, b) {
      var k = ut();
      try {
        return _t(d)(h, f, v, b);
      } catch (Q) {
        if (dt(k), Q !== Q + 0) throw Q;
        it(1, 0);
      }
    }
    function Pq(d, h, f, v) {
      var b = ut();
      try {
        return _t(d)(h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function $q(d, h, f, v, b, k) {
      var Q = ut();
      try {
        return _t(d)(h, f, v, b, k);
      } catch (D) {
        if (dt(Q), D !== D + 0) throw D;
        it(1, 0);
      }
    }
    function Kq(d, h, f, v, b, k) {
      var Q = ut();
      try {
        return _t(d)(h, f, v, b, k);
      } catch (D) {
        if (dt(Q), D !== D + 0) throw D;
        it(1, 0);
      }
    }
    function Xq(d, h, f, v, b, k, Q, D) {
      var X = ut();
      try {
        return _t(d)(h, f, v, b, k, Q, D);
      } catch (j) {
        if (dt(X), j !== j + 0) throw j;
        it(1, 0);
      }
    }
    function zq(d, h, f, v, b, k, Q, D) {
      var X = ut();
      try {
        _t(d)(h, f, v, b, k, Q, D);
      } catch (j) {
        if (dt(X), j !== j + 0) throw j;
        it(1, 0);
      }
    }
    function qq(d, h, f, v, b, k, Q, D, X, j, he, Ye) {
      var Oe = ut();
      try {
        return _t(d)(h, f, v, b, k, Q, D, X, j, he, Ye);
      } catch (ht) {
        if (dt(Oe), ht !== ht + 0) throw ht;
        it(1, 0);
      }
    }
    function eee(d, h, f, v, b, k, Q, D, X, j, he, Ye, Oe, ht, Nt, kr) {
      var _r = ut();
      try {
        _t(d)(h, f, v, b, k, Q, D, X, j, he, Ye, Oe, ht, Nt, kr);
      } catch (oi) {
        if (dt(_r), oi !== oi + 0) throw oi;
        it(1, 0);
      }
    }
    function tee(d, h, f, v) {
      var b = ut();
      try {
        _t(d)(h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function ree(d, h, f, v) {
      var b = ut();
      try {
        _t(d)(h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function nee(d, h, f, v, b) {
      var k = ut();
      try {
        fR(d, h, f, v, b);
      } catch (Q) {
        if (dt(k), Q !== Q + 0) throw Q;
        it(1, 0);
      }
    }
    function aee(d, h, f, v) {
      var b = ut();
      try {
        vR(d, h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function iee(d) {
      var h = ut();
      try {
        return mR(d);
      } catch (f) {
        if (dt(h), f !== f + 0) throw f;
        it(1, 0);
      }
    }
    function oee(d, h, f, v, b, k, Q) {
      var D = ut();
      try {
        return SR(d, h, f, v, b, k, Q);
      } catch (X) {
        if (dt(D), X !== X + 0) throw X;
        it(1, 0);
      }
    }
    function see(d, h, f, v) {
      var b = ut();
      try {
        return CR(d, h, f, v);
      } catch (k) {
        if (dt(b), k !== k + 0) throw k;
        it(1, 0);
      }
    }
    function lee(d, h, f) {
      var v = ut();
      try {
        return IR(d, h, f);
      } catch (b) {
        if (dt(v), b !== b + 0) throw b;
        it(1, 0);
      }
    }
    var _I;
    Rr = function d() {
      _I || bR(), _I || (Rr = d);
    };
    function bR() {
      function d() {
        var h;
        if (!_I && (_I = !0, a.calledRun = !0, !J)) {
          if (!a.noFSInit && !rr) {
            var f, v;
            rr = !0, b ?? (b = a.stdin), f ?? (f = a.stdout), v ?? (v = a.stderr), b ? m0("stdin", b) : uA("/dev/tty", "/dev/stdin"), f ? m0("stdout", null, f) : uA("/dev/tty", "/dev/stdout"), v ? m0("stderr", null, v) : uA("/dev/tty1", "/dev/stderr"), hI("/dev/stdin", 0), hI("/dev/stdout", 1), hI("/dev/stderr", 1);
          }
          if (ra = !1, hd(Rn), hd(vs), i(a), (h = a.onRuntimeInitialized) == null || h.call(a), yR) {
            var b = cR;
            try {
              var k = b(0, 0);
              W = k, UI(k);
            } catch (Q) {
              _A(Q);
            }
          }
          if (a.postRun) for (typeof a.postRun == "function" && (a.postRun = [a.postRun]); a.postRun.length; ) k = a.postRun.shift(), Ss.unshift(k);
          hd(Ss);
        }
      }
      if (!(0 < ta)) {
        if (a.preRun) for (typeof a.preRun == "function" && (a.preRun = [a.preRun]); a.preRun.length; ) Tl();
        hd(ea), 0 < ta || (a.setStatus ? (a.setStatus("Running..."), setTimeout(function() {
          setTimeout(function() {
            a.setStatus("");
          }, 1), d();
        }, 1)) : d());
      }
    }
    if (a.preInit) for (typeof a.preInit == "function" && (a.preInit = [a.preInit]); 0 < a.preInit.length; ) a.preInit.pop()();
    var yR = !0;
    return a.noInitialRun && (yR = !1), bR(), n = s, n;
  };
})();
const cpe = () => spe(), dpe = async (e, t = {}) => {
  const r = await WebAssembly.compile(e);
  return lpe({
    instantiateWasm(n, a) {
      WebAssembly.instantiate(r, n).then((i) => (a(i), i.exports));
    },
    noExitRuntime: !0,
    noInitialRun: !0,
    ...t
  });
}, Ax = "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", upe = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), P5 = typeof self < "u" && self.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", upe(Ax)], { type: "text/javascript;charset=utf-8" });
function hpe(e) {
  let t;
  try {
    if (t = P5 && (self.URL || self.webkitURL).createObjectURL(P5), !t) throw "";
    const r = new Worker(t, {
      type: "module",
      name: e == null ? void 0 : e.name
    });
    return r.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), r;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + Ax,
      {
        type: "module",
        name: e == null ? void 0 : e.name
      }
    );
  }
}
const Ux = "dmFyIGcgPSAvKiBAX19QVVJFX18gKi8gKChuKSA9PiAobi5QaW5nID0gInBpbmciLCBuLlBvbmcgPSAicG9uZyIsIG4pKShnIHx8IHt9KTsKb25tZXNzYWdlID0gKG4pID0+IHsKICB0eXBlb2Ygbi5kYXRhID09ICJzdHJpbmciICYmIG4uZGF0YSA9PT0gZy5QaW5nICYmIHBvc3RNZXNzYWdlKGcuUG9uZyk7Cn07Ci8vIyBzb3VyY2VNYXBwaW5nVVJMPW5lc3RlZC13ZWItd29ya2VyLXRlc3QtQ0diZms4a0YuanMubWFwCg==", ppe = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), $5 = typeof self < "u" && self.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", ppe(Ux)], { type: "text/javascript;charset=utf-8" });
function gpe(e) {
  let t;
  try {
    if (t = $5 && (self.URL || self.webkitURL).createObjectURL($5), !t) throw "";
    const r = new Worker(t, {
      type: "module",
      name: e == null ? void 0 : e.name
    });
    return r.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), r;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + Ux,
      {
        type: "module",
        name: e == null ? void 0 : e.name
      }
    );
  }
}
var F_ = /* @__PURE__ */ ((e) => (e.Ping = "ping", e.Pong = "pong", e))(F_ || {});
async function fpe(e = 1e3) {
  const t = new gpe();
  try {
    return await new Promise((r, n) => {
      const a = () => n(new Error("Nested Web Workers not available"));
      t.onerror = a, t.onmessageerror = a, t.onmessage = (i) => {
        typeof i.data == "string" && i.data === F_.Pong && r();
      }, setTimeout(a, e), t.postMessage(F_.Ping);
    }), !0;
  } catch {
    return !1;
  } finally {
    t.terminate();
  }
}
async function mpe(e) {
  return !e && await fpe() ? new hpe() : new wx();
}
var _i = /* @__PURE__ */ ((e) => (e.Idle = "idle", e.Pending = "pending", e.Error = "error", e.Success = "success", e))(_i || {}), Y = /* @__PURE__ */ ((e) => (e.Ar = "ar", e.Bg = "bg", e.Cs = "cs", e.Da = "da", e.De = "de", e.El = "el", e.En = "en", e.EnGb = "en_GB", e.EnGbHyphen = "en-GB", e.EnUs = "en_US", e.EnUsHyphen = "en-US", e.Es = "es", e.EsMx = "es_MX", e.EsMxHyphen = "es-MX", e.Et = "et", e.Fi = "fi", e.Fr = "fr", e.He = "he", e.Hr = "hr", e.Hu = "hu", e.Hy = "hy", e.Id = "id", e.It = "it", e.Ja = "ja", e.KaGe = "ka_GE", e.KaGeHyphen = "ka-GE", e.Km = "km", e.KmKh = "km_KH", e.KmKhHyphen = "km-KH", e.Ko = "ko", e.Lt = "lt", e.Ms = "ms", e.Nl = "nl", e.No = "no", e.Pl = "pl", e.Pt = "pt", e.PtBr = "pt_BR", e.PtBrHyphen = "pt-BR", e.Ro = "ro", e.Ru = "ru", e.Sk = "sk", e.SrCyrl = "sr_Cyrl", e.SrCyrlHyphen = "sr-Cyrl", e.Sr = "sr", e.SrLatn = "sr_Latn", e.SrLatnHyphen = "sr-Latn", e.Sv = "sv", e.Sw = "sw", e.Th = "th", e.Tr = "tr", e.Uk = "uk", e.Vi = "vi", e.Zh = "zh", e.ZhCn = "zh_CN", e.ZhCnHyphen = "zh-CN", e.ZhHk = "zh_HK", e.ZhHkHyphen = "zh-HK", e))(Y || {}), Ee = /* @__PURE__ */ ((e) => (e.Trace = "trace", e.Debug = "debug", e.Info = "info", e.Warn = "warn", e.Error = "error", e.None = "none", e))(Ee || {}), ul = /* @__PURE__ */ ((e) => (e.Default = "default", e.EmailOnly = "email_only", e.QrOnly = "qr_only", e))(ul || {}), In = /* @__PURE__ */ ((e) => (e.Start = "start-screen-start", e.ConsentScreen = "start-screen-consent", e.Finish = "start-screen-finish", e))(In || {}), Z = /* @__PURE__ */ ((e) => (e.CaptureScreenEntry = "id-capture-screen-entry", e.CaptureScreen = "id-capture-screen", e.CaptureScreenAutoCaptureLoading = "id-capture-screen-auto-capture-loading", e.CaptureScreenBack = "id-capture-screen-back", e.CaptureScreenBackFinish = "id-capture-screen-back-finish", e.CaptureScreenBackStart = "id-capture-screen-back-start", e.CaptureScreenComplete = "id-capture-screen-complete", e.CaptureScreenDecision = "id-capture-screen-decision", e.CaptureScreenFront = "id-capture-screen-front", e.CaptureScreenFrontFinish = "id-capture-screen-front-finish", e.CaptureScreenPrepareForRecapturingBack = "id-capture-screen-prepare-for-recapturing-back", e.CaptureScreenFrontStart = "id-capture-screen-front-start", e.CaptureScreenSelectProvider = "id-capture-screen-select-provider", e.CaptureScreenUpload = "id-capture-screen-upload", e.CaptureScreenUploadFailed = "id-capture-screen-upload-failed", e.CaptureSourceSelection = "id-capture-source-selection", e.DocTypeDecision = "id-doctype-decision", e.DocTypeSelection = "id-doctype-selection", e.DocTypeVariantSelection = "id-doctype-variant-selection", e.Finish = "id-finish", e.IdUsabilityCheck = "id-usability-check", e.IdUsabilityCheckFailure = "id-usability-check-failure", e.IdUsabilityCheckBackMissing = "id-usability-check-back-missing", e.IdUsabilityCheckReset = "id-usability-check-reset", e.IdUsabilitySupportedList = "id-usability-supported-list", e.Start = "id-start", e.Upload = "id-upload", e))(Z || {}), x = /* @__PURE__ */ ((e) => (e.Start = "identity-start", e.VerificationMethodFailed = "identity-verification-method-failure", e.Iproov = "identity-liveness", e.IproovFailureSystem = "identity-liveness-failure-system", e.IproovFinish = "identity-liveness-finish", e.JumioStandard = "identity-jumio-standard", e.JumioStandardGuidance = "identity-jumio-standard-guidance", e.JumioStandardCaptureScreen = "identity-jumio-standard-capture-screen", e.JumioStandardCaptureScreenLiveness = "identity-jumio-standard-capture-screen-liveness", e.JumioStandardCaptureScreenLivenessLoading = "identity-jumio-standard-capture-screen-liveness-loading", e.JumioStandardCaptureScreenCaptureFinish = "identity-jumio-standard-capture-screen-capture-finish", e.JumioStandardCaptureScreenSelfie = "identity-jumio-standard-capture-screen-manual-selfie", e.JumioStandardCaptureScreenUpload = "identity-jumio-standard-capture-screen-upload", e.JumioStandardCaptureScreenUploadFailed = "identity-jumio-standard-capture-screen-upload-failed", e.JumioStandardUsabilityCheck = "identity-jumio-standard-usability-check", e.JumioStandardUsabilityCheckFailure = "identity-jumio-standard-usability-check-failure", e.JumioStandardFinish = "identity-jumio-standard-finish", e.NoVerificationMethodsLeft = "identity-no-verification-methods-left", e.Finish = "identity-finish", e))(x || {}), Cn = /* @__PURE__ */ ((e) => (e.UploadScreen = "document-upload", e.MobileCapture = "document-mobile-capture", e.Finish = "document-finish", e))(Cn || {}), Jd = /* @__PURE__ */ ((e) => (e.Start = "data-start", e.Finish = "data-finish", e))(Jd || {}), jd = /* @__PURE__ */ ((e) => (e.Ready = "ready", e.Success = "success", e.Error = "error", e.Loading = "loading", e))(jd || {}), T_ = /* @__PURE__ */ ((e) => (e.Camera = "camera", e.Upload = "upload", e.Preview = "preview", e))(T_ || {}), er = /* @__PURE__ */ ((e) => (e.NotStarted = "not-started", e.Progress = "progress", e.Error = "error", e.Success = "success", e))(er || {}), hl = /* @__PURE__ */ ((e) => (e.NotStarted = "not-started", e.Progress = "progress", e.Success = "success", e.Error = "error", e))(hl || {});
const iVe = {
  JumioStandard: "JUMIO_STANDARD",
  JumioLiveness: "JUMIO_LIVENESS",
  JumioPremium: "JUMIO_PREMIUM",
  IproovStandard: "IPROOV_STANDARD",
  IproovPremium: "IPROOV_PREMIUM"
}, vpe = {
  AutoCapture: "AUTO_CAPTURE",
  ManualCapture: "MANUAL_CAPTURE",
  Upload: "UPLOAD"
};
var Nm = /* @__PURE__ */ ((e) => (e.BrazilianDrivingLicense = "BRA_PDF_DRIVING_LICENSE", e.Mastercard = "MASTERCARD", e))(Nm || {});
function Spe(...e) {
  const t = {
    config: {},
    state: {}
  };
  for (const {
    config: r,
    props: n
  } of e)
    Object.assign(t.config, r), Object.assign(t.state, n);
  return t;
}
const kx = new Kt(!1), Ipe = kx.asObservable().pipe(at((e) => !e), qc(1)), FI = {}, AE = /* @__PURE__ */ new Map(), UE = new _e();
UE.asObservable();
function Cpe(e) {
  AE.set(e.name, e), UE.next({
    type: "add",
    store: e
  });
}
function bpe(e) {
  AE.delete(e.name), UE.next({
    type: "remove",
    store: e
  });
}
function _x() {
  return AE;
}
let _C = [];
function ype(e) {
  _C.push(e);
}
function K5(e) {
  _C.length && _C.forEach((t) => e.next(t)), _C = [];
}
class wpe extends Kt {
  constructor(t) {
    super(t.state), this.storeDef = t, this.initialState = void 0, this.state = void 0, this.batchInProgress = !1, this.events = new _e(), this.context = {
      config: this.getConfig(),
      setEvent: (r) => {
        ype(r);
      }
    }, this.events$ = this.events.asObservable(), this.state = this.getInitialState(t.state), this.initialState = this.getValue(), Cpe(this);
  }
  get name() {
    return this.storeDef.name;
  }
  getInitialState(t) {
    return FI.preStateInit ? FI.preStateInit(t, this.name) : t;
  }
  getConfig() {
    return this.storeDef.config;
  }
  query(t) {
    return t(this.getValue());
  }
  update(...t) {
    const r = this.getValue();
    let n = t.reduce((a, i) => (a = i(a, this.context), a), r);
    FI.preStoreUpdate && (n = FI.preStoreUpdate(r, n, this.name)), n !== r && (this.state = n, kx.getValue() ? this.batchInProgress || (this.batchInProgress = !0, Ipe.subscribe(() => {
      super.next(this.state), K5(this.events), this.batchInProgress = !1;
    })) : (super.next(this.state), K5(this.events)));
  }
  getValue() {
    return this.state;
  }
  reset() {
    this.update(() => this.initialState);
  }
  combine(t) {
    let r = !0;
    const n = {};
    return new Ht((a) => {
      for (const [i, o] of Object.entries(t))
        a.add(o.subscribe((s) => {
          n[i] = s, r = !0;
        }));
      return this.subscribe({
        next() {
          r && (a.next({
            ...n
          }), r = !1);
        },
        error(i) {
          a.error(i);
        },
        complete() {
          a.complete();
        }
      });
    });
  }
  destroy() {
    bpe(this), this.reset();
  }
  next(t) {
    this.update(() => t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  error() {
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  complete() {
  }
}
function mo(e, ...t) {
  const {
    state: r,
    config: n
  } = Spe(...t), {
    name: a
  } = e;
  return new wpe({
    name: a,
    state: r,
    config: n
  });
}
function vl(e) {
  return Array.isArray(e) ? e : [e];
}
function Zm(e) {
  return typeof e == "function";
}
function x1(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Ape(e) {
  return typeof e == "object" && !Array.isArray(e) && e !== null;
}
function cn(e, t) {
  return function(r) {
    return {
      ...r,
      [e]: Zm(t) ? t(r[e]) : t
    };
  };
}
function Nx(e) {
  return function(t) {
    return {
      ...t,
      ...Zm(e) ? e(t) : e
    };
  };
}
function bt(e) {
  return ho(te(e), vt());
}
function Zx(e, {
  initialValue: t,
  config: r
}) {
  let n = t;
  const a = x1(e);
  return {
    [`with${a}`](i = n) {
      return {
        props: {
          [e]: i
        },
        config: r
      };
    },
    [`set${a}InitialValue`](i) {
      n = i;
    },
    [`set${a}`](i) {
      return function(o) {
        const s = Zm(i) ? i(o) : i;
        return s === o[e] ? o : {
          ...o,
          [e]: s
        };
      };
    },
    [`update${a}`](i) {
      return function(o) {
        const s = Zm(i) ? i(o) : i;
        return s === o[e] ? o : {
          ...o,
          [e]: Ape(s) ? {
            ...o[e],
            ...s
          } : s
        };
      };
    },
    [`reset${a}`]() {
      return function(i) {
        return {
          ...i,
          [e]: n
        };
      };
    },
    [`select${a}`]() {
      return bt((i) => i[e]);
    },
    [`get${a}`](i) {
      return i[e];
    }
  };
}
function Upe(e, t) {
  const r = x1(e);
  return {
    ...Zx(e, t),
    [`add${r}`](a) {
      return function(i) {
        return {
          ...i,
          [e]: kpe(i[e], a)
        };
      };
    },
    [`remove${r}`](a) {
      return function(i) {
        return {
          ...i,
          [e]: _pe(i[e], a)
        };
      };
    },
    [`toggle${r}`](a) {
      return function(i) {
        return {
          ...i,
          [e]: Npe(i[e], a)
        };
      };
    },
    [`update${r}`](a, i) {
      return function(o) {
        return {
          ...o,
          [e]: Bpe(o[e], a, i)
        };
      };
    },
    [`in${r}`](a) {
      return (i) => Zpe(i[e], a);
    }
  };
}
function kpe(e, t) {
  return [...e, ...vl(t)];
}
function _pe(e, t) {
  const r = vl(t);
  return e.filter((n) => !r.includes(n));
}
function Npe(e, t) {
  const r = vl(t), n = [...e];
  return r.forEach((a) => {
    const i = n.indexOf(a);
    i > -1 ? n.splice(i, 1) : n.push(a);
  }), n;
}
function Zpe(e, t) {
  return e.includes(t);
}
function Bpe(e, t, r) {
  return e.map((n) => n === t ? r : n);
}
function Wl(e) {
  return {
    props: e,
    config: void 0
  };
}
function kE(e, t) {
  const r = {}, n = [];
  for (const a of e) {
    const i = a[t];
    n.push(i), r[i] = a;
  }
  return {
    ids: n,
    asObject: r
  };
}
function Wpe(e, t, r) {
  const {
    idsKey: n,
    entitiesKey: a
  } = t, i = e[a];
  return e[n].filter((o) => r(i[o]));
}
function _E(e, t) {
  return e.config[t.idKeyRef];
}
class Epe {
  constructor(t) {
    this.entitiesKey = void 0, this.idsKey = void 0, this.idKeyRef = "idKey", this.entitiesKey = t.entitiesKey, this.idsKey = t.idsKey, this.idKeyRef = t.idKeyRef;
  }
}
function ad(e) {
  const t = e ? `idKey${x1(e)}` : "idKey", r = new Epe({
    entitiesKey: e ? `${e}Entities` : "entities",
    idsKey: e ? `${e}Ids` : "ids",
    idKeyRef: t
  });
  function n(a) {
    let i = {}, o = [];
    const s = (a == null ? void 0 : a.idKey) || "id";
    return a != null && a.initialValue && ({
      ids: o,
      asObject: i
    } = kE(a.initialValue, s)), {
      props: {
        [r.entitiesKey]: i,
        [r.idsKey]: o
      },
      config: {
        [t]: s
      }
    };
  }
  return {
    [`${e}EntitiesRef`]: r,
    [`with${x1(e)}Entities`]: n
  };
}
const {
  withEntities: Qpe,
  EntitiesRef: ni
} = ad("");
ad("UI");
function R_(e, t = {}) {
  return function(r, n) {
    const {
      ref: {
        idsKey: a,
        entitiesKey: i
      } = ni
    } = t, o = vl(e), s = {
      ...r[i]
    }, c = r[a].filter((l) => !o.includes(l));
    for (const l of o)
      Reflect.deleteProperty(s, l);
    return n.setEvent({
      type: "delete",
      ids: o
    }), {
      ...r,
      [i]: s,
      [a]: c
    };
  };
}
function Bm(e, t = {}) {
  return function(n, a) {
    const i = Wpe(n, t.ref || ni, e);
    return i.length ? (a.setEvent({
      type: "delete",
      ids: i
    }), R_(i, t)(n, a)) : n;
  };
}
function Fpe(e = {}) {
  return function(r, n) {
    const {
      ref: {
        idsKey: a,
        entitiesKey: i
      } = ni
    } = e;
    return n.setEvent({
      type: "delete",
      ids: []
    }), {
      ...r,
      [i]: {},
      [a]: []
    };
  };
}
function Tpe(e, t = {}) {
  return function(r, n) {
    const {
      prepend: a = !1,
      ref: i = ni
    } = t, {
      entitiesKey: o,
      idsKey: s
    } = i, c = _E(n, i), l = vl(e);
    if (!l.length) return r;
    Rpe(l, c, r, o), Dpe(l, c);
    const {
      ids: u,
      asObject: g
    } = kE(l, c);
    return n.setEvent({
      type: "add",
      ids: u
    }), {
      ...r,
      [o]: {
        ...r[o],
        ...g
      },
      [s]: a ? [...u, ...r[s]] : [...r[s], ...u]
    };
  };
}
function Rpe(e, t, r, n) {
  e.forEach((a) => {
    const i = a[t];
    if (r[n][i])
      throw Error(`Entity already exists. ${t} ${i}`);
  });
}
function Dpe(e, t) {
  const r = /* @__PURE__ */ new Set();
  e.forEach((n) => {
    const a = n[t];
    if (r.has(a))
      throw Error(`Duplicate entity id provided. ${t} ${a}`);
    r.add(a);
  });
}
function sw(e, t = {}) {
  return function(r, n) {
    const {
      ref: a = ni
    } = t, {
      entitiesKey: i,
      idsKey: o
    } = a, {
      ids: s,
      asObject: c
    } = kE(e, _E(n, a));
    return n.setEvent({
      type: "set",
      ids: s
    }), {
      ...r,
      [i]: c,
      [o]: s
    };
  };
}
function D_(e = {}) {
  const {
    ref: {
      entitiesKey: t,
      idsKey: r
    } = ni
  } = e;
  return function(n) {
    return n[r].map((a) => n[t][a]);
  };
}
function Jpe(e) {
  const {
    ref: {
      entitiesKey: t,
      idsKey: r
    } = ni,
    filterEntity: n = () => !0,
    mapEntity: a = (i) => i
  } = e;
  return function(i) {
    const o = [];
    for (const s of i[r]) {
      const c = i[t][s];
      n(c) && o.push(a(c));
    }
    return o;
  };
}
function WS(e, t = {}) {
  return function(r) {
    const {
      ref: {
        entitiesKey: n
      } = ni
    } = t;
    return r[n][e];
  };
}
function Bx(e, t = {}) {
  return function(r) {
    const {
      ref: {
        entitiesKey: n
      } = ni
    } = t;
    return Reflect.has(r[n], e);
  };
}
function Vpe(e = {}) {
  return function(t) {
    const {
      ref: {
        idsKey: r
      } = ni
    } = e;
    return t[r];
  };
}
function Wx(e, t) {
  return Zm(e) ? e(t) : {
    ...t,
    ...e
  };
}
function Ex(e, t, r = {}) {
  return function(n, a) {
    const i = vl(e);
    if (!i.length) return n;
    const {
      ref: {
        entitiesKey: o
      } = ni
    } = r, s = {};
    for (const c of i)
      Bx(c, r)(n) && (s[c] = Wx(t, WS(c, r)(n)));
    return a.setEvent({
      type: "update",
      ids: i
    }), {
      ...n,
      [o]: {
        ...n[o],
        ...s
      }
    };
  };
}
function lw(e, {
  updater: t,
  creator: r,
  ...n
}) {
  return function(a, i) {
    const o = [], s = [], c = vl(e);
    if (!c.length) return a;
    for (const u of c)
      if (Bx(u, n)(a))
        o.push(u);
      else {
        let g = r(u);
        n.mergeUpdaterWithCreator && (g = Wx(t, g)), s.push(g);
      }
    const l = Ex(o, t, n)(a, i);
    return Tpe(s, n)(l, i);
  };
}
function X5(e, t, r = {}) {
  return function(n, a) {
    const i = vl(e), o = vl(t);
    if (i.length !== o.length)
      throw new Error("The number of old and new ids must be equal");
    if (!i.length || !o.length) return n;
    const {
      ref: s = ni
    } = r, c = _E(a, s), l = {
      ...n[s.entitiesKey]
    };
    for (let p = 0; p < i.length; p++) {
      const m = i[p], I = o[p];
      if (n[s.entitiesKey][I])
        throw new Error(`Updating id "${m}". The new id "${I}" already exists`);
      const A = {
        ...n[s.entitiesKey][m],
        [c]: I
      };
      l[I] = A, Reflect.deleteProperty(l, m);
    }
    const u = n[s.idsKey].slice();
    let g = 0;
    for (let p = 0; p < u.length; p++) {
      const m = u[p];
      for (let I = 0; I < i.length; I++) {
        const C = i[I], A = o[I];
        if (m === C) {
          u[p] = A, g++;
          break;
        }
      }
      if (g === i.length)
        break;
    }
    return a.setEvent({
      type: "update",
      ids: o
    }), {
      ...n,
      [s.entitiesKey]: l,
      [s.idsKey]: u
    };
  };
}
function Mpe(e) {
  return vt((t, r) => t[e] === r[e]);
}
function Tu(e) {
  const {
    ref: {
      entitiesKey: t,
      idsKey: r
    } = ni,
    filterEntity: n = () => !0,
    mapEntity: a = (i) => i
  } = e;
  return ho(Mpe(t), te((i) => {
    const o = [];
    for (const s of i[r]) {
      const c = i[t][s];
      n(c) && o.push(a(c));
    }
    return o;
  }));
}
Zx("activeId", {
  initialValue: void 0
});
Upe("activeIds", {
  initialValue: []
});
const ES = mo(
  { name: "consents" },
  Qpe(),
  Wl({ settingsFetched: !1 })
), Gpe = (e) => {
  ES.update(sw(e));
}, xpe = (e) => {
  ES.update(cn("settingsFetched", e));
}, Hpe = (e) => {
  ES.update(
    Ex(e.id, (t) => ({
      ...t,
      timestamp: e.timestamp,
      given: e.consentGiven
    }))
  );
}, Lpe = () => Object.values(ES.getValue().entities).map((e) => ({
  id: e.id,
  displayType: e.item.displayType,
  timestamp: e.timestamp ?? Date.now()
})), Ype = () => ES.pipe(
  at((e) => e.settingsFetched),
  Tu({
    filterEntity: (e) => e.item.displayType === M1.Active,
    mapEntity: (e) => e.given
  }),
  te((e) => e.length === 0 || e.every((t) => t))
);
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var z5;
(function(e) {
  (function(t) {
    var r = typeof globalThis == "object" ? globalThis : typeof A5 == "object" ? A5 : typeof self == "object" ? self : typeof this == "object" ? this : s(), n = a(e);
    typeof r.Reflect < "u" && (n = a(r.Reflect, n)), t(n, r), typeof r.Reflect > "u" && (r.Reflect = e);
    function a(c, l) {
      return function(u, g) {
        Object.defineProperty(c, u, { configurable: !0, writable: !0, value: g }), l && l(u, g);
      };
    }
    function i() {
      try {
        return Function("return this;")();
      } catch {
      }
    }
    function o() {
      try {
        return (0, eval)("(function() { return this; })()");
      } catch {
      }
    }
    function s() {
      return i() || o();
    }
  })(function(t, r) {
    var n = Object.prototype.hasOwnProperty, a = typeof Symbol == "function", i = a && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", o = a && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", s = typeof Object.create == "function", c = { __proto__: [] } instanceof Array, l = !s && !c, u = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: s ? function() {
        return gh(/* @__PURE__ */ Object.create(null));
      } : c ? function() {
        return gh({ __proto__: null });
      } : function() {
        return gh({});
      },
      has: l ? function(F, V) {
        return n.call(F, V);
      } : function(F, V) {
        return V in F;
      },
      get: l ? function(F, V) {
        return n.call(F, V) ? F[V] : void 0;
      } : function(F, V) {
        return F[V];
      }
    }, g = Object.getPrototypeOf(Function), p = typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : sI(), m = typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : Vi(), I = typeof WeakMap == "function" ? WeakMap : g0(), C = a ? Symbol.for("@reflect-metadata:registry") : void 0, A = iI(), U = sA(A);
    function B(F, V, $, ce) {
      if (ye($)) {
        if (!hd(F))
          throw new TypeError();
        if (!Ji(V))
          throw new TypeError();
        return yr(F, V);
      } else {
        if (!hd(F))
          throw new TypeError();
        if (!mr(V))
          throw new TypeError();
        if (!mr(ce) && !ye(ce) && !fr(ce))
          throw new TypeError();
        return fr(ce) && (ce = void 0), $ = Qa($), hr(F, V, $, ce);
      }
    }
    t("decorate", B);
    function J(F, V) {
      function $(ce, Qe) {
        if (!mr(ce))
          throw new TypeError();
        if (!ye(Qe) && !uh(Qe))
          throw new TypeError();
        Tl(F, V, ce, Qe);
      }
      return $;
    }
    t("metadata", J);
    function W(F, V, $, ce) {
      if (!mr($))
        throw new TypeError();
      return ye(ce) || (ce = Qa(ce)), Tl(F, V, $, ce);
    }
    t("defineMetadata", W);
    function L(F, V, $) {
      if (!mr(V))
        throw new TypeError();
      return ye($) || ($ = Qa($)), ea(F, V, $);
    }
    t("hasMetadata", L);
    function H(F, V, $) {
      if (!mr(V))
        throw new TypeError();
      return ye($) || ($ = Qa($)), Rn(F, V, $);
    }
    t("hasOwnMetadata", H);
    function R(F, V, $) {
      if (!mr(V))
        throw new TypeError();
      return ye($) || ($ = Qa($)), vs(F, V, $);
    }
    t("getMetadata", R);
    function ge(F, V, $) {
      if (!mr(V))
        throw new TypeError();
      return ye($) || ($ = Qa($)), Ss(F, V, $);
    }
    t("getOwnMetadata", ge);
    function z(F, V) {
      if (!mr(F))
        throw new TypeError();
      return ye(V) || (V = Qa(V)), ta(F, V);
    }
    t("getMetadataKeys", z);
    function K(F, V) {
      if (!mr(F))
        throw new TypeError();
      return ye(V) || (V = Qa(V)), Rr(F, V);
    }
    t("getOwnMetadataKeys", K);
    function Fe(F, V, $) {
      if (!mr(V))
        throw new TypeError();
      if (ye($) || ($ = Qa($)), !mr(V))
        throw new TypeError();
      ye($) || ($ = Qa($));
      var ce = So(
        V,
        $,
        /*Create*/
        !1
      );
      return ye(ce) ? !1 : ce.OrdinaryDeleteMetadata(F, V, $);
    }
    t("deleteMetadata", Fe);
    function yr(F, V) {
      for (var $ = F.length - 1; $ >= 0; --$) {
        var ce = F[$], Qe = ce(V);
        if (!ye(Qe) && !fr(Qe)) {
          if (!Ji(Qe))
            throw new TypeError();
          V = Qe;
        }
      }
      return V;
    }
    function hr(F, V, $, ce) {
      for (var Qe = F.length - 1; Qe >= 0; --Qe) {
        var Ur = F[Qe], pr = Ur(V, $, ce);
        if (!ye(pr) && !fr(pr)) {
          if (!mr(pr))
            throw new TypeError();
          ce = pr;
        }
      }
      return ce;
    }
    function ea(F, V, $) {
      var ce = Rn(F, V, $);
      if (ce)
        return !0;
      var Qe = Is(V);
      return fr(Qe) ? !1 : ea(F, Qe, $);
    }
    function Rn(F, V, $) {
      var ce = So(
        V,
        $,
        /*Create*/
        !1
      );
      return ye(ce) ? !1 : Xe(ce.OrdinaryHasOwnMetadata(F, V, $));
    }
    function vs(F, V, $) {
      var ce = Rn(F, V, $);
      if (ce)
        return Ss(F, V, $);
      var Qe = Is(V);
      if (!fr(Qe))
        return vs(F, Qe, $);
    }
    function Ss(F, V, $) {
      var ce = So(
        V,
        $,
        /*Create*/
        !1
      );
      if (!ye(ce))
        return ce.OrdinaryGetOwnMetadata(F, V, $);
    }
    function Tl(F, V, $, ce) {
      var Qe = So(
        $,
        ce,
        /*Create*/
        !0
      );
      Qe.OrdinaryDefineOwnMetadata(F, V, $, ce);
    }
    function ta(F, V) {
      var $ = Rr(F, V), ce = Is(F);
      if (ce === null)
        return $;
      var Qe = ta(ce, V);
      if (Qe.length <= 0)
        return $;
      if ($.length <= 0)
        return Qe;
      for (var Ur = new m(), pr = [], pe = 0, fe = $; pe < fe.length; pe++) {
        var Se = fe[pe], Ae = Ur.has(Se);
        Ae || (Ur.add(Se), pr.push(Se));
      }
      for (var Ue = 0, et = Qe; Ue < et.length; Ue++) {
        var Se = et[Ue], Ae = Ur.has(Se);
        Ae || (Ur.add(Se), pr.push(Se));
      }
      return pr;
    }
    function Rr(F, V) {
      var $ = So(
        F,
        V,
        /*create*/
        !1
      );
      return $ ? $.OrdinaryOwnMetadataKeys(F, V) : [];
    }
    function wr(F) {
      if (F === null)
        return 1;
      switch (typeof F) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return F === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function ye(F) {
      return F === void 0;
    }
    function fr(F) {
      return F === null;
    }
    function Rl(F) {
      return typeof F == "symbol";
    }
    function mr(F) {
      return typeof F == "object" ? F !== null : typeof F == "function";
    }
    function aI(F, V) {
      switch (wr(F)) {
        case 0:
          return F;
        case 1:
          return F;
        case 2:
          return F;
        case 3:
          return F;
        case 4:
          return F;
        case 5:
          return F;
      }
      var $ = "string", ce = pd(F, i);
      if (ce !== void 0) {
        var Qe = ce.call(F, $);
        if (mr(Qe))
          throw new TypeError();
        return Qe;
      }
      return iA(F);
    }
    function iA(F, V) {
      var $, ce;
      {
        var Qe = F.toString;
        if (Dl(Qe)) {
          var ce = Qe.call(F);
          if (!mr(ce))
            return ce;
        }
        var $ = F.valueOf;
        if (Dl($)) {
          var ce = $.call(F);
          if (!mr(ce))
            return ce;
        }
      }
      throw new TypeError();
    }
    function Xe(F) {
      return !!F;
    }
    function Ar(F) {
      return "" + F;
    }
    function Qa(F) {
      var V = aI(F);
      return Rl(V) ? V : Ar(V);
    }
    function hd(F) {
      return Array.isArray ? Array.isArray(F) : F instanceof Object ? F instanceof Array : Object.prototype.toString.call(F) === "[object Array]";
    }
    function Dl(F) {
      return typeof F == "function";
    }
    function Ji(F) {
      return typeof F == "function";
    }
    function uh(F) {
      switch (wr(F)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function Fa(F, V) {
      return F === V || F !== F && V !== V;
    }
    function pd(F, V) {
      var $ = F[V];
      if ($ != null) {
        if (!Dl($))
          throw new TypeError();
        return $;
      }
    }
    function hh(F) {
      var V = pd(F, o);
      if (!Dl(V))
        throw new TypeError();
      var $ = V.call(F);
      if (!mr($))
        throw new TypeError();
      return $;
    }
    function ph(F) {
      return F.value;
    }
    function ii(F) {
      var V = F.next();
      return V.done ? !1 : V;
    }
    function p0(F) {
      var V = F.return;
      V && V.call(F);
    }
    function Is(F) {
      var V = Object.getPrototypeOf(F);
      if (typeof F != "function" || F === g || V !== g)
        return V;
      var $ = F.prototype, ce = $ && Object.getPrototypeOf($);
      if (ce == null || ce === Object.prototype)
        return V;
      var Qe = ce.constructor;
      return typeof Qe != "function" || Qe === F ? V : Qe;
    }
    function oA() {
      var F;
      !ye(C) && typeof r.Reflect < "u" && !(C in r.Reflect) && typeof r.Reflect.defineMetadata == "function" && (F = oI(r.Reflect));
      var V, $, ce, Qe = new I(), Ur = {
        registerProvider: pr,
        getProvider: fe,
        setProvider: Ae
      };
      return Ur;
      function pr(Ue) {
        if (!Object.isExtensible(Ur))
          throw new Error("Cannot add provider to a frozen registry.");
        switch (!0) {
          case F === Ue:
            break;
          case ye(V):
            V = Ue;
            break;
          case V === Ue:
            break;
          case ye($):
            $ = Ue;
            break;
          case $ === Ue:
            break;
          default:
            ce === void 0 && (ce = new m()), ce.add(Ue);
            break;
        }
      }
      function pe(Ue, et) {
        if (!ye(V)) {
          if (V.isProviderFor(Ue, et))
            return V;
          if (!ye($)) {
            if ($.isProviderFor(Ue, et))
              return V;
            if (!ye(ce))
              for (var yt = hh(ce); ; ) {
                var rr = ii(yt);
                if (!rr)
                  return;
                var ra = ph(rr);
                if (ra.isProviderFor(Ue, et))
                  return p0(yt), ra;
              }
          }
        }
        if (!ye(F) && F.isProviderFor(Ue, et))
          return F;
      }
      function fe(Ue, et) {
        var yt = Qe.get(Ue), rr;
        return ye(yt) || (rr = yt.get(et)), ye(rr) && (rr = pe(Ue, et), ye(rr) || (ye(yt) && (yt = new p(), Qe.set(Ue, yt)), yt.set(et, rr))), rr;
      }
      function Se(Ue) {
        if (ye(Ue))
          throw new TypeError();
        return V === Ue || $ === Ue || !ye(ce) && ce.has(Ue);
      }
      function Ae(Ue, et, yt) {
        if (!Se(yt))
          throw new Error("Metadata provider not registered.");
        var rr = fe(Ue, et);
        if (rr !== yt) {
          if (!ye(rr))
            return !1;
          var ra = Qe.get(Ue);
          ye(ra) && (ra = new p(), Qe.set(Ue, ra)), ra.set(et, yt);
        }
        return !0;
      }
    }
    function iI() {
      var F;
      return !ye(C) && mr(r.Reflect) && Object.isExtensible(r.Reflect) && (F = r.Reflect[C]), ye(F) && (F = oA()), !ye(C) && mr(r.Reflect) && Object.isExtensible(r.Reflect) && Object.defineProperty(r.Reflect, C, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: F
      }), F;
    }
    function sA(F) {
      var V = new I(), $ = {
        isProviderFor: function(Se, Ae) {
          var Ue = V.get(Se);
          return ye(Ue) ? !1 : Ue.has(Ae);
        },
        OrdinaryDefineOwnMetadata: pr,
        OrdinaryHasOwnMetadata: Qe,
        OrdinaryGetOwnMetadata: Ur,
        OrdinaryOwnMetadataKeys: pe,
        OrdinaryDeleteMetadata: fe
      };
      return A.registerProvider($), $;
      function ce(Se, Ae, Ue) {
        var et = V.get(Se), yt = !1;
        if (ye(et)) {
          if (!Ue)
            return;
          et = new p(), V.set(Se, et), yt = !0;
        }
        var rr = et.get(Ae);
        if (ye(rr)) {
          if (!Ue)
            return;
          if (rr = new p(), et.set(Ae, rr), !F.setProvider(Se, Ae, $))
            throw et.delete(Ae), yt && V.delete(Se), new Error("Wrong provider for target.");
        }
        return rr;
      }
      function Qe(Se, Ae, Ue) {
        var et = ce(
          Ae,
          Ue,
          /*Create*/
          !1
        );
        return ye(et) ? !1 : Xe(et.has(Se));
      }
      function Ur(Se, Ae, Ue) {
        var et = ce(
          Ae,
          Ue,
          /*Create*/
          !1
        );
        if (!ye(et))
          return et.get(Se);
      }
      function pr(Se, Ae, Ue, et) {
        var yt = ce(
          Ue,
          et,
          /*Create*/
          !0
        );
        yt.set(Se, Ae);
      }
      function pe(Se, Ae) {
        var Ue = [], et = ce(
          Se,
          Ae,
          /*Create*/
          !1
        );
        if (ye(et))
          return Ue;
        for (var yt = et.keys(), rr = hh(yt), ra = 0; ; ) {
          var we = ii(rr);
          if (!we)
            return Ue.length = ra, Ue;
          var f0 = ph(we);
          try {
            Ue[ra] = f0;
          } catch (lA) {
            try {
              p0(rr);
            } finally {
              throw lA;
            }
          }
          ra++;
        }
      }
      function fe(Se, Ae, Ue) {
        var et = ce(
          Ae,
          Ue,
          /*Create*/
          !1
        );
        if (ye(et) || !et.delete(Se))
          return !1;
        if (et.size === 0) {
          var yt = V.get(Ae);
          ye(yt) || (yt.delete(Ue), yt.size === 0 && V.delete(yt));
        }
        return !0;
      }
    }
    function oI(F) {
      var V = F.defineMetadata, $ = F.hasOwnMetadata, ce = F.getOwnMetadata, Qe = F.getOwnMetadataKeys, Ur = F.deleteMetadata, pr = new I(), pe = {
        isProviderFor: function(fe, Se) {
          var Ae = pr.get(fe);
          return !ye(Ae) && Ae.has(Se) ? !0 : Qe(fe, Se).length ? (ye(Ae) && (Ae = new m(), pr.set(fe, Ae)), Ae.add(Se), !0) : !1;
        },
        OrdinaryDefineOwnMetadata: V,
        OrdinaryHasOwnMetadata: $,
        OrdinaryGetOwnMetadata: ce,
        OrdinaryOwnMetadataKeys: Qe,
        OrdinaryDeleteMetadata: Ur
      };
      return pe;
    }
    function So(F, V, $) {
      var ce = A.getProvider(F, V);
      if (!ye(ce))
        return ce;
      if ($) {
        if (A.setProvider(F, V, U))
          return U;
        throw new Error("Illegal state.");
      }
    }
    function sI() {
      var F = {}, V = [], $ = (
        /** @class */
        function() {
          function pe(fe, Se, Ae) {
            this._index = 0, this._keys = fe, this._values = Se, this._selector = Ae;
          }
          return pe.prototype["@@iterator"] = function() {
            return this;
          }, pe.prototype[o] = function() {
            return this;
          }, pe.prototype.next = function() {
            var fe = this._index;
            if (fe >= 0 && fe < this._keys.length) {
              var Se = this._selector(this._keys[fe], this._values[fe]);
              return fe + 1 >= this._keys.length ? (this._index = -1, this._keys = V, this._values = V) : this._index++, { value: Se, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, pe.prototype.throw = function(fe) {
            throw this._index >= 0 && (this._index = -1, this._keys = V, this._values = V), fe;
          }, pe.prototype.return = function(fe) {
            return this._index >= 0 && (this._index = -1, this._keys = V, this._values = V), { value: fe, done: !0 };
          }, pe;
        }()
      ), ce = (
        /** @class */
        function() {
          function pe() {
            this._keys = [], this._values = [], this._cacheKey = F, this._cacheIndex = -2;
          }
          return Object.defineProperty(pe.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), pe.prototype.has = function(fe) {
            return this._find(
              fe,
              /*insert*/
              !1
            ) >= 0;
          }, pe.prototype.get = function(fe) {
            var Se = this._find(
              fe,
              /*insert*/
              !1
            );
            return Se >= 0 ? this._values[Se] : void 0;
          }, pe.prototype.set = function(fe, Se) {
            var Ae = this._find(
              fe,
              /*insert*/
              !0
            );
            return this._values[Ae] = Se, this;
          }, pe.prototype.delete = function(fe) {
            var Se = this._find(
              fe,
              /*insert*/
              !1
            );
            if (Se >= 0) {
              for (var Ae = this._keys.length, Ue = Se + 1; Ue < Ae; Ue++)
                this._keys[Ue - 1] = this._keys[Ue], this._values[Ue - 1] = this._values[Ue];
              return this._keys.length--, this._values.length--, Fa(fe, this._cacheKey) && (this._cacheKey = F, this._cacheIndex = -2), !0;
            }
            return !1;
          }, pe.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = F, this._cacheIndex = -2;
          }, pe.prototype.keys = function() {
            return new $(this._keys, this._values, Qe);
          }, pe.prototype.values = function() {
            return new $(this._keys, this._values, Ur);
          }, pe.prototype.entries = function() {
            return new $(this._keys, this._values, pr);
          }, pe.prototype["@@iterator"] = function() {
            return this.entries();
          }, pe.prototype[o] = function() {
            return this.entries();
          }, pe.prototype._find = function(fe, Se) {
            if (!Fa(this._cacheKey, fe)) {
              this._cacheIndex = -1;
              for (var Ae = 0; Ae < this._keys.length; Ae++)
                if (Fa(this._keys[Ae], fe)) {
                  this._cacheIndex = Ae;
                  break;
                }
            }
            return this._cacheIndex < 0 && Se && (this._cacheIndex = this._keys.length, this._keys.push(fe), this._values.push(void 0)), this._cacheIndex;
          }, pe;
        }()
      );
      return ce;
      function Qe(pe, fe) {
        return pe;
      }
      function Ur(pe, fe) {
        return fe;
      }
      function pr(pe, fe) {
        return [pe, fe];
      }
    }
    function Vi() {
      var F = (
        /** @class */
        function() {
          function V() {
            this._map = new p();
          }
          return Object.defineProperty(V.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), V.prototype.has = function($) {
            return this._map.has($);
          }, V.prototype.add = function($) {
            return this._map.set($, $), this;
          }, V.prototype.delete = function($) {
            return this._map.delete($);
          }, V.prototype.clear = function() {
            this._map.clear();
          }, V.prototype.keys = function() {
            return this._map.keys();
          }, V.prototype.values = function() {
            return this._map.keys();
          }, V.prototype.entries = function() {
            return this._map.entries();
          }, V.prototype["@@iterator"] = function() {
            return this.keys();
          }, V.prototype[o] = function() {
            return this.keys();
          }, V;
        }()
      );
      return F;
    }
    function g0() {
      var F = 16, V = u.create(), $ = ce();
      return (
        /** @class */
        function() {
          function fe() {
            this._key = ce();
          }
          return fe.prototype.has = function(Se) {
            var Ae = Qe(
              Se,
              /*create*/
              !1
            );
            return Ae !== void 0 ? u.has(Ae, this._key) : !1;
          }, fe.prototype.get = function(Se) {
            var Ae = Qe(
              Se,
              /*create*/
              !1
            );
            return Ae !== void 0 ? u.get(Ae, this._key) : void 0;
          }, fe.prototype.set = function(Se, Ae) {
            var Ue = Qe(
              Se,
              /*create*/
              !0
            );
            return Ue[this._key] = Ae, this;
          }, fe.prototype.delete = function(Se) {
            var Ae = Qe(
              Se,
              /*create*/
              !1
            );
            return Ae !== void 0 ? delete Ae[this._key] : !1;
          }, fe.prototype.clear = function() {
            this._key = ce();
          }, fe;
        }()
      );
      function ce() {
        var fe;
        do
          fe = "@@WeakMap@@" + pe();
        while (u.has(V, fe));
        return V[fe] = !0, fe;
      }
      function Qe(fe, Se) {
        if (!n.call(fe, $)) {
          if (!Se)
            return;
          Object.defineProperty(fe, $, { value: u.create() });
        }
        return fe[$];
      }
      function Ur(fe, Se) {
        for (var Ae = 0; Ae < Se; ++Ae)
          fe[Ae] = Math.random() * 255 | 0;
        return fe;
      }
      function pr(fe) {
        if (typeof Uint8Array == "function") {
          var Se = new Uint8Array(fe);
          return typeof crypto < "u" ? crypto.getRandomValues(Se) : typeof msCrypto < "u" ? msCrypto.getRandomValues(Se) : Ur(Se, fe), Se;
        }
        return Ur(new Array(fe), fe);
      }
      function pe() {
        var fe = pr(F);
        fe[6] = fe[6] & 79 | 64, fe[8] = fe[8] & 191 | 128;
        for (var Se = "", Ae = 0; Ae < F; ++Ae) {
          var Ue = fe[Ae];
          (Ae === 4 || Ae === 6 || Ae === 8) && (Se += "-"), Ue < 16 && (Se += "0"), Se += Ue.toString(16).toLowerCase();
        }
        return Se;
      }
    }
    function gh(F) {
      return F.__ = void 0, delete F.__, F;
    }
  });
})(z5 || (z5 = {}));
var wi = "named", Qx = "name", NE = "unmanaged", Fx = "optional", cw = "inject", Wm = "multi_inject", Tx = "inversify:tagged", Rx = "inversify:tagged_props", J_ = "inversify:paramtypes", Ope = "design:paramtypes", q5 = "post_construct", V_ = "pre_destroy";
function jpe() {
  return [
    cw,
    Wm,
    Qx,
    NE,
    wi,
    Fx
  ];
}
var eD = jpe(), br = {
  Request: "Request",
  Singleton: "Singleton",
  Transient: "Transient"
}, qt = {
  ConstantValue: "ConstantValue",
  Constructor: "Constructor",
  DynamicValue: "DynamicValue",
  Factory: "Factory",
  Function: "Function",
  Instance: "Instance",
  Invalid: "Invalid",
  Provider: "Provider"
}, QS = {
  ClassProperty: "ClassProperty",
  ConstructorArgument: "ConstructorArgument",
  Variable: "Variable"
}, Ppe = 0;
function FS() {
  return Ppe++;
}
var $pe = function() {
  function e(t, r) {
    this.id = FS(), this.activated = !1, this.serviceIdentifier = t, this.scope = r, this.type = qt.Invalid, this.constraint = function(n) {
      return !0;
    }, this.implementationType = null, this.cache = null, this.factory = null, this.provider = null, this.onActivation = null, this.onDeactivation = null, this.dynamicValue = null;
  }
  return e.prototype.clone = function() {
    var t = new e(this.serviceIdentifier, this.scope);
    return t.activated = t.scope === br.Singleton ? this.activated : !1, t.implementationType = this.implementationType, t.dynamicValue = this.dynamicValue, t.scope = this.scope, t.type = this.type, t.factory = this.factory, t.provider = this.provider, t.constraint = this.constraint, t.onActivation = this.onActivation, t.onDeactivation = this.onDeactivation, t.cache = this.cache, t;
  }, e;
}(), Kpe = "Cannot apply @injectable decorator multiple times.", Dx = "Metadata key was used more than once in a parameter:", B0 = "NULL argument", tD = "Key Not Found", Xpe = "Ambiguous match found for serviceIdentifier:", zpe = "Could not unbind serviceIdentifier:", qpe = "No matching bindings found for serviceIdentifier:", Jx = "Missing required @injectable annotation in:", ege = "Missing required @inject or @multiInject annotation in:", tge = function(e) {
  return "@inject called with undefined this could mean that the class " + e + " has a circular dependency problem. You can use a LazyServiceIdentifier to  overcome this limitation.";
}, rge = "Circular dependency found:", nge = "Invalid binding type:", age = "No snapshot available to restore.", ige = "Invalid return type in middleware. Middleware must return!", oge = "Value provided to function binding must be a function!", sge = function(e) {
  return "You are attempting to construct '" + e + `' in a synchronous way
 but it has asynchronous dependencies.`;
}, lge = "The toSelf function can only be applied when a constructor is used as service identifier", Vx = "The @inject @multiInject @tagged and @named decorators must be applied to the parameters of a class constructor or a class property.", cge = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return "The number of constructor arguments in the derived class " + (e[0] + " must be >= than the number of constructor arguments of its base class.");
}, dge = "Invalid Container constructor argument. Container options must be an object.", uge = 'Invalid Container option. Default scope must be a string ("singleton" or "transient").', hge = "Invalid Container option. Auto bind injectable must be a boolean", pge = "Invalid Container option. Skip base check must be a boolean", gge = "Attempting to unbind dependency with asynchronous destruction (@preDestroy or onDeactivation)", fge = function(e, t) {
  return "@postConstruct error in class " + e + ": " + t;
}, mge = function(e, t) {
  return "@preDestroy error in class " + e + ": " + t;
}, M_ = function(e, t) {
  return "onDeactivation() error in class " + e + ": " + t;
}, vge = function(e, t) {
  return "It looks like there is a circular dependency in one of the '" + e + "' bindings. Please investigate bindings with " + ("service identifier '" + t + "'.");
}, Sge = "Maximum call stack size exceeded", Ige = function() {
  function e() {
  }
  return e.prototype.getConstructorMetadata = function(t) {
    var r = Reflect.getMetadata(J_, t), n = Reflect.getMetadata(Tx, t);
    return {
      compilerGeneratedMetadata: r,
      userGeneratedMetadata: n || {}
    };
  }, e.prototype.getPropertiesMetadata = function(t) {
    var r = Reflect.getMetadata(Rx, t) || [];
    return r;
  }, e;
}(), NC = {
  MultipleBindingsAvailable: 2,
  NoBindingsAvailable: 0,
  OnlyOneBindingAvailable: 1
};
function Mx(e) {
  return e instanceof RangeError || e.message === Sge;
}
var Cge = function(e, t) {
  try {
    return e();
  } catch (r) {
    throw Mx(r) && (r = t()), r;
  }
};
function Em(e) {
  if (typeof e == "function") {
    var t = e;
    return t.name;
  } else {
    if (typeof e == "symbol")
      return e.toString();
    var t = e;
    return t;
  }
}
function rD(e, t, r) {
  var n = "", a = r(e, t);
  return a.length !== 0 && (n = `
Registered bindings:`, a.forEach(function(i) {
    var o = "Object";
    i.implementationType !== null && (o = dw(i.implementationType)), n = n + `
 ` + o, i.constraint.metaData && (n = n + " - " + i.constraint.metaData);
  })), n;
}
function Gx(e, t) {
  return e.parentRequest === null ? !1 : e.parentRequest.serviceIdentifier === t ? !0 : Gx(e.parentRequest, t);
}
function bge(e) {
  function t(n, a) {
    a === void 0 && (a = []);
    var i = Em(n.serviceIdentifier);
    return a.push(i), n.parentRequest !== null ? t(n.parentRequest, a) : a;
  }
  var r = t(e);
  return r.reverse().join(" --> ");
}
function xx(e) {
  e.childRequests.forEach(function(t) {
    if (Gx(t, t.serviceIdentifier)) {
      var r = bge(t);
      throw new Error(rge + " " + r);
    } else
      xx(t);
  });
}
function yge(e, t) {
  if (t.isTagged() || t.isNamed()) {
    var r = "", n = t.getNamedTag(), a = t.getCustomTags();
    return n !== null && (r += n.toString() + `
`), a !== null && a.forEach(function(i) {
      r += i.toString() + `
`;
    }), " " + e + `
 ` + e + " - " + r;
  } else
    return " " + e;
}
function dw(e) {
  if (e.name)
    return e.name;
  var t = e.toString(), r = t.match(/^function\s*([^\s(]+)/);
  return r ? r[1] : "Anonymous function: " + t;
}
function wge(e) {
  return e.toString().slice(7, -1);
}
var Hx = function() {
  function e(t) {
    this.id = FS(), this.container = t;
  }
  return e.prototype.addPlan = function(t) {
    this.plan = t;
  }, e.prototype.setCurrentRequest = function(t) {
    this.currentRequest = t;
  }, e;
}(), Ru = function() {
  function e(t, r) {
    this.key = t, this.value = r;
  }
  return e.prototype.toString = function() {
    return this.key === wi ? "named: " + String(this.value).toString() + " " : "tagged: { key:" + this.key.toString() + ", value: " + String(this.value) + " }";
  }, e;
}(), Age = /* @__PURE__ */ function() {
  function e(t, r) {
    this.parentContext = t, this.rootRequest = r;
  }
  return e;
}(), Uge = function() {
  function e(t) {
    this._cb = t;
  }
  return e.prototype.unwrap = function() {
    return this._cb();
  }, e;
}(), kge = function() {
  function e(t) {
    this.str = t;
  }
  return e.prototype.startsWith = function(t) {
    return this.str.indexOf(t) === 0;
  }, e.prototype.endsWith = function(t) {
    var r = "", n = t.split("").reverse().join("");
    return r = this.str.split("").reverse().join(""), this.startsWith.call({ str: r }, n);
  }, e.prototype.contains = function(t) {
    return this.str.indexOf(t) !== -1;
  }, e.prototype.equals = function(t) {
    return this.str === t;
  }, e.prototype.value = function() {
    return this.str;
  }, e;
}(), uw = function() {
  function e(t, r, n, a) {
    this.id = FS(), this.type = t, this.serviceIdentifier = n;
    var i = typeof r == "symbol" ? wge(r) : r;
    this.name = new kge(i || ""), this.identifier = r, this.metadata = new Array();
    var o = null;
    typeof a == "string" ? o = new Ru(wi, a) : a instanceof Ru && (o = a), o !== null && this.metadata.push(o);
  }
  return e.prototype.hasTag = function(t) {
    for (var r = 0, n = this.metadata; r < n.length; r++) {
      var a = n[r];
      if (a.key === t)
        return !0;
    }
    return !1;
  }, e.prototype.isArray = function() {
    return this.hasTag(Wm);
  }, e.prototype.matchesArray = function(t) {
    return this.matchesTag(Wm)(t);
  }, e.prototype.isNamed = function() {
    return this.hasTag(wi);
  }, e.prototype.isTagged = function() {
    return this.metadata.some(function(t) {
      return eD.every(function(r) {
        return t.key !== r;
      });
    });
  }, e.prototype.isOptional = function() {
    return this.matchesTag(Fx)(!0);
  }, e.prototype.getNamedTag = function() {
    return this.isNamed() ? this.metadata.filter(function(t) {
      return t.key === wi;
    })[0] : null;
  }, e.prototype.getCustomTags = function() {
    return this.isTagged() ? this.metadata.filter(function(t) {
      return eD.every(function(r) {
        return t.key !== r;
      });
    }) : null;
  }, e.prototype.matchesNamedTag = function(t) {
    return this.matchesTag(wi)(t);
  }, e.prototype.matchesTag = function(t) {
    var r = this;
    return function(n) {
      for (var a = 0, i = r.metadata; a < i.length; a++) {
        var o = i[a];
        if (o.key === t && o.value === n)
          return !0;
      }
      return !1;
    };
  }, e;
}(), H1 = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function _ge(e, t) {
  var r = dw(t);
  return Lx(e, r, t, !1);
}
function Lx(e, t, r, n) {
  var a = e.getConstructorMetadata(r), i = a.compilerGeneratedMetadata;
  if (i === void 0) {
    var o = Jx + " " + t + ".";
    throw new Error(o);
  }
  var s = a.userGeneratedMetadata, c = Object.keys(s), l = r.length === 0 && c.length > 0, u = c.length > r.length, g = l || u ? c.length : r.length, p = Zge(n, t, i, s, g), m = Yx(e, r, t), I = H1(H1([], p, !0), m, !0);
  return I;
}
function Nge(e, t, r, n, a) {
  var i = a[e.toString()] || [], o = jx(i), s = o.unmanaged !== !0, c = n[e], l = o.inject || o.multiInject;
  if (c = l || c, c instanceof Uge && (c = c.unwrap()), s) {
    var u = c === Object, g = c === Function, p = c === void 0, m = u || g || p;
    if (!t && m) {
      var I = ege + " argument " + e + " in class " + r + ".";
      throw new Error(I);
    }
    var C = new uw(QS.ConstructorArgument, o.targetName, c);
    return C.metadata = i, C;
  }
  return null;
}
function Zge(e, t, r, n, a) {
  for (var i = [], o = 0; o < a; o++) {
    var s = o, c = Nge(s, e, t, r, n);
    c !== null && i.push(c);
  }
  return i;
}
function Bge(e, t, r, n) {
  var a = e || t;
  if (a === void 0) {
    var i = Jx + " for property " + String(r) + " in class " + n + ".";
    throw new Error(i);
  }
  return a;
}
function Yx(e, t, r) {
  for (var n = e.getPropertiesMetadata(t), a = [], i = Object.getOwnPropertySymbols(n), o = Object.keys(n), s = o.concat(i), c = 0, l = s; c < l.length; c++) {
    var u = l[c], g = n[u], p = jx(g), m = p.targetName || u, I = Bge(p.inject, p.multiInject, u, r), C = new uw(QS.ClassProperty, m, I);
    C.metadata = g, a.push(C);
  }
  var A = Object.getPrototypeOf(t.prototype).constructor;
  if (A !== Object) {
    var U = Yx(e, A, r);
    a = H1(H1([], a, !0), U, !0);
  }
  return a;
}
function Ox(e, t) {
  var r = Object.getPrototypeOf(t.prototype).constructor;
  if (r !== Object) {
    var n = dw(r), a = Lx(e, n, r, !0), i = a.map(function(c) {
      return c.metadata.filter(function(l) {
        return l.key === NE;
      });
    }), o = [].concat.apply([], i).length, s = a.length - o;
    return s > 0 ? s : Ox(e, r);
  } else
    return 0;
}
function jx(e) {
  var t = {};
  return e.forEach(function(r) {
    t[r.key.toString()] = r.value;
  }), {
    inject: t[cw],
    multiInject: t[Wm],
    targetName: t[Qx],
    unmanaged: t[NE]
  };
}
var ZE = function() {
  function e(t, r, n, a, i) {
    this.id = FS(), this.serviceIdentifier = t, this.parentContext = r, this.parentRequest = n, this.target = i, this.childRequests = [], this.bindings = Array.isArray(a) ? a : [a], this.requestScope = n === null ? /* @__PURE__ */ new Map() : null;
  }
  return e.prototype.addChildRequest = function(t, r, n) {
    var a = new e(t, this.parentContext, this, r, n);
    return this.childRequests.push(a), a;
  }, e;
}();
function L1(e) {
  return e._bindingDictionary;
}
function Wge(e, t, r, n, a, i) {
  var o = e ? Wm : cw, s = new Ru(o, r), c = new uw(t, n, r, s);
  if (a !== void 0) {
    var l = new Ru(a, i);
    c.metadata.push(l);
  }
  return c;
}
function nD(e, t, r, n, a) {
  var i = Qm(r.container, a.serviceIdentifier), o = [];
  return i.length === NC.NoBindingsAvailable && r.container.options.autoBindInjectable && typeof a.serviceIdentifier == "function" && e.getConstructorMetadata(a.serviceIdentifier).compilerGeneratedMetadata && (r.container.bind(a.serviceIdentifier).toSelf(), i = Qm(r.container, a.serviceIdentifier)), t ? o = i : o = i.filter(function(s) {
    var c = new ZE(s.serviceIdentifier, r, n, s, a);
    return s.constraint(c);
  }), Ege(a.serviceIdentifier, o, a, r.container), o;
}
function Ege(e, t, r, n) {
  switch (t.length) {
    case NC.NoBindingsAvailable:
      if (r.isOptional())
        return t;
      var a = Em(e), i = qpe;
      throw i += yge(a, r), i += rD(n, a, Qm), new Error(i);
    case NC.OnlyOneBindingAvailable:
      return t;
    case NC.MultipleBindingsAvailable:
    default:
      if (r.isArray())
        return t;
      var a = Em(e), i = Xpe + " " + a;
      throw i += rD(n, a, Qm), new Error(i);
  }
}
function Px(e, t, r, n, a, i) {
  var o, s;
  if (a === null) {
    o = nD(e, t, n, null, i), s = new ZE(r, n, null, o, i);
    var c = new Age(n, s);
    n.addPlan(c);
  } else
    o = nD(e, t, n, a, i), s = a.addChildRequest(i.serviceIdentifier, o, i);
  o.forEach(function(l) {
    var u = null;
    if (i.isArray())
      u = s.addChildRequest(l.serviceIdentifier, l, i);
    else {
      if (l.cache)
        return;
      u = s;
    }
    if (l.type === qt.Instance && l.implementationType !== null) {
      var g = _ge(e, l.implementationType);
      if (!n.container.options.skipBaseClassChecks) {
        var p = Ox(e, l.implementationType);
        if (g.length < p) {
          var m = cge(dw(l.implementationType));
          throw new Error(m);
        }
      }
      g.forEach(function(I) {
        Px(e, !1, I.serviceIdentifier, n, u, I);
      });
    }
  });
}
function Qm(e, t) {
  var r = [], n = L1(e);
  return n.hasKey(t) ? r = n.get(t) : e.parent !== null && (r = Qm(e.parent, t)), r;
}
function Qge(e, t, r, n, a, i, o, s) {
  s === void 0 && (s = !1);
  var c = new Hx(t), l = Wge(r, n, a, "", i, o);
  try {
    return Px(e, s, a, c, null, l), c;
  } catch (u) {
    throw Mx(u) && xx(c.plan.rootRequest), u;
  }
}
function Fge(e, t, r, n) {
  var a = new uw(QS.Variable, "", t, new Ru(r, n)), i = new Hx(e), o = new ZE(t, i, null, [], a);
  return o;
}
function ga(e) {
  var t = typeof e == "object" && e !== null || typeof e == "function";
  return t && typeof e.then == "function";
}
function $x(e) {
  return ga(e) ? !0 : Array.isArray(e) && e.some(ga);
}
var Tge = function(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (g) {
        o(g);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (g) {
        o(g);
      }
    }
    function l(u) {
      u.done ? i(u.value) : a(u.value).then(s, c);
    }
    l((n = n.apply(e, t || [])).next());
  });
}, Rge = function(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, a && (i = l[0] & 2 ? a.return : l[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, l[1])).done) return i;
      switch (a = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (u) {
      l = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, Dge = function(e, t) {
  return t.scope === br.Singleton && t.activated ? t.cache : t.scope === br.Request && e.has(t.id) ? e.get(t.id) : null;
}, Jge = function(e, t, r) {
  t.scope === br.Singleton && Mge(t, r), t.scope === br.Request && Vge(e, t, r);
}, Vge = function(e, t, r) {
  e.has(t.id) || e.set(t.id, r);
}, Mge = function(e, t) {
  e.cache = t, e.activated = !0, ga(t) && Gge(e, t);
}, Gge = function(e, t) {
  return Tge(void 0, void 0, void 0, function() {
    var r, n;
    return Rge(this, function(a) {
      switch (a.label) {
        case 0:
          return a.trys.push([0, 2, , 3]), [4, t];
        case 1:
          return r = a.sent(), e.cache = r, [3, 3];
        case 2:
          throw n = a.sent(), e.cache = null, e.activated = !1, n;
        case 3:
          return [2];
      }
    });
  });
}, Vf;
(function(e) {
  e.DynamicValue = "toDynamicValue", e.Factory = "toFactory", e.Provider = "toProvider";
})(Vf || (Vf = {}));
var xge = function(e) {
  var t = null;
  switch (e.type) {
    case qt.ConstantValue:
    case qt.Function:
      t = e.cache;
      break;
    case qt.Constructor:
    case qt.Instance:
      t = e.implementationType;
      break;
    case qt.DynamicValue:
      t = e.dynamicValue;
      break;
    case qt.Provider:
      t = e.provider;
      break;
    case qt.Factory:
      t = e.factory;
      break;
  }
  if (t === null) {
    var r = Em(e.serviceIdentifier);
    throw new Error(nge + " " + r);
  }
}, Hge = function(e) {
  switch (e.type) {
    case qt.Factory:
      return { factory: e.factory, factoryType: Vf.Factory };
    case qt.Provider:
      return { factory: e.provider, factoryType: Vf.Provider };
    case qt.DynamicValue:
      return { factory: e.dynamicValue, factoryType: Vf.DynamicValue };
    default:
      throw new Error("Unexpected factory type " + e.type);
  }
}, og = function() {
  return og = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, og.apply(this, arguments);
}, Kx = function(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (g) {
        o(g);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (g) {
        o(g);
      }
    }
    function l(u) {
      u.done ? i(u.value) : a(u.value).then(s, c);
    }
    l((n = n.apply(e, t || [])).next());
  });
}, Xx = function(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, a && (i = l[0] & 2 ? a.return : l[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, l[1])).done) return i;
      switch (a = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (u) {
      l = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, Lge = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function Yge(e, t) {
  return e.reduce(function(r, n) {
    var a = t(n), i = n.target.type;
    return i === QS.ConstructorArgument ? r.constructorInjections.push(a) : (r.propertyRequests.push(n), r.propertyInjections.push(a)), r.isAsync || (r.isAsync = $x(a)), r;
  }, { constructorInjections: [], propertyInjections: [], propertyRequests: [], isAsync: !1 });
}
function Oge(e, t, r) {
  var n;
  if (t.length > 0) {
    var a = Yge(t, r), i = og(og({}, a), { constr: e });
    a.isAsync ? n = jge(i) : n = zx(i);
  } else
    n = new e();
  return n;
}
function zx(e) {
  var t, r = new ((t = e.constr).bind.apply(t, Lge([void 0], e.constructorInjections, !1)))();
  return e.propertyRequests.forEach(function(n, a) {
    var i = n.target.identifier, o = e.propertyInjections[a];
    (!n.target.isOptional() || o !== void 0) && (r[i] = o);
  }), r;
}
function jge(e) {
  return Kx(this, void 0, void 0, function() {
    var t, r;
    return Xx(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, aD(e.constructorInjections)];
        case 1:
          return t = n.sent(), [4, aD(e.propertyInjections)];
        case 2:
          return r = n.sent(), [2, zx(og(og({}, e), { constructorInjections: t, propertyInjections: r }))];
      }
    });
  });
}
function aD(e) {
  return Kx(this, void 0, void 0, function() {
    var t, r, n, a;
    return Xx(this, function(i) {
      for (t = [], r = 0, n = e; r < n.length; r++)
        a = n[r], Array.isArray(a) ? t.push(Promise.all(a)) : t.push(a);
      return [2, Promise.all(t)];
    });
  });
}
function iD(e, t) {
  var r = Pge(e, t);
  return ga(r) ? r.then(function() {
    return t;
  }) : t;
}
function Pge(e, t) {
  var r, n;
  if (Reflect.hasMetadata(q5, e)) {
    var a = Reflect.getMetadata(q5, e);
    try {
      return (n = (r = t)[a.value]) === null || n === void 0 ? void 0 : n.call(r);
    } catch (i) {
      if (i instanceof Error)
        throw new Error(fge(e.name, i.message));
    }
  }
}
function $ge(e, t) {
  e.scope !== br.Singleton && Kge(e, t);
}
function Kge(e, t) {
  var r = "Class cannot be instantiated in " + (e.scope === br.Request ? "request" : "transient") + " scope.";
  if (typeof e.onDeactivation == "function")
    throw new Error(M_(t.name, r));
  if (Reflect.hasMetadata(V_, t))
    throw new Error(mge(t.name, r));
}
function Xge(e, t, r, n) {
  $ge(e, t);
  var a = Oge(t, r, n);
  return ga(a) ? a.then(function(i) {
    return iD(t, i);
  }) : iD(t, a);
}
var zge = function(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (g) {
        o(g);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (g) {
        o(g);
      }
    }
    function l(u) {
      u.done ? i(u.value) : a(u.value).then(s, c);
    }
    l((n = n.apply(e, t || [])).next());
  });
}, qge = function(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, a && (i = l[0] & 2 ? a.return : l[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, l[1])).done) return i;
      switch (a = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (u) {
      l = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, BE = function(e) {
  return function(t) {
    t.parentContext.setCurrentRequest(t);
    var r = t.bindings, n = t.childRequests, a = t.target && t.target.isArray(), i = !t.parentRequest || !t.parentRequest.target || !t.target || !t.parentRequest.target.matchesArray(t.target.serviceIdentifier);
    if (a && i)
      return n.map(function(s) {
        var c = BE(e);
        return c(s);
      });
    if (t.target.isOptional() && r.length === 0)
      return;
    var o = r[0];
    return n0e(e, t, o);
  };
}, e0e = function(e, t) {
  var r = Hge(e);
  return Cge(function() {
    return r.factory.bind(e)(t);
  }, function() {
    return new Error(vge(r.factoryType, t.currentRequest.serviceIdentifier.toString()));
  });
}, t0e = function(e, t, r) {
  var n, a = t.childRequests;
  switch (xge(r), r.type) {
    case qt.ConstantValue:
    case qt.Function:
      n = r.cache;
      break;
    case qt.Constructor:
      n = r.implementationType;
      break;
    case qt.Instance:
      n = Xge(r, r.implementationType, a, BE(e));
      break;
    default:
      n = e0e(r, t.parentContext);
  }
  return n;
}, r0e = function(e, t, r) {
  var n = Dge(e, t);
  return n !== null || (n = r(), Jge(e, t, n)), n;
}, n0e = function(e, t, r) {
  return r0e(e, r, function() {
    var n = t0e(e, t, r);
    return ga(n) ? n = n.then(function(a) {
      return oD(t, r, a);
    }) : n = oD(t, r, n), n;
  });
};
function oD(e, t, r) {
  var n = a0e(e.parentContext, t, r), a = s0e(e.parentContext.container), i, o = a.next();
  do {
    i = o.value;
    var s = e.parentContext, c = e.serviceIdentifier, l = o0e(i, c);
    ga(n) ? n = qx(l, s, n) : n = i0e(l, s, n), o = a.next();
  } while (o.done !== !0 && !L1(i).hasKey(e.serviceIdentifier));
  return n;
}
var a0e = function(e, t, r) {
  var n;
  return typeof t.onActivation == "function" ? n = t.onActivation(e, r) : n = r, n;
}, i0e = function(e, t, r) {
  for (var n = e.next(); !n.done; ) {
    if (r = n.value(t, r), ga(r))
      return qx(e, t, r);
    n = e.next();
  }
  return r;
}, qx = function(e, t, r) {
  return zge(void 0, void 0, void 0, function() {
    var n, a;
    return qge(this, function(i) {
      switch (i.label) {
        case 0:
          return [4, r];
        case 1:
          n = i.sent(), a = e.next(), i.label = 2;
        case 2:
          return a.done ? [3, 4] : [4, a.value(t, n)];
        case 3:
          return n = i.sent(), a = e.next(), [3, 2];
        case 4:
          return [2, n];
      }
    });
  });
}, o0e = function(e, t) {
  var r = e._activations;
  return r.hasKey(t) ? r.get(t).values() : [].values();
}, s0e = function(e) {
  for (var t = [e], r = e.parent; r !== null; )
    t.push(r), r = r.parent;
  var n = function() {
    var i = t.pop();
    return i !== void 0 ? { done: !1, value: i } : { done: !0, value: void 0 };
  }, a = {
    next: n
  };
  return a;
};
function l0e(e) {
  var t = BE(e.plan.rootRequest.requestScope);
  return t(e.plan.rootRequest);
}
var Es = function(e, t) {
  var r = e.parentRequest;
  return r !== null ? t(r) ? !0 : Es(r, t) : !1;
}, tf = function(e) {
  return function(t) {
    var r = function(n) {
      return n !== null && n.target !== null && n.target.matchesTag(e)(t);
    };
    return r.metaData = new Ru(e, t), r;
  };
}, TI = tf(wi), vU = function(e) {
  return function(t) {
    var r = null;
    if (t !== null)
      if (r = t.bindings[0], typeof e == "string") {
        var n = r.serviceIdentifier;
        return n === e;
      } else {
        var a = t.bindings[0].implementationType;
        return e === a;
      }
    return !1;
  };
}, Y1 = function() {
  function e(t) {
    this._binding = t;
  }
  return e.prototype.when = function(t) {
    return this._binding.constraint = t, new sn(this._binding);
  }, e.prototype.whenTargetNamed = function(t) {
    return this._binding.constraint = TI(t), new sn(this._binding);
  }, e.prototype.whenTargetIsDefault = function() {
    return this._binding.constraint = function(t) {
      if (t === null)
        return !1;
      var r = t.target !== null && !t.target.isNamed() && !t.target.isTagged();
      return r;
    }, new sn(this._binding);
  }, e.prototype.whenTargetTagged = function(t, r) {
    return this._binding.constraint = tf(t)(r), new sn(this._binding);
  }, e.prototype.whenInjectedInto = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && vU(t)(r.parentRequest);
    }, new sn(this._binding);
  }, e.prototype.whenParentNamed = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && TI(t)(r.parentRequest);
    }, new sn(this._binding);
  }, e.prototype.whenParentTagged = function(t, r) {
    return this._binding.constraint = function(n) {
      return n !== null && tf(t)(r)(n.parentRequest);
    }, new sn(this._binding);
  }, e.prototype.whenAnyAncestorIs = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && Es(r, vU(t));
    }, new sn(this._binding);
  }, e.prototype.whenNoAncestorIs = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && !Es(r, vU(t));
    }, new sn(this._binding);
  }, e.prototype.whenAnyAncestorNamed = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && Es(r, TI(t));
    }, new sn(this._binding);
  }, e.prototype.whenNoAncestorNamed = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && !Es(r, TI(t));
    }, new sn(this._binding);
  }, e.prototype.whenAnyAncestorTagged = function(t, r) {
    return this._binding.constraint = function(n) {
      return n !== null && Es(n, tf(t)(r));
    }, new sn(this._binding);
  }, e.prototype.whenNoAncestorTagged = function(t, r) {
    return this._binding.constraint = function(n) {
      return n !== null && !Es(n, tf(t)(r));
    }, new sn(this._binding);
  }, e.prototype.whenAnyAncestorMatches = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && Es(r, t);
    }, new sn(this._binding);
  }, e.prototype.whenNoAncestorMatches = function(t) {
    return this._binding.constraint = function(r) {
      return r !== null && !Es(r, t);
    }, new sn(this._binding);
  }, e;
}(), sn = function() {
  function e(t) {
    this._binding = t;
  }
  return e.prototype.onActivation = function(t) {
    return this._binding.onActivation = t, new Y1(this._binding);
  }, e.prototype.onDeactivation = function(t) {
    return this._binding.onDeactivation = t, new Y1(this._binding);
  }, e;
}(), Vs = function() {
  function e(t) {
    this._binding = t, this._bindingWhenSyntax = new Y1(this._binding), this._bindingOnSyntax = new sn(this._binding);
  }
  return e.prototype.when = function(t) {
    return this._bindingWhenSyntax.when(t);
  }, e.prototype.whenTargetNamed = function(t) {
    return this._bindingWhenSyntax.whenTargetNamed(t);
  }, e.prototype.whenTargetIsDefault = function() {
    return this._bindingWhenSyntax.whenTargetIsDefault();
  }, e.prototype.whenTargetTagged = function(t, r) {
    return this._bindingWhenSyntax.whenTargetTagged(t, r);
  }, e.prototype.whenInjectedInto = function(t) {
    return this._bindingWhenSyntax.whenInjectedInto(t);
  }, e.prototype.whenParentNamed = function(t) {
    return this._bindingWhenSyntax.whenParentNamed(t);
  }, e.prototype.whenParentTagged = function(t, r) {
    return this._bindingWhenSyntax.whenParentTagged(t, r);
  }, e.prototype.whenAnyAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorIs(t);
  }, e.prototype.whenNoAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorIs(t);
  }, e.prototype.whenAnyAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorNamed(t);
  }, e.prototype.whenAnyAncestorTagged = function(t, r) {
    return this._bindingWhenSyntax.whenAnyAncestorTagged(t, r);
  }, e.prototype.whenNoAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorNamed(t);
  }, e.prototype.whenNoAncestorTagged = function(t, r) {
    return this._bindingWhenSyntax.whenNoAncestorTagged(t, r);
  }, e.prototype.whenAnyAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorMatches(t);
  }, e.prototype.whenNoAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorMatches(t);
  }, e.prototype.onActivation = function(t) {
    return this._bindingOnSyntax.onActivation(t);
  }, e.prototype.onDeactivation = function(t) {
    return this._bindingOnSyntax.onDeactivation(t);
  }, e;
}(), c0e = function() {
  function e(t) {
    this._binding = t;
  }
  return e.prototype.inRequestScope = function() {
    return this._binding.scope = br.Request, new Vs(this._binding);
  }, e.prototype.inSingletonScope = function() {
    return this._binding.scope = br.Singleton, new Vs(this._binding);
  }, e.prototype.inTransientScope = function() {
    return this._binding.scope = br.Transient, new Vs(this._binding);
  }, e;
}(), sD = function() {
  function e(t) {
    this._binding = t, this._bindingWhenSyntax = new Y1(this._binding), this._bindingOnSyntax = new sn(this._binding), this._bindingInSyntax = new c0e(t);
  }
  return e.prototype.inRequestScope = function() {
    return this._bindingInSyntax.inRequestScope();
  }, e.prototype.inSingletonScope = function() {
    return this._bindingInSyntax.inSingletonScope();
  }, e.prototype.inTransientScope = function() {
    return this._bindingInSyntax.inTransientScope();
  }, e.prototype.when = function(t) {
    return this._bindingWhenSyntax.when(t);
  }, e.prototype.whenTargetNamed = function(t) {
    return this._bindingWhenSyntax.whenTargetNamed(t);
  }, e.prototype.whenTargetIsDefault = function() {
    return this._bindingWhenSyntax.whenTargetIsDefault();
  }, e.prototype.whenTargetTagged = function(t, r) {
    return this._bindingWhenSyntax.whenTargetTagged(t, r);
  }, e.prototype.whenInjectedInto = function(t) {
    return this._bindingWhenSyntax.whenInjectedInto(t);
  }, e.prototype.whenParentNamed = function(t) {
    return this._bindingWhenSyntax.whenParentNamed(t);
  }, e.prototype.whenParentTagged = function(t, r) {
    return this._bindingWhenSyntax.whenParentTagged(t, r);
  }, e.prototype.whenAnyAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorIs(t);
  }, e.prototype.whenNoAncestorIs = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorIs(t);
  }, e.prototype.whenAnyAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorNamed(t);
  }, e.prototype.whenAnyAncestorTagged = function(t, r) {
    return this._bindingWhenSyntax.whenAnyAncestorTagged(t, r);
  }, e.prototype.whenNoAncestorNamed = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorNamed(t);
  }, e.prototype.whenNoAncestorTagged = function(t, r) {
    return this._bindingWhenSyntax.whenNoAncestorTagged(t, r);
  }, e.prototype.whenAnyAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenAnyAncestorMatches(t);
  }, e.prototype.whenNoAncestorMatches = function(t) {
    return this._bindingWhenSyntax.whenNoAncestorMatches(t);
  }, e.prototype.onActivation = function(t) {
    return this._bindingOnSyntax.onActivation(t);
  }, e.prototype.onDeactivation = function(t) {
    return this._bindingOnSyntax.onDeactivation(t);
  }, e;
}(), d0e = function() {
  function e(t) {
    this._binding = t;
  }
  return e.prototype.to = function(t) {
    return this._binding.type = qt.Instance, this._binding.implementationType = t, new sD(this._binding);
  }, e.prototype.toSelf = function() {
    if (typeof this._binding.serviceIdentifier != "function")
      throw new Error("" + lge);
    var t = this._binding.serviceIdentifier;
    return this.to(t);
  }, e.prototype.toConstantValue = function(t) {
    return this._binding.type = qt.ConstantValue, this._binding.cache = t, this._binding.dynamicValue = null, this._binding.implementationType = null, this._binding.scope = br.Singleton, new Vs(this._binding);
  }, e.prototype.toDynamicValue = function(t) {
    return this._binding.type = qt.DynamicValue, this._binding.cache = null, this._binding.dynamicValue = t, this._binding.implementationType = null, new sD(this._binding);
  }, e.prototype.toConstructor = function(t) {
    return this._binding.type = qt.Constructor, this._binding.implementationType = t, this._binding.scope = br.Singleton, new Vs(this._binding);
  }, e.prototype.toFactory = function(t) {
    return this._binding.type = qt.Factory, this._binding.factory = t, this._binding.scope = br.Singleton, new Vs(this._binding);
  }, e.prototype.toFunction = function(t) {
    if (typeof t != "function")
      throw new Error(oge);
    var r = this.toConstantValue(t);
    return this._binding.type = qt.Function, this._binding.scope = br.Singleton, r;
  }, e.prototype.toAutoFactory = function(t) {
    return this._binding.type = qt.Factory, this._binding.factory = function(r) {
      var n = function() {
        return r.container.get(t);
      };
      return n;
    }, this._binding.scope = br.Singleton, new Vs(this._binding);
  }, e.prototype.toAutoNamedFactory = function(t) {
    return this._binding.type = qt.Factory, this._binding.factory = function(r) {
      return function(n) {
        return r.container.getNamed(t, n);
      };
    }, new Vs(this._binding);
  }, e.prototype.toProvider = function(t) {
    return this._binding.type = qt.Provider, this._binding.provider = t, this._binding.scope = br.Singleton, new Vs(this._binding);
  }, e.prototype.toService = function(t) {
    this.toDynamicValue(function(r) {
      return r.container.get(t);
    });
  }, e;
}(), u0e = function() {
  function e() {
  }
  return e.of = function(t, r, n, a, i) {
    var o = new e();
    return o.bindings = t, o.middleware = r, o.deactivations = a, o.activations = n, o.moduleActivationStore = i, o;
  }, e;
}();
function h0e(e) {
  return typeof e == "object" && e !== null && "clone" in e && typeof e.clone == "function";
}
var Vd = function() {
  function e() {
    this._map = /* @__PURE__ */ new Map();
  }
  return e.prototype.getMap = function() {
    return this._map;
  }, e.prototype.add = function(t, r) {
    if (t == null)
      throw new Error(B0);
    if (r == null)
      throw new Error(B0);
    var n = this._map.get(t);
    n !== void 0 ? n.push(r) : this._map.set(t, [r]);
  }, e.prototype.get = function(t) {
    if (t == null)
      throw new Error(B0);
    var r = this._map.get(t);
    if (r !== void 0)
      return r;
    throw new Error(tD);
  }, e.prototype.remove = function(t) {
    if (t == null)
      throw new Error(B0);
    if (!this._map.delete(t))
      throw new Error(tD);
  }, e.prototype.removeIntersection = function(t) {
    var r = this;
    this.traverse(function(n, a) {
      var i = t.hasKey(n) ? t.get(n) : void 0;
      if (i !== void 0) {
        var o = a.filter(function(s) {
          return !i.some(function(c) {
            return s === c;
          });
        });
        r._setValue(n, o);
      }
    });
  }, e.prototype.removeByCondition = function(t) {
    var r = this, n = [];
    return this._map.forEach(function(a, i) {
      for (var o = [], s = 0, c = a; s < c.length; s++) {
        var l = c[s], u = t(l);
        u ? n.push(l) : o.push(l);
      }
      r._setValue(i, o);
    }), n;
  }, e.prototype.hasKey = function(t) {
    if (t == null)
      throw new Error(B0);
    return this._map.has(t);
  }, e.prototype.clone = function() {
    var t = new e();
    return this._map.forEach(function(r, n) {
      r.forEach(function(a) {
        return t.add(n, h0e(a) ? a.clone() : a);
      });
    }), t;
  }, e.prototype.traverse = function(t) {
    this._map.forEach(function(r, n) {
      t(n, r);
    });
  }, e.prototype._setValue = function(t, r) {
    r.length > 0 ? this._map.set(t, r) : this._map.delete(t);
  }, e;
}(), p0e = function() {
  function e() {
    this._map = /* @__PURE__ */ new Map();
  }
  return e.prototype.remove = function(t) {
    if (this._map.has(t)) {
      var r = this._map.get(t);
      return this._map.delete(t), r;
    }
    return this._getEmptyHandlersStore();
  }, e.prototype.addDeactivation = function(t, r, n) {
    this._getModuleActivationHandlers(t).onDeactivations.add(r, n);
  }, e.prototype.addActivation = function(t, r, n) {
    this._getModuleActivationHandlers(t).onActivations.add(r, n);
  }, e.prototype.clone = function() {
    var t = new e();
    return this._map.forEach(function(r, n) {
      t._map.set(n, {
        onActivations: r.onActivations.clone(),
        onDeactivations: r.onDeactivations.clone()
      });
    }), t;
  }, e.prototype._getModuleActivationHandlers = function(t) {
    var r = this._map.get(t);
    return r === void 0 && (r = this._getEmptyHandlersStore(), this._map.set(t, r)), r;
  }, e.prototype._getEmptyHandlersStore = function() {
    var t = {
      onActivations: new Vd(),
      onDeactivations: new Vd()
    };
    return t;
  }, e;
}(), O1 = function() {
  return O1 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, O1.apply(this, arguments);
}, li = function(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(o) {
      o(i);
    });
  }
  return new (r || (r = Promise))(function(i, o) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (g) {
        o(g);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (g) {
        o(g);
      }
    }
    function l(u) {
      u.done ? i(u.value) : a(u.value).then(s, c);
    }
    l((n = n.apply(e, t || [])).next());
  });
}, ci = function(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, a && (i = l[0] & 2 ? a.return : l[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, l[1])).done) return i;
      switch (a = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (u) {
      l = [6, u], a = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, g0e = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, eH = function() {
  function e(t) {
    var r = t || {};
    if (typeof r != "object")
      throw new Error("" + dge);
    if (r.defaultScope === void 0)
      r.defaultScope = br.Transient;
    else if (r.defaultScope !== br.Singleton && r.defaultScope !== br.Transient && r.defaultScope !== br.Request)
      throw new Error("" + uge);
    if (r.autoBindInjectable === void 0)
      r.autoBindInjectable = !1;
    else if (typeof r.autoBindInjectable != "boolean")
      throw new Error("" + hge);
    if (r.skipBaseClassChecks === void 0)
      r.skipBaseClassChecks = !1;
    else if (typeof r.skipBaseClassChecks != "boolean")
      throw new Error("" + pge);
    this.options = {
      autoBindInjectable: r.autoBindInjectable,
      defaultScope: r.defaultScope,
      skipBaseClassChecks: r.skipBaseClassChecks
    }, this.id = FS(), this._bindingDictionary = new Vd(), this._snapshots = [], this._middleware = null, this._activations = new Vd(), this._deactivations = new Vd(), this.parent = null, this._metadataReader = new Ige(), this._moduleActivationStore = new p0e();
  }
  return e.merge = function(t, r) {
    for (var n = [], a = 2; a < arguments.length; a++)
      n[a - 2] = arguments[a];
    var i = new e(), o = g0e([t, r], n, !0).map(function(l) {
      return L1(l);
    }), s = L1(i);
    function c(l, u) {
      l.traverse(function(g, p) {
        p.forEach(function(m) {
          u.add(m.serviceIdentifier, m.clone());
        });
      });
    }
    return o.forEach(function(l) {
      c(l, s);
    }), i;
  }, e.prototype.load = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var n = this._getContainerModuleHelpersFactory(), a = 0, i = t; a < i.length; a++) {
      var o = i[a], s = n(o.id);
      o.registry(s.bindFunction, s.unbindFunction, s.isboundFunction, s.rebindFunction, s.unbindAsyncFunction, s.onActivationFunction, s.onDeactivationFunction);
    }
  }, e.prototype.loadAsync = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return li(this, void 0, void 0, function() {
      var n, a, i, o, s;
      return ci(this, function(c) {
        switch (c.label) {
          case 0:
            n = this._getContainerModuleHelpersFactory(), a = 0, i = t, c.label = 1;
          case 1:
            return a < i.length ? (o = i[a], s = n(o.id), [4, o.registry(s.bindFunction, s.unbindFunction, s.isboundFunction, s.rebindFunction, s.unbindAsyncFunction, s.onActivationFunction, s.onDeactivationFunction)]) : [3, 4];
          case 2:
            c.sent(), c.label = 3;
          case 3:
            return a++, [3, 1];
          case 4:
            return [2];
        }
      });
    });
  }, e.prototype.unload = function() {
    for (var t = this, r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    r.forEach(function(a) {
      var i = t._removeModuleBindings(a.id);
      t._deactivateSingletons(i), t._removeModuleHandlers(a.id);
    });
  }, e.prototype.unloadAsync = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return li(this, void 0, void 0, function() {
      var n, a, i, o;
      return ci(this, function(s) {
        switch (s.label) {
          case 0:
            n = 0, a = t, s.label = 1;
          case 1:
            return n < a.length ? (i = a[n], o = this._removeModuleBindings(i.id), [4, this._deactivateSingletonsAsync(o)]) : [3, 4];
          case 2:
            s.sent(), this._removeModuleHandlers(i.id), s.label = 3;
          case 3:
            return n++, [3, 1];
          case 4:
            return [2];
        }
      });
    });
  }, e.prototype.bind = function(t) {
    var r = this.options.defaultScope || br.Transient, n = new $pe(t, r);
    return this._bindingDictionary.add(t, n), new d0e(n);
  }, e.prototype.rebind = function(t) {
    return this.unbind(t), this.bind(t);
  }, e.prototype.rebindAsync = function(t) {
    return li(this, void 0, void 0, function() {
      return ci(this, function(r) {
        switch (r.label) {
          case 0:
            return [4, this.unbindAsync(t)];
          case 1:
            return r.sent(), [2, this.bind(t)];
        }
      });
    });
  }, e.prototype.unbind = function(t) {
    if (this._bindingDictionary.hasKey(t)) {
      var r = this._bindingDictionary.get(t);
      this._deactivateSingletons(r);
    }
    this._removeServiceFromDictionary(t);
  }, e.prototype.unbindAsync = function(t) {
    return li(this, void 0, void 0, function() {
      var r;
      return ci(this, function(n) {
        switch (n.label) {
          case 0:
            return this._bindingDictionary.hasKey(t) ? (r = this._bindingDictionary.get(t), [4, this._deactivateSingletonsAsync(r)]) : [3, 2];
          case 1:
            n.sent(), n.label = 2;
          case 2:
            return this._removeServiceFromDictionary(t), [2];
        }
      });
    });
  }, e.prototype.unbindAll = function() {
    var t = this;
    this._bindingDictionary.traverse(function(r, n) {
      t._deactivateSingletons(n);
    }), this._bindingDictionary = new Vd();
  }, e.prototype.unbindAllAsync = function() {
    return li(this, void 0, void 0, function() {
      var t, r = this;
      return ci(this, function(n) {
        switch (n.label) {
          case 0:
            return t = [], this._bindingDictionary.traverse(function(a, i) {
              t.push(r._deactivateSingletonsAsync(i));
            }), [4, Promise.all(t)];
          case 1:
            return n.sent(), this._bindingDictionary = new Vd(), [2];
        }
      });
    });
  }, e.prototype.onActivation = function(t, r) {
    this._activations.add(t, r);
  }, e.prototype.onDeactivation = function(t, r) {
    this._deactivations.add(t, r);
  }, e.prototype.isBound = function(t) {
    var r = this._bindingDictionary.hasKey(t);
    return !r && this.parent && (r = this.parent.isBound(t)), r;
  }, e.prototype.isCurrentBound = function(t) {
    return this._bindingDictionary.hasKey(t);
  }, e.prototype.isBoundNamed = function(t, r) {
    return this.isBoundTagged(t, wi, r);
  }, e.prototype.isBoundTagged = function(t, r, n) {
    var a = !1;
    if (this._bindingDictionary.hasKey(t)) {
      var i = this._bindingDictionary.get(t), o = Fge(this, t, r, n);
      a = i.some(function(s) {
        return s.constraint(o);
      });
    }
    return !a && this.parent && (a = this.parent.isBoundTagged(t, r, n)), a;
  }, e.prototype.snapshot = function() {
    this._snapshots.push(u0e.of(this._bindingDictionary.clone(), this._middleware, this._activations.clone(), this._deactivations.clone(), this._moduleActivationStore.clone()));
  }, e.prototype.restore = function() {
    var t = this._snapshots.pop();
    if (t === void 0)
      throw new Error(age);
    this._bindingDictionary = t.bindings, this._activations = t.activations, this._deactivations = t.deactivations, this._middleware = t.middleware, this._moduleActivationStore = t.moduleActivationStore;
  }, e.prototype.createChild = function(t) {
    var r = new e(t || this.options);
    return r.parent = this, r;
  }, e.prototype.applyMiddleware = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    var n = this._middleware ? this._middleware : this._planAndResolve();
    this._middleware = t.reduce(function(a, i) {
      return i(a);
    }, n);
  }, e.prototype.applyCustomMetadataReader = function(t) {
    this._metadataReader = t;
  }, e.prototype.get = function(t) {
    var r = this._getNotAllArgs(t, !1);
    return this._getButThrowIfAsync(r);
  }, e.prototype.getAsync = function(t) {
    return li(this, void 0, void 0, function() {
      var r;
      return ci(this, function(n) {
        return r = this._getNotAllArgs(t, !1), [2, this._get(r)];
      });
    });
  }, e.prototype.getTagged = function(t, r, n) {
    var a = this._getNotAllArgs(t, !1, r, n);
    return this._getButThrowIfAsync(a);
  }, e.prototype.getTaggedAsync = function(t, r, n) {
    return li(this, void 0, void 0, function() {
      var a;
      return ci(this, function(i) {
        return a = this._getNotAllArgs(t, !1, r, n), [2, this._get(a)];
      });
    });
  }, e.prototype.getNamed = function(t, r) {
    return this.getTagged(t, wi, r);
  }, e.prototype.getNamedAsync = function(t, r) {
    return this.getTaggedAsync(t, wi, r);
  }, e.prototype.getAll = function(t) {
    var r = this._getAllArgs(t);
    return this._getButThrowIfAsync(r);
  }, e.prototype.getAllAsync = function(t) {
    var r = this._getAllArgs(t);
    return this._getAll(r);
  }, e.prototype.getAllTagged = function(t, r, n) {
    var a = this._getNotAllArgs(t, !0, r, n);
    return this._getButThrowIfAsync(a);
  }, e.prototype.getAllTaggedAsync = function(t, r, n) {
    var a = this._getNotAllArgs(t, !0, r, n);
    return this._getAll(a);
  }, e.prototype.getAllNamed = function(t, r) {
    return this.getAllTagged(t, wi, r);
  }, e.prototype.getAllNamedAsync = function(t, r) {
    return this.getAllTaggedAsync(t, wi, r);
  }, e.prototype.resolve = function(t) {
    var r = this.isBound(t);
    r || this.bind(t).toSelf();
    var n = this.get(t);
    return r || this.unbind(t), n;
  }, e.prototype._preDestroy = function(t, r) {
    var n, a;
    if (Reflect.hasMetadata(V_, t)) {
      var i = Reflect.getMetadata(V_, t);
      return (a = (n = r)[i.value]) === null || a === void 0 ? void 0 : a.call(n);
    }
  }, e.prototype._removeModuleHandlers = function(t) {
    var r = this._moduleActivationStore.remove(t);
    this._activations.removeIntersection(r.onActivations), this._deactivations.removeIntersection(r.onDeactivations);
  }, e.prototype._removeModuleBindings = function(t) {
    return this._bindingDictionary.removeByCondition(function(r) {
      return r.moduleId === t;
    });
  }, e.prototype._deactivate = function(t, r) {
    var n = this, a = Object.getPrototypeOf(r).constructor;
    try {
      if (this._deactivations.hasKey(t.serviceIdentifier)) {
        var i = this._deactivateContainer(r, this._deactivations.get(t.serviceIdentifier).values());
        if (ga(i))
          return this._handleDeactivationError(i.then(function() {
            return n._propagateContainerDeactivationThenBindingAndPreDestroyAsync(t, r, a);
          }), a);
      }
      var o = this._propagateContainerDeactivationThenBindingAndPreDestroy(t, r, a);
      if (ga(o))
        return this._handleDeactivationError(o, a);
    } catch (s) {
      if (s instanceof Error)
        throw new Error(M_(a.name, s.message));
    }
  }, e.prototype._handleDeactivationError = function(t, r) {
    return li(this, void 0, void 0, function() {
      var n;
      return ci(this, function(a) {
        switch (a.label) {
          case 0:
            return a.trys.push([0, 2, , 3]), [4, t];
          case 1:
            return a.sent(), [3, 3];
          case 2:
            if (n = a.sent(), n instanceof Error)
              throw new Error(M_(r.name, n.message));
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  }, e.prototype._deactivateContainer = function(t, r) {
    for (var n = this, a = r.next(); a.value; ) {
      var i = a.value(t);
      if (ga(i))
        return i.then(function() {
          return n._deactivateContainerAsync(t, r);
        });
      a = r.next();
    }
  }, e.prototype._deactivateContainerAsync = function(t, r) {
    return li(this, void 0, void 0, function() {
      var n;
      return ci(this, function(a) {
        switch (a.label) {
          case 0:
            n = r.next(), a.label = 1;
          case 1:
            return n.value ? [4, n.value(t)] : [3, 3];
          case 2:
            return a.sent(), n = r.next(), [3, 1];
          case 3:
            return [2];
        }
      });
    });
  }, e.prototype._getContainerModuleHelpersFactory = function() {
    var t = this, r = function(u, g) {
      u._binding.moduleId = g;
    }, n = function(u) {
      return function(g) {
        var p = t.bind(g);
        return r(p, u), p;
      };
    }, a = function() {
      return function(u) {
        return t.unbind(u);
      };
    }, i = function() {
      return function(u) {
        return t.unbindAsync(u);
      };
    }, o = function() {
      return function(u) {
        return t.isBound(u);
      };
    }, s = function(u) {
      return function(g) {
        var p = t.rebind(g);
        return r(p, u), p;
      };
    }, c = function(u) {
      return function(g, p) {
        t._moduleActivationStore.addActivation(u, g, p), t.onActivation(g, p);
      };
    }, l = function(u) {
      return function(g, p) {
        t._moduleActivationStore.addDeactivation(u, g, p), t.onDeactivation(g, p);
      };
    };
    return function(u) {
      return {
        bindFunction: n(u),
        isboundFunction: o(),
        onActivationFunction: c(u),
        onDeactivationFunction: l(u),
        rebindFunction: s(u),
        unbindFunction: a(),
        unbindAsyncFunction: i()
      };
    };
  }, e.prototype._getAll = function(t) {
    return Promise.all(this._get(t));
  }, e.prototype._get = function(t) {
    var r = O1(O1({}, t), { contextInterceptor: function(a) {
      return a;
    }, targetType: QS.Variable });
    if (this._middleware) {
      var n = this._middleware(r);
      if (n == null)
        throw new Error(ige);
      return n;
    }
    return this._planAndResolve()(r);
  }, e.prototype._getButThrowIfAsync = function(t) {
    var r = this._get(t);
    if ($x(r))
      throw new Error(sge(t.serviceIdentifier));
    return r;
  }, e.prototype._getAllArgs = function(t) {
    var r = {
      avoidConstraints: !0,
      isMultiInject: !0,
      serviceIdentifier: t
    };
    return r;
  }, e.prototype._getNotAllArgs = function(t, r, n, a) {
    var i = {
      avoidConstraints: !1,
      isMultiInject: r,
      serviceIdentifier: t,
      key: n,
      value: a
    };
    return i;
  }, e.prototype._planAndResolve = function() {
    var t = this;
    return function(r) {
      var n = Qge(t._metadataReader, t, r.isMultiInject, r.targetType, r.serviceIdentifier, r.key, r.value, r.avoidConstraints);
      n = r.contextInterceptor(n);
      var a = l0e(n);
      return a;
    };
  }, e.prototype._deactivateIfSingleton = function(t) {
    var r = this;
    if (t.activated)
      return ga(t.cache) ? t.cache.then(function(n) {
        return r._deactivate(t, n);
      }) : this._deactivate(t, t.cache);
  }, e.prototype._deactivateSingletons = function(t) {
    for (var r = 0, n = t; r < n.length; r++) {
      var a = n[r], i = this._deactivateIfSingleton(a);
      if (ga(i))
        throw new Error(gge);
    }
  }, e.prototype._deactivateSingletonsAsync = function(t) {
    return li(this, void 0, void 0, function() {
      var r = this;
      return ci(this, function(n) {
        switch (n.label) {
          case 0:
            return [4, Promise.all(t.map(function(a) {
              return r._deactivateIfSingleton(a);
            }))];
          case 1:
            return n.sent(), [2];
        }
      });
    });
  }, e.prototype._propagateContainerDeactivationThenBindingAndPreDestroy = function(t, r, n) {
    return this.parent ? this._deactivate.bind(this.parent)(t, r) : this._bindingDeactivationAndPreDestroy(t, r, n);
  }, e.prototype._propagateContainerDeactivationThenBindingAndPreDestroyAsync = function(t, r, n) {
    return li(this, void 0, void 0, function() {
      return ci(this, function(a) {
        switch (a.label) {
          case 0:
            return this.parent ? [4, this._deactivate.bind(this.parent)(t, r)] : [3, 2];
          case 1:
            return a.sent(), [3, 4];
          case 2:
            return [4, this._bindingDeactivationAndPreDestroyAsync(t, r, n)];
          case 3:
            a.sent(), a.label = 4;
          case 4:
            return [2];
        }
      });
    });
  }, e.prototype._removeServiceFromDictionary = function(t) {
    try {
      this._bindingDictionary.remove(t);
    } catch {
      throw new Error(zpe + " " + Em(t));
    }
  }, e.prototype._bindingDeactivationAndPreDestroy = function(t, r, n) {
    var a = this;
    if (typeof t.onDeactivation == "function") {
      var i = t.onDeactivation(r);
      if (ga(i))
        return i.then(function() {
          return a._preDestroy(n, r);
        });
    }
    return this._preDestroy(n, r);
  }, e.prototype._bindingDeactivationAndPreDestroyAsync = function(t, r, n) {
    return li(this, void 0, void 0, function() {
      return ci(this, function(a) {
        switch (a.label) {
          case 0:
            return typeof t.onDeactivation != "function" ? [3, 2] : [4, t.onDeactivation(r)];
          case 1:
            a.sent(), a.label = 2;
          case 2:
            return [4, this._preDestroy(n, r)];
          case 3:
            return a.sent(), [2];
        }
      });
    });
  }, e;
}();
function f0e(e) {
  for (var t = /* @__PURE__ */ new Set(), r = 0, n = e; r < n.length; r++) {
    var a = n[r];
    if (t.has(a))
      return a;
    t.add(a);
  }
}
function m0e(e) {
  return e.prototype !== void 0;
}
function v0e(e) {
  if (e !== void 0)
    throw new Error(Vx);
}
function S0e(e, t, r, n) {
  v0e(t), tH(Tx, e, r.toString(), n);
}
function I0e(e, t, r) {
  if (m0e(e))
    throw new Error(Vx);
  tH(Rx, e.constructor, t, r);
}
function C0e(e) {
  var t = [];
  if (Array.isArray(e)) {
    t = e;
    var r = f0e(t.map(function(n) {
      return n.key;
    }));
    if (r !== void 0)
      throw new Error(Dx + " " + r.toString());
  } else
    t = [e];
  return t;
}
function tH(e, t, r, n) {
  var a = C0e(n), i = {};
  Reflect.hasOwnMetadata(e, t) && (i = Reflect.getMetadata(e, t));
  var o = i[r];
  if (o === void 0)
    o = [];
  else
    for (var s = function(g) {
      if (a.some(function(p) {
        return p.key === g.key;
      }))
        throw new Error(Dx + " " + g.key.toString());
    }, c = 0, l = o; c < l.length; c++) {
      var u = l[c];
      s(u);
    }
  o.push.apply(o, a), i[r] = o, Reflect.defineMetadata(e, i, t);
}
function b0e(e) {
  return function(t, r, n) {
    typeof n == "number" ? S0e(t, r, n, e) : I0e(t, r, e);
  };
}
function Qt() {
  return function(e) {
    if (Reflect.hasOwnMetadata(J_, e))
      throw new Error(Kpe);
    var t = Reflect.getMetadata(Ope, e) || [];
    return Reflect.defineMetadata(J_, t, e), e;
  };
}
function y0e(e) {
  return function(t) {
    return function(r, n, a) {
      if (t === void 0) {
        var i = typeof r == "function" ? r.name : r.constructor.name;
        throw new Error(tge(i));
      }
      return b0e(new Ru(e, t))(r, n, a);
    };
  };
}
var ih = y0e(cw), w0e = Object.defineProperty, A0e = Object.getOwnPropertyDescriptor, rH = (e) => {
  throw TypeError(e);
}, U0e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? A0e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && w0e(t, r, a), a;
}, nH = (e, t, r) => t.has(e) || rH("Cannot " + r), W0 = (e, t, r) => (nH(e, t, "read from private field"), r ? r.call(e) : t.get(e)), lD = (e, t, r) => t.has(e) ? rH("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), k0e = (e, t, r, n) => (nH(e, t, "write to private field"), t.set(e, r), r), _d, G_;
const { documentEntitiesRef: RI, withDocumentEntities: _0e } = ad("document"), N0e = (e) => ({
  credentialFileGuid: e,
  selected: !0,
  filename: void 0
});
let x_ = class {
  constructor(e) {
    lD(this, _d), lD(this, G_, new _e()), k0e(this, _d, mo(
      { name: `credential#document#${e.id}` },
      _0e({
        initialValue: [],
        idKey: "credentialFileGuid"
      })
    ));
  }
  destroy() {
    W0(this, G_).next();
  }
  getPageById(e) {
    return W0(this, _d).query(WS(e, { ref: RI }));
  }
  selectPagesFromStore$() {
    return W0(this, _d).pipe(
      Tu({
        filterEntity: (e) => !!e.selected,
        ref: RI
      })
    );
  }
  upsertPageInStore(e) {
    W0(this, _d).update(
      lw(e.credentialFileGuid, {
        updater: e,
        mergeUpdaterWithCreator: !0,
        ref: RI,
        creator: N0e
      })
    );
  }
  removePagesWithOriginalFileGuid() {
    W0(this, _d).update(
      Bm((e) => !!e.originCredentialFileGuid, {
        ref: RI
      })
    );
  }
};
_d = /* @__PURE__ */ new WeakMap();
G_ = /* @__PURE__ */ new WeakMap();
x_ = U0e([
  Qt()
], x_);
var Z0e = Object.defineProperty, B0e = Object.getOwnPropertyDescriptor, aH = (e) => {
  throw TypeError(e);
}, W0e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? B0e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Z0e(t, r, a), a;
}, iH = (e, t, r) => t.has(e) || aH("Cannot " + r), Xt = (e, t, r) => (iH(e, t, "read from private field"), r ? r.call(e) : t.get(e)), SU = (e, t, r) => t.has(e) ? aH("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), cD = (e, t, r, n) => (iH(e, t, "write to private field"), t.set(e, r), r), H_, Yt, L_;
let Y_ = class {
  constructor(e) {
    SU(this, H_), SU(this, Yt), SU(this, L_, new _e()), cD(this, H_, e), cD(this, Yt, mo(
      { name: `credential#facemap#${e.id}` },
      Wl({
        activeVerificationMethod: e.type.values[0] ?? ei.JumioStandard,
        jLiveAttemptNo: 0,
        jLiveCameraCommand: void 0,
        jLiveDisplayMessage: Zr.Start,
        jLivePhotinusColor: void 0,
        jLiveProgressCurrentStep: 0,
        jLiveProgressStepsTotal: 0,
        jLiveVisibleFaceFinder: "initial",
        jLiveUiCommand: void 0,
        jLiveManualCaptureFallbackReason: void 0,
        jLiveFallbackError: void 0,
        iproovStatus: _i.Pending,
        iproovTokenData: void 0,
        iproovError: void 0,
        iproovLatestOutcome: "none",
        iproovReady: !1
      })
    ));
  }
  destroy() {
    Xt(this, L_).next();
  }
  setActiveFaceVerificationMethod(e) {
    Xt(this, Yt).update(cn("activeVerificationMethod", e));
  }
  setJLiveFallbackError(e) {
    Xt(this, Yt).update(cn("jLiveFallbackError", e));
  }
  selectJLiveFallbackError$() {
    return Xt(this, Yt).pipe(bt(({ jLiveFallbackError: e }) => e));
  }
  setJLiveManualCaptureFallbackReason(e) {
    Xt(this, Yt).update(cn("jLiveManualCaptureFallbackReason", e));
  }
  selectJLiveManualCaptureFallbackReason$() {
    return Xt(this, Yt).pipe(bt(({ jLiveManualCaptureFallbackReason: e }) => e));
  }
  getActiveFaceVerificationMethod() {
    return Xt(this, Yt).query((e) => e.activeVerificationMethod);
  }
  selectActiveFaceVerificationMethod$() {
    return Xt(this, Yt).pipe(
      bt((e) => e.activeVerificationMethod),
      vt()
    );
  }
  selectLivenessState$() {
    return Xt(this, Yt).asObservable();
  }
  setLivenessVisibleFaceFinder(e) {
    Xt(this, Yt).update(cn("jLiveVisibleFaceFinder", e));
  }
  selectLivenessVisibleFaceFinder$() {
    return Xt(this, Yt).pipe(bt((e) => e.jLiveVisibleFaceFinder));
  }
  selectLivenessAttempt$() {
    return Xt(this, Yt).pipe(te((e) => e.jLiveAttemptNo));
  }
  selectLivenessFeedbackMessage$() {
    return Xt(this, Yt).pipe(bt((e) => e.jLiveDisplayMessage));
  }
  selectLivenessScanning$() {
    return this.selectLivenessFeedbackMessage$().pipe(te((e) => e === Zr.FaceHoldStill));
  }
  selectLivenessBackgroundColor$() {
    return Xt(this, Yt).pipe(
      te(({ jLivePhotinusColor: e }) => {
        if (e) {
          const [t, r, n] = (e ?? "").split(",").map((a) => parseFloat(a));
          return t < 0 ? void 0 : `rgb(${t * 255}, ${r * 255}, ${n * 255})`;
        }
      })
    );
  }
  setLivenessStoreToNextAttempt() {
    Xt(this, Yt).update((e) => ({
      ...e,
      jLiveAttemptNo: e.jLiveAttemptNo + 1
    }));
  }
  setLivenessStoreProgress(e) {
    const [t, r] = e.split("/");
    Xt(this, Yt).update(
      Nx({
        jLiveProgressCurrentStep: Number.parseInt(t, 10),
        jLiveProgressStepsTotal: Number.parseInt(r, 10)
      })
    );
  }
  setLivenessStorePhotinusColor(e) {
    Xt(this, Yt).update(cn("jLivePhotinusColor", e));
  }
  setLivenessStoreDisplayMessage(e) {
    Xt(this, Yt).update(cn("jLiveDisplayMessage", e));
  }
  setLivenessStoreCameraCommand(e) {
    Xt(this, Yt).update(cn("jLiveCameraCommand", e));
  }
  setLivenessStoreUiCommand(e) {
    Xt(this, Yt).update(cn("jLiveUiCommand", e));
  }
  reset() {
    Xt(this, Yt).reset();
  }
  selectLivenessProgress$() {
    return Xt(this, Yt).pipe(
      te((e) => [e.jLiveProgressCurrentStep, e.jLiveProgressStepsTotal]),
      vt((e, t) => e[0] === t[0] && e[1] === t[1])
    );
  }
  selectIproovTokenState$() {
    return Xt(this, Yt).pipe(
      te(({ iproovStatus: e, iproovTokenData: t, iproovError: r, iproovLatestOutcome: n, iproovReady: a }) => ({
        iproovStatus: e,
        iproovTokenData: t,
        iproovError: r,
        iproovLatestOutcome: n,
        iproovReady: a
      }))
    );
  }
  getIproovTokenState() {
    return Xt(this, Yt).query(
      ({ iproovStatus: e, iproovTokenData: t, iproovError: r, iproovLatestOutcome: n, iproovReady: a }) => ({ iproovStatus: e, iproovTokenData: t, iproovError: r, iproovLatestOutcome: n, iproovReady: a })
    );
  }
  patchIproovTokenState(e) {
    Xt(this, Yt).update((t) => ({
      ...t,
      ...e
    }));
  }
};
H_ = /* @__PURE__ */ new WeakMap();
Yt = /* @__PURE__ */ new WeakMap();
L_ = /* @__PURE__ */ new WeakMap();
Y_ = W0e([
  Qt()
], Y_);
const { uploadEntitiesRef: Sl, withUploadEntities: E0e } = ad("upload"), { usabilityEntitiesRef: id, withUsabilityEntities: Q0e } = ad("usability"), dn = mo(
  { name: "file" },
  E0e({
    initialValue: [],
    idKey: "id"
  }),
  Q0e({
    initialValue: [],
    idKey: "id"
  })
), F0e = (e) => ({
  id: e,
  state: er.NotStarted
}), T0e = (e) => ({
  id: e,
  state: hl.NotStarted,
  usabilityId: ""
}), R0e = (e) => {
  const t = dn.query(
    Vpe({
      ref: Sl
    })
  ).filter((r) => r.includes(or.FrontSide))[0];
  t !== e && dn.update(
    X5(t, e, {
      ref: Sl
    }),
    X5(t, e, {
      ref: id
    })
  );
}, ZC = (e) => {
  dn.update(
    lw(e.id, {
      updater: e,
      creator: F0e,
      mergeUpdaterWithCreator: !0,
      ref: Sl
    })
  );
}, BC = (e) => {
  dn.update(
    lw(e.id, {
      updater: e,
      creator: T0e,
      mergeUpdaterWithCreator: !0,
      ref: id
    })
  );
}, O_ = (e) => dn.query(
  Jpe({
    filterEntity: (t) => t.id.startsWith(`${e}_`),
    ref: id
  })
), D0e = (e) => dn.query(WS(e, { ref: Sl })), J0e = (e) => dn.pipe(
  Tu({
    filterEntity: (t) => t.id.startsWith(`${e}_`),
    ref: id
  })
), oH = (e) => J0e(e).pipe(
  Wi((t) => po(t).pipe(
    at(
      (r) => r.state === hl.Success
    ),
    wS()
  ))
), TS = (e, t = void 0) => oH(e).pipe(
  Wi((r) => po(r).pipe(
    at(
      (n) => !t || n.result.decisionType === t
    ),
    wS()
  ))
), WE = (e) => dn.pipe(
  Tu({
    filterEntity: (t) => t.id.startsWith(`${e}_`),
    ref: Sl
  })
), EE = (e, t = void 0) => WE(e).pipe(
  go(TS(e, t)),
  Wi(([r, n]) => po(r).pipe(
    at((a) => !!n.find((i) => i.id === a.id)),
    wS()
  ))
), oVe = (e) => dn.query(
  WS(e, {
    ref: id
  })
), V0e = (e) => dn.query(({ uploadEntities: t }) => {
  const r = Object.values(t).filter((n) => n.id.startsWith(`${e}_`));
  return r.length > 0 && r.every((n) => n.state === er.Success);
}), M0e = (e) => dn.pipe(
  bt(({ uploadEntities: t }) => {
    const r = Object.values(t).filter(
      (n) => n.id.startsWith(`${e}_`)
    );
    return r.length > 0 && r.every((n) => [er.Success, er.Error].includes(n.state));
  })
), G0e = (e) => dn.pipe(
  bt(({ uploadEntities: t }) => {
    const r = Object.values(t).filter(
      (n) => n.id.startsWith(`${e}_`)
    );
    return r.length > 0 && r.some((n) => [er.Progress].includes(n.state));
  })
), x0e = (e) => dn.pipe(
  bt(({ uploadEntities: t }) => Object.values(t).filter(
    (n) => n.id.startsWith(`${e}_`)
  ).filter((n) => n.state === er.Success)),
  te((t) => t.map((r) => r.blob)),
  te((t) => t.find(H2))
), H0e = (e) => EE(e, zn.REJECT).pipe(
  te((t) => t.length > 0)
), sH = (e) => {
  dn.update(
    Bm((t) => t.id.startsWith(`${e}_`), {
      ref: Sl
    }),
    Bm((t) => t.id.startsWith(`${e}_`), {
      ref: id
    })
  );
}, lH = (e) => {
  dn.update(
    Bm((t) => t.state !== er.Success && t.id.startsWith(`${e}_`), {
      ref: Sl
    }),
    Bm(
      (t) => t.state !== hl.Success && t.id.startsWith(`${e}_`),
      {
        ref: id
      }
    )
  );
}, cH = (...e) => {
  dn.update(
    R_(e, {
      ref: Sl
    }),
    R_(e, {
      ref: id
    })
  );
}, QE = (e) => dn.pipe(
  Tu({
    filterEntity: (t) => t.id.startsWith(`${e}_`),
    ref: Sl
  }),
  te((t) => t.some((r) => r.source === Fu.Upload))
), ai = mo(
  { name: "settings" },
  Wl({
    acquisitionReference: "00000000-0000-0000-0000-000000000000",
    accountId: "00000000-0000-0000-0000-000000000000",
    workflowDefinitionKey: 0,
    countryForIp: "XXX",
    stateForIp: "XX-XX",
    analyticsEnabled: !1,
    brandingEnabled: !1,
    dvFileUploadEnabled: !1,
    maxFileUploadSize: 0,
    credentials: [],
    timestamp: "",
    configurations: {
      consentRequired: "XX-XX",
      jumioLiveness: {
        fallbackTimeInMs: 9e4,
        farImages: 2,
        frameRateThreshold: 15,
        imageCompression: 0.8,
        imageResolutionHeight: 1080,
        imageResolutionWidth: 720,
        initialImages: 1,
        maxConsecutiveImageTimespanInMs: 1e3,
        maxFaceCenterDifference: 0.15,
        maximumPseudoPitch: 170,
        maximumPseudoYaw: 135,
        minNearFarRatio: 1.1,
        minTimePerDistanceInMs: 1e3,
        minimumPseudoPitch: 105,
        minimumPseudoYaw: 65,
        modelInitTimeoutInMs: 5e3,
        nearImages: 2,
        retries: 3,
        samplingTimeInMs: 1e3,
        tooFarThreshold: 0.2,
        tooNearThreshold: 0.95,
        transitionImages: 2,
        userFallbackAllowed: !0,
        violationLimit: 3
      },
      idAutocapture: {
        fallbackTimeInMs: 9e4
      },
      cameraData: {
        cameraTimeoutMs: 5e3
      }
    },
    deviceRiskTokenData: [],
    supportedCountries: [],
    supportedDocumentTypes: [],
    consents: [],
    merchantSettings: {
      jLiveEnabled: !1,
      jLiveFallbackPolicy: ol.Disabled
    }
  })
), L0e = () => ai.query((e) => {
  var t, r;
  return ((r = (t = e.merchantSettings) == null ? void 0 : t.autoCapture) == null ? void 0 : r.idEnabled) ?? !1;
}), Y0e = () => ai.pipe(te((e) => {
  var t;
  return ((t = e.configurations.idAutocapture) == null ? void 0 : t.excludeDevices) ?? [];
})), dH = (e) => {
  var t;
  return ((t = e.configurations.idAutocapture) == null ? void 0 : t.focusTimeInMs) ?? 1500;
}, sVe = () => ai.pipe(te(dH)), j_ = () => ai.query(dH), kn = () => ai.pipe(at((e) => e.credentials.length > 0)), dD = () => ai.query((e) => e.maxFileUploadSize), O0e = (e, t) => {
  var r, n, a, i, o, s;
  return (((s = (o = (i = (a = (n = (r = ai.query((c) => c.supportedCountries).find((c) => c.country === e)) == null ? void 0 : r.idTypes) == null ? void 0 : n.find((c) => c.idType === t)) == null ? void 0 : a.variants) == null ? void 0 : i.find((c) => c.variant === Qu.Plastic)) == null ? void 0 : o.parts) == null ? void 0 : s.length) ?? 0) > 1;
}, lVe = (e, t) => ai.pipe(
  te(
    (r) => {
      var n, a, i, o, s;
      return (s = (o = (i = (a = (n = r.supportedCountries.find((c) => c.country === e)) == null ? void 0 : n.idTypes) == null ? void 0 : a.find((c) => c.idType === t)) == null ? void 0 : i.variants) == null ? void 0 : o.find((c) => c.variant === Qu.Plastic)) == null ? void 0 : s.parts;
    }
  ),
  te((r) => r ? (r == null ? void 0 : r.length) > 1 : !1)
), j0e = (e) => {
  ai.update((t) => ({
    ...t,
    ...e,
    configurations: { ...t == null ? void 0 : t.configurations, ...e == null ? void 0 : e.configurations },
    // FIXME: We need to sort this on the backend
    supportedCountries: Od(e.supportedCountries, [(r) => r.country], ["asc"])
  }));
}, P0e = () => kn().pipe(bt((e) => e.supportedCountries)), On = () => ai.getValue(), $0e = () => kn().pipe(bt((e) => e.credentials)), K0e = () => kn().pipe(bt((e) => e.consents)), X0e = () => kn().pipe(bt((e) => {
  var t;
  return (t = e.merchantSettings) == null ? void 0 : t.crossDevice;
})), uH = () => X0e().pipe(
  te((e) => (e == null ? void 0 : e.enabled) === !0),
  vt()
), z0e = () => kn().pipe(
  te(
    (e) => {
      var t, r, n;
      return ((r = (t = e.configurations) == null ? void 0 : t.fileUpload) == null ? void 0 : r.isFallbackUploadEnabled) && ((n = e.merchantSettings) == null ? void 0 : n.isFileUploadEnabled);
    }
  )
), hH = () => kn().pipe(te((e) => {
  var t;
  return (t = e.merchantSettings) == null ? void 0 : t.isExplicitUploadEnabled;
})), q0e = () => kn().pipe(
  te((e) => {
    const { retries: t = 3 } = e.configurations.jumioLiveness ?? {};
    return t;
  })
), FE = (e) => kn().pipe(
  te((t) => {
    var r;
    return (r = t.configurations.helpScreen) == null ? void 0 : r[e];
  }),
  at((t) => typeof t == "number" && !Number.isNaN(t))
), vo = (e) => {
  const { credentials: t } = ai.getValue(), r = t.find((n) => n.id === e);
  if (!r)
    throw new Error("Credential is not found");
  return r;
}, TE = () => ai.query((e) => e.configurations.cameraData), efe = (e) => {
  var t;
  return ((t = e.merchantSettings) == null ? void 0 : t.jLiveFallbackPolicy) ?? ol.Disabled;
}, tfe = () => ai.query(efe);
function* P_(e, t) {
  const { selectedCountry: r, selectedIdType: n, selectedDocumentVariant: a, selectedIdFormat: i } = e, o = t.find((s) => s.country === r);
  if (o) {
    for (const s of o.idTypes)
      if (s.idType === n)
        for (const c of s.variants)
          (!a || c.variant === a) && (!i || c.format === i) && (yield c);
  }
}
const rfe = (e) => Object.values(Y).includes(e), $g = ({
  step: e,
  substep: t,
  credentialId: r,
  activeScreen: n,
  shouldStoreNavigationState: a
}) => ({ step: e, substep: t, credentialId: r, activeScreen: n, shouldStoreNavigationState: a });
var nfe = Object.defineProperty, afe = Object.getOwnPropertyDescriptor, pH = (e) => {
  throw TypeError(e);
}, ife = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? afe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && nfe(t, r, a), a;
}, RE = (e, t, r) => t.has(e) || pH("Cannot " + r), Gr = (e, t, r) => (RE(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Cd = (e, t, r) => t.has(e) ? pH("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), uD = (e, t, r, n) => (RE(e, t, "write to private field"), t.set(e, r), r), E0 = (e, t, r) => (RE(e, t, "access private method"), r), Ms, Yi, WC, Nd, gH, EC, DE, $_, fH, JE;
let K_ = class {
  constructor(e) {
    Cd(this, Nd), Cd(this, Ms), Cd(this, Yi), Cd(this, WC, new _e()), Cd(this, DE, ({ credential: t, countries: r }) => {
      var i, o, s, c;
      const n = r.length === 1 ? r[0].country : void 0;
      return (((o = (i = t == null ? void 0 : t.country) == null ? void 0 : i.values) == null ? void 0 : o.length) === 1 ? (c = (s = t == null ? void 0 : t.country) == null ? void 0 : s.values) == null ? void 0 : c[0] : void 0) ?? n ?? void 0;
    }), Cd(this, $_, (t) => Object.values(ft).includes(t)), Cd(this, JE, (t, r, n = On()) => {
      var c, l, u, g, p;
      const a = n.supportedCountries.find((m) => m.country === r);
      if (a == null)
        return;
      const i = ((c = a == null ? void 0 : a.idTypes) == null ? void 0 : c.length) === 1 ? a.idTypes[0].idType : void 0, o = ((u = (l = t == null ? void 0 : t.type) == null ? void 0 : l.values) == null ? void 0 : u.length) === 1 ? (p = (g = t == null ? void 0 : t.type) == null ? void 0 : g.values) == null ? void 0 : p[0] : void 0;
      if (o != null && a.idTypes.find((m) => o === m.idType) == null)
        return;
      const s = o ?? i ?? void 0;
      return Gr(this, $_).call(this, s) ? s : void 0;
    }), uD(this, Ms, e), uD(this, Yi, mo(
      { name: `credential#id#${e.id}` },
      Wl({
        selectedCountry: void 0,
        selectedIdType: void 0,
        selectedDocumentVariant: void 0,
        selectedIdFormat: void 0,
        selectedDigitalIdentity: void 0
      })
    )), kn().pipe(ae(E0(this, Nd, fH).bind(this)), le(Gr(this, WC))).subscribe();
  }
  are2FilesUploaded(e) {
    return O_(e).length > 1;
  }
  isUsabilityBackMissing(e) {
    var r;
    const t = O_(e);
    if (t.length === 1) {
      const [n] = t;
      if (E0(this, Nd, gH).call(this, n)) {
        const { country: a, issuingCountry: i, idType: o } = ((r = n.result) == null ? void 0 : r.extractedData) ?? {};
        return {
          isBackMissing: O0e(a ?? i, o),
          country: a ?? i,
          idType: o
        };
      }
    }
    return { isBackMissing: !1 };
  }
  destroy() {
    Gr(this, WC).next();
  }
  patchIdUserSelection(e, t = On()) {
    Gr(this, Yi).update((r) => {
      const n = {
        ...r,
        ...e
      }, a = Array.from(P_(n, t.supportedCountries)), [i] = a;
      return a.length === 1 ? {
        ...n,
        selectedDocumentVariant: i.variant,
        selectedIdFormat: i.format
      } : n;
    });
  }
  selectSidesForSelectedDocument$() {
    return Gr(this, Yi).pipe(
      bt((e) => Array.from(P_(e, On().supportedCountries))),
      at((e) => e.length >= 0),
      te(([e]) => e),
      at((e) => (e == null ? void 0 : e.parts.length) > 0),
      te((e) => e.parts.map((t) => t.side))
    );
  }
  selectIdTypesForCountryWithVariants$() {
    return kn().pipe(
      $a(Gr(this, Yi)),
      bt(([e, { selectedCountry: t }]) => {
        const r = E0(this, Nd, EC).call(this, e.supportedCountries, t);
        return (r == null ? void 0 : r.idTypes) ?? [];
      })
    );
  }
  selectIdTypesForCountry$() {
    return kn().pipe(
      $a(Gr(this, Yi)),
      bt(([e, { selectedCountry: t }]) => {
        const r = E0(this, Nd, EC).call(this, e.supportedCountries, t);
        return r ? r.idTypes.map((n) => n.idType) : [];
      })
    );
  }
  selectIdTypeVariantCollection$() {
    return kn().pipe(
      $a(Gr(this, Yi)),
      bt(([e, { selectedCountry: t, selectedIdType: r }]) => {
        const n = E0(this, Nd, EC).call(this, e.supportedCountries, t);
        if (!n)
          throw new Error("selectIdTypeVariantCollection$: no records matching country found");
        const a = n.idTypes.find((i) => i.idType === r);
        if (!a)
          throw new Error("selectIdTypeVariantCollection$: no records matching idType found");
        return a.variants;
      })
    );
  }
  selectIdTypeVariant$() {
    return this.selectIdTypeVariantCollection$().pipe(
      $a(Gr(this, Yi)),
      bt(([e, { selectedDocumentVariant: t, selectedIdFormat: r }]) => {
        const n = e.find(
          (a) => a.variant === t && a.format === r
        );
        if (!n)
          throw new Error("selectIdTypeVariant$: no records matching documentVariant and format found");
        return n;
      })
    );
  }
  getIdUserSelection() {
    return Gr(this, Yi).query(
      ({ selectedCountry: e, selectedDigitalIdentity: t, selectedIdType: r, selectedDocumentVariant: n, selectedIdFormat: a }) => ({ selectedCountry: e, selectedDigitalIdentity: t, selectedIdType: r, selectedDocumentVariant: n, selectedIdFormat: a })
    );
  }
  selectIdUserSelection$() {
    return Gr(this, Yi).pipe(
      bt(
        ({ selectedCountry: e, selectedDigitalIdentity: t, selectedIdType: r, selectedDocumentVariant: n, selectedIdFormat: a }) => ({
          selectedCountry: e,
          selectedDigitalIdentity: t,
          selectedIdType: r,
          selectedDocumentVariant: n,
          selectedIdFormat: a
        })
      )
    );
  }
  isCountryAndDocTypePredefined() {
    var r, n, a, i;
    const e = ((r = Gr(this, Ms).country) == null ? void 0 : r.predefinedType) === __.Defined && ((n = Gr(this, Ms).country) == null ? void 0 : n.values.length) === 1, t = ((a = Gr(this, Ms).type) == null ? void 0 : a.predefinedType) === __.Defined && ((i = Gr(this, Ms).type) == null ? void 0 : i.values.length) === 1;
    return e && t;
  }
};
Ms = /* @__PURE__ */ new WeakMap();
Yi = /* @__PURE__ */ new WeakMap();
WC = /* @__PURE__ */ new WeakMap();
Nd = /* @__PURE__ */ new WeakSet();
gH = function(e) {
  return e.state === hl.Success && e.result.decisionType === zn.PASS && e.result.classifier === or.FrontSide;
};
EC = function(e, t) {
  return e.find((r) => r.country === t);
};
DE = /* @__PURE__ */ new WeakMap();
$_ = /* @__PURE__ */ new WeakMap();
fH = function(e) {
  const t = Gr(this, DE).call(this, {
    credential: Gr(this, Ms),
    countries: e.supportedCountries,
    countryForIp: e.countryForIp
  }), r = Gr(this, JE).call(this, Gr(this, Ms), t, e);
  this.patchIdUserSelection(
    {
      ...t && { selectedCountry: t },
      ...r && { selectedIdType: r }
    },
    e
  );
};
JE = /* @__PURE__ */ new WeakMap();
K_ = ife([
  Qt()
], K_);
const sg = {}, Xl = new eH(), up = {
  CredentialIdStoreFactory: Symbol.for("Factory<CredentialIdStore>"),
  CredentialFacemapStoreFactory: Symbol.for("Factory<CredentialFacemapStore>"),
  CredentialDocumentStoreFactory: Symbol.for("Factory<CredentialDocumentStore>")
}, ofe = (e) => {
  const t = vo(e);
  if (!(e && t && t.category === T.Id))
    throw new Error(`createIdLogic: Invalid credential ${T.Id}#${e} requested!`);
  const r = `${T.Id}_${e}`, n = sg[r] ?? new K_(t);
  return sg[r] = n, n;
}, sfe = (e) => {
  const t = vo(e);
  if (!(e && t && t.category === T.Facemap))
    throw new Error(`createDatastoreContainer: Invalid credential ${T.Facemap}#${e} requested!`);
  const r = `${T.Facemap}_${e}`, n = sg[r] ?? new Y_(t);
  return sg[r] = n, n;
}, lfe = (e) => {
  const t = vo(e);
  if (!(e && t && t.category === T.Document))
    throw new Error(`createDatastoreContainer: Invalid credential ${T.Document}#${e} requested!`);
  const r = `${T.Document}_${e}`, n = sg[r] ?? new x_(t);
  return sg[r] = n, n;
};
function cfe(e = {}) {
  return Xl.unbindAll(), Xl.bind(up.CredentialIdStoreFactory).toFactory(() => (e == null ? void 0 : e.credentialIdStoreFactory) ?? ofe), Xl.bind(up.CredentialFacemapStoreFactory).toFactory(() => (e == null ? void 0 : e.credentialFacemapStoreFactory) ?? sfe), Xl.bind(up.CredentialDocumentStoreFactory).toFactory(() => (e == null ? void 0 : e.credentialDocumentStoreFactory) ?? lfe), Xl;
}
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const dfe = 4, hD = 0, pD = 1, ufe = 2;
function Kg(e) {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}
const hfe = 0, mH = 1, pfe = 2, gfe = 3, ffe = 258, VE = 29, RS = 256, Fm = RS + 1 + VE, hp = 30, ME = 19, vH = 2 * Fm + 1, Pd = 15, IU = 16, mfe = 7, GE = 256, SH = 16, IH = 17, CH = 18, X_ = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), QC = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), vfe = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), bH = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Sfe = 512, Gs = new Array((Fm + 2) * 2);
Kg(Gs);
const Mf = new Array(hp * 2);
Kg(Mf);
const Tm = new Array(Sfe);
Kg(Tm);
const Rm = new Array(ffe - gfe + 1);
Kg(Rm);
const xE = new Array(VE);
Kg(xE);
const j1 = new Array(hp);
Kg(j1);
function CU(e, t, r, n, a) {
  this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = a, this.has_stree = e && e.length;
}
let yH, wH, AH;
function bU(e, t) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
const UH = (e) => e < 256 ? Tm[e] : Tm[256 + (e >>> 7)], Dm = (e, t) => {
  e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
}, ma = (e, t, r) => {
  e.bi_valid > IU - r ? (e.bi_buf |= t << e.bi_valid & 65535, Dm(e, e.bi_buf), e.bi_buf = t >> IU - e.bi_valid, e.bi_valid += r - IU) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
}, Ho = (e, t, r) => {
  ma(
    e,
    r[t * 2],
    r[t * 2 + 1]
    /*.Len*/
  );
}, kH = (e, t) => {
  let r = 0;
  do
    r |= e & 1, e >>>= 1, r <<= 1;
  while (--t > 0);
  return r >>> 1;
}, Ife = (e) => {
  e.bi_valid === 16 ? (Dm(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, Cfe = (e, t) => {
  const r = t.dyn_tree, n = t.max_code, a = t.stat_desc.static_tree, i = t.stat_desc.has_stree, o = t.stat_desc.extra_bits, s = t.stat_desc.extra_base, c = t.stat_desc.max_length;
  let l, u, g, p, m, I, C = 0;
  for (p = 0; p <= Pd; p++)
    e.bl_count[p] = 0;
  for (r[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < vH; l++)
    u = e.heap[l], p = r[r[u * 2 + 1] * 2 + 1] + 1, p > c && (p = c, C++), r[u * 2 + 1] = p, !(u > n) && (e.bl_count[p]++, m = 0, u >= s && (m = o[u - s]), I = r[u * 2], e.opt_len += I * (p + m), i && (e.static_len += I * (a[u * 2 + 1] + m)));
  if (C !== 0) {
    do {
      for (p = c - 1; e.bl_count[p] === 0; )
        p--;
      e.bl_count[p]--, e.bl_count[p + 1] += 2, e.bl_count[c]--, C -= 2;
    } while (C > 0);
    for (p = c; p !== 0; p--)
      for (u = e.bl_count[p]; u !== 0; )
        g = e.heap[--l], !(g > n) && (r[g * 2 + 1] !== p && (e.opt_len += (p - r[g * 2 + 1]) * r[g * 2], r[g * 2 + 1] = p), u--);
  }
}, _H = (e, t, r) => {
  const n = new Array(Pd + 1);
  let a = 0, i, o;
  for (i = 1; i <= Pd; i++)
    a = a + r[i - 1] << 1, n[i] = a;
  for (o = 0; o <= t; o++) {
    let s = e[o * 2 + 1];
    s !== 0 && (e[o * 2] = kH(n[s]++, s));
  }
}, bfe = () => {
  let e, t, r, n, a;
  const i = new Array(Pd + 1);
  for (r = 0, n = 0; n < VE - 1; n++)
    for (xE[n] = r, e = 0; e < 1 << X_[n]; e++)
      Rm[r++] = n;
  for (Rm[r - 1] = n, a = 0, n = 0; n < 16; n++)
    for (j1[n] = a, e = 0; e < 1 << QC[n]; e++)
      Tm[a++] = n;
  for (a >>= 7; n < hp; n++)
    for (j1[n] = a << 7, e = 0; e < 1 << QC[n] - 7; e++)
      Tm[256 + a++] = n;
  for (t = 0; t <= Pd; t++)
    i[t] = 0;
  for (e = 0; e <= 143; )
    Gs[e * 2 + 1] = 8, e++, i[8]++;
  for (; e <= 255; )
    Gs[e * 2 + 1] = 9, e++, i[9]++;
  for (; e <= 279; )
    Gs[e * 2 + 1] = 7, e++, i[7]++;
  for (; e <= 287; )
    Gs[e * 2 + 1] = 8, e++, i[8]++;
  for (_H(Gs, Fm + 1, i), e = 0; e < hp; e++)
    Mf[e * 2 + 1] = 5, Mf[e * 2] = kH(e, 5);
  yH = new CU(Gs, X_, RS + 1, Fm, Pd), wH = new CU(Mf, QC, 0, hp, Pd), AH = new CU(new Array(0), vfe, 0, ME, mfe);
}, NH = (e) => {
  let t;
  for (t = 0; t < Fm; t++)
    e.dyn_ltree[t * 2] = 0;
  for (t = 0; t < hp; t++)
    e.dyn_dtree[t * 2] = 0;
  for (t = 0; t < ME; t++)
    e.bl_tree[t * 2] = 0;
  e.dyn_ltree[GE * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, ZH = (e) => {
  e.bi_valid > 8 ? Dm(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, gD = (e, t, r, n) => {
  const a = t * 2, i = r * 2;
  return e[a] < e[i] || e[a] === e[i] && n[t] <= n[r];
}, yU = (e, t, r) => {
  const n = e.heap[r];
  let a = r << 1;
  for (; a <= e.heap_len && (a < e.heap_len && gD(t, e.heap[a + 1], e.heap[a], e.depth) && a++, !gD(t, n, e.heap[a], e.depth)); )
    e.heap[r] = e.heap[a], r = a, a <<= 1;
  e.heap[r] = n;
}, fD = (e, t, r) => {
  let n, a, i = 0, o, s;
  if (e.sym_next !== 0)
    do
      n = e.pending_buf[e.sym_buf + i++] & 255, n += (e.pending_buf[e.sym_buf + i++] & 255) << 8, a = e.pending_buf[e.sym_buf + i++], n === 0 ? Ho(e, a, t) : (o = Rm[a], Ho(e, o + RS + 1, t), s = X_[o], s !== 0 && (a -= xE[o], ma(e, a, s)), n--, o = UH(n), Ho(e, o, r), s = QC[o], s !== 0 && (n -= j1[o], ma(e, n, s)));
    while (i < e.sym_next);
  Ho(e, GE, t);
}, z_ = (e, t) => {
  const r = t.dyn_tree, n = t.stat_desc.static_tree, a = t.stat_desc.has_stree, i = t.stat_desc.elems;
  let o, s, c = -1, l;
  for (e.heap_len = 0, e.heap_max = vH, o = 0; o < i; o++)
    r[o * 2] !== 0 ? (e.heap[++e.heap_len] = c = o, e.depth[o] = 0) : r[o * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    l = e.heap[++e.heap_len] = c < 2 ? ++c : 0, r[l * 2] = 1, e.depth[l] = 0, e.opt_len--, a && (e.static_len -= n[l * 2 + 1]);
  for (t.max_code = c, o = e.heap_len >> 1; o >= 1; o--)
    yU(e, r, o);
  l = i;
  do
    o = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], yU(
      e,
      r,
      1
      /*SMALLEST*/
    ), s = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = o, e.heap[--e.heap_max] = s, r[l * 2] = r[o * 2] + r[s * 2], e.depth[l] = (e.depth[o] >= e.depth[s] ? e.depth[o] : e.depth[s]) + 1, r[o * 2 + 1] = r[s * 2 + 1] = l, e.heap[
      1
      /*SMALLEST*/
    ] = l++, yU(
      e,
      r,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], Cfe(e, t), _H(r, c, e.bl_count);
}, mD = (e, t, r) => {
  let n, a = -1, i, o = t[0 * 2 + 1], s = 0, c = 7, l = 4;
  for (o === 0 && (c = 138, l = 3), t[(r + 1) * 2 + 1] = 65535, n = 0; n <= r; n++)
    i = o, o = t[(n + 1) * 2 + 1], !(++s < c && i === o) && (s < l ? e.bl_tree[i * 2] += s : i !== 0 ? (i !== a && e.bl_tree[i * 2]++, e.bl_tree[SH * 2]++) : s <= 10 ? e.bl_tree[IH * 2]++ : e.bl_tree[CH * 2]++, s = 0, a = i, o === 0 ? (c = 138, l = 3) : i === o ? (c = 6, l = 3) : (c = 7, l = 4));
}, vD = (e, t, r) => {
  let n, a = -1, i, o = t[0 * 2 + 1], s = 0, c = 7, l = 4;
  for (o === 0 && (c = 138, l = 3), n = 0; n <= r; n++)
    if (i = o, o = t[(n + 1) * 2 + 1], !(++s < c && i === o)) {
      if (s < l)
        do
          Ho(e, i, e.bl_tree);
        while (--s !== 0);
      else i !== 0 ? (i !== a && (Ho(e, i, e.bl_tree), s--), Ho(e, SH, e.bl_tree), ma(e, s - 3, 2)) : s <= 10 ? (Ho(e, IH, e.bl_tree), ma(e, s - 3, 3)) : (Ho(e, CH, e.bl_tree), ma(e, s - 11, 7));
      s = 0, a = i, o === 0 ? (c = 138, l = 3) : i === o ? (c = 6, l = 3) : (c = 7, l = 4);
    }
}, yfe = (e) => {
  let t;
  for (mD(e, e.dyn_ltree, e.l_desc.max_code), mD(e, e.dyn_dtree, e.d_desc.max_code), z_(e, e.bl_desc), t = ME - 1; t >= 3 && e.bl_tree[bH[t] * 2 + 1] === 0; t--)
    ;
  return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}, wfe = (e, t, r, n) => {
  let a;
  for (ma(e, t - 257, 5), ma(e, r - 1, 5), ma(e, n - 4, 4), a = 0; a < n; a++)
    ma(e, e.bl_tree[bH[a] * 2 + 1], 3);
  vD(e, e.dyn_ltree, t - 1), vD(e, e.dyn_dtree, r - 1);
}, Afe = (e) => {
  let t = 4093624447, r;
  for (r = 0; r <= 31; r++, t >>>= 1)
    if (t & 1 && e.dyn_ltree[r * 2] !== 0)
      return hD;
  if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
    return pD;
  for (r = 32; r < RS; r++)
    if (e.dyn_ltree[r * 2] !== 0)
      return pD;
  return hD;
};
let SD = !1;
const Ufe = (e) => {
  SD || (bfe(), SD = !0), e.l_desc = new bU(e.dyn_ltree, yH), e.d_desc = new bU(e.dyn_dtree, wH), e.bl_desc = new bU(e.bl_tree, AH), e.bi_buf = 0, e.bi_valid = 0, NH(e);
}, BH = (e, t, r, n) => {
  ma(e, (hfe << 1) + (n ? 1 : 0), 3), ZH(e), Dm(e, r), Dm(e, ~r), r && e.pending_buf.set(e.window.subarray(t, t + r), e.pending), e.pending += r;
}, kfe = (e) => {
  ma(e, mH << 1, 3), Ho(e, GE, Gs), Ife(e);
}, _fe = (e, t, r, n) => {
  let a, i, o = 0;
  e.level > 0 ? (e.strm.data_type === ufe && (e.strm.data_type = Afe(e)), z_(e, e.l_desc), z_(e, e.d_desc), o = yfe(e), a = e.opt_len + 3 + 7 >>> 3, i = e.static_len + 3 + 7 >>> 3, i <= a && (a = i)) : a = i = r + 5, r + 4 <= a && t !== -1 ? BH(e, t, r, n) : e.strategy === dfe || i === a ? (ma(e, (mH << 1) + (n ? 1 : 0), 3), fD(e, Gs, Mf)) : (ma(e, (pfe << 1) + (n ? 1 : 0), 3), wfe(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1), fD(e, e.dyn_ltree, e.dyn_dtree)), NH(e), n && ZH(e);
}, Nfe = (e, t, r) => (e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = r, t === 0 ? e.dyn_ltree[r * 2]++ : (e.matches++, t--, e.dyn_ltree[(Rm[r] + RS + 1) * 2]++, e.dyn_dtree[UH(t) * 2]++), e.sym_next === e.sym_end);
var Zfe = Ufe, Bfe = BH, Wfe = _fe, Efe = Nfe, Qfe = kfe, Ffe = {
  _tr_init: Zfe,
  _tr_stored_block: Bfe,
  _tr_flush_block: Wfe,
  _tr_tally: Efe,
  _tr_align: Qfe
};
const Tfe = (e, t, r, n) => {
  let a = e & 65535 | 0, i = e >>> 16 & 65535 | 0, o = 0;
  for (; r !== 0; ) {
    o = r > 2e3 ? 2e3 : r, r -= o;
    do
      a = a + t[n++] | 0, i = i + a | 0;
    while (--o);
    a %= 65521, i %= 65521;
  }
  return a | i << 16 | 0;
};
var Jm = Tfe;
const Rfe = () => {
  let e, t = [];
  for (var r = 0; r < 256; r++) {
    e = r;
    for (var n = 0; n < 8; n++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[r] = e;
  }
  return t;
}, Dfe = new Uint32Array(Rfe()), Jfe = (e, t, r, n) => {
  const a = Dfe, i = n + r;
  e ^= -1;
  for (let o = n; o < i; o++)
    e = e >>> 8 ^ a[(e ^ t[o]) & 255];
  return e ^ -1;
};
var qr = Jfe, lg = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, DS = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_ERRNO: -1,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  //Z_VERSION_ERROR: -6,
  /* compression levels */
  Z_NO_COMPRESSION: 0,
  Z_BEST_SPEED: 1,
  Z_BEST_COMPRESSION: 9,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY: 0,
  Z_TEXT: 1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init: Vfe, _tr_stored_block: q_, _tr_flush_block: Mfe, _tr_tally: Zc, _tr_align: Gfe } = Ffe, {
  Z_NO_FLUSH: Bc,
  Z_PARTIAL_FLUSH: xfe,
  Z_FULL_FLUSH: Hfe,
  Z_FINISH: Ai,
  Z_BLOCK: ID,
  Z_OK: ln,
  Z_STREAM_END: CD,
  Z_STREAM_ERROR: ts,
  Z_DATA_ERROR: Lfe,
  Z_BUF_ERROR: wU,
  Z_DEFAULT_COMPRESSION: Yfe,
  Z_FILTERED: Ofe,
  Z_HUFFMAN_ONLY: DI,
  Z_RLE: jfe,
  Z_FIXED: Pfe,
  Z_DEFAULT_STRATEGY: $fe,
  Z_UNKNOWN: Kfe,
  Z_DEFLATED: hw
} = DS, Xfe = 9, zfe = 15, qfe = 8, eme = 29, tme = 256, eN = tme + 1 + eme, rme = 30, nme = 19, ame = 2 * eN + 1, ime = 15, lt = 3, mc = 258, rs = mc + lt + 1, ome = 32, cg = 42, HE = 57, tN = 69, rN = 73, nN = 91, aN = 103, $d = 113, rf = 666, Ln = 1, Xg = 2, Du = 3, zg = 4, sme = 3, Kd = (e, t) => (e.msg = lg[t], t), bD = (e) => e * 2 - (e > 4 ? 9 : 0), zl = (e) => {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}, lme = (e) => {
  let t, r, n, a = e.w_size;
  t = e.hash_size, n = t;
  do
    r = e.head[--n], e.head[n] = r >= a ? r - a : 0;
  while (--t);
  t = a, n = t;
  do
    r = e.prev[--n], e.prev[n] = r >= a ? r - a : 0;
  while (--t);
};
let cme = (e, t, r) => (t << e.hash_shift ^ r) & e.hash_mask, Wc = cme;
const xa = (e) => {
  const t = e.state;
  let r = t.pending;
  r > e.avail_out && (r = e.avail_out), r !== 0 && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + r), e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, t.pending === 0 && (t.pending_out = 0));
}, Ka = (e, t) => {
  Mfe(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, xa(e.strm);
}, wt = (e, t) => {
  e.pending_buf[e.pending++] = t;
}, Q0 = (e, t) => {
  e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
}, iN = (e, t, r, n) => {
  let a = e.avail_in;
  return a > n && (a = n), a === 0 ? 0 : (e.avail_in -= a, t.set(e.input.subarray(e.next_in, e.next_in + a), r), e.state.wrap === 1 ? e.adler = Jm(e.adler, t, a, r) : e.state.wrap === 2 && (e.adler = qr(e.adler, t, a, r)), e.next_in += a, e.total_in += a, a);
}, WH = (e, t) => {
  let r = e.max_chain_length, n = e.strstart, a, i, o = e.prev_length, s = e.nice_match;
  const c = e.strstart > e.w_size - rs ? e.strstart - (e.w_size - rs) : 0, l = e.window, u = e.w_mask, g = e.prev, p = e.strstart + mc;
  let m = l[n + o - 1], I = l[n + o];
  e.prev_length >= e.good_match && (r >>= 2), s > e.lookahead && (s = e.lookahead);
  do
    if (a = t, !(l[a + o] !== I || l[a + o - 1] !== m || l[a] !== l[n] || l[++a] !== l[n + 1])) {
      n += 2, a++;
      do
        ;
      while (l[++n] === l[++a] && l[++n] === l[++a] && l[++n] === l[++a] && l[++n] === l[++a] && l[++n] === l[++a] && l[++n] === l[++a] && l[++n] === l[++a] && l[++n] === l[++a] && n < p);
      if (i = mc - (p - n), n = p - mc, i > o) {
        if (e.match_start = t, o = i, i >= s)
          break;
        m = l[n + o - 1], I = l[n + o];
      }
    }
  while ((t = g[t & u]) > c && --r !== 0);
  return o <= e.lookahead ? o : e.lookahead;
}, dg = (e) => {
  const t = e.w_size;
  let r, n, a;
  do {
    if (n = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - rs) && (e.window.set(e.window.subarray(t, t + t - n), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), lme(e), n += t), e.strm.avail_in === 0)
      break;
    if (r = iN(e.strm, e.window, e.strstart + e.lookahead, n), e.lookahead += r, e.lookahead + e.insert >= lt)
      for (a = e.strstart - e.insert, e.ins_h = e.window[a], e.ins_h = Wc(e, e.ins_h, e.window[a + 1]); e.insert && (e.ins_h = Wc(e, e.ins_h, e.window[a + lt - 1]), e.prev[a & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = a, a++, e.insert--, !(e.lookahead + e.insert < lt)); )
        ;
  } while (e.lookahead < rs && e.strm.avail_in !== 0);
}, EH = (e, t) => {
  let r = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, n, a, i, o = 0, s = e.strm.avail_in;
  do {
    if (n = 65535, i = e.bi_valid + 42 >> 3, e.strm.avail_out < i || (i = e.strm.avail_out - i, a = e.strstart - e.block_start, n > a + e.strm.avail_in && (n = a + e.strm.avail_in), n > i && (n = i), n < r && (n === 0 && t !== Ai || t === Bc || n !== a + e.strm.avail_in)))
      break;
    o = t === Ai && n === a + e.strm.avail_in ? 1 : 0, q_(e, 0, 0, o), e.pending_buf[e.pending - 4] = n, e.pending_buf[e.pending - 3] = n >> 8, e.pending_buf[e.pending - 2] = ~n, e.pending_buf[e.pending - 1] = ~n >> 8, xa(e.strm), a && (a > n && (a = n), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + a), e.strm.next_out), e.strm.next_out += a, e.strm.avail_out -= a, e.strm.total_out += a, e.block_start += a, n -= a), n && (iN(e.strm, e.strm.output, e.strm.next_out, n), e.strm.next_out += n, e.strm.avail_out -= n, e.strm.total_out += n);
  } while (o === 0);
  return s -= e.strm.avail_in, s && (s >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= s && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - s, e.strm.next_in), e.strstart), e.strstart += s, e.insert += s > e.w_size - e.insert ? e.w_size - e.insert : s), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), o ? zg : t !== Bc && t !== Ai && e.strm.avail_in === 0 && e.strstart === e.block_start ? Xg : (i = e.window_size - e.strstart, e.strm.avail_in > i && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, i += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), i > e.strm.avail_in && (i = e.strm.avail_in), i && (iN(e.strm, e.window, e.strstart, i), e.strstart += i, e.insert += i > e.w_size - e.insert ? e.w_size - e.insert : i), e.high_water < e.strstart && (e.high_water = e.strstart), i = e.bi_valid + 42 >> 3, i = e.pending_buf_size - i > 65535 ? 65535 : e.pending_buf_size - i, r = i > e.w_size ? e.w_size : i, a = e.strstart - e.block_start, (a >= r || (a || t === Ai) && t !== Bc && e.strm.avail_in === 0 && a <= i) && (n = a > i ? i : a, o = t === Ai && e.strm.avail_in === 0 && n === a ? 1 : 0, q_(e, e.block_start, n, o), e.block_start += n, xa(e.strm)), o ? Du : Ln);
}, AU = (e, t) => {
  let r, n;
  for (; ; ) {
    if (e.lookahead < rs) {
      if (dg(e), e.lookahead < rs && t === Bc)
        return Ln;
      if (e.lookahead === 0)
        break;
    }
    if (r = 0, e.lookahead >= lt && (e.ins_h = Wc(e, e.ins_h, e.window[e.strstart + lt - 1]), r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), r !== 0 && e.strstart - r <= e.w_size - rs && (e.match_length = WH(e, r)), e.match_length >= lt)
      if (n = Zc(e, e.strstart - e.match_start, e.match_length - lt), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= lt) {
        e.match_length--;
        do
          e.strstart++, e.ins_h = Wc(e, e.ins_h, e.window[e.strstart + lt - 1]), r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = Wc(e, e.ins_h, e.window[e.strstart + 1]);
    else
      n = Zc(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (n && (Ka(e, !1), e.strm.avail_out === 0))
      return Ln;
  }
  return e.insert = e.strstart < lt - 1 ? e.strstart : lt - 1, t === Ai ? (Ka(e, !0), e.strm.avail_out === 0 ? Du : zg) : e.sym_next && (Ka(e, !1), e.strm.avail_out === 0) ? Ln : Xg;
}, Sh = (e, t) => {
  let r, n, a;
  for (; ; ) {
    if (e.lookahead < rs) {
      if (dg(e), e.lookahead < rs && t === Bc)
        return Ln;
      if (e.lookahead === 0)
        break;
    }
    if (r = 0, e.lookahead >= lt && (e.ins_h = Wc(e, e.ins_h, e.window[e.strstart + lt - 1]), r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = lt - 1, r !== 0 && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - rs && (e.match_length = WH(e, r), e.match_length <= 5 && (e.strategy === Ofe || e.match_length === lt && e.strstart - e.match_start > 4096) && (e.match_length = lt - 1)), e.prev_length >= lt && e.match_length <= e.prev_length) {
      a = e.strstart + e.lookahead - lt, n = Zc(e, e.strstart - 1 - e.prev_match, e.prev_length - lt), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= a && (e.ins_h = Wc(e, e.ins_h, e.window[e.strstart + lt - 1]), r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = lt - 1, e.strstart++, n && (Ka(e, !1), e.strm.avail_out === 0))
        return Ln;
    } else if (e.match_available) {
      if (n = Zc(e, 0, e.window[e.strstart - 1]), n && Ka(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return Ln;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (n = Zc(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < lt - 1 ? e.strstart : lt - 1, t === Ai ? (Ka(e, !0), e.strm.avail_out === 0 ? Du : zg) : e.sym_next && (Ka(e, !1), e.strm.avail_out === 0) ? Ln : Xg;
}, dme = (e, t) => {
  let r, n, a, i;
  const o = e.window;
  for (; ; ) {
    if (e.lookahead <= mc) {
      if (dg(e), e.lookahead <= mc && t === Bc)
        return Ln;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= lt && e.strstart > 0 && (a = e.strstart - 1, n = o[a], n === o[++a] && n === o[++a] && n === o[++a])) {
      i = e.strstart + mc;
      do
        ;
      while (n === o[++a] && n === o[++a] && n === o[++a] && n === o[++a] && n === o[++a] && n === o[++a] && n === o[++a] && n === o[++a] && a < i);
      e.match_length = mc - (i - a), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= lt ? (r = Zc(e, 1, e.match_length - lt), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = Zc(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (Ka(e, !1), e.strm.avail_out === 0))
      return Ln;
  }
  return e.insert = 0, t === Ai ? (Ka(e, !0), e.strm.avail_out === 0 ? Du : zg) : e.sym_next && (Ka(e, !1), e.strm.avail_out === 0) ? Ln : Xg;
}, ume = (e, t) => {
  let r;
  for (; ; ) {
    if (e.lookahead === 0 && (dg(e), e.lookahead === 0)) {
      if (t === Bc)
        return Ln;
      break;
    }
    if (e.match_length = 0, r = Zc(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (Ka(e, !1), e.strm.avail_out === 0))
      return Ln;
  }
  return e.insert = 0, t === Ai ? (Ka(e, !0), e.strm.avail_out === 0 ? Du : zg) : e.sym_next && (Ka(e, !1), e.strm.avail_out === 0) ? Ln : Xg;
};
function Io(e, t, r, n, a) {
  this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = a;
}
const nf = [
  /*      good lazy nice chain */
  new Io(0, 0, 0, 0, EH),
  /* 0 store only */
  new Io(4, 4, 8, 4, AU),
  /* 1 max speed, no lazy matches */
  new Io(4, 5, 16, 8, AU),
  /* 2 */
  new Io(4, 6, 32, 32, AU),
  /* 3 */
  new Io(4, 4, 16, 16, Sh),
  /* 4 lazy matches */
  new Io(8, 16, 32, 32, Sh),
  /* 5 */
  new Io(8, 16, 128, 128, Sh),
  /* 6 */
  new Io(8, 32, 128, 256, Sh),
  /* 7 */
  new Io(32, 128, 258, 1024, Sh),
  /* 8 */
  new Io(32, 258, 258, 4096, Sh)
  /* 9 max compression */
], hme = (e) => {
  e.window_size = 2 * e.w_size, zl(e.head), e.max_lazy_match = nf[e.level].max_lazy, e.good_match = nf[e.level].good_length, e.nice_match = nf[e.level].nice_length, e.max_chain_length = nf[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = lt - 1, e.match_available = 0, e.ins_h = 0;
};
function pme() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = hw, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(ame * 2), this.dyn_dtree = new Uint16Array((2 * rme + 1) * 2), this.bl_tree = new Uint16Array((2 * nme + 1) * 2), zl(this.dyn_ltree), zl(this.dyn_dtree), zl(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(ime + 1), this.heap = new Uint16Array(2 * eN + 1), zl(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * eN + 1), zl(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const JS = (e) => {
  if (!e)
    return 1;
  const t = e.state;
  return !t || t.strm !== e || t.status !== cg && //#ifdef GZIP
  t.status !== HE && //#endif
  t.status !== tN && t.status !== rN && t.status !== nN && t.status !== aN && t.status !== $d && t.status !== rf ? 1 : 0;
}, QH = (e) => {
  if (JS(e))
    return Kd(e, ts);
  e.total_in = e.total_out = 0, e.data_type = Kfe;
  const t = e.state;
  return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = //#ifdef GZIP
  t.wrap === 2 ? HE : (
    //#endif
    t.wrap ? cg : $d
  ), e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = -2, Vfe(t), ln;
}, FH = (e) => {
  const t = QH(e);
  return t === ln && hme(e.state), t;
}, gme = (e, t) => JS(e) || e.state.wrap !== 2 ? ts : (e.state.gzhead = t, ln), TH = (e, t, r, n, a, i) => {
  if (!e)
    return ts;
  let o = 1;
  if (t === Yfe && (t = 6), n < 0 ? (o = 0, n = -n) : n > 15 && (o = 2, n -= 16), a < 1 || a > Xfe || r !== hw || n < 8 || n > 15 || t < 0 || t > 9 || i < 0 || i > Pfe || n === 8 && o !== 1)
    return Kd(e, ts);
  n === 8 && (n = 9);
  const s = new pme();
  return e.state = s, s.strm = e, s.status = cg, s.wrap = o, s.gzhead = null, s.w_bits = n, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = a + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + lt - 1) / lt), s.window = new Uint8Array(s.w_size * 2), s.head = new Uint16Array(s.hash_size), s.prev = new Uint16Array(s.w_size), s.lit_bufsize = 1 << a + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new Uint8Array(s.pending_buf_size), s.sym_buf = s.lit_bufsize, s.sym_end = (s.lit_bufsize - 1) * 3, s.level = t, s.strategy = i, s.method = r, FH(e);
}, fme = (e, t) => TH(e, t, hw, zfe, qfe, $fe), mme = (e, t) => {
  if (JS(e) || t > ID || t < 0)
    return e ? Kd(e, ts) : ts;
  const r = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || r.status === rf && t !== Ai)
    return Kd(e, e.avail_out === 0 ? wU : ts);
  const n = r.last_flush;
  if (r.last_flush = t, r.pending !== 0) {
    if (xa(e), e.avail_out === 0)
      return r.last_flush = -1, ln;
  } else if (e.avail_in === 0 && bD(t) <= bD(n) && t !== Ai)
    return Kd(e, wU);
  if (r.status === rf && e.avail_in !== 0)
    return Kd(e, wU);
  if (r.status === cg && r.wrap === 0 && (r.status = $d), r.status === cg) {
    let a = hw + (r.w_bits - 8 << 4) << 8, i = -1;
    if (r.strategy >= DI || r.level < 2 ? i = 0 : r.level < 6 ? i = 1 : r.level === 6 ? i = 2 : i = 3, a |= i << 6, r.strstart !== 0 && (a |= ome), a += 31 - a % 31, Q0(r, a), r.strstart !== 0 && (Q0(r, e.adler >>> 16), Q0(r, e.adler & 65535)), e.adler = 1, r.status = $d, xa(e), r.pending !== 0)
      return r.last_flush = -1, ln;
  }
  if (r.status === HE) {
    if (e.adler = 0, wt(r, 31), wt(r, 139), wt(r, 8), r.gzhead)
      wt(
        r,
        (r.gzhead.text ? 1 : 0) + (r.gzhead.hcrc ? 2 : 0) + (r.gzhead.extra ? 4 : 0) + (r.gzhead.name ? 8 : 0) + (r.gzhead.comment ? 16 : 0)
      ), wt(r, r.gzhead.time & 255), wt(r, r.gzhead.time >> 8 & 255), wt(r, r.gzhead.time >> 16 & 255), wt(r, r.gzhead.time >> 24 & 255), wt(r, r.level === 9 ? 2 : r.strategy >= DI || r.level < 2 ? 4 : 0), wt(r, r.gzhead.os & 255), r.gzhead.extra && r.gzhead.extra.length && (wt(r, r.gzhead.extra.length & 255), wt(r, r.gzhead.extra.length >> 8 & 255)), r.gzhead.hcrc && (e.adler = qr(e.adler, r.pending_buf, r.pending, 0)), r.gzindex = 0, r.status = tN;
    else if (wt(r, 0), wt(r, 0), wt(r, 0), wt(r, 0), wt(r, 0), wt(r, r.level === 9 ? 2 : r.strategy >= DI || r.level < 2 ? 4 : 0), wt(r, sme), r.status = $d, xa(e), r.pending !== 0)
      return r.last_flush = -1, ln;
  }
  if (r.status === tN) {
    if (r.gzhead.extra) {
      let a = r.pending, i = (r.gzhead.extra.length & 65535) - r.gzindex;
      for (; r.pending + i > r.pending_buf_size; ) {
        let s = r.pending_buf_size - r.pending;
        if (r.pending_buf.set(r.gzhead.extra.subarray(r.gzindex, r.gzindex + s), r.pending), r.pending = r.pending_buf_size, r.gzhead.hcrc && r.pending > a && (e.adler = qr(e.adler, r.pending_buf, r.pending - a, a)), r.gzindex += s, xa(e), r.pending !== 0)
          return r.last_flush = -1, ln;
        a = 0, i -= s;
      }
      let o = new Uint8Array(r.gzhead.extra);
      r.pending_buf.set(o.subarray(r.gzindex, r.gzindex + i), r.pending), r.pending += i, r.gzhead.hcrc && r.pending > a && (e.adler = qr(e.adler, r.pending_buf, r.pending - a, a)), r.gzindex = 0;
    }
    r.status = rN;
  }
  if (r.status === rN) {
    if (r.gzhead.name) {
      let a = r.pending, i;
      do {
        if (r.pending === r.pending_buf_size) {
          if (r.gzhead.hcrc && r.pending > a && (e.adler = qr(e.adler, r.pending_buf, r.pending - a, a)), xa(e), r.pending !== 0)
            return r.last_flush = -1, ln;
          a = 0;
        }
        r.gzindex < r.gzhead.name.length ? i = r.gzhead.name.charCodeAt(r.gzindex++) & 255 : i = 0, wt(r, i);
      } while (i !== 0);
      r.gzhead.hcrc && r.pending > a && (e.adler = qr(e.adler, r.pending_buf, r.pending - a, a)), r.gzindex = 0;
    }
    r.status = nN;
  }
  if (r.status === nN) {
    if (r.gzhead.comment) {
      let a = r.pending, i;
      do {
        if (r.pending === r.pending_buf_size) {
          if (r.gzhead.hcrc && r.pending > a && (e.adler = qr(e.adler, r.pending_buf, r.pending - a, a)), xa(e), r.pending !== 0)
            return r.last_flush = -1, ln;
          a = 0;
        }
        r.gzindex < r.gzhead.comment.length ? i = r.gzhead.comment.charCodeAt(r.gzindex++) & 255 : i = 0, wt(r, i);
      } while (i !== 0);
      r.gzhead.hcrc && r.pending > a && (e.adler = qr(e.adler, r.pending_buf, r.pending - a, a));
    }
    r.status = aN;
  }
  if (r.status === aN) {
    if (r.gzhead.hcrc) {
      if (r.pending + 2 > r.pending_buf_size && (xa(e), r.pending !== 0))
        return r.last_flush = -1, ln;
      wt(r, e.adler & 255), wt(r, e.adler >> 8 & 255), e.adler = 0;
    }
    if (r.status = $d, xa(e), r.pending !== 0)
      return r.last_flush = -1, ln;
  }
  if (e.avail_in !== 0 || r.lookahead !== 0 || t !== Bc && r.status !== rf) {
    let a = r.level === 0 ? EH(r, t) : r.strategy === DI ? ume(r, t) : r.strategy === jfe ? dme(r, t) : nf[r.level].func(r, t);
    if ((a === Du || a === zg) && (r.status = rf), a === Ln || a === Du)
      return e.avail_out === 0 && (r.last_flush = -1), ln;
    if (a === Xg && (t === xfe ? Gfe(r) : t !== ID && (q_(r, 0, 0, !1), t === Hfe && (zl(r.head), r.lookahead === 0 && (r.strstart = 0, r.block_start = 0, r.insert = 0))), xa(e), e.avail_out === 0))
      return r.last_flush = -1, ln;
  }
  return t !== Ai ? ln : r.wrap <= 0 ? CD : (r.wrap === 2 ? (wt(r, e.adler & 255), wt(r, e.adler >> 8 & 255), wt(r, e.adler >> 16 & 255), wt(r, e.adler >> 24 & 255), wt(r, e.total_in & 255), wt(r, e.total_in >> 8 & 255), wt(r, e.total_in >> 16 & 255), wt(r, e.total_in >> 24 & 255)) : (Q0(r, e.adler >>> 16), Q0(r, e.adler & 65535)), xa(e), r.wrap > 0 && (r.wrap = -r.wrap), r.pending !== 0 ? ln : CD);
}, vme = (e) => {
  if (JS(e))
    return ts;
  const t = e.state.status;
  return e.state = null, t === $d ? Kd(e, Lfe) : ln;
}, Sme = (e, t) => {
  let r = t.length;
  if (JS(e))
    return ts;
  const n = e.state, a = n.wrap;
  if (a === 2 || a === 1 && n.status !== cg || n.lookahead)
    return ts;
  if (a === 1 && (e.adler = Jm(e.adler, t, r, 0)), n.wrap = 0, r >= n.w_size) {
    a === 0 && (zl(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0);
    let c = new Uint8Array(n.w_size);
    c.set(t.subarray(r - n.w_size, r), 0), t = c, r = n.w_size;
  }
  const i = e.avail_in, o = e.next_in, s = e.input;
  for (e.avail_in = r, e.next_in = 0, e.input = t, dg(n); n.lookahead >= lt; ) {
    let c = n.strstart, l = n.lookahead - (lt - 1);
    do
      n.ins_h = Wc(n, n.ins_h, n.window[c + lt - 1]), n.prev[c & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = c, c++;
    while (--l);
    n.strstart = c, n.lookahead = lt - 1, dg(n);
  }
  return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = lt - 1, n.match_available = 0, e.next_in = o, e.input = s, e.avail_in = i, n.wrap = a, ln;
};
var Ime = fme, Cme = TH, bme = FH, yme = QH, wme = gme, Ame = mme, Ume = vme, kme = Sme, _me = "pako deflate (from Nodeca project)", Gf = {
  deflateInit: Ime,
  deflateInit2: Cme,
  deflateReset: bme,
  deflateResetKeep: yme,
  deflateSetHeader: wme,
  deflate: Ame,
  deflateEnd: Ume,
  deflateSetDictionary: kme,
  deflateInfo: _me
};
const Nme = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
var Zme = function(e) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const r = t.shift();
    if (r) {
      if (typeof r != "object")
        throw new TypeError(r + "must be non-object");
      for (const n in r)
        Nme(r, n) && (e[n] = r[n]);
    }
  }
  return e;
}, Bme = (e) => {
  let t = 0;
  for (let n = 0, a = e.length; n < a; n++)
    t += e[n].length;
  const r = new Uint8Array(t);
  for (let n = 0, a = 0, i = e.length; n < i; n++) {
    let o = e[n];
    r.set(o, a), a += o.length;
  }
  return r;
}, pw = {
  assign: Zme,
  flattenChunks: Bme
};
let RH = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  RH = !1;
}
const Vm = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  Vm[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
Vm[254] = Vm[254] = 1;
var Wme = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let t, r, n, a, i, o = e.length, s = 0;
  for (a = 0; a < o; a++)
    r = e.charCodeAt(a), (r & 64512) === 55296 && a + 1 < o && (n = e.charCodeAt(a + 1), (n & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++)), s += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
  for (t = new Uint8Array(s), i = 0, a = 0; i < s; a++)
    r = e.charCodeAt(a), (r & 64512) === 55296 && a + 1 < o && (n = e.charCodeAt(a + 1), (n & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++)), r < 128 ? t[i++] = r : r < 2048 ? (t[i++] = 192 | r >>> 6, t[i++] = 128 | r & 63) : r < 65536 ? (t[i++] = 224 | r >>> 12, t[i++] = 128 | r >>> 6 & 63, t[i++] = 128 | r & 63) : (t[i++] = 240 | r >>> 18, t[i++] = 128 | r >>> 12 & 63, t[i++] = 128 | r >>> 6 & 63, t[i++] = 128 | r & 63);
  return t;
};
const Eme = (e, t) => {
  if (t < 65534 && e.subarray && RH)
    return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
  let r = "";
  for (let n = 0; n < t; n++)
    r += String.fromCharCode(e[n]);
  return r;
};
var Qme = (e, t) => {
  const r = t || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, t));
  let n, a;
  const i = new Array(r * 2);
  for (a = 0, n = 0; n < r; ) {
    let o = e[n++];
    if (o < 128) {
      i[a++] = o;
      continue;
    }
    let s = Vm[o];
    if (s > 4) {
      i[a++] = 65533, n += s - 1;
      continue;
    }
    for (o &= s === 2 ? 31 : s === 3 ? 15 : 7; s > 1 && n < r; )
      o = o << 6 | e[n++] & 63, s--;
    if (s > 1) {
      i[a++] = 65533;
      continue;
    }
    o < 65536 ? i[a++] = o : (o -= 65536, i[a++] = 55296 | o >> 10 & 1023, i[a++] = 56320 | o & 1023);
  }
  return Eme(i, a);
}, Fme = (e, t) => {
  t = t || e.length, t > e.length && (t = e.length);
  let r = t - 1;
  for (; r >= 0 && (e[r] & 192) === 128; )
    r--;
  return r < 0 || r === 0 ? t : r + Vm[e[r]] > t ? r : t;
}, Mm = {
  string2buf: Wme,
  buf2string: Qme,
  utf8border: Fme
};
function Tme() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var DH = Tme;
const JH = Object.prototype.toString, {
  Z_NO_FLUSH: Rme,
  Z_SYNC_FLUSH: Dme,
  Z_FULL_FLUSH: Jme,
  Z_FINISH: Vme,
  Z_OK: P1,
  Z_STREAM_END: Mme,
  Z_DEFAULT_COMPRESSION: Gme,
  Z_DEFAULT_STRATEGY: xme,
  Z_DEFLATED: Hme
} = DS;
function LE(e) {
  this.options = pw.assign({
    level: Gme,
    method: Hme,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: xme
  }, e || {});
  let t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new DH(), this.strm.avail_out = 0;
  let r = Gf.deflateInit2(
    this.strm,
    t.level,
    t.method,
    t.windowBits,
    t.memLevel,
    t.strategy
  );
  if (r !== P1)
    throw new Error(lg[r]);
  if (t.header && Gf.deflateSetHeader(this.strm, t.header), t.dictionary) {
    let n;
    if (typeof t.dictionary == "string" ? n = Mm.string2buf(t.dictionary) : JH.call(t.dictionary) === "[object ArrayBuffer]" ? n = new Uint8Array(t.dictionary) : n = t.dictionary, r = Gf.deflateSetDictionary(this.strm, n), r !== P1)
      throw new Error(lg[r]);
    this._dict_set = !0;
  }
}
LE.prototype.push = function(e, t) {
  const r = this.strm, n = this.options.chunkSize;
  let a, i;
  if (this.ended)
    return !1;
  for (t === ~~t ? i = t : i = t === !0 ? Vme : Rme, typeof e == "string" ? r.input = Mm.string2buf(e) : JH.call(e) === "[object ArrayBuffer]" ? r.input = new Uint8Array(e) : r.input = e, r.next_in = 0, r.avail_in = r.input.length; ; ) {
    if (r.avail_out === 0 && (r.output = new Uint8Array(n), r.next_out = 0, r.avail_out = n), (i === Dme || i === Jme) && r.avail_out <= 6) {
      this.onData(r.output.subarray(0, r.next_out)), r.avail_out = 0;
      continue;
    }
    if (a = Gf.deflate(r, i), a === Mme)
      return r.next_out > 0 && this.onData(r.output.subarray(0, r.next_out)), a = Gf.deflateEnd(this.strm), this.onEnd(a), this.ended = !0, a === P1;
    if (r.avail_out === 0) {
      this.onData(r.output);
      continue;
    }
    if (i > 0 && r.next_out > 0) {
      this.onData(r.output.subarray(0, r.next_out)), r.avail_out = 0;
      continue;
    }
    if (r.avail_in === 0) break;
  }
  return !0;
};
LE.prototype.onData = function(e) {
  this.chunks.push(e);
};
LE.prototype.onEnd = function(e) {
  e === P1 && (this.result = pw.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
const JI = 16209, Lme = 16191;
var Yme = function(t, r) {
  let n, a, i, o, s, c, l, u, g, p, m, I, C, A, U, B, J, W, L, H, R, ge, z, K;
  const Fe = t.state;
  n = t.next_in, z = t.input, a = n + (t.avail_in - 5), i = t.next_out, K = t.output, o = i - (r - t.avail_out), s = i + (t.avail_out - 257), c = Fe.dmax, l = Fe.wsize, u = Fe.whave, g = Fe.wnext, p = Fe.window, m = Fe.hold, I = Fe.bits, C = Fe.lencode, A = Fe.distcode, U = (1 << Fe.lenbits) - 1, B = (1 << Fe.distbits) - 1;
  e:
    do {
      I < 15 && (m += z[n++] << I, I += 8, m += z[n++] << I, I += 8), J = C[m & U];
      t:
        for (; ; ) {
          if (W = J >>> 24, m >>>= W, I -= W, W = J >>> 16 & 255, W === 0)
            K[i++] = J & 65535;
          else if (W & 16) {
            L = J & 65535, W &= 15, W && (I < W && (m += z[n++] << I, I += 8), L += m & (1 << W) - 1, m >>>= W, I -= W), I < 15 && (m += z[n++] << I, I += 8, m += z[n++] << I, I += 8), J = A[m & B];
            r:
              for (; ; ) {
                if (W = J >>> 24, m >>>= W, I -= W, W = J >>> 16 & 255, W & 16) {
                  if (H = J & 65535, W &= 15, I < W && (m += z[n++] << I, I += 8, I < W && (m += z[n++] << I, I += 8)), H += m & (1 << W) - 1, H > c) {
                    t.msg = "invalid distance too far back", Fe.mode = JI;
                    break e;
                  }
                  if (m >>>= W, I -= W, W = i - o, H > W) {
                    if (W = H - W, W > u && Fe.sane) {
                      t.msg = "invalid distance too far back", Fe.mode = JI;
                      break e;
                    }
                    if (R = 0, ge = p, g === 0) {
                      if (R += l - W, W < L) {
                        L -= W;
                        do
                          K[i++] = p[R++];
                        while (--W);
                        R = i - H, ge = K;
                      }
                    } else if (g < W) {
                      if (R += l + g - W, W -= g, W < L) {
                        L -= W;
                        do
                          K[i++] = p[R++];
                        while (--W);
                        if (R = 0, g < L) {
                          W = g, L -= W;
                          do
                            K[i++] = p[R++];
                          while (--W);
                          R = i - H, ge = K;
                        }
                      }
                    } else if (R += g - W, W < L) {
                      L -= W;
                      do
                        K[i++] = p[R++];
                      while (--W);
                      R = i - H, ge = K;
                    }
                    for (; L > 2; )
                      K[i++] = ge[R++], K[i++] = ge[R++], K[i++] = ge[R++], L -= 3;
                    L && (K[i++] = ge[R++], L > 1 && (K[i++] = ge[R++]));
                  } else {
                    R = i - H;
                    do
                      K[i++] = K[R++], K[i++] = K[R++], K[i++] = K[R++], L -= 3;
                    while (L > 2);
                    L && (K[i++] = K[R++], L > 1 && (K[i++] = K[R++]));
                  }
                } else if (W & 64) {
                  t.msg = "invalid distance code", Fe.mode = JI;
                  break e;
                } else {
                  J = A[(J & 65535) + (m & (1 << W) - 1)];
                  continue r;
                }
                break;
              }
          } else if (W & 64)
            if (W & 32) {
              Fe.mode = Lme;
              break e;
            } else {
              t.msg = "invalid literal/length code", Fe.mode = JI;
              break e;
            }
          else {
            J = C[(J & 65535) + (m & (1 << W) - 1)];
            continue t;
          }
          break;
        }
    } while (n < a && i < s);
  L = I >> 3, n -= L, I -= L << 3, m &= (1 << I) - 1, t.next_in = n, t.next_out = i, t.avail_in = n < a ? 5 + (a - n) : 5 - (n - a), t.avail_out = i < s ? 257 + (s - i) : 257 - (i - s), Fe.hold = m, Fe.bits = I;
};
const Ih = 15, yD = 852, wD = 592, AD = 0, UU = 1, UD = 2, Ome = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), jme = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), Pme = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), $me = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), Kme = (e, t, r, n, a, i, o, s) => {
  const c = s.bits;
  let l = 0, u = 0, g = 0, p = 0, m = 0, I = 0, C = 0, A = 0, U = 0, B = 0, J, W, L, H, R, ge = null, z;
  const K = new Uint16Array(Ih + 1), Fe = new Uint16Array(Ih + 1);
  let yr = null, hr, ea, Rn;
  for (l = 0; l <= Ih; l++)
    K[l] = 0;
  for (u = 0; u < n; u++)
    K[t[r + u]]++;
  for (m = c, p = Ih; p >= 1 && K[p] === 0; p--)
    ;
  if (m > p && (m = p), p === 0)
    return a[i++] = 1 << 24 | 64 << 16 | 0, a[i++] = 1 << 24 | 64 << 16 | 0, s.bits = 1, 0;
  for (g = 1; g < p && K[g] === 0; g++)
    ;
  for (m < g && (m = g), A = 1, l = 1; l <= Ih; l++)
    if (A <<= 1, A -= K[l], A < 0)
      return -1;
  if (A > 0 && (e === AD || p !== 1))
    return -1;
  for (Fe[1] = 0, l = 1; l < Ih; l++)
    Fe[l + 1] = Fe[l] + K[l];
  for (u = 0; u < n; u++)
    t[r + u] !== 0 && (o[Fe[t[r + u]]++] = u);
  if (e === AD ? (ge = yr = o, z = 20) : e === UU ? (ge = Ome, yr = jme, z = 257) : (ge = Pme, yr = $me, z = 0), B = 0, u = 0, l = g, R = i, I = m, C = 0, L = -1, U = 1 << m, H = U - 1, e === UU && U > yD || e === UD && U > wD)
    return 1;
  for (; ; ) {
    hr = l - C, o[u] + 1 < z ? (ea = 0, Rn = o[u]) : o[u] >= z ? (ea = yr[o[u] - z], Rn = ge[o[u] - z]) : (ea = 96, Rn = 0), J = 1 << l - C, W = 1 << I, g = W;
    do
      W -= J, a[R + (B >> C) + W] = hr << 24 | ea << 16 | Rn | 0;
    while (W !== 0);
    for (J = 1 << l - 1; B & J; )
      J >>= 1;
    if (J !== 0 ? (B &= J - 1, B += J) : B = 0, u++, --K[l] === 0) {
      if (l === p)
        break;
      l = t[r + o[u]];
    }
    if (l > m && (B & H) !== L) {
      for (C === 0 && (C = m), R += g, I = l - C, A = 1 << I; I + C < p && (A -= K[I + C], !(A <= 0)); )
        I++, A <<= 1;
      if (U += 1 << I, e === UU && U > yD || e === UD && U > wD)
        return 1;
      L = B & H, a[L] = m << 24 | I << 16 | R - i | 0;
    }
  }
  return B !== 0 && (a[R + B] = l - C << 24 | 64 << 16 | 0), s.bits = m, 0;
};
var xf = Kme;
const Xme = 0, VH = 1, MH = 2, {
  Z_FINISH: kD,
  Z_BLOCK: zme,
  Z_TREES: VI,
  Z_OK: Ju,
  Z_STREAM_END: qme,
  Z_NEED_DICT: eve,
  Z_STREAM_ERROR: Qi,
  Z_DATA_ERROR: GH,
  Z_MEM_ERROR: xH,
  Z_BUF_ERROR: tve,
  Z_DEFLATED: _D
} = DS, gw = 16180, ND = 16181, ZD = 16182, BD = 16183, WD = 16184, ED = 16185, QD = 16186, FD = 16187, TD = 16188, RD = 16189, $1 = 16190, ks = 16191, kU = 16192, DD = 16193, _U = 16194, JD = 16195, VD = 16196, MD = 16197, GD = 16198, MI = 16199, GI = 16200, xD = 16201, HD = 16202, LD = 16203, YD = 16204, OD = 16205, NU = 16206, jD = 16207, PD = 16208, nr = 16209, HH = 16210, LH = 16211, rve = 852, nve = 592, ave = 15, ive = ave, $D = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function ove() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const oh = (e) => {
  if (!e)
    return 1;
  const t = e.state;
  return !t || t.strm !== e || t.mode < gw || t.mode > LH ? 1 : 0;
}, YH = (e) => {
  if (oh(e))
    return Qi;
  const t = e.state;
  return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = t.wrap & 1), t.mode = gw, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(rve), t.distcode = t.distdyn = new Int32Array(nve), t.sane = 1, t.back = -1, Ju;
}, OH = (e) => {
  if (oh(e))
    return Qi;
  const t = e.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, YH(e);
}, jH = (e, t) => {
  let r;
  if (oh(e))
    return Qi;
  const n = e.state;
  return t < 0 ? (r = 0, t = -t) : (r = (t >> 4) + 5, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? Qi : (n.window !== null && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, OH(e));
}, PH = (e, t) => {
  if (!e)
    return Qi;
  const r = new ove();
  e.state = r, r.strm = e, r.window = null, r.mode = gw;
  const n = jH(e, t);
  return n !== Ju && (e.state = null), n;
}, sve = (e) => PH(e, ive);
let KD = !0, ZU, BU;
const lve = (e) => {
  if (KD) {
    ZU = new Int32Array(512), BU = new Int32Array(32);
    let t = 0;
    for (; t < 144; )
      e.lens[t++] = 8;
    for (; t < 256; )
      e.lens[t++] = 9;
    for (; t < 280; )
      e.lens[t++] = 7;
    for (; t < 288; )
      e.lens[t++] = 8;
    for (xf(VH, e.lens, 0, 288, ZU, 0, e.work, { bits: 9 }), t = 0; t < 32; )
      e.lens[t++] = 5;
    xf(MH, e.lens, 0, 32, BU, 0, e.work, { bits: 5 }), KD = !1;
  }
  e.lencode = ZU, e.lenbits = 9, e.distcode = BU, e.distbits = 5;
}, $H = (e, t, r, n) => {
  let a;
  const i = e.state;
  return i.window === null && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = new Uint8Array(i.wsize)), n >= i.wsize ? (i.window.set(t.subarray(r - i.wsize, r), 0), i.wnext = 0, i.whave = i.wsize) : (a = i.wsize - i.wnext, a > n && (a = n), i.window.set(t.subarray(r - n, r - n + a), i.wnext), n -= a, n ? (i.window.set(t.subarray(r - n, r), 0), i.wnext = n, i.whave = i.wsize) : (i.wnext += a, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += a))), 0;
}, cve = (e, t) => {
  let r, n, a, i, o, s, c, l, u, g, p, m, I, C, A = 0, U, B, J, W, L, H, R, ge;
  const z = new Uint8Array(4);
  let K, Fe;
  const yr = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (oh(e) || !e.output || !e.input && e.avail_in !== 0)
    return Qi;
  r = e.state, r.mode === ks && (r.mode = kU), o = e.next_out, a = e.output, c = e.avail_out, i = e.next_in, n = e.input, s = e.avail_in, l = r.hold, u = r.bits, g = s, p = c, ge = Ju;
  e:
    for (; ; )
      switch (r.mode) {
        case gw:
          if (r.wrap === 0) {
            r.mode = kU;
            break;
          }
          for (; u < 16; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          if (r.wrap & 2 && l === 35615) {
            r.wbits === 0 && (r.wbits = 15), r.check = 0, z[0] = l & 255, z[1] = l >>> 8 & 255, r.check = qr(r.check, z, 2, 0), l = 0, u = 0, r.mode = ND;
            break;
          }
          if (r.head && (r.head.done = !1), !(r.wrap & 1) || /* check if zlib header allowed */
          (((l & 255) << 8) + (l >> 8)) % 31) {
            e.msg = "incorrect header check", r.mode = nr;
            break;
          }
          if ((l & 15) !== _D) {
            e.msg = "unknown compression method", r.mode = nr;
            break;
          }
          if (l >>>= 4, u -= 4, R = (l & 15) + 8, r.wbits === 0 && (r.wbits = R), R > 15 || R > r.wbits) {
            e.msg = "invalid window size", r.mode = nr;
            break;
          }
          r.dmax = 1 << r.wbits, r.flags = 0, e.adler = r.check = 1, r.mode = l & 512 ? RD : ks, l = 0, u = 0;
          break;
        case ND:
          for (; u < 16; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          if (r.flags = l, (r.flags & 255) !== _D) {
            e.msg = "unknown compression method", r.mode = nr;
            break;
          }
          if (r.flags & 57344) {
            e.msg = "unknown header flags set", r.mode = nr;
            break;
          }
          r.head && (r.head.text = l >> 8 & 1), r.flags & 512 && r.wrap & 4 && (z[0] = l & 255, z[1] = l >>> 8 & 255, r.check = qr(r.check, z, 2, 0)), l = 0, u = 0, r.mode = ZD;
        case ZD:
          for (; u < 32; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          r.head && (r.head.time = l), r.flags & 512 && r.wrap & 4 && (z[0] = l & 255, z[1] = l >>> 8 & 255, z[2] = l >>> 16 & 255, z[3] = l >>> 24 & 255, r.check = qr(r.check, z, 4, 0)), l = 0, u = 0, r.mode = BD;
        case BD:
          for (; u < 16; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          r.head && (r.head.xflags = l & 255, r.head.os = l >> 8), r.flags & 512 && r.wrap & 4 && (z[0] = l & 255, z[1] = l >>> 8 & 255, r.check = qr(r.check, z, 2, 0)), l = 0, u = 0, r.mode = WD;
        case WD:
          if (r.flags & 1024) {
            for (; u < 16; ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            r.length = l, r.head && (r.head.extra_len = l), r.flags & 512 && r.wrap & 4 && (z[0] = l & 255, z[1] = l >>> 8 & 255, r.check = qr(r.check, z, 2, 0)), l = 0, u = 0;
          } else r.head && (r.head.extra = null);
          r.mode = ED;
        case ED:
          if (r.flags & 1024 && (m = r.length, m > s && (m = s), m && (r.head && (R = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Uint8Array(r.head.extra_len)), r.head.extra.set(
            n.subarray(
              i,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              i + m
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            R
          )), r.flags & 512 && r.wrap & 4 && (r.check = qr(r.check, n, m, i)), s -= m, i += m, r.length -= m), r.length))
            break e;
          r.length = 0, r.mode = QD;
        case QD:
          if (r.flags & 2048) {
            if (s === 0)
              break e;
            m = 0;
            do
              R = n[i + m++], r.head && R && r.length < 65536 && (r.head.name += String.fromCharCode(R));
            while (R && m < s);
            if (r.flags & 512 && r.wrap & 4 && (r.check = qr(r.check, n, m, i)), s -= m, i += m, R)
              break e;
          } else r.head && (r.head.name = null);
          r.length = 0, r.mode = FD;
        case FD:
          if (r.flags & 4096) {
            if (s === 0)
              break e;
            m = 0;
            do
              R = n[i + m++], r.head && R && r.length < 65536 && (r.head.comment += String.fromCharCode(R));
            while (R && m < s);
            if (r.flags & 512 && r.wrap & 4 && (r.check = qr(r.check, n, m, i)), s -= m, i += m, R)
              break e;
          } else r.head && (r.head.comment = null);
          r.mode = TD;
        case TD:
          if (r.flags & 512) {
            for (; u < 16; ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            if (r.wrap & 4 && l !== (r.check & 65535)) {
              e.msg = "header crc mismatch", r.mode = nr;
              break;
            }
            l = 0, u = 0;
          }
          r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = ks;
          break;
        case RD:
          for (; u < 32; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          e.adler = r.check = $D(l), l = 0, u = 0, r.mode = $1;
        case $1:
          if (r.havedict === 0)
            return e.next_out = o, e.avail_out = c, e.next_in = i, e.avail_in = s, r.hold = l, r.bits = u, eve;
          e.adler = r.check = 1, r.mode = ks;
        case ks:
          if (t === zme || t === VI)
            break e;
        case kU:
          if (r.last) {
            l >>>= u & 7, u -= u & 7, r.mode = NU;
            break;
          }
          for (; u < 3; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          switch (r.last = l & 1, l >>>= 1, u -= 1, l & 3) {
            case 0:
              r.mode = DD;
              break;
            case 1:
              if (lve(r), r.mode = MI, t === VI) {
                l >>>= 2, u -= 2;
                break e;
              }
              break;
            case 2:
              r.mode = VD;
              break;
            case 3:
              e.msg = "invalid block type", r.mode = nr;
          }
          l >>>= 2, u -= 2;
          break;
        case DD:
          for (l >>>= u & 7, u -= u & 7; u < 32; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          if ((l & 65535) !== (l >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", r.mode = nr;
            break;
          }
          if (r.length = l & 65535, l = 0, u = 0, r.mode = _U, t === VI)
            break e;
        case _U:
          r.mode = JD;
        case JD:
          if (m = r.length, m) {
            if (m > s && (m = s), m > c && (m = c), m === 0)
              break e;
            a.set(n.subarray(i, i + m), o), s -= m, i += m, c -= m, o += m, r.length -= m;
            break;
          }
          r.mode = ks;
          break;
        case VD:
          for (; u < 14; ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          if (r.nlen = (l & 31) + 257, l >>>= 5, u -= 5, r.ndist = (l & 31) + 1, l >>>= 5, u -= 5, r.ncode = (l & 15) + 4, l >>>= 4, u -= 4, r.nlen > 286 || r.ndist > 30) {
            e.msg = "too many length or distance symbols", r.mode = nr;
            break;
          }
          r.have = 0, r.mode = MD;
        case MD:
          for (; r.have < r.ncode; ) {
            for (; u < 3; ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            r.lens[yr[r.have++]] = l & 7, l >>>= 3, u -= 3;
          }
          for (; r.have < 19; )
            r.lens[yr[r.have++]] = 0;
          if (r.lencode = r.lendyn, r.lenbits = 7, K = { bits: r.lenbits }, ge = xf(Xme, r.lens, 0, 19, r.lencode, 0, r.work, K), r.lenbits = K.bits, ge) {
            e.msg = "invalid code lengths set", r.mode = nr;
            break;
          }
          r.have = 0, r.mode = GD;
        case GD:
          for (; r.have < r.nlen + r.ndist; ) {
            for (; A = r.lencode[l & (1 << r.lenbits) - 1], U = A >>> 24, B = A >>> 16 & 255, J = A & 65535, !(U <= u); ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            if (J < 16)
              l >>>= U, u -= U, r.lens[r.have++] = J;
            else {
              if (J === 16) {
                for (Fe = U + 2; u < Fe; ) {
                  if (s === 0)
                    break e;
                  s--, l += n[i++] << u, u += 8;
                }
                if (l >>>= U, u -= U, r.have === 0) {
                  e.msg = "invalid bit length repeat", r.mode = nr;
                  break;
                }
                R = r.lens[r.have - 1], m = 3 + (l & 3), l >>>= 2, u -= 2;
              } else if (J === 17) {
                for (Fe = U + 3; u < Fe; ) {
                  if (s === 0)
                    break e;
                  s--, l += n[i++] << u, u += 8;
                }
                l >>>= U, u -= U, R = 0, m = 3 + (l & 7), l >>>= 3, u -= 3;
              } else {
                for (Fe = U + 7; u < Fe; ) {
                  if (s === 0)
                    break e;
                  s--, l += n[i++] << u, u += 8;
                }
                l >>>= U, u -= U, R = 0, m = 11 + (l & 127), l >>>= 7, u -= 7;
              }
              if (r.have + m > r.nlen + r.ndist) {
                e.msg = "invalid bit length repeat", r.mode = nr;
                break;
              }
              for (; m--; )
                r.lens[r.have++] = R;
            }
          }
          if (r.mode === nr)
            break;
          if (r.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", r.mode = nr;
            break;
          }
          if (r.lenbits = 9, K = { bits: r.lenbits }, ge = xf(VH, r.lens, 0, r.nlen, r.lencode, 0, r.work, K), r.lenbits = K.bits, ge) {
            e.msg = "invalid literal/lengths set", r.mode = nr;
            break;
          }
          if (r.distbits = 6, r.distcode = r.distdyn, K = { bits: r.distbits }, ge = xf(MH, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, K), r.distbits = K.bits, ge) {
            e.msg = "invalid distances set", r.mode = nr;
            break;
          }
          if (r.mode = MI, t === VI)
            break e;
        case MI:
          r.mode = GI;
        case GI:
          if (s >= 6 && c >= 258) {
            e.next_out = o, e.avail_out = c, e.next_in = i, e.avail_in = s, r.hold = l, r.bits = u, Yme(e, p), o = e.next_out, a = e.output, c = e.avail_out, i = e.next_in, n = e.input, s = e.avail_in, l = r.hold, u = r.bits, r.mode === ks && (r.back = -1);
            break;
          }
          for (r.back = 0; A = r.lencode[l & (1 << r.lenbits) - 1], U = A >>> 24, B = A >>> 16 & 255, J = A & 65535, !(U <= u); ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          if (B && !(B & 240)) {
            for (W = U, L = B, H = J; A = r.lencode[H + ((l & (1 << W + L) - 1) >> W)], U = A >>> 24, B = A >>> 16 & 255, J = A & 65535, !(W + U <= u); ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            l >>>= W, u -= W, r.back += W;
          }
          if (l >>>= U, u -= U, r.back += U, r.length = J, B === 0) {
            r.mode = OD;
            break;
          }
          if (B & 32) {
            r.back = -1, r.mode = ks;
            break;
          }
          if (B & 64) {
            e.msg = "invalid literal/length code", r.mode = nr;
            break;
          }
          r.extra = B & 15, r.mode = xD;
        case xD:
          if (r.extra) {
            for (Fe = r.extra; u < Fe; ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            r.length += l & (1 << r.extra) - 1, l >>>= r.extra, u -= r.extra, r.back += r.extra;
          }
          r.was = r.length, r.mode = HD;
        case HD:
          for (; A = r.distcode[l & (1 << r.distbits) - 1], U = A >>> 24, B = A >>> 16 & 255, J = A & 65535, !(U <= u); ) {
            if (s === 0)
              break e;
            s--, l += n[i++] << u, u += 8;
          }
          if (!(B & 240)) {
            for (W = U, L = B, H = J; A = r.distcode[H + ((l & (1 << W + L) - 1) >> W)], U = A >>> 24, B = A >>> 16 & 255, J = A & 65535, !(W + U <= u); ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            l >>>= W, u -= W, r.back += W;
          }
          if (l >>>= U, u -= U, r.back += U, B & 64) {
            e.msg = "invalid distance code", r.mode = nr;
            break;
          }
          r.offset = J, r.extra = B & 15, r.mode = LD;
        case LD:
          if (r.extra) {
            for (Fe = r.extra; u < Fe; ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            r.offset += l & (1 << r.extra) - 1, l >>>= r.extra, u -= r.extra, r.back += r.extra;
          }
          if (r.offset > r.dmax) {
            e.msg = "invalid distance too far back", r.mode = nr;
            break;
          }
          r.mode = YD;
        case YD:
          if (c === 0)
            break e;
          if (m = p - c, r.offset > m) {
            if (m = r.offset - m, m > r.whave && r.sane) {
              e.msg = "invalid distance too far back", r.mode = nr;
              break;
            }
            m > r.wnext ? (m -= r.wnext, I = r.wsize - m) : I = r.wnext - m, m > r.length && (m = r.length), C = r.window;
          } else
            C = a, I = o - r.offset, m = r.length;
          m > c && (m = c), c -= m, r.length -= m;
          do
            a[o++] = C[I++];
          while (--m);
          r.length === 0 && (r.mode = GI);
          break;
        case OD:
          if (c === 0)
            break e;
          a[o++] = r.length, c--, r.mode = GI;
          break;
        case NU:
          if (r.wrap) {
            for (; u < 32; ) {
              if (s === 0)
                break e;
              s--, l |= n[i++] << u, u += 8;
            }
            if (p -= c, e.total_out += p, r.total += p, r.wrap & 4 && p && (e.adler = r.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            r.flags ? qr(r.check, a, p, o - p) : Jm(r.check, a, p, o - p)), p = c, r.wrap & 4 && (r.flags ? l : $D(l)) !== r.check) {
              e.msg = "incorrect data check", r.mode = nr;
              break;
            }
            l = 0, u = 0;
          }
          r.mode = jD;
        case jD:
          if (r.wrap && r.flags) {
            for (; u < 32; ) {
              if (s === 0)
                break e;
              s--, l += n[i++] << u, u += 8;
            }
            if (r.wrap & 4 && l !== (r.total & 4294967295)) {
              e.msg = "incorrect length check", r.mode = nr;
              break;
            }
            l = 0, u = 0;
          }
          r.mode = PD;
        case PD:
          ge = qme;
          break e;
        case nr:
          ge = GH;
          break e;
        case HH:
          return xH;
        case LH:
        default:
          return Qi;
      }
  return e.next_out = o, e.avail_out = c, e.next_in = i, e.avail_in = s, r.hold = l, r.bits = u, (r.wsize || p !== e.avail_out && r.mode < nr && (r.mode < NU || t !== kD)) && $H(e, e.output, e.next_out, p - e.avail_out), g -= e.avail_in, p -= e.avail_out, e.total_in += g, e.total_out += p, r.total += p, r.wrap & 4 && p && (e.adler = r.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  r.flags ? qr(r.check, a, p, e.next_out - p) : Jm(r.check, a, p, e.next_out - p)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === ks ? 128 : 0) + (r.mode === MI || r.mode === _U ? 256 : 0), (g === 0 && p === 0 || t === kD) && ge === Ju && (ge = tve), ge;
}, dve = (e) => {
  if (oh(e))
    return Qi;
  let t = e.state;
  return t.window && (t.window = null), e.state = null, Ju;
}, uve = (e, t) => {
  if (oh(e))
    return Qi;
  const r = e.state;
  return r.wrap & 2 ? (r.head = t, t.done = !1, Ju) : Qi;
}, hve = (e, t) => {
  const r = t.length;
  let n, a, i;
  return oh(e) || (n = e.state, n.wrap !== 0 && n.mode !== $1) ? Qi : n.mode === $1 && (a = 1, a = Jm(a, t, r, 0), a !== n.check) ? GH : (i = $H(e, t, r, r), i ? (n.mode = HH, xH) : (n.havedict = 1, Ju));
};
var pve = OH, gve = jH, fve = YH, mve = sve, vve = PH, Sve = cve, Ive = dve, Cve = uve, bve = hve, yve = "pako inflate (from Nodeca project)", xs = {
  inflateReset: pve,
  inflateReset2: gve,
  inflateResetKeep: fve,
  inflateInit: mve,
  inflateInit2: vve,
  inflate: Sve,
  inflateEnd: Ive,
  inflateGetHeader: Cve,
  inflateSetDictionary: bve,
  inflateInfo: yve
};
function wve() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var Ave = wve;
const KH = Object.prototype.toString, {
  Z_NO_FLUSH: Uve,
  Z_FINISH: kve,
  Z_OK: Gm,
  Z_STREAM_END: WU,
  Z_NEED_DICT: EU,
  Z_STREAM_ERROR: _ve,
  Z_DATA_ERROR: XD,
  Z_MEM_ERROR: Nve
} = DS;
function VS(e) {
  this.options = pw.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(e && e.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15 || (t.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new DH(), this.strm.avail_out = 0;
  let r = xs.inflateInit2(
    this.strm,
    t.windowBits
  );
  if (r !== Gm)
    throw new Error(lg[r]);
  if (this.header = new Ave(), xs.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = Mm.string2buf(t.dictionary) : KH.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (r = xs.inflateSetDictionary(this.strm, t.dictionary), r !== Gm)))
    throw new Error(lg[r]);
}
VS.prototype.push = function(e, t) {
  const r = this.strm, n = this.options.chunkSize, a = this.options.dictionary;
  let i, o, s;
  if (this.ended) return !1;
  for (t === ~~t ? o = t : o = t === !0 ? kve : Uve, KH.call(e) === "[object ArrayBuffer]" ? r.input = new Uint8Array(e) : r.input = e, r.next_in = 0, r.avail_in = r.input.length; ; ) {
    for (r.avail_out === 0 && (r.output = new Uint8Array(n), r.next_out = 0, r.avail_out = n), i = xs.inflate(r, o), i === EU && a && (i = xs.inflateSetDictionary(r, a), i === Gm ? i = xs.inflate(r, o) : i === XD && (i = EU)); r.avail_in > 0 && i === WU && r.state.wrap > 0 && e[r.next_in] !== 0; )
      xs.inflateReset(r), i = xs.inflate(r, o);
    switch (i) {
      case _ve:
      case XD:
      case EU:
      case Nve:
        return this.onEnd(i), this.ended = !0, !1;
    }
    if (s = r.avail_out, r.next_out && (r.avail_out === 0 || i === WU))
      if (this.options.to === "string") {
        let c = Mm.utf8border(r.output, r.next_out), l = r.next_out - c, u = Mm.buf2string(r.output, c);
        r.next_out = l, r.avail_out = n - l, l && r.output.set(r.output.subarray(c, c + l), 0), this.onData(u);
      } else
        this.onData(r.output.length === r.next_out ? r.output : r.output.subarray(0, r.next_out));
    if (!(i === Gm && s === 0)) {
      if (i === WU)
        return i = xs.inflateEnd(this.strm), this.onEnd(i), this.ended = !0, !0;
      if (r.avail_in === 0) break;
    }
  }
  return !0;
};
VS.prototype.onData = function(e) {
  this.chunks.push(e);
};
VS.prototype.onEnd = function(e) {
  e === Gm && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = pw.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function YE(e, t) {
  const r = new VS(t);
  if (r.push(e), r.err) throw r.msg || lg[r.err];
  return r.result;
}
function Zve(e, t) {
  return t = t || {}, t.raw = !0, YE(e, t);
}
var Bve = VS, Wve = YE, Eve = Zve, Qve = YE, Fve = DS, Tve = {
  Inflate: Bve,
  inflate: Wve,
  inflateRaw: Eve,
  ungzip: Qve,
  constants: Fve
};
const { Inflate: cVe, inflate: Rve, inflateRaw: dVe, ungzip: uVe } = Tve;
var Dve = Rve;
function Jve(e) {
  const t = new ArrayBuffer(e.length), r = new Uint8Array(t);
  for (let n = 0, a = e.length; n < a; n += 1)
    r[n] = e.charCodeAt(n);
  return t;
}
function Vve(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("Illegal base64url string!");
  }
  return t;
}
function Mve(e) {
  let t;
  try {
    const r = window.atob(Vve(e.split(".")[1])), n = JSON.parse(
      Dve(Jve(r), {
        to: "string"
      })
    );
    Ut(n, ["exAt"]) && (t = {
      ...n,
      exAt: new Date(Number.parseInt(n.exAt, 10))
    });
  } catch {
    t = void 0;
  }
  return t;
}
const OE = new Kt(!1), Lr = mo(
  { name: "workflow" },
  Wl({
    sessionUrl: window.location.href,
    baseUrl: "",
    token: "",
    locale: Y.En,
    finalized: !1,
    consentGivenSent: !1,
    step: Me.Setup,
    substep: void 0,
    shouldStoreNavigationState: !1,
    transactionId: "00000000-0000-0000-0000-000000000000",
    linked: !1,
    acquisitionStatus: Wr.NotStarted,
    acquisitionPolling: !0,
    tokenExpired: !1,
    credentialId: void 0,
    activeScreen: Ot.Workflow
  })
), Gve = () => OE.asObservable(), xve = () => OE.getValue(), Hf = (e) => {
  OE.next(e);
}, eo = (e) => {
  const t = e.token ? Mve(e.token) : void 0;
  Lr.update(
    Nx({
      ...e,
      ...t ? { transactionId: t.wfeId || t.aId || "" } : void 0,
      ...t ? { parsedToken: t } : void 0
    })
  );
}, Hve = () => {
  Lr.update((e) => ({
    ...e,
    consentGivenSent: !0
  }));
}, Lve = () => Lr.pipe(bt(({ consentGivenSent: e }) => e)), ug = () => Lr.asObservable(), Yve = (e = Lr.getValue()) => Ut(
  e,
  ["token", "baseUrl", "locale", "transactionId"],
  (t) => !!(t.token && t.transactionId && rfe(t.locale))
), XH = () => Lr.pipe(bt(Yve)), Ove = () => Lr.pipe(
  bt(
    ({ parsedToken: e, token: t, transactionId: r, tokenExpired: n }) => ({
      parsedToken: e,
      token: t,
      transactionId: r,
      tokenExpired: n
    })
  )
), zH = () => Lr.query(({ parsedToken: e, token: t, transactionId: r, tokenExpired: n }) => ({
  parsedToken: e,
  token: t,
  transactionId: r,
  tokenExpired: n
})), jve = () => Lr.pipe(
  bt((e) => e.step),
  vt()
), ur = () => Lr.pipe(
  bt(({ substep: e }) => e),
  vt()
), hVe = () => Lr.query(({ substep: e }) => e), fw = () => Lr.pipe(
  bt($g),
  vt((e, t) => hG(e, t))
), qH = () => Lr.query($g), Le = () => Lr.getValue(), sh = (e) => {
  eo(e);
}, oe = () => Lr.query(({ credentialId: e }) => e ?? "00000000-0000-0000-0000-000000000000"), pVe = () => Lr.query(({ step: e }) => e), Pve = () => Lr.pipe(
  bt((e) => e.tokenExpired),
  vt()
), Ec = () => Lr.query(({ transactionId: e }) => e), $ve = () => Lr.query(({ parsedToken: e }) => (e == null ? void 0 : e.cId) ?? ""), oN = () => {
  const { locale: e, parsedToken: t } = Le(), { wfeId: r } = t ?? {}, { accountId: n, workflowDefinitionKey: a } = On();
  return {
    locale: e,
    accountId: n,
    workflowId: a.toString(),
    workflowExecutionId: r
  };
}, Kve = () => {
  _x().forEach((e) => {
    e.reset();
  });
}, eL = {}, sN = [], gVe = () => sN[sN.length - 1], tL = (e) => eL[e] ?? void 0, rL = (e = ["settings", "consents", "camera"]) => {
  const t = Array.from(_x().values()).filter((a) => !e.includes(a.name)).map((a) => {
    const i = a.getValue();
    return () => {
      a.next(i);
    };
  }), r = () => {
    for (const a of t)
      a();
  }, n = um();
  return eL[n] = r, sN.push(n), n;
};
var Vu = /* @__PURE__ */ ((e) => (e.EndToEnd = "e2e", e.Production = "production", e.Development = "development", e))(Vu || {});
const Xve = (e) => Object.values(Vu).includes(e), zve = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CJS_IGNORE_WARNING: "true" }, qve = !1, fVe = !1, jE = Xve(void 0) ? void 0 : Vu.Development, eSe = () => [Vu.Development, Vu.EndToEnd].includes(jE), hg = (() => {
  const t = parseInt("", 10);
  return t > 0 ? t : 0;
})(), tSe = (() => {
  const t = parseInt("", 10);
  return t > 0 ? t : 0;
})(), { DEV: nL } = zve;
class rSe extends CustomEvent {
  constructor(t) {
    super("analytic", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class nSe extends CustomEvent {
  constructor(t) {
    super("report", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
const kt = () => ({});
let yu = {};
const pg = (e) => {
  yu = typeof e == "function" ? e(yu) : {
    ...yu,
    ...e
  };
}, mVe = () => ({ ...yu }), vVe = (e = {}) => {
  yu = e;
};
function aL({
  eventType: e,
  eventName: t,
  code: r,
  level: n
}) {
  return (a) => {
    const i = a != null && a.tags ? { ...yu, ...a == null ? void 0 : a.tags } : yu;
    return {
      eventType: e,
      eventName: t,
      value: `${e}:${t}`,
      code: r,
      level: n,
      tags: i,
      timestamp: /* @__PURE__ */ new Date(),
      ...(a == null ? void 0 : a.metadata) && { metadata: a == null ? void 0 : a.metadata }
    };
  };
}
function aSe(e) {
  return (t, r = {}) => {
    const n = e(r), a = new rSe(n);
    t.dispatchEvent(a);
  };
}
function iSe(e) {
  return (t, r = {}) => {
    const n = e(r), a = new nSe(n);
    t.dispatchEvent(a);
  };
}
function Ve(e) {
  const t = aL(e);
  return [t, aSe(t)];
}
function PE(e) {
  const t = aL(e);
  return [t, iSe(t)];
}
const Ri = "action", Di = 501, [oSe, sSe] = Ve({
  eventType: Ri,
  eventName: "switch camera",
  code: Di,
  level: Ee.Info,
  metadata: kt()
}), [lSe, cSe] = Ve({
  eventType: Ri,
  eventName: "capture",
  code: Di,
  level: Ee.Info,
  metadata: kt()
}), [dSe, uSe] = Ve({
  eventType: Ri,
  eventName: "selected country",
  code: Di,
  level: Ee.Info,
  metadata: kt()
}), [hSe, pSe] = Ve({
  eventType: Ri,
  eventName: "selected document",
  code: Di,
  level: Ee.Info,
  metadata: kt()
}), [gSe, fSe] = Ve({
  eventType: Ri,
  eventName: "selected document variant",
  code: Di,
  level: Ee.Info,
  metadata: kt()
}), [mSe, vSe] = Ve({
  eventType: Ri,
  eventName: "clicked start button",
  code: Di,
  level: Ee.Info
}), [SSe, ISe] = Ve({
  eventType: Ri,
  eventName: "clicked retry button",
  code: Di,
  level: Ee.Info
}), [CSe, bSe] = Ve({
  eventType: Ri,
  eventName: "clicked cross device button",
  code: Di,
  level: Ee.Info
}), [ySe, wSe] = Ve({
  eventType: Ri,
  eventName: "clicked send email button",
  code: Di,
  level: Ee.Info
}), [ASe, USe] = Ve({
  eventType: Ri,
  eventName: "email sent error",
  code: Di,
  level: Ee.Info
}), [kSe, _Se] = Ve({
  eventType: Ri,
  eventName: "clicked file upload button",
  code: Di,
  level: Ee.Info
}), [iL, NSe] = Ve({
  eventType: Ri,
  eventName: "uploaded file",
  code: Di,
  level: Ee.Info,
  metadata: kt()
}), ZSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cameraCapture: cSe,
  clickedCrossDeviceButton: bSe,
  clickedRetryButton: ISe,
  clickedSendEmailButton: wSe,
  clickedStartButton: vSe,
  clickedUploadButton: _Se,
  createCameraCaptureEvent: lSe,
  createClickedCrossDeviceButtonEvent: CSe,
  createClickedRetryButtonEvent: SSe,
  createClickedSendEmailButtonEvent: ySe,
  createClickedStartButtonEvent: mSe,
  createClickedUploadButtonEvent: kSe,
  createEmailSentError: ASe,
  createSelectedCountryEvent: dSe,
  createSelectedDocumentEvent: hSe,
  createSelectedDocumentVariantEvent: gSe,
  createSwitchCameraEvent: oSe,
  createUploadedFileEvent: iL,
  emailSentError: USe,
  selectedCountry: uSe,
  selectedDocument: pSe,
  selectedDocumentVariant: fSe,
  switchCamera: sSe,
  uploadedFile: NSe
}, Symbol.toStringTag, { value: "Module" })), mw = "arbitrary", BSe = 518, [WSe, ESe] = PE({
  eventType: mw,
  eventName: "settings",
  code: 506,
  level: Ee.Info,
  metadata: kt()
}), [QSe, FSe] = PE({
  eventType: mw,
  eventName: "runtime",
  code: 507,
  level: Ee.Info
}), [TSe, RSe] = PE({
  eventType: mw,
  eventName: "shown consent message",
  code: BSe,
  level: Ee.Info
}), [DSe, JSe] = Ve({
  eventType: mw,
  eventName: "capture types",
  code: 516,
  level: Ee.Trace,
  metadata: kt()
}), VSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createRuntimeEvent: QSe,
  createSettingsEvent: WSe,
  createShownConsentMessageEvent: TSe,
  createUsedCaptureTypesEvent: DSe,
  runtime: FSe,
  settings: ESe,
  shownConsentMessage: RSe,
  usedCaptureTypesEvent: JSe
}, Symbol.toStringTag, { value: "Module" }));
class MSe {
  constructor(t, r, n) {
    this.errorCase = t, this.call = r, this.detailCode = n;
  }
  isRetryable() {
    return this.errorCase.retry;
  }
  domain() {
    return this.errorCase.domain;
  }
  code() {
    return `${this.errorCase.domain}${String(this.call).padStart(2, "0")}${String(this.detailCode).padStart(4, "0")}`;
  }
  legacyCode() {
    return this.call === Kr.UploadCall ? rt.FileUploadError : this.call === Kr.UsabilityCall ? rt.UsabilityError : this.errorCase.legacyCode;
  }
}
const vw = (e, t, r) => new MSe(e, t, r), Za = "screen", Ba = 500, [GSe, xSe] = Ve({
  eventType: Za,
  eventName: "start",
  code: Ba,
  level: Ee.Info
}), [HSe, LSe] = Ve({
  eventType: Za,
  eventName: "document select",
  code: Ba,
  level: Ee.Info
}), [YSe, OSe] = Ve({
  eventType: Za,
  eventName: "document variant select",
  code: Ba,
  level: Ee.Info
}), [jSe, PSe] = Ve({
  eventType: Za,
  eventName: "capture",
  code: Ba,
  level: Ee.Info,
  metadata: kt()
}), [$Se, KSe] = Ve({
  eventType: Za,
  eventName: "camera access request",
  code: Ba,
  level: Ee.Info,
  metadata: kt()
}), [XSe, zSe] = Ve({
  eventType: Za,
  eventName: "guidance",
  code: Ba,
  level: Ee.Info
}), [qSe, eIe] = Ve({
  eventType: Za,
  eventName: "upload",
  code: Ba,
  level: Ee.Info
}), [tIe, rIe] = Ve({
  eventType: Za,
  eventName: "retry",
  code: Ba,
  level: Ee.Info,
  metadata: kt()
}), [nIe, aIe] = Ve({
  eventType: Za,
  eventName: "finish",
  code: Ba,
  level: Ee.Info,
  metadata: kt()
}), [iIe, oIe] = Ve({
  eventType: Za,
  eventName: "cross device",
  code: Ba,
  level: Ee.Info
}), [oL, sIe] = Ve({
  eventType: Za,
  eventName: "cross device finish",
  code: Ba,
  level: Ee.Info,
  metadata: kt()
}), [lIe, cIe] = Ve({
  eventType: Za,
  eventName: "error",
  code: Ba,
  level: Ee.Info
}), dIe = (e) => Ve({
  eventType: Za,
  eventName: e,
  code: Ba,
  level: Ee.Info,
  metadata: kt()
}), [lN, uIe] = Ve({
  eventType: Za,
  eventName: "public error",
  code: Ba,
  level: Ee.Error,
  metadata: kt()
}), hIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createPublicErrorEvent: lN,
  createShowRetryScreenEvent: tIe,
  createShownCameraAccessRequestScreenEvent: $Se,
  createShownCaptureScreenEvent: jSe,
  createShownCrossDeviceFinishScreenEvent: oL,
  createShownCrossDeviceScreenEvent: iIe,
  createShownDocumentSelectScreenEvent: HSe,
  createShownDocumentVariantSelectScreenEvent: YSe,
  createShownErrorEvent: lIe,
  createShownFinishScreenEvent: nIe,
  createShownGuidanceScreenEvent: XSe,
  createShownStartScreenEvent: GSe,
  createShownUploadScreenEvent: qSe,
  getShownScreenEventReporter: dIe,
  publicError: uIe,
  showRetryScreen: rIe,
  shownCameraAccessRequestScreen: KSe,
  shownCaptureScreen: PSe,
  shownCrossDeviceFinishScreen: sIe,
  shownCrossDeviceScreen: oIe,
  shownDocumentSelectScreen: LSe,
  shownDocumentVariantSelectScreen: OSe,
  shownError: cIe,
  shownFinishScreen: aIe,
  shownGuidanceScreen: zSe,
  shownStartScreen: xSe,
  shownUploadScreen: eIe
}, Symbol.toStringTag, { value: "Module" })), Yr = "trace", Or = 517, [pIe, gIe] = Ve({
  eventType: Yr,
  eventName: "custom element attributes changed",
  code: Or,
  level: Ee.Info,
  metadata: kt()
}), [fIe, mIe] = Ve({
  eventType: Yr,
  eventName: "workflow restarted",
  code: Or,
  level: Ee.Info
}), [sL, vIe] = Ve({
  eventType: Yr,
  eventName: "video thrown an error",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [SIe, IIe] = Ve({
  eventType: Yr,
  eventName: "camera access granted",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [CIe, bIe] = Ve({
  eventType: Yr,
  eventName: "camera access denied",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [yIe, wIe] = Ve({
  eventType: Yr,
  eventName: "shown camera capture hints",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [AIe, UIe] = Ve({
  eventType: Yr,
  eventName: "back side of ID is missing",
  code: Or,
  level: Ee.Trace
}), [kIe, _Ie] = Ve({
  eventType: Yr,
  eventName: "started camera stream",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [NIe, ZIe] = Ve({
  eventType: Yr,
  eventName: "device list changed",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [BIe, lL] = Ve({
  eventType: Yr,
  eventName: "failed to fetch",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [cL, WIe] = Ve({
  eventType: Yr,
  eventName: "liveness - manual selfie fallback",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [dL, EIe] = Ve({
  eventType: Yr,
  eventName: "liveness - initialized",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [QIe, uL] = Ve({
  eventType: Yr,
  eventName: "liveness - module loading failed",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [hL, FIe] = Ve({
  eventType: Yr,
  eventName: "liveness - progress",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [pL, TIe] = Ve(
  {
    eventType: Yr,
    eventName: "id autocapture - state change event",
    code: Or,
    level: Ee.Trace,
    metadata: kt()
  }
), [RIe, DIe] = Ve({
  eventType: Yr,
  eventName: "camera playback status",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [JIe, gL] = Ve({
  eventType: Yr,
  eventName: "unhandled promise rejection",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [VIe, fL] = Ve({
  eventType: Yr,
  eventName: "uncaught error",
  code: Or,
  level: Ee.Trace,
  metadata: kt()
}), [MIe, GIe] = Ve({
  eventType: Yr,
  eventName: "missing idType - defaulting to DL",
  code: Or,
  level: Ee.Trace
}), xIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attributesChanged: gIe,
  autocaptureStateChangeEvent: TIe,
  backMissingEvent: UIe,
  cameraAccessDenied: bIe,
  cameraAccessGranted: IIe,
  cameraPlaybackStatusEvent: DIe,
  cameraStreamStarted: _Ie,
  crateBackMissingEvent: AIe,
  createAttributesChanged: pIe,
  createAutocaptureStateChangeEvent: pL,
  createCameraAccessDeniedEvent: CIe,
  createCameraAccessGrantedEvent: SIe,
  createCameraCaptureHintsShownEvent: yIe,
  createCameraPlaybackStatusEvent: RIe,
  createCameraStreamStartedEvent: kIe,
  createDefaultToDL: MIe,
  createDeviceListChangedEvent: NIe,
  createFailedToFetchEvent: BIe,
  createLivenessInitializedEvent: dL,
  createLivenessManualSelfieFallbackEvent: cL,
  createLivenessModuleLoadingFailedEvent: QIe,
  createLivenessProgressEvent: hL,
  createUncaughtErrorEvent: VIe,
  createUnhandledrejectionEvent: JIe,
  createVideoPlayThrowsEvent: sL,
  createWorkflowRestarted: fIe,
  defaultToDL: GIe,
  deviceListChanged: ZIe,
  failedToFetch: lL,
  livenessInitialized: EIe,
  livenessManualSelfieFallback: WIe,
  livenessModuleLoadingFailed: uL,
  livenessProgressEvent: FIe,
  shownCameraCaptureHints: wIe,
  uncaughtErrorEvent: fL,
  unhandledrejectionEvent: gL,
  videoPlayThrows: vIe,
  workflowRestarted: mIe
}, Symbol.toStringTag, { value: "Module" })), Te = {
  ...VSe,
  ...ZSe,
  ...hIe,
  ...xIe
};
var K1 = /* @__PURE__ */ ((e) => (e.NavigateToWorkflow = "active-screen-navigate-to-workflow", e.NavigateToCrossDevice = "active-screen-navigate-to-cross-device", e))(K1 || {}), Aa = /* @__PURE__ */ ((e) => (e.PreviousStep = "step-navigation-previous-step", e.NextStep = "step-navigation-next-step", e))(Aa || {});
const re = (e) => ({
  type: "setWorkflowStep",
  params: e
}), HIe = (e, t, r) => {
  const n = e === 0, a = r[e - 1], i = {
    target: n ? Me.Start : a.id,
    actions: re({
      step: n ? Me.Start : a.category,
      substep: void 0,
      credentialId: n ? void 0 : a.id,
      shouldStoreNavigationState: n
    })
  }, o = e === r.length - 1, s = r[e + 1], c = {
    target: o ? Me.Finish : s.id,
    actions: re({
      step: o ? Me.Finish : s.category,
      substep: void 0,
      credentialId: o ? void 0 : s.id,
      shouldStoreNavigationState: o
    })
  };
  return { credentialId: t.id, previousStep: i, nextStep: c };
}, LIe = (e) => re({
  credentialId: e,
  step: T.Data,
  substep: Jd.Start,
  shouldStoreNavigationState: !1
}), mL = (e) => ({
  Finish: `${e}:data-finish`
}), YIe = ({ credentialId: e, previousStep: t, nextStep: r }) => {
  const n = mL(e), a = {
    [e]: {
      id: e,
      initial: Jd.Start,
      states: {
        [Jd.Start]: {
          on: {
            [n.Finish]: {
              target: Jd.Finish,
              actions: re({
                credentialId: e,
                step: T.Data,
                substep: Jd.Finish,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Jd.Finish]: {
          type: "final"
        }
      },
      on: {
        [Aa.NextStep]: r,
        [Aa.PreviousStep]: t
      },
      entry: LIe(e),
      onDone: r
    }
  };
  return {
    credentialId: e,
    actions: n,
    transitions: a
  };
}, OIe = (e) => re({
  credentialId: e,
  step: T.Document,
  substep: Cn.UploadScreen,
  shouldStoreNavigationState: !0
}), Sw = (e) => ({
  Finish: `${e}:document-finish`,
  UploadScreen: `${e}:document-upload-screen`,
  MobileCapture: `${e}:document-mobile-capture`
}), jIe = ({ credentialId: e, previousStep: t, nextStep: r }) => {
  const n = Sw(e), a = {
    [e]: {
      id: e,
      initial: Cn.UploadScreen,
      states: {
        [Cn.UploadScreen]: {
          on: {
            [n.UploadScreen]: {
              target: Cn.UploadScreen,
              actions: re({
                credentialId: e,
                step: T.Document,
                substep: Cn.UploadScreen,
                shouldStoreNavigationState: !0
              })
            },
            [n.MobileCapture]: {
              target: Cn.MobileCapture,
              actions: re({
                credentialId: e,
                step: T.Document,
                substep: Cn.MobileCapture,
                shouldStoreNavigationState: !1
              })
            },
            [n.Finish]: {
              target: Cn.Finish,
              actions: re({
                credentialId: e,
                step: T.Document,
                substep: Cn.Finish,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Cn.MobileCapture]: {
          on: {
            [n.UploadScreen]: {
              target: Cn.UploadScreen,
              actions: re({
                credentialId: e,
                step: T.Document,
                substep: Cn.UploadScreen,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Cn.Finish]: {
          type: "final"
        }
      },
      on: {
        [Aa.NextStep]: r,
        [Aa.PreviousStep]: t
      },
      entry: OIe(e),
      onDone: r
    }
  };
  return {
    credentialId: e,
    actions: n,
    transitions: a
  };
}, PIe = (e) => re({
  credentialId: e,
  step: T.Facemap,
  substep: x.Start,
  shouldStoreNavigationState: !1
}), Tt = (e) => ({
  Start: `${e}:identity-start`,
  Iproov: `${e}:identity-liveness`,
  IproovFailureSystem: `${e}:identity-liveness-failure-system`,
  IproovFailureUser: `${e}:identity-liveness-failure-user`,
  IdentityFailureNoAttemptsLeft: `${e}:identity-failure-no-attempts-left`,
  IproovFinish: `${e}:identity-liveness-finish`,
  JumioStandard: `${e}:identity-jumio-standard`,
  JumioStandardGuidance: `${e}:identity-jumio-standard-guidance`,
  JumioStandardCaptureScreen: `${e}:identity-jumio-standard-capture-screen`,
  JumioStandardCaptureScreenLiveness: `${e}:identity-jumio-standard-capture-screen-liveness`,
  JumioStandardCaptureScreenLivenessLoading: `${e}:identity-jumio-standard-capture-screen-liveness-loading`,
  JumioStandardCaptureScreenLivenessRetry: `${e}:identity-jumio-standard-capture-screen-liveness-retry`,
  JumioStandardCaptureScreenSelfie: `${e}:identity-jumio-standard-capture-screen-selfie`,
  JumioStandardCaptureScreenCaptureFinish: `${e}:identity-jumio-standard-capture-screen-capture-finish`,
  JumioStandardCaptureScreenUpload: `${e}:identity-jumio-standard-capture-screen-upload`,
  JumioStandardCaptureScreenUploadFailed: `${e}:identity-jumio-standard-capture-screen-upload-failed`,
  JumioStandardUsabilityCheck: `${e}:identity-jumio-standard-usability-check`,
  JumioStandardUsabilityCheckSuccess: `${e}:identity-jumio-standard-usability-check-success`,
  JumioStandardUsabilityCheckFailure: `${e}:identity-jumio-standard-usability-check-failure`,
  NoVerificationMethodsLeft: `${e}:identity-no-verification-methods-left`,
  Finish: `${e}:identity-finish`
}), $Ie = ({ credentialId: e, previousStep: t, nextStep: r }) => {
  const n = Tt(e), a = {
    [e]: {
      id: e,
      initial: x.Start,
      states: {
        [x.Start]: {
          on: {
            [n.JumioStandard]: {
              target: x.JumioStandard,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandard,
                shouldStoreNavigationState: !1
              })
            },
            [n.Iproov]: {
              target: x.Iproov,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.Iproov,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [x.JumioStandard]: {
          on: {
            [n.JumioStandardGuidance]: {
              target: x.JumioStandardGuidance,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardGuidance,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [x.JumioStandardGuidance]: {
          on: {
            [n.JumioStandardCaptureScreen]: {
              target: x.JumioStandardCaptureScreen,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreen,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [x.JumioStandardCaptureScreen]: {
          on: {
            [n.JumioStandardCaptureScreenSelfie]: {
              target: x.JumioStandardCaptureScreenSelfie,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenSelfie,
                shouldStoreNavigationState: !1
              })
            },
            [n.JumioStandardCaptureScreenLivenessLoading]: {
              target: x.JumioStandardCaptureScreenLivenessLoading,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenLivenessLoading,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardCaptureScreenLivenessLoading]: {
          on: {
            [n.JumioStandardCaptureScreenLiveness]: {
              target: x.JumioStandardCaptureScreenLiveness,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenLiveness,
                shouldStoreNavigationState: !1
              })
            },
            [n.JumioStandardCaptureScreenLivenessRetry]: {
              target: x.JumioStandardGuidance,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardGuidance,
                shouldStoreNavigationState: !0
              })
            },
            [n.JumioStandardCaptureScreenSelfie]: {
              target: x.JumioStandardCaptureScreenSelfie,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenSelfie,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardCaptureScreenLiveness]: {
          on: {
            [n.JumioStandardCaptureScreenCaptureFinish]: {
              target: x.JumioStandardCaptureScreenCaptureFinish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenCaptureFinish,
                shouldStoreNavigationState: !1
              })
            },
            [n.JumioStandardCaptureScreenLivenessRetry]: {
              target: x.JumioStandardCaptureScreen,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreen,
                shouldStoreNavigationState: !0
              })
            },
            [n.JumioStandardCaptureScreenSelfie]: {
              target: x.JumioStandardCaptureScreenSelfie,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenSelfie,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardCaptureScreenSelfie]: {
          on: {
            [n.JumioStandardCaptureScreenCaptureFinish]: {
              target: x.JumioStandardCaptureScreenCaptureFinish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenCaptureFinish,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardCaptureScreenCaptureFinish]: {
          on: {
            [n.JumioStandardCaptureScreenUpload]: {
              target: x.JumioStandardCaptureScreenUpload,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenUpload,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardCaptureScreenUpload]: {
          on: {
            [n.JumioStandardUsabilityCheck]: {
              target: x.JumioStandardUsabilityCheck,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardUsabilityCheck,
                shouldStoreNavigationState: !1
              })
            },
            [n.JumioStandardCaptureScreenUploadFailed]: {
              target: x.JumioStandardCaptureScreenUploadFailed,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreenUploadFailed,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardCaptureScreenUploadFailed]: {
          on: {
            [n.JumioStandardCaptureScreen]: {
              target: x.JumioStandardCaptureScreen,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreen,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [x.JumioStandardUsabilityCheck]: {
          on: {
            [n.JumioStandardUsabilityCheckSuccess]: {
              target: x.JumioStandardFinish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardFinish,
                shouldStoreNavigationState: !1
              })
            },
            [n.JumioStandardUsabilityCheckFailure]: {
              target: x.JumioStandardUsabilityCheckFailure,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardUsabilityCheckFailure,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.JumioStandardUsabilityCheckFailure]: {
          on: {
            [n.JumioStandardCaptureScreen]: {
              target: x.JumioStandardCaptureScreen,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.JumioStandardCaptureScreen,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [x.JumioStandardFinish]: {
          on: {
            [n.Finish]: {
              target: x.Finish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.Finish,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.Iproov]: {
          on: {
            [n.IproovFinish]: {
              target: x.IproovFinish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.IproovFinish,
                shouldStoreNavigationState: !1
              })
            },
            [n.IproovFailureUser]: {
              target: x.Iproov,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.Iproov,
                shouldStoreNavigationState: !0
              })
            },
            [n.IproovFailureSystem]: {
              target: x.VerificationMethodFailed,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.VerificationMethodFailed,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.IproovFinish]: {
          on: {
            [n.Finish]: {
              target: x.Finish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.Finish,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.NoVerificationMethodsLeft]: {
          on: {
            [n.IdentityFailureNoAttemptsLeft]: {
              target: x.Finish,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.Finish,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.VerificationMethodFailed]: {
          on: {
            [n.Start]: {
              target: x.Start,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.Start,
                shouldStoreNavigationState: !1
              })
            },
            [n.NoVerificationMethodsLeft]: {
              target: x.NoVerificationMethodsLeft,
              actions: re({
                credentialId: e,
                step: T.Facemap,
                substep: x.NoVerificationMethodsLeft,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [x.Finish]: {
          type: "final"
        }
      },
      on: {
        [Aa.NextStep]: r,
        [Aa.PreviousStep]: t
      },
      entry: PIe(e),
      onDone: r
    }
  };
  return {
    credentialId: e,
    actions: n,
    transitions: a
  };
}, KIe = (e) => re({
  credentialId: e,
  step: T.Id,
  substep: Z.Start,
  shouldStoreNavigationState: !1,
  activeScreen: Ot.Workflow
}), un = (e) => ({
  Start: `${e}:id-start`,
  DocTypeDecision: `${e}:id-doctype-decision`,
  DocTypeSelection: `${e}:id-doctype-selection`,
  DocTypeVariantSelection: `${e}:id-doctype-variant-selection`,
  CaptureSourceSelection: `${e}:id-capture-source-selection`,
  CaptureScreenEntry: `${e}:id-capture-screen-entry`,
  CaptureScreen: `${e}:id-capture-screen`,
  CaptureScreenSelectProvider: `${e}:id-capture-screen-select-provider`,
  CaptureScreenSelectProviderAutoCapture: `${e}:id-capture-screen-select-provider-auto-capture`,
  CaptureScreenSelectProviderManualCapture: `${e}:id-capture-screen-select-provider-manual-capture`,
  CaptureScreenAutoCaptureLoadingSuccess: `${e}:id-capture-screen-auto-capture-loading-success`,
  CaptureScreenAutoCaptureLoadingFailure: `${e}:id-capture-screen-auto-capture-loading-failure`,
  CaptureScreenDecision: `${e}:id-capture-screen-decision`,
  CaptureScreenPrepareForRecapturingBack: `${e}:id-capture-prepare-for-recapturing-back`,
  CaptureScreenFrontStart: `${e}:id-capture-screen-front-start`,
  CaptureScreenFront: `${e}:id-capture-screen-front`,
  CaptureScreenFrontFinish: `${e}:id-capture-screen-front-finish`,
  CaptureScreenBackStart: `${e}:id-capture-screen-back-start`,
  CaptureScreenBack: `${e}:id-capture-screen-back`,
  CaptureScreenBackFinish: `${e}:id-capture-screen-back-finish`,
  CaptureScreenComplete: `${e}:id-capture-screen-complete`,
  CaptureScreenUpload: `${e}:id-capture-screen-upload`,
  CaptureScreenUploadFailed: `${e}:id-capture-screen-upload-failed`,
  IdUsabilityCheck: `${e}:id-usability-check`,
  IdUsabilityCheckFailure: `${e}:id-usability-check-failure`,
  IdUsabilityCheckBackMissing: `${e}:id-usability-check-back-missing`,
  IdUsabilityCheckSuccess: `${e}:id-usability-check-success`,
  IdUsabilitySupportedList: `${e}:id-usability-supported-list`,
  IdUsabilityCheckReset: `${e}:id-usability-check-reset`,
  Upload: `${e}:id-upload`,
  Finish: `${e}:id-finish`
}), XIe = ({ credentialId: e, previousStep: t, nextStep: r }) => {
  const n = un(e), a = {
    [e]: {
      initial: Z.Start,
      states: {
        [Z.Start]: {
          on: {
            [n.DocTypeDecision]: {
              target: Z.DocTypeDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.DocTypeDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.DocTypeDecision]: {
          on: {
            [n.DocTypeSelection]: {
              target: Z.DocTypeSelection,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.DocTypeSelection,
                shouldStoreNavigationState: !0
              })
            },
            [n.CaptureSourceSelection]: {
              target: Z.CaptureSourceSelection,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureSourceSelection,
                shouldStoreNavigationState: !0
              })
            },
            [n.DocTypeVariantSelection]: {
              target: Z.DocTypeVariantSelection,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.DocTypeVariantSelection,
                shouldStoreNavigationState: !0
              })
            },
            [n.CaptureScreenEntry]: {
              target: Z.CaptureScreenEntry,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenEntry,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.DocTypeSelection]: {
          on: {
            [n.DocTypeDecision]: {
              target: Z.DocTypeDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.DocTypeDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.DocTypeVariantSelection]: {
          on: {
            [n.DocTypeDecision]: {
              target: Z.DocTypeDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.DocTypeDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureSourceSelection]: {
          on: {
            [n.CaptureScreenEntry]: {
              target: Z.CaptureScreenEntry,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenEntry,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.CaptureScreenEntry]: {
          on: {
            [n.CaptureScreen]: {
              target: Z.CaptureScreen,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreen,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.CaptureScreenPrepareForRecapturingBack]: {
          on: {
            [n.CaptureScreenSelectProvider]: {
              target: Z.CaptureScreenSelectProvider,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenSelectProvider,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreen]: {
          on: {
            [n.CaptureScreenSelectProvider]: {
              target: Z.CaptureScreenSelectProvider,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenSelectProvider,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenSelectProvider]: {
          on: {
            [n.CaptureScreenSelectProviderAutoCapture]: {
              target: Z.CaptureScreenAutoCaptureLoading,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenAutoCaptureLoading,
                shouldStoreNavigationState: !1
              })
            },
            [n.CaptureScreenSelectProviderManualCapture]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenAutoCaptureLoading]: {
          on: {
            [n.CaptureScreenAutoCaptureLoadingSuccess]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            },
            [n.CaptureScreenAutoCaptureLoadingFailure]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenDecision]: {
          on: {
            [n.CaptureScreenFrontStart]: {
              target: Z.CaptureScreenFrontStart,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenFrontStart,
                shouldStoreNavigationState: !1
              })
            },
            [n.CaptureScreenBackStart]: {
              target: Z.CaptureScreenBackStart,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenBackStart,
                shouldStoreNavigationState: !1
              })
            },
            [n.CaptureScreenComplete]: {
              target: Z.CaptureScreenComplete,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenComplete,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenFrontStart]: {
          on: {
            [n.CaptureScreenFront]: {
              target: Z.CaptureScreenFront,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenFront,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.CaptureScreenFront]: {
          on: {
            [n.CaptureScreenFrontFinish]: {
              target: Z.CaptureScreenFrontFinish,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenFrontFinish,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            },
            [n.CaptureScreenDecision]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenFrontFinish]: {
          on: {
            [n.CaptureScreenDecision]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenBackStart]: {
          on: {
            [n.CaptureScreenBack]: {
              target: Z.CaptureScreenBack,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenBack,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.CaptureScreenBack]: {
          on: {
            [n.CaptureScreenBackFinish]: {
              target: Z.CaptureScreenBackFinish,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenBackFinish,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            },
            [n.CaptureScreenDecision]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenBackFinish]: {
          on: {
            [n.CaptureScreenDecision]: {
              target: Z.CaptureScreenDecision,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenDecision,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenComplete]: {
          on: {
            [n.CaptureScreenUpload]: {
              target: Z.CaptureScreenUpload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenUpload,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenUpload]: {
          on: {
            [n.IdUsabilityCheck]: {
              target: Z.IdUsabilityCheck,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilityCheck,
                shouldStoreNavigationState: !1
              })
            },
            [n.CaptureScreenUploadFailed]: {
              target: Z.CaptureScreenUploadFailed,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenUploadFailed,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.CaptureScreenUploadFailed]: {
          on: {
            [n.CaptureScreen]: {
              target: Z.CaptureScreen,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreen,
                shouldStoreNavigationState: !0
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.IdUsabilityCheck]: {
          on: {
            [n.IdUsabilityCheckBackMissing]: {
              target: Z.IdUsabilityCheckBackMissing,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilityCheckBackMissing,
                shouldStoreNavigationState: !1
              })
            },
            [n.IdUsabilityCheckFailure]: {
              target: Z.IdUsabilityCheckFailure,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilityCheckFailure,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.IdUsabilityCheckBackMissing]: {
          on: {
            [n.IdUsabilityCheckSuccess]: {
              target: Z.Finish,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Finish,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !1
              })
            },
            [n.CaptureScreenPrepareForRecapturingBack]: {
              target: Z.CaptureScreenPrepareForRecapturingBack,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenPrepareForRecapturingBack,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.IdUsabilityCheckFailure]: {
          on: {
            [n.IdUsabilityCheckReset]: {
              target: Z.IdUsabilityCheckReset,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilityCheckReset,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            },
            [n.IdUsabilitySupportedList]: {
              target: Z.IdUsabilitySupportedList,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilitySupportedList,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.IdUsabilitySupportedList]: {
          on: {
            [n.IdUsabilityCheckReset]: {
              target: Z.IdUsabilityCheckReset,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilityCheckReset,
                shouldStoreNavigationState: !1
              })
            },
            [n.Upload]: {
              target: Z.Upload,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.Upload,
                shouldStoreNavigationState: !0
              })
            }
          }
        },
        [Z.IdUsabilityCheckReset]: {
          on: {
            [n.CaptureScreenSelectProvider]: {
              target: Z.CaptureScreenSelectProvider,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.CaptureScreenSelectProvider,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.Upload]: {
          on: {
            [n.IdUsabilityCheck]: {
              target: Z.IdUsabilityCheck,
              actions: re({
                credentialId: e,
                step: T.Id,
                substep: Z.IdUsabilityCheck,
                shouldStoreNavigationState: !1
              })
            }
          }
        },
        [Z.Finish]: {
          type: "final"
        }
      },
      on: {
        [Aa.NextStep]: r,
        [Aa.PreviousStep]: t
      },
      entry: KIe(e),
      onDone: r
    }
  };
  return {
    credentialId: e,
    actions: n,
    transitions: a
  };
}, $E = () => ({
  Start: "start-screen-start",
  ConsentScreen: "start-screen-consent-screen",
  ProvideConsent: "start-screen-provide-consent",
  Finish: "start-screen-finish"
});
function zIe({ credentialId: e }) {
  const t = $E();
  return {
    [Me.Start]: {
      initial: In.Start,
      states: {
        [In.Start]: {
          on: {
            [t.ConsentScreen]: {
              target: In.ConsentScreen,
              actions: {
                type: "setWorkflowStep",
                params: {
                  credentialId: e,
                  step: Me.Start,
                  substep: In.ConsentScreen,
                  shouldStoreNavigationState: !0,
                  activeScreen: Ot.Workflow
                }
              }
            },
            [t.Finish]: {
              target: In.Finish,
              actions: {
                type: "setWorkflowStep",
                params: {
                  credentialId: e,
                  step: Me.Start,
                  substep: In.Finish,
                  shouldStoreNavigationState: !1,
                  activeScreen: Ot.Workflow
                }
              }
            }
          }
        },
        [In.ConsentScreen]: {
          on: {
            [t.ProvideConsent]: {
              target: In.Finish,
              actions: {
                type: "setWorkflowStep",
                params: {
                  credentialId: void 0,
                  step: Me.Start,
                  substep: In.Finish,
                  shouldStoreNavigationState: !1,
                  activeScreen: Ot.Workflow
                }
              }
            }
          }
        },
        [In.Finish]: {
          type: "final"
        }
      },
      on: {
        [Aa.NextStep]: {
          target: e,
          actions: {
            type: "setWorkflowStep",
            params: {
              credentialId: e,
              step: Me.Start,
              substep: In.Finish,
              shouldStoreNavigationState: !1,
              activeScreen: Ot.Workflow
            }
          }
        }
      },
      onDone: {
        target: e,
        actions: {
          type: "setWorkflowStep",
          params: {
            credentialId: e,
            step: Me.Start,
            substep: In.Finish,
            shouldStoreNavigationState: !1,
            activeScreen: Ot.Workflow
          }
        }
      }
    }
  };
}
function qIe() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function eCe() {
  const e = qIe();
  if (e.__xstate__)
    return e.__xstate__;
}
const tCe = (e) => {
  if (typeof window > "u")
    return;
  const t = eCe();
  t && t.register(e);
};
class zD {
  constructor(t) {
    this._process = t, this._active = !1, this._current = null, this._last = null;
  }
  start() {
    this._active = !0, this.flush();
  }
  clear() {
    this._current && (this._current.next = null, this._last = this._current);
  }
  enqueue(t) {
    const r = {
      value: t,
      next: null
    };
    if (this._current) {
      this._last.next = r, this._last = r;
      return;
    }
    this._current = r, this._last = r, this._active && this.flush();
  }
  flush() {
    for (; this._current; ) {
      const t = this._current;
      this._process(t.value), this._current = t.next;
    }
    this._last = null;
  }
}
const vL = ".", rCe = "", SL = "", nCe = "#", aCe = "*", IL = "xstate.init", iCe = "xstate.error", cN = "xstate.stop";
function oCe(e, t) {
  return {
    type: `xstate.after.${e}.${t}`
  };
}
function dN(e, t) {
  return {
    type: `xstate.done.state.${e}`,
    output: t
  };
}
function sCe(e, t) {
  return {
    type: `xstate.done.actor.${e}`,
    output: t,
    actorId: e
  };
}
function CL(e, t) {
  return {
    type: `xstate.error.actor.${e}`,
    error: t,
    actorId: e
  };
}
function bL(e) {
  return {
    type: IL,
    input: e
  };
}
function _s(e) {
  setTimeout(() => {
    throw e;
  });
}
const lCe = typeof Symbol == "function" && Symbol.observable || "@@observable";
function yL(e, t) {
  const r = qD(e), n = qD(t);
  return typeof n == "string" ? typeof r == "string" ? n === r : !1 : typeof r == "string" ? r in n : Object.keys(r).every((a) => a in n ? yL(r[a], n[a]) : !1);
}
function KE(e) {
  if (AL(e))
    return e;
  let t = [], r = "";
  for (let n = 0; n < e.length; n++) {
    switch (e.charCodeAt(n)) {
      case 92:
        r += e[n + 1], n++;
        continue;
      case 46:
        t.push(r), r = "";
        continue;
    }
    r += e[n];
  }
  return t.push(r), t;
}
function qD(e) {
  if (VCe(e))
    return e.value;
  if (typeof e != "string")
    return e;
  const t = KE(e);
  return cCe(t);
}
function cCe(e) {
  if (e.length === 1)
    return e[0];
  const t = {};
  let r = t;
  for (let n = 0; n < e.length - 1; n++)
    if (n === e.length - 2)
      r[e[n]] = e[n + 1];
    else {
      const a = r;
      r = {}, a[e[n]] = r;
    }
  return t;
}
function eJ(e, t) {
  const r = {}, n = Object.keys(e);
  for (let a = 0; a < n.length; a++) {
    const i = n[a];
    r[i] = t(e[i], i, e, a);
  }
  return r;
}
function wL(e) {
  return AL(e) ? e : [e];
}
function vc(e) {
  return e === void 0 ? [] : wL(e);
}
function uN(e, t, r, n) {
  return typeof e == "function" ? e({
    context: t,
    event: r,
    self: n
  }) : e;
}
function AL(e) {
  return Array.isArray(e);
}
function dCe(e) {
  return e.type.startsWith("xstate.error.actor");
}
function Wh(e) {
  return wL(e).map((t) => typeof t > "u" || typeof t == "string" ? {
    target: t
  } : t);
}
function UL(e) {
  if (!(e === void 0 || e === rCe))
    return vc(e);
}
function hN(e, t, r) {
  var i, o, s;
  const n = typeof e == "object", a = n ? e : void 0;
  return {
    next: (i = n ? e.next : e) == null ? void 0 : i.bind(a),
    error: (o = n ? e.error : t) == null ? void 0 : o.bind(a),
    complete: (s = n ? e.complete : r) == null ? void 0 : s.bind(a)
  };
}
function tJ(e, t) {
  return `${t}.${e}`;
}
function XE(e, t) {
  const r = t.match(/^xstate\.invoke\.(\d+)\.(.*)/);
  if (!r)
    return e.implementations.actors[t];
  const [, n, a] = r, o = e.getStateNodeById(a).config.invoke;
  return (Array.isArray(o) ? o[n] : o).src;
}
function rJ(e, t) {
  return `${e.sessionId}.${t}`;
}
let uCe = 0;
function hCe(e, t) {
  const r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new Set(), o = {}, {
    clock: s,
    logger: c
  } = t, l = {
    schedule: (p, m, I, C, A = Math.random().toString(36).slice(2)) => {
      const U = {
        source: p,
        target: m,
        event: I,
        delay: C,
        id: A,
        startedAt: Date.now()
      }, B = rJ(p, A);
      g._snapshot._scheduledEvents[B] = U;
      const J = s.setTimeout(() => {
        delete o[B], delete g._snapshot._scheduledEvents[B], g._relay(p, m, I);
      }, C);
      o[B] = J;
    },
    cancel: (p, m) => {
      const I = rJ(p, m), C = o[I];
      delete o[I], delete g._snapshot._scheduledEvents[I], C !== void 0 && s.clearTimeout(C);
    },
    cancelAll: (p) => {
      for (const m in g._snapshot._scheduledEvents) {
        const I = g._snapshot._scheduledEvents[m];
        I.source === p && l.cancel(p, I.id);
      }
    }
  }, u = (p) => {
    if (!i.size)
      return;
    const m = {
      ...p,
      rootId: e.sessionId
    };
    i.forEach((I) => {
      var C;
      return (C = I.next) == null ? void 0 : C.call(I, m);
    });
  }, g = {
    _snapshot: {
      _scheduledEvents: ((t == null ? void 0 : t.snapshot) && t.snapshot.scheduler) ?? {}
    },
    _bookId: () => `x:${uCe++}`,
    _register: (p, m) => (r.set(p, m), p),
    _unregister: (p) => {
      r.delete(p.sessionId);
      const m = a.get(p);
      m !== void 0 && (n.delete(m), a.delete(p));
    },
    get: (p) => n.get(p),
    _set: (p, m) => {
      const I = n.get(p);
      if (I && I !== m)
        throw new Error(`Actor with system ID '${p}' already exists.`);
      n.set(p, m), a.set(m, p);
    },
    inspect: (p) => {
      const m = hN(p);
      return i.add(m), {
        unsubscribe() {
          i.delete(m);
        }
      };
    },
    _sendInspectionEvent: u,
    _relay: (p, m, I) => {
      g._sendInspectionEvent({
        type: "@xstate.event",
        sourceRef: p,
        actorRef: m,
        event: I
      }), m._send(I);
    },
    scheduler: l,
    getSnapshot: () => ({
      _scheduledEvents: {
        ...g._snapshot._scheduledEvents
      }
    }),
    start: () => {
      const p = g._snapshot._scheduledEvents;
      g._snapshot._scheduledEvents = {};
      for (const m in p) {
        const {
          source: I,
          target: C,
          event: A,
          delay: U,
          id: B
        } = p[m];
        l.schedule(I, C, A, U, B);
      }
    },
    _clock: s,
    _logger: c
  };
  return g;
}
const zE = 1;
let Mn = /* @__PURE__ */ function(e) {
  return e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped", e;
}({});
const pCe = {
  clock: {
    setTimeout: (e, t) => setTimeout(e, t),
    clearTimeout: (e) => clearTimeout(e)
  },
  logger: console.log.bind(console),
  devTools: !1
};
class gCe {
  /**
   * Creates a new actor instance for the given logic with the provided options,
   * if any.
   *
   * @param logic The logic to create an actor from
   * @param options Actor options
   */
  constructor(t, r) {
    this.logic = t, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new zD(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = Mn.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this._systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
    const n = {
      ...pCe,
      ...r
    }, {
      clock: a,
      logger: i,
      parent: o,
      syncSnapshot: s,
      id: c,
      systemId: l,
      inspect: u
    } = n;
    this.system = o ? o.system : hCe(this, {
      clock: a,
      logger: i
    }), u && !o && this.system.inspect(hN(u)), this.sessionId = this.system._bookId(), this.id = c ?? this.sessionId, this.logger = (r == null ? void 0 : r.logger) ?? this.system._logger, this.clock = (r == null ? void 0 : r.clock) ?? this.system._clock, this._parent = o, this._syncSnapshot = s, this.options = n, this.src = n.src ?? t, this.ref = this, this._actorScope = {
      self: this,
      id: this.id,
      sessionId: this.sessionId,
      logger: this.logger,
      defer: (g) => {
        this._deferred.push(g);
      },
      system: this.system,
      stopChild: (g) => {
        if (g._parent !== this)
          throw new Error(`Cannot stop child actor ${g.id} of ${this.id} because it is not a child`);
        g._stop();
      },
      emit: (g) => {
        const p = this.eventListeners.get(g.type), m = this.eventListeners.get("*");
        if (!p && !m)
          return;
        const I = /* @__PURE__ */ new Set([...p ? p.values() : [], ...m ? m.values() : []]);
        for (const C of Array.from(I))
          C(g);
      }
    }, this.send = this.send.bind(this), this.system._sendInspectionEvent({
      type: "@xstate.actor",
      actorRef: this
    }), l && (this._systemId = l, this.system._set(l, this)), this._initState((r == null ? void 0 : r.snapshot) ?? (r == null ? void 0 : r.state)), l && this._snapshot.status !== "active" && this.system._unregister(this);
  }
  _initState(t) {
    var r;
    try {
      this._snapshot = t ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(t, this._actorScope) : t : this.logic.getInitialSnapshot(this._actorScope, (r = this.options) == null ? void 0 : r.input);
    } catch (n) {
      this._snapshot = {
        status: "error",
        output: void 0,
        error: n
      };
    }
  }
  update(t, r) {
    var a, i;
    this._snapshot = t;
    let n;
    for (; n = this._deferred.shift(); )
      try {
        n();
      } catch (o) {
        this._deferred.length = 0, this._snapshot = {
          ...t,
          status: "error",
          error: o
        };
      }
    switch (this._snapshot.status) {
      case "active":
        for (const o of this.observers)
          try {
            (a = o.next) == null || a.call(o, t);
          } catch (s) {
            _s(s);
          }
        break;
      case "done":
        for (const o of this.observers)
          try {
            (i = o.next) == null || i.call(o, t);
          } catch (s) {
            _s(s);
          }
        this._stopProcedure(), this._complete(), this._doneEvent = sCe(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
        break;
      case "error":
        this._error(this._snapshot.error);
        break;
    }
    this.system._sendInspectionEvent({
      type: "@xstate.snapshot",
      actorRef: this,
      event: r,
      snapshot: t
    });
  }
  /**
   * Subscribe an observer to an actor’s snapshot values.
   *
   * @remarks
   * The observer will receive the actor’s snapshot value when it is emitted.
   * The observer can be:
   *
   * - A plain function that receives the latest snapshot, or
   * - An observer object whose `.next(snapshot)` method receives the latest
   *   snapshot
   *
   * @example
   *
   * ```ts
   * // Observer as a plain function
   * const subscription = actor.subscribe((snapshot) => {
   *   console.log(snapshot);
   * });
   * ```
   *
   * @example
   *
   * ```ts
   * // Observer as an object
   * const subscription = actor.subscribe({
   *   next(snapshot) {
   *     console.log(snapshot);
   *   },
   *   error(err) {
   *     // ...
   *   },
   *   complete() {
   *     // ...
   *   }
   * });
   * ```
   *
   * The return value of `actor.subscribe(observer)` is a subscription object
   * that has an `.unsubscribe()` method. You can call
   * `subscription.unsubscribe()` to unsubscribe the observer:
   *
   * @example
   *
   * ```ts
   * const subscription = actor.subscribe((snapshot) => {
   *   // ...
   * });
   *
   * // Unsubscribe the observer
   * subscription.unsubscribe();
   * ```
   *
   * When the actor is stopped, all of its observers will automatically be
   * unsubscribed.
   *
   * @param observer - Either a plain function that receives the latest
   *   snapshot, or an observer object whose `.next(snapshot)` method receives
   *   the latest snapshot
   */
  subscribe(t, r, n) {
    var i;
    const a = hN(t, r, n);
    if (this._processingStatus !== Mn.Stopped)
      this.observers.add(a);
    else
      switch (this._snapshot.status) {
        case "done":
          try {
            (i = a.complete) == null || i.call(a);
          } catch (o) {
            _s(o);
          }
          break;
        case "error": {
          const o = this._snapshot.error;
          if (!a.error)
            _s(o);
          else
            try {
              a.error(o);
            } catch (s) {
              _s(s);
            }
          break;
        }
      }
    return {
      unsubscribe: () => {
        this.observers.delete(a);
      }
    };
  }
  on(t, r) {
    let n = this.eventListeners.get(t);
    n || (n = /* @__PURE__ */ new Set(), this.eventListeners.set(t, n));
    const a = r.bind(void 0);
    return n.add(a), {
      unsubscribe: () => {
        n.delete(a);
      }
    };
  }
  /** Starts the Actor from the initial state */
  start() {
    if (this._processingStatus === Mn.Running)
      return this;
    this._syncSnapshot && this.subscribe({
      next: (n) => {
        n.status === "active" && this.system._relay(this, this._parent, {
          type: `xstate.snapshot.${this.id}`,
          snapshot: n
        });
      },
      error: () => {
      }
    }), this.system._register(this.sessionId, this), this._systemId && this.system._set(this._systemId, this), this._processingStatus = Mn.Running;
    const t = bL(this.options.input);
    switch (this.system._sendInspectionEvent({
      type: "@xstate.event",
      sourceRef: this._parent,
      actorRef: this,
      event: t
    }), this._snapshot.status) {
      case "done":
        return this.update(this._snapshot, t), this;
      case "error":
        return this._error(this._snapshot.error), this;
    }
    if (this._parent || this.system.start(), this.logic.start)
      try {
        this.logic.start(this._snapshot, this._actorScope);
      } catch (n) {
        return this._snapshot = {
          ...this._snapshot,
          status: "error",
          error: n
        }, this._error(n), this;
      }
    return this.update(this._snapshot, t), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
  }
  _process(t) {
    let r, n;
    try {
      r = this.logic.transition(this._snapshot, t, this._actorScope);
    } catch (a) {
      n = {
        err: a
      };
    }
    if (n) {
      const {
        err: a
      } = n;
      this._snapshot = {
        ...this._snapshot,
        status: "error",
        error: a
      }, this._error(a);
      return;
    }
    this.update(r, t), t.type === cN && (this._stopProcedure(), this._complete());
  }
  _stop() {
    return this._processingStatus === Mn.Stopped ? this : (this.mailbox.clear(), this._processingStatus === Mn.NotStarted ? (this._processingStatus = Mn.Stopped, this) : (this.mailbox.enqueue({
      type: cN
    }), this));
  }
  /** Stops the Actor and unsubscribe all listeners. */
  stop() {
    if (this._parent)
      throw new Error("A non-root actor cannot be stopped directly.");
    return this._stop();
  }
  _complete() {
    var t;
    for (const r of this.observers)
      try {
        (t = r.complete) == null || t.call(r);
      } catch (n) {
        _s(n);
      }
    this.observers.clear();
  }
  _reportError(t) {
    if (!this.observers.size) {
      this._parent || _s(t);
      return;
    }
    let r = !1;
    for (const n of this.observers) {
      const a = n.error;
      r || (r = !a);
      try {
        a == null || a(t);
      } catch (i) {
        _s(i);
      }
    }
    this.observers.clear(), r && _s(t);
  }
  _error(t) {
    this._stopProcedure(), this._reportError(t), this._parent && this.system._relay(this, this._parent, CL(this.id, t));
  }
  // TODO: atm children don't belong entirely to the actor so
  // in a way - it's not even super aware of them
  // so we can't stop them from here but we really should!
  // right now, they are being stopped within the machine's transition
  // but that could throw and leave us with "orphaned" active actors
  _stopProcedure() {
    return this._processingStatus !== Mn.Running ? this : (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new zD(this._process.bind(this)), this._processingStatus = Mn.Stopped, this.system._unregister(this), this);
  }
  /** @internal */
  _send(t) {
    this._processingStatus !== Mn.Stopped && this.mailbox.enqueue(t);
  }
  /**
   * Sends an event to the running Actor to trigger a transition.
   *
   * @param event The event to send
   */
  send(t) {
    this.system._relay(void 0, this, t);
  }
  attachDevTools() {
    const {
      devTools: t
    } = this.options;
    t && (typeof t == "function" ? t : tCe)(this);
  }
  toJSON() {
    return {
      xstate$$type: zE,
      id: this.id
    };
  }
  /**
   * Obtain the internal state of the actor, which can be persisted.
   *
   * @remarks
   * The internal state can be persisted from any actor, not only machines.
   *
   * Note that the persisted state is not the same as the snapshot from
   * {@link Actor.getSnapshot}. Persisted state represents the internal state of
   * the actor, while snapshots represent the actor's last emitted value.
   *
   * Can be restored with {@link ActorOptions.state}
   * @see https://stately.ai/docs/persistence
   */
  getPersistedSnapshot(t) {
    return this.logic.getPersistedSnapshot(this._snapshot, t);
  }
  [lCe]() {
    return this;
  }
  /**
   * Read an actor’s snapshot synchronously.
   *
   * @remarks
   * The snapshot represent an actor's last emitted value.
   *
   * When an actor receives an event, its internal state may change. An actor
   * may emit a snapshot when a state transition occurs.
   *
   * Note that some actors, such as callback actors generated with
   * `fromCallback`, will not emit snapshots.
   * @see {@link Actor.subscribe} to subscribe to an actor’s snapshot values.
   * @see {@link Actor.getPersistedSnapshot} to persist the internal state of an actor (which is more than just a snapshot).
   */
  getSnapshot() {
    return this._snapshot;
  }
}
function xm(e, ...[t]) {
  return new gCe(e, t);
}
function fCe(e, t, r, n, {
  sendId: a
}) {
  const i = typeof a == "function" ? a(r, n) : a;
  return [t, i];
}
function mCe(e, t) {
  e.defer(() => {
    e.system.scheduler.cancel(e.self, t);
  });
}
function kL(e) {
  function t(r, n) {
  }
  return t.type = "xstate.cancel", t.sendId = e, t.resolve = fCe, t.execute = mCe, t;
}
function vCe(e, t, r, n, {
  id: a,
  systemId: i,
  src: o,
  input: s,
  syncSnapshot: c
}) {
  const l = typeof o == "string" ? XE(t.machine, o) : o, u = typeof a == "function" ? a(r) : a;
  let g;
  return l && (g = xm(l, {
    id: u,
    src: o,
    parent: e.self,
    syncSnapshot: c,
    systemId: i,
    input: typeof s == "function" ? s({
      context: t.context,
      event: r.event,
      self: e.self
    }) : s
  })), [Mu(t, {
    children: {
      ...t.children,
      [u]: g
    }
  }), {
    id: a,
    actorRef: g
  }];
}
function SCe(e, {
  id: t,
  actorRef: r
}) {
  r && e.defer(() => {
    r._processingStatus !== Mn.Stopped && r.start();
  });
}
function _L(...[e, {
  id: t,
  systemId: r,
  input: n,
  syncSnapshot: a = !1
} = {}]) {
  function i(o, s) {
  }
  return i.type = "snapshot.spawnChild", i.id = t, i.systemId = r, i.src = e, i.input = n, i.syncSnapshot = a, i.resolve = vCe, i.execute = SCe, i;
}
function ICe(e, t, r, n, {
  actorRef: a
}) {
  const i = typeof a == "function" ? a(r, n) : a, o = typeof i == "string" ? t.children[i] : i;
  let s = t.children;
  return o && (s = {
    ...s
  }, delete s[o.id]), [Mu(t, {
    children: s
  }), o];
}
function CCe(e, t) {
  if (t) {
    if (e.system._unregister(t), t._processingStatus !== Mn.Running) {
      e.stopChild(t);
      return;
    }
    e.defer(() => {
      e.stopChild(t);
    });
  }
}
function qE(e) {
  function t(r, n) {
  }
  return t.type = "xstate.stopChild", t.actorRef = e, t.resolve = ICe, t.execute = CCe, t;
}
function Iw(e, t, r, n) {
  const {
    machine: a
  } = n, i = typeof e == "function", o = i ? e : a.implementations.guards[typeof e == "string" ? e : e.type];
  if (!i && !o)
    throw new Error(`Guard '${typeof e == "string" ? e : e.type}' is not implemented.'.`);
  if (typeof o != "function")
    return Iw(o, t, r, n);
  const s = {
    context: t,
    event: r
  }, c = i || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
    context: t,
    event: r
  }) : e.params : void 0;
  return "check" in o ? o.check(
    n,
    s,
    o
    // this holds all params
  ) : o(s, c);
}
const eQ = (e) => e.type === "atomic" || e.type === "final";
function gg(e) {
  return Object.values(e.states).filter((t) => t.type !== "history");
}
function MS(e, t) {
  const r = [];
  if (t === e)
    return r;
  let n = e.parent;
  for (; n && n !== t; )
    r.push(n), n = n.parent;
  return r;
}
function X1(e) {
  const t = new Set(e), r = ZL(t);
  for (const n of t)
    if (n.type === "compound" && (!r.get(n) || !r.get(n).length))
      nJ(n).forEach((a) => t.add(a));
    else if (n.type === "parallel") {
      for (const a of gg(n))
        if (a.type !== "history" && !t.has(a)) {
          const i = nJ(a);
          for (const o of i)
            t.add(o);
        }
    }
  for (const n of t) {
    let a = n.parent;
    for (; a; )
      t.add(a), a = a.parent;
  }
  return t;
}
function NL(e, t) {
  const r = t.get(e);
  if (!r)
    return {};
  if (e.type === "compound") {
    const a = r[0];
    if (a) {
      if (eQ(a))
        return a.key;
    } else
      return {};
  }
  const n = {};
  for (const a of r)
    n[a.key] = NL(a, t);
  return n;
}
function ZL(e) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    t.has(r) || t.set(r, []), r.parent && (t.has(r.parent) || t.set(r.parent, []), t.get(r.parent).push(r));
  return t;
}
function BL(e, t) {
  const r = X1(t);
  return NL(e, ZL(r));
}
function tQ(e, t) {
  return t.type === "compound" ? gg(t).some((r) => r.type === "final" && e.has(r)) : t.type === "parallel" ? gg(t).every((r) => tQ(e, r)) : t.type === "final";
}
const Cw = (e) => e[0] === nCe;
function bCe(e, t) {
  return e.transitions.get(t) || [...e.transitions.keys()].filter((n) => {
    if (n === aCe)
      return !0;
    if (!n.endsWith(".*"))
      return !1;
    const a = n.split("."), i = t.split(".");
    for (let o = 0; o < a.length; o++) {
      const s = a[o], c = i[o];
      if (s === "*")
        return o === a.length - 1;
      if (s !== c)
        return !1;
    }
    return !0;
  }).sort((n, a) => a.length - n.length).flatMap((n) => e.transitions.get(n));
}
function yCe(e) {
  const t = e.config.after;
  if (!t)
    return [];
  const r = (a, i) => {
    const o = oCe(a, e.id), s = o.type;
    return e.entry.push(JL(o, {
      id: s,
      delay: a
    })), e.exit.push(kL(s)), s;
  };
  return Object.keys(t).flatMap((a, i) => {
    const o = t[a], s = typeof o == "string" ? {
      target: o
    } : o, c = Number.isNaN(+a) ? a : +a, l = r(c);
    return vc(s).map((u) => ({
      ...u,
      event: l,
      delay: c
    }));
  }).map((a) => {
    const {
      delay: i
    } = a;
    return {
      ...Md(e, a.event, a),
      delay: i
    };
  });
}
function Md(e, t, r) {
  const n = UL(r.target), a = r.reenter ?? !1, i = UCe(e, n), o = {
    ...r,
    actions: vc(r.actions),
    guard: r.guard,
    target: i,
    source: e,
    reenter: a,
    eventType: t,
    toJSON: () => ({
      ...o,
      source: `#${e.id}`,
      target: i ? i.map((s) => `#${s.id}`) : void 0
    })
  };
  return o;
}
function wCe(e) {
  const t = /* @__PURE__ */ new Map();
  if (e.config.on)
    for (const r of Object.keys(e.config.on)) {
      if (r === SL)
        throw new Error('Null events ("") cannot be specified as a transition key. Use `always: { ... }` instead.');
      const n = e.config.on[r];
      t.set(r, Wh(n).map((a) => Md(e, r, a)));
    }
  if (e.config.onDone) {
    const r = `xstate.done.state.${e.id}`;
    t.set(r, Wh(e.config.onDone).map((n) => Md(e, r, n)));
  }
  for (const r of e.invoke) {
    if (r.onDone) {
      const n = `xstate.done.actor.${r.id}`;
      t.set(n, Wh(r.onDone).map((a) => Md(e, n, a)));
    }
    if (r.onError) {
      const n = `xstate.error.actor.${r.id}`;
      t.set(n, Wh(r.onError).map((a) => Md(e, n, a)));
    }
    if (r.onSnapshot) {
      const n = `xstate.snapshot.${r.id}`;
      t.set(n, Wh(r.onSnapshot).map((a) => Md(e, n, a)));
    }
  }
  for (const r of e.after) {
    let n = t.get(r.eventType);
    n || (n = [], t.set(r.eventType, n)), n.push(r);
  }
  return t;
}
function ACe(e, t) {
  const r = typeof t == "string" ? e.states[t] : t ? e.states[t.target] : void 0;
  if (!r && t)
    throw new Error(`Initial state node "${t}" not found on parent state node #${e.id}`);
  const n = {
    source: e,
    actions: !t || typeof t == "string" ? [] : vc(t.actions),
    eventType: null,
    reenter: !1,
    target: r ? [r] : [],
    toJSON: () => ({
      ...n,
      source: `#${e.id}`,
      target: r ? [`#${r.id}`] : []
    })
  };
  return n;
}
function UCe(e, t) {
  if (t !== void 0)
    return t.map((r) => {
      if (typeof r != "string")
        return r;
      if (Cw(r))
        return e.machine.getStateNodeById(r);
      const n = r[0] === vL;
      if (n && !e.parent)
        return z1(e, r.slice(1));
      const a = n ? e.key + r : r;
      if (e.parent)
        try {
          return z1(e.parent, a);
        } catch (i) {
          throw new Error(`Invalid transition definition for state node '${e.id}':
${i.message}`);
        }
      else
        throw new Error(`Invalid target: "${r}" is not a valid target from the root node. Did you mean ".${r}"?`);
    });
}
function WL(e) {
  const t = UL(e.config.target);
  return t ? {
    target: t.map((r) => typeof r == "string" ? z1(e.parent, r) : r)
  } : e.parent.initial;
}
function Xd(e) {
  return e.type === "history";
}
function nJ(e) {
  const t = EL(e);
  for (const r of t)
    for (const n of MS(r, e))
      t.add(n);
  return t;
}
function EL(e) {
  const t = /* @__PURE__ */ new Set();
  function r(n) {
    if (!t.has(n)) {
      if (t.add(n), n.type === "compound")
        r(n.initial.target[0]);
      else if (n.type === "parallel")
        for (const a of gg(n))
          r(a);
    }
  }
  return r(e), t;
}
function fg(e, t) {
  if (Cw(t))
    return e.machine.getStateNodeById(t);
  if (!e.states)
    throw new Error(`Unable to retrieve child state '${t}' from '${e.id}'; no child states exist.`);
  const r = e.states[t];
  if (!r)
    throw new Error(`Child state '${t}' does not exist on '${e.id}'`);
  return r;
}
function z1(e, t) {
  if (typeof t == "string" && Cw(t))
    try {
      return e.machine.getStateNodeById(t);
    } catch {
    }
  const r = KE(t).slice();
  let n = e;
  for (; r.length; ) {
    const a = r.shift();
    if (!a.length)
      break;
    n = fg(n, a);
  }
  return n;
}
function q1(e, t) {
  if (typeof t == "string") {
    const a = e.states[t];
    if (!a)
      throw new Error(`State '${t}' does not exist on '${e.id}'`);
    return [e, a];
  }
  const r = Object.keys(t), n = r.map((a) => fg(e, a)).filter(Boolean);
  return [e.machine.root, e].concat(n, r.reduce((a, i) => {
    const o = fg(e, i);
    if (!o)
      return a;
    const s = q1(o, t[i]);
    return a.concat(s);
  }, []));
}
function kCe(e, t, r, n) {
  const i = fg(e, t).next(r, n);
  return !i || !i.length ? e.next(r, n) : i;
}
function _Ce(e, t, r, n) {
  const a = Object.keys(t), i = fg(e, a[0]), o = rQ(i, t[a[0]], r, n);
  return !o || !o.length ? e.next(r, n) : o;
}
function NCe(e, t, r, n) {
  const a = [];
  for (const i of Object.keys(t)) {
    const o = t[i];
    if (!o)
      continue;
    const s = fg(e, i), c = rQ(s, o, r, n);
    c && a.push(...c);
  }
  return a.length ? a : e.next(r, n);
}
function rQ(e, t, r, n) {
  return typeof t == "string" ? kCe(e, t, r, n) : Object.keys(t).length === 1 ? _Ce(e, t, r, n) : NCe(e, t, r, n);
}
function ZCe(e) {
  return Object.keys(e.states).map((t) => e.states[t]).filter((t) => t.type === "history");
}
function Vc(e, t) {
  let r = e;
  for (; r.parent && r.parent !== t; )
    r = r.parent;
  return r.parent === t;
}
function BCe(e, t) {
  const r = new Set(e), n = new Set(t);
  for (const a of r)
    if (n.has(a))
      return !0;
  for (const a of n)
    if (r.has(a))
      return !0;
  return !1;
}
function QL(e, t, r) {
  const n = /* @__PURE__ */ new Set();
  for (const a of e) {
    let i = !1;
    const o = /* @__PURE__ */ new Set();
    for (const s of n)
      if (BCe(pN([a], t, r), pN([s], t, r)))
        if (Vc(a.source, s.source))
          o.add(s);
        else {
          i = !0;
          break;
        }
    if (!i) {
      for (const s of o)
        n.delete(s);
      n.add(a);
    }
  }
  return Array.from(n);
}
function WCe(e) {
  const [t, ...r] = e;
  for (const n of MS(t, void 0))
    if (r.every((a) => Vc(a, n)))
      return n;
}
function nQ(e, t) {
  if (!e.target)
    return [];
  const r = /* @__PURE__ */ new Set();
  for (const n of e.target)
    if (Xd(n))
      if (t[n.id])
        for (const a of t[n.id])
          r.add(a);
      else
        for (const a of nQ(WL(n), t))
          r.add(a);
    else
      r.add(n);
  return [...r];
}
function FL(e, t) {
  const r = nQ(e, t);
  if (!r)
    return;
  if (!e.reenter && r.every((a) => a === e.source || Vc(a, e.source)))
    return e.source;
  const n = WCe(r.concat(e.source));
  if (n)
    return n;
  if (!e.reenter)
    return e.source.machine.root;
}
function pN(e, t, r) {
  var a;
  const n = /* @__PURE__ */ new Set();
  for (const i of e)
    if ((a = i.target) != null && a.length) {
      const o = FL(i, r);
      i.reenter && i.source === o && n.add(o);
      for (const s of t)
        Vc(s, o) && n.add(s);
    }
  return [...n];
}
function ECe(e, t) {
  if (e.length !== t.size)
    return !1;
  for (const r of e)
    if (!t.has(r))
      return !1;
  return !0;
}
function gN(e, t, r, n, a, i) {
  if (!e.length)
    return t;
  const o = new Set(t._nodes);
  let s = t.historyValue;
  const c = QL(e, o, s);
  let l = t;
  a || ([l, s] = RCe(l, n, r, c, o, s, i)), l = mg(l, n, r, c.flatMap((g) => g.actions), i), l = FCe(l, n, r, c, o, i, s, a);
  const u = [...o];
  l.status === "done" && (l = mg(l, n, r, u.sort((g, p) => p.order - g.order).flatMap((g) => g.exit), i));
  try {
    return s === t.historyValue && ECe(t._nodes, o) ? l : Mu(l, {
      _nodes: u,
      historyValue: s
    });
  } catch (g) {
    throw g;
  }
}
function QCe(e, t, r, n, a) {
  if (n.output === void 0)
    return;
  const i = dN(a.id, a.output !== void 0 && a.parent ? uN(a.output, e.context, t, r.self) : void 0);
  return uN(n.output, e.context, i, r.self);
}
function FCe(e, t, r, n, a, i, o, s) {
  let c = e;
  const l = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
  TCe(n, o, u, l), s && u.add(e.machine.root);
  const g = /* @__PURE__ */ new Set();
  for (const p of [...l].sort((m, I) => m.order - I.order)) {
    a.add(p);
    const m = [];
    m.push(...p.entry);
    for (const I of p.invoke)
      m.push(_L(I.src, {
        ...I,
        syncSnapshot: !!I.onSnapshot
      }));
    if (u.has(p)) {
      const I = p.initial.actions;
      m.push(...I);
    }
    if (c = mg(c, t, r, m, i, p.invoke.map((I) => I.id)), p.type === "final") {
      const I = p.parent;
      let C = (I == null ? void 0 : I.type) === "parallel" ? I : I == null ? void 0 : I.parent, A = C || p;
      for ((I == null ? void 0 : I.type) === "compound" && i.push(dN(I.id, p.output !== void 0 ? uN(p.output, c.context, t, r.self) : void 0)); (C == null ? void 0 : C.type) === "parallel" && !g.has(C) && tQ(a, C); )
        g.add(C), i.push(dN(C.id)), A = C, C = C.parent;
      if (C)
        continue;
      c = Mu(c, {
        status: "done",
        output: QCe(c, t, r, c.machine.root, A)
      });
    }
  }
  return c;
}
function TCe(e, t, r, n) {
  for (const a of e) {
    const i = FL(a, t);
    for (const s of a.target || [])
      !Xd(s) && // if the target is different than the source then it will *definitely* be entered
      (a.source !== s || // we know that the domain can't lie within the source
      // if it's different than the source then it's outside of it and it means that the target has to be entered as well
      a.source !== i || // reentering transitions always enter the target, even if it's the source itself
      a.reenter) && (n.add(s), r.add(s)), Kh(s, t, r, n);
    const o = nQ(a, t);
    for (const s of o) {
      const c = MS(s, i);
      (i == null ? void 0 : i.type) === "parallel" && c.push(i), TL(n, t, r, c, !a.source.parent && a.reenter ? void 0 : i);
    }
  }
}
function Kh(e, t, r, n) {
  var a;
  if (Xd(e))
    if (t[e.id]) {
      const i = t[e.id];
      for (const o of i)
        n.add(o), Kh(o, t, r, n);
      for (const o of i)
        QU(o, e.parent, n, t, r);
    } else {
      const i = WL(e);
      for (const o of i.target)
        n.add(o), i === ((a = e.parent) == null ? void 0 : a.initial) && r.add(e.parent), Kh(o, t, r, n);
      for (const o of i.target)
        QU(o, e.parent, n, t, r);
    }
  else if (e.type === "compound") {
    const [i] = e.initial.target;
    Xd(i) || (n.add(i), r.add(i)), Kh(i, t, r, n), QU(i, e, n, t, r);
  } else if (e.type === "parallel")
    for (const i of gg(e).filter((o) => !Xd(o)))
      [...n].some((o) => Vc(o, i)) || (Xd(i) || (n.add(i), r.add(i)), Kh(i, t, r, n));
}
function TL(e, t, r, n, a) {
  for (const i of n)
    if ((!a || Vc(i, a)) && e.add(i), i.type === "parallel")
      for (const o of gg(i).filter((s) => !Xd(s)))
        [...e].some((s) => Vc(s, o)) || (e.add(o), Kh(o, t, r, e));
}
function QU(e, t, r, n, a) {
  TL(r, n, a, MS(e, t));
}
function RCe(e, t, r, n, a, i, o) {
  let s = e;
  const c = pN(n, a, i);
  c.sort((u, g) => g.order - u.order);
  let l;
  for (const u of c)
    for (const g of ZCe(u)) {
      let p;
      g.history === "deep" ? p = (m) => eQ(m) && Vc(m, u) : p = (m) => m.parent === u, l ?? (l = {
        ...i
      }), l[g.id] = Array.from(a).filter(p);
    }
  for (const u of c)
    s = mg(s, t, r, [...u.exit, ...u.invoke.map((g) => qE(g.id))], o), a.delete(u);
  return [s, l || i];
}
let aJ = !1;
function RL(e, t, r, n, a, i) {
  const {
    machine: o
  } = e;
  let s = e;
  for (const c of n) {
    let m = function() {
      r.system._sendInspectionEvent({
        type: "@xstate.action",
        actorRef: r.self,
        action: {
          type: typeof c == "string" ? c : typeof c == "object" ? c.type : c.name || "(anonymous)",
          params: p
        }
      });
      try {
        aJ = u, u(g, p);
      } finally {
        aJ = !1;
      }
    };
    const l = typeof c == "function", u = l ? c : (
      // the existing type of `.actions` assumes non-nullable `TExpressionAction`
      // it's fine to cast this here to get a common type and lack of errors in the rest of the code
      // our logic below makes sure that we call those 2 "variants" correctly
      o.implementations.actions[typeof c == "string" ? c : c.type]
    );
    if (!u)
      continue;
    const g = {
      context: s.context,
      event: t,
      self: r.self,
      system: r.system
    }, p = l || typeof c == "string" ? void 0 : "params" in c ? typeof c.params == "function" ? c.params({
      context: s.context,
      event: t
    }) : c.params : void 0;
    if (!("resolve" in u)) {
      r.self._processingStatus === Mn.Running ? m() : r.defer(() => {
        m();
      });
      continue;
    }
    const I = u, [C, A, U] = I.resolve(
      r,
      s,
      g,
      p,
      u,
      // this holds all params
      a
    );
    s = C, "retryResolve" in I && (i == null || i.push([I, A])), "execute" in I && (r.self._processingStatus === Mn.Running ? I.execute(r, A) : r.defer(I.execute.bind(null, r, A))), U && (s = RL(s, t, r, U, a, i));
  }
  return s;
}
function mg(e, t, r, n, a, i) {
  const o = i ? [] : void 0, s = RL(e, t, r, n, {
    internalQueue: a,
    deferredActorIds: i
  }, o);
  return o == null || o.forEach(([c, l]) => {
    c.retryResolve(r, s, l);
  }), s;
}
function FU(e, t, r, n = []) {
  let a = e;
  const i = [];
  function o(l, u, g) {
    r.system._sendInspectionEvent({
      type: "@xstate.microstep",
      actorRef: r.self,
      event: u,
      snapshot: l,
      _transitions: g
    }), i.push(l);
  }
  if (t.type === cN)
    return a = Mu(iJ(a, t, r), {
      status: "stopped"
    }), o(a, t, []), {
      snapshot: a,
      microstates: i
    };
  let s = t;
  if (s.type !== IL) {
    const l = s, u = dCe(l), g = oJ(l, a);
    if (u && !g.length)
      return a = Mu(e, {
        status: "error",
        error: l.error
      }), o(a, l, []), {
        snapshot: a,
        microstates: i
      };
    a = gN(
      g,
      e,
      r,
      s,
      !1,
      // isInitial
      n
    ), o(a, l, g);
  }
  let c = !0;
  for (; a.status === "active"; ) {
    let l = c ? DCe(a, s) : [];
    const u = l.length ? a : void 0;
    if (!l.length) {
      if (!n.length)
        break;
      s = n.shift(), l = oJ(s, a);
    }
    a = gN(l, a, r, s, !1, n), c = a !== u, o(a, s, l);
  }
  return a.status !== "active" && iJ(a, s, r), {
    snapshot: a,
    microstates: i
  };
}
function iJ(e, t, r) {
  return mg(e, t, r, Object.values(e.children).map((n) => qE(n)), []);
}
function oJ(e, t) {
  return t.machine.getTransitionData(t, e);
}
function DCe(e, t) {
  const r = /* @__PURE__ */ new Set(), n = e._nodes.filter(eQ);
  for (const a of n)
    e: for (const i of [a].concat(MS(a, void 0)))
      if (i.always) {
        for (const o of i.always)
          if (o.guard === void 0 || Iw(o.guard, e.context, t, e)) {
            r.add(o);
            break e;
          }
      }
  return QL(Array.from(r), new Set(e._nodes), e.historyValue);
}
function JCe(e, t) {
  const r = X1(q1(e, t));
  return BL(e, [...r]);
}
function VCe(e) {
  return !!e && typeof e == "object" && "machine" in e && "value" in e;
}
const MCe = function(t) {
  return yL(t, this.value);
}, GCe = function(t) {
  return this.tags.has(t);
}, xCe = function(t) {
  const r = this.machine.getTransitionData(this, t);
  return !!(r != null && r.length) && // Check that at least one transition is not forbidden
  r.some((n) => n.target !== void 0 || n.actions.length);
}, HCe = function() {
  const {
    _nodes: t,
    tags: r,
    machine: n,
    getMeta: a,
    toJSON: i,
    can: o,
    hasTag: s,
    matches: c,
    ...l
  } = this;
  return {
    ...l,
    tags: Array.from(r)
  };
}, LCe = function() {
  return this._nodes.reduce((t, r) => (r.meta !== void 0 && (t[r.id] = r.meta), t), {});
};
function FC(e, t) {
  return {
    status: e.status,
    output: e.output,
    error: e.error,
    machine: t,
    context: e.context,
    _nodes: e._nodes,
    value: BL(t.root, e._nodes),
    tags: new Set(e._nodes.flatMap((r) => r.tags)),
    children: e.children,
    historyValue: e.historyValue || {},
    matches: MCe,
    hasTag: GCe,
    can: xCe,
    getMeta: LCe,
    toJSON: HCe
  };
}
function Mu(e, t = {}) {
  return FC({
    ...e,
    ...t
  }, e.machine);
}
function YCe(e, t) {
  const {
    _nodes: r,
    tags: n,
    machine: a,
    children: i,
    context: o,
    can: s,
    hasTag: c,
    matches: l,
    getMeta: u,
    toJSON: g,
    ...p
  } = e, m = {};
  for (const C in i) {
    const A = i[C];
    m[C] = {
      snapshot: A.getPersistedSnapshot(t),
      src: A.src,
      systemId: A._systemId,
      syncSnapshot: A._syncSnapshot
    };
  }
  return {
    ...p,
    context: DL(o),
    children: m
  };
}
function DL(e) {
  let t;
  for (const r in e) {
    const n = e[r];
    if (n && typeof n == "object")
      if ("sessionId" in n && "send" in n && "ref" in n)
        t ?? (t = Array.isArray(e) ? e.slice() : {
          ...e
        }), t[r] = {
          xstate$$type: zE,
          id: n.id
        };
      else {
        const a = DL(n);
        a !== n && (t ?? (t = Array.isArray(e) ? e.slice() : {
          ...e
        }), t[r] = a);
      }
  }
  return t ?? e;
}
function OCe(e, t, r, n, {
  event: a,
  id: i,
  delay: o
}, {
  internalQueue: s
}) {
  const c = t.machine.implementations.delays;
  if (typeof a == "string")
    throw new Error(`Only event objects may be used with raise; use raise({ type: "${a}" }) instead`);
  const l = typeof a == "function" ? a(r, n) : a;
  let u;
  if (typeof o == "string") {
    const g = c && c[o];
    u = typeof g == "function" ? g(r, n) : g;
  } else
    u = typeof o == "function" ? o(r, n) : o;
  return typeof u != "number" && s.push(l), [t, {
    event: l,
    id: i,
    delay: u
  }];
}
function jCe(e, t) {
  const {
    event: r,
    delay: n,
    id: a
  } = t;
  if (typeof n == "number") {
    e.defer(() => {
      const i = e.self;
      e.system.scheduler.schedule(i, i, r, n, a);
    });
    return;
  }
}
function JL(e, t) {
  function r(n, a) {
  }
  return r.type = "xstate.raise", r.event = e, r.id = t == null ? void 0 : t.id, r.delay = t == null ? void 0 : t.delay, r.resolve = OCe, r.execute = jCe, r;
}
function PCe(e, {
  machine: t,
  context: r
}, n, a) {
  const i = (o, s = {}) => {
    const {
      systemId: c,
      input: l
    } = s;
    if (typeof o == "string") {
      const u = XE(t, o);
      if (!u)
        throw new Error(`Actor logic '${o}' not implemented in machine '${t.id}'`);
      const g = xm(u, {
        id: s.id,
        parent: e.self,
        syncSnapshot: s.syncSnapshot,
        input: typeof l == "function" ? l({
          context: r,
          event: n,
          self: e.self
        }) : l,
        src: o,
        systemId: c
      });
      return a[g.id] = g, g;
    } else
      return xm(o, {
        id: s.id,
        parent: e.self,
        syncSnapshot: s.syncSnapshot,
        input: s.input,
        src: o,
        systemId: c
      });
  };
  return (o, s) => {
    const c = i(o, s);
    return a[c.id] = c, e.defer(() => {
      c._processingStatus !== Mn.Stopped && c.start();
    }), c;
  };
}
function $Ce(e, t, r, n, {
  assignment: a
}) {
  if (!t.context)
    throw new Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
  const i = {}, o = {
    context: t.context,
    event: r.event,
    spawn: PCe(e, t, r.event, i),
    self: e.self,
    system: e.system
  };
  let s = {};
  if (typeof a == "function")
    s = a(o, n);
  else
    for (const l of Object.keys(a)) {
      const u = a[l];
      s[l] = typeof u == "function" ? u(o, n) : u;
    }
  const c = Object.assign({}, t.context, s);
  return [Mu(t, {
    context: c,
    children: Object.keys(i).length ? {
      ...t.children,
      ...i
    } : t.children
  })];
}
function VL(e) {
  function t(r, n) {
  }
  return t.type = "xstate.assign", t.assignment = e, t.resolve = $Ce, t;
}
function KCe(e, t, r, n, {
  event: a
}) {
  const i = typeof a == "function" ? a(r, n) : a;
  return [t, {
    event: i
  }];
}
function XCe(e, {
  event: t
}) {
  e.defer(() => e.emit(t));
}
function zCe(e) {
  function t(r, n) {
  }
  return t.type = "xstate.emit", t.event = e, t.resolve = KCe, t.execute = XCe, t;
}
let fN = /* @__PURE__ */ function(e) {
  return e.Parent = "#_parent", e.Internal = "#_internal", e;
}({});
function qCe(e, t, r, n, {
  to: a,
  event: i,
  id: o,
  delay: s
}, c) {
  var I;
  const l = t.machine.implementations.delays;
  if (typeof i == "string")
    throw new Error(`Only event objects may be used with sendTo; use sendTo({ type: "${i}" }) instead`);
  const u = typeof i == "function" ? i(r, n) : i;
  let g;
  if (typeof s == "string") {
    const C = l && l[s];
    g = typeof C == "function" ? C(r, n) : C;
  } else
    g = typeof s == "function" ? s(r, n) : s;
  const p = typeof a == "function" ? a(r, n) : a;
  let m;
  if (typeof p == "string") {
    if (p === fN.Parent ? m = e.self._parent : p === fN.Internal ? m = e.self : p.startsWith("#_") ? m = t.children[p.slice(2)] : m = (I = c.deferredActorIds) != null && I.includes(p) ? p : t.children[p], !m)
      throw new Error(`Unable to send event to actor '${p}' from machine '${t.machine.id}'.`);
  } else
    m = p || e.self;
  return [t, {
    to: m,
    event: u,
    id: o,
    delay: g
  }];
}
function ebe(e, t, r) {
  typeof r.to == "string" && (r.to = t.children[r.to]);
}
function tbe(e, t) {
  e.defer(() => {
    const {
      to: r,
      event: n,
      delay: a,
      id: i
    } = t;
    if (typeof a == "number") {
      e.system.scheduler.schedule(e.self, r, n, a, i);
      return;
    }
    e.system._relay(
      e.self,
      // at this point, in a deferred task, it should already be mutated by retryResolveSendTo
      // if it initially started as a string
      r,
      n.type === iCe ? CL(e.self.id, n.data) : n
    );
  });
}
function ML(e, t, r) {
  function n(a, i) {
  }
  return n.type = "xsnapshot.sendTo", n.to = e, n.event = t, n.id = r == null ? void 0 : r.id, n.delay = r == null ? void 0 : r.delay, n.resolve = qCe, n.retryResolve = ebe, n.execute = tbe, n;
}
function rbe(e, t) {
  return ML(fN.Parent, e, t);
}
function nbe(e, t, r, n, {
  collect: a
}) {
  const i = [], o = function(c) {
    i.push(c);
  };
  return o.assign = (...s) => {
    i.push(VL(...s));
  }, o.cancel = (...s) => {
    i.push(kL(...s));
  }, o.raise = (...s) => {
    i.push(JL(...s));
  }, o.sendTo = (...s) => {
    i.push(ML(...s));
  }, o.sendParent = (...s) => {
    i.push(rbe(...s));
  }, o.spawnChild = (...s) => {
    i.push(_L(...s));
  }, o.stopChild = (...s) => {
    i.push(qE(...s));
  }, o.emit = (...s) => {
    i.push(zCe(...s));
  }, a({
    context: r.context,
    event: r.event,
    enqueue: o,
    check: (s) => Iw(s, t.context, r.event, t),
    self: e.self,
    system: e.system
  }, n), [t, void 0, i];
}
function abe(e) {
  function t(r, n) {
  }
  return t.type = "xstate.enqueueActions", t.collect = e, t.resolve = nbe, t;
}
const sJ = /* @__PURE__ */ new WeakMap();
function Ch(e, t, r) {
  let n = sJ.get(e);
  return n ? t in n || (n[t] = r()) : (n = {
    [t]: r()
  }, sJ.set(e, n)), n[t];
}
const ibe = {}, F0 = (e) => typeof e == "string" ? {
  type: e
} : typeof e == "function" ? "resolve" in e ? {
  type: e.type
} : {
  type: e.name
} : e;
class aQ {
  constructor(t, r) {
    if (this.config = t, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = r._parent, this.key = r._key, this.machine = r._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join(vL), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? eJ(this.config.states, (n, a) => new aQ(n, {
      _parent: this,
      _key: a,
      _machine: this.machine
    })) : ibe, this.type === "compound" && !this.config.initial)
      throw new Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
    this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = vc(this.config.entry).slice(), this.exit = vc(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = vc(t.tags).slice();
  }
  /** @internal */
  _initialize() {
    this.transitions = wCe(this), this.config.always && (this.always = Wh(this.config.always).map((t) => Md(this, SL, t))), Object.keys(this.states).forEach((t) => {
      this.states[t]._initialize();
    });
  }
  /** The well-structured state node definition. */
  get definition() {
    return {
      id: this.id,
      key: this.key,
      version: this.machine.version,
      type: this.type,
      initial: this.initial ? {
        target: this.initial.target,
        source: this,
        actions: this.initial.actions.map(F0),
        eventType: null,
        reenter: !1,
        toJSON: () => ({
          target: this.initial.target.map((t) => `#${t.id}`),
          source: `#${this.id}`,
          actions: this.initial.actions.map(F0),
          eventType: null
        })
      } : void 0,
      history: this.history,
      states: eJ(this.states, (t) => t.definition),
      on: this.on,
      transitions: [...this.transitions.values()].flat().map((t) => ({
        ...t,
        actions: t.actions.map(F0)
      })),
      entry: this.entry.map(F0),
      exit: this.exit.map(F0),
      meta: this.meta,
      order: this.order || -1,
      output: this.output,
      invoke: this.invoke,
      description: this.description,
      tags: this.tags
    };
  }
  /** @internal */
  toJSON() {
    return this.definition;
  }
  /** The logic invoked as actors by this state node. */
  get invoke() {
    return Ch(this, "invoke", () => vc(this.config.invoke).map((t, r) => {
      const {
        src: n,
        systemId: a
      } = t, i = t.id ?? tJ(this.id, r), o = typeof n == "string" ? n : `xstate.invoke.${tJ(this.id, r)}`;
      return {
        ...t,
        src: o,
        id: i,
        systemId: a,
        toJSON() {
          const {
            onDone: s,
            onError: c,
            ...l
          } = t;
          return {
            ...l,
            type: "xstate.invoke",
            src: o,
            id: i
          };
        }
      };
    }));
  }
  /** The mapping of events to transitions. */
  get on() {
    return Ch(this, "on", () => [...this.transitions].flatMap(([r, n]) => n.map((a) => [r, a])).reduce((r, [n, a]) => (r[n] = r[n] || [], r[n].push(a), r), {}));
  }
  get after() {
    return Ch(this, "delayedTransitions", () => yCe(this));
  }
  get initial() {
    return Ch(this, "initial", () => ACe(this, this.config.initial));
  }
  /** @internal */
  next(t, r) {
    const n = r.type, a = [];
    let i;
    const o = Ch(this, `candidates-${n}`, () => bCe(this, n));
    for (const s of o) {
      const {
        guard: c
      } = s, l = t.context;
      let u = !1;
      try {
        u = !c || Iw(c, l, r, t);
      } catch (g) {
        const p = typeof c == "string" ? c : typeof c == "object" ? c.type : void 0;
        throw new Error(`Unable to evaluate guard ${p ? `'${p}' ` : ""}in transition for event '${n}' in state node '${this.id}':
${g.message}`);
      }
      if (u) {
        a.push(...s.actions), i = s;
        break;
      }
    }
    return i ? [i] : void 0;
  }
  /** All the event types accepted by this state node and its descendants. */
  get events() {
    return Ch(this, "events", () => {
      const {
        states: t
      } = this, r = new Set(this.ownEvents);
      if (t)
        for (const n of Object.keys(t)) {
          const a = t[n];
          if (a.states)
            for (const i of a.events)
              r.add(`${i}`);
        }
      return Array.from(r);
    });
  }
  /**
   * All the events that have transitions directly from this state node.
   *
   * Excludes any inert events.
   */
  get ownEvents() {
    const t = new Set([...this.transitions.keys()].filter((r) => this.transitions.get(r).some((n) => !(!n.target && !n.actions.length && !n.reenter))));
    return Array.from(t);
  }
}
const obe = "#";
class iQ {
  constructor(t, r) {
    this.config = t, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = t.id || "(machine)", this.implementations = {
      actors: (r == null ? void 0 : r.actors) ?? {},
      actions: (r == null ? void 0 : r.actions) ?? {},
      delays: (r == null ? void 0 : r.delays) ?? {},
      guards: (r == null ? void 0 : r.guards) ?? {}
    }, this.version = this.config.version, this.schemas = this.config.schemas, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new aQ(t, {
      _key: this.id,
      _machine: this
    }), this.root._initialize(), this.states = this.root.states, this.events = this.root.events;
  }
  /**
   * Clones this state machine with the provided implementations and merges the
   * `context` (if provided).
   *
   * @param implementations Options (`actions`, `guards`, `actors`, `delays`,
   *   `context`) to recursively merge with the existing options.
   * @returns A new `StateMachine` instance with the provided implementations.
   */
  provide(t) {
    const {
      actions: r,
      guards: n,
      actors: a,
      delays: i
    } = this.implementations;
    return new iQ(this.config, {
      actions: {
        ...r,
        ...t.actions
      },
      guards: {
        ...n,
        ...t.guards
      },
      actors: {
        ...a,
        ...t.actors
      },
      delays: {
        ...i,
        ...t.delays
      }
    });
  }
  resolveState(t) {
    const r = JCe(this.root, t.value), n = X1(q1(this.root, r));
    return FC({
      _nodes: [...n],
      context: t.context || {},
      children: {},
      status: tQ(n, this.root) ? "done" : t.status || "active",
      output: t.output,
      error: t.error,
      historyValue: t.historyValue
    }, this);
  }
  /**
   * Determines the next snapshot given the current `snapshot` and received
   * `event`. Calculates a full macrostep from all microsteps.
   *
   * @param snapshot The current snapshot
   * @param event The received event
   */
  transition(t, r, n) {
    return FU(t, r, n).snapshot;
  }
  /**
   * Determines the next state given the current `state` and `event`. Calculates
   * a microstep.
   *
   * @param state The current state
   * @param event The received event
   */
  microstep(t, r, n) {
    return FU(t, r, n).microstates;
  }
  getTransitionData(t, r) {
    return rQ(this.root, t.value, t, r) || [];
  }
  /**
   * The initial state _before_ evaluating any microsteps. This "pre-initial"
   * state is provided to initial actions executed in the initial state.
   */
  getPreInitialState(t, r, n) {
    const {
      context: a
    } = this.config, i = FC({
      context: typeof a != "function" && a ? a : {},
      _nodes: [this.root],
      children: {},
      status: "active"
    }, this);
    return typeof a == "function" ? mg(i, r, t, [VL(({
      spawn: s,
      event: c,
      self: l
    }) => a({
      spawn: s,
      input: c.input,
      self: l
    }))], n) : i;
  }
  /**
   * Returns the initial `State` instance, with reference to `self` as an
   * `ActorRef`.
   */
  getInitialSnapshot(t, r) {
    const n = bL(r), a = [], i = this.getPreInitialState(t, n, a), o = gN([{
      target: [...EL(this.root)],
      source: this.root,
      reenter: !0,
      actions: [],
      eventType: null,
      toJSON: null
      // TODO: fix
    }], i, t, n, !0, a), {
      snapshot: s
    } = FU(o, n, t, a);
    return s;
  }
  start(t) {
    Object.values(t.children).forEach((r) => {
      r.getSnapshot().status === "active" && r.start();
    });
  }
  getStateNodeById(t) {
    const r = KE(t), n = r.slice(1), a = Cw(r[0]) ? r[0].slice(obe.length) : r[0], i = this.idMap.get(a);
    if (!i)
      throw new Error(`Child state node '#${a}' does not exist on machine '${this.id}'`);
    return z1(i, n);
  }
  get definition() {
    return this.root.definition;
  }
  toJSON() {
    return this.definition;
  }
  getPersistedSnapshot(t, r) {
    return YCe(t, r);
  }
  restoreSnapshot(t, r) {
    const n = {}, a = t.children;
    Object.keys(a).forEach((c) => {
      const l = a[c], u = l.snapshot, g = l.src, p = typeof g == "string" ? XE(this, g) : g;
      if (!p)
        return;
      const m = xm(p, {
        id: c,
        parent: r.self,
        syncSnapshot: l.syncSnapshot,
        snapshot: u,
        src: g,
        systemId: l.systemId
      });
      n[c] = m;
    });
    const i = FC({
      ...t,
      children: n,
      _nodes: Array.from(X1(q1(this.root, t.value)))
    }, this);
    let o = /* @__PURE__ */ new Set();
    function s(c, l) {
      if (!o.has(c)) {
        o.add(c);
        for (let u in c) {
          const g = c[u];
          if (g && typeof g == "object") {
            if ("xstate$$type" in g && g.xstate$$type === zE) {
              c[u] = l[g.id];
              continue;
            }
            s(g, l);
          }
        }
      }
    }
    return s(i.context, n), i;
  }
}
function sbe(e, t) {
  return new iQ(e, t);
}
function lbe({
  schemas: e,
  actors: t,
  actions: r,
  guards: n,
  delays: a
}) {
  return {
    createMachine: (i) => sbe({
      ...i,
      schemas: e
    }, {
      actors: t,
      actions: r,
      guards: n,
      delays: a
    })
  };
}
const cbe = ({
  credentials: e,
  setWorkflowStepCallback: t,
  initialState: r = e.length === 0 ? Me.Setup : Me.Start
}) => {
  var o, s;
  const n = e.map((c, l, u) => {
    const g = HIe(l, c, u);
    switch (c.category) {
      case T.Id:
        return XIe(g);
      case T.Facemap:
        return $Ie(g);
      case T.Document:
        return jIe(g);
      case T.Data:
        return YIe(g);
      default:
        return;
    }
  }).filter((c) => !!c), a = n.reduce((c, l) => ({
    ...c,
    ...l == null ? void 0 : l.transitions
  }), {});
  return lbe({
    actions: {
      setWorkflowStep: (c, l) => {
        t == null || t(l);
      }
    }
  }).createMachine({
    id: "@jumio/websdk workflow state machine",
    type: "parallel",
    states: {
      step: {
        id: "step",
        initial: r,
        states: {
          [Me.Setup]: {
            on: {
              [Aa.NextStep]: {
                target: Me.Start,
                actions: {
                  type: "setWorkflowStep",
                  params: {
                    step: Me.Start,
                    substep: In.Start,
                    shouldStoreNavigationState: !1,
                    credentialId: void 0,
                    activeScreen: Ot.Workflow
                  }
                }
              }
            }
          },
          ...zIe({
            credentialId: ((o = n[0]) == null ? void 0 : o.credentialId) ?? ""
          }),
          ...a,
          [Me.Finish]: {
            on: {
              [Aa.PreviousStep]: ((s = n[n.length - 1]) == null ? void 0 : s.credentialId) ?? ""
            }
          }
        },
        entry: abe(({ enqueue: c }) => {
          c(
            e.length === 0 ? {
              type: "setWorkflowStep",
              params: {
                step: Me.Setup,
                substep: void 0,
                credentialId: void 0,
                shouldStoreNavigationState: !0,
                activeScreen: Ot.Workflow
              }
            } : {
              type: "setWorkflowStep",
              params: {
                step: Me.Start,
                substep: In.Start,
                credentialId: void 0,
                shouldStoreNavigationState: !1,
                activeScreen: Ot.Workflow
              }
            }
          );
        })
      },
      activeScreen: {
        id: "active screen state machine",
        initial: Ot.Workflow,
        states: {
          [Ot.Workflow]: {},
          [Ot.CrossDevice]: {}
        },
        on: {
          /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */
          [K1.NavigateToCrossDevice]: {
            target: `.${Ot.CrossDevice}`,
            actions: re({
              activeScreen: Ot.CrossDevice
            })
          },
          [K1.NavigateToWorkflow]: {
            target: `.${Ot.Workflow}`,
            actions: re({
              activeScreen: Ot.Workflow
            })
          }
          /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */
        }
      }
    }
  });
};
let ey, Sc;
const GL = ({
  credentials: e,
  setWorkflowStepCallback: t = sh,
  initialState: r,
  snapshotValue: n
}) => {
  const a = cbe({
    credentials: e,
    setWorkflowStepCallback: t,
    initialState: r
  }), i = xm(
    a,
    n ? {
      snapshot: {
        status: "active",
        output: void 0,
        error: void 0,
        value: n,
        historyValue: {},
        context: {},
        children: {}
      }
    } : void 0
  );
  return i.start(), { stateMachine: a, actor: i };
}, dbe = () => {
  Sc == null || Sc.stop(), Sc = void 0, ey = void 0;
}, ve = () => {
  if (!(ey && Sc)) {
    const { stateMachine: e, actor: t } = GL({
      credentials: [],
      setWorkflowStepCallback: sh
    });
    return ey = e, Sc = t, t;
  }
  return Sc;
}, oQ = ({
  credentials: e,
  setWorkflowStepCallback: t = sh,
  initialState: r,
  snapshotValue: n
}) => {
  dbe();
  const { actor: a, stateMachine: i } = GL({
    credentials: e,
    setWorkflowStepCallback: t,
    initialState: r,
    snapshotValue: n
  });
  return ey = i, Sc = a, a;
}, Ne = new eH(), Ie = {
  Logger: Symbol.for("Logger"),
  TokenManager: Symbol.for("TokenManager"),
  TokenManagerController: Symbol.for("TokenManagerController"),
  Transport: Symbol.for("Transport"),
  TransportController: Symbol.for("TransportController"),
  Workflow: Symbol.for("Workflow"),
  WorkflowConfiguration: Symbol.for("WorkflowConfiguration"),
  WorkflowConfigurationController: Symbol.for("WorkflowConfigurationController"),
  WorkflowConsent: Symbol.for("WorkflowConsent"),
  WorkflowConsentController: Symbol.for("WorkflowConsentController"),
  WorkflowDeviceFingerprint: Symbol.for("WorkflowDeviceFingerprint"),
  WorkflowDeviceFingerprintController: Symbol.for("WorkflowDeviceFingerprintController"),
  WorkflowEmail: Symbol.for("WorkflowEmail"),
  WorkflowEmailController: Symbol.for("WorkflowEmailController"),
  WorkflowController: Symbol.for("WorkflowController"),
  WorkflowStepCrossDevice: Symbol.for("WorkflowStepCrossDevice"),
  WorkflowStepCrossDeviceController: Symbol.for("WorkflowStepCrossDeviceController"),
  WorkflowStepFinish: Symbol.for("WorkflowStepFinish"),
  WorkflowStepFinishController: Symbol.for("WorkflowStepFinishController"),
  WorkflowStepIdFactory: Symbol.for("Factory<WorkflowStepId>"),
  WorkflowStepIdControllerFactory: Symbol.for("Factory<WorkflowStepIdController>"),
  WorkflowStepFacemapFactory: Symbol.for("Factory<WorkflowStepFacemap>"),
  WorkflowStepFacemapControllerFactory: Symbol.for("Factory<WorkflowStepFacemapController>"),
  WorkflowStepDocumentFactory: Symbol.for("Factory<WorkflowStepDocument>"),
  WorkflowStepDocumentControllerFactory: Symbol.for("Factory<WorkflowStepDocumentController>"),
  WorkflowStepDataFactory: Symbol.for("Factory<WorkflowStepData>"),
  WorkflowStepDataControllerFactory: Symbol.for("Factory<WorkflowStepDataController>"),
  WorkflowStepSetup: Symbol.for("WorkflowStepSetup"),
  WorkflowStepSetupController: Symbol.for("WorkflowStepSetupController"),
  WorkflowStepStart: Symbol.for("WorkflowStepStart"),
  WorkflowStepStartController: Symbol.for("WorkflowStepStartController")
};
function _n() {
  return (e) => e.pipe(
    ti((t) => {
      if (t instanceof es) {
        const r = t.details.httpStatus === 401 && t.details.message === "Credentials in invalid state.", n = t.details.httpStatus === 412 && t.details.message === "Acquisition expired.", a = t.details.httpStatus === 412 && t.details.message === "JWT expired.";
        if (r || n || a)
          return eo({
            tokenExpired: !0
          }), om;
      }
      return zc(() => t);
    })
  );
}
var ube = Object.defineProperty, hbe = Object.getOwnPropertyDescriptor, xL = (e) => {
  throw TypeError(e);
}, pbe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? hbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ube(t, r, a), a;
}, gbe = (e, t, r) => t.has(e) || xL("Cannot " + r), fbe = (e, t, r) => t.has(e) ? xL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), mbe = (e, t, r) => (gbe(e, t, "access private method"), r), mN, HL;
let vN = class {
  constructor() {
    fbe(this, mN), this.settings$ = kn(), this.credentials$ = $0e();
  }
  fetchSettings$(e) {
    const t = (r) => mbe(this, mN, HL).call(this).getSettings$(r).pipe(_n());
    return Sa(e).pipe(
      Wt(t),
      ae((r) => {
        oQ({
          credentials: r.credentials,
          setWorkflowStepCallback: sh
        }), j0e(r);
      }),
      ae((r) => {
        const n = r.consents.map((a) => ({
          id: a.id,
          item: a,
          given: !1
        }));
        xpe(!0), Gpe(n), pg({
          customerId: $ve()
        });
      }),
      Wt(() => kn())
    );
  }
  getSettings() {
    return On();
  }
};
mN = /* @__PURE__ */ new WeakSet();
HL = function() {
  return Ne.get(Ie.Transport);
};
vN = pbe([
  Qt()
], vN);
var vbe = Object.defineProperty, Sbe = Object.getOwnPropertyDescriptor, LL = (e) => {
  throw TypeError(e);
}, Ibe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Sbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && vbe(t, r, a), a;
}, Cbe = (e, t) => (r, n) => t(r, n, e), YL = (e, t, r) => t.has(e) || LL("Cannot " + r), T0 = (e, t, r) => (YL(e, t, "read from private field"), r ? r.call(e) : t.get(e)), bbe = (e, t, r) => t.has(e) ? LL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), ybe = (e, t, r, n) => (YL(e, t, "write to private field"), t.set(e, r), r), Ll;
let SN = class {
  constructor(e) {
    bbe(this, Ll), ybe(this, Ll, e);
  }
  sendConsentData() {
    return Be(this.sendConsentData$());
  }
  sendConsentData$() {
    return T0(this, Ll).sendConsentData$();
  }
  areAllActiveConsentsGiven$() {
    return T0(this, Ll).areAllActiveConsentsGiven$();
  }
  areAllActiveConsentsGiven() {
    return Be(this.areAllActiveConsentsGiven$());
  }
  isConsentGivenSent() {
    return Be(this.isConsentGivenSent$());
  }
  isConsentGivenSent$() {
    return T0(this, Ll).isConsentGivenSent$();
  }
  updateConsentStatus(e) {
    T0(this, Ll).updateConsentStatus(e);
  }
  selectAllConsents$() {
    return T0(this, Ll).selectAllConsents$();
  }
  selectAllConsents() {
    return Be(this.selectAllConsents$());
  }
};
Ll = /* @__PURE__ */ new WeakMap();
SN = Ibe([
  Qt(),
  Cbe(0, ih(Ie.WorkflowConsent))
], SN);
var wbe = Object.defineProperty, Abe = Object.getOwnPropertyDescriptor, OL = (e) => {
  throw TypeError(e);
}, Ube = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Abe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && wbe(t, r, a), a;
}, kbe = (e, t, r) => t.has(e) || OL("Cannot " + r), _be = (e, t, r) => t.has(e) ? OL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), lJ = (e, t, r) => (kbe(e, t, "access private method"), r), TC, jL, PL;
let IN = class {
  constructor() {
    _be(this, TC);
  }
  areAllActiveConsentsGiven$() {
    return Ype();
  }
  sendConsentData$() {
    return lJ(this, TC, PL).call(this).uploadData$({
      credentialUUID: "00000000-0000-0000-0000-000000000000",
      params: lJ(this, TC, jL).call(this)
    }).pipe(
      _n(),
      ae(() => {
        Hve();
      })
    );
  }
  selectAllConsents$() {
    return K0e();
  }
  updateConsentStatus(e) {
    Hpe(e);
  }
  isConsentGivenSent$() {
    return Lve();
  }
};
TC = /* @__PURE__ */ new WeakSet();
jL = function() {
  return { consents: Lpe() };
};
PL = function() {
  return Ne.get(Ie.Transport);
};
IN = Ube([
  Qt()
], IN);
var Nbe = Object.defineProperty, Zbe = Object.getOwnPropertyDescriptor, $L = (e) => {
  throw TypeError(e);
}, Bbe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Zbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Nbe(t, r, a), a;
}, Wbe = (e, t, r) => t.has(e) || $L("Cannot " + r), Ebe = (e, t, r) => t.has(e) ? $L("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Vl = (e, t, r) => (Wbe(e, t, "access private method"), r), Uo, Qs;
let CN = class {
  constructor() {
    Ebe(this, Uo);
  }
  getConsentController() {
    return Ne.get(Ie.WorkflowConsentController);
  }
  getControllerById(e, t) {
    const r = t ?? oe();
    switch (e) {
      case Me.Setup:
        return Ne.get(
          Ie.WorkflowStepSetupController
        );
      case Me.Start:
        return Ne.get(
          Ie.WorkflowStepStartController
        );
      case Me.Finish:
        return Ne.get(
          Ie.WorkflowStepFinishController
        );
      case T.Id:
        return Ne.get(
          Ie.WorkflowStepIdControllerFactory
        )(r);
      case T.Facemap:
        return Ne.get(
          Ie.WorkflowStepFacemapControllerFactory
        )(r);
      case T.Document:
        return Ne.get(
          Ie.WorkflowStepDocumentControllerFactory
        )(r);
      case T.Data:
        return Ne.get(
          Ie.WorkflowStepDataControllerFactory
        )(r);
      default:
        throw new Error(`getControllerById: Invalid controller for "${e}#${t}" requested!`);
    }
  }
  selectStepChange$() {
    return jve().pipe(
      QM(1),
      go(fw()),
      te(([e, t]) => ({
        ...$g(t),
        controller: this.getControllerById(e)
      }))
    );
  }
  onStepChange(e) {
    const t = this.selectStepChange$().pipe(ae(e)).subscribe();
    return () => {
      t.unsubscribe();
    };
  }
  goToNextStep() {
    Vl(this, Uo, Qs).call(this).goToNextStep();
  }
  goToPreviousStep() {
    Vl(this, Uo, Qs).call(this).goToPreviousStep();
  }
  getConfiguration() {
    return Ne.get(Ie.WorkflowConfigurationController);
  }
  extractData$() {
    return Vl(this, Uo, Qs).call(this).extractData$();
  }
  async extractDataAsync() {
    return Be(this.extractData$());
  }
  finalize$() {
    return Vl(this, Uo, Qs).call(this).finalize$();
  }
  async finalizeAsync() {
    return Be(this.finalize$());
  }
  getWorkflowState() {
    return Vl(this, Uo, Qs).call(this).getWorkflowState();
  }
  setWorkflowState(e) {
    Vl(this, Uo, Qs).call(this).setWorkflowState(e);
  }
  getLoggerManager() {
    return Ne.get(Ie.Logger);
  }
  getTokenManager() {
    return Ne.get(Ie.TokenManagerController);
  }
  getTransport() {
    return Ne.get(Ie.TransportController);
  }
  checkAcquisitionStatus$() {
    return Vl(this, Uo, Qs).call(this).checkAcquisitionStatus$();
  }
  async checkAcquisitionStatusAsync() {
    return Be(this.checkAcquisitionStatus$());
  }
  checkAcquisitionStatusPolling$(e = 7e3) {
    return Vl(this, Uo, Qs).call(this).checkAcquisitionStatusPolling$(e);
  }
  getEmailController() {
    return Ne.get(Ie.WorkflowEmailController);
  }
};
Uo = /* @__PURE__ */ new WeakSet();
Qs = function() {
  return Ne.get(Ie.Workflow);
};
CN = Bbe([
  Qt()
], CN);
var Qbe = Object.defineProperty, Fbe = Object.getOwnPropertyDescriptor, KL = (e) => {
  throw TypeError(e);
}, Tbe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Fbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Qbe(t, r, a), a;
}, Rbe = (e, t, r) => t.has(e) || KL("Cannot " + r), Dbe = (e, t, r) => t.has(e) ? KL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), TU = (e, t, r) => (Rbe(e, t, "access private method"), r), af, RC;
let bN = class {
  constructor() {
    Dbe(this, af);
  }
  goToPreviousStep() {
    ve().send({ type: Aa.PreviousStep });
  }
  goToNextStep() {
    ve().send({ type: Aa.NextStep });
  }
  getStepById(e, t) {
    const r = t ?? oe();
    switch (e) {
      case Me.Setup:
        return Ne.get(Ie.WorkflowStepSetup);
      case Me.Start:
        return Ne.get(Ie.WorkflowStepStart);
      case Me.Finish:
        return Ne.get(Ie.WorkflowStepFinish);
      case T.Id:
        return Ne.get(
          Ie.WorkflowStepIdFactory
        )(r);
      case T.Facemap:
        return Ne.get(
          Ie.WorkflowStepFacemapFactory
        )(r);
      case T.Document:
        return Ne.get(
          Ie.WorkflowStepDocumentFactory
        )(r);
      case T.Data:
        return Ne.get(
          Ie.WorkflowStepDataFactory
        )(r);
      default:
        throw new Error(`getStepById: The step ${e}#${r} is not found`);
    }
  }
  finalize$() {
    return vn(() => TU(this, af, RC).call(this).finalize$()).pipe(
      ae(() => {
        eo({
          step: Me.Finish,
          substep: void 0,
          finalized: !0,
          acquisitionPolling: !1
        });
      }),
      _n(),
      WM(() => {
        eo({ acquisitionPolling: !1 });
      })
    );
  }
  checkAcquisitionStatus$() {
    return ug().pipe(
      te(({ token: e }) => e),
      vt(),
      at((e) => !!e),
      Wt(
        () => TU(this, af, RC).call(this).getAcquisitionStatus$().pipe(
          ae((e) => {
            eo({
              acquisitionStatus: e.status
            });
          }),
          _n()
        )
      )
    );
  }
  checkAcquisitionStatusPolling$(e = 7e3) {
    return this.checkAcquisitionStatus$().pipe(
      _S({
        interval: e,
        shouldRepeat: (t) => {
          const { acquisitionPolling: r } = Le();
          return r && t.status === Wr.NotStarted;
        }
      })
    );
  }
  getWorkflowState() {
    return Le();
  }
  setWorkflowState(e) {
    eo(e);
  }
  extractData$() {
    return TU(this, af, RC).call(this).extractData$().pipe(_n());
  }
};
af = /* @__PURE__ */ new WeakSet();
RC = function() {
  return Ne.get(Ie.Transport);
};
bN = Tbe([
  Qt()
], bN);
var Jbe = Object.defineProperty, Vbe = Object.getOwnPropertyDescriptor, XL = (e) => {
  throw TypeError(e);
}, Mbe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Vbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Jbe(t, r, a), a;
}, zL = (e, t, r) => t.has(e) || XL("Cannot " + r), xi = (e, t, r) => (zL(e, t, "read from private field"), r ? r.call(e) : t.get(e)), cJ = (e, t, r) => t.has(e) ? XL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), dJ = (e, t, r, n) => (zL(e, t, "write to private field"), t.set(e, r), r), Oi, Eh;
let yN = class {
  constructor(e) {
    this.category = T.Document, cJ(this, Oi), cJ(this, Eh);
    const t = Ne.get(
      Ie.WorkflowStepDocumentFactory
    );
    dJ(this, Oi, t(e.id)), dJ(this, Eh, e);
  }
  getCredential() {
    return xi(this, Eh);
  }
  async getCredentialAsync() {
    return Be(this.selectCredential$());
  }
  selectCredential$() {
    return xi(this, Oi).selectCredential$();
  }
  checkUsability$(e) {
    return xi(this, Oi).checkUsability$(e);
  }
  async checkUsabilityAsync(e) {
    return Be(this.checkUsability$(e));
  }
  uploadData$(e) {
    return xi(this, Oi).uploadData$(e);
  }
  async uploadDataAsync(e) {
    return Be(this.uploadData$(e));
  }
  selectDocument$() {
    return this.selectCredential$().pipe(
      go(kn()),
      te(([e, t]) => t == null ? void 0 : t.supportedDocumentTypes.find((r) => {
        var n;
        return (n = e.type) == null ? void 0 : n.values.includes(r.code);
      }))
    );
  }
  selectPdfPages$() {
    return xi(this, Oi).selectPdfPages$();
  }
  softDeletePdfPage(e) {
    xi(this, Oi).softDeletePdfPage(e);
  }
  updateMetadataWithPageSelection$() {
    return xi(this, Oi).updateMetadataWithPageSelection$();
  }
  isUploadingFiles$() {
    return G0e(xi(this, Eh).id);
  }
  selectMaxFileUploadSize$() {
    return xi(this, Oi).selectMaxFileUploadSize$();
  }
  selectUploadedPdfFile$() {
    return x0e(xi(this, Eh).id);
  }
  removeOldPdfPages() {
    xi(this, Oi).removeOldPdfPages();
  }
};
Oi = /* @__PURE__ */ new WeakMap();
Eh = /* @__PURE__ */ new WeakMap();
yN = Mbe([
  Qt()
], yN);
const bw = (e) => ho(
  Lg(() => {
    var t;
    (t = e.uploadFilesMetadata) == null || t.files.forEach((r) => {
      ZC({
        state: er.Progress,
        id: r.multipartName,
        blob: r.file
      });
    });
  }),
  ae((t) => {
    var r;
    (r = e.uploadFilesMetadata) == null || r.files.forEach((n) => {
      const a = t.usabilityResultKeys[n.multipartName];
      ZC({
        state: er.Success,
        id: n.multipartName,
        blob: n.file,
        usabilityId: t.usabilityResultKeys[n.multipartName] ?? ""
      }), a && BC({
        state: hl.NotStarted,
        id: n.multipartName,
        usabilityId: t.usabilityResultKeys[n.multipartName] ?? ""
      });
    });
  }),
  ti((t) => {
    var r;
    return (r = e.uploadFilesMetadata) == null || r.files.forEach((n) => {
      ZC({
        state: er.Error,
        id: n.multipartName,
        blob: n.file,
        error: t
      });
    }), zc(() => t);
  })
);
var Gbe = Object.defineProperty, xbe = Object.getOwnPropertyDescriptor, qL = (e) => {
  throw TypeError(e);
}, Hbe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? xbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Gbe(t, r, a), a;
}, sQ = (e, t, r) => t.has(e) || qL("Cannot " + r), bn = (e, t, r) => (sQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), xI = (e, t, r) => t.has(e) ? qL("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), RU = (e, t, r, n) => (sQ(e, t, "write to private field"), t.set(e, r), r), Zo = (e, t, r) => (sQ(e, t, "access private method"), r), Hs, Mo, Qh, vi, eY, tY, wN, rY, nY, Lf;
let AN = class {
  constructor(e) {
    xI(this, vi), this.category = T.Document, xI(this, Hs), xI(this, Mo), xI(this, Qh), RU(this, Hs, e), RU(this, Mo, Zo(this, vi, nY).call(this)), RU(this, Qh, Ne.get(Ie.WorkflowConfiguration));
  }
  getCredential() {
    return bn(this, Hs);
  }
  selectCredential$() {
    return Sa(bn(this, Hs));
  }
  uploadData$(e) {
    return e.uploadFilesMetadata ? e.uploadFilesMetadata.files.find((r) => r.fileType === xr.Pdf) ? this.uploadPdfData$(e) : this.uploadImageData(e, e.uploadFilesMetadata.files[0]) : this.uploadPdfData$(e);
  }
  uploadPdfData$(e) {
    return Zo(this, vi, wN).call(this, e).pipe(
      Wt((t) => Zo(this, vi, eY).call(this, t, e))
    );
  }
  uploadImageData(e, t) {
    return Zo(this, vi, wN).call(this, e).pipe(
      Wt((r) => Zo(this, vi, tY).call(this, r, t))
    );
  }
  checkUsability$(e) {
    return Zo(this, vi, Lf).call(this).checkUsability$(e.usability).pipe(
      _n(),
      _S({
        shouldRepeat: (t) => t.decisionType === zn.NOT_AVAILABLE
      })
    );
  }
  selectPdfPages$() {
    return bn(this, Mo).selectPagesFromStore$();
  }
  async getFilePart(e) {
    const t = bn(this, Qh).getSettings().acquisitionReference;
    return await Be(
      Zo(this, vi, Lf).call(this).getFilePart$({ acquisitionId: t, credentialId: bn(this, Hs).id, partId: e })
    );
  }
  softDeletePdfPage(e) {
    const t = bn(this, Mo).getPageById(e);
    t && bn(this, Mo).upsertPageInStore({
      ...t,
      selected: !1
    });
  }
  removeOldPdfPages() {
    bn(this, Mo).removePagesWithOriginalFileGuid();
  }
  updateMetadataWithPageSelection$() {
    const e = bn(this, Qh).getSettings().acquisitionReference;
    return this.selectPdfPages$().pipe(
      te((t) => t.filter((r) => r.selected).map((r) => r.credentialFileGuid)),
      Wt(
        (t) => Zo(this, vi, Lf).call(this).updateMetadata$(e, bn(this, Hs).id, {
          credentialFileGuidSelection: t
        })
      )
    );
  }
  selectMaxFileUploadSize$() {
    return bn(this, Qh).settings$.pipe(te((e) => e.maxFileUploadSize));
  }
};
Hs = /* @__PURE__ */ new WeakMap();
Mo = /* @__PURE__ */ new WeakMap();
Qh = /* @__PURE__ */ new WeakMap();
vi = /* @__PURE__ */ new WeakSet();
eY = async function(e, t) {
  var r;
  if (e.documentResult) {
    const n = Object.values(e.documentResult.parts);
    n.forEach((i) => {
      var c;
      const o = (c = t.uploadFilesMetadata) == null ? void 0 : c.files[0].file, s = Zo(this, vi, rY).call(this, o) ? o.name : "unknown-filename";
      bn(this, Mo).upsertPageInStore({
        credentialFileGuid: i,
        selected: !0,
        filename: s
      });
    });
    const a = n.map((i) => this.getFilePart(i));
    for await (const i of a)
      bn(this, Mo).upsertPageInStore({
        ...i,
        base64: `data:image/png;base64, ${i.base64}`,
        filename: ((r = t.uploadFilesMetadata) == null ? void 0 : r.files[0].file).name
      });
  }
  return e;
};
tY = async function(e, t) {
  return e.documentResult && bn(this, Mo).upsertPageInStore({
    credentialFileGuid: Object.values(e.documentResult.parts)[0],
    selected: !0,
    base64: URL.createObjectURL(t.file),
    filename: t.file.name
  }), Promise.resolve(e);
};
wN = function(e) {
  return Zo(this, vi, Lf).call(this).uploadData$({
    credentialUUID: bn(this, Hs).id,
    params: e
  }).pipe(bw(e), _n());
};
rY = function(e) {
  return Ut(e, ["name"]);
};
nY = function() {
  return Xl.get(
    up.CredentialDocumentStoreFactory
  )(bn(this, Hs).id);
};
Lf = function() {
  return Ne.get(Ie.Transport);
};
AN = Hbe([
  Qt()
], AN);
var Lbe = Object.defineProperty, Ybe = Object.getOwnPropertyDescriptor, aY = (e) => {
  throw TypeError(e);
}, Obe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Ybe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Lbe(t, r, a), a;
}, iY = (e, t, r) => t.has(e) || aY("Cannot " + r), St = (e, t, r) => (iY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), uJ = (e, t, r) => t.has(e) ? aY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), hJ = (e, t, r, n) => (iY(e, t, "write to private field"), t.set(e, r), r), DC, pt;
let UN = class {
  constructor(e) {
    this.category = T.Facemap, uJ(this, DC), uJ(this, pt), hJ(this, DC, e);
    const t = Ne.get(
      Ie.WorkflowStepFacemapFactory
    );
    hJ(this, pt, t(e.id));
  }
  resetJLiveFallbackError() {
    St(this, pt).resetJLiveFallbackError();
  }
  selectJLiveFallbackError$() {
    return St(this, pt).selectJLiveFallbackError$();
  }
  setJLiveManualCaptureFallbackReason(e) {
    St(this, pt).setJLiveManualCaptureFallbackReason(e);
  }
  selectJLiveManualCaptureFallbackReason$() {
    return St(this, pt).selectJLiveManualCaptureFallbackReason$();
  }
  getCredential() {
    return St(this, DC);
  }
  async getCredentialAsync() {
    return Be(this.selectCredential$());
  }
  selectCredential$() {
    return St(this, pt).selectCredential$();
  }
  checkUsability$(e) {
    return St(this, pt).checkUsability$(e);
  }
  async checkUsabilityAsync(e) {
    return Be(this.checkUsability$(e));
  }
  fetchIproovToken$() {
    return St(this, pt).fetchIproovToken$();
  }
  async fetchIproovTokenAsync() {
    return Be(this.fetchIproovToken$());
  }
  getIproovTokenState() {
    return St(this, pt).getIproovTokenState();
  }
  patchIproovTokenState(e) {
    St(this, pt).patchIproovTokenState(e);
  }
  validateIproovToken$(e) {
    return St(this, pt).validateIproovToken$(e);
  }
  async validateIproovTokenAsync(e) {
    return Be(this.validateIproovToken$(e));
  }
  uploadData$(e) {
    return St(this, pt).uploadData$(e);
  }
  async uploadDataAsync(e) {
    return Be(this.uploadData$(e));
  }
  getIproovTokenStateAsync() {
    return Be(this.selectIproovTokenState$());
  }
  selectIproovTokenState$() {
    return St(this, pt).selectIproovTokenState$();
  }
  selectVerificationMethods$() {
    return St(this, pt).selectVerificationMethods$();
  }
  getVerificationMethodsAsync() {
    return Be(this.selectVerificationMethods$());
  }
  setActiveFaceVerificationMethod(e) {
    St(this, pt).setActiveFaceVerificationMethod(e);
  }
  getActiveFaceVerificationMethod() {
    return St(this, pt).getActiveFaceVerificationMethod();
  }
  selectActiveFaceVerificationMethod$() {
    return St(this, pt).selectActiveFaceVerificationMethod$();
  }
  selectLivenessState$() {
    return St(this, pt).selectLivenessState$();
  }
  setLivenessVisibleFaceFinder(e) {
    St(this, pt).setLivenessVisibleFaceFinder(e);
  }
  selectLivenessVisibleFaceFinder$() {
    return St(this, pt).selectLivenessVisibleFaceFinder$();
  }
  selectLivenessAttempt$() {
    return St(this, pt).selectLivenessAttempt$();
  }
  selectLivenessFeedbackMessage$() {
    return St(this, pt).selectLivenessFeedbackMessage$();
  }
  selectLivenessScanning$() {
    return St(this, pt).selectLivenessScanning$();
  }
  selectLivenessBackgroundColor$() {
    return St(this, pt).selectLivenessBackgroundColor$();
  }
  setLivenessStoreToNextAttempt() {
    St(this, pt).setLivenessStoreToNextAttempt();
  }
  setLivenessStoreProgress(e) {
    St(this, pt).setLivenessStoreProgress(e);
  }
  setLivenessStorePhotinusColor(e) {
    St(this, pt).setLivenessStorePhotinusColor(e);
  }
  setLivenessStoreDisplayMessage(e) {
    St(this, pt).setLivenessStoreDisplayMessage(e);
  }
  setLivenessStoreCameraCommand(e) {
    St(this, pt).setLivenessStoreCameraCommand(e);
  }
  setLivenessStoreUiCommand(e) {
    St(this, pt).setLivenessStoreUiCommand(e);
  }
  selectLivenessProgress$() {
    return St(this, pt).selectLivenessProgress$();
  }
  reset() {
    St(this, pt).reset();
  }
};
DC = /* @__PURE__ */ new WeakMap();
pt = /* @__PURE__ */ new WeakMap();
UN = Obe([
  Qt()
], UN);
const oY = (e) => ho(
  Lg(() => {
    BC({
      id: e.id,
      state: hl.Progress,
      usabilityId: e.usability.resultKey
    });
  }),
  ae((t) => {
    BC({
      id: e.id,
      state: hl.Success,
      usabilityId: e.usability.resultKey,
      result: t
    });
  }),
  ti((t) => (BC({
    id: e.id,
    state: hl.Error,
    usabilityId: e.usability.resultKey,
    error: t
  }), ba))
);
var jbe = Object.defineProperty, Pbe = Object.getOwnPropertyDescriptor, sY = (e) => {
  throw TypeError(e);
}, $be = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Pbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && jbe(t, r, a), a;
}, lQ = (e, t, r) => t.has(e) || sY("Cannot " + r), JC = (e, t, r) => (lQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), pJ = (e, t, r) => t.has(e) ? sY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Kbe = (e, t, r, n) => (lQ(e, t, "write to private field"), t.set(e, r), r), tt = (e, t, r) => (lQ(e, t, "access private method"), r), Gd, $e, lY, It, of, kN;
let _N = class {
  constructor(e) {
    pJ(this, $e), this.category = T.Facemap, pJ(this, Gd), Kbe(this, Gd, e);
  }
  getCredential() {
    return JC(this, Gd);
  }
  selectCredential$() {
    return Sa(JC(this, Gd));
  }
  validateIproovToken$(e) {
    return tt(this, $e, of).call(this).validateIproovToken$(e).pipe(_n());
  }
  checkUsability$(e) {
    return tt(this, $e, of).call(this).checkUsability$(e.usability).pipe(
      oY(e),
      _n(),
      _S({
        shouldRepeat: (t) => t.decisionType === zn.NOT_AVAILABLE
      })
    );
  }
  fetchIproovToken$() {
    const { iproovLatestOutcome: e } = tt(this, $e, It).call(this).getIproovTokenState();
    return ((r) => tt(this, $e, of).call(this).getIproovToken$(r).pipe(_n()))(e).pipe(
      Lg(() => {
        tt(this, $e, It).call(this).patchIproovTokenState({
          iproovStatus: _i.Pending,
          iproovTokenData: void 0
        });
      }),
      te((r) => {
        const { iproovLatestOutcome: n, iproovReady: a } = tt(this, $e, It).call(this).getIproovTokenState();
        return {
          iproovStatus: _i.Success,
          iproovTokenData: r,
          iproovLatestOutcome: n,
          iproovReady: a
        };
      }),
      ae((r) => {
        tt(this, $e, It).call(this).patchIproovTokenState(r);
      }),
      ti((r) => (tt(this, $e, It).call(this).patchIproovTokenState({
        iproovStatus: _i.Error,
        iproovTokenData: void 0,
        iproovError: r
      }), zc(() => r)))
    );
  }
  selectIproovTokenState$() {
    return tt(this, $e, It).call(this).selectIproovTokenState$();
  }
  getIproovTokenState() {
    return tt(this, $e, It).call(this).getIproovTokenState();
  }
  uploadData$(e) {
    return tt(this, $e, of).call(this).uploadData$({
      credentialUUID: JC(this, Gd).id,
      params: e
    }).pipe(bw(e), _n());
  }
  selectIproovTokenData$() {
    return tt(this, $e, It).call(this).selectIproovTokenState$();
  }
  selectVerificationMethods$() {
    return this.selectCredential$().pipe(
      te((e) => {
        var r, n;
        let t = [];
        return tt(this, $e, lY).call(this, (r = e.type) == null ? void 0 : r.values) && (t = ((n = e.type) == null ? void 0 : n.values) ?? []), t;
      })
    );
  }
  patchIproovTokenState(e) {
    tt(this, $e, It).call(this).patchIproovTokenState(e);
  }
  setActiveFaceVerificationMethod(e) {
    tt(this, $e, It).call(this).setActiveFaceVerificationMethod(e);
  }
  getActiveFaceVerificationMethod() {
    return tt(this, $e, It).call(this).getActiveFaceVerificationMethod();
  }
  selectActiveFaceVerificationMethod$() {
    return tt(this, $e, It).call(this).selectActiveFaceVerificationMethod$();
  }
  selectLivenessState$() {
    return tt(this, $e, It).call(this).selectLivenessState$();
  }
  setLivenessVisibleFaceFinder(e) {
    tt(this, $e, It).call(this).setLivenessVisibleFaceFinder(e);
  }
  selectLivenessVisibleFaceFinder$() {
    return tt(this, $e, It).call(this).selectLivenessVisibleFaceFinder$();
  }
  selectLivenessAttempt$() {
    return tt(this, $e, It).call(this).selectLivenessAttempt$();
  }
  selectLivenessFeedbackMessage$() {
    return tt(this, $e, It).call(this).selectLivenessFeedbackMessage$();
  }
  selectLivenessScanning$() {
    return tt(this, $e, It).call(this).selectLivenessScanning$();
  }
  selectLivenessBackgroundColor$() {
    return tt(this, $e, It).call(this).selectLivenessBackgroundColor$();
  }
  setLivenessStoreToNextAttempt() {
    tt(this, $e, It).call(this).setLivenessStoreToNextAttempt();
  }
  setLivenessStoreProgress(e) {
    tt(this, $e, It).call(this).setLivenessStoreProgress(e);
  }
  setLivenessStorePhotinusColor(e) {
    tt(this, $e, It).call(this).setLivenessStorePhotinusColor(e);
  }
  setLivenessStoreDisplayMessage(e) {
    tt(this, $e, It).call(this).setLivenessStoreDisplayMessage(e);
  }
  setLivenessStoreCameraCommand(e) {
    tt(this, $e, It).call(this).setLivenessStoreCameraCommand(e);
  }
  setLivenessStoreUiCommand(e) {
    tt(this, $e, It).call(this).setLivenessStoreUiCommand(e);
  }
  selectLivenessProgress$() {
    return tt(this, $e, It).call(this).selectLivenessProgress$();
  }
  reset() {
    tt(this, $e, It).call(this).reset();
  }
  setJLiveManualCaptureFallbackReason(e) {
    const t = {
      [ol.Disabled]: [
        nt.ModuleLoadingError,
        nt.ModuleInitializationError,
        nt.WorkerCrashed,
        nt.WorkerError,
        nt.PostMessageError,
        nt.Struggle,
        nt.Timeout,
        nt.UserSelection,
        nt.ExcludedDevice
      ],
      [ol.Soft]: [
        nt.ModuleLoadingError,
        nt.ModuleInitializationError,
        nt.WorkerCrashed,
        nt.WorkerError,
        nt.PostMessageError,
        nt.Struggle,
        nt.ExcludedDevice
      ],
      [ol.Strict]: []
    }, r = tfe(), n = t[r];
    if (!e || n.includes(e)) {
      tt(this, $e, It).call(this).setJLiveManualCaptureFallbackReason(e);
      return;
    }
    r === ol.Strict && e !== nt.Timeout && tt(this, $e, kN).call(this, { type: e });
  }
  selectJLiveManualCaptureFallbackReason$() {
    return tt(this, $e, It).call(this).selectJLiveManualCaptureFallbackReason$();
  }
  selectJLiveFallbackError$() {
    return tt(this, $e, It).call(this).selectJLiveFallbackError$();
  }
  resetJLiveFallbackError() {
    this.setJLiveManualCaptureFallbackReason(void 0), tt(this, $e, kN).call(this, void 0);
  }
};
Gd = /* @__PURE__ */ new WeakMap();
$e = /* @__PURE__ */ new WeakSet();
lY = function(e) {
  const t = Object.values(ei);
  return Array.isArray(e) && e.every((r) => t.includes(r));
};
It = function() {
  return Xl.get(
    up.CredentialFacemapStoreFactory
  )(JC(this, Gd).id);
};
of = function() {
  return Ne.get(Ie.Transport);
};
kN = function(e) {
  tt(this, $e, It).call(this).setJLiveFallbackError(e);
};
_N = $be([
  Qt()
], _N);
var Xbe = Object.defineProperty, zbe = Object.getOwnPropertyDescriptor, cY = (e) => {
  throw TypeError(e);
}, qbe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? zbe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Xbe(t, r, a), a;
}, e1e = (e, t) => (r, n) => t(r, n, e), dY = (e, t, r) => t.has(e) || cY("Cannot " + r), t1e = (e, t, r) => (dY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), r1e = (e, t, r) => t.has(e) ? cY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), n1e = (e, t, r, n) => (dY(e, t, "write to private field"), t.set(e, r), r), VC;
let NN = class {
  constructor(e) {
    this.category = Me.Finish, r1e(this, VC), n1e(this, VC, e);
  }
  finalize$() {
    return t1e(this, VC).finalize$();
  }
  async finalizeAsync() {
    return Be(this.finalize$());
  }
};
VC = /* @__PURE__ */ new WeakMap();
NN = qbe([
  Qt(),
  e1e(0, ih(Ie.WorkflowStepFinish))
], NN);
var a1e = Object.defineProperty, i1e = Object.getOwnPropertyDescriptor, uY = (e) => {
  throw TypeError(e);
}, o1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? i1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && a1e(t, r, a), a;
}, s1e = (e, t) => (r, n) => t(r, n, e), hY = (e, t, r) => t.has(e) || uY("Cannot " + r), l1e = (e, t, r) => (hY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), c1e = (e, t, r) => t.has(e) ? uY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), d1e = (e, t, r, n) => (hY(e, t, "write to private field"), t.set(e, r), r), MC;
let ZN = class {
  constructor(e) {
    this.category = Me.Finish, c1e(this, MC), d1e(this, MC, e);
  }
  finalize$() {
    return l1e(this, MC).finalize$();
  }
};
MC = /* @__PURE__ */ new WeakMap();
ZN = o1e([
  Qt(),
  s1e(0, ih(Ie.Workflow))
], ZN);
var u1e = Object.defineProperty, h1e = Object.getOwnPropertyDescriptor, pY = (e) => {
  throw TypeError(e);
}, p1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? h1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && u1e(t, r, a), a;
}, gY = (e, t, r) => t.has(e) || pY("Cannot " + r), Jr = (e, t, r) => (gY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), gJ = (e, t, r) => t.has(e) ? pY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), fJ = (e, t, r, n) => (gY(e, t, "write to private field"), t.set(e, r), r), GC, vr;
let BN = class {
  constructor(e) {
    this.category = T.Id, gJ(this, GC), gJ(this, vr), fJ(this, GC, e);
    const t = Ne.get(
      Ie.WorkflowStepIdFactory
    );
    fJ(this, vr, t(e.id));
  }
  getCredential() {
    return Jr(this, GC);
  }
  async getCredentialAsync() {
    return Be(this.selectCredential$());
  }
  selectCredential$() {
    return Jr(this, vr).selectCredential$();
  }
  selectAvailableInputSources$() {
    return Jr(this, vr).selectAvailableInputSources$();
  }
  async getAvailableInputSourcesAsync() {
    return Be(this.selectAvailableInputSources$());
  }
  checkUsability$(e) {
    return Jr(this, vr).checkUsability$(e);
  }
  async checkUsabilityAsync(e) {
    return Be(this.checkUsability$(e));
  }
  selectIdTypeVariant$() {
    return Jr(this, vr).selectIdTypeVariant$();
  }
  getIdTypeVariantAsync() {
    return Be(this.selectIdTypeVariant$());
  }
  selectIdTypeVariantCollection$() {
    return Jr(this, vr).selectIdTypeVariantCollection$();
  }
  async getIdTypeVariantCollectionAsync() {
    return Be(this.selectIdTypeVariantCollection$());
  }
  selectIdTypesForCountry$() {
    return Jr(this, vr).selectIdTypesForCountryWithVariants$();
  }
  async getIdTypesForCountryAsync() {
    return Be(this.selectIdTypesForCountry$());
  }
  uploadData$(e) {
    return Jr(this, vr).uploadData$(e);
  }
  async uploadDataAsync(e) {
    return Be(this.uploadData$(e));
  }
  patchUserSelection(e) {
    Jr(this, vr).patchUserSelection(e);
  }
  getUserSelection() {
    return Jr(this, vr).getUserSelection();
  }
  selectUserSelection$() {
    return Jr(this, vr).selectUserSelection$();
  }
  are2FilesUploaded(e) {
    return Jr(this, vr).are2FilesUploaded(e);
  }
  isUsabilityBackMissing(e) {
    return Jr(this, vr).isUsabilityBackMissing(e);
  }
  selectSidesForSelectedDocument$() {
    return Jr(this, vr).selectSidesForSelectedDocument$();
  }
  getSidesForSelectedDocumentAsync() {
    return Be(this.selectSidesForSelectedDocument$());
  }
  selectIdTypesForCountryWithVariants$() {
    return Jr(this, vr).selectIdTypesForCountryWithVariants$();
  }
  isCountryAndDocTypePredefined() {
    return Jr(this, vr).isCountryAndDocTypePredefined();
  }
  getPartsForDocumentType(e) {
    return Jr(this, vr).getPartsForDocumentType(e);
  }
  selectPartsForDocumentType$(e) {
    return Jr(this, vr).selectPartsForDocumentType$(e);
  }
  selectPartsForDocumentTypeAsync(e) {
    return Be(Jr(this, vr).selectPartsForDocumentType$(e));
  }
};
GC = /* @__PURE__ */ new WeakMap();
vr = /* @__PURE__ */ new WeakMap();
BN = p1e([
  Qt()
], BN);
var g1e = Object.defineProperty, f1e = Object.getOwnPropertyDescriptor, fY = (e) => {
  throw TypeError(e);
}, m1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? f1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && g1e(t, r, a), a;
}, cQ = (e, t, r) => t.has(e) || fY("Cannot " + r), Yf = (e, t, r) => (cQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), mJ = (e, t, r) => t.has(e) ? fY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), v1e = (e, t, r, n) => (cQ(e, t, "write to private field"), t.set(e, r), r), mn = (e, t, r) => (cQ(e, t, "access private method"), r), ql, jr, WN, hi, mY, vY, SY;
let EN = class {
  constructor(e) {
    mJ(this, jr), this.category = T.Id, mJ(this, ql), v1e(this, ql, e), mn(this, jr, mY).call(this);
  }
  getCredential() {
    return Yf(this, ql);
  }
  selectAvailableInputSources$() {
    return Sa([T_.Camera, T_.Upload]);
  }
  selectCredential$() {
    return Sa(Yf(this, ql));
  }
  checkUsability$(e) {
    return mn(this, jr, WN).call(this).checkUsability$(e.usability).pipe(
      oY(e),
      _n(),
      _S({
        shouldRepeat: (t) => t.decisionType === zn.NOT_AVAILABLE
      })
    );
  }
  uploadData$(e) {
    return mn(this, jr, WN).call(this).uploadData$({
      credentialUUID: Yf(this, ql).id,
      params: e
    }).pipe(bw(e), _n());
  }
  selectIdTypesForCountry$() {
    return mn(this, jr, hi).call(this).selectIdTypesForCountry$();
  }
  selectIdTypesForCountryWithVariants$() {
    return mn(this, jr, hi).call(this).selectIdTypesForCountryWithVariants$();
  }
  selectIdTypeVariant$() {
    return mn(this, jr, hi).call(this).selectIdTypeVariant$();
  }
  selectIdTypeVariantCollection$() {
    return mn(this, jr, hi).call(this).selectIdTypeVariantCollection$();
  }
  patchUserSelection(e) {
    mn(this, jr, hi).call(this).patchIdUserSelection(e);
  }
  getUserSelection() {
    return mn(this, jr, hi).call(this).getIdUserSelection();
  }
  are2FilesUploaded(e) {
    return mn(this, jr, hi).call(this).are2FilesUploaded(e);
  }
  isUsabilityBackMissing(e) {
    return mn(this, jr, hi).call(this).isUsabilityBackMissing(e);
  }
  selectUserSelection$() {
    return mn(this, jr, hi).call(this).selectIdUserSelection$();
  }
  selectSidesForSelectedDocument$() {
    return mn(this, jr, hi).call(this).selectSidesForSelectedDocument$();
  }
  isCountryAndDocTypePredefined() {
    return mn(this, jr, hi).call(this).isCountryAndDocTypePredefined();
  }
  selectPartsForDocumentType$(e) {
    return kn().pipe(bt((t) => this.getPartsForDocumentType(e, t)));
  }
  getPartsForDocumentType(e, t = On()) {
    const r = Array.from(P_(e, t.supportedCountries)), [n] = r;
    return (n == null ? void 0 : n.parts) ?? [];
  }
};
ql = /* @__PURE__ */ new WeakMap();
jr = /* @__PURE__ */ new WeakSet();
WN = function() {
  return Ne.get(Ie.Transport);
};
hi = function() {
  return Xl.get(
    up.CredentialIdStoreFactory
  )(Yf(this, ql).id);
};
mY = function(e = On()) {
  const t = mn(this, jr, SY).call(this, Yf(this, ql), e);
  this.patchUserSelection({
    ...t && { selectedCountry: t }
  });
};
vY = function(e) {
  return Object.values(_).includes(e);
};
SY = function(e, t = On()) {
  var o, s, c, l;
  const r = t.supportedCountries.length === 1 ? t.supportedCountries[0].country : void 0, n = ((s = (o = e == null ? void 0 : e.country) == null ? void 0 : o.values) == null ? void 0 : s.length) === 1 ? (l = (c = e == null ? void 0 : e.country) == null ? void 0 : c.values) == null ? void 0 : l[0] : void 0, a = t.countryForIp, i = mn(this, jr, vY).call(this, a) && t.supportedCountries.find((u) => u.country === a) ? a : void 0;
  return n ?? i ?? r ?? void 0;
};
EN = m1e([
  Qt()
], EN);
var S1e = Object.defineProperty, I1e = Object.getOwnPropertyDescriptor, C1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? I1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && S1e(t, r, a), a;
};
let QN = class {
  constructor() {
    this.category = Me.Setup;
  }
};
QN = C1e([
  Qt()
], QN);
var b1e = Object.defineProperty, y1e = Object.getOwnPropertyDescriptor, w1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? y1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && b1e(t, r, a), a;
};
let FN = class {
  constructor() {
    this.category = Me.Setup;
  }
};
FN = w1e([
  Qt()
], FN);
var A1e = Object.defineProperty, U1e = Object.getOwnPropertyDescriptor, k1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? U1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && A1e(t, r, a), a;
};
let TN = class {
  constructor() {
    this.category = Me.Start;
  }
};
TN = k1e([
  Qt()
], TN);
var _1e = Object.defineProperty, N1e = Object.getOwnPropertyDescriptor, Z1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? N1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && _1e(t, r, a), a;
};
let RN = class {
  constructor() {
    this.category = Me.Start;
  }
};
RN = Z1e([
  Qt()
], RN);
var B1e = Object.defineProperty, W1e = Object.getOwnPropertyDescriptor, IY = (e) => {
  throw TypeError(e);
}, E1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? W1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && B1e(t, r, a), a;
}, CY = (e, t, r) => t.has(e) || IY("Cannot " + r), Ns = (e, t, r) => (CY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), DU = (e, t, r) => t.has(e) ? IY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), JU = (e, t, r, n) => (CY(e, t, "write to private field"), t.set(e, r), r), sf, Yl, lf;
let DN = class {
  constructor() {
    DU(this, sf, {}), DU(this, Yl, []), DU(this, lf, new sM(1 / 0));
  }
  addLogger(e) {
    Ns(this, Yl).push(e), Ns(this, sf)[e.getId()] = Ns(this, lf).subscribe(([t, r]) => {
      switch (t) {
        case "analytic":
          e.log(r);
          break;
        case "report":
          e.report(r);
          break;
      }
    });
  }
  getLoggerById(e) {
    return Ns(this, Yl).find((t) => t.getId() === e);
  }
  removeLogger(e) {
    this.removeLoggerById(e.getId()), JU(this, Yl, Ns(this, Yl).filter((t) => e !== t));
  }
  removeLoggerById(e) {
    const { [e]: t, ...r } = Ns(this, sf);
    t == null || t.unsubscribe(), JU(this, sf, r), JU(this, Yl, Ns(this, Yl).filter((n) => n.getId() !== e));
  }
  log(e) {
    const { tags: t = {} } = e;
    e.eventType === "screen" && (t.screen = e.eventName), pg(t), Ns(this, lf).next(["analytic", e]);
  }
  report(e) {
    const { tags: t = {} } = e;
    e.eventType === "screen" && (t.screen = e.eventName), pg(t), Ns(this, lf).next(["report", e]);
  }
};
sf = /* @__PURE__ */ new WeakMap();
Yl = /* @__PURE__ */ new WeakMap();
lf = /* @__PURE__ */ new WeakMap();
DN = E1e([
  Qt()
], DN);
class Q1e extends Error {
  constructor(t = "The condition is not met") {
    super(t);
  }
}
const F1e = ({ maxRetryAttempts: e = 2, scalingDuration: t = 1e3 }) => (r, n) => n + 1 > e ? zc(() => r) : hs(t), T1e = ({ retryCondition: e, maxRetryAttempts: t = 2, scalingDuration: r = 1e3 }) => (n, a) => !e(n) || a > t ? zc(() => n) : hs(r), R1e = (e) => ho(
  EM({
    delay: T1e(e)
  })
), D1e = (e) => {
  const { successCondition: t, maxRetryAttempts: r = 2, scalingDuration: n = 1e4 } = e;
  return (a) => a.pipe(
    Ote({
      count: r,
      delay: n
    }),
    Wt((i, o) => o > r ? zc(() => new Q1e()) : [i]),
    Yte(t)
  );
}, Co = (e = {
  maxRetryAttempts: 2,
  scalingDuration: 1e3
}) => ho(
  EM({
    delay: F1e(e)
  })
), J1e = (e) => Ut(e, [
  "accountId",
  "acquisitionReference",
  "credentials",
  "supportedCountries",
  "supportedDocumentTypes",
  "timestamp"
]), Ta = (e = {}) => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  "Sdk-Platform": "WEB",
  "Sdk-Version": "Jumio WEB SDK 4.13",
  "Websdk-Version": "0.2.14-b10b1242.2",
  ...e
}), V1e = async (e) => {
  const t = await e.text();
  try {
    return {
      response: e,
      responseText: t,
      responseJson: JSON.parse(t),
      isValidJson: !0
    };
  } catch {
    return {
      response: e,
      responseText: t,
      responseJson: {},
      isValidJson: !1
    };
  }
}, bY = (e, t) => {
  let r = B_;
  switch (e.status) {
    case 305:
      r = Phe;
      break;
    case 400:
      t === Kr.FinalizeCall && (r = $he);
      break;
    case 401:
      r = Ohe;
      break;
    case 406:
      r = jhe;
      break;
    case 412:
      r = yE;
      break;
    case 429:
      r = Yhe;
      break;
    case 451:
      r = Khe;
      break;
    default:
      r = B_;
      break;
  }
  return vw(r, t, e.status);
};
function M1e({ response: e, responseJson: t, responseText: r }, n) {
  const a = {
    requestURI: e.url,
    httpStatus: e.status,
    errorJson: t,
    errorText: r,
    message: Ut(t, ["message"]) ? t.message : "",
    publicError: bY(e, n)
  };
  return Promise.reject(new es(a));
}
const Ra = ({
  requestCode: e,
  validator: t,
  url: r
}) => (n) => n.pipe(
  ao((a) => V1e(a).then((i) => {
    const { responseJson: o, response: s, responseText: c } = i, l = o ?? c;
    return s.status === Hm.HTTP_STATUS_OK ? t(l) ? l : Promise.reject(
      new es({
        httpStatus: 200,
        requestURI: s.url,
        message: "Server response validation has failed",
        errorJson: o,
        errorText: c,
        publicError: bY(a, e)
      })
    ) : M1e(i, e);
  })),
  ti((a) => zc(() => a instanceof es ? a : new es({
    httpStatus: 0,
    requestURI: r,
    message: "Could not reach the backend"
  })))
);
var G1e = Object.defineProperty, x1e = Object.getOwnPropertyDescriptor, yY = (e) => {
  throw TypeError(e);
}, H1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? x1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && G1e(t, r, a), a;
}, L1e = (e, t, r) => t.has(e) || yY("Cannot " + r), Y1e = (e, t, r) => t.has(e) ? yY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Vt = (e, t, r) => (L1e(e, t, "access private method"), r), Zt, ia, oa, wY, AY;
let Hm = class {
  constructor() {
    Y1e(this, Zt);
  }
  getSettings$(e) {
    const t = `${Vt(this, Zt, oa).call(this)}/settings`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      body: JSON.stringify(e),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.SettingsCall,
        validator: J1e
      }),
      Co()
    );
  }
  sendAnalyticsEvent$(e) {
    const t = `${Vt(this, Zt, oa).call(this)}/analyticsevent`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      body: JSON.stringify(e),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.ReportingCall,
        validator: vd
      }),
      te(() => ({})),
      ti(() => Sa({}))
    );
  }
  sendReportingEvent$(e) {
    const t = `${Vt(this, Zt, oa).call(this)}/reportingevent`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      body: JSON.stringify(e),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.ReportingCall,
        validator: vd
      }),
      Co()
    );
  }
  finalize$() {
    const e = `${Vt(this, Zt, oa).call(this)}/finalize`;
    return vn(() => fetch(e, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      mode: "cors"
    })).pipe(
      Ra({
        url: e,
        requestCode: Kr.FinalizeCall,
        validator: (t) => vd(t)
      }),
      Co()
    );
  }
  getIproovToken$(e = "none") {
    const t = `${Vt(this, Zt, oa).call(this)}/iproov/token`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      body: JSON.stringify({
        reason: e
      }),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.IproovTokenCall,
        validator: (r) => typeof r > "u" || Ut(
          r,
          ["token", "url", "productType", "remainingAttempts"],
          (n) => !!(n.token && n.url && n.productType && n.remainingAttempts >= 0)
        )
      }),
      Co()
    );
  }
  validateIproovToken$(e) {
    const t = `${Vt(this, Zt, oa).call(this)}/iproov/validate`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      body: JSON.stringify(e),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.IproovValidateCall,
        validator: (r) => Ut(r, ["passed"])
      }),
      Co()
    );
  }
  checkUsability$({ resultKey: e }) {
    const t = `${Vt(this, Zt, oa).call(this)}/result/usability/${e}`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.UsabilityCall,
        validator: (r) => Ut(r, ["decisionType"])
      }),
      Co()
    );
  }
  extractData$() {
    const e = `${Vt(this, Zt, oa).call(this)}/results/extract-data`;
    return vn(() => fetch(e, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`
      }),
      mode: "cors"
    })).pipe(
      Ra({
        url: e,
        requestCode: Kr.ExtractDataCall,
        validator: (t) => vd(t)
      }),
      Co()
    );
  }
  uploadData$({ credentialUUID: e, params: t }) {
    const r = `${Vt(this, Zt, oa).call(this)}/credential/${e}/upload`;
    return vn(() => {
      const n = Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`,
        Accept: "application/json"
      });
      return delete n["Content-Type"], fetch(r, {
        method: "POST",
        headers: n,
        body: Vt(this, Zt, wY).call(this, t),
        mode: "cors"
      });
    }).pipe(
      Ra({
        url: r,
        requestCode: Kr.UploadCall,
        validator: (n) => vd(n)
      }),
      Co()
    );
  }
  getAcquisitionStatus$() {
    const e = `${Vt(this, Zt, oa).call(this)}/status`;
    return vn(() => fetch(e, {
      method: "GET",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`,
        Accept: "application/json"
      }),
      mode: "cors"
    })).pipe(
      Ra({
        url: e,
        requestCode: Kr.StatusCall,
        validator: (t) => Ut(t, ["status"])
      }),
      R1e({
        retryCondition: (t) => t instanceof es && t.details.httpStatus === 0,
        maxRetryAttempts: Number.MAX_VALUE,
        scalingDuration: 5e3
      })
    );
  }
  sendCrossDeviceEmail$(e) {
    const t = `${Vt(this, Zt, oa).call(this)}/email`;
    return vn(() => fetch(t, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`,
        Accept: "application/json"
      }),
      body: JSON.stringify(e),
      mode: "cors"
    })).pipe(
      Ra({
        url: t,
        requestCode: Kr.CrossDeviceEmailCall,
        validator: (r) => Ut(r, ["success"])
      }),
      Co()
    );
  }
  getFilePart$(e) {
    const { acquisitionId: t, credentialId: r, partId: n } = e, a = `${Vt(this, Zt, oa).call(this)}/${t}/credentials/${r}/parts/${n}`;
    return vn(() => fetch(a, {
      method: "GET",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`,
        Accept: "application/json"
      }),
      mode: "cors"
    })).pipe(
      Ra({
        url: a,
        requestCode: Kr.GetFilePartCall,
        validator: (i) => vd(i)
      }),
      D1e({
        maxRetryAttempts: 10,
        scalingDuration: 5e3,
        successCondition: (i) => !!i.base64
      })
    );
  }
  updateMetadata$(e, t, r) {
    const n = `${Vt(this, Zt, oa).call(this)}/${e}/credentials/${t}/metadata`;
    return vn(() => fetch(n, {
      method: "POST",
      headers: Ta({
        Authorization: `Bearer ${Vt(this, Zt, ia).call(this)}`,
        Accept: "application/json"
      }),
      body: JSON.stringify(r),
      mode: "cors"
    })).pipe(
      Ra({
        url: n,
        requestCode: Kr.UpdateMetadata,
        validator: (a) => vd(a)
      }),
      Co()
    );
  }
};
Zt = /* @__PURE__ */ new WeakSet();
ia = function() {
  const { token: e } = Le();
  return e;
};
oa = function() {
  const { baseUrl: e } = Le();
  return e;
};
wY = function(e, t = new FormData()) {
  return e.uploadFilesMetadata && Vt(this, Zt, AY).call(this, t, e.uploadFilesMetadata), e.data && t.append("data", JSON.stringify(e.data)), e.deviceRisks && t.append("deviceRisks", JSON.stringify({ deviceRisks: e.deviceRisks })), e.consents && t.append("consents", JSON.stringify({ consents: e.consents })), t;
};
AY = function(e, t) {
  const r = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    files: t.files.map(({ file: n, ...a }) => a)
  };
  e.append("uploadFilesMetadata", JSON.stringify(r)), t.files.forEach((n) => {
    n.file instanceof File ? e.append(n.multipartName, n.file, n.file.name) : e.append(n.multipartName, n.file);
  });
};
Hm.HTTP_STATUS_OK = 200;
Hm = H1e([
  Qt()
], Hm);
var O1e = Object.defineProperty, j1e = Object.getOwnPropertyDescriptor, UY = (e) => {
  throw TypeError(e);
}, P1e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? j1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && O1e(t, r, a), a;
}, $1e = (e, t) => (r, n) => t(r, n, e), kY = (e, t, r) => t.has(e) || UY("Cannot " + r), bo = (e, t, r) => (kY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), K1e = (e, t, r) => t.has(e) ? UY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), X1e = (e, t, r, n) => (kY(e, t, "write to private field"), t.set(e, r), r), Va;
let JN = class {
  constructor(e) {
    K1e(this, Va), X1e(this, Va, e);
  }
  async checkUsability(e) {
    return Be(bo(this, Va).checkUsability$(e));
  }
  async extractData() {
    return Be(bo(this, Va).extractData$());
  }
  async finalize() {
    return Be(bo(this, Va).finalize$());
  }
  async getIproovToken(e = "none") {
    return Be(bo(this, Va).getIproovToken$(e));
  }
  async getSettings(e) {
    return Be(bo(this, Va).getSettings$(e));
  }
  async sendAnalyticsEvent(e) {
    return Be(bo(this, Va).sendAnalyticsEvent$(e));
  }
  async sendReportingEvent(e) {
    return Be(bo(this, Va).sendReportingEvent$(e));
  }
  async uploadData(e) {
    return Be(bo(this, Va).uploadData$(e));
  }
  async validateIproovToken(e) {
    return Be(bo(this, Va).validateIproovToken$(e));
  }
  getAcquisitionStatus() {
    return Be(bo(this, Va).getAcquisitionStatus$());
  }
};
Va = /* @__PURE__ */ new WeakMap();
JN = P1e([
  Qt(),
  $1e(0, ih(Ie.Transport))
], JN);
var z1e = Object.defineProperty, q1e = Object.getOwnPropertyDescriptor, _Y = (e) => {
  throw TypeError(e);
}, eye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? q1e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && z1e(t, r, a), a;
}, tye = (e, t) => (r, n) => t(r, n, e), NY = (e, t, r) => t.has(e) || _Y("Cannot " + r), vJ = (e, t, r) => (NY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), rye = (e, t, r) => t.has(e) ? _Y("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), nye = (e, t, r, n) => (NY(e, t, "write to private field"), t.set(e, r), r), cf;
let VN = class {
  constructor(e) {
    rye(this, cf), nye(this, cf, e);
  }
  getToken$() {
    return vJ(this, cf).token$;
  }
  async getToken() {
    return Be(this.getToken$());
  }
  setToken(e) {
    vJ(this, cf).setToken(e);
  }
};
cf = /* @__PURE__ */ new WeakMap();
VN = eye([
  Qt(),
  tye(0, ih(Ie.TokenManager))
], VN);
var aye = Object.defineProperty, iye = Object.getOwnPropertyDescriptor, oye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? iye(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && aye(t, r, a), a;
};
let MN = class {
  constructor() {
    this.token$ = Ove();
  }
  setToken(e) {
    eo({
      token: e
    });
  }
  getToken() {
    return zH();
  }
};
MN = oye([
  Qt()
], MN);
var sye = Object.defineProperty, lye = Object.getOwnPropertyDescriptor, ZY = (e) => {
  throw TypeError(e);
}, cye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? lye(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && sye(t, r, a), a;
}, dye = (e, t) => (r, n) => t(r, n, e), BY = (e, t, r) => t.has(e) || ZY("Cannot " + r), VU = (e, t, r) => (BY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), uye = (e, t, r) => t.has(e) ? ZY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), hye = (e, t, r, n) => (BY(e, t, "write to private field"), t.set(e, r), r), Fh;
const SJ = {
  linkedModules: [
    Ja.Mrz,
    Ja.Barcode,
    Ja.LineFinder,
    Ja.DocFinder,
    Ja.Manual,
    Ja.FaceManual,
    Ja.FaceIproov,
    Ja.DataDog,
    Ja.Sardine,
    Ja.Iovation,
    Ja.JumioLiveness,
    Ja.DigitalIdentity
  ],
  deviceDetails: {
    "sdk-platform": "WEB",
    "sdk-version": "Jumio WEB SDK 4.13"
  }
};
let GN = class {
  constructor(e) {
    uye(this, Fh), hye(this, Fh, e);
  }
  getSettings() {
    return VU(this, Fh).getSettings();
  }
  async fetchSettingsAsync(e = SJ) {
    return Be(this.fetchSettings$(e));
  }
  fetchSettings$(e = SJ) {
    return VU(this, Fh).fetchSettings$(e);
  }
  async selectSettings() {
    return Be(this.selectSettings$());
  }
  selectSettings$() {
    return VU(this, Fh).settings$;
  }
};
Fh = /* @__PURE__ */ new WeakMap();
GN = cye([
  Qt(),
  dye(0, ih(Ie.WorkflowConfiguration))
], GN);
var pye = Object.defineProperty, gye = Object.getOwnPropertyDescriptor, WY = (e) => {
  throw TypeError(e);
}, fye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? gye(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && pye(t, r, a), a;
}, mye = (e, t) => (r, n) => t(r, n, e), EY = (e, t, r) => t.has(e) || WY("Cannot " + r), vye = (e, t, r) => (EY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Sye = (e, t, r) => t.has(e) ? WY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Iye = (e, t, r, n) => (EY(e, t, "write to private field"), t.set(e, r), r), xC;
let xN = class {
  constructor(e) {
    Sye(this, xC), Iye(this, xC, e);
  }
  sendEmail$(e) {
    return vye(this, xC).sendEmail$(e);
  }
  sendEmailAsync(e) {
    return Be(this.sendEmail$(e));
  }
};
xC = /* @__PURE__ */ new WeakMap();
xN = fye([
  Qt(),
  mye(0, ih(Ie.WorkflowEmail))
], xN);
var Cye = Object.defineProperty, bye = Object.getOwnPropertyDescriptor, QY = (e) => {
  throw TypeError(e);
}, yye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? bye(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Cye(t, r, a), a;
}, wye = (e, t, r) => t.has(e) || QY("Cannot " + r), Aye = (e, t, r) => t.has(e) ? QY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Uye = (e, t, r) => (wye(e, t, "access private method"), r), HN, FY;
let LN = class {
  constructor() {
    Aye(this, HN);
  }
  sendEmail$(e) {
    return Uye(this, HN, FY).call(this).sendCrossDeviceEmail$(e).pipe(_n());
  }
};
HN = /* @__PURE__ */ new WeakSet();
FY = function() {
  return Ne.get(Ie.Transport);
};
LN = yye([
  Qt()
], LN);
var kye = Object.defineProperty, _ye = Object.getOwnPropertyDescriptor, TY = (e) => {
  throw TypeError(e);
}, Nye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? _ye(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && kye(t, r, a), a;
}, RY = (e, t, r) => t.has(e) || TY("Cannot " + r), R0 = (e, t, r) => (RY(e, t, "read from private field"), r ? r.call(e) : t.get(e)), IJ = (e, t, r) => t.has(e) ? TY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), CJ = (e, t, r, n) => (RY(e, t, "write to private field"), t.set(e, r), r), HC, Zd;
let YN = class {
  constructor(e) {
    this.category = T.Data, IJ(this, HC), IJ(this, Zd);
    const t = Ne.get(
      Ie.WorkflowStepDataFactory
    );
    CJ(this, HC, e), CJ(this, Zd, t(e.id));
  }
  getCredential() {
    return R0(this, HC);
  }
  async getCredentialAsync() {
    return Be(this.selectCredential$());
  }
  selectCredential$() {
    return R0(this, Zd).selectCredential$();
  }
  checkUsability$(e) {
    return R0(this, Zd).checkUsability$(e);
  }
  async checkUsabilityAsync(e) {
    return Be(this.checkUsability$(e));
  }
  uploadData$(e) {
    return R0(this, Zd).uploadData$(e);
  }
  async uploadDataAsync(e) {
    return Be(this.uploadData$(e));
  }
  isIovation() {
    return R0(this, Zd).isIovation();
  }
};
HC = /* @__PURE__ */ new WeakMap();
Zd = /* @__PURE__ */ new WeakMap();
YN = Nye([
  Qt()
], YN);
var Zye = Object.defineProperty, Bye = Object.getOwnPropertyDescriptor, DY = (e) => {
  throw TypeError(e);
}, Wye = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Bye(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Zye(t, r, a), a;
}, dQ = (e, t, r) => t.has(e) || DY("Cannot " + r), HI = (e, t, r) => (dQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), bJ = (e, t, r) => t.has(e) ? DY("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Eye = (e, t, r, n) => (dQ(e, t, "write to private field"), t.set(e, r), r), yJ = (e, t, r) => (dQ(e, t, "access private method"), r), Bd, LC, ON;
let jN = class {
  constructor(e) {
    bJ(this, LC), this.category = T.Data, bJ(this, Bd), Eye(this, Bd, e);
  }
  getCredential() {
    return HI(this, Bd);
  }
  selectCredential$() {
    return Sa(HI(this, Bd));
  }
  isIovation() {
    return HI(this, Bd).deviceRiskVendors.includes(bE.Iovation);
  }
  uploadData$(e) {
    return yJ(this, LC, ON).call(this).uploadData$({
      credentialUUID: HI(this, Bd).id,
      params: e
    }).pipe(bw(e), _n());
  }
  checkUsability$(e) {
    return yJ(this, LC, ON).call(this).checkUsability$(e.usability).pipe(
      _n(),
      _S({
        shouldRepeat: (t) => t.decisionType === zn.NOT_AVAILABLE
      })
    );
  }
};
Bd = /* @__PURE__ */ new WeakMap();
LC = /* @__PURE__ */ new WeakSet();
ON = function() {
  return Ne.get(Ie.Transport);
};
jN = Wye([
  Qt()
], jN);
const Bn = {}, Qye = (e) => {
  if (!e)
    throw new Error(`Credential for "ID#${e}" logic is not defined!`);
  const t = `${T.Id}_logic_${e}`, r = Bn[t] ?? new EN(vo(e));
  return Bn[t] = r, r;
}, Fye = (e) => {
  if (!e)
    throw new Error(`Credential for "ID#${e}" controller is not defined!`);
  const t = `${T.Id}_controller_${e}`, r = Bn[t] ?? new BN(vo(e));
  return Bn[t] = r, r;
}, Tye = (e) => {
  if (!e)
    throw new Error(`Credential for "FACEMAP#${e}" logic is not defined!`);
  const t = `${T.Facemap}_logic_${e}`, r = Bn[t] ?? new _N(vo(e));
  return Bn[t] = r, r;
}, Rye = (e) => {
  if (!e)
    throw new Error(`Credential for "FACEMAP#${e}" controller is not defined!`);
  const t = `${T.Facemap}_controller_${e}`, r = Bn[t] ?? new UN(vo(e));
  return Bn[t] = r, r;
}, Dye = (e) => {
  if (!e)
    throw new Error(`Credential for "DOCUMENT#${e}" logic is not defined!`);
  const t = `${T.Document}_logic_${e}`, r = Bn[t] ?? new AN(vo(e));
  return Bn[t] = r, r;
}, Jye = (e) => {
  if (!e)
    throw new Error(`Credential for "DOCUMENT#${e}" controller is not defined!`);
  const t = `${T.Document}_controller_${e}`, r = Bn[t] ?? new yN(vo(e));
  return Bn[t] = r, r;
}, Vye = (e) => {
  if (!e)
    throw new Error(`Credential for "DATA#${e}" logic is not defined!`);
  const t = `${T.Data}_logic_${e}`, r = Bn[t] ?? new jN(vo(e));
  return Bn[t] = r, r;
}, Mye = (e) => {
  if (!e)
    throw new Error(`Credential for "DATA#${e}" controller is not defined!`);
  const t = `${T.Data}_controller_${e}`, r = Bn[t] ?? new YN(vo(e));
  return Bn[t] = r, r;
};
function Gye(e = {}) {
  return Kve(), Ne.unbindAll(), Ne.parent = cfe(e), Ne.bind(e.TokenManager ?? Ie.TokenManager).to(e.TokenManager ?? MN).inSingletonScope(), Ne.bind(Ie.TokenManagerController).to(e.TokenManagerController ?? VN).inSingletonScope(), Ne.bind(Ie.Logger).to(e.LoggerManager ?? DN).inSingletonScope(), Ne.bind(Ie.Transport).to(e.Transport ?? Hm).inSingletonScope(), Ne.bind(Ie.TransportController).to(e.TransportController ?? JN).inSingletonScope(), Ne.bind(Ie.WorkflowConfiguration).to(e.WorkflowConfiguration ?? vN).inSingletonScope(), Ne.bind(Ie.WorkflowConfigurationController).to(e.WorkflowConfigurationController ?? GN).inSingletonScope(), Ne.bind(Ie.WorkflowConsent).to(e.WorkflowConsent ?? IN).inSingletonScope(), Ne.bind(Ie.WorkflowEmail).to(e.WorkflowEmail ?? LN).inSingletonScope(), Ne.bind(Ie.WorkflowConsentController).to(e.WorkflowConsentController ?? SN).inSingletonScope(), Ne.bind(Ie.WorkflowEmailController).to(e.WorkflowEmailController ?? xN).inSingletonScope(), Ne.bind(Ie.Workflow).to(e.Workflow ?? bN).inSingletonScope(), Ne.bind(e.WorkflowController ?? Ie.WorkflowController).to(CN).inSingletonScope(), Ne.bind(Ie.WorkflowStepSetupController).to(e.WorkflowStepSetupController ?? QN).inSingletonScope(), Ne.bind(Ie.WorkflowStepSetup).to(e.WorkflowStepSetup ?? FN).inSingletonScope(), Ne.bind(Ie.WorkflowStepStart).to(e.WorkflowStepStart ?? RN).inSingletonScope(), Ne.bind(Ie.WorkflowStepStartController).to(e.WorkflowStepStartController ?? TN).inSingletonScope(), Ne.bind(Ie.WorkflowStepIdFactory).toFactory(() => e.WorkflowStepIdFactory ?? Qye), Ne.bind(Ie.WorkflowStepIdControllerFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepIdControllerFactory) ?? Fye), Ne.bind(Ie.WorkflowStepFacemapFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepFacemapFactory) ?? Tye), Ne.bind(Ie.WorkflowStepFacemapControllerFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepFacemapControllerFactory) ?? Rye), Ne.bind(Ie.WorkflowStepDocumentFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepDocumentFactory) ?? Dye), Ne.bind(Ie.WorkflowStepDocumentControllerFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepDocumentControllerFactory) ?? Jye), Ne.bind(Ie.WorkflowStepDataFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepDataFactory) ?? Vye), Ne.bind(Ie.WorkflowStepDataControllerFactory).toFactory(() => (e == null ? void 0 : e.WorkflowStepDataControllerFactory) ?? Mye), Ne.bind(Ie.WorkflowStepFinish).to(e.WorkflowStepFinish ?? ZN).inSingletonScope(), Ne.bind(Ie.WorkflowStepFinishController).to(e.WorkflowStepFinishController ?? NN).inSingletonScope(), Ne.get(Ie.WorkflowController);
}
const YC = new Kt(void 0), JY = () => Gye();
function xye(e = JY()) {
  return YC.next(e), e;
}
function Ce() {
  const e = YC.getValue() || JY();
  return YC.getValue() || YC.next(e), e;
}
const VY = new _e(), MY = (e) => {
  VY.next(e);
}, Hye = () => VY.asObservable();
class GY extends CustomEvent {
  constructor(t) {
    super("rendererframe", {
      bubbles: !0,
      cancelable: !0,
      composed: !0,
      detail: t
    });
  }
}
class wJ extends CustomEvent {
  constructor(t) {
    super("cameraplaybackstatus", {
      bubbles: !0,
      cancelable: !0,
      composed: !0,
      detail: t
    });
  }
}
class GS extends DOMException {
  constructor(t = "Internal camera error") {
    super(t, "CameraError");
  }
}
const uQ = "SFSafariViewControllerCameraError";
class Lye extends DOMException {
  constructor(t = "A MediaStreamTrack ended due to a capture failure") {
    super(t, uQ);
  }
}
const LI = "WebglError";
var vg = /* @__PURE__ */ ((e) => (e.Front = "front", e.Back = "back", e.NotAvailable = "not-available", e))(vg || {}), Sg = /* @__PURE__ */ ((e) => (e.Camera = "camera", e.File = "file", e))(Sg || {});
const { deviceEntitiesRef: hQ, withDeviceEntities: Yye } = ad("device"), { mockDeviceEntitiesRef: xS, withMockDeviceEntities: Oye } = ad("mockDevice"), Wn = mo(
  { name: "devices" },
  Wl({
    deviceId: void 0,
    cameraPermissionState: "granted"
  }),
  Yye({
    idKey: "deviceId",
    initialValue: []
  }),
  Oye({
    idKey: "deviceId",
    initialValue: []
  })
), SVe = () => Wn.pipe(
  te((e) => {
    const t = {
      ...e.mockDeviceEntities,
      ...e.deviceEntities
    };
    return e.deviceId ? t[e.deviceId] : void 0;
  }),
  vt((e, t) => (e == null ? void 0 : e.deviceId) === (t == null ? void 0 : t.deviceId))
), xY = () => Wn.getValue(), jye = (e) => {
  Wn.update(
    sw(e, {
      ref: hQ
    })
  );
}, IVe = (e) => {
  nL && Wn.update(
    sw(e, {
      ref: xS
    })
  );
}, CVe = (...e) => {
  if (nL) {
    const t = e.map((r) => {
      const n = new URL(r);
      return {
        deviceId: um(),
        groupId: um(),
        kind: "videoinput",
        label: n.pathname,
        capabilities: {}
      };
    });
    Wn.update(
      sw(t, {
        ref: xS
      })
    );
  }
}, pQ = () => {
  const { cameraPermissionState: e } = Wn.getValue();
  return e;
}, Pye = (e) => {
  Wn.update(cn("cameraPermissionState", e));
}, gQ = () => Wn.pipe(bt((e) => e.cameraPermissionState)), HY = () => {
  const e = Wn.pipe(
    Tu({
      mapEntity: (r) => r,
      filterEntity: (r) => r.kind === "videoinput",
      ref: hQ
    })
  ), t = Wn.pipe(
    Tu({
      mapEntity: (r) => r,
      filterEntity: (r) => r.kind === "videoinput",
      ref: xS
    })
  );
  return e.pipe($a(t)).pipe(te(([r, n]) => [...r, ...n]));
}, $ye = (e = "") => {
  Wn.update((t) => {
    const r = Object.values(t.deviceEntities).find((a) => a.deviceId === e), n = Object.values(t.mockDeviceEntities).find((a) => a.deviceId === e);
    return {
      ...t,
      currentDevice: r ?? n,
      deviceId: e
    };
  });
}, jn = () => Wn.query((e) => {
  const t = {
    ...e.mockDeviceEntities,
    ...e.deviceEntities
  };
  return e.deviceId ? t[e.deviceId] : void 0;
}), Kye = () => {
  Wn.update(cn("deviceId", void 0));
}, fQ = () => {
  const e = Wn.query(
    D_({
      ref: hQ
    })
  ), t = Wn.query(
    D_({
      ref: xS
    })
  );
  return [...e, ...t];
}, LY = (e) => Wn.query(
  WS(e, {
    ref: xS
  })
), Xye = (e) => !!LY(e), zye = [
  "Front Camera",
  "الكاميرا الأمامية",
  "Предна камера",
  "前置相机",
  "前置相機",
  "前置鏡頭",
  "Prednja kamera",
  "Přední fotoaparát",
  "Forsidekamera",
  "Camera aan voorzijde",
  "Front Camera",
  "Etukamera",
  "Appareil photo avant",
  "Appareil photo avant",
  "Frontkamera",
  "Μπροστινή κάμερα",
  "מצלמה קדמית",
  "Előlapi kamera",
  "Kamera Depan",
  "Fotocamera anteriore",
  "前面カメラ",
  "전면 카메라",
  "Kamera Depan",
  "Kamera på forsiden",
  "Aparat przedni",
  "Câmara frontal",
  "Câmera Frontal",
  "Cameră față",
  "Передняя камера",
  "Predná kamera",
  "Cámara frontal",
  "Cámara frontal",
  "Kamera på framsidan",
  "กล้องด้านหน้า",
  "Ön Kamera",
  "Передня камера",
  "Camera mặt trước"
], qye = [
  "Back Triple Camera",
  "كاميرا خلفية ثلاثية",
  "Задна тройна камера",
  "后置三镜头",
  "後置三鏡頭相機",
  "後置三鏡頭相機",
  "Stražnja trostruka kamera",
  "Zadní trojitý fotoaparát",
  "Back Triple Camera",
  "Back Triple Camera",
  "Back Triple Camera",
  "Kolmoistakakamera",
  "Triple appareil photo arrière",
  "Rückseitige Triple-Kamera",
  "Πίσω τριπλή κάμερα",
  "מצלמה משולשת אחורית",
  "Hátsó, tripla kamera",
  "Tiga Kamera Belakang",
  "Fotocamera tripla (posteriore)",
  "背面トリプルカメラ",
  "후면 트리플 카메라",
  "Tiga Kamera Belakang",
  "Trippelt kamera bak",
  "Tylny aparat trójobiektywowy",
  "Câmara tripla traseira",
  "Câmera Tripla Traseira",
  "Cameră triplă spate",
  "Задняя тройная камера",
  "Zadná trojitá kamera",
  "Cámara trasera triple",
  "Cámara posterior triple",
  "Bakre trippelkamera",
  "กล้องด้านหลังสามกล้อง",
  "Üçlü Arka Kamera",
  "Задня потроєна камера",
  "Ba camera mặt sau"
], e2e = [
  "Back Dual Wide Camera",
  "كاميرا خلفية مزدوجة عريضة",
  "Задна двойна широкоъгълна камера",
  "后置双广角镜头",
  "後置雙廣角相機",
  "後置雙廣角鏡頭相機",
  "Stražnja dvostruka široka kamera",
  "Zadní duální širokoúhlý fotoaparát",
  "Back Dual Wide Camera",
  "Back Dual Wide Camera",
  "Back Dual Wide Camera",
  "Laajakulmainen kaksoistakakamera",
  "Double appareil photo grand angle arrière",
  "Rückseitige Dual-Weitwinkelkamera",
  "Πίσω διπλή ευρεία κάμερα",
  "מצלמה כפולה רחבה אחורית",
  "Hátsó, kettős, széles látószögű kamera",
  "Kamera Lebar Belakang Ganda",
  "Fotocamera doppia con grandangolo (posteriore)",
  "背面デュアル広角カメラ",
  "후면 듀얼 와이드 카메라",
  "Dwikamera Lebar Belakang",
  "Dobbelt vidvinkelkamera bak",
  "Tylny dwuobiektywowy aparat szerokokątny",
  "Câmara grande angular dupla traseira",
  "Câmera Dupla Grande-Angular Traseira",
  "Cameră dublă cu obiectiv superangular spate",
  "Задняя двойная широкоугольная камера",
  "Zadná duálna širokouhlá kamera",
  "Cámara trasera dual con gran angular",
  "Cámara amplia posterior doble",
  "Dubbel vidvinkelkamera på baksidan",
  "กล้องคู่ด้านหลังมุมกว้าง",
  "Çift Geniş Kamera Arka Yüzü",
  "Задня здвоєна ширококутна камера",
  "Camera kép rộng mặt sau"
], AJ = [
  "Back Ultra Wide Camera",
  "كاميرا خلفية عريضة جدًا",
  "Задна свръх широкоъгълна камера",
  "后置超广角相机",
  "後置超廣角相機",
  "後置超廣角鏡頭相機",
  "Stražnja ultra široka kamera",
  "Zadní ultraširokoúhlý fotoaparát",
  "Ultravidvinkelkameraet på bagsiden",
  "Ultrabrede camera aan achterzijde",
  "Back Ultra Wide Camera",
  "Ultralaajakulmainen takakamera",
  "Appareil photo ultra grand angle arrière",
  "Rückseitige Ultra-Weitwinkelkamera",
  "Πίσω υπερευρεία κάμερα",
  "מצלמה אולטרה רחבה אחורית",
  "Hátsó, ultraszéles látószögű kamera",
  "Kamera Ultra Lebar Belakang",
  "Fotocamera con ultra-grandangolo (posteriore)",
  "背面超広角カメラ",
  "후면 울트라 와이드 카메라",
  "Kamera Ultralebar Belakang",
  "Ultravidvinkelkamera bak",
  "Tylny aparat ultraszerokokątny",
  "Câmara ultra grande angular traseira",
  "Câmera Ultra-Angular Traseira",
  "Cameră cu obiectiv ultra‑superangular spate",
  "Задняя сверхширокоугольная камера",
  "Zadná ultraširokouhlá kamera",
  "Cámara trasera con ultra gran angular",
  "Cámara ultra amplia posterior doble",
  "Ultravidvinkelkamera på baksidan",
  "กล้องด้านหลังอัลตร้าไวด์",
  "Ultra Geniş Kamera Arka Yüzü",
  "Задня надширококутна камера",
  "Camera cực rộng mặt sau"
], t2e = [
  "Back Dual Camera",
  "الكاميرا الخلفية المزدوجة",
  "Задна двойна камера",
  "后置双镜头",
  "後置雙鏡頭相機",
  "後置雙鏡頭相機",
  "Stražnja dvostruka kamera",
  "Zadní duální fotoaparát",
  "Dobbelt kamera på bagsiden",
  "Dubbele camera achterzijde",
  "Back Dual Camera",
  "Kaksoistakakamera",
  "Double appareil photo arrière",
  "Rückseitige Dual-Kamera",
  "Πίσω διπλή κάμερα",
  "מצלמה כפולה אחורית",
  "Hátsó kettős kamera",
  "Kamera Ganda Belakang",
  "Fotocamera doppia (posteriore)",
  "背面デュアルカメラ",
  "후면 듀얼 카메라",
  "Dwikamera Belakang",
  "Dobbelt kamera bak",
  "Tylny aparat dwuobiektywowy",
  "Câmara dupla traseira",
  "Câmera Dupla Traseira",
  "Cameră dublă spate",
  "Задняя двойная камера",
  "Zadná duálna kamera",
  "Cámara trasera dual",
  "Cámara posterior doble",
  "Bakre dubbelkamera",
  "กล้องคู่ด้านหลัง",
  "Çift Arka Kamera",
  "Задня здвоєна камера",
  "Camera kép mặt sau"
], UJ = [
  "Back Camera",
  "الكاميرا الخلفية",
  "Задна камера",
  "后置相机",
  "後置相機",
  "後置鏡頭",
  "Stražnja kamera",
  "Zadní fotoaparát",
  "Bagsidekamera",
  "Camera aan achterzijde",
  "Back Camera",
  "Takakamera",
  "Caméra arrière",
  "Rückkamera",
  "Πίσω κάμερα",
  "מצלמה אחורית",
  "Hátoldali kamera",
  "Kamera Belakang",
  "Fotocamera (posteriore)",
  "背面カメラ",
  "후면 카메라",
  "Kamera Belakang",
  "Kamera på baksiden",
  "Aparat tylny",
  "Câmara traseira",
  "Câmera Traseira",
  "Cameră spate",
  "Задняя камера",
  "Zadná kamera",
  "Cámara trasera",
  "Cámara trasera",
  "Kamera på baksidan",
  "กล้องด้านหลัง",
  "Arka Kamera",
  "Задня камера",
  "Camera mặt sau"
], YY = [
  "Back Telephoto Camera",
  "كاميرا Telephoto خلفية",
  "Задна телефото камера",
  "后置长焦相机",
  "後置望遠相機",
  "後置長焦相機",
  "Stražnja telefoto kamera",
  "Zadní fotoaparát s teleobjektivem",
  "Zadní fotoaparát s teleobjektivem",
  "Teleobjektiv, bagside",
  "Telelens aan achterzijde",
  "Back Telephoto Camera",
  "Tele-takakamera",
  "Appareil photo arrière de longue focale",
  "Rückseitige Telefotokamera",
  "Πίσω κάμερα τηλεφακού",
  "מצלמת Telephoto קדמית",
  "Hátsó telefotó-kamera",
  "Kamera Telefoto Belakang",
  "Fotocamera con teleobiettivo (posteriore)",
  "背面望遠カメラ",
  "후면 망원 카메라",
  "Kamera Telefoto Belakang",
  "Telefotokamera bak",
  "Tylny aparat długoogniskowy",
  "Câmara teleobjetiva traseira",
  "Câmera teleobjetiva traseira",
  "Cameră cu teleobiectiv spate",
  "Камера с задним телеобъективом",
  "Zadná kamera Telephoto",
  "Cámara trasera con teleobjetivo",
  "Cámara Telephoto posterior",
  "Bakre Telephoto-kamera",
  "กล้องด้านหลังแบบภาพระยะไกล",
  "Arka Telefoto Kamera",
  "Задня телефотокамера",
  "Camera chụp xa mặt sau"
], r2e = (e) => new ErrorEvent("error", {
  composed: !0,
  bubbles: !0,
  error: e
}), Lm = (e, ...t) => ho(
  ti((r) => (t.forEach((n) => {
    n(r);
  }), e.dispatchEvent(r2e(r)), om))
);
var n2e = "2.0.0-beta.3", Ig = "", kJ = "?", PN = "function", Ic = "undefined", Cg = "object", $N = "string", Ym = "major", de = "model", ne = "name", se = "type", me = "vendor", ie = "version", ua = "architecture", Xh = "console", ot = "mobile", sr = "tablet", Ma = "smarttv", OC = "wearable", _J = "xr", KN = "embedded", NJ = "user-agent", XN = 500, mQ = "brands", xd = "formFactors", vQ = "fullVersionList", pp = "platform", SQ = "platformVersion", yw = "bitness", od = "sec-ch-ua", a2e = od + "-full-version-list", i2e = od + "-arch", o2e = od + "-" + yw, s2e = od + "-form-factors", l2e = od + "-" + ot, c2e = od + "-" + de, OY = od + "-" + pp, d2e = OY + "-version", jY = [mQ, vQ, ot, de, pp, SQ, ua, xd, yw], ja = "browser", nl = "cpu", Go = "device", sl = "engine", bi = "os", gp = "result", YI = "Amazon", D0 = "Apple", ZJ = "ASUS", BJ = "BlackBerry", OI = "Google", WJ = "Huawei", EJ = "Lenovo", MU = "LG", jC = "Microsoft", QJ = "Motorola", jI = "Samsung", FJ = "Sharp", PI = "Sony", GU = "Xiaomi", xU = "Zebra", bh = "Mobile ", yh = " Browser", $I = "Chrome", u2e = "Edge", J0 = "Firefox", V0 = "Opera", TJ = "Facebook", RJ = "Sogou", zN = "Windows", h2e = typeof window !== Ic, ha = h2e && window.navigator ? window.navigator : void 0, ec = ha && ha.userAgentData ? ha.userAgentData : void 0, p2e = function(e, t) {
  var r = {}, n = t;
  if (!ty(t)) {
    n = {};
    for (var a in t)
      for (var i in t[a])
        n[i] = t[a][i].concat(n[i] ? n[i] : []);
  }
  for (var o in e)
    r[o] = n[o] && n[o].length % 2 === 0 ? n[o].concat(e[o]) : e[o];
  return r;
}, ww = function(e) {
  for (var t = {}, r = 0; r < e.length; r++)
    t[e[r].toUpperCase()] = e[r];
  return t;
}, qN = function(e, t) {
  if (typeof e === Cg && e.length > 0) {
    for (var r in e)
      if (Cc(e[r]) == Cc(t)) return !0;
    return !1;
  }
  return qg(e) ? Cc(t).indexOf(Cc(e)) !== -1 : !1;
}, ty = function(e, t) {
  for (var r in e)
    return /^(browser|cpu|device|engine|os)$/.test(r) || (t ? ty(e[r]) : !1);
}, qg = function(e) {
  return typeof e === $N;
}, HU = function(e) {
  if (e) {
    for (var t = [], r = Gu(/\\?\"/g, e).split(","), n = 0; n < r.length; n++)
      if (r[n].indexOf(";") > -1) {
        var a = Om(r[n]).split(";v=");
        t[n] = { brand: a[0], version: a[1] };
      } else
        t[n] = Om(r[n]);
    return t;
  }
}, Cc = function(e) {
  return qg(e) ? e.toLowerCase() : e;
}, LU = function(e) {
  return qg(e) ? Gu(/[^\d\.]/g, e).split(".")[0] : void 0;
}, ll = function(e) {
  for (var t in e) {
    var r = e[t];
    typeof r == Cg && r.length == 2 ? this[r[0]] = r[1] : this[r] = void 0;
  }
  return this;
}, Gu = function(e, t) {
  return qg(t) ? t.replace(e, Ig) : t;
}, M0 = function(e) {
  return Gu(/\\?\"/g, e);
}, Om = function(e, t) {
  if (qg(e))
    return e = Gu(/^\s\s*/, e), typeof t === Ic ? e : e.substring(0, XN);
}, DJ = function(e, t) {
  if (!(!e || !t))
    for (var r = 0, n, a, i, o, s, c; r < t.length && !s; ) {
      var l = t[r], u = t[r + 1];
      for (n = a = 0; n < l.length && !s && l[n]; )
        if (s = l[n++].exec(e), s)
          for (i = 0; i < u.length; i++)
            c = s[++a], o = u[i], typeof o === Cg && o.length > 0 ? o.length === 2 ? typeof o[1] == PN ? this[o[0]] = o[1].call(this, c) : this[o[0]] = o[1] : o.length === 3 ? typeof o[1] === PN && !(o[1].exec && o[1].test) ? this[o[0]] = c ? o[1].call(this, c, o[2]) : void 0 : this[o[0]] = c ? c.replace(o[1], o[2]) : void 0 : o.length === 4 && (this[o[0]] = c ? o[3].call(this, c.replace(o[1], o[2])) : void 0) : this[o] = c || void 0;
      r += 2;
    }
}, ry = function(e, t) {
  for (var r in t)
    if (typeof t[r] === Cg && t[r].length > 0) {
      for (var n = 0; n < t[r].length; n++)
        if (qN(t[r][n], e))
          return r === kJ ? void 0 : r;
    } else if (qN(t[r], e))
      return r === kJ ? void 0 : r;
  return t.hasOwnProperty("*") ? t["*"] : e;
}, JJ = {
  ME: "4.90",
  "NT 3.11": "NT3.51",
  "NT 4.0": "NT4.0",
  2e3: "NT 5.0",
  XP: ["NT 5.1", "NT 5.2"],
  Vista: "NT 6.0",
  7: "NT 6.1",
  8: "NT 6.2",
  "8.1": "NT 6.3",
  10: ["NT 6.4", "NT 10.0"],
  RT: "ARM"
}, VJ = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: "Watch",
  xr: ["VR", "XR"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, MJ = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [ie, [ne, bh + "Chrome"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [ie, [ne, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [ne, ie],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [ie, [ne, V0 + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [ie, [ne, V0 + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [ie, [ne, V0]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [ie, [ne, "Baidu"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
      // Trident based
      /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
      // Avant/IEMobile/SlimBrowser
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar
      /(heytap|ovi)browser\/([\d\.]+)/i,
      // HeyTap/Ovi
      /(weibo)__([\d\.]+)/i
      // Weibo
    ],
    [ne, ie],
    [
      /\bddg\/([\w\.]+)/i
      // DuckDuckGo
    ],
    [ie, [ne, "DuckDuckGo"]],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [ie, [ne, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [ie, [ne, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [ie, [ne, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [ie, [ne, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [ie, [ne, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [ie, [ne, "Smart " + EJ + yh]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[ne, /(.+)/, "$1 Secure" + yh], ie],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [ie, [ne, J0 + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [ie, [ne, V0 + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [ie, [ne, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [ie, [ne, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [ie, [ne, V0 + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [ie, [ne, "MIUI" + yh]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [ie, [ne, bh + J0]],
    [
      /\bqihu|(qi?ho?o?|360)browser/i
      // 360
    ],
    [[ne, "360" + yh]],
    [
      /\b(qq)\/([\w\.]+)/i
      // QQ
    ],
    [[ne, /(.+)/, "$1Browser"], ie],
    [
      /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
    ],
    [[ne, /(.+)/, "$1" + yh], ie],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [ie, [ne, jI + " Internet"]],
    [
      /(comodo_dragon)\/([\w\.]+)/i
      // Comodo Dragon
    ],
    [[ne, /_/g, " "], ie],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [ie, [ne, RJ + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[ne, RJ + " Mobile"], ie],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
      // QQBrowser/2345 Browser
    ],
    [ne, ie],
    [
      /(lbbrowser|rekonq)/i,
      // LieBao Browser/Rekonq
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [ne],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[ne, TJ], ie],
    [
      /(Klarna)\/([\w\.]+)/i,
      // Klarna Shopping Browser for iOS & Android
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
      // Chromium/Instagram/Snapchat
    ],
    [ne, ie],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [ie, [ne, "GSA"]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [ie, [ne, "TikTok"]],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [ie, [ne, $I + " Headless"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[ne, $I + " WebView"], ie],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [ie, [ne, "Android" + yh]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [ie, [ne, bh + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [ne, ie],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [ie, [ne, bh + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[ne, bh + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [ie, ne],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [ne, [ie, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [ne, ie],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[ne, bh + J0], ie],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[ne, "Netscape"], ie],
    [
      /(wolvic)\/([\w\.]+)/i
      // Wolvic
    ],
    [ne, ie],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [ie, [ne, J0 + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla
      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
      /(links) \(([\w\.]+)/i
      // Links
    ],
    [ne, [ie, /_/g, "."]],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [ne, [ie, /[^\d\.]+./, Ig]]
  ],
  cpu: [
    [
      /\b(?:(amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[ua, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /((?:i[346]|x)86)[;\)]/i
      // IA32 (x86)
    ],
    [[ua, "ia32"]],
    [
      /\b(aarch64|arm(v?8e?l?|_?64))\b/i
      // ARM64
    ],
    [[ua, "arm64"]],
    [
      /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[ua, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /windows (ce|mobile); ppc;/i
    ],
    [[ua, "arm"]],
    [
      /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
      // PowerPC
    ],
    [[ua, /ower/, Ig, Cc]],
    [
      /(sun4\w)[;\)]/i
      // SPARC
    ],
    [[ua, "sparc"]],
    [
      /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ],
    [[ua, Cc]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [de, [me, jI], [se, sr]],
    [
      /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]([-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [de, [me, jI], [se, ot]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
      // iPod/iPhone
    ],
    [de, [me, D0], [se, ot]],
    [
      /\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i,
      /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
    ],
    [de, [me, D0], [se, sr]],
    [
      /(macintosh);/i
    ],
    [de, [me, D0]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [de, [me, FJ], [se, ot]],
    [
      // Huawei
      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
    ],
    [de, [me, WJ], [se, sr]],
    [
      /(?:huawei|honor)([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
    ],
    [de, [me, WJ], [se, ot]],
    [
      // Xiaomi
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
      // Xiaomi Mi
    ],
    [[de, /_/g, " "], [me, GU], [se, ot]],
    [
      /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
      // Redmi Pad
      /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[de, /_/g, " "], [me, GU], [se, sr]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [de, [me, "OPPO"], [se, ot]],
    [
      /\b(opd2\d{3}a?) bui/i
    ],
    [de, [me, "OPPO"], [se, sr]],
    [
      // Vivo
      /vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [de, [me, "Vivo"], [se, ot]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [de, [me, "Realme"], [se, ot]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ](\w*)/i,
      /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
    ],
    [de, [me, QJ], [se, ot]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [de, [me, QJ], [se, sr]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [de, [me, MU], [se, sr]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [de, [me, MU], [se, ot]],
    [
      // Lenovo
      /(ideatab[-\w ]+)/i,
      /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
    ],
    [de, [me, EJ], [se, sr]],
    [
      // Nokia
      /(?:maemo|nokia).*(n900|lumia \d+)/i,
      /nokia[-_ ]?([-\w\.]*)/i
    ],
    [[de, /_/g, " "], [me, "Nokia"], [se, ot]],
    [
      // Google
      /(pixel c)\b/i
      // Google Pixel C
    ],
    [de, [me, OI], [se, sr]],
    [
      /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
      // Google Pixel
    ],
    [de, [me, OI], [se, ot]],
    [
      // Sony
      /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [de, [me, PI], [se, ot]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[de, "Xperia Tablet"], [me, PI], [se, sr]],
    [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [de, [me, "OnePlus"], [se, ot]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [de, [me, YI], [se, sr]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[de, /(.+)/g, "Fire Phone $1"], [me, YI], [se, ot]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [de, me, [se, sr]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /\(bb10; (\w+)/i
      // BlackBerry 10
    ],
    [de, [me, BJ], [se, ot]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [de, [me, ZJ], [se, sr]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [de, [me, ZJ], [se, ot]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [de, [me, "HTC"], [se, sr]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [me, [de, /_/g, " "], [se, ot]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [de, [me, "Acer"], [se, sr]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [de, [me, "Meizu"], [se, ot]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [de, [me, "Ulefone"], [se, ot]],
    [
      // MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(asus)-?(\w+)/i,
      // Asus
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w]+)/i,
      // Lenovo
      /(jolla)/i,
      // Jolla
      /(oppo) ?([\w ]+) bui/i
      // OPPO
    ],
    [me, de, [se, ot]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [me, de, [se, sr]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [de, [me, jC], [se, sr]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [de, [me, "Fairphone"], [se, ot]],
    [
      /(shield[\w ]+) b/i
      // Nvidia Shield Tablets
    ],
    [de, [me, "Nvidia"], [se, sr]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [me, de, [se, ot]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[de, /\./g, " "], [me, jC], [se, ot]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [de, [me, xU], [se, sr]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [de, [me, xU], [se, ot]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [me, [se, Ma]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[de, /^/, "SmartTV"], [me, jI], [se, Ma]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
      // LG SmartTV
    ],
    [[me, MU], [se, Ma]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [me, [de, D0 + " TV"], [se, Ma]],
    [
      /crkey/i
      // Google Chromecast
    ],
    [[de, $I + "cast"], [me, OI], [se, Ma]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [de, [me, YI], [se, Ma]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [de, [me, FJ], [se, Ma]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [de, [me, PI], [se, Ma]],
    [
      /(mitv-\w{5}) bui/i
      // Xiaomi
    ],
    [de, [me, GU], [se, Ma]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [me, de, [se, Ma]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[me, Om], [de, Om], [se, Ma]],
    [
      /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
      // SmartTV from Unidentified Vendors
    ],
    [[se, Ma]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i
      // Nintendo
    ],
    [me, de, [se, Xh]],
    [
      /droid.+; (shield) bui/i
      // Nvidia
    ],
    [de, [me, "Nvidia"], [se, Xh]],
    [
      /(playstation \w+)/i
      // Playstation
    ],
    [de, [me, PI], [se, Xh]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [de, [me, jC], [se, Xh]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /((pebble))app/i
      // Pebble
    ],
    [me, de, [se, OC]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [de, [me, D0], [se, OC]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [de, [me, xU], [se, OC]],
    [
      ///////////////////
      // XR
      ///////////////////
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [de, [me, OI], [se, _J]],
    [
      /(quest( \d| pro)?)/i
      // Oculus Quest
    ],
    [de, [me, TJ], [se, _J]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [me, [se, KN]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [de, [me, YI], [se, KN]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
      // Android Phones from Unidentified Vendors
    ],
    [de, [se, ot]],
    [
      /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
      // Android Tablets from Unidentified Vendors
    ],
    [de, [se, sr]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[se, sr]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[se, ot]],
    [
      /(android[-\w\. ]{0,9});.+buil/i
      // Generic Android Device
    ],
    [de, [me, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [ie, [ne, u2e + "HTML"]],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [ie, [ne, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
    ],
    [ne, ie],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [ie, ne]
  ],
  os: [
    [
      // Windows
      /microsoft (windows) (vista|xp)/i
      // Windows (iTunes)
    ],
    [ne, ie],
    [
      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
      // Windows Phone
    ],
    [ne, [ie, ry, JJ]],
    [
      /windows nt 6\.2; (arm)/i,
      // Windows RT
      /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
      /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
    ],
    [[ie, ry, JJ], [ne, zN]],
    [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[ie, /_/g, "."], [ne, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+haiku)/i
      // Mac OS
    ],
    [[ne, "macOS"], [ie, /_/g, "."]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
      // Android-x86/HarmonyOS
    ],
    [ie, ne],
    [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
      /(blackberry)\w*\/([\w\.]*)/i,
      // Blackberry
      /(tizen|kaios)[\/ ]([\w\.]+)/i,
      // Tizen/KaiOS
      /\((series40);/i
      // Series 40
    ],
    [ne, ie],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [ie, [ne, BJ]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [ie, [ne, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [ie, [ne, J0 + " OS"]],
    [
      /web0s;.+rt(tv)/i,
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
      // WebOS
    ],
    [ie, [ne, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [ie, [ne, "watchOS"]],
    [
      // Google Chromecast
      /crkey\/([\d\.]+)/i
      // Google Chromecast
    ],
    [ie, [ne, $I + "cast"]],
    [
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[ne, "Chrome OS"], ie],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i
      // Haiku
    ],
    [ne, ie],
    [
      /(sunos) ?([\w\.\d]*)/i
      // Solaris
    ],
    [[ne, "Solaris"], ie],
    [
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [ne, ie]
  ]
}, KI = function() {
  var e = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return ll.call(e.init, [
    [ja, [ne, ie, Ym, se]],
    [nl, [ua]],
    [Go, [se, de, me]],
    [sl, [ne, ie]],
    [bi, [ne, ie]]
  ]), ll.call(e.isIgnore, [
    [ja, [ie, Ym]],
    [sl, [ie]],
    [bi, [ie]]
  ]), ll.call(e.isIgnoreRgx, [
    [ja, / ?browser$/i],
    [bi, / ?os$/i]
  ]), ll.call(e.toString, [
    [ja, [ne, ie]],
    [nl, [ua]],
    [Go, [me, de]],
    [sl, [ne, ie]],
    [bi, [ne, ie]]
  ]), e;
}(), g2e = function(e, t) {
  var r = KI.init[t], n = KI.isIgnore[t] || 0, a = KI.isIgnoreRgx[t] || 0, i = KI.toString[t] || 0;
  function o() {
    ll.call(this, r);
  }
  return o.prototype.getItem = function() {
    return e;
  }, o.prototype.withClientHints = function() {
    return ec ? ec.getHighEntropyValues(jY).then(function(s) {
      return e.setCH(new PY(s, !1)).parseCH().get();
    }) : e.parseCH().get();
  }, o.prototype.withFeatureCheck = function() {
    return e.detectFeature().get();
  }, t != gp && (o.prototype.is = function(s) {
    var c = !1;
    for (var l in this)
      if (this.hasOwnProperty(l) && !qN(n, l) && Cc(a ? Gu(a, this[l]) : this[l]) == Cc(a ? Gu(a, s) : s)) {
        if (c = !0, s != Ic) break;
      } else if (s == Ic && c) {
        c = !c;
        break;
      }
    return c;
  }, o.prototype.toString = function() {
    var s = Ig;
    for (var c in i)
      typeof this[i[c]] !== Ic && (s += (s ? " " : Ig) + this[i[c]]);
    return s || Ic;
  }), ec || (o.prototype.then = function(s) {
    var c = this, l = function() {
      for (var g in c)
        c.hasOwnProperty(g) && (this[g] = c[g]);
    };
    l.prototype = {
      is: o.prototype.is,
      toString: o.prototype.toString
    };
    var u = new l();
    return s(u), u;
  }), new o();
};
function PY(e, t) {
  if (e = e || {}, ll.call(this, jY), t)
    ll.call(this, [
      [mQ, HU(e[od])],
      [vQ, HU(e[a2e])],
      [ot, /\?1/.test(e[l2e])],
      [de, M0(e[c2e])],
      [pp, M0(e[OY])],
      [SQ, M0(e[d2e])],
      [ua, M0(e[i2e])],
      [xd, HU(e[s2e])],
      [yw, M0(e[o2e])]
    ]);
  else
    for (var r in e)
      this.hasOwnProperty(r) && typeof e[r] !== Ic && (this[r] = e[r]);
}
function GJ(e, t, r, n) {
  return this.get = function(a) {
    return a ? this.data.hasOwnProperty(a) ? this.data[a] : void 0 : this.data;
  }, this.set = function(a, i) {
    return this.data[a] = i, this;
  }, this.setCH = function(a) {
    return this.uaCH = a, this;
  }, this.detectFeature = function() {
    if (ha && ha.userAgent == this.ua)
      switch (this.itemType) {
        case ja:
          ha.brave && typeof ha.brave.isBrave == PN && this.set(ne, "Brave");
          break;
        case Go:
          !this.get(se) && ec && ec[ot] && this.set(se, ot), this.get(de) == "Macintosh" && ha && typeof ha.standalone !== Ic && ha.maxTouchPoints && ha.maxTouchPoints > 2 && this.set(de, "iPad").set(se, sr);
          break;
        case bi:
          !this.get(ne) && ec && ec[pp] && this.set(ne, ec[pp]);
          break;
        case gp:
          var a = this.data, i = function(o) {
            return a[o].getItem().detectFeature().get();
          };
          this.set(ja, i(ja)).set(nl, i(nl)).set(Go, i(Go)).set(sl, i(sl)).set(bi, i(bi));
      }
    return this;
  }, this.parseUA = function() {
    return this.itemType != gp && DJ.call(this.data, this.ua, this.rgxMap), this.itemType == ja && this.set(Ym, LU(this.get(ie))), this;
  }, this.parseCH = function() {
    var a = this.uaCH, i = this.rgxMap;
    switch (this.itemType) {
      case ja:
        var o = a[vQ] || a[mQ], s;
        if (o)
          for (var c in o) {
            var l = Gu(/(Google|Microsoft) /, o[c].brand || o[c]), u = o[c].version;
            !/not.a.brand/i.test(l) && (!s || /chrom/i.test(s) && !/chromi/i.test(l)) && (this.set(ne, l).set(ie, u).set(Ym, LU(u)), s = l);
          }
        break;
      case nl:
        var g = a[ua];
        g && (g && a[yw] == "64" && (g += "64"), DJ.call(this.data, g + ";", i));
        break;
      case Go:
        if (a[ot] && this.set(se, ot), a[de] && this.set(de, a[de]), a[de] == "Xbox" && this.set(se, Xh).set(me, jC), a[xd]) {
          var p;
          if (typeof a[xd] != "string")
            for (var m = 0; !p && m < a[xd].length; )
              p = ry(a[xd][m++], VJ);
          else
            p = ry(a[xd], VJ);
          this.set(se, p);
        }
        break;
      case bi:
        var I = a[pp];
        if (I) {
          var C = a[SQ];
          I == zN && (C = parseInt(LU(C), 10) >= 13 ? "11" : "10"), this.set(ne, I).set(ie, C);
        }
        this.get(ne) == zN && a[de] == "Xbox" && this.set(ne, "Xbox").set(ie, void 0);
        break;
      case gp:
        var A = this.data, U = function(B) {
          return A[B].getItem().setCH(a).parseCH().get();
        };
        this.set(ja, U(ja)).set(nl, U(nl)).set(Go, U(Go)).set(sl, U(sl)).set(bi, U(bi));
    }
    return this;
  }, ll.call(this, [
    ["itemType", e],
    ["ua", t],
    ["uaCH", n],
    ["rgxMap", r],
    ["data", g2e(this, e)]
  ]), this;
}
function so(e, t, r) {
  if (typeof e === Cg ? (ty(e, !0) ? (typeof t === Cg && (r = t), t = e) : (r = e, t = void 0), e = void 0) : typeof e === $N && !ty(t, !0) && (r = t, t = void 0), !(this instanceof so))
    return new so(e, t, r).getResult();
  var n = typeof e === $N ? e : (
    // Passed user-agent string
    ha && ha.userAgent ? ha.userAgent : (
      // navigator.userAgent
      r && r[NJ] ? r[NJ] : (
        // User-Agent from passed headers
        Ig
      )
    )
  ), a = new PY(r, !0), i = t ? p2e(MJ, t) : MJ, o = function(s) {
    return s == gp ? function() {
      return new GJ(s, n, i, a).set("ua", n).set(ja, this.getBrowser()).set(nl, this.getCPU()).set(Go, this.getDevice()).set(sl, this.getEngine()).set(bi, this.getOS()).get();
    } : function() {
      return new GJ(s, n, i[s], a).parseUA().get();
    };
  };
  return ll.call(this, [
    ["getBrowser", o(ja)],
    ["getCPU", o(nl)],
    ["getDevice", o(Go)],
    ["getEngine", o(sl)],
    ["getOS", o(bi)],
    ["getResult", o(gp)],
    ["getUA", function() {
      return n;
    }],
    ["setUA", function(s) {
      return qg(s) && (n = s.length > XN ? Om(s, XN) : s), this;
    }]
  ]).setUA(n), this;
}
so.VERSION = n2e;
so.BROWSER = ww([ne, ie, Ym, se]);
so.CPU = ww([ua]);
so.DEVICE = ww([de, me, se, Xh, ot, Ma, sr, OC, KN]);
so.ENGINE = so.OS = ww([ne, ie]);
const IQ = new so(), CQ = () => {
  var t;
  const e = ((t = IQ.getResult().os.name) == null ? void 0 : t.toLowerCase()) ?? "";
  return ["macos", "ios", "ipad"].some((r) => e.includes(r));
}, $Y = () => {
  var e;
  return (e = IQ.getResult().os.name) == null ? void 0 : e.includes("Android");
}, f2e = () => {
  const e = IQ.getResult();
  return [
    `${e.browser.name}`,
    `${e.browser.name}_${e.browser.major}`,
    `${e.browser.name}_${e.browser.version}`,
    ...e.cpu.architecture ? [e.cpu.architecture] : [],
    `${e.device.vendor}`,
    `${e.device.vendor}_${e.device.model}`,
    ...e.device.type ? [
      e.device.type,
      `${e.device.type}_${e.device.vendor}`,
      `${e.device.type}_${e.device.vendor}_${e.device.model}`
    ] : [],
    `${e.engine.name}`,
    `${e.engine.name}_${e.engine.version}`,
    `${e.os.name}`,
    `${e.os.name}_${e.os.version}`,
    e.ua
  ];
}, m2e = (e, t, r) => new Promise((n, a) => {
  e.toBlob(
    (i) => {
      i ? n(i) : a(new Error("canvasToBlobAsync: Cannot create image"));
    },
    t,
    r
  );
}), KY = async (e, t) => {
  const { imageType: r, filenameBase: n, quality: a } = t, i = await m2e(e, r, a), s = new RegExp("(\\w+)$", "i").exec(i.type);
  if (!s)
    throw new Error("canvasToBlobFileAsync: Invalid mime type");
  const c = `${n}.${s[1]}`;
  return new File([i], c, {
    type: i.type
  });
}, v2e = async (e, t) => {
  const n = Q2(
    750,
    new Error("canvasToBlobWithFormat: Image generation failed")
  ), a = KY(e, t);
  return Promise.race([a, n]);
}, S2e = () => !CQ() && qve, XY = async (e) => {
  const t = {
    filenameBase: "capture",
    imageType: S2e() ? "image/webp" : "image/jpeg",
    quality: 0.99
  };
  try {
    return await v2e(e, t);
  } catch {
    return await KY(e, {
      filenameBase: t.filenameBase,
      imageType: "image/png",
      quality: t.quality
    });
  }
}, I2e = (e) => /\s0,\s/gi.test(e), C2e = (e) => e.some((t) => YY.includes(t.label)), b2e = (e, t) => {
  if (t) {
    if (qye.includes(e.label))
      return -3;
    if (UJ.includes(e.label))
      return -2;
    if (AJ.includes(e.label))
      return -1;
  } else {
    if (UJ.includes(e.label))
      return -2;
    if (AJ.includes(e.label))
      return -1;
  }
  return zye.includes(e.label) ? Number.MAX_VALUE : 0;
}, y2e = (e) => I2e(e.label) ? -1 : e.label.includes("facing front") ? Number.MAX_VALUE : 0, w2e = (e) => Od(
  e,
  [
    (t) => CQ() ? b2e(t, C2e(e)) : $Y() ? y2e(t) : 0
  ],
  ["asc"]
), xJ = (e) => e.map((t) => `${t.kind}-${t.deviceId}-${t.groupId}-${t.label}`).join(";"), HJ = async () => {
  var e;
  return typeof ((e = navigator.mediaDevices) == null ? void 0 : e.enumerateDevices) == "function" ? navigator.mediaDevices.enumerateDevices().catch(() => []) : [];
}, zY = (e = 1e3) => ps(
  vn(() => HJ()),
  E2(e).pipe(Wi(() => HJ()))
).pipe(
  te(w2e),
  vt((t, r) => xJ(t) === xJ(r))
), qY = (e) => {
  const { deviceId: t, groupId: r, kind: n, label: a } = e;
  return {
    deviceId: t,
    groupId: r,
    kind: n,
    label: a,
    capabilities: Ut(e, ["getCapabilities"]) ? e.getCapabilities() : {}
  };
}, A2e = [...t2e, ...e2e, ...YY], U2e = CQ(), k2e = (e) => e.kind === "videoinput", _2e = (e) => U2e ? !A2e.includes(e.label) : !0, e4 = () => ho(te((e) => e.filter((t) => k2e(t) && _2e(t))));
let t4;
const r4 = (e) => navigator.permissions ? (t4 ?? navigator.permissions.query.bind(navigator.permissions))({
  name: e
}) : ba, N2e = (e) => E2(1e3).pipe(
  Wi(() => r4(e)),
  te((t) => t.state)
), Z2e = (e) => vn(() => r4(e)).pipe(
  Wi((t) => p1(
    Sa(t.state),
    Ke(t, "change").pipe(
      te((r) => r.currentTarget.state)
    )
  ))
), B2e = (e) => ps(Z2e(e), N2e(e)).pipe(
  vt(),
  ti(() => Sa("granted"))
), bVe = (e) => {
  eSe() && (t4 = e);
}, W2e = (e, t = 25) => new Ht((r) => {
  const n = () => {
    r.next(e);
  }, a = E2(Math.ceil(1e3 / t)).subscribe(n);
  return () => {
    a.unsubscribe();
  };
}).pipe(Xc(yS)), E2e = (e, t = 20) => new Ht((r) => {
  let n, a;
  const i = () => {
    e.cancelVideoFrameCallback(n), window.clearTimeout(a), r.next(e), a = window.setTimeout(() => i, Math.ceil(1e3 / t)), n = e.requestVideoFrameCallback(i);
  };
  return n = e.requestVideoFrameCallback(i), () => {
    window.clearTimeout(a), e.cancelVideoFrameCallback(n);
  };
}), Q2e = (e, t = 25) => typeof e.requestVideoFrameCallback == "function" ? E2e(e) : W2e(e, t), yVe = (e, t) => t.readyState === "live" && t.getSettings().deviceId === e, bQ = (e) => gQ().pipe(
  EW(),
  at(([t, r]) => t === "denied" && (r === "granted" || r === "prompt")),
  te(([, t]) => t),
  ae(() => {
    e.next();
  })
), yQ = (e) => e.currentTime > 0 && !e.paused && !e.ended && e.readyState > 2, wQ = () => {
  const e = dm();
  return {
    width: {
      ideal: e ? 1080 : 1920
    },
    height: {
      ideal: e ? 1440 : 1080
    }
  };
}, F2e = ({ videoElement: e, cancelNotifier$: t, timeoutMs: r = 3e3 }) => {
  const n = Ke(e, "timeupdate").pipe(qc(1), le(t)), a = hs(r).pipe(ao(() => zc(() => new Error("Video is stuck"))));
  return UM(n, a).pipe(le(t));
}, T2e = (e) => Ut(e, ["name", "message"], (t) => ["AbortError"].includes(t.name)), R2e = (e) => Ut(
  e,
  ["name", "message"],
  (t) => ["PermissionDismissedError", "NotAllowedError", "PermissionDeniedError"].includes(t.name)
), D2e = (e) => {
  const t = [
    "CameraError",
    "ConstraintNotSatisfiedError",
    "DevicesNotFoundError",
    "InvalidStateError",
    "NotFoundError",
    "NotReadableError",
    "NotSupportedError",
    "OverconstrainedError",
    uQ,
    "SecurityError",
    "TrackStartError",
    "TypeError"
  ];
  return Ut(e, ["name", "message"], (r) => t.includes(r.name));
}, J2e = ({
  videoElement: e,
  cancelNotifier$: t,
  timeoutMs: r = 3e3
}) => {
  const n = Ke(e, "loadedmetadata"), a = hs(r).pipe(ao(() => Sa(void 0)));
  return UM(n, a).pipe(qc(1), le(t));
}, V2e = (e) => {
  for (const t of e.getTracks())
    t.onended = null, t.stop(), e.removeTrack(t);
}, M2e = (e) => {
  e.pause(), e.srcObject = null, e.src = "";
}, G2e = (e) => {
  const { trackId: t, label: r, deviceId: n } = e;
  return {
    id: t,
    kind: "videoinput",
    label: r,
    muted: !0,
    readyState: "live",
    enabled: !0,
    constraints: {},
    // getCapabilities is not available in the Firefox
    capabilities: {},
    settings: {
      deviceId: n
    },
    contentHint: ""
  };
}, x2e = (e) => {
  const t = e.video.deviceId.exact, r = um(), n = LY(t);
  if (!n)
    throw new Error("Mocked device is not found");
  return Promise.resolve({
    type: Sg.File,
    url: n.label,
    trackId: r,
    track: G2e({
      trackId: r,
      deviceId: t,
      label: r
    }),
    device: n,
    deviceId: n.deviceId
  });
}, H2e = (e, t) => {
  const r = jE === Vu.EndToEnd ? Promise.reject(new DOMException("Cannot use real camera in E2E tests", "InvalidEnvironment")) : navigator.mediaDevices.getUserMedia(e), n = Q2(
    t,
    new GS("getUserMediaWithTimeFallback: Could not start camera on time")
  );
  return Promise.race([r, n]);
}, n4 = async ({
  constraints: e,
  timeoutMs: t = 3e4
}) => {
  const r = await H2e(e, t), [n] = r.getVideoTracks();
  return n.onended = () => {
    MY(
      new Lye("getVideoSourceFromRealDevice: Track has ended unexpectedly")
    );
  }, {
    type: Sg.Camera,
    source: r,
    track: n,
    deviceId: n.getSettings().deviceId ?? ""
  };
}, L2e = async (e) => Xye(e.constraints.video.deviceId.exact) ? x2e(e.constraints) : n4(e), Y2e = (e) => Ut(e, ["video"], (t) => {
  var r, n;
  return !!((n = (r = t == null ? void 0 : t.video) == null ? void 0 : r.facingMode) != null && n.ideal);
}), O2e = () => {
  const e = zY().pipe(
    e4(),
    te((t) => t.map(qY))
  );
  return Be(e, {
    defaultValue: []
  });
}, j2e = (e, t) => {
  const { video: r, ...n } = e, { facingMode: a, ...i } = e.video;
  return {
    ...n,
    video: {
      ...i,
      deviceId: {
        exact: t
      }
    }
  };
}, P2e = (e) => {
  var r, n;
  return (n = (((r = e.getCapabilities) == null ? void 0 : r.call(e)) ?? {}).facingMode) != null && n.includes("environment") ? vg.Back : vg.Front;
}, $2e = (e) => {
  var t;
  return {
    id: e.id,
    kind: e.kind,
    label: e.label,
    muted: e.muted,
    readyState: e.readyState,
    enabled: e.enabled,
    constraints: e.getConstraints(),
    // getCapabilities is not available in the Firefox
    capabilities: ((t = e.getCapabilities) == null ? void 0 : t.call(e)) ?? {},
    settings: e.getSettings(),
    contentHint: e.contentHint
  };
}, K2e = (e, t) => {
  const [r] = e.getVideoTracks();
  return r.getSettings().deviceId === t.deviceId;
}, X2e = (e, t) => t === "environment" ? e.filter((n) => {
  var a;
  return (a = n.capabilities.facingMode) == null ? void 0 : a.includes("environment");
})[0] ?? e[0] : t === "user" ? e.filter((n) => {
  var a;
  return (a = n.capabilities.facingMode) == null ? void 0 : a.includes("user");
})[0] ?? e[0] : e[0], z2e = (e) => e.type === Sg.Camera ? P2e(e.track) : vg.Front, q2e = () => zY().pipe(
  e4(),
  te((e) => e.map(qY)),
  ae(jye)
), ewe = async (e, t) => Be(
  J2e({
    videoElement: e,
    cancelNotifier$: t
  }),
  {
    defaultValue: void 0
  }
), a4 = (e) => e instanceof MediaStream, twe = (e, t = 1e3) => ps(
  Ke(e, "abort"),
  Ke(e, "canplay"),
  Ke(e, "canplaythrough"),
  Ke(e, "durationchange"),
  Ke(e, "emptied"),
  Ke(e, "ended"),
  Ke(e, "error"),
  Ke(e, "loadeddata"),
  Ke(e, "loadedmetadata"),
  Ke(e, "loadstart"),
  Ke(e, "pause"),
  Ke(e, "play"),
  Ke(e, "playing"),
  Ke(e, "progress"),
  Ke(e, "ratechange"),
  Ke(e, "resize"),
  Ke(e, "seeked"),
  Ke(e, "seeking"),
  Ke(e, "stalled"),
  Ke(e, "suspend"),
  Ke(e, "timeupdate").pipe($te(t)),
  Ke(e, "waiting"),
  hs(1e3).pipe(te(() => e))
).pipe(
  te(() => yQ(e)),
  vt(),
  ae(g4)
), rwe = ({
  videoElement: e,
  videoSource: t,
  unsetVideoSource: r,
  playbackCancelNotifier$: n
}) => {
  n.next(), e && M2e(e), a4(t) && (V2e(t), r()), tZ(void 0), g4(!1), Kye();
}, nwe = `
  attribute vec2 position;
  varying vec2 texCoords;
  void main() {
      texCoords = (position + 1.0) / 2.0;
      gl_Position = vec4(position, 0.0, 1.0);
  }
`.trim(), awe = `
  #ifdef GL_FRAGMENT_PRECISION_HIGH
    precision highp float;
  #else
    precision mediump float;
  #endif

  varying vec2 texCoords;
  uniform sampler2D videoTexture;
  void main() {
      gl_FragColor = texture2D(videoTexture, texCoords);
  }
`.trim();
var Up, PC;
class i4 extends N {
  constructor() {
    super(...arguments);
    E(this, Up);
    this.singleFrameRequested = !0, this.gl = null, this.program = null, this.positionBuffer = null, this.vertexShader = null, this.fragmentShader = null, this.texture = null, this.imageDataFrameBuffer = null, this.imageDataTexture = null, this.targetWidth = 0, this.targetHeight = 0, this.originalSourceWidth = 0, this.originalSourceHeight = 0, this.onVideoTick = async (r) => {
      await this.onRenderingStart(r), await this.onRenderFrame(r);
    }, this.onRenderingStart = (r) => {
      try {
        O(this, Up, PC).call(this) && !this.gl && (this.renderingResize(r.videoElement), this.renderingSetup());
      } catch {
      }
      return Promise.resolve();
    }, this.onRenderFrame = (r) => {
      try {
        O(this, Up, PC).call(this) && this.gl && this.texture && this.isVideoPlaying(r.videoElement) && (this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture), this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !0), this.gl.texImage2D(
          this.gl.TEXTURE_2D,
          0,
          this.gl.RGBA,
          this.originalSourceWidth,
          this.originalSourceHeight,
          0,
          this.gl.RGBA,
          this.gl.UNSIGNED_BYTE,
          r.videoElement
        ), this.gl.clearColor(0, 0, 0, 1), this.gl.clear(this.gl.COLOR_BUFFER_BIT), this.gl.drawArrays(this.gl.TRIANGLES, 0, 6), this.singleFrameRequested = !1, this.dispatchEvent(new GY(r)));
      } catch {
      }
      return Promise.resolve();
    }, this.onStreamStart = (r) => {
      this.renderingTeardown(), this.renderingResize(r), this.renderingSetup();
    }, this.onStreamPause = () => {
      this.renderingTeardown();
    }, this.onStreamResize = (r) => {
      this.renderingResize(r), this.renderingTeardown(), this.renderingSetup();
    };
  }
  renderingSetup() {
    var u;
    const r = (u = this.canvasRef.value) == null ? void 0 : u.getContext("webgl2", {
      // Anti-alias *MUST* be turned off, otherwise the rendering hangs on the Mobile Chrome browsers on Android
      antialias: !1,
      depth: !1,
      alpha: !1,
      desynchronized: !0
    });
    if (!(O(this, Up, PC).call(this) && r))
      return;
    const n = this.renderingCompileShader(r, nwe, r.VERTEX_SHADER), a = this.renderingCompileShader(r, awe, r.FRAGMENT_SHADER), i = r.createProgram();
    if (!i)
      return;
    if (r.viewport(0, 0, this.targetWidth, this.targetHeight), r.attachShader(i, n), r.attachShader(i, a), r.linkProgram(i), !r.getProgramParameter(i, r.LINK_STATUS))
      throw new DOMException(
        `Unable to initialize the shader program: ${r.getProgramInfoLog(i)}`,
        LI
      );
    r.useProgram(i);
    const o = r.createBuffer();
    r.bindBuffer(r.ARRAY_BUFFER, o);
    const s = [-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1];
    r.bufferData(r.ARRAY_BUFFER, new Float32Array(s), r.STATIC_DRAW);
    const c = r.getAttribLocation(i, "position");
    r.enableVertexAttribArray(c), r.vertexAttribPointer(c, 2, r.FLOAT, !1, 0, 0);
    const l = r.createTexture();
    r.bindTexture(r.TEXTURE_2D, l), r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, !0), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.LINEAR), this.gl = r, this.texture = l, this.vertexShader = n, this.fragmentShader = a, this.positionBuffer = o, this.program = i;
  }
  renderingResize(r) {
    this.originalSourceWidth = r.videoWidth, this.originalSourceHeight = r.videoHeight, this.targetWidth = Math.round(this.imageRatio * this.originalSourceWidth), this.targetHeight = Math.round(this.imageRatio * this.originalSourceHeight), this.canvasRef.value && (this.canvasRef.value.width = this.targetWidth, this.canvasRef.value.height = this.targetHeight);
  }
  renderingTeardown() {
    this.gl && (this.texture && this.gl.deleteTexture(this.texture), this.vertexShader && this.gl.deleteShader(this.vertexShader), this.fragmentShader && this.gl.deleteShader(this.fragmentShader), this.positionBuffer && this.gl.deleteBuffer(this.positionBuffer), this.imageDataTexture && this.gl.deleteTexture(this.imageDataTexture), this.imageDataFrameBuffer && this.gl.deleteFramebuffer(this.imageDataFrameBuffer), this.program && this.gl.deleteProgram(this.program), this.gl = null, this.texture = null, this.vertexShader = null, this.fragmentShader = null, this.positionBuffer = null, this.imageDataTexture = null, this.imageDataFrameBuffer = null, this.program = null);
  }
  isVideoPlaying(r) {
    return yQ(r);
  }
  renderingCompileShader(r, n, a) {
    const i = r.createShader(a);
    if (!i)
      throw new DOMException("Shader could not be compiled", LI);
    if (r.shaderSource(i, n), r.compileShader(i), !r.getShaderParameter(i, r.COMPILE_STATUS)) {
      const o = `An error occurred compiling the shader: ${r.getShaderInfoLog(i)}`;
      throw r.deleteShader(i), new DOMException(o, LI);
    }
    return i;
  }
  setRenderingAllowedState(r) {
    this.renderingAllowed = r;
  }
  setSingleFrameRequestedState(r) {
    this.singleFrameRequested = r;
  }
  getRenderingAllowedState() {
    return this.renderingAllowed;
  }
  readImageDataFromCanvas(r, n) {
    return new Promise((a, i) => {
      const o = this.imageDataFrameBuffer ?? n.createFramebuffer();
      n.bindFramebuffer(n.FRAMEBUFFER, o);
      const s = this.imageDataTexture ?? n.createTexture();
      if (n.bindTexture(n.TEXTURE_2D, s), this.imageDataTexture || (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE)), n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, !1), n.texImage2D(
        n.TEXTURE_2D,
        0,
        n.RGBA,
        this.originalSourceWidth,
        this.originalSourceHeight,
        0,
        n.RGBA,
        n.UNSIGNED_BYTE,
        r
      ), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, s, 0), n.flush(), n.checkFramebufferStatus(n.FRAMEBUFFER) !== n.FRAMEBUFFER_COMPLETE) {
        i(new DOMException("Framebuffer is not complete", LI));
        return;
      }
      const c = new Uint8ClampedArray(this.targetWidth * this.targetHeight * 4);
      n.readPixels(0, 0, this.targetWidth, this.targetHeight, n.RGBA, n.UNSIGNED_BYTE, c), n.bindTexture(n.TEXTURE_2D, null), n.bindFramebuffer(n.FRAMEBUFFER, null), a(new ImageData(c, this.targetWidth, this.targetHeight)), this.imageDataTexture = s, this.imageDataFrameBuffer = o;
    });
  }
}
Up = new WeakSet(), PC = function() {
  return this.renderingAllowed || this.singleFrameRequested;
};
var HS = /* @__PURE__ */ ((e) => (e.StreamPlaying = "streamplaying", e.StreamPaused = "streampaused", e.StreamResized = "streamresized", e.ImageCaptured = "imagecaptured", e))(HS || {});
class o4 extends CustomEvent {
  constructor(t) {
    super(HS.ImageCaptured, {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var Aw = /* @__PURE__ */ ((e) => (e.SwitchCamera = "switchcamera", e.SwitchStream = "switchstream", e.StopStream = "stopstream", e.CaptureImage = "captureimage", e))(Aw || {});
class wVe extends CustomEvent {
  constructor() {
    super(Aw.StopStream, {
      bubbles: !0,
      composed: !0
    });
  }
}
class iwe extends CustomEvent {
  constructor(t) {
    super(HS.StreamPaused, {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class owe extends CustomEvent {
  constructor(t) {
    super(HS.StreamPlaying, {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class swe extends CustomEvent {
  constructor(t) {
    super(HS.StreamResized, {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class Uw extends CustomEvent {
  constructor(t) {
    super(Aw.SwitchCamera, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: t
    });
  }
}
var kw = /* @__PURE__ */ ((e) => (e.User = "user", e.Environment = "environment", e))(kw || {});
class Il extends CustomEvent {
  constructor(t) {
    super(Aw.SwitchStream, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: t
    });
  }
}
var lwe = Object.defineProperty, cwe = Object.getOwnPropertyDescriptor, LS = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? cwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && lwe(t, r, a), a;
}, s4 = /* @__PURE__ */ ((e) => (e.Contain = "contain", e.Cover = "cover", e))(s4 || {});
let xu = class extends i4 {
  constructor() {
    super(...arguments), this.imageRatio = 1, this.flipped = !0, this.renderingAllowed = !0, this.fitMode = "cover", this.canvasRef = Rt(), this.getImageData = async () => new Promise((e, t) => {
      const r = () => {
        const { gl: n } = this, a = this.canvasRef.value;
        a && n && this.readImageDataFromCanvas(a, n).then(e, t);
      };
      this.addEventListener("rendererframe", r, { once: !0 }), this.setSingleFrameRequestedState(!0);
    }), this.getBlob = async () => new Promise((e, t) => {
      const r = () => {
        const { gl: n } = this;
        this.canvasRef.value && n ? XY(this.canvasRef.value).then(e, t) : t(new Error("CameraWebglRendererComponent: Canvas is not created"));
      };
      this.addEventListener("rendererframe", r, { once: !0 }), this.setSingleFrameRequestedState(!0);
    }), this.captureImage = async () => {
      const e = await this.getBlob();
      return e && this.dispatchEvent(
        new o4({
          width: this.targetWidth,
          height: this.targetHeight,
          blob: e
        })
      ), e;
    };
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.renderingTeardown();
  }
  render() {
    return w`
      <canvas ${Mt(this.canvasRef)} class="canvas"></canvas>
      <slot></slot>
    `;
  }
};
xu.styles = [
  ...i4.styles,
  ee`
      :host {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .canvas {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        object-position: center;
        width: 100%;
        height: 100%;
      }

      :host([data-fit-mode='contain']) .canvas {
        object-fit: contain;
      }

      :host([data-fit-mode='cover']) .canvas {
        object-fit: cover;
      }

      :host([data-flipped='true']) .canvas {
        transform: scaleX(-1);
      }
    `
];
LS([
  M({
    attribute: "data-image-ratio",
    type: Number,
    reflect: !0
  })
], xu.prototype, "imageRatio", 2);
LS([
  M({
    attribute: "data-flipped",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], xu.prototype, "flipped", 2);
LS([
  M({
    attribute: "data-rendering-allowed",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], xu.prototype, "renderingAllowed", 2);
LS([
  M({
    attribute: "data-fit-mode",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => Object.values(s4).includes(e) ? e : "cover",
      toAttribute: (e) => e
    }
  })
], xu.prototype, "fitMode", 2);
xu = LS([
  P("x-camera-webgl-renderer")
], xu);
var dwe = Object.defineProperty, uwe = Object.getOwnPropertyDescriptor, l4 = (e) => {
  throw TypeError(e);
}, YS = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? uwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && dwe(t, r, a), a;
}, AQ = (e, t, r) => t.has(e) || l4("Cannot " + r), pn = (e, t, r) => (AQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), wh = (e, t, r) => t.has(e) ? l4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), bd = (e, t, r, n) => (AQ(e, t, "write to private field"), t.set(e, r), r), LJ = (e, t, r) => (AQ(e, t, "access private method"), r), $C, KC, Wd, Ed, ji, XC, eZ, c4 = /* @__PURE__ */ ((e) => (e.Contain = "contain", e.Cover = "cover", e))(c4 || {});
let Hu = class extends N {
  constructor() {
    super(...arguments), wh(this, XC), this.imageRatio = 1, this.flipped = !0, this.renderingAllowed = !0, this.fitMode = "cover", this.canvasRef = Rt(), this.singleFrameRequested = !0, wh(this, $C, 0), wh(this, KC, 0), wh(this, Wd, 0), wh(this, Ed, 0), wh(this, ji), this.getImageData = async () => new Promise((e) => {
      const t = () => {
        if (pn(this, ji)) {
          const r = pn(this, ji).getImageData(0, 0, pn(this, Wd), pn(this, Ed), {
            colorSpace: "srgb"
          });
          e(r);
        }
      };
      this.addEventListener("rendererframe", t, { once: !0 }), this.setSingleFrameRequestedState(!0);
    }), this.getBlob = async () => new Promise((e, t) => {
      const r = () => {
        const n = this.canvasRef.value;
        n && pn(this, ji) && XY(n).then(e, t);
      };
      this.addEventListener("rendererframe", r, { once: !0 }), this.setSingleFrameRequestedState(!0);
    }), this.captureImage = async () => {
      const e = await this.getBlob();
      return e && this.dispatchEvent(
        new o4({
          width: pn(this, Wd),
          height: pn(this, Ed),
          blob: e
        })
      ), e;
    }, this.onVideoTick = async (e) => {
      await this.onRenderingStart(e), await this.onRenderFrame(e);
    }, this.onRenderingStart = (e) => (LJ(this, XC, eZ).call(this) && !pn(this, ji) && (this.renderingResize(e.videoElement), this.renderingSetup()), Promise.resolve()), this.onRenderFrame = (e) => (LJ(this, XC, eZ).call(this) && pn(this, ji) && yQ(e.videoElement) && (pn(this, ji).drawImage(
      e.videoElement,
      0,
      0,
      e.videoElement.videoWidth,
      e.videoElement.videoHeight,
      0,
      0,
      pn(this, Wd),
      pn(this, Ed)
    ), this.setSingleFrameRequestedState(!1), this.dispatchEvent(new GY(e))), Promise.resolve()), this.onStreamStart = (e) => {
      this.renderingTeardown(), this.renderingResize(e), this.renderingSetup();
    }, this.onStreamPause = () => {
      this.renderingTeardown();
    }, this.onStreamResize = (e) => {
      this.renderingResize(e), this.renderingTeardown(), this.renderingSetup();
    };
  }
  firstUpdated(e) {
    var t;
    super.firstUpdated(e), bd(this, ji, ((t = this.canvasRef.value) == null ? void 0 : t.getContext("2d")) ?? void 0);
  }
  render() {
    return w`
      <canvas ${Mt(this.canvasRef)} class="canvas"></canvas>
      <slot></slot>
    `;
  }
  renderingSetup() {
    var t;
    const e = (t = this.canvasRef.value) == null ? void 0 : t.getContext("2d", {
      desynchronized: !0,
      willReadFrequently: !0
    });
    e && bd(this, ji, e);
  }
  renderingResize(e) {
    bd(this, $C, e.videoWidth), bd(this, KC, e.videoHeight), bd(this, Wd, Math.round(this.imageRatio * pn(this, $C))), bd(this, Ed, Math.round(this.imageRatio * pn(this, KC))), this.canvasRef.value && (this.canvasRef.value.width = pn(this, Wd), this.canvasRef.value.height = pn(this, Ed));
  }
  renderingTeardown() {
    bd(this, ji, void 0);
  }
  setRenderingAllowedState(e) {
    this.renderingAllowed = e;
  }
  setSingleFrameRequestedState(e) {
    this.singleFrameRequested = e;
  }
  getRenderingAllowedState() {
    return this.renderingAllowed;
  }
};
$C = /* @__PURE__ */ new WeakMap();
KC = /* @__PURE__ */ new WeakMap();
Wd = /* @__PURE__ */ new WeakMap();
Ed = /* @__PURE__ */ new WeakMap();
ji = /* @__PURE__ */ new WeakMap();
XC = /* @__PURE__ */ new WeakSet();
eZ = function() {
  return this.renderingAllowed || this.singleFrameRequested;
};
Hu.styles = [
  ...N.styles,
  ee`
      :host {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .canvas {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        object-position: center;
        width: 100%;
        height: 100%;
      }

      :host([data-fit-mode='contain']) .canvas {
        object-fit: contain;
      }

      :host([data-fit-mode='cover']) .canvas {
        object-fit: cover;
      }

      :host([data-flipped='true']) .canvas {
        transform: scaleX(-1);
      }
    `
];
YS([
  M({
    attribute: "data-image-ratio",
    type: Number,
    reflect: !0
  })
], Hu.prototype, "imageRatio", 2);
YS([
  M({
    attribute: "data-flipped",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Hu.prototype, "flipped", 2);
YS([
  M({
    attribute: "data-rendering-allowed",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Hu.prototype, "renderingAllowed", 2);
YS([
  M({
    attribute: "data-fit-mode",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => Object.values(c4).includes(e) ? e : "cover",
      toAttribute: (e) => e
    }
  })
], Hu.prototype, "fitMode", 2);
Hu = YS([
  P("x-camera-canvas2d-renderer")
], Hu);
const { clsEntitiesRef: UQ, withClsEntities: hwe } = ad("cls"), nn = mo(
  { name: "camera" },
  Wl({
    activeTrack: void 0,
    resolution: {
      width: 1920,
      height: 1080
    },
    cameraFacingMode: vg.NotAvailable,
    playing: !1,
    isBusy: !1,
    capturing: !1
  }),
  hwe({
    initialValue: [],
    idKey: "t"
  })
), pwe = (e) => ({
  t: e,
  l: "",
  y: !1
}), YJ = (e) => {
  e.l && nn.update(
    lw(e.t, {
      updater: e,
      creator: pwe,
      mergeUpdaterWithCreator: !0,
      ref: UQ
    })
  );
}, d4 = () => nn.query(
  D_({
    ref: UQ
  })
), u4 = (e, t) => e.filter((r) => r.t <= t), sd = (e) => {
  const t = u4(d4(), e ?? Date.now());
  return t.length > 0 ? t[t.length - 1] : void 0;
}, ld = (e) => {
  const t = u4(d4(), e ?? Date.now()), [r] = Od(t, [(n) => n.y ? n.p : 0], ["desc"]);
  return r;
}, h4 = () => {
  nn.update(
    Fpe({
      ref: UQ
    })
  );
}, kQ = (e) => {
  nn.update(cn("resolution", e));
}, _Q = () => nn.pipe(
  bt((e) => e.resolution),
  vt((e, t) => e.width === t.width && e.height === t.height)
), bg = (e = nn.getValue()) => e.activeTrack, p4 = () => nn.pipe(
  bt((e) => e.activeTrack),
  vt()
), tZ = (e) => {
  nn.update(cn("activeTrack", e));
}, gwe = (e) => {
  nn.update(cn("cameraFacingMode", e));
}, fwe = () => nn.pipe(
  bt(({ cameraFacingMode: e }) => e),
  vt()
), g4 = (e) => {
  nn.update(cn("playing", e));
}, _w = () => nn.pipe(
  te(({ playing: e }) => e),
  vt()
), YU = (e) => {
  nn.update(cn("isBusy", e));
}, mwe = () => nn.query(({ isBusy: e }) => e), f4 = () => nn.pipe(
  te(({ isBusy: e }) => e),
  vt()
), vwe = () => nn.pipe(
  te(({ capturing: e }) => e),
  vt()
), AVe = () => nn.query(({ capturing: e }) => e), zC = (e) => {
  nn.update(cn("capturing", e));
};
var Swe = Object.defineProperty, Iwe = Object.getOwnPropertyDescriptor, m4 = (e) => {
  throw TypeError(e);
}, Cwe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Iwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Swe(t, r, a), a;
}, bwe = (e, t, r) => t.has(e) || m4("Cannot " + r), ywe = (e, t, r) => t.has(e) ? m4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), rZ = (e, t, r) => (bwe(e, t, "access private method"), r), jm, v4, S4, I4;
let nZ = class extends N {
  constructor() {
    super(...arguments), ywe(this, jm), this.containerElRef = Rt(), this.refresh$ = new _e(), this.videoSize$ = rZ(this, jm, I4).call(this, this.refresh$), this.videoSizeController = new ue(this, this.videoSize$);
  }
  firstUpdated(e) {
    super.firstUpdated(e), this.refresh$.next();
  }
  render() {
    var i;
    const e = (i = this.videoSizeController) == null ? void 0 : i.value, t = (e == null ? void 0 : e.streamWidth) ?? 0, r = (e == null ? void 0 : e.streamHeight) ?? 0;
    let n = fc.Landscape, a = `${t} / ${r}`;
    return e && (n = e.elementAspectRatio > e.streamAspectRatio ? fc.Portrait : fc.Landscape, a = e.elementAspectRatio > e.streamAspectRatio ? `auto ${e.streamWidth} / ${e.streamHeight}` : `${e.streamWidth} / ${e.streamHeight}`), w`
      <div
        ${Mt(this.containerElRef)}
        class="container"
        data-fit-orientation="${n}"
        style="--video-aspect-ratio: ${a};"
      >
        <slot name="backdrop"></slot>
        <slot name="video"></slot>
        <slot name="canvas"></slot>
        <slot name="underlay"></slot>
        <div class="container__video-wrap--width">
          <slot name="video-width-before"></slot>
          <div class="container__video-wrap--height">
            <slot name="video-height-before"></slot>
            <div class="container__video-overlay">
              <slot name="video-overlay"></slot>
            </div>
            <slot name="video-height-after"></slot>
          </div>
          <slot name="video-width-after"></slot>
        </div>
        <slot name="overlay"></slot>
      </div>
    `;
  }
};
jm = /* @__PURE__ */ new WeakSet();
v4 = function() {
  return _Q();
};
S4 = function(e) {
  return Bl(this.containerElRef, e).pipe(
    Wt((t) => aw({ el: t }))
  );
};
I4 = function(e) {
  return rZ(this, jm, v4).call(this).pipe(
    $a(rZ(this, jm, S4).call(this, e)),
    te(([t, r]) => ({
      streamWidth: t.width,
      streamHeight: t.height,
      streamAspectRatio: t.height !== 0 ? t.width / t.height : 1,
      elementWidth: r.width,
      elementHeight: r.height,
      elementAspectRatio: r.height !== 0 ? r.width / r.height : 1
    }))
  );
};
nZ.styles = [
  ...N.styles,
  ee`
      :host {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .container {
        display: flex;
        width: 100%;
        height: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      .container__video-wrap--width,
      .container__video-wrap--height {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      [data-fit-orientation='${Gt(fc.Landscape)}'] .container__video-wrap--width {
        width: 100%;
        height: 100%;
      }

      [data-fit-orientation='${Gt(fc.Landscape)}'] .container__video-wrap--height {
        aspect-ratio: var(--video-aspect-ratio);
        width: 100%;
      }

      [data-fit-orientation='${Gt(fc.Portrait)}'] .container__video-wrap--width {
        aspect-ratio: var(--video-aspect-ratio);
        height: 100%;
      }

      [data-fit-orientation='${Gt(fc.Portrait)}'] .container__video-wrap--height {
        width: 100%;
        height: 100%;
      }

      .container__video-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    `
];
nZ = Cwe([
  P("x-camera-internal-layout")
], nZ);
var wwe = Object.defineProperty, Awe = Object.getOwnPropertyDescriptor, C4 = (e) => {
  throw TypeError(e);
}, Uwe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Awe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && wwe(t, r, a), a;
}, b4 = (e, t, r) => t.has(e) || C4("Cannot " + r), OJ = (e, t, r) => (b4(e, t, "read from private field"), t.get(e)), jJ = (e, t, r) => t.has(e) ? C4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), aZ = (e, t, r) => (b4(e, t, "access private method"), r), qC, Of, y4, iZ;
let oZ = class extends N {
  constructor() {
    super(), jJ(this, Of), jJ(this, qC, new _e()), this.ticker$ = aZ(this, Of, iZ).call(this);
  }
  firstUpdated(e) {
    super.firstUpdated(e), aZ(this, Of, iZ).call(this).pipe(le(OJ(this, qC))).subscribe();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), OJ(this, qC).next();
  }
  render() {
    return w`<slot></slot>`;
  }
};
qC = /* @__PURE__ */ new WeakMap();
Of = /* @__PURE__ */ new WeakSet();
y4 = function(e, t) {
  return t ? Q2e(e) : ba;
};
iZ = function() {
  return _w().pipe(
    Wt((e) => {
      var t;
      return (t = this.videoElRef) != null && t.value ? aZ(this, Of, y4).call(this, this.videoElRef.value, e) : ba;
    }),
    Xc(yS),
    ao(
      (e) => {
        var t;
        return ((t = this.videoTickCallback) == null ? void 0 : t.call(this, e).then(
          () => e,
          () => e
        )) ?? Promise.resolve(e);
      }
    ),
    QW({
      refCount: !0,
      bufferSize: 1
    })
  );
};
oZ.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
oZ = Uwe([
  P("x-camera-video-ticker")
], oZ);
var gr, Fo, Ps, ou, Kn, sZ, w4, A4, U4, k4, _4;
class kwe {
  constructor(t) {
    E(this, Kn);
    E(this, gr);
    E(this, Fo);
    E(this, Ps);
    E(this, ou);
    this.processVideoTick = (r) => {
      const n = this.getCanvasProcessorCollection(), a = { videoElement: r, frameId: Date.now().toString() }, i = n.map(
        (o) => {
          var s;
          return ((s = o.onVideoTick) == null ? void 0 : s.call(o, a)) ?? Promise.resolve(void 0);
        }
      );
      return Promise.all(i).then(() => {
      });
    }, this.videoPlaying = (r) => {
      var n, a;
      if (a4(S(this, Ps))) {
        const [i] = S(this, Ps).getVideoTracks();
        Te.cameraStreamStarted(S(this, gr), {
          metadata: zo(
            {
              constraints: i.getConstraints(),
              // getCapabilities is not available in the Firefox
              capabilities: ((n = i.getCapabilities) == null ? void 0 : n.call(i)) ?? {},
              settings: i.getSettings(),
              state: xY()
            },
            ["deviceId", "groupId", "deviceIds", "deviceEntities", "mockDeviceIds", "mockDeviceEntities"]
          )
        });
      }
      r instanceof HTMLVideoElement && ((a = S(this, gr).videoElRef.value) == null || a.dispatchEvent(
        new owe({
          source: r,
          sourceWidth: r.videoWidth,
          sourceHeight: r.videoHeight
        })
      ), this.processStreamStart(r));
    }, this.onVideoResize = (r) => {
      var n;
      r && ((n = S(this, gr).videoElRef.value) == null || n.dispatchEvent(
        new swe({
          source: r,
          sourceWidth: r.videoWidth,
          sourceHeight: r.videoHeight
        })
      ), this.processStreamResize(r));
    }, this.videoPause = (r) => {
      var n;
      if (r instanceof HTMLVideoElement) {
        const a = new iwe({
          source: r,
          sourceWidth: r.videoWidth,
          sourceHeight: r.videoHeight
        });
        (n = S(this, gr).videoElRef.value) == null || n.dispatchEvent(a), this.processStreamPause(r);
      }
    }, G(this, gr, t), G(this, Fo, new _e()), G(this, ou, new _e()), S(this, gr).addController(this);
  }
  hostConnected() {
    q2e().pipe(le(S(this, Fo))).subscribe(), O(this, Kn, U4).call(this).pipe(le(S(this, Fo))).subscribe(), O(this, Kn, k4).call(this).pipe(le(S(this, Fo))).subscribe(), O(this, Kn, _4).call(this).pipe(le(S(this, Fo))).subscribe();
  }
  hostDisconnected() {
    this.stopStream(), S(this, Fo).next();
  }
  async restartStream(t) {
    try {
      return YU(!0), this.stopStream(), await O(this, Kn, w4).call(this, t);
    } catch (r) {
      this.stopStream(), r instanceof Error && MY(r);
      return;
    } finally {
      YU(!1);
    }
  }
  stopStream(t = S(this, Ps)) {
    var r;
    rwe({
      videoSource: t,
      videoElement: (r = S(this, gr).videoElRef) == null ? void 0 : r.value,
      unsetVideoSource: () => {
        G(this, Ps, void 0);
      },
      playbackCancelNotifier$: S(this, ou)
    }), YU(!1);
  }
  async captureImage() {
    const r = [
      ...S(this, gr).videoRenderingEngineCollection,
      ...S(this, gr).videoOverlayVideoRenderingEngineCollection
    ].map(
      (n) => {
        var a;
        return ((a = n.captureImage) == null ? void 0 : a.call(n)) ?? Promise.resolve(void 0);
      }
    );
    return await Promise.all(r);
  }
  processStreamStart(t) {
    this.getCanvasProcessorCollection().forEach((n) => {
      var a;
      return (a = n.onStreamStart) == null ? void 0 : a.call(n, t);
    });
  }
  processStreamPause(t) {
    this.getCanvasProcessorCollection().forEach((n) => {
      var a;
      return (a = n.onStreamPause) == null ? void 0 : a.call(n, t);
    });
  }
  processStreamResize(t) {
    this.getCanvasProcessorCollection().forEach((n) => {
      var a;
      return (a = n.onStreamResize) == null ? void 0 : a.call(n, t);
    });
  }
  getCanvasProcessorCollection() {
    return [
      ...S(this, gr).videoRenderingEngineCollection,
      ...S(this, gr).videoRenderingEngineBackdrop,
      ...S(this, gr).videoOverlayVideoRenderingEngineCollection
    ];
  }
}
gr = new WeakMap(), Fo = new WeakMap(), Ps = new WeakMap(), ou = new WeakMap(), Kn = new WeakSet(), sZ = async function(t) {
  let r;
  const n = t.detail.constraints;
  if (Y2e(n)) {
    const a = await n4({
      constraints: n
    }), i = await O2e(), o = X2e(i, n.video.facingMode.ideal);
    if (K2e(a.source, o))
      r = a;
    else {
      this.stopStream(a.source);
      const s = j2e(n, o.deviceId);
      return O(this, Kn, sZ).call(this, new Il({
        videoElement: t.detail.videoElement,
        constraints: s
      }));
    }
  } else
    r = await L2e({
      constraints: n
    });
  return r;
}, w4 = async function(t) {
  var i, o;
  const r = t.detail.videoElement, n = await O(this, Kn, sZ).call(this, t), a = ewe(r, S(this, ou));
  switch (n.type) {
    case Sg.Camera:
      await ((o = (i = S(this, gr)).applyConstraintCallback) == null ? void 0 : o.call(i, {
        stream: n.source,
        track: n.track
      })), r.srcObject = n.source, G(this, Ps, n.source), tZ($2e(n.track));
      break;
    case Sg.File:
      r.src = n.url, G(this, Ps, n.url), tZ(n.track);
      break;
  }
  return r.load(), await a, await r.play(), O(this, Kn, A4).call(this, r), gwe(z2e(n)), $ye(n.deviceId), n;
}, A4 = function(t) {
  const { cameraTimeoutMs: r = 5e3 } = TE() ?? {};
  F2e({
    videoElement: t,
    cancelNotifier$: S(this, ou),
    timeoutMs: r
  }).pipe(
    ae(() => {
      S(this, gr).dispatchEvent(new wJ(Z_.Alive));
    }),
    ti(() => (S(this, gr).dispatchEvent(new wJ(Z_.Stalled)), ba)),
    qc(1),
    le(S(this, Fo))
  ).subscribe();
}, U4 = function() {
  return B2e("camera").pipe(ae(Pye));
}, k4 = function() {
  return _w().pipe(
    ae((t) => {
      S(this, gr).videoElRef.value && (t ? this.videoPlaying.bind(this) : this.videoPause.bind(this))(S(this, gr).videoElRef.value);
    })
  );
}, _4 = function() {
  return Bl(S(this, gr).videoElRef, S(this, gr).refresh$).pipe(
    at((t) => t instanceof HTMLVideoElement),
    Wt((t) => twe(t))
  );
};
var _we = Object.defineProperty, Nwe = Object.getOwnPropertyDescriptor, N4 = (e) => {
  throw TypeError(e);
}, Nw = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Nwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && _we(t, r, a), a;
}, NQ = (e, t, r) => t.has(e) || N4("Cannot " + r), yd = (e, t, r) => (NQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), G0 = (e, t, r) => t.has(e) ? N4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), XI = (e, t, r, n) => (NQ(e, t, "write to private field"), t.set(e, r), r), Zwe = (e, t, r) => (NQ(e, t, "access private method"), r), Th, eb, tb, df, lZ, Z4;
let yg = class extends N {
  constructor() {
    super(), G0(this, lZ), G0(this, Th), G0(this, eb), G0(this, tb), G0(this, df), this.processVideoTick = (e) => this.controller.processVideoTick(e), this.videoElRef = Rt(), this.layoutElRef = Rt(), this.canvasRendererElRef = Rt(), this.cameraVideoTickerComponentRef = Rt(), XI(this, Th, new _e()), this.refresh$ = yd(this, Th).asObservable(), this.videoElement$ = Bl(this.videoElRef, yd(this, Th)), this.controller = new kwe(this), XI(this, eb, new ue(this, fwe())), XI(this, tb, new Kt(Zwe(this, lZ, Z4).call(this))), XI(this, df, new ue(this, yd(this, tb)));
  }
  firstUpdated(e) {
    super.firstUpdated(e), yd(this, Th).next();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.stopStream();
  }
  render() {
    return w`
      <x-camera-video-ticker
        ${Mt(this.cameraVideoTickerComponentRef)}
        .videoElRef="${this.videoElRef}"
        .videoTickCallback="${this.processVideoTick.bind(this)}"
      >
        <x-camera-internal-layout ${Mt(this.layoutElRef)}>
          <slot name="backdrop" slot="backdrop">
            ${yd(this, df).value ? w`
                  <x-camera-webgl-renderer
                    slot="backdrop"
                    class="backdrop"
                    data-image-ratio="0.25"
                    data-fit-mode="cover"
                    data-rendering-allowed="true"
                    .flipped="${this.isFlipped()}"
                  >
                    <div class="backdrop-overlay"></div>
                  </x-camera-webgl-renderer>
                ` : q}
          </slot>
          <slot name="between-backdrop-and-video" slot="backdrop"></slot>
          <video
            ${Mt(this.videoElRef)}
            slot="video"
            class="${tn({
      video: !0
    })}"
            data-qa-id="video"
            data-flipped="${this.isFlipped()}"
            @resize="${(e) => {
      this.controller.onVideoResize(this.videoElRef.value, e);
    }}"
            muted
            playsinline
            loop
            autoplay
          ></video>
          <slot name="canvas" slot="canvas">
            ${yd(this, df).value ? w`
                  <x-camera-webgl-renderer
                    ${Mt(this.canvasRendererElRef)}
                    class="renderer"
                    data-fit-mode="contain"
                    data-rendering-allowed="false"
                  ></x-camera-webgl-renderer>
                ` : w`
                  <x-camera-canvas2d-renderer
                    ${Mt(this.canvasRendererElRef)}
                    class="renderer"
                    data-fit-mode="contain"
                    data-rendering-allowed="false"
                  ></x-camera-canvas2d-renderer>
                `}
          </slot>
          <slot name="underlay" slot="underlay"></slot>
          <slot name="video-width-before" slot="video-width-before"></slot>
          <slot name="video-height-before" slot="video-height-before"></slot>
          <slot name="video-overlay" slot="video-overlay"></slot>
          <slot name="video-height-after" slot="video-height-after"></slot>
          <slot name="video-width-after" slot="video-width-after"></slot>
          <slot name="overlay" slot="overlay"></slot>
        </x-camera-internal-layout>
      </x-camera-video-ticker>
    `;
  }
  captureImage() {
    return this.controller.captureImage();
  }
  async switchStream(e) {
    if (e instanceof Il)
      return this.controller.restartStream(e);
    const t = this.videoElRef.value;
    if (!t)
      throw new GS("switchStream: video element is not defined");
    return this.controller.restartStream(
      new Il({
        videoElement: t,
        constraints: {
          video: {
            ...wQ(),
            deviceId: {
              exact: e.detail.deviceId
            }
          },
          audio: !1
        }
      })
    );
  }
  stopStream() {
    this.controller.stopStream();
  }
  isFlipped() {
    return yd(this, eb).value !== vg.Back;
  }
};
Th = /* @__PURE__ */ new WeakMap();
eb = /* @__PURE__ */ new WeakMap();
tb = /* @__PURE__ */ new WeakMap();
df = /* @__PURE__ */ new WeakMap();
lZ = /* @__PURE__ */ new WeakSet();
Z4 = function() {
  const e = document.createElement("canvas");
  return jE !== Vu.EndToEnd && !!e.getContext("webgl2");
};
yg.styles = [
  ...N.styles,
  ee`
      :host {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .backdrop,
      .video {
        position: absolute;
        display: block;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        box-sizing: border-box;
      }

      .video[data-flipped='true'] {
        transform: scale(-1, 1);
      }

      .backdrop-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-backdrop-filter: blur(1em);
        backdrop-filter: blur(1em);
      }

      .renderer {
        display: none;
      }
    `
];
Nw([
  dr({ slot: "canvas", flatten: !0 })
], yg.prototype, "videoRenderingEngineCollection", 2);
Nw([
  dr({ slot: "video-overlay", flatten: !0 })
], yg.prototype, "videoOverlayVideoRenderingEngineCollection", 2);
Nw([
  dr({ slot: "backdrop", flatten: !0 })
], yg.prototype, "videoRenderingEngineBackdrop", 2);
yg = Nw([
  P("x-camera")
], yg);
const ZQ = (e, t) => Bl(e, t).pipe(Wt((r) => r.videoElement$));
var Bwe = Object.defineProperty, Wwe = Object.getOwnPropertyDescriptor, B4 = (e) => {
  throw TypeError(e);
}, W4 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Wwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Bwe(t, r, a), a;
}, E4 = (e, t, r) => t.has(e) || B4("Cannot " + r), rb = (e, t, r) => (E4(e, t, "read from private field"), r ? r.call(e) : t.get(e)), x0 = (e, t, r) => t.has(e) ? B4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), OU = (e, t, r) => (E4(e, t, "access private method"), r), cZ, dZ, BQ, uZ, uf, Q4, F4, T4;
let hZ = class extends N {
  constructor() {
    super(...arguments), x0(this, uf), this.orientation = qa.Vertical, x0(this, cZ, new _e()), x0(this, dZ, new ue(this, OU(this, uf, F4).call(this))), x0(this, BQ, new ue(this, p4())), x0(this, uZ, new ue(this, f4()));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), rb(this, cZ).next();
  }
  getDevices() {
    const [e] = rb(this, dZ).value ?? [];
    return e ?? [];
  }
  render() {
    const e = this.getDevices();
    return w`
      <x-ds-camera-selector data-orientation="${this.orientation}">
        ${e.map((t, r) => w`
            <x-ds-camera-icon
              slot="icon"
              data-qa-id="camera-button"
              data-qa-id-label="${t.label}"
              data-qa-id-device-id="${t.deviceId}"
              data-selected="${OU(this, uf, T4).call(this, t)}"
              data-enabled="${rb(this, uZ).value === !1}"
              @click=${() => {
      mwe() || OU(this, uf, Q4).call(this, t);
    }}
              title="${t.label}"
            >
              ${r + 1}
            </x-ds-camera-icon>
          `)}
      </x-ds-camera-selector>
    `;
  }
};
cZ = /* @__PURE__ */ new WeakMap();
dZ = /* @__PURE__ */ new WeakMap();
BQ = /* @__PURE__ */ new WeakMap();
uZ = /* @__PURE__ */ new WeakMap();
uf = /* @__PURE__ */ new WeakSet();
Q4 = function(e) {
  this.dispatchEvent(new Uw(e)), Te.switchCamera(this, {
    metadata: zo({ deviceInfo: e }, [
      "deviceId",
      "groupId",
      "deviceIds",
      "deviceEntities",
      "mockDeviceIds",
      "mockDeviceEntities"
    ])
  });
};
F4 = function() {
  return HY().pipe(
    $a(gQ()),
    ae(([e, t]) => {
      switch (t) {
        case "granted":
          Te.cameraAccessGranted(this, {
            metadata: zo({ devices: e, permissionState: t }, [
              "deviceId",
              "groupId",
              "deviceIds",
              "deviceEntities",
              "mockDeviceIds",
              "mockDeviceEntities"
            ])
          });
          break;
        case "denied":
          Te.cameraAccessDenied(this, {
            metadata: zo({ devices: e, permissionState: t }, [
              "deviceId",
              "groupId",
              "deviceIds",
              "deviceEntities",
              "mockDeviceIds",
              "mockDeviceEntities"
            ])
          });
          break;
      }
      Te.deviceListChanged(this, {
        metadata: zo({ devices: e, permissionState: t }, [
          "deviceId",
          "groupId",
          "deviceIds",
          "deviceEntities",
          "mockDeviceIds",
          "mockDeviceEntities"
        ])
      });
    })
  );
};
T4 = function(e) {
  var t;
  return ((t = rb(this, BQ).value) == null ? void 0 : t.settings.deviceId) === e.deviceId;
};
W4([
  M({
    attribute: "data-orientation",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => zle(e) ? e : qa.Horizontal,
      toAttribute: (e) => e.toString()
    }
  })
], hZ.prototype, "orientation", 2);
hZ = W4([
  P("x-camera-selector")
], hZ);
class R4 extends CustomEvent {
  constructor(t) {
    super("consentchange", {
      detail: t,
      bubbles: !0,
      cancelable: !1,
      composed: !0
    });
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const El = (e, t, r) => {
  for (const n of t) if (n[0] === e) return (0, n[1])();
  return r == null ? void 0 : r();
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class pZ extends jg {
  constructor(t) {
    if (super(t), this.it = q, t.type !== Yg.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === q || t == null) return this._t = void 0, this.it = t;
    if (t === no) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const r = [t];
    return r.raw = r, this._t = { _$litType$: this.constructor.resultType, strings: r, values: [] };
  }
}
pZ.directiveName = "unsafeHTML", pZ.resultType = 1;
const Pm = Og(pZ), Ewe = (e) => {
  if (e) {
    const r = /\[\(\{(.*?)}\)]/g.exec(e);
    if (r) {
      const [n, a] = e.split(r[0]);
      return { text1: n, text2: a, linkText: r[1] };
    }
  }
  return { text1: e ?? "", text2: "", linkText: "" };
};
var Qwe = Object.defineProperty, Fwe = Object.getOwnPropertyDescriptor, D4 = (e) => {
  throw TypeError(e);
}, Zw = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Fwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Qwe(t, r, a), a;
}, J4 = (e, t, r) => t.has(e) || D4("Cannot " + r), V4 = (e, t, r) => (J4(e, t, "read from private field"), r ? r.call(e) : t.get(e)), PJ = (e, t, r) => t.has(e) ? D4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Lu = (e, t, r) => (J4(e, t, "access private method"), r), Bw, Cl, M4, G4, x4, H4, WQ, L4;
const Twe = (e) => Array.isArray(e) && e.every(
  (t) => Ut(t, ["id", "displayType", "text", "alternativeTexts"])
);
let wg = class extends N {
  constructor() {
    super(...arguments), PJ(this, Cl), this.locale = Y.En, this.consentDto = [], this.consentGiven = !1, PJ(this, Bw, Rt());
  }
  render() {
    return w`
      <div class="consent-policy" data-qa-id="consent-policy" data-color-scheme="${this.colorScheme}">
        ${this.consentDto.map((e, t) => Lu(this, Cl, M4).call(this, e, t))}
      </div>
    `;
  }
};
Bw = /* @__PURE__ */ new WeakMap();
Cl = /* @__PURE__ */ new WeakSet();
M4 = function(e, t) {
  return w`
      <div data-qa-id="consent-item-${t}">
        ${El(e.displayType, [
    [M1.Active, () => Lu(this, Cl, G4).call(this, e)],
    [M1.Passive, () => Lu(this, Cl, x4).call(this, e)]
  ])}
      </div>
    `;
};
G4 = function(e) {
  return w`
      <div>
        <label class="text-center">
          <input
            ${Mt(V4(this, Bw))}
            type="checkbox"
            @click="${() => {
    Lu(this, Cl, L4).call(this, e);
  }}"
            .checked="${this.consentGiven}"
            data-qa-id="consent-item-checkbox"
          />
          ${Lu(this, Cl, WQ).call(this, e, !1)}
        </label>
      </div>
    `;
};
x4 = function(e) {
  return w` <div>${Lu(this, Cl, WQ).call(this, e, !0)}</div>`;
};
H4 = function(e) {
  return Object.values(Y).includes(e);
};
WQ = function(e, t) {
  var g;
  const r = (g = this.locale) == null ? void 0 : g.replace(/_/g, "-"), n = Lu(this, Cl, H4).call(this, r) ? r : void 0, a = n ? e.alternativeTexts[n] : void 0, i = e.alternativeTexts[this.locale] ?? a ?? e.text, { text1: o, text2: s, linkText: c } = Ewe(i), l = Pm(o), u = Pm(s);
  return t ? w`
        <!-- prettier-ignore -->
        <span class="${"text-center"}" data-qa-id="consent-policy-text">${l}<a target="_blank"
                                                                                       href="${e.privacyPolicyUrl}"
                                                                                       class="link"
                                                                                       data-qa-id="consent-policy-link">${c.trim()}</a>${u}</span>
      ` : w`
      <!-- prettier-ignore -->
      <span data-qa-id="consent-policy-text">${l}<a target="_blank" href="${e.privacyPolicyUrl}"
                                                            class="link"
                                                            data-qa-id="consent-policy-link">${c.trim()}</a>${u}</span>
    `;
};
L4 = function(e) {
  var t;
  this.dispatchEvent(
    new R4({
      consentGiven: ((t = V4(this, Bw).value) == null ? void 0 : t.checked) ?? !1,
      timestamp: Date.now(),
      id: e.id
    })
  );
};
wg.styles = [
  ...N.styles,
  ee`
      .consent-policy {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
      }

      .text-center {
        display: inline-block;
        width: 100%;
        text-align: center;
      }
    `
];
Zw([
  M({
    attribute: "data-locale",
    type: String,
    converter: {
      fromAttribute: (e) => Object.values(Y).includes(e) ? e : Y.En,
      toAttribute: (e) => e.toString()
    }
  })
], wg.prototype, "locale", 2);
Zw([
  M({
    attribute: "data-consent-dto",
    type: String,
    converter: {
      toAttribute: (e) => JSON.stringify(e),
      fromAttribute: (e) => {
        let t = [];
        try {
          const r = JSON.parse(e ?? "");
          Twe(r) && (t = r);
        } catch {
        }
        return t;
      }
    }
  })
], wg.prototype, "consentDto", 2);
Zw([
  M({
    attribute: "data-consent-given",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], wg.prototype, "consentGiven", 2);
wg = Zw([
  P("x-consent-policy")
], wg);
class Rwe extends CustomEvent {
  constructor() {
    super("startcapture", {
      bubbles: !0,
      composed: !0
    });
  }
}
class Dwe extends CustomEvent {
  constructor(t) {
    super("thumbnaildeleted", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class Jwe extends CustomEvent {
  constructor(t) {
    super("thumbnailselected", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class Vwe extends CustomEvent {
  constructor(t) {
    super("uploadupdate", {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
class EQ extends CustomEvent {
  constructor(t, r) {
    super(t, {
      bubbles: !0,
      composed: !0,
      detail: r
    });
  }
}
var $m = /* @__PURE__ */ ((e) => (e.FilesUploadedRaw = "filesuploadedraw", e.FilesUploaded = "filesuploaded", e))($m || {}), QQ = /* @__PURE__ */ ((e) => (e.Upload = "upload", e.Clipboard = "clipboard", e))(QQ || {}), Y4 = /* @__PURE__ */ ((e) => (e.DRAG = "drag", e.DRAG_END = "dragend", e.DRAG_ENTER = "dragenter", e.DRAG_LEAVE = "dragleave", e.DRAG_OVER = "dragover", e.DRAG_START = "dragstart", e.DROP = "drop", e.DRAG_AND_DROP_CHANGE = "draganddropchange", e))(Y4 || {}), Mwe = Object.defineProperty, Gwe = Object.getOwnPropertyDescriptor, O4 = (e) => {
  throw TypeError(e);
}, j4 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Gwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Mwe(t, r, a), a;
}, P4 = (e, t, r) => t.has(e) || O4("Cannot " + r), $4 = (e, t, r) => (P4(e, t, "read from private field"), r ? r.call(e) : t.get(e)), $J = (e, t, r) => t.has(e) ? O4("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), xwe = (e, t, r) => (P4(e, t, "access private method"), r), ny, gZ, K4;
const Hwe = (e) => e;
let ay = class extends N {
  constructor() {
    super(...arguments), $J(this, gZ), this.filter = Hwe, $J(this, ny, new _e());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), $4(this, ny).next();
  }
  render() {
    return w`<slot></slot>`;
  }
  firstUpdated(e) {
    super.firstUpdated(e), xwe(this, gZ, K4).call(this);
  }
};
ny = /* @__PURE__ */ new WeakMap();
gZ = /* @__PURE__ */ new WeakSet();
K4 = function() {
  Ke(this, $m.FilesUploadedRaw).pipe(
    ae((e) => {
      this.dispatchEvent(
        new EQ($m.FilesUploaded, {
          source: e.detail.source,
          files: this.filter(e.detail.files)
        })
      );
    }),
    Lm(this),
    le($4(this, ny))
  ).subscribe();
};
ay.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
j4([
  Xn()
], ay.prototype, "filter", 2);
ay = j4([
  P("x-file-sink")
], ay);
const FQ = (e) => Ut(
  e,
  ["filesystem", "fullPath", "isDirectory", "isFile", "name"],
  (t) => t.isFile
), X4 = (e) => Ut(
  e,
  ["filesystem", "fullPath", "isDirectory", "isFile", "name"],
  (t) => t.isDirectory
), Lwe = async (e) => {
  const t = [];
  let r;
  do
    r = await e.next(), FQ(r.value) && t.push(r.value);
  while (!r.done);
  return t;
};
async function* fZ(e) {
  if (Array.isArray(e))
    for (const t of e)
      yield* fZ(t);
  else if (FQ(e))
    yield Promise.resolve(e);
  else if (X4(e)) {
    const t = e.createReader(), r = await new Promise((n, a) => {
      t.readEntries(n, a);
    });
    for await (const n of r)
      yield* fZ(n);
  }
}
async function Ywe(e) {
  const t = Array.from(e).map((n) => n.webkitGetAsEntry()).filter((n) => X4(n) || FQ(n)), r = await Lwe(fZ(t));
  return Promise.all(
    r.map(
      (n) => new Promise((a, i) => {
        n.file(a, i);
      })
    )
  );
}
const z4 = (e) => Array.from(e), q4 = () => ho(
  at((e) => e instanceof DataTransfer),
  Wt((e) => {
    let t = om;
    return e.items instanceof DataTransferItemList ? t = Ywe(e.items) : e.files instanceof FileList && (t = Promise.resolve(z4(e.files))), t;
  })
), Owe = (e) => e ? Ke(e, "change").pipe(
  Wt((t) => {
    let r = om;
    return t.currentTarget instanceof HTMLInputElement && t.currentTarget.files instanceof FileList && (r = Promise.resolve(z4(t.currentTarget.files))), r;
  })
) : om, jwe = (e) => Ke(e, "drop").pipe(
  ae((t) => {
    t.preventDefault(), t.stopPropagation();
  }),
  te((t) => t.dataTransfer),
  q4()
), Pwe = (e) => Ke(document, "paste").pipe(
  te((t) => t.clipboardData),
  q4(),
  ae((t) => {
    e.dispatchEvent(
      new EQ($m.FilesUploadedRaw, {
        source: QQ.Clipboard,
        files: t
      })
    );
  })
);
var $we = Object.defineProperty, Kwe = Object.getOwnPropertyDescriptor, eO = (e) => {
  throw TypeError(e);
}, Xwe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Kwe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && $we(t, r, a), a;
}, tO = (e, t, r) => t.has(e) || eO("Cannot " + r), rO = (e, t, r) => (tO(e, t, "read from private field"), r ? r.call(e) : t.get(e)), KJ = (e, t, r) => t.has(e) ? eO("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), zwe = (e, t, r) => (tO(e, t, "access private method"), r), iy, mZ, nO;
let XJ = class extends N {
  constructor() {
    super(...arguments), KJ(this, mZ), KJ(this, iy, new _e());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), rO(this, iy).next();
  }
  render() {
    return w`<slot></slot>`;
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownUploadScreen(this);
  }
  firstUpdated(e) {
    super.firstUpdated(e), zwe(this, mZ, nO).call(this);
  }
};
iy = /* @__PURE__ */ new WeakMap();
mZ = /* @__PURE__ */ new WeakSet();
nO = function() {
  Pwe(this).pipe(Lm(this), le(rO(this, iy))).subscribe();
};
XJ = Xwe([
  P("x-file-source-clipboard")
], XJ);
class zJ extends CustomEvent {
  constructor(t) {
    super(Y4.DRAG_AND_DROP_CHANGE, {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
var qwe = Object.defineProperty, eAe = Object.getOwnPropertyDescriptor, aO = (e) => {
  throw TypeError(e);
}, Ql = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? eAe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && qwe(t, r, a), a;
}, iO = (e, t, r) => t.has(e) || aO("Cannot " + r), cl = (e, t, r) => (iO(e, t, "read from private field"), r ? r.call(e) : t.get(e)), jU = (e, t, r) => t.has(e) ? aO("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), hf = (e, t, r) => (iO(e, t, "access private method"), r), zd, Ag, qd, oO, nb, sO;
const tAe = (e, t) => t.map((r) => Ke(e, r));
let lo = class extends N {
  constructor() {
    super(...arguments), jU(this, qd), this.dragging = !1, this.dragOver = !1, this.fileInputMultiple = !0, this.fileInputAccept = "", this.fileInputDirectory = !1, this.fileInputAllowDirs = !1, this.fileInputWebkitDirectory = !1, this.fileInputCapture = !1, jU(this, zd, Rt()), jU(this, Ag, new _e());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), cl(this, Ag).next();
  }
  render() {
    return w`
      <input
        ${Mt(cl(this, zd))}
        type="file"
        accept="${this.fileInputAccept}"
        data-qa-id="file-browser"
        ?hidden="${!0}"
        ${this.fileInputMultiple ? '?multiple="${this.fileInputMultiple}"' : q}
        ?directory="${this.fileInputDirectory}"
        ?allowdirs="${this.fileInputAllowDirs}"
        ?webkitdirectory="${this.fileInputWebkitDirectory}"
        ?capture="${this.fileInputCapture}"
      />
      <slot></slot>
    `;
  }
  firstUpdated(e) {
    super.firstUpdated(e), hf(this, qd, oO).call(this);
  }
  clearFile() {
    cl(this, zd).value && (cl(this, zd).value.value = "");
  }
};
zd = /* @__PURE__ */ new WeakMap();
Ag = /* @__PURE__ */ new WeakMap();
qd = /* @__PURE__ */ new WeakSet();
oO = function() {
  hf(this, qd, nb).call(this, ["dragover"], (e) => {
    e.preventDefault();
  }), hf(this, qd, nb).call(this, ["dragenter", "dragover"], () => {
    this.dragOver = !0, this.dragging = !0, this.dispatchEvent(
      new zJ({
        isDragging: !0
      })
    );
  }), hf(this, qd, nb).call(this, ["dragleave", "dragend", "drop"], () => {
    this.dragOver = !1, this.dragging = !1, this.dispatchEvent(
      new zJ({
        isDragging: !1
      })
    );
  }), Ke(this, "click").pipe(
    ae(() => {
      var e;
      return (e = cl(this, zd).value) == null ? void 0 : e.click();
    }),
    Lm(this),
    le(cl(this, Ag))
  ).subscribe(), hf(this, qd, sO).call(this).pipe(Lm(this), le(cl(this, Ag))).subscribe();
};
nb = function(e, t) {
  ps(...tAe(this, e)).pipe(
    ae((r) => {
      r.preventDefault(), r.stopPropagation(), t(r);
    }),
    Lm(this),
    le(cl(this, Ag))
  ).subscribe();
};
sO = function() {
  return ps(jwe(this), Owe(cl(this, zd).value)).pipe(
    ae((t) => {
      this.dispatchEvent(
        new EQ($m.FilesUploadedRaw, {
          source: QQ.Upload,
          files: t
        })
      );
    })
  );
};
lo.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
Ql([
  M({ attribute: "data-dragging", type: String, reflect: !0 })
], lo.prototype, "dragging", 2);
Ql([
  M({ attribute: "data-drag-over", type: String, reflect: !0 })
], lo.prototype, "dragOver", 2);
Ql([
  M({ attribute: "multiple", type: String, reflect: !0 })
], lo.prototype, "fileInputMultiple", 2);
Ql([
  M({ attribute: "accept", type: String, reflect: !0 })
], lo.prototype, "fileInputAccept", 2);
Ql([
  M({ attribute: "directory" })
], lo.prototype, "fileInputDirectory", 2);
Ql([
  M({ attribute: "allowdirs" })
], lo.prototype, "fileInputAllowDirs", 2);
Ql([
  M({ attribute: "webkitdirectory" })
], lo.prototype, "fileInputWebkitDirectory", 2);
Ql([
  M({ attribute: "capture" })
], lo.prototype, "fileInputCapture", 2);
lo = Ql([
  P("x-file-source-picker")
], lo);
var rAe = Object.defineProperty, nAe = Object.getOwnPropertyDescriptor, lO = (e) => {
  throw TypeError(e);
}, TQ = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? nAe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && rAe(t, r, a), a;
}, RQ = (e, t, r) => t.has(e) || lO("Cannot " + r), aAe = (e, t, r) => (RQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), qJ = (e, t, r) => t.has(e) ? lO("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), iAe = (e, t, r, n) => (RQ(e, t, "write to private field"), t.set(e, r), r), Xa = (e, t, r) => (RQ(e, t, "access private method"), r), Ww, Yn, cO, dO, uO, hO, pO, gO, fO, DQ, mO, JQ, vO;
let Km = class extends N {
  constructor() {
    super(...arguments), qJ(this, Yn), qJ(this, Ww, !1), this.loading = !1, this.images = [];
  }
  render() {
    const e = this.images.map((t) => t.base64);
    return w` <div
      class=${tn({
      "file-multi-upload": !0,
      "empty-mobile": _l() && !(e != null && e.length)
    })}
    >
      ${this.loading ? w` <div class="file-multi-upload-content">
            <slot name="loading"></slot>
          </div>` : w` <x-file-sink
            @filesuploaded="${(t) => {
      Xa(this, Yn, fO).call(this, t);
    }}"
          >
            ${e != null && e.length ? Xa(this, Yn, hO).call(this, e) : Xa(this, Yn, cO).call(this)}
          </x-file-sink>`}
    </div>`;
  }
};
Ww = /* @__PURE__ */ new WeakMap();
Yn = /* @__PURE__ */ new WeakSet();
cO = function() {
  return _l() ? Xa(this, Yn, dO).call(this) : Xa(this, Yn, uO).call(this);
};
dO = function() {
  return w` <slot name="empty-mobile" data-qa-id="empty-mobile"></slot>`;
};
uO = function() {
  return w` <x-file-source-picker
      data-qa-id="empty-desktop"
      @draganddropchange="${(e) => {
    Xa(this, Yn, DQ).call(this, e);
  }}"
    >
      <div class="file-multi-upload-content">
        ${aAe(this, Ww) ? w` <slot name="drop-zone"></slot>` : w` <slot name="empty-desktop"></slot> `}
      </div>
    </x-file-source-picker>`;
};
hO = function(e) {
  return w` <div class="file-multi-upload-content">
      ${_l() ? Xa(this, Yn, pO).call(this, e) : Xa(this, Yn, gO).call(this, e)}
    </div>`;
};
pO = function(e) {
  return w`
      ${e.map(
    (t, r) => t ? w`<img
              class="is-mobile"
              src="${t}"
              @click="${(n) => {
      n.stopPropagation(), Xa(this, Yn, JQ).call(this, r);
    }}"
            />` : w` <x-ds-shimmer-loader></x-ds-shimmer-loader>`
  )}
      <div class="upload-item is-mobile" data-qa-id="mobile-actions">
        <div
          class="upload-action"
          @click="${() => {
    Xa(this, Yn, vO).call(this);
  }}"
        >
          <span class="icon icon-ic-method-camera"></span>
        </div>
        <div class="upload-action">
          <x-file-source-picker data-qa-id="file-source-picker">
            <span class="icon icon-upload-method"></span>
          </x-file-source-picker>
        </div>
      </div>
    `;
};
gO = function(e) {
  return w`
      <x-file-source-picker
        data-qa-id="file-source-picker"
        multiple="true"
        @draganddropchange="${(t) => {
    Xa(this, Yn, DQ).call(this, t);
  }}"
      >
        ${e.map(
    (t, r) => w` <div
              class="desktop-image-wrapper"
              @click="${(n) => {
      n.stopPropagation(), Xa(this, Yn, JQ).call(this, r);
    }}"
            >
              ${t ? w`<img src="${t}" />` : w` <x-ds-shimmer-loader></x-ds-shimmer-loader>`}

              <div class="desktop-image-actions">
                <span
                  class="icon icon-delete delete-icon"
                  @click="${(n) => {
      n.stopPropagation(), Xa(this, Yn, mO).call(this, r);
    }}"
                ></span>
                <x-ds-button data-type="${De.Secondary}">
                  ${y("Preview", { id: "dv.preview.zoommode" })}
                </x-ds-button>
              </div>
            </div>`
  )}
        <div class="upload-item" data-qa-id="desktop-actions">
          <div class="upload-action">
            <span class="icon icon-add"></span>
          </div>
        </div>
      </x-file-source-picker>
    `;
};
fO = function(e) {
  this.dispatchEvent(new Vwe(e.detail.files[0]));
};
DQ = function(e) {
  iAe(this, Ww, e.detail.isDragging), this.requestUpdate();
};
mO = function(e) {
  this.dispatchEvent(new Dwe(e));
};
JQ = function(e = -1) {
  this.dispatchEvent(new Jwe(e));
};
vO = function() {
  this.dispatchEvent(new Rwe());
};
Km.styles = [
  ...N.styles,
  ee`
      .file-multi-upload {
        display: flex;
        justify-content: center;
        align-items: center;

        box-sizing: border-box;
        border: 0.0625em dashed var(--white);
        border-radius: 0.75em;
      }

      .file-multi-upload.empty-mobile {
        align-items: unset;
        flex-direction: column;
        min-height: unset;
        gap: 1em;
        border: none;
      }

      .file-multi-upload-content {
        display: flex;
        gap: 1em;
        width: 100%;
        height: 100%;
        flex-wrap: wrap;
        align-items: center;
        padding: 1em;
      }

      .file-multi-upload .desktop-image-wrapper {
        width: 14em;
        height: 19em;
        border: 0.0625em solid var(--white);
        border-radius: 0.75em;
        overflow: hidden;
        position: relative;
      }

      .file-multi-upload .desktop-image-wrapper img,
      .file-multi-upload .desktop-image-wrapper x-ds-shimmer-loader {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .file-multi-upload .desktop-image-wrapper:hover .desktop-image-actions {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .file-multi-upload .desktop-image-wrapper:hover .desktop-image-actions .icon {
        position: absolute;
        top: 0.3em;
        right: 0.3em;
        font-size: 1.5em;
        cursor: pointer;
        color: var(--white);
      }

      .file-multi-upload img.is-mobile {
        width: 9em;
        height: 13em;
        object-fit: cover;
      }

      .file-multi-upload x-ds-shimmer-loader {
        width: 9em;
        height: 13em;
        display: block;
      }

      .upload-item {
        width: 14em;
        height: 19em;
        display: flex;
        gap: 0.5em;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .upload-item.is-mobile {
        width: 9em;
        height: 13em;
      }

      .upload-action {
        cursor: pointer;
        border: 0.0625em solid var(--white);
        border-radius: 0.75em;
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
      }

      .upload-item .icon {
        font-size: 2.2em;
      }

      :host([data-color-scheme='light']) .file-multi-upload,
      :host([data-color-scheme='light']) .file-multi-upload canvas,
      :host([data-color-scheme='light']) .upload-action {
        border-color: var(--color-secondary7);
      }

      :host([data-color-scheme='dark']) .file-multi-upload,
      :host([data-color-scheme='dark']) .file-multi-upload canvas,
      :host([data-color-scheme='dark']) .upload-action {
        border-color: var(--color-secondary5);
      }

      :host([data-color-scheme='light']) .file-multi-upload {
        background-color: var(--color-secondary1);
      }

      :host([data-color-scheme='dark']) .file-multi-upload {
        background-color: var(--color-secondary9);
      }
    `
];
TQ([
  M({
    attribute: "data-loading",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Km.prototype, "loading", 2);
TQ([
  M({
    attribute: "images",
    type: Array,
    reflect: !0
  })
], Km.prototype, "images", 2);
Km = TQ([
  P("x-file-multi-upload")
], Km);
var VQ = /* @__PURE__ */ ((e) => (e.FileUpload = "fileupload", e.FileRemove = "fileremove", e))(VQ || {});
class oAe extends CustomEvent {
  constructor() {
    super(VQ.FileRemove, {
      bubbles: !0,
      composed: !0
    });
  }
}
class sAe extends CustomEvent {
  constructor(t) {
    super(VQ.FileUpload, {
      bubbles: !0,
      composed: !0,
      detail: t
    });
  }
}
const lAe = "filepickererror";
class eV extends CustomEvent {
  constructor(t) {
    super(lAe, {
      detail: t,
      bubbles: !0,
      composed: !0
    });
  }
}
var cAe = Object.defineProperty, dAe = Object.getOwnPropertyDescriptor, SO = (e) => {
  throw TypeError(e);
}, e0 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? dAe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && cAe(t, r, a), a;
}, MQ = (e, t, r) => t.has(e) || SO("Cannot " + r), pf = (e, t, r) => (MQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), PU = (e, t, r) => t.has(e) ? SO("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), uAe = (e, t, r, n) => (MQ(e, t, "write to private field"), t.set(e, r), r), pi = (e, t, r) => (MQ(e, t, "access private method"), r), zh, oy, sa, vZ, IO, CO, bO, SZ, yO, wO, AO, UO, kO;
const _O = -1;
let Mc = class extends N {
  constructor() {
    super(...arguments), PU(this, sa), this.status = er.NotStarted, this.maxFileSize = _O, this.accept = "", this.previewImageUrl = "", PU(this, zh, !1), PU(this, oy, Rt());
  }
  render() {
    return w`
      <div data-qa-id="file-upload" class="file-upload">
        <x-file-sink
          @filesuploaded="${(e) => {
      pi(this, sa, yO).call(this, e);
    }}"
        >
          <x-file-source-picker
            ${Mt(pf(this, oy))}
            data-qa-id="file-source-picker"
            accept="${this.accept}"
            multiple="false"
            @draganddropchange="${(e) => {
      pi(this, sa, kO).call(this, e);
    }}"
          >
            <div
              data-qa-id="file-upload-content"
              data-dd-privacy="hidden"
              style="${!pf(this, zh) && this.previewImageUrl && this.status === er.Success ? `background-image: url('${this.previewImageUrl}')` : ""}"
              class="${tn({
      "file-upload-content": !0,
      "file-upload-drop": pf(this, zh),
      [this.status]: !0
    })}"
            >
              ${pf(this, zh) ? pi(this, sa, bO).call(this) : El(this.status, [
      [er.NotStarted, () => pi(this, sa, vZ).call(this)],
      [er.Progress, () => pi(this, sa, IO).call(this)],
      [er.Success, () => pi(this, sa, vZ).call(this)],
      [er.Error, () => pi(this, sa, CO).call(this)]
    ])}
            </div>
          </x-file-source-picker>
        </x-file-sink>
        <div class="file-upload-actions">
          ${pi(this, sa, SZ).call(this, "zoom-in", () => {
      pi(this, sa, UO).call(this);
    })}
          ${pi(this, sa, SZ).call(this, "delete", () => {
      pi(this, sa, AO).call(this);
    })}
        </div>
      </div>
    `;
  }
};
zh = /* @__PURE__ */ new WeakMap();
oy = /* @__PURE__ */ new WeakMap();
sa = /* @__PURE__ */ new WeakSet();
vZ = function() {
  return w`<slot name="upload"></slot>`;
};
IO = function() {
  return w`<slot data-qa-id="file-upload-progress" name="loading"></slot>`;
};
CO = function() {
  return w`<slot data-qa-id="file-upload-error" name="error"></slot>`;
};
bO = function() {
  return w`<slot name="drop"></slot>`;
};
SZ = function(e, t) {
  return this.status === er.Success ? w`
          <span
            data-qa-id="file-upload-success-action-${e}"
            class="icon icon-${e} ${e}-icon"
            @click="${t}"
          ></span>
        ` : q;
};
yO = function(e) {
  const t = e.detail.files[0];
  if (t) {
    if (!pi(this, sa, wO).call(this, t)) {
      this.status = er.Error;
      return;
    }
    const r = new sAe({
      file: e.detail.files[0],
      mimeType: t.type,
      extension: t.name.substring(t.name.lastIndexOf("."))
    });
    try {
      this.dispatchEvent(r);
    } catch {
      this.status = er.Error;
    }
  }
};
wO = function(e) {
  return this.maxFileSize === _O || e.size <= this.maxFileSize ? this.accept && !this.accept.includes(e.type) ? (this.dispatchEvent(new eV("file-type")), !1) : !0 : (this.dispatchEvent(new eV("max-file-size")), !1);
};
AO = function() {
  var t;
  const e = new oAe();
  this.dispatchEvent(e), (t = pf(this, oy).value) == null || t.clearFile();
};
UO = function() {
  const e = new B9();
  this.dispatchEvent(e);
};
kO = function(e) {
  uAe(this, zh, e.detail.isDragging), this.requestUpdate();
};
Mc.styles = [
  ...N.styles,
  ee`
      .file-upload {
        position: relative;
        height: 100%;
      }

      .file-upload-content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        box-sizing: border-box;
        border: 0.0625em dashed var(--white);
        border-radius: 0.75em;
      }

      .file-upload-content.success {
        box-shadow: inset 0 0 0 64em rgba(0, 0, 0, 0.6);
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
      }

      .file-upload-actions {
        display: flex;
        justify-content: space-between;
        padding: 0.5em;
        position: absolute;
        top: 0;
        width: 100%;
        box-sizing: border-box;
      }

      :host([data-color-scheme='light']) .file-upload-content {
        border-color: var(--color-secondary7);
        background-color: var(--color-secondary1);
      }

      :host([data-color-scheme='dark']) .file-upload-content {
        border-color: var(--color-secondary5);
        background-color: var(--color-secondary9);
      }

      :host([data-color-scheme='light']) .delete-icon::before,
      :host([data-color-scheme='light']) .zoom-in-icon::before {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='light']) .delete-icon::before,
      :host([data-color-scheme='light']) .zoom-in-icon::before {
        color: var(--color-secondary3);
      }

      .delete-icon,
      .zoom-in-icon {
        cursor: pointer;
        font-size: 2.5em;
      }
    `
];
e0([
  M({
    attribute: "data-status",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => Object.values(er).includes(e) ? e : er.NotStarted,
      toAttribute: (e) => e.toString()
    }
  })
], Mc.prototype, "status", 2);
e0([
  M({
    attribute: "data-max-file-size",
    type: Number,
    reflect: !0
  })
], Mc.prototype, "maxFileSize", 2);
e0([
  M({
    attribute: "data-accept",
    type: String,
    reflect: !0
  })
], Mc.prototype, "accept", 2);
e0([
  M({
    attribute: "data-key",
    type: String,
    reflect: !0
  })
], Mc.prototype, "key", 2);
e0([
  M({
    attribute: "data-preview-url",
    type: String,
    reflect: !0
  })
], Mc.prototype, "previewImageUrl", 2);
Mc = e0([
  P("x-file-upload")
], Mc);
const hAe = ':host{display:inline-block;width:10em;height:7.25em}.flip-card{width:100%;height:100%;perspective:62.5em}.flip-card-inner{position:relative;width:100%;height:100%;text-align:center;transition:transform .6s;transform-style:preserve-3d}:host([data-id-side="BACK"]) .flip-card-front{animation-name:rotateFrontToBack;animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:1}:host([data-id-side="BACK"]) .flip-card-back{animation-name:rotateBackToFront;animation-duration:2s;animation-fill-mode:forwards;animation-iteration-count:1}.flip-card-front,.flip-card-back{position:absolute;width:100%;height:100%;-webkit-backface-visibility:hidden;backface-visibility:hidden}.flip-card-front{transform:rotateY(0)}.flip-card-back{transform:rotateY(180deg)}@keyframes rotateFrontToBack{0%{transform:rotateY(0);opacity:1}25%{transform:rotateY(0);opacity:1}75%{transform:rotateY(180deg);opacity:1}to{transform:rotateY(180deg);opacity:0}}@keyframes rotateBackToFront{0%{transform:rotateY(180deg);opacity:1}25%{transform:rotateY(180deg);opacity:1}75%{transform:rotateY(360deg);opacity:1}to{transform:rotateY(360deg);opacity:0}}';
var pAe = Object.defineProperty, gAe = Object.getOwnPropertyDescriptor, NO = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? gAe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && pAe(t, r, a), a;
};
const fAe = (e) => Object.values(cr).includes(e);
let sy = class extends N {
  constructor() {
    super(...arguments), this.side = cr.Front;
  }
  render() {
    return w`
      <div class="flip-card">
        <div class="flip-card-inner">
          <div class="flip-card-front">
            <svg width="160" height="116" viewBox="0 0 160 116" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2.29102" width="156" height="112" rx="28" fill="black" fill-opacity="0.6" />
              <rect
                x="1"
                y="1.29102"
                width="158"
                height="114"
                rx="29"
                stroke="black"
                stroke-opacity="0.6"
                stroke-width="2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 30.2262C2 14.798 14.6694 2.29102 30.298 2.29102H129.702C145.331 2.29102 158 14.798 158 30.2262V86.3558C158 101.784 145.331 114.291 129.702 114.291H30.298C14.6695 114.291 2 101.784 2 86.3558V30.2262ZM62.2727 44.291C62.2727 52.023 55.9233 58.291 48.0909 58.291C40.2585 58.291 33.9091 52.023 33.9091 44.291C33.9091 36.559 40.2585 30.291 48.0909 30.291C55.9233 30.291 62.2727 36.559 62.2727 44.291ZM48.0909 58.291C37.3422 58.291 27.99 64.1933 23.1786 72.8939C19.4343 79.6647 26.062 86.291 33.8763 86.291H62.3056C70.1198 86.291 76.7475 79.6648 73.0033 72.8939C68.1919 64.1933 58.8396 58.291 48.0909 58.291ZM85.1213 40.0132C85.1213 38.0802 86.7086 36.5132 88.6667 36.5132H137.122C139.08 36.5132 140.667 38.0802 140.667 40.0132C140.667 41.9462 139.08 43.5133 137.122 43.5133H88.6667C86.7086 43.5133 85.1213 41.9462 85.1213 40.0132ZM88.6667 53.6243C86.7086 53.6243 85.1213 55.1913 85.1213 57.1243C85.1213 59.0573 86.7086 60.6243 88.6667 60.6243H137.122C139.08 60.6243 140.667 59.0573 140.667 57.1243C140.667 55.1913 139.08 53.6243 137.122 53.6243H88.6667ZM85.1213 74.2355C85.1213 72.3025 86.7086 70.7355 88.6667 70.7355H137.122C139.08 70.7355 140.667 72.3025 140.667 74.2355C140.667 76.1685 139.08 77.7355 137.122 77.7355H88.6667C86.7086 77.7355 85.1213 76.1685 85.1213 74.2355Z"
                fill="white"
                fill-opacity="0.9"
              />
            </svg>
          </div>
          <div class="flip-card-back">
            <svg width="160" height="116" viewBox="0 0 160 116" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="156" height="112" rx="26" fill="black" fill-opacity="0.6" />
              <rect x="1" y="1" width="158" height="114" rx="27" stroke="black" stroke-opacity="0.6" stroke-width="2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M28 2C13.6406 2 2 13.4914 2 27.6667V88.3333C2 102.509 13.6406 114 28 114H132C146.359 114 158 102.509 158 88.3333V27.6667C158 13.4914 146.359 2 132 2H28ZM27.9995 79C23.213 79 19.3328 82.8305 19.3328 87.5556C19.3328 92.2807 23.213 96.1111 27.9995 96.1111H132C136.786 96.1111 140.667 92.2807 140.667 87.5556C140.667 82.8305 136.786 79 132 79H27.9995ZM22.8788 53.3333C20.9207 53.3333 19.3333 54.9003 19.3333 56.8333C19.3333 58.7663 20.9207 60.3333 22.8788 60.3333H137.121C139.079 60.3333 140.667 58.7663 140.667 56.8333C140.667 54.9003 139.079 53.3333 137.121 53.3333H22.8788ZM19.3333 39.7222C19.3333 37.7892 20.9207 36.2222 22.8788 36.2222H137.121C139.079 36.2222 140.667 37.7892 140.667 39.7222C140.667 41.6552 139.079 43.2222 137.121 43.2222H22.8788C20.9207 43.2222 19.3333 41.6552 19.3333 39.7222Z"
                fill="white"
                fill-opacity="0.9"
              />
            </svg>
          </div>
        </div>
      </div>
    `;
  }
};
sy.styles = [...N.styles, Gt(hAe)];
NO([
  M({
    attribute: "data-id-side",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => fAe(e) ? e : cr.Front,
      toAttribute: (e) => e.toString()
    }
  })
], sy.prototype, "side", 2);
sy = NO([
  P("x-id-side")
], sy);
var Er = /* @__PURE__ */ ((e) => (e.NOT_LOADED = "not-loaded", e.LOADING = "loading", e.ACTIVE = "active", e.MANUAL_CAPTURE_FALLBACK = "manual-capture-fallback", e))(Er || {});
const mAe = () => ({
  state: "not-loaded",
  fallbackReason: void 0,
  docFinder: {
    type: Sx.DocFinder,
    edgeMarginRatio: (1 - 0.9) / 2,
    minFillRatio: 0.7,
    maxFillRatio: 0.9,
    cx: 0.5,
    cy: 0.5,
    radius: 0.1
  }
}), Gc = new Kt(mAe()), ZO = new Kt(void 0), BO = new Kt(void 0), WO = new Kt(void 0), vAe = () => {
  const { state: e } = Gc.getValue();
  return e === "active";
}, SAe = () => Gc.pipe(bt((e) => e.docFinder)), IAe = () => Gc.value.docFinder, EO = () => Gc.asObservable(), tV = (e) => {
  ZO.next(e);
}, CAe = () => ZO.asObservable(), bAe = (e) => {
  WO.next(e);
}, yAe = (e) => {
  BO.next(e);
}, wAe = () => Gc.pipe(te((e) => e.state)), Bo = (e, t) => {
  const r = Gc.getValue();
  Gc.next({
    ...r,
    state: e,
    fallbackReason: t
  });
}, QO = () => Gc.getValue(), FO = (e) => BO.pipe(
  $a(WO),
  te(([t, r]) => r && r.fps >= e ? t : r)
), AAe = ":host{position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none}", UAe = (e) => {
  switch (e.activeScreen) {
    case Ot.CrossDevice:
      return "cross-device";
    case Ot.Workflow:
      return Object.values(T).includes(e.step) ? `${e.credentialId}/${e.substep}` : e.step;
    default:
      return "";
  }
}, kAe = (e, t, r = !0) => !e || !e.length ? e : r ? e.sort((n, a) => {
  var i;
  return (i = n[t]) == null ? void 0 : i.localeCompare(a[t]);
}) : e.sort((n, a) => {
  var i;
  return (i = a[t]) == null ? void 0 : i.localeCompare(n[t]);
}), TO = (e, t) => {
  var o, s, c;
  const r = Le(), n = On(), a = new URL(e), i = (() => {
    switch (r.acquisitionStatus) {
      case Wr.Success:
        return "SUCCESS";
      case Wr.Failed:
      case Wr.Retry:
        return "ERROR";
      default:
        return t;
    }
  })();
  return n.accountId && a.searchParams.append("accountId", n.accountId), (o = r.parsedToken) != null && o.wfeId && (a.searchParams.append("workflowExecutionId", r.parsedToken.wfeId ?? ""), a.searchParams.append("transactionReference", r.parsedToken.wfeId ?? ""), rV(n) && a.searchParams.append("jumioIdScanReference", r.parsedToken.wfeId ?? "")), t && (a.searchParams.append("acquisitionStatus", i), a.searchParams.append("transactionStatus", i), rV(n) && a.searchParams.append("idScanStatus", i)), (s = r.parsedToken) != null && s.cRef && a.searchParams.append("customerInternalReference", ((c = r.parsedToken) == null ? void 0 : c.cRef) ?? ""), t === "ERROR" && a.searchParams.append("errorCode", "9100"), a;
}, RO = (e) => {
  window.location.href = e;
}, DO = (e, t = RO) => {
  e && t(TO(
    e,
    "SUCCESS"
    /* Success */
  ).toString());
}, IZ = (e, t = RO) => {
  e && t(TO(
    e,
    "ERROR"
    /* Error */
  ).toString());
}, JO = (e, t) => {
  const r = e.replace("-", "_"), n = e.split(/[_\-]/)[0];
  return t[r] ?? t[n] ?? t.en;
}, rV = (e) => e.credentials.some((t) => t.category === T.Document), _Ae = "capturerequest";
class VO extends CustomEvent {
  constructor(t) {
    super(_Ae, {
      detail: t,
      bubbles: !0,
      cancelable: !0,
      composed: !0
    });
  }
}
const NAe = () => new Ht((e) => {
  let t = {
    fullscreen: !1,
    standalone: !1,
    minimalUI: !1,
    browser: !1,
    windowControlsOverlay: !1
  };
  const r = ["fullscreen", "standalone", "minimal-ui", "browser", "window-controls-overlay"], n = ["fullscreen", "standalone", "minimalUI", "browser", "windowControlsOverlay"], a = r.map((i, o) => {
    const s = n[o], c = window.matchMedia(`(display-mode: ${i})`), l = () => {
      t = {
        ...t,
        [s]: c.matches
      }, e.next(t);
    };
    return c.addEventListener("change", l), l(), () => {
      c.removeEventListener("change", l);
    };
  });
  return () => {
    a.forEach((i) => {
      i();
    });
  };
}), OS = {
  "image/jpeg": xr.Jpeg,
  "image/jpg": xr.Jpg,
  "image/webp": xr.WebP,
  "image/png": xr.Png,
  "application/pdf": xr.Pdf
}, ZAe = () => navigator.userAgent, BAe = () => {
  Ok.interpolate = /{{([\s\S]+?)}}/g;
}, WAe = () => `${y("Sorry, there was an unexpected error.", {
  id: "identity.preview.3dliveness.serverError.description"
})}
  ${y("Upload a CNH Digital PDF", {
  id: '"jumio_brazil_cnh_upload_button"'
})}`, EAe = (e) => Rc(
  y(
    `Sorry, there was a problem uploading your images.
             Please try again with images that are smaller than {{uploadFileSizeMax}}MB in size.`,
    {
      id: "error.maxfilesize02.description"
    }
  )
)({ uploadFileSizeMax: XW(e) }), QAe = () => y(
  "Upload a color image of the entire document. Screenshots are not allowed. JPG, JPEG, or PNG format only.",
  {
    id: "upload.file.id.hint.nonDV"
  }
);
var FAe = MO;
function MO(e, t, r) {
  e instanceof RegExp && (e = nV(e, r)), t instanceof RegExp && (t = nV(t, r));
  var n = GO(e, t, r);
  return n && {
    start: n[0],
    end: n[1],
    pre: r.slice(0, n[0]),
    body: r.slice(n[0] + e.length, n[1]),
    post: r.slice(n[1] + t.length)
  };
}
function nV(e, t) {
  var r = t.match(e);
  return r ? r[0] : null;
}
MO.range = GO;
function GO(e, t, r) {
  var n, a, i, o, s, c = r.indexOf(e), l = r.indexOf(t, c + 1), u = c;
  if (c >= 0 && l > 0) {
    if (e === t)
      return [c, l];
    for (n = [], i = r.length; u >= 0 && !s; )
      u == c ? (n.push(u), c = r.indexOf(e, u + 1)) : n.length == 1 ? s = [n.pop(), l] : (a = n.pop(), a < i && (i = a, o = l), l = r.indexOf(t, u + 1)), u = c < l && c >= 0 ? c : l;
    n.length && (s = [i, o]);
  }
  return s;
}
var xO = FAe, TAe = JAe, HO = "\0SLASH" + Math.random() + "\0", LO = "\0OPEN" + Math.random() + "\0", GQ = "\0CLOSE" + Math.random() + "\0", YO = "\0COMMA" + Math.random() + "\0", OO = "\0PERIOD" + Math.random() + "\0";
function $U(e) {
  return parseInt(e, 10) == e ? parseInt(e, 10) : e.charCodeAt(0);
}
function RAe(e) {
  return e.split("\\\\").join(HO).split("\\{").join(LO).split("\\}").join(GQ).split("\\,").join(YO).split("\\.").join(OO);
}
function DAe(e) {
  return e.split(HO).join("\\").split(LO).join("{").split(GQ).join("}").split(YO).join(",").split(OO).join(".");
}
function jO(e) {
  if (!e)
    return [""];
  var t = [], r = xO("{", "}", e);
  if (!r)
    return e.split(",");
  var n = r.pre, a = r.body, i = r.post, o = n.split(",");
  o[o.length - 1] += "{" + a + "}";
  var s = jO(i);
  return i.length && (o[o.length - 1] += s.shift(), o.push.apply(o, s)), t.push.apply(t, o), t;
}
function JAe(e) {
  return e ? (e.substr(0, 2) === "{}" && (e = "\\{\\}" + e.substr(2)), gf(RAe(e), !0).map(DAe)) : [];
}
function VAe(e) {
  return "{" + e + "}";
}
function MAe(e) {
  return /^-?0\d/.test(e);
}
function GAe(e, t) {
  return e <= t;
}
function xAe(e, t) {
  return e >= t;
}
function gf(e, t) {
  var r = [], n = xO("{", "}", e);
  if (!n) return [e];
  var a = n.pre, i = n.post.length ? gf(n.post, !1) : [""];
  if (/\$$/.test(n.pre))
    for (var o = 0; o < i.length; o++) {
      var s = a + "{" + n.body + "}" + i[o];
      r.push(s);
    }
  else {
    var c = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(n.body), l = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(n.body), u = c || l, g = n.body.indexOf(",") >= 0;
    if (!u && !g)
      return n.post.match(/,.*\}/) ? (e = n.pre + "{" + n.body + GQ + n.post, gf(e)) : [e];
    var p;
    if (u)
      p = n.body.split(/\.\./);
    else if (p = jO(n.body), p.length === 1 && (p = gf(p[0], !1).map(VAe), p.length === 1))
      return i.map(function(K) {
        return n.pre + p[0] + K;
      });
    var m;
    if (u) {
      var I = $U(p[0]), C = $U(p[1]), A = Math.max(p[0].length, p[1].length), U = p.length == 3 ? Math.abs($U(p[2])) : 1, B = GAe, J = C < I;
      J && (U *= -1, B = xAe);
      var W = p.some(MAe);
      m = [];
      for (var L = I; B(L, C); L += U) {
        var H;
        if (l)
          H = String.fromCharCode(L), H === "\\" && (H = "");
        else if (H = String(L), W) {
          var R = A - H.length;
          if (R > 0) {
            var ge = new Array(R + 1).join("0");
            L < 0 ? H = "-" + ge + H.slice(1) : H = ge + H;
          }
        }
        m.push(H);
      }
    } else {
      m = [];
      for (var z = 0; z < p.length; z++)
        m.push.apply(m, gf(p[z], !1));
    }
    for (var z = 0; z < m.length; z++)
      for (var o = 0; o < i.length; o++) {
        var s = a + m[z] + i[o];
        (!t || u || s) && r.push(s);
      }
  }
  return r;
}
const HAe = /* @__PURE__ */ $W(TAe), LAe = 1024 * 64, ly = (e) => {
  if (typeof e != "string")
    throw new TypeError("invalid pattern");
  if (e.length > LAe)
    throw new TypeError("pattern is too long");
}, YAe = {
  "[:alnum:]": ["\\p{L}\\p{Nl}\\p{Nd}", !0],
  "[:alpha:]": ["\\p{L}\\p{Nl}", !0],
  "[:ascii:]": ["\\x00-\\x7f", !1],
  "[:blank:]": ["\\p{Zs}\\t", !0],
  "[:cntrl:]": ["\\p{Cc}", !0],
  "[:digit:]": ["\\p{Nd}", !0],
  "[:graph:]": ["\\p{Z}\\p{C}", !0, !0],
  "[:lower:]": ["\\p{Ll}", !0],
  "[:print:]": ["\\p{C}", !0],
  "[:punct:]": ["\\p{P}", !0],
  "[:space:]": ["\\p{Z}\\t\\r\\n\\v\\f", !0],
  "[:upper:]": ["\\p{Lu}", !0],
  "[:word:]": ["\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}", !0],
  "[:xdigit:]": ["A-Fa-f0-9", !1]
}, H0 = (e) => e.replace(/[[\]\\-]/g, "\\$&"), OAe = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), aV = (e) => e.join(""), jAe = (e, t) => {
  const r = t;
  if (e.charAt(r) !== "[")
    throw new Error("not in a brace expression");
  const n = [], a = [];
  let i = r + 1, o = !1, s = !1, c = !1, l = !1, u = r, g = "";
  e: for (; i < e.length; ) {
    const C = e.charAt(i);
    if ((C === "!" || C === "^") && i === r + 1) {
      l = !0, i++;
      continue;
    }
    if (C === "]" && o && !c) {
      u = i + 1;
      break;
    }
    if (o = !0, C === "\\" && !c) {
      c = !0, i++;
      continue;
    }
    if (C === "[" && !c) {
      for (const [A, [U, B, J]] of Object.entries(YAe))
        if (e.startsWith(A, i)) {
          if (g)
            return ["$.", !1, e.length - r, !0];
          i += A.length, J ? a.push(U) : n.push(U), s = s || B;
          continue e;
        }
    }
    if (c = !1, g) {
      C > g ? n.push(H0(g) + "-" + H0(C)) : C === g && n.push(H0(C)), g = "", i++;
      continue;
    }
    if (e.startsWith("-]", i + 1)) {
      n.push(H0(C + "-")), i += 2;
      continue;
    }
    if (e.startsWith("-", i + 1)) {
      g = C, i += 2;
      continue;
    }
    n.push(H0(C)), i++;
  }
  if (u < i)
    return ["", !1, 0, !1];
  if (!n.length && !a.length)
    return ["$.", !1, e.length - r, !0];
  if (a.length === 0 && n.length === 1 && /^\\?.$/.test(n[0]) && !l) {
    const C = n[0].length === 2 ? n[0].slice(-1) : n[0];
    return [OAe(C), !1, u - r, !1];
  }
  const p = "[" + (l ? "^" : "") + aV(n) + "]", m = "[" + (l ? "" : "^") + aV(a) + "]";
  return [n.length && a.length ? "(" + p + "|" + m + ")" : n.length ? p : m, s, u - r, !0];
}, ff = (e, { windowsPathsNoEscape: t = !1 } = {}) => t ? e.replace(/\[([^\/\\])\]/g, "$1") : e.replace(/((?!\\).|^)\[([^\/\\])\]/g, "$1$2").replace(/\\([^\/])/g, "$1"), PAe = /* @__PURE__ */ new Set(["!", "?", "+", "*", "@"]), iV = (e) => PAe.has(e), $Ae = "(?!(?:^|/)\\.\\.?(?:$|/))", zI = "(?!\\.)", KAe = /* @__PURE__ */ new Set(["[", "."]), XAe = /* @__PURE__ */ new Set(["..", "."]), zAe = new Set("().*{}+?[]^$\\!"), qAe = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), xQ = "[^/]", oV = xQ + "*?", sV = xQ + "+?";
var Mr, Pr, $s, ar, Br, ic, su, oc, To, lu, Wv, Xu, PO, Fc, ab, CZ, $O;
const Vn = class Vn {
  constructor(t, r, n = {}) {
    E(this, Xu);
    Dr(this, "type");
    E(this, Mr);
    E(this, Pr);
    E(this, $s, !1);
    E(this, ar, []);
    E(this, Br);
    E(this, ic);
    E(this, su);
    E(this, oc, !1);
    E(this, To);
    E(this, lu);
    // set to true if it's an extglob with no children
    // (which really means one child of '')
    E(this, Wv, !1);
    this.type = t, t && G(this, Pr, !0), G(this, Br, r), G(this, Mr, S(this, Br) ? S(S(this, Br), Mr) : this), G(this, To, S(this, Mr) === this ? n : S(S(this, Mr), To)), G(this, su, S(this, Mr) === this ? [] : S(S(this, Mr), su)), t === "!" && !S(S(this, Mr), oc) && S(this, su).push(this), G(this, ic, S(this, Br) ? S(S(this, Br), ar).length : 0);
  }
  get hasMagic() {
    if (S(this, Pr) !== void 0)
      return S(this, Pr);
    for (const t of S(this, ar))
      if (typeof t != "string" && (t.type || t.hasMagic))
        return G(this, Pr, !0);
    return S(this, Pr);
  }
  // reconstructs the pattern
  toString() {
    return S(this, lu) !== void 0 ? S(this, lu) : this.type ? G(this, lu, this.type + "(" + S(this, ar).map((t) => String(t)).join("|") + ")") : G(this, lu, S(this, ar).map((t) => String(t)).join(""));
  }
  push(...t) {
    for (const r of t)
      if (r !== "") {
        if (typeof r != "string" && !(r instanceof Vn && S(r, Br) === this))
          throw new Error("invalid part: " + r);
        S(this, ar).push(r);
      }
  }
  toJSON() {
    var r;
    const t = this.type === null ? S(this, ar).slice().map((n) => typeof n == "string" ? n : n.toJSON()) : [this.type, ...S(this, ar).map((n) => n.toJSON())];
    return this.isStart() && !this.type && t.unshift([]), this.isEnd() && (this === S(this, Mr) || S(S(this, Mr), oc) && ((r = S(this, Br)) == null ? void 0 : r.type) === "!") && t.push({}), t;
  }
  isStart() {
    var r;
    if (S(this, Mr) === this)
      return !0;
    if (!((r = S(this, Br)) != null && r.isStart()))
      return !1;
    if (S(this, ic) === 0)
      return !0;
    const t = S(this, Br);
    for (let n = 0; n < S(this, ic); n++) {
      const a = S(t, ar)[n];
      if (!(a instanceof Vn && a.type === "!"))
        return !1;
    }
    return !0;
  }
  isEnd() {
    var r, n, a;
    if (S(this, Mr) === this || ((r = S(this, Br)) == null ? void 0 : r.type) === "!")
      return !0;
    if (!((n = S(this, Br)) != null && n.isEnd()))
      return !1;
    if (!this.type)
      return (a = S(this, Br)) == null ? void 0 : a.isEnd();
    const t = S(this, Br) ? S(S(this, Br), ar).length : 0;
    return S(this, ic) === t - 1;
  }
  copyIn(t) {
    typeof t == "string" ? this.push(t) : this.push(t.clone(this));
  }
  clone(t) {
    const r = new Vn(this.type, t);
    for (const n of S(this, ar))
      r.copyIn(n);
    return r;
  }
  static fromGlob(t, r = {}) {
    var a;
    const n = new Vn(null, void 0, r);
    return O(a = Vn, Fc, ab).call(a, t, n, 0, r), n;
  }
  // returns the regular expression if there's magic, or the unescaped
  // string if not.
  toMMPattern() {
    if (this !== S(this, Mr))
      return S(this, Mr).toMMPattern();
    const t = this.toString(), [r, n, a, i] = this.toRegExpSource();
    if (!(a || S(this, Pr) || S(this, To).nocase && !S(this, To).nocaseMagicOnly && t.toUpperCase() !== t.toLowerCase()))
      return n;
    const s = (S(this, To).nocase ? "i" : "") + (i ? "u" : "");
    return Object.assign(new RegExp(`^${r}$`, s), {
      _src: r,
      _glob: t
    });
  }
  get options() {
    return S(this, To);
  }
  // returns the string match, the regexp source, whether there's magic
  // in the regexp (so a regular expression is required) and whether or
  // not the uflag is needed for the regular expression (for posix classes)
  // TODO: instead of injecting the start/end at this point, just return
  // the BODY of the regexp, along with the start/end portions suitable
  // for binding the start/end in either a joined full-path makeRe context
  // (where we bind to (^|/), or a standalone matchPart context (where
  // we bind to ^, and not /).  Otherwise slashes get duped!
  //
  // In part-matching mode, the start is:
  // - if not isStart: nothing
  // - if traversal possible, but not allowed: ^(?!\.\.?$)
  // - if dots allowed or not possible: ^
  // - if dots possible and not allowed: ^(?!\.)
  // end is:
  // - if not isEnd(): nothing
  // - else: $
  //
  // In full-path matching mode, we put the slash at the START of the
  // pattern, so start is:
  // - if first pattern: same as part-matching mode
  // - if not isStart(): nothing
  // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
  // - if dots allowed or not possible: /
  // - if dots possible and not allowed: /(?!\.)
  // end is:
  // - if last pattern, same as part-matching mode
  // - else nothing
  //
  // Always put the (?:$|/) on negated tails, though, because that has to be
  // there to bind the end of the negated pattern portion, and it's easier to
  // just stick it in now rather than try to inject it later in the middle of
  // the pattern.
  //
  // We can just always return the same end, and leave it up to the caller
  // to know whether it's going to be used joined or in parts.
  // And, if the start is adjusted slightly, can do the same there:
  // - if not isStart: nothing
  // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
  // - if dots allowed or not possible: (?:/|^)
  // - if dots possible and not allowed: (?:/|^)(?!\.)
  //
  // But it's better to have a simpler binding without a conditional, for
  // performance, so probably better to return both start options.
  //
  // Then the caller just ignores the end if it's not the first pattern,
  // and the start always gets applied.
  //
  // But that's always going to be $ if it's the ending pattern, or nothing,
  // so the caller can just attach $ at the end of the pattern when building.
  //
  // So the todo is:
  // - better detect what kind of start is needed
  // - return both flavors of starting pattern
  // - attach $ at the end of the pattern when creating the actual RegExp
  //
  // Ah, but wait, no, that all only applies to the root when the first pattern
  // is not an extglob. If the first pattern IS an extglob, then we need all
  // that dot prevention biz to live in the extglob portions, because eg
  // +(*|.x*) can match .xy but not .yx.
  //
  // So, return the two flavors if it's #root and the first child is not an
  // AST, otherwise leave it to the child AST to handle it, and there,
  // use the (?:^|/) style of start binding.
  //
  // Even simplified further:
  // - Since the start for a join is eg /(?!\.) and the start for a part
  // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
  // or start or whatever) and prepend ^ or / at the Regexp construction.
  toRegExpSource(t) {
    var c;
    const r = t ?? !!S(this, To).dot;
    if (S(this, Mr) === this && O(this, Xu, PO).call(this), !this.type) {
      const l = this.isStart() && this.isEnd(), u = S(this, ar).map((I) => {
        var J;
        const [C, A, U, B] = typeof I == "string" ? O(J = Vn, Fc, $O).call(J, I, S(this, Pr), l) : I.toRegExpSource(t);
        return G(this, Pr, S(this, Pr) || U), G(this, $s, S(this, $s) || B), C;
      }).join("");
      let g = "";
      if (this.isStart() && typeof S(this, ar)[0] == "string" && !(S(this, ar).length === 1 && XAe.has(S(this, ar)[0]))) {
        const C = KAe, A = (
          // dots are allowed, and the pattern starts with [ or .
          r && C.has(u.charAt(0)) || // the pattern starts with \., and then [ or .
          u.startsWith("\\.") && C.has(u.charAt(2)) || // the pattern starts with \.\., and then [ or .
          u.startsWith("\\.\\.") && C.has(u.charAt(4))
        ), U = !r && !t && C.has(u.charAt(0));
        g = A ? $Ae : U ? zI : "";
      }
      let p = "";
      return this.isEnd() && S(S(this, Mr), oc) && ((c = S(this, Br)) == null ? void 0 : c.type) === "!" && (p = "(?:$|\\/)"), [
        g + u + p,
        ff(u),
        G(this, Pr, !!S(this, Pr)),
        S(this, $s)
      ];
    }
    const n = this.type === "*" || this.type === "+", a = this.type === "!" ? "(?:(?!(?:" : "(?:";
    let i = O(this, Xu, CZ).call(this, r);
    if (this.isStart() && this.isEnd() && !i && this.type !== "!") {
      const l = this.toString();
      return G(this, ar, [l]), this.type = null, G(this, Pr, void 0), [l, ff(this.toString()), !1, !1];
    }
    let o = !n || t || r || !zI ? "" : O(this, Xu, CZ).call(this, !0);
    o === i && (o = ""), o && (i = `(?:${i})(?:${o})*?`);
    let s = "";
    if (this.type === "!" && S(this, Wv))
      s = (this.isStart() && !r ? zI : "") + sV;
    else {
      const l = this.type === "!" ? (
        // !() must match something,but !(x) can match ''
        "))" + (this.isStart() && !r && !t ? zI : "") + oV + ")"
      ) : this.type === "@" ? ")" : this.type === "?" ? ")?" : this.type === "+" && o ? ")" : this.type === "*" && o ? ")?" : `)${this.type}`;
      s = a + i + l;
    }
    return [
      s,
      ff(i),
      G(this, Pr, !!S(this, Pr)),
      S(this, $s)
    ];
  }
};
Mr = new WeakMap(), Pr = new WeakMap(), $s = new WeakMap(), ar = new WeakMap(), Br = new WeakMap(), ic = new WeakMap(), su = new WeakMap(), oc = new WeakMap(), To = new WeakMap(), lu = new WeakMap(), Wv = new WeakMap(), Xu = new WeakSet(), PO = function() {
  if (this !== S(this, Mr))
    throw new Error("should only call on root");
  if (S(this, oc))
    return this;
  this.toString(), G(this, oc, !0);
  let t;
  for (; t = S(this, su).pop(); ) {
    if (t.type !== "!")
      continue;
    let r = t, n = S(r, Br);
    for (; n; ) {
      for (let a = S(r, ic) + 1; !n.type && a < S(n, ar).length; a++)
        for (const i of S(t, ar)) {
          if (typeof i == "string")
            throw new Error("string part in extglob AST??");
          i.copyIn(S(n, ar)[a]);
        }
      r = n, n = S(r, Br);
    }
  }
  return this;
}, Fc = new WeakSet(), ab = function(t, r, n, a) {
  var m, I;
  let i = !1, o = !1, s = -1, c = !1;
  if (r.type === null) {
    let C = n, A = "";
    for (; C < t.length; ) {
      const U = t.charAt(C++);
      if (i || U === "\\") {
        i = !i, A += U;
        continue;
      }
      if (o) {
        C === s + 1 ? (U === "^" || U === "!") && (c = !0) : U === "]" && !(C === s + 2 && c) && (o = !1), A += U;
        continue;
      } else if (U === "[") {
        o = !0, s = C, c = !1, A += U;
        continue;
      }
      if (!a.noext && iV(U) && t.charAt(C) === "(") {
        r.push(A), A = "";
        const B = new Vn(U, r);
        C = O(m = Vn, Fc, ab).call(m, t, B, C, a), r.push(B);
        continue;
      }
      A += U;
    }
    return r.push(A), C;
  }
  let l = n + 1, u = new Vn(null, r);
  const g = [];
  let p = "";
  for (; l < t.length; ) {
    const C = t.charAt(l++);
    if (i || C === "\\") {
      i = !i, p += C;
      continue;
    }
    if (o) {
      l === s + 1 ? (C === "^" || C === "!") && (c = !0) : C === "]" && !(l === s + 2 && c) && (o = !1), p += C;
      continue;
    } else if (C === "[") {
      o = !0, s = l, c = !1, p += C;
      continue;
    }
    if (iV(C) && t.charAt(l) === "(") {
      u.push(p), p = "";
      const A = new Vn(C, u);
      u.push(A), l = O(I = Vn, Fc, ab).call(I, t, A, l, a);
      continue;
    }
    if (C === "|") {
      u.push(p), p = "", g.push(u), u = new Vn(null, r);
      continue;
    }
    if (C === ")")
      return p === "" && S(r, ar).length === 0 && G(r, Wv, !0), u.push(p), p = "", r.push(...g, u), l;
    p += C;
  }
  return r.type = null, G(r, Pr, void 0), G(r, ar, [t.substring(n - 1)]), l;
}, CZ = function(t) {
  return S(this, ar).map((r) => {
    if (typeof r == "string")
      throw new Error("string type in extglob ast??");
    const [n, a, i, o] = r.toRegExpSource(t);
    return G(this, $s, S(this, $s) || o), n;
  }).filter((r) => !(this.isStart() && this.isEnd()) || !!r).join("|");
}, $O = function(t, r, n = !1) {
  let a = !1, i = "", o = !1;
  for (let s = 0; s < t.length; s++) {
    const c = t.charAt(s);
    if (a) {
      a = !1, i += (zAe.has(c) ? "\\" : "") + c;
      continue;
    }
    if (c === "\\") {
      s === t.length - 1 ? i += "\\\\" : a = !0;
      continue;
    }
    if (c === "[") {
      const [l, u, g, p] = jAe(t, s);
      if (g) {
        i += l, o = o || u, s += g - 1, r = r || p;
        continue;
      }
    }
    if (c === "*") {
      n && t === "*" ? i += sV : i += oV, r = !0;
      continue;
    }
    if (c === "?") {
      i += xQ, r = !0;
      continue;
    }
    i += qAe(c);
  }
  return [i, ff(t), !!r, o];
}, E(Vn, Fc);
let cy = Vn;
const eUe = (e, { windowsPathsNoEscape: t = !1 } = {}) => t ? e.replace(/[?*()[\]]/g, "[$&]") : e.replace(/[?*()[\]\\]/g, "\\$&"), En = (e, t, r = {}) => (ly(t), !r.nocomment && t.charAt(0) === "#" ? !1 : new Ew(t, r).match(e)), tUe = /^\*+([^+@!?\*\[\(]*)$/, rUe = (e) => (t) => !t.startsWith(".") && t.endsWith(e), nUe = (e) => (t) => t.endsWith(e), aUe = (e) => (e = e.toLowerCase(), (t) => !t.startsWith(".") && t.toLowerCase().endsWith(e)), iUe = (e) => (e = e.toLowerCase(), (t) => t.toLowerCase().endsWith(e)), oUe = /^\*+\.\*+$/, sUe = (e) => !e.startsWith(".") && e.includes("."), lUe = (e) => e !== "." && e !== ".." && e.includes("."), cUe = /^\.\*+$/, dUe = (e) => e !== "." && e !== ".." && e.startsWith("."), uUe = /^\*+$/, hUe = (e) => e.length !== 0 && !e.startsWith("."), pUe = (e) => e.length !== 0 && e !== "." && e !== "..", gUe = /^\?+([^+@!?\*\[\(]*)?$/, fUe = ([e, t = ""]) => {
  const r = KO([e]);
  return t ? (t = t.toLowerCase(), (n) => r(n) && n.toLowerCase().endsWith(t)) : r;
}, mUe = ([e, t = ""]) => {
  const r = XO([e]);
  return t ? (t = t.toLowerCase(), (n) => r(n) && n.toLowerCase().endsWith(t)) : r;
}, vUe = ([e, t = ""]) => {
  const r = XO([e]);
  return t ? (n) => r(n) && n.endsWith(t) : r;
}, SUe = ([e, t = ""]) => {
  const r = KO([e]);
  return t ? (n) => r(n) && n.endsWith(t) : r;
}, KO = ([e]) => {
  const t = e.length;
  return (r) => r.length === t && !r.startsWith(".");
}, XO = ([e]) => {
  const t = e.length;
  return (r) => r.length === t && r !== "." && r !== "..";
}, zO = typeof process == "object" && process ? typeof process.env == "object" && process.env && process.env.__MINIMATCH_TESTING_PLATFORM__ || process.platform : "posix", lV = {
  win32: { sep: "\\" },
  posix: { sep: "/" }
}, IUe = zO === "win32" ? lV.win32.sep : lV.posix.sep;
En.sep = IUe;
const fi = Symbol("globstar **");
En.GLOBSTAR = fi;
const CUe = "[^/]", bUe = CUe + "*?", yUe = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?", wUe = "(?:(?!(?:\\/|^)\\.).)*?", AUe = (e, t = {}) => (r) => En(r, e, t);
En.filter = AUe;
const di = (e, t = {}) => Object.assign({}, e, t), UUe = (e) => {
  if (!e || typeof e != "object" || !Object.keys(e).length)
    return En;
  const t = En;
  return Object.assign((n, a, i = {}) => t(n, a, di(e, i)), {
    Minimatch: class extends t.Minimatch {
      constructor(a, i = {}) {
        super(a, di(e, i));
      }
      static defaults(a) {
        return t.defaults(di(e, a)).Minimatch;
      }
    },
    AST: class extends t.AST {
      /* c8 ignore start */
      constructor(a, i, o = {}) {
        super(a, i, di(e, o));
      }
      /* c8 ignore stop */
      static fromGlob(a, i = {}) {
        return t.AST.fromGlob(a, di(e, i));
      }
    },
    unescape: (n, a = {}) => t.unescape(n, di(e, a)),
    escape: (n, a = {}) => t.escape(n, di(e, a)),
    filter: (n, a = {}) => t.filter(n, di(e, a)),
    defaults: (n) => t.defaults(di(e, n)),
    makeRe: (n, a = {}) => t.makeRe(n, di(e, a)),
    braceExpand: (n, a = {}) => t.braceExpand(n, di(e, a)),
    match: (n, a, i = {}) => t.match(n, a, di(e, i)),
    sep: t.sep,
    GLOBSTAR: fi
  });
};
En.defaults = UUe;
const qO = (e, t = {}) => (ly(e), t.nobrace || !/\{(?:(?!\{).)*\}/.test(e) ? [e] : HAe(e));
En.braceExpand = qO;
const kUe = (e, t = {}) => new Ew(e, t).makeRe();
En.makeRe = kUe;
const _Ue = (e, t, r = {}) => {
  const n = new Ew(t, r);
  return e = e.filter((a) => n.match(a)), n.options.nonull && !e.length && e.push(t), e;
};
En.match = _Ue;
const cV = /[?*]|[+@!]\(.*?\)|\[|\]/, NUe = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
class Ew {
  constructor(t, r = {}) {
    Dr(this, "options");
    Dr(this, "set");
    Dr(this, "pattern");
    Dr(this, "windowsPathsNoEscape");
    Dr(this, "nonegate");
    Dr(this, "negate");
    Dr(this, "comment");
    Dr(this, "empty");
    Dr(this, "preserveMultipleSlashes");
    Dr(this, "partial");
    Dr(this, "globSet");
    Dr(this, "globParts");
    Dr(this, "nocase");
    Dr(this, "isWindows");
    Dr(this, "platform");
    Dr(this, "windowsNoMagicRoot");
    Dr(this, "regexp");
    ly(t), r = r || {}, this.options = r, this.pattern = t, this.platform = r.platform || zO, this.isWindows = this.platform === "win32", this.windowsPathsNoEscape = !!r.windowsPathsNoEscape || r.allowWindowsEscape === !1, this.windowsPathsNoEscape && (this.pattern = this.pattern.replace(/\\/g, "/")), this.preserveMultipleSlashes = !!r.preserveMultipleSlashes, this.regexp = null, this.negate = !1, this.nonegate = !!r.nonegate, this.comment = !1, this.empty = !1, this.partial = !!r.partial, this.nocase = !!this.options.nocase, this.windowsNoMagicRoot = r.windowsNoMagicRoot !== void 0 ? r.windowsNoMagicRoot : !!(this.isWindows && this.nocase), this.globSet = [], this.globParts = [], this.set = [], this.make();
  }
  hasMagic() {
    if (this.options.magicalBraces && this.set.length > 1)
      return !0;
    for (const t of this.set)
      for (const r of t)
        if (typeof r != "string")
          return !0;
    return !1;
  }
  debug(...t) {
  }
  make() {
    const t = this.pattern, r = this.options;
    if (!r.nocomment && t.charAt(0) === "#") {
      this.comment = !0;
      return;
    }
    if (!t) {
      this.empty = !0;
      return;
    }
    this.parseNegate(), this.globSet = [...new Set(this.braceExpand())], r.debug && (this.debug = (...i) => console.error(...i)), this.debug(this.pattern, this.globSet);
    const n = this.globSet.map((i) => this.slashSplit(i));
    this.globParts = this.preprocess(n), this.debug(this.pattern, this.globParts);
    let a = this.globParts.map((i, o, s) => {
      if (this.isWindows && this.windowsNoMagicRoot) {
        const c = i[0] === "" && i[1] === "" && (i[2] === "?" || !cV.test(i[2])) && !cV.test(i[3]), l = /^[a-z]:/i.test(i[0]);
        if (c)
          return [...i.slice(0, 4), ...i.slice(4).map((u) => this.parse(u))];
        if (l)
          return [i[0], ...i.slice(1).map((u) => this.parse(u))];
      }
      return i.map((c) => this.parse(c));
    });
    if (this.debug(this.pattern, a), this.set = a.filter((i) => i.indexOf(!1) === -1), this.isWindows)
      for (let i = 0; i < this.set.length; i++) {
        const o = this.set[i];
        o[0] === "" && o[1] === "" && this.globParts[i][2] === "?" && typeof o[3] == "string" && /^[a-z]:$/i.test(o[3]) && (o[2] = "?");
      }
    this.debug(this.pattern, this.set);
  }
  // various transforms to equivalent pattern sets that are
  // faster to process in a filesystem walk.  The goal is to
  // eliminate what we can, and push all ** patterns as far
  // to the right as possible, even if it increases the number
  // of patterns that we have to process.
  preprocess(t) {
    if (this.options.noglobstar)
      for (let n = 0; n < t.length; n++)
        for (let a = 0; a < t[n].length; a++)
          t[n][a] === "**" && (t[n][a] = "*");
    const { optimizationLevel: r = 1 } = this.options;
    return r >= 2 ? (t = this.firstPhasePreProcess(t), t = this.secondPhasePreProcess(t)) : r >= 1 ? t = this.levelOneOptimize(t) : t = this.adjascentGlobstarOptimize(t), t;
  }
  // just get rid of adjascent ** portions
  adjascentGlobstarOptimize(t) {
    return t.map((r) => {
      let n = -1;
      for (; (n = r.indexOf("**", n + 1)) !== -1; ) {
        let a = n;
        for (; r[a + 1] === "**"; )
          a++;
        a !== n && r.splice(n, a - n);
      }
      return r;
    });
  }
  // get rid of adjascent ** and resolve .. portions
  levelOneOptimize(t) {
    return t.map((r) => (r = r.reduce((n, a) => {
      const i = n[n.length - 1];
      return a === "**" && i === "**" ? n : a === ".." && i && i !== ".." && i !== "." && i !== "**" ? (n.pop(), n) : (n.push(a), n);
    }, []), r.length === 0 ? [""] : r));
  }
  levelTwoFileOptimize(t) {
    Array.isArray(t) || (t = this.slashSplit(t));
    let r = !1;
    do {
      if (r = !1, !this.preserveMultipleSlashes) {
        for (let a = 1; a < t.length - 1; a++) {
          const i = t[a];
          a === 1 && i === "" && t[0] === "" || (i === "." || i === "") && (r = !0, t.splice(a, 1), a--);
        }
        t[0] === "." && t.length === 2 && (t[1] === "." || t[1] === "") && (r = !0, t.pop());
      }
      let n = 0;
      for (; (n = t.indexOf("..", n + 1)) !== -1; ) {
        const a = t[n - 1];
        a && a !== "." && a !== ".." && a !== "**" && (r = !0, t.splice(n - 1, 2), n -= 2);
      }
    } while (r);
    return t.length === 0 ? [""] : t;
  }
  // First phase: single-pattern processing
  // <pre> is 1 or more portions
  // <rest> is 1 or more portions
  // <p> is any portion other than ., .., '', or **
  // <e> is . or ''
  //
  // **/.. is *brutal* for filesystem walking performance, because
  // it effectively resets the recursive walk each time it occurs,
  // and ** cannot be reduced out by a .. pattern part like a regexp
  // or most strings (other than .., ., and '') can be.
  //
  // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
  // <pre>/<e>/<rest> -> <pre>/<rest>
  // <pre>/<p>/../<rest> -> <pre>/<rest>
  // **/**/<rest> -> **/<rest>
  //
  // **/*/<rest> -> */**/<rest> <== not valid because ** doesn't follow
  // this WOULD be allowed if ** did follow symlinks, or * didn't
  firstPhasePreProcess(t) {
    let r = !1;
    do {
      r = !1;
      for (let n of t) {
        let a = -1;
        for (; (a = n.indexOf("**", a + 1)) !== -1; ) {
          let o = a;
          for (; n[o + 1] === "**"; )
            o++;
          o > a && n.splice(a + 1, o - a);
          let s = n[a + 1];
          const c = n[a + 2], l = n[a + 3];
          if (s !== ".." || !c || c === "." || c === ".." || !l || l === "." || l === "..")
            continue;
          r = !0, n.splice(a, 1);
          const u = n.slice(0);
          u[a] = "**", t.push(u), a--;
        }
        if (!this.preserveMultipleSlashes) {
          for (let o = 1; o < n.length - 1; o++) {
            const s = n[o];
            o === 1 && s === "" && n[0] === "" || (s === "." || s === "") && (r = !0, n.splice(o, 1), o--);
          }
          n[0] === "." && n.length === 2 && (n[1] === "." || n[1] === "") && (r = !0, n.pop());
        }
        let i = 0;
        for (; (i = n.indexOf("..", i + 1)) !== -1; ) {
          const o = n[i - 1];
          if (o && o !== "." && o !== ".." && o !== "**") {
            r = !0;
            const c = i === 1 && n[i + 1] === "**" ? ["."] : [];
            n.splice(i - 1, 2, ...c), n.length === 0 && n.push(""), i -= 2;
          }
        }
      }
    } while (r);
    return t;
  }
  // second phase: multi-pattern dedupes
  // {<pre>/*/<rest>,<pre>/<p>/<rest>} -> <pre>/*/<rest>
  // {<pre>/<rest>,<pre>/<rest>} -> <pre>/<rest>
  // {<pre>/**/<rest>,<pre>/<rest>} -> <pre>/**/<rest>
  //
  // {<pre>/**/<rest>,<pre>/**/<p>/<rest>} -> <pre>/**/<rest>
  // ^-- not valid because ** doens't follow symlinks
  secondPhasePreProcess(t) {
    for (let r = 0; r < t.length - 1; r++)
      for (let n = r + 1; n < t.length; n++) {
        const a = this.partsMatch(t[r], t[n], !this.preserveMultipleSlashes);
        if (a) {
          t[r] = [], t[n] = a;
          break;
        }
      }
    return t.filter((r) => r.length);
  }
  partsMatch(t, r, n = !1) {
    let a = 0, i = 0, o = [], s = "";
    for (; a < t.length && i < r.length; )
      if (t[a] === r[i])
        o.push(s === "b" ? r[i] : t[a]), a++, i++;
      else if (n && t[a] === "**" && r[i] === t[a + 1])
        o.push(t[a]), a++;
      else if (n && r[i] === "**" && t[a] === r[i + 1])
        o.push(r[i]), i++;
      else if (t[a] === "*" && r[i] && (this.options.dot || !r[i].startsWith(".")) && r[i] !== "**") {
        if (s === "b")
          return !1;
        s = "a", o.push(t[a]), a++, i++;
      } else if (r[i] === "*" && t[a] && (this.options.dot || !t[a].startsWith(".")) && t[a] !== "**") {
        if (s === "a")
          return !1;
        s = "b", o.push(r[i]), a++, i++;
      } else
        return !1;
    return t.length === r.length && o;
  }
  parseNegate() {
    if (this.nonegate)
      return;
    const t = this.pattern;
    let r = !1, n = 0;
    for (let a = 0; a < t.length && t.charAt(a) === "!"; a++)
      r = !r, n++;
    n && (this.pattern = t.slice(n)), this.negate = r;
  }
  // set partial to true to test if, for example,
  // "/a/b" matches the start of "/*/b/*/d"
  // Partial means, if you run out of file before you run
  // out of pattern, then that's fine, as long as all
  // the parts match.
  matchOne(t, r, n = !1) {
    const a = this.options;
    if (this.isWindows) {
      const C = typeof t[0] == "string" && /^[a-z]:$/i.test(t[0]), A = !C && t[0] === "" && t[1] === "" && t[2] === "?" && /^[a-z]:$/i.test(t[3]), U = typeof r[0] == "string" && /^[a-z]:$/i.test(r[0]), B = !U && r[0] === "" && r[1] === "" && r[2] === "?" && typeof r[3] == "string" && /^[a-z]:$/i.test(r[3]), J = A ? 3 : C ? 0 : void 0, W = B ? 3 : U ? 0 : void 0;
      if (typeof J == "number" && typeof W == "number") {
        const [L, H] = [t[J], r[W]];
        L.toLowerCase() === H.toLowerCase() && (r[W] = L, W > J ? r = r.slice(W) : J > W && (t = t.slice(J)));
      }
    }
    const { optimizationLevel: i = 1 } = this.options;
    i >= 2 && (t = this.levelTwoFileOptimize(t)), this.debug("matchOne", this, { file: t, pattern: r }), this.debug("matchOne", t.length, r.length);
    for (var o = 0, s = 0, c = t.length, l = r.length; o < c && s < l; o++, s++) {
      this.debug("matchOne loop");
      var u = r[s], g = t[o];
      if (this.debug(r, u, g), u === !1)
        return !1;
      if (u === fi) {
        this.debug("GLOBSTAR", [r, u, g]);
        var p = o, m = s + 1;
        if (m === l) {
          for (this.debug("** at the end"); o < c; o++)
            if (t[o] === "." || t[o] === ".." || !a.dot && t[o].charAt(0) === ".")
              return !1;
          return !0;
        }
        for (; p < c; ) {
          var I = t[p];
          if (this.debug(`
globstar while`, t, p, r, m, I), this.matchOne(t.slice(p), r.slice(m), n))
            return this.debug("globstar found match!", p, c, I), !0;
          if (I === "." || I === ".." || !a.dot && I.charAt(0) === ".") {
            this.debug("dot detected!", t, p, r, m);
            break;
          }
          this.debug("globstar swallow a segment, and continue"), p++;
        }
        return !!(n && (this.debug(`
>>> no match, partial?`, t, p, r, m), p === c));
      }
      let C;
      if (typeof u == "string" ? (C = g === u, this.debug("string match", u, g, C)) : (C = u.test(g), this.debug("pattern match", u, g, C)), !C)
        return !1;
    }
    if (o === c && s === l)
      return !0;
    if (o === c)
      return n;
    if (s === l)
      return o === c - 1 && t[o] === "";
    throw new Error("wtf?");
  }
  braceExpand() {
    return qO(this.pattern, this.options);
  }
  parse(t) {
    ly(t);
    const r = this.options;
    if (t === "**")
      return fi;
    if (t === "")
      return "";
    let n, a = null;
    (n = t.match(uUe)) ? a = r.dot ? pUe : hUe : (n = t.match(tUe)) ? a = (r.nocase ? r.dot ? iUe : aUe : r.dot ? nUe : rUe)(n[1]) : (n = t.match(gUe)) ? a = (r.nocase ? r.dot ? mUe : fUe : r.dot ? vUe : SUe)(n) : (n = t.match(oUe)) ? a = r.dot ? lUe : sUe : (n = t.match(cUe)) && (a = dUe);
    const i = cy.fromGlob(t, this.options).toMMPattern();
    return a && typeof i == "object" && Reflect.defineProperty(i, "test", { value: a }), i;
  }
  makeRe() {
    if (this.regexp || this.regexp === !1)
      return this.regexp;
    const t = this.set;
    if (!t.length)
      return this.regexp = !1, this.regexp;
    const r = this.options, n = r.noglobstar ? bUe : r.dot ? yUe : wUe, a = new Set(r.nocase ? ["i"] : []);
    let i = t.map((c) => {
      const l = c.map((u) => {
        if (u instanceof RegExp)
          for (const g of u.flags.split(""))
            a.add(g);
        return typeof u == "string" ? NUe(u) : u === fi ? fi : u._src;
      });
      return l.forEach((u, g) => {
        const p = l[g + 1], m = l[g - 1];
        u !== fi || m === fi || (m === void 0 ? p !== void 0 && p !== fi ? l[g + 1] = "(?:\\/|" + n + "\\/)?" + p : l[g] = n : p === void 0 ? l[g - 1] = m + "(?:\\/|" + n + ")?" : p !== fi && (l[g - 1] = m + "(?:\\/|\\/" + n + "\\/)" + p, l[g + 1] = fi));
      }), l.filter((u) => u !== fi).join("/");
    }).join("|");
    const [o, s] = t.length > 1 ? ["(?:", ")"] : ["", ""];
    i = "^" + o + i + s + "$", this.negate && (i = "^(?!" + i + ").+$");
    try {
      this.regexp = new RegExp(i, [...a].join(""));
    } catch {
      this.regexp = !1;
    }
    return this.regexp;
  }
  slashSplit(t) {
    return this.preserveMultipleSlashes ? t.split("/") : this.isWindows && /^\/\/[^\/]+/.test(t) ? ["", ...t.split(/\/+/)] : t.split(/\/+/);
  }
  match(t, r = this.partial) {
    if (this.debug("match", t, this.pattern), this.comment)
      return !1;
    if (this.empty)
      return t === "";
    if (t === "/" && r)
      return !0;
    const n = this.options;
    this.isWindows && (t = t.split("\\").join("/"));
    const a = this.slashSplit(t);
    this.debug(this.pattern, "split", a);
    const i = this.set;
    this.debug(this.pattern, "set", i);
    let o = a[a.length - 1];
    if (!o)
      for (let s = a.length - 2; !o && s >= 0; s--)
        o = a[s];
    for (let s = 0; s < i.length; s++) {
      const c = i[s];
      let l = a;
      if (n.matchBase && c.length === 1 && (l = [o]), this.matchOne(l, c, r))
        return n.flipNegate ? !0 : !this.negate;
    }
    return n.flipNegate ? !1 : this.negate;
  }
  static defaults(t) {
    return En.defaults(t).Minimatch;
  }
}
En.AST = cy;
En.Minimatch = Ew;
En.escape = eUe;
En.unescape = ff;
const ZUe = 500, ej = 10, tj = (e) => ({
  cornersVisible: !1,
  tooFar: !0,
  tooClose: !0,
  middlePointAligned: !1,
  allChecksPassed: !1,
  ...e
}), Fs = (e, t) => Math.sqrt((e.x - t.x) ** 2 + (e.y - t.y) ** 2), rj = (e) => {
  const t = Math.min(
    Fs(e.topLeft, e.bottomLeft),
    Fs(e.topRight, e.bottomRight)
  ), r = Math.max(
    Fs(e.topLeft, e.bottomLeft),
    Fs(e.topRight, e.bottomRight)
  ), n = (t + r) / 2, a = Math.min(
    Fs(e.topLeft, e.topRight),
    Fs(e.bottomLeft, e.bottomRight)
  ), i = Math.max(
    Fs(e.topLeft, e.topRight),
    Fs(e.bottomLeft, e.bottomRight)
  );
  return { width: (a + i) / 2, height: n };
}, BUe = (e) => {
  const [
    t = 0,
    r = 0,
    n = 0,
    a = 0,
    i = 0,
    o = 0,
    s = 0,
    c = 0
  ] = e.corners.split(/[,;]/).map((U) => Number.parseInt(U, 10)), l = [
    {
      x: t,
      y: r
    },
    {
      x: n,
      y: a
    },
    {
      x: i,
      y: o
    },
    {
      x: s,
      y: c
    }
  ], u = Od(l, [(U) => U.y], ["asc"]).slice(0, 2), g = Od(u, [(U) => U.x], ["asc"]), p = Od(l, [(U) => U.y], ["desc"]).slice(0, 2), m = Od(p, [(U) => U.x], ["asc"]), I = {
    topLeft: g[0],
    topRight: g[1],
    bottomLeft: m[0],
    bottomRight: m[1]
  }, { width: C, height: A } = rj(I);
  return {
    timestamp: new Date(Number.parseInt(e.timestamp, 10)),
    originalCornerData: {
      topLeft: l[0],
      topRight: l[1],
      bottomRight: l[2],
      bottomLeft: l[3]
    },
    cornerData: I,
    middlePoint: {
      x: (t + n + i + s) / 4,
      y: (r + a + o + c) / 4
    },
    width: Math.round(C),
    height: Math.round(A),
    aspectRatio: C / A
  };
}, WUe = (e, t) => {
  const r = t.filter((l) => !!l), n = r.filter((l) => l.allChecksPassed), a = r.length > 0 ? r.every((l) => l.tooFar) : !0, i = r.length > 0 ? r.every((l) => l.tooClose) : !0, o = r.length > 0 ? r.every((l) => l.cornersVisible) : !1, s = r.length > 0 ? r.some((l) => l.middlePointAligned) : !1, c = t.length > 0 ? n.length / t.length : 0;
  return {
    ...tj({
      cornersVisible: o,
      tooFar: a,
      tooClose: i,
      middlePointAligned: s,
      allChecksPassed: !a && !i && s
    }),
    successRate: c,
    frameCount: t.length,
    duration: e,
    fps: 1e3 / (e / t.length)
  };
}, EUe = ({ circleX: e, circleY: t, circleR: r, targetPt: n }) => Math.sqrt((n.x - e) ** 2 + (n.y - t) ** 2) <= r, QUe = (e) => {
  e({
    event: He.CameraLivenessStart,
    timestamp: Date.now().toString()
  });
}, FUe = (e) => {
  e({
    event: He.CameraLivenessEnd,
    timestamp: Date.now().toString()
  });
}, HQ = (e) => {
  FUe(e), QUe(e);
}, nj = (e) => p4().pipe(
  ae(() => {
    HQ(e);
  })
), aj = (e, t = 1e3) => E2(t).pipe(
  ae(() => {
    !!bg() && e({
      event: He.CameraLivenessReqStatus,
      timestamp: Date.now().toString()
    });
  })
), TUe = (e) => {
  const t = JSON.parse(e);
  let r = [];
  return Ut(t, ["last_sn", "sequence"]) && (r = t.sequence ?? []), r;
}, ij = (e) => {
  var t;
  e.have_duplicates === "true" ? TUe(e.duplicate_sequences).forEach((n) => {
    var i;
    const a = (n.end_time === 0 ? Date.now() : n.end_time) - n.start_time;
    YJ({
      t: n.start_time,
      l: (i = bg()) == null ? void 0 : i.label,
      y: !0,
      q: a,
      p: n.num_frames
    });
  }) : YJ({
    t: Number.parseInt(e.timestamp),
    l: (t = bg()) == null ? void 0 : t.label,
    y: !1
  });
};
var Ha, cu, i2, oj, o2, s2;
const l2 = class l2 {
  constructor(t, r) {
    E(this, i2);
    E(this, Ha);
    E(this, cu);
    E(this, o2, (t) => {
      var n, a, i, o, s, c, l;
      const r = t.data;
      switch (r.event) {
        case He.InitializeSuccess:
          {
            const u = {
              event: He.StartSession,
              timestamp: Date.now().toString()
            };
            (n = S(this, Ha)) == null || n.postMessage(u), (i = (a = S(this, cu)).initializationSuccess) == null || i.call(a);
          }
          break;
        case He.DocIdInfo:
          if (S(this, s2).call(this, r)) {
            const u = BUe(r);
            [
              u.cornerData.topLeft.x,
              u.cornerData.topLeft.y,
              u.cornerData.topRight.x,
              u.cornerData.topRight.y,
              u.cornerData.bottomLeft.x,
              u.cornerData.bottomLeft.y,
              u.cornerData.bottomRight.x,
              u.cornerData.bottomRight.y
            ].every((p) => p > 0) ? (s = (o = S(this, cu)).updateFrame) == null || s.call(o, u) : (l = (c = S(this, cu)).updateFrame) == null || l.call(c, void 0);
          }
          break;
        case He.CameraLivenessStatus:
          ij(r);
          break;
      }
    });
    E(this, s2, (t) => Ut(
      t,
      ["event", "timestamp", "corners"],
      (r) => r.event === He.DocIdInfo
    ));
    G(this, cu, r), G(this, Ha, new wx()), S(this, Ha).onerror = () => {
      var n;
      (n = r.initializationFailure) == null || n.call(r, nt.WorkerError);
    }, S(this, Ha).onmessage = S(this, o2), O(this, i2, oj).call(this, S(this, Ha), t);
  }
  postMessage(t) {
    var r, n;
    if (t.event === He.Image) {
      (r = S(this, Ha)) == null || r.postMessage(t);
      return;
    }
    (n = S(this, Ha)) == null || n.postMessage(t);
  }
  terminate() {
    var r, n;
    const t = {
      event: He.Terminate,
      timestamp: Date.now().toString()
    };
    (r = S(this, Ha)) == null || r.postMessage(t), (n = S(this, Ha)) == null || n.terminate();
  }
  get isWorkerFree() {
    var t;
    return ((t = S(this, Ha)) == null ? void 0 : t.isWorkerReady(l2.ID)) ?? !1;
  }
};
Ha = new WeakMap(), cu = new WeakMap(), i2 = new WeakSet(), oj = function(t, r) {
  try {
    t.postMessage({
      assets: r.assets,
      config_name: r.configName,
      event: He.InitializeWasm,
      timestamp: Date.now().toString(),
      wasm_module: r.wasmModule
    });
  } catch {
    Bo(Er.MANUAL_CAPTURE_FALLBACK, nt.WorkerCrashed);
  }
}, o2 = new WeakMap(), s2 = new WeakMap(), l2.ID = "DocIdFinder";
let bZ = l2;
async function sj() {
  const t = await (await cpe() ? import(
    /* @vite-ignore */
    "./dac_simd.BXf06QGJ.js"
  ) : import(
    /* @vite-ignore */
    "./dac.D-L9bEov.js"
  )), n = await (await fetch(t.default)).arrayBuffer(), a = await import(
    /* @vite-ignore */
    "./assets_da_1_1_5.tar.ANYSPtwf.js"
  ), o = await (await fetch(a.default)).arrayBuffer();
  return {
    wasmModule: n,
    assets: new Uint8Array(o)
  };
}
class Ug extends Error {
  constructor(t) {
    super(), this.reason = t;
  }
}
var sc, lc, Fn, lj, cj, dj, uj, hj, pj, gj;
const c2 = class c2 {
  constructor() {
    E(this, Fn);
    E(this, sc);
    E(this, lc);
    G(this, lc, new _e()), this.pose$ = CAe(), this.videoResolution$ = _Q(), this.docFinder$ = SAe(), this.autocaptureSettings$ = O(this, Fn, lj).call(this), this.state$ = EO(), this.minMovementData$ = O(this, Fn, hj).call(this, this.pose$).pipe(
      FW(Number.MAX_VALUE),
      QW({
        refCount: !0,
        bufferSize: 1
      })
    ), this.feedback$ = O(this, Fn, cj).call(this, {
      pose$: this.pose$,
      autocaptureSettings$: this.autocaptureSettings$,
      docFinder$: this.docFinder$,
      videoResolution$: this.videoResolution$
    }).pipe(Gk()), this.smoothedFeedback$ = O(this, Fn, uj).call(this, this.feedback$).pipe(Gk());
    const t = this.postMessage.bind(this);
    aj(t).pipe(le(S(this, lc))).subscribe(), nj(t).pipe(le(S(this, lc))).subscribe(), O(this, Fn, gj).call(this).pipe(le(S(this, lc))).subscribe();
  }
  async initialize() {
    const t = ve(), { CaptureScreenAutoCaptureLoadingFailure: r, CaptureScreenAutoCaptureLoadingSuccess: n } = un(oe()), a = await Be(Y0e(), {
      defaultValue: []
    });
    if (O(this, Fn, pj).call(this, a)) {
      Bo(Er.MANUAL_CAPTURE_FALLBACK, nt.ExcludedDevice), t.send({ type: r });
      return;
    }
    try {
      Bo(Er.LOADING);
      const i = await sj(), o = Q2(
        c2.WASM_MODULE_INIT_FALLBACK_MS,
        new Ug(nt.ModuleInitializationError)
      ), s = new Promise((c) => {
        Bo(Er.LOADING);
        let l, u;
        const g = new bZ(
          {
            ...i,
            configName: _m.IdFinderLiveness
          },
          {
            updateFrame: (p) => {
              const m = Date.now();
              if (l && typeof u == "number" && p) {
                const I = Math.floor(Fs(l.middlePoint, p.middlePoint));
                tV({
                  ...p,
                  shift: I,
                  shiftTime: m - u
                });
              } else
                tV(p);
              l = p, u = m;
            },
            initializationFailure: (p) => {
              var m;
              (m = S(this, sc)) == null || m.terminate(), Bo(Er.MANUAL_CAPTURE_FALLBACK, p), t.send({ type: r });
            },
            initializationSuccess: () => {
              l = void 0, u = void 0, h4(), Bo(Er.ACTIVE, void 0);
              const p = {
                event: He.DocIdStart,
                timestamp: Date.now().toString()
              };
              this.postMessage(p), HQ(this.postMessage.bind(this)), t.send({ type: n }), c(g);
            }
          }
        );
        G(this, sc, g);
      });
      await Promise.race([o, s]);
    } catch (i) {
      const o = i instanceof Ug ? i.reason : nt.WorkerError;
      Bo(Er.MANUAL_CAPTURE_FALLBACK, o), t.send({ type: r });
    }
  }
  get isWorkerFree() {
    var t;
    return ((t = S(this, sc)) == null ? void 0 : t.isWorkerFree) ?? !1;
  }
  postMessage(t) {
    var r;
    try {
      (r = S(this, sc)) == null || r.postMessage(t);
    } catch {
      Bo(Er.MANUAL_CAPTURE_FALLBACK, nt.PostMessageError);
    }
  }
  destroy() {
    var t;
    (t = S(this, sc)) == null || t.terminate(), S(this, lc).next();
  }
};
sc = new WeakMap(), lc = new WeakMap(), Fn = new WeakSet(), lj = function() {
  return Ce().getConfiguration().selectSettings$().pipe(te((t) => t.configurations.idAutocapture ?? {}));
}, cj = function(t) {
  const { pose$: r, docFinder$: n, videoResolution$: a } = t;
  return r.pipe(
    go(n, a),
    te((i) => {
      const [o, s, c] = i;
      if (c && o) {
        const { width: l, height: u } = rj(o.cornerData), g = l / u, p = c.width / c.height;
        let m, I;
        const C = O(this, Fn, dj).call(this, i), A = EUe({
          targetPt: o.middlePoint,
          circleX: s.cx * c.width,
          circleY: s.cy * c.height,
          circleR: s.radius * Math.min(c.width, c.height)
        });
        return g >= p ? (m = l > c.width * s.maxFillRatio, I = l < c.width * s.minFillRatio) : (m = u > c.height * s.maxFillRatio, I = u < c.height * s.minFillRatio), tj({
          cornersVisible: C,
          tooFar: I,
          tooClose: m,
          middlePointAligned: A,
          allChecksPassed: !I && !m && A && C
        });
      }
    }),
    ae(yAe)
  );
}, dj = function([t, r, n]) {
  let a = !1;
  if (t && r && n) {
    const i = Math.floor(r.edgeMarginRatio * Math.min(n.width, n.height)), o = t.cornerData.topLeft.x >= i && t.cornerData.topLeft.y >= i, s = t.cornerData.topRight.x <= n.width - i && t.cornerData.topRight.y >= i, c = t.cornerData.bottomLeft.x >= i && t.cornerData.bottomLeft.y <= n.height - i, l = t.cornerData.bottomRight.x <= n.width - i && t.cornerData.bottomRight.y <= n.height - i;
    a = o && s && c && l;
  }
  return a;
}, uj = function(t, r = ZUe, n = 1e3 / 25) {
  return t.pipe(
    Rte(r, n),
    te(WUe.bind(void 0, r)),
    ae(bAe)
  );
}, hj = function(t) {
  return t.pipe(
    te((a) => a == null ? void 0 : a.shift),
    at(qse),
    jte((a, i) => Math.max(Math.min(a, i), 2), 5),
    vt()
  );
}, pj = function(t) {
  for (const r of f2e())
    for (const n of t) {
      const a = r.toLowerCase(), i = n.toLowerCase();
      if (En(a, i))
        return !0;
    }
  return !1;
}, gj = function(t = 20, r = 250) {
  return this.smoothedFeedback$.pipe(
    vt((n, a) => {
      const i = `${n == null ? void 0 : n.tooFar}_${n == null ? void 0 : n.tooClose}_${n == null ? void 0 : n.middlePointAligned}_${n == null ? void 0 : n.allChecksPassed}`, o = `${a == null ? void 0 : a.tooFar}_${a == null ? void 0 : a.tooClose}_${a == null ? void 0 : a.middlePointAligned}_${a == null ? void 0 : a.allChecksPassed}`;
      return i === o;
    }),
    ZM(r),
    kM(t),
    ae(() => {
      Bo(Er.MANUAL_CAPTURE_FALLBACK, nt.Struggle);
    }),
    Wt(() => ur().pipe(QM(1))),
    qc(1)
  );
}, c2.WASM_MODULE_INIT_FALLBACK_MS = 5e3;
let yZ = c2, eu;
const Qw = () => (eu || (eu = new yZ()), eu), RUe = () => {
  eu == null || eu.destroy(), eu = void 0;
};
var DUe = Object.defineProperty, JUe = Object.getOwnPropertyDescriptor, fj = (e) => {
  throw TypeError(e);
}, VUe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? JUe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && DUe(t, r, a), a;
}, LQ = (e, t, r) => t.has(e) || fj("Cannot " + r), gi = (e, t, r) => (LQ(e, t, "read from private field"), t.get(e)), qI = (e, t, r) => t.has(e) ? fj("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), dV = (e, t, r, n) => (LQ(e, t, "write to private field"), t.set(e, r), r), tu = (e, t, r) => (LQ(e, t, "access private method"), r), Wo, mf, vf, al, mj, ib, vj, Sj, Ij;
let wZ = class extends N {
  constructor() {
    super(...arguments), qI(this, al), this.cameraRef = Rt(), qI(this, Wo, Qw()), qI(this, mf, !0), qI(this, vf, new _e()), this.onVideoTick = async () => {
      var e, t;
      if (vAe() && gi(this, mf) && gi(this, Wo).isWorkerFree) {
        dV(this, mf, !1);
        const r = await ((e = this.getImageData) == null ? void 0 : e.call(this));
        r && ((t = gi(this, Wo)) == null || t.postMessage({
          event: He.Image,
          timestamp: Date.now().toString(),
          image: r,
          format: "rgba"
        })), dV(this, mf, !0);
      }
    }, this.getImageData = async (...e) => {
      var t, r, n, a, i;
      return (i = (a = (n = (r = (t = this.cameraRef) == null ? void 0 : t.value) == null ? void 0 : r.canvasRendererElRef) == null ? void 0 : n.value) == null ? void 0 : a.getImageData) == null ? void 0 : i.call(a, ...e);
    };
  }
  connectedCallback() {
    super.connectedCallback(), tu(this, al, mj).call(this).pipe(le(gi(this, vf))).subscribe(), tu(this, al, vj).call(this).pipe(le(gi(this, vf))).subscribe();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), gi(this, vf).next();
  }
  getPoseCombinedParams$() {
    return gi(this, Wo).smoothedFeedback$.pipe(
      go(
        gi(this, Wo).feedback$,
        gi(this, Wo).pose$,
        ur(),
        tu(this, al, Ij).call(this).selectUserSelection$(),
        gi(this, Wo).minMovementData$,
        gi(this, Wo).autocaptureSettings$,
        tu(this, al, Sj).call(this)
      ),
      te(
        ([
          e,
          t,
          r,
          n,
          a,
          i,
          o,
          s
        ]) => ({
          pose: r,
          userSelection: a,
          idStep: n,
          minMovement: i,
          smoothedFeedback: e,
          feedback: t,
          autocaptureSettings: o,
          stepActivationTime: s
        })
      )
    );
  }
  assertAutocaptureConditions({ idStep: e }) {
    return [Z.CaptureScreenFront, Z.CaptureScreenBack].includes(e);
  }
  activateFallbackIfNeeded({ stepActivationTime: e, autocaptureSettings: t }) {
    const r = (t == null ? void 0 : t.fallbackTimeInMs) ?? 9e4;
    Date.now() - e > r && Bo(Er.MANUAL_CAPTURE_FALLBACK, nt.Timeout);
  }
};
Wo = /* @__PURE__ */ new WeakMap();
mf = /* @__PURE__ */ new WeakMap();
vf = /* @__PURE__ */ new WeakMap();
al = /* @__PURE__ */ new WeakSet();
mj = function() {
  return this.getPoseCombinedParams$().pipe(
    ae(this.activateFallbackIfNeeded.bind(this)),
    at(this.assertAutocaptureConditions.bind(this)),
    vt((e, t) => {
      const r = tu(this, al, ib).call(this, e.smoothedFeedback), n = tu(this, al, ib).call(this, t.smoothedFeedback);
      return r === n && e.idStep === t.idStep;
    }),
    ZM(Math.max(hg, j_())),
    at(({ smoothedFeedback: e }) => tu(this, al, ib).call(this, e)),
    ae(({ smoothedFeedback: e }) => {
      gi(this, Wo).postMessage({
        event: He.CameraLivenessReqStatus,
        timestamp: Date.now().toString()
      }), this.dispatchEvent(
        new VO({
          autocapture: !0,
          ...typeof (e == null ? void 0 : e.fps) == "number" && { autocaptureFps: Math.round(e.fps) },
          cls: sd(),
          clsm: ld()
        })
      );
    })
  );
};
ib = function(e) {
  return (e == null ? void 0 : e.allChecksPassed) === !0;
};
vj = function() {
  return EO().pipe(
    ae(({ state: e, fallbackReason: t }) => {
      const r = Ce(), { substep: n = "" } = Le();
      r.getLoggerManager().log(
        pL({
          metadata: {
            step: n,
            autocaptureState: e,
            autocaptureFallbackReason: t
          }
        })
      );
    })
  );
};
Sj = function() {
  return ur().pipe(te(() => Date.now()));
};
Ij = function() {
  return Ce().getControllerById(T.Id);
};
wZ.styles = [...N.styles, Gt(AAe)];
wZ = VUe([
  P("jumio-sdk-autocapture"),
  be()
], wZ);
var MUe = Object.defineProperty, GUe = Object.getOwnPropertyDescriptor, Cj = (e) => {
  throw TypeError(e);
}, xUe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? GUe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && MUe(t, r, a), a;
}, HUe = (e, t, r) => t.has(e) || Cj("Cannot " + r), LUe = (e, t, r) => t.has(e) ? Cj("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), YUe = (e, t, r) => (HUe(e, t, "access private method"), r), AZ, bj;
let Xm = class extends N {
  constructor() {
    super(...arguments), LUe(this, AZ), this.idStepAsyncController = new ue(this, YUe(this, AZ, bj).call(this));
  }
  render() {
    var e;
    return w`
      <x-ds-capture-message-container>
        ${this.renderContents((e = this.idStepAsyncController.value) == null ? void 0 : e.substep)}
      </x-ds-capture-message-container>
    `;
  }
  renderContents(e) {
    var t;
    switch (e) {
      case Z.CaptureScreenFrontStart:
        return this.renderFront();
      case Z.CaptureScreenBackStart:
        return this.renderFlipToBack();
      case Z.CaptureScreenFront:
      case Z.CaptureScreenBack:
        return (t = this.idStepAsyncController.value) != null && t.capturing ? this.renderCapturing() : this.renderCaptureImage(e);
      case Z.CaptureScreenFrontFinish:
      case Z.CaptureScreenBackFinish:
        return this.renderCaptured();
      default:
        return q;
    }
  }
  renderCaptureImage(e) {
    const t = (() => {
      switch (e) {
        case Z.CaptureScreenFront:
          return y("Manually capture the PHOTO side", {
            id: "jumio_id_scan_guide_photo_side_manually"
          });
        case Z.CaptureScreenBack:
          return y("Manually capture the BACK side", {
            id: "jumio_id_scan_guide_back_side_manually"
          });
        default:
          return y("Center your document", {
            id: "jumio_id_scan_prompt_center_id"
          });
      }
    })();
    return w`
      <x-ds-prompt-loader
        slot="top"
        data-state="${Ia.Initial}"
        class="center-message"
      ></x-ds-prompt-loader>
      <x-ds-capture-label
        class="capture-state-message"
        slot="bottom"
        data-qa-id="capture-state-message"
        data-text="${t}"
      >
        ${t}
      </x-ds-capture-label>
    `;
  }
  renderCapturing() {
    const e = y("Hold still…", { id: "autocapture.holdStillDots" });
    return w`
      <x-ds-prompt-loader
        slot="top"
        data-state="${Ia.Progress}"
        data-progress="100"
      ></x-ds-prompt-loader>
      <x-ds-capture-label
        slot="bottom"
        class="capture-state-message"
        data-qa-id="capture-state-message"
        data-text="${e}"
      >
        ${e}
      </x-ds-capture-label>
    `;
  }
  renderFront() {
    const e = y("Capture the PHOTO side", { id: "jumio_id_scan_guide_photo_side" });
    return w`
      <x-id-side slot="top" data-id-side="${cr.Front}"></x-id-side>
      <x-ds-capture-label
        slot="bottom"
        class="capture-state-message"
        data-qa-id="capture-state-message"
        data-text="${e}"
      >
        ${e}
      </x-ds-capture-label>
    `;
  }
  renderFlipToBack() {
    const e = y("Flip to the BACK side", { id: "jumio_id_scan_prompt_flip_to_back" });
    return w`
      <x-id-side slot="top" data-id-side="${cr.Back}"></x-id-side>
      <x-ds-capture-label
        slot="bottom"
        class="capture-state-message"
        data-qa-id="capture-state-message"
        data-text="${e}"
      >
        ${e}
      </x-ds-capture-label>
    `;
  }
  renderCaptured() {
    const e = y("Captured", { id: "jumio_id_scan_prompt_captured" });
    return w`
      <x-ds-prompt-loader
        slot="top"
        data-state="${Ia.Progress}"
        data-progress="100"
      ></x-ds-prompt-loader>
      <x-ds-capture-label
        slot="bottom"
        class="capture-state-message"
        data-qa-id="capture-state-message"
        data-text="${e}"
      >
        ${e}
      </x-ds-capture-label>
    `;
  }
};
AZ = /* @__PURE__ */ new WeakSet();
bj = function() {
  return ur().pipe(
    $a(vwe()),
    te(([e, t]) => ({
      substep: e,
      capturing: t
    }))
  );
};
Xm.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
Xm = xUe([
  be(),
  P("jumio-sdk-step-id-capture-state")
], Xm);
var OUe = Object.defineProperty, jUe = Object.getOwnPropertyDescriptor, yj = (e) => {
  throw TypeError(e);
}, PUe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? jUe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && OUe(t, r, a), a;
}, wj = (e, t, r) => t.has(e) || yj("Cannot " + r), eC = (e, t, r) => (wj(e, t, "read from private field"), r ? r.call(e) : t.get(e)), KU = (e, t, r) => t.has(e) ? yj("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), ob = (e, t, r) => (wj(e, t, "access private method"), r), sb, lb, qh, Aj, Uj, kj, _j;
let UZ = class extends Xm {
  constructor() {
    super(...arguments), KU(this, qh), KU(this, sb, new ue(this, ob(this, qh, kj).call(this))), KU(this, lb, Rt());
  }
  renderContents(e) {
    switch (e) {
      case Z.CaptureScreenAutoCaptureLoading:
        return ob(this, qh, _j).call(this);
      default:
        return Xm.prototype.renderContents.call(this, e);
    }
  }
  renderCaptureImage() {
    const e = eC(this, sb).value, t = ob(this, qh, Aj).call(this, e);
    return w`
      ${this.renderLoadingIndicator()}
      <x-ds-capture-label
        class="capture-state-message"
        slot="bottom"
        data-qa-id="capture-state-message"
        data-text="${t}"
      >
        ${t}
      </x-ds-capture-label>
    `;
  }
  renderLoadingIndicator() {
    return window.requestAnimationFrame(() => this.renderProgress()), w`
      <x-ds-prompt-loader
        slot="top"
        ${Mt(eC(this, lb))}
        data-state="${Ia.Initial}"
        data-progress="0"
        data-progress-transition-duration="${j_()}"
        class="center-message"
      ></x-ds-prompt-loader>
    `;
  }
  async renderProgress() {
    const e = eC(this, lb).value, t = eC(this, sb).value;
    if (e) {
      const r = !!(t != null && t.allChecksPassed);
      e.state = r ? Ia.Progress : Ia.Initial, e.progressTransitionDuration = j_(), e.progress = 0, await Kue(() => {
        r && (e.progress = 100);
      });
    }
  }
};
sb = /* @__PURE__ */ new WeakMap();
lb = /* @__PURE__ */ new WeakMap();
qh = /* @__PURE__ */ new WeakSet();
Aj = function(e) {
  const t = ob(this, qh, Uj).call(this);
  if (e) {
    if (e.tooFar)
      return t.jumio_id_scan_prompt_move_closer;
    if (e.tooClose)
      return t.jumio_autocapture_prompt_too_close;
    if (!e.middlePointAligned)
      return t.autocapture_center_your_document;
    if (e.allChecksPassed)
      return t.jumio_autocapture_prompt_hold_still;
  }
  return t.autocapture_center_your_document;
};
Uj = function() {
  return {
    jumio_autocapture_prompt_hold_still: y("Hold still…", {
      id: "jumio_autocapture_prompt_hold_still"
    }),
    jumio_id_scan_prompt_move_closer: y("Move closer", {
      id: "jumio_id_scan_prompt_move_closer"
    }),
    jumio_autocapture_prompt_too_close: y("Too close", {
      id: "jumio_id_scan_prompt_too_close"
    }),
    autocapture_center_your_document: y("Center your document", {
      id: "autocapture.centerYourDocument"
    })
  };
};
kj = function() {
  return FO(ej).pipe(
    vt((e, t) => {
      const r = `${e == null ? void 0 : e.tooFar}_${e == null ? void 0 : e.tooClose}_${e == null ? void 0 : e.middlePointAligned}_${e == null ? void 0 : e.allChecksPassed}`, n = `${t == null ? void 0 : t.tooFar}_${t == null ? void 0 : t.tooClose}_${t == null ? void 0 : t.middlePointAligned}_${t == null ? void 0 : t.allChecksPassed}`;
      return r === n;
    })
  );
};
_j = function() {
  const e = y("Loading", {
    id: "identity.guidance.button.progress"
  });
  return w`
      <x-ds-prompt-loader
        slot="top"
        data-state="${Ia.Pulsing}"
        class="center-message"
      ></x-ds-prompt-loader>
      <x-ds-capture-label data-qa-id="capture-state-message" data-text="${e}" slot="bottom">
        ${e}
      </x-ds-capture-label>
    `;
};
UZ.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
UZ = PUe([
  be(),
  P("jumio-sdk-autocapture-capture-state")
], UZ);
const $Ue = Symbol("jumio-sdk-autocapture-service");
var KUe = Object.defineProperty, XUe = Object.getOwnPropertyDescriptor, Nj = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? XUe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && KUe(t, r, a), a;
};
let dy = class extends N {
  constructor() {
    super(...arguments), this.jumioSdkAutocaptureService = Qw();
  }
  render() {
    return w`<slot></slot>`;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), RUe();
  }
};
dy.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
Nj([
  ka({ context: $Ue })
], dy.prototype, "jumioSdkAutocaptureService", 2);
dy = Nj([
  P("jumio-sdk-autocapture-provider"),
  be()
], dy);
var zUe = Object.defineProperty, qUe = Object.getOwnPropertyDescriptor, Zj = (e) => {
  throw TypeError(e);
}, eke = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? qUe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && zUe(t, r, a), a;
}, YQ = (e, t, r) => t.has(e) || Zj("Cannot " + r), At = (e, t, r) => (YQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), gn = (e, t, r) => t.has(e) ? Zj("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Ml = (e, t, r, n) => (YQ(e, t, "write to private field"), t.set(e, r), r), jf = (e, t, r) => (YQ(e, t, "access private method"), r), Ls, OQ, jQ, PQ, $Q, uy, KQ, hy, zm, cb, Sf, py, Eo, qm, db, ru, Bj, Wj, Ej, Qj, Fj;
let kZ = class extends N {
  constructor() {
    super(), gn(this, ru), gn(this, Ls), gn(this, OQ, 86 / 54), gn(this, jQ, 12 / 1080), gn(this, PQ, "#fff"), gn(this, $Q, 24 / 1080), gn(this, uy, "#5acc29"), gn(this, KQ, 0.05), gn(this, hy), gn(this, zm), gn(this, cb), gn(this, Sf, new _e()), gn(this, py, new _e()), gn(this, Eo), gn(this, qm), gn(this, db), this.onVideoTick = () => (this.renderTick(), Promise.resolve()), Ml(this, Ls, Rt()), Ml(this, cb, jf(this, ru, Qj).call(this)), this.autocaptureService = Qw(), Ml(this, Eo, new ue(this, this.autocaptureService.videoResolution$)), Ml(this, qm, new ue(this, At(this, cb))), Ml(this, db, new ue(this, ur()));
  }
  connectedCallback() {
    super.connectedCallback(), jf(this, ru, Ej).call(this).pipe(le(At(this, Sf))).subscribe((e) => {
      Ml(this, hy, e);
    }), FO(ej).pipe(le(At(this, Sf))).subscribe((e) => {
      Ml(this, zm, e);
    });
  }
  firstUpdated(e) {
    super.firstUpdated(e), Ml(this, uy, getComputedStyle(this).getPropertyValue("--color-primary4") ?? "#5acc29"), this.renderTick(), At(this, py).next();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), At(this, Sf).next();
  }
  render() {
    var e, t;
    return w`
      <canvas
        ${Mt(At(this, Ls))}
        class="canvas2d"
        data-step="${At(this, db).value ?? ""}"
        width="${((e = At(this, Eo).value) == null ? void 0 : e.width) ?? 0}"
        height="${((t = At(this, Eo).value) == null ? void 0 : t.height) ?? 0}"
      ></canvas>
    `;
  }
  onStreamPause() {
    var t;
    const e = (t = At(this, Ls).value) == null ? void 0 : t.getContext("2d");
    if (At(this, Eo).value) {
      const r = At(this, Eo).value;
      e == null || e.clearRect(0, 0, r.width, r.height);
    }
  }
  renderTick() {
    var t, r;
    const e = (t = At(this, Ls).value) == null ? void 0 : t.getContext("2d");
    if (e) {
      if (At(this, Eo).value) {
        const n = At(this, Eo).value;
        e.clearRect(0, 0, n.width, n.height);
      }
      e.save(), e.translate(Math.round(((r = At(this, Ls).value) == null ? void 0 : r.width) ?? 0), 0), e.scale(-1, 1), jf(this, ru, Bj).call(this, e), e.restore();
    }
  }
};
Ls = /* @__PURE__ */ new WeakMap();
OQ = /* @__PURE__ */ new WeakMap();
jQ = /* @__PURE__ */ new WeakMap();
PQ = /* @__PURE__ */ new WeakMap();
$Q = /* @__PURE__ */ new WeakMap();
uy = /* @__PURE__ */ new WeakMap();
KQ = /* @__PURE__ */ new WeakMap();
hy = /* @__PURE__ */ new WeakMap();
zm = /* @__PURE__ */ new WeakMap();
cb = /* @__PURE__ */ new WeakMap();
Sf = /* @__PURE__ */ new WeakMap();
py = /* @__PURE__ */ new WeakMap();
Eo = /* @__PURE__ */ new WeakMap();
qm = /* @__PURE__ */ new WeakMap();
db = /* @__PURE__ */ new WeakMap();
ru = /* @__PURE__ */ new WeakSet();
Bj = function(e) {
  var i, o;
  const t = At(this, Eo).value, r = ((i = At(this, hy)) == null ? void 0 : i.aspectRatio) ?? At(this, OQ), n = At(this, qm).value ?? { width: 0, height: 0 }, a = r;
  if (a && t && n.width > 0 && n.height > 0) {
    const s = IAe(), c = t.width / t.height, l = (s.minFillRatio + s.maxFillRatio) / 2;
    let u, g;
    a >= c ? (u = t.width * l, g = u / a) : (g = t.height * l, u = g * a);
    const p = Math.round((t.width - u) / 2), m = Math.round((t.height - g) / 2), I = Math.round(Math.min(g, u) * At(this, KQ)), C = jf(this, ru, Fj).call(this, !!((o = At(this, zm)) != null && o.allChecksPassed));
    e.save(), e.translate(p, m), jf(this, ru, Wj).call(this, e, u, g, I, C), e.restore();
  }
};
Wj = function(e, t, r, n, a) {
  var s;
  if (n > t / 2 || n > r / 2)
    return;
  e.save(), e.lineWidth = a, e.strokeStyle = (s = At(this, zm)) != null && s.allChecksPassed ? At(this, uy) : At(this, PQ), e.beginPath(), e.moveTo(n, 0), e.arcTo(t, 0, t, r, n), e.arcTo(t, r, 0, r, n), e.arcTo(0, r, 0, 0, n), e.arcTo(0, 0, t, 0, n), e.closePath(), e.stroke(), e.globalCompositeOperation = "destination-out";
  const o = 0.15 * Math.min(t, r);
  e.fillRect(-a, o, t + 2 * a, r - 2 * o), e.fillRect(o, -a, t - 2 * o, r + 2 * a), e.restore();
};
Ej = function() {
  return this.autocaptureService.pose$.pipe(
    kM(5, 1),
    te((e) => {
      const t = e.filter((n) => !!n), r = t.reduce((n, a) => n + ((a == null ? void 0 : a.aspectRatio) ?? 0), 0) / t.length;
      return t.length > 0 ? {
        ...t[t.length - 1],
        aspectRatio: r
      } : void 0;
    })
  );
};
Qj = function() {
  return Bl(At(this, Ls), At(this, py)).pipe(
    Wt((e) => {
      var t;
      return aw({ el: e }).pipe(
        FW(((t = At(this, Ls).value) == null ? void 0 : t.getBoundingClientRect()) ?? { width: 0, height: 0 })
      );
    })
  );
};
Fj = function(e) {
  const { width: t = 0, height: r = 0 } = At(this, qm).value ?? {}, n = Math.min(t, r), a = e ? At(this, $Q) : At(this, jQ);
  return Math.max(Math.round(a * n), 4);
};
kZ.styles = [
  ...N.styles,
  ee`
      :host {
        pointer-events: none;
      }

      .canvas2d {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        opacity: 0;
        transition: opacity 500ms;
      }

      .canvas2d[data-step='id-capture-screen-front'],
      .canvas2d[data-step='id-capture-screen-back'] {
        opacity: 1;
      }
    `
];
kZ = eke([
  P("jumio-sdk-autocapture-tracker")
], kZ);
const Pf = {
  [qi.Us]: "https://web-sdk.amer-1.jumio.ai/websdk/v4/api",
  [qi.Eu]: "https://web-sdk.emea-1.jumio.ai/websdk/v4/api",
  [qi.Sgp]: "https://web-sdk.apac-1.jumio.ai/websdk/v4/api"
};
Pf[qi.Us] + "", qi.Us, Pf[qi.Eu] + "", qi.Eu, Pf[qi.Sgp] + "", qi.Sgp;
const XQ = Y.En, Tj = Object.values(Y).filter((e) => e !== XQ);
[...Object.values(Tj)];
const tke = (e) => Object.values(Y).includes(e), xe = (e) => {
  if (!Ut(e, ["default"]))
    throw new Error(`Cannot read the file: ${e}`);
  return {
    templates: e.default
  };
}, { getLocale: _Ve, setLocale: rke } = wee({
  sourceLocale: XQ,
  targetLocales: Tj,
  loadLocale: async (e) => {
    switch (tke(e) ? e : Y.En) {
      case Y.Ar:
        return import("./i18n/ar.Bd1tccH7.js").then(xe);
      case Y.Bg:
        return import("./i18n/bg.nQ_G9LVk.js").then(xe);
      case Y.Cs:
        return import("./i18n/cs.DMX_d0v7.js").then(xe);
      case Y.Da:
        return import("./i18n/da.DgurKXXC.js").then(xe);
      case Y.De:
        return import("./i18n/de.Cfao5pyc.js").then(xe);
      case Y.El:
        return import("./i18n/el.DTjFC2XD.js").then(xe);
      case Y.EnGb:
      case Y.EnGbHyphen:
        return import("./i18n/en_GB.DehS8DQp.js").then(xe);
      case Y.Es:
        return import("./i18n/es.zGLl7YR5.js").then(xe);
      case Y.EsMx:
      case Y.EsMxHyphen:
        return import("./i18n/es_MX.DpdA-cqS.js").then(xe);
      case Y.Et:
        return import("./i18n/et.C7AXrKdN.js").then(xe);
      case Y.Fi:
        return import("./i18n/fi.4SJVJ50z.js").then(xe);
      case Y.Fr:
        return import("./i18n/fr.C5j5IlaD.js").then(xe);
      case Y.He:
        return import("./i18n/he.CeGHyVeG.js").then(xe);
      case Y.Hr:
        return import("./i18n/hr.BOwP6prR.js").then(xe);
      case Y.Hu:
        return import("./i18n/hu.DC4UmQQJ.js").then(xe);
      case Y.Hy:
        return import("./i18n/hy.I_BD7SVm.js").then(xe);
      case Y.Id:
        return import("./i18n/id.D9By5840.js").then(xe);
      case Y.It:
        return import("./i18n/it.CB9iWY3q.js").then(xe);
      case Y.Ja:
        return import("./i18n/ja.BRICLbDD.js").then(xe);
      case Y.KaGe:
      case Y.KaGeHyphen:
        return import("./i18n/ka_GE.C5Bk7C0S.js").then(xe);
      case Y.Km:
      case Y.KmKh:
      case Y.KmKhHyphen:
        return import("./i18n/km_KH.DBrwG0Mz.js").then(xe);
      case Y.Ko:
        return import("./i18n/ko.V96Ofu2S.js").then(xe);
      case Y.Lt:
        return import("./i18n/lt.DPymAv77.js").then(xe);
      case Y.Ms:
        return import("./i18n/ms.BWa9QaiX.js").then(xe);
      case Y.Nl:
        return import("./i18n/nl.DRaoEllf.js").then(xe);
      case Y.No:
        return import("./i18n/no.DT_sSQHz.js").then(xe);
      case Y.Pl:
        return import("./i18n/pl.BBtOxaAP.js").then(xe);
      case Y.Pt:
        return import("./i18n/pt.9IXviZ06.js").then(xe);
      case Y.PtBr:
      case Y.PtBrHyphen:
        return import("./i18n/pt_BR.DVFbOwfT.js").then(xe);
      case Y.Ro:
        return import("./i18n/ro.C_sWcYoG.js").then(xe);
      case Y.Ru:
        return import("./i18n/ru.CQrPblu4.js").then(xe);
      case Y.Sk:
        return import("./i18n/sk.C_TOQQVn.js").then(xe);
      case Y.Sr:
      case Y.SrCyrl:
      case Y.SrCyrlHyphen:
        return import("./i18n/sr_Cyrl.DeuzvrY0.js").then(xe);
      case Y.SrLatn:
      case Y.SrLatnHyphen:
        return import("./i18n/sr_Latn.DM3OKmvn.js").then(xe);
      case Y.Sv:
        return import("./i18n/sv.8mh369YN.js").then(xe);
      case Y.Sw:
        return import("./i18n/sw.D9DWt1T4.js").then(xe);
      case Y.Th:
        return import("./i18n/th.yY2_gQdX.js").then(xe);
      case Y.Tr:
        return import("./i18n/tr.BDllq4J9.js").then(xe);
      case Y.Uk:
        return import("./i18n/uk.C1MWphQh.js").then(xe);
      case Y.Vi:
        return import("./i18n/vi.BMMseybp.js").then(xe);
      case Y.Zh:
      case Y.ZhCn:
      case Y.ZhCnHyphen:
        return import("./i18n/zh_CN.DFMlmsiD.js").then(xe);
      case Y.ZhHk:
      case Y.ZhHkHyphen:
        return import("./i18n/zh_HK.DGHeKcbY.js").then(xe);
      case Y.En:
      case Y.EnUs:
      case Y.EnUsHyphen:
      default:
        return import("./i18n/en.8OU2grh4.js").then(xe);
    }
  }
}), Rj = "LoggerPostMessage", wu = "__NVW_WEBVIEW_HANDLER__";
class nke {
  constructor() {
    this.isEnabled = !0;
  }
  async log(t) {
    return this.isEnabled && _Z(t), Promise.resolve();
  }
  report(t) {
    return this.isEnabled && _Z(t), Promise.resolve();
  }
  getId() {
    return Rj;
  }
  updateConfig(t) {
    this.isEnabled = t.isEnabled;
  }
}
const _Z = (e) => {
  var i;
  const t = ake() && window[wu], r = ike() && ((i = window == null ? void 0 : window.webkit) == null ? void 0 : i.messageHandlers[wu]), n = typeof e != "string" ? JSON.stringify(e) : e;
  typeof (r == null ? void 0 : r.postMessage) == "function" && r.postMessage(n, "*"), typeof (t == null ? void 0 : t.postMessage) == "function" && (t == null || t.postMessage(n, "*")), (mG() ? window.parent.postMessage.bind(window.parent) : window.postMessage.bind(window))(n, "*");
}, ake = () => Ut(window, [wu], (e) => !!e[wu]) ? window[wu] : void 0, ike = () => {
  var e, t;
  return Ut(
    window,
    ["webkit"],
    (r) => {
      var n, a;
      return !!((a = (n = r.webkit) == null ? void 0 : n.messageHandlers) != null && a[wu]);
    }
  ) ? (t = (e = window.webkit) == null ? void 0 : e.messageHandlers) == null ? void 0 : t[wu] : void 0;
};
var kg = /* @__PURE__ */ ((e) => (e.Success = "success", e.Loaded = "loaded", e.Error = "error", e))(kg || {});
const uV = 9100, ev = (e, t) => {
  const { parsedToken: r, token: n } = Le(), a = {
    value: e,
    metainfo: {
      mode: "original",
      ...e === "error" ? {
        code: t ? t.legacyCode() : uV,
        codeExternal: t ? t.legacyCode() : uV,
        publicErrorCode: t == null ? void 0 : t.code()
      } : {}
    }
  }, i = JSON.stringify({
    authorizationToken: n,
    eventType: 510,
    dateTime: /* @__PURE__ */ new Date(),
    payload: a,
    workflowExecutionId: r == null ? void 0 : r.wfeId,
    transactionReference: r == null ? void 0 : r.wfeId,
    jumioIdScanReference: r == null ? void 0 : r.wfeId,
    accountId: r == null ? void 0 : r.aId,
    customerInternalReference: (r == null ? void 0 : r.cRef) ?? ""
  });
  _Z(i);
};
class NVe extends CustomEvent {
  constructor(t) {
    super("workflow:initiate", {
      composed: !0,
      bubbles: !0,
      detail: t
    });
  }
}
const Fw = (e, t) => new CustomEvent(e, {
  bubbles: !0,
  composed: !0,
  cancelable: !0,
  detail: {
    type: e,
    ...t
  }
}), oke = (e) => Fw("workflow:start", e), Dj = (e) => Fw("workflow:success", e), Jj = (e) => Fw("workflow:failed", e), ske = (e) => Fw("workflow:retry", e);
var Fr = /* @__PURE__ */ ((e) => (e.Error = "error", e.Success = "success", e.Progress = "progress", e))(Fr || {});
const NZ = "jmessage", ZZ = "jmessageclose";
class Vj extends CustomEvent {
  constructor(t) {
    super(ZZ, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: t
    });
  }
}
class lke extends CustomEvent {
  constructor(t) {
    super(NZ, {
      bubbles: !0,
      composed: !0,
      cancelable: !0,
      detail: t
    });
  }
}
var ct = /* @__PURE__ */ ((e) => (e.AcquisitionFailed = "acquisition-failed", e.AcquisitionSuccessful = "acquisition-success", e.UsabilityCheck = "usability-check", e.CameraGenericError = "camera-generic-error", e.CameraInitialization = "camera-initialization", e.CameraNotAllowedError = "camera-not-allowed-error", e.SessionExpired = "session-expired", e.Uploading = "uploading", e.Finalizing = "finalizing", e.EmbargoedCountry = "embargoed-country", e.CloseBrowser = "close-browser", e.LivenessFailed = "liveness-failed", e))(ct || {}), Xi;
class cke {
  constructor() {
    E(this, Xi);
    G(this, Xi, new Kt(void 0)), this.message$ = S(this, Xi).asObservable();
  }
  showMessage(t) {
    S(this, Xi).next(t);
  }
  showMessageIfPossible(t) {
    const r = S(this, Xi).getValue();
    (!r || r.closable) && this.showMessage(t);
  }
  clearMessage() {
    S(this, Xi).next(void 0);
  }
  closeActiveClosableMessage() {
    const t = S(this, Xi).getValue();
    t != null && t.closable && this.clearMessage();
  }
  closeActiveClosableMessageById(...t) {
    const r = S(this, Xi).getValue();
    for (const n of t)
      r != null && r.closable && r.id === n && this.clearMessage();
  }
  getMessage() {
    return S(this, Xi).getValue();
  }
}
Xi = new WeakMap();
const mt = new cke(), yo = (e, t, r) => ({
  title: { label: t, id: `error.${e}.title` },
  message: { label: r, id: `error.${e}.description` }
}), Tw = {
  [rt.SystemError]: yo(
    rt.SystemError,
    "Oops…",
    "Sorry, there was an unexpected error. Please try again."
  ),
  [rt.AuthTokenError]: yo(
    rt.AuthTokenError,
    "Authorization expired",
    "Sorry, your session has expired, and we are unable to continue."
  ),
  [rt.AuthSessionError]: yo(
    rt.AuthSessionError,
    "Session expired",
    "Sorry, your session has expired, and we are unable to continue."
  ),
  [rt.FileUploadError]: yo(
    rt.FileUploadError,
    "Upload error",
    "Sorry, there was a problem uploading your images. Please try again."
  ),
  [rt.UsabilityError]: yo(
    rt.UsabilityError,
    "Technical error",
    "Sorry, a technical problem has occurred. Please try again."
  ),
  [rt.UserOffline]: yo(
    rt.UserOffline,
    "Connection error",
    "Sorry, the connection was lost. Please check your network settings."
  ),
  [rt.UnhandledError]: yo(
    rt.UnhandledError,
    "Oops…",
    "Sorry, there was an unexpected error. Please try again later."
  ),
  [rt.BrowserDoesNotSupportCamera]: yo(
    rt.BrowserDoesNotSupportCamera,
    "Verification error",
    "This browser does not support face authentication."
  ),
  [rt.AuthFailed]: yo(
    rt.AuthFailed,
    "Authentication failed",
    "Sorry, we're unable to continue. You may now close your browser."
  ),
  [rt.CredentialError]: yo(
    rt.CredentialError,
    "Unable to continue",
    "The document cannot be further processed for verification."
  )
};
var du;
class dke {
  constructor() {
    E(this, du);
    this.showAcquisitionStatus = (t) => {
      var n, a;
      const { finalized: r } = Ce().getWorkflowState();
      if (!r) {
        const { status: i } = t;
        i === Wr.Success || i === Wr.Pending ? this.showAcquisitionSuccessMessage(i) : (i === Wr.Retry || i === Wr.Failed) && this.showAcquisitionFailedMessage(i, (a = (n = t.error) == null ? void 0 : n.details) == null ? void 0 : a.publicError);
      }
    }, G(this, du, Ce().getLoggerManager());
  }
  showAcquisitionFailedMessage(t, r) {
    var s;
    const n = r ?? vw(yE, 0, 0), { linked: a } = Le();
    if (S(this, du).log(lN({ metadata: { errorCode: n.code() } })), a) {
      const c = {
        ...[Wr.Retry, Wr.Failed].includes(t) ? { errorCode: n.code() } : void 0,
        acquisitionStatus: t
      };
      S(this, du).log(
        lN({
          metadata: {
            errorCode: "",
            ...c
          }
        })
      );
    }
    const { title: i, message: o } = Tw[n.legacyCode()];
    mt.showMessageIfPossible({
      type: Fr.Error,
      id: ct.AcquisitionFailed,
      date: /* @__PURE__ */ new Date(),
      transactionId: Ec(),
      title: y(i.label, { id: i.id }),
      message: y(o.label, { id: o.id }),
      closable: !1,
      errorCode: n.code()
    }), ev(kg.Error, n), !a && IZ((s = Ce().getConfiguration().getSettings().redirects) == null ? void 0 : s.error);
  }
  showAcquisitionSuccessMessage(t) {
    var a;
    const { linked: r } = Le(), { redirects: n } = Ce().getConfiguration().getSettings();
    r && S(this, du).log(
      oL({
        metadata: {
          acquisitionStatus: t
        }
      })
    ), !r && !(n != null && n.success) && mt.showMessageIfPossible({
      type: Fr.Success,
      id: ct.AcquisitionSuccessful,
      title: y("Success", {
        id: "title.success"
      }),
      message: y("Thank you. You may now close your browser.", {
        id: "success.paragraph"
      }),
      closable: !1
    }), ev(kg.Success), !(r || !(n != null && n.success)) && DO((a = Ce().getConfiguration().getSettings().redirects) == null ? void 0 : a.success);
  }
  getTokenExpiredMessage$() {
    return Pve().pipe(
      at((t) => t),
      ae(() => {
        const t = Ce().getConfiguration().getSettings().redirects;
        if (t != null && t.error) {
          IZ(t.error);
          return;
        }
        mt.showMessageIfPossible({
          type: Fr.Error,
          id: ct.SessionExpired,
          date: /* @__PURE__ */ new Date(),
          transactionId: Ec(),
          title: y("Session expired", {
            id: "error.9210.title"
          }),
          message: y("Sorry, your session has expired, and we are unable to continue.", {
            id: "error.9210.description"
          }),
          errorCode: "9210",
          closable: !1
        });
      }),
      te(() => {
      })
    );
  }
  embargoedCountryMessage() {
    mt.showMessageIfPossible({
      type: Fr.Error,
      id: ct.EmbargoedCountry,
      date: /* @__PURE__ */ new Date(),
      transactionId: Ec(),
      title: "451 Exception",
      message: "Unavailable for legal reasons",
      closable: !1
    });
  }
}
du = new WeakMap();
var La, cc, Ev, Ks, jc, Mj, Gj, d2, xj;
class uke {
  constructor(t, r) {
    E(this, jc);
    E(this, La);
    E(this, cc);
    E(this, Ev, new _e());
    E(this, Ks);
    E(this, d2, (t) => {
      const { status: r } = t, n = {
        locale: S(this, La).locale,
        accountId: S(this, La).accountId,
        workflowId: S(this, La).workflowId,
        workflowExecutionId: S(this, La).workflowExecutionId
      };
      switch (r) {
        case Wr.Success:
        case Wr.Pending:
          return S(this, La).dispatchEvent(Dj(n));
        case Wr.Failed:
          return S(this, La).dispatchEvent(Jj(n));
        case Wr.Retry:
          return S(this, La).dispatchEvent(ske(n));
        default:
          return !1;
      }
    });
    G(this, La, t), G(this, cc, r), this.acquisitionStatusPolling$ = O(this, jc, Gj).call(this), this.locale$ = O(this, jc, xj).call(this), this.stepChange$ = Ce().selectStepChange$(), G(this, Ev, new _e()), t.addController(this), G(this, Ks, new dke()), this.tokenExpiredMessage$ = S(this, Ks).getTokenExpiredMessage$();
  }
  getWorkflowController() {
    return Ce();
  }
  hostDisconnected() {
    S(this, Ev).next();
  }
  async updateWorkflowParams(t = Le()) {
    if ("token" in t || "baseUrl" in t || "dc" in t) {
      const { baseUrl: n, locale: a, linked: i, sessionUrl: o } = Le();
      if (mt.clearMessage(), xye(), eo({
        baseUrl: n,
        locale: a,
        linked: i,
        sessionUrl: o,
        ...t
      }), !await Be(XH(), {
        defaultValue: !1
      }))
        return;
      const c = await Be(Ce().checkAcquisitionStatus$(), {
        defaultValue: {
          status: Wr.NotStarted
        }
      });
      S(this, Ks).showAcquisitionStatus(c), c.status === Wr.NotStarted && await Be(O(this, jc, Mj).call(this), {
        defaultValue: void 0
      }), S(this, cc).value && Te.workflowRestarted(S(this, cc).value, {});
    } else
      eo(t);
  }
}
La = new WeakMap(), cc = new WeakMap(), Ev = new WeakMap(), Ks = new WeakMap(), jc = new WeakSet(), Mj = function() {
  return Ce().getConfiguration().fetchSettings$().pipe(
    go(ug()),
    ae(([t, r]) => {
      if (S(this, cc).value) {
        const {
          acquisitionReference: n,
          workflowDefinitionKey: a,
          credentials: i,
          merchantSettings: { datadog: o } = {}
        } = t, { linked: s, locale: c } = r;
        Te.settings(S(this, cc).value, {
          metadata: { credentials: i },
          tags: {
            scanReference: n,
            workflow: a,
            linked: s,
            locale: c,
            customerName: o == null ? void 0 : o.merchantName
          }
        }), ev(kg.Loaded);
      }
    }),
    te(([t]) => t),
    ti((t) => t.details.httpStatus == 451 ? (S(this, Ks).embargoedCountryMessage(), ba) : (S(this, Ks).showAcquisitionFailedMessage(
      Wr.NotStarted,
      vw(B_, Kr.SettingsCall, 0)
    ), ba))
  );
}, Gj = function() {
  return Ce().checkAcquisitionStatusPolling$().pipe(
    at(({ status: t }) => t !== Wr.NotStarted),
    ae((t) => {
      S(this, Ks).showAcquisitionStatus(t);
    }),
    ae((t) => S(this, d2).call(this, t)),
    te(({ status: t }) => t),
    ae((t) => {
      eo({ acquisitionStatus: t, finalized: !0 });
    })
  );
}, d2 = new WeakMap(), xj = function() {
  return ug().pipe(
    te((t) => t.locale),
    vt(),
    Wt((t) => {
      const r = S(this, La).locale ?? t;
      return S(this, La).locale = r, rke(r);
    })
  );
};
const BZ = (e) => Object.values(qi).includes(e), hke = (e) => Object.values(Y).includes(e), Hj = (e = On()) => {
  var a;
  const t = ((a = e == null ? void 0 : e.merchantSettings) == null ? void 0 : a.crossDeviceOnly) ?? !1, { linked: r } = Le(), n = dm();
  return t && !(r || n);
}, pke = Symbol("workflow-controller-context"), Lj = Symbol("workflow-step-start-controller-context"), gke = Symbol("workflow-step-document-controller-context"), fke = Symbol("workflow-step-id-controller-context"), mke = Symbol("workflow-step-facemap-controller-context"), vke = Symbol("workflow-step-finish-controller-context"), zQ = Symbol("workflow-navigation-service-context"), Ske = (e) => {
  mt.showMessageIfPossible({
    id: ct.CameraNotAllowedError,
    type: Fr.Error,
    title: y("Camera access blocked", {
      id: "error.camera-not-allowed.title"
    }),
    message: y(
      "Your request to access the camera was blocked. This usually occurs if you have not granted permission for its use, or if your browser settings restrict access.",
      {
        id: "error.camera-not-allowed.description"
      }
    ),
    errorCode: e.name,
    closable: !0,
    date: /* @__PURE__ */ new Date(),
    transactionId: Ec()
  });
}, Ike = (e) => {
  mt.showMessageIfPossible({
    id: ct.CameraGenericError,
    type: Fr.Error,
    title: y("No camera available", {
      id: "error.camera-not-readable.title"
    }),
    message: y("This may be caused by an issue with your camera or its permissions.", {
      id: "error.camera-not-readable.description"
    }),
    errorCode: e.name,
    closable: !0,
    date: /* @__PURE__ */ new Date(),
    transactionId: Ec()
  });
};
function Cke(e) {
  if (!T2e(e)) {
    if (R2e(e)) {
      Ske(e);
      return;
    }
    if (D2e(e)) {
      Ike(e);
      return;
    }
  }
}
var Xs, Ro, u2, Yj;
class bke {
  constructor(t) {
    E(this, u2);
    E(this, Xs, new _e());
    E(this, Ro);
    G(this, Ro, t), this.workflowController = Ce(), this.loggerManager = this.workflowController.getLoggerManager(), this.reportUnhandledFetchError$ = this.getReportUnhandledFetchError$(), this.reportUnhandledError$ = this.getReportUnhandledError$(), this.cameraError$ = this.getCameraErrorMessage$(), S(this, Ro).addController(this);
  }
  logEvent(t) {
    this.loggerManager.log(t.detail);
  }
  reportEvent(t) {
    this.loggerManager.report(t.detail);
  }
  hostConnected() {
    Ke(S(this, Ro), "analytic").pipe(
      vt((t, r) => t.detail.value === r.detail.value),
      ae((t) => {
        this.logEvent(t);
      }),
      le(S(this, Xs))
    ).subscribe(), Ke(S(this, Ro), "report").pipe(
      ae((t) => {
        this.reportEvent(t);
      }),
      le(S(this, Xs))
    ).subscribe(), this.reportUnhandledFetchError$.pipe(le(S(this, Xs))).subscribe(), this.reportUnhandledError$.pipe(le(S(this, Xs))).subscribe(), this.cameraError$.pipe(le(S(this, Xs))).subscribe();
  }
  hostDisconnected() {
    S(this, Xs).next();
  }
  getReportUnhandledFetchError$() {
    return Ke(window, "unhandledrejection").pipe(
      ae((t) => {
        if (t.preventDefault(), t.reason instanceof es) {
          O(this, u2, Yj).call(this, t.reason.details.requestURI) || lL(S(this, Ro), {
            metadata: {
              error: t.reason.details
            }
          });
          return;
        }
        t.reason instanceof Error && gL(S(this, Ro), {
          metadata: {
            name: t.reason.name,
            message: t.reason.message,
            stack: t.reason.stack
          }
        });
      })
    );
  }
  getReportUnhandledError$() {
    return Ke(window, "error").pipe(
      ae((t) => {
        t.preventDefault(), t.error instanceof Error && fL(S(this, Ro), {
          metadata: {
            name: t.error.name,
            message: t.error.message,
            stack: t.error.stack
          }
        });
      })
    );
  }
  getCameraErrorMessage$() {
    return Hye().pipe(
      ae((t) => {
        this.loggerManager.log(
          sL({
            metadata: zo(
              {
                name: t.name,
                message: t.message,
                stack: t.stack,
                state: xY()
              },
              ["deviceId", "groupId", "deviceIds", "deviceEntities", "mockDeviceIds", "mockDeviceEntities"]
            )
          })
        ), Cke(t);
      })
    );
  }
}
Xs = new WeakMap(), Ro = new WeakMap(), u2 = new WeakSet(), Yj = function(t) {
  return ["analyticsevent", "reportingevent"].some((r) => t.includes(r));
};
var yke = Object.defineProperty, wke = Object.getOwnPropertyDescriptor, Oj = (e) => {
  throw TypeError(e);
}, Ake = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? wke(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && yke(t, r, a), a;
}, jj = (e, t, r) => t.has(e) || Oj("Cannot " + r), Uke = (e, t, r) => (jj(e, t, "read from private field"), r ? r.call(e) : t.get(e)), kke = (e, t, r) => t.has(e) ? Oj("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), _ke = (e, t, r, n) => (jj(e, t, "write to private field"), t.set(e, r), r), ub;
let WZ = class extends N {
  constructor() {
    super(), kke(this, ub), _ke(this, ub, new bke(this));
  }
  get componentController() {
    return Uke(this, ub);
  }
  render() {
    return w`<slot></slot>`;
  }
};
ub = /* @__PURE__ */ new WeakMap();
WZ.styles = [
  ee`
      :host {
        display: contents;
      }
    `
];
WZ = Ake([
  P("jumio-sdk-logger-sink")
], WZ);
var Qv, Fv, Tv, EZ;
class Nke {
  constructor(t) {
    E(this, Tv);
    E(this, Qv);
    E(this, Fv);
    G(this, Fv, t), G(this, Qv, Ce()), this.primaryColor$ = O(this, Tv, EZ).call(this, "primaryColor"), this.secondaryColor$ = O(this, Tv, EZ).call(this, "accentColor"), S(this, Fv).addController(this);
  }
  hostConnected() {
  }
}
Qv = new WeakMap(), Fv = new WeakMap(), Tv = new WeakSet(), EZ = function(t) {
  return S(this, Qv).getConfiguration().selectSettings$().pipe(
    te((r) => {
      var n, a;
      return (a = (n = r == null ? void 0 : r.merchantSettings) == null ? void 0 : n.branding) == null ? void 0 : a[t];
    }),
    at((r) => !!r)
  );
};
var Zke = Object.defineProperty, Bke = Object.getOwnPropertyDescriptor, Pj = (e) => {
  throw TypeError(e);
}, Wke = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? Bke(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && Zke(t, r, a), a;
}, qQ = (e, t, r) => t.has(e) || Pj("Cannot " + r), $j = (e, t, r) => (qQ(e, t, "read from private field"), r ? r.call(e) : t.get(e)), XU = (e, t, r) => t.has(e) ? Pj("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), hV = (e, t, r, n) => (qQ(e, t, "write to private field"), t.set(e, r), r), Kj = (e, t, r) => (qQ(e, t, "access private method"), r), hb, gy, fy, Xj, zj;
let _g = class extends N {
  constructor() {
    super(), XU(this, fy), XU(this, hb), XU(this, gy), hV(this, gy, new ue(this, this.componentController.primaryColor$));
  }
  get componentController() {
    return $j(this, hb) ?? hV(this, hb, new Nke(this));
  }
  render() {
    return w`
      ${Kj(this, fy, Xj).call(this)}
      <slot></slot>
    `;
  }
};
hb = /* @__PURE__ */ new WeakMap();
gy = /* @__PURE__ */ new WeakMap();
fy = /* @__PURE__ */ new WeakSet();
Xj = function() {
  var t;
  const e = ((t = $j(this, gy).value) == null ? void 0 : t.toLowerCase()) ?? _g.defaultColor;
  return e ? w`
        <style>
          ::slotted(*) {
            ${Kj(this, fy, zj).call(this, e)}
          }
        </style>
      ` : q;
};
zj = function(e, t = _g.defaultColor) {
  const r = Ule({ primary: e, font: "#fff" }).AA ? "#fff" : "#000";
  return e === t ? q : w`
          --portal-theme-light-primary-default-color: ${r};
          --portal-theme-light-primary-focus-color: ${r};
          --portal-theme-light-primary-active-color: ${r};
          --portal-theme-light-primary-disabled-color: ${_0(r, 0.2)};

          --portal-theme-dark-primary-default-color: ${r};
          --portal-theme-dark-primary-focus-color: ${r};
          --portal-theme-dark-primary-active-color: ${r};
          --portal-theme-dark-primary-disabled-color: ${_0(r, 0.2)};

          --portal-color-primary1: ${_0(KA(e, 0.5), 0.5)};
          --portal-color-primary2: ${_0(KA(e, 0.25), 0.25)};
          --portal-color-primary3: ${_0(KA(e, 0.1), 0.1)};
          --portal-color-primary4: #${e};
          --portal-color-primary5: ${XA(e, 0.1)};
          --portal-color-primary6: ${XA(e, 0.25)};
          --portal-color-primary7: ${XA(e, 0.5)};

          --portal-theme-light-clickable-primary-default-bg-color: #${e};
          --portal-theme-dark-clickable-primary-default-bg-color: #${e};
        `;
};
_g.defaultColor = "5acc29";
_g.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
_g = Wke([
  P("jumio-sdk-branding")
], _g);
var Eke = [
  // if it says it's a webview, let's go with that
  "WebView",
  // iOS webview will be the same as safari but missing "Safari"
  "(iPhone|iPod|iPad)(?!.*Safari)",
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
  "Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})",
  // old chrome android webview agent
  "Linux; U; Android"
], Qke = Eke, Fke = new RegExp("(" + Qke.join("|") + ")", "ig"), Tke = function(t) {
  return !!t.match(Fke);
};
const qj = /* @__PURE__ */ $W(Tke), eP = "LoggerConsole", pV = (e) => ({
  /* eslint-disable no-console */
  [Ee.Debug]: console.debug,
  [Ee.Error]: console.error,
  [Ee.Info]: console.info,
  [Ee.None]: console.log,
  [Ee.Trace]: console.trace,
  [Ee.Warn]: console.warn
  /* eslint-enable no-console */
})[e];
class Rke {
  constructor() {
    this.isEnabled = !1;
  }
  async log(t) {
    return this.isEnabled && pV(t.level)(t), Promise.resolve();
  }
  async report(t) {
    return this.isEnabled && pV(t.level)(t), Promise.resolve();
  }
  getId() {
    return eP;
  }
  updateConfig(t) {
    this.isEnabled = t.isEnabled;
  }
}
const pb = "LoggerDatadogRum";
var Rw = {
  log: "log",
  debug: "debug",
  info: "info",
  warn: "warn",
  error: "error"
}, il = console, Rh = {};
Object.keys(Rw).forEach(function(e) {
  Rh[e] = il[e];
});
var L0 = "Datadog Browser SDK:", Et = {
  debug: Rh.debug.bind(il, L0),
  log: Rh.log.bind(il, L0),
  info: Rh.info.bind(il, L0),
  warn: Rh.warn.bind(il, L0),
  error: Rh.error.bind(il, L0)
}, Dw = "https://docs.datadoghq.com", tP = "".concat(Dw, "/real_user_monitoring/browser/troubleshooting"), Jw = "More details:";
function rP(e, t) {
  return function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    try {
      return e.apply(void 0, r);
    } catch (a) {
      Et.error(t, a);
    }
  };
}
function Au(e) {
  return e !== 0 && Math.random() * 100 <= e;
}
function my(e, t) {
  return +e.toFixed(t);
}
function Dke(e) {
  return t0(e) && e >= 0 && e <= 100;
}
function t0(e) {
  return typeof e == "number";
}
var qn = 1e3, Wa = 60 * qn, nP = 60 * Wa, Jke = 24 * nP, Vke = 365 * Jke;
function Vw(e) {
  return { relative: e, timeStamp: Gke(e) };
}
function Mke(e) {
  return { relative: eF(e), timeStamp: e };
}
function Gke(e) {
  var t = ls() - performance.now();
  return t > jS() ? Math.round(r0(t, e)) : Hke(e);
}
function xke() {
  return Math.round(ls() - r0(jS(), performance.now()));
}
function st(e) {
  return t0(e) ? my(e * 1e6, 0) : e;
}
function ls() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function rn() {
  return ls();
}
function co() {
  return performance.now();
}
function $n() {
  return { relative: co(), timeStamp: rn() };
}
function aP() {
  return { relative: 0, timeStamp: jS() };
}
function Qn(e, t) {
  return t - e;
}
function r0(e, t) {
  return e + t;
}
function eF(e) {
  return e - jS();
}
function Hke(e) {
  return Math.round(r0(jS(), e));
}
function Lke(e) {
  return e < Vke;
}
var zU;
function jS() {
  return zU === void 0 && (zU = performance.timing.navigationStart), zU;
}
var xc = 1024, iP = 1024 * xc, Yke = /[^\u0000-\u007F]/;
function tF(e) {
  return Yke.test(e) ? window.TextEncoder !== void 0 ? new TextEncoder().encode(e).length : new Blob([e]).size : e.length;
}
function Oke(e) {
  for (var t = e.reduce(function(s, c) {
    return s + c.length;
  }, 0), r = new Uint8Array(t), n = 0, a = 0, i = e; a < i.length; a++) {
    var o = i[a];
    r.set(o, n), n += o.length;
  }
  return r;
}
function uo(e, t) {
  return e.indexOf(t) !== -1;
}
function rF(e) {
  if (Array.from)
    return Array.from(e);
  var t = [];
  if (e instanceof Set)
    e.forEach(function(n) {
      return t.push(n);
    });
  else
    for (var r = 0; r < e.length; r++)
      t.push(e[r]);
  return t;
}
function Hc(e, t) {
  for (var r = 0; r < e.length; r += 1) {
    var n = e[r];
    if (t(n, r))
      return n;
  }
}
function jke(e, t) {
  for (var r = e.length - 1; r >= 0; r -= 1) {
    var n = e[r];
    if (t(n, r, e))
      return n;
  }
}
function Pke(e, t) {
  Array.prototype.forEach.call(e, t);
}
function Mw(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
function nF(e) {
  return Object.keys(e).map(function(t) {
    return [t, e[t]];
  });
}
function PS(e, t) {
  return e.slice(0, t.length) === t;
}
function $ke(e, t) {
  return e.slice(-t.length) === t;
}
function Ge(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.forEach(function(n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
  }), e;
}
function tv(e) {
  return Ge({}, e);
}
function vy(e, t) {
  return Object.keys(e).some(function(r) {
    return e[r] === t;
  });
}
function Yu(e) {
  return Object.keys(e).length === 0;
}
function Kke(e, t) {
  for (var r = {}, n = 0, a = Object.keys(e); n < a.length; n++) {
    var i = a[n];
    r[i] = t(e[i]);
  }
  return r;
}
function cd() {
  if (typeof globalThis == "object")
    return globalThis;
  Object.defineProperty(Object.prototype, "_dd_temp_", {
    get: function() {
      return this;
    },
    configurable: !0
  });
  var e = _dd_temp_;
  return delete Object.prototype._dd_temp_, typeof e != "object" && (typeof self == "object" ? e = self : typeof window == "object" ? e = window : e = {}), e;
}
function Lc(e, t) {
  var r = cd(), n;
  return r.Zone && typeof r.Zone.__symbol__ == "function" && (n = e[r.Zone.__symbol__(t)]), n || (n = e[t]), n;
}
var Xke = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, QZ, oP = !1;
function zke(e) {
  QZ = e;
}
function qke(e) {
  oP = e;
}
function Re(e) {
  return function() {
    return Ou(e, this, arguments);
  };
}
function Ou(e, t, r) {
  try {
    return e.apply(t, r);
  } catch (n) {
    if (FZ(n), QZ)
      try {
        QZ(n);
      } catch (a) {
        FZ(a);
      }
  }
}
function FZ() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  oP && Et.error.apply(Et, Xke(["[MONITOR]"], e, !1));
}
function Nn(e, t) {
  return Lc(cd(), "setTimeout")(Re(e), t);
}
function Ui(e) {
  Lc(cd(), "clearTimeout")(e);
}
function n0(e, t) {
  return Lc(cd(), "setInterval")(Re(e), t);
}
function Gw(e) {
  Lc(cd(), "clearInterval")(e);
}
var xt = (
  /** @class */
  function() {
    function e(t) {
      this.onFirstSubscribe = t, this.observers = [];
    }
    return e.prototype.subscribe = function(t) {
      var r = this;
      return this.observers.push(t), this.observers.length === 1 && this.onFirstSubscribe && (this.onLastUnsubscribe = this.onFirstSubscribe(this) || void 0), {
        unsubscribe: function() {
          r.observers = r.observers.filter(function(n) {
            return t !== n;
          }), !r.observers.length && r.onLastUnsubscribe && r.onLastUnsubscribe();
        }
      };
    }, e.prototype.notify = function(t) {
      this.observers.forEach(function(r) {
        return r(t);
      });
    }, e;
  }()
);
function sP() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return new xt(function(r) {
    var n = e.map(function(a) {
      return a.subscribe(function(i) {
        return r.notify(i);
      });
    });
    return function() {
      return n.forEach(function(a) {
        return a.unsubscribe();
      });
    };
  });
}
function Fl(e, t, r) {
  var n = r && r.leading !== void 0 ? r.leading : !0, a = r && r.trailing !== void 0 ? r.trailing : !0, i = !1, o, s;
  return {
    throttled: function() {
      for (var c = [], l = 0; l < arguments.length; l++)
        c[l] = arguments[l];
      if (i) {
        o = c;
        return;
      }
      n ? e.apply(void 0, c) : o = c, i = !0, s = Nn(function() {
        a && o && e.apply(void 0, o), i = !1, o = void 0;
      }, t);
    },
    cancel: function() {
      Ui(s), i = !1, o = void 0;
    }
  };
}
function Dt() {
}
function Tn(e) {
  return e ? (
    // eslint-disable-next-line  no-bitwise
    (parseInt(e, 10) ^ Math.random() * 16 >> parseInt(e, 10) / 4).toString(16)
  ) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, Tn);
}
var Sy = /([\w-]+)\s*=\s*([^;]+)/g;
function rv(e, t) {
  for (Sy.lastIndex = 0; ; ) {
    var r = Sy.exec(e);
    if (r) {
      if (r[1] === t)
        return r[2];
    } else
      break;
  }
}
function e_e(e) {
  var t = /* @__PURE__ */ new Map();
  for (Sy.lastIndex = 0; ; ) {
    var r = Sy.exec(e);
    if (r)
      t.set(r[1], r[2]);
    else
      break;
  }
  return t;
}
function lP(e, t, r) {
  r === void 0 && (r = "");
  var n = e.charCodeAt(t - 1), a = n >= 55296 && n <= 56319, i = a ? t + 1 : t;
  return e.length <= i ? e : "".concat(e.slice(0, i)).concat(r);
}
function t_e() {
  return aF() === 0;
}
function r_e() {
  return aF() === 1;
}
function n_e() {
  return aF() === 2;
}
var tC;
function aF() {
  return tC ?? (tC = a_e());
}
function a_e(e) {
  var t;
  e === void 0 && (e = window);
  var r = e.navigator.userAgent;
  return e.chrome || /HeadlessChrome/.test(r) ? 1 : (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((t = e.navigator.vendor) === null || t === void 0 ? void 0 : t.indexOf("Apple")) === 0 || /safari/i.test(r) && !/chrome|android/i.test(r) ? 2 : e.document.documentMode ? 0 : 3
  );
}
function $S(e, t, r, n) {
  var a = /* @__PURE__ */ new Date();
  a.setTime(a.getTime() + r);
  var i = "expires=".concat(a.toUTCString()), o = n && n.crossSite ? "none" : "strict", s = n && n.domain ? ";domain=".concat(n.domain) : "", c = n && n.secure ? ";secure" : "", l = n && n.partitioned ? ";partitioned" : "";
  document.cookie = "".concat(e, "=").concat(t, ";").concat(i, ";path=/;samesite=").concat(o).concat(s).concat(c).concat(l);
}
function iF(e) {
  return rv(document.cookie, e);
}
var qU;
function bc(e) {
  return qU || (qU = e_e(document.cookie)), qU.get(e);
}
function cP(e, t) {
  $S(e, "", 0, t);
}
function i_e(e) {
  if (document.cookie === void 0 || document.cookie === null)
    return !1;
  try {
    var t = "dd_cookie_test_".concat(Tn()), r = "test";
    $S(t, r, Wa, e);
    var n = iF(t) === r;
    return cP(t, e), n;
  } catch (a) {
    return Et.error(a), !1;
  }
}
var ek;
function o_e() {
  if (ek === void 0) {
    for (var e = "dd_site_test_".concat(Tn()), t = "test", r = window.location.hostname.split("."), n = r.pop(); r.length && !iF(e); )
      n = "".concat(r.pop(), ".").concat(n), $S(e, t, qn, { domain: n });
    cP(e, { domain: n }), ek = n;
  }
  return ek;
}
var a0 = "_dd_s", lh = 4 * nP, dP = 15 * Wa, uP = /^([a-zA-Z]+)=([a-z0-9-]+)$/, oF = "&", s_e = "1";
function Hd() {
  return {
    isExpired: s_e
  };
}
function gb(e) {
  return Yu(e);
}
function hP(e) {
  return !gb(e);
}
function Iy(e) {
  return e.isExpired !== void 0 || !l_e(e);
}
function l_e(e) {
  return (e.created === void 0 || ls() - Number(e.created) < lh) && (e.expire === void 0 || ls() < Number(e.expire));
}
function pP(e) {
  e.expire = String(ls() + dP);
}
function sF(e) {
  return nF(e).map(function(t) {
    var r = t[0], n = t[1];
    return "".concat(r, "=").concat(n);
  }).join(oF);
}
function gP(e) {
  var t = {};
  return c_e(e) && e.split(oF).forEach(function(r) {
    var n = uP.exec(r);
    if (n !== null) {
      var a = n[1], i = n[2];
      t[a] = i;
    }
  }), t;
}
function c_e(e) {
  return !!e && (e.indexOf(oF) !== -1 || uP.test(e));
}
var d_e = "_dd", u_e = "_dd_r", h_e = "_dd_l", p_e = "rum", g_e = "logs";
function f_e(e) {
  var t = bc(a0);
  if (!t) {
    var r = bc(d_e), n = bc(u_e), a = bc(h_e), i = {};
    r && (i.id = r), a && /^[01]$/.test(a) && (i[g_e] = a), n && /^[012]$/.test(n) && (i[p_e] = n), hP(i) && (pP(i), e.persistSession(i));
  }
}
function m_e(e) {
  var t = b_e(e);
  return i_e(t) ? { type: "Cookie", cookieOptions: t } : void 0;
}
function v_e(e) {
  var t = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: r_e(),
    persistSession: S_e(e),
    retrieveSession: C_e,
    expireSession: function() {
      return I_e(e);
    }
  };
  return f_e(t), t;
}
function S_e(e) {
  return function(t) {
    $S(a0, sF(t), dP, e);
  };
}
function I_e(e) {
  $S(a0, sF(Hd()), lh, e);
}
function C_e() {
  var e = iF(a0);
  return gP(e);
}
function b_e(e) {
  var t = {};
  return t.secure = !!e.useSecureSessionCookie || !!e.usePartitionedCrossSiteSessionCookie || !!e.useCrossSiteSessionCookie, t.crossSite = !!e.usePartitionedCrossSiteSessionCookie || !!e.useCrossSiteSessionCookie, t.partitioned = !!e.usePartitionedCrossSiteSessionCookie, e.trackSessionAcrossSubdomains && (t.domain = o_e()), t;
}
var y_e = "_dd_test_";
function w_e() {
  try {
    var e = Tn(), t = "".concat(y_e).concat(e);
    localStorage.setItem(t, e);
    var r = localStorage.getItem(t);
    return localStorage.removeItem(t), e === r ? { type: "LocalStorage" } : void 0;
  } catch {
    return;
  }
}
function A_e() {
  return {
    isLockEnabled: !1,
    persistSession: fP,
    retrieveSession: U_e,
    expireSession: k_e
  };
}
function fP(e) {
  localStorage.setItem(a0, sF(e));
}
function U_e() {
  var e = localStorage.getItem(a0);
  return gP(e);
}
function k_e() {
  fP(Hd());
}
var __e = 10, N_e = 100, mP = [], fb;
function Ld(e, t, r) {
  var n;
  r === void 0 && (r = 0);
  var a = t.isLockEnabled, i = t.persistSession, o = t.expireSession, s = function(p) {
    return i(Ge({}, p, { lock: l }));
  }, c = function() {
    var p = t.retrieveSession(), m = p.lock;
    return p.lock && delete p.lock, {
      session: p,
      lock: m
    };
  };
  if (fb || (fb = e), e !== fb) {
    mP.push(e);
    return;
  }
  if (a && r >= N_e) {
    gV(t);
    return;
  }
  var l, u = c();
  if (a) {
    if (u.lock) {
      rC(e, t, r);
      return;
    }
    if (l = Tn(), s(u.session), u = c(), u.lock !== l) {
      rC(e, t, r);
      return;
    }
  }
  var g = e.process(u.session);
  if (a && (u = c(), u.lock !== l)) {
    rC(e, t, r);
    return;
  }
  if (g && (Iy(g) ? o() : (pP(g), a ? s(g) : i(g))), a && !(g && Iy(g))) {
    if (u = c(), u.lock !== l) {
      rC(e, t, r);
      return;
    }
    i(u.session), g = u.session;
  }
  (n = e.after) === null || n === void 0 || n.call(e, g || u.session), gV(t);
}
function rC(e, t, r) {
  Nn(function() {
    Ld(e, t, r + 1);
  }, __e);
}
function gV(e) {
  fb = void 0;
  var t = mP.shift();
  t && Ld(t, e);
}
var fV = qn;
function Z_e(e) {
  var t = m_e(e);
  return !t && e.allowFallbackToLocalStorage && (t = w_e()), t;
}
function B_e(e, t, r) {
  var n = new xt(), a = new xt(), i = new xt(), o = e.type === "Cookie" ? v_e(e.cookieOptions) : A_e(), s = o.expireSession, c = n0(I, fV), l;
  A();
  var u = Fl(function() {
    Ld({
      process: function(R) {
        if (!gb(R)) {
          var ge = C(R);
          return U(ge), ge;
        }
      },
      after: function(R) {
        hP(R) && !B() && L(R), l = R;
      }
    }, o);
  }, fV), g = u.throttled, p = u.cancel;
  function m() {
    Ld({
      process: function(R) {
        return B() ? C(R) : void 0;
      }
    }, o);
  }
  function I() {
    Ld({
      process: function(R) {
        return Iy(R) ? Hd() : void 0;
      },
      after: C
    }, o);
  }
  function C(R) {
    return Iy(R) && (R = Hd()), B() && (J(R) ? W() : (i.notify({ previousState: l, newState: R }), l = R)), R;
  }
  function A() {
    Ld({
      process: function(R) {
        if (gb(R))
          return Hd();
      },
      after: function(R) {
        l = R;
      }
    }, o);
  }
  function U(R) {
    if (gb(R))
      return !1;
    var ge = r(R[t]), z = ge.trackingType, K = ge.isTracked;
    R[t] = z, delete R.isExpired, K && !R.id && (R.id = Tn(), R.created = String(ls()));
  }
  function B() {
    return l[t] !== void 0;
  }
  function J(R) {
    return l.id !== R.id || l[t] !== R[t];
  }
  function W() {
    l = Hd(), a.notify();
  }
  function L(R) {
    l = R, n.notify();
  }
  function H(R) {
    Ld({
      process: function(ge) {
        return Ge({}, ge, R);
      },
      after: C
    }, o);
  }
  return {
    expandOrRenewSession: g,
    expandSession: m,
    getSession: function() {
      return l;
    },
    renewObservable: n,
    expireObservable: a,
    sessionStateUpdateObservable: i,
    restartSession: A,
    expire: function() {
      p(), s(), C(Hd());
    },
    stop: function() {
      Gw(c);
    },
    updateSessionState: H
  };
}
var TZ = {
  GRANTED: "granted",
  NOT_GRANTED: "not-granted"
};
function W_e(e) {
  var t = new xt();
  return {
    tryToInit: function(r) {
      e || (e = r);
    },
    update: function(r) {
      e = r, t.notify();
    },
    isGranted: function() {
      return e === TZ.GRANTED;
    },
    observable: t
  };
}
function ch(e, t, r) {
  if (typeof e != "object" || e === null)
    return JSON.stringify(e);
  var n = ep(Object.prototype), a = ep(Array.prototype), i = ep(Object.getPrototypeOf(e)), o = ep(e);
  try {
    return JSON.stringify(e, t, r);
  } catch {
    return "<error: unable to serialize object>";
  } finally {
    n(), a(), i(), o();
  }
}
function ep(e) {
  var t = e, r = t.toJSON;
  return r ? (delete t.toJSON, function() {
    t.toJSON = r;
  }) : Dt;
}
function lF(e) {
  return xw(e, location.href).href;
}
function E_e(e) {
  try {
    return !!xw(e);
  } catch {
    return !1;
  }
}
function Q_e(e) {
  var t = xw(e).pathname;
  return t[0] === "/" ? t : "/".concat(t);
}
function xw(e, t) {
  var r = F_e();
  if (r)
    try {
      return t !== void 0 ? new r(e, t) : new r(e);
    } catch (o) {
      throw new Error("Failed to construct URL: ".concat(String(o), " ").concat(ch({ url: e, base: t })));
    }
  if (t === void 0 && !/:/.test(e))
    throw new Error("Invalid URL: '".concat(e, "'"));
  var n = document, a = n.createElement("a");
  if (t !== void 0) {
    n = document.implementation.createHTMLDocument("");
    var i = n.createElement("base");
    i.href = t, n.head.appendChild(i), n.body.appendChild(a);
  }
  return a.href = e, a;
}
var mV = URL, nC;
function F_e() {
  if (nC === void 0)
    try {
      var e = new mV("http://test/path");
      nC = e.href === "http://test/path";
    } catch {
      nC = !1;
    }
  return nC ? mV : void 0;
}
var vP = "datad0g.com", T_e = "dd0g-gov.com", yc = "datadoghq.com", R_e = "datadoghq.eu", D_e = "ddog-gov.com", SP = "pci.browser-intake-datadoghq.com";
function $f(e, t, r) {
  var n = J_e(e, t);
  return {
    build: function(a, i) {
      var o = M_e(e, t, r, a, i);
      return n(o);
    },
    urlPrefix: n(""),
    trackType: t
  };
}
function J_e(e, t) {
  var r = "/api/v2/".concat(t), n = e.proxy;
  if (typeof n == "string") {
    var a = lF(n);
    return function(o) {
      return "".concat(a, "?ddforward=").concat(encodeURIComponent("".concat(r, "?").concat(o)));
    };
  }
  if (typeof n == "function")
    return function(o) {
      return n({ path: r, parameters: o });
    };
  var i = V_e(t, e);
  return function(o) {
    return "https://".concat(i).concat(r, "?").concat(o);
  };
}
function V_e(e, t) {
  var r = t.site, n = r === void 0 ? yc : r, a = t.internalAnalyticsSubdomain;
  if (e === "logs" && t.usePciIntake && n === yc)
    return SP;
  if (a && n === yc)
    return "".concat(a, ".").concat(yc);
  if (n === T_e)
    return "http-intake.logs.".concat(n);
  var i = n.split("."), o = i.pop();
  return "browser-intake-".concat(i.join("-"), ".").concat(o);
}
function M_e(e, t, r, n, a) {
  var i = e.clientToken, o = e.internalAnalyticsSubdomain, s = a.retry, c = a.encoding, l = ["sdk_version:".concat("5.28.0"), "api:".concat(n)].concat(r);
  s && l.push("retry_count:".concat(s.count), "retry_after:".concat(s.lastFailureStatus));
  var u = [
    "ddsource=browser",
    "ddtags=".concat(encodeURIComponent(l.join(","))),
    "dd-api-key=".concat(i),
    "dd-evp-origin-version=".concat(encodeURIComponent("5.28.0")),
    "dd-evp-origin=browser",
    "dd-request-id=".concat(Tn())
  ];
  return c && u.push("dd-evp-encoding=".concat(c)), t === "rum" && u.push("batch_time=".concat(rn())), o && u.reverse(), u.join("&");
}
var G_e = 200;
function x_e(e) {
  var t = e.env, r = e.service, n = e.version, a = e.datacenter, i = [];
  return t && i.push(aC("env", t)), r && i.push(aC("service", r)), n && i.push(aC("version", n)), a && i.push(aC("datacenter", a)), i;
}
function aC(e, t) {
  var r = G_e - e.length - 1;
  (t.length > r || H_e(t)) && Et.warn("".concat(e, " value doesn't meet tag requirements and will be sanitized. ").concat(Jw, " ").concat(Dw, "/getting_started/tagging/#defining-tags"));
  var n = t.replace(/,/g, "_");
  return "".concat(e, ":").concat(n);
}
function H_e(e) {
  return L_e() ? new RegExp("[^\\p{Ll}\\p{Lo}0-9_:./-]", "u").test(e) : !1;
}
function L_e() {
  try {
    return new RegExp("[\\p{Ll}]", "u"), !0;
  } catch {
    return !1;
  }
}
function Y_e(e) {
  var t = e.site || yc, r = x_e(e), n = O_e(e, r), a = P_e(n, t), i = j_e(e, a, r);
  return Ge({
    isIntakeUrl: function(o) {
      return a.some(function(s) {
        return o.indexOf(s) === 0;
      });
    },
    replica: i,
    site: t
  }, n);
}
function O_e(e, t) {
  return {
    logsEndpointBuilder: $f(e, "logs", t),
    rumEndpointBuilder: $f(e, "rum", t),
    sessionReplayEndpointBuilder: $f(e, "replay", t)
  };
}
function j_e(e, t, r) {
  if (e.replica) {
    var n = Ge({}, e, {
      site: yc,
      clientToken: e.replica.clientToken
    }), a = {
      logsEndpointBuilder: $f(n, "logs", r),
      rumEndpointBuilder: $f(n, "rum", r)
    };
    return t.push.apply(t, Mw(a).map(function(i) {
      return i.urlPrefix;
    })), Ge({ applicationId: e.replica.applicationId }, a);
  }
}
function P_e(e, t) {
  var r = Mw(e).map(function(n) {
    return n.urlPrefix;
  });
  return t === yc && r.push("https://".concat(SP, "/")), r;
}
var Kf = {
  ALLOW: "allow",
  MASK: "mask",
  MASK_USER_INPUT: "mask-user-input"
}, RZ = {
  ALL: "all",
  SAMPLED: "sampled"
};
function tk(e, t) {
  return e != null && typeof e != "string" ? (Et.error("".concat(t, " must be defined as a string")), !1) : !0;
}
function $_e(e) {
  return e && typeof e == "string" && !/(datadog|ddog|datad0g|dd0g)/.test(e) ? (Et.error("Site should be a valid Datadog site. ".concat(Jw, " ").concat(Dw, "/getting_started/site/.")), !1) : !0;
}
function tp(e, t) {
  return e !== void 0 && !Dke(e) ? (Et.error("".concat(t, " Sample Rate should be a number between 0 and 100")), !1) : !0;
}
function K_e(e) {
  var t, r, n, a, i;
  if (!e || !e.clientToken) {
    Et.error("Client Token is not configured, we will not send any data.");
    return;
  }
  if (!(!$_e(e.site) || !tp(e.sessionSampleRate, "Session") || !tp(e.telemetrySampleRate, "Telemetry") || !tp(e.telemetryConfigurationSampleRate, "Telemetry Configuration") || !tp(e.telemetryUsageSampleRate, "Telemetry Usage") || !tk(e.version, "Version") || !tk(e.env, "Env") || !tk(e.service, "Service"))) {
    if (e.trackingConsent !== void 0 && !vy(TZ, e.trackingConsent)) {
      Et.error('Tracking Consent should be either "granted" or "not-granted"');
      return;
    }
    return Ge({
      beforeSend: e.beforeSend && rP(e.beforeSend, "beforeSend threw an error:"),
      sessionStoreStrategyType: Z_e(e),
      sessionSampleRate: (t = e.sessionSampleRate) !== null && t !== void 0 ? t : 100,
      telemetrySampleRate: (r = e.telemetrySampleRate) !== null && r !== void 0 ? r : 20,
      telemetryConfigurationSampleRate: (n = e.telemetryConfigurationSampleRate) !== null && n !== void 0 ? n : 5,
      telemetryUsageSampleRate: (a = e.telemetryUsageSampleRate) !== null && a !== void 0 ? a : 5,
      service: e.service || void 0,
      silentMultipleInit: !!e.silentMultipleInit,
      allowUntrustedEvents: !!e.allowUntrustedEvents,
      trackingConsent: (i = e.trackingConsent) !== null && i !== void 0 ? i : TZ.GRANTED,
      storeContextsAcrossPages: !!e.storeContextsAcrossPages,
      /**
       * beacon payload max queue size implementation is 64kb
       * ensure that we leave room for logs, rum and potential other users
       */
      batchBytesLimit: 16 * xc,
      eventRateLimiterThreshold: 3e3,
      maxTelemetryEventsPerPage: 15,
      /**
       * flush automatically, aim to be lower than ALB connection timeout
       * to maximize connection reuse.
       */
      flushTimeout: 30 * qn,
      /**
       * Logs intake limit
       */
      batchMessagesLimit: 50,
      messageBytesLimit: 256 * xc
    }, Y_e(e));
  }
}
function X_e(e) {
  return {
    session_sample_rate: e.sessionSampleRate,
    telemetry_sample_rate: e.telemetrySampleRate,
    telemetry_configuration_sample_rate: e.telemetryConfigurationSampleRate,
    telemetry_usage_sample_rate: e.telemetryUsageSampleRate,
    use_before_send: !!e.beforeSend,
    use_cross_site_session_cookie: e.useCrossSiteSessionCookie,
    use_partitioned_cross_site_session_cookie: e.usePartitionedCrossSiteSessionCookie,
    use_secure_session_cookie: e.useSecureSessionCookie,
    use_proxy: !!e.proxy,
    silent_multiple_init: e.silentMultipleInit,
    track_session_across_subdomains: e.trackSessionAcrossSubdomains,
    allow_fallback_to_local_storage: !!e.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!e.storeContextsAcrossPages,
    allow_untrusted_events: !!e.allowUntrustedEvents,
    tracking_consent: e.trackingConsent
  };
}
var Yc;
(function(e) {
  e.WRITABLE_RESOURCE_GRAPHQL = "writable_resource_graphql", e.REMOTE_CONFIGURATION = "remote_configuration", e.UPDATE_VIEW_NAME = "update_view_name", e.LONG_ANIMATION_FRAME = "long_animation_frame";
})(Yc || (Yc = {}));
var cF = /* @__PURE__ */ new Set();
function z_e(e) {
  Array.isArray(e) && q_e(e.filter(function(t) {
    return vy(Yc, t);
  }));
}
function q_e(e) {
  e.forEach(function(t) {
    cF.add(t);
  });
}
function KS(e) {
  return cF.has(e);
}
function eNe() {
  return cF;
}
var XS = "?";
function dd(e) {
  var t = [], r = rk(e, "stack"), n = String(e);
  return r && PS(r, n) && (r = r.slice(n.length)), r && r.split(`
`).forEach(function(a) {
    var i = nNe(a) || iNe(a) || sNe(a) || dNe(a);
    i && (!i.func && i.line && (i.func = XS), t.push(i));
  }), {
    message: rk(e, "message"),
    name: rk(e, "name"),
    stack: t
  };
}
var IP = "((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)", Ng = "(?::(\\d+))", tNe = new RegExp("^\\s*at (.*?) ?\\(".concat(IP).concat(Ng, "?").concat(Ng, "?\\)?\\s*$"), "i"), rNe = new RegExp("\\((\\S*)".concat(Ng).concat(Ng, "\\)"));
function nNe(e) {
  var t = tNe.exec(e);
  if (t) {
    var r = t[2] && t[2].indexOf("native") === 0, n = t[2] && t[2].indexOf("eval") === 0, a = rNe.exec(t[2]);
    return n && a && (t[2] = a[1], t[3] = a[2], t[4] = a[3]), {
      args: r ? [t[2]] : [],
      column: t[4] ? +t[4] : void 0,
      func: t[1] || XS,
      line: t[3] ? +t[3] : void 0,
      url: r ? void 0 : t[2]
    };
  }
}
var aNe = new RegExp("^\\s*at ?".concat(IP).concat(Ng, "?").concat(Ng, "??\\s*$"), "i");
function iNe(e) {
  var t = aNe.exec(e);
  if (t)
    return {
      args: [],
      column: t[3] ? +t[3] : void 0,
      func: XS,
      line: t[2] ? +t[2] : void 0,
      url: t[1]
    };
}
var oNe = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function sNe(e) {
  var t = oNe.exec(e);
  if (t)
    return {
      args: [],
      column: t[4] ? +t[4] : void 0,
      func: t[1] || XS,
      line: +t[3],
      url: t[2]
    };
}
var lNe = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, cNe = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function dNe(e) {
  var t = lNe.exec(e);
  if (t) {
    var r = t[3] && t[3].indexOf(" > eval") > -1, n = cNe.exec(t[3]);
    return r && n && (t[3] = n[1], t[4] = n[2], t[5] = void 0), {
      args: t[2] ? t[2].split(",") : [],
      column: t[5] ? +t[5] : void 0,
      func: t[1] || XS,
      line: t[4] ? +t[4] : void 0,
      url: t[3]
    };
  }
}
function rk(e, t) {
  if (!(typeof e != "object" || !e || !(t in e))) {
    var r = e[t];
    return typeof r == "string" ? r : void 0;
  }
}
function uNe(e, t, r, n) {
  var a = [{ url: t, column: n, line: r }], i = pNe(e), o = i.name, s = i.message;
  return {
    name: o,
    message: s,
    stack: a
  };
}
var hNe = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function pNe(e) {
  var t, r, n;
  return {}.toString.call(e) === "[object String]" && (t = hNe.exec(e), r = t[1], n = t[2]), { name: r, message: n };
}
function Cy() {
  var e = 2, t = new Error(), r;
  if (!t.stack)
    try {
      throw t;
    } catch {
    }
  return Ou(function() {
    var n = dd(t);
    n.stack = n.stack.slice(e), r = i0(n);
  }), r;
}
function i0(e) {
  var t = CP(e);
  return e.stack.forEach(function(r) {
    var n = r.func === "?" ? "<anonymous>" : r.func, a = r.args && r.args.length > 0 ? "(".concat(r.args.join(", "), ")") : "", i = r.line ? ":".concat(r.line) : "", o = r.line && r.column ? ":".concat(r.column) : "";
    t += `
  at `.concat(n).concat(a, " @ ").concat(r.url).concat(i).concat(o);
  }), t;
}
function CP(e) {
  return "".concat(e.name || "Error", ": ").concat(e.message);
}
function va(e, t, r, n) {
  var a = n === void 0 ? {} : n, i = a.computeHandlingStack, o = e[t];
  if (typeof o != "function")
    if (t in e && PS(t, "on"))
      o = Dt;
    else
      return { stop: Dt };
  var s = !1, c = function() {
    if (s)
      return o.apply(this, arguments);
    var l = rF(arguments), u;
    Ou(r, null, [
      {
        target: this,
        parameters: l,
        onPostCall: function(p) {
          u = p;
        },
        handlingStack: i ? Cy() : void 0
      }
    ]);
    var g = o.apply(this, l);
    return u && Ou(u, null, [g]), g;
  };
  return e[t] = c, {
    stop: function() {
      s = !0, e[t] === c && (e[t] = o);
    }
  };
}
function Y0(e, t, r) {
  var n = Object.getOwnPropertyDescriptor(e, t);
  if (!n || !n.set || !n.configurable)
    return { stop: Dt };
  var a = Dt, i = function(s, c) {
    Nn(function() {
      i !== a && r(s, c);
    }, 0);
  }, o = function(s) {
    n.set.call(this, s), i(this, s);
  };
  return Object.defineProperty(e, t, {
    set: o
  }), {
    stop: function() {
      var s;
      ((s = Object.getOwnPropertyDescriptor(e, t)) === null || s === void 0 ? void 0 : s.set) === o && Object.defineProperty(e, t, n), i = a;
    }
  };
}
var gNe = 220 * xc, fNe = "$", mNe = 3;
function Sr(e, t) {
  t === void 0 && (t = gNe);
  var r = ep(Object.prototype), n = ep(Array.prototype), a = [], i = /* @__PURE__ */ new WeakMap(), o = nk(e, fNe, void 0, a, i), s = JSON.stringify(o), c = s ? s.length : 0;
  if (c > t) {
    ak(t, "discarded", e);
    return;
  }
  for (; a.length > 0 && c < t; ) {
    var l = a.shift(), u = 0;
    if (Array.isArray(l.source))
      for (var g = 0; g < l.source.length; g++) {
        var p = nk(l.source[g], l.path, g, a, i);
        if (p !== void 0 ? c += JSON.stringify(p).length : c += 4, c += u, u = 1, c > t) {
          ak(t, "truncated", e);
          break;
        }
        l.target[g] = p;
      }
    else
      for (var g in l.source)
        if (Object.prototype.hasOwnProperty.call(l.source, g)) {
          var p = nk(l.source[g], l.path, g, a, i);
          if (p !== void 0 && (c += JSON.stringify(p).length + u + g.length + mNe, u = 1), c > t) {
            ak(t, "truncated", e);
            break;
          }
          l.target[g] = p;
        }
  }
  return r(), n(), o;
}
function nk(e, t, r, n, a) {
  var i = INe(e);
  if (!i || typeof i != "object")
    return vNe(i);
  var o = SNe(i);
  if (o !== "[Object]" && o !== "[Array]" && o !== "[Error]")
    return o;
  var s = e;
  if (a.has(s))
    return "[Reference seen at ".concat(a.get(s), "]");
  var c = r !== void 0 ? "".concat(t, ".").concat(r) : t, l = Array.isArray(i) ? [] : {};
  return a.set(s, c), n.push({ source: i, target: l, path: c }), l;
}
function vNe(e) {
  return typeof e == "bigint" ? "[BigInt] ".concat(e.toString()) : typeof e == "function" ? "[Function] ".concat(e.name || "unknown") : typeof e == "symbol" ? "[Symbol] ".concat(e.description || e.toString()) : e;
}
function SNe(e) {
  try {
    if (e instanceof Event)
      return {
        isTrusted: e.isTrusted
      };
    var t = Object.prototype.toString.call(e), r = t.match(/\[object (.*)\]/);
    if (r && r[1])
      return "[".concat(r[1], "]");
  } catch {
  }
  return "[Unserializable]";
}
function INe(e) {
  var t = e;
  if (t && typeof t.toJSON == "function")
    try {
      return t.toJSON();
    } catch {
    }
  return e;
}
function ak(e, t, r) {
  Et.warn("The data provided has been ".concat(t, " as it is over the limit of ").concat(e, " characters:"), r);
}
var bP = "No stack, consider using an instance of Error";
function yP(e) {
  var t = e.stackTrace, r = e.originalError, n = e.handlingStack, a = e.startClocks, i = e.nonErrorPrefix, o = e.source, s = e.handling, c = r instanceof Error, l = CNe(t, c, i, r), u = bNe(c, t) ? i0(t) : bP, g = c ? AP(r, o) : void 0, p = t ? t.name : void 0, m = wP(r);
  return {
    startClocks: a,
    source: o,
    handling: s,
    handlingStack: n,
    originalError: r,
    type: p,
    message: l,
    stack: u,
    causes: g,
    fingerprint: m
  };
}
function CNe(e, t, r, n) {
  return e != null && e.message && (e != null && e.name) ? e.message : t ? "Empty message" : "".concat(r, " ").concat(ch(Sr(n)));
}
function bNe(e, t) {
  return t === void 0 ? !1 : e ? !0 : t.stack.length > 0 && (t.stack.length > 1 || t.stack[0].url !== void 0);
}
function wP(e) {
  return e instanceof Error && "dd_fingerprint" in e ? String(e.dd_fingerprint) : void 0;
}
function AP(e, t) {
  for (var r = e, n = []; (r == null ? void 0 : r.cause) instanceof Error && n.length < 10; ) {
    var a = dd(r.cause);
    n.push({
      message: r.cause.message,
      source: t,
      type: a == null ? void 0 : a.name,
      stack: a && i0(a)
    }), r = r.cause;
  }
  return n.length ? n : void 0;
}
var o0 = {
  AGENT: "agent",
  CONSOLE: "console",
  CUSTOM: "custom",
  LOGGER: "logger",
  NETWORK: "network",
  SOURCE: "source",
  REPORT: "report"
};
function yNe(e) {
  var t = function(a, i) {
    var o = yP({
      stackTrace: a,
      originalError: i,
      startClocks: $n(),
      nonErrorPrefix: "Uncaught",
      source: o0.SOURCE,
      handling: "unhandled"
    });
    e.notify(o);
  }, r = wNe(t).stop, n = ANe(t).stop;
  return {
    stop: function() {
      r(), n();
    }
  };
}
function wNe(e) {
  return va(window, "onerror", function(t) {
    var r = t.parameters, n = r[0], a = r[1], i = r[2], o = r[3], s = r[4], c;
    s instanceof Error ? c = dd(s) : c = uNe(n, a, i, o), e(c, s ?? n);
  });
}
function ANe(e) {
  return va(window, "onunhandledrejection", function(t) {
    var r = t.parameters[0], n = r.reason || "Empty reason", a = dd(n);
    e(a, n);
  });
}
function UNe(e) {
  var t = Ge({
    version: "5.28.0",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function(r) {
      r();
    }
  }, e);
  return Object.defineProperty(t, "_setDebug", {
    get: function() {
      return qke;
    },
    enumerable: !1
  }), t;
}
function kNe(e, t, r) {
  var n = e[t];
  n && !n.q && n.version && Et.warn("SDK is loaded more than once. This is unsupported and might have unexpected behavior."), e[t] = r, n && n.q && n.q.forEach(function(a) {
    return rP(a, "onReady callback threw an error:")();
  });
}
function UP(e, t) {
  t.silentMultipleInit || Et.error("".concat(e, " is already initialized."));
}
function tr(e, t, r, n, a) {
  return Ua(e, t, [r], n, a);
}
function Ua(e, t, r, n, a) {
  var i = a === void 0 ? {} : a, o = i.once, s = i.capture, c = i.passive, l = Re(function(m) {
    !m.isTrusted && !m.__ddIsTrusted && !e.allowUntrustedEvents || (o && p(), n(m));
  }), u = c ? { capture: s, passive: c } : s, g = Lc(t, "addEventListener");
  r.forEach(function(m) {
    return g.call(t, m, l, u);
  });
  function p() {
    var m = Lc(t, "removeEventListener");
    r.forEach(function(I) {
      return m.call(t, I, l, u);
    });
  }
  return {
    stop: p
  };
}
var nv = {
  intervention: "intervention",
  deprecation: "deprecation",
  cspViolation: "csp_violation"
};
function _Ne(e, t) {
  var r = [];
  uo(t, nv.cspViolation) && r.push(ZNe(e));
  var n = t.filter(function(a) {
    return a !== nv.cspViolation;
  });
  return n.length && r.push(NNe(n)), sP.apply(void 0, r);
}
function NNe(e) {
  return new xt(function(t) {
    if (window.ReportingObserver) {
      var r = Re(function(a, i) {
        return a.forEach(function(o) {
          return t.notify(BNe(o));
        });
      }), n = new window.ReportingObserver(r, {
        types: e,
        buffered: !0
      });
      return n.observe(), function() {
        n.disconnect();
      };
    }
  });
}
function ZNe(e) {
  return new xt(function(t) {
    var r = tr(e, document, "securitypolicyviolation", function(n) {
      t.notify(WNe(n));
    }).stop;
    return r;
  });
}
function BNe(e) {
  var t = e.type, r = e.body;
  return kP({
    type: r.id,
    message: "".concat(t, ": ").concat(r.message),
    originalError: e,
    stack: _P(r.id, r.message, r.sourceFile, r.lineNumber, r.columnNumber)
  });
}
function WNe(e) {
  var t = "'".concat(e.blockedURI, "' blocked by '").concat(e.effectiveDirective, "' directive");
  return kP({
    type: e.effectiveDirective,
    message: "".concat(nv.cspViolation, ": ").concat(t),
    originalError: e,
    csp: {
      disposition: e.disposition
    },
    stack: _P(e.effectiveDirective, e.originalPolicy ? "".concat(t, ' of the policy "').concat(lP(e.originalPolicy, 100, "..."), '"') : "no policy", e.sourceFile, e.lineNumber, e.columnNumber)
  });
}
function kP(e) {
  return Ge({
    startClocks: $n(),
    source: o0.REPORT,
    handling: "unhandled"
  }, e);
}
function _P(e, t, r, n, a) {
  return r ? i0({
    name: e,
    message: t,
    stack: [
      {
        func: "?",
        url: r,
        line: n ?? void 0,
        column: a ?? void 0
      }
    ]
  }) : void 0;
}
function dF(e, t) {
  var r = window.__ddBrowserSdkExtensionCallback;
  r && r({ type: e, payload: t });
}
function ud(e) {
  return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
}
function by(e, t, r) {
  if (r === void 0 && (r = ENe()), t === void 0)
    return e;
  if (typeof t != "object" || t === null)
    return t;
  if (t instanceof Date)
    return new Date(t.getTime());
  if (t instanceof RegExp) {
    var n = t.flags || // old browsers compatibility
    [
      t.global ? "g" : "",
      t.ignoreCase ? "i" : "",
      t.multiline ? "m" : "",
      t.sticky ? "y" : "",
      t.unicode ? "u" : ""
    ].join("");
    return new RegExp(t.source, n);
  }
  if (!r.hasAlreadyBeenSeen(t)) {
    if (Array.isArray(t)) {
      for (var a = Array.isArray(e) ? e : [], i = 0; i < t.length; ++i)
        a[i] = by(a[i], t[i], r);
      return a;
    }
    var o = ud(e) === "object" ? e : {};
    for (var s in t)
      Object.prototype.hasOwnProperty.call(t, s) && (o[s] = by(o[s], t[s], r));
    return o;
  }
}
function uF(e) {
  return by(void 0, e);
}
function cs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r, n = 0, a = e; n < a.length; n++) {
    var i = a[n];
    i != null && (r = by(r, i));
  }
  return r;
}
function ENe() {
  if (typeof WeakSet < "u") {
    var e = /* @__PURE__ */ new WeakSet();
    return {
      hasAlreadyBeenSeen: function(r) {
        var n = e.has(r);
        return n || e.add(r), n;
      }
    };
  }
  var t = [];
  return {
    hasAlreadyBeenSeen: function(r) {
      var n = t.indexOf(r) >= 0;
      return n || t.push(r), n;
    }
  };
}
function NP() {
  var e, t = window.navigator;
  return {
    status: t.onLine ? "connected" : "not_connected",
    interfaces: t.connection && t.connection.type ? [t.connection.type] : void 0,
    effective_type: (e = t.connection) === null || e === void 0 ? void 0 : e.effectiveType
  };
}
function ZP(e, t) {
  var r = e.indexOf(t);
  r >= 0 && e.splice(r, 1);
}
var QNe = 500;
function BP() {
  var e = [], t = function(a) {
    var i = e.push(a);
    i > QNe && e.splice(0, 1);
  }, r = function(a) {
    ZP(e, a);
  }, n = function(a) {
    e.forEach(function(i) {
      return i(a);
    }), e.length = 0;
  };
  return {
    add: t,
    remove: r,
    drain: n
  };
}
var Uu = {
  log: "log",
  configuration: "configuration",
  usage: "usage"
}, FNe = [
  "https://www.datadoghq-browser-agent.com",
  "https://www.datad0g-browser-agent.com",
  "https://d3uc069fcn7uxw.cloudfront.net",
  "https://d20xtzwzcl0ceb.cloudfront.net",
  "http://localhost",
  "<anonymous>"
], TNe = [D_e], WP = BP(), s0 = function(e) {
  WP.add(function() {
    return s0(e);
  });
};
function RNe(e, t) {
  var r, n, a = new xt(), i = /* @__PURE__ */ new Set(), o = !uo(TNe, t.site) && Au(t.telemetrySampleRate), s = (r = {}, r[Uu.log] = o, r[Uu.configuration] = o && Au(t.telemetryConfigurationSampleRate), r[Uu.usage] = o && Au(t.telemetryUsageSampleRate), r), c = DNe();
  s0 = function(u) {
    var g = ch(u);
    if (s[u.type] && i.size < t.maxTelemetryEventsPerPage && !i.has(g)) {
      var p = l(e, u, c);
      a.notify(p), dF("telemetry", p), i.add(g);
    }
  }, zke(yy);
  function l(u, g, p) {
    return cs({
      type: "telemetry",
      date: rn(),
      service: u,
      version: "5.28.0",
      source: "browser",
      _dd: {
        format_version: 2
      },
      telemetry: cs(g, {
        runtime_env: p,
        connectivity: NP()
      }),
      experimental_features: rF(eNe())
    }, n !== void 0 ? n() : {});
  }
  return {
    setContextProvider: function(u) {
      n = u;
    },
    observable: a,
    enabled: o
  };
}
function DNe() {
  return {
    is_local_file: window.location.protocol === "file:",
    is_worker: "WorkerGlobalScope" in self
  };
}
function JNe() {
  WP.drain();
}
function VNe(e) {
  return e.site === vP;
}
function l0(e, t) {
  FZ(Rw.debug, e, t), s0(Ge({
    type: Uu.log,
    message: e,
    status: "debug"
  }, t));
}
function yy(e, t) {
  s0(Ge({
    type: Uu.log,
    status: "error"
  }, GNe(e), t));
}
function MNe(e) {
  s0({
    type: Uu.configuration,
    configuration: e
  });
}
function aa(e) {
  s0({
    type: Uu.usage,
    usage: e
  });
}
function GNe(e) {
  if (e instanceof Error) {
    var t = dd(e);
    return {
      error: {
        kind: t.name,
        stack: i0(xNe(t))
      },
      message: t.message
    };
  }
  return {
    error: {
      stack: bP
    },
    message: "".concat("Uncaught", " ").concat(ch(e))
  };
}
function xNe(e) {
  return e.stack = e.stack.filter(function(t) {
    return !t.url || FNe.some(function(r) {
      return PS(t.url, r);
    });
  }), e;
}
var iC = 1 / 0, HNe = Wa;
function c0(e) {
  var t = e.expireDelay, r = e.maxEntries, n = [], a = n0(function() {
    return i();
  }, HNe);
  function i() {
    for (var p = co() - t; n.length > 0 && n[n.length - 1].endTime < p; )
      n.pop();
  }
  function o(p, m) {
    var I = {
      value: p,
      startTime: m,
      endTime: iC,
      remove: function() {
        ZP(n, I);
      },
      close: function(C) {
        I.endTime = C;
      }
    };
    return r && n.length >= r && n.pop(), n.unshift(I), I;
  }
  function s(p, m) {
    p === void 0 && (p = iC), m === void 0 && (m = { returnInactive: !1 });
    for (var I = 0, C = n; I < C.length; I++) {
      var A = C[I];
      if (A.startTime <= p) {
        if (m.returnInactive || p <= A.endTime)
          return A.value;
        break;
      }
    }
  }
  function c(p) {
    var m = n[0];
    m && m.endTime === iC && m.close(p);
  }
  function l(p, m) {
    p === void 0 && (p = iC), m === void 0 && (m = 0);
    var I = r0(p, m);
    return n.filter(function(C) {
      return C.startTime <= I && p <= C.endTime;
    }).map(function(C) {
      return C.value;
    });
  }
  function u() {
    n = [];
  }
  function g() {
    Gw(a);
  }
  return { add: o, find: s, closeActive: c, findAll: l, reset: u, stop: g };
}
var LNe = Wa, YNe = lh;
function ONe(e, t, r, n) {
  var a = new xt(), i = new xt(), o = B_e(e.sessionStoreStrategyType, t, r), s = c0({
    expireDelay: YNe
  });
  o.renewObservable.subscribe(function() {
    s.add(c(), co()), a.notify();
  }), o.expireObservable.subscribe(function() {
    i.notify(), s.closeActive(co());
  }), o.expandOrRenewSession(), s.add(c(), aP().relative), n.observable.subscribe(function() {
    n.isGranted() ? o.expandOrRenewSession() : o.expire();
  }), jNe(e, function() {
    n.isGranted() && o.expandOrRenewSession();
  }), PNe(e, function() {
    return o.expandSession();
  }), $Ne(e, function() {
    return o.restartSession();
  });
  function c() {
    return {
      id: o.getSession().id,
      trackingType: o.getSession()[t],
      isReplayForced: !!o.getSession().forcedReplay
    };
  }
  return {
    findSession: function(l, u) {
      return s.find(l, u);
    },
    renewObservable: a,
    expireObservable: i,
    sessionStateUpdateObservable: o.sessionStateUpdateObservable,
    expire: o.expire,
    updateSessionState: o.updateSessionState
  };
}
function jNe(e, t) {
  Ua(e, window, [
    "click",
    "touchstart",
    "keydown",
    "scroll"
    /* DOM_EVENT.SCROLL */
  ], t, { capture: !0, passive: !0 }).stop;
}
function PNe(e, t) {
  var r = function() {
    document.visibilityState === "visible" && t();
  };
  tr(e, document, "visibilitychange", r).stop, n0(r, LNe);
}
function $Ne(e, t) {
  tr(e, window, "resume", t, { capture: !0 }).stop;
}
function KNe(e) {
  return e >= 500;
}
function XNe(e) {
  try {
    return e.clone();
  } catch {
    return;
  }
}
var zNe = 80 * xc, qNe = 32, EP = 3 * iP, eZe = Wa, QP = qn;
function FP(e, t, r, n, a) {
  t.transportStatus === 0 && t.queuedPayloads.size() === 0 && t.bandwidthMonitor.canHandle(e) ? RP(e, t, r, {
    onSuccess: function() {
      return DP(0, t, r, n, a);
    },
    onFailure: function() {
      t.queuedPayloads.enqueue(e), TP(t, r, n, a);
    }
  }) : t.queuedPayloads.enqueue(e);
}
function TP(e, t, r, n) {
  e.transportStatus === 2 && Nn(function() {
    var a = e.queuedPayloads.first();
    RP(a, e, t, {
      onSuccess: function() {
        e.queuedPayloads.dequeue(), e.currentBackoffTime = QP, DP(1, e, t, r, n);
      },
      onFailure: function() {
        e.currentBackoffTime = Math.min(eZe, e.currentBackoffTime * 2), TP(e, t, r, n);
      }
    });
  }, e.currentBackoffTime);
}
function RP(e, t, r, n) {
  var a = n.onSuccess, i = n.onFailure;
  t.bandwidthMonitor.add(e), r(e, function(o) {
    t.bandwidthMonitor.remove(e), tZe(o) ? (t.transportStatus = t.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2, e.retry = {
      count: e.retry ? e.retry.count + 1 : 1,
      lastFailureStatus: o.status
    }, i()) : (t.transportStatus = 0, a());
  });
}
function DP(e, t, r, n, a) {
  e === 0 && t.queuedPayloads.isFull() && !t.queueFullReported && (a({
    message: "Reached max ".concat(n, " events size queued for upload: ").concat(EP / iP, "MiB"),
    source: o0.AGENT,
    startClocks: $n()
  }), t.queueFullReported = !0);
  var i = t.queuedPayloads;
  for (t.queuedPayloads = JP(); i.size() > 0; )
    FP(i.dequeue(), t, r, n, a);
}
function tZe(e) {
  return e.type !== "opaque" && (e.status === 0 && !navigator.onLine || e.status === 408 || e.status === 429 || KNe(e.status));
}
function rZe() {
  return {
    transportStatus: 0,
    currentBackoffTime: QP,
    bandwidthMonitor: nZe(),
    queuedPayloads: JP(),
    queueFullReported: !1
  };
}
function JP() {
  var e = [];
  return {
    bytesCount: 0,
    enqueue: function(t) {
      this.isFull() || (e.push(t), this.bytesCount += t.bytesCount);
    },
    first: function() {
      return e[0];
    },
    dequeue: function() {
      var t = e.shift();
      return t && (this.bytesCount -= t.bytesCount), t;
    },
    size: function() {
      return e.length;
    },
    isFull: function() {
      return this.bytesCount >= EP;
    }
  };
}
function nZe() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function(e) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + e.bytesCount <= zNe && this.ongoingRequestCount < qNe;
    },
    add: function(e) {
      this.ongoingRequestCount += 1, this.ongoingByteCount += e.bytesCount;
    },
    remove: function(e) {
      this.ongoingRequestCount -= 1, this.ongoingByteCount -= e.bytesCount;
    }
  };
}
function VP(e, t, r, n) {
  var a = rZe(), i = function(o, s) {
    return oZe(e, t, r, o, s);
  };
  return {
    send: function(o) {
      FP(o, a, i, t.trackType, n);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function(o) {
      aZe(e, t, r, o);
    }
  };
}
function aZe(e, t, r, n) {
  var a = !!navigator.sendBeacon && n.bytesCount < r;
  if (a)
    try {
      var i = t.build("beacon", n), o = navigator.sendBeacon(i, n.data);
      if (o)
        return;
    } catch (c) {
      iZe(c);
    }
  var s = t.build("xhr", n);
  DZ(e, s, n.data);
}
var vV = !1;
function iZe(e) {
  vV || (vV = !0, yy(e));
}
function oZe(e, t, r, n, a) {
  var i = sZe() && n.bytesCount < r;
  if (i) {
    var o = t.build("fetch", n);
    fetch(o, { method: "POST", body: n.data, keepalive: !0, mode: "cors" }).then(Re(function(c) {
      return a == null ? void 0 : a({ status: c.status, type: c.type });
    }), Re(function() {
      var c = t.build("xhr", n);
      DZ(e, c, n.data, a);
    }));
  } else {
    var s = t.build("xhr", n);
    DZ(e, s, n.data, a);
  }
}
function sZe() {
  try {
    return window.Request && "keepalive" in new Request("http://a");
  } catch {
    return !1;
  }
}
function DZ(e, t, r, n) {
  var a = new XMLHttpRequest();
  a.open("POST", t, !0), r instanceof Blob && a.setRequestHeader("Content-Type", r.type), tr(e, a, "loadend", function() {
    n == null || n({ status: a.status });
  }, {
    // prevent multiple onResponse callbacks
    // if the xhr instance is reused by a third party
    once: !0
  }), a.send(r);
}
function d0() {
  var e = lZe();
  if (e)
    return {
      getCapabilities: function() {
        var t;
        return JSON.parse(((t = e.getCapabilities) === null || t === void 0 ? void 0 : t.call(e)) || "[]");
      },
      getPrivacyLevel: function() {
        var t;
        return (t = e.getPrivacyLevel) === null || t === void 0 ? void 0 : t.call(e);
      },
      getAllowedWebViewHosts: function() {
        return JSON.parse(e.getAllowedWebViewHosts());
      },
      send: function(t, r, n) {
        var a = n ? { id: n } : void 0;
        e.send(JSON.stringify({ eventType: t, event: r, view: a }));
      }
    };
}
function MP(e) {
  var t = d0();
  return !!t && uo(t.getCapabilities(), e);
}
function ju(e) {
  var t;
  e === void 0 && (e = (t = cd().location) === null || t === void 0 ? void 0 : t.hostname);
  var r = d0();
  return !!r && r.getAllowedWebViewHosts().some(function(n) {
    return e === n || $ke(e, ".".concat(n));
  });
}
function lZe() {
  return cd().DatadogEventBridge;
}
var fp = {
  HIDDEN: "visibility_hidden",
  UNLOADING: "before_unload",
  PAGEHIDE: "page_hide",
  FROZEN: "page_frozen"
};
function cZe(e) {
  return new xt(function(t) {
    var r = Ua(e, window, [
      "visibilitychange",
      "freeze"
      /* DOM_EVENT.FREEZE */
    ], function(a) {
      a.type === "visibilitychange" && document.visibilityState === "hidden" ? t.notify({ reason: fp.HIDDEN }) : a.type === "freeze" && t.notify({ reason: fp.FROZEN });
    }, { capture: !0 }).stop, n = tr(e, window, "beforeunload", function() {
      t.notify({ reason: fp.UNLOADING });
    }).stop;
    return function() {
      r(), n();
    };
  });
}
function GP(e) {
  return uo(Mw(fp), e);
}
function dZe(e) {
  var t = e.encoder, r = e.request, n = e.flushController, a = e.messageBytesLimit, i = {}, o = n.flushObservable.subscribe(function(p) {
    return g(p);
  });
  function s(p, m, I) {
    n.notifyBeforeAddMessage(m), I !== void 0 ? (i[I] = p, n.notifyAfterAddMessage()) : t.write(t.isEmpty ? p : `
`.concat(p), function(C) {
      n.notifyAfterAddMessage(C - m);
    });
  }
  function c(p) {
    return p !== void 0 && i[p] !== void 0;
  }
  function l(p) {
    var m = i[p];
    delete i[p];
    var I = t.estimateEncodedBytesCount(m);
    n.notifyAfterRemoveMessage(I);
  }
  function u(p, m) {
    var I = ch(p), C = t.estimateEncodedBytesCount(I);
    if (C >= a) {
      Et.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(a, "KB. ").concat(Jw, " ").concat(tP, "/#technical-limitations"));
      return;
    }
    c(m) && l(m), s(I, C, m);
  }
  function g(p) {
    var m = Mw(i).join(`
`);
    i = {};
    var I = GP(p.reason), C = I ? r.sendOnExit : r.send;
    if (I && // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
    // if the encoder is async we need to send two requests in some cases (one for encoded data
    // and the other for non-encoded data). But if it's not async, we don't have to worry about
    // it and always send a single request.
    t.isAsync) {
      var A = t.finishSync();
      A.outputBytesCount && C(SV(A));
      var U = [A.pendingData, m].filter(Boolean).join(`
`);
      U && C({
        data: U,
        bytesCount: tF(U)
      });
    } else
      m && t.write(t.isEmpty ? m : `
`.concat(m)), t.finish(function(B) {
        C(SV(B));
      });
  }
  return {
    flushController: n,
    add: u,
    upsert: u,
    stop: o.unsubscribe
  };
}
function SV(e) {
  var t;
  return typeof e.output == "string" ? t = e.output : t = new Blob([e.output], {
    // This will set the 'Content-Type: text/plain' header. Reasoning:
    // * The intake rejects the request if there is no content type.
    // * The browser will issue CORS preflight requests if we set it to 'application/json', which
    // could induce higher intake load (and maybe has other impacts).
    // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
    // new lines.
    type: "text/plain"
  }), {
    data: t,
    bytesCount: e.outputBytesCount,
    encoding: e.encoding
  };
}
function uZe(e) {
  var t = e.messagesLimit, r = e.bytesLimit, n = e.durationLimit, a = e.pageExitObservable, i = e.sessionExpireObservable, o = a.subscribe(function(C) {
    return g(C.reason);
  }), s = i.subscribe(function() {
    return g("session_expire");
  }), c = new xt(function() {
    return function() {
      o.unsubscribe(), s.unsubscribe();
    };
  }), l = 0, u = 0;
  function g(C) {
    if (u !== 0) {
      var A = u, U = l;
      u = 0, l = 0, I(), c.notify({
        reason: C,
        messagesCount: A,
        bytesCount: U
      });
    }
  }
  var p;
  function m() {
    p === void 0 && (p = Nn(function() {
      g("duration_limit");
    }, n));
  }
  function I() {
    Ui(p), p = void 0;
  }
  return {
    flushObservable: c,
    get messagesCount() {
      return u;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     *
     * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
     * actually added.
     */
    notifyBeforeAddMessage: function(C) {
      l + C >= r && g("bytes_limit"), u += 1, l += C, m();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     *
     * @param messageBytesCountDiff: the difference between the estimated message bytes count and
     * its actual bytes count once added to the pool.
     */
    notifyAfterAddMessage: function(C) {
      C === void 0 && (C = 0), l += C, u >= t ? g("messages_limit") : l >= r && g("bytes_limit");
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     *
     * @param messageBytesCount: the message bytes count that was added to the pool. Should
     * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
     * `notifyAfterAddMessage`.
     */
    notifyAfterRemoveMessage: function(C) {
      l -= C, u -= 1, u === 0 && I();
    }
  };
}
function hZe(e, t, r, n, a, i, o) {
  o === void 0 && (o = dZe);
  var s = l(e, t), c = r && l(e, r);
  function l(u, g) {
    var p = g.endpoint, m = g.encoder;
    return o({
      encoder: m,
      request: VP(u, p, u.batchBytesLimit, n),
      flushController: uZe({
        messagesLimit: u.batchMessagesLimit,
        bytesLimit: u.batchBytesLimit,
        durationLimit: u.flushTimeout,
        pageExitObservable: a,
        sessionExpireObservable: i
      }),
      messageBytesLimit: u.messageBytesLimit
    });
  }
  return {
    flushObservable: s.flushController.flushObservable,
    add: function(u, g) {
      g === void 0 && (g = !0), s.add(u), c && g && c.add(r.transformMessage ? r.transformMessage(u) : u);
    },
    upsert: function(u, g) {
      s.upsert(u, g), c && c.upsert(r.transformMessage ? r.transformMessage(u) : u, g);
    },
    stop: function() {
      s.stop(), c && c.stop();
    }
  };
}
function pZe() {
  var e = "", t = 0;
  return {
    isAsync: !1,
    get isEmpty() {
      return !e;
    },
    write: function(r, n) {
      var a = tF(r);
      t += a, e += r, n && n(a);
    },
    finish: function(r) {
      r(this.finishSync());
    },
    finishSync: function() {
      var r = {
        output: e,
        outputBytesCount: t,
        rawBytesCount: t,
        pendingData: ""
      };
      return e = "", t = 0, r;
    },
    estimateEncodedBytesCount: function(r) {
      return r.length;
    }
  };
}
var gZe = (
  /** @class */
  function() {
    function e() {
      this.callbacks = {};
    }
    return e.prototype.notify = function(t, r) {
      var n = this.callbacks[t];
      n && n.forEach(function(a) {
        return a(r);
      });
    }, e.prototype.subscribe = function(t, r) {
      var n = this;
      return this.callbacks[t] || (this.callbacks[t] = []), this.callbacks[t].push(r), {
        unsubscribe: function() {
          n.callbacks[t] = n.callbacks[t].filter(function(a) {
            return r !== a;
          });
        }
      };
    }, e;
  }()
);
function ik(e, t, r) {
  var n = 0, a = !1;
  return {
    isLimitReached: function() {
      if (n === 0 && Nn(function() {
        n = 0;
      }, Wa), n += 1, n <= t || a)
        return a = !1, !1;
      if (n === t + 1) {
        a = !0;
        try {
          r({
            message: "Reached max number of ".concat(e, "s by minute: ").concat(t),
            source: o0.AGENT,
            startClocks: $n()
          });
        } finally {
          a = !1;
        }
      }
      return !0;
    }
  };
}
function hF(e, t, r) {
  if (document.readyState === t || document.readyState === "complete")
    return r(), { stop: Dt };
  var n = t === "complete" ? "load" : "DOMContentLoaded";
  return tr(e, window, n, r, { once: !0 });
}
var ok, pF = /* @__PURE__ */ new WeakMap();
function fZe(e) {
  return ok || (ok = mZe(e)), ok;
}
function mZe(e) {
  return new xt(function(t) {
    var r = va(XMLHttpRequest.prototype, "open", vZe).stop, n = va(XMLHttpRequest.prototype, "send", function(i) {
      SZe(i, e, t);
    }, { computeHandlingStack: !0 }).stop, a = va(XMLHttpRequest.prototype, "abort", IZe).stop;
    return function() {
      r(), n(), a();
    };
  });
}
function vZe(e) {
  var t = e.target, r = e.parameters, n = r[0], a = r[1];
  pF.set(t, {
    state: "open",
    method: String(n).toUpperCase(),
    url: lF(String(a))
  });
}
function SZe(e, t, r) {
  var n = e.target, a = e.handlingStack, i = pF.get(n);
  if (i) {
    var o = i;
    o.state = "start", o.startClocks = $n(), o.isAborted = !1, o.xhr = n, o.handlingStack = a;
    var s = !1, c = va(n, "onreadystatechange", function() {
      n.readyState === XMLHttpRequest.DONE && l();
    }).stop, l = function() {
      if (u(), c(), !s) {
        s = !0;
        var g = i;
        g.state = "complete", g.duration = Qn(o.startClocks.timeStamp, rn()), g.status = n.status, r.notify(tv(g));
      }
    }, u = tr(t, n, "loadend", l).stop;
    r.notify(o);
  }
}
function IZe(e) {
  var t = e.target, r = pF.get(t);
  r && (r.isAborted = !0);
}
var sk;
function xP() {
  return sk || (sk = CZe()), sk;
}
function CZe() {
  return new xt(function(e) {
    if (window.fetch) {
      var t = va(window, "fetch", function(r) {
        return bZe(r, e);
      }, {
        computeHandlingStack: !0
      }).stop;
      return t;
    }
  });
}
function bZe(e, t) {
  var r = e.parameters, n = e.onPostCall, a = e.handlingStack, i = r[0], o = r[1], s = o && o.method;
  s === void 0 && i instanceof Request && (s = i.method);
  var c = s !== void 0 ? String(s).toUpperCase() : "GET", l = i instanceof Request ? i.url : lF(String(i)), u = $n(), g = {
    state: "start",
    init: o,
    input: i,
    method: c,
    startClocks: u,
    url: l,
    handlingStack: a
  };
  t.notify(g), r[0] = g.input, r[1] = g.init, n(function(p) {
    return yZe(t, p, g);
  });
}
function yZe(e, t, r) {
  var n = r;
  function a(i) {
    n.state = "resolve", Ge(n, i), e.notify(n);
  }
  t.then(Re(function(i) {
    a({
      response: i,
      responseType: i.type,
      status: i.status,
      isAborted: !1
    });
  }), Re(function(i) {
    var o, s;
    a({
      status: 0,
      isAborted: ((s = (o = n.init) === null || o === void 0 ? void 0 : o.signal) === null || s === void 0 ? void 0 : s.aborted) || i instanceof DOMException && i.code === DOMException.ABORT_ERR,
      error: i
    });
  }));
}
var lk = {};
function wZe(e) {
  var t = e.map(function(r) {
    return lk[r] || (lk[r] = AZe(r)), lk[r];
  });
  return sP.apply(void 0, t);
}
function AZe(e) {
  return new xt(function(t) {
    var r = il[e];
    return il[e] = function() {
      for (var n = [], a = 0; a < arguments.length; a++)
        n[a] = arguments[a];
      r.apply(console, n);
      var i = Cy();
      Ou(function() {
        t.notify(UZe(n, e, i));
      });
    }, function() {
      il[e] = r;
    };
  });
}
function UZe(e, t, r) {
  var n = e.map(function(o) {
    return kZe(o);
  }).join(" "), a;
  if (t === Rw.error) {
    var i = Hc(e, function(o) {
      return o instanceof Error;
    });
    a = {
      stack: i ? i0(dd(i)) : void 0,
      fingerprint: wP(i),
      causes: i ? AP(i, "console") : void 0,
      startClocks: $n(),
      message: n,
      source: o0.CONSOLE,
      handling: "handled",
      handlingStack: r
    };
  }
  return {
    api: t,
    message: n,
    error: a,
    handlingStack: r
  };
}
function kZe(e) {
  return typeof e == "string" ? Sr(e) : e instanceof Error ? CP(dd(e)) : ch(Sr(e), void 0, 2);
}
function JZ(e) {
  var t = {}, r = new xt(), n = {
    getContext: function() {
      return uF(t);
    },
    setContext: function(a) {
      ud(a) === "object" ? (t = Sr(a), e && e.updateCustomerData(t)) : n.clearContext(), r.notify();
    },
    setContextProperty: function(a, i) {
      t[a] = Sr(i), e && e.updateCustomerData(t), r.notify();
    },
    removeContextProperty: function(a) {
      delete t[a], e && e.updateCustomerData(t), r.notify();
    },
    clearContext: function() {
      t = {}, e && e.resetCustomerData(), r.notify();
    },
    changeObservable: r
  };
  return n;
}
var _Ze = "_dd_c", NZe = [];
function IV(e, t, r, n) {
  var a = ZZe(r, n);
  NZe.push(tr(e, window, "storage", function(c) {
    var l = c.key;
    a === l && i();
  })), t.changeObservable.subscribe(o), t.setContext(cs(s(), t.getContext()));
  function i() {
    t.setContext(s());
  }
  function o() {
    localStorage.setItem(a, JSON.stringify(t.getContext()));
  }
  function s() {
    var c = localStorage.getItem(a);
    return c !== null ? JSON.parse(c) : {};
  }
}
function ZZe(e, t) {
  return "".concat(_Ze, "_").concat(e, "_").concat(t);
}
var BZe = 3 * xc, WZe = 16 * xc, EZe = 200;
function QZe(e) {
  e === void 0 && (e = 2);
  var t = /* @__PURE__ */ new Map(), r = !1;
  function n(a) {
    if (a === void 0 && (a = 0), !(r || e === 0)) {
      var i = e === 2 ? BZe : WZe, o = a;
      t.forEach(function(s) {
        o += s.getBytesCount();
      }), o > i && (FZe(i), r = !0);
    }
  }
  return {
    /**
     * Creates a detached tracker. The manager will not store a reference to that tracker, and the
     * bytes count will be counted independently from other detached trackers.
     *
     * This is particularly useful when we don't know when the tracker will be unused, so we don't
     * leak memory (ex: when used in Logger instances).
     */
    createDetachedTracker: function() {
      var a = CV(function() {
        return n(a.getBytesCount());
      });
      return a;
    },
    /**
     * Creates a tracker if it doesn't exist, and returns it.
     */
    getOrCreateTracker: function(a) {
      return t.has(a) || t.set(a, CV(n)), t.get(a);
    },
    setCompressionStatus: function(a) {
      e === 0 && (e = a, n());
    },
    getCompressionStatus: function() {
      return e;
    },
    stop: function() {
      t.forEach(function(a) {
        return a.stop();
      }), t.clear();
    }
  };
}
function CV(e) {
  var t = 0, r = Fl(function(o) {
    t = tF(ch(o)), e();
  }, EZe), n = r.throttled, a = r.cancel, i = function() {
    a(), t = 0;
  };
  return {
    updateCustomerData: function(o) {
      Yu(o) ? i() : n(o);
    },
    resetCustomerData: i,
    getBytesCount: function() {
      return t;
    },
    stop: function() {
      a();
    }
  };
}
function FZe(e) {
  Et.warn("Customer data exceeds the recommended ".concat(e / xc, "KiB threshold. ").concat(Jw, " ").concat(tP, "/#customer-data-exceeds-the-recommended-threshold-warning"));
}
function TZe(e, t, r) {
  var n = e.getReader(), a = 0;
  i();
  function i() {
    n.read().then(Re(function(s) {
      if (s.done) {
        o();
        return;
      }
      a += s.value.length, a > r.bytesLimit ? o() : i();
    }), Re(function(s) {
      return t(s);
    }));
  }
  function o() {
    n.cancel().catch(
      // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
      // as an unhandled rejection
      Dt
    );
    var s, c;
    t(void 0, s, c);
  }
}
var RZe = "datadog-synthetics-public-id", DZe = "datadog-synthetics-result-id", JZe = "datadog-synthetics-injects-rum";
function HP() {
  return !!(window._DATADOG_SYNTHETICS_INJECTS_RUM || bc(JZe));
}
function VZe() {
  var e = window._DATADOG_SYNTHETICS_PUBLIC_ID || bc(RZe);
  return typeof e == "string" ? e : void 0;
}
function MZe() {
  var e = window._DATADOG_SYNTHETICS_RESULT_ID || bc(DZe);
  return typeof e == "string" ? e : void 0;
}
function bV(e) {
  var t = Ge({}, e), r = ["id", "name", "email"];
  return r.forEach(function(n) {
    n in t && (t[n] = String(t[n]));
  }), t;
}
function GZe(e) {
  var t = ud(e) === "object";
  return t || Et.error("Unsupported user:", e), t;
}
function gF(e) {
  var t = ud(e);
  return t === "string" || t === "function" || e instanceof RegExp;
}
function LP(e, t, r) {
  return r === void 0 && (r = !1), e.some(function(n) {
    try {
      if (typeof n == "function")
        return n(t);
      if (n instanceof RegExp)
        return n.test(t);
      if (typeof n == "string")
        return r ? PS(t, n) : n === t;
    } catch (a) {
      Et.error(a);
    }
    return !1;
  });
}
function xZe(e, t, r) {
  return {
    context: e.getContext(),
    user: t.getContext(),
    hasReplay: r.isRecording() ? !0 : void 0
  };
}
function HZe() {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new WeakMap();
  return { vitalsByName: e, vitalsByReference: t };
}
function LZe(e, t, r) {
  function n(i) {
    return !t.wasInPageStateDuringPeriod("frozen", i.startClocks.relative, i.duration);
  }
  function a(i) {
    n(i) && e.notify(11, OZe(i));
  }
  return {
    addDurationVital: a,
    startDurationVital: function(i, o) {
      return o === void 0 && (o = {}), YP(r, i, o);
    },
    stopDurationVital: function(i, o) {
      o === void 0 && (o = {}), OP(a, r, i, o);
    }
  };
}
function YP(e, t, r) {
  var n = e.vitalsByName, a = e.vitalsByReference;
  r === void 0 && (r = {});
  var i = {
    name: t,
    startClocks: $n(),
    context: r.context,
    description: r.description
  }, o = { __dd_vital_reference: !0 };
  return n.set(t, i), a.set(o, i), o;
}
function OP(e, t, r, n) {
  var a = t.vitalsByName, i = t.vitalsByReference;
  n === void 0 && (n = {});
  var o = typeof r == "string" ? a.get(r) : i.get(r);
  o && (e(YZe(o, o.startClocks, n, $n())), typeof r == "string" ? a.delete(r) : i.delete(r));
}
function YZe(e, t, r, n) {
  var a;
  return {
    name: e.name,
    type: "duration",
    startClocks: t,
    duration: Qn(t.timeStamp, n.timeStamp),
    context: cs(e.context, r.context),
    description: (a = r.description) !== null && a !== void 0 ? a : e.description
  };
}
function OZe(e, t) {
  var r = {
    date: e.startClocks.timeStamp,
    vital: {
      id: Tn(),
      type: e.type,
      name: e.name,
      duration: st(e.duration),
      description: e.description
    },
    type: "vital"
  };
  return r._dd = {
    vital: {
      computed_value: !0
    }
  }, {
    rawRumEvent: r,
    startTime: e.startClocks.relative,
    customerContext: e.context,
    domainContext: {}
  };
}
function jZe(e) {
  var t = e;
  return ud(t) === "object" && gF(t.match) && Array.isArray(t.propagatorTypes);
}
function PZe(e) {
  e.status === 0 && !e.isAborted && (e.traceId = void 0, e.spanId = void 0, e.traceSampled = void 0);
}
function $Ze(e, t) {
  return {
    clearTracingIfNeeded: PZe,
    traceFetch: function(r) {
      return yV(e, r, t, function(n) {
        var a;
        if (r.input instanceof Request && !(!((a = r.init) === null || a === void 0) && a.headers))
          r.input = new Request(r.input), Object.keys(n).forEach(function(o) {
            r.input.headers.append(o, n[o]);
          });
        else {
          r.init = tv(r.init);
          var i = [];
          r.init.headers instanceof Headers ? r.init.headers.forEach(function(o, s) {
            i.push([s, o]);
          }) : Array.isArray(r.init.headers) ? r.init.headers.forEach(function(o) {
            i.push(o);
          }) : r.init.headers && Object.keys(r.init.headers).forEach(function(o) {
            i.push([o, r.init.headers[o]]);
          }), r.init.headers = i.concat(nF(n));
        }
      });
    },
    traceXhr: function(r, n) {
      return yV(e, r, t, function(a) {
        Object.keys(a).forEach(function(i) {
          n.setRequestHeader(i, a[i]);
        });
      });
    }
  };
}
function yV(e, t, r, n) {
  if (!(!KZe() || !r.findTrackedSession())) {
    var a = Hc(e.allowedTracingUrls, function(i) {
      return LP([i.match], t.url, !0);
    });
    a && (t.traceSampled = !t0(e.traceSampleRate) || Au(e.traceSampleRate), !(!t.traceSampled && e.traceContextInjection !== RZ.ALL) && (t.traceId = VZ(), t.spanId = VZ(), n(XZe(t.traceId, t.spanId, t.traceSampled, a.propagatorTypes))));
  }
}
function KZe() {
  return jP() !== void 0;
}
function jP() {
  return window.crypto || window.msCrypto;
}
function XZe(e, t, r, n) {
  var a = {};
  return n.forEach(function(i) {
    switch (i) {
      case "datadog": {
        Ge(a, {
          "x-datadog-origin": "rum",
          "x-datadog-parent-id": t.toDecimalString(),
          "x-datadog-sampling-priority": r ? "1" : "0",
          "x-datadog-trace-id": e.toDecimalString()
        });
        break;
      }
      case "tracecontext": {
        Ge(a, {
          traceparent: "00-0000000000000000".concat(e.toPaddedHexadecimalString(), "-").concat(t.toPaddedHexadecimalString(), "-0").concat(r ? "1" : "0")
        });
        break;
      }
      case "b3": {
        Ge(a, {
          b3: "".concat(e.toPaddedHexadecimalString(), "-").concat(t.toPaddedHexadecimalString(), "-").concat(r ? "1" : "0")
        });
        break;
      }
      case "b3multi": {
        Ge(a, {
          "X-B3-TraceId": e.toPaddedHexadecimalString(),
          "X-B3-SpanId": t.toPaddedHexadecimalString(),
          "X-B3-Sampled": r ? "1" : "0"
        });
        break;
      }
    }
  }), a;
}
function VZ() {
  var e = new Uint8Array(8);
  jP().getRandomValues(e), e[0] = e[0] & 127;
  function t(i) {
    return e[i] * 16777216 + (e[i + 1] << 16) + (e[i + 2] << 8) + e[i + 3];
  }
  function r(i) {
    var o = t(0), s = t(4), c = "";
    do {
      var l = o % i * 4294967296 + s;
      o = Math.floor(o / i), s = Math.floor(l / i), c = (l % i).toString(i) + c;
    } while (o || s);
    return c;
  }
  function n() {
    return r(10);
  }
  function a() {
    var i = r(16);
    return Array(17 - i.length).join("0") + i;
  }
  return {
    toDecimalString: n,
    toPaddedHexadecimalString: a
  };
}
var PP = ["tracecontext", "datadog"];
function zZe(e) {
  var t, r;
  if (!e.applicationId) {
    Et.error("Application ID is not configured, no RUM data will be collected.");
    return;
  }
  if (!(!tp(e.sessionReplaySampleRate, "Session Replay") || !tp(e.traceSampleRate, "Trace"))) {
    if (e.excludedActivityUrls !== void 0 && !Array.isArray(e.excludedActivityUrls)) {
      Et.error("Excluded Activity Urls should be an array");
      return;
    }
    var n = qZe(e);
    if (n) {
      var a = K_e(e);
      if (a)
        return Ge({
          applicationId: e.applicationId,
          version: e.version || void 0,
          actionNameAttribute: e.actionNameAttribute,
          sessionReplaySampleRate: (t = e.sessionReplaySampleRate) !== null && t !== void 0 ? t : 0,
          startSessionReplayRecordingManually: !!e.startSessionReplayRecordingManually,
          traceSampleRate: e.traceSampleRate,
          allowedTracingUrls: n,
          excludedActivityUrls: (r = e.excludedActivityUrls) !== null && r !== void 0 ? r : [],
          workerUrl: e.workerUrl,
          compressIntakeRequests: !!e.compressIntakeRequests,
          trackUserInteractions: !!e.trackUserInteractions,
          trackViewsManually: !!e.trackViewsManually,
          trackResources: !!e.trackResources,
          trackLongTasks: !!e.trackLongTasks,
          subdomain: e.subdomain,
          defaultPrivacyLevel: vy(Kf, e.defaultPrivacyLevel) ? e.defaultPrivacyLevel : Kf.MASK,
          enablePrivacyForActionName: !!e.enablePrivacyForActionName,
          customerDataTelemetrySampleRate: 1,
          traceContextInjection: vy(RZ, e.traceContextInjection) ? e.traceContextInjection : RZ.ALL,
          plugins: e.betaPlugins || []
        }, a);
    }
  }
}
function qZe(e) {
  if (e.allowedTracingUrls === void 0)
    return [];
  if (!Array.isArray(e.allowedTracingUrls)) {
    Et.error("Allowed Tracing URLs should be an array");
    return;
  }
  if (e.allowedTracingUrls.length !== 0 && e.service === void 0) {
    Et.error("Service needs to be configured when tracing is enabled");
    return;
  }
  var t = [];
  return e.allowedTracingUrls.forEach(function(r) {
    gF(r) ? t.push({ match: r, propagatorTypes: PP }) : jZe(r) ? t.push(r) : Et.warn("Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter", r);
  }), t;
}
function eBe(e) {
  var t = /* @__PURE__ */ new Set();
  return Array.isArray(e.allowedTracingUrls) && e.allowedTracingUrls.length > 0 && e.allowedTracingUrls.forEach(function(r) {
    gF(r) ? PP.forEach(function(n) {
      return t.add(n);
    }) : ud(r) === "object" && Array.isArray(r.propagatorTypes) && r.propagatorTypes.forEach(function(n) {
      return t.add(n);
    });
  }), rF(t);
}
function tBe(e) {
  var t, r = X_e(e);
  return Ge({
    session_replay_sample_rate: e.sessionReplaySampleRate,
    start_session_replay_recording_manually: e.startSessionReplayRecordingManually,
    trace_sample_rate: e.traceSampleRate,
    trace_context_injection: e.traceContextInjection,
    action_name_attribute: e.actionNameAttribute,
    use_allowed_tracing_urls: Array.isArray(e.allowedTracingUrls) && e.allowedTracingUrls.length > 0,
    selected_tracing_propagators: eBe(e),
    default_privacy_level: e.defaultPrivacyLevel,
    enable_privacy_for_action_name: e.enablePrivacyForActionName,
    use_excluded_activity_urls: Array.isArray(e.excludedActivityUrls) && e.excludedActivityUrls.length > 0,
    use_worker_url: !!e.workerUrl,
    compress_intake_requests: e.compressIntakeRequests,
    track_views_manually: e.trackViewsManually,
    track_user_interactions: e.trackUserInteractions,
    track_resources: e.trackResources,
    track_long_task: e.trackLongTasks,
    plugins: (t = e.betaPlugins) === null || t === void 0 ? void 0 : t.map(function(n) {
      var a;
      return Ge({ name: n.name }, (a = n.getConfigurationTelemetry) === null || a === void 0 ? void 0 : a.call(n));
    })
  }, r);
}
var rBe = "https://d3uc069fcn7uxw.cloudfront.net/configuration";
function nBe(e, t) {
  iBe(e, function(r) {
    t(aBe(e, r));
  });
}
function aBe(e, t) {
  return Ge({}, e, t);
}
function iBe(e, t) {
  var r = new XMLHttpRequest();
  tr(e, r, "load", function() {
    r.status === 200 ? t(JSON.parse(r.responseText)) : wV();
  }), tr(e, r, "error", function() {
    wV();
  }), r.open("GET", "".concat(rBe, "/").concat(encodeURIComponent(e.remoteConfigurationId), ".json")), r.send();
}
function wV() {
  Et.error("Error fetching the remote configuration.");
}
function oBe(e, t, r) {
  if (e)
    for (var n = 0, a = e; n < a.length; n++) {
      var i = a[n], o = i[t];
      o && o(r);
    }
}
function sBe(e, t, r, n, a) {
  var i = e.ignoreInitIfSyntheticsWillInjectRum, o = e.startDeflateWorker, s = BP(), c, l, u, g, p = r.observable.subscribe(m);
  function m() {
    if (!(!u || !g || !r.isGranted())) {
      p.unsubscribe();
      var A;
      if (g.trackViewsManually) {
        if (!c)
          return;
        s.remove(c.callback), A = c.options;
      }
      var U = a(g, l, A);
      s.drain(U);
    }
  }
  function I(A) {
    var U = ju();
    if (U && (A = lBe(A)), u = A, MNe(tBe(A)), g) {
      UP("DD_RUM", A);
      return;
    }
    var B = zZe(A);
    if (B) {
      if (!U && !B.sessionStoreStrategyType) {
        Et.warn("No storage available for session. We will not send any data.");
        return;
      }
      B.compressIntakeRequests && !U && o && (l = o(
        B,
        "Datadog RUM",
        // Worker initialization can fail asynchronously, especially in Firefox where even CSP
        // issues are reported asynchronously. For now, the SDK will continue its execution even if
        // data won't be sent to Datadog. We could improve this behavior in the future.
        Dt
      ), !l) || (g = B, xP().subscribe(Dt), r.tryToInit(B.trackingConsent), m());
    }
  }
  var C = function(A) {
    s.add(function(U) {
      return U.addDurationVital(A);
    });
  };
  return {
    init: function(A, U) {
      if (!A) {
        Et.error("Missing configuration");
        return;
      }
      z_e(A.enableExperimentalFeatures), u = A, !(i && HP()) && (oBe(A.betaPlugins, "onInit", { initConfiguration: A, publicApi: U }), A.remoteConfigurationId && KS(Yc.REMOTE_CONFIGURATION) ? nBe(A, I) : I(A));
    },
    get initConfiguration() {
      return u;
    },
    getInternalContext: Dt,
    stopSession: Dt,
    addTiming: function(A, U) {
      U === void 0 && (U = rn()), s.add(function(B) {
        return B.addTiming(A, U);
      });
    },
    startView: function(A, U) {
      U === void 0 && (U = $n());
      var B = function(J) {
        J.startView(A, U);
      };
      s.add(B), c || (c = { options: A, callback: B }, m());
    },
    updateViewName: function(A) {
      s.add(function(U) {
        return U.updateViewName(A);
      });
    },
    setViewContext: function(A) {
      s.add(function(U) {
        return U.setViewContext(A);
      });
    },
    setViewContextProperty: function(A, U) {
      s.add(function(B) {
        return B.setViewContextProperty(A, U);
      });
    },
    addAction: function(A, U) {
      U === void 0 && (U = t()), s.add(function(B) {
        return B.addAction(A, U);
      });
    },
    addError: function(A, U) {
      U === void 0 && (U = t()), s.add(function(B) {
        return B.addError(A, U);
      });
    },
    addFeatureFlagEvaluation: function(A, U) {
      s.add(function(B) {
        return B.addFeatureFlagEvaluation(A, U);
      });
    },
    startDurationVital: function(A, U) {
      return YP(n, A, U);
    },
    stopDurationVital: function(A, U) {
      OP(C, n, A, U);
    },
    addDurationVital: C
  };
}
function lBe(e) {
  var t, r;
  return Ge({}, e, {
    applicationId: "00000000-aaaa-0000-aaaa-000000000000",
    clientToken: "empty",
    sessionSampleRate: 100,
    defaultPrivacyLevel: (t = e.defaultPrivacyLevel) !== null && t !== void 0 ? t : (r = d0()) === null || r === void 0 ? void 0 : r.getPrivacyLevel()
  });
}
var AV = "rum";
function cBe(e, t, r) {
  r === void 0 && (r = {});
  var n = QZe(
    0
    /* CustomerDataCompressionStatus.Unknown */
  ), a = JZ(n.getOrCreateTracker(
    2
    /* CustomerDataType.GlobalContext */
  )), i = JZ(n.getOrCreateTracker(
    1
    /* CustomerDataType.User */
  )), o = W_e(), s = HZe();
  function c() {
    return xZe(a, i, t);
  }
  var l = sBe(r, c, o, s, function(p, m, I) {
    p.storeContextsAcrossPages && (IV(
      p,
      a,
      AV,
      2
      /* CustomerDataType.GlobalContext */
    ), IV(
      p,
      i,
      AV,
      1
      /* CustomerDataType.User */
    )), n.setCompressionStatus(
      m ? 1 : 2
      /* CustomerDataCompressionStatus.Disabled */
    );
    var C = e(p, t, n, c, I, m && r.createDeflateEncoder ? function(A) {
      return r.createDeflateEncoder(p, m, A);
    } : pZe, o, s);
    return t.onRumStart(C.lifeCycle, p, C.session, C.viewHistory, m), l = dBe(l, C), C;
  }), u = Re(function(p) {
    var m = typeof p == "object" ? p : { name: p };
    m.context && n.getOrCreateTracker(
      3
      /* CustomerDataType.View */
    ).updateCustomerData(m.context), l.startView(m), aa({ feature: "start-view" });
  }), g = UNe({
    init: Re(function(p) {
      l.init(p, g), KS(Yc.UPDATE_VIEW_NAME) && (g.updateViewName = Re(function(m) {
        l.updateViewName(m);
      }));
    }),
    setTrackingConsent: Re(function(p) {
      o.update(p), aa({ feature: "set-tracking-consent", tracking_consent: p });
    }),
    setViewContext: Re(function(p) {
      l.setViewContext(p);
    }),
    setViewContextProperty: Re(function(p, m) {
      l.setViewContextProperty(p, m);
    }),
    setGlobalContext: Re(function(p) {
      a.setContext(p), aa({ feature: "set-global-context" });
    }),
    getGlobalContext: Re(function() {
      return a.getContext();
    }),
    setGlobalContextProperty: Re(function(p, m) {
      a.setContextProperty(p, m), aa({ feature: "set-global-context" });
    }),
    removeGlobalContextProperty: Re(function(p) {
      return a.removeContextProperty(p);
    }),
    clearGlobalContext: Re(function() {
      return a.clearContext();
    }),
    getInternalContext: Re(function(p) {
      return l.getInternalContext(p);
    }),
    getInitConfiguration: Re(function() {
      return uF(l.initConfiguration);
    }),
    addAction: function(p, m) {
      var I = Cy();
      Ou(function() {
        l.addAction({
          name: Sr(p),
          context: Sr(m),
          startClocks: $n(),
          type: "custom",
          handlingStack: I
        }), aa({ feature: "add-action" });
      });
    },
    addError: function(p, m) {
      var I = Cy();
      Ou(function() {
        l.addError({
          error: p,
          // Do not sanitize error here, it is needed unserialized by computeRawError()
          handlingStack: I,
          context: Sr(m),
          startClocks: $n()
        }), aa({ feature: "add-error" });
      });
    },
    addTiming: Re(function(p, m) {
      l.addTiming(Sr(p), m);
    }),
    setUser: Re(function(p) {
      GZe(p) && i.setContext(bV(p)), aa({ feature: "set-user" });
    }),
    getUser: Re(function() {
      return i.getContext();
    }),
    setUserProperty: Re(function(p, m) {
      var I, C = bV((I = {}, I[p] = m, I))[p];
      i.setContextProperty(p, C), aa({ feature: "set-user" });
    }),
    removeUserProperty: Re(function(p) {
      return i.removeContextProperty(p);
    }),
    clearUser: Re(function() {
      return i.clearContext();
    }),
    startView: u,
    stopSession: Re(function() {
      l.stopSession(), aa({ feature: "stop-session" });
    }),
    addFeatureFlagEvaluation: Re(function(p, m) {
      l.addFeatureFlagEvaluation(Sr(p), Sr(m)), aa({ feature: "add-feature-flag-evaluation" });
    }),
    getSessionReplayLink: Re(function() {
      return t.getSessionReplayLink();
    }),
    startSessionReplayRecording: Re(function(p) {
      t.start(p), aa({ feature: "start-session-replay-recording", force: p && p.force });
    }),
    stopSessionReplayRecording: Re(function() {
      return t.stop();
    }),
    addDurationVital: Re(function(p, m) {
      aa({ feature: "add-duration-vital" }), l.addDurationVital({
        name: Sr(p),
        type: "duration",
        startClocks: Mke(m.startTime),
        duration: m.duration,
        context: Sr(m && m.context),
        description: Sr(m && m.description)
      });
    }),
    startDurationVital: Re(function(p, m) {
      return aa({ feature: "start-duration-vital" }), l.startDurationVital(Sr(p), {
        context: Sr(m && m.context),
        description: Sr(m && m.description)
      });
    }),
    stopDurationVital: Re(function(p, m) {
      aa({ feature: "stop-duration-vital" }), l.stopDurationVital(typeof p == "string" ? Sr(p) : p, {
        context: Sr(m && m.context),
        description: Sr(m && m.description)
      });
    })
  });
  return g;
}
function dBe(e, t) {
  return Ge({
    init: function(r) {
      UP("DD_RUM", r);
    },
    initConfiguration: e.initConfiguration
  }, t);
}
function uBe() {
  var e = $P();
  return new xt(function(t) {
    if (e) {
      var r = new e(Re(function() {
        return t.notify();
      }));
      return r.observe(document, {
        attributes: !0,
        characterData: !0,
        childList: !0,
        subtree: !0
      }), function() {
        return r.disconnect();
      };
    }
  });
}
function $P() {
  var e, t = window;
  if (t.Zone && (e = Lc(t, "MutationObserver"), t.MutationObserver && e === t.MutationObserver)) {
    var r = new t.MutationObserver(Dt), n = Lc(r, "originalInstance");
    e = n && n.constructor;
  }
  return e || (e = t.MutationObserver), e;
}
function hBe() {
  var e = VZe(), t = MZe();
  if (e && t)
    return {
      test_id: e,
      result_id: t,
      injected: HP()
    };
}
function pBe(e, t, r) {
  var n = uF(e), a = r(n);
  return nF(t).forEach(function(i) {
    var o = i[0], s = i[1], c = gBe(n, o), l = ud(c);
    l === s ? UV(e, o, Sr(c)) : s === "object" && (l === "undefined" || l === "null") && UV(e, o, {});
  }), a;
}
function gBe(e, t) {
  for (var r = e, n = 0, a = t.split("."); n < a.length; n++) {
    var i = a[n];
    if (!fBe(r, i))
      return;
    r = r[i];
  }
  return r;
}
function UV(e, t, r) {
  for (var n = e, a = t.split("."), i = 0; i < a.length; i += 1) {
    var o = a[i];
    if (!KP(n))
      return;
    i !== a.length - 1 ? n = n[o] : n[o] = r;
  }
}
function KP(e) {
  return ud(e) === "object";
}
function fBe(e, t) {
  return KP(e) && Object.prototype.hasOwnProperty.call(e, t);
}
var Ah = {
  "view.name": "string",
  "view.url": "string",
  "view.referrer": "string"
}, Uh = {
  context: "object"
}, ck = {
  service: "string",
  version: "string"
}, XP;
function mBe(e, t, r, n, a, i, o, s, c, l) {
  var u, g;
  XP = (u = {}, u.view = Ge({}, Uh, Ah), u.error = Ge({
    "error.message": "string",
    "error.stack": "string",
    "error.resource.url": "string",
    "error.fingerprint": "string"
  }, Uh, Ah, ck), u.resource = Ge({
    "resource.url": "string"
  }, KS(Yc.WRITABLE_RESOURCE_GRAPHQL) ? {
    "resource.graphql": "object"
  } : {}, Uh, Ah, ck), u.action = Ge({
    "action.target.name": "string"
  }, Uh, Ah, ck), u.long_task = Ge({}, Uh, Ah), u.vital = Ge({}, Uh, Ah), u);
  var p = (g = {}, g.error = ik("error", e.eventRateLimiterThreshold, l), g.action = ik("action", e.eventRateLimiterThreshold, l), g.vital = ik("vital", e.eventRateLimiterThreshold, l), g), m = hBe();
  t.subscribe(11, function(I) {
    var C = I.startTime, A = I.rawRumEvent, U = I.domainContext, B = I.savedCommonContext, J = I.customerContext, W = n.findView(C), L = a.findUrl(C), H = r.findTrackedSession(C);
    if (H && W && L) {
      var R = B || c(), ge = i.findActionId(C), z = {
        _dd: {
          format_version: 2,
          drift: xke(),
          configuration: {
            session_sample_rate: my(e.sessionSampleRate, 3),
            session_replay_sample_rate: my(e.sessionReplaySampleRate, 3)
          },
          browser_sdk_version: ju() ? "5.28.0" : void 0
        },
        application: {
          id: e.applicationId
        },
        date: rn(),
        service: W.service || e.service,
        version: W.version || e.version,
        source: "browser",
        session: {
          id: H.id,
          type: m ? "synthetics" : s.get() ? "ci_test" : "user"
        },
        view: {
          id: W.id,
          name: W.name,
          url: L.url,
          referrer: L.referrer
        },
        action: SBe(A) && ge ? { id: ge } : void 0,
        synthetics: m,
        ci_test: s.get(),
        display: o.get(),
        connectivity: NP()
      }, K = cs(z, A);
      K.context = cs(R.context, W.context, J), "has_replay" in K.session || (K.session.has_replay = R.hasReplay), K.type === "view" && (K.session.sampled_for_replay = H.sessionReplay === 1), Yu(R.user) || (K.usr = R.user), vBe(K, e.beforeSend, U, p) && (Yu(K.context) && delete K.context, t.notify(12, K));
    }
  });
}
function vBe(e, t, r, n) {
  var a;
  if (t) {
    var i = pBe(e, XP[e.type], function(s) {
      return t(s, r);
    });
    if (i === !1 && e.type !== "view")
      return !1;
    i === !1 && Et.warn("Can't dismiss view events using beforeSend!");
  }
  var o = (a = n[e.type]) === null || a === void 0 ? void 0 : a.isLimitReached();
  return !o;
}
function SBe(e) {
  return [
    "error",
    "resource",
    "long_task"
    /* RumEventType.LONG_TASK */
  ].indexOf(e.type) !== -1;
}
function IBe(e, t, r, n, a) {
  return {
    get: function(i) {
      var o = r.findView(i), s = a.findUrl(i), c = t.findTrackedSession(i);
      if (c && o && s) {
        var l = n.findActionId(i);
        return {
          application_id: e,
          session_id: c.id,
          user_action: l ? { id: l } : void 0,
          view: { id: o.id, name: o.name, referrer: s.referrer, url: s.url }
        };
      }
    }
  };
}
var CBe = gZe, bBe = lh;
function yBe(e) {
  var t = c0({ expireDelay: bBe });
  e.subscribe(1, function(n) {
    t.add(r(n), n.startClocks.relative);
  }), e.subscribe(5, function(n) {
    var a = n.endClocks;
    t.closeActive(a.relative);
  }), e.subscribe(3, function(n) {
    var a = t.find(n.startClocks.relative);
    a && n.name && (a.name = n.name), a && n.context && (a.context = n.context);
  }), e.subscribe(9, function() {
    t.reset();
  });
  function r(n) {
    return {
      service: n.service,
      version: n.version,
      context: n.context,
      id: n.id,
      name: n.name,
      startClocks: n.startClocks
    };
  }
  return {
    findView: function(n) {
      return t.find(n);
    },
    stop: function() {
      t.stop();
    }
  };
}
var zP = "initial_document", wBe = [
  ["document", function(e) {
    return zP === e;
  }],
  ["xhr", function(e) {
    return e === "xmlhttprequest";
  }],
  ["fetch", function(e) {
    return e === "fetch";
  }],
  ["beacon", function(e) {
    return e === "beacon";
  }],
  ["css", function(e, t) {
    return /\.css$/i.test(t);
  }],
  ["js", function(e, t) {
    return /\.js$/i.test(t);
  }],
  [
    "image",
    function(e, t) {
      return uo(["image", "img", "icon"], e) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(t) !== null;
    }
  ],
  ["font", function(e, t) {
    return /\.(woff|eot|woff2|ttf)$/i.exec(t) !== null;
  }],
  [
    "media",
    function(e, t) {
      return uo(["audio", "video"], e) || /\.(mp3|mp4)$/i.exec(t) !== null;
    }
  ]
];
function ABe(e) {
  var t = e.name;
  if (!E_e(t))
    return l0('Failed to construct URL for "'.concat(e.name, '"')), "other";
  for (var r = Q_e(t), n = 0, a = wBe; n < a.length; n++) {
    var i = a[n], o = i[0], s = i[1];
    if (s(e.initiatorType, r))
      return o;
  }
  return "other";
}
function kV() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = 1; r < e.length; r += 1)
    if (e[r - 1] > e[r])
      return !1;
  return !0;
}
function UBe(e) {
  return e.initiatorType === "xmlhttprequest" || e.initiatorType === "fetch";
}
function kBe(e) {
  var t = e.duration, r = e.startTime, n = e.responseEnd;
  return t === 0 && r < n ? st(Qn(r, n)) : st(t);
}
function _Be(e) {
  if (e$(e)) {
    var t = e.startTime, r = e.fetchStart, n = e.redirectStart, a = e.redirectEnd, i = e.domainLookupStart, o = e.domainLookupEnd, s = e.connectStart, c = e.secureConnectionStart, l = e.connectEnd, u = e.requestStart, g = e.responseStart, p = e.responseEnd, m = {
      download: kh(t, g, p),
      first_byte: kh(t, u, g)
    };
    return r < l && (m.connect = kh(t, s, l), s <= c && c <= l && (m.ssl = kh(t, c, l))), r < o && (m.dns = kh(t, i, o)), t < a && (m.redirect = kh(t, n, a)), m;
  }
}
function qP(e) {
  return e.duration >= 0;
}
function e$(e) {
  var t = kV(e.startTime, e.fetchStart, e.domainLookupStart, e.domainLookupEnd, e.connectStart, e.connectEnd, e.requestStart, e.responseStart, e.responseEnd), r = NBe(e) ? kV(e.startTime, e.redirectStart, e.redirectEnd, e.fetchStart) : !0;
  return t && r;
}
function NBe(e) {
  return e.redirectEnd > e.startTime;
}
function kh(e, t, r) {
  if (e <= t && t <= r)
    return {
      duration: st(Qn(t, r)),
      start: st(Qn(e, t))
    };
}
function ZBe(e) {
  if (e.startTime < e.responseStart) {
    var t = e.encodedBodySize, r = e.decodedBodySize, n = e.transferSize;
    return {
      size: r,
      encoded_body_size: t,
      decoded_body_size: r,
      transfer_size: n
    };
  }
  return {
    size: void 0,
    encoded_body_size: void 0,
    decoded_body_size: void 0,
    transfer_size: void 0
  };
}
function fF(e, t) {
  return t && !e.isIntakeUrl(t);
}
var BBe = /data:(.+)?(;base64)?,/g, _V = 24e3;
function t$(e) {
  return e.length <= _V ? !1 : e.substring(0, 5) === "data:" ? (e = e.substring(0, _V), !0) : !1;
}
function r$(e) {
  return "".concat(e.match(BBe)[0], "[...]");
}
var NV = 1;
function WBe(e, t, r) {
  var n = $Ze(t, r);
  EBe(e, t, n), QBe(e, t, n);
}
function EBe(e, t, r) {
  var n = fZe(t).subscribe(function(a) {
    var i = a;
    if (fF(t, i.url))
      switch (i.state) {
        case "start":
          r.traceXhr(i, i.xhr), i.requestIndex = n$(), e.notify(6, {
            requestIndex: i.requestIndex,
            url: i.url
          });
          break;
        case "complete":
          r.clearTracingIfNeeded(i), e.notify(7, {
            duration: i.duration,
            method: i.method,
            requestIndex: i.requestIndex,
            spanId: i.spanId,
            startClocks: i.startClocks,
            status: i.status,
            traceId: i.traceId,
            traceSampled: i.traceSampled,
            type: "xhr",
            url: i.url,
            xhr: i.xhr,
            isAborted: i.isAborted,
            handlingStack: i.handlingStack
          });
          break;
      }
  });
  return { stop: function() {
    return n.unsubscribe();
  } };
}
function QBe(e, t, r) {
  var n = xP().subscribe(function(a) {
    var i = a;
    if (fF(t, i.url))
      switch (i.state) {
        case "start":
          r.traceFetch(i), i.requestIndex = n$(), e.notify(6, {
            requestIndex: i.requestIndex,
            url: i.url
          });
          break;
        case "resolve":
          FBe(i, function(o) {
            r.clearTracingIfNeeded(i), e.notify(7, {
              duration: o,
              method: i.method,
              requestIndex: i.requestIndex,
              responseType: i.responseType,
              spanId: i.spanId,
              startClocks: i.startClocks,
              status: i.status,
              traceId: i.traceId,
              traceSampled: i.traceSampled,
              type: "fetch",
              url: i.url,
              response: i.response,
              init: i.init,
              input: i.input,
              isAborted: i.isAborted,
              handlingStack: i.handlingStack
            });
          });
          break;
      }
  });
  return { stop: function() {
    return n.unsubscribe();
  } };
}
function n$() {
  var e = NV;
  return NV += 1, e;
}
function FBe(e, t) {
  var r = e.response && XNe(e.response);
  !r || !r.body ? t(Qn(e.startClocks.timeStamp, rn())) : TZe(r.body, function() {
    t(Qn(e.startClocks.timeStamp, rn()));
  }, {
    bytesLimit: Number.POSITIVE_INFINITY,
    collectStreamBody: !1
  });
}
function a$(e) {
  return t0(e) && e < 0 ? void 0 : e;
}
function i$(e) {
  var t = e.lifeCycle, r = e.isChildEvent, n = e.onChange, a = n === void 0 ? Dt : n, i = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  }, o = t.subscribe(12, function(s) {
    var c;
    if (!(s.type === "view" || s.type === "vital" || !r(s)))
      switch (s.type) {
        case "error":
          i.errorCount += 1, a();
          break;
        case "action":
          i.actionCount += 1, s.action.frustration && (i.frustrationCount += s.action.frustration.type.length), a();
          break;
        case "long_task":
          i.longTaskCount += 1, a();
          break;
        case "resource":
          !((c = s._dd) === null || c === void 0) && c.discarded || (i.resourceCount += 1, a());
          break;
      }
  });
  return {
    stop: function() {
      o.unsubscribe();
    },
    eventCounts: i
  };
}
function TBe(e, t) {
  var r = ls(), n = !1, a = Ua(e, window, [
    "click",
    "mousedown",
    "keydown",
    "touchstart",
    "pointerdown"
    /* DOM_EVENT.POINTER_DOWN */
  ], function(s) {
    if (s.cancelable) {
      var c = {
        entryType: "first-input",
        processingStart: co(),
        processingEnd: co(),
        startTime: s.timeStamp,
        duration: 0,
        // arbitrary value to avoid nullable duration and simplify INP logic
        name: "",
        cancelable: !1,
        target: null,
        toJSON: function() {
          return {};
        }
      };
      s.type === "pointerdown" ? i(e, c) : o(c);
    }
  }, { passive: !0, capture: !0 }).stop;
  return { stop: a };
  function i(s, c) {
    Ua(s, window, [
      "pointerup",
      "pointercancel"
      /* DOM_EVENT.POINTER_CANCEL */
    ], function(l) {
      l.type === "pointerup" && o(c);
    }, { once: !0 });
  }
  function o(s) {
    if (!n) {
      n = !0, a();
      var c = s.processingStart - s.startTime;
      c >= 0 && c < ls() - r && t(s);
    }
  }
}
var jt;
(function(e) {
  e.EVENT = "event", e.FIRST_INPUT = "first-input", e.LARGEST_CONTENTFUL_PAINT = "largest-contentful-paint", e.LAYOUT_SHIFT = "layout-shift", e.LONG_TASK = "longtask", e.LONG_ANIMATION_FRAME = "long-animation-frame", e.NAVIGATION = "navigation", e.PAINT = "paint", e.RESOURCE = "resource";
})(jt || (jt = {}));
function ds(e, t) {
  return new xt(function(r) {
    if (window.PerformanceObserver) {
      var n = function(l) {
        var u = JBe(e, l);
        u.length > 0 && r.notify(u);
      }, a, i = !0, o = new PerformanceObserver(Re(function(l) {
        i ? a = Nn(function() {
          return n(l.getEntries());
        }) : n(l.getEntries());
      }));
      try {
        o.observe(t);
      } catch {
        var s = [
          jt.RESOURCE,
          jt.NAVIGATION,
          jt.LONG_TASK,
          jt.PAINT
        ];
        if (uo(s, t.type)) {
          t.buffered && (a = Nn(function() {
            return n(performance.getEntriesByType(t.type));
          }));
          try {
            o.observe({ entryTypes: [t.type] });
          } catch {
            return;
          }
        }
      }
      i = !1, RBe(e);
      var c;
      return !Hw(jt.FIRST_INPUT) && t.type === jt.FIRST_INPUT && (c = TBe(e, function(l) {
        n([l]);
      }).stop), function() {
        o.disconnect(), c && c(), Ui(a);
      };
    }
  });
}
var O0;
function RBe(e) {
  return !O0 && DBe() && "addEventListener" in performance && (O0 = tr(e, performance, "resourcetimingbufferfull", function() {
    performance.clearResourceTimings();
  })), function() {
    O0 == null || O0.stop();
  };
}
function DBe() {
  return window.performance !== void 0 && "getEntries" in performance;
}
function Hw(e) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== void 0 && PerformanceObserver.supportedEntryTypes.includes(e);
}
function JBe(e, t) {
  return t.filter(function(r) {
    return !VBe(e, r);
  });
}
function VBe(e, t) {
  return t.entryType === jt.RESOURCE && (!fF(e, t.name) || !qP(t));
}
var o$ = 100, MBe = 100;
function mF(e, t, r, n, a) {
  var i = xBe(e, t, r);
  return GBe(i, n, a);
}
function GBe(e, t, r) {
  var n, a = !1, i = Nn(Re(function() {
    return l({ hadActivity: !1 });
  }), o$), o = r !== void 0 ? Nn(Re(function() {
    return l({ hadActivity: !0, end: rn() });
  }), r) : void 0, s = e.subscribe(function(u) {
    var g = u.isBusy;
    Ui(i), Ui(n);
    var p = rn();
    g || (n = Nn(Re(function() {
      return l({ hadActivity: !0, end: p });
    }), MBe));
  }), c = function() {
    a = !0, Ui(i), Ui(n), Ui(o), s.unsubscribe();
  };
  function l(u) {
    a || (c(), t(u));
  }
  return { stop: c };
}
function xBe(e, t, r) {
  return new xt(function(n) {
    var a = [], i, o = 0;
    a.push(t.subscribe(c), ds(r, { type: jt.RESOURCE }).subscribe(function(l) {
      l.some(function(u) {
        return !dk(r, u.name);
      }) && c();
    }), e.subscribe(6, function(l) {
      dk(r, l.url) || (i === void 0 && (i = l.requestIndex), o += 1, c());
    }), e.subscribe(7, function(l) {
      dk(r, l.url) || i === void 0 || // If the request started before the tracking start, ignore it
      l.requestIndex < i || (o -= 1, c());
    }));
    var s = HBe(c).stop;
    return function() {
      s(), a.forEach(function(l) {
        return l.unsubscribe();
      });
    };
    function c() {
      n.notify({ isBusy: o > 0 });
    }
  });
}
function dk(e, t) {
  return LP(e.excludedActivityUrls, t);
}
function HBe(e) {
  return va(window, "open", e);
}
function Oc(e) {
  return window.CSS && window.CSS.escape ? window.CSS.escape(e) : e.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function(t, r) {
    return r ? t === "\0" ? "�" : "".concat(t.slice(0, -1), "\\").concat(t.charCodeAt(t.length - 1).toString(16), " ") : "\\".concat(t);
  });
}
function rp(e, t) {
  return e.matches ? e.matches(t) : e.msMatchesSelector ? e.msMatchesSelector(t) : !1;
}
function zS(e) {
  if (e.parentElement)
    return e.parentElement;
  for (; e.parentNode; ) {
    if (e.parentNode.nodeType === Node.ELEMENT_NODE)
      return e.parentNode;
    e = e.parentNode;
  }
  return null;
}
function LBe(e) {
  if (e.classList)
    return e.classList;
  var t = (e.getAttribute("class") || "").trim();
  return t ? t.split(/\s+/) : [];
}
var ZV = 1, YBe = (
  /** @class */
  function() {
    function e(t) {
      var r = this;
      this.map = /* @__PURE__ */ new WeakMap(), t && t.forEach(function(n) {
        return r.map.set(n, ZV);
      });
    }
    return e.prototype.add = function(t) {
      return this.map.set(t, ZV), this;
    }, e.prototype.delete = function(t) {
      return this.map.delete(t);
    }, e.prototype.has = function(t) {
      return this.map.has(t);
    }, e;
  }()
);
function s$(e) {
  return e.nodeType === Node.TEXT_NODE;
}
function OBe(e) {
  return e.nodeType === Node.COMMENT_NODE;
}
function u0(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
function Lw(e) {
  return u0(e) && !!e.shadowRoot;
}
function vF(e) {
  var t = e;
  return !!t.host && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && u0(t.host);
}
function jBe(e) {
  return e.childNodes.length > 0 || Lw(e);
}
function l$(e, t) {
  for (var r = e.firstChild; r; )
    t(r), r = r.nextSibling;
  Lw(e) && t(e.shadowRoot);
}
function Yw(e) {
  return vF(e) ? e.host : e.parentNode;
}
var Je = {
  IGNORE: "ignore",
  HIDDEN: "hidden",
  ALLOW: Kf.ALLOW,
  MASK: Kf.MASK,
  MASK_USER_INPUT: Kf.MASK_USER_INPUT
}, SF = "data-dd-privacy", PBe = "hidden", $Be = "dd-privacy-", wc = "***", BV = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==", KBe = {
  INPUT: !0,
  OUTPUT: !0,
  TEXTAREA: !0,
  SELECT: !0,
  OPTION: !0,
  DATALIST: !0,
  OPTGROUP: !0
}, XBe = "x";
function fs(e, t, r) {
  if (r && r.has(e))
    return r.get(e);
  var n = Yw(e), a = n ? fs(n, t, r) : t, i = d$(e), o = c$(i, a);
  return r && r.set(e, o), o;
}
function c$(e, t) {
  switch (t) {
    case Je.HIDDEN:
    case Je.IGNORE:
      return t;
  }
  switch (e) {
    case Je.ALLOW:
    case Je.MASK:
    case Je.MASK_USER_INPUT:
    case Je.HIDDEN:
    case Je.IGNORE:
      return e;
    default:
      return t;
  }
}
function d$(e) {
  if (u0(e)) {
    if (e.tagName === "BASE")
      return Je.ALLOW;
    if (e.tagName === "INPUT") {
      var t = e;
      if (t.type === "password" || t.type === "email" || t.type === "tel" || t.type === "hidden")
        return Je.MASK;
      var r = t.getAttribute("autocomplete");
      if (r && r.indexOf("cc-") === 0)
        return Je.MASK;
    }
    if (rp(e, np(Je.HIDDEN)))
      return Je.HIDDEN;
    if (rp(e, np(Je.MASK)))
      return Je.MASK;
    if (rp(e, np(Je.MASK_USER_INPUT)))
      return Je.MASK_USER_INPUT;
    if (rp(e, np(Je.ALLOW)))
      return Je.ALLOW;
    if (qBe(e))
      return Je.IGNORE;
  }
}
function Ow(e, t) {
  switch (t) {
    case Je.MASK:
    case Je.HIDDEN:
    case Je.IGNORE:
      return !0;
    case Je.MASK_USER_INPUT:
      return s$(e) ? WV(e.parentNode) : WV(e);
    default:
      return !1;
  }
}
function WV(e) {
  if (!e || e.nodeType !== e.ELEMENT_NODE)
    return !1;
  var t = e;
  if (t.tagName === "INPUT")
    switch (t.type) {
      case "button":
      case "color":
      case "reset":
      case "submit":
        return !1;
    }
  return !!KBe[t.tagName];
}
var zBe = function(e) {
  return e.replace(/\S/g, XBe);
};
function u$(e, t, r) {
  var n, a = (n = e.parentElement) === null || n === void 0 ? void 0 : n.tagName, i = e.textContent || "";
  if (!(t && !i.trim())) {
    var o = r, s = a === "SCRIPT";
    if (s)
      i = wc;
    else if (o === Je.HIDDEN)
      i = wc;
    else if (Ow(e, o))
      if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        a === "DATALIST" || a === "SELECT" || a === "OPTGROUP"
      ) {
        if (!i.trim())
          return;
      } else a === "OPTION" ? i = wc : i = zBe(i);
    return i;
  }
}
function qBe(e) {
  if (e.nodeName === "SCRIPT")
    return !0;
  if (e.nodeName === "LINK") {
    var t = a("rel");
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(t) && a("as") === "script" || // Favicons
      t === "shortcut icon" || t === "icon"
    );
  }
  if (e.nodeName === "META") {
    var r = a("name"), t = a("rel"), n = a("property");
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(r) || r === "application-name" || t === "icon" || t === "apple-touch-icon" || t === "shortcut icon" || // Description
      r === "keywords" || r === "description" || // Social
      /^(og|twitter|fb):/.test(n) || /^(og|twitter):/.test(r) || r === "pinterest" || // Robots
      r === "robots" || r === "googlebot" || r === "bingbot" || // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      e.hasAttribute("http-equiv") || // Authorship
      r === "author" || r === "generator" || r === "framework" || r === "publisher" || r === "progid" || /^article:/.test(n) || /^product:/.test(n) || // Verification
      r === "google-site-verification" || r === "yandex-verification" || r === "csrf-token" || r === "p:domain_verify" || r === "verify-v1" || r === "verification" || r === "shopify-checkout-api-token"
    );
  }
  function a(i) {
    return (e.getAttribute(i) || "").toLowerCase();
  }
  return !1;
}
function np(e) {
  return "[".concat(SF, '="').concat(e, '"], .').concat($Be).concat(e);
}
var IF = "data-dd-action-name", eWe = "Masked Element";
function tWe(e, t, r) {
  var n = t.enablePrivacyForActionName, a = t.actionNameAttribute, i = EV(e, IF) || a && EV(e, a);
  return r === Je.MASK ? i || eWe : i || QV(e, a, rWe, n) || QV(e, a, nWe, n) || "";
}
function EV(e, t) {
  var r;
  if (lWe())
    r = e.closest("[".concat(t, "]"));
  else
    for (var n = e; n; ) {
      if (n.hasAttribute(t)) {
        r = n;
        break;
      }
      n = zS(n);
    }
  if (r) {
    var a = r.getAttribute(t);
    return p$(h$(a.trim()));
  }
}
var rWe = [
  // associated LABEL text
  function(e, t, r) {
    if (sWe()) {
      if ("labels" in e && e.labels && e.labels.length > 0)
        return Dh(e.labels[0], t);
    } else if (e.id) {
      var n = e.ownerDocument && Hc(e.ownerDocument.querySelectorAll("label"), function(a) {
        return a.htmlFor === e.id;
      });
      return n && Dh(n, t, r);
    }
  },
  // INPUT button (and associated) value
  function(e) {
    if (e.nodeName === "INPUT") {
      var t = e, r = t.getAttribute("type");
      if (r === "button" || r === "submit" || r === "reset")
        return t.value;
    }
  },
  // BUTTON, LABEL or button-like element text
  function(e, t, r) {
    if (e.nodeName === "BUTTON" || e.nodeName === "LABEL" || e.getAttribute("role") === "button")
      return Dh(e, t, r);
  },
  function(e) {
    return e.getAttribute("aria-label");
  },
  // associated element text designated by the aria-labelledby attribute
  function(e, t, r) {
    var n = e.getAttribute("aria-labelledby");
    if (n)
      return n.split(/\s+/).map(function(a) {
        return iWe(e, a);
      }).filter(function(a) {
        return !!a;
      }).map(function(a) {
        return Dh(a, t, r);
      }).join(" ");
  },
  function(e) {
    return e.getAttribute("alt");
  },
  function(e) {
    return e.getAttribute("name");
  },
  function(e) {
    return e.getAttribute("title");
  },
  function(e) {
    return e.getAttribute("placeholder");
  },
  // SELECT first OPTION text
  function(e, t) {
    if ("options" in e && e.options.length > 0)
      return Dh(e.options[0], t);
  }
], nWe = [
  function(e, t, r) {
    return Dh(e, t, r);
  }
], aWe = 10;
function QV(e, t, r, n) {
  for (var a = e, i = 0; i <= aWe && a && a.nodeName !== "BODY" && a.nodeName !== "HTML" && a.nodeName !== "HEAD"; ) {
    for (var o = 0, s = r; o < s.length; o++) {
      var c = s[o], l = c(a, t, n);
      if (typeof l == "string") {
        var u = l.trim();
        if (u)
          return p$(h$(u));
      }
    }
    if (a.nodeName === "FORM")
      break;
    a = zS(a), i += 1;
  }
}
function h$(e) {
  return e.replace(/\s+/g, " ");
}
function p$(e) {
  return e.length > 100 ? "".concat(lP(e, 100), " [...]") : e;
}
function iWe(e, t) {
  return e.ownerDocument ? e.ownerDocument.getElementById(t) : null;
}
function Dh(e, t, r) {
  if (!e.isContentEditable) {
    if ("innerText" in e) {
      var n = e.innerText, a = function(i) {
        for (var o = e.querySelectorAll(i), s = 0; s < o.length; s += 1) {
          var c = o[s];
          if ("innerText" in c) {
            var l = c.innerText;
            l && l.trim().length > 0 && (n = n.replace(l, ""));
          }
        }
      };
      return oWe() || a("script, style"), a("[".concat(IF, "]")), t && a("[".concat(t, "]")), r && a("".concat(np(Je.HIDDEN), ", ").concat(np(Je.MASK))), n;
    }
    return e.textContent;
  }
}
function oWe() {
  return !t_e();
}
var uk;
function sWe() {
  return uk === void 0 && (uk = "labels" in HTMLInputElement.prototype), uk;
}
var hk;
function lWe() {
  return hk === void 0 && (hk = "closest" in HTMLElement.prototype), hk;
}
var g$ = [
  IF,
  // Common test attributes (list provided by google recorder)
  "data-testid",
  "data-test",
  "data-qa",
  "data-cy",
  "data-test-id",
  "data-qa-id",
  "data-testing",
  // FullStory decorator attributes:
  "data-component",
  "data-element",
  "data-source-file"
], cWe = [m$, uWe], dWe = [
  m$,
  hWe,
  pWe
];
function qS(e, t) {
  if (SWe(e)) {
    for (var r, n = e; n && n.nodeName !== "HTML"; ) {
      var a = FV(n, cWe, fWe, t, r);
      if (a)
        return a;
      var i = FV(n, dWe, mWe, t, r);
      r = i || av(gWe(n), r), n = zS(n);
    }
    return r;
  }
}
function f$(e) {
  return /[0-9]/.test(e);
}
function uWe(e) {
  if (e.id && !f$(e.id))
    return "#".concat(Oc(e.id));
}
function hWe(e) {
  if (e.tagName !== "BODY")
    for (var t = LBe(e), r = 0; r < t.length; r += 1) {
      var n = t[r];
      if (!f$(n))
        return "".concat(Oc(e.tagName), ".").concat(Oc(n));
    }
}
function pWe(e) {
  return Oc(e.tagName);
}
function m$(e, t) {
  if (t) {
    var r = o(t);
    if (r)
      return r;
  }
  for (var n = 0, a = g$; n < a.length; n++) {
    var i = a[n], r = o(i);
    if (r)
      return r;
  }
  function o(s) {
    if (e.hasAttribute(s))
      return "".concat(Oc(e.tagName), "[").concat(s, '="').concat(Oc(e.getAttribute(s)), '"]');
  }
}
function gWe(e) {
  for (var t = zS(e).firstElementChild, r = 1; t && t !== e; )
    t.tagName === e.tagName && (r += 1), t = t.nextElementSibling;
  return "".concat(Oc(e.tagName), ":nth-of-type(").concat(r, ")");
}
function FV(e, t, r, n, a) {
  for (var i = 0, o = t; i < o.length; i++) {
    var s = o[i], c = s(e, n);
    if (c && r(e, c, a))
      return av(c, a);
  }
}
function fWe(e, t, r) {
  return e.ownerDocument.querySelectorAll(av(t, r)).length === 1;
}
function mWe(e, t, r) {
  var n;
  if (r === void 0)
    n = function(s) {
      return rp(s, t);
    };
  else {
    var a = vWe() ? av("".concat(t, ":scope"), r) : av(t, r);
    n = function(s) {
      return s.querySelector(a) !== null;
    };
  }
  for (var i = zS(e), o = i.firstElementChild; o; ) {
    if (o !== e && n(o))
      return !1;
    o = o.nextElementSibling;
  }
  return !0;
}
function av(e, t) {
  return t ? "".concat(e, ">").concat(t) : e;
}
var oC;
function vWe() {
  if (oC === void 0)
    try {
      document.querySelector(":scope"), oC = !0;
    } catch {
      oC = !1;
    }
  return oC;
}
function SWe(e) {
  return "isConnected" in // cast is to make sure `element` is not inferred as `never` after the check
  e ? e.isConnected : e.ownerDocument.documentElement.contains(e);
}
var v$ = qn, IWe = 100;
function CWe(e, t) {
  var r = [], n = 0, a;
  i(e);
  function i(c) {
    c.stopObservable.subscribe(o), r.push(c), Ui(a), a = Nn(s, v$);
  }
  function o() {
    n === 1 && r.every(function(c) {
      return c.isStopped();
    }) && (n = 2, t(r));
  }
  function s() {
    Ui(a), n === 0 && (n = 1, o());
  }
  return {
    tryAppend: function(c) {
      return n !== 0 ? !1 : r.length > 0 && !bWe(r[r.length - 1].event, c.event) ? (s(), !1) : (i(c), !0);
    },
    stop: function() {
      s();
    }
  };
}
function bWe(e, t) {
  return e.target === t.target && yWe(e, t) <= IWe && e.timeStamp - t.timeStamp <= v$;
}
function yWe(e, t) {
  return Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2));
}
function wWe(e, t) {
  var r = t.onPointerDown, n = t.onPointerUp, a, i = {
    selection: !1,
    input: !1,
    scroll: !1
  }, o, s = [
    tr(e, window, "pointerdown", function(c) {
      RV(c) && (a = TV(), i = {
        selection: !1,
        input: !1,
        scroll: !1
      }, o = r(c));
    }, { capture: !0 }),
    tr(e, window, "selectionchange", function() {
      (!a || !TV()) && (i.selection = !0);
    }, { capture: !0 }),
    tr(e, window, "scroll", function() {
      i.scroll = !0;
    }, { capture: !0, passive: !0 }),
    tr(e, window, "pointerup", function(c) {
      if (RV(c) && o) {
        var l = i;
        n(o, c, function() {
          return l;
        }), o = void 0;
      }
    }, { capture: !0 }),
    tr(e, window, "input", function() {
      i.input = !0;
    }, { capture: !0 })
  ];
  return {
    stop: function() {
      s.forEach(function(c) {
        return c.stop();
      });
    }
  };
}
function TV() {
  var e = window.getSelection();
  return !e || e.isCollapsed;
}
function RV(e) {
  return e.target instanceof Element && // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  e.isPrimary !== !1;
}
var DV = 3;
function AWe(e, t) {
  if (UWe(e))
    return t.addFrustration(
      "rage_click"
      /* FrustrationType.RAGE_CLICK */
    ), e.some(JV) && t.addFrustration(
      "dead_click"
      /* FrustrationType.DEAD_CLICK */
    ), t.hasError && t.addFrustration(
      "error_click"
      /* FrustrationType.ERROR_CLICK */
    ), { isRage: !0 };
  var r = e.some(function(n) {
    return n.getUserActivity().selection;
  });
  return e.forEach(function(n) {
    n.hasError && n.addFrustration(
      "error_click"
      /* FrustrationType.ERROR_CLICK */
    ), JV(n) && // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !r && n.addFrustration(
      "dead_click"
      /* FrustrationType.DEAD_CLICK */
    );
  }), { isRage: !1 };
}
function UWe(e) {
  if (e.some(function(r) {
    return r.getUserActivity().selection || r.getUserActivity().scroll;
  }))
    return !1;
  for (var t = 0; t < e.length - (DV - 1); t += 1)
    if (e[t + DV - 1].event.timeStamp - e[t].event.timeStamp <= qn)
      return !0;
  return !1;
}
var kWe = (
  // inputs that don't trigger a meaningful event like "input" when clicked, including textual
  // inputs (using a negative selector is shorter here)
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *'
);
function JV(e) {
  return e.hasPageActivity || e.getUserActivity().input || e.getUserActivity().scroll ? !1 : !rp(e.event.target, kWe);
}
var _We = 10 * qn, NWe = 5 * Wa;
function ZWe(e, t, r) {
  var n = c0({ expireDelay: NWe }), a = new xt(), i;
  e.subscribe(9, function() {
    n.reset();
  }), e.subscribe(4, l);
  var o = wWe(r, {
    onPointerDown: function(u) {
      return BWe(r, e, t, u);
    },
    onPointerUp: function(u, g, p) {
      var m = u.clickActionBase, I = u.hadActivityOnPointerDown;
      WWe(r, e, t, n, a, c, m, g, p, I);
    }
  }).stop, s = {
    findActionId: function(u) {
      return n.findAll(u);
    }
  };
  return {
    stop: function() {
      l(), a.notify(), o();
    },
    actionContexts: s
  };
  function c(u) {
    if (!i || !i.tryAppend(u)) {
      var g = u.clone();
      i = CWe(u, function(p) {
        QWe(p, g);
      });
    }
  }
  function l() {
    i && i.stop();
  }
}
function BWe(e, t, r, n) {
  var a = e.enablePrivacyForActionName ? fs(n.target, e.defaultPrivacyLevel) : Je.ALLOW;
  if (a !== Je.HIDDEN) {
    var i = EWe(n, a, e), o = !1;
    return mF(
      t,
      r,
      e,
      function(s) {
        o = s.hadActivity;
      },
      // We don't care about the activity duration, we just want to know whether an activity did happen
      // within the "validation delay" or not. Limit the duration so the callback is called sooner.
      o$
    ), { clickActionBase: i, hadActivityOnPointerDown: function() {
      return o;
    } };
  }
}
function WWe(e, t, r, n, a, i, o, s, c, l) {
  var u = S$(t, n, c, o, s);
  i(u);
  var g = mF(t, r, e, function(I) {
    I.hadActivity && I.end < u.startClocks.timeStamp ? u.discard() : I.hadActivity ? u.stop(I.end) : l() ? u.stop(
      // using the click start as activity end, so the click will have some activity but its
      // duration will be 0 (as the activity started before the click start)
      u.startClocks.timeStamp
    ) : u.stop();
  }, _We).stop, p = t.subscribe(4, function(I) {
    var C = I.endClocks;
    u.stop(C.timeStamp);
  }), m = a.subscribe(function() {
    u.stop();
  });
  u.stopObservable.subscribe(function() {
    p.unsubscribe(), g(), m.unsubscribe();
  });
}
function EWe(e, t, r) {
  var n = e.target.getBoundingClientRect();
  return {
    type: "click",
    target: {
      width: Math.round(n.width),
      height: Math.round(n.height),
      selector: qS(e.target, r.actionNameAttribute)
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(e.clientX - n.left),
      y: Math.round(e.clientY - n.top)
    },
    name: tWe(e.target, r, t)
  };
}
function S$(e, t, r, n, a) {
  var i = Tn(), o = $n(), s = t.add(i, o.relative), c = i$({
    lifeCycle: e,
    isChildEvent: function(I) {
      return I.action !== void 0 && (Array.isArray(I.action.id) ? uo(I.action.id, i) : I.action.id === i);
    }
  }), l = 0, u, g = [], p = new xt();
  function m(I) {
    l === 0 && (u = I, l = 1, u ? s.close(eF(u)) : s.remove(), c.stop(), p.notify());
  }
  return {
    event: a,
    stop: m,
    stopObservable: p,
    get hasError() {
      return c.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return u !== void 0;
    },
    getUserActivity: r,
    addFrustration: function(I) {
      g.push(I);
    },
    startClocks: o,
    isStopped: function() {
      return l === 1 || l === 2;
    },
    clone: function() {
      return S$(e, t, r, n, a);
    },
    validate: function(I) {
      if (m(), l === 1) {
        var C = c.eventCounts, A = C.resourceCount, U = C.errorCount, B = C.longTaskCount, J = Ge({
          type: "click",
          duration: u && Qn(o.timeStamp, u),
          startClocks: o,
          id: i,
          frustrationTypes: g,
          counts: {
            resourceCount: A,
            errorCount: U,
            longTaskCount: B
          },
          events: I ?? [a],
          event: a
        }, n);
        e.notify(0, J), l = 2;
      }
    },
    discard: function() {
      m(), l = 2;
    }
  };
}
function QWe(e, t) {
  var r = AWe(e, t).isRage;
  r ? (e.forEach(function(n) {
    return n.discard();
  }), t.stop(rn()), t.validate(e.map(function(n) {
    return n.event;
  }))) : (t.discard(), e.forEach(function(n) {
    return n.validate();
  }));
}
function FWe(e, t, r, n) {
  e.subscribe(0, function(i) {
    return e.notify(11, VV(i, n));
  });
  var a = { findActionId: Dt };
  return r.trackUserInteractions && (a = ZWe(e, t, r).actionContexts), {
    addAction: function(i, o) {
      e.notify(11, Ge({
        savedCommonContext: o
      }, VV(i, n)));
    },
    actionContexts: a
  };
}
function VV(e, t) {
  var r = sC(e) ? {
    action: {
      id: e.id,
      loading_time: a$(st(e.duration)),
      frustration: {
        type: e.frustrationTypes
      },
      error: {
        count: e.counts.errorCount
      },
      long_task: {
        count: e.counts.longTaskCount
      },
      resource: {
        count: e.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: e.target,
        position: e.position
      }
    }
  } : void 0, n = sC(e) ? void 0 : e.context, a = cs({
    action: {
      id: Tn(),
      target: {
        name: e.name
      },
      type: e.type
    },
    date: e.startClocks.timeStamp,
    type: "action",
    view: { in_foreground: t.wasInPageStateAt("active", e.startClocks.relative) }
  }, r), i = sC(e) ? { events: e.events } : {};
  return !sC(e) && e.handlingStack && (i.handlingStack = e.handlingStack), {
    customerContext: n,
    rawRumEvent: a,
    startTime: e.startClocks.relative,
    domainContext: i
  };
}
function sC(e) {
  return e.type !== "custom";
}
function TWe(e) {
  var t = wZe([Rw.error]).subscribe(function(r) {
    return e.notify(r.error);
  });
  return {
    stop: function() {
      t.unsubscribe();
    }
  };
}
function RWe(e, t) {
  var r = _Ne(e, [
    nv.cspViolation,
    nv.intervention
  ]).subscribe(function(n) {
    return t.notify(n);
  });
  return {
    stop: function() {
      r.unsubscribe();
    }
  };
}
function DWe(e, t, r, n) {
  var a = new xt();
  return TWe(a), yNe(a), RWe(t, a), a.subscribe(function(i) {
    return e.notify(13, { error: i });
  }), JWe(e, r, n);
}
function JWe(e, t, r) {
  return e.subscribe(13, function(n) {
    var a = n.error, i = n.customerContext, o = n.savedCommonContext;
    e.notify(11, Ge({
      customerContext: i,
      savedCommonContext: o
    }, VWe(a, t, r)));
  }), {
    addError: function(n, a) {
      var i = n.error, o = n.handlingStack, s = n.startClocks, c = n.context, l = i instanceof Error ? dd(i) : void 0, u = yP({
        stackTrace: l,
        originalError: i,
        handlingStack: o,
        startClocks: s,
        nonErrorPrefix: "Provided",
        source: o0.CUSTOM,
        handling: "handled"
      });
      e.notify(13, {
        customerContext: c,
        savedCommonContext: a,
        error: u
      });
    }
  };
}
function VWe(e, t, r) {
  var n = {
    date: e.startClocks.timeStamp,
    error: {
      id: Tn(),
      message: e.message,
      source: e.source,
      stack: e.stack,
      handling_stack: e.handlingStack,
      type: e.type,
      handling: e.handling,
      causes: e.causes,
      source_type: "browser",
      fingerprint: e.fingerprint,
      csp: e.csp
    },
    type: "error",
    view: { in_foreground: t.wasInPageStateAt("active", e.startClocks.relative) }
  }, a = r.findFeatureFlagEvaluations(e.startClocks.relative);
  a && !Yu(a) && (n.feature_flags = a);
  var i = {
    error: e.originalError,
    handlingStack: e.handlingStack
  };
  return {
    rawRumEvent: n,
    startTime: e.startClocks.relative,
    domainContext: i
  };
}
function MWe(e, t) {
  var r = ds(t, {
    type: jt.LONG_TASK,
    buffered: !0
  }).subscribe(function(n) {
    for (var a = 0, i = n; a < i.length; a++) {
      var o = i[a];
      if (o.entryType !== jt.LONG_TASK || !t.trackLongTasks)
        break;
      var s = Vw(o.startTime), c = {
        date: s.timeStamp,
        long_task: {
          id: Tn(),
          entry_type: "long-task",
          duration: st(o.duration)
        },
        type: "long_task",
        _dd: {
          discarded: !1
        }
      };
      e.notify(11, {
        rawRumEvent: c,
        startTime: s.relative,
        domainContext: { performanceEntry: o }
      });
    }
  });
  return {
    stop: function() {
      r.unsubscribe();
    }
  };
}
var MV = new YBe();
function GWe(e) {
  if (!(!performance || !("getEntriesByName" in performance))) {
    var t = performance.getEntriesByName(e.url, "resource");
    if (!(!t.length || !("toJSON" in t[0]))) {
      var r = t.filter(function(n) {
        return !MV.has(n);
      }).filter(function(n) {
        return qP(n) && e$(n);
      }).filter(function(n) {
        return xWe(n, e.startClocks.relative, I$({ startTime: e.startClocks.relative, duration: e.duration }));
      });
      if (r.length === 1)
        return MV.add(r[0]), r[0].toJSON();
    }
  }
}
function I$(e) {
  return r0(e.startTime, e.duration);
}
function xWe(e, t, r) {
  var n = 1;
  return e.startTime >= t - n && I$(e) <= r0(r, n);
}
var HWe = 2 * Wa;
function LWe(e) {
  var t = YWe(e) || OWe(e);
  if (!(!t || t.traceTime <= ls() - HWe))
    return t.traceId;
}
function YWe(e) {
  var t = e.querySelector("meta[name=dd-trace-id]"), r = e.querySelector("meta[name=dd-trace-time]");
  return C$(t && t.content, r && r.content);
}
function OWe(e) {
  var t = jWe(e);
  if (t)
    return C$(rv(t, "trace-id"), rv(t, "trace-time"));
}
function C$(e, t) {
  var r = t && Number(t);
  if (!(!e || !r))
    return {
      traceId: e,
      traceTime: r
    };
}
function jWe(e) {
  for (var t = 0; t < e.childNodes.length; t += 1) {
    var r = GV(e.childNodes[t]);
    if (r)
      return r;
  }
  if (e.body)
    for (var t = e.body.childNodes.length - 1; t >= 0; t -= 1) {
      var n = e.body.childNodes[t], r = GV(n);
      if (r)
        return r;
      if (!s$(n))
        break;
    }
}
function GV(e) {
  if (e && OBe(e)) {
    var t = /^\s*DATADOG;(.*?)\s*$/.exec(e.data);
    if (t)
      return t[1];
  }
}
function b$() {
  if (Hw(jt.NAVIGATION)) {
    var e = performance.getEntriesByType(jt.NAVIGATION)[0];
    if (e)
      return e;
  }
  var t = PWe(), r = Ge({
    entryType: jt.NAVIGATION,
    initiatorType: "navigation",
    name: window.location.href,
    startTime: 0,
    duration: t.responseEnd,
    decodedBodySize: 0,
    encodedBodySize: 0,
    transferSize: 0,
    toJSON: function() {
      return Ge({}, r, { toJSON: void 0 });
    }
  }, t);
  return r;
}
function PWe() {
  var e = {}, t = performance.timing;
  for (var r in t)
    if (t0(t[r])) {
      var n = r, a = t[n];
      e[n] = a === 0 ? 0 : eF(a);
    }
  return e;
}
function $We(e, t) {
  hF(e, "interactive", function() {
    var r = Ge(b$().toJSON(), {
      entryType: jt.RESOURCE,
      initiatorType: zP,
      traceId: LWe(document),
      toJSON: function() {
        return Ge({}, r, { toJSON: void 0 });
      }
    });
    t(r);
  });
}
function KWe(e, t, r, n) {
  n === void 0 && (n = $We), e.subscribe(7, function(i) {
    var o = XWe(i, t, r);
    o && e.notify(11, o);
  });
  var a = ds(t, {
    type: jt.RESOURCE,
    buffered: !0
  }).subscribe(function(i) {
    for (var o = 0, s = i; o < s.length; o++) {
      var c = s[o];
      if (!UBe(c)) {
        var l = xV(c, t);
        l && e.notify(11, l);
      }
    }
  });
  return n(t, function(i) {
    var o = xV(i, t);
    o && e.notify(11, o);
  }), {
    stop: function() {
      a.unsubscribe();
    }
  };
}
function XWe(e, t, r) {
  var n = GWe(e), a = n ? Vw(n.startTime) : e.startClocks, i = zWe(e, t);
  if (!(!t.trackResources && !i)) {
    var o = e.type === "xhr" ? "xhr" : "fetch", s = n ? y$(n) : void 0, c = eEe(r, a, e.duration), l = cs({
      date: a.timeStamp,
      resource: {
        id: Tn(),
        type: o,
        duration: c,
        method: e.method,
        status_code: e.status,
        url: t$(e.url) ? r$(e.url) : e.url
      },
      type: "resource",
      _dd: {
        discarded: !t.trackResources
      }
    }, i, s);
    return {
      startTime: a.relative,
      rawRumEvent: l,
      domainContext: {
        performanceEntry: n,
        xhr: e.xhr,
        response: e.response,
        requestInput: e.input,
        requestInit: e.init,
        error: e.error,
        isAborted: e.isAborted,
        handlingStack: e.handlingStack
      }
    };
  }
}
function xV(e, t) {
  var r = Vw(e.startTime), n = qWe(e, t);
  if (!(!t.trackResources && !n)) {
    var a = ABe(e), i = y$(e), o = cs({
      date: r.timeStamp,
      resource: {
        id: Tn(),
        type: a,
        url: e.name,
        status_code: tEe(e.responseStatus)
      },
      type: "resource",
      _dd: {
        discarded: !t.trackResources
      }
    }, n, i);
    return {
      startTime: r.relative,
      rawRumEvent: o,
      domainContext: {
        performanceEntry: e
      }
    };
  }
}
function y$(e) {
  var t = e.renderBlockingStatus;
  return {
    resource: Ge({
      duration: kBe(e),
      render_blocking_status: t
    }, ZBe(e), _Be(e))
  };
}
function zWe(e, t) {
  var r = e.traceSampled && e.traceId && e.spanId;
  if (r)
    return {
      _dd: {
        span_id: e.spanId.toDecimalString(),
        trace_id: e.traceId.toDecimalString(),
        rule_psr: w$(t)
      }
    };
}
function qWe(e, t) {
  var r = e.traceId;
  if (r)
    return {
      _dd: {
        trace_id: e.traceId,
        span_id: VZ().toDecimalString(),
        rule_psr: w$(t)
      }
    };
}
function w$(e) {
  return t0(e.traceSampleRate) ? e.traceSampleRate / 100 : void 0;
}
function eEe(e, t, r) {
  return e.wasInPageStateDuringPeriod("frozen", t.relative, r) ? void 0 : st(r);
}
function tEe(e) {
  return e === 0 ? void 0 : e;
}
function rEe(e, t, r) {
  var n = i$({
    lifeCycle: e,
    isChildEvent: function(o) {
      return o.view.id === t;
    },
    onChange: r
  }), a = n.stop, i = n.eventCounts;
  return {
    stop: a,
    eventCounts: i
  };
}
var nEe = 10 * Wa;
function aEe(e, t, r) {
  var n = ds(e, {
    type: jt.PAINT,
    buffered: !0
  }).subscribe(function(a) {
    var i = Hc(a, function(o) {
      return o.name === "first-contentful-paint" && o.startTime < t.timeStamp && o.startTime < nEe;
    });
    i && r(i.startTime);
  });
  return {
    stop: n.unsubscribe
  };
}
function iEe(e, t, r) {
  var n = ds(e, {
    type: jt.FIRST_INPUT,
    buffered: !0
  }).subscribe(function(a) {
    var i = Hc(a, function(c) {
      return c.startTime < t.timeStamp;
    });
    if (i) {
      var o = Qn(i.startTime, i.processingStart), s = void 0;
      i.target && u0(i.target) && (s = qS(i.target, e.actionNameAttribute)), r({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: o >= 0 ? o : 0,
        time: i.startTime,
        targetSelector: s
      });
    }
  });
  return {
    stop: function() {
      n.unsubscribe();
    }
  };
}
function oEe(e, t, r) {
  return r === void 0 && (r = b$), cEe(e, function() {
    var n = r();
    lEe(n) || t(sEe(n));
  });
}
function sEe(e) {
  return {
    domComplete: e.domComplete,
    domContentLoaded: e.domContentLoadedEventEnd,
    domInteractive: e.domInteractive,
    loadEvent: e.loadEventEnd,
    // In some cases the value reported is negative or is larger
    // than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    firstByte: e.responseStart >= 0 && e.responseStart <= co() ? e.responseStart : void 0
  };
}
function lEe(e) {
  return e.loadEventEnd <= 0;
}
function cEe(e, t) {
  var r, n = hF(e, "complete", function() {
    r = Nn(function() {
      return t();
    });
  }).stop;
  return {
    stop: function() {
      n(), Ui(r);
    }
  };
}
var dEe = 10 * Wa;
function uEe(e, t, r, n) {
  var a = 1 / 0, i = Ua(e, r, [
    "pointerdown",
    "keydown"
    /* DOM_EVENT.KEY_DOWN */
  ], function(c) {
    a = c.timeStamp;
  }, { capture: !0, once: !0 }).stop, o = 0, s = ds(e, {
    type: jt.LARGEST_CONTENTFUL_PAINT,
    buffered: !0
  }).subscribe(function(c) {
    var l = jke(c, function(g) {
      return g.entryType === jt.LARGEST_CONTENTFUL_PAINT && g.startTime < a && g.startTime < t.timeStamp && g.startTime < dEe && // Ensure to get the LCP entry with the biggest size, see
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
      g.size > o;
    });
    if (l) {
      var u = void 0;
      l.element && (u = qS(l.element, e.actionNameAttribute)), n({
        value: l.startTime,
        targetSelector: u
      }), o = l.size;
    }
  });
  return {
    stop: function() {
      i(), s.unsubscribe();
    }
  };
}
function A$(e, t) {
  t === void 0 && (t = window);
  var r, n;
  return document.visibilityState === "hidden" ? r = 0 : (r = 1 / 0, n = Ua(e, t, [
    "pagehide",
    "visibilitychange"
    /* DOM_EVENT.VISIBILITY_CHANGE */
  ], function(a) {
    (a.type === "pagehide" || document.visibilityState === "hidden") && (r = a.timeStamp, n());
  }, { capture: !0 }).stop), {
    get timeStamp() {
      return r;
    },
    stop: function() {
      n == null || n();
    }
  };
}
function hEe(e, t, r) {
  var n = {}, a = oEe(e, function(u) {
    t(u.loadEvent), n.navigationTimings = u, r();
  }).stop, i = A$(e), o = aEe(e, i, function(u) {
    n.firstContentfulPaint = u, r();
  }).stop, s = uEe(e, i, window, function(u) {
    n.largestContentfulPaint = u, r();
  }).stop, c = iEe(e, i, function(u) {
    n.firstInput = u, r();
  }).stop;
  function l() {
    a(), o(), s(), c(), i.stop();
  }
  return {
    stop: l,
    initialViewMetrics: n
  };
}
function pEe(e, t, r) {
  if (!SEe())
    return {
      stop: Dt
    };
  var n = 0, a, i;
  r({
    value: 0
  });
  var o = vEe(), s = ds(e, {
    type: jt.LAYOUT_SHIFT,
    buffered: !0
  }).subscribe(function(c) {
    for (var l = 0, u = c; l < u.length; l++) {
      var g = u[l];
      if (!g.hadRecentInput) {
        var p = o.update(g), m = p.cumulatedValue, I = p.isMaxValue;
        if (I) {
          var C = gEe(g.sources);
          a = C ? new WeakRef(C) : void 0, i = Qn(t, g.startTime);
        }
        if (m > n) {
          n = m;
          var C = a == null ? void 0 : a.deref();
          r({
            value: my(n, 4),
            targetSelector: C && qS(C, e.actionNameAttribute),
            time: i
          });
        }
      }
    }
  });
  return {
    stop: function() {
      s.unsubscribe();
    }
  };
}
function gEe(e) {
  var t;
  if (e)
    return (t = Hc(e, function(r) {
      return !!r.node && u0(r.node);
    })) === null || t === void 0 ? void 0 : t.node;
}
var fEe = 5 * qn, mEe = qn;
function vEe() {
  var e = 0, t, r, n = 0;
  return {
    update: function(a) {
      var i = t === void 0 || a.startTime - r >= mEe || a.startTime - t >= fEe, o;
      return i ? (t = r = a.startTime, n = e = a.value, o = !0) : (e += a.value, r = a.startTime, o = a.value > n, o && (n = a.value)), {
        cumulatedValue: e,
        isMaxValue: o
      };
    }
  };
}
function SEe() {
  return Hw(jt.LAYOUT_SHIFT) && "WeakRef" in window;
}
var mb, U$ = 0, pk = 1 / 0, gk = 0;
function IEe() {
  "interactionCount" in performance || mb || (mb = new window.PerformanceObserver(Re(function(e) {
    e.getEntries().forEach(function(t) {
      var r = t;
      r.interactionId && (pk = Math.min(pk, r.interactionId), gk = Math.max(gk, r.interactionId), U$ = (gk - pk) / 7 + 1);
    });
  })), mb.observe({ type: "event", buffered: !0, durationThreshold: 0 }));
}
var HV = function() {
  return mb ? U$ : window.performance.interactionCount || 0;
}, LV = 10, CEe = 1 * Wa;
function bEe(e, t, r) {
  if (!AEe())
    return {
      getInteractionToNextPaint: function() {
      },
      setViewEnd: Dt,
      stop: Dt
    };
  var n = wEe(r), a = n.getViewInteractionCount, i = n.stopViewInteractionCount, o = 1 / 0, s = yEe(a), c = -1, l, u;
  function g(I) {
    for (var C = 0, A = I; C < A.length; C++) {
      var U = A[C];
      U.interactionId && // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
      U.startTime >= t && U.startTime <= o && s.process(U);
    }
    var B = s.estimateP98Interaction();
    B && B.duration !== c && (c = B.duration, u = Qn(t, B.startTime), B.target && u0(B.target) ? l = qS(B.target, e.actionNameAttribute) : l = void 0);
  }
  var p = ds(e, {
    type: jt.FIRST_INPUT,
    buffered: !0
  }).subscribe(g), m = ds(e, {
    type: jt.EVENT,
    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L202-L210
    durationThreshold: 40,
    buffered: !0
  }).subscribe(g);
  return {
    getInteractionToNextPaint: function() {
      if (c >= 0)
        return {
          value: Math.min(c, CEe),
          targetSelector: l,
          time: u
        };
      if (a())
        return {
          value: 0
        };
    },
    setViewEnd: function(I) {
      o = I, i();
    },
    stop: function() {
      m.unsubscribe(), p.unsubscribe();
    }
  };
}
function yEe(e) {
  var t = [];
  function r() {
    t.sort(function(n, a) {
      return a.duration - n.duration;
    }).splice(LV);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process: function(n) {
      var a = t.findIndex(function(o) {
        return n.interactionId === o.interactionId;
      }), i = t[t.length - 1];
      a !== -1 ? n.duration > t[a].duration && (t[a] = n, r()) : (t.length < LV || n.duration > i.duration) && (t.push(n), r());
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction: function() {
      var n = Math.min(t.length - 1, Math.floor(e() / 50));
      return t[n];
    }
  };
}
function wEe(e) {
  IEe();
  var t = e === "initial_load" ? 0 : HV(), r = { stopped: !1 };
  function n() {
    return HV() - t;
  }
  return {
    getViewInteractionCount: function() {
      return r.stopped ? r.interactionCount : n();
    },
    stopViewInteractionCount: function() {
      r = { stopped: !0, interactionCount: n() };
    }
  };
}
function AEe() {
  return Hw(jt.EVENT) && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}
function UEe(e, t, r, n, a, i) {
  var o = n === "initial_load", s = !0, c = [], l = A$(r);
  function u() {
    if (!s && !o && c.length > 0) {
      var p = Math.max.apply(Math, c);
      p < l.timeStamp && i(p);
    }
  }
  var g = mF(e, t, r, function(p) {
    s && (s = !1, p.hadActivity && c.push(Qn(a.timeStamp, p.end)), u());
  }).stop;
  return {
    stop: function() {
      g(), l.stop();
    },
    setLoadEvent: function(p) {
      o && (o = !1, c.push(p), u());
    }
  };
}
function k$() {
  var e, t = window.visualViewport;
  return t ? e = t.pageLeft - t.offsetLeft : window.scrollX !== void 0 ? e = window.scrollX : e = window.pageXOffset || 0, Math.round(e);
}
function CF() {
  var e, t = window.visualViewport;
  return t ? e = t.pageTop - t.offsetTop : window.scrollY !== void 0 ? e = window.scrollY : e = window.pageYOffset || 0, Math.round(e);
}
var fk;
function _$(e) {
  return fk || (fk = kEe(e)), fk;
}
function kEe(e) {
  return new xt(function(t) {
    var r = Fl(function() {
      t.notify(jw());
    }, 200).throttled;
    return tr(e, window, "resize", r, { capture: !0, passive: !0 }).stop;
  });
}
function jw() {
  var e = window.visualViewport;
  return e ? {
    width: Number(e.width * e.scale),
    height: Number(e.height * e.scale)
  } : {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}
var _Ee = qn;
function NEe(e, t, r, n) {
  n === void 0 && (n = BEe(e));
  var a = 0, i = 0, o = 0, s = n.subscribe(function(c) {
    var l = c.scrollDepth, u = c.scrollTop, g = c.scrollHeight, p = !1;
    if (l > a && (a = l, p = !0), g > i) {
      i = g;
      var m = co();
      o = Qn(t.relative, m), p = !0;
    }
    p && r({
      maxDepth: Math.min(a, i),
      maxDepthScrollTop: u,
      maxScrollHeight: i,
      maxScrollHeightTime: o
    });
  });
  return {
    stop: function() {
      return s.unsubscribe();
    }
  };
}
function ZEe() {
  var e = CF(), t = jw().height, r = Math.round((document.scrollingElement || document.documentElement).scrollHeight), n = Math.round(t + e);
  return {
    scrollHeight: r,
    scrollDepth: n,
    scrollTop: e
  };
}
function BEe(e, t) {
  return t === void 0 && (t = _Ee), new xt(function(r) {
    function n() {
      r.notify(ZEe());
    }
    if (window.ResizeObserver) {
      var a = Fl(n, t, {
        leading: !1,
        trailing: !0
      }), i = document.scrollingElement || document.documentElement, o = new ResizeObserver(Re(a.throttled));
      o.observe(i);
      var s = tr(e, window, "scroll", a.throttled, {
        passive: !0
      });
      return function() {
        a.cancel(), o.unobserve(i), s.stop();
      };
    }
  });
}
function WEe(e, t, r, n, a, i) {
  var o = {}, s = UEe(e, t, r, a, i, function(A) {
    o.loadingTime = A, n();
  }), c = s.stop, l = s.setLoadEvent, u = NEe(r, i, function(A) {
    o.scroll = A;
  }).stop, g = pEe(r, i.relative, function(A) {
    o.cumulativeLayoutShift = A, n();
  }).stop, p = bEe(r, i.relative, a), m = p.stop, I = p.getInteractionToNextPaint, C = p.setViewEnd;
  return {
    stop: function() {
      c(), g(), u();
    },
    stopINPTracking: m,
    setLoadEvent: l,
    setViewEnd: C,
    getCommonViewMetrics: function() {
      return o.interactionToNextPaint = I(), o;
    }
  };
}
var EEe = 3e3, QEe = 5 * Wa, FEe = 5 * Wa;
function TEe(e, t, r, n, a, i, o) {
  var s = /* @__PURE__ */ new Set(), c = u("initial_load", aP(), o);
  g();
  var l;
  i && (l = p(a));
  function u(m, I, C) {
    var A = REe(t, r, n, e, m, I, C);
    return s.add(A), A.stopObservable.subscribe(function() {
      s.delete(A);
    }), A;
  }
  function g() {
    t.subscribe(9, function() {
      c = u("route_change", void 0, {
        name: c.name,
        service: c.service,
        version: c.version,
        context: c.contextManager.getContext()
      });
    }), t.subscribe(8, function() {
      c.end({ sessionIsActive: !1 });
    }), t.subscribe(10, function(m) {
      m.reason === fp.UNLOADING && c.end();
    });
  }
  function p(m) {
    return m.subscribe(function(I) {
      var C = I.oldLocation, A = I.newLocation;
      JEe(C, A) && (c.end(), c = u(
        "route_change"
        /* ViewLoadingType.ROUTE_CHANGE */
      ));
    });
  }
  return {
    addTiming: function(m, I) {
      I === void 0 && (I = rn()), c.addTiming(m, I);
    },
    startView: function(m, I) {
      c.end({ endClocks: I }), c = u("route_change", I, m);
    },
    setViewContext: function(m) {
      c.contextManager.setContext(m);
    },
    setViewContextProperty: function(m, I) {
      c.contextManager.setContextProperty(m, I);
    },
    updateViewName: function(m) {
      c.updateViewName(m);
    },
    stop: function() {
      l && l.unsubscribe(), c.end(), s.forEach(function(m) {
        return m.stop();
      });
    }
  };
}
function REe(e, t, r, n, a, i, o) {
  i === void 0 && (i = $n());
  var s = Tn(), c = new xt(), l = {}, u = 0, g, p = tv(n), m = JZ(), I = !0, C, A, U, B;
  o && (C = o.name, A = o.service || void 0, U = o.version || void 0, o.context && (B = o.context, m.setContext(B)));
  var J = {
    id: s,
    name: C,
    startClocks: i,
    service: A,
    version: U,
    context: B
  };
  e.notify(1, J), e.notify(2, J);
  var W = Fl(Rr, EEe, {
    leading: !1
  }), L = W.throttled, H = W.cancel, R = WEe(e, t, r, L, a, i), ge = R.setLoadEvent, z = R.setViewEnd, K = R.stop, Fe = R.stopINPTracking, yr = R.getCommonViewMetrics, hr = a === "initial_load" ? hEe(r, ge, L) : { stop: Dt, initialViewMetrics: {} }, ea = hr.stop, Rn = hr.initialViewMetrics, vs = rEe(e, s, L), Ss = vs.stop, Tl = vs.eventCounts, ta = n0(Rr, QEe);
  Rr(), m.changeObservable.subscribe(Rr);
  function Rr() {
    H(), u += 1;
    var wr = g === void 0 ? rn() : g.timeStamp;
    e.notify(3, {
      customTimings: l,
      documentVersion: u,
      id: s,
      name: C,
      service: A,
      version: U,
      context: m.getContext(),
      loadingType: a,
      location: p,
      startClocks: i,
      commonViewMetrics: yr(),
      initialViewMetrics: Rn,
      duration: Qn(i.timeStamp, wr),
      isActive: g === void 0,
      sessionIsActive: I,
      eventCounts: Tl
    });
  }
  return {
    get name() {
      return C;
    },
    service: A,
    version: U,
    contextManager: m,
    stopObservable: c,
    end: function(wr) {
      var ye = this, fr, Rl;
      wr === void 0 && (wr = {}), !g && (g = (fr = wr.endClocks) !== null && fr !== void 0 ? fr : $n(), I = (Rl = wr.sessionIsActive) !== null && Rl !== void 0 ? Rl : !0, e.notify(4, { endClocks: g }), e.notify(5, { endClocks: g }), Gw(ta), z(g.relative), K(), Rr(), Nn(function() {
        ye.stop();
      }, FEe));
    },
    stop: function() {
      ea(), Ss(), Fe(), c.notify();
    },
    addTiming: function(wr, ye) {
      if (!g) {
        var fr = Lke(ye) ? ye : Qn(i.timeStamp, ye);
        l[DEe(wr)] = fr, L();
      }
    },
    updateViewName: function(wr) {
      KS(Yc.UPDATE_VIEW_NAME) && (C = wr, Rr());
    }
  };
}
function DEe(e) {
  var t = e.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
  return t !== e && Et.warn("Invalid timing name: ".concat(e, ", sanitized to: ").concat(t)), t;
}
function JEe(e, t) {
  return e.pathname !== t.pathname || !VEe(t.hash) && YV(t.hash) !== YV(e.hash);
}
function VEe(e) {
  var t = e.substring(1);
  return t !== "" && !!document.getElementById(t);
}
function YV(e) {
  var t = e.indexOf("?");
  return t < 0 ? e : e.slice(0, t);
}
function MEe(e, t, r, n, a, i, o, s, c) {
  return e.subscribe(3, function(l) {
    return e.notify(11, GEe(l, t, i, s, o));
  }), TEe(r, e, n, t, a, !t.trackViewsManually, c);
}
function GEe(e, t, r, n, a) {
  var i, o, s, c, l, u, g, p, m, I, C, A, U, B, J, W, L = n.getReplayStats(e.id), H = r.findFeatureFlagEvaluations(e.startClocks.relative), R = a.findAll(e.startClocks.relative, e.duration), ge = {
    _dd: {
      document_version: e.documentVersion,
      replay_stats: L,
      page_states: R,
      configuration: {
        start_session_replay_recording_manually: t.startSessionReplayRecordingManually
      }
    },
    date: e.startClocks.timeStamp,
    type: "view",
    view: {
      action: {
        count: e.eventCounts.actionCount
      },
      frustration: {
        count: e.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (i = e.commonViewMetrics.cumulativeLayoutShift) === null || i === void 0 ? void 0 : i.value,
      cumulative_layout_shift_time: st((o = e.commonViewMetrics.cumulativeLayoutShift) === null || o === void 0 ? void 0 : o.time),
      cumulative_layout_shift_target_selector: (s = e.commonViewMetrics.cumulativeLayoutShift) === null || s === void 0 ? void 0 : s.targetSelector,
      first_byte: st((c = e.initialViewMetrics.navigationTimings) === null || c === void 0 ? void 0 : c.firstByte),
      dom_complete: st((l = e.initialViewMetrics.navigationTimings) === null || l === void 0 ? void 0 : l.domComplete),
      dom_content_loaded: st((u = e.initialViewMetrics.navigationTimings) === null || u === void 0 ? void 0 : u.domContentLoaded),
      dom_interactive: st((g = e.initialViewMetrics.navigationTimings) === null || g === void 0 ? void 0 : g.domInteractive),
      error: {
        count: e.eventCounts.errorCount
      },
      first_contentful_paint: st(e.initialViewMetrics.firstContentfulPaint),
      first_input_delay: st((p = e.initialViewMetrics.firstInput) === null || p === void 0 ? void 0 : p.delay),
      first_input_time: st((m = e.initialViewMetrics.firstInput) === null || m === void 0 ? void 0 : m.time),
      first_input_target_selector: (I = e.initialViewMetrics.firstInput) === null || I === void 0 ? void 0 : I.targetSelector,
      interaction_to_next_paint: st((C = e.commonViewMetrics.interactionToNextPaint) === null || C === void 0 ? void 0 : C.value),
      interaction_to_next_paint_time: st((A = e.commonViewMetrics.interactionToNextPaint) === null || A === void 0 ? void 0 : A.time),
      interaction_to_next_paint_target_selector: (U = e.commonViewMetrics.interactionToNextPaint) === null || U === void 0 ? void 0 : U.targetSelector,
      is_active: e.isActive,
      name: e.name,
      largest_contentful_paint: st((B = e.initialViewMetrics.largestContentfulPaint) === null || B === void 0 ? void 0 : B.value),
      largest_contentful_paint_target_selector: (J = e.initialViewMetrics.largestContentfulPaint) === null || J === void 0 ? void 0 : J.targetSelector,
      load_event: st((W = e.initialViewMetrics.navigationTimings) === null || W === void 0 ? void 0 : W.loadEvent),
      loading_time: a$(st(e.commonViewMetrics.loadingTime)),
      loading_type: e.loadingType,
      long_task: {
        count: e.eventCounts.longTaskCount
      },
      resource: {
        count: e.eventCounts.resourceCount
      },
      time_spent: st(e.duration)
    },
    feature_flags: H && !Yu(H) ? H : void 0,
    display: e.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: e.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: e.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: e.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: st(e.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : void 0,
    session: {
      has_replay: L ? !0 : void 0,
      is_active: e.sessionIsActive ? void 0 : !1
    },
    privacy: {
      replay_level: t.defaultPrivacyLevel
    }
  };
  return Yu(e.customTimings) || (ge.view.custom_timings = Kke(e.customTimings, st)), {
    rawRumEvent: ge,
    startTime: e.startClocks.relative,
    domainContext: {
      location: e.location
    }
  };
}
var xEe = "rum";
function HEe(e, t, r) {
  var n = ONe(e, xEe, function(a) {
    return YEe(e, a);
  }, r);
  return n.expireObservable.subscribe(function() {
    t.notify(
      8
      /* LifeCycleEventType.SESSION_EXPIRED */
    );
  }), n.renewObservable.subscribe(function() {
    t.notify(
      9
      /* LifeCycleEventType.SESSION_RENEWED */
    );
  }), n.sessionStateUpdateObservable.subscribe(function(a) {
    var i = a.previousState, o = a.newState;
    if (!i.forcedReplay && o.forcedReplay) {
      var s = n.findSession();
      s && (s.isReplayForced = !0);
    }
  }), {
    findTrackedSession: function(a) {
      var i = n.findSession(a);
      if (!(!i || !N$(i.trackingType)))
        return {
          id: i.id,
          sessionReplay: i.trackingType === "1" ? 1 : i.isReplayForced ? 2 : 0
        };
    },
    expire: n.expire,
    expireObservable: n.expireObservable,
    setForcedReplay: function() {
      return n.updateSessionState({ forcedReplay: "1" });
    }
  };
}
function LEe() {
  var e = {
    id: "00000000-aaaa-0000-aaaa-000000000000",
    sessionReplay: MP(
      "records"
      /* BridgeCapability.RECORDS */
    ) ? 1 : 0
  };
  return {
    findTrackedSession: function() {
      return e;
    },
    expire: Dt,
    expireObservable: new xt(),
    setForcedReplay: Dt
  };
}
function YEe(e, t) {
  var r;
  return OEe(t) ? r = t : Au(e.sessionSampleRate) ? Au(e.sessionReplaySampleRate) ? r = "1" : r = "2" : r = "0", {
    trackingType: r,
    isTracked: N$(r)
  };
}
function OEe(e) {
  return e === "0" || e === "1" || e === "2";
}
function N$(e) {
  return e === "2" || e === "1";
}
function jEe(e, t, r, n, a, i, o) {
  var s = e.replica, c = hZe(e, {
    endpoint: e.rumEndpointBuilder,
    encoder: o(
      2
      /* DeflateEncoderStreamId.RUM */
    )
  }, s && {
    endpoint: s.rumEndpointBuilder,
    transformMessage: function(l) {
      return cs(l, { application: { id: s.applicationId } });
    },
    encoder: o(
      3
      /* DeflateEncoderStreamId.RUM_REPLICA */
    )
  }, n, a, i);
  return t.subscribe(12, function(l) {
    l.type === "view" ? c.upsert(l, l.view.id) : c.add(l);
  }), r.subscribe(function(l) {
    return c.add(l, VNe(e));
  }), c;
}
function PEe(e) {
  var t = d0();
  e.subscribe(12, function(r) {
    t.send("rum", r);
  });
}
var $Ee = lh;
function KEe(e, t, r) {
  var n = c0({ expireDelay: $Ee }), a;
  e.subscribe(1, function(s) {
    var c = s.startClocks, l = r.href;
    n.add(o({
      url: l,
      referrer: a || document.referrer
    }), c.relative), a = l;
  }), e.subscribe(5, function(s) {
    var c = s.endClocks;
    n.closeActive(c.relative);
  });
  var i = t.subscribe(function(s) {
    var c = s.newLocation, l = n.find();
    if (l) {
      var u = co();
      n.closeActive(u), n.add(o({
        url: c.href,
        referrer: l.referrer
      }), u);
    }
  });
  function o(s) {
    var c = s.url, l = s.referrer;
    return {
      url: c,
      referrer: l
    };
  }
  return {
    findUrl: function(s) {
      return n.find(s);
    },
    stop: function() {
      i.unsubscribe(), n.stop();
    }
  };
}
function XEe(e, t) {
  var r = tv(t);
  return new xt(function(n) {
    var a = zEe(e, o).stop, i = qEe(e, o).stop;
    function o() {
      if (r.href !== t.href) {
        var s = tv(t);
        n.notify({
          newLocation: s,
          oldLocation: r
        }), r = s;
      }
    }
    return function() {
      a(), i();
    };
  });
}
function zEe(e, t) {
  var r = va(OV("pushState"), "pushState", function(i) {
    var o = i.onPostCall;
    o(t);
  }).stop, n = va(OV("replaceState"), "replaceState", function(i) {
    var o = i.onPostCall;
    o(t);
  }).stop, a = tr(e, window, "popstate", t).stop;
  return {
    stop: function() {
      r(), n(), a();
    }
  };
}
function qEe(e, t) {
  return tr(e, window, "hashchange", t);
}
function OV(e) {
  return Object.prototype.hasOwnProperty.call(history, e) ? history : History.prototype;
}
var eQe = lh;
function tQe(e, t) {
  var r = c0({
    expireDelay: eQe
  });
  return e.subscribe(1, function(n) {
    var a = n.startClocks;
    r.add({}, a.relative), t.resetCustomerData();
  }), e.subscribe(5, function(n) {
    var a = n.endClocks;
    r.closeActive(a.relative);
  }), {
    findFeatureFlagEvaluations: function(n) {
      return r.find(n);
    },
    addFeatureFlagEvaluation: function(n, a) {
      var i = r.find();
      i && (i[n] = a, t.updateCustomerData(i));
    },
    stop: function() {
      return t.stop();
    }
  };
}
var rQe = 10 * qn, Ys, Qd, MZ;
function nQe(e, t, r, n, a) {
  var i = t.enabled && Au(e.customerDataTelemetrySampleRate);
  i && (Z$(), jV(), r.subscribe(12, function(o) {
    MZ = !0, j0(Qd.globalContextBytes, n.getOrCreateTracker(
      2
      /* CustomerDataType.GlobalContext */
    ).getBytesCount()), j0(Qd.userContextBytes, n.getOrCreateTracker(
      1
      /* CustomerDataType.User */
    ).getBytesCount()), j0(Qd.featureFlagBytes, uo([
      "view",
      "error"
      /* RumEventType.ERROR */
    ], o.type) ? n.getOrCreateTracker(
      0
      /* CustomerDataType.FeatureFlag */
    ).getBytesCount() : 0);
  }), a.subscribe(function(o) {
    var s = o.bytesCount, c = o.messagesCount;
    MZ && (Ys.batchCount += 1, j0(Ys.batchBytesCount, s), j0(Ys.batchMessagesCount, c), mk(Ys.globalContextBytes, Qd.globalContextBytes), mk(Ys.userContextBytes, Qd.userContextBytes), mk(Ys.featureFlagBytes, Qd.featureFlagBytes), jV());
  }), n0(aQe, rQe));
}
function aQe() {
  Ys.batchCount !== 0 && (l0("Customer data measures", Ys), Z$());
}
function tc() {
  return { min: 1 / 0, max: 0, sum: 0 };
}
function j0(e, t) {
  e.sum += t, e.min = Math.min(e.min, t), e.max = Math.max(e.max, t);
}
function mk(e, t) {
  e.sum += t.sum, e.min = Math.min(e.min, t.min), e.max = Math.max(e.max, t.max);
}
function Z$() {
  Ys = {
    batchCount: 0,
    batchBytesCount: tc(),
    batchMessagesCount: tc(),
    globalContextBytes: tc(),
    userContextBytes: tc(),
    featureFlagBytes: tc()
  };
}
function jV() {
  MZ = !1, Qd = {
    globalContextBytes: tc(),
    userContextBytes: tc(),
    featureFlagBytes: tc()
  };
}
var iQe = 4e3, oQe = 500, sQe = lh;
function lQe(e, t) {
  t === void 0 && (t = oQe);
  var r = c0({
    expireDelay: sQe,
    maxEntries: iQe
  }), n;
  i(B$(), co());
  var a = Ua(e, window, [
    "pageshow",
    "focus",
    "blur",
    "visibilitychange",
    "resume",
    "freeze",
    "pagehide"
  ], function(s) {
    i(cQe(s), s.timeStamp);
  }, { capture: !0 }).stop;
  function i(s, c) {
    c === void 0 && (c = co()), s !== n && (n = s, r.closeActive(c), r.add({ state: n, startTime: c }, c));
  }
  var o = {
    findAll: function(s, c) {
      var l = r.findAll(s, c);
      if (l.length !== 0) {
        for (var u = [], g = Math.max(0, l.length - t), p = l.length - 1; p >= g; p--) {
          var m = l[p], I = Qn(s, m.startTime);
          u.push({
            state: m.state,
            start: st(I)
          });
        }
        return u;
      }
    },
    wasInPageStateAt: function(s, c) {
      return o.wasInPageStateDuringPeriod(s, c, 0);
    },
    wasInPageStateDuringPeriod: function(s, c, l) {
      return r.findAll(c, l).some(function(u) {
        return u.state === s;
      });
    },
    addPageState: i,
    stop: function() {
      a(), r.stop();
    }
  };
  return o;
}
function cQe(e) {
  return e.type === "freeze" ? "frozen" : e.type === "pagehide" ? e.persisted ? "frozen" : "terminated" : B$();
}
function B$() {
  return document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
function dQe(e) {
  var t = jw(), r = _$(e).subscribe(function(n) {
    t = n;
  }).unsubscribe;
  return {
    get: function() {
      return { viewport: t };
    },
    stop: r
  };
}
function uQe(e, t) {
  var r = window.cookieStore ? hQe(e) : gQe;
  return new xt(function(n) {
    return r(t, function(a) {
      return n.notify(a);
    });
  });
}
function hQe(e) {
  return function(t, r) {
    var n = tr(e, window.cookieStore, "change", function(a) {
      var i = Hc(a.changed, function(o) {
        return o.name === t;
      }) || Hc(a.deleted, function(o) {
        return o.name === t;
      });
      i && r(i.value);
    });
    return n.stop;
  };
}
var pQe = qn;
function gQe(e, t) {
  var r = rv(document.cookie, e), n = n0(function() {
    var a = rv(document.cookie, e);
    a !== r && t(a);
  }, pQe);
  return function() {
    Gw(n);
  };
}
var PV = "datadog-ci-visibility-test-execution-id";
function fQe(e, t) {
  var r;
  t === void 0 && (t = uQe(e, PV));
  var n = bc(PV) || ((r = window.Cypress) === null || r === void 0 ? void 0 : r.env("traceId")), a = t.subscribe(function(i) {
    n = i;
  });
  return {
    get: function() {
      if (typeof n == "string")
        return {
          test_execution_id: n
        };
    },
    stop: function() {
      return a.unsubscribe();
    }
  };
}
function mQe(e, t) {
  var r = ds(t, {
    type: jt.LONG_ANIMATION_FRAME,
    buffered: !0
  }).subscribe(function(n) {
    for (var a = 0, i = n; a < i.length; a++) {
      var o = i[a], s = Vw(o.startTime), c = {
        date: s.timeStamp,
        long_task: {
          id: Tn(),
          entry_type: "long-animation-frame",
          duration: st(o.duration),
          blocking_duration: st(o.blockingDuration),
          first_ui_event_timestamp: st(o.firstUIEventTimestamp),
          render_start: st(o.renderStart),
          style_and_layout_start: st(o.styleAndLayoutStart),
          scripts: o.scripts.map(function(l) {
            return {
              duration: st(l.duration),
              pause_duration: st(l.pauseDuration),
              forced_style_and_layout_duration: st(l.forcedStyleAndLayoutDuration),
              start_time: st(l.startTime),
              execution_start: st(l.executionStart),
              source_url: l.sourceURL,
              source_function_name: l.sourceFunctionName,
              source_char_position: l.sourceCharPosition,
              invoker: l.invoker,
              invoker_type: l.invokerType,
              window_attribution: l.windowAttribution
            };
          })
        },
        type: "long_task",
        _dd: {
          discarded: !1
        }
      };
      e.notify(11, {
        rawRumEvent: c,
        startTime: s.relative,
        domainContext: { performanceEntry: o }
      });
    }
  });
  return {
    stop: function() {
      return r.unsubscribe();
    }
  };
}
function vQe(e, t, r, n, a, i, o, s) {
  var c = [], l = new CBe();
  l.subscribe(12, function(ye) {
    return dF("rum", ye);
  });
  var u = SQe(e);
  u.setContextProvider(function() {
    var ye, fr;
    return {
      application: {
        id: e.applicationId
      },
      session: {
        id: (ye = C.findTrackedSession()) === null || ye === void 0 ? void 0 : ye.id
      },
      view: {
        id: (fr = L.findView()) === null || fr === void 0 ? void 0 : fr.id
      },
      action: {
        id: R.findActionId()
      }
    };
  });
  var g = function(ye) {
    l.notify(13, { error: ye }), l0("Error reported to customer", { "error.message": ye.message });
  }, p = tQe(l, r.getOrCreateTracker(
    0
    /* CustomerDataType.FeatureFlag */
  )), m = cZe(e), I = m.subscribe(function(ye) {
    l.notify(10, ye);
  });
  c.push(function() {
    return I.unsubscribe();
  });
  var C = ju() ? LEe() : HEe(e, l, o);
  if (ju())
    PEe(l);
  else {
    var A = jEe(e, l, u.observable, g, m, C.expireObservable, i);
    c.push(function() {
      return A.stop();
    }), nQe(e, u, l, r, A.flushObservable);
  }
  var U = uBe(), B = XEe(e, location), J = lQe(e), W = IQe(l, e, location, C, J, B, U, n, g), L = W.viewHistory, H = W.urlContexts, R = W.actionContexts, ge = W.addAction, z = W.stop;
  c.push(z), JNe();
  var K = MEe(l, e, location, U, B, p, J, t, a), Fe = K.addTiming, yr = K.startView, hr = K.updateViewName, ea = K.setViewContext, Rn = K.setViewContextProperty, vs = K.stop;
  c.push(vs);
  var Ss = KWe(l, e, J).stop;
  if (c.push(Ss), KS(Yc.LONG_ANIMATION_FRAME)) {
    if (e.trackLongTasks) {
      var Tl = mQe(l, e).stop;
      c.push(Tl);
    }
  } else
    MWe(l, e);
  var ta = DWe(l, e, J, p).addError;
  WBe(l, e, C);
  var Rr = LZe(l, J, s), wr = IBe(e.applicationId, C, L, R, H);
  return {
    addAction: ge,
    addError: ta,
    addTiming: Fe,
    addFeatureFlagEvaluation: p.addFeatureFlagEvaluation,
    startView: yr,
    setViewContext: ea,
    setViewContextProperty: Rn,
    updateViewName: hr,
    lifeCycle: l,
    viewHistory: L,
    session: C,
    stopSession: function() {
      return C.expire();
    },
    getInternalContext: wr.get,
    startDurationVital: Rr.startDurationVital,
    stopDurationVital: Rr.stopDurationVital,
    addDurationVital: Rr.addDurationVital,
    stop: function() {
      c.forEach(function(ye) {
        return ye();
      });
    }
  };
}
function SQe(e) {
  var t = RNe("browser-rum-sdk", e);
  if (ju()) {
    var r = d0();
    t.observable.subscribe(function(n) {
      return r.send("internal_telemetry", n);
    });
  }
  return t;
}
function IQe(e, t, r, n, a, i, o, s, c) {
  var l = yBe(e), u = KEe(e, i, r), g = FWe(e, o, t, a), p = g.addAction, m = g.actionContexts, I = dQe(t), C = fQe(t);
  return mBe(t, e, n, l, u, m, I, C, s, c), {
    viewHistory: l,
    pageStateHistory: a,
    urlContexts: u,
    addAction: p,
    actionContexts: m,
    stop: function() {
      C.stop(), I.stop(), u.stop(), l.stop(), a.stop();
    }
  };
}
function CQe(e, t) {
  var r = t.session, n = t.viewContext, a = t.errorType, i = r ? r.id : "no-session-id", o = [];
  a !== void 0 && o.push("error-type=".concat(a)), n && (o.push("seed=".concat(n.id)), o.push("from=".concat(n.startClocks.timeStamp)));
  var s = bQe(e), c = "/rum/replay/sessions/".concat(i);
  return "".concat(s).concat(c, "?").concat(o.join("&"));
}
function bQe(e) {
  var t = e.site, r = e.subdomain || yQe(e);
  return "https://".concat(r ? "".concat(r, ".") : "").concat(t);
}
function yQe(e) {
  switch (e.site) {
    case yc:
    case R_e:
      return "app";
    case vP:
      return "dd";
    default:
      return;
  }
}
var wQe = 10, xn;
function AQe(e) {
  return Pw(e).segments_count;
}
function UQe(e) {
  Pw(e).segments_count += 1;
}
function kQe(e) {
  Pw(e).records_count += 1;
}
function _Qe(e, t) {
  Pw(e).segments_total_raw_size += t;
}
function NQe(e) {
  return xn == null ? void 0 : xn.get(e);
}
function Pw(e) {
  xn || (xn = /* @__PURE__ */ new Map());
  var t;
  return xn.has(e) ? t = xn.get(e) : (t = {
    records_count: 0,
    segments_count: 0,
    segments_total_raw_size: 0
  }, xn.set(e, t), xn.size > wQe && ZQe()), t;
}
function ZQe() {
  if (xn)
    if (xn.keys) {
      var e = xn.keys().next().value;
      e && xn.delete(e);
    } else {
      var t = !0;
      xn.forEach(function(r, n) {
        t && (xn.delete(n), t = !1);
      });
    }
}
var bF = /* @__PURE__ */ new WeakMap();
function ns(e) {
  return bF.has(e);
}
function BQe(e) {
  for (var t = e; t; ) {
    if (!ns(t) && !vF(t))
      return !1;
    t = Yw(t);
  }
  return !0;
}
function fa(e) {
  return bF.get(e);
}
function WQe(e, t) {
  bF.set(e, t);
}
function yF(e, t) {
  var r = e.tagName, n = e.value;
  if (Ow(e, t)) {
    var a = e.type;
    return r === "INPUT" && (a === "button" || a === "submit" || a === "reset") ? n : !n || r === "OPTION" ? void 0 : wc;
  }
  if (r === "OPTION" || r === "SELECT")
    return e.value;
  if (!(r !== "INPUT" && r !== "TEXTAREA"))
    return n;
}
var EQe = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm, QQe = /^[A-Za-z]+:|^\/\//, FQe = /^data:.*,/i;
function TQe(e, t) {
  return e.replace(EQe, function(r, n, a, i, o, s) {
    var c = a || o || s;
    if (!t || !c || QQe.test(c) || FQe.test(c))
      return r;
    var l = n || i || "";
    return "url(".concat(l).concat(RQe(c, t)).concat(l, ")");
  });
}
function RQe(e, t) {
  try {
    return xw(e, t).href;
  } catch {
    return e;
  }
}
var DQe = /[^a-z1-6-_]/;
function W$(e) {
  var t = e.toLowerCase().trim();
  return DQe.test(t) ? "div" : t;
}
function $V(e, t) {
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(e, "' height='").concat(t, "' style='background-color:silver'%3E%3C/svg%3E");
}
var jo = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
}, Pu = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4,
  DocumentFragment: 11
}, Ni = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8
  // CanvasMutation : 9,
  // Font : 10,
}, $i = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
}, KV = {
  Play: 0,
  Pause: 1
};
function E$(e) {
  if (!(e === void 0 || e.length === 0))
    return e.map(function(t) {
      var r = t.cssRules || t.rules, n = Array.from(r, function(i) {
        return i.cssText;
      }), a = {
        cssRules: n,
        disabled: t.disabled || void 0,
        media: t.media.length > 0 ? Array.from(t.media) : void 0
      };
      return a;
    });
}
function Q$(e, t, r, n) {
  if (t === Je.HIDDEN)
    return null;
  var a = e.getAttribute(r);
  if (t === Je.MASK && r !== SF && !g$.includes(r) && r !== n.actionNameAttribute) {
    var i = e.tagName;
    switch (r) {
      case "title":
      case "alt":
      case "placeholder":
        return wc;
    }
    if (i === "IMG" && (r === "src" || r === "srcset")) {
      var o = e;
      if (o.naturalWidth > 0)
        return $V(o.naturalWidth, o.naturalHeight);
      var s = e.getBoundingClientRect(), c = s.width, l = s.height;
      return c > 0 || l > 0 ? $V(c, l) : BV;
    }
    if (i === "SOURCE" && (r === "src" || r === "srcset"))
      return BV;
    if (i === "A" && r === "href" || a && PS(r, "data-") || i === "IFRAME" && r === "srcdoc")
      return wc;
  }
  return !a || typeof a != "string" ? a : t$(a) ? r$(a) : a;
}
function JQe(e, t, r) {
  var n;
  if (t === Je.HIDDEN)
    return {};
  for (var a = {}, i = W$(e.tagName), o = e.ownerDocument, s = 0; s < e.attributes.length; s += 1) {
    var c = e.attributes.item(s), l = c.name, u = Q$(e, t, l, r.configuration);
    u !== null && (a[l] = u);
  }
  if (e.value && (i === "textarea" || i === "select" || i === "option" || i === "input")) {
    var g = yF(e, t);
    g !== void 0 && (a.value = g);
  }
  if (i === "option" && t === Je.ALLOW) {
    var p = e;
    p.selected && (a.selected = p.selected);
  }
  if (i === "link") {
    var m = Array.from(o.styleSheets).find(function(W) {
      return W.href === e.href;
    }), I = GZ(m);
    I && m && (a._cssText = I);
  }
  if (i === "style" && e.sheet) {
    var I = GZ(e.sheet);
    I && (a._cssText = I);
  }
  var C = e;
  if (i === "input" && (C.type === "radio" || C.type === "checkbox") && (t === Je.ALLOW ? a.checked = !!C.checked : Ow(C, t) && delete a.checked), i === "audio" || i === "video") {
    var A = e;
    a.rr_mediaState = A.paused ? "paused" : "played";
  }
  var U, B, J = r.serializationContext;
  switch (J.status) {
    case 0:
      U = Math.round(e.scrollTop), B = Math.round(e.scrollLeft), (U || B) && J.elementsScrollPositions.set(e, { scrollTop: U, scrollLeft: B });
      break;
    case 1:
      J.elementsScrollPositions.has(e) && (n = J.elementsScrollPositions.get(e), U = n.scrollTop, B = n.scrollLeft);
      break;
  }
  return B && (a.rr_scrollLeft = B), U && (a.rr_scrollTop = U), a;
}
function GZ(e) {
  if (!e)
    return null;
  var t;
  try {
    t = e.rules || e.cssRules;
  } catch {
  }
  if (!t)
    return null;
  var r = Array.from(t, n_e() ? VQe : F$).join("");
  return TQe(r, e.href);
}
function VQe(e) {
  if (GQe(e) && e.selectorText.includes(":")) {
    var t = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
    return e.cssText.replace(t, "$1\\$2");
  }
  return F$(e);
}
function F$(e) {
  return MQe(e) && GZ(e.styleSheet) || e.cssText;
}
function MQe(e) {
  return "styleSheet" in e;
}
function GQe(e) {
  return "selectorText" in e;
}
function wF(e, t) {
  var r = LQe(e, t);
  if (!r)
    return null;
  var n = fa(e) || HQe(), a = r;
  return a.id = n, WQe(e, n), t.serializedNodeIds && t.serializedNodeIds.add(n), a;
}
var xQe = 1;
function HQe() {
  return xQe++;
}
function AF(e, t) {
  var r = [];
  return l$(e, function(n) {
    var a = wF(n, t);
    a && r.push(a);
  }), r;
}
function LQe(e, t) {
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return YQe(e, t);
    case e.DOCUMENT_FRAGMENT_NODE:
      return OQe(e, t);
    case e.DOCUMENT_TYPE_NODE:
      return jQe(e);
    case e.ELEMENT_NODE:
      return PQe(e, t);
    case e.TEXT_NODE:
      return KQe(e, t);
    case e.CDATA_SECTION_NODE:
      return XQe();
  }
}
function YQe(e, t) {
  return {
    type: Pu.Document,
    childNodes: AF(e, t),
    adoptedStyleSheets: E$(e.adoptedStyleSheets)
  };
}
function OQe(e, t) {
  var r = vF(e);
  return r && t.serializationContext.shadowRootsController.addShadowRoot(e), {
    type: Pu.DocumentFragment,
    childNodes: AF(e, t),
    isShadowRoot: r,
    adoptedStyleSheets: r ? E$(e.adoptedStyleSheets) : void 0
  };
}
function jQe(e) {
  return {
    type: Pu.DocumentType,
    name: e.name,
    publicId: e.publicId,
    systemId: e.systemId
  };
}
function PQe(e, t) {
  var r, n = W$(e.tagName), a = $Qe(e) || void 0, i = c$(d$(e), t.parentNodePrivacyLevel);
  if (i === Je.HIDDEN) {
    var o = e.getBoundingClientRect(), s = o.width, c = o.height;
    return {
      type: Pu.Element,
      tagName: n,
      attributes: (r = {
        rr_width: "".concat(s, "px"),
        rr_height: "".concat(c, "px")
      }, r[SF] = PBe, r),
      childNodes: [],
      isSVG: a
    };
  }
  if (i !== Je.IGNORE) {
    var l = JQe(e, i, t), u = [];
    if (jBe(e) && // Do not serialize style children as the css rules are already in the _cssText attribute
    n !== "style") {
      var g = void 0;
      t.parentNodePrivacyLevel === i && t.ignoreWhiteSpace === (n === "head") ? g = t : g = Ge({}, t, {
        parentNodePrivacyLevel: i,
        ignoreWhiteSpace: n === "head"
      }), u = AF(e, g);
    }
    return {
      type: Pu.Element,
      tagName: n,
      attributes: l,
      childNodes: u,
      isSVG: a
    };
  }
}
function $Qe(e) {
  return e.tagName === "svg" || e instanceof SVGElement;
}
function KQe(e, t) {
  var r = u$(e, t.ignoreWhiteSpace || !1, t.parentNodePrivacyLevel);
  if (r !== void 0)
    return {
      type: Pu.Text,
      textContent: r
    };
}
function XQe() {
  return {
    type: Pu.CDATA,
    textContent: ""
  };
}
function zQe(e, t, r) {
  return wF(e, {
    serializationContext: r,
    parentNodePrivacyLevel: t.defaultPrivacyLevel,
    configuration: t
  });
}
function T$(e) {
  return !!e.changedTouches;
}
function eI(e) {
  return e.composed === !0 && Lw(e.target) ? e.composedPath()[0] : e.target;
}
var XV = 25;
function qQe(e) {
  return Math.abs(e.pageTop - e.offsetTop - window.scrollY) > XV || Math.abs(e.pageLeft - e.offsetLeft - window.scrollX) > XV;
}
var eFe = function(e, t) {
  var r = window.visualViewport, n = {
    layoutViewportX: e,
    layoutViewportY: t,
    visualViewportX: e,
    visualViewportY: t
  };
  if (r)
    qQe(r) ? (n.layoutViewportX = Math.round(e + r.offsetLeft), n.layoutViewportY = Math.round(t + r.offsetTop)) : (n.visualViewportX = Math.round(e - r.offsetLeft), n.visualViewportY = Math.round(t - r.offsetTop));
  else return n;
  return n;
}, R$ = function(e) {
  return {
    scale: e.scale,
    offsetLeft: e.offsetLeft,
    offsetTop: e.offsetTop,
    pageLeft: e.pageLeft,
    pageTop: e.pageTop,
    height: e.height,
    width: e.width
  };
};
function to(e, t) {
  return {
    data: Ge({
      source: e
    }, t),
    type: jo.IncrementalSnapshot,
    timestamp: rn()
  };
}
var tFe = 50;
function rFe(e, t) {
  var r = Fl(function(o) {
    var s = eI(o);
    if (ns(s)) {
      var c = D$(o);
      if (!c)
        return;
      var l = {
        id: fa(s),
        timeOffset: 0,
        x: c.x,
        y: c.y
      };
      t(to(T$(o) ? Ni.TouchMove : Ni.MouseMove, { positions: [l] }));
    }
  }, tFe, {
    trailing: !1
  }), n = r.throttled, a = r.cancel, i = Ua(e, document, [
    "mousemove",
    "touchmove"
    /* DOM_EVENT.TOUCH_MOVE */
  ], n, {
    capture: !0,
    passive: !0
  }).stop;
  return {
    stop: function() {
      i(), a();
    }
  };
}
function D$(e) {
  var t = T$(e) ? e.changedTouches[0] : e, r = t.clientX, n = t.clientY;
  if (window.visualViewport) {
    var a = eFe(r, n), i = a.visualViewportX, o = a.visualViewportY;
    r = i, n = o;
  }
  if (!Number.isFinite(r) || !Number.isFinite(n)) {
    e.isTrusted && l0("mouse/touch event without x/y");
    return;
  }
  return { x: r, y: n };
}
var Hi, zV = (Hi = {}, // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
Hi.pointerup = $i.MouseUp, Hi.mousedown = $i.MouseDown, Hi.click = $i.Click, Hi.contextmenu = $i.ContextMenu, Hi.dblclick = $i.DblClick, Hi.focus = $i.Focus, Hi.blur = $i.Blur, Hi.touchstart = $i.TouchStart, Hi.touchend = $i.TouchEnd, Hi);
function nFe(e, t, r) {
  var n = function(a) {
    var i = eI(a);
    if (!(fs(i, e.defaultPrivacyLevel) === Je.HIDDEN || !ns(i))) {
      var o = fa(i), s = zV[a.type], c;
      if (s !== $i.Blur && s !== $i.Focus) {
        var l = D$(a);
        if (!l)
          return;
        c = { id: o, type: s, x: l.x, y: l.y };
      } else
        c = { id: o, type: s };
      var u = Ge({ id: r.getIdForEvent(a) }, to(Ni.MouseInteraction, c));
      t(u);
    }
  };
  return Ua(e, document, Object.keys(zV), n, {
    capture: !0,
    passive: !0
  });
}
var aFe = 100;
function J$(e, t, r, n) {
  n === void 0 && (n = document);
  var a = Fl(function(c) {
    var l = eI(c);
    if (!(!l || fs(l, e.defaultPrivacyLevel) === Je.HIDDEN || !ns(l))) {
      var u = fa(l), g = l === document ? {
        scrollTop: CF(),
        scrollLeft: k$()
      } : {
        scrollTop: Math.round(l.scrollTop),
        scrollLeft: Math.round(l.scrollLeft)
      };
      r.set(l, g), t(to(Ni.Scroll, {
        id: u,
        x: g.scrollLeft,
        y: g.scrollTop
      }));
    }
  }, aFe), i = a.throttled, o = a.cancel, s = tr(e, n, "scroll", i, {
    capture: !0,
    passive: !0
  }).stop;
  return {
    stop: function() {
      s(), o();
    }
  };
}
var iFe = 200;
function oFe(e, t) {
  var r = _$(e).subscribe(function(n) {
    t(to(Ni.ViewportResize, n));
  });
  return {
    stop: function() {
      r.unsubscribe();
    }
  };
}
function sFe(e, t) {
  var r = window.visualViewport;
  if (!r)
    return { stop: Dt };
  var n = Fl(function() {
    t({
      data: R$(r),
      type: jo.VisualViewport,
      timestamp: rn()
    });
  }, iFe, {
    trailing: !1
  }), a = n.throttled, i = n.cancel, o = Ua(e, r, [
    "resize",
    "scroll"
    /* DOM_EVENT.SCROLL */
  ], a, {
    capture: !0,
    passive: !0
  }).stop;
  return {
    stop: function() {
      o(), i();
    }
  };
}
function lFe(e, t) {
  return Ua(e, document, [
    "play",
    "pause"
    /* DOM_EVENT.PAUSE */
  ], function(r) {
    var n = eI(r);
    !n || fs(n, e.defaultPrivacyLevel) === Je.HIDDEN || !ns(n) || t(to(Ni.MediaInteraction, {
      id: fa(n),
      type: r.type === "play" ? KV.Play : KV.Pause
    }));
  }, {
    capture: !0,
    passive: !0
  });
}
function cFe(e) {
  function t(a, i) {
    a && ns(a.ownerNode) && i(fa(a.ownerNode));
  }
  var r = [
    va(CSSStyleSheet.prototype, "insertRule", function(a) {
      var i = a.target, o = a.parameters, s = o[0], c = o[1];
      t(i, function(l) {
        return e(to(Ni.StyleSheetRule, {
          id: l,
          adds: [{ rule: s, index: c }]
        }));
      });
    }),
    va(CSSStyleSheet.prototype, "deleteRule", function(a) {
      var i = a.target, o = a.parameters[0];
      t(i, function(s) {
        return e(to(Ni.StyleSheetRule, {
          id: s,
          removes: [{ index: o }]
        }));
      });
    })
  ];
  typeof CSSGroupingRule < "u" ? n(CSSGroupingRule) : (n(CSSMediaRule), n(CSSSupportsRule));
  function n(a) {
    r.push(va(a.prototype, "insertRule", function(i) {
      var o = i.target, s = i.parameters, c = s[0], l = s[1];
      t(o.parentStyleSheet, function(u) {
        var g = qV(o);
        g && (g.push(l || 0), e(to(Ni.StyleSheetRule, {
          id: u,
          adds: [{ rule: c, index: g }]
        })));
      });
    }), va(a.prototype, "deleteRule", function(i) {
      var o = i.target, s = i.parameters[0];
      t(o.parentStyleSheet, function(c) {
        var l = qV(o);
        l && (l.push(s), e(to(Ni.StyleSheetRule, {
          id: c,
          removes: [{ index: l }]
        })));
      });
    }));
  }
  return {
    stop: function() {
      r.forEach(function(a) {
        return a.stop();
      });
    }
  };
}
function qV(e) {
  for (var t = [], r = e; r.parentRule; ) {
    var n = Array.from(r.parentRule.cssRules), a = n.indexOf(r);
    t.unshift(a), r = r.parentRule;
  }
  if (r.parentStyleSheet) {
    var i = Array.from(r.parentStyleSheet.cssRules), o = i.indexOf(r);
    return t.unshift(o), t;
  }
}
function dFe(e, t) {
  return Ua(e, window, [
    "focus",
    "blur"
    /* DOM_EVENT.BLUR */
  ], function() {
    t({
      data: { has_focus: document.hasFocus() },
      type: jo.Focus,
      timestamp: rn()
    });
  });
}
function uFe(e, t, r) {
  var n = e.subscribe(11, function(a) {
    var i, o;
    a.rawRumEvent.type === "action" && a.rawRumEvent.action.type === "click" && (!((o = (i = a.rawRumEvent.action.frustration) === null || i === void 0 ? void 0 : i.type) === null || o === void 0) && o.length) && "events" in a.domainContext && a.domainContext.events && a.domainContext.events.length && t({
      timestamp: a.rawRumEvent.date,
      type: jo.FrustrationRecord,
      data: {
        frustrationTypes: a.rawRumEvent.action.frustration.type,
        recordIds: a.domainContext.events.map(function(s) {
          return r.getIdForEvent(s);
        })
      }
    });
  });
  return {
    stop: function() {
      n.unsubscribe();
    }
  };
}
function hFe(e, t) {
  var r = e.subscribe(4, function() {
    t({
      timestamp: rn(),
      type: jo.ViewEnd
    });
  });
  return {
    stop: function() {
      r.unsubscribe();
    }
  };
}
function V$(e, t, r) {
  r === void 0 && (r = document);
  var n = e.defaultPrivacyLevel, a = /* @__PURE__ */ new WeakMap(), i = r !== document, o = Ua(
    e,
    r,
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    i ? [
      "change"
      /* DOM_EVENT.CHANGE */
    ] : [
      "input",
      "change"
      /* DOM_EVENT.CHANGE */
    ],
    function(g) {
      var p = eI(g);
      (p instanceof HTMLInputElement || p instanceof HTMLTextAreaElement || p instanceof HTMLSelectElement) && l(p);
    },
    {
      capture: !0,
      passive: !0
    }
  ).stop, s;
  if (i)
    s = Dt;
  else {
    var c = [
      Y0(HTMLInputElement.prototype, "value", l),
      Y0(HTMLInputElement.prototype, "checked", l),
      Y0(HTMLSelectElement.prototype, "value", l),
      Y0(HTMLTextAreaElement.prototype, "value", l),
      Y0(HTMLSelectElement.prototype, "selectedIndex", l)
    ];
    s = function() {
      c.forEach(function(g) {
        return g.stop();
      });
    };
  }
  return {
    stop: function() {
      s(), o();
    }
  };
  function l(g) {
    var p = fs(g, n);
    if (p !== Je.HIDDEN) {
      var m = g.type, I;
      if (m === "radio" || m === "checkbox") {
        if (Ow(g, p))
          return;
        I = { isChecked: g.checked };
      } else {
        var C = yF(g, p);
        if (C === void 0)
          return;
        I = { text: C };
      }
      u(g, I);
      var A = g.name;
      m === "radio" && A && g.checked && Pke(document.querySelectorAll('input[type="radio"][name="'.concat(Oc(A), '"]')), function(U) {
        U !== g && u(U, { isChecked: !1 });
      });
    }
  }
  function u(g, p) {
    if (ns(g)) {
      var m = a.get(g);
      (!m || m.text !== p.text || m.isChecked !== p.isChecked) && (a.set(g, p), t(to(Ni.Input, Ge({
        id: fa(g)
      }, p))));
    }
  }
}
var pFe = 100, gFe = 16;
function fFe(e) {
  var t = Dt, r = [];
  function n() {
    t(), e(r), r = [];
  }
  var a = Fl(n, gFe, {
    leading: !1
  }), i = a.throttled, o = a.cancel;
  return {
    addMutations: function(s) {
      r.length === 0 && (t = mFe(i, { timeout: pFe })), r.push.apply(r, s);
    },
    flush: n,
    stop: function() {
      t(), o();
    }
  };
}
function mFe(e, t) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    var r = window.requestIdleCallback(Re(e), t);
    return function() {
      return window.cancelIdleCallback(r);
    };
  }
  var n = window.requestAnimationFrame(Re(e));
  return function() {
    return window.cancelAnimationFrame(n);
  };
}
function M$(e, t, r, n) {
  var a = $P();
  if (!a)
    return { stop: Dt, flush: Dt };
  var i = fFe(function(s) {
    vFe(s.concat(o.takeRecords()), e, t, r);
  }), o = new a(Re(i.addMutations));
  return o.observe(n, {
    attributeOldValue: !0,
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), {
    stop: function() {
      o.disconnect(), i.stop();
    },
    flush: function() {
      i.flush();
    }
  };
}
function vFe(e, t, r, n) {
  var a = /* @__PURE__ */ new Map();
  e.filter(function(p) {
    return p.type === "childList";
  }).forEach(function(p) {
    p.removedNodes.forEach(function(m) {
      G$(m, n.removeShadowRoot);
    });
  });
  var i = e.filter(function(p) {
    return p.target.isConnected && BQe(p.target) && fs(p.target, r.defaultPrivacyLevel, a) !== Je.HIDDEN;
  }), o = SFe(i.filter(function(p) {
    return p.type === "childList";
  }), r, n, a), s = o.adds, c = o.removes, l = o.hasBeenSerialized, u = IFe(i.filter(function(p) {
    return p.type === "characterData" && !l(p.target);
  }), r, a), g = CFe(i.filter(function(p) {
    return p.type === "attributes" && !l(p.target);
  }), r, a);
  !u.length && !g.length && !c.length && !s.length || t(to(Ni.Mutation, { adds: s, removes: c, texts: u, attributes: g }));
}
function SFe(e, t, r, n) {
  for (var a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map(), o = function(H) {
    H.addedNodes.forEach(function(R) {
      a.add(R);
    }), H.removedNodes.forEach(function(R) {
      a.has(R) || i.set(R, H.target), a.delete(R);
    });
  }, s = 0, c = e; s < c.length; s++) {
    var l = c[s];
    o(l);
  }
  var u = Array.from(a);
  bFe(u);
  for (var g = /* @__PURE__ */ new Set(), p = [], m = 0, I = u; m < I.length; m++) {
    var C = I[m];
    if (!W(C)) {
      var A = fs(C.parentNode, t.defaultPrivacyLevel, n);
      if (!(A === Je.HIDDEN || A === Je.IGNORE)) {
        var U = wF(C, {
          serializedNodeIds: g,
          parentNodePrivacyLevel: A,
          serializationContext: { status: 2, shadowRootsController: r },
          configuration: t
        });
        if (U) {
          var B = Yw(C);
          p.push({
            nextId: L(C),
            parentId: fa(B),
            node: U
          });
        }
      }
    }
  }
  var J = [];
  return i.forEach(function(H, R) {
    ns(R) && J.push({
      parentId: fa(H),
      id: fa(R)
    });
  }), { adds: p, removes: J, hasBeenSerialized: W };
  function W(H) {
    return ns(H) && g.has(fa(H));
  }
  function L(H) {
    for (var R = H.nextSibling; R; ) {
      if (ns(R))
        return fa(R);
      R = R.nextSibling;
    }
    return null;
  }
}
function IFe(e, t, r) {
  for (var n, a = [], i = /* @__PURE__ */ new Set(), o = e.filter(function(p) {
    return i.has(p.target) ? !1 : (i.add(p.target), !0);
  }), s = 0, c = o; s < c.length; s++) {
    var l = c[s], u = l.target.textContent;
    if (u !== l.oldValue) {
      var g = fs(Yw(l.target), t.defaultPrivacyLevel, r);
      g === Je.HIDDEN || g === Je.IGNORE || a.push({
        id: fa(l.target),
        // TODO: pass a valid "ignoreWhiteSpace" argument
        value: (n = u$(l.target, !1, g)) !== null && n !== void 0 ? n : null
      });
    }
  }
  return a;
}
function CFe(e, t, r) {
  for (var n = [], a = /* @__PURE__ */ new Map(), i = e.filter(function(A) {
    var U = a.get(A.target);
    return U && U.has(A.attributeName) ? !1 : (U ? U.add(A.attributeName) : a.set(A.target, /* @__PURE__ */ new Set([A.attributeName])), !0);
  }), o = /* @__PURE__ */ new Map(), s = 0, c = i; s < c.length; s++) {
    var l = c[s], u = l.target.getAttribute(l.attributeName);
    if (u !== l.oldValue) {
      var g = fs(l.target, t.defaultPrivacyLevel, r), p = Q$(l.target, g, l.attributeName, t), m = void 0;
      if (l.attributeName === "value") {
        var I = yF(l.target, g);
        if (I === void 0)
          continue;
        m = I;
      } else typeof p == "string" ? m = p : m = null;
      var C = o.get(l.target);
      C || (C = {
        id: fa(l.target),
        attributes: {}
      }, n.push(C), o.set(l.target, C)), C.attributes[l.attributeName] = m;
    }
  }
  return n;
}
function bFe(e) {
  e.sort(function(t, r) {
    var n = t.compareDocumentPosition(r);
    return n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_CONTAINS || n & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : n & Node.DOCUMENT_POSITION_PRECEDING ? -1 : 0;
  });
}
function G$(e, t) {
  Lw(e) && t(e.shadowRoot), l$(e, function(r) {
    return G$(r, t);
  });
}
function yFe() {
  var e = /* @__PURE__ */ new WeakMap();
  return {
    set: function(t, r) {
      t === document && !document.scrollingElement || e.set(t === document ? document.scrollingElement : t, r);
    },
    get: function(t) {
      return e.get(t);
    },
    has: function(t) {
      return e.has(t);
    }
  };
}
var wFe = function(e, t, r) {
  var n = /* @__PURE__ */ new Map(), a = {
    addShadowRoot: function(i) {
      if (!n.has(i)) {
        var o = M$(t, e, a, i), s = V$(e, t, i), c = J$(e, t, r, i);
        n.set(i, {
          flush: function() {
            return o.flush();
          },
          stop: function() {
            o.stop(), s.stop(), c.stop();
          }
        });
      }
    },
    removeShadowRoot: function(i) {
      var o = n.get(i);
      o && (o.stop(), n.delete(i));
    },
    stop: function() {
      n.forEach(function(i) {
        var o = i.stop;
        return o();
      });
    },
    flush: function() {
      n.forEach(function(i) {
        var o = i.flush;
        return o();
      });
    }
  };
  return a;
};
function AFe(e, t, r, n, a, i) {
  var o = function(c, l) {
    c === void 0 && (c = rn()), l === void 0 && (l = {
      status: 0,
      elementsScrollPositions: e,
      shadowRootsController: t
    });
    var u = jw(), g = u.width, p = u.height, m = [
      {
        data: {
          height: p,
          href: window.location.href,
          width: g
        },
        type: jo.Meta,
        timestamp: c
      },
      {
        data: {
          has_focus: document.hasFocus()
        },
        type: jo.Focus,
        timestamp: c
      },
      {
        data: {
          node: zQe(document, n, l),
          initialOffset: {
            left: k$(),
            top: CF()
          }
        },
        type: jo.FullSnapshot,
        timestamp: c
      }
    ];
    return window.visualViewport && m.push({
      data: R$(window.visualViewport),
      type: jo.VisualViewport,
      timestamp: c
    }), m;
  };
  i(o());
  var s = r.subscribe(2, function(c) {
    a(), i(o(c.startClocks.timeStamp, {
      shadowRootsController: t,
      status: 1,
      elementsScrollPositions: e
    }));
  }).unsubscribe;
  return {
    stop: s
  };
}
function UFe() {
  var e = /* @__PURE__ */ new WeakMap(), t = 1;
  return {
    getIdForEvent: function(r) {
      return e.has(r) || e.set(r, t++), e.get(r);
    }
  };
}
function kFe(e) {
  var t = e.emit, r = e.configuration, n = e.lifeCycle;
  if (!t)
    throw new Error("emit function is required");
  var a = function(p) {
    t(p), dF("record", { record: p });
    var m = e.viewHistory.findView();
    kQe(m.id);
  }, i = yFe(), o = wFe(r, a, i), s = AFe(i, o, n, r, c, function(p) {
    return p.forEach(function(m) {
      return a(m);
    });
  }).stop;
  function c() {
    o.flush(), u.flush();
  }
  var l = UFe(), u = M$(a, r, o, document), g = [
    u,
    rFe(r, a),
    nFe(r, a, l),
    J$(r, a, i, document),
    oFe(r, a),
    V$(r, a),
    lFe(r, a),
    cFe(a),
    dFe(r, a),
    sFe(r, a),
    uFe(n, a, l),
    hFe(n, function(p) {
      c(), a(p);
    })
  ];
  return {
    stop: function() {
      o.stop(), g.forEach(function(p) {
        return p.stop();
      }), s();
    },
    flushMutations: c,
    shadowRootsController: o
  };
}
function _Fe(e, t, r) {
  var n = new FormData();
  n.append("segment", new Blob([e], {
    type: "application/octet-stream"
  }), "".concat(t.session.id, "-").concat(t.start));
  var a = Ge({
    raw_segment_size: r,
    compressed_segment_size: e.byteLength
  }, t), i = JSON.stringify(a);
  return n.append("event", new Blob([i], { type: "application/json" })), { data: n, bytesCount: e.byteLength };
}
function NFe(e) {
  var t = e.context, r = e.creationReason, n = e.encoder, a = 0, i = t.view.id, o = Ge({
    start: 1 / 0,
    end: -1 / 0,
    creation_reason: r,
    records_count: 0,
    has_full_snapshot: !1,
    index_in_view: AQe(i),
    source: "browser"
  }, t);
  UQe(i);
  function s(l, u) {
    o.start = Math.min(o.start, l.timestamp), o.end = Math.max(o.end, l.timestamp), o.records_count += 1, o.has_full_snapshot || (o.has_full_snapshot = l.type === jo.FullSnapshot);
    var g = n.isEmpty ? '{"records":[' : ",";
    n.write(g + JSON.stringify(l), function(p) {
      a += p, u(a);
    });
  }
  function c(l) {
    if (n.isEmpty)
      throw new Error("Empty segment flushed");
    n.write("],".concat(JSON.stringify(o).slice(1), `
`)), n.finish(function(u) {
      _Qe(o.view.id, u.rawBytesCount), l(o, u);
    });
  }
  return { addRecord: s, flush: c };
}
var ZFe = 30 * qn, x$ = 6e4;
function BFe(e, t, r, n, a, i) {
  return WFe(e, function() {
    return EFe(t.applicationId, r, n);
  }, a, i);
}
function WFe(e, t, r, n) {
  var a = {
    status: 0,
    nextSegmentCreationReason: "init"
  }, i = e.subscribe(2, function() {
    s("view_change");
  }).unsubscribe, o = e.subscribe(10, function(c) {
    s(c.reason);
  }).unsubscribe;
  function s(c) {
    a.status === 1 && (a.segment.flush(function(l, u) {
      var g = _Fe(u.output, l, u.rawBytesCount);
      GP(c) ? r.sendOnExit(g) : r.send(g);
    }), Ui(a.expirationTimeoutId)), c !== "stop" ? a = {
      status: 0,
      nextSegmentCreationReason: c
    } : a = {
      status: 2
    };
  }
  return {
    addRecord: function(c) {
      if (a.status !== 2) {
        if (a.status === 0) {
          var l = t();
          if (!l)
            return;
          a = {
            status: 1,
            segment: NFe({ encoder: n, context: l, creationReason: a.nextSegmentCreationReason }),
            expirationTimeoutId: Nn(function() {
              s("segment_duration_limit");
            }, ZFe)
          };
        }
        a.segment.addRecord(c, function(u) {
          u > x$ && s("segment_bytes_limit");
        });
      }
    },
    stop: function() {
      s("stop"), i(), o();
    }
  };
}
function EFe(e, t, r) {
  var n = t.findTrackedSession(), a = r.findView();
  if (!(!n || !a))
    return {
      application: {
        id: e
      },
      session: {
        id: n.id
      },
      view: {
        id: a.id
      }
    };
}
function QFe(e) {
  var t = d0();
  return {
    addRecord: function(r) {
      var n = e.findView();
      t.send("record", r, n.id);
    }
  };
}
function FFe(e, t, r, n, a, i) {
  var o = [], s = function(p) {
    e.notify(13, { error: p }), l0("Error reported to customer", { "error.message": p.message });
  }, c = i || VP(t, t.sessionReplayEndpointBuilder, x$, s), l;
  if (ju())
    l = QFe(n).addRecord;
  else {
    var u = BFe(e, t, r, n, c, a);
    l = u.addRecord, o.push(u.stop);
  }
  var g = kFe({
    emit: l,
    configuration: t,
    lifeCycle: e,
    viewHistory: n
  }).stop;
  return o.push(g), {
    stop: function() {
      o.forEach(function(p) {
        return p();
      });
    }
  };
}
function H$() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from == "function" && typeof CSSSupportsRule == "function" && typeof URL.createObjectURL == "function" && "forEach" in NodeList.prototype
  );
}
function TFe(e, t, r, n) {
  var a = t.findTrackedSession(), i = RFe(a, n), o = r.findView();
  return CQe(e, {
    viewContext: o,
    errorType: i,
    session: a
  });
}
function RFe(e, t) {
  if (!H$())
    return "browser-not-supported";
  if (!e)
    return "rum-not-tracked";
  if (e.sessionReplay === 0)
    return "incorrect-session-plan";
  if (!t)
    return "replay-not-started";
}
function L$(e, t, r) {
  var n = 0, a = [], i, o = 0, s = [], c = tr(e, t, "message", function(g) {
    var p = g.data;
    if (!(p.type !== "wrote" || p.streamId !== r)) {
      n += p.additionalBytesCount, a.push(p.result), i = p.trailer;
      var m = s.shift();
      m && m.id === p.id ? m.writeCallback ? m.writeCallback(p.result.byteLength) : m.finishCallback && m.finishCallback() : (c(), l0("Worker responses received out of order."));
    }
  }).stop;
  function l() {
    var g = a.length === 0 ? new Uint8Array(0) : Oke(a.concat(i)), p = {
      rawBytesCount: n,
      output: g,
      outputBytesCount: g.byteLength,
      encoding: "deflate"
    };
    return n = 0, a = [], p;
  }
  function u() {
    o > 0 && (t.postMessage({
      action: "reset",
      streamId: r
    }), o = 0);
  }
  return {
    isAsync: !0,
    get isEmpty() {
      return o === 0;
    },
    write: function(g, p) {
      t.postMessage({
        action: "write",
        id: o,
        data: g,
        streamId: r
      }), s.push({
        id: o,
        writeCallback: p,
        data: g
      }), o += 1;
    },
    finish: function(g) {
      u(), s.length ? (s.forEach(function(p) {
        delete p.writeCallback;
      }), s[s.length - 1].finishCallback = function() {
        return g(l());
      }) : g(l());
    },
    finishSync: function() {
      u();
      var g = s.map(function(p) {
        return delete p.writeCallback, delete p.finishCallback, p.data;
      }).join("");
      return Ge(l(), {
        pendingData: g
      });
    },
    estimateEncodedBytesCount: function(g) {
      return g.length / 8;
    },
    stop: function() {
      c();
    }
  };
}
var DFe = 30 * qn;
function Y$(e) {
  return new Worker(e.workerUrl || URL.createObjectURL(new Blob(['!function(){"use strict";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:"pako deflate (from Nodeca project)"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a="[object ArrayBuffer]"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:"errored",error:e,streamId:a})}catch(n){t.postMessage({type:"errored",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,"[object ArrayBuffer]"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener("message",(function(n){try{var r=function(e,a){switch(a.action){case"init":return{type:"initialized",version:"5.28.0"};case"write":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:"wrote",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case"reset":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&"streamId"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();'])));
}
var Cr = {
  status: 0
  /* DeflateWorkerStatus.Nil */
};
function O$(e, t, r, n) {
  switch (n === void 0 && (n = Y$), Cr.status === 0 && JFe(e, t, n), Cr.status) {
    case 1:
      return Cr.initializationFailureCallbacks.push(r), Cr.worker;
    case 3:
      return Cr.worker;
  }
}
function e3() {
  return Cr.status;
}
function JFe(e, t, r) {
  r === void 0 && (r = Y$);
  try {
    var n = r(e), a = tr(e, n, "error", function(s) {
      vk(e, t, s);
    }).stop, i = tr(e, n, "message", function(s) {
      var c = s.data;
      c.type === "errored" ? vk(e, t, c.error, c.streamId) : c.type === "initialized" && MFe(c.version);
    }).stop;
    n.postMessage({ action: "init" }), Nn(function() {
      return VFe(t);
    }, DFe);
    var o = function() {
      a(), i();
    };
    Cr = { status: 1, worker: n, stop: o, initializationFailureCallbacks: [] };
  } catch (s) {
    vk(e, t, s);
  }
}
function VFe(e) {
  Cr.status === 1 && (Et.error("".concat(e, " failed to start: a timeout occurred while initializing the Worker")), Cr.initializationFailureCallbacks.forEach(function(t) {
    return t();
  }), Cr = {
    status: 2
    /* DeflateWorkerStatus.Error */
  });
}
function MFe(e) {
  Cr.status === 1 && (Cr = { status: 3, worker: Cr.worker, stop: Cr.stop, version: e });
}
function vk(e, t, r, n) {
  if (Cr.status === 1 || Cr.status === 0) {
    if (Et.error("".concat(t, " failed to start: an error occurred while creating the Worker:"), r), r instanceof Event || r instanceof Error && GFe(r.message)) {
      var a = void 0;
      e.workerUrl ? a = "Please make sure the Worker URL ".concat(e.workerUrl, " is correct and CSP is correctly configured.") : a = "Please make sure CSP is correctly configured.", Et.error("".concat(a, " See documentation at ").concat(Dw, "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
    } else
      yy(r);
    Cr.status === 1 && Cr.initializationFailureCallbacks.forEach(function(i) {
      return i();
    }), Cr = {
      status: 2
      /* DeflateWorkerStatus.Error */
    };
  } else
    yy(r, {
      worker_version: Cr.status === 3 && Cr.version,
      stream_id: n
    });
}
function GFe(e) {
  return uo(e, "Content Security Policy") || // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  uo(e, "requires 'TrustedScriptURL'");
}
function xFe(e, t) {
  if (ju() && !MP(
    "records"
    /* BridgeCapability.RECORDS */
  ) || !H$())
    return {
      start: Dt,
      stop: Dt,
      getReplayStats: function() {
      },
      onRumStart: Dt,
      isRecording: function() {
        return !1;
      },
      getSessionReplayLink: function() {
      }
    };
  var r = {
    status: 1
  }, n = function() {
    r = {
      status: 1
      /* RecorderStatus.IntentToStart */
    };
  }, a = function() {
    r = {
      status: 0
      /* RecorderStatus.Stopped */
    };
  }, i = Dt;
  return {
    start: function(o) {
      return n(o);
    },
    stop: function() {
      return a();
    },
    getSessionReplayLink: function() {
      return i();
    },
    onRumStart: function(o, s, c, l, u) {
      s.startSessionReplayRecordingManually && (r = {
        status: 0
        /* RecorderStatus.Stopped */
      }), o.subscribe(8, function() {
        (r.status === 2 || r.status === 3) && (a(), r = {
          status: 1
          /* RecorderStatus.IntentToStart */
        });
      }), o.subscribe(10, function(m) {
        m.reason === fp.UNLOADING && a();
      }), o.subscribe(9, function() {
        r.status === 1 && n();
      });
      var g;
      function p() {
        return g || (u || (u = O$(s, "Datadog Session Replay", function() {
          a();
        }, t)), u && (g = L$(
          s,
          u,
          1
          /* DeflateEncoderStreamId.REPLAY */
        ))), g;
      }
      n = function(m) {
        var I = c.findTrackedSession();
        if (!I || I.sessionReplay === 0 && (!m || !m.force)) {
          r = {
            status: 1
            /* RecorderStatus.IntentToStart */
          };
          return;
        }
        r.status === 2 || r.status === 3 || (r = {
          status: 2
          /* RecorderStatus.Starting */
        }, hF(s, "interactive", function() {
          if (r.status === 2) {
            var C = p();
            if (!C) {
              r = {
                status: 0
              };
              return;
            }
            var A = e(o, s, c, l, C).stop;
            r = {
              status: 3,
              stopRecording: A
            };
          }
        }), m && m.force && I.sessionReplay === 0 && c.setForcedReplay());
      }, a = function() {
        r.status !== 0 && (r.status === 3 && r.stopRecording(), r = {
          status: 0
        });
      }, i = function() {
        return TFe(
          s,
          c,
          l,
          r.status !== 0
          /* RecorderStatus.Stopped */
        );
      }, r.status === 1 && n();
    },
    isRecording: function() {
      return e3() === 3 && r.status === 3;
    },
    getReplayStats: function(o) {
      return e3() === 3 ? NQe(o) : void 0;
    }
  };
}
var HFe = xFe(FFe), Ol = cBe(vQe, HFe, { startDeflateWorker: O$, createDeflateEncoder: L$ });
kNe(cd(), "DD_RUM", Ol);
const LFe = {
  applicationId: "be132ab8-34b7-4e0a-9dbb-e60d6cfca6e4",
  clientToken: "pub35fc76c21e4a18b288e47bfb1d2df327",
  site: "datadoghq.com",
  // Custom params
  service: "web-sdk",
  env: "production",
  version: "0.2.14-b10b1242.2",
  // Specify a version number to identify the deployed version of your application in Datadog
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: !0,
  trackResources: !0,
  trackLongTasks: !0,
  defaultPrivacyLevel: "mask-user-input",
  allowFallbackToLocalStorage: !0
};
var kp, _p, Rv, Dv, wl, j$, HZ, P$, Np, Jv;
const WT = class WT {
  constructor(t = {}) {
    E(this, wl);
    E(this, kp);
    E(this, _p);
    E(this, Rv);
    E(this, Dv);
    E(this, Np);
    E(this, Jv);
    this.params = t, this.isEnabled = !0, G(this, kp, um()), G(this, Rv, Date.now()), G(this, Dv, /* @__PURE__ */ new Date()), G(this, Np, (r) => {
      r ? (Ol.init({
        ...LFe,
        ...this.params
      }), Ol.startSessionReplayRecording()) : (Ol.stopSession(), Ol.stopSessionReplayRecording());
    }), G(this, Jv, dse(S(this, Np), 0, {
      trailing: !0
    }));
  }
  getId() {
    return pb;
  }
  async log(t) {
    return O(this, wl, HZ).call(this, t), Promise.resolve();
  }
  report(t) {
    return O(this, wl, HZ).call(this, t), Promise.resolve();
  }
  get datadogRumLogger() {
    return S(this, _p) || (S(this, Np).call(this, this.isEnabled), G(this, _p, Ol)), S(this, _p) ?? Ol;
  }
  updateConfig(t) {
    O(this, wl, P$).call(this, t) && (this.isEnabled = t.isEnabled, this.params = {
      ...this.params,
      ...t.params
    }, S(this, Jv).call(this, this.isEnabled));
  }
};
kp = new WeakMap(), _p = new WeakMap(), Rv = new WeakMap(), Dv = new WeakMap(), wl = new WeakSet(), j$ = function(t) {
  if (!this.isEnabled)
    return;
  const { eventType: r, eventName: n, value: a } = t;
  r === "screen" && this.datadogRumLogger.startView(n), this.datadogRumLogger.addAction(a, {
    ...t,
    instanceId: S(this, kp)
  });
}, HZ = function(t) {
  if (!this.isEnabled)
    return;
  const r = pG(t.tags ?? {}, ["rejectionReasons", "variant"]);
  Ol.setUser({
    ...r,
    instanceId: S(this, kp),
    sessionDuration: Math.ceil((Date.now() - S(this, Rv)) / 1e3),
    sessionStartTime: S(this, Dv)
  }), O(this, wl, j$).call(this, t);
}, P$ = function(t) {
  return Ut(t, ["isEnabled", "type"], (r) => r.type === pb);
}, Np = new WeakMap(), Jv = new WeakMap(), WT.id = pb;
let xZ = WT;
const t3 = "LoggerFacade";
var uu, Vv, Zp, Mv, Pc, $$, K$, X$;
const ET = class ET {
  constructor(t, r) {
    E(this, Pc);
    E(this, uu);
    E(this, Vv);
    E(this, Zp);
    E(this, Mv);
    this.isEnabled = !0, G(this, uu, []), G(this, Vv, r ?? { bufferTime: 0 }), G(this, Zp, t);
  }
  getId() {
    return t3;
  }
  log({ value: t, level: r, code: n, timestamp: a, ...i }) {
    return this.isEnabled && (S(this, uu).push({
      eventType: n,
      timestamp: a.getTime(),
      payload: {
        value: t,
        level: r,
        ...i
      }
    }), window.clearTimeout(S(this, Mv)), G(this, Mv, window.setTimeout(() => {
      O(this, Pc, $$).call(this);
    }, S(this, Vv).bufferTime))), Promise.resolve();
  }
  report({ value: t, level: r, code: n, timestamp: a, ...i }) {
    return this.isEnabled && O(this, Pc, X$).call(this, {
      events: [
        {
          eventType: n,
          timestamp: a.getTime(),
          payload: {
            value: t,
            level: r,
            ...i
          }
        }
      ]
    }), Promise.resolve();
  }
};
uu = new WeakMap(), Vv = new WeakMap(), Zp = new WeakMap(), Mv = new WeakMap(), Pc = new WeakSet(), $$ = async function() {
  const t = S(this, uu);
  return G(this, uu, []), O(this, Pc, K$).call(this, {
    events: t
  });
}, K$ = async function(t) {
  return S(this, Zp).getTransport().sendAnalyticsEvent(t);
}, X$ = async function(t) {
  return S(this, Zp).getTransport().sendReportingEvent(t);
}, ET.id = t3;
let LZ = ET;
const YFe = ({ userAgent: e = navigator.userAgent, ...t }) => {
  const r = new so(e), { webview: n, iframe: a, jumioHosted: i } = t, l = `${n ? "webview" : "browser"}:${a ? "iframe" : "non-iframe"}:${i ? "jumio-hosted" : "customer-hosted"}`;
  return {
    ua: navigator.userAgent,
    runtime: l,
    browser: {
      ...r.getBrowser()
    },
    device: {
      ...r.getDevice()
    },
    os: {
      ...r.getOS(),
      ...r.getCPU()
    },
    ...t
  };
};
var OFe = Object.defineProperty, jFe = Object.getOwnPropertyDescriptor, z$ = (e) => {
  throw TypeError(e);
}, q$ = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? jFe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && OFe(t, r, a), a;
}, UF = (e, t, r) => t.has(e) || z$("Cannot " + r), Ts = (e, t, r) => (UF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Sk = (e, t, r) => t.has(e) ? z$("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), PFe = (e, t, r, n) => (UF(e, t, "write to private field"), t.set(e, r), r), ap = (e, t, r) => (UF(e, t, "access private method"), r), Jh, Pl, rc, eK, tK, rK, nK, aK, iK;
let YZ = class extends N {
  constructor() {
    super(), Sk(this, rc), Sk(this, Jh, new _e()), Sk(this, Pl);
    const e = Ce();
    PFe(this, Pl, e.getLoggerManager()), Ts(this, Pl).addLogger(new Rke()), Ts(this, Pl).addLogger(new LZ(e)), Ts(this, Pl).addLogger(new xZ()), Ts(this, Pl).addLogger(new nke());
  }
  connectedCallback() {
    super.connectedCallback(), ap(this, rc, iK).call(this).pipe(le(Ts(this, Jh))).subscribe(), this.getScreenLogging$().pipe(le(Ts(this, Jh))).subscribe(), XH().pipe(
      at(Boolean),
      ae(() => {
        ap(this, rc, tK).call(this);
      }),
      ae(() => {
        ap(this, rc, rK).call(this);
      }),
      le(Ts(this, Jh))
    ).subscribe();
  }
  render() {
    return w`<slot
      name="logger"
      @slotchange="${() => {
      ap(this, rc, eK).call(this);
    }}"
    ></slot>`;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Ts(this, Jh).next();
  }
  getScreenLogging$() {
    return ug().pipe(
      vt((e, t) => e.step === t.step && e.substep === t.substep),
      te(({ step: e, substep: t }) => [e, t].filter((r) => !!r).join(":")),
      ae((e) => {
        const { acquisitionStatus: t } = Le(), [, r] = Te.getShownScreenEventReporter(e);
        r(this, {
          metadata: {
            acquisitionStatus: t
          }
        });
      })
    );
  }
};
Jh = /* @__PURE__ */ new WeakMap();
Pl = /* @__PURE__ */ new WeakMap();
rc = /* @__PURE__ */ new WeakSet();
eK = function() {
  this.loggerConfig.forEach((e) => {
    var r;
    const t = Ts(this, Pl).getLoggerById(e.type);
    (r = t == null ? void 0 : t.updateConfig) == null || r.call(t, e);
  });
};
tK = function() {
  const { parsedToken: e } = zH();
  e && pg({
    scanReference: e.aId,
    customerId: e.cId,
    customerReference: e.cRef
  });
};
rK = function() {
  var c;
  const e = ZAe(), t = new so(e), r = Ce(), n = YFe({
    hostname: window.location.hostname,
    iframe: mG(),
    jumioHosted: ap(this, rc, aK).call(this),
    webview: ap(this, rc, nK).call(this)
  }), a = r.getLoggerManager(), i = `${n.hostname}|${n.runtime}`, o = `${i}|${(c = t.getResult().os.name) == null ? void 0 : c.toLowerCase()}`, s = `${o}|${t.getResult().os.version}`;
  a.report(
    Te.createRuntimeEvent({
      metadata: n,
      tags: {
        hostname: n.hostname,
        runtime: n.runtime,
        hostnameRuntime: i,
        hostnameRuntimeOs: o,
        hostnameRuntimeOsVersion: s
      }
    })
  );
};
nK = function() {
  return qj(window.navigator.userAgent);
};
aK = function() {
  return /(jumiopp\.link|jumio\.ai|jumio\.link|jumio\.com)/.test(window.location.host);
};
iK = function() {
  return NAe().pipe(
    ae((e) => {
      pg({
        displayMode: e
      });
    })
  );
};
q$([
  dr({ slot: "logger", flatten: !0 })
], YZ.prototype, "loggerConfig", 2);
YZ = q$([
  P("jumio-sdk-logging")
], YZ);
var Gv;
class $Fe {
  constructor(t) {
    E(this, Gv);
    this.jms = mt, G(this, Gv, t), S(this, Gv).addController(this);
  }
  showMessage(t) {
    this.jms.showMessage(t);
  }
  showMessageIfPossible(t) {
    this.jms.showMessageIfPossible(t);
  }
  clearMessage() {
    this.jms.clearMessage();
  }
  closeActiveClosableMessage() {
    this.jms.closeActiveClosableMessage();
  }
  closeActiveClosableMessageById(t) {
    this.jms.closeActiveClosableMessageById(t);
  }
  get message$() {
    return this.jms.message$;
  }
  hostConnected() {
  }
}
Gv = new WeakMap();
const KFe = ':host{display:block;height:100%;width:100%;max-width:min(32em,100vw);box-sizing:border-box;margin:0 auto}.error__control-panel{position:sticky;bottom:0;width:100%;margin-top:-1em;padding:1em 0}:host([data-color-scheme="light"]) .error__control-panel{background:var(--theme-light-app-container-bg-color)}:host([data-color-scheme="dark"]) .error__control-panel{background:var(--theme-dark-app-container-bg-color)}.error__link{display:block;width:100%}.horizontal-separator{width:100%;height:1px;margin:1em 0;background:var(--color-secondary3)}', tI = new _e();
var XFe = Object.defineProperty, zFe = Object.getOwnPropertyDescriptor, oK = (e) => {
  throw TypeError(e);
}, $w = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? zFe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && XFe(t, r, a), a;
}, qFe = (e, t, r) => t.has(e) || oK("Cannot " + r), eTe = (e, t, r) => (qFe(e, t, "read from private field"), r ? r.call(e) : t.get(e)), tTe = (e, t, r) => t.has(e) ? oK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), OZ;
let Zg = class extends N {
  constructor() {
    super(...arguments), this.fluid = !0, this.type = De.Quiet, this.size = _a.Medium, this.crossDeviceEnabledController = new ue(this, uH()), tTe(this, OZ, () => {
      Te.clickedCrossDeviceButton(this), ve().send({
        type: K1.NavigateToCrossDevice
      });
    });
  }
  get isLinked() {
    const { linked: e } = Le();
    return e;
  }
  get isMobile() {
    return _l();
  }
  render() {
    const e = this.crossDeviceEnabledController.value === !0;
    return this.isMobile || this.isLinked || !e ? q : w`
      <x-ds-button
        @jclick="${eTe(this, OZ)}"
        data-qa-id="cross-device-button"
        data-size="${this.size}"
        data-fluid="${this.fluid}"
        data-type="${this.type}"
      >
        ${y("Use mobile phone", { id: "xdevice.unicorn.attribute" })}
      </x-ds-button>
    `;
  }
};
OZ = /* @__PURE__ */ new WeakMap();
Zg.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
$w([
  M({
    attribute: "data-fluid",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Zg.prototype, "fluid", 2);
$w([
  M({
    attribute: "data-type",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => O2(e) ? e : De.Primary,
      toAttribute: (e) => e.toString()
    }
  })
], Zg.prototype, "type", 2);
$w([
  M({
    attribute: "data-size",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => rE(e) ? e : _a.Medium,
      toAttribute: (e) => e.toString()
    }
  })
], Zg.prototype, "size", 2);
Zg = $w([
  be(),
  P("jumio-sdk-cross-device-button")
], Zg);
var rTe = Object.defineProperty, nTe = Object.getOwnPropertyDescriptor, sK = (e) => {
  throw TypeError(e);
}, Kw = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? nTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && rTe(t, r, a), a;
}, lK = (e, t, r) => t.has(e) || sK("Cannot " + r), r3 = (e, t, r) => (lK(e, t, "read from private field"), r ? r.call(e) : t.get(e)), n3 = (e, t, r) => t.has(e) ? sK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), aTe = (e, t, r, n) => (lK(e, t, "write to private field"), t.set(e, r), r), vb, jZ;
let Bg = class extends N {
  constructor() {
    super(), this.fluid = !0, this.type = De.Quiet, this.size = _a.Medium, n3(this, vb), n3(this, jZ, () => {
      const { Upload: e } = un(oe());
      ve().send({ type: e });
    }), aTe(this, vb, new ue(this, z0e()));
  }
  render() {
    var e;
    return (e = r3(this, vb)) != null && e.value ? w`
          <x-ds-button
            @jclick="${r3(this, jZ)}"
            data-qa-id="upload-button"
            data-type="quiet"
            data-size="${this.size}"
            data-fluid="${this.fluid}"
            data-type="${this.type}"
          >
            ${y("Upload file", { id: "id-source.button.upload" })}
          </x-ds-button>
        ` : q;
  }
};
vb = /* @__PURE__ */ new WeakMap();
jZ = /* @__PURE__ */ new WeakMap();
Bg.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
Kw([
  M({
    attribute: "data-fluid",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Bg.prototype, "fluid", 2);
Kw([
  M({
    attribute: "data-type",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => O2(e) ? e : De.Primary,
      toAttribute: (e) => e.toString()
    }
  })
], Bg.prototype, "type", 2);
Kw([
  M({
    attribute: "data-size",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => rE(e) ? e : _a.Medium,
      toAttribute: (e) => e.toString()
    }
  })
], Bg.prototype, "size", 2);
Bg = Kw([
  be(),
  P("jumio-sdk-upload-button")
], Bg);
var iTe = Object.defineProperty, oTe = Object.getOwnPropertyDescriptor, cK = (e) => {
  throw TypeError(e);
}, dh = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? oTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && iTe(t, r, a), a;
}, dK = (e, t, r) => t.has(e) || cK("Cannot " + r), a3 = (e, t, r) => (dK(e, t, "read from private field"), r ? r.call(e) : t.get(e)), i3 = (e, t, r) => t.has(e) ? cK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), If = (e, t, r) => (dK(e, t, "access private method"), r), wy, nu, uK, hK, pK, gK, fK;
let bl = class extends wa {
  constructor() {
    super(...arguments), i3(this, nu), this.title = "", this.message = "", this.overlay = !1, this.errorCode = "", this.date = null, this.transactionId = "", i3(this, wy, new ue(this, f4()));
  }
  render() {
    return w`
      <div class="error">
        <x-ds-error-message-details
          data-qa-id="error-details"
          data-title="${this.title}"
          data-message="${this.message}"
          data-error-code="${this.errorCode}"
          data-transaction-id="${this.transactionId}"
          .date="${this.date}"
        >
          <slot name="message" slot="message"></slot>
        </x-ds-error-message-details>
        ${If(this, nu, uK).call(this)}
      </div>
    `;
  }
  retry() {
    mt.closeActiveClosableMessage(), tI.next();
  }
};
wy = /* @__PURE__ */ new WeakMap();
nu = /* @__PURE__ */ new WeakSet();
uK = function() {
  return w`
      <div class="error__control-panel">
        ${If(this, nu, gK).call(this)} ${If(this, nu, pK).call(this)} ${If(this, nu, fK).call(this)}
        ${If(this, nu, hK).call(this)}
      </div>
    `;
};
hK = function() {
  const { sessionUrl: e } = Le();
  return w`
      <div class="horizontal-separator"></div>
      <x-ds-session-url-box data-url="${e}"></x-ds-session-url-box>
    `;
};
pK = function() {
  const { linked: e } = Le();
  return !_l() && !e ? w`
          <div class="horizontal-separator"></div>
          <jumio-sdk-cross-device-button
            data-type="${De.Secondary}"
            data-size="${_a.Small}"
          ></jumio-sdk-cross-device-button>
        ` : q;
};
gK = function() {
  return w`
      <x-ds-button
        data-qa-id="retry-button"
        data-type="primary"
        data-fluid="true"
        data-size="${_a.Small}"
        data-disabled="${a3(this, wy).value === !0}"
        @click="${() => {
    a3(this, wy).value || this.retry();
  }}"
      >
        ${y("Try again", { id: "retry.button.try-again" })}
      </x-ds-button>
    `;
};
fK = function() {
  const { step: e } = Le();
  return e === T.Id ? w`
          <div class="horizontal-separator"></div>
          <jumio-sdk-upload-button
            data-type="${De.Secondary}"
            data-size="${_a.Small}"
            data-fluid="true"
          ></jumio-sdk-upload-button>
        ` : q;
};
bl.styles = [...wa.styles, Gt(KFe)];
dh([
  M({
    type: String,
    attribute: "data-title",
    reflect: !0
  })
], bl.prototype, "title", 2);
dh([
  M({
    type: String,
    attribute: "data-message",
    reflect: !0
  })
], bl.prototype, "message", 2);
dh([
  M({
    type: String,
    attribute: "data-overlay",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], bl.prototype, "overlay", 2);
dh([
  M({
    type: String,
    attribute: "data-error-code",
    reflect: !0
  })
], bl.prototype, "errorCode", 2);
dh([
  M({
    type: String,
    attribute: "data-date",
    reflect: !0,
    converter: {
      fromAttribute: (e) => e ? new Date(e) : null,
      toAttribute: (e) => e instanceof Date ? e.toISOString() : null
    }
  })
], bl.prototype, "date", 2);
dh([
  M({
    type: String,
    attribute: "data-transaction-id",
    reflect: !0
  })
], bl.prototype, "transactionId", 2);
bl = dh([
  be(),
  P("jumio-sdk-camera-error")
], bl);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Ea = Og(class extends jg {
  constructor(e) {
    if (super(e), e.type !== Yg.CHILD) throw Error("templateContent can only be used in child bindings");
  }
  render(e) {
    return this.vt === e ? no : (this.vt = e, document.importNode(e.content, !0));
  }
});
function sTe(e) {
  pg((t) => ({ ...t, templates: { ...t.templates ?? {}, [e]: !0 } }));
}
function lTe(e) {
  return !!document.querySelector(`template#${e}`);
}
function ke(e, t = q) {
  const r = document.querySelector(`template#${e}`);
  return r ? (sTe(e), w`${Ea(r)}`) : t ?? q;
}
var cTe = Object.defineProperty, dTe = Object.getOwnPropertyDescriptor, mK = (e) => {
  throw TypeError(e);
}, uTe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? dTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && cTe(t, r, a), a;
}, kF = (e, t, r) => t.has(e) || mK("Cannot " + r), wo = (e, t, r) => (kF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), P0 = (e, t, r) => t.has(e) ? mK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), o3 = (e, t, r, n) => (kF(e, t, "write to private field"), t.set(e, r), r), Lo = (e, t, r) => (kF(e, t, "access private method"), r), Fd, Cf, ki, vK, SK, IK, CK, bK, yK, Sb, Ib, _F, NF;
let PZ = class extends N {
  constructor() {
    super(), P0(this, ki), P0(this, Fd), P0(this, Cf), P0(this, Sb, (e) => {
      e instanceof lke && wo(this, Fd).showMessageIfPossible(e.detail);
    }), P0(this, Ib, (e) => {
      e instanceof Vj && (e.detail ? wo(this, Fd).closeActiveClosableMessageById(e.detail.id) : wo(this, Fd).closeActiveClosableMessage());
    }), o3(this, Fd, new $Fe(this)), o3(this, Cf, new ue(this, wo(this, Fd).message$));
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener(NZ, wo(this, Sb)), this.addEventListener(ZZ, wo(this, Ib));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener(NZ, wo(this, Sb)), this.removeEventListener(ZZ, wo(this, Ib));
  }
  render() {
    return wo(this, Cf).value ? Lo(this, ki, vK).call(this, wo(this, Cf).value) : w`<slot></slot>`;
  }
};
Fd = /* @__PURE__ */ new WeakMap();
Cf = /* @__PURE__ */ new WeakMap();
ki = /* @__PURE__ */ new WeakSet();
vK = function(e) {
  let t;
  switch (e.type) {
    case Fr.Progress:
      t = Lo(this, ki, SK).call(this, e);
      break;
    case Fr.Error:
      switch (e.id) {
        case ct.CameraNotAllowedError:
          t = Lo(this, ki, CK).call(this, e);
          break;
        case ct.CameraGenericError:
          t = Lo(this, ki, IK).call(this, e);
          break;
        default:
          t = w`${ke("jumio-finish-before")}${Lo(this, ki, bK).call(this, e)}${ke("jumio-finish-after")}`;
          break;
      }
      break;
    case Fr.Success:
    default:
      t = w`${ke("jumio-finish-before")}${Lo(this, ki, yK).call(this, e)}${ke("jumio-finish-after")}`;
      break;
  }
  return e ? w`<div class="container">${t}</div>` : q;
};
SK = function(e) {
  return w`
      ${e.overlay ? w`<slot></slot>` : w``}
      <x-ds-progress-message
        data-qa-id="progress-message"
        .title="${e.title}"
        .message="${e.message}"
        .overlay="${e.overlay}"
      ></x-ds-progress-message>
    `;
};
IK = function(e) {
  return w`
      ${e.overlay ? w`<slot></slot>` : w``}
      <jumio-sdk-camera-error
        data-qa-id="error-message"
        class="message-not-readable"
        .title="${e.title}"
        .message="${e.message}"
        .overlay="${e.overlay}"
        .errorCode="${e.errorCode ?? ""}"
        .transactionId="${e.transactionId}"
        .date="${e.date}"
      >
        <div slot="message" data-qa-id="message">
          <p>${e.message}</p>
          <x-ds-card-list>
            <h6 slot="header" class="text-body-medium">
              ${y("Please try the following steps:", {
    id: "error.camera-error.try-steps"
  })}
            </h6>
            ${Lo(this, ki, _F).call(this, e)}
            <li slot="item">
              ${y("Confirm your camera is correctly connected and is not in use by another application", {
    id: "error.camera-not-readable.step1"
  })}
            </li>
            <li slot="item">
              ${y("Verify camera permissions for this app in your device settings", {
    id: "error.camera-not-readable.step2"
  })}
            </li>
            <li slot="item">
              ${y("Try restarting your device to resolve any temporary issues", {
    id: "error.camera-not-readable.step3"
  })}
            </li>
          </x-ds-card-list>
        </div>
      </jumio-sdk-camera-error>
      ${Lo(this, ki, NF).call(this, e)}
    `;
};
CK = function(e) {
  return w`
      ${e.overlay ? w`<slot></slot>` : w``}
      <jumio-sdk-camera-error
        data-qa-id="error-message"
        class="message-not-readable"
        .title="${e.title}"
        .message="${e.message}"
        .overlay="${e.overlay}"
        .errorCode="${e.errorCode ?? ""}"
        .transactionId="${e.transactionId}"
        .date="${e.date}"
      >
        <div slot="message" data-qa-id="message">
          <p>${e.message}</p>
          <x-ds-card-list>
            <h6 slot="header" class="text-body-medium">
              ${y("Please try the following steps:", {
    id: "error.camera-error.try-steps"
  })}
            </h6>
            ${Lo(this, ki, _F).call(this, e)}
            <li slot="item">
              ${y("Check if there's a camera icon in your browser's address bar. Click on it and allow access.", {
    id: "error.camera-not-allowed.step1"
  })}
            </li>
            <li slot="item">
              ${y("Go to your browser's settings. Look for Camera settings and allow access for this website.", {
    id: "error.camera-not-allowed.step2"
  })}
            </li>
          </x-ds-card-list>
        </div>
      </jumio-sdk-camera-error>
      ${Lo(this, ki, NF).call(this, e)}
    `;
};
bK = function(e) {
  return ke(
    "jumio-finish-error",
    w`
        ${e.overlay ? w`<slot></slot>` : w``}
        <x-ds-error-message
          data-qa-id="error-message"
          .title="${e.title}"
          .message="${e.message}"
          .overlay="${e.overlay}"
          .errorCode="${e.errorCode ?? ""}"
          .transactionId="${e.transactionId}"
          .date="${e.date}"
        >
          ${e.closable ? w`<x-ds-button
                slot="button"
                @jclick="${() => this.dispatchEvent(new Vj())}"
                data-type="${De.Primary}"
                data-fluid="true"
                >${y("Try again", { id: "retry.button.try-again" })}</x-ds-button
              >` : q}
        </x-ds-error-message>
      `
  );
};
yK = function(e) {
  return ke(
    "jumio-finish-success",
    w`
        ${e.overlay ? w`<slot></slot>` : w``}
        <x-ds-success-message
          data-qa-id="success-message"
          .title="${e.title}"
          .message="${e.message}"
          .overlay="${e.overlay}"
        ></x-ds-success-message>
      `
  );
};
Sb = /* @__PURE__ */ new WeakMap();
Ib = /* @__PURE__ */ new WeakMap();
_F = function(e) {
  const t = (() => {
    const r = y(
      "Camera access denied. Open this page in a {{browser-marker-begin}}system browser{{browser-marker-end}} to continue.",
      {
        id: "error.camera-denied.open-system-browser"
      }
    ), a = new RegExp("{{browser-marker-begin}}(.*){{browser-marker-end}}", "gi").exec(r);
    return a ? r.replace(
      a[0],
      `<a href="${window.location.href}" target="_blank" class="browser">${a[1]}</a>`
    ) : "";
  })();
  return window.location.href && t ? w`<li
          slot="item"
          class="${tn({
    "safari-camera-wrapper-error": e.errorCode === uQ
  })}"
        >
          ${Pm(t)}
        </li>` : q;
};
NF = function(e) {
  return e.closable ? w`
          <div class="close-dialog-container">
            <x-ds-button
              class="right-button mobile-only"
              slot="top-right"
              data-size="${_a.Medium}"
              data-shape="${ya.Round}"
              data-type="${De.Tertiary}"
              data-padding="false"
              @jclick="${() => {
    mt.closeActiveClosableMessage();
  }}"
            >
              <span class="close-dialog icon icon-close"></span>
            </x-ds-button>
          </div>
        ` : q;
};
PZ.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      @keyframes displayMessage {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      .container {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        row-gap: 1em;
        animation: displayMessage 500ms 1;
        padding: 0 1em;
        overflow-y: auto;
      }

      :host([data-color-scheme='light']) .container {
        background: var(--theme-light-app-container-bg-color);
      }

      :host([data-color-scheme='dark']) .container {
        background: var(--theme-dark-app-container-bg-color);
      }

      .browser {
        font-weight: bold;
      }

      p {
        margin-block: 0;
      }

      p + p,
      p + x-ds-card-list,
      x-ds-card-list + p {
        display: block;
        margin-top: 1em;
      }

      .close-dialog-container {
        position: absolute;
        top: 1em;
        right: 1em;
      }

      .close-dialog {
        font-size: 150%;
        padding: 0.5em;
      }

      .container {
        padding-block: 1.5em;
      }

      .safari-camera-wrapper-error {
        color: var(--red);
        font-weight: bold;
      }
    `
];
PZ = uTe([
  be(),
  P("jumio-sdk-message-screen")
], PZ);
const wK = ({ originalUrl: e, suggestedUrlPart: t }) => {
  const r = new URL(e), n = "step=", a = r.hash.split(/[#&]/).filter((i) => !!i && !i.startsWith(n)).join("&");
  return r.hash = a ? `${a}&${n}${t}` : `${n}${t}`, r.toString();
}, AK = (e, t = []) => t.length > 0 ? t.every((r) => {
  const n = r.shouldStoreState(e);
  return n || n === void 0;
}) : e.shouldStoreNavigationState, UK = ({
  step: e,
  substep: t,
  credentialId: r,
  activeScreen: n
}) => ({
  activeScreen: n,
  step: hTe(e) ? e : {
    [r]: t ?? ""
  }
}), hTe = (e) => Object.values(Me).includes(e), kK = {
  shouldStoreState: (e) => e.activeScreen === Ot.CrossDevice ? !0 : e.shouldStoreNavigationState
}, $Z = ({ step: e, substep: t, credentialId: r, activeScreen: n }) => n === Ot.CrossDevice ? `${r}#${Ot.CrossDevice}` : [
  Z.CaptureScreen,
  Z.CaptureScreenAutoCaptureLoading,
  Z.CaptureScreenBack,
  Z.CaptureScreenBackFinish,
  Z.CaptureScreenBackStart,
  Z.CaptureScreenComplete,
  Z.CaptureScreenDecision,
  Z.CaptureScreenFront,
  Z.CaptureScreenFrontFinish,
  Z.CaptureScreenFrontStart,
  Z.CaptureScreenSelectProvider,
  x.Iproov,
  x.JumioStandard,
  x.JumioStandardCaptureScreen,
  x.JumioStandardCaptureScreenLiveness,
  x.JumioStandardCaptureScreenLivenessLoading,
  x.JumioStandardCaptureScreenCaptureFinish,
  x.JumioStandardCaptureScreenSelfie,
  x.JumioStandardCaptureScreenUpload
].includes(t) ? `${r}#${Z.CaptureScreen}` : `${e}#${r}#${t}#${n}`;
var pTe = Object.defineProperty, gTe = Object.getOwnPropertyDescriptor, _K = (e) => {
  throw TypeError(e);
}, h0 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? gTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && pTe(t, r, a), a;
}, NK = (e, t, r) => t.has(e) || _K("Cannot " + r), ZF = (e, t, r) => (NK(e, t, "read from private field"), r ? r.call(e) : t.get(e)), s3 = (e, t, r) => t.has(e) ? _K("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), lC = (e, t, r) => (NK(e, t, "access private method"), r), iv, Vh, ZK, BK, KZ;
let yl = class extends N {
  constructor() {
    super(...arguments), s3(this, Vh), this.transformUrl = wK, this.baseUrl = window.location.href, this.navigationService = this, s3(this, iv, new _e()), this.pushState = ({ data: e, url: t, unused: r = "" }) => {
      window.history.pushState(e, r, t);
    }, this.replaceState = ({ data: e, url: t, unused: r = "" }) => {
      window.history.replaceState(e, r, t);
    }, this.recreateStateMachine = (e) => {
      oQ(e);
    };
  }
  static isTheSameNavigationStep(e, t) {
    return e.credentialId === t.credentialId && e.step === t.step && e.substep === t.substep;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), ZF(this, iv).next();
  }
  firstUpdated(e) {
    super.firstUpdated(e), lC(this, Vh, BK).call(this), lC(this, Vh, ZK).call(this), lC(this, Vh, KZ).call(this), window.setTimeout(() => {
      this.baseUrl = window.location.href;
    });
  }
  render() {
    return w`
      <slot
        name="navigation-interceptor"
        @slotchange="${() => {
      this.requestUpdate();
    }}"
      ></slot>
      <slot
        name="navigation"
        @slotchange="${() => {
      lC(this, Vh, KZ).call(this);
    }}"
      ></slot>
      <slot></slot>
    `;
  }
  back() {
    window.history.back();
  }
  hasHistoryItems() {
    var n;
    const e = this.initialWorkflowState, t = (n = this.lastPushedState) == null ? void 0 : n.workflowState, r = !!(e && t && yl.isTheSameNavigationStep(e, t));
    return window.history.length > 0 && !r;
  }
  popState(e) {
    if (!Le().finalized && Ut(e, ["backupGuid", "workflowState", "navigationStep", "descriptor"])) {
      const r = tL(e.backupGuid);
      r && (Hf(!0), r(), this.recreateStateMachine({
        credentials: On().credentials,
        setWorkflowStepCallback: sh,
        snapshotValue: UK(e.navigationStep)
      }), this.lastPushedState = e, Hf(!1));
    }
  }
  updateWorkflowState(e) {
    eo(e);
  }
  getLastPushedState() {
    return this.lastPushedState;
  }
};
iv = /* @__PURE__ */ new WeakMap();
Vh = /* @__PURE__ */ new WeakSet();
ZK = function() {
  ug().pipe(
    go(Gve()),
    te(([e, t]) => ({ workflowState: e, recoveringState: t })),
    at(({ recoveringState: e }) => !e),
    ae(({ workflowState: e }) => {
      var n;
      const t = [kK, ...this.interceptors], r = {
        backupGuid: rL(),
        workflowState: e,
        navigationStep: $g(e),
        descriptor: $Z(e)
      };
      if (AK(r.workflowState, t)) {
        this.initialWorkflowState || (this.initialWorkflowState = e);
        const a = {
          data: r,
          url: this.transformUrl({
            originalUrl: this.baseUrl,
            suggestedUrlPart: UAe(r.workflowState) ?? "",
            stepData: r.navigationStep
          })
        };
        ((n = this.lastPushedState) == null ? void 0 : n.descriptor) === r.descriptor ? this.replaceState(a) : (this.pushState(a), this.lastPushedState = r);
      }
    }),
    le(ZF(this, iv))
  ).subscribe();
};
BK = function() {
  Ke(window, "popstate").pipe(
    ae((e) => {
      this.popState(e.state);
    }),
    le(ZF(this, iv))
  ).subscribe();
};
KZ = function() {
  this.navigationConfig.forEach((e) => {
    this.transformUrl = e.transformUrl, this.baseUrl = e.baseUrl;
  }), this.requestUpdate();
};
yl.styles = [
  ee`
      :host {
        display: contents;
      }
    `
];
h0([
  Xn()
], yl.prototype, "transformUrl", 2);
h0([
  M({
    attribute: "data-base-url",
    type: String,
    reflect: !0
  })
], yl.prototype, "baseUrl", 2);
h0([
  ka({ context: zQ }),
  Xn()
], yl.prototype, "navigationService", 2);
h0([
  dr({
    slot: "navigation-interceptor",
    flatten: !0
  })
], yl.prototype, "interceptors", 2);
h0([
  dr({
    slot: "navigation",
    selector: "jumio-sdk-navigation-config-browser",
    flatten: !0
  })
], yl.prototype, "navigationConfig", 2);
yl = h0([
  P("jumio-sdk-navigation-browser")
], yl);
var mp = /* @__PURE__ */ ((e) => (e.Browser = "browser", e.Memory = "memory", e))(mp || {}), fTe = Object.defineProperty, mTe = Object.getOwnPropertyDescriptor, BF = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? mTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && fTe(t, r, a), a;
};
let Ay = class extends ro {
  constructor() {
    super(...arguments), this.type = mp.Browser, this.transformUrl = wK, this.baseUrl = window.location.href;
  }
};
BF([
  Xn()
], Ay.prototype, "transformUrl", 2);
BF([
  M({
    attribute: "data-base-url",
    type: String,
    reflect: !0
  })
], Ay.prototype, "baseUrl", 2);
Ay = BF([
  P("jumio-sdk-navigation-config-browser")
], Ay);
var vTe = Object.defineProperty, STe = Object.getOwnPropertyDescriptor, ITe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? STe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && vTe(t, r, a), a;
};
let l3 = class extends ro {
  constructor() {
    super(...arguments), this.type = mp.Memory;
  }
};
l3 = ITe([
  P("jumio-sdk-navigation-config-memory")
], l3);
var CTe = Object.defineProperty, bTe = Object.getOwnPropertyDescriptor, yTe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? bTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && CTe(t, r, a), a;
};
let c3 = class extends ro {
  shouldStoreState(e) {
    return !e.shouldStoreNavigationState || e.step === Me.Setup ? !1 : !(e.step === T.Id && !e.substep);
  }
};
c3 = yTe([
  P("jumio-sdk-navigation-interceptor")
], c3);
var wTe = Object.defineProperty, ATe = Object.getOwnPropertyDescriptor, WK = (e) => {
  throw TypeError(e);
}, Xw = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ATe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && wTe(t, r, a), a;
}, WF = (e, t, r) => t.has(e) || WK("Cannot " + r), Ac = (e, t, r) => (WF(e, t, "read from private field"), t.get(e)), Ik = (e, t, r) => t.has(e) ? WK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), d3 = (e, t, r, n) => (WF(e, t, "write to private field"), t.set(e, r), r), UTe = (e, t, r) => (WF(e, t, "access private method"), r), xo, Uy, XZ, EK;
let Wg = class extends N {
  constructor() {
    super(...arguments), Ik(this, XZ), this.navigationService = this, Ik(this, xo, []), Ik(this, Uy, new _e()), this.pushState = (e) => {
      Ac(this, xo).push(e);
    }, this.recreateStateMachine = (e) => {
      oQ(e);
    };
  }
  firstUpdated(e) {
    super.firstUpdated(e), UTe(this, XZ, EK).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Ac(this, Uy).next();
  }
  render() {
    return w`
      <slot
        name="navigation-interceptor"
        @slotchange="${() => {
      this.requestUpdate();
    }}"
      ></slot>
      <slot
        name="navigation"
        @slotchange="${() => {
      this.requestUpdate();
    }}"
      ></slot>
      <slot></slot>
    `;
  }
  back() {
    if (Le().finalized)
      return;
    const e = this.getHistoryItems(), t = e.pop();
    if (t) {
      Hf(!0), d3(this, xo, e);
      const r = tL(t.backupGuid);
      if (r) {
        r();
        const n = UK(t.workflowState);
        this.recreateStateMachine({
          credentials: On().credentials,
          setWorkflowStepCallback: sh,
          snapshotValue: n
        });
      }
      Hf(!1), Ac(this, xo).push(t);
    }
  }
  hasHistoryItems() {
    return this.getHistoryItems().length > 0;
  }
  reset() {
    Hf(!1), d3(this, xo, []);
  }
  getHistoryItems() {
    const e = [kK, ...this.interceptors], t = $Z($g(Le())), r = Ac(this, xo).filter((o) => AK(o.navigationStep, e)).map((o) => ({
      ...o,
      descriptor: $Z(o.navigationStep)
    })), n = Ose(r, (o) => o.descriptor), a = n[n.length - 1];
    return ((a == null ? void 0 : a.descriptor) === t ? n.slice(0, -1) : n).map(({ descriptor: o, ...s }) => s);
  }
};
xo = /* @__PURE__ */ new WeakMap();
Uy = /* @__PURE__ */ new WeakMap();
XZ = /* @__PURE__ */ new WeakSet();
EK = function() {
  ug().pipe(
    at(() => !xve()),
    te((e) => ({
      backupGuid: rL(),
      workflowState: e,
      navigationStep: $g(e)
    })),
    ae((e) => {
      const t = Ac(this, xo)[Ac(this, xo).length - 1];
      hG(t == null ? void 0 : t.navigationStep, e) && Ac(this, xo).pop(), this.pushState(e);
    }),
    le(Ac(this, Uy))
  ).subscribe();
};
Wg.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
Xw([
  ka({ context: zQ }),
  Xn()
], Wg.prototype, "navigationService", 2);
Xw([
  dr({ slot: "navigation-interceptor", flatten: !0 })
], Wg.prototype, "interceptors", 2);
Xw([
  dr({
    slot: "navigation",
    selector: "jumio-sdk-navigation-config-memory",
    flatten: !0
  })
], Wg.prototype, "navigationConfig", 2);
Wg = Xw([
  P("jumio-sdk-navigation-memory")
], Wg);
var EF = /* @__PURE__ */ ((e) => (e.NavigationBackward = "navigationbackward", e.NavigationForward = "navigationforward", e.NavigationDirect = "navigationdirect", e))(EF || {}), kTe = Object.defineProperty, _Te = Object.getOwnPropertyDescriptor, QK = (e) => {
  throw TypeError(e);
}, FK = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? _Te(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && kTe(t, r, a), a;
}, QF = (e, t, r) => t.has(e) || QK("Cannot " + r), ky = (e, t, r) => (QF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ck = (e, t, r) => t.has(e) ? QK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), NTe = (e, t, r, n) => (QF(e, t, "write to private field"), t.set(e, r), r), cC = (e, t, r) => (QF(e, t, "access private method"), r), Cb, ov, Mh, TK, RK, DK, JK;
let _y = class extends N {
  constructor() {
    super(...arguments), Ck(this, Mh), Ck(this, Cb), Ck(this, ov, new _e()), this.handleNavigationForward = () => {
      this.workflowController.goToNextStep();
    }, this.handleNavigationBackward = () => {
      this.workflowController.goToPreviousStep();
    };
  }
  firstUpdated(e) {
    super.firstUpdated(e), cC(this, Mh, TK).call(this), cC(this, Mh, RK).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), ky(this, ov).next();
  }
  get workflowController() {
    return ky(this, Cb) ?? NTe(this, Cb, Ce());
  }
  render() {
    return w`
      ${El(this.getNavigationType(), [
      [mp.Memory, () => cC(this, Mh, DK).call(this)],
      [mp.Browser, () => cC(this, Mh, JK).call(this)]
    ])}
    `;
  }
  getNavigationType() {
    let e = mp.Browser;
    return this.navigationConfig.length > 0 && (e = this.navigationConfig[this.navigationConfig.length - 1].type), e;
  }
};
Cb = /* @__PURE__ */ new WeakMap();
ov = /* @__PURE__ */ new WeakMap();
Mh = /* @__PURE__ */ new WeakSet();
TK = function() {
  Ke(this, EF.NavigationForward).pipe(
    ae(() => {
      this.handleNavigationForward();
    }),
    le(ky(this, ov))
  ).subscribe();
};
RK = function() {
  Ke(this, EF.NavigationBackward).pipe(
    ae(() => {
      this.handleNavigationBackward();
    }),
    le(ky(this, ov))
  ).subscribe();
};
DK = function() {
  return w`
      <jumio-sdk-navigation-memory>
        <slot
          name="navigation-interceptor"
          slot="navigation-interceptor"
          @slotchange="${() => {
    this.requestUpdate();
  }}"
        ></slot>
        <slot
          name="navigation"
          slot="navigation"
          @slotchange="${() => {
    this.requestUpdate();
  }}"
        ></slot>
        <slot></slot>
      </jumio-sdk-navigation-memory>
    `;
};
JK = function() {
  return w`
      <jumio-sdk-navigation-browser>
        <slot
          name="navigation-interceptor"
          slot="navigation-interceptor"
          @slotchange="${() => {
    this.requestUpdate();
  }}"
        ></slot>
        <slot
          name="navigation"
          slot="navigation"
          @slotchange="${() => {
    this.requestUpdate();
  }}"
        ></slot>
        <slot></slot>
      </jumio-sdk-navigation-browser>
    `;
};
_y.styles = [
  ee`
      :host {
        display: contents;
      }
    `
];
FK([
  dr({ slot: "navigation", flatten: !0 })
], _y.prototype, "navigationConfig", 2);
_y = FK([
  P("jumio-sdk-navigation")
], _y);
var xv, Bp, Dg, VK, MK;
class ZTe {
  constructor(t) {
    E(this, Dg);
    E(this, xv);
    E(this, Bp);
    G(this, xv, t), G(this, Bp, Ce()), this.crossDeviceOption$ = O(this, Dg, VK).call(this), S(this, xv).addController(this);
  }
  get baseUrl() {
    const { baseUrl: t } = Le();
    return t;
  }
  get token() {
    const { token: t } = Le();
    return t;
  }
  get locale() {
    const { locale: t } = Le();
    return t;
  }
  get crossDeviceUrl$() {
    return O(this, Dg, MK).call(this).pipe(
      at((t) => !!t),
      te((t) => {
        const r = new URL(t);
        return r.searchParams.set("authorizationToken", this.token), r.searchParams.set("locale", this.locale), r;
      })
    );
  }
  hostConnected() {
  }
  hostDisconnected() {
  }
}
xv = new WeakMap(), Bp = new WeakMap(), Dg = new WeakSet(), VK = function() {
  return S(this, Bp).getConfiguration().selectSettings$().pipe(
    te((t) => {
      var r, n;
      return (n = (r = t == null ? void 0 : t.merchantSettings) == null ? void 0 : r.crossDevice) == null ? void 0 : n.crossDeviceOption;
    })
  );
}, MK = function() {
  return S(this, Bp).getConfiguration().selectSettings$().pipe(
    te((t) => {
      var r, n;
      return (n = (r = t == null ? void 0 : t.merchantSettings) == null ? void 0 : r.crossDevice) == null ? void 0 : n.link;
    })
  );
};
var h2, Hv;
class BTe {
  constructor(t) {
    E(this, h2);
    E(this, Hv);
    G(this, h2, t), G(this, Hv, Ce());
  }
  hostConnected() {
  }
  getLogoFromSettings() {
    var t, r;
    return (r = (t = S(this, Hv).getConfiguration().getSettings().merchantSettings) == null ? void 0 : t.branding) == null ? void 0 : r.logoUri;
  }
}
h2 = new WeakMap(), Hv = new WeakMap();
var WTe = Object.defineProperty, ETe = Object.getOwnPropertyDescriptor, GK = (e) => {
  throw TypeError(e);
}, QTe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ETe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && WTe(t, r, a), a;
}, FTe = (e, t, r) => t.has(e) || GK("Cannot " + r), TTe = (e, t, r) => t.has(e) ? GK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), u3 = (e, t, r) => (FTe(e, t, "access private method"), r), bb, zZ;
let qZ = class extends N {
  constructor() {
    super(...arguments), TTe(this, bb), this.componentController = new BTe(this);
  }
  render() {
    return w`
      <div class="logotype">
        ${lTe("jumio-logotype") ? w`
              <div class="logotype__wrapper">
                ${u3(this, bb, zZ).call(this, "jumio-logotype")}
              </div>
            ` : w`
              <div class="logotype__wrapper logotype__wrapper--light">
                ${u3(this, bb, zZ).call(this, "jumio-logotype-light")}
              </div>
              <div class="logotype__wrapper logotype__wrapper--dark">
                ${ke("jumio-logotype-dark")}
              </div>
            `}
      </div>
    `;
  }
};
bb = /* @__PURE__ */ new WeakSet();
zZ = function(e) {
  if (document.querySelector(`template#${e}`))
    return w`${ke(e)}`;
  const r = this.componentController.getLogoFromSettings();
  return r ? w`<img src="${`data:image/png;base64,${r}`}" />` : q;
};
qZ.styles = [
  ...N.styles,
  ee`
      :host {
        display: block;
        box-sizing: border-box;
        min-width: 12em;
        height: 5em;
        margin: 0.5em auto;
        flex-grow: 1;
        align-self: stretch;
        overflow: hidden;
      }

      .logotype {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
      }

      .logotype__wrapper > img {
        height: 100%;
        object-fit: contain;
        object-position: center center;
        max-width: 60vw;
      }

      .logotype__wrapper--light,
      .logotype__wrapper--dark {
        display: none;
      }

      @media (prefers-color-scheme: light) {
        .logotype__wrapper--light {
          display: contents;
        }
      }

      @media (prefers-color-scheme: dark) {
        .logotype__wrapper--dark {
          display: contents;
        }
      }
    `
];
qZ = QTe([
  P("jumio-sdk-logotype")
], qZ);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const h3 = (e, t, r) => {
  const n = /* @__PURE__ */ new Map();
  for (let a = t; a <= r; a++) n.set(e[a], a);
  return n;
}, xK = Og(class extends jg {
  constructor(e) {
    if (super(e), e.type !== Yg.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(e, t, r) {
    let n;
    r === void 0 ? r = t : t !== void 0 && (n = t);
    const a = [], i = [];
    let o = 0;
    for (const s of e) a[o] = n ? n(s, o) : o, i[o] = r(s, o), o++;
    return { values: i, keys: a };
  }
  render(e, t, r) {
    return this.dt(e, t, r).values;
  }
  update(e, [t, r, n]) {
    const a = Lce(e), { values: i, keys: o } = this.dt(t, r, n);
    if (!Array.isArray(a)) return this.ut = o, i;
    const s = this.ut ?? (this.ut = []), c = [];
    let l, u, g = 0, p = a.length - 1, m = 0, I = i.length - 1;
    for (; g <= p && m <= I; ) if (a[g] === null) g++;
    else if (a[p] === null) p--;
    else if (s[g] === o[m]) c[m] = Id(a[g], i[m]), g++, m++;
    else if (s[p] === o[I]) c[I] = Id(a[p], i[I]), p--, I--;
    else if (s[g] === o[I]) c[I] = Id(a[g], i[I]), Z0(e, c[I + 1], a[g]), g++, I--;
    else if (s[p] === o[m]) c[m] = Id(a[p], i[m]), Z0(e, a[g], a[p]), p--, m++;
    else if (l === void 0 && (l = h3(o, m, I), u = h3(s, g, p)), l.has(s[g])) if (l.has(s[p])) {
      const C = u.get(o[m]), A = C !== void 0 ? a[C] : null;
      if (A === null) {
        const U = Z0(e, a[g]);
        Id(U, i[m]), c[m] = U;
      } else c[m] = Id(A, i[m]), Z0(e, a[g], A), a[C] = null;
      m++;
    } else rU(a[p]), p--;
    else rU(a[g]), g++;
    for (; m <= I; ) {
      const C = Z0(e, c[I + 1]);
      Id(C, i[m]), c[m++] = C;
    }
    for (; g <= p; ) {
      const C = a[g++];
      C !== null && rU(C);
    }
    return this.ut = o, Hce(e, c), no;
  }
});
class RTe extends CustomEvent {
  constructor(t, r) {
    super("locale:change", {
      detail: { previousLocale: t, currentLocale: r },
      bubbles: !0,
      composed: !0
    });
  }
}
const DTe = () => [
  { keys: [Y.Ar], label: "Arabic - العربية" },
  { keys: [Y.Hy], label: "Armenian - Հայկական Այբուբեն" },
  { keys: [Y.Bg], label: "Bulgarian - български език" },
  { keys: [Y.ZhCn, Y.ZhCnHyphen, Y.Zh], label: "Chinese (Simplified) - 简体中文" },
  { keys: [Y.ZhHk, Y.ZhHkHyphen], label: "Chinese (Traditional) - 繁體中文" },
  { keys: [Y.Hr], label: "Croatian - Hrvatski" },
  { keys: [Y.Cs], label: "Czech - Čeština" },
  { keys: [Y.Da], label: "Danish - Dansk" },
  { keys: [Y.Nl], label: "Dutch - Nederlands" },
  { keys: [Y.En, Y.EnUs, Y.EnUsHyphen], label: "English (United States)" },
  { keys: [Y.EnGb, Y.EnGbHyphen], label: "English (United Kingdom)" },
  { keys: [Y.Et], label: "Estonian - Eesti" },
  { keys: [Y.Fi], label: "Finnish - Suomi" },
  { keys: [Y.Fr], label: "French - Français" },
  { keys: [Y.KaGe, Y.KaGeHyphen], label: "Georgian - ქართული" },
  { keys: [Y.De], label: "German - Deutsch" },
  { keys: [Y.El], label: "Greek - Ελληνικά" },
  { keys: [Y.He], label: "Hebrew - עברית‎" },
  { keys: [Y.Hu], label: "Hungarian - Magyar" },
  { keys: [Y.Id], label: "Indonesian - Bahasa Indonesia" },
  { keys: [Y.It], label: "Italian - Italiano" },
  { keys: [Y.Ja], label: "Japanese - 日本語" },
  { keys: [Y.Km, Y.KmKh, Y.KmKhHyphen], label: "Khmer - ភាសាខ្មែរ" },
  { keys: [Y.Ko], label: "Korean - 한국어" },
  { keys: [Y.Lt], label: "Lithuanian - Lietuvių" },
  { keys: [Y.Ms], label: "Malaysian - Malay" },
  { keys: [Y.No], label: "Norwegian - Norsk" },
  { keys: [Y.Pl], label: "Polish - polski" },
  { keys: [Y.Pt], label: "Portuguese - Português" },
  { keys: [Y.PtBr, Y.PtBrHyphen], label: "Portuguese (Brazilian)- Português" },
  { keys: [Y.Ro], label: "Romanian - Română" },
  { keys: [Y.Ru], label: "Russian - Русский" },
  { keys: [Y.SrLatn, Y.SrLatnHyphen], label: "Serbian (Latin) - Srpski latinica" },
  { keys: [Y.SrCyrl, Y.SrCyrlHyphen, Y.Sr], label: "Serbian (Cyrillic) - Cрпски ћирилица" },
  { keys: [Y.Sk], label: "Slovak - Slovenčina" },
  { keys: [Y.Es], label: "Spanish - Español" },
  { keys: [Y.EsMx, Y.EsMxHyphen], label: "Spanish (Mexican) - Español" },
  { keys: [Y.Sv], label: "Swedish - Svenska" },
  { keys: [Y.Th], label: "Thai - ภาษาไทย" },
  { keys: [Y.Uk], label: "Ukrainian - Українська" },
  { keys: [Y.Tr], label: "Turkish - Türkçe" },
  { keys: [Y.Vi], label: "Vietnamese - Tiếng Việt Nam" }
];
var Wp, Ep;
class JTe {
  constructor(t) {
    E(this, Wp);
    E(this, Ep);
    G(this, Wp, Ce()), G(this, Ep, t), S(this, Ep).addController(this);
  }
  hostDisconnected() {
  }
  updateLocale(t) {
    const { locale: r } = S(this, Wp).getWorkflowState();
    S(this, Ep).dispatchEvent(new RTe(r, t));
  }
  getSelectedLocale() {
    const { locale: t } = S(this, Wp).getWorkflowState();
    return t;
  }
  getLocales() {
    return DTe();
  }
}
Wp = new WeakMap(), Ep = new WeakMap();
var VTe = Object.defineProperty, MTe = Object.getOwnPropertyDescriptor, HK = (e) => {
  throw TypeError(e);
}, GTe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? MTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && VTe(t, r, a), a;
}, FF = (e, t, r) => t.has(e) || HK("Cannot " + r), eB = (e, t, r) => (FF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), bk = (e, t, r) => t.has(e) ? HK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), xTe = (e, t, r, n) => (FF(e, t, "write to private field"), t.set(e, r), r), LK = (e, t, r) => (FF(e, t, "access private method"), r), yb, Ny, Zy, YK, OK;
let tB = class extends N {
  constructor() {
    super(...arguments), bk(this, Zy), bk(this, yb), bk(this, Ny, Rt());
  }
  get componentController() {
    return eB(this, yb) ?? xTe(this, yb, new JTe(this));
  }
  render() {
    return w`
      <div class="locale-select-container">
        <select
          ${Mt(eB(this, Ny))}
          class="select"
          @change="${() => {
      LK(this, Zy, OK).call(this);
    }}"
          data-qa-id="locale-select"
          id="locale-select"
        >
          ${xK(
      this.componentController.getLocales(),
      (e) => e,
      (e) => w`
              <option
                value="${e.keys[0]}"
                ?selected="${e.keys.includes(this.componentController.getSelectedLocale())}"
              >
                ${e.label}
              </option>
            `
    )}
        </select>
        <span class="icon-globe locale-select-small"></span>
      </div>
    `;
  }
};
yb = /* @__PURE__ */ new WeakMap();
Ny = /* @__PURE__ */ new WeakMap();
Zy = /* @__PURE__ */ new WeakSet();
YK = function(e) {
  return Object.values(Y).includes(e);
};
OK = function() {
  var t;
  const e = ((t = eB(this, Ny).value) == null ? void 0 : t.value) ?? "";
  LK(this, Zy, YK).call(this, e) && this.componentController.updateLocale(e);
};
tB.styles = [
  ...N.styles,
  ee`
      .locale-select-container {
        position: relative;
        min-width: 2em;
        min-height: 2em;
        line-height: 2em;
      }

      .select {
        position: absolute;
        border: none;
        background: none;
        appearance: none;
        font: var(--text-font-body-medium);
        line-height: 1.25em; /* 20 / 16 */
        opacity: 0;
        cursor: pointer;

        @media screen and (min-width: 48em) {
          position: static;
          opacity: 1;
        }
      }

      .locale-select-small {
        left: 0;
        pointer-events: none;
        color: var(--color-secondary7);
        font-size: 2em;
        cursor: pointer;

        @media screen and (min-width: 48em) {
          display: none;
        }
      }

      :host([data-color-scheme='light']) .select {
        color: var(--theme-light-clickable-quiet-default-color);
      }

      :host([data-color-scheme='light']) .locale-select-small {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='light']) .select:focus,
      :host([data-color-scheme='light']) .select:hover {
        color: var(--theme-light-clickable-quiet-default-color);
      }

      :host([data-color-scheme='light']) .locale-select-small:focus,
      :host([data-color-scheme='light']) .locale-select-small:hover {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='light']:active) .select {
        color: var(--theme-light-clickable-quiet-default-color);
      }

      :host([data-color-scheme='light']:active) .locale-select-small {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='light'][data-disabled='true']) .select {
        color: var(--theme-light-clickable-quiet-default-color);
      }

      :host([data-color-scheme='light'][data-disabled='true']) .locale-select-small {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='dark']) .select,
      :host([data-color-scheme='dark']) .locale-select-small {
        color: var(--theme-dark-text-color);
      }

      :host([data-color-scheme='dark']:focus) .select,
      :host([data-color-scheme='dark']:hover) .select,
      :host([data-color-scheme='dark']:focus) .locale-select-small,
      :host([data-color-scheme='dark']:hover) .locale-select-small {
        color: var(--theme-dark-text-color);
      }

      :host([data-color-scheme='dark']:active) .select,
      :host([data-color-scheme='dark']:active) .locale-select-small {
        color: var(--theme-dark-text-color);
      }
    `
];
tB = GTe([
  be(),
  P("jumio-sdk-locale-selection")
], tB);
var HTe = Object.defineProperty, LTe = Object.getOwnPropertyDescriptor, jK = (e) => {
  throw TypeError(e);
}, zw = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? LTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && HTe(t, r, a), a;
}, YTe = (e, t, r) => t.has(e) || jK("Cannot " + r), OTe = (e, t, r) => (YTe(e, t, "read from private field"), r ? r.call(e) : t.get(e)), jTe = (e, t, r) => t.has(e) ? jK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), rB;
let Eg = class extends N {
  constructor() {
    super(...arguments), this.type = De.Quiet, this.shape = ya.Round, jTe(this, rB, new ue(this, fw()));
  }
  render() {
    var n;
    const e = OTe(this, rB).value, t = (e == null ? void 0 : e.activeScreen) === Ot.CrossDevice;
    return ((n = this.navigationService) == null ? void 0 : n.hasHistoryItems()) || t && !Hj() ? w`
          <x-ds-button
            data-qa-id="back-button"
            data-type="${this.type}"
            data-shape="${this.shape}"
            @jclick="${() => {
      var a;
      return (a = this.navigationService) == null ? void 0 : a.back();
    }}"
          >
            <span class="icon-chevron-direction-left"></span>
          </x-ds-button>
        ` : w`<jumio-sdk-locale-selection></jumio-sdk-locale-selection>`;
  }
};
rB = /* @__PURE__ */ new WeakMap();
Eg.styles = [...N.styles];
zw([
  M({
    attribute: "data-type",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => O2(e) ? e : De.Primary,
      toAttribute: (e) => e.toString()
    }
  })
], Eg.prototype, "type", 2);
zw([
  M({
    attribute: "data-shape",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => GG(e) ? e : ya.Round,
      toAttribute: (e) => e.toString()
    }
  })
], Eg.prototype, "shape", 2);
zw([
  td({ context: zQ, subscribe: !0 })
], Eg.prototype, "navigationService", 2);
Eg = zw([
  P("jumio-sdk-navigation-button")
], Eg);
var hu, Qp, Lv;
class PTe {
  constructor(t) {
    E(this, hu);
    E(this, Qp);
    E(this, Lv);
    this.emailResponse$ = new _e(), G(this, Qp, new _e()), G(this, hu, t), G(this, Lv, Ce()), S(this, hu).addController(this);
  }
  get locale() {
    const { locale: t } = Le();
    return t;
  }
  hostConnected() {
  }
  hostDisconnected() {
    S(this, Qp).next();
  }
  sendEmail(t) {
    S(this, Lv).getEmailController().sendEmail$(t).pipe(
      Lg(() => {
        Te.clickedSendEmailButton(S(this, hu));
      }),
      ti(() => (Te.emailSentError(S(this, hu)), this.emailResponse$.next({ success: !1 }), ba)),
      le(S(this, Qp))
    ).subscribe((r) => {
      this.emailResponse$.next(r);
    });
  }
}
hu = new WeakMap(), Qp = new WeakMap(), Lv = new WeakMap();
const $Te = (e) => {
  switch (e) {
    case N_.INVALID_ADDRESS:
      return y("Invalid email address", { id: "xdevice.email.error.example" });
    case N_.OUT_OF_ATTEMPTS:
      return y("Too many email attempts", { id: "xdevice.email.error.attempt" });
    default:
      return y("Sorry, there was an unexpected error.", {
        id: "identity.preview.3dliveness.serverError.description"
      });
  }
};
var KTe = Object.defineProperty, XTe = Object.getOwnPropertyDescriptor, PK = (e) => {
  throw TypeError(e);
}, $K = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? XTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && KTe(t, r, a), a;
}, TF = (e, t, r) => t.has(e) || PK("Cannot " + r), jl = (e, t, r) => (TF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), $0 = (e, t, r) => t.has(e) ? PK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), yk = (e, t, r, n) => (TF(e, t, "write to private field"), t.set(e, r), r), wb = (e, t, r) => (TF(e, t, "access private method"), r), bf, Ab, ip, op, RF, KK, Ub, XK;
let By = class extends N {
  constructor() {
    super(), $0(this, op), this.email = "", this.inputComponent = Rt(), this.controller = new PTe(this), $0(this, bf), $0(this, Ab, !1), $0(this, ip, !1), $0(this, Ub, (e) => {
      e.code === "Enter" && this.clickHandler();
    }), yk(this, bf, new ue(this, this.controller.emailResponse$));
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("keydown", jl(this, Ub));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("keydown", jl(this, Ub));
  }
  render() {
    var a, i;
    const e = ((a = jl(this, bf).value) == null ? void 0 : a.success) ?? !1, t = (i = jl(this, bf).value) == null ? void 0 : i.rejectionCode, r = $Te(t), n = wb(this, op, RF).call(this, e);
    return w`
      <div class="container">
        <h4>${y("Send link by email", { id: "xdevice.email.title" })}</h4>
        <x-ds-input
          @input="${this.onKeyUpChange.bind(this)}"
          ${Mt(this.inputComponent)}
          data-disabled="${jl(this, ip)}"
          data-error="${n}"
          data-error-message="${n ? r : q}"
        >
          ${wb(this, op, KK).call(this, e)}
        </x-ds-input>
        <x-ds-button
          data-fluid="true"
          @click="${() => {
      this.clickHandler();
    }}"
          data-disabled="${this.isButtonDisabled()}"
        >
          <div class="button__wrapper">${wb(this, op, XK).call(this, e)}</div>
        </x-ds-button>
      </div>
    `;
  }
  onKeyUpChange(e) {
    var t, r;
    e.currentTarget === this.inputComponent.value && (yk(this, Ab, Pse((r = (t = this.inputComponent.value) == null ? void 0 : t.inputRef.value) == null ? void 0 : r.value)), this.requestUpdate());
  }
  clickHandler() {
    var t, r;
    if (this.isButtonDisabled())
      return;
    yk(this, ip, !0);
    const e = (r = (t = this.inputComponent.value) == null ? void 0 : t.inputRef.value) == null ? void 0 : r.value;
    e && this.controller.sendEmail({
      address: e,
      locale: this.controller.locale
    });
  }
  isButtonDisabled() {
    return !jl(this, Ab) || jl(this, ip);
  }
};
bf = /* @__PURE__ */ new WeakMap();
Ab = /* @__PURE__ */ new WeakMap();
ip = /* @__PURE__ */ new WeakMap();
op = /* @__PURE__ */ new WeakSet();
RF = function(e) {
  return !e && jl(this, ip);
};
KK = function(e) {
  return wb(this, op, RF).call(this, e) ? w`<span slot="post-icon" class="icon-exclamation-mark" style="font-size: 150%;"></span>` : q;
};
Ub = /* @__PURE__ */ new WeakMap();
XK = function(e) {
  return e ? w`<span class="icon-check"></span> ${y("Email is sent", {
    id: "xdevice.email.sent"
  })}` : w`${y("Send", { id: "xdevice.send.button" })}`;
};
By.styles = [
  ...N.styles,
  ee`
      .container {
        display: flex;
        flex-flow: column;
        row-gap: 1em;
        align-items: stretch;
        text-align: center;
      }

      .button__wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 0.5em;
      }
    `
];
$K([
  M({
    type: String,
    attribute: "data-email",
    reflect: !0
  })
], By.prototype, "email", 2);
By = $K([
  be(),
  P("jumio-sdk-send-link-by-email")
], By);
var zTe = Object.defineProperty, qTe = Object.getOwnPropertyDescriptor, zK = (e) => {
  throw TypeError(e);
}, eRe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? qTe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && zTe(t, r, a), a;
}, DF = (e, t, r) => t.has(e) || zK("Cannot " + r), qK = (e, t, r) => (DF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), wk = (e, t, r) => t.has(e) ? zK("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), p3 = (e, t, r, n) => (DF(e, t, "write to private field"), t.set(e, r), r), vp = (e, t, r) => (DF(e, t, "access private method"), r), kb, Wy, Qc, e6, JF, VF, t6;
let nB = class extends N {
  constructor() {
    super(), wk(this, Qc), this.controller = new ZTe(this), wk(this, kb), wk(this, Wy), p3(this, kb, new ue(this, this.controller.crossDeviceOption$)), p3(this, Wy, new ue(this, this.controller.crossDeviceUrl$));
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownCrossDeviceScreen(this), this.controller.hostConnected();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.controller.hostDisconnected();
  }
  render() {
    const e = qK(this, kb).value ?? ul.Default;
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-cross-device-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main" class="main">
          <div class="container">
            ${ke("jumio-cross-device-before")}
            ${ke(
      "jumio-cross-device-title",
      w`<h1 class="text-center">${y("Use mobile phone", { id: "xdevice.unicorn.attribute" })}</h1>`
    )}
            ${ke(
      "jumio-cross-device-subtitle",
      w`<h5 class="text-center">
                ${y("Switching to a mobile device will restart the scanning", {
        id: "xdevice.subtitle.restart"
      })}
              </h5>`
    )}
            ${vp(this, Qc, e6).call(this, e)} ${ke("jumio-cross-device-after")}
          </div>
        </div>
      </x-ds-app-container>
    `;
  }
};
kb = /* @__PURE__ */ new WeakMap();
Wy = /* @__PURE__ */ new WeakMap();
Qc = /* @__PURE__ */ new WeakSet();
e6 = function(e) {
  return w`
      <div class="grid" data-type="${e}">
        ${El(e, [
    [ul.QrOnly, () => vp(this, Qc, JF).call(this, e)],
    [ul.EmailOnly, () => vp(this, Qc, VF).call(this, e)],
    [ul.Default, () => vp(this, Qc, t6).call(this, e)]
  ])}
      </div>
    `;
};
JF = function(e) {
  return [ul.Default, ul.QrOnly].includes(e) ? w` <x-ds-scan-qr-code
          class="grid__left"
          .uri="${qK(this, Wy).value}"
        ></x-ds-scan-qr-code>` : q;
};
VF = function(e) {
  return [ul.Default, ul.EmailOnly].includes(e) ? w` <jumio-sdk-send-link-by-email class="grid__right"></jumio-sdk-send-link-by-email>` : q;
};
t6 = function(e) {
  return w`${vp(this, Qc, JF).call(this, e)}
      <div class="grid__separator">
        <div class="vertical-separator"></div>
      </div>
      ${vp(this, Qc, VF).call(this, e)}`;
};
nB.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .main {
        flex-grow: 1;
        display: flex;
      }

      .container {
        display: flex;
        flex-flow: column;
        align-items: center;
        align-self: center;
        max-width: 64em;
        margin: 0 auto;
      }

      h1 + h5 {
        margin-top: 0.5em;
      }

      h5 + .grid {
        margin-top: 2em;
      }

      .grid[data-type='default'] {
        display: grid;
        grid-template-columns: [qrcode] 1fr [separator] auto [email] 1fr [end];
      }

      .grid[data-type='email_only'] {
        display: grid;
        grid-template-columns: [email] 1fr [separator] 0 [end];
      }

      .grid[data-type='qr_only'] {
        display: grid;
        grid-template-columns: [qrcode] 1fr [separator] 0 [end];
      }

      .grid__left {
        grid-column: qrcode / separator;
      }

      .grid__separator {
        grid-column: separator / email;
      }

      .grid__right {
        grid-column: email / end;
      }

      .vertical-separator {
        width: 0.0625em;
        height: 100%;
        margin: 0 2em;
        background: var(--color-secondary4);
      }
    `
];
nB = eRe([
  be(),
  P("jumio-sdk-step-cross-device")
], nB);
var Yv, Ov, jv, aB;
class tRe {
  constructor(t) {
    E(this, jv);
    E(this, Yv);
    E(this, Ov);
    G(this, Yv, t), G(this, Ov, Ce().getConsentController()), S(this, Yv).addController(this);
  }
  hostConnected() {
  }
  isIovation() {
    return O(this, jv, aB).call(this).isIovation();
  }
  async sendTokenData(t) {
    if (!await S(this, Ov).isConsentGivenSent())
      throw new Error("sendTokenData: No consent is given!");
    await O(this, jv, aB).call(this).uploadDataAsync({
      deviceRisks: [t]
    });
  }
  goToNextStep() {
    const t = ve(), { Finish: r } = mL(oe());
    t.send({ type: r });
  }
}
Yv = new WeakMap(), Ov = new WeakMap(), jv = new WeakSet(), aB = function() {
  return Ce().getControllerById(T.Data);
};
var rRe = Object.defineProperty, nRe = Object.getOwnPropertyDescriptor, r6 = (e) => {
  throw TypeError(e);
}, aRe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? nRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && rRe(t, r, a), a;
}, n6 = (e, t, r) => t.has(e) || r6("Cannot " + r), Ak = (e, t, r) => (n6(e, t, "read from private field"), r ? r.call(e) : t.get(e)), iRe = (e, t, r) => t.has(e) ? r6("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), oRe = (e, t, r, n) => (n6(e, t, "write to private field"), t.set(e, r), r), Gh;
let g3 = class extends N {
  constructor() {
    super(...arguments), iRe(this, Gh);
  }
  get componentController() {
    return Ak(this, Gh) ?? oRe(this, Gh, new tRe(this));
  }
  connectedCallback() {
    super.connectedCallback(), this.componentController.isIovation() ? this.loadIovation() : this.goToNextStep();
  }
  render() {
    return q;
  }
  async importLoaderJs() {
    var r;
    const e = await import("./loader.BMK4_g6C.js"), t = document.createElement("script");
    t.src = e.default, (r = this.shadowRoot) == null || r.appendChild(t);
  }
  async loadIovation() {
    try {
      await this.importLoaderJs();
      const e = await new Promise((t) => {
        window.bb_callback = (r, n) => {
          n && t({ token: r, sdkType: bE.Iovation });
        };
      });
      await this.sendTokenData(e);
    } catch {
    } finally {
      this.goToNextStep();
    }
  }
  sendTokenData(e) {
    var t;
    return (t = Ak(this, Gh)) == null ? void 0 : t.sendTokenData(e);
  }
  goToNextStep() {
    var e;
    (e = Ak(this, Gh)) == null || e.goToNextStep();
  }
};
Gh = /* @__PURE__ */ new WeakMap();
g3 = aRe([
  P("jumio-sdk-step-data")
], g3);
var p2, pu, la, Jg, a6, i6;
class sRe {
  constructor(t) {
    E(this, Jg);
    E(this, p2);
    E(this, pu);
    E(this, la);
    G(this, p2, t), G(this, pu, Ce()), G(this, la, O(this, Jg, i6).call(this)), this.document$ = S(this, la).selectDocument$(), this.maxFileUploadSize$ = S(this, la).selectMaxFileUploadSize$(), this.pdfPages$ = S(this, la).selectPdfPages$(), this.pdfFiles$ = new Kt(void 0);
  }
  hostConnected() {
  }
  uploadFile(t) {
    return S(this, la).uploadDataAsync({
      uploadFilesMetadata: {
        files: [
          {
            multipartName: `${oe()}_${or.Document}`,
            fileType: OS[t.type],
            uploadType: or.Document,
            usabilityExpected: !1,
            file: t
          }
        ]
      }
    });
  }
  softDeletePdfPage(t) {
    S(this, la).softDeletePdfPage(t);
  }
  async confirmSelection() {
    await Be(S(this, la).updateMetadataWithPageSelection$());
    const t = ve(), r = Sw(oe());
    t.send({
      type: r.Finish
    });
  }
  isUploadingFiles$() {
    return S(this, la).isUploadingFiles$();
  }
  selectUploadedPdfFile() {
    return Be(S(this, la).selectUploadedPdfFile$());
  }
  getLocale() {
    return S(this, pu).getWorkflowState().locale;
  }
  getSupportedDocumentTranslationsFromSettings() {
    const t = S(this, pu).getConfiguration().getSettings(), [r] = t.supportedDocumentTypes;
    return (r == null ? void 0 : r.translations) ?? {};
  }
  async checkPdfUpload(t) {
    if (H2(t)) {
      const r = await Be(S(this, la).selectUploadedPdfFile$());
      if (O(this, Jg, a6).call(this, r))
        return this.pdfFiles$.next([
          { label: t.name, value: "new", selected: !1, file: t },
          { label: r.name, value: "old", selected: !1, file: r }
        ]), !0;
    }
    return !1;
  }
  cancelPdfSelection() {
    this.pdfFiles$.next(void 0);
  }
  async handlePdfSelection() {
    const t = await Be(this.pdfFiles$);
    if (t) {
      const r = t.find((n) => n.selected);
      r && r.value === "new" && (S(this, la).removeOldPdfPages(), this.pdfFiles$.next(void 0), await this.uploadFile(r.file));
    }
    this.pdfFiles$.next(void 0);
  }
}
p2 = new WeakMap(), pu = new WeakMap(), la = new WeakMap(), Jg = new WeakSet(), a6 = function(t) {
  return t instanceof File;
}, i6 = function() {
  return S(this, pu).getControllerById(T.Document);
};
const o6 = {
  [Ft.BC]: { label: "Upload birth certificate", id: "dv.document.title.bc" },
  [Ft.BS]: { label: "Upload bank statement", id: "dv.document.title.bs" },
  [Ft.CAAP]: { label: "Upload cash advance application", id: "dv.document.title.caap" },
  [Ft.CB]: { label: "Upload council tax bill", id: "dv.document.title.cb" },
  [Ft.CC]: { label: "Upload credit card", id: "dv.document.title.cc" },
  [Ft.CCS]: { label: "Upload credit card statement", id: "dv.document.title.ccs" },
  [Ft.CRC]: { label: "Upload corporate resolution certificate", id: "dv.document.title.crc" },
  [Ft.CUSTOM]: { label: "", id: "" },
  [Ft.HCC]: { label: "Upload health care card", id: "dv.document.title.hcc" },
  [Ft.IC]: { label: "Upload insurance card", id: "dv.document.title.ic" },
  [Ft.LAG]: { label: "Upload lease agreement", id: "dv.document.title.lag" },
  [Ft.LOAP]: { label: "Upload loan application", id: "dv.document.title.loap" },
  [Ft.MEDC]: { label: "Upload medicare card", id: "dv.document.title.medc" },
  [Ft.MOAP]: { label: "Upload mortgage application", id: "dv.document.title.moap" },
  [Ft.PB]: { label: "Upload phone bill", id: "dv.document.title.pb" },
  [Ft.SEL]: { label: "Upload school enrolment letter", id: "dv.document.title.sel" },
  [Ft.SENC]: { label: "Upload seniors card", id: "dv.document.title.senc" },
  [Ft.SS]: { label: "Upload superannuation statement", id: "dv.document.title.ss" },
  [Ft.SSC]: { label: "Upload social security card", id: "dv.document.title.ssc" },
  [Ft.STUC]: { label: "Upload student card", id: "dv.document.title.stuc" },
  [Ft.TAC]: { label: "Upload trade association card", id: "dv.document.title.tac" },
  [Ft.TR]: { label: "Upload tax return", id: "dv.document.title.tr" },
  [Ft.UB]: { label: "Upload utility bill", id: "dv.document.title.ub" },
  [Ft.USSS]: { label: "Upload social security card", id: "dv.document.title.ssc" },
  [Ft.VC]: { label: "Upload voided check", id: "dv.document.title.vc" },
  [Ft.VT]: { label: "Upload vehicle title", id: "dv.document.title.vt" },
  [Ft.WP]: { label: "Upload work permit", id: "dv.document.title.wp" },
  [Ft.WWCC]: { label: "Upload Working with Children Check", id: "dv.document.title.wwcc" }
};
var lRe = Object.defineProperty, cRe = Object.getOwnPropertyDescriptor, s6 = (e) => {
  throw TypeError(e);
}, dRe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? cRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && lRe(t, r, a), a;
}, MF = (e, t, r) => t.has(e) || s6("Cannot " + r), iB = (e, t, r) => (MF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Uk = (e, t, r) => t.has(e) ? s6("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), GF = (e, t, r, n) => (MF(e, t, "write to private field"), t.set(e, r), r), Sn = (e, t, r) => (MF(e, t, "access private method"), r), sv, lv, $r, l6, c6, d6, u6, h6, p6, g6, f6, m6, xF, HF, v6, oB;
let sB = class extends N {
  constructor() {
    super(), Uk(this, $r), Uk(this, sv, -1), Uk(this, lv, !1), this.componentController = new sRe(this), this.documentCodeController = new ue(this, this.componentController.document$), this.isUploadingController = new ue(this, this.componentController.isUploadingFiles$()), this.maxFileUploadSizeController = new ue(this, this.componentController.maxFileUploadSize$), this.pageController = new ue(this, this.componentController.pdfPages$), this.pdfFilesController = new ue(this, this.componentController.pdfFiles$);
  }
  render() {
    const e = this.pageController.value;
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-document-upload-backward-button",
      w` <jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main">
          ${ke("jumio-document-upload-before")}
          <div class="step-document-upload">
            <h1 data-qa-id="upload-title">${Sn(this, $r, d6).call(this)}</h1>
            ${Sn(this, $r, c6).call(this)}
            <x-file-multi-upload
              data-qa-id="file-multi-upload"
              data-loading="${this.isUploadingController.value}"
              .images="${e}"
              @thumbnaildeleted="${(t) => {
      e && Sn(this, $r, HF).call(this, e[t.detail].credentialFileGuid);
    }}"
              @thumbnailselected="${(t) => Sn(this, $r, xF).call(this, t.detail)}"
              @uploadupdate="${(t) => Sn(this, $r, f6).call(this, t)}"
              @startcapture="${() => {
      Sn(this, $r, oB).call(this);
    }}"
            >
              <div slot="drop-zone" class="drop-zone">
                <span class="icon icon-download"></span>
                <h3>${y("Drop image here", { id: "upload.dnd.confirm" })}</h3>
              </div>
              <div slot="empty-desktop" class="empty-desktop">
                <span class="icon icon-id-document"></span>
                <x-ds-button data-type="${De.Secondary}">
                  ${y("Click or drop a file to upload", { id: "upload.generic.button" })}
                </x-ds-button>
              </div>
              <div slot="empty-mobile" class="empty-mobile">
                <x-ds-card
                  class="card"
                  data-qa-id="id-card"
                  data-type="${Zn.Secondary}"
                  data-header="${y("Take a photo", { id: "jumio_dv_method_photo_button" })}"
                  @click="${() => {
      Sn(this, $r, oB).call(this);
    }}"
                >
                  <span slot="icon" class="icon icon-ic-method-camera"></span>
                </x-ds-card>
                <x-file-source-picker data-qa-id="file-source-picker">
                  <x-ds-card
                    class="card"
                    data-qa-id="id-card"
                    data-type="${Zn.Secondary}"
                    data-header="${y("Upload a PDF file", { id: "jumio_dv_method_upload_pdf_button" })}"
                  >
                    <span slot="icon" class="icon icon-upload-method"></span>
                  </x-ds-card>
                </x-file-source-picker>
              </div>
              <div slot="loading" class="loading">
                <x-ds-loading-indicator data-qa-id="file-upload-progress"></x-ds-loading-indicator>
                <h3>${y("Uploading", { id: "upload.title" })}</h3>
              </div>
            </x-file-multi-upload>

            <div class="step-document-upload-footer ${e != null && e.length ? "" : "no-pages"}">
              ${Sn(this, $r, l6).call(this)}
              <span></span>
              <x-ds-button
                data-disabled="${!Sn(this, $r, g6).call(this)}"
                @jclick="${async () => {
      await Sn(this, $r, v6).call(this);
    }}"
                data-fluid="true"
              >
                ${y("Continue", {
      id: "identity.guidance.cam.button"
    })}
              </x-ds-button>
            </div>

            ${ke("jumio-document-upload-after")}
          </div>
        </div>
        ${Sn(this, $r, u6).call(this)} ${Sn(this, $r, h6).call(this)} ${Sn(this, $r, p6).call(this)}
      </x-ds-app-container>
    `;
  }
};
sv = /* @__PURE__ */ new WeakMap();
lv = /* @__PURE__ */ new WeakMap();
$r = /* @__PURE__ */ new WeakSet();
l6 = function() {
  var t;
  const e = (t = this.pageController.value) == null ? void 0 : t.length;
  return e === 1 ? w`
        <p data-qa-id="paging">
          ${y("1 page uploaded", {
    id: "dv.preview.page1"
  })}
        </p>
      ` : w`
      <p data-qa-id="paging">
        ${Rc(
    y("{{pageCount}} pages uploaded", {
      id: "dv.preview.pages"
    })
  )({ pageCount: e })}
      </p>
    `;
};
c6 = function() {
  var e;
  return w`
      <p class="upload-instructions">
        ${Rc(
    y(
      "Upload a color image of the whole document. Max. size: {{pageLimit}} images or {{uploadFileSizeMax}} MB.",
      {
        id: "dv.upload.guideline4"
      }
    )
  )({
    pageLimit: (e = this.documentCodeController.value) == null ? void 0 : e.maxPages,
    uploadFileSizeMax: XW(this.maxFileUploadSizeController.value || 0)
  })}
      </p>
    `;
};
d6 = function() {
  const e = this.documentCodeController.value ? o6[this.documentCodeController.value.code] : void 0;
  if (e)
    return y(e.label, { id: e.id });
  const t = JO(
    this.componentController.getLocale(),
    this.componentController.getSupportedDocumentTranslationsFromSettings()
  );
  return Rc(vG(y("Upload your {{customTitle}}", { id: "dv.upload.title" })))({
    customTitle: t ?? ""
  });
};
u6 = function() {
  return iB(this, sv) !== -1 ? w`
          <div slot="overlay" class="overlay">
            <x-ds-image-viewer
              @imageviewertoggle="${async () => {
    await Sn(this, $r, xF).call(this, -1);
  }}"
              @imageviewerremove="${(e) => {
    Sn(this, $r, HF).call(this, e.detail.name);
  }}"
              data-index="${iB(this, sv)}"
            >
              ${(this.pageController.value ?? []).map((e) => w`<img
                  slot="image"
                  src="${e.base64}"
                  alt="${e.filename}"
                  data-id="${e.credentialFileGuid}"
                />`)}
            </x-ds-image-viewer>
          </div>
        ` : q;
};
h6 = function() {
  return iB(this, lv) ? w`
          <x-ds-modal slot="overlay" class="overlay">
            <x-ds-error-message
              data-title="${y("Upload error", { id: "error.9300.title" })}"
              data-message="${y("Sorry, this file type is not supported.", {
    id: "notify.file-type.header"
  })}"
              data-show-date="false"
            >
              <x-ds-button
                slot="button"
                data-fluid="true"
                @jclick="${async () => {
    GF(this, lv, !1), this.requestUpdate(), await this.updateComplete;
  }}"
                >${y("Try again", {
    id: "notify.button.close"
  })}
              </x-ds-button>
            </x-ds-error-message>
          </x-ds-modal>
        ` : q;
};
p6 = function() {
  var e;
  return (e = this.pdfFilesController.value) != null && e.length ? w` <x-ds-modal slot="overlay" class="overlay">
          <div>
            <h1>${y("Select a PDF file", { id: "dialog.document.single_pdf.header" })}</h1>
            <p>
              ${y("Only one PDF file can be uploaded. Please select one.", {
    id: "dialog.document.single_pdf.description"
  })}
            </p>
            <div class="pdf-selector-content">
              <x-ds-radio-list
                .items="${this.pdfFilesController.value}"
                @radiolistselection="${async () => {
    this.requestUpdate(), await this.updateComplete;
  }}"
              ></x-ds-radio-list>
              <div class="pdf-selector-buttons">
                <x-ds-button
                  data-type="${De.Primary}"
                  data-fluid="true"
                  data-disabled="${!this.pdfFilesController.value.find((t) => t.selected)}"
                  @jclick="${async () => {
    await this.componentController.handlePdfSelection();
  }}"
                  >${y("Select", { id: "dialog.document.single_pdf.select" })}
                </x-ds-button>
                <x-ds-button
                  data-type="${De.Secondary}"
                  data-fluid="true"
                  @jclick="${() => {
    this.componentController.cancelPdfSelection();
  }}"
                  >${y("Close", { id: "dialog.document.single_pdf.cancel" })}
                </x-ds-button>
              </div>
            </div>
          </div>
        </x-ds-modal>` : q;
};
g6 = function() {
  var t;
  const e = this.pageController.value;
  if (e) {
    const r = !!e.length && e.every((i) => i.base64), n = e.filter((i) => i.selected).length || 0, a = ((t = this.documentCodeController.value) == null ? void 0 : t.maxPages) || Number.MAX_VALUE;
    return r && n > 0 && n <= a;
  }
  return !1;
};
f6 = async function(e) {
  await this.componentController.checkPdfUpload(e.detail) || await Sn(this, $r, m6).call(this, e.detail);
};
m6 = async function(e) {
  try {
    await this.componentController.uploadFile(e);
  } catch (t) {
    GF(this, lv, !!t);
  } finally {
    this.requestUpdate(), await this.updateComplete;
  }
};
xF = async function(e) {
  GF(this, sv, e), this.requestUpdate(), await this.updateComplete;
};
HF = function(e) {
  this.componentController.softDeletePdfPage(e);
};
v6 = async function() {
  await this.componentController.confirmSelection();
};
oB = function() {
  const e = ve(), t = Sw(oe());
  e.send({
    type: t.MobileCapture
  });
};
sB.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .step-document-upload {
        max-width: 64em;
        margin: 0 auto;
      }

      .step-document-upload-footer {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        margin-top: 1.5em;

        @media (max-width: 32em) {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0;
        }
      }

      .empty-desktop,
      .drop-zone,
      .loading {
        display: flex;
        flex-direction: column;
        gap: 1em;
        align-items: center;
        justify-content: center;
        padding: 7em 0;
        width: 100%;
      }

      .empty-desktop .icon {
        font-size: 7.5em;
        color: var(--color-secondary7);
      }

      .drop-zone .icon {
        font-size: 7.5em;
        color: var(--color-primary3);
      }

      :host([data-color-scheme='light']) .empty-desktop .icon {
        color: var(--color-secondary7);
      }

      :host([data-color-scheme='dark']) .empty-desktop .icon {
        color: var(--theme-dark-text-color);
      }

      .empty-mobile {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.5em;
        width: 100%;
      }

      .empty-mobile .icon {
        font-size: 2.5em;
      }

      .overlay {
        pointer-events: unset;
      }

      .pdf-selector-content {
        display: flex;
        flex-direction: column;
        margin: 1.5em 0;
        gap: 1.5em;
      }

      .pdf-selector-buttons {
        display: flex;
        flex-direction: column;
        gap: 1em;
      }

      .no-pages {
        @media (max-width: 32em) {
          display: none;
        }
      }
    `
];
sB = dRe([
  be(),
  P("jumio-sdk-step-document-upload")
], sB);
var uRe = Object.defineProperty, hRe = Object.getOwnPropertyDescriptor, S6 = (e) => {
  throw TypeError(e);
}, I6 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? hRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && uRe(t, r, a), a;
}, LF = (e, t, r) => t.has(e) || S6("Cannot " + r), pRe = (e, t, r) => (LF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), f3 = (e, t, r) => t.has(e) ? S6("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), gRe = (e, t, r, n) => (LF(e, t, "write to private field"), t.set(e, r), r), m3 = (e, t, r) => (LF(e, t, "access private method"), r), _b, Nb, C6, b6;
let Ey = class extends N {
  constructor() {
    super(), f3(this, Nb), f3(this, _b), gRe(this, _b, new ue(this, ur()));
  }
  get workflowStepController() {
    return Ce().getControllerById(T.Document);
  }
  render() {
    switch (pRe(this, _b).value) {
      case Cn.UploadScreen:
        return m3(this, Nb, C6).call(this);
      case Cn.MobileCapture:
        return m3(this, Nb, b6).call(this);
      default:
        return q;
    }
  }
};
_b = /* @__PURE__ */ new WeakMap();
Nb = /* @__PURE__ */ new WeakSet();
C6 = function() {
  return w`<jumio-sdk-step-document-upload data-qa-id="document-upload"></jumio-sdk-step-document-upload>`;
};
b6 = function() {
  return w`<jumio-sdk-step-document-capture data-qa-id="document-capture"></jumio-sdk-step-document-capture>`;
};
Ey.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
I6([
  ka({ context: gke }),
  Xn()
], Ey.prototype, "workflowStepController", 1);
Ey = I6([
  be(),
  P("jumio-sdk-step-document")
], Ey);
var g2, Pv, $v, Fp, Tc, y6, Zb;
class fRe {
  constructor(t) {
    E(this, Tc);
    E(this, g2);
    E(this, Pv);
    E(this, $v);
    E(this, Fp);
    G(this, g2, t), G(this, Pv, Ce()), G(this, $v, S(this, Pv).getControllerById(T.Facemap)), G(this, Fp, new _e()), t.addController(this);
  }
  hostConnected() {
    this.getStepChange$().pipe(le(S(this, Fp))).subscribe();
  }
  hostDisconnected() {
    S(this, Fp).next();
  }
  selectVerificationMethods$() {
    return S(this, $v).selectVerificationMethods$();
  }
  selectActiveVerificationMethod$() {
    return O(this, Tc, Zb).call(this).selectActiveFaceVerificationMethod$();
  }
  selectFacemapStepInformation$() {
    return ur();
  }
  getStepChange$() {
    return this.selectFacemapStepInformation$().pipe(
      go(this.selectVerificationMethods$(), this.selectActiveVerificationMethod$()),
      ae(([t, r, n]) => {
        switch (t) {
          case x.Start: {
            this.decideOnVerificationMethod();
            return;
          }
          case x.VerificationMethodFailed: {
            this.handleVerificationMethodFailed(r, n);
            return;
          }
          case x.NoVerificationMethodsLeft: {
            this.handleNoVerificationMethodsLeft();
            return;
          }
        }
      })
    );
  }
  handleVerificationMethodFailed(t, r) {
    const n = ve(), a = Tt(oe()), i = O(this, Tc, y6).call(this, t, r);
    if (i) {
      O(this, Tc, Zb).call(this).setActiveFaceVerificationMethod(i), n.send({
        type: a.Start
      });
      return;
    }
    n.send({
      type: a.NoVerificationMethodsLeft
    });
  }
  handleNoVerificationMethodsLeft() {
    const t = ve(), r = Tt(oe());
    t.send({
      type: r.IdentityFailureNoAttemptsLeft
    });
  }
  decideOnVerificationMethod() {
    const t = ve(), r = Tt(oe());
    switch (O(this, Tc, Zb).call(this).getActiveFaceVerificationMethod()) {
      case ei.IproovStandard:
      case ei.IproovPremium:
        t.send({
          type: r.Iproov
        });
        break;
      default:
        t.send({
          type: r.JumioStandard
        });
    }
  }
}
g2 = new WeakMap(), Pv = new WeakMap(), $v = new WeakMap(), Fp = new WeakMap(), Tc = new WeakSet(), y6 = function(t, r) {
  const n = t.findIndex((i) => i === r), a = n + 1;
  return n !== -1 && a < t.length ? t[a] : void 0;
}, Zb = function() {
  return Ce().getControllerById(T.Facemap);
};
const YF = mo(
  { name: "usedCaptureTypes" },
  Wl({
    livenessCaptureType: void 0,
    idCaptureType: void 0,
    usedAllCaptureTypes: []
  })
), mRe = (e) => {
  YF.update(({ usedAllCaptureTypes: t, ...r }) => ({
    ...r,
    idCaptureType: e,
    usedAllCaptureTypes: [...t, e]
  }));
}, vRe = (e) => {
  YF.update(({ usedAllCaptureTypes: t, ...r }) => ({
    ...r,
    livenessCaptureType: e,
    usedAllCaptureTypes: [...t, e]
  }));
}, SRe = () => YF.getValue(), IRe = (e) => Object.values(vpe).includes(e), rI = (e) => {
  if (IRe(e)) {
    mRe(e);
    return;
  }
  vRe(e);
};
var f2, Kv, Ya, Xv, hn, lB, w6, A6, U6, k6, _6, N6;
class CRe {
  constructor(t) {
    E(this, hn);
    E(this, f2);
    E(this, Kv);
    E(this, Ya);
    E(this, Xv, new _e());
    G(this, f2, t), G(this, Kv, Ce()), G(this, Ya, O(this, hn, N6).call(this)), this.iProovTokenState$ = O(this, hn, k6).call(this), t.addController(this);
  }
  hostConnected() {
    S(this, Ya).patchIproovTokenState({
      iproovStatus: _i.Pending,
      iproovTokenData: void 0,
      iproovError: void 0,
      iproovReady: !1,
      iproovLatestOutcome: "none"
    }), O(this, hn, A6).call(this).pipe(le(S(this, Xv))).subscribe(), this.fetchToken();
  }
  hostDisconnected() {
    S(this, Xv).next();
  }
  async fetchToken() {
    return S(this, Ya).fetchIproovTokenAsync();
  }
  handleSystemError({ event: t, token: r }) {
    const n = ve(), a = Tt(oe());
    mt.closeActiveClosableMessageById(ct.UsabilityCheck), S(this, Ya).patchIproovTokenState({ iproovLatestOutcome: t.type }), r && r.remainingAttempts > 0 && n.send({ type: a.IproovFailureSystem });
  }
  async handleFailedAttempt({ event: t, token: r }) {
    const n = ve(), a = Tt(oe());
    O(this, hn, lB).call(this, r == null ? void 0 : r.productType), mt.closeActiveClosableMessageById(ct.UsabilityCheck), S(this, Ya).patchIproovTokenState({ iproovLatestOutcome: t.type }), (r == null ? void 0 : r.remainingAttempts) === 0 && (t.type === "failed" && await S(this, Ya).validateIproovTokenAsync({
      token: r.token
    }), n.send({
      type: a.IproovFailureUser
    }));
  }
  async handleIproovSuccess({ token: t }) {
    const r = ve(), n = Tt(oe());
    O(this, hn, lB).call(this, t == null ? void 0 : t.productType), S(this, Ya).patchIproovTokenState({
      iproovLatestOutcome: "success"
    }), await S(this, Ya).validateIproovTokenAsync({
      token: (t == null ? void 0 : t.token) ?? ""
    }), mt.closeActiveClosableMessageById(ct.UsabilityCheck), r.send({
      type: n.IproovFinish
    });
  }
  handleReady(t) {
    t && S(this, Ya).patchIproovTokenState({
      iproovReady: !0
    });
  }
  handleProgress({ event: t }) {
    O(this, hn, U6).call(this, t) && t.detail.progress >= 90 && mt.showMessageIfPossible({
      type: Fr.Progress,
      id: ct.UsabilityCheck,
      title: y("Analyzing biometric data", { id: "identity.iproov.progress" }),
      message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
      overlay: !0,
      closable: !0
    });
  }
}
f2 = new WeakMap(), Kv = new WeakMap(), Ya = new WeakMap(), Xv = new WeakMap(), hn = new WeakSet(), lB = function(t) {
  const r = O(this, hn, w6).call(this, t) ? "IPROOV_PREMIUM" : "IPROOV_STANDARD";
  rI(r);
}, w6 = function(t) {
  return t === ei.IproovPremium;
}, A6 = function() {
  return ur().pipe(
    ae((t) => {
      const r = ve(), n = Tt(oe());
      switch (t) {
        case x.IproovFinish:
          r.send({
            type: n.Finish
          });
      }
    })
  );
}, U6 = function(t) {
  return t instanceof CustomEvent && Ut(t.detail, ["progress"]);
}, k6 = function() {
  return S(this, Ya).selectIproovTokenState$().pipe(
    ae((t) => {
      switch (t.iproovStatus) {
        case _i.Error:
          O(this, hn, _6).call(this, t);
          break;
      }
    })
  );
}, _6 = function(t) {
  if (mt.closeActiveClosableMessageById(ct.UsabilityCheck), t.iproovStatus === _i.Error) {
    const r = ve(), n = Tt(oe());
    r.send({
      type: n.IproovFailureSystem
    });
  }
}, N6 = function() {
  return S(this, Kv).getControllerById(T.Facemap);
};
const bRe = `:host{display:contents}.container{max-width:32em;margin:0 auto}.container__inner{display:flex;position:relative;height:auto;flex-flow:column nowrap;gap:1em;align-items:center;padding-bottom:1em}.illustration{width:8em;height:10em;background:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='128'%20height='160'%20mask-type='alpha'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080-63.555%2080S0%20124.183%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cpath%20fill-rule='evenodd'%20d='M50.595%20125.351l-.287%204.301c-.257%203.849-.94%207.787-3.22%2010.9-.88%201.202-1.852%202.141-2.74%202.141-1.086%200%20.28%203.112.28%203.112s6.465%203.685%2019.501%203.685%2019.728-3.403%2019.728-3.403%201.042-1.866-1.477-3.394-3.041-4.335-3.041-4.335l-.341-1.599a32.97%2032.97%200%200%201-.656-4.721l-.44-6.687H50.595z'%20fill='%23dfe5ec'/%3e%3cpath%20opacity='.402'%20fill-rule='evenodd'%20d='M50.513%20129.652l.287-4.301h6.935%2020.373l.44%206.687a32.97%2032.97%200%200%200%20.656%204.721l.341%201.599s.483%202.595%202.759%204.153c-.823.207-2.085.192-2.748.185l-.262-.003c-17.205%200-22.484-5.756-25.607-9.162-1.233-1.345-2.13-2.323-3.293-2.436.048-.481.086-.963.119-1.443z'%20fill='%239aa4af'/%3e%3cpath%20d='M98.238%2081.903c0%205.997-1.297%2015.871%203.609%2015.871s14.16-9.874%2014.16-15.871-3.978-10.86-8.885-10.86-8.884%204.862-8.884%2010.86zm-67.345%200c0%205.997%201.297%2015.871-3.609%2015.871s-14.16-9.874-14.16-15.871%203.978-10.86%208.885-10.86%208.885%204.862%208.885%2010.86z'%20fill='%23dfe5ec'/%3e%3cpath%20d='M100.009%2082.407c0%204.123-.884%2010.912%202.46%2010.912s9.651-6.788%209.651-10.912-2.711-7.466-6.055-7.466-6.056%203.343-6.056%207.466zm-70.887%200c0%204.123.884%2010.912-2.46%2010.912s-9.651-6.788-9.651-10.912%202.711-7.466%206.055-7.466%206.055%203.343%206.055%207.466z'%20fill='%23c6cdd5'/%3e%3cpath%20fill-rule='evenodd'%20d='M64.488%2023.15c22.541%200%2040.813%2016.017%2040.813%2035.775v11.005h-.097v5.874c0%20.217.01.579.024%201.07.184%206.58%201.012%2036.173-13.378%2045.481-9.152%205.919-11.972%207.117-13.478%207.756-1.038.441-1.452.617-2.886%201.893-2.907%202.585-4.794%202.563-8.955%202.515l-1.995-.015-1.995.015c-4.139.048-5.953.069-8.859-2.515-1.42-1.263-1.871-1.448-2.925-1.88-1.554-.636-4.418-1.809-13.633-7.769-14.39-9.308-13.562-38.902-13.378-45.481l.024-1.07v-5.874h-.097V58.925c0-19.758%2018.273-35.774%2040.813-35.774z'%20fill='%23dfe5ec'/%3e%3cpath%20fill-rule='evenodd'%20d='M124.764%20172.959H.723c.114-25.609%2024.066-27.457%2045.307-31.164%202.372%203.283%2012.769%205.555%2018.701%205.555%206.037%200%2013.78-2.353%2016.095-5.729%2021.712%203.497%2043.901%205.729%2043.938%2031.338z'%20fill='%23757f8a'/%3e%3c/g%3e%3cpath%20fill-rule='evenodd'%20d='M4.915%2053.215a.95.95%200%200%201-.913-1.217C9.86%2032.268%2021.728%2016.229%2036.803%207.412c.642-.375%201.437.094%201.437.838h0c0%20.351-.188.674-.491.851C23.163%2017.644%2011.57%2033.21%205.838%2052.522c-.121.409-.496.693-.923.693h0zm.106%2053.925a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.464%2032.694%2044.228.642.376%201.437-.094%201.437-.837h0a.99.99%200%200%200-.491-.852c-14.498-8.491-26.038-23.92-31.806-43.07-.123-.408-.497-.689-.922-.689h0zm117.069%200c-.425%200-.799.281-.922.689-5.767%2019.15-17.308%2034.579-31.806%2043.07a.99.99%200%200%200-.49.852h0c0%20.743.795%201.213%201.437.837%2014.984-8.764%2026.8-24.662%2032.694-44.228a.95.95%200%200%200-.912-1.22h0zm.106-53.925a.95.95%200%200%200%20.913-1.217c-5.857-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838h0c0%20.351.188.674.49.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.122.409.497.693.923.693h0z'%20fill='%233e4753'/%3e%3c/svg%3e") center center no-repeat;background-size:contain}.text-center{text-align:center}p{margin:0}.iproov{display:block;width:100%;max-width:32em;text-align:center}.btn-transparent{font:inherit;color:inherit;background:transparent;outline:none;border:none}.button-container{display:flex;position:sticky;bottom:0;width:100%;max-width:32em;flex-direction:column;min-height:3.25em;align-items:center;justify-content:center;padding-top:1em;padding-bottom:1em;margin-top:-1em;margin-bottom:-1em}:host([data-color-scheme="light"]) .button-container{background:var(--theme-light-app-container-bg-color)}:host([data-color-scheme="dark"]) .button-container{background:var(--theme-dark-app-container-bg-color)}`, yRe = () => ({
  camera_next_button_aria: y("Switch to next camera", { id: "iproov_camera_next_button_aria" }),
  canceled_user: y("The user has intentionally exited the application", { id: "iproov_canceled_user" }),
  client_camera: y("There was an error getting video from the camera", { id: "iproov_client_camera" }),
  close_button_aria: y("Close", { id: "iproov_close_button_aria" }),
  error: y("Error", { id: "iproov_error" }),
  error_asset_fetch: y("Transaction setup problem", { id: "iproov_error_asset_fetch" }),
  error_asset_fetch_message: y(
    "We had a network problem setting up this transaction; please check your device connection and try again.",
    { id: "iproov_error_asset_fetch_message" }
  ),
  error_camera: y("There was a problem accessing your camera", { id: "iproov_error_camera" }),
  error_camera_in_use: y("Your camera is already in use", { id: "iproov_error_camera_in_use" }),
  error_camera_in_use_message: y("Please try closing other applications using the camera and try again.", {
    id: "iproov_error_camera_in_use_message"
  }),
  error_camera_message: y(
    "We encountered an unknown camera error. Please try closing other applications using the camera and try again.",
    { id: "iproov_error_camera_message" }
  ),
  error_camera_not_supported: y("The camera you are using isn't supported", {
    id: "iproov_error_camera_not_supported"
  }),
  error_camera_not_supported_message: y("We couldn't request a high enough quality video from your camera.", {
    id: "iproov_error_camera_not_supported_message"
  }),
  error_camera_permission_denied: y("Permission to access the camera has been denied", {
    id: "iproov_error_camera_permission_denied"
  }),
  error_camera_permission_denied_message: y(
    "Please allow camera access, then reload the page for the settings to take effect.",
    { id: "iproov_error_camera_permission_denied_message" }
  ),
  error_client: y("An unknown error occurred", { id: "iproov_error_client" }),
  error_device_motion_denied: y("Device motion permission denied", {
    id: "iproov_error_device_motion_denied"
  }),
  error_device_motion_denied_message: y(
    "Permission to access device motion has been denied. Please allow device motion access to use iProov. You may need to reload the page or reopen the tab.",
    { id: "iproov_error_device_motion_denied_message" }
  ),
  error_device_motion_unsupported: y("Your device does not seem to fully report device motion", {
    id: "iproov_error_device_motion_unsupported"
  }),
  error_device_motion_unsupported_message: y(
    "Some devices do not support device motion, please try using another device.",
    { id: "iproov_error_device_motion_unsupported_message" }
  ),
  error_fullscreen_change: y("Canceled", { id: "iproov_error_fullscreen_change" }),
  error_fullscreen_change_message: y("Exited full-screen without completing iProov, please try again.", {
    id: "iproov_error_fullscreen_change_message"
  }),
  error_integration_unloaded: y("The iProov integration has been unloaded from the page", {
    id: "iproov_error_integration_unloaded"
  }),
  error_invalid_token: y("Your token is invalid", { id: "iproov_error_invalid_token" }),
  error_invalid_token_message: y(
    "This usually happens when your iProov configuration isn't correct. Please check and try again.",
    { id: "iproov_error_invalid_token_message" }
  ),
  error_network: y("Network error", { id: "iproov_error_network" }),
  error_no_camera: y("We couldn't find a camera connected to your device", {
    id: "iproov_error_no_camera"
  }),
  error_no_camera_message: y("A camera must be available to use iProov.", {
    id: "iproov_error_no_camera_message"
  }),
  error_no_face_found: y("No face could be found", { id: "iproov_error_no_face_found" }),
  error_no_face_found_message: y("Please ensure your camera is front facing and is not covered or blocked.", {
    id: "iproov_error_no_face_found_message"
  }),
  error_not_supported: y("Device is not supported", { id: "iproov_error_not_supported" }),
  error_not_supported_message: y(
    "We can't access your device's sensors to iProov you. Please check your device and settings before trying again.",
    { id: "iproov_error_not_supported_message" }
  ),
  error_server: y("Server error", { id: "iproov_error_server" }),
  error_server_message: y("Sorry, but there was an error with the service. Please try again.", {
    id: "iproov_error_server_message"
  }),
  error_token_timeout: y("Your session did not start in time", { id: "iproov_error_token_timeout" }),
  error_token_timeout_message: y("This normally happens if your session didn't start in time. Please try again.", {
    id: "iproov_error_token_timeout_message"
  }),
  error_too_many_requests: y("Please try again later", { id: "iproov_error_too_many_requests" }),
  error_too_many_requests_message: y(
    "Sorry, this service is exceptionally busy right now; please try again later.",
    { id: "iproov_error_too_many_requests_message" }
  ),
  error_transaction_canceled: y("This transaction has been canceled", {
    id: "iproov_error_transaction_canceled"
  }),
  error_user_timeout: y("Try again", { id: "iproov_error_user_timeout" }),
  failed: y("Failed", { id: "iproov_failed" }),
  failure_eyes_closed: y("Keep your eyes open", { id: "iproov_failure_eyes_closed" }),
  failure_face_too_close: y("Move your face farther from the screen", {
    id: "jumio_liveness_prompt_move_away"
  }),
  failure_face_too_far: y("Move your face closer to the screen", { id: "iproov_failure_face_too_far" }),
  failure_misaligned_face: y("Keep your face in the oval", { id: "iproov_failure_misaligned_face" }),
  failure_multiple_faces: y("Ensure only one person is visible", { id: "iproov_failure_multiple_faces" }),
  failure_network_problem: y("Sorry, network problem", { id: "iproov_failure_network_problem" }),
  failure_obscured_face: y("Remove any face coverings", { id: "iproov_failure_obscured_face" }),
  failure_sunglasses: y("Remove sunglasses", { id: "iproov_failure_sunglasses" }),
  failure_too_bright: y("Move somewhere darker", { id: "iproov_failure_too_bright" }),
  failure_too_dark: y("Move somewhere brighter", { id: "iproov_failure_too_dark" }),
  failure_too_much_movement: y("Keep still", { id: "iproov_failure_too_much_movement" }),
  failure_unknown: y("Try again", { id: "iproov_failure_unknown" }),
  iproov_ready_button: y("Scan face", { id: "iproov_iproov_ready_button" }),
  iproov_ready_title: y("Ready to iProov", { id: "iproov_iproov_ready_title" }),
  iproov_success: y("You have iProoved successfully", { id: "iproov_iproov_success" }),
  label_camera_selector: y("Choose camera:", { id: "iproov_label_camera_selector" }),
  label_secured_by_iproov_aria: y("Secured by iProov", { id: "iproov_label_secured_by_iproov_aria" }),
  language_file: y("en", { id: "iproov_language_file" }),
  logo_aria: y("Logo", { id: "iproov_logo_aria" }),
  passed: y("Passed", { id: "iproov_passed" }),
  progress_assessing_genuine_presence: y("Assessing genuine presence…", {
    id: "iproov_progress_assessing_genuine_presence"
  }),
  progress_assessing_liveness: y("Assessing liveness…", { id: "iproov_progress_assessing_liveness" }),
  progress_confirming_identity: y("Confirming identity…", { id: "iproov_progress_confirming_identity" }),
  progress_creating_identity: y("Creating identity…", { id: "iproov_progress_creating_identity" }),
  progress_finding_face: y("Finding face…", { id: "iproov_progress_finding_face" }),
  progress_identifying_face: y("Identifying face…", { id: "iproov_progress_identifying_face" }),
  progress_loading: y("Loading…", { id: "iproov_progress_loading" }),
  progress_streaming: y("Streaming…", { id: "iproov_progress_streaming" }),
  prompt_align_face_accessibility: y("Hold the device in front of your face and look at the screen", {
    id: "iproov_prompt_align_face_accessibility"
  }),
  prompt_align_face_accessibility_desktop: y("Put your face in front of the camera and look forwards", {
    id: "iproov_prompt_align_face_accessibility_desktop"
  }),
  prompt_connecting: y("Connecting…", { id: "iproov_prompt_connecting" }),
  prompt_genuine_presence_align_face: y("Put your face in the oval", {
    id: "iproov_prompt_genuine_presence_align_face"
  }),
  prompt_get_ready: y("Get ready…", { id: "iproov_prompt_get_ready" }),
  prompt_grant_permission: y("Grant Permissions", { id: "jumio_grant_permission_iproov" }),
  prompt_grant_button: y("Grant Permissions", { id: "jumio_grant_permission_iproov" }),
  prompt_grant_permission_message: y("Device permissions must be granted", {
    id: "jumio_prompt_grant_permission_message"
  }),
  prompt_kiosk_align_face: y("Put your face in the oval", { id: "iproov_prompt_kiosk_align_face" }),
  prompt_kiosk_keep_still: y("Keep still", { id: "iproov_prompt_kiosk_keep_still" }),
  prompt_liveness_align_face: y("Put your face in the oval", { id: "iproov_prompt_liveness_align_face" }),
  prompt_liveness_no_target: y("Put your face in the oval", { id: "iproov_prompt_liveness_no_target" }),
  prompt_liveness_scan_completed: y("Scan completed", { id: "iproov_prompt_liveness_scan_completed" }),
  prompt_loading: y("Please wait", { id: "notify.wait.header" }),
  prompt_rotate_portrait: y("Please rotate your device to portrait", {
    id: "iproov_prompt_rotate_portrait"
  }),
  prompt_rotate_portrait_short: y("Rotate to portrait", { id: "iproov_prompt_rotate_portrait_short" }),
  prompt_scanning: y("Scanning", { id: "iproov_prompt_scanning" }),
  prompt_too_close: y("Move away", { id: "jumio_liveness_prompt_move_away" }),
  prompt_too_far: y("Move closer", { id: "iproov_prompt_too_far" }),
  prompt_too_high: y("Move down", { id: "iproov_prompt_too_high" }),
  prompt_too_left: y("Move right", { id: "iproov_prompt_too_left" }),
  prompt_too_low: y("Move up", { id: "iproov_prompt_too_low" }),
  prompt_too_right: y("Move left", { id: "iproov_prompt_too_right" })
});
var wRe = Object.defineProperty, ARe = Object.getOwnPropertyDescriptor, Z6 = (e) => {
  throw TypeError(e);
}, URe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ARe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && wRe(t, r, a), a;
}, OF = (e, t, r) => t.has(e) || Z6("Cannot " + r), Ds = (e, t, r) => (OF(e, t, "read from private field"), r ? r.call(e) : t.get(e)), K0 = (e, t, r) => t.has(e) ? Z6("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), cB = (e, t, r, n) => (OF(e, t, "write to private field"), t.set(e, r), r), Pa = (e, t, r) => (OF(e, t, "access private method"), r), Bb, nc, jF, cv, Hn, B6, W6, E6, Q6, F6, T6, dB, R6, D6, J6, V6, M6;
let uB = class extends N {
  constructor() {
    super(...arguments), K0(this, Hn), K0(this, Bb), K0(this, nc, new ue(this, this.componentController.iProovTokenState$)), K0(this, jF, Rt()), K0(this, cv, !0);
  }
  connectedCallback() {
    super.connectedCallback(), Pa(this, Hn, M6).call(this);
  }
  get componentController() {
    return Ds(this, Bb) ?? cB(this, Bb, new CRe(this));
  }
  render() {
    return w`
      <x-ds-app-container data-footer-visible="false">
        ${ke(
      "jumio-biometric-guidance-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main" class="container">
          <div class="container__inner">
            ${ke("jumio-biometric-guidance-before")} ${Pa(this, Hn, B6).call(this)}
            ${ke("jumio-biometric-guidance-after")} ${Pa(this, Hn, T6).call(this)}
            ${Pa(this, Hn, D6).call(this)}
          </div>
        </div>
      </x-ds-app-container>
    `;
  }
};
Bb = /* @__PURE__ */ new WeakMap();
nc = /* @__PURE__ */ new WeakMap();
jF = /* @__PURE__ */ new WeakMap();
cv = /* @__PURE__ */ new WeakMap();
Hn = /* @__PURE__ */ new WeakSet();
B6 = function() {
  const e = document.querySelector("template#face_liveness-introduction_guidance");
  return ke(
    "jumio-biometric-guidance",
    e ? w`${Ea(e)}` : w`${Pa(this, Hn, W6).call(this)}${Pa(this, Hn, E6).call(this)}${Pa(this, Hn, Q6).call(this)}${Pa(this, Hn, F6).call(this)}`
  );
};
W6 = function() {
  const e = document.querySelector("template#face_liveness-introduction_title");
  return ke(
    "jumio-biometric-guidance-title",
    e ? w`${Ea(e)}` : w`<h1 data-qa-id="title">${y("Face Verification", { id: "jumio_identity_title" })}</h1>`
  );
};
E6 = function() {
  const e = document.querySelector("template#face_liveness-introduction_explanation");
  return ke(
    "jumio-biometric-guidance-explanation",
    e ? w`${Ea(e)}` : w`
            <p data-qa-id="explanation">
              ${y("We need to take a scan of your face to verify that you are a real person.", {
      id: "jlive_desc_1"
    })}
            </p>
          `
  );
};
Q6 = function() {
  const e = document.querySelector("template#face_liveness-introduction_face-image");
  return ke(
    "jumio-biometric-guidance-illustration",
    e ? w`${Ea(e)}` : w`<div class="illustration" data-qa-id="face-image"></div>`
  );
};
F6 = function() {
  const e = document.querySelector("template#face_liveness-introduction_checklist");
  return ke(
    "jumio-biometric-guidance-checklist",
    e ? w`${Ea(e)}` : w`
            <x-ds-shield-list data-qa-id="checklist">
              <x-ds-shield-list-item slot="item">
                ${y("Your face must be evenly lit and stand out from the background.", {
      id: "identity.iproov.preview.lighting"
    })}
              </x-ds-shield-list-item>
              <x-ds-shield-list-item slot="item">
                ${y("Look straight into the camera", { id: "jumio_liveness_prompt_look_straight_into_the_camera" })}
              </x-ds-shield-list-item>
            </x-ds-shield-list>
          `
  );
};
T6 = function() {
  var t, r, n, a, i;
  const e = ((t = Ds(this, nc).value) == null ? void 0 : t.iproovStatus) === _i.Success && Pa(this, Hn, R6).call(this, (r = Ds(this, nc).value) == null ? void 0 : r.iproovTokenData) ? (n = Ds(this, nc).value) == null ? void 0 : n.iproovTokenData : void 0;
  if (Ds(this, cv))
    return Pa(this, Hn, dB).call(this);
  switch ((a = Ds(this, nc).value) == null ? void 0 : a.iproovStatus) {
    case _i.Idle:
    case _i.Pending:
      return Pa(this, Hn, dB).call(this);
    case _i.Success:
      const o = !!((i = Ds(this, nc).value) != null && i.iproovReady);
      return w`
          <div class="button-container">
            <iproov-me
              ${Mt(Ds(this, jF))}
              class="${tn({
        iproov: !0,
        hidden: !o
      })}"
              token="${e == null ? void 0 : e.token}"
              filter="${Pa(this, Hn, J6).call(this)}"
              data-qa-id="iproov"
              allow_landscape="true"
              base_url="${e == null ? void 0 : e.url.replace("wss://", "https://")}"
              @progress="${(s) => {
        this.componentController.handleProgress({ event: s, token: e });
      }}"
              @ready="${(s) => {
        this.componentController.handleReady({ event: s, token: e });
      }}"
              @permission="${(s) => {
        this.componentController.handleReady({ event: s, token: e });
      }}"
              @permission_denied="${(s) => {
        this.componentController.handleSystemError({ event: s, token: e });
      }}"
              @connecting="${(s) => {
        this.componentController.handleReady({ event: s, token: e });
      }}"
              @failed="${(s) => this.componentController.handleFailedAttempt({ event: s, token: e })}"
              @canceled="${(s) => this.componentController.handleFailedAttempt({ event: s, token: e })}"
              @error="${(s) => {
        Pa(this, Hn, V6).call(this, s) || this.componentController.handleSystemError({ event: s, token: e });
      }}"
              @unsupported="${(s) => {
        this.componentController.handleSystemError({ event: s, token: e });
      }}"
              @passed="${(s) => this.componentController.handleIproovSuccess({ event: s, token: e })}"
              language="${JSON.stringify(yRe())}"
            >
              <div slot="ready"></div>
              <div slot="grant_button" class="grant_button">
                <button role="button" type="button" aria-label="Click to grant camera permission" tabindex="1">
                  ${y("Grant permission", { id: "jumio_grant_permission_iproov" })}
                </button>
              </div>
              <x-ds-button
                slot="failed"
                data-fluid="true"
                data-type="${De.Primary}"
                data-type=""
                @jclick="${() => this.componentController.fetchToken()}"
              >
                ${y("Retake", { id: "preview.retry" })}
              </x-ds-button>
              <x-ds-button
                slot="error"
                data-fluid="true"
                data-type="${De.Primary}"
                @jclick="${() => this.componentController.fetchToken()}"
              >
                ${y("Retake", { id: "preview.retry" })}
              </x-ds-button>
              <x-ds-button
                slot="canceled"
                data-fluid="true"
                data-type="${De.Primary}"
                @jclick="${() => this.componentController.fetchToken()}"
              >
                ${y("Retake", { id: "preview.retry" })}
              </x-ds-button>
              <x-ds-button slot="button" data-type="${De.Primary}" data-fluid="true">
                <button type="button" class="btn-transparent">
                  ${y("Start", {
        id: "identity.guidance.button"
      })}
                </button>
              </x-ds-button>
            </iproov-me>
          </div>
        `;
  }
  return q;
};
dB = function() {
  return w`
      <div class="button-container">
        <x-ds-loading-indicator></x-ds-loading-indicator>
      </div>
    `;
};
R6 = function(e) {
  return Ut(e, ["url", "token", "productType", "remainingAttempts"]);
};
D6 = function() {
  return w`<jumio-sdk-cross-device-button></jumio-sdk-cross-device-button>`;
};
J6 = function() {
  var t, r;
  return ((r = (t = Ds(this, nc).value) == null ? void 0 : t.iproovTokenData) == null ? void 0 : r.productType) === ei.IproovStandard ? "clear" : q;
};
V6 = function(e) {
  return Ut(e.detail, ["feedback"]) && e.detail.feedback === "error_integration_unloaded";
};
M6 = function() {
  return import("./iProovMe.Cvk3KkX7.js").then((e) => e.i).then(
    () => {
      cB(this, cv, !1), this.requestUpdate();
    },
    () => {
      cB(this, cv, !1);
      const e = ve(), t = Tt(oe());
      e.send({
        type: t.IproovFailureSystem
      });
    }
  );
};
uB.styles = [
  ...N.styles,
  Gt(bRe),
  ee`
      .grant_button button {
        background-color: blue;
        color: white;
        padding: 0.875em;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        box-sizing: border-box;
        border: 0.0625em solid transparent;
        border-radius: 1.75em; /* 28 / 16 */
        line-height: 1.25em; /* 20 / 16 */
        cursor: pointer;
        font-style: normal;
        letter-spacing: 0.01em;
        text-align: center;
        transition-property: background-color, color, box-shadow;
        transition-duration: 250ms;
      }
    `
];
uB = URe([
  be(),
  P("jumio-sdk-step-facemap-iproov")
], uB);
var zv, qv, m2, G6;
class kRe {
  constructor(t) {
    E(this, m2);
    E(this, zv);
    E(this, qv, new _e());
    G(this, zv, t), S(this, zv).addController(this);
  }
  hostConnected() {
    O(this, m2, G6).call(this).pipe(le(S(this, qv))).subscribe();
  }
  hostDisconnected() {
    S(this, qv).next();
  }
}
zv = new WeakMap(), qv = new WeakMap(), m2 = new WeakSet(), G6 = function() {
  return ur().pipe(
    ae((t) => {
      const r = ve(), n = Tt(oe());
      switch (t) {
        case x.JumioStandard:
          r.send({ type: n.JumioStandardGuidance });
          break;
        case x.JumioStandardFinish:
          r.send({ type: n.Finish });
          break;
      }
    })
  );
};
const _Re = ':host{display:contents}.container{max-width:32em;margin:0 auto}.container__inner{display:flex;position:relative;height:auto;flex-flow:column nowrap;gap:1em;align-items:center;padding-bottom:1em}.illustration{width:8em;height:10em}.text-center{text-align:center}p{margin:0}.button-container{display:flex;position:sticky;bottom:0;width:100%;max-width:32em;flex-direction:column;min-height:3.25em;align-items:center;justify-content:center;padding-top:1em;padding-bottom:1em;margin-top:-1em;margin-bottom:-1em}:host([data-color-scheme="light"]) .button-container{background:var(--theme-light-app-container-bg-color)}:host([data-color-scheme="dark"]) .button-container{background:var(--theme-dark-app-container-bg-color)}.start-btn{display:block;width:100%}';
var NRe = Object.defineProperty, ZRe = Object.getOwnPropertyDescriptor, x6 = (e) => {
  throw TypeError(e);
}, BRe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? ZRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && NRe(t, r, a), a;
}, WRe = (e, t, r) => t.has(e) || x6("Cannot " + r), ERe = (e, t, r) => t.has(e) ? x6("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Po = (e, t, r) => (WRe(e, t, "access private method"), r), Zi, H6, L6, Y6, O6, j6, P6, $6, K6, PF;
let hB = class extends N {
  constructor() {
    super(...arguments), ERe(this, Zi);
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownGuidanceScreen(this);
  }
  render() {
    return w`
      <x-ds-app-container data-footer-visible="false">
        ${ke(
      "jumio-biometric-guidance-backward-button",
      w` <jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main" class="container">
          <div class="container__inner">
            ${ke("jumio-biometric-guidance-before")} ${Po(this, Zi, H6).call(this)}
            ${ke("jumio-biometric-guidance-after")}
            <div class="button-container">
              <x-ds-button
                class="start-btn"
                data-fluid="true"
                data-qa-id="continue-button"
                @jclick="${() => {
      Po(this, Zi, P6).call(this);
    }}"
              >
                ${y("Continue", {
      id: "identity.guidance.cam.button"
    })}
              </x-ds-button>
            </div>
            <jumio-sdk-cross-device-button></jumio-sdk-cross-device-button>
          </div>
        </div>
      </x-ds-app-container>
    `;
  }
};
Zi = /* @__PURE__ */ new WeakSet();
H6 = function() {
  return ke(
    "jumio-biometric-guidance",
    w`${Po(this, Zi, L6).call(this)}${Po(this, Zi, Y6).call(this)}${Po(this, Zi, O6).call(this)}${Po(this, Zi, j6).call(this)}`
  );
};
L6 = function() {
  return ke(
    "jumio-biometric-guidance-title",
    w`<h1>${y("Face Verification", { id: "jumio_identity_title" })}</h1>`
  );
};
Y6 = function() {
  return ke(
    "jumio-biometric-guidance-explanation",
    w`
        <p data-qa-id="explanation">
          ${y("We need to take a scan of your face to verify that you are a real person.", {
      id: "jlive_desc_1"
    })}
        </p>
      `
  );
};
O6 = function() {
  const e = Po(this, Zi, PF).call(this);
  return ke(
    "jumio-biometric-guidance-illustration",
    w`
        <x-ds-guidance-face-animation
          class="illustration"
          data-qa-id="face-image"
          data-jumio-premium="${e}"
        ></x-ds-guidance-face-animation>
      `
  );
};
j6 = function() {
  return ke(
    "jumio-biometric-guidance-checklist",
    w`
        <x-ds-shield-list data-qa-id="checklist">
          <x-ds-shield-list-item slot="item">
            ${y("Your face must be evenly lit and stand out from the background.", {
      id: "identity.iproov.preview.lighting"
    })}
          </x-ds-shield-list-item>
          <x-ds-shield-list-item slot="item">
            ${y("Look straight into the camera", { id: "jumio_liveness_prompt_look_straight_into_the_camera" })}
          </x-ds-shield-list-item>
          ${Po(this, Zi, K6).call(this)}
        </x-ds-shield-list>
      `
  );
};
P6 = function() {
  const e = ve(), t = Tt(oe());
  e.send({
    type: t.JumioStandardCaptureScreen
  });
};
$6 = function() {
  return Ce().getControllerById(T.Facemap);
};
K6 = function() {
  return Po(this, Zi, PF).call(this) ? w`
          <x-ds-shield-list-item slot="item">
            ${y("Make sure the screen brightness is set to maximum", { id: "jumio_liveness_brightness_instruction" })}
          </x-ds-shield-list-item>
        ` : q;
};
PF = function() {
  return Po(this, Zi, $6).call(this).getActiveFaceVerificationMethod() === ei.JumioPremium;
};
hB.styles = [...N.styles, Gt(_Re)];
hB = BRe([
  be(),
  P("jumio-sdk-step-facemap-jumio-standard-introduction")
], hB);
const QRe = ":host{display:contents}.camera-selector-container{position:relative}.camera-selector-container[data-orientation=vertical]{width:100%;height:100%}.camera-selector[data-orientation=vertical]{position:absolute;right:0;bottom:0}.cross-device-container{display:flex;align-items:flex-end;height:100%}", FRe = (e) => Be(
  q0e().pipe(
    go(e),
    te(([t, r]) => r > t)
  )
), TRe = async (e) => {
  try {
    const t = Ce(), r = ve(), n = Tt(oe());
    return mt.showMessageIfPossible({
      type: Fr.Progress,
      id: ct.Uploading,
      title: y("Uploading", { id: "upload.title" }),
      message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
      overlay: !0,
      closable: !0
    }), r.send({ type: n.JumioStandardCaptureScreenUpload }), await Dd(() => {
    }, Math.max(500, hg)), t.getLoggerManager().log(
      iL({
        metadata: { source: Fu.Camera }
      })
    ), await t.getControllerById(T.Facemap).uploadDataAsync(e);
  } finally {
    mt.closeActiveClosableMessageById(ct.Uploading);
  }
}, RRe = async ({
  uploadResponse: e,
  workflowStepFacemapController: t,
  stateManager: r
}) => {
  const n = Tt(oe()), a = Ce().getControllerById(T.Facemap);
  try {
    mt.showMessageIfPossible({
      type: Fr.Progress,
      id: ct.UsabilityCheck,
      title: y("Analyzing biometric data", { id: "identity.iproov.progress" }),
      message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
      overlay: !0,
      closable: !0
    }), r.send({ type: n.JumioStandardUsabilityCheck });
    const [i] = Object.entries((e == null ? void 0 : e.usabilityResultKeys) ?? {}), [o, s = ""] = i ?? [], c = await Ce().getControllerById(T.Facemap).checkUsabilityAsync({
      id: o,
      usability: {
        resultKey: s
      }
    });
    return await Dd(() => {
    }, Math.max(hg, 2e3)), mt.closeActiveClosableMessageById(ct.UsabilityCheck), c.decisionType === zn.PASS || await FRe(a.selectLivenessAttempt$()) ? r.send({ type: n.JumioStandardUsabilityCheckSuccess }) : (t.setLivenessStoreToNextAttempt(), r.send({ type: n.JumioStandardUsabilityCheckFailure })), c;
  } catch {
    r.send({ type: n.JumioStandardUsabilityCheckSuccess });
    return;
  } finally {
    mt.closeActiveClosableMessageById(ct.UsabilityCheck);
  }
}, qw = mo(
  { name: "help" },
  Wl({
    visible: !1,
    allowedSubsteps: [
      Z.CaptureScreen,
      Z.CaptureScreenSelectProvider,
      Z.CaptureScreenAutoCaptureLoading,
      Z.CaptureScreenDecision,
      Z.CaptureScreenFrontStart,
      Z.CaptureScreenFront,
      Z.CaptureScreenFrontFinish,
      Z.CaptureScreenBackStart,
      Z.CaptureScreenBack,
      Z.CaptureScreenBackFinish,
      x.JumioStandardCaptureScreen,
      x.JumioStandardCaptureScreenLiveness,
      x.JumioStandardCaptureScreenLivenessLoading,
      x.JumioStandardCaptureScreenSelfie
    ],
    timeoutMs: 9e4,
    popupOnTimer: !0
  })
), ZVe = () => qw.getValue(), X6 = () => qw.asObservable(), eA = (e = {}) => {
  qw.update((t) => ({
    ...t,
    ...e
  }));
}, Qg = () => {
  qw.update(({ visible: e, ...t }) => ({
    ...t,
    visible: !e
  }));
};
var DRe = Object.defineProperty, JRe = Object.getOwnPropertyDescriptor, z6 = (e) => {
  throw TypeError(e);
}, VRe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? JRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && DRe(t, r, a), a;
}, $F = (e, t, r) => t.has(e) || z6("Cannot " + r), dl = (e, t, r) => ($F(e, t, "read from private field"), t.get(e)), dC = (e, t, r) => t.has(e) ? z6("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), MRe = (e, t, r, n) => ($F(e, t, "write to private field"), t.set(e, r), r), sp = (e, t, r) => ($F(e, t, "access private method"), r), tA, $u, yf, ac, q6, KF, eX, tX, rX;
let pB = class extends N {
  constructor() {
    super(...arguments), dC(this, ac), dC(this, tA, -1), this.delayedHelpDisplay$ = sp(this, ac, tX).call(this), this.visibilityStateLogging$ = sp(this, ac, q6).call(this), dC(this, $u, new ue(this, X6())), dC(this, yf, new _e());
  }
  connectedCallback() {
    super.connectedCallback(), this.delayedHelpDisplay$.pipe(le(dl(this, yf))).subscribe(), this.visibilityStateLogging$.pipe(le(dl(this, yf))).subscribe();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.setHelpVisibility(!1), dl(this, yf).next();
  }
  render() {
    var t;
    const e = ((t = dl(this, $u).value) == null ? void 0 : t.visible) === !0;
    return e ? w`
          <x-ds-backdrop
            slot="overlay"
            data-click-to-close="false"
            hidden="${!e}"
            @click="${() => {
      this.setHelpVisibility(!1);
    }}"
          >
            <x-ds-sheet>
              <div slot="instructions">
                <h3>${y("Tips", { id: "id-source.help.card.tips" })}</h3>
                <slot name="tips"></slot>
              </div>
              <div slot="actions" class="overlay-actions">
                <x-ds-button
                  @jclick="${() => {
      this.setHelpVisibility(!1);
    }}"
                  data-qa-id="continue-btn"
                  data-type="${De.Primary}"
                  data-fluid="true"
                >
                  ${y("Continue", { id: "identity.guidance.cam.button" })}
                </x-ds-button>
                <slot name="secondary-action-button"></slot>
                <jumio-sdk-cross-device-button
                  data-type="${De.Secondary}"
                  data-fluid="true"
                ></jumio-sdk-cross-device-button>
              </div>
            </x-ds-sheet>
          </x-ds-backdrop>
        ` : q;
  }
  setHelpVisibility(e) {
    eA({ visible: e });
  }
  rescheduleHelpPopup() {
    sp(this, ac, KF).call(this), sp(this, ac, eX).call(this);
  }
};
tA = /* @__PURE__ */ new WeakMap();
$u = /* @__PURE__ */ new WeakMap();
yf = /* @__PURE__ */ new WeakMap();
ac = /* @__PURE__ */ new WeakSet();
q6 = function() {
  return X6().pipe(
    te(({ visible: e }) => e),
    vt(),
    ae((e) => {
      Te.shownCameraCaptureHints(this, {
        metadata: {
          visible: e
        }
      });
    })
  );
};
KF = function() {
  window.clearTimeout(dl(this, tA));
};
eX = function() {
  var e, t;
  if ((e = dl(this, $u).value) != null && e.popupOnTimer) {
    const r = ((t = dl(this, $u).value) == null ? void 0 : t.timeoutMs) ?? 9e4;
    MRe(this, tA, window.setTimeout(() => {
      this.setHelpVisibility(!0);
    }, r));
  }
};
tX = function() {
  return ur().pipe(
    te((e) => sp(this, ac, rX).call(this, e)),
    vt(),
    ae(() => {
      sp(this, ac, KF).call(this);
    }),
    at((e) => {
      var r;
      return !!((r = dl(this, $u).value) != null && r.popupOnTimer) && e;
    }),
    ae(() => {
      this.rescheduleHelpPopup();
    })
  );
};
rX = function(e) {
  var r;
  return (((r = dl(this, $u).value) == null ? void 0 : r.allowedSubsteps) ?? []).includes(e ?? "");
};
pB.styles = [
  ...N.styles,
  ee`
      :host {
        display: block;
      }

      x-ds-backdrop {
        pointer-events: all;
      }

      .overlay-actions {
        display: flex;
        gap: 1em;
        flex-direction: column;
      }
    `
];
pB = VRe([
  be(),
  P("jumio-sdk-capture-hints")
], pB);
var gu, fu, dc, mu, Tp, Rp, vu, as, Wb, nX, aX;
class GRe {
  constructor(t) {
    E(this, as);
    E(this, gu);
    E(this, fu);
    E(this, dc);
    E(this, mu);
    E(this, Tp);
    E(this, Rp);
    E(this, vu);
    G(this, gu, t), G(this, dc, new _e()), G(this, fu, Ce()), G(this, mu, Ce().getControllerById(T.Facemap)), S(this, gu).addController(this);
  }
  hostConnected() {
    O(this, as, nX).call(this).pipe(le(S(this, dc))).subscribe(), FE(T.Facemap).pipe(
      ae((t) => {
        eA({
          timeoutMs: t
        });
      }),
      le(S(this, dc))
    ).subscribe(), ml.getInstance().fullscreenChange$.pipe(
      ae((t) => {
        h_.next(!t);
      }),
      le(S(this, dc))
    ).subscribe();
  }
  hostDisconnected() {
    O(this, as, Wb).call(this), S(this, dc).next(), h_.next(!0);
  }
  requestUpload(t) {
    G(this, Rp, t);
    const r = ve(), n = Tt(oe());
    r.send({ type: n.JumioStandardCaptureScreenUpload });
  }
  async upload() {
    if (!S(this, Rp))
      throw new Error("Upload request is not defined");
    const r = Ce().getControllerById(T.Facemap).getActiveFaceVerificationMethod();
    return r && rI(r), TRe(S(this, Rp));
  }
}
gu = new WeakMap(), fu = new WeakMap(), dc = new WeakMap(), mu = new WeakMap(), Tp = new WeakMap(), Rp = new WeakMap(), vu = new WeakMap(), as = new WeakSet(), Wb = function() {
  window.clearTimeout(S(this, Tp)), G(this, Tp, void 0);
}, nX = function() {
  return ur().pipe(
    ae((t) => {
      const r = ve(), n = Tt(oe());
      switch (t) {
        case x.JumioStandardCaptureScreenLiveness:
          const a = O(this, as, aX).call(this);
          O(this, as, Wb).call(this), G(this, Tp, window.setTimeout(() => {
            S(this, mu).setJLiveManualCaptureFallbackReason(nt.Timeout);
          }, a));
          break;
        case x.JumioStandardCaptureScreen:
          sH(oe()), r.send({ type: n.JumioStandardCaptureScreenLivenessLoading });
          break;
        case x.JumioStandardCaptureScreenUpload:
          S(this, gu).stopStream(), mt.showMessageIfPossible({
            type: Fr.Progress,
            id: ct.Uploading,
            title: y("Uploading", { id: "upload.title" }),
            message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
            overlay: !0,
            closable: !0
          }), this.upload().then(
            (o) => {
              G(this, vu, o), r.send({ type: n.JumioStandardUsabilityCheck });
            },
            () => {
              G(this, vu, void 0), r.send({ type: n.JumioStandardCaptureScreenUploadFailed });
            }
          ).finally(() => {
            mt.closeActiveClosableMessageById(ct.Uploading);
          });
          break;
        case x.JumioStandardCaptureScreenLivenessLoading:
          const { merchantSettings: i } = S(this, fu).getConfiguration().getSettings();
          if (i != null && i.jLiveEnabled) {
            Promise.resolve().then(() => LJe).catch(() => {
              uL(S(this, gu), {
                metadata: {
                  step: x.JumioStandardCaptureScreenLivenessLoading
                }
              }), S(this, mu).setJLiveManualCaptureFallbackReason(
                nt.ModuleLoadingError
              );
            });
            return;
          }
          r.send({ type: n.JumioStandardCaptureScreenSelfie });
          break;
        case x.JumioStandardCaptureScreenSelfie:
          d9("near");
          break;
        case x.JumioStandardUsabilityCheck:
          S(this, vu) && S(this, fu) && RRe({
            uploadResponse: S(this, vu),
            stateManager: r,
            workflowStepFacemapController: S(this, mu)
          }).catch(Pp);
          break;
        case x.JumioStandardCaptureScreenCaptureFinish:
          ml.getInstance().exitFullscreen().catch(Pp), O(this, as, Wb).call(this);
          break;
      }
    })
  );
}, aX = function() {
  const { jumioLiveness: t } = S(this, fu).getConfiguration().getSettings().configurations, { fallbackTimeInMs: r = 9e4 } = t ?? {};
  return r;
};
const XF = ".icon-help{font-size:240%}";
class xRe extends CustomEvent {
  constructor(t) {
    super("uploadrequest", {
      detail: t,
      bubbles: !0,
      cancelable: !0,
      composed: !0
    });
  }
}
const iX = (e) => e === x.JumioStandardCaptureScreenSelfie, HRe = (e) => iX(e), LRe = (e) => {
  const t = _l();
  return {
    normalizedNearFarCutOffPoint: t ? 0.8 : 0.55,
    initialPoseCheckFaceWidthRatioMin: t ? 0.7 : 0.45,
    initialPoseCheckFaceWidthRatioMax: t ? 0.9 : 0.65,
    requiredDistanceMovementRatio: 0.85,
    poseCheck: {
      pseudoPitchMin: 105,
      pseudoPitchMax: 170,
      pseudoYawMin: 65,
      pseudoYawMax: 135,
      normalizedOffCenterThreshold: 0.1
    },
    delayMillisecondsBetweenDistance: 1e3,
    ...e.isPhotinus && {
      nearPhotinus: {
        nonce: e.nonce,
        hardwareLatency: 4
      }
    }
  };
}, YRe = ({
  forwardedEvent$: e,
  uxCommand$: t
}) => ({
  onEventForForwarding: (r) => {
    e.next(r);
  },
  onResponse: (r) => {
    t.next(r);
  }
}), ORe = async ({ handleWorkerMessage: e, initializationFailure: t }) => {
  const r = await mpe(!1);
  return r.onerror = () => {
    t == null || t(nt.WorkerError);
  }, r.onmessage = e, r;
}, jRe = (e, ...t) => {
  const r = [e, ...t], { merchantSettings: n } = On();
  return r.includes((n == null ? void 0 : n.jLiveFallbackPolicy) ?? ol.Disabled);
}, PRe = () => jRe(ol.Disabled), zF = (e, t) => {
  Te.cameraPlaybackStatusEvent(e, {
    metadata: { status: t }
  });
};
var $Re = Object.defineProperty, KRe = Object.getOwnPropertyDescriptor, oX = (e) => {
  throw TypeError(e);
}, XRe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? KRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && $Re(t, r, a), a;
}, sX = (e, t, r) => t.has(e) || oX("Cannot " + r), v3 = (e, t, r) => (sX(e, t, "read from private field"), r ? r.call(e) : t.get(e)), S3 = (e, t, r) => t.has(e) ? oX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), lX = (e, t, r) => (sX(e, t, "access private method"), r), Eb, Qy, cX, dX;
let gB = class extends N {
  constructor() {
    super(...arguments), S3(this, Qy), S3(this, Eb, new _e());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), v3(this, Eb).next(), mt.closeActiveClosableMessageById(
      ct.CameraNotAllowedError,
      ct.CameraGenericError
    );
  }
  connectedCallback() {
    super.connectedCallback(), lX(this, Qy, dX).call(this).pipe(le(v3(this, Eb))).subscribe();
  }
};
Eb = /* @__PURE__ */ new WeakMap();
Qy = /* @__PURE__ */ new WeakSet();
cX = function() {
  mt.showMessageIfPossible({
    type: Fr.Progress,
    id: ct.CameraInitialization,
    title: y("Initializing camera…", {
      id: "initialising-camera.title"
    }),
    closable: !0
  });
};
dX = function() {
  return gQ().pipe(
    go(HY()),
    ae(([e]) => {
      e === "prompt" && !($Y() && qj(window.navigator.userAgent)) ? lX(this, Qy, cX).call(this) : e === "granted" && mt.closeActiveClosableMessageById(ct.CameraInitialization);
    }),
    ae(([e, t]) => {
      const r = zo(t.filter(Boolean), [
        "deviceId",
        "groupId",
        "deviceIds",
        "deviceEntities",
        "mockDeviceIds",
        "mockDeviceEntities"
      ]);
      e === "prompt" ? Te.shownCameraAccessRequestScreen(this, {
        metadata: { kind: "prompt", devices: r }
      }) : e === "denied" && Te.shownCameraAccessRequestScreen(this, {
        metadata: { kind: "denied", devices: r }
      });
    }),
    te(([e]) => e)
  );
};
gB.styles = [
  ...N.styles,
  ee`
      :host {
        display: none;
      }
    `
];
gB = XRe([
  be(),
  P("jumio-sdk-camera-permissions-screen")
], gB);
var zRe = Object.defineProperty, qRe = Object.getOwnPropertyDescriptor, uX = (e) => {
  throw TypeError(e);
}, e5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? qRe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && zRe(t, r, a), a;
}, t5e = (e, t, r) => t.has(e) || uX("Cannot " + r), kk = (e, t, r) => (t5e(e, t, "read from private field"), r ? r.call(e) : t.get(e)), _k = (e, t, r) => t.has(e) ? uX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), fB, mB, vB;
let I3 = class extends N {
  constructor() {
    super(...arguments), this.captureStateController = new ue(this, ur()), _k(this, fB, (e) => {
      switch (this.captureStateController.value) {
        case x.JumioStandardCaptureScreenLivenessLoading:
          return kk(this, vB).call(this, e);
        case x.JumioStandardCaptureScreenSelfie:
          return kk(this, mB).call(this, e);
        default:
          return w`<slot></slot>`;
      }
    }), _k(this, mB, () => {
      const e = y("Face Verification", {
        id: "jumio_identity_title"
      });
      return w`
      <x-ds-capture-label data-qa-id="capture-state-message" data-text="${e}">
        ${e}
      </x-ds-capture-label>
    `;
    }), _k(this, vB, () => {
      const e = y("Loading", {
        id: "identity.guidance.button.progress"
      });
      return w`
      <x-ds-capture-label data-qa-id="capture-state-message" data-text="${e}">
        ${e}
      </x-ds-capture-label>
    `;
    });
  }
  render() {
    var t;
    const e = (t = this.captureStateController) == null ? void 0 : t.value;
    return e ? kk(this, fB).call(this, e) : w`<slot></slot>`;
  }
};
fB = /* @__PURE__ */ new WeakMap();
mB = /* @__PURE__ */ new WeakMap();
vB = /* @__PURE__ */ new WeakMap();
I3 = e5e([
  be(),
  P("jumio-sdk-step-facemap-capture-state")
], I3);
const r5e = ":host{display:contents}.loading-indicator{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}";
var rA = /* @__PURE__ */ ((e) => (e.ServerData = "server_data", e.LivenessBlob = "liveness_blob", e))(rA || {});
const n5e = (e) => {
  let t;
  if ("liveness_blob" in e) {
    const r = {};
    let n = 0;
    for (; ; ) {
      n++;
      const a = e[`liveness_${n}`], i = e[`liveness_${n}_type`], o = e[`liveness_${n}_timestamp`];
      if (a && i) {
        const s = i5e(i);
        r[`liveness_${n}`] = new File([a], `liveness_${n + 1}.${s}`, {
          type: i,
          lastModified: Number.parseInt(o ?? Date.now().toString())
        });
      } else
        break;
    }
    t = {
      type: rA.LivenessBlob,
      blobs: r,
      best_image: e.best_image,
      liveness_blob: e.liveness_blob
    };
  }
  return t;
}, a5e = (e) => ({
  "image/webp": xr.WebP,
  "image/png": xr.Png,
  "image/jpg": xr.Jpg,
  "image/jpeg": xr.Jpeg,
  "image/jp2": xr.Jpeg2000,
  "image/jpx": xr.Jpeg2000,
  "image/jpc": xr.Jpeg2000,
  "image/j2c": xr.Jpeg2000,
  "application/pdf": xr.Pdf,
  "application/octet-stream": xr.Dat
})[e] ?? xr.Jpeg, i5e = (e) => ({
  "image/webp": "webp",
  "image/png": "png",
  "image/jpg": "jpg",
  "image/jpeg": "jpeg",
  "image/jp2": "jpeg",
  "image/jpx": "jpeg",
  "image/jpc": "jpeg",
  "image/j2c": "jpeg",
  "application/pdf": "pdf",
  "application/octet-stream": "dat"
})[e] ?? "jpeg", o5e = (e) => Object.entries(e.blobs).map(([t, r], n) => {
  var a, i, o;
  return {
    multipartName: `${oe()}_${ei.JumioLiveness}_${n + 1}`,
    fileType: a5e(r.type),
    uploadType: `JUMIO_LIVENESS_${n + 1}`,
    usabilityExpected: !0,
    fileMetaData: {
      bestSelfieShot: t === e.best_image
    },
    file: r,
    riskSignals: {
      deviceId: ((a = jn()) == null ? void 0 : a.deviceId) ?? "",
      deviceLabel: ((i = jn()) == null ? void 0 : i.label) ?? "",
      groupId: ((o = jn()) == null ? void 0 : o.groupId) ?? ""
    },
    cls: sd(r.lastModified),
    clsm: ld(r.lastModified)
  };
}), s5e = (e, t) => {
  var r, n, a;
  return {
    multipartName: `${e}_JUMIO_LIVENESS_BLOB`,
    fileType: xr.Dat,
    uploadType: "JUMIO_LIVENESS_BLOB",
    usabilityExpected: !1,
    fileMetaData: {
      bestSelfieShot: !1
    },
    riskSignals: {
      deviceId: ((r = jn()) == null ? void 0 : r.deviceId) ?? "",
      deviceLabel: ((n = jn()) == null ? void 0 : n.label) ?? "",
      groupId: ((a = jn()) == null ? void 0 : a.groupId) ?? ""
    },
    file: new Blob([t.liveness_blob], {
      type: "application/octet-stream"
    })
  };
}, l5e = (e, t) => [
  ...o5e(t),
  s5e(e, t)
], c5e = (e) => e.pipe(
  at((t) => t.event === He.ServerDataBlob),
  Wt((t) => {
    const r = n5e(t);
    if ((r == null ? void 0 : r.type) === rA.LivenessBlob) {
      const n = l5e(oe(), r);
      return Sa({
        uploadFilesMetadata: {
          files: n
        }
      });
    }
    return ba;
  })
), d5e = ({
  jLiveActivationTime$: e,
  progressChangeTime$: t,
  loggerManager: r = Ce().getLoggerManager(),
  progress$: n
}) => n.pipe(
  ae(([a, i]) => {
    const o = Date.now() - e.getValue();
    r.log(
      hL({
        metadata: {
          jliveProgressCurrentStep: a,
          jliveProgressStepsTotal: i,
          jLiveStepDuration: Date.now() - t.getValue(),
          jLiveDuration: o,
          cls: sd(),
          clsm: ld()
        },
        tags: {
          jLiveDuration: o,
          jliveProgressCurrentStep: a,
          jliveProgressStepsTotal: i
        }
      })
    ), t.next(Date.now());
  })
);
var uc, Ii, zs, us, hX, pX, gX, v2, fX;
const S2 = class S2 {
  constructor(t) {
    E(this, us);
    E(this, uc);
    E(this, Ii);
    E(this, zs);
    E(this, v2, (t) => {
      var n, a, i, o;
      const r = t.data;
      switch (S(this, uc).outputMessage$.next(r), (n = S(this, zs)) == null || n.onLowerLevelEvent(r), r.event) {
        case He.InitializeSuccess:
          {
            const s = {
              event: He.StartSession,
              timestamp: Date.now().toString()
            };
            (a = S(this, Ii)) == null || a.postMessage(s), (o = (i = S(this, uc)).initializationSuccess) == null || o.call(i);
          }
          break;
      }
    });
    G(this, uc, t), ORe({
      handleWorkerMessage: S(this, v2),
      initializationFailure: t.initializationFailure
    }).then((r) => {
      G(this, Ii, r), O(this, us, gX).call(this, r, t.workerData);
    }), O(this, us, pX).call(this, t.workerData, LRe(O(this, us, hX).call(this)));
  }
  async postMessage(t) {
    var r, n, a, i;
    if (t.event === He.Image) {
      (r = S(this, zs)) == null || r.onBeforeFrame(), await ((n = S(this, Ii)) == null ? void 0 : n.postMessage(t)), (a = S(this, zs)) == null || a.onAfterFrame();
      return;
    }
    await ((i = S(this, Ii)) == null ? void 0 : i.postMessage(t));
  }
  terminate() {
    var r, n, a;
    const t = {
      event: He.Terminate,
      timestamp: Date.now().toString()
    };
    (r = S(this, zs)) == null || r.delete(), G(this, zs, void 0), (n = S(this, Ii)) == null || n.postMessage(t), (a = S(this, Ii)) == null || a.terminate(), G(this, Ii, void 0);
  }
  get isWorkerFree() {
    return Ut(S(this, Ii), ["isWorkerReady"]) ? S(this, Ii).isWorkerReady(S2.ID) : !0;
  }
};
uc = new WeakMap(), Ii = new WeakMap(), zs = new WeakMap(), us = new WeakSet(), hX = function() {
  var r;
  const t = O(this, us, fX).call(this).getActiveFaceVerificationMethod() === ei.JumioPremium;
  return t ? {
    isPhotinus: !0,
    ...t && { nonce: ((r = Ce().getWorkflowState().parsedToken) == null ? void 0 : r.wfeId) ?? "" }
  } : {
    isPhotinus: !1
  };
}, pX = async function(t, r) {
  const n = await dpe(t.wasmModule), a = "nearPhotinus" in r ? n.LivenessUX.createPremium(r) : n.LivenessUX.createStandard(r);
  G(this, zs, a);
  const i = n.LivenessUXDelegate.implement(YRe(S(this, uc)));
  a.setDelegate(i), await a.run();
}, gX = function(t, r) {
  var n, a;
  try {
    t.postMessage({
      assets: r.assets,
      config_name: r.configName,
      event: He.InitializeWasm,
      timestamp: Date.now().toString(),
      wasm_module: r.wasmModule
    });
  } catch {
    (a = (n = S(this, uc)).initializationFailure) == null || a.call(n, nt.WorkerCrashed);
  }
}, v2 = new WeakMap(), fX = function() {
  return Ce().getControllerById(T.Facemap);
}, S2.ID = "EyeFinder";
let SB = S2;
var eS, Dp, Jp, Vp, Do, ca, tS, $c, mX, vX, SX;
const I2 = class I2 {
  constructor(t) {
    E(this, $c);
    E(this, eS);
    E(this, Dp);
    E(this, Jp);
    E(this, Vp);
    E(this, Do);
    E(this, ca);
    E(this, tS);
    this.postMessage = (n) => {
      try {
        const a = this.getWorkerService();
        a == null || a.postMessage(n);
      } catch {
        S(this, ca).setJLiveManualCaptureFallbackReason(nt.PostMessageError);
      }
    }, this.initializationSuccess = () => {
      const n = ve(), a = Tt(oe()), { substep: i } = Le(), o = this.getWorkerService(), s = {
        event: He.PoseStart,
        timestamp: Date.now().toString()
      };
      o == null || o.postMessage(s), h4(), HQ(this.postMessage), this.getLogger().log(
        dL({
          metadata: {
            step: i ?? ""
          }
        })
      ), n.send({
        type: a.JumioStandardCaptureScreenLiveness
      });
    }, this.initializationFailure = (n) => {
      const a = this.getWorkerService();
      a == null || a.terminate(), S(this, ca).setJLiveManualCaptureFallbackReason(n);
    }, this.handleUxCommand = (n) => {
      "camera_command" in n && S(this, ca).setLivenessStoreCameraCommand(n.camera_command), "display_message" in n && S(this, ca).setLivenessStoreDisplayMessage(n.display_message), "photinus_color" in n && S(this, ca).setLivenessStorePhotinusColor(n.photinus_color), "ui_command" in n && (S(this, ca).setLivenessStoreUiCommand(n.ui_command), n.ui_command === E_.HintMoveAway && S(this, ca).setLivenessVisibleFaceFinder("far"), n.ui_command === E_.HintMoveCloser && S(this, ca).setLivenessVisibleFaceFinder("near")), "ux_progress" in n && S(this, ca).setLivenessStoreProgress(n.ux_progress);
    }, G(this, tS, t), G(this, Do, new _e()), G(this, Dp, new _e()), G(this, Jp, new _e()), G(this, Vp, new _e()), this.uxCommand$ = S(this, Dp).asObservable(), this.outputMessage$ = S(this, Jp).asObservable(), this.livenessSettings$ = O(this, $c, vX).call(this), this.cls$ = O(this, $c, mX).call(this), G(this, ca, Ce().getControllerById(T.Facemap)), O(this, $c, SX).call(this, t.configName);
    const r = this.postMessage.bind(this);
    aj(r).pipe(le(S(this, Do))).subscribe(), nj(r).pipe(le(S(this, Do))).subscribe(), this.uxCommand$.pipe(ae(this.handleUxCommand), le(S(this, Do))).subscribe(), S(this, Vp).pipe(ae(this.postMessage), le(S(this, Do))).subscribe(), this.cls$.pipe(le(S(this, Do))).subscribe();
  }
  get isWorkerFree() {
    const t = this.getWorkerService();
    return (t == null ? void 0 : t.isWorkerFree) ?? !1;
  }
  destroy() {
    const t = this.getWorkerService();
    t == null || t.terminate(), S(this, Do).next();
  }
  getWorkerService() {
    return S(this, eS);
  }
  getLogger() {
    return Ce().getLoggerManager();
  }
};
eS = new WeakMap(), Dp = new WeakMap(), Jp = new WeakMap(), Vp = new WeakMap(), Do = new WeakMap(), ca = new WeakMap(), tS = new WeakMap(), $c = new WeakSet(), mX = function() {
  return this.outputMessage$.pipe(
    at((t) => t.event === He.CameraLivenessStatus),
    ae((t) => {
      ij(t);
    })
  );
}, vX = function() {
  return Ce().getConfiguration().selectSettings$().pipe(
    te((t) => t.configurations.jumioLiveness),
    at((t) => !!t)
  );
}, SX = async function(t = _m.StandardWeb) {
  try {
    const r = Q2(
      I2.WASM_MODULE_INIT_FALLBACK_MS,
      new Ug(nt.ModuleInitializationError)
    ), n = new Promise((a) => {
      const i = new SB({
        workerData: {
          ...S(this, tS),
          configName: t
        },
        initializationSuccess: async () => (a(i), this.initializationSuccess(), Promise.resolve(void 0)),
        initializationFailure: this.initializationFailure,
        uxCommand$: S(this, Dp),
        outputMessage$: S(this, Jp),
        forwardedEvent$: S(this, Vp)
      });
      G(this, eS, i);
    });
    await Promise.race([r, n]);
  } catch (r) {
    const n = r instanceof Ug ? r.reason : nt.WorkerError;
    S(this, ca).setJLiveManualCaptureFallbackReason(n);
  }
}, I2.WASM_MODULE_INIT_FALLBACK_MS = 5e3;
let Fy = I2;
var u5e = Object.defineProperty, h5e = Object.getOwnPropertyDescriptor, IX = (e) => {
  throw TypeError(e);
}, p5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? h5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && u5e(t, r, a), a;
}, qF = (e, t, r) => t.has(e) || IX("Cannot " + r), Xr = (e, t, r) => (qF(e, t, "read from private field"), t.get(e)), Gl = (e, t, r) => t.has(e) ? IX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), wf = (e, t, r, n) => (qF(e, t, "write to private field"), t.set(e, r), r), eT = (e, t, r) => (qF(e, t, "access private method"), r), Af, Uf, Xf, Qb, ku, zf, Sp, dv, CX, bX, yX;
let Ty = class extends N {
  constructor() {
    super(), Gl(this, dv), this.cameraRef = Rt(), Gl(this, Af), Gl(this, Uf), Gl(this, Xf, new _e()), Gl(this, Qb), Gl(this, ku), Gl(this, zf, new _e()), Gl(this, Sp), this.onVideoTick = async (...e) => {
      var n, a, i, o;
      const t = this.getRenderer(), r = await ((n = t == null ? void 0 : t.onVideoTick) == null ? void 0 : n.call(t, ...e));
      if ((a = Xr(this, Sp)) != null && a.isWorkerFree) {
        const s = await ((i = t == null ? void 0 : t.getImageData) == null ? void 0 : i.call(t));
        s && ((o = Xr(this, Sp)) == null || o.postMessage({
          event: He.Image,
          timestamp: Date.now().toString(),
          image: s,
          format: "rgba"
        }));
      }
      return r;
    }, this.captureImage = async (...e) => {
      var t, r;
      return (r = (t = this.getRenderer()) == null ? void 0 : t.captureImage) == null ? void 0 : r.call(t, ...e);
    }, wf(this, Af, new Kt(Date.now())), wf(this, Uf, new Kt(Date.now())), wf(this, ku, Ce().getControllerById(T.Facemap)), wf(this, Qb, new ue(this, ur())), this.livenessProgressReport$ = d5e({
      progressChangeTime$: Xr(this, Uf),
      jLiveActivationTime$: Xr(this, Af),
      progress$: Xr(this, ku).selectLivenessProgress$()
    }), eT(this, dv, yX).call(this).pipe(le(Xr(this, Xf))).subscribe();
  }
  connectedCallback() {
    super.connectedCallback(), Xr(this, Af).next(Date.now()), Xr(this, Uf).next(Date.now()), this.livenessProgressReport$.pipe(le(Xr(this, Xf))).subscribe(), Xr(this, zf).next(), Xr(this, zf).complete();
  }
  render() {
    return Xr(this, Qb).value === x.JumioStandardCaptureScreenLivenessLoading ? w`
          <x-ds-prompt-loader
            data-state="pulsing"
            class="loading-indicator"
            data-qa-id="loading-indicator"
          ></x-ds-prompt-loader>
        ` : q;
  }
  getRenderer() {
    var e, t, r;
    return (r = (t = (e = this.cameraRef) == null ? void 0 : e.value) == null ? void 0 : t.canvasRendererElRef) == null ? void 0 : r.value;
  }
};
Af = /* @__PURE__ */ new WeakMap();
Uf = /* @__PURE__ */ new WeakMap();
Xf = /* @__PURE__ */ new WeakMap();
Qb = /* @__PURE__ */ new WeakMap();
ku = /* @__PURE__ */ new WeakMap();
zf = /* @__PURE__ */ new WeakMap();
Sp = /* @__PURE__ */ new WeakMap();
dv = /* @__PURE__ */ new WeakSet();
CX = async function() {
  const e = await sj().catch(
    () => Promise.reject(new Ug(nt.ModuleLoadingError))
  );
  wf(this, Sp, new Fy({
    ...e,
    configName: eT(this, dv, bX).call(this)
  })), c5e(Xr(this, Sp).outputMessage$).pipe(
    ae((t) => {
      this.dispatchEvent(new xRe(t));
    }),
    le(Xr(this, Xf))
  ).subscribe();
};
bX = function() {
  return Xr(this, ku).getActiveFaceVerificationMethod() === ei.JumioPremium ? _m.PremiumWeb : _m.StandardWeb;
};
yX = function() {
  const e = Xr(this, ku).selectJLiveFallbackError$().pipe(
    EW(),
    at(([t, r]) => !!(t && !r))
  );
  return p1(Xr(this, zf), e).pipe(
    Wt(async () => {
      try {
        await eT(this, dv, CX).call(this);
        return;
      } catch (t) {
        t instanceof Ug && Xr(this, ku).setJLiveManualCaptureFallbackReason(t.reason);
        return;
      }
    })
  );
};
Ty.styles = [...N.styles, Gt(r5e)];
Ty = p5e([
  P("jumio-sdk-liveness"),
  be()
], Ty);
var g5e = Object.defineProperty, f5e = Object.getOwnPropertyDescriptor, wX = (e) => {
  throw TypeError(e);
}, m5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? f5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && g5e(t, r, a), a;
}, tT = (e, t, r) => t.has(e) || wX("Cannot " + r), IB = (e, t, r) => (tT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Nk = (e, t, r) => t.has(e) ? wX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), C3 = (e, t, r, n) => (tT(e, t, "write to private field"), t.set(e, r), r), v5e = (e, t, r) => (tT(e, t, "access private method"), r), qf, Fb, CB, AX;
let bB = class extends N {
  constructor() {
    super(), Nk(this, CB), Nk(this, qf), Nk(this, Fb), C3(this, Fb, Ce().getControllerById(T.Facemap)), C3(this, qf, new ue(
      this,
      IB(this, Fb).selectLivenessFeedbackMessage$()
    ));
  }
  render() {
    const e = v5e(this, CB, AX).call(this);
    return IB(this, qf).value && e ? w`
          <x-ds-capture-label
            class="capture-state-message"
            data-qa-id="capture-state-message"
            data-size="${Wu.Large}"
            data-text="${e}"
          >
            ${e}
          </x-ds-capture-label>
        ` : q;
  }
};
qf = /* @__PURE__ */ new WeakMap();
Fb = /* @__PURE__ */ new WeakMap();
CB = /* @__PURE__ */ new WeakSet();
AX = function() {
  return {
    [Zr.FaceHoldStillInitial]: y("Hold still…", { id: "jumio_liveness_prompt_hold_still" }),
    [Zr.FaceHoldStill]: y("Keep still", { id: "jumio_liveness_prompt_keep_still" }),
    [Zr.FaceKeepCenterSevere]: y("Put your face in the frame", {
      id: "jumio_liveness_prompt_no_target"
    }),
    [Zr.FaceMoveAway]: y("Move away", { id: "jumio_liveness_prompt_move_away" }),
    [Zr.FaceMoveCloser]: y("Move closer", { id: "jumio_liveness_prompt_too_far" }),
    [Zr.FaceNoneDetected]: y("Put your face in the frame", { id: "jumio_liveness_prompt_no_target" }),
    [Zr.FaceNotUpright]: y("Keep upright", { id: "jumio_liveness_prompt_keep_upright" }),
    [Zr.FaceStopMovement]: y("Keep still", { id: "jumio_liveness_prompt_keep_still" }),
    [Zr.FaceTiltDown]: y("Tilt down", { id: "jumio_liveness_prompt_tilt_down" }),
    [Zr.FaceTiltLeft]: y("Tilt left", { id: "jumio_liveness_prompt_tilt_left" }),
    [Zr.FaceTiltRight]: y("Tilt right", { id: "jumio_liveness_prompt_tilt_right" }),
    [Zr.FaceTiltUp]: y("Tilt up", { id: "jumio_liveness_prompt_tilt_up" }),
    [Zr.Finish]: y("Scanning completed", { id: "jumio_liveness_scanning_completed" }),
    [Zr.KeepFaceCenter]: y("Keep centered", { id: "jumio_liveness_prompt_keep_centered" }),
    [Zr.MoreCapturesNeeded]: y("Let's take another scan", {
      id: "jumio_liveness_prompt_success_another_scan"
    }),
    [Zr.Start]: y("Put your face in the frame", { id: "jumio_liveness_prompt_no_target" })
  }[IB(this, qf).value ?? Zr.Start];
};
bB = m5e([
  be(),
  P("jumio-sdk-liveness-capture-state")
], bB);
var S5e = Object.defineProperty, I5e = Object.getOwnPropertyDescriptor, UX = (e) => {
  throw TypeError(e);
}, C5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? I5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && S5e(t, r, a), a;
}, rT = (e, t, r) => t.has(e) || UX("Cannot " + r), ze = (e, t, r) => (rT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Li = (e, t, r) => t.has(e) ? UX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), X0 = (e, t, r, n) => (rT(e, t, "write to private field"), t.set(e, r), r), yn = (e, t, r) => (rT(e, t, "access private method"), r), uv, Fg, Ry, Tb, hv, Dy, pv, Ga, Gn, zr, kX, nT, yB, _X, NX, ZX, BX, WX, EX, QX, FX, aT, TX, RX, DX;
let wB = class extends N {
  constructor() {
    super(), Li(this, zr), this.cameraRef = Rt(), Li(this, uv, new _e()), Li(this, Fg), Li(this, Ry), Li(this, Tb), Li(this, hv, Rt()), Li(this, Dy), Li(this, pv, new _e()), Li(this, Ga, new _e()), Li(this, Gn), this.onImageCapture = (e) => {
      var n, a, i;
      const t = ve(), r = Tt(oe());
      t.send({ type: r.JumioStandardCaptureScreenCaptureFinish }), Te.cameraCapture(this, {
        metadata: zo(
          {
            width: e.detail.width,
            height: e.detail.height,
            track: bg(),
            devices: fQ(),
            permissionState: pQ()
          },
          ["deviceId", "groupId", "deviceIds", "deviceEntities", "mockDeviceIds", "mockDeviceEntities"]
        )
      }), this.requestUpload({
        uploadFilesMetadata: {
          files: [
            {
              multipartName: `${oe()}_${or.Face}`,
              fileType: OS[e.detail.blob.type],
              uploadType: or.Face,
              usabilityExpected: !0,
              file: e.detail.blob,
              riskSignals: {
                deviceId: ((n = jn()) == null ? void 0 : n.deviceId) ?? "",
                deviceLabel: ((a = jn()) == null ? void 0 : a.label) ?? "",
                groupId: ((i = jn()) == null ? void 0 : i.groupId) ?? ""
              },
              cls: sd(),
              clsm: ld()
            }
          ]
        }
      });
    }, this.requestUpload = (e) => {
      const t = ve(), r = Tt(oe());
      t.send({ type: r.JumioStandardCaptureScreenCaptureFinish }), this.componentController.requestUpload(e);
    }, Li(this, nT, async () => {
      var e;
      rI("JUMIO_STANDARD"), await ((e = this.cameraRef.value) == null ? void 0 : e.captureImage());
    }), X0(this, Gn, Ce().getControllerById(T.Facemap)), this.componentController = new GRe(this), X0(this, Tb, new ue(this, ze(this, Gn).selectLivenessState$())), X0(this, Fg, new ue(this, ur())), X0(this, Ry, new ue(this, yn(this, zr, NX).call(this))), X0(this, Dy, new ue(this, _w())), ze(this, Gn).selectLivenessVisibleFaceFinder$().pipe(ae(d9), le(ze(this, Ga))).subscribe(), ze(this, Gn).selectLivenessBackgroundColor$().pipe(ae(cde), le(ze(this, Ga))).subscribe(), ze(this, Gn).selectLivenessScanning$().pipe(ae(lde), le(ze(this, Ga))).subscribe(), _Q().pipe(ae(sde), le(ze(this, Ga))).subscribe(), yn(this, zr, RX).call(this).pipe(le(ze(this, Ga))).subscribe(), yn(this, zr, DX).call(this).pipe(le(ze(this, Ga))).subscribe(), mt.message$.pipe(
      EW(),
      ae(([e, t]) => {
        if ((e == null ? void 0 : e.id) === ct.LivenessFailed && !t && (e == null ? void 0 : e.id) === ct.LivenessFailed && !t) {
          const r = Tt(oe());
          ve().send({
            type: r.JumioStandardCaptureScreenLivenessRetry
          }), ze(this, Gn).resetJLiveFallbackError();
        }
      }),
      le(ze(this, Ga))
    ).subscribe(), yn(this, zr, TX).call(this).pipe(le(ze(this, Ga))).subscribe();
  }
  connectedCallback() {
    super.connectedCallback(), yn(this, zr, WX).call(this).pipe(le(ze(this, Ga))).subscribe(), yn(this, zr, _X).call(this).pipe(le(ze(this, Ga))).subscribe();
  }
  firstUpdated(e) {
    super.firstUpdated(e), ze(this, pv).next(), ze(this, uv).next(), Te.shownCaptureScreen(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), ze(this, Ga).next(), this.stopStream(), ml.getInstance().exitFullscreen().catch(Pp);
  }
  render() {
    return ze(this, Tb).value ? w`
          <x-ds-app-container
            ${Mt(ze(this, hv))}
            data-type="${An.CaptureScreen}"
            @switchstream="${this.switchStream.bind(this)}"
          >
            <jumio-sdk-navigation-button
              slot="top-left"
              data-type="${De.Tertiary}"
              data-shape="${ya.Round}"
            ></jumio-sdk-navigation-button>
            <x-ds-color-scheme slot="top-middle" data-color-scheme="dark">
              <x-ds-watermark data-version="0.2.14-b10b1242.2"></x-ds-watermark>
            </x-ds-color-scheme>
            <x-ds-button
              class="mobile-only"
              slot="top-right"
              data-type="${De.Tertiary}"
              data-shape="${ya.Round}"
              data-padding="false"
              @jclick="${() => {
      Qg();
    }}"
            >
              <span class="icon-help"></span>
            </x-ds-button>
            <x-ds-button
              class="desktop-only"
              slot="top-right"
              data-type="${De.Tertiary}"
              @jclick="${() => {
      Qg();
    }}"
            >
              <span>${y("Help", { id: "app.nav.help" })}</span>
            </x-ds-button>
            ${yn(this, zr, FX).call(this)}
            <x-camera
              ${Mt(this.cameraRef)}
              slot="background"
              class="camera"
              @imagecaptured="${(e) => {
      this.onImageCapture(e);
    }}"
              @streamresized="${(e) => {
      yn(this, zr, EX).call(this, e);
    }}"
              @cameraplaybackstatus="${(e) => {
      zF(this, e.detail);
    }}"
              @uploadrequest="${(e) => {
      this.requestUpload(e.detail);
    }}"
            >
              ${yn(this, zr, QX).call(this)}
              <jumio-sdk-camera-permissions-screen></jumio-sdk-camera-permissions-screen>
            </x-camera>
            ${yn(this, zr, BX).call(this)} ${yn(this, zr, kX).call(this)}
            <div slot="bottom-left" class="cross-device-container">
              <jumio-sdk-cross-device-button
                data-fluid="false"
                data-type="${De.Tertiary}"
              ></jumio-sdk-cross-device-button>
            </div>
            <jumio-sdk-capture-hints slot="overlay" class="overlay">
              <ul slot="tips">
                <li>${y("Make sure you are in a well-lit environment", { id: "start.instructions.06" })}</li>
                <li>
                  ${y("Look straight into the camera", {
      id: "jumio_liveness_prompt_look_straight_into_the_camera"
    })}
                </li>
              </ul>
              ${PRe() ? w`<x-ds-button
                    slot="secondary-action-button"
                    data-type="${De.Secondary}"
                    data-fluid="true"
                    @click="${() => {
      ze(this, Gn).setJLiveManualCaptureFallbackReason(
        nt.UserSelection
      );
    }}"
                    >${y("Take photo manually", { id: "jumio_id_scan_tips_button_fallback" })}
                  </x-ds-button>` : q}
            </jumio-sdk-capture-hints>
          </x-ds-app-container>
        ` : q;
  }
  switchStream(e) {
    return (e instanceof Uw || e instanceof Il) && this.cameraRef.value ? this.cameraRef.value.switchStream(e) : Promise.reject(new GS("switchStream: Camera could not be started"));
  }
  stopStream() {
    var e;
    (e = this.cameraRef.value) == null || e.stopStream();
  }
  handleCameraSwitch(e) {
    return this.switchStream(e);
  }
};
uv = /* @__PURE__ */ new WeakMap();
Fg = /* @__PURE__ */ new WeakMap();
Ry = /* @__PURE__ */ new WeakMap();
Tb = /* @__PURE__ */ new WeakMap();
hv = /* @__PURE__ */ new WeakMap();
Dy = /* @__PURE__ */ new WeakMap();
pv = /* @__PURE__ */ new WeakMap();
Ga = /* @__PURE__ */ new WeakMap();
Gn = /* @__PURE__ */ new WeakMap();
zr = /* @__PURE__ */ new WeakSet();
kX = function() {
  return iX(ze(this, Fg).value) ? w`
          <x-ds-capture-button
            slot="capture-button"
            data-qa-id="capture-button"
            data-disabled="${!yn(this, zr, ZX).call(this)}"
            @click="${() => ze(this, nT).call(this)}"
          ></x-ds-capture-button>
        ` : q;
};
nT = /* @__PURE__ */ new WeakMap();
yB = function() {
  const e = ze(this, Ry).value;
  return (e == null ? void 0 : e.type) === An.CaptureScreen && (e == null ? void 0 : e.variant) === Bu.Small ? qa.Horizontal : qa.Vertical;
};
_X = function() {
  return ps(ze(this, uv), tI).pipe(
    Wt(() => ZQ(this.cameraRef, ze(this, pv))),
    Xc(yS),
    Wt(
      (e) => this.switchStream(
        new Il({
          videoElement: e,
          constraints: {
            video: {
              aspectRatio: {
                ideal: 16 / 9
              },
              height: {
                ideal: dm() ? 1080 : 1920,
                max: dm() ? 1080 : 1920
              },
              facingMode: {
                ideal: kw.User
              }
            },
            audio: !1
          }
        })
      )
    )
  );
};
NX = function() {
  return Bl(ze(this, hv), ze(this, pv)).pipe(
    Wt((e) => e.layout$)
  );
};
ZX = function() {
  return !!ze(this, Dy).value && ze(this, Fg).value === x.JumioStandardCaptureScreenSelfie;
};
BX = function() {
  return w`
      <div
        slot="camera-selector"
        class="camera-selector-container"
        data-orientation="${yn(this, zr, yB).call(this)}"
      >
        <x-camera-selector
          class="camera-selector"
          @switchcamera="${(e) => this.handleCameraSwitch(e)}"
          .orientation="${yn(this, zr, yB).call(this)}"
        ></x-camera-selector>
      </div>
    `;
};
WX = function() {
  return bQ(ze(this, uv));
};
EX = function(e) {
  kQ({
    width: e.detail.sourceWidth,
    height: e.detail.sourceHeight
  });
};
QX = function() {
  return HRe(ze(this, Fg).value) ? w`
        <x-ds-face-finder slot="underlay"></x-ds-face-finder>
        <x-ds-top-message-container slot="video-width-after">
          <jumio-sdk-step-facemap-capture-state></jumio-sdk-step-facemap-capture-state>
        </x-ds-top-message-container>
      ` : w`
      <x-ds-face-finder slot="underlay"></x-ds-face-finder>
      <jumio-sdk-liveness slot="video-overlay" .cameraRef="${this.cameraRef}"></jumio-sdk-liveness>
      <x-ds-top-message-container slot="video-width-after">
        <jumio-sdk-step-facemap-capture-state>
          <jumio-sdk-liveness-capture-state></jumio-sdk-liveness-capture-state>
        </jumio-sdk-step-facemap-capture-state>
      </x-ds-top-message-container>
    `;
};
FX = function() {
  const e = ze(this, Gn).getActiveFaceVerificationMethod();
  return e && yn(this, zr, aT).call(this, e) ? w`
          <x-ds-fullscreen-mode-button
            slot="top-right"
            .elRef="${ze(this, hv)}"
          ></x-ds-fullscreen-mode-button>
        ` : q;
};
aT = function(e) {
  return !_l() && e === ei.JumioPremium;
};
TX = function() {
  return ze(this, Gn).selectActiveFaceVerificationMethod$().pipe(
    ae((e) => {
      e && yn(this, zr, aT).call(this, e) ? ml.getInstance().enterFullscreen().catch(Pp) : ml.getInstance().exitFullscreen().catch(Pp);
    })
  );
};
RX = function() {
  return ze(this, Gn).selectJLiveManualCaptureFallbackReason$().pipe(
    at((e) => !!e),
    ae((e) => {
      const t = Ce(), r = ve(), n = Tt(oe()), { step: a } = qH();
      t.getLoggerManager().log(
        cL({
          metadata: {
            reason: e,
            step: a
          }
        })
      ), ze(this, Gn).setActiveFaceVerificationMethod(ei.JumioStandard), ze(this, Gn).setLivenessVisibleFaceFinder("near"), r.send({
        type: n.JumioStandardCaptureScreenSelfie
      });
    })
  );
};
DX = function() {
  return ze(this, Gn).selectJLiveFallbackError$().pipe(
    at((e) => !!e),
    ae(() => {
      const { title: e, message: t } = Tw[rt.UsabilityError];
      mt.showMessageIfPossible({
        id: ct.LivenessFailed,
        type: Fr.Error,
        title: y(e.label, { id: e.id }),
        message: y(t.label, { id: t.id }),
        errorCode: `${rt.UsabilityError}`,
        closable: !0,
        date: /* @__PURE__ */ new Date(),
        transactionId: Ec()
      });
    })
  );
};
wB.styles = [
  ...N.styles,
  Gt(QRe),
  Gt(XF),
  ee`
      .mobile-only {
        display: block;
      }

      .desktop-only {
        display: none;
      }

      @media only screen and (min-width: 40em) {
        .mobile-only {
          display: none;
        }

        .desktop-only {
          display: block;
        }
      }
    `
];
wB = C5e([
  be(),
  P("jumio-sdk-step-facemap-jumio-standard-capture")
], wB);
const b5e = `:host{display:flex;height:100%;flex-direction:column;justify-content:center}.usability-check{display:flex;height:100%;flex-direction:column;justify-content:center}.title{margin-block:0}.error-icon{width:8em;height:10em;background-position:center center;background-repeat:no-repeat;background-size:contain}.error-icon--eyes-closed,.error-icon--face-obscured{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='-1'%20width='128'%20height='161'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080.001-63.555%2080.001S0%20124.182%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cpath%20fill-rule='evenodd'%20d='M50.595%20125.35l-.287%204.301c-.257%203.849-.94%207.788-3.219%2010.9-.88%201.202-1.852%202.142-2.74%202.142-1.086%200%20.281%203.111.281%203.111s6.465%203.685%2019.501%203.685%2019.728-3.402%2019.728-3.402%201.042-1.867-1.477-3.394-3.042-4.336-3.042-4.336l-.341-1.598a33.01%2033.01%200%200%201-.656-4.721l-.44-6.688H50.595z'%20fill='%23dfe5ec'/%3e%3cpath%20opacity='.402'%20fill-rule='evenodd'%20d='M50.513%20129.651l.287-4.301h6.935%2020.373l.44%206.688a33.01%2033.01%200%200%200%20.656%204.721l.341%201.598s.483%202.596%202.759%204.154c-.823.207-2.085.192-2.748.184l-.262-.002c-17.205%200-22.484-5.757-25.607-9.163-1.233-1.345-2.13-2.323-3.293-2.436.048-.481.086-.963.119-1.443z'%20fill='%239aa4af'/%3e%3cpath%20d='M98.238%2081.902c0%205.998-1.297%2015.872%203.609%2015.872s14.16-9.874%2014.16-15.872-3.978-10.859-8.885-10.859-8.884%204.862-8.884%2010.859zm-67.345%200c0%205.998%201.298%2015.872-3.609%2015.872s-14.16-9.874-14.16-15.872%203.978-10.859%208.885-10.859%208.885%204.862%208.885%2010.859z'%20fill='%23dfe5ec'/%3e%3cpath%20d='M100.009%2082.407c0%204.123-.884%2010.912%202.46%2010.912s9.651-6.788%209.651-10.912-2.711-7.466-6.056-7.466-6.055%203.343-6.055%207.466zm-70.887%200c0%204.123.884%2010.912-2.46%2010.912s-9.651-6.788-9.651-10.912%202.711-7.466%206.055-7.466%206.055%203.343%206.055%207.466z'%20fill='%23c6cdd5'/%3e%3cpath%20fill-rule='evenodd'%20d='M64.488%2023.149c22.541%200%2040.813%2016.017%2040.813%2035.775v11.005h-.097v5.874c0%20.217.01.579.024%201.07.184%206.58%201.012%2036.174-13.378%2045.481-9.152%205.92-11.972%207.117-13.478%207.757-1.038.441-1.452.616-2.886%201.892-2.907%202.585-4.794%202.563-8.955%202.515l-1.995-.015-1.995.015c-4.139.048-5.953.069-8.859-2.515-1.42-1.263-1.871-1.448-2.925-1.879-1.554-.637-4.418-1.81-13.633-7.77-14.39-9.307-13.562-38.901-13.378-45.481l.024-1.07v-5.874h-.097V58.924c0-19.758%2018.273-35.774%2040.813-35.774z'%20fill='%23dfe5ec'/%3e%3cpath%20fill-rule='evenodd'%20d='M124.764%20172.958H.723c.114-25.609%2024.066-27.457%2045.307-31.164%202.372%203.283%2012.769%205.555%2018.701%205.555%206.037%200%2013.78-2.352%2016.095-5.729%2021.712%203.498%2043.902%205.729%2043.938%2031.338z'%20fill='%23757f8a'/%3e%3crect%20x='7.5'%20y='59'%20width='112'%20height='40'%20rx='18'%20fill='%23c6cdd5'/%3e%3c/g%3e%3cpath%20fill-rule='evenodd'%20d='M5.415%2053.214a.95.95%200%200%201-.913-1.216c5.858-19.73%2017.726-35.769%2032.801-44.587.642-.375%201.437.094%201.437.838%200%20.351-.188.674-.49.851C23.663%2017.643%2012.07%2033.209%206.338%2052.521c-.121.409-.496.693-.923.693zm.106%2053.925a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.464%2032.694%2044.229.642.375%201.437-.095%201.437-.838%200-.351-.188-.674-.491-.851-14.498-8.492-26.038-23.921-31.806-43.071-.123-.407-.497-.689-.922-.689zm117.069%200c-.425%200-.799.282-.922.689-5.767%2019.15-17.308%2034.579-31.806%2043.071-.303.177-.49.5-.49.851%200%20.743.795%201.213%201.437.838%2014.984-8.765%2026.8-24.663%2032.694-44.229a.95.95%200%200%200-.912-1.22zm.106-53.925a.95.95%200%200%200%20.913-1.216c-5.857-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838%200%20.351.188.674.49.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.122.409.497.693.923.693z'%20fill='%233e4753'/%3e%3c/svg%3e")}.error-icon--face-verification-failed{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='-1'%20width='128'%20height='161'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080.001-63.555%2080.001S0%20124.182%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cpath%20fill-rule='evenodd'%20d='M50.595%20125.35l-.287%204.301c-.257%203.849-.94%207.788-3.22%2010.9-.88%201.202-1.852%202.142-2.74%202.142-1.086%200%20.28%203.111.28%203.111s6.465%203.685%2019.501%203.685%2019.728-3.402%2019.728-3.402%201.042-1.867-1.477-3.394-3.041-4.336-3.041-4.336l-.341-1.598a33.01%2033.01%200%200%201-.656-4.721l-.44-6.688H50.595z'%20fill='%23dfe5ec'/%3e%3cpath%20opacity='.402'%20fill-rule='evenodd'%20d='M50.513%20129.651l.287-4.301h6.935%2020.373l.44%206.688a33.01%2033.01%200%200%200%20.656%204.721l.341%201.598s.483%202.596%202.759%204.154c-.823.207-2.085.192-2.748.184l-.262-.002c-17.205%200-22.484-5.757-25.607-9.163-1.233-1.345-2.13-2.323-3.293-2.436.048-.481.086-.963.118-1.443z'%20fill='%239aa4af'/%3e%3cpath%20d='M98.238%2081.902c0%205.998-1.297%2015.872%203.609%2015.872s14.16-9.874%2014.16-15.872-3.978-10.859-8.885-10.859-8.884%204.862-8.884%2010.859zm-67.345%200c0%205.998%201.297%2015.872-3.609%2015.872s-14.16-9.874-14.16-15.872%203.978-10.859%208.885-10.859%208.885%204.862%208.885%2010.859z'%20fill='%23dfe5ec'/%3e%3cpath%20d='M100.009%2082.407c0%204.123-.884%2010.912%202.46%2010.912s9.651-6.788%209.651-10.912-2.711-7.466-6.056-7.466-6.055%203.343-6.055%207.466zm-70.887%200c0%204.123.884%2010.912-2.46%2010.912s-9.651-6.788-9.651-10.912%202.711-7.466%206.055-7.466%206.055%203.343%206.055%207.466z'%20fill='%23c6cdd5'/%3e%3cpath%20fill-rule='evenodd'%20d='M64.488%2023.149c22.541%200%2040.813%2016.017%2040.813%2035.775v11.005h-.097v5.874c0%20.217.01.579.024%201.07.184%206.58%201.012%2036.174-13.378%2045.481-9.152%205.92-11.972%207.117-13.477%207.757-1.038.441-1.452.616-2.886%201.892-2.907%202.585-4.794%202.563-8.955%202.515l-1.996-.015-1.995.015c-4.139.048-5.953.069-8.859-2.515-1.42-1.263-1.871-1.448-2.925-1.879-1.554-.637-4.418-1.81-13.633-7.77-14.39-9.307-13.562-38.901-13.378-45.481l.024-1.07v-5.874h-.097V58.924c0-19.758%2018.273-35.774%2040.813-35.774z'%20fill='%23dfe5ec'/%3e%3cpath%20fill-rule='evenodd'%20d='M124.764%20172.958H.723c.114-25.609%2024.066-27.457%2045.307-31.164%202.372%203.283%2012.769%205.555%2018.701%205.555%206.037%200%2013.78-2.352%2016.095-5.729%2021.712%203.498%2043.901%205.729%2043.938%2031.338z'%20fill='%23757f8a'/%3e%3c/g%3e%3cpath%20fill-rule='evenodd'%20d='M4.915%2053.215a.95.95%200%200%201-.913-1.216C9.86%2032.268%2021.728%2016.229%2036.803%207.411c.642-.375%201.437.094%201.437.838%200%20.351-.188.674-.491.851C23.163%2017.644%2011.57%2033.209%205.838%2052.522c-.121.409-.496.693-.923.693zm.106%2053.924a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.465%2032.694%2044.229.642.375%201.437-.094%201.437-.838%200-.351-.188-.674-.491-.851-14.498-8.492-26.038-23.921-31.806-43.071-.123-.407-.497-.689-.922-.689zm117.069%200c-.425%200-.799.282-.922.689-5.767%2019.15-17.308%2034.58-31.806%2043.071-.303.177-.49.5-.49.851%200%20.744.795%201.213%201.437.838%2014.984-8.764%2026.8-24.663%2032.694-44.229a.95.95%200%200%200-.912-1.22zm.106-53.924a.95.95%200%200%200%20.913-1.216c-5.857-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838%200%20.351.188.674.49.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.122.409.497.693.923.693z'%20fill='%233e4753'/%3e%3c/svg%3e")}.error-icon--multiple-people-detected{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cstyle%3e%3c![CDATA[.B{fill-rule:evenodd}.C{fill:%23c6cdd5}.D{fill:%23dfe5ec}]]%3e%3c/style%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='-1'%20width='128'%20height='161'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080.001-63.555%2080.001S0%20124.182%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cpath%20d='M73.63%20123.838l-.183%202.765c-.253%203.819-.773%207.864-3.291%2010.745-.58.663-1.184%201.12-1.747%201.12-.908%200%20.234%202.625.234%202.625s5.405%203.109%2016.302%203.109%2016.492-2.871%2016.492-2.871.871-1.574-1.235-2.863-2.543-3.657-2.543-3.657l-.212-1.003c-.326-1.542-.542-3.107-.644-4.68l-.345-5.29H73.63z'%20class='B%20C'/%3e%3cpath%20opacity='.402'%20d='M73.619%20126.603l.183-2.765h5.797%2017.03l.345%205.29c.103%201.573.318%203.138.644%204.68l.212%201.003s.403%202.189%202.306%203.503c-.688.175-1.743.163-2.297.156l-.219-.002c-14.383%200-18.795-4.856-21.406-7.729-1.037-1.141-1.789-1.97-2.769-2.057a53.92%2053.92%200%200%200%20.173-2.079z'%20fill='%239aa4af'%20class='B'/%3e%3cpath%20d='M113.457%2087.186c0%205.059-1.085%2013.389%203.017%2013.389s11.837-8.33%2011.837-13.389-3.326-9.161-7.427-9.161-7.427%204.102-7.427%209.161zm-56.296%200c0%205.059%201.085%2013.389-3.017%2013.389s-11.837-8.33-11.837-13.389%203.325-9.161%207.427-9.161%207.427%204.102%207.427%209.161z'%20class='C'/%3e%3cpath%20d='M114.938%2087.612c0%203.478-.739%209.205%202.056%209.205s8.068-5.727%208.068-9.205-2.267-6.298-5.062-6.298-5.062%202.82-5.062%206.298zm-59.258%200c0%203.478.739%209.205-2.056%209.205s-8.067-5.727-8.067-9.205%202.266-6.298%205.062-6.298%205.062%202.82%205.062%206.298z'%20class='C'/%3e%3cpath%20d='M85.244%2037.623c18.842%200%2034.117%2013.511%2034.117%2030.179v9.284h-.081v4.955c0%20.183.009.489.02.902.154%205.551.846%2030.515-11.183%2038.367-7.65%204.993-10.007%206.004-11.266%206.543-.868.372-1.214.52-2.413%201.596-2.43%202.181-4.008%202.163-7.486%202.122l-1.668-.012-1.667.012c-3.46.041-4.976.059-7.406-2.122-1.187-1.065-1.564-1.221-2.445-1.585-1.299-.537-3.693-1.526-11.396-6.554-12.029-7.852-11.337-32.817-11.183-38.367l.02-.902v-4.955h-.081v-9.284c0-16.667%2015.275-30.179%2034.117-30.179z'%20class='B%20C'/%3e%3cpath%20d='M135.632%20163.999H31.941c.096-21.603%2020.118-23.162%2037.874-26.289%201.982%202.77%2010.674%204.686%2015.633%204.686%205.046%200%2011.519-1.984%2013.454-4.833%2018.151%202.951%2036.698%204.833%2036.731%2026.436z'%20fill='%235c6570'%20class='B'/%3e%3cpath%20d='M38.595%20127.35l-.287%204.301c-.257%203.849-.94%207.788-3.219%2010.9-.88%201.202-1.852%202.142-2.74%202.142-1.086%200%20.281%203.111.281%203.111s6.465%203.685%2019.501%203.685%2019.728-3.402%2019.728-3.402%201.042-1.867-1.477-3.394-3.042-4.336-3.042-4.336l-.341-1.598a33.01%2033.01%200%200%201-.656-4.721l-.44-6.688H38.595z'%20class='B%20D'/%3e%3cpath%20opacity='.402'%20d='M38.513%20131.651l.287-4.301h6.935%2020.373l.44%206.688a33.01%2033.01%200%200%200%20.656%204.721l.341%201.598s.483%202.596%202.759%204.154c-.823.207-2.085.192-2.748.184l-.262-.002c-17.205%200-22.484-5.757-25.607-9.163-1.233-1.345-2.13-2.323-3.293-2.436.048-.481.086-.963.119-1.443z'%20fill='%239aa4af'%20class='B'/%3e%3cpath%20d='M86.238%2083.902c0%205.998-1.297%2015.872%203.609%2015.872s14.16-9.874%2014.16-15.872-3.978-10.859-8.885-10.859-8.885%204.862-8.885%2010.859zm-67.345%200c0%205.998%201.297%2015.872-3.609%2015.872S1.124%2089.9%201.124%2083.902s3.978-10.859%208.885-10.859%208.885%204.862%208.885%2010.859z'%20class='D'/%3e%3cpath%20d='M88.009%2084.407c0%204.123-.884%2010.912%202.46%2010.912s9.651-6.788%209.651-10.912-2.711-7.466-6.056-7.466-6.055%203.343-6.055%207.466zm-70.887%200c0%204.123.884%2010.912-2.46%2010.912s-9.65-6.788-9.65-10.912%202.711-7.466%206.055-7.466%206.055%203.343%206.055%207.466z'%20class='C'/%3e%3cpath%20d='M52.488%2025.149c22.541%200%2040.813%2016.017%2040.813%2035.775v11.005h-.097v5.874c0%20.217.01.579.024%201.07.184%206.58%201.012%2036.174-13.378%2045.481-9.152%205.92-11.972%207.117-13.478%207.757-1.038.441-1.452.616-2.886%201.892-2.907%202.585-4.794%202.563-8.955%202.515l-1.995-.015-1.995.015c-4.139.048-5.953.069-8.859-2.515-1.42-1.263-1.871-1.448-2.925-1.879-1.554-.637-4.418-1.81-13.633-7.77-14.39-9.307-13.562-38.901-13.378-45.481l.024-1.07v-5.874h-.097V60.924c0-19.758%2018.273-35.774%2040.813-35.774z'%20class='B%20D'/%3e%3cpath%20d='M112.764%20174.958H-11.277c.114-25.609%2024.066-27.457%2045.307-31.164%202.372%203.283%2012.769%205.555%2018.701%205.555%206.037%200%2013.78-2.352%2016.095-5.729%2021.713%203.498%2043.902%205.729%2043.938%2031.338z'%20fill='%23757f8a'%20class='B'/%3e%3c/g%3e%3cpath%20d='M4.915%2053.214a.95.95%200%200%201-.913-1.216C9.86%2032.268%2021.728%2016.229%2036.803%207.411c.642-.375%201.437.094%201.437.838%200%20.351-.188.674-.49.851C23.163%2017.643%2011.57%2033.209%205.838%2052.521c-.121.409-.496.693-.923.693zm.106%2053.925a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.464%2032.694%2044.229.642.375%201.437-.095%201.437-.838%200-.351-.188-.674-.491-.851-14.498-8.492-26.038-23.921-31.806-43.071-.123-.407-.497-.689-.922-.689zm117.069%200c-.425%200-.799.282-.922.689-5.767%2019.15-17.308%2034.579-31.806%2043.071-.303.177-.49.5-.49.851%200%20.743.795%201.213%201.437.838%2014.984-8.765%2026.8-24.663%2032.694-44.229a.95.95%200%200%200-.912-1.22zm.106-53.925a.95.95%200%200%200%20.913-1.216c-5.857-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838%200%20.351.188.674.49.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.122.409.497.693.923.693z'%20fill='%233e4753'%20class='B'/%3e%3c/svg%3e")}.error-icon--too-dark{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='-1'%20width='128'%20height='161'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080.001-63.555%2080.001S0%20124.182%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cg%20opacity='.6'%3e%3cpath%20fill-rule='evenodd'%20d='M50.595%20125.35l-.287%204.301c-.257%203.849-.94%207.788-3.219%2010.9-.88%201.202-1.852%202.142-2.74%202.142-1.086%200%20.281%203.111.281%203.111s6.465%203.685%2019.501%203.685%2019.728-3.402%2019.728-3.402%201.042-1.867-1.477-3.394-3.041-4.336-3.041-4.336l-.341-1.598a33.01%2033.01%200%200%201-.656-4.721l-.44-6.688H50.595z'%20fill='%23dfe5ec'/%3e%3cpath%20opacity='.402'%20fill-rule='evenodd'%20d='M50.513%20129.651l.287-4.301h6.935%2020.373l.44%206.688a33.01%2033.01%200%200%200%20.656%204.721l.341%201.598s.483%202.596%202.759%204.154c-.823.207-2.085.192-2.748.184l-.262-.002c-17.205%200-22.484-5.757-25.607-9.163-1.233-1.345-2.13-2.323-3.293-2.436.048-.481.086-.963.119-1.443z'%20fill='%239aa4af'/%3e%3cpath%20d='M98.238%2081.902c0%205.998-1.297%2015.872%203.609%2015.872s14.16-9.874%2014.16-15.872-3.978-10.859-8.885-10.859-8.885%204.862-8.885%2010.859zm-67.345%200c0%205.998%201.298%2015.872-3.609%2015.872s-14.16-9.874-14.16-15.872%203.978-10.859%208.885-10.859%208.885%204.862%208.885%2010.859z'%20fill='%23dfe5ec'/%3e%3cpath%20d='M100.009%2082.407c0%204.123-.884%2010.912%202.46%2010.912s9.651-6.788%209.651-10.912-2.711-7.466-6.056-7.466-6.055%203.343-6.055%207.466zm-70.888%200c0%204.123.884%2010.912-2.46%2010.912s-9.651-6.788-9.651-10.912%202.711-7.466%206.055-7.466%206.055%203.343%206.055%207.466z'%20fill='%23c6cdd5'/%3e%3cpath%20fill-rule='evenodd'%20d='M64.487%2023.149c22.541%200%2040.814%2016.017%2040.814%2035.775v11.005h-.097v5.874c0%20.217.01.579.024%201.07.184%206.58%201.012%2036.174-13.378%2045.481-9.152%205.92-11.972%207.117-13.477%207.757-1.038.441-1.452.616-2.886%201.892-2.907%202.585-4.794%202.563-8.955%202.515l-1.996-.015-1.995.015c-4.139.048-5.953.069-8.859-2.515-1.42-1.263-1.871-1.448-2.925-1.879-1.554-.637-4.418-1.81-13.633-7.77-14.39-9.307-13.562-38.901-13.378-45.481l.024-1.07v-5.874h-.097V58.924c0-19.758%2018.273-35.774%2040.813-35.774z'%20fill='%23dfe5ec'/%3e%3cpath%20fill-rule='evenodd'%20d='M124.765%20172.958H.723c.114-25.609%2024.066-27.457%2045.307-31.164%202.372%203.283%2012.769%205.555%2018.701%205.555%206.037%200%2013.78-2.352%2016.095-5.729%2021.712%203.498%2043.901%205.729%2043.939%2031.338z'%20fill='%23757f8a'/%3e%3c/g%3e%3cellipse%20opacity='.6'%20cx='63.556'%20cy='80'%20rx='63.556'%20ry='80'%20fill='%23757f8a'/%3e%3c/g%3e%3cpath%20fill-rule='evenodd'%20d='M4.915%2053.215a.95.95%200%200%201-.913-1.217c5.858-19.73%2017.726-35.769%2032.801-44.587.642-.375%201.437.094%201.437.838%200%20.351-.188.674-.491.851C23.163%2017.644%2011.57%2033.209%205.838%2052.522c-.121.409-.496.693-.923.693zm.106%2053.924a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.465%2032.694%2044.229.642.375%201.437-.094%201.437-.838%200-.351-.188-.674-.491-.851-14.498-8.492-26.038-23.921-31.806-43.071-.123-.407-.497-.689-.922-.689zm117.069%200c-.425%200-.799.282-.922.689-5.768%2019.15-17.308%2034.58-31.806%2043.071-.303.177-.491.5-.491.851%200%20.744.795%201.213%201.437.838%2014.984-8.764%2026.8-24.663%2032.694-44.229a.95.95%200%200%200-.912-1.22zm.106-53.924a.95.95%200%200%200%20.913-1.217c-5.858-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838%200%20.351.188.674.491.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.121.409.497.693.923.693z'%20fill='%233e4753'/%3e%3c/svg%3e")}.error-icon--too-much-light{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cstyle%3e%3c![CDATA[.B{fill-rule:evenodd}.C{fill:%23dfe5ec}]]%3e%3c/style%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='-1'%20width='128'%20height='161'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080.001-63.555%2080.001S0%20124.182%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cellipse%20cx='63.556'%20cy='80'%20rx='63.556'%20ry='80'%20fill='%23f5f7fa'/%3e%3cg%20opacity='.6'%3e%3cpath%20d='M50.595%20125.35l-.287%204.301c-.257%203.849-.94%207.788-3.219%2010.9-.88%201.202-1.852%202.142-2.74%202.142-1.086%200%20.281%203.111.281%203.111s6.465%203.685%2019.501%203.685%2019.728-3.402%2019.728-3.402%201.042-1.867-1.477-3.394-3.041-4.336-3.041-4.336l-.341-1.598a33.01%2033.01%200%200%201-.656-4.721l-.44-6.688H50.595z'%20class='B%20C'/%3e%3cpath%20opacity='.402'%20d='M50.513%20129.651l.287-4.301h6.935%2020.373l.44%206.688a33.01%2033.01%200%200%200%20.656%204.721l.341%201.598s.483%202.596%202.759%204.154c-.823.207-2.085.192-2.748.184l-.262-.002c-17.205%200-22.484-5.757-25.607-9.163-1.233-1.345-2.13-2.323-3.293-2.436.048-.481.086-.963.119-1.443z'%20fill='%239aa4af'%20class='B'/%3e%3cpath%20d='M98.238%2081.902c0%205.998-1.297%2015.872%203.609%2015.872s14.16-9.874%2014.16-15.872-3.978-10.859-8.885-10.859-8.885%204.862-8.885%2010.859zm-67.345%200c0%205.998%201.298%2015.872-3.609%2015.872s-14.16-9.874-14.16-15.872%203.978-10.859%208.885-10.859%208.885%204.862%208.885%2010.859z'%20class='C'/%3e%3cpath%20d='M100.009%2082.407c0%204.123-.884%2010.912%202.46%2010.912s9.651-6.788%209.651-10.912-2.711-7.466-6.056-7.466-6.055%203.343-6.055%207.466zm-70.888%200c0%204.123.884%2010.912-2.46%2010.912s-9.651-6.788-9.651-10.912%202.711-7.466%206.055-7.466%206.055%203.343%206.055%207.466z'%20fill='%23c6cdd5'/%3e%3cpath%20d='M64.487%2023.149c22.541%200%2040.814%2016.017%2040.814%2035.775v11.005h-.097v5.874c0%20.217.01.579.024%201.07.184%206.58%201.012%2036.174-13.378%2045.481-9.152%205.92-11.972%207.117-13.477%207.757-1.038.441-1.452.616-2.886%201.892-2.907%202.585-4.794%202.563-8.955%202.515l-1.996-.015-1.995.015c-4.139.048-5.953.069-8.859-2.515-1.42-1.263-1.871-1.448-2.925-1.879-1.554-.637-4.418-1.81-13.633-7.77-14.39-9.307-13.562-38.901-13.378-45.481l.024-1.07v-5.874h-.097V58.924c0-19.758%2018.273-35.774%2040.813-35.774z'%20class='B%20C'/%3e%3cpath%20d='M124.765%20172.958H.723c.114-25.609%2024.066-27.457%2045.307-31.164%202.372%203.283%2012.769%205.555%2018.701%205.555%206.037%200%2013.78-2.352%2016.095-5.729%2021.712%203.498%2043.901%205.729%2043.939%2031.338z'%20fill='%23757f8a'%20class='B'/%3e%3c/g%3e%3cellipse%20opacity='.2'%20cx='63.556'%20cy='80'%20rx='63.556'%20ry='80'%20class='C'/%3e%3cg%20style='mix-blend-mode:lighten'%3e%3cellipse%20cx='63.556'%20cy='80'%20rx='63.556'%20ry='80'%20fill='url(%23B)'/%3e%3c/g%3e%3c/g%3e%3cpath%20d='M4.915%2053.215a.95.95%200%200%201-.913-1.216c5.858-19.73%2017.726-35.769%2032.801-44.587.642-.375%201.437.094%201.437.838%200%20.351-.188.674-.491.851C23.163%2017.644%2011.57%2033.209%205.838%2052.522c-.121.409-.496.693-.923.693zm.106%2053.924a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.465%2032.694%2044.229.642.375%201.437-.094%201.437-.838%200-.351-.188-.674-.491-.851-14.498-8.492-26.038-23.921-31.806-43.071-.123-.407-.497-.689-.922-.689zm117.069%200c-.425%200-.799.282-.922.689-5.768%2019.15-17.308%2034.58-31.806%2043.071-.303.177-.491.5-.491.851%200%20.744.795%201.213%201.437.838%2014.984-8.764%2026.8-24.663%2032.694-44.229a.95.95%200%200%200-.912-1.22zm.106-53.924a.95.95%200%200%200%20.913-1.216c-5.858-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838%200%20.351.188.674.491.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.121.409.497.693.923.693z'%20fill='%233e4753'%20class='B'/%3e%3cdefs%3e%3cradialGradient%20id='B'%20cx='0'%20cy='0'%20r='1'%20gradientUnits='userSpaceOnUse'%20gradientTransform='translate(63.5556%2079.9995)%20rotate(90)%20scale(80%2063.5556)'%3e%3cstop%20stop-color='%23fff'/%3e%3cstop%20offset='1'%20stop-color='%23fff'%20stop-opacity='0'/%3e%3c/radialGradient%3e%3c/defs%3e%3c/svg%3e")}.error-icon--too-much-movement{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='160'%20fill='none'%3e%3cmask%20id='A'%20maskUnits='userSpaceOnUse'%20x='0'%20y='-1'%20width='128'%20height='161'%3e%3cpath%20d='M127.111%2080c0%2044.183-28.455%2080.001-63.555%2080.001S0%20124.182%200%2080%2028.455%200%2063.556%200s63.555%2035.817%2063.555%2080z'%20fill='%23f5f7fa'/%3e%3c/mask%3e%3cg%20mask='url(%23A)'%3e%3cpath%20fill-rule='evenodd'%20d='M43.974%20133.845l.389%204.293c.348%203.842.289%207.839-1.475%2011.27-.681%201.325-1.494%202.405-2.371%202.544-1.073.17.764%203.029.764%203.029s6.962%202.628%2019.838.589%2018.953-6.447%2018.953-6.447.737-2.006-1.99-3.121-3.682-3.806-3.682-3.806l-.587-1.526c-.571-1.484-1.035-3.009-1.386-4.56l-1.481-6.537-26.972%204.272z'%20fill='%23dfe5ec'/%3e%3cpath%20opacity='.402'%20fill-rule='evenodd'%20d='M44.565%20138.106l-.389-4.293%206.85-1.085%2020.122-3.187%201.481%206.537c.352%201.551.815%203.076%201.386%204.56l.587%201.525s.883%202.489%203.374%203.671c-.78.333-2.029.516-2.685.612l-.259.039c-16.994%202.692-23.108-2.169-26.725-5.044-1.428-1.135-2.467-1.961-3.633-1.891-.028-.483-.065-.964-.109-1.444z'%20fill='%239aa4af'/%3e%3cpath%20d='M84.233%2083.479c.938%205.924%201.201%2015.879%206.048%2015.111s12.441-11.968%2011.503-17.891-5.628-10.103-10.474-9.336-8.015%206.192-7.076%2012.116zM17.718%2094.014c.938%205.924%203.764%2015.473-1.082%2016.241S1.106%20102.718.168%2096.794s2.23-11.348%207.076-12.116%209.536%203.412%2010.474%209.336z'%20fill='%23dfe5ec'/%3e%3cpath%20d='M86.062%2083.701c.645%204.073.834%2010.916%204.137%2010.393s8.47-8.215%207.825-12.287-3.846-6.95-7.149-6.427-5.458%204.249-4.813%208.321zM16.047%2094.79c.645%204.073%202.58%2010.639-.723%2011.162S4.73%20100.757%204.085%2096.684s1.51-7.798%204.813-8.321%206.504%202.354%207.149%206.427z'%20fill='%23c6cdd5'/%3e%3cpath%20fill-rule='evenodd'%20d='M41.708%2030.73c22.263-3.526%2042.817%209.435%2045.907%2028.949l1.722%2010.869-.096.015.919%205.801c.034.214.101.571.191%201.053%201.211%206.47%206.658%2035.57-6.098%2047.014-8.113%207.278-10.711%208.902-12.098%209.769-.957.598-1.338.836-2.555%202.32-2.466%203.008-4.334%203.282-8.451%203.885l-1.973.298-1.968.327c-4.081.695-5.869.999-9.143-1.099-1.6-1.025-2.075-1.137-3.183-1.398-1.634-.386-4.646-1.096-14.68-5.542-15.669-6.941-19.481-36.3-20.328-42.828l-.144-1.06-.919-5.801-.096.015-1.722-10.869C3.903%2052.934%2019.445%2034.256%2041.708%2030.73z'%20fill='%23dfe5ec'/%3e%3cpath%20fill-rule='evenodd'%20d='M124.678%20169.264L2.164%20188.669c-3.893-25.312%2019.475-30.884%2039.874-37.868%202.856%202.871%2013.481%203.489%2019.34%202.561%205.962-.944%2013.243-4.479%2015-8.176%2021.993.058%2044.258-1.209%2048.301%2024.078z'%20fill='%23757f8a'/%3e%3c/g%3e%3cpath%20fill-rule='evenodd'%20d='M4.915%2053.214a.95.95%200%200%201-.913-1.216C9.86%2032.268%2021.728%2016.229%2036.803%207.411c.642-.375%201.437.094%201.437.838%200%20.351-.188.674-.49.851C23.163%2017.643%2011.57%2033.209%205.838%2052.522c-.121.409-.496.693-.923.693zm.106%2053.925a.95.95%200%200%200-.912%201.22c5.894%2019.566%2017.71%2035.464%2032.694%2044.229.642.375%201.437-.095%201.437-.838%200-.351-.188-.674-.49-.851-14.498-8.492-26.038-23.921-31.806-43.071-.123-.407-.497-.689-.922-.689zm117.069%200c-.425%200-.799.282-.922.689-5.768%2019.15-17.308%2034.579-31.806%2043.071-.303.177-.49.5-.49.851%200%20.743.795%201.213%201.437.838%2014.984-8.765%2026.8-24.663%2032.694-44.229a.95.95%200%200%200-.912-1.22zm.106-53.925a.95.95%200%200%200%20.913-1.216c-5.857-19.73-17.726-35.769-32.801-44.587-.642-.375-1.437.094-1.437.838%200%20.351.188.674.49.851%2014.586%208.543%2026.179%2024.109%2031.911%2043.421.122.409.497.693.923.693z'%20fill='%233e4753'/%3e%3c/svg%3e")}.button{display:block;width:100%}`;
var y5e = Object.defineProperty, w5e = Object.getOwnPropertyDescriptor, JX = (e) => {
  throw TypeError(e);
}, A5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? w5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && y5e(t, r, a), a;
}, VX = (e, t, r) => t.has(e) || JX("Cannot " + r), U5e = (e, t, r) => (VX(e, t, "read from private field"), r ? r.call(e) : t.get(e)), b3 = (e, t, r) => t.has(e) ? JX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Zs = (e, t, r) => (VX(e, t, "access private method"), r), iT, Pi, MX, GX, xX, HX, AB, LX, YX, OX;
let UB = class extends N {
  constructor() {
    super(...arguments), b3(this, Pi), b3(this, iT, new ue(
      this,
      TS(oe(), zn.REJECT)
    ));
  }
  render() {
    return w`
      <x-ds-app-container data-footer-visible="false">
        <jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        ${El(
      Zs(this, Pi, OX).call(this),
      [
        [$t.LIVENESS_TOO_MUCH_MOVEMENT, () => Zs(this, Pi, GX).call(this)],
        [$t.LIVENESS_TOO_DARK, () => Zs(this, Pi, xX).call(this)],
        [$t.LIVENESS_TOO_BRIGHT, () => Zs(this, Pi, HX).call(this)],
        [$t.LIVENESS_FACE_OBSCURED, () => Zs(this, Pi, LX).call(this)],
        [$t.LIVENESS_MULTIPLE_FACES, () => Zs(this, Pi, YX).call(this)],
        [$t.LIVENESS_EYES_CLOSED, () => Zs(this, Pi, AB).call(this)],
        [$t.LIVENESS_SUNGLASSES, () => Zs(this, Pi, AB).call(this)]
      ],
      () => Zs(this, Pi, MX).call(this)
    )}
      </x-ds-app-container>
    `;
  }
};
iT = /* @__PURE__ */ new WeakMap();
Pi = /* @__PURE__ */ new WeakSet();
MX = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Face verification failed", {
    id: "jumio_liveness_retry_title_generic_error"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--face-verification-failed"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Your face must be evenly lit and stand out from the background", {
    id: "identity.iproov.preview.lighting"
  })}
          </li>
          <li slot="item">
            ${y("Look straight into the camera", {
    id: "jumio_liveness_prompt_look_straight_into_the_camera"
  })}
          </li>
          <li slot="item">
            ${y("Center your face in the frame and follow the on-screen instructions", {
    id: "iproov.intro.la.paragraph"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({ type: t.JumioStandardCaptureScreen });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
GX = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Too much movement", {
    id: "jumio_liveness_retry_title_too_much_movement"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--too-much-movement"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Keep still", {
    id: "jumio_liveness_prompt_keep_still"
  })}
          </li>
          <li slot="item">
            ${y("Look straight into the camera", {
    id: "jumio_liveness_prompt_look_straight_into_the_camera"
  })}
          </li>
          <li slot="item">
            ${y("Center your face in the frame and follow the on-screen instructions", {
    id: "iproov.intro.la.paragraph"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({
      type: t.JumioStandardCaptureScreen
    });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
xX = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Too dark", {
    id: "jumio_liveness_retry_title_too_dark"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--too-dark"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Move somewhere brighter", {
    id: "iproov_failure_too_dark"
  })}
          </li>
          <li slot="item">
            ${y("Your face must be evenly lit and stand out from the background", {
    id: "identity.iproov.preview.lighting"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({
      type: t.JumioStandardCaptureScreen
    });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
HX = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Too much light", {
    id: "jumio_liveness_retry_title_too_much_light"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--too-much-light"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Move somewhere darker", {
    id: "iproov_failure_too_bright"
  })}
          </li>
          <li slot="item">
            ${y("Your face must be evenly lit and stand out from the background", {
    id: "identity.iproov.preview.lighting"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({
      type: t.JumioStandardCaptureScreen
    });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
AB = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Eyes are closed", {
    id: "jumio_liveness_retry_title_eyes_closed"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--eyes-closed"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Keep your eyes open", {
    id: "iproov_failure_eyes_closed"
  })}
          </li>
          <li slot="item">
            ${y("Center your face in the frame and follow the on-screen instructions", {
    id: "iproov.intro.la.paragraph"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({
      type: t.JumioStandardCaptureScreen
    });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
LX = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Face is obscured", {
    id: "jumio_liveness_retry_title_face_obscured"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--face-obscured"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Remove any face coverings", {
    id: "iproov_failure_obscured_face"
  })}
          </li>
          <li slot="item">
            ${y("Look straight into the camera", {
    id: "jumio_liveness_prompt_look_straight_into_the_camera"
  })}
          </li>
          <li slot="item">
            ${y("Center your face in the frame and follow the on-screen instructions", {
    id: "iproov.intro.la.paragraph"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({
      type: t.JumioStandardCaptureScreen
    });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
YX = function() {
  return w`
      <x-ds-usability-check slot="main" class="usability-check">
        <h3 slot="item" class="title" data-qa-id="title">
          ${y("Multiple people detected", {
    id: "jumio_liveness_retry_multiple_people_detected"
  })}
        </h3>
        <div slot="item" data-qa-id="error-icon" class="error-icon error-icon--multiple-people-detected"></div>
        <x-ds-card-list slot="item" data-qa-id="items">
          <li slot="item">
            ${y("Be the only person in the frame", {
    id: "jumio_liveness_retry_instr_multiple_people_detected"
  })}
          </li>
          <li slot="item">
            ${y("Look straight into the camera", {
    id: "jumio_liveness_prompt_look_straight_into_the_camera"
  })}
          </li>
          <li slot="item">
            ${y("Center your face in the frame and follow the on-screen instructions", {
    id: "iproov.intro.la.paragraph"
  })}
          </li>
        </x-ds-card-list>
        <x-ds-button
          slot="button"
          class="button"
          data-qa-id="retry-button"
          @jclick="${() => {
    const e = ve(), t = Tt(oe());
    e.send({
      type: t.JumioStandardCaptureScreen
    });
  }}"
        >
          ${y("Try again", { id: "retry.button.try-again" })}
        </x-ds-button>
        <jumio-sdk-cross-device-button
          slot="button"
          class="button"
          data-qa-id="cross-device-button"
        ></jumio-sdk-cross-device-button>
      </x-ds-usability-check>
    `;
};
OX = function() {
  var t, r;
  const [e] = U5e(this, iT).value ?? [];
  return (r = (t = e == null ? void 0 : e.result) == null ? void 0 : t.rejectReason) == null ? void 0 : r.reasonCode;
};
UB.styles = [...N.styles, Gt(b5e)];
UB = A5e([
  be(),
  P("jumio-sdk-step-facemap-usability-check")
], UB);
var k5e = Object.defineProperty, _5e = Object.getOwnPropertyDescriptor, jX = (e) => {
  throw TypeError(e);
}, N5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? _5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && k5e(t, r, a), a;
}, PX = (e, t, r) => t.has(e) || jX("Cannot " + r), Z5e = (e, t, r) => (PX(e, t, "read from private field"), r ? r.call(e) : t.get(e)), y3 = (e, t, r) => t.has(e) ? jX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), uC = (e, t, r) => (PX(e, t, "access private method"), r), kB, xh, $X, KX, XX, zX;
let _B = class extends N {
  constructor() {
    super(...arguments), y3(this, xh), this.componentController = new kRe(this), y3(this, kB, new ue(this, ur()));
  }
  getActiveStep() {
    return Z5e(this, kB).value;
  }
  render() {
    switch (this.getActiveStep()) {
      case x.JumioStandardGuidance:
        return uC(this, xh, $X).call(this);
      case x.JumioStandardCaptureScreen:
      case x.JumioStandardCaptureScreenSelfie:
      case x.JumioStandardCaptureScreenLiveness:
      case x.JumioStandardCaptureScreenLivenessLoading:
      case x.JumioStandardCaptureScreenCaptureFinish:
      case x.JumioStandardCaptureScreenUpload:
      case x.JumioStandardUsabilityCheck:
        return uC(this, xh, KX).call(this);
      case x.JumioStandardCaptureScreenUploadFailed:
        return uC(this, xh, zX).call(this);
      case x.JumioStandardUsabilityCheckFailure:
        return uC(this, xh, XX).call(this);
      default:
        return q;
    }
  }
};
kB = /* @__PURE__ */ new WeakMap();
xh = /* @__PURE__ */ new WeakSet();
$X = function() {
  return w`<jumio-sdk-step-facemap-jumio-standard-introduction></jumio-sdk-step-facemap-jumio-standard-introduction>`;
};
KX = function() {
  return w`<jumio-sdk-step-facemap-jumio-standard-capture></jumio-sdk-step-facemap-jumio-standard-capture>`;
};
XX = function() {
  return w`<jumio-sdk-step-facemap-usability-check></jumio-sdk-step-facemap-usability-check>`;
};
zX = function() {
  const e = Tt(oe());
  return w`
      <jumio-sdk-file-upload-failed
        .retryAction="${() => {
    const t = oe();
    lH(t), ve().send({ type: e.JumioStandardCaptureScreen });
  }}"
        data-qa-id="file-upload-failed-step"
      ></jumio-sdk-file-upload-failed>
    `;
};
_B.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
_B = N5e([
  be(),
  P("jumio-sdk-step-facemap-jumio-standard")
], _B);
var B5e = Object.defineProperty, W5e = Object.getOwnPropertyDescriptor, qX = (e) => {
  throw TypeError(e);
}, e8 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? W5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && B5e(t, r, a), a;
}, E5e = (e, t, r) => t.has(e) || qX("Cannot " + r), Q5e = (e, t, r) => t.has(e) ? qX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), w3 = (e, t, r) => (E5e(e, t, "access private method"), r), Rb, t8, r8;
let Jy = class extends N {
  constructor() {
    super(...arguments), Q5e(this, Rb), this.stepInformationController = new ue(this, ur()), this.componentController = new fRe(this);
  }
  get workflowStepController() {
    return Ce().getControllerById(T.Facemap);
  }
  render() {
    const { value: e = x.Start } = this.stepInformationController;
    switch (e) {
      case x.Iproov:
      case x.IproovFailureSystem:
      case x.IproovFinish:
        return w3(this, Rb, t8).call(this);
      case x.JumioStandard:
      case x.JumioStandardGuidance:
      case x.JumioStandardCaptureScreen:
      case x.JumioStandardCaptureScreenSelfie:
      case x.JumioStandardCaptureScreenLiveness:
      case x.JumioStandardCaptureScreenLivenessLoading:
      case x.JumioStandardCaptureScreenCaptureFinish:
      case x.JumioStandardCaptureScreenUpload:
      case x.JumioStandardCaptureScreenUploadFailed:
      case x.JumioStandardUsabilityCheck:
      case x.JumioStandardUsabilityCheckFailure:
      case x.JumioStandardFinish:
        return w3(this, Rb, r8).call(this);
      case x.Start:
      case x.Finish:
      case x.VerificationMethodFailed:
      case x.NoVerificationMethodsLeft:
      default:
        return q;
    }
  }
};
Rb = /* @__PURE__ */ new WeakSet();
t8 = function() {
  const e = document.querySelector("template#face_liveness");
  return e ? w`${Ea(e)}` : w`<jumio-sdk-step-facemap-iproov data-qa-id="iproov"></jumio-sdk-step-facemap-iproov>`;
};
r8 = function() {
  const e = document.querySelector("template#face_standard");
  return e ? w`${Ea(e)}` : w`
          <jumio-sdk-step-facemap-jumio-standard data-qa-id="jumio-standard"></jumio-sdk-step-facemap-jumio-standard>
        `;
};
Jy.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
e8([
  ka({ context: mke }),
  Xn()
], Jy.prototype, "workflowStepController", 1);
Jy = e8([
  be(),
  P("jumio-sdk-step-facemap")
], Jy);
var qs, Su, rS, C2, Vg, n8, a8, b2;
class F5e {
  constructor(t) {
    E(this, Vg);
    E(this, qs);
    E(this, Su);
    E(this, rS);
    E(this, C2, (t) => {
      var n;
      const { linked: r } = Le();
      Te.shownFinishScreen(S(this, qs), { metadata: { outcome: t } }), S(this, qs).dispatchEvent(Dj(oN())), ev(kg.Success), !r && DO((n = S(this, Su).getConfiguration().getSettings().redirects) == null ? void 0 : n.success);
    });
    E(this, b2, (t) => t instanceof es);
    G(this, qs, t), G(this, Su, Ce()), G(this, rS, S(this, Su).getControllerById(Me.Finish, void 0)), this.finalize$ = this.getFinalize$(), t.addController(this);
  }
  hostConnected() {
  }
  getController() {
    return S(this, rS);
  }
  getFinalize$() {
    return Sa({
      type: jd.Ready
    }).pipe(
      Wi(
        () => this.getController().finalize$().pipe(
          Lg(() => {
            O(this, Vg, n8).call(this), mt.showMessageIfPossible({
              type: Fr.Progress,
              id: ct.Finalizing,
              title: y("Processing", { id: "upload.file.processing" }),
              message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
              overlay: !0,
              closable: !0
            });
          }),
          BM(Math.max(hg, 0)),
          te(
            (t) => ({
              type: jd.Success,
              result: t
            })
          ),
          ae(S(this, C2).bind(this)),
          ti(O(this, Vg, a8).bind(this)),
          WM(() => {
            mt.closeActiveClosableMessageById(ct.Finalizing);
          })
        )
      )
    );
  }
}
qs = new WeakMap(), Su = new WeakMap(), rS = new WeakMap(), C2 = new WeakMap(), Vg = new WeakSet(), n8 = function() {
  const t = SRe(), { linked: r } = Le();
  Te.usedCaptureTypesEvent(S(this, qs), {
    metadata: {
      xDeviceJourney: r,
      livenessCaptureType: t.livenessCaptureType ?? "",
      idCaptureType: t.idCaptureType ?? "",
      usedAllCaptureTypes: t.usedAllCaptureTypes
    }
  });
}, a8 = function(t) {
  var i;
  const { linked: r } = Le();
  let n;
  S(this, b2).call(this, t) ? n = t.details.publicError : n = vw(yE, 0, 0), Te.shownFinishScreen(S(this, qs), {
    metadata: {
      outcome: {
        type: jd.Error,
        errorCode: n == null ? void 0 : n.code(),
        error: t
      }
    }
  }), S(this, qs).dispatchEvent(Jj(oN())), ev(kg.Error, n);
  const a = {
    type: jd.Error,
    error: t
  };
  return r || IZ((i = S(this, Su).getConfiguration().getSettings().redirects) == null ? void 0 : i.error), Sa(a);
}, b2 = new WeakMap();
var T5e = Object.defineProperty, R5e = Object.getOwnPropertyDescriptor, i8 = (e) => {
  throw TypeError(e);
}, o8 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? R5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && T5e(t, r, a), a;
}, oT = (e, t, r) => t.has(e) || i8("Cannot " + r), Zk = (e, t, r) => (oT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Bk = (e, t, r) => t.has(e) ? i8("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), A3 = (e, t, r, n) => (oT(e, t, "write to private field"), t.set(e, r), r), Vy = (e, t, r) => (oT(e, t, "access private method"), r), kf, Db, Tg, s8, l8, c8, d8;
let My = class extends N {
  constructor() {
    super(), Bk(this, Tg), Bk(this, kf), Bk(this, Db), A3(this, kf, new ue(this, this.componentController.finalize$));
  }
  get workflowStepController() {
    return Ce().getControllerById(Me.Finish, void 0);
  }
  get componentController() {
    return Zk(this, Db) ?? A3(this, Db, new F5e(this));
  }
  render() {
    return Zk(this, kf) ? w`
          <x-ds-app-container>
            <div class="page-items" slot="main">
              ${ke("jumio-finish-before")}
              ${Vy(this, Tg, s8).call(this, Zk(this, kf).value)}
              ${ke("jumio-finish-after")}
            </div>
          </x-ds-app-container>
        ` : q;
  }
};
kf = /* @__PURE__ */ new WeakMap();
Db = /* @__PURE__ */ new WeakMap();
Tg = /* @__PURE__ */ new WeakSet();
s8 = function(e) {
  return w`${ke(
    "jumio-finish-outcome",
    El(e == null ? void 0 : e.type, [
      [jd.Success, () => Vy(this, Tg, l8).call(this)],
      [jd.Error, () => Vy(this, Tg, c8).call(this, e)]
    ])
  )}`;
};
l8 = function() {
  return w`${ke(
    "jumio-finish-success",
    w`
        <x-ds-success-message
          data-qa-id="success-message"
          .title="${y("Success", {
      id: "title.success"
    })}"
          .message="${y("Thank you. You may now close your browser.", { id: "success.paragraph" })}"
        >
        </x-ds-success-message>
      `
  )}`;
};
c8 = function(e) {
  let t, r = "", n = "";
  if (Vy(this, Tg, d8).call(this, e)) {
    const { publicError: a } = e.error.details;
    if (a) {
      n = a.code();
      const { title: i, message: o } = Tw[a.legacyCode()];
      r = y(i.label, { id: i.id }), t = y(o.label, { id: o.id });
    } else
      t = e.error.details.message;
  } else
    t = JSON.stringify(e);
  return w`${ke(
    "jumio-finish-error",
    w`
        <x-ds-error-message
          data-qa-id="error-message"
          data-error-code="${n}"
          data-title="${r}"
          .message="${t}"
        ></x-ds-error-message>
      `
  )}`;
};
d8 = function(e) {
  return Ut(e, ["error"], (t) => t.error instanceof es);
};
My.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .page-items {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        row-gap: 1em;
      }
    `
];
o8([
  ka({ context: vke }),
  Xn()
], My.prototype, "workflowStepController", 1);
My = o8([
  be(),
  P("jumio-sdk-step-finish")
], My);
var nS, aS, iS, y2, u8;
class D5e {
  constructor(t, r = Ce()) {
    E(this, y2);
    E(this, nS);
    E(this, aS);
    E(this, iS, new _e());
    G(this, nS, t), G(this, aS, r), S(this, nS).addController(this);
  }
  hostConnected() {
    this.getStepSelection$().pipe(le(S(this, iS))).subscribe();
  }
  hostDisconnected() {
    S(this, iS).next();
  }
  isDocumentTypeSelected(t) {
    const { selectedCountry: r, selectedIdType: n } = t;
    return !!(r && n);
  }
  isDocumentVariantSelected(t) {
    const { selectedDocumentVariant: r, selectedIdFormat: n } = t;
    return !!(r && n);
  }
  isDigitalIdentityTypeSelected(t) {
    const { selectedIdType: r } = t;
    return r === ft.DigitalIdentity;
  }
  getStepSelection$() {
    return ur().pipe(
      ae((t) => {
        switch (t) {
          case Z.Start: {
            this.handleStart();
            return;
          }
          case Z.DocTypeDecision:
            this.handleDocTypeDecision();
            return;
        }
      })
    );
  }
  handleStart() {
    const { DocTypeDecision: t } = un(oe());
    ve().send({ type: t });
  }
  async handleDocTypeDecision() {
    const { Upload: t, DocTypeSelection: r, DocTypeVariantSelection: n, CaptureSourceSelection: a, CaptureScreenEntry: i } = un(oe()), o = O(this, y2, u8).call(this).getUserSelection();
    if (this.isDigitalIdentityTypeSelected(o)) {
      ve().send({ type: t });
      return;
    }
    if (!this.isDocumentTypeSelected(o)) {
      ve().send({ type: r });
      return;
    }
    if (!this.isDocumentVariantSelected(o)) {
      ve().send({ type: n });
      return;
    }
    const c = await Be(hH()) ? a : i;
    ve().send({ type: c });
  }
}
nS = new WeakMap(), aS = new WeakMap(), iS = new WeakMap(), y2 = new WeakSet(), u8 = function() {
  return S(this, aS).getControllerById(T.Id);
};
var Ci, hc, oS, sS, ir, We, h8, p8, g8, f8, m8, NB, v8, S8, I8, C8, ZB, b8, y8, w8, A8, U8, k8, Jb, Vb, BB, _8, N8, Z8, B8;
class J5e {
  constructor(t) {
    E(this, We);
    E(this, Ci);
    E(this, hc);
    E(this, oS);
    E(this, sS);
    E(this, ir);
    this.hasFileUpload$ = QE(oe()), G(this, Ci, t), G(this, hc, new _e()), this.workflowController = Ce(), this.stepController = this.workflowController.getControllerById(T.Id), G(this, sS, new ue(
      S(this, Ci),
      WE(oe())
    )), G(this, oS, new ue(
      S(this, Ci),
      TS(oe(), zn.REJECT)
    )), G(this, ir, un(oe())), t.addController(this);
  }
  hostConnected() {
    O(this, We, p8).call(this).pipe(le(S(this, hc))).subscribe(), FE(T.Id).pipe(
      ae((t) => {
        eA({
          timeoutMs: t
        });
      }),
      le(S(this, hc))
    ).subscribe();
  }
  hostDisconnected() {
    S(this, hc).next();
  }
  async upload(t) {
    return Te.uploadedFile(S(this, Ci), {
      metadata: { source: Fu.Camera }
    }), this.stepController.uploadDataAsync(t);
  }
  areAllRequiredSidesCaptured() {
    const t = O(this, We, Jb).call(this, cr.Front) && O(this, We, Vb).call(this, cr.Front), r = O(this, We, Jb).call(this, cr.Back) && O(this, We, Vb).call(this, cr.Back);
    return !(t || r);
  }
}
Ci = new WeakMap(), hc = new WeakMap(), oS = new WeakMap(), sS = new WeakMap(), ir = new WeakMap(), We = new WeakSet(), h8 = async function() {
  const t = O_(oe());
  await Promise.all(
    t.map(
      ({ usabilityId: r, id: n }) => this.stepController.checkUsabilityAsync({
        id: n,
        usability: {
          resultKey: r
        }
      })
    )
  );
}, p8 = function() {
  return ur().pipe(
    ao((t) => {
      switch (t) {
        case Z.CaptureScreenEntry:
          O(this, We, B8).call(this);
          break;
        case Z.CaptureScreen:
          O(this, We, f8).call(this);
          break;
        case Z.CaptureScreenSelectProvider:
          O(this, We, g8).call(this);
          break;
        case Z.CaptureScreenAutoCaptureLoading:
          O(this, We, Z8).call(this);
          break;
        case Z.CaptureScreenDecision:
          O(this, We, m8).call(this);
          break;
        case Z.CaptureScreenFrontStart:
          O(this, We, v8).call(this);
          break;
        case Z.CaptureScreenFrontFinish:
          O(this, We, k8).call(this);
          break;
        case Z.CaptureScreenPrepareForRecapturingBack:
          O(this, We, y8).call(this);
          break;
        case Z.CaptureScreenBackStart:
          O(this, We, U8).call(this);
          break;
        case Z.CaptureScreenBackFinish:
          O(this, We, A8).call(this);
          break;
        case Z.CaptureScreenComplete:
          O(this, We, w8).call(this);
          break;
        case Z.CaptureScreenUpload:
          return O(this, We, N8).call(this);
        case Z.IdUsabilityCheck:
          return O(this, We, I8).call(this);
        case Z.IdUsabilityCheckBackMissing:
          O(this, We, C8).call(this);
          break;
        case Z.IdUsabilityCheckReset:
          O(this, We, S8).call(this);
          break;
      }
      return ba;
    })
  );
}, g8 = function() {
  const t = L0e() ? S(this, ir).CaptureScreenSelectProviderAutoCapture : S(this, ir).CaptureScreenSelectProviderManualCapture;
  ve().send({ type: t });
}, f8 = function() {
  ve().send({ type: S(this, ir).CaptureScreenSelectProvider });
}, m8 = function() {
  if (this.stepController.are2FilesUploaded(oe())) {
    ve().send({ type: S(this, ir).CaptureScreenComplete });
    return;
  }
  const { isBackMissing: r } = this.stepController.isUsabilityBackMissing(oe());
  if (O(this, We, NB).call(this, cr.Front, r)) {
    ve().send({ type: S(this, ir).CaptureScreenFrontStart });
    return;
  }
  if (O(this, We, NB).call(this, cr.Back)) {
    ve().send({ type: S(this, ir).CaptureScreenBackStart });
    return;
  }
  ve().send({ type: S(this, ir).CaptureScreenComplete });
}, NB = function(t, r = !1) {
  return O(this, We, Jb).call(this, t) && O(this, We, Vb).call(this, t) && (t !== cr.Front || !r);
}, v8 = async function() {
  await Dd(() => {
  }, 2e3), ve().send({ type: S(this, ir).CaptureScreenFront });
}, S8 = function() {
  const r = (S(this, oS).value ?? []).map((n) => n.id);
  cH(...r), ve().send({ type: S(this, ir).CaptureScreenSelectProvider });
}, I8 = async function() {
  mt.showMessageIfPossible({
    type: Fr.Progress,
    id: ct.UsabilityCheck,
    title: y("Checking the image…", { id: "jumio_id_scan_prompt_processing" }),
    message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
    overlay: !0,
    closable: !0
  }), await O(this, We, h8).call(this), await Dd(() => {
  }, Math.max(500, hg)), mt.closeActiveClosableMessageById(ct.UsabilityCheck);
  const t = await Be(H0e(oe()));
  ve().send({
    type: t ? S(this, ir).IdUsabilityCheckFailure : S(this, ir).IdUsabilityCheckBackMissing
  });
}, C8 = function() {
  if (this.stepController.are2FilesUploaded(oe())) {
    O(this, We, ZB).call(this);
    return;
  }
  const t = this.stepController.isUsabilityBackMissing(oe());
  t.isBackMissing ? O(this, We, b8).call(this, t) : O(this, We, ZB).call(this);
}, ZB = function() {
  ve().send({ type: S(this, ir).IdUsabilityCheckSuccess });
}, b8 = function(t) {
  this.hasFileUpload$.pipe(qc(1), le(S(this, hc))).subscribe((r) => {
    Te.backMissingEvent(S(this, Ci));
    const { Upload: n, CaptureScreenPrepareForRecapturingBack: a } = un(oe());
    R0e(O(this, We, BB).call(this, cr.Front, t.idType)), this.stepController.patchUserSelection({
      selectedCountry: t.country,
      selectedIdType: t.idType,
      selectedDocumentVariant: void 0,
      selectedIdFormat: void 0
    }), ve().send({ type: r ? n : a });
  });
}, y8 = async function() {
  S(this, Ci).requestUpdate(), await S(this, Ci).updateComplete, tI.next(), ve().send({ type: S(this, ir).CaptureScreenSelectProvider });
}, w8 = function() {
  S(this, Ci).stopStream(), ve().send({ type: S(this, ir).CaptureScreenUpload });
}, A8 = async function() {
  await Dd(() => {
  }, 2500), ve().send({ type: S(this, ir).CaptureScreenDecision });
}, U8 = async function() {
  await Dd(() => {
  }, Math.max(tSe, 2500)), ve().send({ type: S(this, ir).CaptureScreenBack });
}, k8 = async function() {
  await Dd(() => {
  }, 2500), ve().send({ type: S(this, ir).CaptureScreenDecision });
}, Jb = function(t) {
  return !!this.stepController.getPartsForDocumentType(this.stepController.getUserSelection()).find((n) => n.side === t);
}, Vb = function(t) {
  const r = O(this, We, BB).call(this, t);
  return !O(this, We, _8).call(this, r);
}, BB = function(t, r) {
  const n = t === cr.Front ? or.FrontSide : or.BackSide;
  let a = r ?? this.stepController.getUserSelection().selectedIdType;
  return a || (a = ft.DrivingLicense, Te.defaultToDL(S(this, Ci))), `${oe()}_${a}_${n}`;
}, _8 = function(t) {
  return !!(S(this, sS).value ?? []).find((n) => n.id === t);
}, N8 = function() {
  return M0e(oe()).pipe(
    Lg(() => {
      mt.showMessageIfPossible({
        type: Fr.Progress,
        id: ct.Uploading,
        title: y("Uploading", { id: "upload.title" }),
        message: y("Please do not close your browser — this may take a moment.", { id: "upload.notice" }),
        overlay: !0,
        closable: !0
      });
    }),
    at(Boolean),
    BM(Math.max(hg, 500)),
    ae(() => {
      mt.closeActiveClosableMessageById(ct.Uploading);
      const t = V0e(oe()) ? S(this, ir).IdUsabilityCheck : S(this, ir).CaptureScreenUploadFailed;
      ve().send({ type: t });
    })
  );
}, Z8 = async function() {
  return Qw().initialize();
}, B8 = function() {
  sH(oe()), ve().send({ type: S(this, ir).CaptureScreen });
};
const W8 = ({
  width: e = 1920,
  height: t = 1080,
  aspectRatio: r = 1920 / 1080
}) => async ({ track: n }) => {
  var m, I, C;
  const a = ((m = n.getCapabilities) == null ? void 0 : m.call(n)) ?? {}, i = (I = a.width) == null ? void 0 : I.max, o = (C = a.height) == null ? void 0 : C.max, c = (() => {
    if (typeof i == "number" && typeof o == "number") {
      const A = i / o;
      return Number.isNaN(A) || A === 1 ? void 0 : A;
    }
  })() ?? r, l = o ? Math.min(t, o) : t, u = i ? Math.min(l * c, i) : e, { width: g, height: p } = n.getSettings();
  try {
    g === u && p === l || await n.applyConstraints({
      width: {
        ideal: u
      },
      height: {
        ideal: l
      }
    });
  } catch {
  }
  return n.getSettings();
};
var V5e = Object.defineProperty, M5e = Object.getOwnPropertyDescriptor, E8 = (e) => {
  throw TypeError(e);
}, G5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? M5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && V5e(t, r, a), a;
}, sT = (e, t, r) => t.has(e) || E8("Cannot " + r), lr = (e, t, r) => (sT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), ui = (e, t, r) => t.has(e) ? E8("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), _f = (e, t, r, n) => (sT(e, t, "write to private field"), t.set(e, r), r), Ct = (e, t, r) => (sT(e, t, "access private method"), r), gv, lT, Rg, Gy, xy, Hy, fv, Hh, Ly, em, Yy, gt, Q8, F8, T8, R8, nA, D8, J8, V8, cT, WB, M8, G8, x8, H8, L8, Y8, O8, j8, Yo, P8;
let EB = class extends N {
  constructor() {
    var e;
    super(), ui(this, gt), this.cameraRef = Rt(), ui(this, gv, new _e()), ui(this, lT, W8(
      ((e = TE()) == null ? void 0 : e.resolutionId) ?? {
        width: 1920,
        height: 1080,
        aspectRatio: 16 / 9
      }
    )), ui(this, Rg), ui(this, Gy), ui(this, xy, Rt()), ui(this, Hy), ui(this, fv, new _e()), ui(this, Hh, new _e()), ui(this, Ly), ui(this, em, new Kt(void 0)), ui(this, Yy, Date.now()), this.logImageCapturedEvent = (t) => {
      var a, i, o, s, c;
      const { idAutocaptureState: r, idAutocaptureFallbackReason: n } = Ct(this, gt, Q8).call(this);
      Te.cameraCapture(this, {
        metadata: zo(
          {
            width: t.detail.width,
            height: t.detail.height,
            track: bg(),
            devices: fQ(),
            permissionState: pQ(),
            idAutocapture: !!((a = Ct(this, gt, Yo).call(this)) != null && a.detail.autocapture),
            cls: (i = Ct(this, gt, Yo).call(this)) == null ? void 0 : i.detail.cls,
            clsm: (o = Ct(this, gt, Yo).call(this)) == null ? void 0 : o.detail.clsm,
            idAutocaptureState: r,
            idAutocaptureFallbackReason: n,
            timeSpentInStepMs: Date.now() - lr(this, Yy)
          },
          ["deviceId", "groupId", "deviceIds", "deviceEntities", "mockDeviceIds", "mockDeviceEntities"]
        ),
        tags: {
          idAutocaptureState: r,
          idAutocaptureFallbackReason: n,
          ...typeof ((s = Ct(this, gt, Yo).call(this)) == null ? void 0 : s.detail.autocaptureFps) == "number" && {
            idAutocaptureFps: (c = Ct(this, gt, Yo).call(this)) == null ? void 0 : c.detail.autocaptureFps
          }
        }
      });
    }, this.uploadImage = (t) => {
      var p, m, I;
      const r = ve(), { multipartName: n, uploadType: a } = Ct(this, gt, V8).call(this), i = this.componentController.stepController.getUserSelection();
      let { selectedIdType: o } = i;
      const { selectedCountry: s } = i;
      o || (o = ft.DrivingLicense, Te.defaultToDL(this));
      const { CaptureScreenDecision: c, CaptureScreenFrontFinish: l, CaptureScreenBackFinish: u } = un(oe());
      !D0e(n) && n && (this.logImageCapturedEvent(t), this.componentController.upload({
        uploadFilesMetadata: {
          files: [
            {
              multipartName: n,
              uploadType: a,
              fileType: OS[t.detail.blob.type],
              usabilityExpected: !0,
              country: s,
              idType: o,
              file: t.detail.blob,
              riskSignals: {
                deviceId: ((p = jn()) == null ? void 0 : p.deviceId) ?? "",
                deviceLabel: ((m = jn()) == null ? void 0 : m.label) ?? "",
                groupId: ((I = jn()) == null ? void 0 : I.groupId) ?? ""
              },
              cls: sd(),
              clsm: ld()
            }
          ]
        }
      }).catch(Pp), this.componentController.areAllRequiredSidesCaptured() ? r.send({ type: c }) : r.send({
        type: a === or.FrontSide ? l : u
      }), zC(!1), lr(this, em).next(void 0));
    }, this.componentController = new J5e(this), _f(this, Rg, new ue(this, ur())), _f(this, Gy, new ue(this, Ct(this, gt, G8).call(this))), _f(this, Hy, new ue(this, _w())), _f(this, Ly, new ue(this, wAe())), this.captureRequest$ = lr(this, em).asObservable(), this.captureRequestController = new ue(this, this.captureRequest$);
  }
  connectedCallback() {
    super.connectedCallback(), zC(!1), Ct(this, gt, Y8).call(this).pipe(le(lr(this, Hh))).subscribe(), Ct(this, gt, M8).call(this).pipe(le(lr(this, Hh))).subscribe(), Ct(this, gt, j8).call(this).pipe(le(lr(this, Hh))).subscribe();
  }
  firstUpdated(e) {
    super.firstUpdated(e), lr(this, fv).next(), lr(this, gv).next(), Te.shownCaptureScreen(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), zC(!1), lr(this, Hh).next(), this.stopStream();
  }
  render() {
    return w`
      <jumio-sdk-autocapture-provider>
        <x-ds-app-container
          ${Mt(lr(this, xy))}
          data-type="${An.CaptureScreen}"
          @switchstream="${this.switchStream.bind(this)}"
        >
          <jumio-sdk-navigation-button
            slot="top-left"
            data-shape="${ya.Round}"
            data-type="${De.Tertiary}"
          ></jumio-sdk-navigation-button>
          <x-ds-color-scheme slot="top-middle" data-color-scheme="dark">
            <x-ds-watermark data-version="0.2.14-b10b1242.2"></x-ds-watermark>
          </x-ds-color-scheme>
          <x-ds-button
            class="mobile-only"
            slot="top-right"
            data-size="${_a.Medium}"
            data-shape="${ya.Round}"
            data-type="${De.Tertiary}"
            data-padding="false"
            @jclick="${() => {
      Qg();
    }}"
          >
            <span class="icon-help"></span>
          </x-ds-button>
          <x-ds-button
            class="desktop-only"
            slot="top-right"
            data-type="${De.Tertiary}"
            @jclick="${() => {
      Qg();
    }}"
          >
            <span>${y("Help", { id: "app.nav.help" })}</span>
          </x-ds-button>
          ${Ct(this, gt, F8).call(this)} ${Ct(this, gt, L8).call(this)} ${Ct(this, gt, D8).call(this)}
          <div slot="bottom-left" class="cross-device-container">
            <jumio-sdk-cross-device-button
              data-fluid="false"
              data-type="${De.Tertiary}"
            ></jumio-sdk-cross-device-button>
          </div>
          <jumio-sdk-capture-hints class="overlay" slot="overlay">
            <ul slot="tips">
              <li>${y("Make sure photo is in focus", { id: "id-source.help.card.tip1" })}</li>
              <li>${y("Do not take picture in the dark", { id: "id-source.help.card.tip2" })}</li>
              <li>${y("Avoid reflections and glare", { id: "id-source.help.card.tip3" })}</li>
            </ul>
            <jumio-sdk-upload-button
              slot="secondary-action-button"
              data-type="${De.Secondary}"
              data-fluid="true"
            ></jumio-sdk-upload-button>
          </jumio-sdk-capture-hints>
        </x-ds-app-container>
      </jumio-sdk-autocapture-provider>
    `;
  }
  switchStream(e) {
    return (e instanceof Uw || e instanceof Il) && this.cameraRef.value ? this.cameraRef.value.switchStream(e) : Promise.reject(new GS("switchStream: Camera could not be started"));
  }
  stopStream() {
    var e;
    (e = this.cameraRef.value) == null || e.stopStream();
  }
  handleCameraSwitch(e) {
    return this.switchStream(e);
  }
};
gv = /* @__PURE__ */ new WeakMap();
lT = /* @__PURE__ */ new WeakMap();
Rg = /* @__PURE__ */ new WeakMap();
Gy = /* @__PURE__ */ new WeakMap();
xy = /* @__PURE__ */ new WeakMap();
Hy = /* @__PURE__ */ new WeakMap();
fv = /* @__PURE__ */ new WeakMap();
Hh = /* @__PURE__ */ new WeakMap();
Ly = /* @__PURE__ */ new WeakMap();
em = /* @__PURE__ */ new WeakMap();
Yy = /* @__PURE__ */ new WeakMap();
gt = /* @__PURE__ */ new WeakSet();
Q8 = function() {
  const { state: e, fallbackReason: t } = QO(), r = (() => {
    var a;
    return (a = Ct(this, gt, Yo).call(this)) != null && a.detail.autocapture ? "auto-capture" : [Er.MANUAL_CAPTURE_FALLBACK, Er.LOADING].includes(e) ? "manual-capture-fallback" : "manual-capture";
  })(), n = e === Er.LOADING ? nt.ModuleLoadingError : t;
  return { idAutocaptureState: r, idAutocaptureFallbackReason: n };
};
F8 = function() {
  return Ct(this, gt, H8).call(this) ? q : w`
      <x-camera
        ${Mt(this.cameraRef)}
        slot="background"
        class="camera"
        .applyConstraintCallback="${lr(this, lT)}"
        @imagecaptured="${(e) => {
    this.uploadImage(e);
  }}"
        @streamresized="${(e) => {
    Ct(this, gt, O8).call(this, e);
  }}"
        @capturerequest="${(e) => {
    Ct(this, gt, cT).call(this, e);
  }}"
        @cameraplaybackstatus="${(e) => {
    zF(this, e.detail);
  }}"
      >
        <div slot="backdrop" class="backdrop"></div>
        ${Ct(this, gt, T8).call(this)} ${Ct(this, gt, R8).call(this)}
        <jumio-sdk-camera-permissions-screen></jumio-sdk-camera-permissions-screen>
      </x-camera>
    `;
};
T8 = function() {
  return Ct(this, gt, nA).call(this) ? w`
        <jumio-sdk-autocapture
          slot="video-overlay"
          .uploadFile="${(e) => this.componentController.upload(e)}"
          .cameraRef="${this.cameraRef}"
        ></jumio-sdk-autocapture>
        <jumio-sdk-autocapture-tracker slot="video-overlay"></jumio-sdk-autocapture-tracker>
      ` : q;
};
R8 = function() {
  return Ct(this, gt, nA).call(this) ? w`<jumio-sdk-autocapture-capture-state slot="video-width-before"></jumio-sdk-autocapture-capture-state>` : w`<jumio-sdk-step-id-capture-state slot="video-width-before"></jumio-sdk-step-id-capture-state>`;
};
nA = function() {
  const e = lr(this, Ly).value ?? Er.NOT_LOADED;
  return [Er.ACTIVE, Er.LOADING].includes(e);
};
D8 = function() {
  const e = !(Ct(this, gt, x8).call(this) && !Ct(this, gt, Yo).call(this));
  return Ct(this, gt, nA).call(this) ? q : w`
          <x-ds-capture-button
            slot="capture-button"
            data-qa-id="capture-button"
            data-disabled="${e}"
            @click="${() => {
    Ct(this, gt, cT).call(this);
  }}"
          ></x-ds-capture-button>
        `;
};
J8 = function() {
  return !Ct(this, gt, Yo).call(this);
};
V8 = function() {
  let { selectedIdType: e } = this.componentController.stepController.getUserSelection();
  switch (e || (e = ft.DrivingLicense, Te.defaultToDL(this)), lr(this, Rg).value) {
    case Z.CaptureScreenFront:
    case Z.CaptureScreenFrontStart:
    case Z.CaptureScreenFrontFinish:
      return {
        uploadType: or.FrontSide,
        multipartName: `${oe()}_${e}_${or.FrontSide}`
      };
    case Z.CaptureScreenBack:
    case Z.CaptureScreenBackStart:
    case Z.CaptureScreenBackFinish:
      return {
        uploadType: or.BackSide,
        multipartName: `${oe()}_${e}_${or.BackSide}`
      };
    default:
      throw new Error("#getCurrentFileKey: the key is invalid");
  }
};
cT = async function(e = Ct(this, gt, P8).call(this)) {
  var t, r;
  if (Ct(this, gt, J8).call(this)) {
    zC(!0), lr(this, em).next(e), await ((t = this.cameraRef.value) == null ? void 0 : t.captureImage());
    const n = (r = Ct(this, gt, Yo).call(this)) != null && r.detail.autocapture ? "AUTO_CAPTURE" : "MANUAL_CAPTURE";
    rI(n);
  }
};
WB = function() {
  const e = lr(this, Gy).value;
  return (e == null ? void 0 : e.type) === An.CaptureScreen && (e == null ? void 0 : e.variant) === Bu.Small ? qa.Horizontal : qa.Vertical;
};
M8 = function() {
  return ps(lr(this, gv), tI).pipe(
    Wt(() => ZQ(this.cameraRef, lr(this, fv))),
    Xc(yS),
    Wt(
      (e) => this.switchStream(
        new Il({
          videoElement: e,
          constraints: {
            video: {
              ...wQ(),
              facingMode: {
                ideal: kw.Environment
              }
            },
            audio: !1
          }
        })
      )
    )
  );
};
G8 = function() {
  return Bl(lr(this, xy), lr(this, fv)).pipe(
    Wt((e) => e.layout$)
  );
};
x8 = function() {
  const e = !!lr(this, Hy).value, t = [Z.CaptureScreenFront, Z.CaptureScreenBack];
  return e && t.includes(lr(this, Rg).value);
};
H8 = function() {
  return [
    Z.CaptureScreenUpload,
    Z.IdUsabilityCheck,
    Z.IdUsabilityCheckFailure
  ].includes(lr(this, Rg).value);
};
L8 = function() {
  return w`
      <div
        slot="camera-selector"
        class="camera-selector-container"
        data-orientation="${Ct(this, gt, WB).call(this)}"
      >
        <x-camera-selector
          class="camera-selector"
          @switchcamera="${(e) => this.handleCameraSwitch(e)}"
          .orientation="${Ct(this, gt, WB).call(this)}"
        ></x-camera-selector>
      </div>
    `;
};
Y8 = function() {
  return bQ(lr(this, gv));
};
O8 = function(e) {
  kQ({
    width: e.detail.sourceWidth,
    height: e.detail.sourceHeight
  });
};
j8 = function() {
  return ur().pipe(
    ae(() => {
      _f(this, Yy, Date.now());
    })
  );
};
Yo = function() {
  return this.captureRequestController.value;
};
P8 = function() {
  return new VO({
    autocapture: !1,
    cls: sd(),
    clsm: ld()
  });
};
EB.styles = [
  ...N.styles,
  Gt(XF),
  ee`
      :host {
        display: contents;
      }

      .camera-selector-container {
        position: relative;
      }

      .camera-selector-container[data-orientation='vertical'] {
        width: 100%;
        height: 100%;
      }

      .camera-selector[data-orientation='vertical'] {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .cross-device-container {
        display: flex;
        align-items: flex-end;
        height: 100%;
      }

      .overlay-actions {
        display: flex;
        gap: 1em;
        flex-direction: column;
      }

      .mobile-only {
        display: flex;
      }

      .desktop-only {
        display: none;
      }

      .backdrop {
        position: absolute;
        inset: 0;
        background: var(--color-secondary12);
        pointer-events: none;
      }

      @media only screen and (min-width: 40em) {
        .mobile-only {
          display: none;
        }

        .desktop-only {
          display: flex;
        }
      }
    `
];
EB = G5e([
  be(),
  P("jumio-sdk-step-id-capture")
], EB);
var x5e = Object.defineProperty, H5e = Object.getOwnPropertyDescriptor, $8 = (e) => {
  throw TypeError(e);
}, L5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? H5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && x5e(t, r, a), a;
}, K8 = (e, t, r) => t.has(e) || $8("Cannot " + r), Y5e = (e, t, r) => (K8(e, t, "read from private field"), r ? r.call(e) : t.get(e)), U3 = (e, t, r) => t.has(e) ? $8("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Ip = (e, t, r) => (K8(e, t, "access private method"), r), dT, Uc, X8, z8, q8, ez, tz, rz;
let QB = class extends N {
  constructor() {
    super(...arguments), U3(this, Uc), this.crossDeviceEnabledController = new ue(this, uH()), U3(this, dT, new ue(this, hH()));
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownDocumentSelectScreen(this);
  }
  get isLinked() {
    const { linked: e } = Le();
    return e;
  }
  get isMobile() {
    return _l();
  }
  get isCrossDeviceVisible() {
    const e = this.crossDeviceEnabledController.value === !0;
    return !(this.isMobile || this.isLinked || !e);
  }
  render() {
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-id-capture-source-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="top-right"></div>
        <div slot="main">
          <div class="step-id-capture-source">
            ${ke("jumio-id-capture-source-before")}
            ${ke(
      "jumio-id-capture-source-title",
      w`<h1 class="capture-source-title">
                ${y("Choose how to proceed", { id: "id.capture-source.title" })}
              </h1>`
    )}
            ${Ip(this, Uc, X8).call(this)} ${Ip(this, Uc, z8).call(this)} ${Ip(this, Uc, q8).call(this)}
            ${ke("jumio-id-capture-source-after")}
          </div>
        </div>
      </x-ds-app-container>
    `;
  }
};
dT = /* @__PURE__ */ new WeakMap();
Uc = /* @__PURE__ */ new WeakSet();
X8 = function() {
  return this.isCrossDeviceVisible ? w`
      <x-ds-card
        data-qa-id="cross-device"
        class="card"
        data-type="${Zn.Secondary}"
        data-header="${y("Use mobile phone", { id: "xdevice.unicorn.attribute" })}"
        data-subheader="${y("Smartphones take clearer pictures of your documents", {
    id: "id.capture-source.smartphones-description"
  })}"
        data-tag="${y("Recommended", { id: "id.capture-source.recommended-tag" })}"
        @click="${() => {
    Ip(this, Uc, rz).call(this);
  }}"
      >
        <span slot="icon" class="icon capture-source-icon icon-device"></span>
      </x-ds-card>
    ` : q;
};
z8 = function() {
  const e = this.isMobile ? y("Smartphones take clearer pictures of your documents", { id: "id.capture-source.smartphones-description" }) : y("Use the built-in camera or an attached webcam", { id: "id.capture-source.webcam-description" });
  return w`
      <x-ds-card
        data-qa-id="this-device"
        class="card"
        data-type="${Zn.Secondary}"
        data-header="${y("Continue on this device", { id: "id.capture-source.this-device-title" })}"
        data-subheader="${e}"
        data-tag="${this.isCrossDeviceVisible ? "" : y("Recommended", { id: "id.capture-source.recommended-tag" })}"
        @click="${() => {
    Ip(this, Uc, ez).call(this);
  }}"
      >
        <span
          slot="icon"
          class="${tn({
    icon: !0,
    "capture-source-icon": !0,
    "icon-device": this.isMobile,
    "icon-camera-video": !this.isMobile
  })}"
        ></span>
      </x-ds-card>
    `;
};
q8 = function() {
  return Y5e(this, dT).value ? w` <x-ds-card
          data-qa-id="upload"
          class="card"
          data-type="${Zn.Secondary}"
          data-header="${y("Upload file", { id: "id.capture-source.upload-title" })}"
          data-subheader="${y(
    "Upload file that is in one of the following formats: JPG, JPEG, PNG from this device",
    { id: "id.capture-source.upload-description" }
  )}"
          @click="${() => {
    Ip(this, Uc, tz).call(this);
  }}"
        >
          <span slot="icon" class="icon capture-source-icon icon-upload"></span>
        </x-ds-card>` : q;
};
ez = function() {
  const e = ve(), { CaptureScreenEntry: t } = un(oe());
  e.send({ type: t });
};
tz = function() {
  const e = ve(), { Upload: t } = un(oe());
  e.send({ type: t });
};
rz = function() {
  sh({
    ...qH(),
    activeScreen: Ot.CrossDevice
  });
};
QB.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .step-id-capture-source {
        display: flex;
        flex-flow: column;
        margin: 0 auto;
        row-gap: 0.5em;
        max-width: 30em;
        align-items: stretch;
        width: 100%;
      }

      .capture-source-title {
        text-align: center;
        margin-bottom: 2rem;
      }

      .capture-source-icon {
        font-size: 2rem;
      }
    `
];
QB = L5e([
  be(),
  P("jumio-sdk-step-id-capture-source")
], QB);
const aA = (e = y) => ({
  [_.ABW]: e("Aruba", { id: "country.abw" }),
  [_.AFG]: e("Afghanistan", { id: "country.afg" }),
  [_.AGO]: e("Angola", { id: "country.ago" }),
  [_.AIA]: e("Anguilla", { id: "country.aia" }),
  [_.ALA]: e("Åland Islands", { id: "country.ala" }),
  [_.ALB]: e("Albania", { id: "country.alb" }),
  [_.AND]: e("Andorra", { id: "country.and" }),
  [_.ARE]: e("United Arab Emirates", { id: "country.are" }),
  [_.ARG]: e("Argentina", { id: "country.arg" }),
  [_.ARM]: e("Armenia", { id: "country.arm" }),
  [_.ASM]: e("American Samoa", { id: "country.asm" }),
  [_.ATA]: e("Antarctica", { id: "country.ata" }),
  [_.ATF]: e("French Southern Territories", { id: "country.atf" }),
  [_.ATG]: e("Antigua and Barbuda", { id: "country.atg" }),
  [_.AUS]: e("Australia", { id: "country.aus" }),
  [_.AUT]: e("Austria", { id: "country.aut" }),
  [_.AZE]: e("Azerbaijan", { id: "country.aze" }),
  [_.BDI]: e("Burundi", { id: "country.bdi" }),
  [_.BEL]: e("Belgium", { id: "country.bel" }),
  [_.BEN]: e("Benin", { id: "country.ben" }),
  [_.BES]: e("Bonaire, Sint Eustatius and Saba", { id: "country.bes" }),
  [_.BFA]: e("Burkina Faso", { id: "country.bfa" }),
  [_.BGD]: e("Bangladesh", { id: "country.bgd" }),
  [_.BGR]: e("Bulgaria", { id: "country.bgr" }),
  [_.BHR]: e("Bahrain", { id: "country.bhr" }),
  [_.BHS]: e("Bahamas", { id: "country.bhs" }),
  [_.BIH]: e("Bosnia and Herzegovina", { id: "country.bih" }),
  [_.BLM]: e("Saint Barthélemy", { id: "country.blm" }),
  [_.BLR]: e("Belarus", { id: "country.blr" }),
  [_.BLZ]: e("Belize", { id: "country.blz" }),
  [_.BMU]: e("Bermuda", { id: "country.bmu" }),
  [_.BOL]: e("Bolivia, Plurinational State of", { id: "country.bol" }),
  [_.BRA]: e("Brazil", { id: "country.bra" }),
  [_.BRB]: e("Barbados", { id: "country.brb" }),
  [_.BRN]: e("Brunei Darussalam", { id: "country.brn" }),
  [_.BTN]: e("Bhutan", { id: "country.btn" }),
  [_.BVT]: e("Bouvet Island", { id: "country.bvt" }),
  [_.BWA]: e("Botswana", { id: "country.bwa" }),
  [_.CAF]: e("Central African Republic", { id: "country.caf" }),
  [_.CAN]: e("Canada", { id: "country.can" }),
  [_.CCK]: e("Cocos (Keeling) Islands", { id: "country.cck" }),
  [_.CHE]: e("Switzerland", { id: "country.che" }),
  [_.CHL]: e("Chile", { id: "country.chl" }),
  [_.CHN]: e("China", { id: "country.chn" }),
  [_.CIV]: e("Côte d'Ivoire", { id: "country.civ" }),
  [_.CMR]: e("Cameroon", { id: "country.cmr" }),
  [_.COD]: e("Congo, The Democratic Republic of the", { id: "country.cod" }),
  [_.COG]: e("Congo", { id: "country.cog" }),
  [_.COK]: e("Cook Islands", { id: "country.cok" }),
  [_.COL]: e("Colombia", { id: "country.col" }),
  [_.COM]: e("Comoros", { id: "country.com" }),
  [_.CPV]: e("Cabo Verde", { id: "country.cpv" }),
  [_.CRI]: e("Costa Rica", { id: "country.cri" }),
  [_.CUB]: e("Cuba", { id: "country.cub" }),
  [_.CUW]: e("Curaçao", { id: "country.cuw" }),
  [_.CXR]: e("Christmas Island", { id: "country.cxr" }),
  [_.CYM]: e("Cayman Islands", { id: "country.cym" }),
  [_.CYP]: e("Cyprus", { id: "country.cyp" }),
  [_.CZE]: e("Czech Republic", { id: "country.cze" }),
  [_.DEU]: e("Germany", { id: "country.deu" }),
  [_.DJI]: e("Djibouti", { id: "country.dji" }),
  [_.DMA]: e("Dominica", { id: "country.dma" }),
  [_.DNK]: e("Denmark", { id: "country.dnk" }),
  [_.DOM]: e("Dominican Republic", { id: "country.dom" }),
  [_.DZA]: e("Algeria", { id: "country.dza" }),
  [_.ECU]: e("Ecuador", { id: "country.ecu" }),
  [_.EGY]: e("Egypt", { id: "country.egy" }),
  [_.ERI]: e("Eritrea", { id: "country.eri" }),
  [_.ESH]: e("Western Sahara", { id: "country.esh" }),
  [_.ESP]: e("Spain", { id: "country.esp" }),
  [_.EST]: e("Estonia", { id: "country.est" }),
  [_.ETH]: e("Ethiopia", { id: "country.eth" }),
  [_.FIN]: e("Finland", { id: "country.fin" }),
  [_.FJI]: e("Fiji", { id: "country.fji" }),
  [_.FLK]: e("Falkland Islands (Malvinas)", { id: "country.flk" }),
  [_.FRA]: e("France", { id: "country.fra" }),
  [_.FRO]: e("Faroe Islands", { id: "country.fro" }),
  [_.FSM]: e("Micronesia, Federated States of", { id: "country.fsm" }),
  [_.GAB]: e("Gabon", { id: "country.gab" }),
  [_.GBR]: e("United Kingdom", { id: "country.gbr" }),
  [_.GEO]: e("Georgia", { id: "country.geo" }),
  [_.GGY]: e("Guernsey", { id: "country.ggy" }),
  [_.GHA]: e("Ghana", { id: "country.gha" }),
  [_.GIB]: e("Gibraltar", { id: "country.gib" }),
  [_.GIN]: e("Guinea", { id: "country.gin" }),
  [_.GLP]: e("Guadeloupe", { id: "country.glp" }),
  [_.GMB]: e("Gambia", { id: "country.gmb" }),
  [_.GNB]: e("Guinea-Bissau", { id: "country.gnb" }),
  [_.GNQ]: e("Equatorial Guinea", { id: "country.gnq" }),
  [_.GRC]: e("Greece", { id: "country.grc" }),
  [_.GRD]: e("Grenada", { id: "country.grd" }),
  [_.GRL]: e("Greenland", { id: "country.grl" }),
  [_.GTM]: e("Guatemala", { id: "country.gtm" }),
  [_.GUF]: e("French Guiana", { id: "country.guf" }),
  [_.GUM]: e("Guam", { id: "country.gum" }),
  [_.GUY]: e("Guyana", { id: "country.guy" }),
  [_.HKG]: e("Hong Kong", { id: "country.hkg" }),
  [_.HMD]: e("Heard Island and McDonald Islands", { id: "country.hmd" }),
  [_.HND]: e("Honduras", { id: "country.hnd" }),
  [_.HRV]: e("Croatia", { id: "country.hrv" }),
  [_.HTI]: e("Haiti", { id: "country.hti" }),
  [_.HUN]: e("Hungary", { id: "country.hun" }),
  [_.IDN]: e("Indonesia", { id: "country.idn" }),
  [_.IMN]: e("Isle of Man", { id: "country.imn" }),
  [_.IND]: e("India", { id: "country.ind" }),
  [_.IOT]: e("British Indian Ocean Territory", { id: "country.iot" }),
  [_.IRL]: e("Ireland", { id: "country.irl" }),
  [_.IRN]: e("Iran, Islamic Republic of", { id: "country.irn" }),
  [_.IRQ]: e("Iraq", { id: "country.irq" }),
  [_.ISL]: e("Iceland", { id: "country.isl" }),
  [_.ISR]: e("Israel", { id: "country.isr" }),
  [_.ITA]: e("Italy", { id: "country.ita" }),
  [_.JAM]: e("Jamaica", { id: "country.jam" }),
  [_.JEY]: e("Jersey", { id: "country.jey" }),
  [_.JOR]: e("Jordan", { id: "country.jor" }),
  [_.JPN]: e("Japan", { id: "country.jpn" }),
  [_.KAZ]: e("Kazakhstan", { id: "country.kaz" }),
  [_.KEN]: e("Kenya", { id: "country.ken" }),
  [_.KGZ]: e("Kyrgyzstan", { id: "country.kgz" }),
  [_.KHM]: e("Cambodia", { id: "country.khm" }),
  [_.KIR]: e("Kiribati", { id: "country.kir" }),
  [_.KNA]: e("Saint Kitts and Nevis", { id: "country.kna" }),
  [_.KOR]: e("Korea, Republic of", { id: "country.kor" }),
  [_.KWT]: e("Kuwait", { id: "country.kwt" }),
  [_.LAO]: e("Lao People's Democratic Republic", { id: "country.lao" }),
  [_.LBN]: e("Lebanon", { id: "country.lbn" }),
  [_.LBR]: e("Liberia", { id: "country.lbr" }),
  [_.LBY]: e("Libya", { id: "country.lby" }),
  [_.LCA]: e("Saint Lucia", { id: "country.lca" }),
  [_.LIE]: e("Liechtenstein", { id: "country.lie" }),
  [_.LKA]: e("Sri Lanka", { id: "country.lka" }),
  [_.LSO]: e("Lesotho", { id: "country.lso" }),
  [_.LTU]: e("Lithuania", { id: "country.ltu" }),
  [_.LUX]: e("Luxembourg", { id: "country.lux" }),
  [_.LVA]: e("Latvia", { id: "country.lva" }),
  [_.MAC]: e("Macao", { id: "country.mac" }),
  [_.MAF]: e("Saint Martin (French part)", { id: "country.maf" }),
  [_.MAR]: e("Morocco", { id: "country.mar" }),
  [_.MCO]: e("Monaco", { id: "country.mco" }),
  [_.MDA]: e("Moldova, Republic of", { id: "country.mda" }),
  [_.MDG]: e("Madagascar", { id: "country.mdg" }),
  [_.MDV]: e("Maldives", { id: "country.mdv" }),
  [_.MEX]: e("Mexico", { id: "country.mex" }),
  [_.MHL]: e("Marshall Islands", { id: "country.mhl" }),
  [_.MKD]: e("Macedonia, The former Yugoslav Republic of", { id: "country.mkd" }),
  [_.MLI]: e("Mali", { id: "country.mli" }),
  [_.MLT]: e("Malta", { id: "country.mlt" }),
  [_.MMR]: e("Myanmar", { id: "country.mmr" }),
  [_.MNE]: e("Montenegro", { id: "country.mne" }),
  [_.MNG]: e("Mongolia", { id: "country.mng" }),
  [_.MNP]: e("Northern Mariana Islands", { id: "country.mnp" }),
  [_.MOZ]: e("Mozambique", { id: "country.moz" }),
  [_.MRT]: e("Mauritania", { id: "country.mrt" }),
  [_.MSR]: e("Montserrat", { id: "country.msr" }),
  [_.MTQ]: e("Martinique", { id: "country.mtq" }),
  [_.MUS]: e("Mauritius", { id: "country.mus" }),
  [_.MWI]: e("Malawi", { id: "country.mwi" }),
  [_.MYS]: e("Malaysia", { id: "country.mys" }),
  [_.MYT]: e("Mayotte", { id: "country.myt" }),
  [_.NAM]: e("Namibia", { id: "country.nam" }),
  [_.NCL]: e("New Caledonia", { id: "country.ncl" }),
  [_.NER]: e("Niger", { id: "country.ner" }),
  [_.NFK]: e("Norfolk Island", { id: "country.nfk" }),
  [_.NGA]: e("Nigeria", { id: "country.nga" }),
  [_.NIC]: e("Nicaragua", { id: "country.nic" }),
  [_.NIU]: e("Niue", { id: "country.niu" }),
  [_.NLD]: e("Netherlands", { id: "country.nld" }),
  [_.NOR]: e("Norway", { id: "country.nor" }),
  [_.NPL]: e("Nepal", { id: "country.npl" }),
  [_.NRU]: e("Nauru", { id: "country.nru" }),
  [_.NZL]: e("New Zealand", { id: "country.nzl" }),
  [_.OMN]: e("Oman", { id: "country.omn" }),
  [_.PAK]: e("Pakistan", { id: "country.pak" }),
  [_.PAN]: e("Panama", { id: "country.pan" }),
  [_.PCN]: e("Pitcairn", { id: "country.pcn" }),
  [_.PER]: e("Peru", { id: "country.per" }),
  [_.PHL]: e("Philippines", { id: "country.phl" }),
  [_.PLW]: e("Palau", { id: "country.plw" }),
  [_.PNG]: e("Papua New Guinea", { id: "country.png" }),
  [_.POL]: e("Poland", { id: "country.pol" }),
  [_.PRI]: e("Puerto Rico", { id: "country.pri" }),
  [_.PRK]: e("Korea, Democratic People's Republic of", { id: "country.prk" }),
  [_.PRT]: e("Portugal", { id: "country.prt" }),
  [_.PRY]: e("Paraguay", { id: "country.pry" }),
  [_.PSE]: e("Palestine, State of", { id: "country.pse" }),
  [_.PYF]: e("French Polynesia", { id: "country.pyf" }),
  [_.QAT]: e("Qatar", { id: "country.qat" }),
  [_.REU]: e("Réunion", { id: "country.reu" }),
  [_.ROU]: e("Romania", { id: "country.rou" }),
  [_.RUS]: e("Russian Federation", { id: "country.rus" }),
  [_.RWA]: e("Rwanda", { id: "country.rwa" }),
  [_.SAU]: e("Saudi Arabia", { id: "country.sau" }),
  [_.SDN]: e("Sudan", { id: "country.sdn" }),
  [_.SEN]: e("Senegal", { id: "country.sen" }),
  [_.SGP]: e("Singapore", { id: "country.sgp" }),
  [_.SGS]: e("South Georgia and the South Sandwich Islands", { id: "country.sgs" }),
  [_.SHN]: e("Saint Helena, Ascension and Tristan da Cunha", { id: "country.shn" }),
  [_.SJM]: e("Svalbard and Jan Mayen", { id: "country.sjm" }),
  [_.SLB]: e("Solomon Islands", { id: "country.slb" }),
  [_.SLE]: e("Sierra Leone", { id: "country.sle" }),
  [_.SLV]: e("El Salvador", { id: "country.slv" }),
  [_.SMR]: e("San Marino", { id: "country.smr" }),
  [_.SOM]: e("Somalia", { id: "country.som" }),
  [_.SPM]: e("Saint Pierre and Miquelon", { id: "country.spm" }),
  [_.SRB]: e("Serbia", { id: "country.srb" }),
  [_.SSD]: e("South Sudan", { id: "country.ssd" }),
  [_.STP]: e("Sao Tome and Principe", { id: "country.stp" }),
  [_.SUR]: e("Suriname", { id: "country.sur" }),
  [_.SVK]: e("Slovak Republic", { id: "country.svk" }),
  [_.SVN]: e("Slovenia", { id: "country.svn" }),
  [_.SWE]: e("Sweden", { id: "country.swe" }),
  [_.SWZ]: e("Swaziland", { id: "country.swz" }),
  [_.SXM]: e("Sint Maartin (Dutch part)", { id: "country.sxm" }),
  [_.SYC]: e("Seychelles", { id: "country.syc" }),
  [_.SYR]: e("Syrian Arab Republic", { id: "country.syr" }),
  [_.TCA]: e("Turks and Caicos Islands", { id: "country.tca" }),
  [_.TCD]: e("Chad", { id: "country.tcd" }),
  [_.TGO]: e("Togo", { id: "country.tgo" }),
  [_.THA]: e("Thailand", { id: "country.tha" }),
  [_.TJK]: e("Tajikistan", { id: "country.tjk" }),
  [_.TKL]: e("Tokelau", { id: "country.tkl" }),
  [_.TKM]: e("Turkmenistan", { id: "country.tkm" }),
  [_.TLS]: e("Timor Leste", { id: "country.tls" }),
  [_.TON]: e("Tonga", { id: "country.ton" }),
  [_.TTO]: e("Trinidad and Tobago", { id: "country.tto" }),
  [_.TUN]: e("Tunisia", { id: "country.tun" }),
  [_.TUR]: e("Turkey", { id: "country.tur" }),
  [_.TUV]: e("Tuvalu", { id: "country.tuv" }),
  [_.TWN]: e("Taiwan, Province of China", { id: "country.twn" }),
  [_.TZA]: e("Tanzania, United Republic of", { id: "country.tza" }),
  [_.UGA]: e("Uganda", { id: "country.uga" }),
  [_.UKR]: e("Ukraine", { id: "country.ukr" }),
  [_.UMI]: e("United States Minor Outlying Islands", { id: "country.umi" }),
  [_.URY]: e("Uruguay", { id: "country.ury" }),
  [_.USA]: e("United States of America", { id: "country.usa" }),
  [_.UZB]: e("Uzbekistan", { id: "country.uzb" }),
  [_.VAT]: e("Holy See", { id: "country.vat" }),
  [_.VCT]: e("Saint Vincent and the Grenadines", { id: "country.vct" }),
  [_.VEN]: e("Venezuela, Bolivarian Republic of", { id: "country.ven" }),
  [_.VGB]: e("Virgin Islands, British", { id: "country.vgb" }),
  [_.VIR]: e("Virgin Islands, U.S.", { id: "country.vir" }),
  [_.VNM]: e("Viet Nam", { id: "country.vnm" }),
  [_.VUT]: e("Vanuatu", { id: "country.vut" }),
  [_.WLF]: e("Wallis and Futuna", { id: "country.wlf" }),
  [_.WSM]: e("Samoa", { id: "country.wsm" }),
  [_.XKX]: e("Kosovo", { id: "country.xkx" }),
  [_.YEM]: e("Yemen", { id: "country.yem" }),
  [_.ZAF]: e("South Africa", { id: "country.zaf" }),
  [_.ZMB]: e("Zambia", { id: "country.zmb" }),
  [_.ZWE]: e("Zimbabwe", { id: "country.zwe" })
}), O5e = ({ countryList: e = [], translate: t = y }) => {
  const r = aA(t), n = e.map((a) => ({
    label: r[a.code],
    value: a.code
  }));
  return kAe(n, "label"), [
    {
      label: t("--- Select ---", { id: "country.none" }),
      value: ""
    },
    ...n
  ];
};
var Iu, Kc, nz, az, iz;
class j5e {
  constructor(t) {
    E(this, Kc);
    E(this, Iu);
    G(this, Iu, O(this, Kc, iz).call(this)), this.countryList$ = O(this, Kc, nz).call(this), t.addController(this);
  }
  hostDisconnected() {
  }
  selectCountry(t) {
    const { selectedCountry: r } = S(this, Iu).getUserSelection(), n = O(this, Kc, az).call(this, t) ? t : void 0;
    r !== t && S(this, Iu).patchUserSelection({
      selectedCountry: n,
      selectedIdType: void 0,
      selectedIdFormat: void 0,
      selectedDocumentVariant: void 0
    });
  }
  getSelectedCountry$() {
    return S(this, Iu).selectUserSelection$().pipe(te((t) => t.selectedCountry));
  }
}
Iu = new WeakMap(), Kc = new WeakSet(), nz = function() {
  return Ce().getConfiguration().selectSettings$().pipe(
    te((t) => {
      const r = aA();
      return t.supportedCountries.map((n) => ({
        code: n.country,
        label: r[n.country]
      }));
    })
  );
}, az = function(t) {
  return Object.keys(_).includes(t);
}, iz = function() {
  return Ce().getControllerById(T.Id);
};
var P5e = Object.defineProperty, $5e = Object.getOwnPropertyDescriptor, oz = (e) => {
  throw TypeError(e);
}, K5e = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? $5e(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && P5e(t, r, a), a;
}, uT = (e, t, r) => t.has(e) || oz("Cannot " + r), Wk = (e, t, r) => (uT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), hC = (e, t, r) => t.has(e) ? oz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), X5e = (e, t, r, n) => (uT(e, t, "write to private field"), t.set(e, r), r), z5e = (e, t, r) => (uT(e, t, "access private method"), r), Mb, FB, TB, RB, sz;
let DB = class extends N {
  constructor() {
    super(...arguments), hC(this, RB), hC(this, Mb), hC(this, FB, new ue(this, this.componentController.getSelectedCountry$())), hC(this, TB, new ue(this, this.componentController.countryList$));
  }
  get componentController() {
    return Wk(this, Mb) ?? X5e(this, Mb, new j5e(this));
  }
  render() {
    const e = O5e({
      countryList: Wk(this, TB).value
    });
    return w`
      <label class="label">
        ${y("Choose issuing country/region", {
      id: "id-country-type.header.country"
    })}
      </label>
      <x-ds-dropdown
        class="dropdown"
        data-qa-id="country-dropdown"
        @optionselected="${z5e(this, RB, sz).bind(this)}"
        .options="${e}"
        .selection="${Wk(this, FB).value}"
      ></x-ds-dropdown>
    `;
  }
};
Mb = /* @__PURE__ */ new WeakMap();
FB = /* @__PURE__ */ new WeakMap();
TB = /* @__PURE__ */ new WeakMap();
RB = /* @__PURE__ */ new WeakSet();
sz = function(e) {
  if (e instanceof zG) {
    const t = e.detail.value;
    Te.selectedCountry(this, { metadata: { country: t }, tags: { country: t } }), this.componentController.selectCountry(t);
  }
};
DB.styles = [
  ...N.styles,
  ee`
      .label {
        font: var(--text-font-h4);
      }

      .dropdown {
        display: block;
      }

      .label + .dropdown {
        margin-top: 0.5em;
      }
    `
];
DB = K5e([
  be(),
  P("jumio-sdk-step-id-country-selection")
], DB);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* lz(e, t) {
  if (e !== void 0) {
    let r = 0;
    for (const n of e) yield t(n, r++);
  }
}
var lS, Jo, w2, cz;
class q5e {
  constructor(t) {
    E(this, w2);
    E(this, lS);
    E(this, Jo);
    G(this, lS, t), G(this, Jo, O(this, w2, cz).call(this)), this.availableIdTypes$ = S(this, Jo).selectIdTypesForCountry$(), t.addController(this);
  }
  hostConnected() {
  }
  selectCredentialType(t, r) {
    const n = ve(), { DocTypeDecision: a } = un(oe()), { selectedCountry: i } = S(this, Jo).getUserSelection();
    i && (S(this, Jo).patchUserSelection({
      selectedIdType: t,
      selectedIdFormat: void 0,
      selectedDocumentVariant: void 0,
      selectedDigitalIdentity: r
    }), n.send({ type: a }), Te.selectedDocument(S(this, lS), {
      metadata: { document: t },
      tags: {
        document: t
      }
    }));
  }
  getPartsForDocumentType(t) {
    const { selectedCountry: r } = S(this, Jo).getUserSelection(), n = S(this, Jo).getPartsForDocumentType({
      selectedCountry: r,
      selectedDocumentVariant: Qu.Plastic,
      selectedIdType: t
    }), a = S(this, Jo).getPartsForDocumentType({
      selectedCountry: r,
      selectedDocumentVariant: Qu.Paper,
      selectedIdType: t
    });
    return n.length > 0 ? n : a;
  }
}
lS = new WeakMap(), Jo = new WeakMap(), w2 = new WeakSet(), cz = function() {
  return Ce().getControllerById(T.Id);
};
var eDe = Object.defineProperty, tDe = Object.getOwnPropertyDescriptor, dz = (e) => {
  throw TypeError(e);
}, rDe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? tDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && eDe(t, r, a), a;
}, hT = (e, t, r) => t.has(e) || dz("Cannot " + r), k3 = (e, t, r) => (hT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ek = (e, t, r) => t.has(e) ? dz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), nDe = (e, t, r, n) => (hT(e, t, "write to private field"), t.set(e, r), r), Td = (e, t, r) => (hT(e, t, "access private method"), r), Gb, JB, Os, uz, hz, pz, gz, fz, mz, vz;
let VB = class extends N {
  constructor() {
    super(...arguments), Ek(this, Os), Ek(this, Gb), Ek(this, JB, new ue(this, this.componentController.availableIdTypes$));
  }
  get componentController() {
    return k3(this, Gb) ?? nDe(this, Gb, new q5e(this));
  }
  render() {
    const e = k3(this, JB).value ?? [];
    return this.setAttribute("data-has-items", String(e.length > 0)), e.length > 0 ? w`
          <h4 class="label">${y("Select ID type", { id: "id-country-type.header.id" })}</h4>
          ${lz(e, (t) => Td(this, Os, uz).call(this, t))}
        ` : q;
  }
  getSubheaderForDocumentType(e) {
    const t = this.componentController.getPartsForDocumentType(e), r = t.find((a) => a.side === cr.Front), n = t.find((a) => a.side === cr.Back);
    return r && n ? y("Front and back", { id: "id-type-front-back" }) : r ? e === ft.Passport ? y("Photo page", { id: "id-type-photo-page" }) : y("Front", { id: "jumio_accessibility_scan_id_front" }) : n ? y("Back", { id: "jumio_accessibility_scan_id_back" }) : "";
  }
};
Gb = /* @__PURE__ */ new WeakMap();
JB = /* @__PURE__ */ new WeakMap();
Os = /* @__PURE__ */ new WeakSet();
uz = function(e) {
  return w`${El(
    e.idType,
    [
      [ft.Passport, () => Td(this, Os, hz).call(this)],
      [ft.IdCard, () => Td(this, Os, pz).call(this)],
      [ft.DrivingLicense, () => Td(this, Os, gz).call(this)],
      [ft.Visa, () => Td(this, Os, mz).call(this)],
      [ft.ResidencePermit, () => Td(this, Os, vz).call(this)],
      [ft.DigitalIdentity, () => Td(this, Os, fz).call(this, e)]
    ],
    () => w``
  )}`;
};
hz = function() {
  const e = y("Passport", {
    id: "id-type-name.passport"
  });
  return w`
      <x-ds-card
        data-qa-id="passport"
        class="card"
        data-type="${Zn.Secondary}"
        data-header="${e}"
        data-subheader="${this.getSubheaderForDocumentType(ft.Passport)}"
        @click="${() => {
    this.componentController.selectCredentialType(ft.Passport);
  }}"
        data-qa-id="passport-card"
      >
        <span slot="icon" class="icon icon-id-passport"></span>
      </x-ds-card>
    `;
};
pz = function() {
  const e = y("Identity card", {
    id: "id-type-name.identity-card"
  });
  return w`
      <x-ds-card
        class="card"
        data-qa-id="id-card"
        data-type="${Zn.Secondary}"
        data-header="${e}"
        data-subheader="${this.getSubheaderForDocumentType(ft.IdCard)}"
        @click="${() => {
    this.componentController.selectCredentialType(ft.IdCard);
  }}"
        data-qa-id="id-card"
      >
        <span slot="icon" class="icon icon-id-front"></span>
      </x-ds-card>
    `;
};
gz = function() {
  const e = y("Driver's license", {
    id: "id-type-name.drivers-license"
  });
  return w`
      <x-ds-card
        class="card"
        data-qa-id="driving-license"
        data-type="${Zn.Secondary}"
        data-header="${e}"
        data-subheader="${this.getSubheaderForDocumentType(ft.DrivingLicense)}"
        @click="${() => {
    this.componentController.selectCredentialType(ft.DrivingLicense);
  }}"
        data-qa-id="license-card"
      >
        <span slot="icon" class="icon icon-id-drivers-license"></span>
      </x-ds-card>
    `;
};
fz = function(e) {
  var r;
  const t = y("Digital ID", {
    id: "id-type-dl"
  });
  return w`
      <x-ds-card
        class="card"
        data-qa-id="driving-license-digital"
        data-type="${Zn.Secondary}"
        data-header="${(r = e.digitalIdentity) == null ? void 0 : r.title}"
        data-subheader="${t}"
        @click="${() => {
    this.componentController.selectCredentialType(ft.DigitalIdentity, e.digitalIdentity);
  }}"
        data-qa-id="license-card"
      >
        <span slot="icon" class="icon icon-bra-id"></span>
      </x-ds-card>
    `;
};
mz = function() {
  return w`
      <x-ds-card
        class="card"
        data-qa-id="visa"
        data-type="${Zn.Secondary}"
        data-header="${y("Visa", { id: "id-type-name.visa" })}"
        data-subheader="${this.getSubheaderForDocumentType(ft.Visa)}"
        @click="${() => {
    this.componentController.selectCredentialType(ft.Visa);
  }}"
        data-qa-id="visa-card"
      >
        <span slot="icon" class="icon icon-id-work-visa"></span>
      </x-ds-card>
    `;
};
vz = function() {
  return w`
      <x-ds-card
        class="card"
        data-qa-id="residence-permit"
        data-type="${Zn.Secondary}"
        data-header="${y("Residence permit", { id: "id-type-option.residence-permit" })}"
        data-subheader="${this.getSubheaderForDocumentType(ft.ResidencePermit)}"
        @click="${() => {
    this.componentController.selectCredentialType(ft.ResidencePermit);
  }}"
        data-qa-id="permit-card"
      ></x-ds-card>
    `;
};
VB.styles = [
  ...N.styles,
  ee`
      :host([data-has-items='false']) {
        display: none;
      }

      :host([data-has-items='true']) {
        display: flex;
        flex-direction: column;
        row-gap: 0.5em;
      }

      .card {
        display: block;
      }

      .icon {
        min-width: 1em; /* 40 / 40 */
        text-align: center;
        font-size: 250%;
      }
    `
];
VB = rDe([
  be(),
  P("jumio-sdk-step-id-document-collection")
], VB);
var aDe = Object.defineProperty, iDe = Object.getOwnPropertyDescriptor, Sz = (e) => {
  throw TypeError(e);
}, oDe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? iDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && aDe(t, r, a), a;
}, sDe = (e, t, r) => t.has(e) || Sz("Cannot " + r), lDe = (e, t, r) => t.has(e) ? Sz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), _3 = (e, t, r) => (sDe(e, t, "access private method"), r), xb, Iz, Cz;
let MB = class extends N {
  constructor() {
    super(...arguments), lDe(this, xb);
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownDocumentSelectScreen(this);
  }
  render() {
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-id-document-select-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="top-right"></div>
        <div slot="main">
          <div class="step-id-document">
            ${ke("jumio-id-document-select-before")}
            ${ke(
      "jumio-id-document-select-title",
      w`<h1 class="text-center">${y("ID Verification", { id: "id-title" })}</h1>`
    )}
            ${_3(this, xb, Iz).call(this)} ${_3(this, xb, Cz).call(this)}
            <jumio-sdk-cross-device-button></jumio-sdk-cross-device-button>
            ${ke("jumio-id-document-select-after")}
          </div>
        </div>
      </x-ds-app-container>
    `;
  }
};
xb = /* @__PURE__ */ new WeakSet();
Iz = function() {
  const e = document.querySelector("template#id_document-type_country-selection");
  return e ? w`${Ea(e)}` : w`<jumio-sdk-step-id-country-selection></jumio-sdk-step-id-country-selection>`;
};
Cz = function() {
  const e = document.querySelector("template#id_document-type_document-collection");
  return e ? w`${Ea(e)}` : w`<jumio-sdk-step-id-document-collection></jumio-sdk-step-id-document-collection>`;
};
MB.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .step-id-document {
        display: flex;
        flex-flow: column;
        margin: 0 auto;
        row-gap: 0.5em;
        max-width: 30em;
        align-items: stretch;
        width: 100%;
      }

      jumio-sdk-step-id-country-selection + jumio-sdk-step-id-document-collection {
        margin-top: 1.5em;
      }
    `
];
MB = oDe([
  be(),
  P("jumio-sdk-step-id-document-type")
], MB);
var cS, Mp, A2, bz;
class cDe {
  constructor(t) {
    E(this, A2);
    E(this, cS);
    E(this, Mp);
    G(this, cS, t), G(this, Mp, O(this, A2, bz).call(this)), this.variants$ = S(this, Mp).selectIdTypeVariantCollection$(), t.addController(this);
  }
  selectDocumentVariant(t) {
    const r = ve(), { DocTypeDecision: n } = un(oe());
    S(this, Mp).patchUserSelection({
      selectedIdFormat: void 0,
      // Reset the value, it will be calculated automatically
      selectedDocumentVariant: t
    }), Te.selectedDocumentVariant(S(this, cS), { metadata: { variant: t }, tags: { variant: t } }), r.send({ type: n });
  }
  hostConnected() {
  }
}
cS = new WeakMap(), Mp = new WeakMap(), A2 = new WeakSet(), bz = function() {
  return Ce().getControllerById(T.Id);
};
var dDe = Object.defineProperty, uDe = Object.getOwnPropertyDescriptor, yz = (e) => {
  throw TypeError(e);
}, hDe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? uDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && dDe(t, r, a), a;
}, pT = (e, t, r) => t.has(e) || yz("Cannot " + r), N3 = (e, t, r) => (pT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Qk = (e, t, r) => t.has(e) ? yz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Z3 = (e, t, r, n) => (pT(e, t, "write to private field"), t.set(e, r), r), GB = (e, t, r) => (pT(e, t, "access private method"), r), Hb, Lb, tm, xB, wz;
let HB = class extends N {
  constructor() {
    super(...arguments), Qk(this, tm), Qk(this, Hb), Qk(this, Lb);
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownDocumentVariantSelectScreen(this), Z3(this, Lb, new ue(this, this.componentController.variants$));
  }
  get componentController() {
    return N3(this, Hb) ?? Z3(this, Hb, new cDe(this));
  }
  render() {
    var t;
    const e = ((t = N3(this, Lb)) == null ? void 0 : t.value) ?? [];
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-id-document-variant-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main" class="page-items">
          ${ke("jumio-id-document-variant-before")}
          ${lz(
      e,
      (r) => El(r.variant, [
        [
          Qu.Plastic,
          () => {
            const n = y("Plastic Card", { id: "jumio_idtype_format_option_plastic" });
            return GB(this, tm, xB).call(this, n, r.variant);
          }
        ],
        [
          Qu.Paper,
          () => {
            const n = y("Other Format", { id: "jumio_idtype_format_option_other" });
            return GB(this, tm, xB).call(this, n, r.variant);
          }
        ]
      ])
    )}
          ${ke("jumio-id-document-variant-after")}
        </div>
        <jumio-sdk-cross-device-button slot="bottom-left" data-fluid="false"></jumio-sdk-cross-device-button>
      </x-ds-app-container>
    `;
  }
};
Hb = /* @__PURE__ */ new WeakMap();
Lb = /* @__PURE__ */ new WeakMap();
tm = /* @__PURE__ */ new WeakSet();
xB = function(e, t) {
  return w`
      <x-ds-card
        data-qa-id="${t.toLowerCase()}"
        data-type="${Zn.Secondary}"
        data-header="${e}"
        @jcardclick="${GB(this, tm, wz).bind(this, t)}"
      ></x-ds-card>
    `;
};
wz = function(e) {
  this.componentController.selectDocumentVariant(e);
};
HB.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .page-items {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
        align-items: stretch;
        max-width: 32em;
        margin-inline: auto;
        width: 100%;
      }
    `
];
HB = hDe([
  be(),
  P("jumio-sdk-step-id-document-variant")
], HB);
var el, Cu, bu, Bi, Az, Uz, Yb, kz;
class pDe {
  constructor(t) {
    E(this, Bi);
    E(this, el);
    E(this, Cu);
    E(this, bu);
    G(this, bu, t), G(this, el, O(this, Bi, kz).call(this)), G(this, Cu, S(this, el).selectUserSelection$()), this.digitalIdentity$ = S(this, Cu).pipe(
      te((r) => r.selectedDigitalIdentity)
    ), this.idType$ = S(this, Cu).pipe(te((r) => r.selectedIdType)), this.parts$ = S(this, Cu).pipe(
      te((r) => ({
        selection: r,
        parts: S(this, el).getPartsForDocumentType(r)
      })),
      te(({ parts: r, selection: n }) => O(this, Bi, Az).call(this, r, n)),
      go(oH(oe())),
      ae(([r, n]) => {
        r.forEach((a) => {
          const i = n.find((o) => o.id === a);
          i ? i.result.decisionType === zn.REJECT && (cH(a), O(this, Bi, Yb).call(this, a)) : O(this, Bi, Yb).call(this, a);
        });
      }),
      Wt(() => WE(oe())),
      QW({ bufferSize: 1, refCount: !0 })
    ), this.ready$ = this.parts$.pipe(
      te((r) => r.every((n) => n.state === er.Success))
    ), t.addController(this);
  }
  hostConnected() {
  }
  async uploadFile(t, r) {
    const n = S(this, el).getUserSelection();
    let { selectedIdType: a } = n;
    const { selectedDigitalIdentity: i, selectedCountry: o } = n;
    a || (a = ft.DrivingLicense, Te.defaultToDL(S(this, bu))), a == ft.DigitalIdentity && (i != null && i.requestedIdType) && (a = i.requestedIdType);
    const { detail: s } = t, c = r, l = r.includes(or.FrontSide), u = await S(this, el).uploadDataAsync({
      uploadFilesMetadata: {
        files: [
          {
            multipartName: c,
            fileType: OS[s.mimeType],
            uploadType: l ? or.FrontSide : or.BackSide,
            usabilityExpected: !0,
            country: o,
            idType: a,
            file: new File([s.file], `${c}.${s.extension}`, {
              type: s.mimeType,
              lastModified: Date.now()
            }),
            cls: sd(),
            clsm: ld()
          }
        ]
      }
    });
    return rI("UPLOAD"), Te.uploadedFile(S(this, bu), {
      metadata: { source: Fu.Upload }
    }), u;
  }
  removeFile(t) {
    O(this, Bi, Yb).call(this, t);
  }
}
el = new WeakMap(), Cu = new WeakMap(), bu = new WeakMap(), Bi = new WeakSet(), Az = function(t, r) {
  const { isBackMissing: n } = S(this, el).isUsabilityBackMissing(oe());
  return t.filter((a) => !n || a.side === cr.Back).map((a) => O(this, Bi, Uz).call(this, a.side, r.selectedIdType));
}, Uz = function(t, r) {
  r || (r = ft.DrivingLicense, Te.defaultToDL(S(this, bu)));
  const a = t === cr.Front ? or.FrontSide : or.BackSide;
  return `${oe()}_${r}_${a}`;
}, Yb = function(t) {
  const r = {
    id: t,
    state: er.NotStarted,
    source: Fu.Upload
  };
  ZC(r);
}, kz = function() {
  return Ce().getControllerById(T.Id);
};
const gDe = (e, t) => {
  const r = /* @__PURE__ */ new Map();
  return r.set("brazilian-id", new SDe().showErrorMessage()), r.set("max-file-size", new mDe(t).showErrorMessage()), r.set("file-type", new vDe().showErrorMessage()), r.get(e);
}, fDe = (e) => {
  const { isBrazilianID: t, errorType: r } = e ?? {};
  return t ? "brazilian-id" : r ?? "max-file-size";
};
class mDe {
  constructor(t) {
    this.maxFileSize = t;
  }
  showErrorMessage() {
    return EAe(this.maxFileSize);
  }
}
class vDe {
  showErrorMessage() {
    return QAe();
  }
}
class SDe {
  showErrorMessage() {
    return WAe();
  }
}
let pC = null;
const IDe = async () => {
  if (!pC) {
    pC = await import("./pdfjs/pdf-BmhaAGRM.js");
    const e = await import("./pdfjs/pdf.worker.min-DRyddSXH.js");
    pC.GlobalWorkerOptions.workerSrc = e.default;
  }
  return pC;
}, CDe = async (e) => await (await (await IDe()).getDocument(await e.arrayBuffer()).promise).getPage(1), _z = async (e) => {
  const t = await CDe(e), r = t.getViewport({ scale: 1 }), n = document.createElement("canvas");
  n.width = r.width, n.height = r.height;
  const a = n.getContext("2d");
  if (a)
    return await t.render({ canvasContext: a, viewport: r }).promise, n;
}, bDe = (e) => e.includes(or.FrontSide) ? cr.Front : e.includes(or.BackSide) ? cr.Back : cr.None, yDe = (e) => H2(e.blob) ? wDe(e) : new Promise((t) => {
  const r = new FileReader();
  r.readAsDataURL(e.blob), r.onloadend = () => {
    var n;
    t({
      name: e.id,
      base64: ((n = r.result) == null ? void 0 : n.toString()) ?? ""
    });
  };
}), wDe = async (e) => {
  let t = "";
  try {
    const r = await _z(e.blob);
    t = (r == null ? void 0 : r.toDataURL()) || "";
  } catch {
  }
  return {
    name: e.id,
    base64: t
  };
}, Nz = (e, t) => {
  if (e === ft.DigitalIdentity && t)
    return t.title;
  switch (e) {
    case ft.DrivingLicense:
      return y("Driving licence", { id: "id-type-name.drivers-license" });
    case ft.IdCard:
      return y("Identity card", { id: "id-type-name.identity-card" });
    case ft.Passport:
      return y("Passport", { id: "id-type-name.passport" });
    case ft.Visa:
      return y("Visa", { id: "id-type-name.visa" });
    case ft.ResidencePermit:
      return y("Residence permit", { id: "id-type-option.residence-permit" });
    default:
      return "";
  }
};
var ADe = Object.defineProperty, UDe = Object.getOwnPropertyDescriptor, Zz = (e) => {
  throw TypeError(e);
}, kDe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? UDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ADe(t, r, a), a;
}, gT = (e, t, r) => t.has(e) || Zz("Cannot " + r), ko = (e, t, r) => (gT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Ao = (e, t, r) => t.has(e) ? Zz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), LB = (e, t, r, n) => (gT(e, t, "write to private field"), t.set(e, r), r), xl = (e, t, r) => (gT(e, t, "access private method"), r), Ob, Oy, mv, YB, _o, Bz, Wz, Ez, Qz, OB, jB, PB, $B, KB, Fz, XB, Tz;
let zB = class extends N {
  constructor() {
    super(), Ao(this, _o), this.uploadErrorMessage$ = new Kt([void 0, void 0]), Ao(this, Ob), Ao(this, Oy, 0), Ao(this, mv, !1), Ao(this, YB, (e) => {
      var l, u, g;
      const { part: t, index: r, idType: n, filePickerErrorType: a } = e, i = bDe(t.id), o = n === ft.DigitalIdentity, s = dD(), c = gDe(
        fDe({
          isBrazilianID: ((l = this.digitalIdentityController.value) == null ? void 0 : l.type) === Nm.BrazilianDrivingLicense,
          errorType: a
        }),
        s
      );
      return w` <div class="step-id-upload-item">
      <x-file-upload
        @filepickererror="${(p) => {
        xl(this, _o, Bz).call(this, r, p.detail);
      }}"
        @fileupload="${(p) => ko(this, PB).call(this, p, t.id)}"
        @fileremove="${() => {
        ko(this, $B).call(this, t.id);
      }}"
        @imageviewertoggle="${(p) => {
        xl(this, _o, XB).call(this, p, r);
      }}"
        data-qa-id="upload-zone"
        data-status="${t.state}"
        data-max-file-size="${s}"
        data-accept="${o ? "application/pdf" : "image/jpg, image/jpeg, image/png"}"
        data-key="${t.id}"
        data-preview-url="${(u = this.imageCollectionController) != null && u.value ? (g = this.imageCollectionController.value[r]) == null ? void 0 : g.base64 : void 0}"
      >
        <div
          slot="upload"
          class="${tn({
        "file-upload-item": !0,
        [t.state]: !0
      })}"
        >
          ${xl(this, _o, Ez).call(this, t, i, this.digitalIdentityController.value)}
          <h3>${xl(this, _o, Qz).call(this, i, this.digitalIdentityController.value)}</h3>
          <x-ds-button data-qa-id="upload-button" data-type="${De.Secondary}">
            ${_l() ? y("Choose file", { id: "upload.button.choose.first" }) : y("Click or drop a file to upload", { id: "upload.generic.button" })}
          </x-ds-button>
        </div>
        <div slot="loading" class="file-upload-item">
          <x-ds-loading-indicator data-qa-id="file-upload-progress"></x-ds-loading-indicator>
          <h3>${y("Uploading", { id: "upload.title" })}</h3>
        </div>
        <div slot="error" class="file-upload-item">
          <x-ds-upload-error-message data-qa-id="file-upload-error" data-message="${c}"></x-ds-upload-error-message>
          <x-ds-button data-type="${De.Secondary}">
            ${y("Click or drop a file to upload", { id: "upload.generic.button" })}
          </x-ds-button>
        </div>
        <div slot="drop" class="file-upload-item">
          <span class="side-icon icon icon-download download-icon"></span>
          <h3>${y("Drop image here", { id: "upload.dnd.confirm" })}</h3>
        </div>
      </x-file-upload>
    </div>`;
    }), Ao(this, OB, (e) => {
      if ((e == null ? void 0 : e.type) === Nm.BrazilianDrivingLicense) {
        const n = Rc(
          y(
            "To proceed with the upload, make sure you have downloaded a digital driver’s license PDF from the official government application {{link}}",
            {
              id: "id.brazil_chn_instructions"
            }
          )
        )({
          link: `<a target="_blank" href="https://www.gov.br/pt-br/servicos/obter-carteira-digital-de-transito">${y("Carteira Digital de Trânsito", { id: "id.brazil_chn_instructions_link" })}</a>`
        });
        return w`<p class="upload-instructions">${Pm(n)}</p>`;
      }
      const t = Rc(
        y("Maximum File size {{uploadFileSizeMax}}MB.", { id: "error.maxfilesize.description" })
      )({ uploadFileSizeMax: XW(dD()) });
      return w`<p class="upload-instructions">
      ${y(
        "Upload a color image of the entire document. Screenshots are not allowed. JPG, JPEG, or PNG format only.",
        {
          id: "upload.file.id.hint.nonDV"
        }
      )}
      ${t}
    </p>`;
    }), Ao(this, jB, (e, t) => Nz(e, t)), Ao(this, PB, async (e, t) => {
      await this.componentController.uploadFile(e, t);
    }), Ao(this, $B, (e) => {
      this.componentController.removeFile(e);
    }), Ao(this, KB, () => {
      const e = ve(), { IdUsabilityCheck: t } = un(oe());
      e.send({ type: t });
    }), this.digitalIdentityController = new ue(this, this.componentController.digitalIdentity$), this.idTypeController = new ue(this, this.componentController.idType$), this.partsController = new ue(this, this.componentController.parts$), this.uploadErrorMessageController = new ue(this, this.uploadErrorMessage$), this.readyController = new ue(this, this.componentController.ready$), this.imageCollectionController = new ue(this, xl(this, _o, Fz).call(this)), this.brazilianIdImageController = new ue(this, xl(this, _o, Wz).call(this));
  }
  get componentController() {
    return ko(this, Ob) ?? LB(this, Ob, new pDe(this));
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownUploadScreen(this, {
      metadata: { category: T.Id }
    });
  }
  render() {
    var e, t, r, n;
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-id-upload-backward-button",
      w` <jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main">
          ${ke("jumio-id-upload-before")}
          <div class="step-id-upload">
            <h1 data-qa-id="upload-title">
              ${(e = this.idTypeController) != null && e.value ? ko(this, jB).call(this, (t = this.idTypeController) == null ? void 0 : t.value, this.digitalIdentityController.value) : q}
            </h1>
            ${ko(this, OB).call(this, this.digitalIdentityController.value)}
            <div class="step-id-upload-container">
              ${(r = this.partsController) != null && r.value ? this.partsController.value.map(
      (a, i) => {
        var o, s;
        return ko(this, YB).call(this, {
          part: a,
          index: i,
          idType: this.idTypeController.value,
          filePickerErrorType: (s = (o = this.uploadErrorMessageController) == null ? void 0 : o.value) == null ? void 0 : s[i]
        });
      }
    ) : q}
            </div>
            <div class="button-container">
              <x-ds-button
                class="start-btn"
                data-disabled="${!((n = this.readyController) != null && n.value)}"
                data-fluid="true"
                data-qa-id="continue-button"
                data-size="medium"
                data-type="primary"
                @jclick="${() => {
      ko(this, KB).call(this);
    }}"
              >
                ${y("Continue", {
      id: "identity.guidance.cam.button"
    })}
              </x-ds-button>
            </div>
          </div>
          ${ke("jumio-id-upload-after")}
        </div>
        ${ko(this, mv) ? w`
              <div slot="overlay" class="overlay">
                <x-ds-image-viewer
                  @imageviewertoggle="${(a) => {
      xl(this, _o, XB).call(this, a);
    }}"
                  @imageviewerremove="${(a) => {
      xl(this, _o, Tz).call(this, a);
    }}"
                  data-index="${ko(this, Oy)}"
                >
                  ${(this.imageCollectionController.value ?? []).map((a) => w`<img slot="image" src="${a.base64}" alt="${a.name}" data-id="${a.name}" />`)}
                </x-ds-image-viewer>
              </div>
            ` : q}
      </x-ds-app-container>
    `;
  }
};
Ob = /* @__PURE__ */ new WeakMap();
Oy = /* @__PURE__ */ new WeakMap();
mv = /* @__PURE__ */ new WeakMap();
YB = /* @__PURE__ */ new WeakMap();
_o = /* @__PURE__ */ new WeakSet();
Bz = function(e, t) {
  const r = goe(this.uploadErrorMessage$.value);
  r[e] = t, this.uploadErrorMessage$.next(r);
};
Wz = function() {
  return po(import(
    /* @vite-ignore */
    "./BRAZILIAN_ID.BmZRIYzL.js"
  ));
};
Ez = function(e, t, r) {
  var n;
  return (r == null ? void 0 : r.type) === Nm.BrazilianDrivingLicense ? w`<div
        class="${tn({
    "brazilian-id": !0,
    [e.state]: !0
  })}"
      >
        <img width="100%" src="${(n = this.brazilianIdImageController.value) == null ? void 0 : n.default}" alt="brazilian id image" />
      </div>` : w`<span class="side-icon icon icon-id-${t == null ? void 0 : t.toLocaleLowerCase()}"></span>`;
};
Qz = function(e, t) {
  return (t == null ? void 0 : t.type) === Nm.BrazilianDrivingLicense ? w`${t.title}` : w`<h3>
      ${e === cr.Front ? y("Upload front", { id: "upload.front.only" }) : y("Upload back", { id: "upload.back.only" })}
    </h3>`;
};
OB = /* @__PURE__ */ new WeakMap();
jB = /* @__PURE__ */ new WeakMap();
PB = /* @__PURE__ */ new WeakMap();
$B = /* @__PURE__ */ new WeakMap();
KB = /* @__PURE__ */ new WeakMap();
Fz = function() {
  return this.componentController.parts$.pipe(
    te((e) => e.filter((t) => t.state === er.Success)),
    at((e) => !!e),
    Wi((e) => Promise.all(e.map(yDe)))
  );
};
XB = function(e, t = 0) {
  e && (LB(this, mv, !ko(this, mv)), LB(this, Oy, t), this.requestUpdate());
};
Tz = function(e) {
  this.componentController.removeFile(e.detail.name);
};
zB.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .step-id-upload {
        max-width: 64em;
        margin: 0 auto;
      }

      .step-id-upload .upload-instructions {
        margin-top: 0.5em;
        margin-bottom: 1em;
      }

      .step-id-upload-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        gap: 1em;

        @media screen and (min-width: 48em) {
          flex-direction: row;
          height: 27.75em;
        }
      }

      .step-id-upload-container + .button-container {
        margin: 1.5em auto 0;
        text-align: center;
        max-width: 23.125em;
      }

      .step-id-upload-item {
        width: 100%;
        min-height: 16.125em;

        @media screen and (min-width: 48em) {
          height: 27.75em;
        }
      }

      .file-upload-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 1em;
        padding: 2em 1em;
      }

      .file-upload-item.success h3 {
        color: var(--white);
      }

      .side-icon {
        font-size: 4.5em;
        color: var(--color-secondary7);

        @media screen and (min-width: 48em) {
          font-size: 7.5em;
        }
      }

      .file-upload-item.success .side-icon {
        visibility: collapse;
      }

      .brazilian-id.success {
        visibility: collapse;
      }

      :host([data-color-scheme='light']) .download-icon::before,
      :host([data-color-scheme='dark']) .download-icon::before {
        color: var(--color-primary4);
      }

      .download-icon {
        color: var(--color-primary4);
      }

      .brazilian-id {
        width: 12em; // 400 / 16
        object-fit: cover;
        object-position: center;

        img {
          border-radius: 1.25em; // 20 / 16
        }
      }

      @media screen and (min-width: 48em) {
        .brazilian-id {
          width: 25em; // 400 / 16
        }
      }
    `
];
zB = kDe([
  be(),
  P("jumio-sdk-step-id-upload")
], zB);
const _De = (e) => new Promise((t) => {
  const r = new FileReader(), n = H2(e.blob);
  r.readAsDataURL(e.blob), r.onloadend = async () => {
    var a;
    t({
      ...e,
      blob: {
        blob: e.blob,
        base64: n ? await NDe(e) : ((a = r.result) == null ? void 0 : a.toString()) ?? "",
        width: 0,
        height: 0
      }
    });
  };
}), NDe = async (e) => {
  const t = await _z(e.blob);
  return (t == null ? void 0 : t.toDataURL()) || "";
}, ZDe = (e) => new Promise((t) => {
  const r = new Image();
  r.src = e.blob.base64, r.onload = () => {
    t({
      ...e,
      blob: {
        ...e.blob,
        width: r.naturalWidth,
        height: r.naturalHeight
      }
    });
  };
}), Rz = () => ho(Wi(_De), Wi(ZDe)), Dz = () => ({
  retakeFrontSide: y("Retake FRONT side", {
    id: "jumio_instant_feedback_retake_front"
  }),
  pleaseTryAgain: y("Please try again", {
    id: "retry.header"
  }),
  retakeBackSide: y("Retake BACK side", {
    id: "jumio_instant_feedback_retake_back"
  }),
  retakeBothSides: y("Retake both", {
    id: "jumio_instant_feedback_retake_both"
  }),
  multipleImageMustBeRetaken: y("Images must be retaken", {
    id: "jumio_error_instant_feedback_both_images_retaken"
  }),
  singleImageMustBeRetaken: y("Image must be retaken", { id: "jumio_error_instant_feedback_one_image_retaken" })
});
var U2;
class BDe {
  constructor(t) {
    E(this, U2);
    G(this, U2, t), t.addController(this);
  }
  hostConnected() {
  }
  openSupportedIdsList() {
    const { IdUsabilitySupportedList: t } = un(oe());
    ve().send({ type: t });
  }
}
U2 = new WeakMap();
const WDe = () => Rc(
  y(
    "Make sure you have downloaded a digital driver’s license PDF from the official government application {{link}}",
    {
      id: "id.brazil_chn_instructions_error"
    }
  )
)({
  link: `<a target="_blank" href="https://www.gov.br/pt-br/servicos/obter-carteira-digital-de-transito">${y("Carteira Digital de Trânsito", { id: "id.brazil_chn_instructions_link" })}</a>`
}), EDe = (e) => ({
  [$t.BLACK_WHITE_COPY]: w`
      <x-ds-card-list>
        <h4 slot="header" data-qa-id="instant-feedback-title">
          ${y("The image is a black and white photocopy", { id: "jumio_error_instant_feedback_bw_copy_title" })}
        </h4>
        <li slot="item" data-qa-id="list-item">
          ${y("Capture an image of your original document", { id: "jumio_error_instant_feedback_digital_copy_tip" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Please try again with a color image", { id: "jumio_error_instant_feedback_bw_copy_tip_color_image" })}
        </li>
      </x-ds-card-list>
    `,
  [$t.COLOR_PHOTOCOPY]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The image appears to be a color photocopy", {
    id: "jumio_error_instant_feedback_color_photocopy_title"
  })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Capture an image of your original document", { id: "jumio_error_instant_feedback_digital_copy_tip" })}
        </p>
      </x-ds-card-light>
    `,
  [$t.DIGITAL_COPY]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The image appears to be a photo of an electronic screen", {
    id: "jumio_error_instant_feedback_digital_copy_title"
  })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Capture an image of your original document", { id: "jumio_error_instant_feedback_digital_copy_tip" })}
        </p>
      </x-ds-card-light>
    `,
  [$t.NOT_READABLE]: w`
      <h4 slot="header" data-qa-id="instant-feedback-title">
        ${y("The image quality is not good enough to be verified.", { id: "retry.titles.2002" })}
      </h4>
      <x-ds-card-list>
        <li slot="item" data-qa-id="list-item">
          ${y("Avoid capturing pictures in the dark", { id: "jumio_error_instant_feedback_glare_tip_lighting" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Avoid reflections and glare", { id: "retry.tips.2002.capture3" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Make sure photo is in focus", { id: "retry.tips.2001.capture1" })}
        </li>
      </x-ds-card-list>
    `,
  [$t.BLURRY]: w`
      <h4 slot="header" data-qa-id="instant-feedback-title">
        ${y("The image is too blurry to be verified.", { id: "retry.titles.2001" })}
      </h4>
      <x-ds-card-list>
        <li slot="item" data-qa-id="list-item">
          ${y("Hold your document steady when taking a photo", {
    id: "jumio_error_instant_feedback_blurry_tip_hold_steady"
  })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Make sure all details on your document are readable", {
    id: "jumio_error_instant_feedback_blurry_tip_readable"
  })}
        </li>
      </x-ds-card-list>
    `,
  [$t.BAD_QUALITY]: w`
      <h4 slot="header" data-qa-id="instant-feedback-title">
        ${y("The image quality is not good enough to be verified.", { id: "retry.titles.2002" })}
      </h4>
      <x-ds-card-list>
        <li slot="item" data-qa-id="list-item">
          ${y("Do not take picture in the dark", { id: "retry.tips.2002.capture1" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Take picture in well-lit room or outdoors", { id: "retry.tips.2002.capture2" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Avoid reflections and glare", { id: "retry.tips.2002.capture3" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Make sure all the details on your ID are readable.", { id: "retry.tips.2001.upload" })}
        </li>
      </x-ds-card-list>
    `,
  [$t.DAMAGED_DOCUMENT]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The document appears to be damaged", { id: "jumio_error_instant_feedback_damaged_doc_title" })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Please try again with a different document", {
    id: "jumio_error_instant_feedback_damaged_doc_tip_different_doc"
  })}
        </p>
      </x-ds-card-light>
    `,
  [$t.GENERIC]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The document cannot be further processed for verification", {
    id: "jumio_error_instant_feedback_generic_title"
  })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Be sure to capture an original document in good lighting conditions", {
    id: "jumio_error_instant_feedback_generic_tip_genuine_doc"
  })}
        </p>
      </x-ds-card-light>
    `,
  [$t.GLARE]: w`
      <x-ds-card-list>
        <h4 slot="header" data-qa-id="instant-feedback-title">
          ${y("The image has reflections", { id: "jumio_error_instant_feedback_glare_title" })}
        </h4>
        <li slot="item" data-qa-id="list-item">
          ${y("Avoid capturing pictures in the dark", { id: "jumio_error_instant_feedback_glare_tip_lighting" })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Avoid reflections and glare", { id: "retry.tips.2002.capture3" })}
        </li>
      </x-ds-card-list>
    `,
  [$t.HIDDEN_PART_DOCUMENT]: w`
      <x-ds-card-list>
        <h4 slot="header" data-qa-id="instant-feedback-title">
          ${y("The image of your document does not show the details required for verification", {
    id: "jumio_error_instant_feedback_missing_part_doc_title"
  })}
        </h4>
        <li slot="item" data-qa-id="list-item">
          ${y("Make sure to capture the whole document", {
    id: "jumio_error_instant_feedback_no_doc_tip_whole_document"
  })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Do not cover the document with your hand", { id: "jumio_error_instant_feedback_no_doc_tip_hand" })}
        </li>
      </x-ds-card-list>
    `,
  [$t.MISSING_BACK]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The back side of your document is missing", {
    id: "jumio_error_instant_feedback_missing_back_title"
  })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Capture an image of the back side of your document", {
    id: "jumio_error_instant_feedback_missing_back_tip_back_side_doc"
  })}
        </p>
      </x-ds-card-light>
    `,
  [$t.MISSING_FRONT]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The front side of your document is missing", {
    id: "jumio_error_instant_feedback_missing_front_title"
  })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Capture an image of the front side of your document", {
    id: "jumio_error_instant_feedback_missing_front_tip_front_side_doc"
  })}
        </p>
      </x-ds-card-light>
    `,
  [$t.MISSING_PART_DOCUMENT]: w`
      <x-ds-card-list>
        <h4 slot="header" data-qa-id="instant-feedback-title">
          ${y("The image of your document does not show the details required for verification", {
    id: "jumio_error_instant_feedback_missing_part_doc_title"
  })}
        </h4>
        <li slot="item" data-qa-id="list-item">
          ${y("Make sure to capture the whole document", {
    id: "jumio_error_instant_feedback_no_doc_tip_whole_document"
  })}
        </li>
        <li slot="item" data-qa-id="list-item">
          ${y("Do not cover the document with your hand", {
    id: "jumio_error_instant_feedback_no_doc_tip_hand"
  })}
        </li>
      </x-ds-card-list>
    `,
  [$t.NO_DOCUMENT]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The image is not a valid form of identification", {
    id: "jumio_error_instant_feedback_no_doc_title"
  })}
        </h4>
        <p data-qa-id="list-item">
          ${y("Use a valid government-issued document", { id: "jumio_error_instant_feedback_no_doc_tip_gov_id" })}
        </p>
      </x-ds-card-light>
    `,
  [$t.SAMPLE_DOCUMENT]: w`
      <x-ds-card-light>
        <h4 data-qa-id="instant-feedback-title">
          ${y("The ID you submitted is a sample.", { id: "retry.titles.202" })}
        </h4>
        <p data-qa-id="list-item">${y("Please try again with your own ID.", { id: "retry.tips.202" })}</p>
      </x-ds-card-light>
    `,
  [$t.UNSUPPORTED_ID]: w`
      <x-ds-card-light>
        <h4 class="text-center" data-qa-id="instant-feedback-title">
          ${y("The captured document is not supported", {
    id: "jumio_error_instant_feedback_unsupported_document_title"
  })}
        </h4>
        <x-ds-button
          @click="${() => {
    typeof (e == null ? void 0 : e.unsupportedIdListCallbackFn) == "function" && e.unsupportedIdListCallbackFn();
  }}"
          data-qa-id="unsupported-id-button"
          data-type=${De.Secondary}
        >
          ${y("List of supported documents", { id: "jumio_error_instant_feedback_supported_document_button" })}
        </x-ds-button>
      </x-ds-card-light>
    `,
  [$t.INVALID_CERTIFICATE]: w`
      <x-ds-card-light>
        <p data-qa-id="list-item">${Pm(WDe())}</p>
      </x-ds-card-light>
    `
});
var QDe = Object.defineProperty, FDe = Object.getOwnPropertyDescriptor, Jz = (e) => {
  throw TypeError(e);
}, Vz = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? FDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && QDe(t, r, a), a;
}, fT = (e, t, r) => t.has(e) || Jz("Cannot " + r), Mz = (e, t, r) => (fT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Fk = (e, t, r) => t.has(e) ? Jz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), TDe = (e, t, r, n) => (fT(e, t, "write to private field"), t.set(e, r), r), RDe = (e, t, r) => (fT(e, t, "access private method"), r), mT, jb, qB, Gz;
let jy = class extends N {
  constructor() {
    super(...arguments), Fk(this, qB), Fk(this, mT, new ue(
      this,
      TS(oe(), zn.REJECT)
    )), Fk(this, jb);
  }
  render() {
    return RDe(this, qB, Gz).call(this);
  }
  get componentController() {
    return Mz(this, jb) ?? TDe(this, jb, new BDe(this));
  }
};
mT = /* @__PURE__ */ new WeakMap();
jb = /* @__PURE__ */ new WeakMap();
qB = /* @__PURE__ */ new WeakSet();
Gz = function() {
  if (this.rejectedId) {
    const t = (Mz(this, mT).value ?? []).find((n) => n.id === this.rejectedId), r = (t == null ? void 0 : t.result.rejectReason.reasonCode) === $t.UNSUPPORTED_ID ? {
      unsupportedIdListCallbackFn: () => {
        this.componentController.openSupportedIdsList();
      }
    } : void 0;
    return t ? EDe(r)[t.result.rejectReason.reasonCode] : q;
  }
  return q;
};
jy.styles = [
  ...N.styles,
  ee`
      :host {
        display: block;
        width: 100%;
      }

      p,
      ::slotted(p) {
        margin: 0;
      }

      x-ds-button {
        display: flex;
        margin-inline: auto;
      }

      h4 + p,
      h4 + x-ds-button {
        margin-top: 1em;
      }
    `
];
Vz([
  M({
    attribute: "data-rejected-id",
    type: String,
    reflect: !0
  })
], jy.prototype, "rejectedId", 2);
jy = Vz([
  be(),
  P("jumio-sdk-step-id-usability-check-retry-message")
], jy);
var DDe = Object.defineProperty, JDe = Object.getOwnPropertyDescriptor, xz = (e) => {
  throw TypeError(e);
}, vT = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? JDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && DDe(t, r, a), a;
}, Hz = (e, t, r) => t.has(e) || xz("Cannot " + r), kc = (e, t, r) => (Hz(e, t, "read from private field"), r ? r.call(e) : t.get(e)), _h = (e, t, r) => t.has(e) ? xz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), wd = (e, t, r) => (Hz(e, t, "access private method"), r), Pb, nI, eW, tW, ST, Rs, Lz, Yz, Oz, jz, Pz, $z, Kz;
let vv = class extends N {
  constructor() {
    super(...arguments), _h(this, Rs), this.carrouselOffset = 0, this.hasFileUpload$ = QE(oe()), this.rejectedImageCollection$ = wd(this, Rs, jz).call(this), this.rejectedUsabilityEntities$ = TS(
      oe(),
      zn.REJECT
    ), _h(this, Pb, new ue(this, this.hasFileUpload$)), _h(this, nI, new ue(this, this.rejectedUsabilityEntities$)), _h(this, eW, Ce().getControllerById(T.Id).selectUserSelection$().pipe(te((e) => e.selectedDigitalIdentity))), _h(this, tW, new ue(this, this.rejectedImageCollection$)), _h(this, ST, new ue(this, kc(this, eW)));
  }
  connectedCallback() {
    super.connectedCallback(), this.reportRejectionReasons();
  }
  reportRejectionReasons() {
    Te.showRetryScreen(this, {
      metadata: {
        category: T.Id,
        rejectionReasons: wd(this, Rs, Pz).call(this),
        rejectionCodeKeys: wd(this, Rs, $z).call(this),
        codes: wd(this, Rs, Kz).call(this)
      }
    });
  }
  render() {
    const e = kc(this, tW).value ?? [], t = wd(this, Rs, Lz).call(this, e);
    return w`
      <x-ds-app-container data-footer-visible="false">
        ${ke(
      "jumio-id-retry-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <x-ds-usability-check slot="main">
          <div slot="item">
            ${ke("jumio-id-retry-title", w`<h3 class="header" slot="item">${t}</h3>`)}
            ${ke("jumio-id-retry-before")}
          </div>
          <x-ds-carrousel
            slot="item"
            class="image-container"
            data-qa-id="instant-feedback-images"
            @carrouselnavigation="${(r) => {
      wd(this, Rs, Oz).call(this, r);
    }}"
          >
            ${e.map((r) => w`
                <img
                  slot="image"
                  src="${r.blob.base64}"
                  data-qa-item="uploaded-image-preview"
                  data-qa-id="uploaded-image-preview-${r.id}"
                  width="${r.blob.width}"
                  height="${r.blob.height}"
                  alt=""
                />
              `)}
          </x-ds-carrousel>
          ${wd(this, Rs, Yz).call(this, e)}
          <jumio-sdk-step-id-usability-check-button
            class="usability-check-button"
            slot="button"
          ></jumio-sdk-step-id-usability-check-button>
          <jumio-sdk-cross-device-button slot="button"></jumio-sdk-cross-device-button>
          ${kc(this, Pb).value ? q : w`<jumio-sdk-upload-button slot="button"></jumio-sdk-upload-button>`}
          <div slot="item">${ke("jumio-id-retry-after")}</div>
        </x-ds-usability-check>
      </x-ds-app-container>
    `;
  }
  retry() {
    const { Upload: e, IdUsabilityCheckReset: t } = un(oe()), r = ve();
    Te.clickedRetryButton(this), r.send({ type: kc(this, Pb).value ? e : t });
  }
};
Pb = /* @__PURE__ */ new WeakMap();
nI = /* @__PURE__ */ new WeakMap();
eW = /* @__PURE__ */ new WeakMap();
tW = /* @__PURE__ */ new WeakMap();
ST = /* @__PURE__ */ new WeakMap();
Rs = /* @__PURE__ */ new WeakSet();
Lz = function(e) {
  const t = Dz();
  return kc(this, ST).value ? t.pleaseTryAgain : e.length > 1 ? t.multipleImageMustBeRetaken : t.singleImageMustBeRetaken;
};
Yz = function(e) {
  const t = e[this.carrouselOffset];
  return t ? w`
          <jumio-sdk-step-id-usability-check-retry-message
            slot="item"
            data-rejected-id="${t.id}"
          ></jumio-sdk-step-id-usability-check-retry-message>
        ` : q;
};
Oz = function(e) {
  e instanceof PG && (this.carrouselOffset = e.detail, this.requestUpdate());
};
jz = function() {
  return EE(oe(), zn.REJECT).pipe(
    Wi((e) => po(e).pipe(Rz(), wS()))
  );
};
Pz = function() {
  const e = kc(this, nI).value ?? [], t = {};
  for (const r of e)
    t[r.id] = r.result.rejectReason.reasonCode;
  return t;
};
$z = function() {
  const e = kc(this, nI).value ?? [], t = {};
  for (const r of e) {
    const n = t[r.result.rejectReason.reasonCode] ?? [];
    t[r.result.rejectReason.reasonCode] = [...n, r.id];
  }
  return t;
};
Kz = function() {
  const t = (kc(this, nI).value ?? []).map(
    (r) => r.result.rejectReason.reasonCode
  );
  return Array.from(new Set(t));
};
vv.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .header {
        font: var(--text-font-h3);
        margin: 0;
      }

      .image-container {
        display: block;
        width: 100%;
        min-height: 13em;
      }

      .usability-check-button {
        width: 100%;
      }
    `
];
vT([
  yW("jumio-sdk-step-id-usability-check-retry-message")
], vv.prototype, "retryMessage", 2);
vT([
  Xn()
], vv.prototype, "carrouselOffset", 2);
vv = vT([
  be(),
  P("jumio-sdk-step-id-usability-check")
], vv);
var VDe = Object.defineProperty, MDe = Object.getOwnPropertyDescriptor, Xz = (e) => {
  throw TypeError(e);
}, GDe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? MDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && VDe(t, r, a), a;
}, zz = (e, t, r) => t.has(e) || Xz("Cannot " + r), qz = (e, t, r) => (zz(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Tk = (e, t, r) => t.has(e) ? Xz("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), B3 = (e, t, r) => (zz(e, t, "access private method"), r), rW, IT, $b, e7, t7;
let nW = class extends N {
  constructor() {
    super(...arguments), Tk(this, $b), this.hasFileUpload$ = QE(oe()), this.rejectedImageCollection$ = B3(this, $b, t7).call(this), Tk(this, rW, new ue(this, this.hasFileUpload$)), Tk(this, IT, new ue(this, this.rejectedImageCollection$));
  }
  retry() {
    const { Upload: e, IdUsabilityCheckReset: t } = un(oe()), r = ve();
    Te.clickedRetryButton(this), r.send({ type: qz(this, rW).value ? e : t });
  }
  render() {
    return w`
      <x-ds-button
        slot="button"
        data-qa-id="retake-image"
        data-fluid="true"
        @jclick="${() => {
      this.retry();
    }}"
      >
        ${B3(this, $b, e7).call(this)}
      </x-ds-button>
    `;
  }
};
rW = /* @__PURE__ */ new WeakMap();
IT = /* @__PURE__ */ new WeakMap();
$b = /* @__PURE__ */ new WeakSet();
e7 = function() {
  const e = Dz(), t = qz(this, IT).value ?? [];
  if (t.length === 1) {
    const [r] = t;
    return r.id.includes(or.FrontSide) ? e.retakeFrontSide : e.retakeBackSide;
  }
  return e.retakeBothSides;
};
t7 = function() {
  return EE(oe(), zn.REJECT).pipe(
    Wi((e) => po(e).pipe(Rz(), wS()))
  );
};
nW.styles = [...N.styles];
nW = GDe([
  be(),
  P("jumio-sdk-step-id-usability-check-button")
], nW);
var k2;
class xDe {
  constructor(t) {
    E(this, k2);
    G(this, k2, t), t.addController(this);
  }
  hostConnected() {
  }
}
k2 = new WeakMap();
var HDe = Object.defineProperty, LDe = Object.getOwnPropertyDescriptor, r7 = (e) => {
  throw TypeError(e);
}, YDe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? LDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && HDe(t, r, a), a;
}, n7 = (e, t, r) => t.has(e) || r7("Cannot " + r), ODe = (e, t, r) => (n7(e, t, "read from private field"), r ? r.call(e) : t.get(e)), jDe = (e, t, r) => t.has(e) ? r7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), PDe = (e, t, r, n) => (n7(e, t, "write to private field"), t.set(e, r), r), Kb;
let aW = class extends N {
  constructor() {
    super(...arguments), jDe(this, Kb);
  }
  get componentController() {
    return ODe(this, Kb) ?? PDe(this, Kb, new xDe(this));
  }
  connectedCallback() {
    super.connectedCallback();
  }
  render() {
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-id-document-variant-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div slot="main" class="page-items">
          <x-ds-error-message
            data-qa-id="error-message"
            data-title="${y("Connection error", {
      id: "error.9800.title"
    })}"
            data-message="${y("Sorry, the connection was lost. Please check your network settings.", {
      id: "error.9800.description"
    })}"
            data-overlay="false"
            data-error-code="FileUploadError"
            data-transaction-id="${Ec()}"
          >
            <x-ds-button
              slot="button"
              @jclick="${() => {
      var e;
      return (e = this.retryAction) == null ? void 0 : e.call(this);
    }}"
              data-type="${De.Primary}"
              data-fluid="true"
            >
              ${y("Try again", { id: "retry.button.try-again" })}
            </x-ds-button>
          </x-ds-error-message>
        </div>
        <jumio-sdk-cross-device-button slot="bottom-left" data-fluid="false"></jumio-sdk-cross-device-button>
      </x-ds-app-container>
    `;
  }
};
Kb = /* @__PURE__ */ new WeakMap();
aW.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .page-items {
        display: flex;
        flex-direction: column;
        row-gap: 1em;
        align-items: stretch;
        max-width: 32em;
        margin-inline: auto;
        width: 100%;
        height: 100%;
        justify-content: center;
      }
    `
];
aW = YDe([
  be(),
  P("jumio-sdk-file-upload-failed")
], aW);
var $De = Object.defineProperty, KDe = Object.getOwnPropertyDescriptor, a7 = (e) => {
  throw TypeError(e);
}, i7 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? KDe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && $De(t, r, a), a;
}, CT = (e, t, r) => t.has(e) || a7("Cannot " + r), XDe = (e, t, r) => (CT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), W3 = (e, t, r) => t.has(e) ? a7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), zDe = (e, t, r, n) => (CT(e, t, "write to private field"), t.set(e, r), r), Hl = (e, t, r) => (CT(e, t, "access private method"), r), Xb, No, o7, s7, l7, c7, d7, u7, h7, p7;
let Py = class extends ro {
  constructor() {
    super(), W3(this, No), W3(this, Xb), this.componentController = new D5e(this, Ce()), zDe(this, Xb, new ue(this, ur()));
  }
  get workflowStepController() {
    return Ce().getControllerById(T.Id);
  }
  render() {
    switch (XDe(this, Xb).value) {
      case Z.DocTypeSelection:
        return Hl(this, No, o7).call(this);
      case Z.DocTypeVariantSelection:
        return Hl(this, No, s7).call(this);
      case Z.CaptureSourceSelection:
        return Hl(this, No, l7).call(this);
      case Z.CaptureScreenEntry:
      case Z.CaptureScreen:
      case Z.CaptureScreenSelectProvider:
      case Z.CaptureScreenAutoCaptureLoading:
      case Z.CaptureScreenDecision:
      case Z.CaptureScreenFrontStart:
      case Z.CaptureScreenFront:
      case Z.CaptureScreenPrepareForRecapturingBack:
      case Z.CaptureScreenFrontFinish:
      case Z.CaptureScreenBackStart:
      case Z.CaptureScreenBack:
      case Z.CaptureScreenBackFinish:
      case Z.CaptureScreenComplete:
      case Z.CaptureScreenUpload:
      case Z.IdUsabilityCheck:
      case Z.IdUsabilityCheckReset:
        return Hl(this, No, c7).call(this);
      case Z.IdUsabilitySupportedList:
        return Hl(this, No, d7).call(this);
      case Z.IdUsabilityCheckFailure:
        return Hl(this, No, u7).call(this);
      case Z.Upload:
        return Hl(this, No, h7).call(this);
      case Z.CaptureScreenUploadFailed:
        return Hl(this, No, p7).call(this);
      default:
        return q;
    }
  }
};
Xb = /* @__PURE__ */ new WeakMap();
No = /* @__PURE__ */ new WeakSet();
o7 = function() {
  return w`<jumio-sdk-step-id-document-type data-qa-id="document-type-step"></jumio-sdk-step-id-document-type>`;
};
s7 = function() {
  return w`
      <jumio-sdk-step-id-document-variant data-qa-id="document-variant-step"></jumio-sdk-step-id-document-variant>
    `;
};
l7 = function() {
  return w`
      <jumio-sdk-step-id-capture-source data-qa-id="document-capture-source-step"></jumio-sdk-step-id-capture-source>
    `;
};
c7 = function() {
  return w`<jumio-sdk-step-id-capture data-qa-id="capture-step"></jumio-sdk-step-id-capture>`;
};
d7 = function() {
  return w`<jumio-sdk-supported-id-search></jumio-sdk-supported-id-search>`;
};
u7 = function() {
  return w`<jumio-sdk-step-id-usability-check data-qa-id="preview-step"></jumio-sdk-step-id-usability-check>`;
};
h7 = function() {
  return w`<jumio-sdk-step-id-upload data-qa-id="upload-step"></jumio-sdk-step-id-upload>`;
};
p7 = function() {
  const e = un(oe());
  return w`
      <jumio-sdk-file-upload-failed
        .retryAction="${() => {
    const t = oe();
    lH(t), ve().send({ type: e.CaptureScreen });
  }}"
        data-qa-id="file-upload-failed-step"
      ></jumio-sdk-file-upload-failed>
    `;
};
Py.styles = [
  ee`
      :host {
        display: contents;
      }
    `
];
i7([
  ka({ context: fke }),
  Xn()
], Py.prototype, "workflowStepController", 1);
Py = i7([
  be(),
  P("jumio-sdk-step-id")
], Py);
var qDe = Object.defineProperty, eJe = Object.getOwnPropertyDescriptor, g7 = (e) => {
  throw TypeError(e);
}, tJe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? eJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && qDe(t, r, a), a;
}, rJe = (e, t, r) => t.has(e) || g7("Cannot " + r), nJe = (e, t, r) => t.has(e) ? g7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), aJe = (e, t, r) => (rJe(e, t, "access private method"), r), iW, f7;
let oW = class extends N {
  constructor() {
    super(...arguments), nJe(this, iW);
  }
  render() {
    return w`
      <x-ds-app-container>
        <div slot="main">
          ${ke("jumio-setup-before")} ${aJe(this, iW, f7).call(this)}
          ${ke("jumio-setup-after")}
        </div>
      </x-ds-app-container>
    `;
  }
};
iW = /* @__PURE__ */ new WeakSet();
f7 = function() {
  const e = document.querySelector("template#setup");
  return ke(
    "jumio-setup",
    e ? w`${Ea(e)}` : w`
            <div class="loading-container">
              <x-ds-loading-indicator
                data-qa-id="loading-indicator"
                data-state="${Ia.Pulsing}"
              ></x-ds-loading-indicator>
              <div data-qa-id="loading-text">${y("Loading", { id: "identity.guidance.button.progress" })}</div>
            </div>
          `
  );
};
oW.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .loading-container {
        display: flex;
        flex-direction: column;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        position: absolute;
        align-items: center;
        justify-content: center;
        row-gap: 1em;
      }
    `
];
oW = tJe([
  be(),
  P("jumio-sdk-step-setup")
], oW);
var _2, dS, N2, uS;
class iJe {
  constructor(t, r = Ce()) {
    E(this, _2);
    E(this, dS);
    E(this, N2);
    E(this, uS, new _e());
    G(this, _2, t), G(this, dS, r), G(this, N2, S(this, dS).getControllerById(Me.Start, void 0)), this.dispatchNextScreen$ = this.getNavigateToNextScreen$(), t.addController(this);
  }
  hostConnected() {
    this.dispatchNextScreen$.pipe(le(S(this, uS))).subscribe();
  }
  hostDisconnected() {
    S(this, uS).next();
  }
  navigateToNextScreen(t, r = ve()) {
    const n = $E();
    r.send({
      type: t.skipStartScreen ? n.Finish : n.ConsentScreen
    });
  }
  getNavigateToNextScreen$() {
    return Ce().getConfiguration().selectSettings$().pipe(
      at((t) => t.credentials.length > 0),
      ae((t) => {
        this.navigateToNextScreen(t);
      })
    );
  }
}
_2 = new WeakMap(), dS = new WeakMap(), N2 = new WeakMap(), uS = new WeakMap();
var hS, Vo, pS, Gp, gS, Z2, m7;
class oJe {
  constructor(t, r = Ce()) {
    E(this, Z2);
    E(this, hS);
    E(this, Vo);
    E(this, pS);
    E(this, Gp);
    E(this, gS, !1);
    G(this, hS, t), G(this, Vo, r), G(this, pS, S(this, Vo).getControllerById(Me.Start, void 0)), G(this, Gp, new _e()), t.addController(this);
  }
  getController() {
    return S(this, pS);
  }
  getAllConsentsGiven() {
    return S(this, gS);
  }
  sendConsentData() {
    return S(this, Vo).getConsentController().sendConsentData();
  }
  goToNextStep() {
    const t = ve(), r = $E();
    t.send({
      type: r.ProvideConsent
    });
  }
  hostConnected() {
    O(this, Z2, m7).call(this);
  }
  hostDisconnected() {
    S(this, Gp).next();
  }
  getDocumentType$() {
    const r = this.getCredentials().find((n) => n.category === T.Document);
    return r ? S(this, Vo).getControllerById(T.Document, r.id).selectDocument$() : ba;
  }
  getLocale() {
    return S(this, Vo).getWorkflowState().locale;
  }
  getSupportedDocumentTranslationsFromSettings() {
    const t = S(this, Vo).getConfiguration().getSettings(), [r] = t.supportedDocumentTypes;
    return (r == null ? void 0 : r.translations) ?? {};
  }
  getCredentials() {
    return Ce().getConfiguration().getSettings().credentials;
  }
}
hS = new WeakMap(), Vo = new WeakMap(), pS = new WeakMap(), Gp = new WeakMap(), gS = new WeakMap(), Z2 = new WeakSet(), m7 = function() {
  S(this, Vo).getConsentController().areAllActiveConsentsGiven$().pipe(le(S(this, Gp))).subscribe((t) => {
    G(this, gS, t), S(this, hS).requestUpdate();
  });
};
var fS, mS, vS, pc, xp, Mg, v7, S7;
class sJe {
  constructor(t) {
    E(this, Mg);
    E(this, fS, new _e());
    E(this, mS, []);
    E(this, vS, !1);
    E(this, pc);
    E(this, xp);
    G(this, xp, t), G(this, pc, Ce()), t.addController(this);
  }
  getConsentItems() {
    return S(this, mS);
  }
  getConsentGiven() {
    return S(this, vS);
  }
  hostConnected() {
    O(this, Mg, v7).call(this), O(this, Mg, S7).call(this);
  }
  hostDisconnected() {
  }
  updateConsentStatus(t) {
    S(this, pc).getConsentController().updateConsentStatus(t);
  }
  getLocale() {
    const { locale: t } = S(this, pc).getWorkflowState();
    return t;
  }
}
fS = new WeakMap(), mS = new WeakMap(), vS = new WeakMap(), pc = new WeakMap(), xp = new WeakMap(), Mg = new WeakSet(), v7 = function() {
  S(this, pc).getConsentController().selectAllConsents$().pipe(le(S(this, fS))).subscribe((t) => {
    G(this, mS, t), S(this, xp).requestUpdate();
  });
}, S7 = function() {
  S(this, pc).getConsentController().areAllActiveConsentsGiven$().pipe(le(S(this, fS))).subscribe((t) => {
    G(this, vS, t), S(this, xp).requestUpdate();
  });
};
var lJe = Object.defineProperty, cJe = Object.getOwnPropertyDescriptor, I7 = (e) => {
  throw TypeError(e);
}, dJe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? cJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && lJe(t, r, a), a;
}, C7 = (e, t, r) => t.has(e) || I7("Cannot " + r), uJe = (e, t, r) => (C7(e, t, "read from private field"), r ? r.call(e) : t.get(e)), hJe = (e, t, r) => t.has(e) ? I7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), pJe = (e, t, r, n) => (C7(e, t, "write to private field"), t.set(e, r), r), zb;
let E3 = class extends N {
  constructor() {
    super(...arguments), hJe(this, zb);
  }
  get componentController() {
    return uJe(this, zb) ?? pJe(this, zb, new sJe(this));
  }
  connectedCallback() {
    super.connectedCallback(), Te.shownConsentMessage(this);
  }
  render() {
    return w`
      <x-consent-policy
        data-consent-dto="${JSON.stringify(this.componentController.getConsentItems())}"
        data-consent-given="${this.componentController.getConsentGiven()}"
        data-locale="${this.componentController.getLocale()}"
        @consentchange="${this.consentChange.bind(this)}"
        data-qa-id="consent-policy"
      ></x-consent-policy>
    `;
  }
  consentChange(e) {
    e instanceof R4 && this.componentController.updateConsentStatus(e.detail);
  }
};
zb = /* @__PURE__ */ new WeakMap();
E3 = dJe([
  be(),
  P("jumio-sdk-consent")
], E3);
var gJe = Object.defineProperty, fJe = Object.getOwnPropertyDescriptor, b7 = (e) => {
  throw TypeError(e);
}, bT = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? fJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && gJe(t, r, a), a;
}, yT = (e, t, r) => t.has(e) || b7("Cannot " + r), mJe = (e, t, r) => (yT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Q3 = (e, t, r) => t.has(e) ? b7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), vJe = (e, t, r, n) => (yT(e, t, "write to private field"), t.set(e, r), r), Rd = (e, t, r) => (yT(e, t, "access private method"), r), qb, Js, y7, w7, A7, U7, k7, _7, N7;
let Sv = class extends N {
  constructor() {
    super(), Q3(this, Js), this.colorScheme = Un.Light, Q3(this, qb), this.documentCodeController = new ue(this, this.componentController.getDocumentType$());
  }
  get workflowStepController() {
    return Ce().getControllerById(Me.Start, void 0);
  }
  get componentController() {
    return mJe(this, qb) ?? vJe(this, qb, new oJe(this));
  }
  render() {
    return w`
      <x-ds-app-container>
        <jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div class="start" slot="main">
          ${ke("jumio-start-before")}
          ${ke(
      "jumio-start-guidance",
      w`
              <div class="start__header">${Rd(this, Js, y7).call(this)} ${Rd(this, Js, w7).call(this)}</div>
              <div class="start__content">${Rd(this, Js, A7).call(this)}</div>
            `
    )}

          <div class="start__footer">
            <jumio-sdk-consent class="text-body-regular"></jumio-sdk-consent>
            <x-ds-button
              class="start__button"
              data-fluid="true"
              data-qa-id="start-button"
              data-type="${De.Primary}"
              data-disabled="${!this.componentController.getAllConsentsGiven()}"
              @jclick="${Rd(this, Js, k7).bind(this)}"
            >
              ${y("Start", {
      id: "start.button.start-capture"
    })}
            </x-ds-button>
          </div>
          <div class="cross-device-button">
            <jumio-sdk-cross-device-button></jumio-sdk-cross-device-button>
          </div>
          ${ke("jumio-start-after")}
        </div>
      </x-ds-app-container>
    `;
  }
  renderInstructionsForCategories(e = {}) {
    const t = e.categories ?? this.componentController.getCredentials().map((a) => a.category), r = new Set(t);
    return (e == null ? void 0 : e.areSettingsFetched) ?? Rd(this, Js, _7).call(this) ? w`
          <x-ds-shield-list class="instructions" data-qa-id="checklist">
            ${xK(
      r,
      (a) => a,
      (a) => Rd(this, Js, U7).call(this, a)
    )}
          </x-ds-shield-list>
        ` : w`
          <x-ds-shield-list class="instructions" data-qa-id="checklist">
            <x-ds-loading-indicator></x-ds-loading-indicator>
          </x-ds-shield-list>
        `;
  }
};
qb = /* @__PURE__ */ new WeakMap();
Js = /* @__PURE__ */ new WeakSet();
y7 = function() {
  const e = document.querySelector("template#start_title");
  return ke(
    "jumio-start-title",
    e ? w`${Ea(e)}` : w`
            <h1 class="title" data-qa-id="title">
              ${y("Start verification", {
      id: "start.start_verification_header"
    })}
            </h1>
          `
  );
};
w7 = function() {
  const e = document.querySelector("template#start_explanation");
  return ke(
    "jumio-start-explanation",
    e ? w`${Ea(e)}` : w`
            <div class="explanation" data-qa-id="explanation">
              ${y("This process is designed to verify your identity and protect you from identity theft.", {
      id: "start.paragraph"
    })}
            </div>
          `
  );
};
A7 = function() {
  const e = document.querySelector("template#start_checklist");
  return ke(
    "jumio-start-checklist",
    e ? w`${Ea(e)}` : this.renderInstructionsForCategories()
  );
};
U7 = function(e) {
  switch (e) {
    case T.Document:
      return w`
          <x-ds-shield-list-item slot="item" data-qa-id="shield-list-item">
            ${Rd(this, Js, N7).call(this)}
          </x-ds-shield-list-item>
          <x-ds-shield-list-item slot="item" data-qa-id="shield-list-item">
            ${y("Use a valid document", {
        id: "start.instructions.05"
      })}
          </x-ds-shield-list-item>
          <x-ds-shield-list-item slot="item" data-qa-id="shield-list-item">
            ${y("Make sure all details are readable", {
        id: "start.instructions.07"
      })}
          </x-ds-shield-list-item>
        `;
    case T.Facemap:
      return w`
          <x-ds-shield-list-item slot="item" data-qa-id="shield-list-item">
            ${y("Be ready to take a selfie", {
        id: "start.instructions.03"
      })}
          </x-ds-shield-list-item>
        `;
    case T.Id:
      return w`
          <x-ds-shield-list-item slot="item" data-qa-id="shield-list-item">
            ${y("Use a valid government-issued document", {
        id: "start.instructions.01"
      })}
          </x-ds-shield-list-item>
          <x-ds-shield-list-item slot="item" data-qa-id="shield-list-item">
            ${y("Find a well-lit surface", {
        id: "start.instructions.02"
      })}
          </x-ds-shield-list-item>
        `;
    default:
      return q;
  }
};
k7 = async function() {
  Te.clickedStartButton(this);
  try {
    await this.componentController.sendConsentData(), this.dispatchEvent(oke(oN())), this.componentController.goToNextStep();
  } catch (e) {
    if (e instanceof es && e.details.publicError) {
      const { title: t, message: r } = Tw[e.details.publicError.legacyCode()];
      mt.showMessageIfPossible({
        type: Fr.Error,
        id: ct.Uploading,
        date: /* @__PURE__ */ new Date(),
        transactionId: Ec(),
        title: y(t.label, { id: t.id }),
        message: y(r.label, { id: r.id }),
        errorCode: e.details.publicError.code(),
        closable: e.details.publicError.isRetryable()
      });
    }
  }
};
_7 = function() {
  return this.componentController.getCredentials().length > 0;
};
N7 = function() {
  if (this.documentCodeController.value) {
    const e = o6[this.documentCodeController.value.code];
    if (e)
      return y(e.label, { id: e.id });
    const t = JO(
      this.componentController.getLocale(),
      this.componentController.getSupportedDocumentTranslationsFromSettings()
    );
    return Rc(vG(y("Upload your {{customTitle}}", { id: "dv.upload.title" })))({
      customTitle: t ?? ""
    });
  }
  return "";
};
Sv.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }

      .start {
        display: flex;
        flex-flow: column nowrap;
        align-items: stretch;
        width: 100%;
        max-width: 32em;
        margin: 0 auto;
        row-gap: 1.5em;
        padding-bottom: 1.5em;
      }

      .start__header {
        text-align: center;
      }

      .start__content {
        display: flex;
        flex-flow: column nowrap;
        gap: 1em;
      }

      .start__footer {
        position: sticky;
        bottom: 0;
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        margin-top: -0.5em;
        margin-bottom: -1.5em;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        gap: 1em;
      }

      :host([data-color-scheme='light']) .start__footer {
        background-color: var(--white);
      }

      :host([data-color-scheme='dark']) .start__footer {
        background-color: var(--gray12);
      }

      .title + .explanation {
        margin-top: 0.5em;
      }

      .instructions {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;
      }
    `
];
bT([
  td({ context: zW, subscribe: !0 }),
  M({ attribute: "data-color-scheme", reflect: !0 })
], Sv.prototype, "colorScheme", 2);
bT([
  ka({ context: Lj }),
  Xn()
], Sv.prototype, "workflowStepController", 1);
Sv = bT([
  be(),
  P("jumio-sdk-step-start-consent")
], Sv);
var SJe = Object.defineProperty, IJe = Object.getOwnPropertyDescriptor, Z7 = (e) => {
  throw TypeError(e);
}, B7 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? IJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && SJe(t, r, a), a;
}, CJe = (e, t, r) => t.has(e) || Z7("Cannot " + r), bJe = (e, t, r) => (CJe(e, t, "read from private field"), r ? r.call(e) : t.get(e)), yJe = (e, t, r) => t.has(e) ? Z7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), sW;
let $y = class extends N {
  constructor() {
    super(...arguments), this.stepInformationController = new ue(this, ur()), yJe(this, sW, new iJe(this));
  }
  get workflowStepController() {
    return Ce().getControllerById(Me.Start, void 0);
  }
  get componentController() {
    return bJe(this, sW);
  }
  render() {
    switch (this.stepInformationController.value) {
      case In.ConsentScreen:
        return w`<jumio-sdk-step-start-consent></jumio-sdk-step-start-consent>`;
    }
    return q;
  }
};
sW = /* @__PURE__ */ new WeakMap();
$y.styles = [
  ...N.styles,
  ee`
      :host {
        display: contents;
      }
    `
];
B7([
  ka({ context: Lj }),
  Xn()
], $y.prototype, "workflowStepController", 1);
$y = B7([
  be(),
  P("jumio-sdk-step-start")
], $y);
var wJe = Object.defineProperty, AJe = Object.getOwnPropertyDescriptor, W7 = (e) => {
  throw TypeError(e);
}, ms = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? AJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && wJe(t, r, a), a;
}, wT = (e, t, r) => t.has(e) || W7("Cannot " + r), Nr = (e, t, r) => (wT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), fn = (e, t, r) => t.has(e) ? W7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Vr = (e, t, r, n) => (wT(e, t, "write to private field"), t.set(e, r), r), Da = (e, t, r) => (wT(e, t, "access private method"), r), e1, t1, r1, n1, a1, Lh, Yh, Nf, Zf, Bf, Wf, Ef, i1, Jn, lW, E7, Q7, F7, T7, R7, D7, J7, V7, o1, s1, M7, cW;
let Fi = class extends N {
  constructor() {
    super(), fn(this, Jn), this.languageDirection = Da(this, Jn, lW).call(this), this.loggerSinkRef = Rt(), this.workflowController = Ce(), this.isVisible = Da(this, Jn, cW).call(this), fn(this, e1), fn(this, t1), fn(this, r1), fn(this, n1), fn(this, a1), fn(this, Lh), fn(this, Yh), fn(this, Nf), fn(this, Zf), fn(this, Bf), fn(this, Wf), fn(this, Ef, !1), fn(this, i1, new _e()), fn(this, o1, (i) => {
      this.locale = i.detail.currentLocale;
    }), fn(this, s1, async (i) => {
      await this.componentController.updateWorkflowParams(i.detail);
    }), BAe();
    const { token: e, baseUrl: t, locale: r, sessionUrl: n, linked: a } = Le();
    Vr(this, Lh, e), Vr(this, Yh, t), Vr(this, Nf, n), Vr(this, Bf, r), Vr(this, Wf, a), Vr(this, t1, new ue(this, this.componentController.tokenExpiredMessage$)), Vr(this, r1, new ue(
      this,
      this.componentController.acquisitionStatusPolling$
    )), Vr(this, n1, new ue(this, this.componentController.locale$)), Vr(this, a1, new ue(this, fw())), Da(this, Jn, M7).call(this).pipe(le(Nr(this, i1))).subscribe();
  }
  get accountId() {
    const { parsedToken: e } = Le();
    return e == null ? void 0 : e.accId;
  }
  get workflowExecutionId() {
    const { parsedToken: e } = Le();
    return e == null ? void 0 : e.wfeId;
  }
  get workflowId() {
    const { workflowDefinitionKey: e } = On();
    return e.toString();
  }
  set token(e) {
    const { token: t } = Le();
    Vr(this, Lh, e), this.requestUpdate("token", t);
  }
  get token() {
    return Nr(this, Lh);
  }
  set sessionUrl(e) {
    const { sessionUrl: t } = Le();
    Vr(this, Nf, e), this.requestUpdate("sessionUrl", t);
  }
  get sessionUrl() {
    return Nr(this, Nf);
  }
  set baseUrl(e) {
    const { baseUrl: t } = Le();
    Vr(this, Yh, e), this.requestUpdate("baseUrl", t);
  }
  get baseUrl() {
    return Nr(this, Yh);
  }
  set dc(e) {
    const t = Nr(this, Zf);
    if (Vr(this, Zf, e), BZ(e)) {
      const { baseUrl: r } = Le();
      Vr(this, Yh, Pf[e]), this.requestUpdate("baseUrl", r);
    }
    this.requestUpdate("dc", t);
  }
  get dc() {
    return Nr(this, Zf);
  }
  set locale(e) {
    const { locale: t } = Le();
    Vr(this, Bf, e), this.requestUpdate("locale", t);
  }
  get locale() {
    return Nr(this, Bf);
  }
  set linked(e) {
    const { linked: t } = Le();
    Vr(this, Wf, e), this.requestUpdate("linked", t);
  }
  get linked() {
    return Nr(this, Wf);
  }
  get componentController() {
    return Nr(this, e1) ?? Vr(this, e1, new uke(this, this.loggerSinkRef));
  }
  willUpdate(e) {
    const t = {
      ...e.has("token") ? { token: Nr(this, Lh) } : void 0,
      ...e.has("sessionUrl") ? { sessionUrl: this.sessionUrl } : void 0,
      ...e.has("baseUrl") ? { baseUrl: this.baseUrl } : void 0,
      ...e.has("locale") ? { locale: this.locale } : void 0,
      ...e.has("linked") ? { linked: this.linked } : void 0,
      ...e.has("dc") && BZ(this.dc) ? { baseUrl: Pf[this.dc] } : void 0
    };
    Object.values(t).length && this.componentController.updateWorkflowParams(t);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("locale:change", Nr(this, o1)), this.addEventListener("workflow:initiate", Nr(this, s1));
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("locale:change", Nr(this, o1)), this.removeEventListener("workflow:initiate", Nr(this, s1)), Nr(this, i1).next();
  }
  async refreshPage() {
    Vr(this, Ef, !0), this.requestUpdate(), await this.updateComplete, Vr(this, Ef, !1), this.requestUpdate(), await this.updateComplete;
  }
  render() {
    const { step: e, activeScreen: t } = Le();
    let r = w``;
    return t === Ot.CrossDevice || Hj() ? r = Da(this, Jn, V7).call(this) : t === Ot.Workflow && !Nr(this, Ef) && (r = El(e, [
      [Me.Setup, () => Da(this, Jn, E7).call(this)],
      [Me.Start, () => Da(this, Jn, Q7).call(this)],
      [T.Document, () => Da(this, Jn, R7).call(this)],
      [T.Id, () => Da(this, Jn, F7).call(this)],
      [T.Facemap, () => Da(this, Jn, T7).call(this)],
      [T.Data, () => Da(this, Jn, D7).call(this)],
      [Me.Finish, () => Da(this, Jn, J7).call(this)]
    ]) ?? w``), this.languageDirection = Da(this, Jn, lW).call(this), this.isVisible = Da(this, Jn, cW).call(this), Nr(this, t1) && Nr(this, r1) && Nr(this, n1) && Nr(this, a1) ? w`
          <jumio-sdk-logger-sink ${Mt(this.loggerSinkRef)}>
            <jumio-sdk-logging>
              <slot slot="logger" name="logger"></slot>
            </jumio-sdk-logging>
            <jumio-sdk-navigation>
              <!--              <jumio-sdk-navigation-interceptor slot="navigation-interceptor"></jumio-sdk-navigation-interceptor>-->
              <slot name="navigation" slot="navigation"></slot>
              <x-ds-color-scheme>
                <slot name="theme" slot="theme"></slot>
                <jumio-sdk-branding>
                  <x-ds-page-container>
                    <jumio-sdk-message-screen>${r}</jumio-sdk-message-screen>
                  </x-ds-page-container>
                </jumio-sdk-branding>
              </x-ds-color-scheme>
            </jumio-sdk-navigation>
          </jumio-sdk-logger-sink>
        ` : q;
  }
};
e1 = /* @__PURE__ */ new WeakMap();
t1 = /* @__PURE__ */ new WeakMap();
r1 = /* @__PURE__ */ new WeakMap();
n1 = /* @__PURE__ */ new WeakMap();
a1 = /* @__PURE__ */ new WeakMap();
Lh = /* @__PURE__ */ new WeakMap();
Yh = /* @__PURE__ */ new WeakMap();
Nf = /* @__PURE__ */ new WeakMap();
Zf = /* @__PURE__ */ new WeakMap();
Bf = /* @__PURE__ */ new WeakMap();
Wf = /* @__PURE__ */ new WeakMap();
Ef = /* @__PURE__ */ new WeakMap();
i1 = /* @__PURE__ */ new WeakMap();
Jn = /* @__PURE__ */ new WeakSet();
lW = function() {
  const { locale: e } = Le();
  return [Y.Ar, Y.He].includes(e) ? "rtl" : "ltr";
};
E7 = function() {
  return w`<jumio-sdk-step-setup data-qa-id="step-setup"></jumio-sdk-step-setup>`;
};
Q7 = function() {
  return w`<jumio-sdk-step-start data-qa-id="step-start"></jumio-sdk-step-start>`;
};
F7 = function() {
  return w`<jumio-sdk-step-id data-qa-id="step-id"></jumio-sdk-step-id>`;
};
T7 = function() {
  return w`<jumio-sdk-step-facemap data-qa-id="step-facemap"></jumio-sdk-step-facemap>`;
};
R7 = function() {
  return w`<jumio-sdk-step-document data-qa-id="step-document"></jumio-sdk-step-document>`;
};
D7 = function() {
  return w`<jumio-sdk-step-data data-qa-id="step-data"></jumio-sdk-step-data>`;
};
J7 = function() {
  return w`<jumio-sdk-step-finish data-qa-id="step-finish"></jumio-sdk-step-finish>`;
};
V7 = function() {
  return w`<jumio-sdk-step-cross-device data-qa-id="step-cross-device"></jumio-sdk-step-cross-device>`;
};
o1 = /* @__PURE__ */ new WeakMap();
s1 = /* @__PURE__ */ new WeakMap();
M7 = function() {
  return fw().pipe(
    te(({ credentialId: e, step: t, activeScreen: r }) => `${r}#${t}#${e}`),
    vt(),
    Wt(() => this.refreshPage())
  );
};
cW = function() {
  return On().brandingEnabled;
};
Fi.styles = [
  ...N.styles,
  ee`
      :host {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        position: relative;
        height: 100%;
        font-weight: 400;
      }

      :host([data-locale='ar']),
      :host([data-locale='he']) {
        direction: rtl;
      }
    `
];
ms([
  M({
    attribute: "token",
    type: String,
    reflect: !0,
    hasChanged: (e = "", t = "") => t !== e,
    noAccessor: !0,
    converter: {
      fromAttribute: (e) => e,
      toAttribute: (e) => e || null
    }
  })
], Fi.prototype, "token", 1);
ms([
  M({
    attribute: "session-url",
    type: String,
    reflect: !0,
    hasChanged: (e = "", t = "") => t !== e,
    noAccessor: !0,
    converter: {
      fromAttribute: (e) => e,
      toAttribute: (e) => e || null
    }
  })
], Fi.prototype, "sessionUrl", 1);
ms([
  M({
    attribute: "base-url",
    type: String,
    reflect: !0,
    hasChanged: (e = "", t = "") => t !== e,
    noAccessor: !0,
    converter: {
      fromAttribute: (e) => e,
      toAttribute: (e) => e || null
    }
  })
], Fi.prototype, "baseUrl", 1);
ms([
  M({
    attribute: "dc",
    type: String,
    reflect: !0,
    hasChanged: (e = "", t = "") => t !== e,
    noAccessor: !0,
    converter: {
      fromAttribute: (e) => BZ(e) ? e : void 0,
      toAttribute: (e) => (e == null ? void 0 : e.toString()) ?? null
    }
  })
], Fi.prototype, "dc", 1);
ms([
  M({
    attribute: "locale",
    type: String,
    reflect: !0,
    hasChanged: (e = "", t = "") => t !== e,
    converter: {
      fromAttribute: (e) => hke(e) ? e : Y.En,
      toAttribute: (e) => e.toString()
    }
  })
], Fi.prototype, "locale", 1);
ms([
  M({
    attribute: "linked",
    type: String,
    reflect: !0,
    hasChanged: (e, t) => !!t != !!e,
    converter: {
      fromAttribute: (e) => e !== void 0 || e !== !1,
      toAttribute: () => {
        const { linked: e } = Le();
        return `${e}`;
      }
    }
  })
], Fi.prototype, "linked", 1);
ms([
  ka({ context: Y2 }),
  M({ attribute: "data-language-direction", reflect: !0 })
], Fi.prototype, "languageDirection", 2);
ms([
  ka({ context: pke }),
  Xn()
], Fi.prototype, "workflowController", 2);
ms([
  ka({ context: fx }),
  Xn()
], Fi.prototype, "isVisible", 2);
Fi = ms([
  be(),
  P("jumio-sdk")
], Fi);
var UJe = Object.defineProperty, kJe = Object.getOwnPropertyDescriptor, G7 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? kJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && UJe(t, r, a), a;
};
let dW = class extends N {
  constructor() {
    super(...arguments), this.type = eP, this.isEnabled = !1;
  }
};
G7([
  M({
    attribute: "data-enabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], dW.prototype, "isEnabled", 2);
dW = G7([
  P("jumio-sdk-logger-console")
], dW);
var _Je = Object.defineProperty, NJe = Object.getOwnPropertyDescriptor, AT = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? NJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && _Je(t, r, a), a;
};
let Ky = class extends N {
  constructor() {
    super(...arguments), this.type = pb, this.isEnabled = !0, this.config = {};
  }
};
AT([
  M({
    attribute: "data-enabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => String(!!e)
    }
  })
], Ky.prototype, "isEnabled", 2);
AT([
  M({
    attribute: "data-config",
    type: Object,
    reflect: !0
  })
], Ky.prototype, "config", 2);
Ky = AT([
  P("jumio-sdk-logger-datadog")
], Ky);
var ZJe = Object.defineProperty, BJe = Object.getOwnPropertyDescriptor, x7 = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? BJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && ZJe(t, r, a), a;
};
let uW = class extends N {
  constructor() {
    super(...arguments), this.type = Rj, this.isEnabled = !1;
  }
};
x7([
  M({
    attribute: "data-enabled",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => e === "true",
      toAttribute: (e) => e.toString()
    }
  })
], uW.prototype, "isEnabled", 2);
uW = x7([
  P("jumio-sdk-logger-post-message")
], uW);
var SS, Hp;
class WJe {
  constructor(t) {
    E(this, SS);
    E(this, Hp);
    G(this, SS, t), this.workflowController = Ce(), this.stepController = this.getStepController(), G(this, Hp, new _e()), t.addController(this);
  }
  hostConnected() {
    FE(T.Document).pipe(
      ae((t) => {
        eA({
          timeoutMs: t
        });
      }),
      le(S(this, Hp))
    ).subscribe();
  }
  hostDisconnected() {
    S(this, Hp).next();
  }
  async upload(t) {
    return Te.uploadedFile(S(this, SS), {
      metadata: { source: Fu.Camera }
    }), this.stepController.uploadDataAsync(t);
  }
  getStepController() {
    return this.workflowController.getControllerById(T.Document);
  }
}
SS = new WeakMap(), Hp = new WeakMap();
var EJe = Object.defineProperty, QJe = Object.getOwnPropertyDescriptor, H7 = (e) => {
  throw TypeError(e);
}, FJe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? QJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && EJe(t, r, a), a;
}, UT = (e, t, r) => t.has(e) || H7("Cannot " + r), Ir = (e, t, r) => (UT(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Bs = (e, t, r) => t.has(e) ? H7("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), kT = (e, t, r, n) => (UT(e, t, "write to private field"), t.set(e, r), r), pa = (e, t, r) => (UT(e, t, "access private method"), r), Iv, _T, Xy, zy, Cv, Oh, js, qy, wn, L7, Y7, O7, j7, NT, hW, P7, $7, K7, X7, z7, q7;
let pW = class extends N {
  constructor() {
    var e;
    super(), Bs(this, wn), this.cameraRef = Rt(), Bs(this, Iv, new _e()), Bs(this, _T, W8(
      ((e = TE()) == null ? void 0 : e.resolutionDocument) ?? {
        width: 1920,
        height: 1080,
        aspectRatio: 16 / 9
      }
    )), Bs(this, Xy), Bs(this, zy, Rt()), Bs(this, Cv, new _e()), Bs(this, Oh, new _e()), Bs(this, js), Bs(this, qy, Date.now()), this.logImageCapturedEvent = (t) => {
      var a, i, o, s;
      const { idAutocaptureState: r, idAutocaptureFallbackReason: n } = pa(this, wn, L7).call(this);
      Te.cameraCapture(this, {
        metadata: zo(
          {
            width: t.detail.width,
            height: t.detail.height,
            track: bg(),
            devices: fQ(),
            permissionState: pQ(),
            idAutocapture: !!((a = Ir(this, js)) != null && a.detail.autocapture),
            cls: (i = Ir(this, js)) == null ? void 0 : i.detail.cls,
            clsm: (o = Ir(this, js)) == null ? void 0 : o.detail.clsm,
            idAutocaptureState: r,
            idAutocaptureFallbackReason: n,
            timeSpentInStepMs: Date.now() - Ir(this, qy)
          },
          ["deviceId", "groupId", "deviceIds", "deviceEntities", "mockDeviceIds", "mockDeviceEntities"]
        ),
        tags: {
          idAutocaptureState: r,
          idAutocaptureFallbackReason: n,
          ...typeof ((s = Ir(this, js)) == null ? void 0 : s.detail.autocaptureFps) == "number" && {
            idAutocaptureFps: Ir(this, js).detail.autocaptureFps
          }
        }
      });
    }, this.uploadImage = async (t) => {
      var a, i, o;
      const r = ve(), n = Sw(oe());
      this.logImageCapturedEvent(t), await this.componentController.upload({
        uploadFilesMetadata: {
          files: [
            {
              multipartName: `${oe()}_${or.Document}`,
              fileType: OS[t.detail.blob.type],
              uploadType: or.Document,
              usabilityExpected: !1,
              file: t.detail.blob,
              riskSignals: {
                deviceId: ((a = jn()) == null ? void 0 : a.deviceId) ?? "",
                deviceLabel: ((i = jn()) == null ? void 0 : i.label) ?? "",
                groupId: ((o = jn()) == null ? void 0 : o.groupId) ?? ""
              },
              cls: sd(),
              clsm: ld()
            }
          ]
        }
      }), r.send({
        type: n.UploadScreen
      });
    }, this.componentController = new WJe(this), kT(this, Xy, new ue(this, pa(this, wn, $7).call(this)));
  }
  connectedCallback() {
    super.connectedCallback(), pa(this, wn, X7).call(this).pipe(le(Ir(this, Oh))).subscribe(), pa(this, wn, P7).call(this).pipe(le(Ir(this, Oh))).subscribe(), pa(this, wn, q7).call(this).pipe(le(Ir(this, Oh))).subscribe();
  }
  firstUpdated(e) {
    super.firstUpdated(e), Ir(this, Cv).next(), Ir(this, Iv).next(), Te.shownCaptureScreen(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), Ir(this, Oh).next(), this.stopStream();
  }
  render() {
    return w`
      <jumio-sdk-autocapture-provider>
        <x-ds-app-container
          ${Mt(Ir(this, zy))}
          data-type="${An.CaptureScreen}"
          @switchstream="${this.switchStream.bind(this)}"
        >
          <jumio-sdk-navigation-button
            slot="top-left"
            data-shape="${ya.Round}"
            data-type="${De.Tertiary}"
          ></jumio-sdk-navigation-button>
          <x-ds-color-scheme slot="top-middle" data-color-scheme="dark">
            <x-ds-watermark data-version="0.2.14-b10b1242.2"></x-ds-watermark>
          </x-ds-color-scheme>
          <x-ds-button
            class="mobile-only"
            slot="top-right"
            data-size="${_a.Medium}"
            data-shape="${ya.Round}"
            data-type="${De.Tertiary}"
            data-padding="false"
            @jclick="${() => {
      Qg();
    }}"
          >
            <span class="icon-help"></span>
          </x-ds-button>
          <x-ds-button
            class="desktop-only"
            slot="top-right"
            data-type="${De.Tertiary}"
            @jclick="${() => {
      Qg();
    }}"
          >
            <span>${y("Help", { id: "app.nav.help" })}</span>
          </x-ds-button>
          ${pa(this, wn, Y7).call(this)} ${pa(this, wn, K7).call(this)} ${pa(this, wn, O7).call(this)}
          <div slot="bottom-left" class="cross-device-container">
            <jumio-sdk-cross-device-button
              data-fluid="false"
              data-type="${De.Tertiary}"
            ></jumio-sdk-cross-device-button>
          </div>
          <jumio-sdk-capture-hints class="overlay" slot="overlay">
            <ul slot="tips">
              <li>${y("Make sure photo is in focus", { id: "id-source.help.card.tip1" })}</li>
              <li>${y("Do not take picture in the dark", { id: "id-source.help.card.tip2" })}</li>
              <li>${y("Avoid reflections and glare", { id: "id-source.help.card.tip3" })}</li>
            </ul>
            <jumio-sdk-upload-button
              slot="secondary-action-button"
              data-type="${De.Secondary}"
              data-fluid="true"
            ></jumio-sdk-upload-button>
          </jumio-sdk-capture-hints>
        </x-ds-app-container>
      </jumio-sdk-autocapture-provider>
    `;
  }
  switchStream(e) {
    return (e instanceof Uw || e instanceof Il) && this.cameraRef.value ? this.cameraRef.value.switchStream(e) : Promise.reject(new GS("switchStream: Camera could not be started"));
  }
  stopStream() {
    var e;
    (e = this.cameraRef.value) == null || e.stopStream();
  }
  handleCameraSwitch(e) {
    return this.switchStream(e);
  }
};
Iv = /* @__PURE__ */ new WeakMap();
_T = /* @__PURE__ */ new WeakMap();
Xy = /* @__PURE__ */ new WeakMap();
zy = /* @__PURE__ */ new WeakMap();
Cv = /* @__PURE__ */ new WeakMap();
Oh = /* @__PURE__ */ new WeakMap();
js = /* @__PURE__ */ new WeakMap();
qy = /* @__PURE__ */ new WeakMap();
wn = /* @__PURE__ */ new WeakSet();
L7 = function() {
  const { state: e, fallbackReason: t } = QO(), r = (() => {
    var a;
    return (a = Ir(this, js)) != null && a.detail.autocapture ? "auto-capture" : [Er.MANUAL_CAPTURE_FALLBACK, Er.LOADING].includes(e) ? "manual-capture-fallback" : "manual-capture";
  })(), n = e === Er.LOADING ? nt.ModuleLoadingError : t;
  return { idAutocaptureState: r, idAutocaptureFallbackReason: n };
};
Y7 = function() {
  return w`
      <x-camera
        ${Mt(this.cameraRef)}
        slot="background"
        class="camera"
        .applyConstraintCallback="${Ir(this, _T)}"
        @imagecaptured="${(e) => this.uploadImage(e)}"
        @streamresized="${(e) => {
    pa(this, wn, z7).call(this, e);
  }}"
        @capturerequest="${(e) => {
    pa(this, wn, NT).call(this, e);
  }}"
        @cameraplaybackstatus="${(e) => {
    zF(this, e.detail);
  }}"
      >
        <jumio-sdk-camera-permissions-screen></jumio-sdk-camera-permissions-screen>
      </x-camera>
    `;
};
O7 = function() {
  return w`
      <x-ds-capture-button
        slot="capture-button"
        data-qa-id="capture-button"
        @click="${() => {
    pa(this, wn, NT).call(this);
  }}"
      ></x-ds-capture-button>
    `;
};
j7 = function() {
  return !1;
};
NT = function(e) {
  var t;
  pa(this, wn, j7).call(this) || (kT(this, js, e), (t = this.cameraRef.value) == null || t.captureImage());
};
hW = function() {
  const e = Ir(this, Xy).value;
  return (e == null ? void 0 : e.type) === An.CaptureScreen && (e == null ? void 0 : e.variant) === Bu.Small ? qa.Horizontal : qa.Vertical;
};
P7 = function() {
  return ps(Ir(this, Iv), tI).pipe(
    Wt(() => ZQ(this.cameraRef, Ir(this, Cv))),
    Xc(yS),
    Wt(
      (e) => this.switchStream(
        new Il({
          videoElement: e,
          constraints: {
            video: {
              ...wQ(),
              facingMode: {
                ideal: kw.Environment
              }
            },
            audio: !1
          }
        })
      )
    )
  );
};
$7 = function() {
  return Bl(Ir(this, zy), Ir(this, Cv)).pipe(
    Wt((e) => e.layout$)
  );
};
K7 = function() {
  return w`
      <div
        slot="camera-selector"
        class="camera-selector-container"
        data-orientation="${pa(this, wn, hW).call(this)}"
      >
        <x-camera-selector
          class="camera-selector"
          @switchcamera="${(e) => this.handleCameraSwitch(e)}"
          .orientation="${pa(this, wn, hW).call(this)}"
        ></x-camera-selector>
      </div>
    `;
};
X7 = function() {
  return bQ(Ir(this, Iv));
};
z7 = function(e) {
  kQ({
    width: e.detail.sourceWidth,
    height: e.detail.sourceHeight
  });
};
q7 = function() {
  return ur().pipe(
    ae(() => {
      kT(this, qy, Date.now());
    })
  );
};
pW.styles = [
  ...N.styles,
  Gt(XF),
  ee`
      :host {
        display: contents;
      }

      .camera-selector-container {
        position: relative;
      }

      .camera-selector-container[data-orientation='vertical'] {
        width: 100%;
        height: 100%;
      }

      .camera-selector[data-orientation='vertical'] {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .cross-device-container {
        display: flex;
        align-items: flex-end;
        height: 100%;
      }

      .mobile-only {
        display: flex;
      }

      .desktop-only {
        display: none;
      }

      @media only screen and (min-width: 40em) {
        .mobile-only {
          display: none;
        }

        .desktop-only {
          display: flex;
        }
      }
    `
];
pW = FJe([
  be(),
  P("jumio-sdk-step-document-capture")
], pW);
var IS, B2, eq;
class TJe {
  constructor(t) {
    E(this, B2);
    E(this, IS, new Kt(void 0));
    const r = P0e().pipe(FW([]));
    this.supportedCountries$ = O(this, B2, eq).call(this, r), t.addController(this);
  }
  hostConnected() {
  }
  filterCountry(t) {
    S(this, IS).next(t);
  }
}
IS = new WeakMap(), B2 = new WeakSet(), eq = function(t) {
  return Ute([t, S(this, IS).asObservable()]).pipe(
    te(([r, n]) => {
      if (!n)
        return r;
      const a = aA();
      return r.filter((i) => a[i.country].toLowerCase().includes(n.toLowerCase()));
    })
  );
};
var RJe = Object.defineProperty, DJe = Object.getOwnPropertyDescriptor, tq = (e) => {
  throw TypeError(e);
}, JJe = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? DJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && RJe(t, r, a), a;
}, VJe = (e, t, r) => t.has(e) || tq("Cannot " + r), Rk = (e, t, r) => (VJe(e, t, "read from private field"), r ? r.call(e) : t.get(e)), F3 = (e, t, r) => t.has(e) ? tq("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), l1, gW;
let fW = class extends N {
  constructor() {
    super(...arguments), F3(this, l1, new TJe(this)), this.supportedCountries = new ue(this, Rk(this, l1).supportedCountries$), this.inputComponent = Rt(), this.onInputChange = () => {
      var t, r;
      const e = (r = (t = this.inputComponent.value) == null ? void 0 : t.inputRef.value) == null ? void 0 : r.value;
      Rk(this, l1).filterCountry(e);
    }, F3(this, gW, (e) => {
      var t;
      (e.code === "Enter" || e.code === "Escape") && ((t = this.inputComponent.value) == null || t.blur());
    });
  }
  render() {
    return w`
      <x-ds-app-container>
        ${ke(
      "jumio-id-upload-backward-button",
      w`<jumio-sdk-navigation-button slot="top-left"></jumio-sdk-navigation-button>`
    )}
        <jumio-sdk-logotype slot="top-middle"></jumio-sdk-logotype>
        <div class="supported-id-search-container" slot="main">
          <x-ds-list
            .dataFlattenerCallback=${MJe}
            .itemRenderer="${GJe(aA())}"
            .data=${this.supportedCountries.value}
          >
            <h1 slot="before">${y("Supported documents", { id: "jumio_list_supported_document_title" })}</h1>
            <x-ds-input
              slot="before"
              @input="${this.onInputChange}"
              ${Mt(this.inputComponent)}
              @keydown=${(e) => {
      Rk(this, gW).call(this, e);
    }}
              data-placeholder="Search"
              data-size="medium"
              data-disabled="false"
              data-error="false"
              data-error-message=""
              data-info-message=""
            >
            </x-ds-input>
            <jumio-sdk-step-id-usability-check-button slot="after"></jumio-sdk-step-id-usability-check-button>
          </x-ds-list>
        </div>
      </x-ds-app-container>
    `;
  }
};
l1 = /* @__PURE__ */ new WeakMap();
gW = /* @__PURE__ */ new WeakMap();
fW.styles = [
  ...wa.styles,
  ee`
      :host {
        display: contents;
        --list-wrapper-border: 1px solid var(--color-secondary4);
        --list-wrapper-border-radius: 1em;
        --list-wrapper-padding: 1.25em;
      }

      h1 {
        text-align: center;
      }

      .supported-id-search-container {
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        max-width: 32em;
        margin-inline: auto;
      }

      .retake-both-button {
        align-self: center;
        width: 100%;
      }
    `
];
fW = JJe([
  be(),
  P("jumio-sdk-supported-id-search")
], fW);
const MJe = (e) => Array.from(e).map((t) => ({ value: t, depth: 0 })), GJe = (e) => ({ item: t, isFirst: r, isLast: n }) => Ut(t.value, ["country", "idTypes"]) ? w`
        <style>
          .item {
            border-bottom: 1px solid var(--color-secondary7);
          }

          .item[data-first='true'] {
            border-top: none;
          }

          .id-type,
          .country {
            padding-block: 0.6875em;
            line-height: 1.375em;
          }

          .id-type {
            padding-inline: 0.75em;
          }

          .country {
            font-weight: 600;
          }
        </style>
        <div class="item" data-first="${r}" data-last="${n}" data-depth-level="${t.depth}">
          <div class="country">${e[t.value.country]}</div>
          ${t.value.idTypes.map((a) => {
  const i = a.digitalIdentity ? a.digitalIdentity.title : Nz(a.idType);
  return w`<div class="id-type">${i}</div>`;
})}
        </div>
      ` : q;
var xJe = Object.defineProperty, HJe = Object.getOwnPropertyDescriptor, ZT = (e, t, r, n) => {
  for (var a = n > 1 ? void 0 : n ? HJe(t, r) : t, i = e.length - 1, o; i >= 0; i--)
    (o = e[i]) && (a = (n ? o(t, r, a) : o(a)) || a);
  return n && a && xJe(t, r, a), a;
};
let e2 = class extends N {
  constructor() {
    super(...arguments), this.colorScheme = Un.Auto;
  }
  attributeChangedCallback(e, t, r) {
    var n;
    super.attributeChangedCallback(e, t, r), e === "data-color" && (v1(r) || r === null) && ((n = this.colorSchemeService) == null || n.setUserColorScheme(r ?? Un.Auto));
  }
};
ZT([
  M({
    attribute: "data-color",
    type: String,
    reflect: !0,
    converter: {
      fromAttribute: (e) => v1(e) ? e : Un.Auto,
      toAttribute: (e) => e.toString()
    }
  })
], e2.prototype, "colorScheme", 2);
ZT([
  td({ context: IG, subscribe: !0 })
], e2.prototype, "colorSchemeService", 2);
e2 = ZT([
  P("jumio-sdk-theme")
], e2);
const LJe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get JumioLivenessComponent() {
    return Ty;
  },
  get JumioSdkLivenessCaptureStateComponent() {
    return bB;
  },
  JumioSdkLivenessService: Fy,
  LivenessImageType: rA
}, Symbol.toStringTag, { value: "Module" }));
export {
  dde as $,
  gm as A,
  fm as B,
  mm as C,
  An as D,
  PG as E,
  Un as F,
  IG as G,
  zW as H,
  $p as I,
  Pk as J,
  rle as K,
  v1 as L,
  Kp as M,
  zG as N,
  wa as O,
  i_ as P,
  c9 as Q,
  rde as R,
  nde as S,
  ade as T,
  w1 as U,
  ide as V,
  ode as W,
  sde as X,
  d9 as Y,
  lde as Z,
  cde as _,
  Bu as a,
  up as a$,
  ude as a0,
  Xp as a1,
  ml as a2,
  l_ as a3,
  Z1 as a4,
  lle as a5,
  ym as a6,
  Nde as a7,
  Zde as a8,
  B9 as a9,
  XA as aA,
  KA as aB,
  XJe as aC,
  Ule as aD,
  G5 as aE,
  Eu as aF,
  U_ as aG,
  km as aH,
  Kue as aI,
  Bl as aJ,
  aw as aK,
  zJe as aL,
  ig as aM,
  fx as aN,
  Ce as aO,
  xye as aP,
  ve as aQ,
  oQ as aR,
  Gpe as aS,
  xpe as aT,
  Hpe as aU,
  Lpe as aV,
  Ype as aW,
  x_ as aX,
  Y_ as aY,
  K_ as aZ,
  Xl as a_,
  oo as aa,
  W1 as ab,
  zp as ac,
  c_ as ad,
  d_ as ae,
  Y2 as af,
  wm as ag,
  u_ as ah,
  p_ as ai,
  h_ as aj,
  qp as ak,
  Jc as al,
  Ia as am,
  ag as an,
  R1 as ao,
  the as ap,
  D1 as aq,
  J1 as ar,
  y_ as as,
  V1 as at,
  w_ as au,
  A_ as av,
  dle as aw,
  ule as ax,
  hle as ay,
  _0 as az,
  N as b,
  qH as b$,
  cfe as b0,
  R0e as b1,
  ZC as b2,
  BC as b3,
  O_ as b4,
  D0e as b5,
  J0e as b6,
  oH as b7,
  TS as b8,
  WE as b9,
  X0e as bA,
  uH as bB,
  z0e as bC,
  hH as bD,
  q0e as bE,
  FE as bF,
  vo as bG,
  TE as bH,
  tfe as bI,
  P_ as bJ,
  rfe as bK,
  $g as bL,
  Gve as bM,
  xve as bN,
  Hf as bO,
  eo as bP,
  Hve as bQ,
  Lve as bR,
  ug as bS,
  Yve as bT,
  XH as bU,
  Ove as bV,
  zH as bW,
  jve as bX,
  ur as bY,
  hVe as bZ,
  fw as b_,
  EE as ba,
  oVe as bb,
  V0e as bc,
  M0e as bd,
  G0e as be,
  x0e as bf,
  H0e as bg,
  sH as bh,
  lH as bi,
  cH as bj,
  QE as bk,
  oN as bl,
  Kve as bm,
  L0e as bn,
  Y0e as bo,
  sVe as bp,
  j_ as bq,
  kn as br,
  dD as bs,
  O0e as bt,
  lVe as bu,
  j0e as bv,
  P0e as bw,
  On as bx,
  $0e as by,
  K0e as bz,
  Yle as c,
  qSe as c$,
  Le as c0,
  sh as c1,
  oe as c2,
  pVe as c3,
  Pve as c4,
  Ec as c5,
  $ve as c6,
  gVe as c7,
  tL as c8,
  rL as c9,
  ASe as cA,
  USe as cB,
  kSe as cC,
  _Se as cD,
  iL as cE,
  NSe as cF,
  WSe as cG,
  ESe as cH,
  QSe as cI,
  FSe as cJ,
  TSe as cK,
  RSe as cL,
  DSe as cM,
  JSe as cN,
  vw as cO,
  GSe as cP,
  xSe as cQ,
  HSe as cR,
  LSe as cS,
  YSe as cT,
  OSe as cU,
  jSe as cV,
  PSe as cW,
  $Se as cX,
  KSe as cY,
  XSe as cZ,
  zSe as c_,
  qve as ca,
  fVe as cb,
  jE as cc,
  eSe as cd,
  hg as ce,
  tSe as cf,
  nL as cg,
  Vu as ch,
  oSe as ci,
  sSe as cj,
  lSe as ck,
  cSe as cl,
  dSe as cm,
  uSe as cn,
  hSe as co,
  pSe as cp,
  gSe as cq,
  fSe as cr,
  mSe as cs,
  vSe as ct,
  SSe as cu,
  ISe as cv,
  CSe as cw,
  bSe as cx,
  ySe as cy,
  wSe as cz,
  _a as d,
  Sw as d$,
  eIe as d0,
  tIe as d1,
  rIe as d2,
  nIe as d3,
  aIe as d4,
  iIe as d5,
  oIe as d6,
  oL as d7,
  sIe as d8,
  lIe as d9,
  WIe as dA,
  dL as dB,
  EIe as dC,
  QIe as dD,
  uL as dE,
  hL as dF,
  FIe as dG,
  pL as dH,
  TIe as dI,
  RIe as dJ,
  DIe as dK,
  JIe as dL,
  gL as dM,
  VIe as dN,
  fL as dO,
  MIe as dP,
  GIe as dQ,
  Te as dR,
  rSe as dS,
  nSe as dT,
  kt as dU,
  pg as dV,
  mVe as dW,
  vVe as dX,
  Ve as dY,
  PE as dZ,
  mL as d_,
  cIe as da,
  dIe as db,
  lN as dc,
  uIe as dd,
  pIe as de,
  gIe as df,
  fIe as dg,
  mIe as dh,
  sL as di,
  vIe as dj,
  SIe as dk,
  IIe as dl,
  CIe as dm,
  bIe as dn,
  yIe as dp,
  wIe as dq,
  AIe as dr,
  UIe as ds,
  kIe as dt,
  _Ie as du,
  NIe as dv,
  ZIe as dw,
  BIe as dx,
  lL as dy,
  cL as dz,
  ya as e,
  Z as e$,
  Tt as e0,
  un as e1,
  $E as e2,
  cbe as e3,
  K1 as e4,
  Aa as e5,
  Sx as e6,
  _ as e7,
  __ as e8,
  M1 as e9,
  Na as eA,
  Ft as eB,
  Z_ as eC,
  nt as eD,
  B_ as eE,
  Yhe as eF,
  qJe as eG,
  Ohe as eH,
  jhe as eI,
  eVe as eJ,
  tVe as eK,
  rVe as eL,
  nVe as eM,
  Phe as eN,
  yE as eO,
  $he as eP,
  Khe as eQ,
  ei as eR,
  es as eS,
  Xhe as eT,
  ol as eU,
  _i as eV,
  Y as eW,
  Ee as eX,
  ul as eY,
  jd as eZ,
  In as e_,
  bE as ea,
  Me as eb,
  Ot as ec,
  T as ed,
  zn as ee,
  $t as ef,
  Ja as eg,
  Jhe as eh,
  cr as ei,
  xr as ej,
  or as ek,
  ft as el,
  fc as em,
  Vhe as en,
  Mhe as eo,
  Ghe as ep,
  xhe as eq,
  Hhe as er,
  Lhe as es,
  Qu as et,
  qi as eu,
  Wr as ev,
  N_ as ew,
  Fu as ex,
  Kr as ey,
  rt as ez,
  De as f,
  e4 as f$,
  x as f0,
  Cn as f1,
  Jd as f2,
  T_ as f3,
  er as f4,
  hl as f5,
  iVe as f6,
  vpe as f7,
  Nm as f8,
  wQ as f9,
  YU as fA,
  mwe as fB,
  f4 as fC,
  vwe as fD,
  AVe as fE,
  zC as fF,
  GY as fG,
  wJ as fH,
  GS as fI,
  uQ as fJ,
  Lye as fK,
  LI as fL,
  vg as fM,
  Sg as fN,
  HS as fO,
  o4 as fP,
  wVe as fQ,
  Aw as fR,
  iwe as fS,
  owe as fT,
  swe as fU,
  Uw as fV,
  kw as fW,
  Il as fX,
  hZ as fY,
  R4 as fZ,
  wg as f_,
  bQ as fa,
  D2e as fb,
  R2e as fc,
  T2e as fd,
  yVe as fe,
  MY as ff,
  Hye as fg,
  s4 as fh,
  xu as fi,
  yg as fj,
  ZQ as fk,
  kwe as fl,
  YJ as fm,
  d4 as fn,
  sd as fo,
  ld as fp,
  h4 as fq,
  kQ as fr,
  _Q as fs,
  bg as ft,
  p4 as fu,
  tZ as fv,
  gwe as fw,
  fwe as fx,
  g4 as fy,
  _w as fz,
  $W as g,
  NVe as g$,
  B2e as g0,
  bVe as g1,
  SVe as g2,
  xY as g3,
  jye as g4,
  IVe as g5,
  CVe as g6,
  pQ as g7,
  Pye as g8,
  gQ as g9,
  XY as gA,
  Lm as gB,
  r2e as gC,
  CQ as gD,
  $Y as gE,
  f2e as gF,
  Er as gG,
  vAe as gH,
  SAe as gI,
  IAe as gJ,
  EO as gK,
  tV as gL,
  CAe as gM,
  bAe as gN,
  yAe as gO,
  wAe as gP,
  Bo as gQ,
  QO as gR,
  FO as gS,
  wZ as gT,
  UZ as gU,
  dy as gV,
  kZ as gW,
  yZ as gX,
  Qw as gY,
  RUe as gZ,
  Fi as g_,
  HY as ga,
  $ye as gb,
  jn as gc,
  Kye as gd,
  fQ as ge,
  LY as gf,
  Xye as gg,
  xJ as gh,
  zY as gi,
  qY as gj,
  Rwe as gk,
  Dwe as gl,
  Jwe as gm,
  Vwe as gn,
  Km as go,
  Hwe as gp,
  ay as gq,
  XJ as gr,
  lo as gs,
  EQ as gt,
  oAe as gu,
  Mc as gv,
  sAe as gw,
  lAe as gx,
  eV as gy,
  sy as gz,
  pl as h,
  vv as h$,
  oke as h0,
  Dj as h1,
  Jj as h2,
  ske as h3,
  _g as h4,
  bl as h5,
  gB as h6,
  pB as h7,
  ZVe as h8,
  X6 as h9,
  Wg as hA,
  _y as hB,
  mp as hC,
  Eg as hD,
  By as hE,
  nB as hF,
  g3 as hG,
  Ey as hH,
  pW as hI,
  sB as hJ,
  Jy as hK,
  I3 as hL,
  uB as hM,
  _B as hN,
  wB as hO,
  hB as hP,
  UB as hQ,
  My as hR,
  Py as hS,
  EB as hT,
  QB as hU,
  Xm as hV,
  DB as hW,
  VB as hX,
  MB as hY,
  HB as hZ,
  zB as h_,
  eA as ha,
  Qg as hb,
  E3 as hc,
  Zg as hd,
  aW as he,
  tB as hf,
  dW as hg,
  Ky as hh,
  uW as hi,
  WZ as hj,
  YZ as hk,
  YFe as hl,
  qZ as hm,
  PZ as hn,
  Vj as ho,
  lke as hp,
  ct as hq,
  cke as hr,
  mt as hs,
  Fr as ht,
  NZ as hu,
  ZZ as hv,
  yl as hw,
  Ay as hx,
  l3 as hy,
  c3 as hz,
  Vle as i,
  nW as i0,
  jy as i1,
  oW as i2,
  $y as i3,
  Sv as i4,
  fW as i5,
  e2 as i6,
  Bg as i7,
  sj as i8,
  UAe as i9,
  kAe as ia,
  RO as ib,
  DO as ic,
  IZ as id,
  JO as ie,
  _Ae as ig,
  VO as ih,
  NAe as ii,
  OS as ij,
  ZAe as ik,
  BAe as il,
  WAe as im,
  EAe as io,
  QAe as ip,
  O2 as j,
  rE as k,
  GG as l,
  vm as m,
  qa as n,
  zle as o,
  Sm as p,
  y1 as q,
  Wu as r,
  qk as s,
  lce as t,
  Zn as u,
  j2 as v,
  os as w,
  e_ as x,
  Im as y,
  gl as z
};
//# sourceMappingURL=index.DXNt2p89.js.map
